
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree135"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree135"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.5" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.5"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.5";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.5";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.5";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ const $b5ad043d24ba28db$export$e4c89085febbc618 = {
    '2': '#050505',
    '4': '#0a0a0a',
    '6': '#0f0f0f',
    '8': '#141414',
    '10': '#1a1a1a',
    '12': '#1f1f1f',
    '14': '#242424',
    '16': '#292929',
    '18': '#2e2e2e',
    '20': '#333333',
    '22': '#383838',
    '24': '#3d3d3d',
    '26': '#424242',
    '28': '#474747',
    '30': '#4d4d4d',
    '32': '#525252',
    '34': '#575757',
    '36': '#5c5c5c',
    '38': '#616161',
    '40': '#666666',
    '42': '#6b6b6b',
    '44': '#707070',
    '46': '#757575',
    '48': '#7a7a7a',
    '50': '#808080',
    '52': '#858585',
    '54': '#8a8a8a',
    '56': '#8f8f8f',
    '58': '#949494',
    '60': '#999999',
    '62': '#9e9e9e',
    '64': '#a3a3a3',
    '66': '#a8a8a8',
    '68': '#adadad',
    '70': '#b3b3b3',
    '72': '#b8b8b8',
    '74': '#bdbdbd',
    '76': '#c2c2c2',
    '78': '#c7c7c7',
    '80': '#cccccc',
    '82': '#d1d1d1',
    '84': '#d6d6d6',
    '86': '#dbdbdb',
    '88': '#e0e0e0',
    '90': '#e6e6e6',
    '92': '#ebebeb',
    '94': '#f0f0f0',
    '96': '#f5f5f5',
    '98': '#fafafa',
    '99': '#fcfcfc'
};
const $b5ad043d24ba28db$export$2c27d7ccbdcc7b47 = {
    '5': 'rgba(255, 255, 255, 0.05)',
    '10': 'rgba(255, 255, 255, 0.1)',
    '20': 'rgba(255, 255, 255, 0.2)',
    '30': 'rgba(255, 255, 255, 0.3)',
    '40': 'rgba(255, 255, 255, 0.4)',
    '50': 'rgba(255, 255, 255, 0.5)',
    '60': 'rgba(255, 255, 255, 0.6)',
    '70': 'rgba(255, 255, 255, 0.7)',
    '80': 'rgba(255, 255, 255, 0.8)',
    '90': 'rgba(255, 255, 255, 0.9)'
};
const $b5ad043d24ba28db$export$8f3334164e0b2b5c = {
    '5': 'rgba(0, 0, 0, 0.05)',
    '10': 'rgba(0, 0, 0, 0.1)',
    '20': 'rgba(0, 0, 0, 0.2)',
    '30': 'rgba(0, 0, 0, 0.3)',
    '40': 'rgba(0, 0, 0, 0.4)',
    '50': 'rgba(0, 0, 0, 0.5)',
    '60': 'rgba(0, 0, 0, 0.6)',
    '70': 'rgba(0, 0, 0, 0.7)',
    '80': 'rgba(0, 0, 0, 0.8)',
    '90': 'rgba(0, 0, 0, 0.9)'
};
const $b5ad043d24ba28db$export$dbc00436b8ca4a1e = {
    '5': 'rgba(26, 26, 26, 0.05)',
    '10': 'rgba(26, 26, 26, 0.1)',
    '20': 'rgba(26, 26, 26, 0.2)',
    '30': 'rgba(26, 26, 26, 0.3)',
    '40': 'rgba(26, 26, 26, 0.4)',
    '50': 'rgba(26, 26, 26, 0.5)',
    '60': 'rgba(26, 26, 26, 0.6)',
    '70': 'rgba(26, 26, 26, 0.7)',
    '80': 'rgba(26, 26, 26, 0.8)',
    '90': 'rgba(26, 26, 26, 0.9)'
};
const $b5ad043d24ba28db$export$bf06a928c351ccfc = {
    '5': 'rgba(31, 31, 31, 0.05)',
    '10': 'rgba(31, 31, 31, 0.1)',
    '20': 'rgba(31, 31, 31, 0.2)',
    '30': 'rgba(31, 31, 31, 0.3)',
    '40': 'rgba(31, 31, 31, 0.4)',
    '50': 'rgba(31, 31, 31, 0.5)',
    '60': 'rgba(31, 31, 31, 0.6)',
    '70': 'rgba(31, 31, 31, 0.7)',
    '80': 'rgba(31, 31, 31, 0.8)',
    '90': 'rgba(31, 31, 31, 0.9)'
};
const $b5ad043d24ba28db$export$f146536593fee9ff = {
    '5': 'rgba(36, 36, 36, 0.05)',
    '10': 'rgba(36, 36, 36, 0.1)',
    '20': 'rgba(36, 36, 36, 0.2)',
    '30': 'rgba(36, 36, 36, 0.3)',
    '40': 'rgba(36, 36, 36, 0.4)',
    '50': 'rgba(36, 36, 36, 0.5)',
    '60': 'rgba(36, 36, 36, 0.6)',
    '70': 'rgba(36, 36, 36, 0.7)',
    '80': 'rgba(36, 36, 36, 0.8)',
    '90': 'rgba(36, 36, 36, 0.9)'
};
const $b5ad043d24ba28db$export$8fa4e5556fd77a60 = '#ffffff';
const $b5ad043d24ba28db$export$c073df10e766abfa = '#000000';
const $b5ad043d24ba28db$export$81de8a918392ac60 = '#ffff00';
const $b5ad043d24ba28db$export$2956f0c7e40f8adb = '#1aebff';
const $b5ad043d24ba28db$export$a98a110048f844c7 = '#3ff23f';
const $b5ad043d24ba28db$export$69ed68f0b7cf93f9 = '#000000';
const $b5ad043d24ba28db$export$5a5eaf27ddfba503 = '#ffffff';
const $b5ad043d24ba28db$export$a3d9060cec6dc0b6 = '#000000';
const $b5ad043d24ba28db$export$8c7cfe6119da801 = '#000000';
const $b5ad043d24ba28db$export$bf0b4078ca5e8271 = '#ffffff';
const $b5ad043d24ba28db$export$76a6bc0ea014735a = {
    shade50: '#130204',
    shade40: '#230308',
    shade30: '#420610',
    shade20: '#590815',
    shade10: '#690a19',
    primary: '#750b1c',
    tint10: '#861b2c',
    tint20: '#962f3f',
    tint30: '#ac4f5e',
    tint40: '#d69ca5',
    tint50: '#e9c7cd',
    tint60: '#f9f0f2'
};
const $b5ad043d24ba28db$export$a0627fd18a354ecb = {
    shade50: '#1a0607',
    shade40: '#310b0d',
    shade30: '#5c1519',
    shade20: '#7d1d21',
    shade10: '#942228',
    primary: '#a4262c',
    tint10: '#af393e',
    tint20: '#ba4d52',
    tint30: '#c86c70',
    tint40: '#e4afb2',
    tint50: '#f0d3d4',
    tint60: '#fbf4f4'
};
const $b5ad043d24ba28db$export$94cf3141ea3c5416 = {
    shade50: '#200205',
    shade40: '#3b0509',
    shade30: '#6e0811',
    shade20: '#960b18',
    shade10: '#b10e1c',
    primary: '#c50f1f',
    tint10: '#cc2635',
    tint20: '#d33f4c',
    tint30: '#dc626d',
    tint40: '#eeacb2',
    tint50: '#f6d1d5',
    tint60: '#fdf3f4'
};
const $b5ad043d24ba28db$export$a90204d1394caf30 = {
    shade50: '#210809',
    shade40: '#3f1011',
    shade30: '#751d1f',
    shade20: '#9f282b',
    shade10: '#bc2f32',
    primary: '#d13438',
    tint10: '#d7494c',
    tint20: '#dc5e62',
    tint30: '#e37d80',
    tint40: '#f1bbbc',
    tint50: '#f8dadb',
    tint60: '#fdf6f6'
};
const $b5ad043d24ba28db$export$4a29193d55cdecba = {
    shade50: '#230900',
    shade40: '#411200',
    shade30: '#7a2101',
    shade20: '#a62d01',
    shade10: '#c43501',
    primary: '#da3b01',
    tint10: '#de501c',
    tint20: '#e36537',
    tint30: '#e9835e',
    tint40: '#f4bfab',
    tint50: '#f9dcd1',
    tint60: '#fdf6f3'
};
const $b5ad043d24ba28db$export$7ce8b36d0b00eddb = {
    shade50: '#1b0a01',
    shade40: '#321303',
    shade30: '#5e2405',
    shade20: '#7f3107',
    shade10: '#963a08',
    primary: '#a74109',
    tint10: '#b2521e',
    tint20: '#bc6535',
    tint30: '#ca8057',
    tint40: '#e5bba4',
    tint50: '#f1d9cc',
    tint60: '#fbf5f2'
};
const $b5ad043d24ba28db$export$978fe4ac22d00df0 = {
    shade50: '#200d03',
    shade40: '#3d1805',
    shade30: '#712d09',
    shade20: '#9a3d0c',
    shade10: '#b6480e',
    primary: '#ca5010',
    tint10: '#d06228',
    tint20: '#d77440',
    tint30: '#df8e64',
    tint40: '#efc4ad',
    tint50: '#f7dfd2',
    tint60: '#fdf7f4'
};
const $b5ad043d24ba28db$export$ad766f34ace1cafd = {
    shade50: '#271002',
    shade40: '#4a1e04',
    shade30: '#8a3707',
    shade20: '#bc4b09',
    shade10: '#de590b',
    primary: '#f7630c',
    tint10: '#f87528',
    tint20: '#f98845',
    tint30: '#faa06b',
    tint40: '#fdcfb4',
    tint50: '#fee5d7',
    tint60: '#fff9f5'
};
const $b5ad043d24ba28db$export$c96cfe71516d2e98 = {
    shade50: '#291600',
    shade40: '#4d2a00',
    shade30: '#8f4e00',
    shade20: '#c26a00',
    shade10: '#e67e00',
    primary: '#ff8c00',
    tint10: '#ff9a1f',
    tint20: '#ffa83d',
    tint30: '#ffba66',
    tint40: '#ffddb3',
    tint50: '#ffedd6',
    tint60: '#fffaf5'
};
const $b5ad043d24ba28db$export$b8872f2e62a1cb31 = {
    shade50: '#251a00',
    shade40: '#463100',
    shade30: '#835b00',
    shade20: '#b27c00',
    shade10: '#d39300',
    primary: '#eaa300',
    tint10: '#edad1c',
    tint20: '#efb839',
    tint30: '#f2c661',
    tint40: '#f9e2ae',
    tint50: '#fcefd3',
    tint60: '#fefbf4'
};
const $b5ad043d24ba28db$export$594c5a8758200c32 = {
    shade50: '#282400',
    shade40: '#4c4400',
    shade30: '#817400',
    shade20: '#c0ad00',
    shade10: '#e4cc00',
    primary: '#fde300',
    tint10: '#fde61e',
    tint20: '#fdea3d',
    tint30: '#feee66',
    tint40: '#fef7b2',
    tint50: '#fffad6',
    tint60: '#fffef5'
};
const $b5ad043d24ba28db$export$c24201f7fe3571d8 = {
    shade50: '#1f1900',
    shade40: '#3a2f00',
    shade30: '#6c5700',
    shade20: '#937700',
    shade10: '#ae8c00',
    primary: '#c19c00',
    tint10: '#c8a718',
    tint20: '#d0b232',
    tint30: '#dac157',
    tint40: '#ecdfa5',
    tint50: '#f5eece',
    tint60: '#fdfbf2'
};
const $b5ad043d24ba28db$export$32afe192cbc0ce8f = {
    shade50: '#181202',
    shade40: '#2e2103',
    shade30: '#553e06',
    shade20: '#745408',
    shade10: '#89640a',
    primary: '#986f0b',
    tint10: '#a47d1e',
    tint20: '#b18c34',
    tint30: '#c1a256',
    tint40: '#e0cea2',
    tint50: '#efe4cb',
    tint60: '#fbf8f2'
};
const $b5ad043d24ba28db$export$b6e6178d3f565007 = {
    shade50: '#170e07',
    shade40: '#2b1a0e',
    shade30: '#50301a',
    shade20: '#6c4123',
    shade10: '#804d29',
    primary: '#8e562e',
    tint10: '#9c663f',
    tint20: '#a97652',
    tint30: '#bb8f6f',
    tint40: '#ddc3b0',
    tint50: '#edded3',
    tint60: '#faf7f4'
};
const $b5ad043d24ba28db$export$7faf1229eaed2d5a = {
    shade50: '#0c0704',
    shade40: '#170c08',
    shade30: '#2b1710',
    shade20: '#3a1f15',
    shade10: '#452519',
    primary: '#4d291c',
    tint10: '#623a2b',
    tint20: '#784d3e',
    tint30: '#946b5c',
    tint40: '#caada3',
    tint50: '#e3d2cb',
    tint60: '#f8f3f2'
};
const $b5ad043d24ba28db$export$221d31baf2636aad = {
    shade50: '#121b06',
    shade40: '#23330b',
    shade30: '#405f14',
    shade20: '#57811b',
    shade10: '#689920',
    primary: '#73aa24',
    tint10: '#81b437',
    tint20: '#90be4c',
    tint30: '#a4cc6c',
    tint40: '#cfe5af',
    tint50: '#e5f1d3',
    tint60: '#f8fcf4'
};
const $b5ad043d24ba28db$export$237f8a8a93370cbc = {
    shade50: '#0c1501',
    shade40: '#162702',
    shade30: '#294903',
    shade20: '#376304',
    shade10: '#427505',
    primary: '#498205',
    tint10: '#599116',
    tint20: '#6ba02b',
    tint30: '#85b44c',
    tint40: '#bdd99b',
    tint50: '#dbebc7',
    tint60: '#f6faf0'
};
const $b5ad043d24ba28db$export$462b2ea9f2b19f0a = {
    shade50: '#002111',
    shade40: '#003d20',
    shade30: '#00723b',
    shade20: '#009b51',
    shade10: '#00b85f',
    primary: '#00cc6a',
    tint10: '#19d279',
    tint20: '#34d889',
    tint30: '#5ae0a0',
    tint40: '#a8f0cd',
    tint50: '#cff7e4',
    tint60: '#f3fdf8'
};
const $b5ad043d24ba28db$export$559a8c00376dc936 = {
    shade50: '#031a02',
    shade40: '#063004',
    shade30: '#0b5a08',
    shade20: '#0e7a0b',
    shade10: '#11910d',
    primary: '#13a10e',
    tint10: '#27ac22',
    tint20: '#3db838',
    tint30: '#5ec75a',
    tint40: '#a7e3a5',
    tint50: '#cef0cd',
    tint60: '#f2fbf2'
};
const $b5ad043d24ba28db$export$955a2ebd2fb142ae = {
    shade50: '#031403',
    shade40: '#052505',
    shade30: '#094509',
    shade20: '#0c5e0c',
    shade10: '#0e700e',
    primary: '#107c10',
    tint10: '#218c21',
    tint20: '#359b35',
    tint30: '#54b054',
    tint40: '#9fd89f',
    tint50: '#c9eac9',
    tint60: '#f1faf1'
};
const $b5ad043d24ba28db$export$430774e3f59aae50 = {
    shade50: '#021102',
    shade40: '#032003',
    shade30: '#063b06',
    shade20: '#085108',
    shade10: '#0a5f0a',
    primary: '#0b6a0b',
    tint10: '#1a7c1a',
    tint20: '#2d8e2d',
    tint30: '#4da64d',
    tint40: '#9ad29a',
    tint50: '#c6e7c6',
    tint60: '#f0f9f0'
};
const $b5ad043d24ba28db$export$6d8f981b04aed00b = {
    shade50: '#001d1f',
    shade40: '#00373a',
    shade30: '#00666d',
    shade20: '#008b94',
    shade10: '#00a5af',
    primary: '#00b7c3',
    tint10: '#18bfca',
    tint20: '#32c8d1',
    tint30: '#58d3db',
    tint40: '#a6e9ed',
    tint50: '#cef3f5',
    tint60: '#f2fcfd'
};
const $b5ad043d24ba28db$export$8bf7dff220b82b4a = {
    shade50: '#001516',
    shade40: '#012728',
    shade30: '#02494c',
    shade20: '#026467',
    shade10: '#037679',
    primary: '#038387',
    tint10: '#159195',
    tint20: '#2aa0a4',
    tint30: '#4cb4b7',
    tint40: '#9bd9db',
    tint50: '#c7ebec',
    tint60: '#f0fafa'
};
const $b5ad043d24ba28db$export$26f90d83836189f4 = {
    shade50: '#001010',
    shade40: '#001f1f',
    shade30: '#003939',
    shade20: '#004e4e',
    shade10: '#005c5c',
    primary: '#006666',
    tint10: '#0e7878',
    tint20: '#218b8b',
    tint30: '#41a3a3',
    tint40: '#92d1d1',
    tint50: '#c2e7e7',
    tint60: '#eff9f9'
};
const $b5ad043d24ba28db$export$7474046f446842ee = {
    shade50: '#00181e',
    shade40: '#002e38',
    shade30: '#005669',
    shade20: '#00748f',
    shade10: '#008aa9',
    primary: '#0099bc',
    tint10: '#18a4c4',
    tint20: '#31afcc',
    tint30: '#56bfd7',
    tint40: '#a4deeb',
    tint50: '#cdedf4',
    tint60: '#f2fafc'
};
const $b5ad043d24ba28db$export$1b2526e493adfe9 = {
    shade50: '#000f12',
    shade40: '#001b22',
    shade30: '#00333f',
    shade20: '#004555',
    shade10: '#005265',
    primary: '#005b70',
    tint10: '#0f6c81',
    tint20: '#237d92',
    tint30: '#4496a9',
    tint40: '#94c8d4',
    tint50: '#c3e1e8',
    tint60: '#eff7f9'
};
const $b5ad043d24ba28db$export$7b0d29b70b435c21 = {
    shade50: '#091823',
    shade40: '#112d42',
    shade30: '#20547c',
    shade20: '#2c72a8',
    shade10: '#3487c7',
    primary: '#3a96dd',
    tint10: '#4fa1e1',
    tint20: '#65ade5',
    tint30: '#83bdeb',
    tint40: '#bfddf5',
    tint50: '#dcedfa',
    tint60: '#f6fafe'
};
const $b5ad043d24ba28db$export$2aa0182783e7e9de = {
    shade50: '#001322',
    shade40: '#002440',
    shade30: '#004377',
    shade20: '#005ba1',
    shade10: '#006cbf',
    primary: '#0078d4',
    tint10: '#1a86d9',
    tint20: '#3595de',
    tint30: '#5caae5',
    tint40: '#a9d3f2',
    tint50: '#d0e7f8',
    tint60: '#f3f9fd'
};
const $b5ad043d24ba28db$export$2ad0c329ccd958f8 = {
    shade50: '#000c16',
    shade40: '#00172a',
    shade30: '#002c4e',
    shade20: '#003b6a',
    shade10: '#00467e',
    primary: '#004e8c',
    tint10: '#125e9a',
    tint20: '#286fa8',
    tint30: '#4a89ba',
    tint40: '#9abfdc',
    tint50: '#c7dced',
    tint60: '#f0f6fa'
};
const $b5ad043d24ba28db$export$4b45ecf3922b2c9e = {
    shade50: '#000910',
    shade40: '#00111f',
    shade30: '#002039',
    shade20: '#002b4e',
    shade10: '#00335c',
    primary: '#003966',
    tint10: '#0e4a78',
    tint20: '#215c8b',
    tint30: '#4178a3',
    tint40: '#92b5d1',
    tint50: '#c2d6e7',
    tint60: '#eff4f9'
};
const $b5ad043d24ba28db$export$795f8b146347687c = {
    shade50: '#0d1126',
    shade40: '#182047',
    shade30: '#2c3c85',
    shade20: '#3c51b4',
    shade10: '#4760d5',
    primary: '#4f6bed',
    tint10: '#637cef',
    tint20: '#778df1',
    tint30: '#93a4f4',
    tint40: '#c8d1fa',
    tint50: '#e1e6fc',
    tint60: '#f7f9fe'
};
const $b5ad043d24ba28db$export$54a390250b5a3226 = {
    shade50: '#00061d',
    shade40: '#000c36',
    shade30: '#001665',
    shade20: '#001e89',
    shade10: '#0023a2',
    primary: '#0027b4',
    tint10: '#173bbd',
    tint20: '#3050c6',
    tint30: '#546fd2',
    tint40: '#a3b2e8',
    tint50: '#ccd5f3',
    tint60: '#f2f4fc'
};
const $b5ad043d24ba28db$export$6733231e677ed539 = {
    shade50: '#120f25',
    shade40: '#221d46',
    shade30: '#3f3682',
    shade20: '#5649b0',
    shade10: '#6656d1',
    primary: '#7160e8',
    tint10: '#8172eb',
    tint20: '#9184ee',
    tint30: '#a79cf1',
    tint40: '#d2ccf8',
    tint50: '#e7e4fb',
    tint60: '#f9f8fe'
};
const $b5ad043d24ba28db$export$e13cce2a2d16a9d4 = {
    shade50: '#0f0717',
    shade40: '#1c0e2b',
    shade30: '#341a51',
    shade20: '#46236e',
    shade10: '#532982',
    primary: '#5c2e91',
    tint10: '#6b3f9e',
    tint20: '#7c52ab',
    tint30: '#9470bd',
    tint40: '#c6b1de',
    tint50: '#e0d3ed',
    tint60: '#f7f4fb'
};
const $b5ad043d24ba28db$export$531848508337a8f0 = {
    shade50: '#0a0411',
    shade40: '#130820',
    shade30: '#240f3c',
    shade20: '#311552',
    shade10: '#3a1861',
    primary: '#401b6c',
    tint10: '#512b7e',
    tint20: '#633e8f',
    tint30: '#7e5ca7',
    tint40: '#b9a3d3',
    tint50: '#d8cce7',
    tint60: '#f5f2f9'
};
const $b5ad043d24ba28db$export$18ae87cb0ad417dd = {
    shade50: '#16101d',
    shade40: '#281e37',
    shade30: '#4c3867',
    shade20: '#674c8c',
    shade10: '#795aa6',
    primary: '#8764b8',
    tint10: '#9373c0',
    tint20: '#a083c9',
    tint30: '#b29ad4',
    tint40: '#d7caea',
    tint50: '#e9e2f4',
    tint60: '#f9f8fc'
};
const $b5ad043d24ba28db$export$e790e457d5be15f9 = {
    shade50: '#160418',
    shade40: '#29072e',
    shade30: '#4c0d55',
    shade20: '#671174',
    shade10: '#7a1589',
    primary: '#881798',
    tint10: '#952aa4',
    tint20: '#a33fb1',
    tint30: '#b55fc1',
    tint40: '#d9a7e0',
    tint50: '#eaceef',
    tint60: '#faf2fb'
};
const $b5ad043d24ba28db$export$aa5190c8aa93b338 = {
    shade50: '#1f091d',
    shade40: '#3a1136',
    shade30: '#6d2064',
    shade20: '#932b88',
    shade10: '#af33a1',
    primary: '#c239b3',
    tint10: '#c94cbc',
    tint20: '#d161c4',
    tint30: '#da7ed0',
    tint40: '#edbbe7',
    tint50: '#f5daf2',
    tint60: '#fdf5fc'
};
const $b5ad043d24ba28db$export$b6ee5bb1c79d6ef5 = {
    shade50: '#1c0b1f',
    shade40: '#35153a',
    shade30: '#63276d',
    shade20: '#863593',
    shade10: '#9f3faf',
    primary: '#b146c2',
    tint10: '#ba58c9',
    tint20: '#c36bd1',
    tint30: '#cf87da',
    tint40: '#e6bfed',
    tint50: '#f2dcf5',
    tint60: '#fcf6fd'
};
const $b5ad043d24ba28db$export$47853bc718611763 = {
    shade50: '#24091b',
    shade40: '#441232',
    shade30: '#80215d',
    shade20: '#ad2d7e',
    shade10: '#cd3595',
    primary: '#e43ba6',
    tint10: '#e750b0',
    tint20: '#ea66ba',
    tint30: '#ef85c8',
    tint40: '#f7c0e3',
    tint50: '#fbddf0',
    tint60: '#fef6fb'
};
const $b5ad043d24ba28db$export$9e214c7c54526b7e = {
    shade50: '#240016',
    shade40: '#44002a',
    shade30: '#7f004e',
    shade20: '#ad006a',
    shade10: '#cc007e',
    primary: '#e3008c',
    tint10: '#e61c99',
    tint20: '#ea38a6',
    tint30: '#ee5fb7',
    tint40: '#f7adda',
    tint50: '#fbd2eb',
    tint60: '#fef4fa'
};
const $b5ad043d24ba28db$export$2a9ca2e383622e18 = {
    shade50: '#1f0013',
    shade40: '#390024',
    shade30: '#6b0043',
    shade20: '#91005a',
    shade10: '#ac006b',
    primary: '#bf0077',
    tint10: '#c71885',
    tint20: '#ce3293',
    tint30: '#d957a8',
    tint40: '#eca5d1',
    tint50: '#f5cee6',
    tint60: '#fcf2f9'
};
const $b5ad043d24ba28db$export$7e2f956ffaea92f4 = {
    shade50: '#13000c',
    shade40: '#240017',
    shade30: '#43002b',
    shade20: '#5a003b',
    shade10: '#6b0045',
    primary: '#77004d',
    tint10: '#87105d',
    tint20: '#98246f',
    tint30: '#ad4589',
    tint40: '#d696c0',
    tint50: '#e9c4dc',
    tint60: '#faf0f6'
};
const $b5ad043d24ba28db$export$67f6b138820ffeff = {
    shade50: '#141313',
    shade40: '#252323',
    shade30: '#444241',
    shade20: '#5d5958',
    shade10: '#6e6968',
    primary: '#7a7574',
    tint10: '#8a8584',
    tint20: '#9a9594',
    tint30: '#afabaa',
    tint40: '#d7d4d4',
    tint50: '#eae8e8',
    tint60: '#faf9f9'
};
const $b5ad043d24ba28db$export$b1b33eef2ea56364 = {
    shade50: '#0f0e0e',
    shade40: '#1c1b1a',
    shade30: '#343231',
    shade20: '#474443',
    shade10: '#54514f',
    primary: '#5d5a58',
    tint10: '#706d6b',
    tint20: '#84817e',
    tint30: '#9e9b99',
    tint40: '#cecccb',
    tint50: '#e5e4e3',
    tint60: '#f8f8f8'
};
const $b5ad043d24ba28db$export$2cf0ade8bd62135d = {
    shade50: '#151818',
    shade40: '#282d2e',
    shade30: '#4a5356',
    shade20: '#657174',
    shade10: '#78868a',
    primary: '#859599',
    tint10: '#92a1a5',
    tint20: '#a0aeb1',
    tint30: '#b3bfc2',
    tint40: '#d8dfe0',
    tint50: '#eaeeef',
    tint60: '#fafbfb'
};
const $b5ad043d24ba28db$export$6bdaf02d1a16321f = {
    shade50: '#111314',
    shade40: '#1f2426',
    shade30: '#3b4447',
    shade20: '#505c60',
    shade10: '#5f6d71',
    primary: '#69797e',
    tint10: '#79898d',
    tint20: '#89989d',
    tint30: '#a0adb2',
    tint40: '#cdd6d8',
    tint50: '#e4e9ea',
    tint60: '#f8f9fa'
};
const $b5ad043d24ba28db$export$2e2992790a6f69a8 = {
    shade50: '#090a0b',
    shade40: '#111315',
    shade30: '#202427',
    shade20: '#2b3135',
    shade10: '#333a3f',
    primary: '#394146',
    tint10: '#4d565c',
    tint20: '#626c72',
    tint30: '#808a90',
    tint40: '#bcc3c7',
    tint50: '#dbdfe1',
    tint60: '#f6f7f8'
};
const $b5ad043d24ba28db$export$c8b8418aada2724d = {
    shade50: '#090909',
    shade40: '#111111',
    shade30: '#202020',
    shade20: '#2b2b2b',
    shade10: '#333333',
    primary: '#393939',
    tint10: '#515151',
    tint20: '#686868',
    tint30: '#888888',
    tint40: '#c4c4c4',
    tint50: '#dfdfdf',
    tint60: '#f7f7f7'
};


const $63dac749da2ca71c$export$4c0b5edd4f42c93 = {
    red: $b5ad043d24ba28db$export$a90204d1394caf30,
    green: $b5ad043d24ba28db$export$955a2ebd2fb142ae,
    darkOrange: $b5ad043d24ba28db$export$4a29193d55cdecba,
    yellow: $b5ad043d24ba28db$export$594c5a8758200c32,
    berry: $b5ad043d24ba28db$export$aa5190c8aa93b338,
    lightGreen: $b5ad043d24ba28db$export$559a8c00376dc936,
    marigold: $b5ad043d24ba28db$export$b8872f2e62a1cb31
};
const $63dac749da2ca71c$export$dcab5894597dfcba = {
    darkRed: $b5ad043d24ba28db$export$76a6bc0ea014735a,
    cranberry: $b5ad043d24ba28db$export$94cf3141ea3c5416,
    pumpkin: $b5ad043d24ba28db$export$978fe4ac22d00df0,
    peach: $b5ad043d24ba28db$export$c96cfe71516d2e98,
    gold: $b5ad043d24ba28db$export$c24201f7fe3571d8,
    brass: $b5ad043d24ba28db$export$32afe192cbc0ce8f,
    brown: $b5ad043d24ba28db$export$b6e6178d3f565007,
    forest: $b5ad043d24ba28db$export$237f8a8a93370cbc,
    seafoam: $b5ad043d24ba28db$export$462b2ea9f2b19f0a,
    darkGreen: $b5ad043d24ba28db$export$430774e3f59aae50,
    lightTeal: $b5ad043d24ba28db$export$6d8f981b04aed00b,
    teal: $b5ad043d24ba28db$export$8bf7dff220b82b4a,
    steel: $b5ad043d24ba28db$export$1b2526e493adfe9,
    blue: $b5ad043d24ba28db$export$2aa0182783e7e9de,
    royalBlue: $b5ad043d24ba28db$export$2ad0c329ccd958f8,
    cornflower: $b5ad043d24ba28db$export$795f8b146347687c,
    navy: $b5ad043d24ba28db$export$54a390250b5a3226,
    lavender: $b5ad043d24ba28db$export$6733231e677ed539,
    purple: $b5ad043d24ba28db$export$e13cce2a2d16a9d4,
    grape: $b5ad043d24ba28db$export$e790e457d5be15f9,
    lilac: $b5ad043d24ba28db$export$b6ee5bb1c79d6ef5,
    pink: $b5ad043d24ba28db$export$47853bc718611763,
    magenta: $b5ad043d24ba28db$export$2a9ca2e383622e18,
    plum: $b5ad043d24ba28db$export$7e2f956ffaea92f4,
    beige: $b5ad043d24ba28db$export$67f6b138820ffeff,
    mink: $b5ad043d24ba28db$export$b1b33eef2ea56364,
    platinum: $b5ad043d24ba28db$export$6bdaf02d1a16321f,
    anchor: $b5ad043d24ba28db$export$2e2992790a6f69a8
};
const $63dac749da2ca71c$export$1e10db4a50d6990f = {
    cranberry: $b5ad043d24ba28db$export$94cf3141ea3c5416,
    green: $b5ad043d24ba28db$export$955a2ebd2fb142ae,
    orange: $b5ad043d24ba28db$export$ad766f34ace1cafd
};


/* Names of colors used in shared color palette alias tokens for status. */ const $645e5d53bca43f72$export$64b4612230bf8b2e = [
    'red',
    'green',
    'darkOrange',
    'yellow',
    'berry',
    'lightGreen',
    'marigold'
];
const $645e5d53bca43f72$export$426ec1c4cd4b768b = [
    'darkRed',
    'cranberry',
    'pumpkin',
    'peach',
    'gold',
    'brass',
    'brown',
    'forest',
    'seafoam',
    'darkGreen',
    'lightTeal',
    'teal',
    'steel',
    'blue',
    'royalBlue',
    'cornflower',
    'navy',
    'lavender',
    'purple',
    'grape',
    'lilac',
    'pink',
    'magenta',
    'plum',
    'beige',
    'mink',
    'platinum',
    'anchor'
];
const $645e5d53bca43f72$export$e8a467959e154e9f = [
    'cranberry',
    'green',
    'orange'
];
const $645e5d53bca43f72$export$40d9527c4c20ee9 = [
    'burgundy',
    'bronze',
    'orange',
    'darkBrown',
    'lime',
    'darkTeal',
    'cyan',
    'lightBlue',
    'darkBlue',
    'darkPurple',
    'orchid',
    'hotPink',
    'silver',
    'charcoal'
];


const $7c62b853e5b72fe4$export$f03eacea8b051531 = {
    success: 'green',
    warning: 'orange',
    danger: 'cranberry'
};


const $ef31f20e44253014$var$statusColorPaletteTokens = (0, $645e5d53bca43f72$export$64b4612230bf8b2e).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint60,
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint40,
        [`colorPalette${color}Background3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Foreground1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade10,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade30,
        [`colorPalette${color}Foreground3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Border1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint40,
        [`colorPalette${color}Border2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
// one-off patch for yellow
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteYellowForeground1 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).yellow.shade30;
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteRedForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.tint20;
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteGreenForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.tint20;
$ef31f20e44253014$var$statusColorPaletteTokens.colorPaletteYellowForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).yellow.tint40;
const $ef31f20e44253014$var$personaColorPaletteTokens = (0, $645e5d53bca43f72$export$426ec1c4cd4b768b).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].tint40,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].shade30,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].primary
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
const $ef31f20e44253014$export$d72a599962b8f734 = {
    ...$ef31f20e44253014$var$statusColorPaletteTokens,
    ...$ef31f20e44253014$var$personaColorPaletteTokens
};
const $ef31f20e44253014$export$3557c617aeef1561 = Object.entries((0, $7c62b853e5b72fe4$export$f03eacea8b051531)).reduce((acc, [statusColor, sharedColor])=>{
    const color = statusColor.slice(0, 1).toUpperCase() + statusColor.slice(1);
    // TODO: double check the mapping with design
    const statusColorTokens = {
        [`colorStatus${color}Background1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint60,
        [`colorStatus${color}Background2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint40,
        [`colorStatus${color}Background3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Foreground1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade10,
        [`colorStatus${color}Foreground2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade30,
        [`colorStatus${color}Foreground3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}ForegroundInverted`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint30,
        [`colorStatus${color}BorderActive`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Border1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint40,
        [`colorStatus${color}Border2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary
    };
    return Object.assign(acc, statusColorTokens);
}, {});
// one-off overrides for colorStatus tokens
$ef31f20e44253014$export$3557c617aeef1561.colorStatusDangerBackground3Hover = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade10;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusDangerBackground3Pressed = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade20;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusWarningForeground1 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusWarningForeground3 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;
$ef31f20e44253014$export$3557c617aeef1561.colorStatusWarningBorder2 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;


/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ 
const $8229bf3c6591f767$export$ad9a05e30090f047 = (brand)=>({
        colorNeutralForeground1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground2Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2BrandHover: brand[80],
        colorNeutralForeground2BrandPressed: brand[70],
        colorNeutralForeground2BrandSelected: brand[80],
        colorNeutralForeground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[38],
        colorNeutralForeground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground3BrandHover: brand[80],
        colorNeutralForeground3BrandPressed: brand[70],
        colorNeutralForeground3BrandSelected: brand[80],
        colorNeutralForeground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[44],
        colorNeutralForeground5: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[38],
        colorNeutralForeground5Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground5Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground5Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[74],
        colorNeutralForegroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorBrandForegroundLink: brand[70],
        colorBrandForegroundLinkHover: brand[60],
        colorBrandForegroundLinkPressed: brand[40],
        colorBrandForegroundLinkSelected: brand[70],
        colorNeutralForeground2Link: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralForeground2LinkHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2LinkPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForeground2LinkSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorCompoundBrandForeground1: brand[80],
        colorCompoundBrandForeground1Hover: brand[70],
        colorCompoundBrandForeground1Pressed: brand[60],
        colorBrandForeground1: brand[80],
        colorBrandForeground2: brand[70],
        colorBrandForeground2Hover: brand[60],
        colorBrandForeground2Pressed: brand[30],
        colorNeutralForeground1Static: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundStaticInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInverted2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundOnBrand: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLink: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandForegroundInverted: brand[100],
        colorBrandForegroundInvertedHover: brand[110],
        colorBrandForegroundInvertedPressed: brand[100],
        colorBrandForegroundOnLight: brand[80],
        colorBrandForegroundOnLightHover: brand[70],
        colorBrandForegroundOnLightPressed: brand[50],
        colorBrandForegroundOnLightSelected: brand[60],
        colorNeutralBackground1: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackground1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralBackground1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralBackground2Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackground2Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[86],
        colorNeutralBackground2Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[90],
        colorNeutralBackground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralBackground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralBackground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackground4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralBackground4Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground4Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackground5: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground5Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackground5Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackground5Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralBackground6: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[90],
        colorNeutralBackground7: '#00000000',
        colorNeutralBackground7Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackground7Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralBackground7Selected: '#00000000',
        colorNeutralBackground8: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[99],
        colorNeutralBackgroundInverted: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorNeutralBackgroundStatic: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralBackgroundAlpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[50],
        colorNeutralBackgroundAlpha2: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[80],
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorSubtleBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorSubtleBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorSubtleBackgroundLightAlphaHover: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[70],
        colorSubtleBackgroundLightAlphaPressed: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[50],
        colorSubtleBackgroundLightAlphaSelected: 'transparent',
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[10],
        colorSubtleBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[30],
        colorSubtleBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[20],
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: 'transparent',
        colorTransparentBackgroundPressed: 'transparent',
        colorTransparentBackgroundSelected: 'transparent',
        colorNeutralBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralBackgroundDisabled2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackgroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStencil1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[90],
        colorNeutralStencil2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralStencil1Alpha: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[10],
        colorNeutralStencil2Alpha: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[5],
        colorBackgroundOverlay: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[40],
        colorScrollbarOverlay: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[50],
        colorBrandBackground: brand[80],
        colorBrandBackgroundHover: brand[70],
        colorBrandBackgroundPressed: brand[40],
        colorBrandBackgroundSelected: brand[60],
        colorCompoundBrandBackground: brand[80],
        colorCompoundBrandBackgroundHover: brand[70],
        colorCompoundBrandBackgroundPressed: brand[60],
        colorBrandBackgroundStatic: brand[80],
        colorBrandBackground2: brand[160],
        colorBrandBackground2Hover: brand[150],
        colorBrandBackground2Pressed: brand[130],
        colorBrandBackground3Static: brand[60],
        colorBrandBackground4Static: brand[40],
        colorBrandBackgroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandBackgroundInvertedHover: brand[160],
        colorBrandBackgroundInvertedPressed: brand[140],
        colorBrandBackgroundInvertedSelected: brand[150],
        colorNeutralCardBackground: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[98],
        colorNeutralCardBackgroundHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralCardBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralCardBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralCardBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralStrokeAccessible: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[38],
        colorNeutralStrokeAccessibleHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[34],
        colorNeutralStrokeAccessiblePressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[30],
        colorNeutralStrokeAccessibleSelected: brand[80],
        colorNeutralStroke1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[82],
        colorNeutralStroke1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[78],
        colorNeutralStroke1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[70],
        colorNeutralStroke1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[74],
        colorNeutralStroke2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStroke3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[94],
        colorNeutralStroke4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralStroke4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStroke4Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralStroke4Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralStrokeSubtle: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStrokeOnBrand: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandStroke1: brand[80],
        colorBrandStroke2: brand[140],
        colorBrandStroke2Hover: brand[120],
        colorBrandStroke2Pressed: brand[80],
        colorBrandStroke2Contrast: brand[140],
        colorCompoundBrandStroke: brand[80],
        colorCompoundBrandStrokeHover: brand[70],
        colorCompoundBrandStrokePressed: brand[60],
        colorNeutralStrokeDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralStrokeDisabled2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralStrokeInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorTransparentStroke: 'transparent',
        colorTransparentStrokeInteractive: 'transparent',
        colorTransparentStrokeDisabled: 'transparent',
        colorNeutralStrokeAlpha: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[5],
        colorNeutralStrokeAlpha2: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[20],
        colorStrokeFocus1: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorStrokeFocus2: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.06)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.07)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.20)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.24)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });


const $ce6bdb492800e603$export$7a57f79000377ca2 = {
    borderRadiusNone: '0',
    borderRadiusSmall: '2px',
    borderRadiusMedium: '4px',
    borderRadiusLarge: '6px',
    borderRadiusXLarge: '8px',
    borderRadius2XLarge: '12px',
    borderRadius3XLarge: '16px',
    borderRadius4XLarge: '24px',
    borderRadius5XLarge: '32px',
    borderRadius6XLarge: '40px',
    borderRadiusCircular: '10000px'
};

const $acaa7b1cbd308031$export$67baea80019ff381 = {
    fontSizeBase100: '10px',
    fontSizeBase200: '12px',
    fontSizeBase300: '14px',
    fontSizeBase400: '16px',
    fontSizeBase500: '20px',
    fontSizeBase600: '24px',
    fontSizeHero700: '28px',
    fontSizeHero800: '32px',
    fontSizeHero900: '40px',
    fontSizeHero1000: '68px'
};
const $acaa7b1cbd308031$export$e646ed6b629bf51e = {
    lineHeightBase100: '14px',
    lineHeightBase200: '16px',
    lineHeightBase300: '20px',
    lineHeightBase400: '22px',
    lineHeightBase500: '28px',
    lineHeightBase600: '32px',
    lineHeightHero700: '36px',
    lineHeightHero800: '40px',
    lineHeightHero900: '52px',
    lineHeightHero1000: '92px'
};
const $acaa7b1cbd308031$export$59230918eb9bd861 = {
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemibold: 600,
    fontWeightBold: 700
};
const $acaa7b1cbd308031$export$709a39c897136e8 = {
    fontFamilyBase: "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
    fontFamilyMonospace: "Consolas, 'Courier New', Courier, monospace",
    fontFamilyNumeric: "Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"
};

const $69e80ab434f476c6$export$fe6cfaf27a046d4c = {
    strokeWidthThin: '1px',
    strokeWidthThick: '2px',
    strokeWidthThicker: '3px',
    strokeWidthThickest: '4px'
};


function $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f(ambientColor, keyColor, tokenSuffix = '') {
    return {
        [`shadow2${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 1px 2px ${keyColor}`,
        [`shadow4${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 2px 4px ${keyColor}`,
        [`shadow8${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 4px 8px ${keyColor}`,
        [`shadow16${tokenSuffix}`]: `0 0 2px ${ambientColor}, 0 8px 16px ${keyColor}`,
        [`shadow28${tokenSuffix}`]: `0 0 8px ${ambientColor}, 0 14px 28px ${keyColor}`,
        [`shadow64${tokenSuffix}`]: `0 0 8px ${ambientColor}, 0 32px 64px ${keyColor}`
    };
}


const $1ac2042b55cb6fc4$export$38b928a7167ce124 = {
    durationUltraFast: '50ms',
    durationFaster: '100ms',
    durationFast: '150ms',
    durationNormal: '200ms',
    durationGentle: '250ms',
    durationSlow: '300ms',
    durationSlower: '400ms',
    durationUltraSlow: '500ms'
};


const $a38b2c50157e284b$export$6894093bf294bea5 = {
    curveAccelerateMax: 'cubic-bezier(0.9,0.1,1,0.2)',
    curveAccelerateMid: 'cubic-bezier(1,0,1,1)',
    curveAccelerateMin: 'cubic-bezier(0.8,0,0.78,1)',
    curveDecelerateMax: 'cubic-bezier(0.1,0.9,0.2,1)',
    curveDecelerateMid: 'cubic-bezier(0,0,0,1)',
    curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
    curveEasyEaseMax: 'cubic-bezier(0.8,0,0.2,1)',
    curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
    curveLinear: 'cubic-bezier(0,0,1,1)'
};


// Intentionally not exported! Use horizontalSpacings and verticalSpacings instead.
const $d15e16efc3c976b1$var$spacings = {
    none: '0',
    xxs: '2px',
    xs: '4px',
    sNudge: '6px',
    s: '8px',
    mNudge: '10px',
    m: '12px',
    l: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px'
};
const $d15e16efc3c976b1$export$a4db2e0274ce31ed = {
    spacingHorizontalNone: $d15e16efc3c976b1$var$spacings.none,
    spacingHorizontalXXS: $d15e16efc3c976b1$var$spacings.xxs,
    spacingHorizontalXS: $d15e16efc3c976b1$var$spacings.xs,
    spacingHorizontalSNudge: $d15e16efc3c976b1$var$spacings.sNudge,
    spacingHorizontalS: $d15e16efc3c976b1$var$spacings.s,
    spacingHorizontalMNudge: $d15e16efc3c976b1$var$spacings.mNudge,
    spacingHorizontalM: $d15e16efc3c976b1$var$spacings.m,
    spacingHorizontalL: $d15e16efc3c976b1$var$spacings.l,
    spacingHorizontalXL: $d15e16efc3c976b1$var$spacings.xl,
    spacingHorizontalXXL: $d15e16efc3c976b1$var$spacings.xxl,
    spacingHorizontalXXXL: $d15e16efc3c976b1$var$spacings.xxxl
};
const $d15e16efc3c976b1$export$9f57b7461d659f60 = {
    spacingVerticalNone: $d15e16efc3c976b1$var$spacings.none,
    spacingVerticalXXS: $d15e16efc3c976b1$var$spacings.xxs,
    spacingVerticalXS: $d15e16efc3c976b1$var$spacings.xs,
    spacingVerticalSNudge: $d15e16efc3c976b1$var$spacings.sNudge,
    spacingVerticalS: $d15e16efc3c976b1$var$spacings.s,
    spacingVerticalMNudge: $d15e16efc3c976b1$var$spacings.mNudge,
    spacingVerticalM: $d15e16efc3c976b1$var$spacings.m,
    spacingVerticalL: $d15e16efc3c976b1$var$spacings.l,
    spacingVerticalXL: $d15e16efc3c976b1$var$spacings.xl,
    spacingVerticalXXL: $d15e16efc3c976b1$var$spacings.xxl,
    spacingVerticalXXXL: $d15e16efc3c976b1$var$spacings.xxxl
};


const $e46fa2d032c035de$export$433454ecdac7def9 = (brand)=>{
    const colorTokens = (0, $8229bf3c6591f767$export$ad9a05e30090f047)(brand);
    return {
        ...(0, $ce6bdb492800e603$export$7a57f79000377ca2),
        ...(0, $acaa7b1cbd308031$export$67baea80019ff381),
        ...(0, $acaa7b1cbd308031$export$e646ed6b629bf51e),
        ...(0, $acaa7b1cbd308031$export$709a39c897136e8),
        ...(0, $acaa7b1cbd308031$export$59230918eb9bd861),
        ...(0, $69e80ab434f476c6$export$fe6cfaf27a046d4c),
        ...(0, $d15e16efc3c976b1$export$a4db2e0274ce31ed),
        ...(0, $d15e16efc3c976b1$export$9f57b7461d659f60),
        ...(0, $1ac2042b55cb6fc4$export$38b928a7167ce124),
        ...(0, $a38b2c50157e284b$export$6894093bf294bea5),
        ...colorTokens,
        ...(0, $ef31f20e44253014$export$d72a599962b8f734),
        ...(0, $ef31f20e44253014$export$3557c617aeef1561),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, 'Brand')
    };
};

/* color palette used in both darkTheme and teamsDarkTheme */ 


const $1e4b4c09e9bf881e$var$statusColorPaletteTokens = (0, $645e5d53bca43f72$export$64b4612230bf8b2e).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade40,
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].shade30,
        [`colorPalette${color}Background3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Foreground1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint30,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint40,
        [`colorPalette${color}Foreground3`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint20,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint30,
        [`colorPalette${color}Border1`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].primary,
        [`colorPalette${color}Border2`]: (0, $63dac749da2ca71c$export$4c0b5edd4f42c93)[sharedColor].tint20
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
// one-off patches
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteRedForeground3 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteRedBorder2 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteGreenForeground3 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.tint40;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteGreenBorder2 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.tint40;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteDarkOrangeForeground3 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).darkOrange.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteDarkOrangeBorder2 = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).darkOrange.tint30;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteRedForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).red.primary;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteGreenForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).green.primary;
$1e4b4c09e9bf881e$var$statusColorPaletteTokens.colorPaletteYellowForegroundInverted = (0, $63dac749da2ca71c$export$4c0b5edd4f42c93).yellow.shade30;
const $1e4b4c09e9bf881e$var$personaColorPaletteTokens = (0, $645e5d53bca43f72$export$426ec1c4cd4b768b).reduce((acc, sharedColor)=>{
    const color = sharedColor.slice(0, 1).toUpperCase() + sharedColor.slice(1);
    const sharedColorTokens = {
        [`colorPalette${color}Background2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].shade30,
        [`colorPalette${color}Foreground2`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].tint40,
        [`colorPalette${color}BorderActive`]: (0, $63dac749da2ca71c$export$dcab5894597dfcba)[sharedColor].tint30
    };
    return Object.assign(acc, sharedColorTokens);
}, {});
// one-off patches
$1e4b4c09e9bf881e$var$personaColorPaletteTokens.colorPaletteDarkRedBackground2 = (0, $63dac749da2ca71c$export$dcab5894597dfcba).darkRed.shade20;
$1e4b4c09e9bf881e$var$personaColorPaletteTokens.colorPalettePlumBackground2 = (0, $63dac749da2ca71c$export$dcab5894597dfcba).plum.shade20;
const $1e4b4c09e9bf881e$export$d72a599962b8f734 = {
    ...$1e4b4c09e9bf881e$var$statusColorPaletteTokens,
    ...$1e4b4c09e9bf881e$var$personaColorPaletteTokens
};
const $1e4b4c09e9bf881e$export$3557c617aeef1561 = Object.entries((0, $7c62b853e5b72fe4$export$f03eacea8b051531)).reduce((acc, [statusColor, sharedColor])=>{
    const color = statusColor.slice(0, 1).toUpperCase() + statusColor.slice(1);
    // TODO: double check the mapping with design - see the one-off patches above
    const statusColorTokens = {
        [`colorStatus${color}Background1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade40,
        [`colorStatus${color}Background2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade30,
        [`colorStatus${color}Background3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Foreground1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint30,
        [`colorStatus${color}Foreground2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint40,
        [`colorStatus${color}Foreground3`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint20,
        [`colorStatus${color}BorderActive`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint30,
        [`colorStatus${color}ForegroundInverted`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].shade10,
        [`colorStatus${color}Border1`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].primary,
        [`colorStatus${color}Border2`]: (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[sharedColor].tint20
    };
    return Object.assign(acc, statusColorTokens);
}, {});
// one-off overrides for colorStatus tokens
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerBackground3Hover = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade10;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerBackground3Pressed = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].shade20;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerForeground3 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].tint40;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusDangerBorder2 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).danger].tint30;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusSuccessForeground3 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).success].tint40;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusSuccessBorder2 = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).success].tint40;
$1e4b4c09e9bf881e$export$3557c617aeef1561.colorStatusWarningForegroundInverted = (0, $63dac749da2ca71c$export$1e10db4a50d6990f)[(0, $7c62b853e5b72fe4$export$f03eacea8b051531).warning].shade20;


/* !!! DO NOT EDIT !!! */ /* This file has been generated by the token pipeline */ 
const $cfd91c97cbdedd72$export$ad9a05e30090f047 = (brand)=>({
        colorNeutralForeground1: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground1Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground1Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground1Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground2Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2BrandHover: brand[100],
        colorNeutralForeground2BrandPressed: brand[90],
        colorNeutralForeground2BrandSelected: brand[100],
        colorNeutralForeground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[68],
        colorNeutralForeground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground3BrandHover: brand[100],
        colorNeutralForeground3BrandPressed: brand[90],
        colorNeutralForeground3BrandSelected: brand[100],
        colorNeutralForeground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[60],
        colorNeutralForeground5: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[68],
        colorNeutralForeground5Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground5Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground5Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[36],
        colorNeutralForegroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorBrandForegroundLink: brand[100],
        colorBrandForegroundLinkHover: brand[110],
        colorBrandForegroundLinkPressed: brand[90],
        colorBrandForegroundLinkSelected: brand[100],
        colorNeutralForeground2Link: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[84],
        colorNeutralForeground2LinkHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2LinkPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForeground2LinkSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorCompoundBrandForeground1: brand[100],
        colorCompoundBrandForeground1Hover: brand[110],
        colorCompoundBrandForeground1Pressed: brand[90],
        colorBrandForeground1: brand[100],
        colorBrandForeground2: brand[110],
        colorBrandForeground2Hover: brand[130],
        colorBrandForeground2Pressed: brand[160],
        colorNeutralForeground1Static: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundStaticInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInverted: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInvertedHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInvertedPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInvertedSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundInverted2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralForegroundOnBrand: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLink: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkHover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkPressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralForegroundInvertedLinkSelected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandForegroundInverted: brand[80],
        colorBrandForegroundInvertedHover: brand[70],
        colorBrandForegroundInvertedPressed: brand[60],
        colorBrandForegroundOnLight: brand[80],
        colorBrandForegroundOnLightHover: brand[70],
        colorBrandForegroundOnLightPressed: brand[50],
        colorBrandForegroundOnLightSelected: brand[60],
        colorNeutralBackground1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackground1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralBackground1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackground1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorNeutralBackground2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackground2Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralBackground2Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackground2Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorNeutralBackground3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackground3Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackground3Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralBackground3Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralBackground4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralBackground4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[12],
        colorNeutralBackground4Pressed: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorNeutralBackground4Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[10],
        colorNeutralBackground5: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorNeutralBackground5Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackground5Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[2],
        colorNeutralBackground5Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[6],
        colorNeutralBackground6: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralBackground7: '#00000000',
        colorNeutralBackground7Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[10],
        colorNeutralBackground7Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralBackground7Selected: '#00000000',
        colorNeutralBackground8: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackgroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[96],
        colorNeutralBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[88],
        colorNeutralBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[92],
        colorNeutralBackgroundStatic: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralBackgroundAlpha: (0, $b5ad043d24ba28db$export$dbc00436b8ca4a1e)[50],
        colorNeutralBackgroundAlpha2: (0, $b5ad043d24ba28db$export$bf06a928c351ccfc)[70],
        colorSubtleBackground: 'transparent',
        colorSubtleBackgroundHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorSubtleBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorSubtleBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorSubtleBackgroundLightAlphaHover: (0, $b5ad043d24ba28db$export$f146536593fee9ff)[80],
        colorSubtleBackgroundLightAlphaPressed: (0, $b5ad043d24ba28db$export$f146536593fee9ff)[50],
        colorSubtleBackgroundLightAlphaSelected: 'transparent',
        colorSubtleBackgroundInverted: 'transparent',
        colorSubtleBackgroundInvertedHover: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[10],
        colorSubtleBackgroundInvertedPressed: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[30],
        colorSubtleBackgroundInvertedSelected: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[20],
        colorTransparentBackground: 'transparent',
        colorTransparentBackgroundHover: 'transparent',
        colorTransparentBackgroundPressed: 'transparent',
        colorTransparentBackgroundSelected: 'transparent',
        colorNeutralBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralBackgroundDisabled2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralBackgroundInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStencil1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[34],
        colorNeutralStencil2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralStencil1Alpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStencil2Alpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[5],
        colorBackgroundOverlay: (0, $b5ad043d24ba28db$export$8f3334164e0b2b5c)[50],
        colorScrollbarOverlay: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[60],
        colorBrandBackground: brand[70],
        colorBrandBackgroundHover: brand[80],
        colorBrandBackgroundPressed: brand[40],
        colorBrandBackgroundSelected: brand[60],
        colorCompoundBrandBackground: brand[100],
        colorCompoundBrandBackgroundHover: brand[110],
        colorCompoundBrandBackgroundPressed: brand[90],
        colorBrandBackgroundStatic: brand[80],
        colorBrandBackground2: brand[20],
        colorBrandBackground2Hover: brand[40],
        colorBrandBackground2Pressed: brand[10],
        colorBrandBackground3Static: brand[60],
        colorBrandBackground4Static: brand[40],
        colorBrandBackgroundInverted: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandBackgroundInvertedHover: brand[160],
        colorBrandBackgroundInvertedPressed: brand[140],
        colorBrandBackgroundInvertedSelected: brand[150],
        colorNeutralCardBackground: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[20],
        colorNeutralCardBackgroundHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralCardBackgroundPressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorNeutralCardBackgroundSelected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[22],
        colorNeutralCardBackgroundDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[8],
        colorNeutralStrokeAccessible: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[68],
        colorNeutralStrokeAccessibleHover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[74],
        colorNeutralStrokeAccessiblePressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[70],
        colorNeutralStrokeAccessibleSelected: brand[100],
        colorNeutralStroke1: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[40],
        colorNeutralStroke1Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[46],
        colorNeutralStroke1Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[42],
        colorNeutralStroke1Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[44],
        colorNeutralStroke2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[32],
        colorNeutralStroke3: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStroke4: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStroke4Hover: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[18],
        colorNeutralStroke4Pressed: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[14],
        colorNeutralStroke4Selected: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStrokeSubtle: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[4],
        colorNeutralStrokeOnBrand: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[16],
        colorNeutralStrokeOnBrand2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Hover: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Pressed: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralStrokeOnBrand2Selected: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorBrandStroke1: brand[100],
        colorBrandStroke2: brand[50],
        colorBrandStroke2Hover: brand[50],
        colorBrandStroke2Pressed: brand[30],
        colorBrandStroke2Contrast: brand[50],
        colorCompoundBrandStroke: brand[100],
        colorCompoundBrandStrokeHover: brand[110],
        colorCompoundBrandStrokePressed: brand[90],
        colorNeutralStrokeDisabled: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[26],
        colorNeutralStrokeDisabled2: (0, $b5ad043d24ba28db$export$e4c89085febbc618)[24],
        colorNeutralStrokeInvertedDisabled: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[40],
        colorTransparentStroke: 'transparent',
        colorTransparentStrokeInteractive: 'transparent',
        colorTransparentStrokeDisabled: 'transparent',
        colorNeutralStrokeAlpha: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[10],
        colorNeutralStrokeAlpha2: (0, $b5ad043d24ba28db$export$2c27d7ccbdcc7b47)[20],
        colorStrokeFocus1: (0, $b5ad043d24ba28db$export$c073df10e766abfa),
        colorStrokeFocus2: (0, $b5ad043d24ba28db$export$8fa4e5556fd77a60),
        colorNeutralShadowAmbient: 'rgba(0,0,0,0.24)',
        colorNeutralShadowKey: 'rgba(0,0,0,0.28)',
        colorNeutralShadowAmbientLighter: 'rgba(0,0,0,0.12)',
        colorNeutralShadowKeyLighter: 'rgba(0,0,0,0.14)',
        colorNeutralShadowAmbientDarker: 'rgba(0,0,0,0.40)',
        colorNeutralShadowKeyDarker: 'rgba(0,0,0,0.48)',
        colorBrandShadowAmbient: 'rgba(0,0,0,0.30)',
        colorBrandShadowKey: 'rgba(0,0,0,0.25)'
    });







const $3b5403a30a78663f$export$ac47085da93aabfb = (brand)=>{
    const colorTokens = (0, $cfd91c97cbdedd72$export$ad9a05e30090f047)(brand);
    return {
        ...(0, $ce6bdb492800e603$export$7a57f79000377ca2),
        ...(0, $acaa7b1cbd308031$export$67baea80019ff381),
        ...(0, $acaa7b1cbd308031$export$e646ed6b629bf51e),
        ...(0, $acaa7b1cbd308031$export$709a39c897136e8),
        ...(0, $acaa7b1cbd308031$export$59230918eb9bd861),
        ...(0, $69e80ab434f476c6$export$fe6cfaf27a046d4c),
        ...(0, $d15e16efc3c976b1$export$a4db2e0274ce31ed),
        ...(0, $d15e16efc3c976b1$export$9f57b7461d659f60),
        ...(0, $1ac2042b55cb6fc4$export$38b928a7167ce124),
        ...(0, $a38b2c50157e284b$export$6894093bf294bea5),
        ...colorTokens,
        ...(0, $1e4b4c09e9bf881e$export$d72a599962b8f734),
        ...(0, $1e4b4c09e9bf881e$export$3557c617aeef1561),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorNeutralShadowAmbient, colorTokens.colorNeutralShadowKey),
        ...(0, $0e0ca0fda5648cb6$export$cbc0dc4ffe74429f)(colorTokens.colorBrandShadowAmbient, colorTokens.colorBrandShadowKey, 'Brand')
    };
};


var $acw62 = parcelRequire("acw62");
/**
 * @internal
 * Internal reference for the render function
 */ const $a9190614d56c943f$export$2eb147a2bf7697ad = Symbol.for('fui.slotRenderFunction');
const $a9190614d56c943f$export$b8c826907bbed9b7 = Symbol.for('fui.slotElementType');
const $a9190614d56c943f$export$fcc89f7e5475925d = Symbol.for('fui.slotClassNameProp');


function $bf74bb91b065b58d$export$8a437e4937654fbf(element) {
    return Boolean(element === null || element === void 0 ? void 0 : element.hasOwnProperty((0, $a9190614d56c943f$export$b8c826907bbed9b7)));
}


parcelRequire("acw62");
parcelRequire("acw62");

function $a8c7357f7e7cd153$export$5ce282bb9581ca36(type, props) {
    return {
        ...props,
        [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: type
    };
}


parcelRequire("acw62");
function $fccc86cb852ed0d5$export$6c4ce7fc9b1c0ed1(type) {}


function $35e0eb7c96e5d540$export$477dc0b5171b4779(runtime, slotRuntime) {
    return function jsx(type, overrideProps, key, source, self) {
        // TODO:
        // this is for backwards compatibility with getSlotsNext
        // it should be removed once getSlotsNext is obsolete
        if ((0, $bf74bb91b065b58d$export$8a437e4937654fbf)(overrideProps)) return slotRuntime((0, $a8c7357f7e7cd153$export$5ce282bb9581ca36)(type, overrideProps), null, key, source, self);
        if ((0, $bf74bb91b065b58d$export$8a437e4937654fbf)(type)) return slotRuntime(type, overrideProps, key, source, self);
        (0, $fccc86cb852ed0d5$export$6c4ce7fc9b1c0ed1)(type);
        return runtime(type, overrideProps, key, source, self);
    };
}



var $acw62 = parcelRequire("acw62");

function $761c0cc80080c285$export$8d5482c1ab8d280c(type) {
    const { as: as, [(0, $a9190614d56c943f$export$fcc89f7e5475925d)]: _classNameProp, [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: baseElementType, [(0, $a9190614d56c943f$export$2eb147a2bf7697ad)]: renderFunction, ...propsWithoutMetadata } = type;
    const props = propsWithoutMetadata;
    const elementType = typeof baseElementType === 'string' ? as !== null && as !== void 0 ? as : baseElementType : baseElementType;
    if (typeof elementType !== 'string' && as) props.as = as;
    return {
        elementType: elementType,
        props: props,
        renderFunction: renderFunction
    };
}



const $d655fc3c2eeb66d8$export$269330a1f1074312 = $7b02d682eb115277$exports;


const $b8c355fc1cc218b9$export$60ed89c671fedc50 = (type, overrideProps, key)=>{
    const { elementType: elementType, renderFunction: renderFunction, props: slotProps } = (0, $761c0cc80080c285$export$8d5482c1ab8d280c)(type);
    const props = {
        ...slotProps,
        ...overrideProps
    };
    if (renderFunction) return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx($acw62.Fragment, {
        children: renderFunction(elementType, props)
    }, key);
    return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx(elementType, props, key);
};



var $acw62 = parcelRequire("acw62");


const $c87a8fa0f2955fd3$export$6110acb8e9c03b3a = (type, overrideProps, key)=>{
    const { elementType: elementType, renderFunction: renderFunction, props: slotProps } = (0, $761c0cc80080c285$export$8d5482c1ab8d280c)(type);
    const props = {
        ...slotProps,
        ...overrideProps
    };
    if (renderFunction) /**
     * In static runtime then children is an array and this array won't be keyed.
     * We should wrap children by a static fragment
     * as there's no way to know if renderFunction will render statically or dynamically
     */ return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx($acw62.Fragment, {
        children: renderFunction(elementType, {
            ...props,
            children: (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsxs($acw62.Fragment, {
                children: props.children
            }, undefined)
        })
    }, key);
    return (0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsxs(elementType, props, key);
};




var $acw62 = parcelRequire("acw62");
const $505f9e7ea0e895ad$export$34b9dba7ce09269b = (0, $35e0eb7c96e5d540$export$477dc0b5171b4779)((0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsx, (0, $b8c355fc1cc218b9$export$60ed89c671fedc50));
const $505f9e7ea0e895ad$export$25062201e9e25d76 = (0, $35e0eb7c96e5d540$export$477dc0b5171b4779)((0, $d655fc3c2eeb66d8$export$269330a1f1074312).jsxs, (0, $c87a8fa0f2955fd3$export$6110acb8e9c03b3a));


parcelRequire("acw62");



function $637c7ee6d96c4982$export$9b4ff06cafef0276(state) {}

'use client';
function $993af50b96092e61$export$71594e8a50f746f4() {
    return /* eslint-disable @nx/workspace-no-restricted-globals -- expected ignore ( SSR friendly acquisition of globals )*/ typeof window !== 'undefined' && !!(window.document && // eslint-disable-next-line @typescript-eslint/no-deprecated
    window.document.createElement);
}



var $acw62 = parcelRequire("acw62");
"use client";
/**
 * @private
 */ const $314edc3f6e2ad580$var$TextDirectionContext = /*#__PURE__*/ $acw62.createContext('ltr');
/**
 * @public
 */ const $314edc3f6e2ad580$export$c244dbe07f501bcc = ({ children: children, dir: dir })=>{
    return /*#__PURE__*/ $acw62.createElement($314edc3f6e2ad580$var$TextDirectionContext.Provider, {
        value: dir
    }, children);
};
/**
 * Returns current directionality of the element's text.
 *
 * @private
 */ function $314edc3f6e2ad580$export$cf24a79f32f45545() {
    return $acw62.useContext($314edc3f6e2ad580$var$TextDirectionContext);
}



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @internal
 */ const $8221ac192738ccc4$var$ProviderContext = $acw62.createContext(undefined);
const $8221ac192738ccc4$var$providerContextDefaultValue = {
    // eslint-disable-next-line @nx/workspace-no-restricted-globals -- expected ignore ( SSR friendly acquisition of globals )
    targetDocument: typeof document === 'object' ? document : undefined,
    dir: 'ltr'
};
const $8221ac192738ccc4$export$2881499e37b75b9a = $8221ac192738ccc4$var$ProviderContext.Provider;
function $8221ac192738ccc4$export$6ab36604f9d4fd68() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($8221ac192738ccc4$var$ProviderContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $8221ac192738ccc4$var$providerContextDefaultValue;
}


var $acw62 = parcelRequire("acw62");
'use client';
const $7474d1e11e05d082$export$2c657da244d00bd6 = $acw62.createContext(undefined);
const $7474d1e11e05d082$export$d8964aec282183a3 = $7474d1e11e05d082$export$2c657da244d00bd6.Provider;


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @internal
 * Used to provide a CSS class that applies theme css variables
 *
 * Useful for elements in the React tree (can read context) but not in the DOM Tree. E.g. Portals
 */ const $74a09e92d7894ea3$var$ThemeClassNameContext = $acw62.createContext(undefined);
const $74a09e92d7894ea3$var$themeClassNameContextDefaultVaue = '';
const $74a09e92d7894ea3$export$1d607f3624b112f5 = $74a09e92d7894ea3$var$ThemeClassNameContext.Provider;
function $74a09e92d7894ea3$export$4996399749b19890() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($74a09e92d7894ea3$var$ThemeClassNameContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $74a09e92d7894ea3$var$themeClassNameContextDefaultVaue;
}


var $acw62 = parcelRequire("acw62");
'use client';
const $df848b23091d7919$export$d1a6d8b46a5f8f83 = $acw62.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $df848b23091d7919$var$noop = ()=>{};
const $df848b23091d7919$export$f7e4b0d3f201e8be = $df848b23091d7919$export$d1a6d8b46a5f8f83.Provider;
const $df848b23091d7919$export$cf90cf4172902307 = (hook)=>{
    var _React_useContext;
    var _React_useContext_hook;
    return (_React_useContext_hook = (_React_useContext = $acw62.useContext($df848b23091d7919$export$d1a6d8b46a5f8f83)) === null || _React_useContext === void 0 ? void 0 : _React_useContext[hook]) !== null && _React_useContext_hook !== void 0 ? _React_useContext_hook : $df848b23091d7919$var$noop;
};


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @internal
 * Context shared by all of the tooltips in the app
 */ const $90b5c6c5b9aab897$var$TooltipVisibilityContext = $acw62.createContext(undefined);
const $90b5c6c5b9aab897$var$tooltipVisibilityContextDefaultValue = {};
const $90b5c6c5b9aab897$export$6e323c529a2fe2d3 = $90b5c6c5b9aab897$var$TooltipVisibilityContext.Provider;
function $90b5c6c5b9aab897$export$d047e971555191a() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($90b5c6c5b9aab897$var$TooltipVisibilityContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $90b5c6c5b9aab897$var$tooltipVisibilityContextDefaultValue;
}


var $acw62 = parcelRequire("acw62");
'use client';
const $dcb30b81376c0f2d$export$1570cf9bb03c301f = $acw62.createContext(undefined);
const $dcb30b81376c0f2d$export$1008c3d7ef9225de = $dcb30b81376c0f2d$export$1570cf9bb03c301f.Provider;
function $dcb30b81376c0f2d$export$ab0d8295b09da679() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($dcb30b81376c0f2d$export$1570cf9bb03c301f)) !== null && _React_useContext !== void 0 ? _React_useContext : {};
}



var $acw62 = parcelRequire("acw62");
const $29e9ce9867929ff7$var$IconDirectionContext = $acw62.createContext(undefined);
const $29e9ce9867929ff7$var$IconDirectionContextDefaultValue = {};
const $29e9ce9867929ff7$export$6bba08bb4157cc42 = $29e9ce9867929ff7$var$IconDirectionContext.Provider;
const $29e9ce9867929ff7$export$6bed2dfdd7bea160 = ()=>{
    const context = $acw62.useContext($29e9ce9867929ff7$var$IconDirectionContext);
    return context !== null && context !== void 0 ? context : $29e9ce9867929ff7$var$IconDirectionContextDefaultValue;
};


'use client';
const $0b70550ea98bf3a8$export$2b3628d62f894ece = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    // Typescript (vscode) incorrectly references the FluentProviderProps.customStyleHooks_unstable
    // instead of FluentProviderContextValues.customStyleHooks_unstable and thinks it is
    // Partial<CustomStyleHooksContextValue>, so it needs to be cast to Required<CustomStyleHooksContextValue>
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $8221ac192738ccc4$export$2881499e37b75b9a), {
        value: contextValues.provider,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $7474d1e11e05d082$export$d8964aec282183a3), {
            value: contextValues.theme,
            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $74a09e92d7894ea3$export$1d607f3624b112f5), {
                value: contextValues.themeClassName,
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $df848b23091d7919$export$f7e4b0d3f201e8be), {
                    value: contextValues.customStyleHooks_unstable,
                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $90b5c6c5b9aab897$export$6e323c529a2fe2d3), {
                        value: contextValues.tooltip,
                        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $314edc3f6e2ad580$export$c244dbe07f501bcc), {
                            dir: contextValues.textDirection,
                            children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $29e9ce9867929ff7$export$6bba08bb4157cc42), {
                                value: contextValues.iconDirection,
                                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $dcb30b81376c0f2d$export$1008c3d7ef9225de), {
                                    value: contextValues.overrides_unstable,
                                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
                                        children: [
                                            (0, $993af50b96092e61$export$71594e8a50f746f4)() ? null : /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)("style", {
                                                // Using dangerous HTML because react can escape characters
                                                // which can lead to invalid CSS.
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML: {
                                                    __html: state.serverStyleProps.cssRule
                                                },
                                                ...state.serverStyleProps.attributes
                                            }),
                                            state.root.children
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};





/**
 * @internal
 *
 * @param entry - CSS bucket entry that can be either a string or an array
 * @returns An array where the first element is the CSS rule
 */ function $8bee18016ab20455$export$8863dfbe2e97628a(entry) {
    if (!Array.isArray(entry)) return [
        entry
    ];
    return entry;
}


// ----
// Heads up!
// These constants are global and will be shared between Griffel instances.
// Any change in them should happen only in a MAJOR version. If it happens,
// please change "__NAMESPACE_PREFIX__" to include a version.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1708e11ed21e9e34$var$__GLOBAL__ = typeof window === 'undefined' ? $parcel$global : window;
const $1708e11ed21e9e34$var$__NAMESPACE_PREFIX__ = '@griffel/';
function $1708e11ed21e9e34$var$getGlobalVar(name, defaultValue) {
    if (!$1708e11ed21e9e34$var$__GLOBAL__[Symbol.for($1708e11ed21e9e34$var$__NAMESPACE_PREFIX__ + name)]) $1708e11ed21e9e34$var$__GLOBAL__[Symbol.for($1708e11ed21e9e34$var$__NAMESPACE_PREFIX__ + name)] = defaultValue;
    return $1708e11ed21e9e34$var$__GLOBAL__[Symbol.for($1708e11ed21e9e34$var$__NAMESPACE_PREFIX__ + name)];
}
/** @internal */ const $1708e11ed21e9e34$export$ce70c9e4412946f3 = /*#__PURE__*/ $1708e11ed21e9e34$var$getGlobalVar('DEBUG_RESET_CLASSES', {});
/** @internal */ const $1708e11ed21e9e34$export$ac80cc81fdb4fb5a = /*#__PURE__*/ $1708e11ed21e9e34$var$getGlobalVar('DEFINITION_LOOKUP_TABLE', {});
// ----
/** @internal */ const $1708e11ed21e9e34$export$1c1323cd9bbf9636 = 'data-make-styles-bucket';
/** @internal */ const $1708e11ed21e9e34$export$4942e61c5aa6baa3 = 'data-priority';
/** @internal */ const $1708e11ed21e9e34$export$fdd4f86041cc97c0 = 'f';
/** @internal */ const $1708e11ed21e9e34$export$a884bacb1a8eabe4 = 'r';
/** @internal */ const $1708e11ed21e9e34$export$92d383cc43013b89 = 7;
/** @internal */ const $1708e11ed21e9e34$export$ed60e64637dbffef = '___';
/** @internal */ const $1708e11ed21e9e34$export$99329b40e7077cf7 = '_';
/** @internal */ const $1708e11ed21e9e34$export$dcee98f0f975aca0 = $1708e11ed21e9e34$export$ed60e64637dbffef.length + $1708e11ed21e9e34$export$92d383cc43013b89;
// indexes for values in LookupItem tuple
/** @internal */ const $1708e11ed21e9e34$export$ac331484967b91fa = 0;
/** @internal */ const $1708e11ed21e9e34$export$d20107152a904e34 = 1;
// This collection is a map simply for faster access when checking if a CSS property is unsupported
/** @internal */ const $1708e11ed21e9e34$export$77c0d61648307b86 = {
    all: 1,
    borderColor: 1,
    borderStyle: 1,
    borderWidth: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockStart: 1,
    borderInline: 1,
    borderInlineEnd: 1,
    borderInlineStart: 1
};
/**
 * Removes a CSS property from the style object.
 *
 * @link https://griffel.js.org/react/api/make-styles
 *
 * Do not use the value directly, use `RESET` constant instead.
 */ const $1708e11ed21e9e34$export$4a991c87e640ef77 = 'DO_NOT_USE_DIRECTLY: @griffel/reset-value';



function $bff60b53b2fb952a$export$3bcd7718a96ff8b9(styleElement, bucketName, priority, elementAttributes) {
    // no CSSStyleSheet in SSR, just append rules here for server render
    const __cssRulesForSSR = [];
    elementAttributes[0, $1708e11ed21e9e34$export$1c1323cd9bbf9636] = bucketName;
    elementAttributes[0, $1708e11ed21e9e34$export$4942e61c5aa6baa3] = String(priority);
    if (styleElement) for(const attrName in elementAttributes)styleElement.setAttribute(attrName, elementAttributes[attrName]);
    function insertRule(rule) {
        if (styleElement === null || styleElement === void 0 ? void 0 : styleElement.sheet) return styleElement.sheet.insertRule(rule, styleElement.sheet.cssRules.length);
        return __cssRulesForSSR.push(rule);
    }
    return {
        elementAttributes: elementAttributes,
        insertRule: insertRule,
        element: styleElement,
        bucketName: bucketName,
        cssRules () {
            if (styleElement === null || styleElement === void 0 ? void 0 : styleElement.sheet) return Array.from(styleElement.sheet.cssRules).map((cssRule)=>cssRule.cssText);
            return __cssRulesForSSR;
        }
    };
}
function $bff60b53b2fb952a$export$996b7b13aed2e98a(element) {
    const elementAttributes = Array.from(element.attributes).reduce((acc, attr)=>{
        acc[attr.name] = attr.value;
        return acc;
    }, {});
    const stylesheet = $bff60b53b2fb952a$export$3bcd7718a96ff8b9(element, elementAttributes[0, $1708e11ed21e9e34$export$1c1323cd9bbf9636], Number(elementAttributes[0, $1708e11ed21e9e34$export$4942e61c5aa6baa3]), elementAttributes);
    return stylesheet;
}


/**
 * Ordered style buckets using their short pseudo name.
 *
 * @internal
 */ const $9eee3a43e0dd0933$export$8394bdfbee416ca4 = [
    // reset styles
    'r',
    // catch-all
    'd',
    // link
    'l',
    // visited
    'v',
    // focus-within
    'w',
    // focus
    'f',
    // focus-visible
    'i',
    // hover
    'h',
    // active
    'a',
    // at rules for reset styles
    's',
    // keyframes
    'k',
    // at-rules
    't',
    // @media rules
    'm',
    // @container rules
    'c'
];
// avoid repeatedly calling `indexOf` to determine order during new insertions
const $9eee3a43e0dd0933$var$styleBucketOrderingMap = /*#__PURE__*/ $9eee3a43e0dd0933$export$8394bdfbee416ca4.reduce((acc, cur, j)=>{
    acc[cur] = j;
    return acc;
}, {});
function $9eee3a43e0dd0933$export$5faf1243ae91fdea(bucketName, media, priority) {
    return (bucketName === 'm' ? bucketName + media : bucketName) + priority;
}
function $9eee3a43e0dd0933$export$d4a5a0a0c43c23d0(styleEl) {
    var _a;
    const bucketName = styleEl.getAttribute((0, $1708e11ed21e9e34$export$1c1323cd9bbf9636));
    const priority = (_a = styleEl.getAttribute((0, $1708e11ed21e9e34$export$4942e61c5aa6baa3))) !== null && _a !== void 0 ? _a : '0';
    return $9eee3a43e0dd0933$export$5faf1243ae91fdea(bucketName, styleEl.media, priority);
}
/**
 * Lazily adds a `<style>` bucket to the `<head>`. This will ensure that the style buckets are ordered.
 */ function $9eee3a43e0dd0933$export$bf774c2f1a190afe(bucketName, targetDocument, insertionPoint, renderer, metadata = {}) {
    var _a, _b;
    const isMediaBucket = bucketName === 'm';
    const media = (_a = metadata['m']) !== null && _a !== void 0 ? _a : '0';
    const priority = (_b = metadata['p']) !== null && _b !== void 0 ? _b : 0;
    const stylesheetKey = $9eee3a43e0dd0933$export$5faf1243ae91fdea(bucketName, media, priority);
    if (!renderer.stylesheets[stylesheetKey]) {
        const tag = targetDocument && targetDocument.createElement('style');
        const stylesheet = (0, $bff60b53b2fb952a$export$3bcd7718a96ff8b9)(tag, bucketName, priority, Object.assign({}, renderer.styleElementAttributes, isMediaBucket && {
            media: media
        }));
        renderer.stylesheets[stylesheetKey] = stylesheet;
        if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.head) && tag) targetDocument.head.insertBefore(tag, $9eee3a43e0dd0933$var$findInsertionPoint(targetDocument, insertionPoint, bucketName, renderer, metadata));
    }
    return renderer.stylesheets[stylesheetKey];
}
function $9eee3a43e0dd0933$var$isSameInsertionKey(element, bucketName, metadata) {
    var _a, _b;
    const targetKey = bucketName + ((_a = metadata['m']) !== null && _a !== void 0 ? _a : '');
    const elementKey = element.getAttribute((0, $1708e11ed21e9e34$export$1c1323cd9bbf9636)) + ((_b = element.media) !== null && _b !== void 0 ? _b : '');
    return targetKey === elementKey;
}
/**
 * Finds an element before which the new bucket style element should be inserted following the bucket sort order.
 *
 * @param targetDocument - A document
 * @param insertionPoint - An element that will be used as an initial insertion point
 * @param targetBucket - The bucket that should be inserted to DOM
 * @param renderer - Griffel renderer
 * @param metadata - metadata for CSS rule
 * @returns - Smallest style element with greater sort order than the current bucket
 */ function $9eee3a43e0dd0933$var$findInsertionPoint(targetDocument, insertionPoint, targetBucket, renderer, metadata = {}) {
    var _a, _b;
    const targetOrder = $9eee3a43e0dd0933$var$styleBucketOrderingMap[targetBucket];
    const media = (_a = metadata['m']) !== null && _a !== void 0 ? _a : '';
    const priority = (_b = metadata['p']) !== null && _b !== void 0 ? _b : 0;
    // Similar to javascript sort comparators where
    // a positive value is increasing sort order
    // a negative value is decreasing sort order
    let comparer = (el)=>targetOrder - $9eee3a43e0dd0933$var$styleBucketOrderingMap[el.getAttribute((0, $1708e11ed21e9e34$export$1c1323cd9bbf9636))];
    let styleElements = targetDocument.head.querySelectorAll(`[${(0, $1708e11ed21e9e34$export$1c1323cd9bbf9636)}]`);
    if (targetBucket === 'm') {
        const mediaElements = targetDocument.head.querySelectorAll(`[${(0, $1708e11ed21e9e34$export$1c1323cd9bbf9636)}="${targetBucket}"]`);
        // only reduce the scope of the search and change comparer
        // if there are other media buckets already on the page
        if (mediaElements.length) {
            styleElements = mediaElements;
            comparer = (el)=>renderer.compareMediaQueries(media, el.media);
        }
    }
    const comparerWithPriority = (el)=>{
        if ($9eee3a43e0dd0933$var$isSameInsertionKey(el, targetBucket, metadata)) return priority - Number(el.getAttribute('data-priority'));
        return comparer(el);
    };
    const length = styleElements.length;
    let index = length - 1;
    while(index >= 0){
        const styleElement = styleElements.item(index);
        if (comparerWithPriority(styleElement) > 0) return styleElement.nextSibling;
        index--;
    }
    if (length > 0) return styleElements.item(0);
    return insertionPoint ? insertionPoint.nextSibling : null;
}


/**
 * Suffixes to be ignored in case of error
 */ const $8d434986888648dd$var$ignoreSuffixes = /*#__PURE__*/ [
    '-moz-placeholder',
    '-moz-focus-inner',
    '-moz-focusring',
    '-ms-input-placeholder',
    '-moz-read-write',
    '-moz-read-only'
].join('|');
const $8d434986888648dd$var$ignoreSuffixesRegex = /*#__PURE__*/ new RegExp(`:(${$8d434986888648dd$var$ignoreSuffixes})`);
/**
 * @internal
 *
 * Calls `sheet.insertRule` and catches errors related to browser prefixes.
 */ function $8d434986888648dd$export$eeb35b988e7e9e06(sheet, ruleCSS) {
    try {
        sheet.insertRule(ruleCSS);
    } catch (e) {}
}


let $348862a511afe2fd$var$lastIndex = 0;
/** @internal */ const $348862a511afe2fd$export$642fd54c606e54c9 = (a, b)=>a < b ? -1 : a > b ? 1 : 0;
/**
 * Creates a new instances of a renderer.
 *
 * @public
 */ function $348862a511afe2fd$export$9fc2f00d85486f7e(targetDocument = typeof document === 'undefined' ? undefined : document, options = {}) {
    const { classNameHashSalt: classNameHashSalt, unstable_filterCSSRule: unstable_filterCSSRule, insertionPoint: insertionPoint, styleElementAttributes: styleElementAttributes, compareMediaQueries: compareMediaQueries = $348862a511afe2fd$export$642fd54c606e54c9 } = options;
    const renderer = {
        classNameHashSalt: classNameHashSalt,
        insertionCache: {},
        stylesheets: {},
        styleElementAttributes: Object.freeze(styleElementAttributes),
        compareMediaQueries: compareMediaQueries,
        id: `d${$348862a511afe2fd$var$lastIndex++}`,
        insertCSSRules (cssRules) {
            // eslint-disable-next-line guard-for-in
            for(const styleBucketName in cssRules){
                const cssRulesForBucket = cssRules[styleBucketName];
                // This is a hot path in rendering styles: ".length" is cached in "l" var to avoid accesses the property
                for(let i = 0, l = cssRulesForBucket.length; i < l; i++){
                    const [ruleCSS, metadata] = (0, $8bee18016ab20455$export$8863dfbe2e97628a)(cssRulesForBucket[i]);
                    const sheet = (0, $9eee3a43e0dd0933$export$bf774c2f1a190afe)(styleBucketName, targetDocument, insertionPoint || null, renderer, metadata);
                    if (renderer.insertionCache[ruleCSS]) continue;
                    renderer.insertionCache[ruleCSS] = styleBucketName;
                    if (unstable_filterCSSRule) {
                        if (unstable_filterCSSRule(ruleCSS)) (0, $8d434986888648dd$export$eeb35b988e7e9e06)(sheet, ruleCSS);
                    } else (0, $8d434986888648dd$export$eeb35b988e7e9e06)(sheet, ruleCSS);
                }
            }
        }
    };
    return renderer;
}






// Regexps to extract names of classes and animations
// https://github.com/styletron/styletron/blob/e0fcae826744eb00ce679ac613a1b10d44256660/packages/styletron-engine-atomic/src/client/client.js#L8
const $b0e7ab2a94ead18c$var$KEYFRAMES_HYDRATOR = /@(-webkit-)?keyframes ([^{]+){((?:(?:from|to|(?:\d+\.?\d*%))\{(?:[^}])*})*)}/g;
const $b0e7ab2a94ead18c$var$AT_RULES_HYDRATOR = /@(media|supports|layer)[^{]+\{([\s\S]+?})\s*}/g;
const $b0e7ab2a94ead18c$var$STYLES_HYDRATOR = /\.([^{:]+)(:[^{]+)?{(?:[^}]*;)?([^}]*?)}/g;
const $b0e7ab2a94ead18c$var$regexps = {
    k: $b0e7ab2a94ead18c$var$KEYFRAMES_HYDRATOR,
    t: $b0e7ab2a94ead18c$var$AT_RULES_HYDRATOR,
    m: $b0e7ab2a94ead18c$var$AT_RULES_HYDRATOR
};
/**
 * Should be called in a case of Server-Side rendering. Rehydrates cache from for a renderer to avoid double insertion
 * of classes to DOM.
 *
 * @public
 */ function $b0e7ab2a94ead18c$export$ff47709f7ae6a457(renderer, target = typeof document === 'undefined' ? undefined : document) {
    if (target) {
        const styleElements = target.querySelectorAll('[data-make-styles-bucket]');
        styleElements.forEach((styleElement)=>{
            const bucketName = styleElement.dataset['makeStylesBucket'];
            const stylesheetKey = (0, $9eee3a43e0dd0933$export$d4a5a0a0c43c23d0)(styleElement);
            // 👇 If some elements are not created yet, we will register them in renderer
            if (!renderer.stylesheets[stylesheetKey]) renderer.stylesheets[stylesheetKey] = (0, $bff60b53b2fb952a$export$996b7b13aed2e98a)(styleElement);
            const regex = $b0e7ab2a94ead18c$var$regexps[bucketName] || $b0e7ab2a94ead18c$var$STYLES_HYDRATOR;
            let match;
            while(match = regex.exec(styleElement.textContent)){
                // "cacheKey" is either a class name or an animation name
                const [cssRule] = match;
                renderer.insertionCache[cssRule] = bucketName;
            }
        });
    }
}



var $acw62 = parcelRequire("acw62");
/**
 * Verifies if an application can use DOM.
 */ function $ecb3e83860eba794$export$71594e8a50f746f4() {
    return typeof window !== 'undefined' && !!(window.document && window.document.createElement);
}


"use client";
/**
 * @private
 */ const $4c6030e36adbdcfb$var$RendererContext = /*#__PURE__*/ $acw62.createContext(/*#__PURE__*/ (0, $348862a511afe2fd$export$9fc2f00d85486f7e)());
/**
 * @public
 */ const $4c6030e36adbdcfb$export$e785a56df110cbc9 = ({ children: children, renderer: renderer, targetDocument: targetDocument })=>{
    $acw62.useMemo(()=>{
        if ((0, $ecb3e83860eba794$export$71594e8a50f746f4)()) // "rehydrateCache()" can't be called in effects as it needs to be called before any component will be rendered to
        // avoid double insertion of classes
        (0, $b0e7ab2a94ead18c$export$ff47709f7ae6a457)(renderer, targetDocument);
    }, [
        renderer,
        targetDocument
    ]);
    return /*#__PURE__*/ $acw62.createElement($4c6030e36adbdcfb$var$RendererContext.Provider, {
        value: renderer
    }, children);
};
/**
 * Returns an instance of current makeStyles() renderer.
 *
 * @private Exported as "useRenderer_unstable" use it on own risk. Can be changed or removed without a notice.
 */ function $4c6030e36adbdcfb$export$e0259e2a2ab69ea() {
    return $acw62.useContext($4c6030e36adbdcfb$var$RendererContext);
}



var $acw62 = parcelRequire("acw62");

/**
 * Verifies if a given node is an HTMLElement,
 * this method works seamlessly with frames and elements from different documents
 *
 * This is preferred over simply using `instanceof`.
 * Since `instanceof` might be problematic while operating with [multiple realms](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/instanceof#instanceof_and_multiple_realms)
 *
 * @example
 * ```ts
 * isHTMLElement(event.target) && event.target.focus()
 * isHTMLElement(event.target, {constructorName: 'HTMLInputElement'}) && event.target.value // some value
 * ```
 *
 */ function $d23f05efbdb19e52$export$1b3bfaa9684536aa(element, options) {
    var _typedElement_ownerDocument;
    const typedElement = element;
    var _options_constructorName;
    return Boolean((typedElement === null || typedElement === void 0 ? void 0 : (_typedElement_ownerDocument = typedElement.ownerDocument) === null || _typedElement_ownerDocument === void 0 ? void 0 : _typedElement_ownerDocument.defaultView) && typedElement instanceof typedElement.ownerDocument.defaultView[(_options_constructorName = options === null || options === void 0 ? void 0 : options.constructorName) !== null && _options_constructorName !== void 0 ? _options_constructorName : 'HTMLElement']);
}


// src/WeakRefInstance.ts
var $7fd4889093258001$var$_canUseWeakRef = typeof WeakRef !== "undefined";
var $7fd4889093258001$var$WeakRefInstance = class {
    constructor(instance){
        if ($7fd4889093258001$var$_canUseWeakRef && typeof instance === "object") this._weakRef = new WeakRef(instance);
        else this._instance = instance;
    }
    /**
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakRef/deref}
   */ deref() {
        var _a, _b;
        let instance;
        if (this._weakRef) {
            instance = (_a = this._weakRef) == null ? void 0 : _a.deref();
            if (!instance) delete this._weakRef;
        } else {
            instance = this._instance;
            if ((_b = instance == null ? void 0 : instance.isDisposed) == null ? void 0 : _b.call(instance)) delete this._instance;
        }
        return instance;
    }
};
// src/FocusEvent.ts
var $7fd4889093258001$export$5644ea5c8a31b6ce = "keyborg:focusin";
var $7fd4889093258001$export$caa225efd612bb56 = "keyborg:focusout";
function $7fd4889093258001$var$canOverrideNativeFocus(win) {
    const HTMLElement = win.HTMLElement;
    const origFocus = HTMLElement.prototype.focus;
    let isCustomFocusCalled = false;
    HTMLElement.prototype.focus = function focus() {
        isCustomFocusCalled = true;
    };
    const btn = win.document.createElement("button");
    btn.focus();
    HTMLElement.prototype.focus = origFocus;
    return isCustomFocusCalled;
}
var $7fd4889093258001$var$_canOverrideNativeFocus = false;
function $7fd4889093258001$export$cf4c60ff2c946f35(element) {
    const focus = element.focus;
    if (focus.__keyborgNativeFocus) focus.__keyborgNativeFocus.call(element);
    else element.focus();
}
function $7fd4889093258001$var$setupFocusEvent(win) {
    const kwin = win;
    if (!$7fd4889093258001$var$_canOverrideNativeFocus) $7fd4889093258001$var$_canOverrideNativeFocus = $7fd4889093258001$var$canOverrideNativeFocus(kwin);
    const origFocus = kwin.HTMLElement.prototype.focus;
    if (origFocus.__keyborgNativeFocus) return;
    kwin.HTMLElement.prototype.focus = focus;
    const shadowTargets = /* @__PURE__ */ new Set();
    const focusOutHandler = (e)=>{
        const target = e.target;
        if (!target) return;
        const event = new CustomEvent($7fd4889093258001$export$caa225efd612bb56, {
            cancelable: true,
            bubbles: true,
            // Allows the event to bubble past an open shadow root
            composed: true,
            detail: {
                originalEvent: e
            }
        });
        target.dispatchEvent(event);
    };
    const focusInHandler = (e)=>{
        const target = e.target;
        if (!target) return;
        let node = e.composedPath()[0];
        const currentShadows = /* @__PURE__ */ new Set();
        while(node)if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            currentShadows.add(node);
            node = node.host;
        } else node = node.parentNode;
        for (const shadowRootWeakRef of shadowTargets){
            const shadowRoot = shadowRootWeakRef.deref();
            if (!shadowRoot || !currentShadows.has(shadowRoot)) {
                shadowTargets.delete(shadowRootWeakRef);
                if (shadowRoot) {
                    shadowRoot.removeEventListener("focusin", focusInHandler, true);
                    shadowRoot.removeEventListener("focusout", focusOutHandler, true);
                }
            }
        }
        onFocusIn(target, e.relatedTarget || void 0);
    };
    const onFocusIn = (target, relatedTarget, originalEvent)=>{
        var _a;
        const shadowRoot = target.shadowRoot;
        if (shadowRoot) {
            for (const shadowRootWeakRef of shadowTargets){
                if (shadowRootWeakRef.deref() === shadowRoot) return;
            }
            shadowRoot.addEventListener("focusin", focusInHandler, true);
            shadowRoot.addEventListener("focusout", focusOutHandler, true);
            shadowTargets.add(new $7fd4889093258001$var$WeakRefInstance(shadowRoot));
            return;
        }
        const details = {
            relatedTarget: relatedTarget,
            originalEvent: originalEvent
        };
        const event = new CustomEvent($7fd4889093258001$export$5644ea5c8a31b6ce, {
            cancelable: true,
            bubbles: true,
            // Allows the event to bubble past an open shadow root
            composed: true,
            detail: details
        });
        event.details = details;
        if ($7fd4889093258001$var$_canOverrideNativeFocus || data.lastFocusedProgrammatically) {
            details.isFocusedProgrammatically = target === ((_a = data.lastFocusedProgrammatically) == null ? void 0 : _a.deref());
            data.lastFocusedProgrammatically = void 0;
        }
        target.dispatchEvent(event);
    };
    const data = kwin.__keyborgData = {
        focusInHandler: focusInHandler,
        focusOutHandler: focusOutHandler,
        shadowTargets: shadowTargets
    };
    kwin.document.addEventListener("focusin", kwin.__keyborgData.focusInHandler, true);
    kwin.document.addEventListener("focusout", kwin.__keyborgData.focusOutHandler, true);
    function focus() {
        const keyborgNativeFocusEvent = kwin.__keyborgData;
        if (keyborgNativeFocusEvent) keyborgNativeFocusEvent.lastFocusedProgrammatically = new $7fd4889093258001$var$WeakRefInstance(this);
        return origFocus.apply(this, arguments);
    }
    let activeElement = kwin.document.activeElement;
    while(activeElement && activeElement.shadowRoot){
        onFocusIn(activeElement);
        activeElement = activeElement.shadowRoot.activeElement;
    }
    focus.__keyborgNativeFocus = origFocus;
}
function $7fd4889093258001$var$disposeFocusEvent(win) {
    const kwin = win;
    const proto = kwin.HTMLElement.prototype;
    const origFocus = proto.focus.__keyborgNativeFocus;
    const keyborgNativeFocusEvent = kwin.__keyborgData;
    if (keyborgNativeFocusEvent) {
        kwin.document.removeEventListener("focusin", keyborgNativeFocusEvent.focusInHandler, true);
        kwin.document.removeEventListener("focusout", keyborgNativeFocusEvent.focusOutHandler, true);
        for (const shadowRootWeakRef of keyborgNativeFocusEvent.shadowTargets){
            const shadowRoot = shadowRootWeakRef.deref();
            if (shadowRoot) {
                shadowRoot.removeEventListener("focusin", keyborgNativeFocusEvent.focusInHandler, true);
                shadowRoot.removeEventListener("focusout", keyborgNativeFocusEvent.focusOutHandler, true);
            }
        }
        keyborgNativeFocusEvent.shadowTargets.clear();
        delete kwin.__keyborgData;
    }
    if (origFocus) proto.focus = origFocus;
}
function $7fd4889093258001$export$6975ba4e8ed68cc8(win) {
    var _a;
    const keyborgNativeFocusEvent = win.__keyborgData;
    return keyborgNativeFocusEvent ? ((_a = keyborgNativeFocusEvent.lastFocusedProgrammatically) == null ? void 0 : _a.deref()) || null : void 0;
}
// src/Keyborg.ts
var $7fd4889093258001$var$_dismissTimeout = 500;
var $7fd4889093258001$var$_lastId = 0;
var $7fd4889093258001$var$KeyborgCore = class {
    constructor(win, props){
        this._isNavigatingWithKeyboard_DO_NOT_USE = false;
        this._onFocusIn = (e)=>{
            if (this._isMouseOrTouchUsedTimer) return;
            if (this.isNavigatingWithKeyboard) return;
            const details = e.detail;
            if (!details.relatedTarget) return;
            if (details.isFocusedProgrammatically || details.isFocusedProgrammatically === void 0) return;
            this.isNavigatingWithKeyboard = true;
        };
        this._onMouseDown = (e)=>{
            if (e.buttons === 0 || e.clientX === 0 && e.clientY === 0 && e.screenX === 0 && e.screenY === 0) return;
            this._onMouseOrTouch();
        };
        this._onMouseOrTouch = ()=>{
            const win = this._win;
            if (win) {
                if (this._isMouseOrTouchUsedTimer) win.clearTimeout(this._isMouseOrTouchUsedTimer);
                this._isMouseOrTouchUsedTimer = win.setTimeout(()=>{
                    delete this._isMouseOrTouchUsedTimer;
                }, 1e3);
            }
            this.isNavigatingWithKeyboard = false;
        };
        this._onKeyDown = (e)=>{
            const isNavigatingWithKeyboard = this.isNavigatingWithKeyboard;
            if (isNavigatingWithKeyboard) {
                if (this._shouldDismissKeyboardNavigation(e)) this._scheduleDismiss();
            } else if (this._shouldTriggerKeyboardNavigation(e)) this.isNavigatingWithKeyboard = true;
        };
        this.id = "c" + ++$7fd4889093258001$var$_lastId;
        this._win = win;
        const doc = win.document;
        if (props) {
            const triggerKeys = props.triggerKeys;
            const dismissKeys = props.dismissKeys;
            if (triggerKeys == null ? void 0 : triggerKeys.length) this._triggerKeys = new Set(triggerKeys);
            if (dismissKeys == null ? void 0 : dismissKeys.length) this._dismissKeys = new Set(dismissKeys);
        }
        doc.addEventListener($7fd4889093258001$export$5644ea5c8a31b6ce, this._onFocusIn, true);
        doc.addEventListener("mousedown", this._onMouseDown, true);
        win.addEventListener("keydown", this._onKeyDown, true);
        doc.addEventListener("touchstart", this._onMouseOrTouch, true);
        doc.addEventListener("touchend", this._onMouseOrTouch, true);
        doc.addEventListener("touchcancel", this._onMouseOrTouch, true);
        $7fd4889093258001$var$setupFocusEvent(win);
    }
    get isNavigatingWithKeyboard() {
        return this._isNavigatingWithKeyboard_DO_NOT_USE;
    }
    set isNavigatingWithKeyboard(val) {
        if (this._isNavigatingWithKeyboard_DO_NOT_USE !== val) {
            this._isNavigatingWithKeyboard_DO_NOT_USE = val;
            this.update();
        }
    }
    dispose() {
        const win = this._win;
        if (win) {
            if (this._isMouseOrTouchUsedTimer) {
                win.clearTimeout(this._isMouseOrTouchUsedTimer);
                this._isMouseOrTouchUsedTimer = void 0;
            }
            if (this._dismissTimer) {
                win.clearTimeout(this._dismissTimer);
                this._dismissTimer = void 0;
            }
            $7fd4889093258001$var$disposeFocusEvent(win);
            const doc = win.document;
            doc.removeEventListener($7fd4889093258001$export$5644ea5c8a31b6ce, this._onFocusIn, true);
            doc.removeEventListener("mousedown", this._onMouseDown, true);
            win.removeEventListener("keydown", this._onKeyDown, true);
            doc.removeEventListener("touchstart", this._onMouseOrTouch, true);
            doc.removeEventListener("touchend", this._onMouseOrTouch, true);
            doc.removeEventListener("touchcancel", this._onMouseOrTouch, true);
            delete this._win;
        }
    }
    isDisposed() {
        return !!this._win;
    }
    /**
   * Updates all keyborg instances with the keyboard navigation state
   */ update() {
        var _a, _b;
        const keyborgs = (_b = (_a = this._win) == null ? void 0 : _a.__keyborg) == null ? void 0 : _b.refs;
        if (keyborgs) for (const id of Object.keys(keyborgs))$7fd4889093258001$var$Keyborg.update(keyborgs[id], this.isNavigatingWithKeyboard);
    }
    /**
   * @returns whether the keyboard event should trigger keyboard navigation mode
   */ _shouldTriggerKeyboardNavigation(e) {
        var _a;
        if (e.key === "Tab") return true;
        const activeElement = (_a = this._win) == null ? void 0 : _a.document.activeElement;
        const isTriggerKey = !this._triggerKeys || this._triggerKeys.has(e.keyCode);
        const isEditable = activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA" || activeElement.isContentEditable);
        return isTriggerKey && !isEditable;
    }
    /**
   * @returns whether the keyboard event should dismiss keyboard navigation mode
   */ _shouldDismissKeyboardNavigation(e) {
        var _a;
        return (_a = this._dismissKeys) == null ? void 0 : _a.has(e.keyCode);
    }
    _scheduleDismiss() {
        const win = this._win;
        if (win) {
            if (this._dismissTimer) {
                win.clearTimeout(this._dismissTimer);
                this._dismissTimer = void 0;
            }
            const was = win.document.activeElement;
            this._dismissTimer = win.setTimeout(()=>{
                this._dismissTimer = void 0;
                const cur = win.document.activeElement;
                if (was && cur && was === cur) this.isNavigatingWithKeyboard = false;
            }, $7fd4889093258001$var$_dismissTimeout);
        }
    }
};
var $7fd4889093258001$var$Keyborg = class _Keyborg {
    constructor(win, props){
        this._cb = [];
        this._id = "k" + ++$7fd4889093258001$var$_lastId;
        this._win = win;
        const current = win.__keyborg;
        if (current) {
            this._core = current.core;
            current.refs[this._id] = this;
        } else {
            this._core = new $7fd4889093258001$var$KeyborgCore(win, props);
            win.__keyborg = {
                core: this._core,
                refs: {
                    [this._id]: this
                }
            };
        }
    }
    static create(win, props) {
        return new _Keyborg(win, props);
    }
    static dispose(instance) {
        instance.dispose();
    }
    /**
   * Updates all subscribed callbacks with the keyboard navigation state
   */ static update(instance, isNavigatingWithKeyboard) {
        instance._cb.forEach((callback)=>callback(isNavigatingWithKeyboard));
    }
    dispose() {
        var _a;
        const current = (_a = this._win) == null ? void 0 : _a.__keyborg;
        if (current == null ? void 0 : current.refs[this._id]) {
            delete current.refs[this._id];
            if (Object.keys(current.refs).length === 0) {
                current.core.dispose();
                delete this._win.__keyborg;
            }
        }
        this._cb = [];
        delete this._core;
        delete this._win;
    }
    /**
   * @returns Whether the user is navigating with keyboard
   */ isNavigatingWithKeyboard() {
        var _a;
        return !!((_a = this._core) == null ? void 0 : _a.isNavigatingWithKeyboard);
    }
    /**
   * @param callback - Called when the keyboard navigation state changes
   */ subscribe(callback) {
        this._cb.push(callback);
    }
    /**
   * @param callback - Registered with subscribe
   */ unsubscribe(callback) {
        const index = this._cb.indexOf(callback);
        if (index >= 0) this._cb.splice(index, 1);
    }
    /**
   * Manually set the keyboard navigtion state
   */ setVal(isNavigatingWithKeyboard) {
        if (this._core) this._core.isNavigatingWithKeyboard = isNavigatingWithKeyboard;
    }
};
function $7fd4889093258001$export$9ccd7417191c0e4b(win, props) {
    return $7fd4889093258001$var$Keyborg.create(win, props);
}
function $7fd4889093258001$export$6c71cf8529293a97(instance) {
    $7fd4889093258001$var$Keyborg.dispose(instance);
}
// src/index.ts
var $7fd4889093258001$export$83d89fbfd8236492 = "2.6.0";
 /*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 

const $adb94d615d1e4f94$export$49535e94ddbaa254 = 'data-keyboard-nav';
const $adb94d615d1e4f94$export$981d564957a4672d = `:global([${$adb94d615d1e4f94$export$49535e94ddbaa254}])`;
const $adb94d615d1e4f94$export$2c9da02e018cbe1c = 'data-fui-focus-visible';
const $adb94d615d1e4f94$export$922950948586e05d = 'data-fui-focus-within';
const $adb94d615d1e4f94$export$ba43bf67f3d48107 = {
    style: {},
    selector: 'focus',
    customizeSelector: (selector)=>selector
};


function $a223f8a765b4d651$export$56707be742262038(scope, targetWindow) {
    if ($a223f8a765b4d651$var$alreadyInScope(scope)) // Focus visible polyfill already applied at this scope
    return ()=>undefined;
    const state = {
        current: undefined
    };
    const keyborg = (0, $7fd4889093258001$export$9ccd7417191c0e4b)(targetWindow);
    function registerElementIfNavigating(el) {
        if (keyborg.isNavigatingWithKeyboard() && (0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(el)) {
            state.current = el;
            el.setAttribute((0, $adb94d615d1e4f94$export$2c9da02e018cbe1c), '');
        }
    }
    function disposeCurrentElement() {
        if (state.current) {
            state.current.removeAttribute((0, $adb94d615d1e4f94$export$2c9da02e018cbe1c));
            state.current = undefined;
        }
    }
    // When navigation mode changes remove the focus-visible selector
    keyborg.subscribe((isNavigatingWithKeyboard)=>{
        if (!isNavigatingWithKeyboard) disposeCurrentElement();
        else registerElementIfNavigating(targetWindow.document.activeElement);
    });
    // Keyborg's focusin event is delegated so it's only registered once on the window
    // and contains metadata about the focus event
    const keyborgListener = (e)=>{
        disposeCurrentElement();
        const target = e.composedPath()[0];
        registerElementIfNavigating(target);
    };
    // Make sure that when focus leaves the scope, the focus visible class is removed
    const blurListener = (e)=>{
        if (!e.relatedTarget || (0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(e.relatedTarget) && !scope.contains(e.relatedTarget)) disposeCurrentElement();
    };
    scope.addEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), keyborgListener);
    scope.addEventListener('focusout', blurListener);
    scope.focusVisible = true;
    if (scope.contains(targetWindow.document.activeElement)) registerElementIfNavigating(targetWindow.document.activeElement);
    // Return disposer
    return ()=>{
        disposeCurrentElement();
        scope.removeEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), keyborgListener);
        scope.removeEventListener('focusout', blurListener);
        scope.focusVisible = undefined;
        (0, $7fd4889093258001$export$6c71cf8529293a97)(keyborg);
    };
}
function $a223f8a765b4d651$var$alreadyInScope(el) {
    if (!el) return false;
    if (el.focusVisible) return true;
    return $a223f8a765b4d651$var$alreadyInScope(el === null || el === void 0 ? void 0 : el.parentElement);
}


'use client';
function $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6(options = {}) {
    const contextValue = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const scopeRef = $acw62.useRef(null);
    var _options_targetDocument;
    const targetDocument = (_options_targetDocument = options.targetDocument) !== null && _options_targetDocument !== void 0 ? _options_targetDocument : contextValue.targetDocument;
    $acw62.useEffect(()=>{
        if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) && scopeRef.current) return (0, $a223f8a765b4d651$export$56707be742262038)(scopeRef.current, targetDocument.defaultView);
    }, [
        scopeRef,
        targetDocument
    ]);
    return scopeRef;
}



var $fcf7ddccaab7fd8f$exports = {};

$parcel$export($fcf7ddccaab7fd8f$exports, "always", () => $fcf7ddccaab7fd8f$export$ba9e5d519bc326ca);
$parcel$export($fcf7ddccaab7fd8f$exports, "resolveShorthand", () => $fcf7ddccaab7fd8f$export$cf82748705625c0e);
$parcel$export($fcf7ddccaab7fd8f$exports, "optional", () => $fcf7ddccaab7fd8f$export$516e28dec6a4b6d4);

var $acw62 = parcelRequire("acw62");

function $fcf7ddccaab7fd8f$export$ba9e5d519bc326ca(value, options) {
    const { defaultProps: defaultProps, elementType: elementType } = options;
    const props = $fcf7ddccaab7fd8f$export$cf82748705625c0e(value);
    /**
   * Casting is required here as SlotComponentType is a function, not an object.
   * Although SlotComponentType has a function signature, it is still just an object.
   * This is required to make a slot callable (JSX compatible), this is the exact same approach
   * that is used on `@types/react` components
   */ const propsWithMetadata = {
        ...defaultProps,
        ...props,
        [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: elementType,
        [(0, $a9190614d56c943f$export$fcc89f7e5475925d)]: (props === null || props === void 0 ? void 0 : props.className) || (defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.className)
    };
    if (props && typeof props.children === 'function') {
        propsWithMetadata[0, $a9190614d56c943f$export$2eb147a2bf7697ad] = props.children;
        propsWithMetadata.children = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.children;
    }
    return propsWithMetadata;
}
function $fcf7ddccaab7fd8f$export$516e28dec6a4b6d4(value, options) {
    if (value === null || value === undefined && !options.renderByDefault) return undefined;
    return $fcf7ddccaab7fd8f$export$ba9e5d519bc326ca(value, options);
}
function $fcf7ddccaab7fd8f$export$cf82748705625c0e(value) {
    if (typeof value === 'string' || typeof value === 'number' || $fcf7ddccaab7fd8f$var$isIterable(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $acw62.isValidElement(value)) return {
        children: value
    };
    value && typeof value;
    return value;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fcf7ddccaab7fd8f$var$isIterable = (value)=>typeof value === 'object' && value !== null && Symbol.iterator in value;

parcelRequire("acw62");
parcelRequire("acw62");
const $70949e6a28333d2f$var$toObjectMap = (...items)=>{
    const result = {};
    for (const item of items){
        const keys = Array.isArray(item) ? item : Object.keys(item);
        for (const key of keys)result[key] = 1;
    }
    return result;
};
const $70949e6a28333d2f$export$32eff4db2feb903 = $70949e6a28333d2f$var$toObjectMap([
    'onAuxClick',
    'onAnimationEnd',
    'onAnimationStart',
    'onCopy',
    'onCut',
    'onPaste',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onInput',
    'onSubmit',
    'onLoad',
    'onError',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyUp',
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onScroll',
    'onWheel',
    'onPointerCancel',
    'onPointerDown',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerMove',
    'onPointerOut',
    'onPointerOver',
    'onPointerUp',
    'onGotPointerCapture',
    'onLostPointerCapture'
]);
const $70949e6a28333d2f$export$7256d73338e409fd = $70949e6a28333d2f$var$toObjectMap([
    'accessKey',
    'children',
    'className',
    'contentEditable',
    'dir',
    'draggable',
    'hidden',
    'htmlFor',
    'id',
    'lang',
    'popover',
    'focusgroup',
    'ref',
    'role',
    'style',
    'tabIndex',
    'title',
    'translate',
    'spellCheck',
    'name'
]);
const $70949e6a28333d2f$export$cd32fb67764fc900 = $70949e6a28333d2f$var$toObjectMap([
    'itemID',
    'itemProp',
    'itemRef',
    'itemScope',
    'itemType'
]);
const $70949e6a28333d2f$export$e4936fed10ab2c40 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$7256d73338e409fd, $70949e6a28333d2f$export$32eff4db2feb903, $70949e6a28333d2f$export$cd32fb67764fc900);
const $70949e6a28333d2f$export$ec8d81a3d8f61d0f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'form'
]);
const $70949e6a28333d2f$export$55af9cf105a52547 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'height',
    'loop',
    'muted',
    'preload',
    'src',
    'width'
]);
const $70949e6a28333d2f$export$cd2126b486be823e = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$55af9cf105a52547, [
    'poster'
]);
const $70949e6a28333d2f$export$9e755727cea4fd1f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'start'
]);
const $70949e6a28333d2f$export$8703767c2ecb797b = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'value'
]);
const $70949e6a28333d2f$export$bd4643a0b4568ed8 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'download',
    'href',
    'hrefLang',
    'media',
    'referrerPolicy',
    'rel',
    'target',
    'type'
]);
const $70949e6a28333d2f$export$1fc5e2c7479ee57 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'dateTime'
]);
const $70949e6a28333d2f$export$4fd534fb1e82b8b4 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'popoverTarget',
    'popoverTargetAction',
    'type',
    'value'
]);
const $70949e6a28333d2f$export$33c6815a27d08ce5 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$4fd534fb1e82b8b4, [
    'accept',
    'alt',
    'autoCorrect',
    'autoCapitalize',
    'autoComplete',
    'checked',
    'dirname',
    'form',
    'height',
    'inputMode',
    'list',
    'max',
    'maxLength',
    'min',
    'minLength',
    'multiple',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'src',
    'step',
    'size',
    'type',
    'value',
    'width'
]);
const $70949e6a28333d2f$export$699534499318873d = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$4fd534fb1e82b8b4, [
    'autoCapitalize',
    'cols',
    'dirname',
    'form',
    'maxLength',
    'placeholder',
    'readOnly',
    'required',
    'rows',
    'wrap'
]);
const $70949e6a28333d2f$export$9475341421ea2846 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$4fd534fb1e82b8b4, [
    'form',
    'multiple',
    'required'
]);
const $70949e6a28333d2f$export$9004c3828878727f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'selected',
    'value'
]);
const $70949e6a28333d2f$export$2f53f8cf7eb86ae5 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'cellPadding',
    'cellSpacing'
]);
const $70949e6a28333d2f$export$3ab2f4f445c2eb24 = $70949e6a28333d2f$export$e4936fed10ab2c40;
const $70949e6a28333d2f$export$2b115a026f474c83 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'colSpan',
    'rowSpan',
    'scope'
]);
const $70949e6a28333d2f$export$b5d753b2279d22cc = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'colSpan',
    'headers',
    'rowSpan',
    'scope'
]);
const $70949e6a28333d2f$export$d526cc4b9c261b42 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'span'
]);
const $70949e6a28333d2f$export$e487baa138d06e98 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'span'
]);
const $70949e6a28333d2f$export$52193885890f710e = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'disabled',
    'form'
]);
const $70949e6a28333d2f$export$477a3a6d251d97a7 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'acceptCharset',
    'action',
    'encType',
    'encType',
    'method',
    'noValidate',
    'target'
]);
const $70949e6a28333d2f$export$727a7f82229b450f = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'allow',
    'allowFullScreen',
    'allowPaymentRequest',
    'allowTransparency',
    'csp',
    'height',
    'importance',
    'referrerPolicy',
    'sandbox',
    'src',
    'srcDoc',
    'width'
]);
const $70949e6a28333d2f$export$91f8cc2b546c057d = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'alt',
    'crossOrigin',
    'height',
    'src',
    'srcSet',
    'useMap',
    'width'
]);
const $70949e6a28333d2f$export$88fc3d496ec6e608 = $70949e6a28333d2f$var$toObjectMap($70949e6a28333d2f$export$e4936fed10ab2c40, [
    'open',
    'onCancel',
    'onClose'
]);
const $70949e6a28333d2f$export$eb42a981869108f0 = $70949e6a28333d2f$export$e4936fed10ab2c40;
function $70949e6a28333d2f$export$26fba481281db559(props, allowedPropNames, excludedPropNames) {
    // It'd be great to properly type this while allowing 'aria-` and 'data-' attributes like TypeScript does for
    // JSX attributes, but that ability is hardcoded into the TS compiler with no analog in TypeScript typings.
    // Then we'd be able to enforce props extends native props (including aria- and data- attributes), and then
    // return native props.
    // We should be able to do this once this PR is merged: https://github.com/microsoft/TypeScript/pull/26797
    const isArray = Array.isArray(allowedPropNames);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    const keys = Object.keys(props);
    for (const key of keys){
        const isNativeProp = !isArray && allowedPropNames[key] || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf('data-') === 0 || key.indexOf('aria-') === 0;
        if (isNativeProp && (!excludedPropNames || (excludedPropNames === null || excludedPropNames === void 0 ? void 0 : excludedPropNames.indexOf(key)) === -1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result[key] = props[key];
    }
    return result;
}


const $f5c0cec12bf016e1$var$nativeElementMap = {
    label: (0, $70949e6a28333d2f$export$ec8d81a3d8f61d0f),
    audio: (0, $70949e6a28333d2f$export$55af9cf105a52547),
    video: (0, $70949e6a28333d2f$export$cd2126b486be823e),
    ol: (0, $70949e6a28333d2f$export$9e755727cea4fd1f),
    li: (0, $70949e6a28333d2f$export$8703767c2ecb797b),
    a: (0, $70949e6a28333d2f$export$bd4643a0b4568ed8),
    button: (0, $70949e6a28333d2f$export$4fd534fb1e82b8b4),
    input: (0, $70949e6a28333d2f$export$33c6815a27d08ce5),
    textarea: (0, $70949e6a28333d2f$export$699534499318873d),
    select: (0, $70949e6a28333d2f$export$9475341421ea2846),
    option: (0, $70949e6a28333d2f$export$9004c3828878727f),
    table: (0, $70949e6a28333d2f$export$2f53f8cf7eb86ae5),
    tr: (0, $70949e6a28333d2f$export$3ab2f4f445c2eb24),
    th: (0, $70949e6a28333d2f$export$2b115a026f474c83),
    td: (0, $70949e6a28333d2f$export$b5d753b2279d22cc),
    colGroup: (0, $70949e6a28333d2f$export$d526cc4b9c261b42),
    col: (0, $70949e6a28333d2f$export$e487baa138d06e98),
    fieldset: (0, $70949e6a28333d2f$export$52193885890f710e),
    form: (0, $70949e6a28333d2f$export$477a3a6d251d97a7),
    iframe: (0, $70949e6a28333d2f$export$727a7f82229b450f),
    img: (0, $70949e6a28333d2f$export$91f8cc2b546c057d),
    time: (0, $70949e6a28333d2f$export$1fc5e2c7479ee57),
    dialog: (0, $70949e6a28333d2f$export$88fc3d496ec6e608)
};
function $f5c0cec12bf016e1$export$eca624771caa6078(tagName, props, excludedPropNames) {
    const allowedPropNames = tagName && $f5c0cec12bf016e1$var$nativeElementMap[tagName] || (0, $70949e6a28333d2f$export$e4936fed10ab2c40);
    allowedPropNames.as = 1;
    return (0, $70949e6a28333d2f$export$26fba481281db559)(props, allowedPropNames, excludedPropNames);
}
const $f5c0cec12bf016e1$export$199c93d3d8d08c56 = ({ primarySlotTagName: primarySlotTagName, props: props, excludedPropNames: excludedPropNames })=>{
    return {
        root: {
            style: props.style,
            className: props.className
        },
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        primary: $f5c0cec12bf016e1$export$eca624771caa6078(primarySlotTagName, props, [
            ...excludedPropNames || [],
            'style',
            'className'
        ])
    };
};


const $3cf8e596657ab4e0$export$c8517108b1b59810 = (tagName, props, excludedPropNames)=>{
    var _props_as;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return (0, $f5c0cec12bf016e1$export$eca624771caa6078)((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : tagName, props, excludedPropNames);
};


var $acw62 = parcelRequire("acw62");
'use client';
function $de7d48ea62179626$export$9cf7d991616612b3(...refs) {
    'use no memo';
    const mergedCallback = $acw62.useCallback((value)=>{
        // Update the "current" prop hanging on the function.
        mergedCallback.current = value;
        for (const ref of refs){
            typeof ref;
            if (typeof ref === 'function') ref(value);
            else if (ref) ref.current = value;
        }
    }, [
        ...refs
    ]);
    return mergedCallback;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

'use client';
const $4e48a6f126575b5a$export$700979bc83e7db82 = (0, $993af50b96092e61$export$71594e8a50f746f4)() ? $acw62.useLayoutEffect : $acw62.useEffect;


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

'use client';
const $fecc0f8e699705f8$export$8d77aa623242822f = {
    current: 0
};
const $fecc0f8e699705f8$export$8452e4682414c100 = /*#__PURE__*/ $acw62.createContext(undefined);
function $fecc0f8e699705f8$export$6b1c54dc4befcda() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($fecc0f8e699705f8$export$8452e4682414c100)) !== null && _React_useContext !== void 0 ? _React_useContext : $fecc0f8e699705f8$export$8d77aa623242822f;
}
const $fecc0f8e699705f8$export$9f8ac96af4b1b2ae = (props)=>{
    const [value] = $acw62.useState(()=>({
            current: 0
        }));
    return /*#__PURE__*/ $acw62.createElement($fecc0f8e699705f8$export$8452e4682414c100.Provider, {
        value: value
    }, props.children);
};
function $fecc0f8e699705f8$export$535bd6ca7f90a273() {
    const isInSSRContext = $fecc0f8e699705f8$export$6b1c54dc4befcda() !== $fecc0f8e699705f8$export$8d77aa623242822f;
    const [isSSR, setIsSSR] = $acw62.useState(isInSSRContext);
    // If on the client, and the component was initially server rendered, then schedule a layout effect to update the
    // component after hydration.
    if ((0, $993af50b96092e61$export$71594e8a50f746f4)() && isInSSRContext) // This if statement technically breaks the rules of hooks, but is safe because the condition never changes after
    // mounting.
    // eslint-disable-next-line
    $acw62.useLayoutEffect(()=>{
        setIsSSR(false);
    }, []);
    return isSSR;
}


'use client';
const $0200d30cfa270435$var$IdPrefixContext = $acw62.createContext(undefined);
const $0200d30cfa270435$export$1ac15c72ae97b87 = $0200d30cfa270435$var$IdPrefixContext.Provider;
function $0200d30cfa270435$var$useIdPrefix() {
    return $acw62.useContext($0200d30cfa270435$var$IdPrefixContext) || '';
}
function $0200d30cfa270435$export$e3990a4b0f37142e() {
    (0, $fecc0f8e699705f8$export$8d77aa623242822f).current = 0;
}
function $0200d30cfa270435$export$f680877a34711e37(prefix = 'fui-', providedId) {
    'use no memo';
    const contextValue = (0, $fecc0f8e699705f8$export$6b1c54dc4befcda)();
    const idPrefix = $0200d30cfa270435$var$useIdPrefix();
    // Checking if useId is available on React, if it is, we use it to generate the id. String concatenation is used to
    // prevent bundlers from complaining with older versions of React.
    const _useId = $acw62.useId;
    if (_useId) {
        const generatedId = _useId();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const escapedId = $acw62.useMemo(()=>generatedId.replace(/:/g, ''), [
            generatedId
        ]);
        return providedId || `${idPrefix}${prefix}${escapedId}`;
    }
    // Hooks appear to be running conditionally, but they will always run in the same order since it's based on
    // the version of React being used. This is safe to ignore.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $acw62.useMemo(()=>{
        if (providedId) return providedId;
        return `${idPrefix}${prefix}${++contextValue.current}`;
    }, [
        idPrefix,
        prefix,
        providedId,
        contextValue
    ]);
}



var $acw62 = parcelRequire("acw62");
const $f935f7668bf32111$var$CSS_ESCAPE_MAP = {
    '<': '\\3C ',
    '>': '\\3E '
};
/**
 * Escapes characters that could break out of a <style> tag during SSR.
 *
 * IMPORTANT: Do not strip quotes. Theme values legitimately include quoted font families and other CSS.
 * We only need to ensure the generated text cannot terminate the style tag and inject HTML.
 */ function $f935f7668bf32111$var$escapeForStyleTag(value) {
    // Escape as CSS code points so the resulting CSS still represents the same characters.
    // Using CSS escapes prevents the HTML parser from seeing a literal '<' / '>' and closing <style>.
    return value.replace(/[<>]/g, (match)=>$f935f7668bf32111$var$CSS_ESCAPE_MAP[match]);
}
function $f935f7668bf32111$export$2e5ce34465bca14b(selector, theme) {
    if (theme) {
        const cssVarsAsString = Object.keys(theme).reduce((cssVarRule, cssVar)=>{
            return `${cssVarRule}--${cssVar}: ${theme[cssVar]}; `;
        }, '');
        return `${selector} { ${$f935f7668bf32111$var$escapeForStyleTag(cssVarsAsString)} }`;
    }
    return `${selector} {}`;
}






/**
 * Default implementation of insertion factory. Inserts styles only once per renderer and performs
 * insertion immediately after styles computation.
 *
 * @internal
 */ const $58dc86b24cfc33cd$export$3509cd6597590fb4 = ()=>{
    const insertionCache = {};
    return function insertStyles(renderer, cssRules) {
        if (insertionCache[renderer.id] === undefined) {
            renderer.insertCSSRules(cssRules);
            insertionCache[renderer.id] = true;
        }
    };
};



/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}



function $b6660f89b23d78e3$var$padEndHash(value) {
    const hashLength = value.length;
    if (hashLength === (0, $1708e11ed21e9e34$export$92d383cc43013b89)) return value;
    for(let i = hashLength; i < (0, $1708e11ed21e9e34$export$92d383cc43013b89); i++)value += '0';
    return value;
}
function $b6660f89b23d78e3$export$714355b806f78694(classes, dir, sequenceIds = []) {
    return (0, $1708e11ed21e9e34$export$ed60e64637dbffef) + $b6660f89b23d78e3$var$padEndHash((0, $3629985b3ecf741f$export$2e2bcd8739ae039)(classes + dir));
}


/**
 * Reduces a classname map for slot to a classname string. Uses classnames according to text directions.
 *
 * @private
 */ function $7f688c48a4d5cb6f$export$9398e6bbc32c24c4(classMap, dir) {
    // - `classString` is a string of classnames separated by a space, used to output classes
    // - `hashString` is a string of classnames separated by a space, used to generate a hash
    //
    // `hashString` is needed to handle `null` values in a class map as they don't produce any classes.
    let classString = '';
    let hashString = '';
    // eslint-disable-next-line guard-for-in
    for(const propertyHash in classMap){
        const classNameMapping = classMap[propertyHash];
        if (classNameMapping === 0) {
            hashString += propertyHash + ' ';
            continue;
        }
        const hasRTLClassName = Array.isArray(classNameMapping);
        const className = dir === 'rtl' ? (hasRTLClassName ? classNameMapping[1] : classNameMapping) + ' ' : (hasRTLClassName ? classNameMapping[0] : classNameMapping) + ' ';
        classString += className;
        hashString += className;
    }
    return [
        classString.slice(0, -1),
        hashString.slice(0, -1)
    ];
}
/**
 * Reduces classname maps for slots to classname strings. Registers them in a definition cache to be used by
 * `mergeClasses()`.
 *
 * @internal
 */ function $7f688c48a4d5cb6f$export$af9182572a187ed1(classesMapBySlot, dir) {
    const classNamesForSlots = {};
    // eslint-disable-next-line guard-for-in
    for(const slotName in classesMapBySlot){
        const [slotClasses, slotClassesHash] = $7f688c48a4d5cb6f$export$9398e6bbc32c24c4(classesMapBySlot[slotName], dir);
        // Handles a case when there are no classes in a set i.e. "makeStyles({ root: {} })"
        if (slotClassesHash === '') {
            classNamesForSlots[slotName] = '';
            continue;
        }
        const sequenceHash = (0, $b6660f89b23d78e3$export$714355b806f78694)(slotClassesHash, dir);
        const resultSlotClasses = sequenceHash + (slotClasses === '' ? '' : ' ' + slotClasses);
        (0, $1708e11ed21e9e34$export$ac80cc81fdb4fb5a)[sequenceHash] = [
            classesMapBySlot[slotName],
            dir
        ];
        classNamesForSlots[slotName] = resultSlotClasses;
    }
    return classNamesForSlots;
}


/**
 * A version of makeStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */ function $1170b0e155e89f44$export$c5d3a2c2e0d67663(classesMapBySlot, cssRules, factory = (0, $58dc86b24cfc33cd$export$3509cd6597590fb4)) {
    const insertStyles = factory();
    let ltrClassNamesForSlots = null;
    let rtlClassNamesForSlots = null;
    let sourceURL;
    function computeClasses(options) {
        const { dir: dir, renderer: renderer } = options;
        const isLTR = dir === 'ltr';
        if (isLTR) {
            if (ltrClassNamesForSlots === null) ltrClassNamesForSlots = (0, $7f688c48a4d5cb6f$export$af9182572a187ed1)(classesMapBySlot, dir);
        } else if (rtlClassNamesForSlots === null) rtlClassNamesForSlots = (0, $7f688c48a4d5cb6f$export$af9182572a187ed1)(classesMapBySlot, dir);
        insertStyles(renderer, cssRules);
        const classNamesForSlots = isLTR ? ltrClassNamesForSlots : rtlClassNamesForSlots;
        return classNamesForSlots;
    }
    return computeClasses;
}




// Contains a mapping of previously resolved sequences of atomic classnames
const $5d215fd24b7ad0fd$export$18cfd45882d1eee = {};
function $5d215fd24b7ad0fd$export$3d46f4579dba46e5() {
    // arguments are parsed manually to avoid double loops as TS & Babel transforms rest via an additional loop
    // @see https://babeljs.io/docs/en/babel-plugin-transform-parameters
    /* eslint-disable prefer-rest-params */ let dir = null;
    let resultClassName = '';
    // Is used as a cache key to avoid object merging
    let sequenceMatch = '';
    const sequencesIds = new Array(arguments.length);
    let containsResetClassName = '';
    for(let i = 0; i < arguments.length; i++){
        const className = arguments[i];
        if (typeof className === 'string' && className !== '') {
            // All classes generated by `makeStyles()` are prefixed by a sequence hash, this allows to identify class sets
            // without parsing each className in a string
            const sequenceIndex = className.indexOf((0, $1708e11ed21e9e34$export$ed60e64637dbffef));
            if (sequenceIndex === -1) {
                var entry;
                resultClassName += className + ' ';
            } else {
                const sequenceId = className.substr(sequenceIndex, (0, $1708e11ed21e9e34$export$dcee98f0f975aca0));
                // Handles a case with mixed classnames, i.e. "ui-button ATOMIC_CLASSES"
                if (sequenceIndex > 0) resultClassName += className.slice(0, sequenceIndex);
                sequenceMatch += sequenceId;
                sequencesIds[i] = sequenceId;
            }
        }
    }
    // .slice() there allows to avoid trailing space for non-atomic classes
    // "ui-button ui-flex " => "ui-button ui-flex"
    if (sequenceMatch === '') return resultClassName.slice(0, -1);
    // It's safe to reuse results to avoid continuous merging as results are stable
    // "__seq1 ... __seq2 ..." => "__seq12 ..."
    const mergeClassesResult = $5d215fd24b7ad0fd$export$18cfd45882d1eee[sequenceMatch];
    if (mergeClassesResult !== undefined) return resultClassName + mergeClassesResult;
    const sequenceMappings = [];
    for(let i = 0; i < arguments.length; i++){
        const sequenceId = sequencesIds[i];
        if (sequenceId) {
            const sequenceMapping = (0, $1708e11ed21e9e34$export$ac80cc81fdb4fb5a)[sequenceId];
            if (sequenceMapping) {
                sequenceMappings.push(sequenceMapping[0, $1708e11ed21e9e34$export$ac331484967b91fa]);
                dir = sequenceMapping[0, $1708e11ed21e9e34$export$d20107152a904e34];
            }
        }
    }
    // eslint-disable-next-line prefer-spread
    const resultClassesMap = Object.assign.apply(Object, // .assign() mutates the first object, we can't mutate mappings as it will produce invalid results later
    [
        {}
    ].concat(sequenceMappings));
    const [atomicClasses, classesMapHash] = (0, $7f688c48a4d5cb6f$export$9398e6bbc32c24c4)(resultClassesMap, dir);
    // Each merge of classes generates a new sequence of atomic classes that needs to be registered
    const newSequenceHash = (0, $b6660f89b23d78e3$export$714355b806f78694)(classesMapHash, dir, sequencesIds);
    const newClassName = newSequenceHash + ' ' + atomicClasses;
    $5d215fd24b7ad0fd$export$18cfd45882d1eee[sequenceMatch] = newClassName;
    (0, $1708e11ed21e9e34$export$ac80cc81fdb4fb5a)[newSequenceHash] = [
        resultClassesMap,
        dir
    ];
    return resultClassName + newClassName;
}




'use client';
const $77cae713233baa8d$export$88dac45d8d60a317 = {
    root: 'fui-FluentProvider'
};
const $77cae713233baa8d$var$useStyles = /*#__PURE__*/ (0, $1170b0e155e89f44$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        fsow6f: [
            "f1o700av",
            "fes3tcz"
        ],
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f1o700av{text-align:left;}",
        ".fes3tcz{text-align:right;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const $77cae713233baa8d$export$8f3c5aad0b161134 = (state)=>{
    'use no memo';
    const renderer = (0, $4c6030e36adbdcfb$export$e0259e2a2ab69ea)();
    const styles = $77cae713233baa8d$var$useStyles({
        dir: state.dir,
        renderer: renderer
    });
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($77cae713233baa8d$export$88dac45d8d60a317.root, state.themeClassName, styles.root, state.root.className);
    return state;
};


'use client';
// String concatenation is used to prevent bundlers to complain with older versions of React
const $aeb2dd938b583a17$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : (0, $4e48a6f126575b5a$export$700979bc83e7db82);
const $aeb2dd938b583a17$var$createStyleTag = (target, elementAttributes)=>{
    // Document might exist but not be ready yet (e.g. during SSR)
    // In that case, we should not create a style tag
    if (!(target === null || target === void 0 ? void 0 : target.head)) return undefined;
    const tag = target.createElement('style');
    Object.keys(elementAttributes).forEach((attrName)=>{
        tag.setAttribute(attrName, elementAttributes[attrName]);
    });
    target.head.appendChild(tag);
    return tag;
};
const $aeb2dd938b583a17$var$insertSheet = (tag, rule)=>{
    const sheet = tag.sheet;
    if (sheet) {
        if (sheet.cssRules.length > 0) sheet.deleteRule(0);
        sheet.insertRule(rule, 0);
    }
};
const $aeb2dd938b583a17$export$bd71951f577fe049 = (options)=>{
    'use no memo';
    const { targetDocument: targetDocument, theme: theme, rendererAttributes: rendererAttributes } = options;
    const styleTag = $acw62.useRef(undefined);
    const styleTagId = (0, $0200d30cfa270435$export$f680877a34711e37)((0, $77cae713233baa8d$export$88dac45d8d60a317).root);
    const styleElementAttributes = rendererAttributes;
    const rule = $acw62.useMemo(()=>(0, $f935f7668bf32111$export$2e5ce34465bca14b)(`.${styleTagId}`, theme), [
        theme,
        styleTagId
    ]);
    var _styleElement_textContent, _styleElement_textContent_length;
    $aeb2dd938b583a17$var$useHandleSSRStyleElements(targetDocument, styleTagId);
    $aeb2dd938b583a17$var$useInsertionEffect(()=>{
        // The style element could already have been created during SSR - no need to recreate it
        const ssrStyleElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.getElementById(styleTagId);
        if (ssrStyleElement) styleTag.current = ssrStyleElement;
        else {
            styleTag.current = $aeb2dd938b583a17$var$createStyleTag(targetDocument, {
                ...styleElementAttributes,
                id: styleTagId
            });
            if (styleTag.current) $aeb2dd938b583a17$var$insertSheet(styleTag.current, rule);
        }
        return ()=>{
            var _styleTag_current;
            (_styleTag_current = styleTag.current) === null || _styleTag_current === void 0 || _styleTag_current.remove();
        };
    }, [
        styleTagId,
        targetDocument,
        rule,
        styleElementAttributes
    ]);
    return {
        styleTagId: styleTagId,
        rule: rule
    };
};
function $aeb2dd938b583a17$var$useHandleSSRStyleElements(targetDocument, styleTagId) {
    // Using a state factory so that this logic only runs once per render
    // Each FluentProvider can create its own style element during SSR as a slot
    // Moves all theme style elements to document head during render to avoid hydration errors.
    // Should be strict mode safe since the logic is idempotent.
    $acw62.useState(()=>{
        if (!targetDocument) return;
        const themeStyleElement = targetDocument.getElementById(styleTagId);
        if (themeStyleElement) targetDocument.head.append(themeStyleElement);
    });
}


'use client';
// Meomizing empty objects to avoid unnecessary rerenders.
const $30ce64e1230177d0$var$DEFAULT_STYLE_HOOKS = {};
const $30ce64e1230177d0$var$DEFAULT_RENDERER_ATTRIBUTES = {};
const $30ce64e1230177d0$export$b5989e5d4d3841f = (props, ref)=>{
    'use no memo';
    const parentContext = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const parentTheme = $30ce64e1230177d0$var$useTheme();
    const parentOverrides = (0, $dcb30b81376c0f2d$export$ab0d8295b09da679)();
    const parentCustomStyleHooks = $acw62.useContext((0, $df848b23091d7919$export$d1a6d8b46a5f8f83)) || $30ce64e1230177d0$var$DEFAULT_STYLE_HOOKS;
    /**
   * TODO: add merge functions to "dir" merge,
   * nesting providers with the same "dir" should not add additional attributes to DOM
   * see https://github.com/microsoft/fluentui/blob/0dc74a19f3aa5a058224c20505016fbdb84db172/packages/fluentui/react-northstar/src/utils/mergeProviderContexts.ts#L89-L93
   */ const { applyStylesToPortals: applyStylesToPortals = true, customStyleHooks_unstable: customStyleHooks_unstable, dir: dir = parentContext.dir, targetDocument: targetDocument = parentContext.targetDocument, theme: theme, overrides_unstable: overrides = {} } = props;
    const mergedTheme = $30ce64e1230177d0$var$shallowMerge(parentTheme, theme);
    const mergedOverrides = $30ce64e1230177d0$var$shallowMerge(parentOverrides, overrides);
    const mergedCustomStyleHooks = $30ce64e1230177d0$var$shallowMerge(parentCustomStyleHooks, customStyleHooks_unstable);
    const renderer = (0, $4c6030e36adbdcfb$export$e0259e2a2ab69ea)();
    var _renderer_styleElementAttributes;
    const { styleTagId: styleTagId, rule: rule } = (0, $aeb2dd938b583a17$export$bd71951f577fe049)({
        theme: mergedTheme,
        targetDocument: targetDocument,
        rendererAttributes: (_renderer_styleElementAttributes = renderer.styleElementAttributes) !== null && _renderer_styleElementAttributes !== void 0 ? _renderer_styleElementAttributes : $30ce64e1230177d0$var$DEFAULT_RENDERER_ATTRIBUTES
    });
    return {
        applyStylesToPortals: applyStylesToPortals,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        customStyleHooks_unstable: mergedCustomStyleHooks,
        dir: dir,
        targetDocument: targetDocument,
        theme: mergedTheme,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        overrides_unstable: mergedOverrides,
        themeClassName: styleTagId,
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            ...props,
            dir: dir,
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, (0, $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6)({
                targetDocument: targetDocument
            }))
        }), {
            elementType: 'div'
        }),
        serverStyleProps: {
            cssRule: rule,
            attributes: {
                ...renderer.styleElementAttributes,
                id: styleTagId
            }
        }
    };
};
function $30ce64e1230177d0$var$shallowMerge(a, b) {
    // Merge impacts perf: we should like to avoid it if it's possible
    if (a && b) return {
        ...a,
        ...b
    };
    if (a) return a;
    return b;
}
function $30ce64e1230177d0$var$useTheme() {
    return $acw62.useContext((0, $7474d1e11e05d082$export$2c657da244d00bd6));
}




var $acw62 = parcelRequire("acw62");
'use client';
function $8f4deae75ca2d733$export$9e2edf0dbc0fca14(state) {
    const { applyStylesToPortals: applyStylesToPortals, customStyleHooks_unstable: customStyleHooks_unstable, dir: dir, root: root, targetDocument: targetDocument, theme: theme, themeClassName: themeClassName, overrides_unstable: overrides_unstable } = state;
    const provider = $acw62.useMemo(()=>({
            dir: dir,
            targetDocument: targetDocument
        }), [
        dir,
        targetDocument
    ]);
    // "Tooltip" component mutates an object in this context, instance should be stable
    const [tooltip] = $acw62.useState(()=>({}));
    const iconDirection = $acw62.useMemo(()=>({
            textDirection: dir
        }), [
        dir
    ]);
    return {
        customStyleHooks_unstable: // eslint-disable-next-line @typescript-eslint/naming-convention
        customStyleHooks_unstable,
        overrides_unstable: // eslint-disable-next-line @typescript-eslint/naming-convention
        overrides_unstable,
        provider: provider,
        textDirection: dir,
        iconDirection: iconDirection,
        tooltip: tooltip,
        theme: theme,
        themeClassName: applyStylesToPortals ? root.className : themeClassName
    };
}


'use client';
const $edc7f381b74604ab$export$a2fd5c9263a86adf = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $30ce64e1230177d0$export$b5989e5d4d3841f)(props, ref);
    (0, $77cae713233baa8d$export$8f3c5aad0b161134)(state);
    const contextValues = (0, $8f4deae75ca2d733$export$9e2edf0dbc0fca14)(state);
    return (0, $0b70550ea98bf3a8$export$2b3628d62f894ece)(state, contextValues);
});
$edc7f381b74604ab$export$a2fd5c9263a86adf.displayName = 'FluentProvider';


/**
 * react-router v7.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $fa12b390a398aec2$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-EVOBXE3Y.mjs"
});
var $fa12b390a398aec2$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $fa12b390a398aec2$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $fa12b390a398aec2$var$__typeError("Cannot " + msg);
var $fa12b390a398aec2$var$__privateGet = (obj, member, getter)=>($fa12b390a398aec2$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $fa12b390a398aec2$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $fa12b390a398aec2$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $fa12b390a398aec2$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($fa12b390a398aec2$export$e19cd5f9376f8cee || {});
var $fa12b390a398aec2$var$PopStateEventType = "popstate";
function $fa12b390a398aec2$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $fa12b390a398aec2$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $fa12b390a398aec2$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $fa12b390a398aec2$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $fa12b390a398aec2$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $fa12b390a398aec2$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $fa12b390a398aec2$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $fa12b390a398aec2$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $fa12b390a398aec2$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $fa12b390a398aec2$export$fe53371bee54353d(to);
    }
    return $fa12b390a398aec2$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $fa12b390a398aec2$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fa12b390a398aec2$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fa12b390a398aec2$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $fa12b390a398aec2$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fa12b390a398aec2$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $fa12b390a398aec2$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fa12b390a398aec2$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fa12b390a398aec2$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $fa12b390a398aec2$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $fa12b390a398aec2$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $fa12b390a398aec2$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fa12b390a398aec2$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $fa12b390a398aec2$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $fa12b390a398aec2$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fa12b390a398aec2$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $fa12b390a398aec2$var$isLocation(to) ? to : $fa12b390a398aec2$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fa12b390a398aec2$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $fa12b390a398aec2$var$isLocation(to) ? to : $fa12b390a398aec2$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fa12b390a398aec2$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $fa12b390a398aec2$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($fa12b390a398aec2$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($fa12b390a398aec2$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $fa12b390a398aec2$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $fa12b390a398aec2$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $fa12b390a398aec2$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $fa12b390a398aec2$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $fa12b390a398aec2$var$_map;
var $fa12b390a398aec2$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $fa12b390a398aec2$var$__privateAdd(this, $fa12b390a398aec2$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($fa12b390a398aec2$var$__privateGet(this, $fa12b390a398aec2$var$_map).has(context)) return $fa12b390a398aec2$var$__privateGet(this, $fa12b390a398aec2$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $fa12b390a398aec2$var$__privateGet(this, $fa12b390a398aec2$var$_map).set(context, value);
    }
};
$fa12b390a398aec2$var$_map = new WeakMap();
var $fa12b390a398aec2$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fa12b390a398aec2$var$isUnsupportedLazyRouteObjectKey(key) {
    return $fa12b390a398aec2$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $fa12b390a398aec2$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $fa12b390a398aec2$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $fa12b390a398aec2$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $fa12b390a398aec2$var$isIndexRoute(route) {
    return route.index === true;
}
function $fa12b390a398aec2$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fa12b390a398aec2$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $fa12b390a398aec2$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($fa12b390a398aec2$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $fa12b390a398aec2$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $fa12b390a398aec2$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $fa12b390a398aec2$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $fa12b390a398aec2$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $fa12b390a398aec2$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $fa12b390a398aec2$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fa12b390a398aec2$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fa12b390a398aec2$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fa12b390a398aec2$var$flattenRoutes(routes);
    $fa12b390a398aec2$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $fa12b390a398aec2$var$decodePath(pathname);
        matches = $fa12b390a398aec2$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fa12b390a398aec2$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $fa12b390a398aec2$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $fa12b390a398aec2$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fa12b390a398aec2$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $fa12b390a398aec2$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $fa12b390a398aec2$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fa12b390a398aec2$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $fa12b390a398aec2$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $fa12b390a398aec2$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fa12b390a398aec2$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fa12b390a398aec2$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $fa12b390a398aec2$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $fa12b390a398aec2$var$paramRe = /^:[\w-]+$/;
var $fa12b390a398aec2$var$dynamicSegmentValue = 3;
var $fa12b390a398aec2$var$indexRouteValue = 2;
var $fa12b390a398aec2$var$emptySegmentValue = 1;
var $fa12b390a398aec2$var$staticSegmentValue = 10;
var $fa12b390a398aec2$var$splatPenalty = -2;
var $fa12b390a398aec2$var$isSplat = (s)=>s === "*";
function $fa12b390a398aec2$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fa12b390a398aec2$var$isSplat)) initialScore += $fa12b390a398aec2$var$splatPenalty;
    if (index) initialScore += $fa12b390a398aec2$var$indexRouteValue;
    return segments.filter((s)=>!$fa12b390a398aec2$var$isSplat(s)).reduce((score, segment)=>score + ($fa12b390a398aec2$var$paramRe.test(segment) ? $fa12b390a398aec2$var$dynamicSegmentValue : segment === "" ? $fa12b390a398aec2$var$emptySegmentValue : $fa12b390a398aec2$var$staticSegmentValue), initialScore);
}
function $fa12b390a398aec2$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fa12b390a398aec2$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fa12b390a398aec2$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fa12b390a398aec2$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fa12b390a398aec2$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fa12b390a398aec2$var$normalizePathname($fa12b390a398aec2$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fa12b390a398aec2$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $fa12b390a398aec2$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fa12b390a398aec2$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $fa12b390a398aec2$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $fa12b390a398aec2$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fa12b390a398aec2$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fa12b390a398aec2$var$compilePath(path, caseSensitive = false, end = true) {
    $fa12b390a398aec2$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $fa12b390a398aec2$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fa12b390a398aec2$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $fa12b390a398aec2$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $fa12b390a398aec2$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $fa12b390a398aec2$var$joinPaths([
        basename,
        pathname
    ]);
}
var $fa12b390a398aec2$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fa12b390a398aec2$var$isAbsoluteUrl = (url)=>$fa12b390a398aec2$var$ABSOLUTE_URL_REGEX.test(url);
function $fa12b390a398aec2$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $fa12b390a398aec2$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $fa12b390a398aec2$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $fa12b390a398aec2$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $fa12b390a398aec2$var$normalizeSearch(search),
        hash: $fa12b390a398aec2$var$normalizeHash(hash)
    };
}
function $fa12b390a398aec2$var$resolvePathname(relativePath, fromPathname) {
    let segments = $fa12b390a398aec2$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fa12b390a398aec2$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $fa12b390a398aec2$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $fa12b390a398aec2$var$getResolveToMatches(matches) {
    let pathMatches = $fa12b390a398aec2$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $fa12b390a398aec2$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $fa12b390a398aec2$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $fa12b390a398aec2$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $fa12b390a398aec2$var$getInvalidPathError("?", "pathname", "search", to));
        $fa12b390a398aec2$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $fa12b390a398aec2$var$getInvalidPathError("#", "pathname", "hash", to));
        $fa12b390a398aec2$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $fa12b390a398aec2$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fa12b390a398aec2$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $fa12b390a398aec2$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
var $fa12b390a398aec2$var$joinPaths = (paths)=>$fa12b390a398aec2$var$removeDoubleSlashes(paths.join("/"));
var $fa12b390a398aec2$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $fa12b390a398aec2$var$normalizePathname = (pathname)=>$fa12b390a398aec2$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $fa12b390a398aec2$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $fa12b390a398aec2$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $fa12b390a398aec2$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $fa12b390a398aec2$export$4051a07651545597(data2, init) {
    return new $fa12b390a398aec2$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $fa12b390a398aec2$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $fa12b390a398aec2$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fa12b390a398aec2$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $fa12b390a398aec2$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fa12b390a398aec2$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $fa12b390a398aec2$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $fa12b390a398aec2$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $fa12b390a398aec2$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $fa12b390a398aec2$var$joinPaths(parts) || "/";
}
var $fa12b390a398aec2$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $fa12b390a398aec2$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$fa12b390a398aec2$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($fa12b390a398aec2$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $fa12b390a398aec2$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $fa12b390a398aec2$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $fa12b390a398aec2$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $fa12b390a398aec2$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $fa12b390a398aec2$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $fa12b390a398aec2$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$fa12b390a398aec2$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $fa12b390a398aec2$var$wrapImpl(aggregated[key], original, (...args)=>$fa12b390a398aec2$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$fa12b390a398aec2$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$fa12b390a398aec2$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $fa12b390a398aec2$var$wrapImpl(aggregated.middleware, original, (...args)=>$fa12b390a398aec2$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$fa12b390a398aec2$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $fa12b390a398aec2$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$fa12b390a398aec2$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $fa12b390a398aec2$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $fa12b390a398aec2$export$fe53371bee54353d(to) : ".",
                ...$fa12b390a398aec2$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$fa12b390a398aec2$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$fa12b390a398aec2$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $fa12b390a398aec2$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$fa12b390a398aec2$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$fa12b390a398aec2$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $fa12b390a398aec2$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $fa12b390a398aec2$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $fa12b390a398aec2$var$getReadonlyRequest(request),
            context: context != null ? $fa12b390a398aec2$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $fa12b390a398aec2$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $fa12b390a398aec2$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $fa12b390a398aec2$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $fa12b390a398aec2$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $fa12b390a398aec2$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $fa12b390a398aec2$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $fa12b390a398aec2$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $fa12b390a398aec2$var$getReadonlyContext(context)
    };
}
function $fa12b390a398aec2$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $fa12b390a398aec2$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $fa12b390a398aec2$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $fa12b390a398aec2$var$getReadonlyContext(context) {
    if ($fa12b390a398aec2$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $fa12b390a398aec2$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fa12b390a398aec2$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fa12b390a398aec2$var$objectProtoNames;
}
// lib/router/router.ts
var $fa12b390a398aec2$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $fa12b390a398aec2$var$validMutationMethods = new Set($fa12b390a398aec2$var$validMutationMethodsArr);
var $fa12b390a398aec2$var$validRequestMethodsArr = [
    "GET",
    ...$fa12b390a398aec2$var$validMutationMethodsArr
];
var $fa12b390a398aec2$var$validRequestMethods = new Set($fa12b390a398aec2$var$validRequestMethodsArr);
var $fa12b390a398aec2$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $fa12b390a398aec2$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $fa12b390a398aec2$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $fa12b390a398aec2$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $fa12b390a398aec2$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $fa12b390a398aec2$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $fa12b390a398aec2$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $fa12b390a398aec2$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $fa12b390a398aec2$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $fa12b390a398aec2$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $fa12b390a398aec2$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$fa12b390a398aec2$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $fa12b390a398aec2$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $fa12b390a398aec2$var$defaultDataStrategyWithMiddleware;
    let future = {
        unstable_passThroughRequests: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fa12b390a398aec2$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $fa12b390a398aec2$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fa12b390a398aec2$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$fa12b390a398aec2$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $fa12b390a398aec2$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $fa12b390a398aec2$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $fa12b390a398aec2$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fa12b390a398aec2$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $fa12b390a398aec2$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fa12b390a398aec2$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fa12b390a398aec2$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $fa12b390a398aec2$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fa12b390a398aec2$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fa12b390a398aec2$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $fa12b390a398aec2$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $fa12b390a398aec2$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $fa12b390a398aec2$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $fa12b390a398aec2$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $fa12b390a398aec2$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $fa12b390a398aec2$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fa12b390a398aec2$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $fa12b390a398aec2$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $fa12b390a398aec2$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $fa12b390a398aec2$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fa12b390a398aec2$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $fa12b390a398aec2$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $fa12b390a398aec2$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $fa12b390a398aec2$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fa12b390a398aec2$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fa12b390a398aec2$var$isErrorResult(result) && $fa12b390a398aec2$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fa12b390a398aec2$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $fa12b390a398aec2$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$fa12b390a398aec2$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $fa12b390a398aec2$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $fa12b390a398aec2$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $fa12b390a398aec2$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $fa12b390a398aec2$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $fa12b390a398aec2$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fa12b390a398aec2$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $fa12b390a398aec2$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($fa12b390a398aec2$var$isErrorResult(result)) {
            let boundaryMatch = $fa12b390a398aec2$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $fa12b390a398aec2$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $fa12b390a398aec2$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $fa12b390a398aec2$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $fa12b390a398aec2$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $fa12b390a398aec2$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$fa12b390a398aec2$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $fa12b390a398aec2$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $fa12b390a398aec2$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $fa12b390a398aec2$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fa12b390a398aec2$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fa12b390a398aec2$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fa12b390a398aec2$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $fa12b390a398aec2$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fa12b390a398aec2$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fa12b390a398aec2$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $fa12b390a398aec2$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fa12b390a398aec2$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fa12b390a398aec2$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fa12b390a398aec2$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fa12b390a398aec2$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $fa12b390a398aec2$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $fa12b390a398aec2$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($fa12b390a398aec2$var$isRedirectResult(actionResult) || $fa12b390a398aec2$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fa12b390a398aec2$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($fa12b390a398aec2$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $fa12b390a398aec2$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fa12b390a398aec2$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($fa12b390a398aec2$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fa12b390a398aec2$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fa12b390a398aec2$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fa12b390a398aec2$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fa12b390a398aec2$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $fa12b390a398aec2$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fa12b390a398aec2$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $fa12b390a398aec2$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $fa12b390a398aec2$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $fa12b390a398aec2$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $fa12b390a398aec2$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fa12b390a398aec2$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $fa12b390a398aec2$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fa12b390a398aec2$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fa12b390a398aec2$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fa12b390a398aec2$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $fa12b390a398aec2$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $fa12b390a398aec2$var$getDoneFetcher(void 0));
            return;
        }
        if ($fa12b390a398aec2$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $fa12b390a398aec2$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($fa12b390a398aec2$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $fa12b390a398aec2$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $fa12b390a398aec2$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $fa12b390a398aec2$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $fa12b390a398aec2$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($fa12b390a398aec2$var$isAbsoluteUrl(location)) {
                const url = $fa12b390a398aec2$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fa12b390a398aec2$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fa12b390a398aec2$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($fa12b390a398aec2$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $fa12b390a398aec2$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $fa12b390a398aec2$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fa12b390a398aec2$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$fa12b390a398aec2$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($fa12b390a398aec2$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $fa12b390a398aec2$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $fa12b390a398aec2$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $fa12b390a398aec2$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $fa12b390a398aec2$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $fa12b390a398aec2$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $fa12b390a398aec2$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fa12b390a398aec2$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fa12b390a398aec2$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fa12b390a398aec2$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fa12b390a398aec2$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fa12b390a398aec2$export$386d57f03f0b2883;
        $fa12b390a398aec2$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $fa12b390a398aec2$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fa12b390a398aec2$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fa12b390a398aec2$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $fa12b390a398aec2$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$fa12b390a398aec2$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $fa12b390a398aec2$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $fa12b390a398aec2$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $fa12b390a398aec2$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fa12b390a398aec2$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $fa12b390a398aec2$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $fa12b390a398aec2$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fa12b390a398aec2$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fa12b390a398aec2$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $fa12b390a398aec2$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $fa12b390a398aec2$export$3336b097a6fbc59a(routes, opts) {
    $fa12b390a398aec2$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $fa12b390a398aec2$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        unstable_passThroughRequests: false,
        // unused in static handler
        ...opts?.future
    };
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$fa12b390a398aec2$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $fa12b390a398aec2$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, unstable_normalizePath: unstable_normalizePath } = {}) {
        let normalizePath = unstable_normalizePath || $fa12b390a398aec2$var$defaultNormalizePath;
        let method = request.method;
        let location = $fa12b390a398aec2$var$createLocation("", normalizePath(request), null, "default");
        let matches = $fa12b390a398aec2$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $fa12b390a398aec2$export$b8d3e69d4b3eff04();
        if (!$fa12b390a398aec2$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fa12b390a398aec2$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fa12b390a398aec2$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $fa12b390a398aec2$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fa12b390a398aec2$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $fa12b390a398aec2$export$f5708dca728d7177(requestContext instanceof $fa12b390a398aec2$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $fa12b390a398aec2$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $fa12b390a398aec2$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_url: $fa12b390a398aec2$var$createDataFunctionUrl(request, location),
                    unstable_pattern: $fa12b390a398aec2$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($fa12b390a398aec2$export$6e80290866a84dd4(error)) return error;
                    if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $fa12b390a398aec2$export$f2680fa305b734ca(error.status, error.statusText, await $fa12b390a398aec2$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($fa12b390a398aec2$export$e0163cfdf7bc9cfa(error)) error = $fa12b390a398aec2$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $fa12b390a398aec2$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $fa12b390a398aec2$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $fa12b390a398aec2$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $fa12b390a398aec2$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, unstable_normalizePath: unstable_normalizePath } = {}) {
        let normalizePath = unstable_normalizePath || $fa12b390a398aec2$var$defaultNormalizePath;
        let method = request.method;
        let location = $fa12b390a398aec2$var$createLocation("", normalizePath(request), null, "default");
        let matches = $fa12b390a398aec2$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $fa12b390a398aec2$export$b8d3e69d4b3eff04();
        if (!$fa12b390a398aec2$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fa12b390a398aec2$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fa12b390a398aec2$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fa12b390a398aec2$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fa12b390a398aec2$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $fa12b390a398aec2$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $fa12b390a398aec2$export$f5708dca728d7177(requestContext instanceof $fa12b390a398aec2$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $fa12b390a398aec2$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $fa12b390a398aec2$var$runServerMiddlewarePipeline({
                request: request,
                unstable_url: $fa12b390a398aec2$var$createDataFunctionUrl(request, location),
                unstable_pattern: $fa12b390a398aec2$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $fa12b390a398aec2$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($fa12b390a398aec2$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($fa12b390a398aec2$var$dataWithResponseInitToResponse(error));
                if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $fa12b390a398aec2$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fa12b390a398aec2$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $fa12b390a398aec2$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $fa12b390a398aec2$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($fa12b390a398aec2$var$isDataStrategyResult(e) && $fa12b390a398aec2$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($fa12b390a398aec2$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fa12b390a398aec2$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fa12b390a398aec2$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($fa12b390a398aec2$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($fa12b390a398aec2$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($fa12b390a398aec2$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fa12b390a398aec2$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $fa12b390a398aec2$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fa12b390a398aec2$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fa12b390a398aec2$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $fa12b390a398aec2$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $fa12b390a398aec2$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $fa12b390a398aec2$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $fa12b390a398aec2$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $fa12b390a398aec2$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $fa12b390a398aec2$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $fa12b390a398aec2$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $fa12b390a398aec2$var$callDataStrategyImpl(dataStrategy || $fa12b390a398aec2$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fa12b390a398aec2$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $fa12b390a398aec2$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($fa12b390a398aec2$export$e0163cfdf7bc9cfa(result.result)) throw $fa12b390a398aec2$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $fa12b390a398aec2$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $fa12b390a398aec2$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $fa12b390a398aec2$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $fa12b390a398aec2$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $fa12b390a398aec2$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $fa12b390a398aec2$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $fa12b390a398aec2$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $fa12b390a398aec2$var$resolveTo(to ? to : ".", $fa12b390a398aec2$var$getResolveToMatches(contextualMatches), $fa12b390a398aec2$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $fa12b390a398aec2$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $fa12b390a398aec2$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $fa12b390a398aec2$export$fe53371bee54353d(path);
}
function $fa12b390a398aec2$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$fa12b390a398aec2$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fa12b390a398aec2$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fa12b390a398aec2$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fa12b390a398aec2$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $fa12b390a398aec2$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$fa12b390a398aec2$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$fa12b390a398aec2$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fa12b390a398aec2$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fa12b390a398aec2$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fa12b390a398aec2$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fa12b390a398aec2$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fa12b390a398aec2$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($fa12b390a398aec2$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $fa12b390a398aec2$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $fa12b390a398aec2$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $fa12b390a398aec2$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $fa12b390a398aec2$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $fa12b390a398aec2$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$fa12b390a398aec2$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $fa12b390a398aec2$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($fa12b390a398aec2$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $fa12b390a398aec2$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($fa12b390a398aec2$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $fa12b390a398aec2$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $fa12b390a398aec2$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $fa12b390a398aec2$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $fa12b390a398aec2$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $fa12b390a398aec2$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($fa12b390a398aec2$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $fa12b390a398aec2$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $fa12b390a398aec2$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$fa12b390a398aec2$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $fa12b390a398aec2$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $fa12b390a398aec2$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fa12b390a398aec2$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $fa12b390a398aec2$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $fa12b390a398aec2$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$fa12b390a398aec2$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $fa12b390a398aec2$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $fa12b390a398aec2$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $fa12b390a398aec2$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$fa12b390a398aec2$var$isSameRoute(aChild, bChild))) ?? false;
}
var $fa12b390a398aec2$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $fa12b390a398aec2$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $fa12b390a398aec2$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $fa12b390a398aec2$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $fa12b390a398aec2$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $fa12b390a398aec2$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $fa12b390a398aec2$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $fa12b390a398aec2$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $fa12b390a398aec2$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $fa12b390a398aec2$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $fa12b390a398aec2$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $fa12b390a398aec2$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $fa12b390a398aec2$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $fa12b390a398aec2$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $fa12b390a398aec2$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $fa12b390a398aec2$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $fa12b390a398aec2$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $fa12b390a398aec2$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $fa12b390a398aec2$var$isNonNullable(value) {
    return value !== void 0;
}
function $fa12b390a398aec2$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $fa12b390a398aec2$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($fa12b390a398aec2$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $fa12b390a398aec2$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $fa12b390a398aec2$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $fa12b390a398aec2$var$defaultDataStrategy(args);
    return $fa12b390a398aec2$var$runClientMiddlewarePipeline(args, ()=>$fa12b390a398aec2$var$defaultDataStrategy(args));
}
function $fa12b390a398aec2$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $fa12b390a398aec2$var$runMiddlewarePipeline(args, handler, processResult, $fa12b390a398aec2$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $fa12b390a398aec2$export$e0163cfdf7bc9cfa(result) ? $fa12b390a398aec2$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $fa12b390a398aec2$var$runClientMiddlewarePipeline(args, handler) {
    return $fa12b390a398aec2$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($fa12b390a398aec2$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $fa12b390a398aec2$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $fa12b390a398aec2$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $fa12b390a398aec2$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $fa12b390a398aec2$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $fa12b390a398aec2$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $fa12b390a398aec2$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $fa12b390a398aec2$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $fa12b390a398aec2$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $fa12b390a398aec2$var$loadLazyRoute(match.route, $fa12b390a398aec2$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $fa12b390a398aec2$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $fa12b390a398aec2$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $fa12b390a398aec2$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $fa12b390a398aec2$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $fa12b390a398aec2$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$fa12b390a398aec2$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($fa12b390a398aec2$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $fa12b390a398aec2$var$callLoaderOrAction({
                request: request,
                path: path,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $fa12b390a398aec2$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $fa12b390a398aec2$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $fa12b390a398aec2$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $fa12b390a398aec2$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $fa12b390a398aec2$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_url: $fa12b390a398aec2$var$createDataFunctionUrl(request, path),
        unstable_pattern: $fa12b390a398aec2$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $fa12b390a398aec2$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $fa12b390a398aec2$var$callLoaderOrAction({ request: request, path: path, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $fa12b390a398aec2$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_url: $fa12b390a398aec2$var$createDataFunctionUrl(request, path),
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fa12b390a398aec2$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fa12b390a398aec2$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fa12b390a398aec2$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $fa12b390a398aec2$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $fa12b390a398aec2$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $fa12b390a398aec2$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($fa12b390a398aec2$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $fa12b390a398aec2$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $fa12b390a398aec2$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $fa12b390a398aec2$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($fa12b390a398aec2$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $fa12b390a398aec2$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $fa12b390a398aec2$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fa12b390a398aec2$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fa12b390a398aec2$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $fa12b390a398aec2$export$30ab200a1a0a2def = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $fa12b390a398aec2$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($fa12b390a398aec2$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if ($fa12b390a398aec2$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $fa12b390a398aec2$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $fa12b390a398aec2$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($fa12b390a398aec2$export$30ab200a1a0a2def.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $fa12b390a398aec2$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fa12b390a398aec2$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fa12b390a398aec2$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $fa12b390a398aec2$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fa12b390a398aec2$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $fa12b390a398aec2$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fa12b390a398aec2$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fa12b390a398aec2$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fa12b390a398aec2$export$f5708dca728d7177(!$fa12b390a398aec2$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fa12b390a398aec2$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $fa12b390a398aec2$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $fa12b390a398aec2$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $fa12b390a398aec2$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fa12b390a398aec2$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $fa12b390a398aec2$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $fa12b390a398aec2$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($fa12b390a398aec2$var$isErrorResult(result)) {
            let boundaryMatch = $fa12b390a398aec2$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($fa12b390a398aec2$var$isRedirectResult(result)) $fa12b390a398aec2$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $fa12b390a398aec2$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fa12b390a398aec2$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $fa12b390a398aec2$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fa12b390a398aec2$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fa12b390a398aec2$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $fa12b390a398aec2$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fa12b390a398aec2$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fa12b390a398aec2$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $fa12b390a398aec2$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $fa12b390a398aec2$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fa12b390a398aec2$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fa12b390a398aec2$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(path) : path;
    return $fa12b390a398aec2$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $fa12b390a398aec2$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $fa12b390a398aec2$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $fa12b390a398aec2$var$dataWithResponseInitToErrorResponse(data2) {
    return new $fa12b390a398aec2$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $fa12b390a398aec2$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $fa12b390a398aec2$var$isDataStrategyResult(value));
}
function $fa12b390a398aec2$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $fa12b390a398aec2$var$isRedirectDataStrategyResult(result) {
    return $fa12b390a398aec2$export$3f1eb41d9a6a6a27(result.result) && $fa12b390a398aec2$var$redirectStatusCodes.has(result.result.status);
}
function $fa12b390a398aec2$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $fa12b390a398aec2$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $fa12b390a398aec2$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fa12b390a398aec2$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fa12b390a398aec2$export$794b2760043cf8cd(statusCode) {
    return $fa12b390a398aec2$var$redirectStatusCodes.has(statusCode);
}
function $fa12b390a398aec2$export$6e80290866a84dd4(result) {
    return $fa12b390a398aec2$export$3f1eb41d9a6a6a27(result) && $fa12b390a398aec2$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $fa12b390a398aec2$var$isValidMethod(method) {
    return $fa12b390a398aec2$var$validRequestMethods.has(method.toUpperCase());
}
function $fa12b390a398aec2$export$cbae47800eb95bc3(method) {
    return $fa12b390a398aec2$var$validMutationMethods.has(method.toUpperCase());
}
function $fa12b390a398aec2$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fa12b390a398aec2$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fa12b390a398aec2$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $fa12b390a398aec2$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fa12b390a398aec2$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $fa12b390a398aec2$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $fa12b390a398aec2$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fa12b390a398aec2$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $fa12b390a398aec2$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $fa12b390a398aec2$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $fa12b390a398aec2$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fa12b390a398aec2$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $fa12b390a398aec2$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fa12b390a398aec2$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fa12b390a398aec2$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $fa12b390a398aec2$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $fa12b390a398aec2$export$2eeee58951ff3c1c = $acw62.createContext(null);
$fa12b390a398aec2$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $fa12b390a398aec2$export$315e3ffb01f217 = $acw62.createContext(null);
$fa12b390a398aec2$export$315e3ffb01f217.displayName = "DataRouterState";
var $fa12b390a398aec2$export$717f757c655223f1 = $acw62.createContext(false);
function $fa12b390a398aec2$var$useIsRSCRouterContext() {
    return $acw62.useContext($fa12b390a398aec2$export$717f757c655223f1);
}
var $fa12b390a398aec2$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$fa12b390a398aec2$export$3681f408decb40d1.displayName = "ViewTransition";
var $fa12b390a398aec2$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$fa12b390a398aec2$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $fa12b390a398aec2$var$AwaitContext = $acw62.createContext(null);
$fa12b390a398aec2$var$AwaitContext.displayName = "Await";
var $fa12b390a398aec2$export$2666c20e15407622 = (props)=>$acw62.createElement($fa12b390a398aec2$var$AwaitContext.Provider, props);
var $fa12b390a398aec2$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$fa12b390a398aec2$export$3044ab7fdabeaee6.displayName = "Navigation";
var $fa12b390a398aec2$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$fa12b390a398aec2$export$e6a44b110a0c44d3.displayName = "Location";
var $fa12b390a398aec2$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$fa12b390a398aec2$export$aac280ed165a4397.displayName = "Route";
var $fa12b390a398aec2$var$RouteErrorContext = $acw62.createContext(null);
$fa12b390a398aec2$var$RouteErrorContext.displayName = "RouteError";
var $fa12b390a398aec2$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $fa12b390a398aec2$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $fa12b390a398aec2$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $fa12b390a398aec2$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $fa12b390a398aec2$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$fa12b390a398aec2$var$ERROR_DIGEST_BASE}:${$fa12b390a398aec2$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $fa12b390a398aec2$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$fa12b390a398aec2$var$ERROR_DIGEST_BASE}:${$fa12b390a398aec2$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $fa12b390a398aec2$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $fa12b390a398aec2$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $fa12b390a398aec2$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $fa12b390a398aec2$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $fa12b390a398aec2$export$9c954a9d03d32f4a() {
    return $acw62.useContext($fa12b390a398aec2$export$e6a44b110a0c44d3) != null;
}
function $fa12b390a398aec2$export$45d76561a5302f2b() {
    $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($fa12b390a398aec2$export$e6a44b110a0c44d3).location;
}
function $fa12b390a398aec2$export$1b3f31771c5d07c() {
    return $acw62.useContext($fa12b390a398aec2$export$e6a44b110a0c44d3).navigationType;
}
function $fa12b390a398aec2$export$6c330e8992e8a295(pattern) {
    $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $fa12b390a398aec2$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$fa12b390a398aec2$export$81336c211d5ff295(pattern, $fa12b390a398aec2$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $fa12b390a398aec2$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $fa12b390a398aec2$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $fa12b390a398aec2$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    return isDataRoute ? $fa12b390a398aec2$var$useNavigateStable() : $fa12b390a398aec2$var$useNavigateUnstable();
}
function $fa12b390a398aec2$var$useNavigateUnstable() {
    $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($fa12b390a398aec2$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fa12b390a398aec2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($fa12b390a398aec2$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $fa12b390a398aec2$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $fa12b390a398aec2$var$warning(activeRef.current, $fa12b390a398aec2$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $fa12b390a398aec2$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fa12b390a398aec2$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $fa12b390a398aec2$var$OutletContext = $acw62.createContext(null);
function $fa12b390a398aec2$export$4138103a3ae699cc() {
    return $acw62.useContext($fa12b390a398aec2$var$OutletContext);
}
function $fa12b390a398aec2$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $fa12b390a398aec2$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $fa12b390a398aec2$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fa12b390a398aec2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($fa12b390a398aec2$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$fa12b390a398aec2$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $fa12b390a398aec2$export$5d3fca4a98652595(routes, locationArg) {
    return $fa12b390a398aec2$var$useRoutesImpl(routes, locationArg);
}
function $fa12b390a398aec2$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($fa12b390a398aec2$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $fa12b390a398aec2$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $fa12b390a398aec2$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $fa12b390a398aec2$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $fa12b390a398aec2$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $fa12b390a398aec2$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($fa12b390a398aec2$export$945fecf35a8ef089) {
        $fa12b390a398aec2$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $fa12b390a398aec2$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $fa12b390a398aec2$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $fa12b390a398aec2$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $fa12b390a398aec2$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $fa12b390a398aec2$var$DefaultErrorComponent() {
    let error = $fa12b390a398aec2$export$ed527bf60f6e05f2();
    let message = $fa12b390a398aec2$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($fa12b390a398aec2$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $fa12b390a398aec2$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$DefaultErrorComponent, null);
var $fa12b390a398aec2$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $fa12b390a398aec2$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$fa12b390a398aec2$var$RenderErrorBoundary.contextType = $fa12b390a398aec2$export$717f757c655223f1;
var $fa12b390a398aec2$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $fa12b390a398aec2$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $fa12b390a398aec2$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $fa12b390a398aec2$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $fa12b390a398aec2$var$parseToInfo(redirect2.location, basename);
            if ($fa12b390a398aec2$var$isBrowser && !$fa12b390a398aec2$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $fa12b390a398aec2$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $fa12b390a398aec2$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($fa12b390a398aec2$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $fa12b390a398aec2$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $fa12b390a398aec2$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $fa12b390a398aec2$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $fa12b390a398aec2$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $fa12b390a398aec2$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $fa12b390a398aec2$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $fa12b390a398aec2$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($fa12b390a398aec2$export$2eeee58951ff3c1c);
    $fa12b390a398aec2$export$f5708dca728d7177(ctx, $fa12b390a398aec2$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $fa12b390a398aec2$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($fa12b390a398aec2$export$315e3ffb01f217);
    $fa12b390a398aec2$export$f5708dca728d7177(state, $fa12b390a398aec2$var$getDataRouterConsoleError(hookName));
    return state;
}
function $fa12b390a398aec2$var$useRouteContext(hookName) {
    let route = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    $fa12b390a398aec2$export$f5708dca728d7177(route, $fa12b390a398aec2$var$getDataRouterConsoleError(hookName));
    return route;
}
function $fa12b390a398aec2$var$useCurrentRouteId(hookName) {
    let route = $fa12b390a398aec2$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $fa12b390a398aec2$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $fa12b390a398aec2$var$useRouteId() {
    return $fa12b390a398aec2$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $fa12b390a398aec2$export$d0fd4b7106de2769() {
    let state = $fa12b390a398aec2$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $fa12b390a398aec2$export$600dc272ed516c15() {
    let dataRouterContext = $fa12b390a398aec2$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $fa12b390a398aec2$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $fa12b390a398aec2$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $fa12b390a398aec2$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$fa12b390a398aec2$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $fa12b390a398aec2$export$1448a5050d252c4d() {
    let state = $fa12b390a398aec2$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $fa12b390a398aec2$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $fa12b390a398aec2$export$fd5d37484eab868d(routeId) {
    let state = $fa12b390a398aec2$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $fa12b390a398aec2$export$fdc00f3f26066d5e() {
    let state = $fa12b390a398aec2$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $fa12b390a398aec2$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $fa12b390a398aec2$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($fa12b390a398aec2$var$RouteErrorContext);
    let state = $fa12b390a398aec2$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $fa12b390a398aec2$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $fa12b390a398aec2$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($fa12b390a398aec2$var$AwaitContext);
    return value?._data;
}
function $fa12b390a398aec2$export$17f53340677d5831() {
    let value = $acw62.useContext($fa12b390a398aec2$var$AwaitContext);
    return value?._error;
}
var $fa12b390a398aec2$var$blockerId = 0;
function $fa12b390a398aec2$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $fa12b390a398aec2$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $fa12b390a398aec2$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $fa12b390a398aec2$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $fa12b390a398aec2$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$fa12b390a398aec2$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $fa12b390a398aec2$export$386d57f03f0b2883;
}
function $fa12b390a398aec2$var$useNavigateStable() {
    let { router: router } = $fa12b390a398aec2$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $fa12b390a398aec2$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $fa12b390a398aec2$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $fa12b390a398aec2$var$warning(activeRef.current, $fa12b390a398aec2$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $fa12b390a398aec2$var$alreadyWarned = {};
function $fa12b390a398aec2$var$warningOnce(key, cond, message) {
    if (!cond && !$fa12b390a398aec2$var$alreadyWarned[key]) {
        $fa12b390a398aec2$var$alreadyWarned[key] = true;
        $fa12b390a398aec2$var$warning(false, message);
    }
}
function $fa12b390a398aec2$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $fa12b390a398aec2$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $fa12b390a398aec2$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $fa12b390a398aec2$var$alreadyWarned2 = {};
function $fa12b390a398aec2$export$5b28268982f175ba(condition, message) {
    if (!condition && !$fa12b390a398aec2$var$alreadyWarned2[message]) {
        $fa12b390a398aec2$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $fa12b390a398aec2$var$USE_OPTIMISTIC = "useOptimistic";
var $fa12b390a398aec2$var$useOptimisticImpl = $acw62[$fa12b390a398aec2$var$USE_OPTIMISTIC];
var $fa12b390a398aec2$var$stableUseOptimisticSetter = ()=>void 0;
function $fa12b390a398aec2$var$useOptimisticSafe(val) {
    if ($fa12b390a398aec2$var$useOptimisticImpl) return $fa12b390a398aec2$var$useOptimisticImpl(val);
    else return [
        val,
        $fa12b390a398aec2$var$stableUseOptimisticSetter
    ];
}
function $fa12b390a398aec2$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($fa12b390a398aec2$export$945fecf35a8ef089) {
            if (route.element) $fa12b390a398aec2$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($fa12b390a398aec2$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $fa12b390a398aec2$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($fa12b390a398aec2$export$945fecf35a8ef089) {
            if (route.errorElement) $fa12b390a398aec2$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $fa12b390a398aec2$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $fa12b390a398aec2$export$f30f7e456d254e83(routes, opts) {
    return $fa12b390a398aec2$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $fa12b390a398aec2$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $fa12b390a398aec2$export$e2fd2c03906469db,
        mapRouteProperties: $fa12b390a398aec2$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $fa12b390a398aec2$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $fa12b390a398aec2$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $fa12b390a398aec2$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $fa12b390a398aec2$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $fa12b390a398aec2$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $fa12b390a398aec2$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $fa12b390a398aec2$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$fa12b390a398aec2$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let initialized = state.initialized;
    $acw62.useLayoutEffect(()=>{
        if (!initialized && router.state.initialized) setState(router.state, {
            deletedFetchers: [],
            flushSync: false,
            newErrors: null
        });
    }, [
        initialized,
        setState,
        router.state
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fa12b390a398aec2$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$fa12b390a398aec2$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $fa12b390a398aec2$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $fa12b390a398aec2$var$MemoizedDataRoutes = $acw62.memo($fa12b390a398aec2$var$DataRoutes);
function $fa12b390a398aec2$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $fa12b390a398aec2$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $fa12b390a398aec2$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $fa12b390a398aec2$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $fa12b390a398aec2$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $fa12b390a398aec2$export$f5708dca728d7177($fa12b390a398aec2$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    $fa12b390a398aec2$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    let { pathname: locationPathname } = $fa12b390a398aec2$export$45d76561a5302f2b();
    let navigate = $fa12b390a398aec2$export$9770f232ac06a008();
    let path = $fa12b390a398aec2$var$resolveTo(to, $fa12b390a398aec2$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $fa12b390a398aec2$export$910ae8079b2c2852(props) {
    return $fa12b390a398aec2$export$a3be3530d8e40d0b(props.context);
}
function $fa12b390a398aec2$export$e7b0ac011bb776c6(props) {
    $fa12b390a398aec2$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $fa12b390a398aec2$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $fa12b390a398aec2$export$f5708dca728d7177(!$fa12b390a398aec2$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $fa12b390a398aec2$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $fa12b390a398aec2$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $fa12b390a398aec2$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $fa12b390a398aec2$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $fa12b390a398aec2$export$5d3fca4a98652595($fa12b390a398aec2$export$16da398f5434bdec(children), location);
}
function $fa12b390a398aec2$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($fa12b390a398aec2$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($fa12b390a398aec2$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $fa12b390a398aec2$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$ResolveAwait, null, children));
}
var $fa12b390a398aec2$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $fa12b390a398aec2$var$ResolveAwait({ children: children }) {
    let data2 = $fa12b390a398aec2$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $fa12b390a398aec2$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $fa12b390a398aec2$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $fa12b390a398aec2$export$f5708dca728d7177(element.type === $fa12b390a398aec2$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $fa12b390a398aec2$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $fa12b390a398aec2$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $fa12b390a398aec2$export$9b5b6d122dea0c88 = $fa12b390a398aec2$export$16da398f5434bdec;
function $fa12b390a398aec2$export$daf73786167a7f72(matches) {
    return $fa12b390a398aec2$var$_renderMatches(matches);
}
function $fa12b390a398aec2$var$useRouteComponentProps() {
    return {
        params: $fa12b390a398aec2$export$99eaa27ddbbb95ef(),
        loaderData: $fa12b390a398aec2$export$1448a5050d252c4d(),
        actionData: $fa12b390a398aec2$export$fdc00f3f26066d5e(),
        matches: $fa12b390a398aec2$export$2378eb7f5ff86053()
    };
}
function $fa12b390a398aec2$export$6c4f3826290c37af({ children: children }) {
    const props = $fa12b390a398aec2$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $fa12b390a398aec2$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $fa12b390a398aec2$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $fa12b390a398aec2$var$useHydrateFallbackProps() {
    return {
        params: $fa12b390a398aec2$export$99eaa27ddbbb95ef(),
        loaderData: $fa12b390a398aec2$export$1448a5050d252c4d(),
        actionData: $fa12b390a398aec2$export$fdc00f3f26066d5e()
    };
}
function $fa12b390a398aec2$export$f8cff34f39c1932a({ children: children }) {
    const props = $fa12b390a398aec2$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $fa12b390a398aec2$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $fa12b390a398aec2$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $fa12b390a398aec2$var$useErrorBoundaryProps() {
    return {
        params: $fa12b390a398aec2$export$99eaa27ddbbb95ef(),
        loaderData: $fa12b390a398aec2$export$1448a5050d252c4d(),
        actionData: $fa12b390a398aec2$export$fdc00f3f26066d5e(),
        error: $fa12b390a398aec2$export$ed527bf60f6e05f2()
    };
}
function $fa12b390a398aec2$export$e5afde5c4b6d747b({ children: children }) {
    const props = $fa12b390a398aec2$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $fa12b390a398aec2$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $fa12b390a398aec2$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $fa12b390a398aec2$var$defaultMethod = "get";
var $fa12b390a398aec2$var$defaultEncType = "application/x-www-form-urlencoded";
function $fa12b390a398aec2$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $fa12b390a398aec2$var$isButtonElement(object) {
    return $fa12b390a398aec2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fa12b390a398aec2$var$isFormElement(object) {
    return $fa12b390a398aec2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fa12b390a398aec2$var$isInputElement(object) {
    return $fa12b390a398aec2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fa12b390a398aec2$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fa12b390a398aec2$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fa12b390a398aec2$var$isModifiedEvent(event);
}
function $fa12b390a398aec2$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fa12b390a398aec2$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fa12b390a398aec2$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $fa12b390a398aec2$var$_formDataSupportsSubmitter = null;
function $fa12b390a398aec2$var$isFormDataSubmitterSupported() {
    if ($fa12b390a398aec2$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fa12b390a398aec2$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fa12b390a398aec2$var$_formDataSupportsSubmitter = true;
    }
    return $fa12b390a398aec2$var$_formDataSupportsSubmitter;
}
var $fa12b390a398aec2$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fa12b390a398aec2$var$getFormEncType(encType) {
    if (encType != null && !$fa12b390a398aec2$var$supportedFormEncTypes.has(encType)) {
        $fa12b390a398aec2$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$fa12b390a398aec2$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $fa12b390a398aec2$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fa12b390a398aec2$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $fa12b390a398aec2$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $fa12b390a398aec2$var$defaultMethod;
        encType = $fa12b390a398aec2$var$getFormEncType(target.getAttribute("enctype")) || $fa12b390a398aec2$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fa12b390a398aec2$var$isButtonElement(target) || $fa12b390a398aec2$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $fa12b390a398aec2$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fa12b390a398aec2$var$defaultMethod;
        encType = $fa12b390a398aec2$var$getFormEncType(target.getAttribute("formenctype")) || $fa12b390a398aec2$var$getFormEncType(form.getAttribute("enctype")) || $fa12b390a398aec2$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$fa12b390a398aec2$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fa12b390a398aec2$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $fa12b390a398aec2$var$defaultMethod;
        action = null;
        encType = $fa12b390a398aec2$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $fa12b390a398aec2$var$HOLE = -1;
var $fa12b390a398aec2$var$NAN = -2;
var $fa12b390a398aec2$var$NEGATIVE_INFINITY = -3;
var $fa12b390a398aec2$var$NEGATIVE_ZERO = -4;
var $fa12b390a398aec2$var$NULL = -5;
var $fa12b390a398aec2$var$POSITIVE_INFINITY = -6;
var $fa12b390a398aec2$var$UNDEFINED = -7;
var $fa12b390a398aec2$var$TYPE_BIGINT = "B";
var $fa12b390a398aec2$var$TYPE_DATE = "D";
var $fa12b390a398aec2$var$TYPE_ERROR = "E";
var $fa12b390a398aec2$var$TYPE_MAP = "M";
var $fa12b390a398aec2$var$TYPE_NULL_OBJECT = "N";
var $fa12b390a398aec2$var$TYPE_PROMISE = "P";
var $fa12b390a398aec2$var$TYPE_REGEXP = "R";
var $fa12b390a398aec2$var$TYPE_SET = "S";
var $fa12b390a398aec2$var$TYPE_SYMBOL = "Y";
var $fa12b390a398aec2$var$TYPE_URL = "U";
var $fa12b390a398aec2$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $fa12b390a398aec2$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $fa12b390a398aec2$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $fa12b390a398aec2$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $fa12b390a398aec2$var$TIME_LIMIT_MS = 1;
var $fa12b390a398aec2$var$getNow = ()=>Date.now();
var $fa12b390a398aec2$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $fa12b390a398aec2$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $fa12b390a398aec2$var$UNDEFINED;
    if (input === null) return $fa12b390a398aec2$var$NULL;
    if (Number.isNaN(input)) return $fa12b390a398aec2$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $fa12b390a398aec2$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $fa12b390a398aec2$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $fa12b390a398aec2$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $fa12b390a398aec2$var$stringify.call(this, stack);
    return index;
}
async function $fa12b390a398aec2$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $fa12b390a398aec2$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $fa12b390a398aec2$var$UNDEFINED;
        if (value === null) return $fa12b390a398aec2$var$NULL;
        if (Number.isNaN(value)) return $fa12b390a398aec2$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $fa12b390a398aec2$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $fa12b390a398aec2$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $fa12b390a398aec2$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $fa12b390a398aec2$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $fa12b390a398aec2$var$TIME_LIMIT_MS) {
            await $fa12b390a398aec2$var$yieldToMain();
            lastYieldTime = $fa12b390a398aec2$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$fa12b390a398aec2$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$fa12b390a398aec2$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$fa12b390a398aec2$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $fa12b390a398aec2$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$fa12b390a398aec2$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$fa12b390a398aec2$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$fa12b390a398aec2$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$fa12b390a398aec2$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$fa12b390a398aec2$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$fa12b390a398aec2$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$fa12b390a398aec2$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$fa12b390a398aec2$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$fa12b390a398aec2$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$fa12b390a398aec2$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($fa12b390a398aec2$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $fa12b390a398aec2$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $fa12b390a398aec2$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $fa12b390a398aec2$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $fa12b390a398aec2$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $fa12b390a398aec2$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $fa12b390a398aec2$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $fa12b390a398aec2$var$hydrate.call(this, startIndex);
}
function $fa12b390a398aec2$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $fa12b390a398aec2$var$UNDEFINED:
                set(void 0);
                continue;
            case $fa12b390a398aec2$var$NULL:
                set(null);
                continue;
            case $fa12b390a398aec2$var$NAN:
                set(NaN);
                continue;
            case $fa12b390a398aec2$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $fa12b390a398aec2$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $fa12b390a398aec2$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $fa12b390a398aec2$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $fa12b390a398aec2$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $fa12b390a398aec2$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $fa12b390a398aec2$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $fa12b390a398aec2$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $fa12b390a398aec2$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $fa12b390a398aec2$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $fa12b390a398aec2$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $fa12b390a398aec2$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $fa12b390a398aec2$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $fa12b390a398aec2$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $fa12b390a398aec2$var$globalObj && $fa12b390a398aec2$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $fa12b390a398aec2$var$globalObj && typeof $fa12b390a398aec2$var$globalObj[errorType] === "function" ? new $fa12b390a398aec2$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $fa12b390a398aec2$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $fa12b390a398aec2$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $fa12b390a398aec2$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $fa12b390a398aec2$var$Deferred2();
    const reader = readable.pipeThrough($fa12b390a398aec2$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $fa12b390a398aec2$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $fa12b390a398aec2$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $fa12b390a398aec2$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $fa12b390a398aec2$var$unflatten.call(this, line)
    };
}
async function $fa12b390a398aec2$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $fa12b390a398aec2$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $fa12b390a398aec2$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $fa12b390a398aec2$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $fa12b390a398aec2$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $fa12b390a398aec2$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $fa12b390a398aec2$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $fa12b390a398aec2$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$fa12b390a398aec2$var$TYPE_PROMISE}${deferredId}:[["${$fa12b390a398aec2$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$fa12b390a398aec2$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$fa12b390a398aec2$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $fa12b390a398aec2$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$fa12b390a398aec2$var$TYPE_ERROR}${deferredId}:[["${$fa12b390a398aec2$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$fa12b390a398aec2$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$fa12b390a398aec2$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $fa12b390a398aec2$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $fa12b390a398aec2$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $fa12b390a398aec2$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $fa12b390a398aec2$export$4cf11838cdc2a8a8(html) {
    return html.replace($fa12b390a398aec2$var$ESCAPE_REGEX, (match)=>$fa12b390a398aec2$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $fa12b390a398aec2$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $fa12b390a398aec2$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $fa12b390a398aec2$var$SingleFetchNoResultError = class extends Error {
};
var $fa12b390a398aec2$export$ae9272e641ead836 = 202;
var $fa12b390a398aec2$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $fa12b390a398aec2$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$fa12b390a398aec2$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $fa12b390a398aec2$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $fa12b390a398aec2$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $fa12b390a398aec2$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $fa12b390a398aec2$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $fa12b390a398aec2$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $fa12b390a398aec2$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $fa12b390a398aec2$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $fa12b390a398aec2$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $fa12b390a398aec2$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $fa12b390a398aec2$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $fa12b390a398aec2$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $fa12b390a398aec2$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($fa12b390a398aec2$export$3f1eb41d9a6a6a27(result.result) || $fa12b390a398aec2$export$972111febbeef05b(result.result) || $fa12b390a398aec2$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $fa12b390a398aec2$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $fa12b390a398aec2$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $fa12b390a398aec2$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $fa12b390a398aec2$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$fa12b390a398aec2$var$createDeferred2());
    let singleFetchDfd = $fa12b390a398aec2$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $fa12b390a398aec2$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $fa12b390a398aec2$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $fa12b390a398aec2$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $fa12b390a398aec2$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $fa12b390a398aec2$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $fa12b390a398aec2$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $fa12b390a398aec2$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $fa12b390a398aec2$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $fa12b390a398aec2$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $fa12b390a398aec2$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $fa12b390a398aec2$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$fa12b390a398aec2$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$fa12b390a398aec2$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $fa12b390a398aec2$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $fa12b390a398aec2$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $fa12b390a398aec2$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $fa12b390a398aec2$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $fa12b390a398aec2$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $fa12b390a398aec2$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($fa12b390a398aec2$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $fa12b390a398aec2$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $fa12b390a398aec2$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($fa12b390a398aec2$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$fa12b390a398aec2$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $fa12b390a398aec2$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $fa12b390a398aec2$export$4023ad4ecd4126a2(body, global) {
    return $fa12b390a398aec2$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $fa12b390a398aec2$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $fa12b390a398aec2$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$fa12b390a398aec2$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $fa12b390a398aec2$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $fa12b390a398aec2$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $fa12b390a398aec2$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $fa12b390a398aec2$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $fa12b390a398aec2$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $fa12b390a398aec2$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $fa12b390a398aec2$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $fa12b390a398aec2$var$getModuleLinkHrefs(matches, manifest);
    return $fa12b390a398aec2$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $fa12b390a398aec2$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $fa12b390a398aec2$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $fa12b390a398aec2$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($fa12b390a398aec2$var$prefetchStyleLink));
}
async function $fa12b390a398aec2$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$fa12b390a398aec2$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$fa12b390a398aec2$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$fa12b390a398aec2$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($fa12b390a398aec2$var$prefetchStyleLink));
}
async function $fa12b390a398aec2$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $fa12b390a398aec2$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $fa12b390a398aec2$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $fa12b390a398aec2$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $fa12b390a398aec2$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $fa12b390a398aec2$var$dedupeLinkDescriptors(links.flat(1).filter($fa12b390a398aec2$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $fa12b390a398aec2$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $fa12b390a398aec2$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $fa12b390a398aec2$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $fa12b390a398aec2$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $fa12b390a398aec2$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $fa12b390a398aec2$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$fa12b390a398aec2$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($fa12b390a398aec2$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $fa12b390a398aec2$var$_isPreloadSupported;
function $fa12b390a398aec2$var$isPreloadSupported() {
    if ($fa12b390a398aec2$var$_isPreloadSupported !== void 0) return $fa12b390a398aec2$var$_isPreloadSupported;
    let el = document.createElement("link");
    $fa12b390a398aec2$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $fa12b390a398aec2$var$_isPreloadSupported;
}
function $fa12b390a398aec2$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $fa12b390a398aec2$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $fa12b390a398aec2$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $fa12b390a398aec2$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $fa12b390a398aec2$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $fa12b390a398aec2$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RemixRootDefaultErrorBoundary, {
            error: $fa12b390a398aec2$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $fa12b390a398aec2$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $fa12b390a398aec2$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $fa12b390a398aec2$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$fa12b390a398aec2$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $fa12b390a398aec2$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $fa12b390a398aec2$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $fa12b390a398aec2$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $fa12b390a398aec2$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $fa12b390a398aec2$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $fa12b390a398aec2$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $fa12b390a398aec2$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $fa12b390a398aec2$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $fa12b390a398aec2$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $fa12b390a398aec2$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $fa12b390a398aec2$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $fa12b390a398aec2$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $fa12b390a398aec2$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$fa12b390a398aec2$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $fa12b390a398aec2$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern, unstable_url: unstable_url }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $fa12b390a398aec2$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            unstable_url: unstable_url,
                            async serverLoader () {
                                $fa12b390a398aec2$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $fa12b390a398aec2$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern, unstable_url: unstable_url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $fa12b390a398aec2$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $fa12b390a398aec2$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        unstable_url: unstable_url,
                        async serverAction () {
                            $fa12b390a398aec2$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $fa12b390a398aec2$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $fa12b390a398aec2$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $fa12b390a398aec2$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $fa12b390a398aec2$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $fa12b390a398aec2$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $fa12b390a398aec2$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $fa12b390a398aec2$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $fa12b390a398aec2$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $fa12b390a398aec2$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $fa12b390a398aec2$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $fa12b390a398aec2$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $fa12b390a398aec2$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $fa12b390a398aec2$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $fa12b390a398aec2$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $fa12b390a398aec2$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $fa12b390a398aec2$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $fa12b390a398aec2$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $fa12b390a398aec2$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $fa12b390a398aec2$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $fa12b390a398aec2$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $fa12b390a398aec2$var$nextPaths = /* @__PURE__ */ new Set();
var $fa12b390a398aec2$var$discoveredPathsMaxSize = 1e3;
var $fa12b390a398aec2$var$discoveredPaths = /* @__PURE__ */ new Set();
var $fa12b390a398aec2$var$URL_LIMIT = 7680;
function $fa12b390a398aec2$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $fa12b390a398aec2$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $fa12b390a398aec2$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $fa12b390a398aec2$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$fa12b390a398aec2$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($fa12b390a398aec2$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $fa12b390a398aec2$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $fa12b390a398aec2$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $fa12b390a398aec2$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$fa12b390a398aec2$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$fa12b390a398aec2$var$discoveredPaths.has(pathname)) $fa12b390a398aec2$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($fa12b390a398aec2$var$nextPaths.keys()).filter((path)=>{
                if ($fa12b390a398aec2$var$discoveredPaths.has(path)) {
                    $fa12b390a398aec2$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $fa12b390a398aec2$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $fa12b390a398aec2$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $fa12b390a398aec2$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $fa12b390a398aec2$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $fa12b390a398aec2$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $fa12b390a398aec2$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($fa12b390a398aec2$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $fa12b390a398aec2$var$URL_LIMIT) {
        $fa12b390a398aec2$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($fa12b390a398aec2$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($fa12b390a398aec2$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($fa12b390a398aec2$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$fa12b390a398aec2$var$addToFifoQueue(p, $fa12b390a398aec2$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $fa12b390a398aec2$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $fa12b390a398aec2$var$addToFifoQueue(path, queue) {
    if (queue.size >= $fa12b390a398aec2$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $fa12b390a398aec2$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $fa12b390a398aec2$var$useDataRouterContext2() {
    let context = $acw62.useContext($fa12b390a398aec2$export$2eeee58951ff3c1c);
    $fa12b390a398aec2$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $fa12b390a398aec2$var$useDataRouterStateContext() {
    let context = $acw62.useContext($fa12b390a398aec2$export$315e3ffb01f217);
    $fa12b390a398aec2$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $fa12b390a398aec2$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$fa12b390a398aec2$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $fa12b390a398aec2$var$useFrameworkContext() {
    let context = $acw62.useContext($fa12b390a398aec2$export$208d6a3bc3aa62bd);
    $fa12b390a398aec2$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $fa12b390a398aec2$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($fa12b390a398aec2$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $fa12b390a398aec2$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $fa12b390a398aec2$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $fa12b390a398aec2$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $fa12b390a398aec2$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $fa12b390a398aec2$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $fa12b390a398aec2$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $fa12b390a398aec2$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$fa12b390a398aec2$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $fa12b390a398aec2$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $fa12b390a398aec2$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $fa12b390a398aec2$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $fa12b390a398aec2$var$useDataRouterStateContext();
    let matches = $fa12b390a398aec2$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$fa12b390a398aec2$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$fa12b390a398aec2$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$fa12b390a398aec2$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$fa12b390a398aec2$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $fa12b390a398aec2$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $fa12b390a398aec2$var$useIsRSCRouterContext();
    let { router: router } = $fa12b390a398aec2$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$fa12b390a398aec2$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (rsc) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $fa12b390a398aec2$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $fa12b390a398aec2$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $fa12b390a398aec2$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $fa12b390a398aec2$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let { future: future } = $fa12b390a398aec2$var$useFrameworkContext();
    let { basename: basename } = $fa12b390a398aec2$var$useDataRouterContext2();
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $fa12b390a398aec2$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $fa12b390a398aec2$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $fa12b390a398aec2$var$useFrameworkContext();
    let { basename: basename } = $fa12b390a398aec2$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $fa12b390a398aec2$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$fa12b390a398aec2$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$fa12b390a398aec2$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $fa12b390a398aec2$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$fa12b390a398aec2$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $fa12b390a398aec2$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $fa12b390a398aec2$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $fa12b390a398aec2$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $fa12b390a398aec2$var$useDataRouterStateContext();
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let _matches = $fa12b390a398aec2$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$fa12b390a398aec2$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $fa12b390a398aec2$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $fa12b390a398aec2$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $fa12b390a398aec2$var$isHydrated = false;
function $fa12b390a398aec2$export$3be068dde909e563() {
    $fa12b390a398aec2$var$isHydrated = true;
}
function $fa12b390a398aec2$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $fa12b390a398aec2$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $fa12b390a398aec2$var$useDataRouterContext2();
    let { matches: routerMatches } = $fa12b390a398aec2$var$useDataRouterStateContext();
    let isRSCRouterContext = $fa12b390a398aec2$var$useIsRSCRouterContext();
    let enableFogOfWar = $fa12b390a398aec2$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $fa12b390a398aec2$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $fa12b390a398aec2$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $fa12b390a398aec2$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($fa12b390a398aec2$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $fa12b390a398aec2$var$isHydrated || isRSCRouterContext ? [] : $fa12b390a398aec2$var$dedupe(manifest.entry.imports.concat($fa12b390a398aec2$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $fa12b390a398aec2$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $fa12b390a398aec2$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $fa12b390a398aec2$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $fa12b390a398aec2$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $fa12b390a398aec2$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $fa12b390a398aec2$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($fa12b390a398aec2$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $fa12b390a398aec2$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $fa12b390a398aec2$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $fa12b390a398aec2$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$ff0bf87698939488, null) : null)));
}
var $fa12b390a398aec2$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($fa12b390a398aec2$var$isBrowser2) window.__reactRouterVersion = "7.14.2";
} catch (e) {}
function $fa12b390a398aec2$export$1f3f55432a00e06d(routes, opts) {
    return $fa12b390a398aec2$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $fa12b390a398aec2$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $fa12b390a398aec2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $fa12b390a398aec2$export$9269a41d8c4635e,
        hydrationRouteProperties: $fa12b390a398aec2$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $fa12b390a398aec2$export$1ba7ed8a3a7b3765(routes, opts) {
    return $fa12b390a398aec2$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $fa12b390a398aec2$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $fa12b390a398aec2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $fa12b390a398aec2$export$9269a41d8c4635e,
        hydrationRouteProperties: $fa12b390a398aec2$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $fa12b390a398aec2$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $fa12b390a398aec2$var$deserializeErrors(state.errors)
    };
    return state;
}
function $fa12b390a398aec2$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $fa12b390a398aec2$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $fa12b390a398aec2$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $fa12b390a398aec2$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $fa12b390a398aec2$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $fa12b390a398aec2$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $fa12b390a398aec2$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$fa12b390a398aec2$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $fa12b390a398aec2$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $fa12b390a398aec2$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $fa12b390a398aec2$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $fa12b390a398aec2$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $fa12b390a398aec2$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $fa12b390a398aec2$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $fa12b390a398aec2$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $fa12b390a398aec2$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $fa12b390a398aec2$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $fa12b390a398aec2$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$fa12b390a398aec2$export$a6c7ac8248d6e38a.displayName = "Link";
var $fa12b390a398aec2$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $fa12b390a398aec2$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($fa12b390a398aec2$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fa12b390a398aec2$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $fa12b390a398aec2$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$fa12b390a398aec2$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $fa12b390a398aec2$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $fa12b390a398aec2$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let submit = $fa12b390a398aec2$export$47c85c6e3a081d3();
    let formAction = $fa12b390a398aec2$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $fa12b390a398aec2$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$fa12b390a398aec2$export$a7fed597f4b8afd8.displayName = "Form";
function $fa12b390a398aec2$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($fa12b390a398aec2$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let matches = $fa12b390a398aec2$export$2378eb7f5ff86053();
    $fa12b390a398aec2$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $fa12b390a398aec2$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$fa12b390a398aec2$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $fa12b390a398aec2$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$fa12b390a398aec2$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$fa12b390a398aec2$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $fa12b390a398aec2$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $fa12b390a398aec2$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($fa12b390a398aec2$export$2eeee58951ff3c1c);
    $fa12b390a398aec2$export$f5708dca728d7177(ctx, $fa12b390a398aec2$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $fa12b390a398aec2$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($fa12b390a398aec2$export$315e3ffb01f217);
    $fa12b390a398aec2$export$f5708dca728d7177(state, $fa12b390a398aec2$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $fa12b390a398aec2$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $fa12b390a398aec2$export$9770f232ac06a008();
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let path = $fa12b390a398aec2$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($fa12b390a398aec2$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $fa12b390a398aec2$export$fe53371bee54353d(location) === $fa12b390a398aec2$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $fa12b390a398aec2$export$f1a78c17382fe22a(defaultInit) {
    $fa12b390a398aec2$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($fa12b390a398aec2$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fa12b390a398aec2$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $fa12b390a398aec2$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fa12b390a398aec2$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $fa12b390a398aec2$var$fetcherId = 0;
var $fa12b390a398aec2$var$getUniqueFetcherId = ()=>`__${String(++$fa12b390a398aec2$var$fetcherId)}__`;
function $fa12b390a398aec2$export$47c85c6e3a081d3() {
    let { router: router } = $fa12b390a398aec2$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let currentRouteId = $fa12b390a398aec2$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fa12b390a398aec2$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $fa12b390a398aec2$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $fa12b390a398aec2$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    $fa12b390a398aec2$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$fa12b390a398aec2$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $fa12b390a398aec2$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $fa12b390a398aec2$export$fe53371bee54353d(path);
}
function $fa12b390a398aec2$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $fa12b390a398aec2$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $fa12b390a398aec2$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($fa12b390a398aec2$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($fa12b390a398aec2$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $fa12b390a398aec2$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $fa12b390a398aec2$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $fa12b390a398aec2$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $fa12b390a398aec2$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $fa12b390a398aec2$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $fa12b390a398aec2$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $fa12b390a398aec2$export$fa996778a3a31087() {
    let state = $fa12b390a398aec2$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $fa12b390a398aec2$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fa12b390a398aec2$var$savedScrollPositions = {};
function $fa12b390a398aec2$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $fa12b390a398aec2$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $fa12b390a398aec2$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $fa12b390a398aec2$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fa12b390a398aec2$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($fa12b390a398aec2$export$3044ab7fdabeaee6);
    let location = $fa12b390a398aec2$export$45d76561a5302f2b();
    let matches = $fa12b390a398aec2$export$2378eb7f5ff86053();
    let navigation = $fa12b390a398aec2$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $fa12b390a398aec2$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $fa12b390a398aec2$var$getScrollRestorationKey(location, matches, basename, getKey);
            $fa12b390a398aec2$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fa12b390a398aec2$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fa12b390a398aec2$var$savedScrollPositions));
        } catch (error) {
            $fa12b390a398aec2$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fa12b390a398aec2$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fa12b390a398aec2$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($fa12b390a398aec2$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$fa12b390a398aec2$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $fa12b390a398aec2$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $fa12b390a398aec2$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $fa12b390a398aec2$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $fa12b390a398aec2$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $fa12b390a398aec2$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $fa12b390a398aec2$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($fa12b390a398aec2$export$3681f408decb40d1);
    $fa12b390a398aec2$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $fa12b390a398aec2$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $fa12b390a398aec2$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $fa12b390a398aec2$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $fa12b390a398aec2$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $fa12b390a398aec2$export$81336c211d5ff295(path.pathname, nextPath) != null || $fa12b390a398aec2$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $fa12b390a398aec2$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $fa12b390a398aec2$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $fa12b390a398aec2$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $fa12b390a398aec2$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $fa12b390a398aec2$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $fa12b390a398aec2$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $fa12b390a398aec2$var$serializeErrors(context.errors)
        };
        let json = $fa12b390a398aec2$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($fa12b390a398aec2$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $fa12b390a398aec2$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($fa12b390a398aec2$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $fa12b390a398aec2$var$getStatelessNavigator() {
    return {
        createHref: $fa12b390a398aec2$var$createHref,
        encodeLocation: $fa12b390a398aec2$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $fa12b390a398aec2$export$69163f0b72ec60d9(routes, opts) {
    return $fa12b390a398aec2$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $fa12b390a398aec2$export$9269a41d8c4635e
    });
}
function $fa12b390a398aec2$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $fa12b390a398aec2$export$87cb1a9238dc3fba(routes, $fa12b390a398aec2$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                unstable_passThroughRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $fa12b390a398aec2$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $fa12b390a398aec2$var$createHref,
        encodeLocation: $fa12b390a398aec2$var$encodeLocation,
        getFetcher () {
            return $fa12b390a398aec2$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $fa12b390a398aec2$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $fa12b390a398aec2$var$createHref(to) {
    return typeof to === "string" ? to : $fa12b390a398aec2$export$fe53371bee54353d(to);
}
function $fa12b390a398aec2$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $fa12b390a398aec2$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $fa12b390a398aec2$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $fa12b390a398aec2$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;









/**
 * Takes an array of [keyValue1, keyValue2] pairs and creates an object of {keyValue1: keyValue2, keyValue2: keyValue1}
 * @param {Array} array the array of pairs
 * @return {Object} the {key, value} pair object
 */ function $8124ab978dad7f97$export$2d1720544b23b823(array) {
    return array.reduce(function(obj, _ref) {
        var prop1 = _ref[0], prop2 = _ref[1];
        obj[prop1] = prop2;
        obj[prop2] = prop1;
        return obj;
    }, {});
}
function $8124ab978dad7f97$export$7ccc53e8f1e7dfc5(val) {
    return typeof val === 'boolean';
}
function $8124ab978dad7f97$export$ae1af26003f05816(val) {
    return typeof val === 'function';
}
function $8124ab978dad7f97$export$9e5f44173e64f162(val) {
    return typeof val === 'number';
}
function $8124ab978dad7f97$export$43caf9889c228507(val) {
    return val === null || typeof val === 'undefined';
}
function $8124ab978dad7f97$export$2408f22a0fab9ae5(val) {
    return val && typeof val === 'object';
}
function $8124ab978dad7f97$export$625550452a3fa3ec(val) {
    return typeof val === 'string';
}
function $8124ab978dad7f97$export$953cecd6e717a553(inclusive, inclusee) {
    return inclusive.indexOf(inclusee) !== -1;
}
/**
 * Flip the sign of a CSS value, possibly with a unit.
 *
 * We can't just negate the value with unary minus due to the units.
 *
 * @private
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example -77%)
 */ function $8124ab978dad7f97$export$342063e11d6c3cad(value) {
    if (parseFloat(value) === 0) // Don't mangle zeroes
    return value;
    if (value[0] === '-') return value.slice(1);
    return "-" + value;
}
function $8124ab978dad7f97$export$35e795649ee09318(match, prefix, offset, suffix) {
    return prefix + $8124ab978dad7f97$export$342063e11d6c3cad(offset) + suffix;
}
/**
 * Takes a percentage for background position and inverts it.
 * This was copied and modified from CSSJanus:
 * https://github.com/cssjanus/cssjanus/blob/4245f834365f6cfb0239191a151432fb85abab23/src/cssjanus.js#L152-L175
 * @param {String} value - the original value (for example 77%)
 * @return {String} the result (for example 23%)
 */ function $8124ab978dad7f97$export$dda1d9f60106f0e9(value) {
    var idx = value.indexOf('.');
    if (idx === -1) value = 100 - parseFloat(value) + "%";
    else {
        // Two off, one for the "%" at the end, one for the dot itself
        var len = value.length - idx - 2;
        value = 100 - parseFloat(value);
        value = value.toFixed(len) + "%";
    }
    return value;
}
/**
 * This takes a list of CSS values and converts it to an array
 * @param {String} value - something like `1px`, `1px 2em`, or `3pt rgb(150, 230, 550) 40px calc(100% - 5px)`
 * @return {Array} the split values (for example: `['3pt', 'rgb(150, 230, 550)', '40px', 'calc(100% - 5px)']`)
 */ function $8124ab978dad7f97$export$3b14a55fb2447963(value) {
    return value.replace(/ +/g, ' ') // remove all extraneous spaces
    .split(' ').map(function(i) {
        return i.trim();
    }) // get rid of extra space before/after each item
    .filter(Boolean) // get rid of empty strings
    // join items which are within parenthese
    // luckily `calc (100% - 5px)` is invalid syntax and it must be `calc(100% - 5px)`, otherwise this would be even more complex
    .reduce(function(_ref2, item) {
        var list = _ref2.list, state = _ref2.state;
        var openParansCount = (item.match(/\(/g) || []).length;
        var closedParansCount = (item.match(/\)/g) || []).length;
        if (state.parensDepth > 0) list[list.length - 1] = list[list.length - 1] + " " + item;
        else list.push(item);
        state.parensDepth += openParansCount - closedParansCount;
        return {
            list: list,
            state: state
        };
    }, {
        list: [],
        state: {
            parensDepth: 0
        }
    }).list;
}
/**
 * This is intended for properties that are `top right bottom left` and will switch them to `top left bottom right`
 * @param {String} value - `1px 2px 3px 4px` for example, but also handles cases where there are too few/too many and
 * simply returns the value in those cases (which is the correct behavior)
 * @return {String} the result - `1px 4px 3px 2px` for example.
 */ function $8124ab978dad7f97$export$882b5998b3b9117c(value) {
    var splitValues = $8124ab978dad7f97$export$3b14a55fb2447963(value);
    if (splitValues.length <= 3 || splitValues.length > 4) return value;
    var top = splitValues[0], right = splitValues[1], bottom = splitValues[2], left = splitValues[3];
    return [
        top,
        left,
        bottom,
        right
    ].join(' ');
}
/**
 *
 * @param {String|Number|Object} value css property value to test
 * @returns If the css property value can(should?) have an RTL equivalent
 */ function $8124ab978dad7f97$export$23f2a1d2818174ef(value) {
    return !$8124ab978dad7f97$export$7ccc53e8f1e7dfc5(value) && !$8124ab978dad7f97$export$43caf9889c228507(value);
}
/**
 * Splits a shadow style into its separate shadows using the comma delimiter, but creating an exception
 * for comma separated values in parentheses often used for rgba colours.
 * @param {String} value
 * @returns {Array} array of all box shadow values in the string
 */ function $8124ab978dad7f97$export$efccba1c4a2ef57b(value) {
    var shadows = [];
    var start = 0;
    var end = 0;
    var rgba = false;
    while(end < value.length){
        if (!rgba && value[end] === ',') {
            shadows.push(value.substring(start, end).trim());
            end++;
            start = end;
        } else if (value[end] === "(") {
            rgba = true;
            end++;
        } else if (value[end] === ')') {
            rgba = false;
            end++;
        } else end++;
    }
    // push the last shadow value if there is one
    // istanbul ignore next
    if (start != end) shadows.push(value.substring(start, end + 1));
    return shadows;
}
// some values require a little fudging, that fudging goes here.
var $8124ab978dad7f97$export$ffb5f4729a158638 = {
    padding: function padding(_ref) {
        var value = _ref.value;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        return $8124ab978dad7f97$export$882b5998b3b9117c(value);
    },
    textShadow: function textShadow(_ref2) {
        var value = _ref2.value;
        var flippedShadows = $8124ab978dad7f97$export$efccba1c4a2ef57b(value).map(function(shadow) {
            // intentionally leaving off the `g` flag here because we only want to change the first number (which is the offset-x)
            return shadow.replace(/(^|\s)(-*)([.|\d]+)/, function(match, whiteSpace, negative, number) {
                if (number === '0') return match;
                var doubleNegative = negative === '' ? '-' : '';
                return "" + whiteSpace + doubleNegative + number;
            });
        });
        return flippedShadows.join(',');
    },
    borderColor: function borderColor(_ref3) {
        var value = _ref3.value;
        return $8124ab978dad7f97$export$882b5998b3b9117c(value);
    },
    borderRadius: function borderRadius(_ref4) {
        var value = _ref4.value;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        if ($8124ab978dad7f97$export$953cecd6e717a553(value, '/')) {
            var _value$split = value.split('/'), radius1 = _value$split[0], radius2 = _value$split[1];
            var convertedRadius1 = $8124ab978dad7f97$export$ffb5f4729a158638.borderRadius({
                value: radius1.trim()
            });
            var convertedRadius2 = $8124ab978dad7f97$export$ffb5f4729a158638.borderRadius({
                value: radius2.trim()
            });
            return convertedRadius1 + " / " + convertedRadius2;
        }
        var splitValues = $8124ab978dad7f97$export$3b14a55fb2447963(value);
        switch(splitValues.length){
            case 2:
                return splitValues.reverse().join(' ');
            case 4:
                var topLeft = splitValues[0], topRight = splitValues[1], bottomRight = splitValues[2], bottomLeft = splitValues[3];
                return [
                    topRight,
                    topLeft,
                    bottomLeft,
                    bottomRight
                ].join(' ');
            default:
                return value;
        }
    },
    background: function background(_ref5) {
        var value = _ref5.value, valuesToConvert = _ref5.valuesToConvert, isRtl = _ref5.isRtl, bgImgDirectionRegex = _ref5.bgImgDirectionRegex, bgPosDirectionRegex = _ref5.bgPosDirectionRegex;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        // Yeah, this is in need of a refactor 🙃...
        // but this property is a tough cookie 🍪
        // get the backgroundPosition out of the string by removing everything that couldn't be the backgroundPosition value
        var backgroundPositionValue = value.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g, '').trim();
        // replace that backgroundPosition value with the converted version
        value = value.replace(backgroundPositionValue, $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition({
            value: backgroundPositionValue,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        }));
        // do the backgroundImage value replacing on the whole value (because why not?)
        return $8124ab978dad7f97$export$ffb5f4729a158638.backgroundImage({
            value: value,
            valuesToConvert: valuesToConvert,
            bgImgDirectionRegex: bgImgDirectionRegex
        });
    },
    backgroundImage: function backgroundImage(_ref6) {
        var value = _ref6.value, valuesToConvert = _ref6.valuesToConvert, bgImgDirectionRegex = _ref6.bgImgDirectionRegex;
        if (!$8124ab978dad7f97$export$953cecd6e717a553(value, 'url(') && !$8124ab978dad7f97$export$953cecd6e717a553(value, 'linear-gradient(')) return value;
        return value.replace(bgImgDirectionRegex, function(match, g1, group2) {
            return match.replace(group2, valuesToConvert[group2]);
        });
    },
    backgroundPosition: function backgroundPosition(_ref7) {
        var value = _ref7.value, valuesToConvert = _ref7.valuesToConvert, isRtl = _ref7.isRtl, bgPosDirectionRegex = _ref7.bgPosDirectionRegex;
        return value// intentionally only grabbing the first instance of this because that represents `left`
        .replace(isRtl ? /^((-|\d|\.)+%)/ : null, function(match, group) {
            return $8124ab978dad7f97$export$dda1d9f60106f0e9(group);
        }).replace(bgPosDirectionRegex, function(match) {
            return valuesToConvert[match];
        });
    },
    backgroundPositionX: function backgroundPositionX(_ref8) {
        var value = _ref8.value, valuesToConvert = _ref8.valuesToConvert, isRtl = _ref8.isRtl, bgPosDirectionRegex = _ref8.bgPosDirectionRegex;
        if ($8124ab978dad7f97$export$9e5f44173e64f162(value)) return value;
        return $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition({
            value: value,
            valuesToConvert: valuesToConvert,
            isRtl: isRtl,
            bgPosDirectionRegex: bgPosDirectionRegex
        });
    },
    transition: function transition(_ref9) {
        var value = _ref9.value, propertiesToConvert = _ref9.propertiesToConvert;
        return value.split(/,\s*/g).map(function(transition) {
            var values = transition.split(' ');
            // Property is always defined first
            values[0] = propertiesToConvert[values[0]] || values[0];
            return values.join(' ');
        }).join(', ');
    },
    transitionProperty: function transitionProperty(_ref10) {
        var value = _ref10.value, propertiesToConvert = _ref10.propertiesToConvert;
        return value.split(/,\s*/g).map(function(prop) {
            return propertiesToConvert[prop] || prop;
        }).join(', ');
    },
    transform: function transform(_ref11) {
        var value = _ref11.value;
        // This was copied and modified from CSSJanus:
        // https://github.com/cssjanus/cssjanus/blob/4a40f001b1ba35567112d8b8e1d9d95eda4234c3/src/cssjanus.js#L152-L153
        var nonAsciiPattern = "[^\\u0020-\\u007e]";
        var escapePattern = "(?:(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)|\\\\[^\\r\\n\\f0-9a-f])";
        var signedQuantPattern = "((?:-?" + ("(?:[0-9]*\\.[0-9]+|[0-9]+)(?:\\s*(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)|" + ("-?" + ("(?:[_a-z]|" + nonAsciiPattern + "|" + escapePattern + ")") + ("(?:[_a-z0-9-]|" + nonAsciiPattern + "|" + escapePattern + ")") + "*") + ")?") + ")|(?:inherit|auto))";
        var translateXRegExp = new RegExp("(translateX\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", 'gi');
        var translateRegExp = new RegExp("(translate\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,1}\\s*\\))", 'gi');
        var translate3dRegExp = new RegExp("(translate3d\\s*\\(\\s*)" + signedQuantPattern + "((?:\\s*,\\s*" + signedQuantPattern + "){0,2}\\s*\\))", 'gi');
        var rotateRegExp = new RegExp("(rotate[ZY]?\\s*\\(\\s*)" + signedQuantPattern + "(\\s*\\))", 'gi');
        return value.replace(translateXRegExp, $8124ab978dad7f97$export$35e795649ee09318).replace(translateRegExp, $8124ab978dad7f97$export$35e795649ee09318).replace(translate3dRegExp, $8124ab978dad7f97$export$35e795649ee09318).replace(rotateRegExp, $8124ab978dad7f97$export$35e795649ee09318);
    }
};
$8124ab978dad7f97$export$ffb5f4729a158638.objectPosition = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition;
$8124ab978dad7f97$export$ffb5f4729a158638.margin = $8124ab978dad7f97$export$ffb5f4729a158638.padding;
$8124ab978dad7f97$export$ffb5f4729a158638.borderWidth = $8124ab978dad7f97$export$ffb5f4729a158638.padding;
$8124ab978dad7f97$export$ffb5f4729a158638.boxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.mozBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.MozBoxShadow = $8124ab978dad7f97$export$ffb5f4729a158638.boxShadow;
$8124ab978dad7f97$export$ffb5f4729a158638.borderStyle = $8124ab978dad7f97$export$ffb5f4729a158638.borderColor;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransform = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransformOrigin = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransition = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638.webkitTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638.mozTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638.WebkitTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638.MozTransitionProperty = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
// kebab-case versions
$8124ab978dad7f97$export$ffb5f4729a158638['text-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['border-color'] = $8124ab978dad7f97$export$ffb5f4729a158638.borderColor;
$8124ab978dad7f97$export$ffb5f4729a158638['border-radius'] = $8124ab978dad7f97$export$ffb5f4729a158638.borderRadius;
$8124ab978dad7f97$export$ffb5f4729a158638['background-image'] = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundImage;
$8124ab978dad7f97$export$ffb5f4729a158638['background-position'] = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPosition;
$8124ab978dad7f97$export$ffb5f4729a158638['background-position-x'] = $8124ab978dad7f97$export$ffb5f4729a158638.backgroundPositionX;
$8124ab978dad7f97$export$ffb5f4729a158638['object-position'] = $8124ab978dad7f97$export$ffb5f4729a158638.objectPosition;
$8124ab978dad7f97$export$ffb5f4729a158638['border-width'] = $8124ab978dad7f97$export$ffb5f4729a158638.padding;
$8124ab978dad7f97$export$ffb5f4729a158638['box-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-box-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-box-shadow'] = $8124ab978dad7f97$export$ffb5f4729a158638.textShadow;
$8124ab978dad7f97$export$ffb5f4729a158638['border-style'] = $8124ab978dad7f97$export$ffb5f4729a158638.borderColor;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transform'] = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transform'] = $8124ab978dad7f97$export$ffb5f4729a158638.transform;
$8124ab978dad7f97$export$ffb5f4729a158638['transform-origin'] = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transform-origin'] = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transform-origin'] = $8124ab978dad7f97$export$ffb5f4729a158638.transformOrigin;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transition'] = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transition'] = $8124ab978dad7f97$export$ffb5f4729a158638.transition;
$8124ab978dad7f97$export$ffb5f4729a158638['transition-property'] = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638['-webkit-transition-property'] = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
$8124ab978dad7f97$export$ffb5f4729a158638['-moz-transition-property'] = $8124ab978dad7f97$export$ffb5f4729a158638.transitionProperty;
// this will be an object of properties that map to their corresponding rtl property (their doppelganger)
var $8124ab978dad7f97$export$407448d2b89b1813 = $8124ab978dad7f97$export$2d1720544b23b823([
    [
        'paddingLeft',
        'paddingRight'
    ],
    [
        'marginLeft',
        'marginRight'
    ],
    [
        'left',
        'right'
    ],
    [
        'borderLeft',
        'borderRight'
    ],
    [
        'borderLeftColor',
        'borderRightColor'
    ],
    [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    [
        'borderTopLeftRadius',
        'borderTopRightRadius'
    ],
    [
        'borderBottomLeftRadius',
        'borderBottomRightRadius'
    ],
    // kebab-case versions
    [
        'padding-left',
        'padding-right'
    ],
    [
        'margin-left',
        'margin-right'
    ],
    [
        'border-left',
        'border-right'
    ],
    [
        'border-left-color',
        'border-right-color'
    ],
    [
        'border-left-style',
        'border-right-style'
    ],
    [
        'border-left-width',
        'border-right-width'
    ],
    [
        'border-top-left-radius',
        'border-top-right-radius'
    ],
    [
        'border-bottom-left-radius',
        'border-bottom-right-radius'
    ]
]);
var $8124ab978dad7f97$export$8b22cf2602fb60ce = [
    'content'
];
// this is the same as the propertiesToConvert except for values
var $8124ab978dad7f97$export$90a7f3efeed30595 = $8124ab978dad7f97$export$2d1720544b23b823([
    [
        'ltr',
        'rtl'
    ],
    [
        'left',
        'right'
    ],
    [
        'w-resize',
        'e-resize'
    ],
    [
        'sw-resize',
        'se-resize'
    ],
    [
        'nw-resize',
        'ne-resize'
    ]
]);
// Sorry for the regex 😞, but basically thisis used to replace _every_ instance of
// `ltr`, `rtl`, `right`, and `left` in `backgroundimage` with the corresponding opposite.
// A situation we're accepting here:
// url('/left/right/rtl/ltr.png') will be changed to url('/right/left/ltr/rtl.png')
// Definite trade-offs here, but I think it's a good call.
var $8124ab978dad7f97$var$bgImgDirectionRegex = new RegExp('(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)', 'g');
var $8124ab978dad7f97$var$bgPosDirectionRegex = new RegExp('(left)|(right)');
/**
 * converts properties and values in the CSS in JS object to their corresponding RTL values
 * @param {Object} object the CSS in JS object
 * @return {Object} the RTL converted object
 */ function $8124ab978dad7f97$export$db3b6bfb95261072(object) {
    return Object.keys(object).reduce(function(newObj, originalKey) {
        var originalValue = object[originalKey];
        if ($8124ab978dad7f97$export$625550452a3fa3ec(originalValue)) // you're welcome to later code 😺
        originalValue = originalValue.trim();
        // Some properties should never be transformed
        if ($8124ab978dad7f97$export$953cecd6e717a553($8124ab978dad7f97$export$8b22cf2602fb60ce, originalKey)) {
            newObj[originalKey] = originalValue;
            return newObj;
        }
        var _convertProperty = $8124ab978dad7f97$export$4368d992c4eafac0(originalKey, originalValue), key = _convertProperty.key, value = _convertProperty.value;
        newObj[key] = value;
        return newObj;
    }, Array.isArray(object) ? [] : {});
}
/**
 * Converts a property and its value to the corresponding RTL key and value
 * @param {String} originalKey the original property key
 * @param {Number|String|Object} originalValue the original css property value
 * @return {Object} the new {key, value} pair
 */ function $8124ab978dad7f97$export$4368d992c4eafac0(originalKey, originalValue) {
    var isNoFlip = /\/\*\s?@noflip\s?\*\//.test(originalValue);
    var key = isNoFlip ? originalKey : $8124ab978dad7f97$export$39b482c5e57630a8(originalKey);
    var value = isNoFlip ? originalValue : $8124ab978dad7f97$export$f1e1789686576879(key, originalValue);
    return {
        key: key,
        value: value
    };
}
/**
 * This gets the RTL version of the given property if it has a corresponding RTL property
 * @param {String} property the name of the property
 * @return {String} the name of the RTL property
 */ function $8124ab978dad7f97$export$39b482c5e57630a8(property) {
    return $8124ab978dad7f97$export$407448d2b89b1813[property] || property;
}
/**
 * This converts the given value to the RTL version of that value based on the key
 * @param {String} key this is the key (note: this should be the RTL version of the originalKey)
 * @param {String|Number|Object} originalValue the original css property value. If it's an object, then we'll convert that as well
 * @return {String|Number|Object} the converted value
 */ function $8124ab978dad7f97$export$f1e1789686576879(key, originalValue) {
    if (!$8124ab978dad7f97$export$23f2a1d2818174ef(originalValue)) return originalValue;
    if ($8124ab978dad7f97$export$2408f22a0fab9ae5(originalValue)) return $8124ab978dad7f97$export$db3b6bfb95261072(originalValue); // recursion 🌀
    var isNum = $8124ab978dad7f97$export$9e5f44173e64f162(originalValue);
    var isFunc = $8124ab978dad7f97$export$ae1af26003f05816(originalValue);
    var importantlessValue = isNum || isFunc ? originalValue : originalValue.replace(/ !important.*?$/, '');
    var isImportant = !isNum && importantlessValue.length !== originalValue.length;
    var valueConverter = $8124ab978dad7f97$export$ffb5f4729a158638[key];
    var newValue;
    if (valueConverter) newValue = valueConverter({
        value: importantlessValue,
        valuesToConvert: $8124ab978dad7f97$export$90a7f3efeed30595,
        propertiesToConvert: $8124ab978dad7f97$export$407448d2b89b1813,
        isRtl: true,
        bgImgDirectionRegex: $8124ab978dad7f97$var$bgImgDirectionRegex,
        bgPosDirectionRegex: $8124ab978dad7f97$var$bgPosDirectionRegex
    });
    else newValue = $8124ab978dad7f97$export$90a7f3efeed30595[importantlessValue] || importantlessValue;
    if (isImportant) return newValue + " !important";
    return newValue;
}





const $c3c3aaaa11557c17$var$uppercasePattern = /[A-Z]/g;
const $c3c3aaaa11557c17$var$msPattern = /^ms-/;
const $c3c3aaaa11557c17$var$cache = {};
function $c3c3aaaa11557c17$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $c3c3aaaa11557c17$export$b018cf9acdc350de(name) {
    if (Object.prototype.hasOwnProperty.call($c3c3aaaa11557c17$var$cache, name)) return $c3c3aaaa11557c17$var$cache[name];
    if (name.substr(0, 2) === '--') return name;
    const hName = name.replace($c3c3aaaa11557c17$var$uppercasePattern, $c3c3aaaa11557c17$var$toHyphenLower);
    return $c3c3aaaa11557c17$var$cache[name] = $c3c3aaaa11557c17$var$msPattern.test(hName) ? '-' + hName : hName;
}


function $cc56a90498587e19$export$bdc4d18748ef5f7c(nestedProperty) {
    if (nestedProperty.charAt(0) === '&') return nestedProperty.slice(1);
    return nestedProperty;
}


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var k = 0;
    var g = 0;
    var $ = "";
    var x = n;
    var y = s;
    var j = c;
    var z = $;
    while(w)switch(b = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) k++, z += "(";
            else z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 41:
            k--, z += ")";
            break;
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            if (k > 0) {
                z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g);
                break;
            }
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($298fb931ed4fbf8b$export$9e1725a4cfeada27(b || 1) == 5 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e() || 1) == 5) && $298fb931ed4fbf8b$export$36776f635604f274(z) && $298fb931ed4fbf8b$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            if (k > 0 && g) {
                z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g);
                break;
            }
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($298fb931ed4fbf8b$export$36776f635604f274(z) - l || h === 0)) $298fb931ed4fbf8b$export$10d8903dec122b9d(v > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, n, u, $, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, c && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, $, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, $ = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    if (k > 0) break;
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    p = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274($ = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, k = 0; w < c; ++w)for(var g = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; g < h; ++g)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? b[g] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, b[g]))) f[k++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, c, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, c), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(c, n, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(c, n)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c + (s = s[n].value), "span") ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(c) - 1 - n > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, $298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$6aad947bda0f3f46:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                c.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (c.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}



const $0cb269731df364bf$export$4b797d4a552868c4 = (element)=>{
    switch(element.type){
        case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (typeof element.props === 'string') return;
            element.props = element.props.map((value)=>{
                // Avoids calling tokenize() on every string
                if (value.indexOf(':global(') === -1) return value;
                return (0, $298fb931ed4fbf8b$export$660b2ee2d4fb4eff)(value).reduce((acc, value, index, children)=>{
                    if (value === '') return acc;
                    if (value === ':' && children[index + 1] === 'global') {
                        const selector = // An inner part of ":global()"
                        children[index + 2].slice(1, -1) + // A separator between selectors i.e. "body .class"
                        ' ';
                        acc.unshift(selector);
                        children[index + 1] = '';
                        children[index + 2] = '';
                        return acc;
                    }
                    acc.push(value);
                    return acc;
                }, []).join('');
            });
    }
};



/* eslint-disable no-fallthrough */ function $9efc9f281175e583$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // backface-visibility, column, box-decoration-break
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // backdrop-filter, background-clip: text
        case 4215:
            // Additional check on "backdrop-(f)ilter" to prevent conflict with "background-clip"
            // https://github.com/thysultan/stylis/issues/292
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 9) === 102) return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
            // background-clip: text
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) === 116) return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
            break;
        // tab-size
        case 4789:
            return (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, hyphens
        case 5349:
        case 4246:
        case 6968:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + value;
        // cursor
        // @ts-expect-error fall through is intentional here
        case 6187:
            if (!(0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /grab/)) return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            // eslint-disable-next-line no-useless-concat
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (f)ill-available
                // @ts-expect-error fall through is intentional here
                case 102:
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) === 108) return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, // eslint-disable-next-line no-useless-concat, eqeqeq
                    '$1' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, 'stretch') ? $9efc9f281175e583$export$82e9f45cca5ba907((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
    }
    return value;
}
/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */ function $9efc9f281175e583$export$b37893ebcaedd06f(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element.return = $9efc9f281175e583$export$82e9f45cca5ba907(element.value, element.length);
                return;
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            [
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
    return undefined;
}



function $f5800bc7425a015e$export$300e9014dd2d454e(element) {
    switch(element.type){
        case '@container':
        case 0, $298fb931ed4fbf8b$export$500415a86c544f73:
        case 0, $298fb931ed4fbf8b$export$9447a5efea57e862:
        case 0, $298fb931ed4fbf8b$export$d773506282b3cfe6:
            return true;
    }
    return false;
}


const $821552ba532d4d38$export$6b44e6671983a6cc = (element)=>{
    if ((0, $f5800bc7425a015e$export$300e9014dd2d454e)(element) && Array.isArray(element.children)) element.children.sort((a, b)=>a.props[0] > b.props[0] ? 1 : -1);
};


// eslint-disable-next-line @typescript-eslint/no-empty-function
function $0c9e2268128b35f0$var$noop() {}
function $0c9e2268128b35f0$export$82c0c9be22f7de4(cssRules, sortClassesInAtRules) {
    const rules = [];
    (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(cssRules), (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)([
        (0, $0cb269731df364bf$export$4b797d4a552868c4),
        sortClassesInAtRules ? (0, $821552ba532d4d38$export$6b44e6671983a6cc) : $0c9e2268128b35f0$var$noop,
        (0, $9efc9f281175e583$export$b37893ebcaedd06f),
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        // 💡 we are using `.insertRule()` API for DOM operations, which does not support
        // insertion of multiple CSS rules in a single call. `rulesheet` plugin extracts
        // individual rules to be used with this API
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)((rule)=>rules.push(rule))
    ]));
    return rules;
}


const $e3ec89946ed04bb5$var$PSEUDO_SELECTOR_REGEX = /,( *[^ &])/g;
/**
 * Normalizes pseudo selectors to always contain &, requires to work properly with comma-separated selectors.
 *
 * @example
 *   ":hover" => "&:hover"
 *   " :hover" => "& :hover"
 *   ":hover,:focus" => "&:hover,&:focus"
 *   " :hover, :focus" => "& :hover,& :focus"
 */ function $e3ec89946ed04bb5$export$db1b8f954c59ac44(pseudoSelector) {
    return '&' + (0, $cc56a90498587e19$export$bdc4d18748ef5f7c)(// Regex there replaces a comma, spaces and an ampersand if it's present with comma and an ampersand.
    // This allows to normalize input, see examples in JSDoc.
    pseudoSelector.replace($e3ec89946ed04bb5$var$PSEUDO_SELECTOR_REGEX, ',&$1'));
}
function $e3ec89946ed04bb5$var$createCSSRule(classNameSelector, cssDeclaration, pseudos) {
    let cssRule = cssDeclaration;
    if (pseudos.length > 0) cssRule = pseudos.reduceRight((acc, selector)=>{
        return `${$e3ec89946ed04bb5$export$db1b8f954c59ac44(selector)} { ${acc} }`;
    }, cssDeclaration);
    return `${classNameSelector}{${cssRule}}`;
}
function $e3ec89946ed04bb5$export$33a9e446f13f0fb6(options, atRules) {
    const { className: className, selectors: selectors, property: property, rtlClassName: rtlClassName, rtlProperty: rtlProperty, rtlValue: rtlValue, value: value } = options;
    const { container: container, layer: layer, media: media, supports: supports } = atRules;
    const classNameSelector = `.${className}`;
    const cssDeclaration = Array.isArray(value) ? `${value.map((v)=>`${(0, $c3c3aaaa11557c17$export$b018cf9acdc350de)(property)}: ${v}`).join(';')};` : `${(0, $c3c3aaaa11557c17$export$b018cf9acdc350de)(property)}: ${value};`;
    let cssRule = $e3ec89946ed04bb5$var$createCSSRule(classNameSelector, cssDeclaration, selectors);
    if (rtlProperty && rtlClassName) {
        const rtlClassNameSelector = `.${rtlClassName}`;
        const rtlCSSDeclaration = Array.isArray(rtlValue) ? `${rtlValue.map((v)=>`${(0, $c3c3aaaa11557c17$export$b018cf9acdc350de)(rtlProperty)}: ${v}`).join(';')};` : `${(0, $c3c3aaaa11557c17$export$b018cf9acdc350de)(rtlProperty)}: ${rtlValue};`;
        cssRule += $e3ec89946ed04bb5$var$createCSSRule(rtlClassNameSelector, rtlCSSDeclaration, selectors);
    }
    if (media) cssRule = `@media ${media} { ${cssRule} }`;
    if (layer) cssRule = `@layer ${layer} { ${cssRule} }`;
    if (supports) cssRule = `@supports ${supports} { ${cssRule} }`;
    if (container) cssRule = `@container ${container} { ${cssRule} }`;
    return (0, $0c9e2268128b35f0$export$82c0c9be22f7de4)(cssRule, true);
}





function $226eab2317de3f43$export$38e49227307c669b(style) {
    let css = '';
    // eslint-disable-next-line guard-for-in
    for(const property in style){
        const value = style[property];
        if (typeof value === 'string' || typeof value === 'number') {
            css += (0, $c3c3aaaa11557c17$export$b018cf9acdc350de)(property) + ':' + value + ';';
            continue;
        }
        if (Array.isArray(value)) for (const arrValue of value)css += (0, $c3c3aaaa11557c17$export$b018cf9acdc350de)(property) + ':' + arrValue + ';';
    }
    return css;
}


function $2be2fc9bf80c2abb$export$f063294709aee23a(keyframeObject) {
    let css = '';
    // eslint-disable-next-line guard-for-in
    for(const percentage in keyframeObject)css += `${percentage}{${(0, $226eab2317de3f43$export$38e49227307c669b)(keyframeObject[percentage])}}`;
    return css;
}
/**
 * Creates CSS rules for insertion from passed CSS.
 */ function $2be2fc9bf80c2abb$export$50cb7050c6244400(keyframeName, keyframeCSS) {
    const cssRule = `@keyframes ${keyframeName} {${keyframeCSS}}`;
    const rules = [];
    (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(cssRule), (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)([
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $9efc9f281175e583$export$b37893ebcaedd06f),
        // 💡 we are using `.insertRule()` API for DOM operations, which does not support
        // insertion of multiple CSS rules in a single call. `rulesheet` plugin extracts
        // individual rules to be used with this API
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)((rule)=>rules.push(rule))
    ]));
    return rules;
}


const $0b6f5fffda9b3666$export$648f2124b45d7105 = {
    animation: [
        -1,
        [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimeline',
            'animationTimingFunction'
        ]
    ],
    animationRange: [
        -1,
        [
            'animationRangeEnd',
            'animationRangeStart'
        ]
    ],
    background: [
        -2,
        [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPosition',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ]
    ],
    backgroundPosition: [
        -1,
        [
            'backgroundPositionX',
            'backgroundPositionY'
        ]
    ],
    border: [
        -2,
        [
            'borderBottom',
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderLeft',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRight',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTop',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ]
    ],
    borderBottom: [
        -1,
        [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ]
    ],
    borderImage: [
        -1,
        [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ]
    ],
    borderLeft: [
        -1,
        [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ]
    ],
    borderRadius: [
        -1,
        [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ]
    ],
    borderRight: [
        -1,
        [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ]
    ],
    borderTop: [
        -1,
        [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ]
    ],
    caret: [
        -1,
        [
            'caretColor',
            'caretShape'
        ]
    ],
    columnRule: [
        -1,
        [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ]
    ],
    columns: [
        -1,
        [
            'columnCount',
            'columnWidth'
        ]
    ],
    containIntrinsicSize: [
        -1,
        [
            'containIntrinsicHeight',
            'containIntrinsicWidth'
        ]
    ],
    container: [
        -1,
        [
            'containerName',
            'containerType'
        ]
    ],
    flex: [
        -1,
        [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ]
    ],
    flexFlow: [
        -1,
        [
            'flexDirection',
            'flexWrap'
        ]
    ],
    font: [
        -1,
        [
            'fontFamily',
            'fontSize',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontWeight',
            'lineHeight'
        ]
    ],
    gap: [
        -1,
        [
            'columnGap',
            'rowGap'
        ]
    ],
    grid: [
        -1,
        [
            'columnGap',
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridColumnGap',
            'gridRowGap',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows',
            'rowGap'
        ]
    ],
    gridArea: [
        -1,
        [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ]
    ],
    gridColumn: [
        -1,
        [
            'gridColumnEnd',
            'gridColumnStart'
        ]
    ],
    gridRow: [
        -1,
        [
            'gridRowEnd',
            'gridRowStart'
        ]
    ],
    gridTemplate: [
        -1,
        [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ]
    ],
    inset: [
        -1,
        [
            'bottom',
            'left',
            'right',
            'top'
        ]
    ],
    insetBlock: [
        -1,
        [
            'insetBlockEnd',
            'insetBlockStart'
        ]
    ],
    insetInline: [
        -1,
        [
            'insetInlineEnd',
            'insetInlineStart'
        ]
    ],
    listStyle: [
        -1,
        [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ]
    ],
    margin: [
        -1,
        [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ]
    ],
    marginBlock: [
        -1,
        [
            'marginBlockEnd',
            'marginBlockStart'
        ]
    ],
    marginInline: [
        -1,
        [
            'marginInlineEnd',
            'marginInlineStart'
        ]
    ],
    mask: [
        -1,
        [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPosition',
            'maskRepeat',
            'maskSize'
        ]
    ],
    maskBorder: [
        -1,
        [
            'maskBorderMode',
            'maskBorderOutset',
            'maskBorderRepeat',
            'maskBorderSlice',
            'maskBorderSource',
            'maskBorderWidth'
        ]
    ],
    offset: [
        -1,
        [
            'offsetAnchor',
            'offsetDistance',
            'offsetPath',
            'offsetPosition',
            'offsetRotate'
        ]
    ],
    outline: [
        -1,
        [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ]
    ],
    overflow: [
        -1,
        [
            'overflowX',
            'overflowY'
        ]
    ],
    overscrollBehavior: [
        -1,
        [
            'overscrollBehaviorX',
            'overscrollBehaviorY'
        ]
    ],
    padding: [
        -1,
        [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ]
    ],
    paddingBlock: [
        -1,
        [
            'paddingBlockEnd',
            'paddingBlockStart'
        ]
    ],
    paddingInline: [
        -1,
        [
            'paddingInlineEnd',
            'paddingInlineStart'
        ]
    ],
    placeContent: [
        -1,
        [
            'alignContent',
            'justifyContent'
        ]
    ],
    placeItems: [
        -1,
        [
            'alignItems',
            'justifyItems'
        ]
    ],
    placeSelf: [
        -1,
        [
            'alignSelf',
            'justifySelf'
        ]
    ],
    scrollMargin: [
        -1,
        [
            'scrollMarginBottom',
            'scrollMarginLeft',
            'scrollMarginRight',
            'scrollMarginTop'
        ]
    ],
    scrollMarginBlock: [
        -1,
        [
            'scrollMarginBlockEnd',
            'scrollMarginBlockStart'
        ]
    ],
    scrollMarginInline: [
        -1,
        [
            'scrollMarginInlineEnd',
            'scrollMarginInlineStart'
        ]
    ],
    scrollPadding: [
        -1,
        [
            'scrollPaddingBottom',
            'scrollPaddingLeft',
            'scrollPaddingRight',
            'scrollPaddingTop'
        ]
    ],
    scrollPaddingBlock: [
        -1,
        [
            'scrollPaddingBlockEnd',
            'scrollPaddingBlockStart'
        ]
    ],
    scrollPaddingInline: [
        -1,
        [
            'scrollPaddingInlineEnd',
            'scrollPaddingInlineStart'
        ]
    ],
    scrollTimeline: [
        -1,
        [
            'scrollTimelineAxis',
            'scrollTimelineName'
        ]
    ],
    textDecoration: [
        -1,
        [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle',
            'textDecorationThickness'
        ]
    ],
    textEmphasis: [
        -1,
        [
            'textEmphasisColor',
            'textEmphasisStyle'
        ]
    ],
    transition: [
        -1,
        [
            'transitionBehavior',
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ]
    ],
    viewTimeline: [
        -1,
        [
            'viewTimelineAxis',
            'viewTimelineName'
        ]
    ]
};


function $8647664170f974d1$export$9f1ed25614266b04(currentMediaQuery, nestedMediaQuery) {
    if (currentMediaQuery.length === 0) return nestedMediaQuery;
    return `${currentMediaQuery} and ${nestedMediaQuery}`;
}


function $5e79e88e3cd41b55$export$685119d24577daa(property) {
    return property.substr(0, 6) === '@media';
}


function $c82621a28c600955$export$1f8685537590b231(property) {
    return property.substr(0, 6) === '@layer';
}


const $91df032bfb87c4a2$var$regex = /^(:|\[|>|&)/;
function $91df032bfb87c4a2$export$6ec9da58e818601b(property) {
    return $91df032bfb87c4a2$var$regex.test(property);
}


function $10f00de62ad97c9c$export$f6f4ace31eaf7c98(property) {
    return property.substr(0, 9) === '@supports';
}


function $6d03dc00daa00702$export$7648458cb39ca9d9(property) {
    return property.substring(0, 10) === '@container';
}



// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a4b00e389e13d348$export$a6cdc56e425d0d0a(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
}


/**
 * Maps the long pseudo name to the short pseudo name. Pseudos that match here will be ordered, everything else will
 * make their way to default style bucket. We reduce the pseudo name to save bundlesize.
 * Thankfully there aren't any overlaps, see: https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes.
 */ const $5016c4763fa89385$var$pseudosMap = {
    // :focus-within
    'us-w': 'w',
    // :focus-visible
    'us-v': 'i',
    // :link
    nk: 'l',
    // :visited
    si: 'v',
    // :focus
    cu: 'f',
    // :hover
    ve: 'h',
    // :active
    ti: 'a'
};
/**
 * Gets the bucket depending on the pseudo.
 *
 * Input:
 *
 * ```
 * ":hover"
 * ":focus:hover"
 * ```
 *
 * Output:
 *
 * ```
 * "h"
 * "f"
 * ```
 *
 * @internal
 */ function $5016c4763fa89385$export$d90f6836ea1aee93(selectors, atRules) {
    if (atRules.media) return 'm';
    // We are grouping all the at-rules like @supports etc. under `t` bucket.
    if (atRules.layer || atRules.supports) return 't';
    if (atRules.container) return 'c';
    if (selectors.length > 0) {
        const normalizedPseudo = selectors[0].trim();
        if (normalizedPseudo.charCodeAt(0) === 58 /* ":" */ ) // We send through a subset of the string instead of the full pseudo name.
        // For example:
        // - `"focus-visible"` name would instead of `"us-v"`.
        // - `"focus"` name would instead of `"us"`.
        // Return a mapped pseudo else default bucket.
        return $5016c4763fa89385$var$pseudosMap[normalizedPseudo.slice(4, 8)] || $5016c4763fa89385$var$pseudosMap[normalizedPseudo.slice(3, 5)] || 'd';
    }
    // Return default bucket
    return 'd';
}





function $d4a02a095ab36648$var$addAtRulePrefix(atRule, prefix) {
    return atRule ? prefix + atRule : atRule;
}
function $d4a02a095ab36648$export$c315e960bf1b31dd(atRules) {
    return $d4a02a095ab36648$var$addAtRulePrefix(atRules.container, 'c') + $d4a02a095ab36648$var$addAtRulePrefix(atRules.media, 'm') + $d4a02a095ab36648$var$addAtRulePrefix(atRules.layer, 'l') + $d4a02a095ab36648$var$addAtRulePrefix(atRules.supports, 's');
}
function $d4a02a095ab36648$export$d78eef92bb01743f(selector, property, atRules) {
    // uniq key based on property & selector, used for merging later
    const computedKey = selector + $d4a02a095ab36648$export$c315e960bf1b31dd(atRules) + property;
    // "key" can be really long as it includes selectors, we use hashes to reduce sizes of keys
    // ".foo :hover" => "abcd"
    const hashedKey = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(computedKey);
    // As these hashes are used as object keys in build output we should avoid having numbers as a first character to
    // avoid having quotes:
    // {
    //   "1abc": {}, // we don't want this
    //   Aabc: {}, // no quotes
    // }
    const firstCharCode = hashedKey.charCodeAt(0);
    const startsWithNumber = firstCharCode >= 48 && firstCharCode <= 57;
    if (startsWithNumber) return String.fromCharCode(firstCharCode + 17) + hashedKey.slice(1);
    return hashedKey;
}


function $36fed63972b92c26$export$2868bfa6c4652df6({ property: property, selector: selector, salt: salt, value: value }, atRules) {
    return (0, $1708e11ed21e9e34$export$fdd4f86041cc97c0) + (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(salt + selector + (0, $d4a02a095ab36648$export$c315e960bf1b31dd)(atRules) + property + // Trimming of value is required to generate consistent hashes
    value.trim());
}




function $80b56f19a60265df$export$6bdeee5c8de376c6(value) {
    return value === (0, $1708e11ed21e9e34$export$4a991c87e640ef77);
}


/**
 * Trims selectors to generate consistent hashes.
 */ function $f112d2144666e15a$export$5ba174c10f60bb93(selector) {
    return selector.replace(/>\s+/g, '>');
}


function $b13dd1085a68b759$export$58da9968c3170cb1(...args) {}


function $4626b6f2f5e30665$export$b0df042dbc0a42f9(property, value) {
    const message = /*#__PURE__*/ (()=>{
        const ruleText = JSON.stringify(value, null, 2);
        const message = [
            "@griffel/react: A rule was not resolved to CSS properly. Please check your `makeStyles` or `makeResetStyles` calls for following:",
            ' '.repeat(2) + 'makeStyles({',
            ' '.repeat(4) + `[slot]: {`,
            ' '.repeat(6) + `"${property}": ${ruleText.split('\n').map((l, n)=>' '.repeat(n === 0 ? 0 : 6) + l).join('\n')}`,
            ' '.repeat(4) + '}',
            ' '.repeat(2) + `})`,
            ''
        ];
        if (property.indexOf('&') === -1) {
            message.push(`It looks that you're are using a nested selector, but it is missing an ampersand placeholder where the generated class name should be injected.`);
            message.push(`Try to update a property to include it i.e "${property}" => "&${property}".`);
        } else {
            message.push('');
            message.push("If it's not obvious what triggers a problem, please report an issue at https://github.com/microsoft/griffel/issues");
        }
        return message.join('\n');
    })();
    (0, $b13dd1085a68b759$export$58da9968c3170cb1)(message);
}



function $3edac670aac8a367$export$e9954ed78017002c(property, value) {
    const message = /*#__PURE__*/ (()=>[
            `@griffel/react: You are using unsupported shorthand CSS property "${property}". ` + `Please check your "makeStyles" calls, there *should not* be following:`,
            ' '.repeat(2) + `makeStyles({`,
            ' '.repeat(4) + `[slot]: { ${property}: "${value}" }`,
            ' '.repeat(2) + `})`,
            '',
            'Learn why CSS shorthands are not supported: https://aka.ms/griffel-css-shorthands'
        ].join('\n'))();
    (0, $b13dd1085a68b759$export$58da9968c3170cb1)(message);
}


function $4d4b51fea020f8c3$var$getShorthandDefinition(property) {
    return (0, $0b6f5fffda9b3666$export$648f2124b45d7105)[property];
}
function $4d4b51fea020f8c3$var$computePropertyPriority(shorthand) {
    var _a;
    return (_a = shorthand === null || shorthand === void 0 ? void 0 : shorthand[0]) !== null && _a !== void 0 ? _a : 0;
}
function $4d4b51fea020f8c3$var$pushToClassesMap(classesMap, propertyKey, ltrClassname, rtlClassname) {
    classesMap[propertyKey] = rtlClassname ? [
        ltrClassname,
        rtlClassname
    ] : ltrClassname;
}
function $4d4b51fea020f8c3$var$createBucketEntry(cssRule, metadata) {
    if (metadata.length > 0) return [
        cssRule,
        Object.fromEntries(metadata)
    ];
    return cssRule;
}
function $4d4b51fea020f8c3$var$pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, media, priority) {
    var _a;
    const metadata = [];
    if (priority !== 0) metadata.push([
        'p',
        priority
    ]);
    if (styleBucketName === 'm' && media) metadata.push([
        'm',
        media
    ]);
    (_a = cssRulesByBucket[styleBucketName]) !== null && _a !== void 0 ? _a : cssRulesByBucket[styleBucketName] = [];
    if (ltrCSS) cssRulesByBucket[styleBucketName].push($4d4b51fea020f8c3$var$createBucketEntry(ltrCSS, metadata));
    if (rtlCSS) cssRulesByBucket[styleBucketName].push($4d4b51fea020f8c3$var$createBucketEntry(rtlCSS, metadata));
}
/**
 * Transforms input styles to classes maps & CSS rules.
 *
 * @internal
 */ function $4d4b51fea020f8c3$export$15fe91a57d59741(styles, classNameHashSalt = '', selectors = [], atRules = {
    container: '',
    layer: '',
    media: '',
    supports: ''
}, cssClassesMap = {}, cssRulesByBucket = {}, rtlValue) {
    // eslint-disable-next-line guard-for-in
    for(const property in styles){
        // eslint-disable-next-line no-prototype-builtins
        if ((0, $1708e11ed21e9e34$export$77c0d61648307b86).hasOwnProperty(property)) {
            (0, $3edac670aac8a367$export$e9954ed78017002c)(property, styles[property]);
            continue;
        }
        const value = styles[property];
        // eslint-disable-next-line eqeqeq
        if (value == null) continue;
        if ((0, $80b56f19a60265df$export$6bdeee5c8de376c6)(value)) {
            const selector = (0, $f112d2144666e15a$export$5ba174c10f60bb93)(selectors.join(''));
            // uniq key based on a hash of property & selector, used for merging later
            const key = (0, $d4a02a095ab36648$export$d78eef92bb01743f)(selector, property, atRules);
            $4d4b51fea020f8c3$var$pushToClassesMap(cssClassesMap, key, 0, undefined);
            continue;
        }
        if (typeof value === 'string' || typeof value === 'number') {
            const selector = (0, $f112d2144666e15a$export$5ba174c10f60bb93)(selectors.join(''));
            const shorthand = $4d4b51fea020f8c3$var$getShorthandDefinition(property);
            if (shorthand) {
                const shorthandProperties = shorthand[1];
                const shorthandResetStyles = Object.fromEntries(shorthandProperties.map((property)=>[
                        property,
                        (0, $1708e11ed21e9e34$export$4a991c87e640ef77)
                    ]));
                $4d4b51fea020f8c3$export$15fe91a57d59741(shorthandResetStyles, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket);
            }
            // uniq key based on a hash of property & selector, used for merging later
            const key = (0, $d4a02a095ab36648$export$d78eef92bb01743f)(selector, property, atRules);
            const className = (0, $36fed63972b92c26$export$2868bfa6c4652df6)({
                value: value.toString(),
                salt: classNameHashSalt,
                selector: selector,
                property: property
            }, atRules);
            const rtlDefinition = rtlValue && {
                key: property,
                value: rtlValue
            } || (0, $8124ab978dad7f97$export$4368d992c4eafac0)(property, value);
            const flippedInRtl = rtlDefinition.key !== property || rtlDefinition.value !== value;
            const rtlClassName = flippedInRtl ? (0, $36fed63972b92c26$export$2868bfa6c4652df6)({
                value: rtlDefinition.value.toString(),
                property: rtlDefinition.key,
                salt: classNameHashSalt,
                selector: selector
            }, atRules) : undefined;
            const rtlCompileOptions = flippedInRtl ? {
                rtlClassName: rtlClassName,
                rtlProperty: rtlDefinition.key,
                rtlValue: rtlDefinition.value
            } : undefined;
            const styleBucketName = (0, $5016c4763fa89385$export$d90f6836ea1aee93)(selectors, atRules);
            const [ltrCSS, rtlCSS] = (0, $e3ec89946ed04bb5$export$33a9e446f13f0fb6)(Object.assign({
                className: className,
                selectors: selectors,
                property: property,
                value: value
            }, rtlCompileOptions), atRules);
            $4d4b51fea020f8c3$var$pushToClassesMap(cssClassesMap, key, className, rtlClassName);
            $4d4b51fea020f8c3$var$pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, atRules.media, $4d4b51fea020f8c3$var$computePropertyPriority(shorthand));
        } else if (property === 'animationName') {
            const animationNameValue = Array.isArray(value) ? value : [
                value
            ];
            const animationNames = [];
            const rtlAnimationNames = [];
            for (const keyframeObject of animationNameValue){
                const keyframeCSS = (0, $2be2fc9bf80c2abb$export$f063294709aee23a)(keyframeObject);
                const rtlKeyframeCSS = (0, $2be2fc9bf80c2abb$export$f063294709aee23a)((0, $8124ab978dad7f97$export$db3b6bfb95261072)(keyframeObject));
                const animationName = (0, $1708e11ed21e9e34$export$fdd4f86041cc97c0) + (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(keyframeCSS);
                let rtlAnimationName;
                const keyframeRules = (0, $2be2fc9bf80c2abb$export$50cb7050c6244400)(animationName, keyframeCSS);
                let rtlKeyframeRules = [];
                if (keyframeCSS === rtlKeyframeCSS) // If CSS for LTR & RTL are same we will re-use animationName from LTR to avoid duplication of rules in output
                rtlAnimationName = animationName;
                else {
                    rtlAnimationName = (0, $1708e11ed21e9e34$export$fdd4f86041cc97c0) + (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(rtlKeyframeCSS);
                    rtlKeyframeRules = (0, $2be2fc9bf80c2abb$export$50cb7050c6244400)(rtlAnimationName, rtlKeyframeCSS);
                }
                for(let i = 0; i < keyframeRules.length; i++)$4d4b51fea020f8c3$var$pushToCSSRules(cssRulesByBucket, // keyframes styles should be inserted into own bucket
                'k', keyframeRules[i], rtlKeyframeRules[i], atRules.media, // keyframes always have default priority
                0);
                animationNames.push(animationName);
                rtlAnimationNames.push(rtlAnimationName);
            }
            $4d4b51fea020f8c3$export$15fe91a57d59741({
                animationName: animationNames.join(', ')
            }, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket, rtlAnimationNames.join(', '));
        } else if (Array.isArray(value)) {
            // not animationName property but array in the value => fallback values
            if (value.length === 0) continue;
            const selector = (0, $f112d2144666e15a$export$5ba174c10f60bb93)(selectors.join(''));
            const shorthand = $4d4b51fea020f8c3$var$getShorthandDefinition(property);
            if (shorthand) {
                const shorthandProperties = shorthand[1];
                const shorthandResetStyles = Object.fromEntries(shorthandProperties.map((property)=>[
                        property,
                        (0, $1708e11ed21e9e34$export$4a991c87e640ef77)
                    ]));
                $4d4b51fea020f8c3$export$15fe91a57d59741(shorthandResetStyles, classNameHashSalt, selectors, atRules, cssClassesMap, cssRulesByBucket);
            }
            const key = (0, $d4a02a095ab36648$export$d78eef92bb01743f)(selector, property, atRules);
            const className = (0, $36fed63972b92c26$export$2868bfa6c4652df6)({
                value: value.map((v)=>(v !== null && v !== void 0 ? v : '').toString()).join(';'),
                salt: classNameHashSalt,
                selector: selector,
                property: property
            }, atRules);
            const rtlDefinitions = value.map((v)=>(0, $8124ab978dad7f97$export$4368d992c4eafac0)(property, v));
            const rtlPropertyConsistent = !rtlDefinitions.some((v)=>v.key !== rtlDefinitions[0].key);
            if (!rtlPropertyConsistent) continue;
            const flippedInRtl = rtlDefinitions[0].key !== property || rtlDefinitions.some((v, i)=>v.value !== value[i]);
            const rtlClassName = flippedInRtl ? (0, $36fed63972b92c26$export$2868bfa6c4652df6)({
                value: rtlDefinitions.map((v)=>{
                    var _a;
                    return ((_a = v === null || v === void 0 ? void 0 : v.value) !== null && _a !== void 0 ? _a : '').toString();
                }).join(';'),
                salt: classNameHashSalt,
                property: rtlDefinitions[0].key,
                selector: selector
            }, atRules) : undefined;
            const rtlCompileOptions = flippedInRtl ? {
                rtlClassName: rtlClassName,
                rtlProperty: rtlDefinitions[0].key,
                rtlValue: rtlDefinitions.map((d)=>d.value)
            } : undefined;
            const styleBucketName = (0, $5016c4763fa89385$export$d90f6836ea1aee93)(selectors, atRules);
            const [ltrCSS, rtlCSS] = (0, $e3ec89946ed04bb5$export$33a9e446f13f0fb6)(Object.assign({
                className: className,
                selectors: selectors,
                property: property,
                value: value
            }, rtlCompileOptions), atRules);
            $4d4b51fea020f8c3$var$pushToClassesMap(cssClassesMap, key, className, rtlClassName);
            $4d4b51fea020f8c3$var$pushToCSSRules(cssRulesByBucket, styleBucketName, ltrCSS, rtlCSS, atRules.media, $4d4b51fea020f8c3$var$computePropertyPriority(shorthand));
        } else if ((0, $a4b00e389e13d348$export$a6cdc56e425d0d0a)(value)) {
            if ((0, $91df032bfb87c4a2$export$6ec9da58e818601b)(property)) $4d4b51fea020f8c3$export$15fe91a57d59741(value, classNameHashSalt, selectors.concat((0, $cc56a90498587e19$export$bdc4d18748ef5f7c)(property)), atRules, cssClassesMap, cssRulesByBucket);
            else if ((0, $5e79e88e3cd41b55$export$685119d24577daa)(property)) {
                const combinedMediaQuery = (0, $8647664170f974d1$export$9f1ed25614266b04)(atRules.media, property.slice(6).trim());
                $4d4b51fea020f8c3$export$15fe91a57d59741(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
                    media: combinedMediaQuery
                }), cssClassesMap, cssRulesByBucket);
            } else if ((0, $c82621a28c600955$export$1f8685537590b231)(property)) {
                const combinedLayerQuery = (atRules.layer ? `${atRules.layer}.` : '') + property.slice(6).trim();
                $4d4b51fea020f8c3$export$15fe91a57d59741(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
                    layer: combinedLayerQuery
                }), cssClassesMap, cssRulesByBucket);
            } else if ((0, $10f00de62ad97c9c$export$f6f4ace31eaf7c98)(property)) {
                const combinedSupportQuery = (0, $8647664170f974d1$export$9f1ed25614266b04)(atRules.supports, property.slice(9).trim());
                $4d4b51fea020f8c3$export$15fe91a57d59741(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
                    supports: combinedSupportQuery
                }), cssClassesMap, cssRulesByBucket);
            } else if ((0, $6d03dc00daa00702$export$7648458cb39ca9d9)(property)) {
                // TODO implement nested container queries if needed
                // The only way to target multiple containers is to nest container queries
                // https://developer.mozilla.org/en-US/docs/Web/CSS/@container#nested_container_queries
                const containerQuery = property.slice(10).trim();
                $4d4b51fea020f8c3$export$15fe91a57d59741(value, classNameHashSalt, selectors, Object.assign({}, atRules, {
                    container: containerQuery
                }), cssClassesMap, cssRulesByBucket);
            } else (0, $4626b6f2f5e30665$export$b0df042dbc0a42f9)(property, value);
        }
    }
    return [
        cssClassesMap,
        cssRulesByBucket
    ];
}


/**
 * Calls resolveStyleRules() for each slot, is also used by build time transform.
 *
 * @param stylesBySlots - An object with makeStyles rules where a key is a slot name
 * @param classNameHashSalt - A salt for classes hash
 *
 * @return - A tuple with an object classnames mapping where a key is a slot name and an array with CSS rules
 */ function $c685af0718760e41$export$14fa50cbb6831b64(stylesBySlots, classNameHashSalt = '') {
    const classesMapBySlot = {};
    const cssRules = {};
    // eslint-disable-next-line guard-for-in
    for(const slotName in stylesBySlots){
        const slotStyles = stylesBySlots[slotName];
        const [cssClassMap, cssRulesByBucket] = (0, $4d4b51fea020f8c3$export$15fe91a57d59741)(slotStyles, classNameHashSalt);
        classesMapBySlot[slotName] = cssClassMap;
        Object.keys(cssRulesByBucket).forEach((styleBucketName)=>{
            cssRules[styleBucketName] = (cssRules[styleBucketName] || []).concat(cssRulesByBucket[styleBucketName]);
        });
    }
    return [
        classesMapBySlot,
        cssRules
    ];
}



function $2487d062875a3f0b$export$b35517af9e0a5689(stylesBySlots, factory = (0, $58dc86b24cfc33cd$export$3509cd6597590fb4)) {
    const insertStyles = factory();
    let classesMapBySlot = null;
    let cssRules = null;
    let ltrClassNamesForSlots = null;
    let rtlClassNamesForSlots = null;
    let sourceURL;
    let classNameHashSalt;
    function computeClasses(options) {
        const { dir: dir, renderer: renderer } = options;
        if (classesMapBySlot === null) [classesMapBySlot, cssRules] = (0, $c685af0718760e41$export$14fa50cbb6831b64)(stylesBySlots, renderer.classNameHashSalt);
        const isLTR = dir === 'ltr';
        if (isLTR) {
            if (ltrClassNamesForSlots === null) ltrClassNamesForSlots = (0, $7f688c48a4d5cb6f$export$af9182572a187ed1)(classesMapBySlot, dir);
        } else if (rtlClassNamesForSlots === null) rtlClassNamesForSlots = (0, $7f688c48a4d5cb6f$export$af9182572a187ed1)(classesMapBySlot, dir);
        insertStyles(renderer, cssRules);
        const classNamesForSlots = isLTR ? ltrClassNamesForSlots : rtlClassNamesForSlots;
        return classNamesForSlots;
    }
    return computeClasses;
}




var $acw62 = parcelRequire("acw62");
"use client";
const $d81d65ca7bce228e$export$aaabe4eda9ed9969 = // @ts-expect-error Hack to make sure that `useInsertionEffect` will not cause bundling issues in older React versions
// eslint-disable-next-line no-useless-concat
$acw62.useInsertionEffect ? $acw62.useInsertionEffect : undefined;


"use client";
const $fa1de8989c7e7130$export$3509cd6597590fb4 = ()=>{
    const insertionCache = {};
    return function insert(renderer, cssRules) {
        // Even if `useInsertionEffect` is available, we can use it on a client only as it will not be executed in SSR
        if ((0, $d81d65ca7bce228e$export$aaabe4eda9ed9969) && (0, $ecb3e83860eba794$export$71594e8a50f746f4)()) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $d81d65ca7bce228e$export$aaabe4eda9ed9969)(()=>{
                renderer.insertCSSRules(cssRules);
            }, [
                renderer,
                cssRules
            ]);
            return;
        }
        if (insertionCache[renderer.id] === undefined) {
            renderer.insertCSSRules(cssRules);
            insertionCache[renderer.id] = true;
        }
    };
};





"use client";
function $6ca57e1ddff6d070$export$b35517af9e0a5689(stylesBySlots) {
    const getStyles = (0, $2487d062875a3f0b$export$b35517af9e0a5689)(stylesBySlots, (0, $fa1de8989c7e7130$export$3509cd6597590fb4));
    return function useClasses() {
        const dir = (0, $314edc3f6e2ad580$export$cf24a79f32f45545)();
        const renderer = (0, $4c6030e36adbdcfb$export$e0259e2a2ab69ea)();
        return getStyles({
            dir: dir,
            renderer: renderer
        });
    };
}



const $3f88f73ddeac33bb$var$useStyles = (0, $6ca57e1ddff6d070$export$b35517af9e0a5689)({
    header: {
        backgroundImage: "linear-gradient(to bottom, #5A4228, #7E6035)",
        height: "100px",
        display: "flex",
        alignItems: "end",
        justifyContent: "center",
        padding: "1rem"
    },
    logo: {
        height: "100%",
        maxHeight: "100px",
        filter: "drop-shadow(0 0 3px rgba(0, 0, 0, 0.25))"
    }
});
function $3f88f73ddeac33bb$export$2e2bcd8739ae039() {
    const styles = $3f88f73ddeac33bb$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: styles.header,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: "/VGLogo_RPSystem.png",
                    alt: "Logo",
                    className: styles.logo
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 1000 100",
                    preserveAspectRatio: "none",
                    style: {
                        width: "100%",
                        maxHeight: "100px",
                        marginTop: "-1px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            style: {
                                fill: "#7E6035"
                            },
                            opacity: "0.33",
                            d: "M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            style: {
                                fill: "#7E6035"
                            },
                            opacity: "0.66",
                            d: "M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            style: {
                                fill: "#7E6035"
                            },
                            d: "M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa12b390a398aec2$export$910ae8079b2c2852), {})
        ]
    });
}




function $9aecac4636d85589$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            padding: "2rem 10rem 2rem 10rem"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "You weren't meant to get here."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: 'This website is intended for management of your roleplay HUD. Please click your HUD\'s menu button and click "Configure" to get started.'
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $9521bdea52bd87ae$export$adc464bf5eb3c05c(setTimer, cancelTimer) {
    const id = $acw62.useRef(undefined);
    const set = $acw62.useCallback((fn, delay)=>{
        if (id.current !== undefined) cancelTimer(id.current);
        id.current = setTimer(fn, delay);
        return id.current;
    }, [
        cancelTimer,
        setTimer
    ]);
    const cancel = $acw62.useCallback(()=>{
        if (id.current !== undefined) {
            cancelTimer(id.current);
            id.current = undefined;
        }
    }, [
        cancelTimer
    ]);
    // Clean up the timeout when the component is unloaded
    $acw62.useEffect(()=>cancel, [
        cancel
    ]);
    return [
        set,
        cancel
    ];
}



'use client';
const $bf7615d1d68d35d9$var$setTimeoutNoop = (_callback)=>-1;
const $bf7615d1d68d35d9$var$clearTimeoutNoop = (_handle)=>undefined;
function $bf7615d1d68d35d9$export$d8e6abf214c9ec0f() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const setTimerFn = win ? win.setTimeout : $bf7615d1d68d35d9$var$setTimeoutNoop;
    const clearTimerFn = win ? win.clearTimeout : $bf7615d1d68d35d9$var$clearTimeoutNoop;
    return (0, $9521bdea52bd87ae$export$adc464bf5eb3c05c)(setTimerFn, clearTimerFn);
}



var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

'use client';
const $2848a314d8ac401f$export$297f2b836c871bf2 = (props, ref)=>{
    const { weight: weight = 'regular', size: size = 'medium', ...baseProps } = props;
    const state = $2848a314d8ac401f$export$e764f418f031c7c0(baseProps, ref);
    return {
        weight: weight,
        size: size,
        ...state
    };
};
const $2848a314d8ac401f$export$e764f418f031c7c0 = (props, ref)=>{
    const { disabled: disabled = false, required: required = false, ...rest } = props;
    return {
        disabled: disabled,
        required: (0, $fcf7ddccaab7fd8f$exports).optional(required === true ? '*' : required || undefined, {
            defaultProps: {
                'aria-hidden': 'true'
            },
            elementType: 'span'
        }),
        components: {
            root: 'label',
            required: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('label', {
            ref: ref,
            ...rest
        }), {
            elementType: 'label'
        })
    };
};




const $5f2d7caf2e03ed24$export$d9062ad594251d74 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.root.children,
            state.required && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.required, {})
        ]
    });
};






"use client";
/**
 * A version of makeStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $8ef74b7807535a4a$export$c5d3a2c2e0d67663(classesMapBySlot, cssRules) {
    const getStyles = (0, $1170b0e155e89f44$export$c5d3a2c2e0d67663)(classesMapBySlot, cssRules, (0, $fa1de8989c7e7130$export$3509cd6597590fb4));
    return function useClasses() {
        const dir = (0, $314edc3f6e2ad580$export$cf24a79f32f45545)();
        const renderer = (0, $4c6030e36adbdcfb$export$e0259e2a2ab69ea)();
        return getStyles({
            dir: dir,
            renderer: renderer
        });
    };
}



'use client';
const $5f3488a634124728$export$17b3ba63392dd087 = {
    root: 'fui-Label',
    required: 'fui-Label__required'
};
/**
 * Styles for the label
 */ const $5f3488a634124728$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        sj55zd: "f19n0e5"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        B7iucu3: "f1cyfu5x"
    },
    required: {
        sj55zd: "f1whyuy6",
        uwmqm3: [
            "fruq291",
            "f7x41pl"
        ]
    },
    small: {
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm"
    },
    medium: {
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        Be2twd7: "fod5ikn",
        Bg96gwp: "faaz57k",
        Bhrd7zp: "fl43uef"
    },
    semibold: {
        Bhrd7zp: "fl43uef"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1whyuy6{color:var(--colorPaletteRedForeground3);}",
        ".fruq291{padding-left:var(--spacingHorizontalXS);}",
        ".f7x41pl{padding-right:var(--spacingHorizontalXS);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1cyfu5x{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $5f3488a634124728$export$226b295eeaef99ee = (state)=>{
    'use no memo';
    const styles = $5f3488a634124728$var$useStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($5f3488a634124728$export$17b3ba63392dd087.root, styles.root, state.disabled && styles.disabled, styles[state.size], state.weight === 'semibold' && styles.semibold, state.root.className);
    if (state.required) state.required.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($5f3488a634124728$export$17b3ba63392dd087.required, styles.required, state.disabled && styles.disabled, state.required.className);
    return state;
};



'use client';
const $0d13e5c2b1019ada$export$b04be29aa201d4f5 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $2848a314d8ac401f$export$297f2b836c871bf2)(props, ref);
    (0, $5f3488a634124728$export$226b295eeaef99ee)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useLabelStyles_unstable')(state);
    return (0, $5f2d7caf2e03ed24$export$d9062ad594251d74)(state);
});
$0d13e5c2b1019ada$export$b04be29aa201d4f5.displayName = 'Label';



var $acw62 = parcelRequire("acw62");
'use client';
const $07e9b2ed98094869$var$SpinnerContext = $acw62.createContext(undefined);
const $07e9b2ed98094869$var$SpinnerContextDefaultValue = {};
const $07e9b2ed98094869$export$3ea29706a0117618 = $07e9b2ed98094869$var$SpinnerContext.Provider;
const $07e9b2ed98094869$export$93bfe20fa842be24 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($07e9b2ed98094869$var$SpinnerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $07e9b2ed98094869$var$SpinnerContextDefaultValue;
};


'use client';
const $ea3ba69704659aea$export$d22a6816f9606c0c = (props, ref)=>{
    const { size: contextSize } = (0, $07e9b2ed98094869$export$93bfe20fa842be24)();
    const { appearance: appearance = 'primary', size: size = contextSize !== null && contextSize !== void 0 ? contextSize : 'medium', ...baseProps } = props;
    const baseState = $ea3ba69704659aea$export$4b37c6839851d9be(baseProps, ref);
    return {
        ...baseState,
        appearance: appearance,
        size: size
    };
};
const $ea3ba69704659aea$export$4b37c6839851d9be = (props, ref)=>{
    const { delay: delay = 0, labelPosition: labelPosition = 'after' } = props;
    const baseId = (0, $0200d30cfa270435$export$f680877a34711e37)('spinner');
    const { role: role = 'progressbar', ...rest } = props;
    const nativeRoot = (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
        // FIXME:
        // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
        // but since it would be a breaking change to fix it, we are casting ref to it's proper type
        ref: ref,
        role: role,
        ...rest
    }), {
        elementType: 'div'
    });
    const [isShownAfterDelay, setIsShownAfterDelay] = $acw62.useState(false);
    const [setDelayTimeout, clearDelayTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    $acw62.useEffect(()=>{
        if (delay <= 0) return;
        setDelayTimeout(()=>{
            setIsShownAfterDelay(true);
        }, delay);
        return ()=>{
            clearDelayTimeout();
        };
    }, [
        setDelayTimeout,
        clearDelayTimeout,
        delay
    ]);
    const labelShorthand = (0, $fcf7ddccaab7fd8f$exports).optional(props.label, {
        defaultProps: {
            id: baseId
        },
        renderByDefault: false,
        elementType: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
    });
    const spinnerShortHand = (0, $fcf7ddccaab7fd8f$exports).optional(props.spinner, {
        renderByDefault: true,
        elementType: 'span'
    });
    if (labelShorthand && nativeRoot && !nativeRoot['aria-labelledby']) nativeRoot['aria-labelledby'] = labelShorthand.id;
    const state = {
        delay: delay,
        labelPosition: labelPosition,
        shouldRenderSpinner: !delay || isShownAfterDelay,
        components: {
            root: 'div',
            spinner: 'span',
            spinnerTail: 'span',
            label: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
        },
        root: nativeRoot,
        spinner: spinnerShortHand,
        spinnerTail: (0, $fcf7ddccaab7fd8f$exports).always(props.spinnerTail, {
            elementType: 'span'
        }),
        label: labelShorthand
    };
    return state;
};




const $90b04b1885011b2b$export$6b431f40bc8da439 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const { labelPosition: labelPosition, shouldRenderSpinner: shouldRenderSpinner } = state;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.label && shouldRenderSpinner && (labelPosition === 'above' || labelPosition === 'before') && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {}),
            state.spinner && shouldRenderSpinner && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.spinner, {
                children: state.spinnerTail && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.spinnerTail, {})
            }),
            state.label && shouldRenderSpinner && (labelPosition === 'below' || labelPosition === 'after') && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {})
        ]
    });
};






/**
 * @internal
 */ function $deed6abd7ec079c5$export$7e3b04e77a0827f2(ltrClassName, rtlClassName, cssRules, factory = (0, $58dc86b24cfc33cd$export$3509cd6597590fb4)) {
    const insertStyles = factory();
    function computeClassName(options) {
        const { dir: dir, renderer: renderer } = options;
        const className = dir === 'ltr' ? ltrClassName : rtlClassName || ltrClassName;
        insertStyles(renderer, Array.isArray(cssRules) ? {
            r: cssRules
        } : cssRules);
        return className;
    }
    return computeClassName;
}





"use client";
/**
 * A version of makeResetStyles() that accepts build output as an input and skips all runtime transforms.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $69f85aebb0ae267b$export$7e3b04e77a0827f2(ltrClassName, rtlClassName, cssRules) {
    const getStyles = (0, $deed6abd7ec079c5$export$7e3b04e77a0827f2)(ltrClassName, rtlClassName, cssRules, (0, $fa1de8989c7e7130$export$3509cd6597590fb4));
    return function useClasses() {
        const dir = (0, $314edc3f6e2ad580$export$cf24a79f32f45545)();
        const renderer = (0, $4c6030e36adbdcfb$export$e0259e2a2ab69ea)();
        return getStyles({
            dir: dir,
            renderer: renderer
        });
    };
}


'use client';
const $5df5dc5c79b7533a$export$78944c62fc89d0be = {
    root: 'fui-Spinner',
    spinner: 'fui-Spinner__spinner',
    spinnerTail: 'fui-Spinner__spinnerTail',
    label: 'fui-Spinner__label'
};
/**
 * CSS variables used internally by Spinner
 */ const $5df5dc5c79b7533a$var$vars = {
    strokeWidth: '--fui-Spinner--strokeWidth'
};
const $5df5dc5c79b7533a$var$useRootBaseClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rpp59a7", null, [
    ".rpp59a7{display:flex;align-items:center;justify-content:center;line-height:0;gap:8px;overflow:hidden;min-width:min-content;}"
]);
const $5df5dc5c79b7533a$var$useRootStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    vertical: {
        Beiy3e4: "f1vx9l62"
    }
}, {
    d: [
        ".f1vx9l62{flex-direction:column;}"
    ]
});
const $5df5dc5c79b7533a$var$useSpinnerBaseClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rvgcg50", "r15nd2jo", {
    r: [
        ".rvgcg50{position:relative;flex-shrink:0;-webkit-mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);background-color:var(--colorBrandStroke2Contrast);color:var(--colorBrandStroke1);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:rb7n1on;}",
        "@keyframes rb7n1on{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}",
        ".r15nd2jo{position:relative;flex-shrink:0;-webkit-mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);background-color:var(--colorBrandStroke2Contrast);color:var(--colorBrandStroke1);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:r1gx3jof;}",
        "@keyframes r1gx3jof{0%{transform:rotate(0deg);}100%{transform:rotate(-360deg);}}"
    ],
    s: [
        "@media screen and (forced-colors: active){.rvgcg50{background-color:HighlightText;color:Highlight;forced-color-adjust:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.rvgcg50{animation-duration:1.8s;}}",
        "@media screen and (forced-colors: active){.r15nd2jo{background-color:HighlightText;color:Highlight;forced-color-adjust:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r15nd2jo{animation-duration:1.8s;}}"
    ]
});
// The spinner tail is rendered using two 135deg arc segments, behind a 105deg arc mask.
// The segments are rotated out from behind the mask to expand the visible arc from
// 30deg (min) to 255deg (max), and then back behind the mask again to shrink the arc.
// The tail and spinner itself also have 360deg rotation animations for the spin.
const $5df5dc5c79b7533a$var$useSpinnerTailBaseClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rxov3xa", "r1o544mv", {
    r: [
        ".rxov3xa{position:absolute;display:block;width:100%;height:100%;-webkit-mask-image:conic-gradient(transparent 105deg, white 105deg);mask-image:conic-gradient(transparent 105deg, white 105deg);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:var(--curveEasyEase);animation-name:r15mim6k;}",
        ".rxov3xa::before,.rxov3xa::after{content:\"\";position:absolute;display:block;width:100%;height:100%;animation:inherit;background-image:conic-gradient(currentcolor 135deg, transparent 135deg);}",
        "@keyframes r15mim6k{0%{transform:rotate(-135deg);}50%{transform:rotate(0deg);}100%{transform:rotate(225deg);}}",
        ".rxov3xa::before{animation-name:r18vhmn8;}",
        "@keyframes r18vhmn8{0%{transform:rotate(0deg);}50%{transform:rotate(105deg);}100%{transform:rotate(0deg);}}",
        ".rxov3xa::after{animation-name:rkgrvoi;}",
        "@keyframes rkgrvoi{0%{transform:rotate(0deg);}50%{transform:rotate(225deg);}100%{transform:rotate(0deg);}}",
        ".r1o544mv{position:absolute;display:block;width:100%;height:100%;-webkit-mask-image:conic-gradient(transparent 105deg, white 105deg);mask-image:conic-gradient(transparent 105deg, white 105deg);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:var(--curveEasyEase);animation-name:r109gmi5;}",
        ".r1o544mv::before,.r1o544mv::after{content:\"\";position:absolute;display:block;width:100%;height:100%;animation:inherit;background-image:conic-gradient(currentcolor 135deg, transparent 135deg);}",
        "@keyframes r109gmi5{0%{transform:rotate(135deg);}50%{transform:rotate(0deg);}100%{transform:rotate(-225deg);}}",
        ".r1o544mv::before{animation-name:r17whflh;}",
        "@keyframes r17whflh{0%{transform:rotate(0deg);}50%{transform:rotate(-105deg);}100%{transform:rotate(0deg);}}",
        ".r1o544mv::after{animation-name:re4odhl;}",
        "@keyframes re4odhl{0%{transform:rotate(0deg);}50%{transform:rotate(-225deg);}100%{transform:rotate(0deg);}}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.rxov3xa{animation-iteration-count:0;background-image:conic-gradient(transparent 120deg, currentcolor 360deg);}.rxov3xa::before,.rxov3xa::after{content:none;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1o544mv{animation-iteration-count:0;background-image:conic-gradient(transparent 120deg, currentcolor 360deg);}.r1o544mv::before,.r1o544mv::after{content:none;}}"
    ]
});
const $5df5dc5c79b7533a$var$useSpinnerStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    inverted: {
        De3pzq: "fr407j0",
        sj55zd: "f1f7voed"
    },
    rtlTail: {
        btxmck: "f179dep3",
        gb5jj2: "fbz9ihp",
        Bdya8wy: "f1pme1qz"
    },
    "extra-tiny": {
        Bqenvij: "fd461yt",
        a9b677: "fjw5fx7",
        qmp6fs: "f1v3ph3m"
    },
    tiny: {
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3",
        qmp6fs: "f1v3ph3m"
    },
    "extra-small": {
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun",
        qmp6fs: "f1v3ph3m"
    },
    small: {
        Bqenvij: "fxldao9",
        a9b677: "f1w9dchk",
        qmp6fs: "f1v3ph3m"
    },
    medium: {
        Bqenvij: "f1d2rq10",
        a9b677: "f1szoe96",
        qmp6fs: "fb52u90"
    },
    large: {
        Bqenvij: "f8ljn23",
        a9b677: "fpdz1er",
        qmp6fs: "fb52u90"
    },
    "extra-large": {
        Bqenvij: "fbhnoac",
        a9b677: "feqmc2u",
        qmp6fs: "fb52u90"
    },
    huge: {
        Bqenvij: "f1ft4266",
        a9b677: "fksc0bp",
        qmp6fs: "fa3u9ii"
    }
}, {
    d: [
        ".fr407j0{background-color:var(--colorNeutralStrokeAlpha2);}",
        ".f1f7voed{color:var(--colorNeutralStrokeOnBrand2);}",
        ".f179dep3{-webkit-mask-image:conic-gradient(white 255deg, transparent 255deg);mask-image:conic-gradient(white 255deg, transparent 255deg);}",
        ".fbz9ihp::before,.fbz9ihp::after{background-image:conic-gradient(transparent 225deg, currentcolor 225deg);}",
        ".fd461yt{height:16px;}",
        ".fjw5fx7{width:16px;}",
        ".f1v3ph3m{--fui-Spinner--strokeWidth:var(--strokeWidthThick);}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".fxldao9{height:28px;}",
        ".f1w9dchk{width:28px;}",
        ".f1d2rq10{height:32px;}",
        ".f1szoe96{width:32px;}",
        ".fb52u90{--fui-Spinner--strokeWidth:var(--strokeWidthThicker);}",
        ".f8ljn23{height:36px;}",
        ".fpdz1er{width:36px;}",
        ".fbhnoac{height:40px;}",
        ".feqmc2u{width:40px;}",
        ".f1ft4266{height:44px;}",
        ".fksc0bp{width:44px;}",
        ".fa3u9ii{--fui-Spinner--strokeWidth:var(--strokeWidthThickest);}"
    ],
    m: [
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1pme1qz{background-image:conic-gradient(currentcolor 0deg, transparent 240deg);}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ]
    ]
});
const $5df5dc5c79b7533a$var$useLabelStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    inverted: {
        sj55zd: "fonrgv7"
    },
    "extra-tiny": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    tiny: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    "extra-small": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    small: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    },
    medium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    "extra-large": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    huge: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f1pp30po",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f106mvju"
    }
}, {
    d: [
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}"
    ]
});
const $5df5dc5c79b7533a$export$c8629923cd802b17 = (state)=>{
    'use no memo';
    const { labelPosition: labelPosition, size: size, appearance: appearance } = state;
    const { dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const rootBaseClassName = $5df5dc5c79b7533a$var$useRootBaseClassName();
    const rootStyles = $5df5dc5c79b7533a$var$useRootStyles();
    const spinnerBaseClassName = $5df5dc5c79b7533a$var$useSpinnerBaseClassName();
    const spinnerStyles = $5df5dc5c79b7533a$var$useSpinnerStyles();
    const spinnerTailBaseClassName = $5df5dc5c79b7533a$var$useSpinnerTailBaseClassName();
    const labelStyles = $5df5dc5c79b7533a$var$useLabelStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.root, rootBaseClassName, (labelPosition === 'above' || labelPosition === 'below') && rootStyles.vertical, state.root.className);
    if (state.spinner) state.spinner.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.spinner, spinnerBaseClassName, spinnerStyles[size], appearance === 'inverted' && spinnerStyles.inverted, state.spinner.className);
    if (state.spinnerTail) state.spinnerTail.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.spinnerTail, spinnerTailBaseClassName, dir === 'rtl' && spinnerStyles.rtlTail, state.spinnerTail.className);
    if (state.label) state.label.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($5df5dc5c79b7533a$export$78944c62fc89d0be.label, labelStyles[size], appearance === 'inverted' && labelStyles.inverted, state.label.className);
    return state;
};



'use client';
const $16c0c2858b6dc7eb$export$7f7cbe89f1eacd2 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $ea3ba69704659aea$export$d22a6816f9606c0c)(props, ref);
    (0, $5df5dc5c79b7533a$export$c8629923cd802b17)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useSpinnerStyles_unstable')(state);
    return (0, $90b04b1885011b2b$export$6b431f40bc8da439)(state);
});
$16c0c2858b6dc7eb$export$7f7cbe89f1eacd2.displayName = 'Spinner';

parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $e4ac2781c39ddd17$export$6b933eea0405bd18 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};

parcelRequire("acw62");

const $38bf99cb9f5ed2d0$export$546b1a6a3828c8cc = (props, ref)=>{
    const { wrap: wrap, truncate: truncate, block: block, italic: italic, underline: underline, strikethrough: strikethrough, size: size, font: font, weight: weight, align: align } = props;
    const state = {
        align: align !== null && align !== void 0 ? align : 'start',
        block: block !== null && block !== void 0 ? block : false,
        font: font !== null && font !== void 0 ? font : 'base',
        italic: italic !== null && italic !== void 0 ? italic : false,
        size: size !== null && size !== void 0 ? size : 300,
        strikethrough: strikethrough !== null && strikethrough !== void 0 ? strikethrough : false,
        truncate: truncate !== null && truncate !== void 0 ? truncate : false,
        underline: underline !== null && underline !== void 0 ? underline : false,
        weight: weight !== null && weight !== void 0 ? weight : 'regular',
        wrap: wrap !== null && wrap !== void 0 ? wrap : true,
        components: {
            root: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('span', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLHeadingElement & HTMLPreElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'span'
        })
    };
    return state;
};



'use client';
const $2d424633ffda5f6a$export$c2a588b7cc722032 = {
    root: 'fui-Text'
};
/**
 * Styles for the root slot
 */ const $2d424633ffda5f6a$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi",
        Bhrd7zp: "figsok6",
        fsow6f: "fpgzoln",
        mc9l5x: "f1w7gpdv",
        Huce71: "f6juhto",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg",
        ygn44y: "f2jf649"
    },
    nowrap: {
        Huce71: "fz5stix",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp"
    },
    truncate: {
        ygn44y: "f1cmbuwj"
    },
    block: {
        mc9l5x: "ftgm304"
    },
    italic: {
        B80ckks: "f1j4dglz"
    },
    underline: {
        w71qe1: "f13mvf36"
    },
    strikethrough: {
        w71qe1: "fv5q2k7"
    },
    strikethroughUnderline: {
        w71qe1: "f1drk4o6"
    },
    base100: {
        Be2twd7: "f13mqy1h",
        Bg96gwp: "fcpl73t"
    },
    base200: {
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm"
    },
    base400: {
        Be2twd7: "fod5ikn",
        Bg96gwp: "faaz57k"
    },
    base500: {
        Be2twd7: "f1pp30po",
        Bg96gwp: "f106mvju"
    },
    base600: {
        Be2twd7: "f1x0m3f5",
        Bg96gwp: "fb86gi6"
    },
    hero700: {
        Be2twd7: "fojgt09",
        Bg96gwp: "fcen8rp"
    },
    hero800: {
        Be2twd7: "fccw675",
        Bg96gwp: "f1ebx5kk"
    },
    hero900: {
        Be2twd7: "f15afnhw",
        Bg96gwp: "fr3w3wp"
    },
    hero1000: {
        Be2twd7: "fpyltcb",
        Bg96gwp: "f1ivgwrt"
    },
    monospace: {
        Bahqtrf: "f1fedwem"
    },
    numeric: {
        Bahqtrf: "f1uq0ln5"
    },
    weightMedium: {
        Bhrd7zp: "fdj6btp"
    },
    weightSemibold: {
        Bhrd7zp: "fl43uef"
    },
    weightBold: {
        Bhrd7zp: "flh3ekv"
    },
    alignCenter: {
        fsow6f: "f17mccla"
    },
    alignEnd: {
        fsow6f: "f12ymhq5"
    },
    alignJustify: {
        fsow6f: "f1j59e10"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fpgzoln{text-align:start;}",
        ".f1w7gpdv{display:inline;}",
        ".f6juhto{white-space:normal;}",
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        ".f2jf649{text-overflow:clip;}",
        ".fz5stix{white-space:nowrap;}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f1cmbuwj{text-overflow:ellipsis;}",
        ".ftgm304{display:block;}",
        ".f1j4dglz{font-style:italic;}",
        ".f13mvf36{text-decoration-line:underline;}",
        ".fv5q2k7{text-decoration-line:line-through;}",
        ".f1drk4o6{text-decoration-line:line-through underline;}",
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".fcpl73t{line-height:var(--lineHeightBase100);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}",
        ".f1x0m3f5{font-size:var(--fontSizeBase600);}",
        ".fb86gi6{line-height:var(--lineHeightBase600);}",
        ".fojgt09{font-size:var(--fontSizeHero700);}",
        ".fcen8rp{line-height:var(--lineHeightHero700);}",
        ".fccw675{font-size:var(--fontSizeHero800);}",
        ".f1ebx5kk{line-height:var(--lineHeightHero800);}",
        ".f15afnhw{font-size:var(--fontSizeHero900);}",
        ".fr3w3wp{line-height:var(--lineHeightHero900);}",
        ".fpyltcb{font-size:var(--fontSizeHero1000);}",
        ".f1ivgwrt{line-height:var(--lineHeightHero1000);}",
        ".f1fedwem{font-family:var(--fontFamilyMonospace);}",
        ".f1uq0ln5{font-family:var(--fontFamilyNumeric);}",
        ".fdj6btp{font-weight:var(--fontWeightMedium);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".flh3ekv{font-weight:var(--fontWeightBold);}",
        ".f17mccla{text-align:center;}",
        ".f12ymhq5{text-align:end;}",
        ".f1j59e10{text-align:justify;}"
    ]
});
const $2d424633ffda5f6a$export$d3aa483101121c70 = (state)=>{
    'use no memo';
    const styles = $2d424633ffda5f6a$var$useStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($2d424633ffda5f6a$export$c2a588b7cc722032.root, styles.root, state.wrap === false && styles.nowrap, state.truncate && styles.truncate, state.block && styles.block, state.italic && styles.italic, state.underline && styles.underline, state.strikethrough && styles.strikethrough, state.underline && state.strikethrough && styles.strikethroughUnderline, state.size === 100 && styles.base100, state.size === 200 && styles.base200, state.size === 400 && styles.base400, state.size === 500 && styles.base500, state.size === 600 && styles.base600, state.size === 700 && styles.hero700, state.size === 800 && styles.hero800, state.size === 900 && styles.hero900, state.size === 1000 && styles.hero1000, state.font === 'monospace' && styles.monospace, state.font === 'numeric' && styles.numeric, state.weight === 'medium' && styles.weightMedium, state.weight === 'semibold' && styles.weightSemibold, state.weight === 'bold' && styles.weightBold, state.align === 'center' && styles.alignCenter, state.align === 'end' && styles.alignEnd, state.align === 'justify' && styles.alignJustify, state.root.className);
    return state;
};


'use client';
function $b47caaa3576ee3da$export$b956d067c5bcf6b(options) {
    const { useStyles: useStyles, className: className, displayName: displayName } = options;
    const Wrapper = $acw62.forwardRef((props, ref)=>{
        'use no memo';
        const styles = useStyles();
        const state = (0, $38bf99cb9f5ed2d0$export$546b1a6a3828c8cc)(props, ref);
        (0, $2d424633ffda5f6a$export$d3aa483101121c70)(state);
        state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(className, state.root.className, styles.root, props.className);
        return (0, $e4ac2781c39ddd17$export$6b933eea0405bd18)(state);
    });
    Wrapper.displayName = displayName;
    return Wrapper;
}




'use client';
const $86bc1fabdb018032$export$b7c5888229bafdeb = {
    root: 'fui-Subtitle2'
};
const $86bc1fabdb018032$export$e1d06f9c365aed08 = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}"
    ]
});


'use client';
const $715c9647a8930a69$export$661f1b2c265066f = (0, $b47caaa3576ee3da$export$b956d067c5bcf6b)({
    useStyles: (0, $86bc1fabdb018032$export$e1d06f9c365aed08),
    className: (0, $86bc1fabdb018032$export$b7c5888229bafdeb).root,
    displayName: 'Subtitle2'
});

const $4e9eda319b2a962b$export$6ad93df59e712c43 = {
    // Color tokens
    colorNeutralForeground1: 'var(--colorNeutralForeground1)',
    colorNeutralForeground1Hover: 'var(--colorNeutralForeground1Hover)',
    colorNeutralForeground1Pressed: 'var(--colorNeutralForeground1Pressed)',
    colorNeutralForeground1Selected: 'var(--colorNeutralForeground1Selected)',
    colorNeutralForeground2: 'var(--colorNeutralForeground2)',
    colorNeutralForeground2Hover: 'var(--colorNeutralForeground2Hover)',
    colorNeutralForeground2Pressed: 'var(--colorNeutralForeground2Pressed)',
    colorNeutralForeground2Selected: 'var(--colorNeutralForeground2Selected)',
    colorNeutralForeground2BrandHover: 'var(--colorNeutralForeground2BrandHover)',
    colorNeutralForeground2BrandPressed: 'var(--colorNeutralForeground2BrandPressed)',
    colorNeutralForeground2BrandSelected: 'var(--colorNeutralForeground2BrandSelected)',
    colorNeutralForeground3: 'var(--colorNeutralForeground3)',
    colorNeutralForeground3Hover: 'var(--colorNeutralForeground3Hover)',
    colorNeutralForeground3Pressed: 'var(--colorNeutralForeground3Pressed)',
    colorNeutralForeground3Selected: 'var(--colorNeutralForeground3Selected)',
    colorNeutralForeground3BrandHover: 'var(--colorNeutralForeground3BrandHover)',
    colorNeutralForeground3BrandPressed: 'var(--colorNeutralForeground3BrandPressed)',
    colorNeutralForeground3BrandSelected: 'var(--colorNeutralForeground3BrandSelected)',
    colorNeutralForeground4: 'var(--colorNeutralForeground4)',
    colorNeutralForeground5: 'var(--colorNeutralForeground5)',
    colorNeutralForeground5Hover: 'var(--colorNeutralForeground5Hover)',
    colorNeutralForeground5Pressed: 'var(--colorNeutralForeground5Pressed)',
    colorNeutralForeground5Selected: 'var(--colorNeutralForeground5Selected)',
    colorNeutralForegroundDisabled: 'var(--colorNeutralForegroundDisabled)',
    colorBrandForegroundLink: 'var(--colorBrandForegroundLink)',
    colorBrandForegroundLinkHover: 'var(--colorBrandForegroundLinkHover)',
    colorBrandForegroundLinkPressed: 'var(--colorBrandForegroundLinkPressed)',
    colorBrandForegroundLinkSelected: 'var(--colorBrandForegroundLinkSelected)',
    colorNeutralForeground2Link: 'var(--colorNeutralForeground2Link)',
    colorNeutralForeground2LinkHover: 'var(--colorNeutralForeground2LinkHover)',
    colorNeutralForeground2LinkPressed: 'var(--colorNeutralForeground2LinkPressed)',
    colorNeutralForeground2LinkSelected: 'var(--colorNeutralForeground2LinkSelected)',
    colorCompoundBrandForeground1: 'var(--colorCompoundBrandForeground1)',
    colorCompoundBrandForeground1Hover: 'var(--colorCompoundBrandForeground1Hover)',
    colorCompoundBrandForeground1Pressed: 'var(--colorCompoundBrandForeground1Pressed)',
    colorNeutralForegroundOnBrand: 'var(--colorNeutralForegroundOnBrand)',
    colorNeutralForegroundInverted: 'var(--colorNeutralForegroundInverted)',
    colorNeutralForegroundInvertedHover: 'var(--colorNeutralForegroundInvertedHover)',
    colorNeutralForegroundInvertedPressed: 'var(--colorNeutralForegroundInvertedPressed)',
    colorNeutralForegroundInvertedSelected: 'var(--colorNeutralForegroundInvertedSelected)',
    colorNeutralForegroundInverted2: 'var(--colorNeutralForegroundInverted2)',
    colorNeutralForegroundStaticInverted: 'var(--colorNeutralForegroundStaticInverted)',
    colorNeutralForegroundInvertedLink: 'var(--colorNeutralForegroundInvertedLink)',
    colorNeutralForegroundInvertedLinkHover: 'var(--colorNeutralForegroundInvertedLinkHover)',
    colorNeutralForegroundInvertedLinkPressed: 'var(--colorNeutralForegroundInvertedLinkPressed)',
    colorNeutralForegroundInvertedLinkSelected: 'var(--colorNeutralForegroundInvertedLinkSelected)',
    colorNeutralForegroundInvertedDisabled: 'var(--colorNeutralForegroundInvertedDisabled)',
    colorBrandForeground1: 'var(--colorBrandForeground1)',
    colorBrandForeground2: 'var(--colorBrandForeground2)',
    colorBrandForeground2Hover: 'var(--colorBrandForeground2Hover)',
    colorBrandForeground2Pressed: 'var(--colorBrandForeground2Pressed)',
    colorNeutralForeground1Static: 'var(--colorNeutralForeground1Static)',
    colorBrandForegroundInverted: 'var(--colorBrandForegroundInverted)',
    colorBrandForegroundInvertedHover: 'var(--colorBrandForegroundInvertedHover)',
    colorBrandForegroundInvertedPressed: 'var(--colorBrandForegroundInvertedPressed)',
    colorBrandForegroundOnLight: 'var(--colorBrandForegroundOnLight)',
    colorBrandForegroundOnLightHover: 'var(--colorBrandForegroundOnLightHover)',
    colorBrandForegroundOnLightPressed: 'var(--colorBrandForegroundOnLightPressed)',
    colorBrandForegroundOnLightSelected: 'var(--colorBrandForegroundOnLightSelected)',
    colorNeutralBackground1: 'var(--colorNeutralBackground1)',
    colorNeutralBackground1Hover: 'var(--colorNeutralBackground1Hover)',
    colorNeutralBackground1Pressed: 'var(--colorNeutralBackground1Pressed)',
    colorNeutralBackground1Selected: 'var(--colorNeutralBackground1Selected)',
    colorNeutralBackground2: 'var(--colorNeutralBackground2)',
    colorNeutralBackground2Hover: 'var(--colorNeutralBackground2Hover)',
    colorNeutralBackground2Pressed: 'var(--colorNeutralBackground2Pressed)',
    colorNeutralBackground2Selected: 'var(--colorNeutralBackground2Selected)',
    colorNeutralBackground3: 'var(--colorNeutralBackground3)',
    colorNeutralBackground3Hover: 'var(--colorNeutralBackground3Hover)',
    colorNeutralBackground3Pressed: 'var(--colorNeutralBackground3Pressed)',
    colorNeutralBackground3Selected: 'var(--colorNeutralBackground3Selected)',
    colorNeutralBackground4: 'var(--colorNeutralBackground4)',
    colorNeutralBackground4Hover: 'var(--colorNeutralBackground4Hover)',
    colorNeutralBackground4Pressed: 'var(--colorNeutralBackground4Pressed)',
    colorNeutralBackground4Selected: 'var(--colorNeutralBackground4Selected)',
    colorNeutralBackground5: 'var(--colorNeutralBackground5)',
    colorNeutralBackground5Hover: 'var(--colorNeutralBackground5Hover)',
    colorNeutralBackground5Pressed: 'var(--colorNeutralBackground5Pressed)',
    colorNeutralBackground5Selected: 'var(--colorNeutralBackground5Selected)',
    colorNeutralBackground6: 'var(--colorNeutralBackground6)',
    colorNeutralBackground7: 'var(--colorNeutralBackground7)',
    colorNeutralBackground7Hover: 'var(--colorNeutralBackground7Hover)',
    colorNeutralBackground7Pressed: 'var(--colorNeutralBackground7Pressed)',
    colorNeutralBackground7Selected: 'var(--colorNeutralBackground7Selected)',
    colorNeutralBackground8: 'var(--colorNeutralBackground8)',
    colorNeutralBackgroundInverted: 'var(--colorNeutralBackgroundInverted)',
    colorNeutralBackgroundInvertedHover: 'var(--colorNeutralBackgroundInvertedHover)',
    colorNeutralBackgroundInvertedPressed: 'var(--colorNeutralBackgroundInvertedPressed)',
    colorNeutralBackgroundInvertedSelected: 'var(--colorNeutralBackgroundInvertedSelected)',
    colorNeutralBackgroundStatic: 'var(--colorNeutralBackgroundStatic)',
    colorNeutralBackgroundAlpha: 'var(--colorNeutralBackgroundAlpha)',
    colorNeutralBackgroundAlpha2: 'var(--colorNeutralBackgroundAlpha2)',
    colorSubtleBackground: 'var(--colorSubtleBackground)',
    colorSubtleBackgroundHover: 'var(--colorSubtleBackgroundHover)',
    colorSubtleBackgroundPressed: 'var(--colorSubtleBackgroundPressed)',
    colorSubtleBackgroundSelected: 'var(--colorSubtleBackgroundSelected)',
    colorSubtleBackgroundLightAlphaHover: 'var(--colorSubtleBackgroundLightAlphaHover)',
    colorSubtleBackgroundLightAlphaPressed: 'var(--colorSubtleBackgroundLightAlphaPressed)',
    colorSubtleBackgroundLightAlphaSelected: 'var(--colorSubtleBackgroundLightAlphaSelected)',
    colorSubtleBackgroundInverted: 'var(--colorSubtleBackgroundInverted)',
    colorSubtleBackgroundInvertedHover: 'var(--colorSubtleBackgroundInvertedHover)',
    colorSubtleBackgroundInvertedPressed: 'var(--colorSubtleBackgroundInvertedPressed)',
    colorSubtleBackgroundInvertedSelected: 'var(--colorSubtleBackgroundInvertedSelected)',
    colorTransparentBackground: 'var(--colorTransparentBackground)',
    colorTransparentBackgroundHover: 'var(--colorTransparentBackgroundHover)',
    colorTransparentBackgroundPressed: 'var(--colorTransparentBackgroundPressed)',
    colorTransparentBackgroundSelected: 'var(--colorTransparentBackgroundSelected)',
    colorNeutralBackgroundDisabled: 'var(--colorNeutralBackgroundDisabled)',
    colorNeutralBackgroundDisabled2: 'var(--colorNeutralBackgroundDisabled2)',
    colorNeutralBackgroundInvertedDisabled: 'var(--colorNeutralBackgroundInvertedDisabled)',
    colorNeutralStencil1: 'var(--colorNeutralStencil1)',
    colorNeutralStencil2: 'var(--colorNeutralStencil2)',
    colorNeutralStencil1Alpha: 'var(--colorNeutralStencil1Alpha)',
    colorNeutralStencil2Alpha: 'var(--colorNeutralStencil2Alpha)',
    colorBackgroundOverlay: 'var(--colorBackgroundOverlay)',
    colorScrollbarOverlay: 'var(--colorScrollbarOverlay)',
    colorBrandBackground: 'var(--colorBrandBackground)',
    colorBrandBackgroundHover: 'var(--colorBrandBackgroundHover)',
    colorBrandBackgroundPressed: 'var(--colorBrandBackgroundPressed)',
    colorBrandBackgroundSelected: 'var(--colorBrandBackgroundSelected)',
    colorCompoundBrandBackground: 'var(--colorCompoundBrandBackground)',
    colorCompoundBrandBackgroundHover: 'var(--colorCompoundBrandBackgroundHover)',
    colorCompoundBrandBackgroundPressed: 'var(--colorCompoundBrandBackgroundPressed)',
    colorBrandBackgroundStatic: 'var(--colorBrandBackgroundStatic)',
    colorBrandBackground2: 'var(--colorBrandBackground2)',
    colorBrandBackground2Hover: 'var(--colorBrandBackground2Hover)',
    colorBrandBackground2Pressed: 'var(--colorBrandBackground2Pressed)',
    colorBrandBackground3Static: 'var(--colorBrandBackground3Static)',
    colorBrandBackground4Static: 'var(--colorBrandBackground4Static)',
    colorBrandBackgroundInverted: 'var(--colorBrandBackgroundInverted)',
    colorBrandBackgroundInvertedHover: 'var(--colorBrandBackgroundInvertedHover)',
    colorBrandBackgroundInvertedPressed: 'var(--colorBrandBackgroundInvertedPressed)',
    colorBrandBackgroundInvertedSelected: 'var(--colorBrandBackgroundInvertedSelected)',
    colorNeutralCardBackground: 'var(--colorNeutralCardBackground)',
    colorNeutralCardBackgroundHover: 'var(--colorNeutralCardBackgroundHover)',
    colorNeutralCardBackgroundPressed: 'var(--colorNeutralCardBackgroundPressed)',
    colorNeutralCardBackgroundSelected: 'var(--colorNeutralCardBackgroundSelected)',
    colorNeutralCardBackgroundDisabled: 'var(--colorNeutralCardBackgroundDisabled)',
    colorNeutralStrokeAccessible: 'var(--colorNeutralStrokeAccessible)',
    colorNeutralStrokeAccessibleHover: 'var(--colorNeutralStrokeAccessibleHover)',
    colorNeutralStrokeAccessiblePressed: 'var(--colorNeutralStrokeAccessiblePressed)',
    colorNeutralStrokeAccessibleSelected: 'var(--colorNeutralStrokeAccessibleSelected)',
    colorNeutralStroke1: 'var(--colorNeutralStroke1)',
    colorNeutralStroke1Hover: 'var(--colorNeutralStroke1Hover)',
    colorNeutralStroke1Pressed: 'var(--colorNeutralStroke1Pressed)',
    colorNeutralStroke1Selected: 'var(--colorNeutralStroke1Selected)',
    colorNeutralStroke2: 'var(--colorNeutralStroke2)',
    colorNeutralStroke3: 'var(--colorNeutralStroke3)',
    colorNeutralStroke4: 'var(--colorNeutralStroke4)',
    colorNeutralStroke4Hover: 'var(--colorNeutralStroke4Hover)',
    colorNeutralStroke4Pressed: 'var(--colorNeutralStroke4Pressed)',
    colorNeutralStroke4Selected: 'var(--colorNeutralStroke4Selected)',
    colorNeutralStrokeSubtle: 'var(--colorNeutralStrokeSubtle)',
    colorNeutralStrokeOnBrand: 'var(--colorNeutralStrokeOnBrand)',
    colorNeutralStrokeOnBrand2: 'var(--colorNeutralStrokeOnBrand2)',
    colorNeutralStrokeOnBrand2Hover: 'var(--colorNeutralStrokeOnBrand2Hover)',
    colorNeutralStrokeOnBrand2Pressed: 'var(--colorNeutralStrokeOnBrand2Pressed)',
    colorNeutralStrokeOnBrand2Selected: 'var(--colorNeutralStrokeOnBrand2Selected)',
    colorBrandStroke1: 'var(--colorBrandStroke1)',
    colorBrandStroke2: 'var(--colorBrandStroke2)',
    colorBrandStroke2Hover: 'var(--colorBrandStroke2Hover)',
    colorBrandStroke2Pressed: 'var(--colorBrandStroke2Pressed)',
    colorBrandStroke2Contrast: 'var(--colorBrandStroke2Contrast)',
    colorCompoundBrandStroke: 'var(--colorCompoundBrandStroke)',
    colorCompoundBrandStrokeHover: 'var(--colorCompoundBrandStrokeHover)',
    colorCompoundBrandStrokePressed: 'var(--colorCompoundBrandStrokePressed)',
    colorNeutralStrokeDisabled: 'var(--colorNeutralStrokeDisabled)',
    colorNeutralStrokeDisabled2: 'var(--colorNeutralStrokeDisabled2)',
    colorNeutralStrokeInvertedDisabled: 'var(--colorNeutralStrokeInvertedDisabled)',
    colorTransparentStroke: 'var(--colorTransparentStroke)',
    colorTransparentStrokeInteractive: 'var(--colorTransparentStrokeInteractive)',
    colorTransparentStrokeDisabled: 'var(--colorTransparentStrokeDisabled)',
    colorNeutralStrokeAlpha: 'var(--colorNeutralStrokeAlpha)',
    colorNeutralStrokeAlpha2: 'var(--colorNeutralStrokeAlpha2)',
    colorStrokeFocus1: 'var(--colorStrokeFocus1)',
    colorStrokeFocus2: 'var(--colorStrokeFocus2)',
    colorNeutralShadowAmbient: 'var(--colorNeutralShadowAmbient)',
    colorNeutralShadowKey: 'var(--colorNeutralShadowKey)',
    colorNeutralShadowAmbientLighter: 'var(--colorNeutralShadowAmbientLighter)',
    colorNeutralShadowKeyLighter: 'var(--colorNeutralShadowKeyLighter)',
    colorNeutralShadowAmbientDarker: 'var(--colorNeutralShadowAmbientDarker)',
    colorNeutralShadowKeyDarker: 'var(--colorNeutralShadowKeyDarker)',
    colorBrandShadowAmbient: 'var(--colorBrandShadowAmbient)',
    colorBrandShadowKey: 'var(--colorBrandShadowKey)',
    // Color palette tokens
    // Color palette red tokens
    colorPaletteRedBackground1: 'var(--colorPaletteRedBackground1)',
    colorPaletteRedBackground2: 'var(--colorPaletteRedBackground2)',
    colorPaletteRedBackground3: 'var(--colorPaletteRedBackground3)',
    colorPaletteRedBorderActive: 'var(--colorPaletteRedBorderActive)',
    colorPaletteRedBorder1: 'var(--colorPaletteRedBorder1)',
    colorPaletteRedBorder2: 'var(--colorPaletteRedBorder2)',
    colorPaletteRedForeground1: 'var(--colorPaletteRedForeground1)',
    colorPaletteRedForeground2: 'var(--colorPaletteRedForeground2)',
    colorPaletteRedForeground3: 'var(--colorPaletteRedForeground3)',
    colorPaletteRedForegroundInverted: 'var(--colorPaletteRedForegroundInverted)',
    // Color palette green tokens
    colorPaletteGreenBackground1: 'var(--colorPaletteGreenBackground1)',
    colorPaletteGreenBackground2: 'var(--colorPaletteGreenBackground2)',
    colorPaletteGreenBackground3: 'var(--colorPaletteGreenBackground3)',
    colorPaletteGreenBorderActive: 'var(--colorPaletteGreenBorderActive)',
    colorPaletteGreenBorder1: 'var(--colorPaletteGreenBorder1)',
    colorPaletteGreenBorder2: 'var(--colorPaletteGreenBorder2)',
    colorPaletteGreenForeground1: 'var(--colorPaletteGreenForeground1)',
    colorPaletteGreenForeground2: 'var(--colorPaletteGreenForeground2)',
    colorPaletteGreenForeground3: 'var(--colorPaletteGreenForeground3)',
    colorPaletteGreenForegroundInverted: 'var(--colorPaletteGreenForegroundInverted)',
    // Color palette dark orange tokens
    colorPaletteDarkOrangeBackground1: 'var(--colorPaletteDarkOrangeBackground1)',
    colorPaletteDarkOrangeBackground2: 'var(--colorPaletteDarkOrangeBackground2)',
    colorPaletteDarkOrangeBackground3: 'var(--colorPaletteDarkOrangeBackground3)',
    colorPaletteDarkOrangeBorderActive: 'var(--colorPaletteDarkOrangeBorderActive)',
    colorPaletteDarkOrangeBorder1: 'var(--colorPaletteDarkOrangeBorder1)',
    colorPaletteDarkOrangeBorder2: 'var(--colorPaletteDarkOrangeBorder2)',
    colorPaletteDarkOrangeForeground1: 'var(--colorPaletteDarkOrangeForeground1)',
    colorPaletteDarkOrangeForeground2: 'var(--colorPaletteDarkOrangeForeground2)',
    colorPaletteDarkOrangeForeground3: 'var(--colorPaletteDarkOrangeForeground3)',
    // Color palette yellow tokens
    colorPaletteYellowBackground1: 'var(--colorPaletteYellowBackground1)',
    colorPaletteYellowBackground2: 'var(--colorPaletteYellowBackground2)',
    colorPaletteYellowBackground3: 'var(--colorPaletteYellowBackground3)',
    colorPaletteYellowBorderActive: 'var(--colorPaletteYellowBorderActive)',
    colorPaletteYellowBorder1: 'var(--colorPaletteYellowBorder1)',
    colorPaletteYellowBorder2: 'var(--colorPaletteYellowBorder2)',
    colorPaletteYellowForeground1: 'var(--colorPaletteYellowForeground1)',
    colorPaletteYellowForeground2: 'var(--colorPaletteYellowForeground2)',
    colorPaletteYellowForeground3: 'var(--colorPaletteYellowForeground3)',
    colorPaletteYellowForegroundInverted: 'var(--colorPaletteYellowForegroundInverted)',
    // Color palette berry tokens
    colorPaletteBerryBackground1: 'var(--colorPaletteBerryBackground1)',
    colorPaletteBerryBackground2: 'var(--colorPaletteBerryBackground2)',
    colorPaletteBerryBackground3: 'var(--colorPaletteBerryBackground3)',
    colorPaletteBerryBorderActive: 'var(--colorPaletteBerryBorderActive)',
    colorPaletteBerryBorder1: 'var(--colorPaletteBerryBorder1)',
    colorPaletteBerryBorder2: 'var(--colorPaletteBerryBorder2)',
    colorPaletteBerryForeground1: 'var(--colorPaletteBerryForeground1)',
    colorPaletteBerryForeground2: 'var(--colorPaletteBerryForeground2)',
    colorPaletteBerryForeground3: 'var(--colorPaletteBerryForeground3)',
    // Color palette marigold tokens
    colorPaletteMarigoldBackground1: 'var(--colorPaletteMarigoldBackground1)',
    colorPaletteMarigoldBackground2: 'var(--colorPaletteMarigoldBackground2)',
    colorPaletteMarigoldBackground3: 'var(--colorPaletteMarigoldBackground3)',
    colorPaletteMarigoldBorderActive: 'var(--colorPaletteMarigoldBorderActive)',
    colorPaletteMarigoldBorder1: 'var(--colorPaletteMarigoldBorder1)',
    colorPaletteMarigoldBorder2: 'var(--colorPaletteMarigoldBorder2)',
    colorPaletteMarigoldForeground1: 'var(--colorPaletteMarigoldForeground1)',
    colorPaletteMarigoldForeground2: 'var(--colorPaletteMarigoldForeground2)',
    colorPaletteMarigoldForeground3: 'var(--colorPaletteMarigoldForeground3)',
    // Color palette light green tokens
    colorPaletteLightGreenBackground1: 'var(--colorPaletteLightGreenBackground1)',
    colorPaletteLightGreenBackground2: 'var(--colorPaletteLightGreenBackground2)',
    colorPaletteLightGreenBackground3: 'var(--colorPaletteLightGreenBackground3)',
    colorPaletteLightGreenBorderActive: 'var(--colorPaletteLightGreenBorderActive)',
    colorPaletteLightGreenBorder1: 'var(--colorPaletteLightGreenBorder1)',
    colorPaletteLightGreenBorder2: 'var(--colorPaletteLightGreenBorder2)',
    colorPaletteLightGreenForeground1: 'var(--colorPaletteLightGreenForeground1)',
    colorPaletteLightGreenForeground2: 'var(--colorPaletteLightGreenForeground2)',
    colorPaletteLightGreenForeground3: 'var(--colorPaletteLightGreenForeground3)',
    // Color palette anchor tokens
    colorPaletteAnchorBackground2: 'var(--colorPaletteAnchorBackground2)',
    colorPaletteAnchorBorderActive: 'var(--colorPaletteAnchorBorderActive)',
    colorPaletteAnchorForeground2: 'var(--colorPaletteAnchorForeground2)',
    // Color palette beige tokens
    colorPaletteBeigeBackground2: 'var(--colorPaletteBeigeBackground2)',
    colorPaletteBeigeBorderActive: 'var(--colorPaletteBeigeBorderActive)',
    colorPaletteBeigeForeground2: 'var(--colorPaletteBeigeForeground2)',
    // Color palette blue tokens
    colorPaletteBlueBackground2: 'var(--colorPaletteBlueBackground2)',
    colorPaletteBlueBorderActive: 'var(--colorPaletteBlueBorderActive)',
    colorPaletteBlueForeground2: 'var(--colorPaletteBlueForeground2)',
    // Color palette brass tokens
    colorPaletteBrassBackground2: 'var(--colorPaletteBrassBackground2)',
    colorPaletteBrassBorderActive: 'var(--colorPaletteBrassBorderActive)',
    colorPaletteBrassForeground2: 'var(--colorPaletteBrassForeground2)',
    // Color palette brown tokens
    colorPaletteBrownBackground2: 'var(--colorPaletteBrownBackground2)',
    colorPaletteBrownBorderActive: 'var(--colorPaletteBrownBorderActive)',
    colorPaletteBrownForeground2: 'var(--colorPaletteBrownForeground2)',
    // Color palette cornflower tokens
    colorPaletteCornflowerBackground2: 'var(--colorPaletteCornflowerBackground2)',
    colorPaletteCornflowerBorderActive: 'var(--colorPaletteCornflowerBorderActive)',
    colorPaletteCornflowerForeground2: 'var(--colorPaletteCornflowerForeground2)',
    // Color palette cranberry tokens
    colorPaletteCranberryBackground2: 'var(--colorPaletteCranberryBackground2)',
    colorPaletteCranberryBorderActive: 'var(--colorPaletteCranberryBorderActive)',
    colorPaletteCranberryForeground2: 'var(--colorPaletteCranberryForeground2)',
    // Color palette dark green tokens
    colorPaletteDarkGreenBackground2: 'var(--colorPaletteDarkGreenBackground2)',
    colorPaletteDarkGreenBorderActive: 'var(--colorPaletteDarkGreenBorderActive)',
    colorPaletteDarkGreenForeground2: 'var(--colorPaletteDarkGreenForeground2)',
    // Color palette dark red tokens
    colorPaletteDarkRedBackground2: 'var(--colorPaletteDarkRedBackground2)',
    colorPaletteDarkRedBorderActive: 'var(--colorPaletteDarkRedBorderActive)',
    colorPaletteDarkRedForeground2: 'var(--colorPaletteDarkRedForeground2)',
    // Color palette forest tokens
    colorPaletteForestBackground2: 'var(--colorPaletteForestBackground2)',
    colorPaletteForestBorderActive: 'var(--colorPaletteForestBorderActive)',
    colorPaletteForestForeground2: 'var(--colorPaletteForestForeground2)',
    // Color palette gold tokens
    colorPaletteGoldBackground2: 'var(--colorPaletteGoldBackground2)',
    colorPaletteGoldBorderActive: 'var(--colorPaletteGoldBorderActive)',
    colorPaletteGoldForeground2: 'var(--colorPaletteGoldForeground2)',
    // Color palette grape tokens
    colorPaletteGrapeBackground2: 'var(--colorPaletteGrapeBackground2)',
    colorPaletteGrapeBorderActive: 'var(--colorPaletteGrapeBorderActive)',
    colorPaletteGrapeForeground2: 'var(--colorPaletteGrapeForeground2)',
    // Color palette lavender tokens
    colorPaletteLavenderBackground2: 'var(--colorPaletteLavenderBackground2)',
    colorPaletteLavenderBorderActive: 'var(--colorPaletteLavenderBorderActive)',
    colorPaletteLavenderForeground2: 'var(--colorPaletteLavenderForeground2)',
    // Color palette light teal tokens
    colorPaletteLightTealBackground2: 'var(--colorPaletteLightTealBackground2)',
    colorPaletteLightTealBorderActive: 'var(--colorPaletteLightTealBorderActive)',
    colorPaletteLightTealForeground2: 'var(--colorPaletteLightTealForeground2)',
    // Color palette lilac tokens
    colorPaletteLilacBackground2: 'var(--colorPaletteLilacBackground2)',
    colorPaletteLilacBorderActive: 'var(--colorPaletteLilacBorderActive)',
    colorPaletteLilacForeground2: 'var(--colorPaletteLilacForeground2)',
    // Color palette magenta tokens
    colorPaletteMagentaBackground2: 'var(--colorPaletteMagentaBackground2)',
    colorPaletteMagentaBorderActive: 'var(--colorPaletteMagentaBorderActive)',
    colorPaletteMagentaForeground2: 'var(--colorPaletteMagentaForeground2)',
    // Color palette mink tokens
    colorPaletteMinkBackground2: 'var(--colorPaletteMinkBackground2)',
    colorPaletteMinkBorderActive: 'var(--colorPaletteMinkBorderActive)',
    colorPaletteMinkForeground2: 'var(--colorPaletteMinkForeground2)',
    // Color palette navy tokens
    colorPaletteNavyBackground2: 'var(--colorPaletteNavyBackground2)',
    colorPaletteNavyBorderActive: 'var(--colorPaletteNavyBorderActive)',
    colorPaletteNavyForeground2: 'var(--colorPaletteNavyForeground2)',
    // Color palette peach tokens
    colorPalettePeachBackground2: 'var(--colorPalettePeachBackground2)',
    colorPalettePeachBorderActive: 'var(--colorPalettePeachBorderActive)',
    colorPalettePeachForeground2: 'var(--colorPalettePeachForeground2)',
    // Color palette pink tokens
    colorPalettePinkBackground2: 'var(--colorPalettePinkBackground2)',
    colorPalettePinkBorderActive: 'var(--colorPalettePinkBorderActive)',
    colorPalettePinkForeground2: 'var(--colorPalettePinkForeground2)',
    // Color palette platinum tokens
    colorPalettePlatinumBackground2: 'var(--colorPalettePlatinumBackground2)',
    colorPalettePlatinumBorderActive: 'var(--colorPalettePlatinumBorderActive)',
    colorPalettePlatinumForeground2: 'var(--colorPalettePlatinumForeground2)',
    // Color palette plum tokens
    colorPalettePlumBackground2: 'var(--colorPalettePlumBackground2)',
    colorPalettePlumBorderActive: 'var(--colorPalettePlumBorderActive)',
    colorPalettePlumForeground2: 'var(--colorPalettePlumForeground2)',
    // Color palette pumpkin tokens
    colorPalettePumpkinBackground2: 'var(--colorPalettePumpkinBackground2)',
    colorPalettePumpkinBorderActive: 'var(--colorPalettePumpkinBorderActive)',
    colorPalettePumpkinForeground2: 'var(--colorPalettePumpkinForeground2)',
    // Color palette purple tokens
    colorPalettePurpleBackground2: 'var(--colorPalettePurpleBackground2)',
    colorPalettePurpleBorderActive: 'var(--colorPalettePurpleBorderActive)',
    colorPalettePurpleForeground2: 'var(--colorPalettePurpleForeground2)',
    // Color palette royal blue tokens
    colorPaletteRoyalBlueBackground2: 'var(--colorPaletteRoyalBlueBackground2)',
    colorPaletteRoyalBlueBorderActive: 'var(--colorPaletteRoyalBlueBorderActive)',
    colorPaletteRoyalBlueForeground2: 'var(--colorPaletteRoyalBlueForeground2)',
    // Color palette seafoam tokens
    colorPaletteSeafoamBackground2: 'var(--colorPaletteSeafoamBackground2)',
    colorPaletteSeafoamBorderActive: 'var(--colorPaletteSeafoamBorderActive)',
    colorPaletteSeafoamForeground2: 'var(--colorPaletteSeafoamForeground2)',
    // Color palette steel tokens
    colorPaletteSteelBackground2: 'var(--colorPaletteSteelBackground2)',
    colorPaletteSteelBorderActive: 'var(--colorPaletteSteelBorderActive)',
    colorPaletteSteelForeground2: 'var(--colorPaletteSteelForeground2)',
    // Color palette teal tokens
    colorPaletteTealBackground2: 'var(--colorPaletteTealBackground2)',
    colorPaletteTealBorderActive: 'var(--colorPaletteTealBorderActive)',
    colorPaletteTealForeground2: 'var(--colorPaletteTealForeground2)',
    // Color status success tokens
    colorStatusSuccessBackground1: 'var(--colorStatusSuccessBackground1)',
    colorStatusSuccessBackground2: 'var(--colorStatusSuccessBackground2)',
    colorStatusSuccessBackground3: 'var(--colorStatusSuccessBackground3)',
    colorStatusSuccessForeground1: 'var(--colorStatusSuccessForeground1)',
    colorStatusSuccessForeground2: 'var(--colorStatusSuccessForeground2)',
    colorStatusSuccessForeground3: 'var(--colorStatusSuccessForeground3)',
    colorStatusSuccessForegroundInverted: 'var(--colorStatusSuccessForegroundInverted)',
    colorStatusSuccessBorderActive: 'var(--colorStatusSuccessBorderActive)',
    colorStatusSuccessBorder1: 'var(--colorStatusSuccessBorder1)',
    colorStatusSuccessBorder2: 'var(--colorStatusSuccessBorder2)',
    // Color status warning tokens
    colorStatusWarningBackground1: 'var(--colorStatusWarningBackground1)',
    colorStatusWarningBackground2: 'var(--colorStatusWarningBackground2)',
    colorStatusWarningBackground3: 'var(--colorStatusWarningBackground3)',
    colorStatusWarningForeground1: 'var(--colorStatusWarningForeground1)',
    colorStatusWarningForeground2: 'var(--colorStatusWarningForeground2)',
    colorStatusWarningForeground3: 'var(--colorStatusWarningForeground3)',
    colorStatusWarningForegroundInverted: 'var(--colorStatusWarningForegroundInverted)',
    colorStatusWarningBorderActive: 'var(--colorStatusWarningBorderActive)',
    colorStatusWarningBorder1: 'var(--colorStatusWarningBorder1)',
    colorStatusWarningBorder2: 'var(--colorStatusWarningBorder2)',
    // Color status danger tokens
    colorStatusDangerBackground1: 'var(--colorStatusDangerBackground1)',
    colorStatusDangerBackground2: 'var(--colorStatusDangerBackground2)',
    colorStatusDangerBackground3: 'var(--colorStatusDangerBackground3)',
    colorStatusDangerBackground3Hover: 'var(--colorStatusDangerBackground3Hover)',
    colorStatusDangerBackground3Pressed: 'var(--colorStatusDangerBackground3Pressed)',
    colorStatusDangerForeground1: 'var(--colorStatusDangerForeground1)',
    colorStatusDangerForeground2: 'var(--colorStatusDangerForeground2)',
    colorStatusDangerForeground3: 'var(--colorStatusDangerForeground3)',
    colorStatusDangerForegroundInverted: 'var(--colorStatusDangerForegroundInverted)',
    colorStatusDangerBorderActive: 'var(--colorStatusDangerBorderActive)',
    colorStatusDangerBorder1: 'var(--colorStatusDangerBorder1)',
    colorStatusDangerBorder2: 'var(--colorStatusDangerBorder2)',
    // Border radius tokens
    borderRadiusNone: 'var(--borderRadiusNone)',
    borderRadiusSmall: 'var(--borderRadiusSmall)',
    borderRadiusMedium: 'var(--borderRadiusMedium)',
    borderRadiusLarge: 'var(--borderRadiusLarge)',
    borderRadiusXLarge: 'var(--borderRadiusXLarge)',
    borderRadius2XLarge: 'var(--borderRadius2XLarge)',
    borderRadius3XLarge: 'var(--borderRadius3XLarge)',
    borderRadius4XLarge: 'var(--borderRadius4XLarge)',
    borderRadius5XLarge: 'var(--borderRadius5XLarge)',
    borderRadius6XLarge: 'var(--borderRadius6XLarge)',
    borderRadiusCircular: 'var(--borderRadiusCircular)',
    // Font family tokens
    fontFamilyBase: 'var(--fontFamilyBase)',
    fontFamilyMonospace: 'var(--fontFamilyMonospace)',
    fontFamilyNumeric: 'var(--fontFamilyNumeric)',
    // Font size tokens
    fontSizeBase100: 'var(--fontSizeBase100)',
    fontSizeBase200: 'var(--fontSizeBase200)',
    fontSizeBase300: 'var(--fontSizeBase300)',
    fontSizeBase400: 'var(--fontSizeBase400)',
    fontSizeBase500: 'var(--fontSizeBase500)',
    fontSizeBase600: 'var(--fontSizeBase600)',
    fontSizeHero700: 'var(--fontSizeHero700)',
    fontSizeHero800: 'var(--fontSizeHero800)',
    fontSizeHero900: 'var(--fontSizeHero900)',
    fontSizeHero1000: 'var(--fontSizeHero1000)',
    // Font weight tokens
    fontWeightRegular: 'var(--fontWeightRegular)',
    fontWeightMedium: 'var(--fontWeightMedium)',
    fontWeightSemibold: 'var(--fontWeightSemibold)',
    fontWeightBold: 'var(--fontWeightBold)',
    // Line height tokens
    lineHeightBase100: 'var(--lineHeightBase100)',
    lineHeightBase200: 'var(--lineHeightBase200)',
    lineHeightBase300: 'var(--lineHeightBase300)',
    lineHeightBase400: 'var(--lineHeightBase400)',
    lineHeightBase500: 'var(--lineHeightBase500)',
    lineHeightBase600: 'var(--lineHeightBase600)',
    lineHeightHero700: 'var(--lineHeightHero700)',
    lineHeightHero800: 'var(--lineHeightHero800)',
    lineHeightHero900: 'var(--lineHeightHero900)',
    lineHeightHero1000: 'var(--lineHeightHero1000)',
    // Shadow tokens
    shadow2: 'var(--shadow2)',
    shadow4: 'var(--shadow4)',
    shadow8: 'var(--shadow8)',
    shadow16: 'var(--shadow16)',
    shadow28: 'var(--shadow28)',
    shadow64: 'var(--shadow64)',
    // Shadow brand tokens
    shadow2Brand: 'var(--shadow2Brand)',
    shadow4Brand: 'var(--shadow4Brand)',
    shadow8Brand: 'var(--shadow8Brand)',
    shadow16Brand: 'var(--shadow16Brand)',
    shadow28Brand: 'var(--shadow28Brand)',
    shadow64Brand: 'var(--shadow64Brand)',
    // Stroke width tokens
    strokeWidthThin: 'var(--strokeWidthThin)',
    strokeWidthThick: 'var(--strokeWidthThick)',
    strokeWidthThicker: 'var(--strokeWidthThicker)',
    strokeWidthThickest: 'var(--strokeWidthThickest)',
    // Spacings
    spacingHorizontalNone: 'var(--spacingHorizontalNone)',
    spacingHorizontalXXS: 'var(--spacingHorizontalXXS)',
    spacingHorizontalXS: 'var(--spacingHorizontalXS)',
    spacingHorizontalSNudge: 'var(--spacingHorizontalSNudge)',
    spacingHorizontalS: 'var(--spacingHorizontalS)',
    spacingHorizontalMNudge: 'var(--spacingHorizontalMNudge)',
    spacingHorizontalM: 'var(--spacingHorizontalM)',
    spacingHorizontalL: 'var(--spacingHorizontalL)',
    spacingHorizontalXL: 'var(--spacingHorizontalXL)',
    spacingHorizontalXXL: 'var(--spacingHorizontalXXL)',
    spacingHorizontalXXXL: 'var(--spacingHorizontalXXXL)',
    spacingVerticalNone: 'var(--spacingVerticalNone)',
    spacingVerticalXXS: 'var(--spacingVerticalXXS)',
    spacingVerticalXS: 'var(--spacingVerticalXS)',
    spacingVerticalSNudge: 'var(--spacingVerticalSNudge)',
    spacingVerticalS: 'var(--spacingVerticalS)',
    spacingVerticalMNudge: 'var(--spacingVerticalMNudge)',
    spacingVerticalM: 'var(--spacingVerticalM)',
    spacingVerticalL: 'var(--spacingVerticalL)',
    spacingVerticalXL: 'var(--spacingVerticalXL)',
    spacingVerticalXXL: 'var(--spacingVerticalXXL)',
    spacingVerticalXXXL: 'var(--spacingVerticalXXXL)',
    // Durations
    durationUltraFast: 'var(--durationUltraFast)',
    durationFaster: 'var(--durationFaster)',
    durationFast: 'var(--durationFast)',
    durationNormal: 'var(--durationNormal)',
    durationGentle: 'var(--durationGentle)',
    durationSlow: 'var(--durationSlow)',
    durationSlower: 'var(--durationSlower)',
    durationUltraSlow: 'var(--durationUltraSlow)',
    // Curves
    curveAccelerateMax: 'var(--curveAccelerateMax)',
    curveAccelerateMid: 'var(--curveAccelerateMid)',
    curveAccelerateMin: 'var(--curveAccelerateMin)',
    curveDecelerateMax: 'var(--curveDecelerateMax)',
    curveDecelerateMid: 'var(--curveDecelerateMid)',
    curveDecelerateMin: 'var(--curveDecelerateMin)',
    curveEasyEaseMax: 'var(--curveEasyEaseMax)',
    curveEasyEase: 'var(--curveEasyEase)',
    curveLinear: 'var(--curveLinear)',
    /**
   * ZIndexes
   * Special case where the tokens contain default values
   * ZIndexes are not mandatory, so they are not included in the theme, but can be used as tokens with default values
   */ /**
   * Elevation 0
   * Can be used for background elements, like surfaces
   */ zIndexBackground: 'var(--zIndexBackground, 0)',
    /**
   * Elevation 2
   * Can be used content that is on top of the background, like cards
   */ zIndexContent: 'var(--zIndexContent, 1)',
    /**
   * Elevation 4
   * Can be used for overlays, like the backdrop of a modal
   */ zIndexOverlay: 'var(--zIndexOverlay, 1000)',
    /**
   * Elevation 8
   * Can be used for popups, like modals and drawers
   */ zIndexPopup: 'var(--zIndexPopup, 2000)',
    /**
   * Elevation 16
   * Can be used for messages, like snackbars and toasts
   */ zIndexMessages: 'var(--zIndexMessages, 3000)',
    /**
   * Elevation 28
   * Can be used for floating elements, like dropdowns
   */ zIndexFloating: 'var(--zIndexFloating, 4000)',
    /**
   * Elevation 64
   * Can be used for high priority floating elements, like tooltips
   */ zIndexPriority: 'var(--zIndexPriority, 5000)',
    /**
   * Special elevation
   * Can be used for elements that need to be above everything else, like debug overlays
   */ zIndexDebug: 'var(--zIndexDebug, 6000)'
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$export$a1195ad1c253d145 = "data-tabster";
const $e3e23e1e89ad903c$export$22865d31b7a9c589 = "data-tabster-dummy";
const $e3e23e1e89ad903c$export$9352ce9777935162 = `:is(${[
    "a[href]",
    "button",
    "input",
    "select",
    "textarea",
    "*[tabindex]",
    "*[contenteditable]",
    "details > summary",
    "audio[controls]",
    "video[controls]"
].join(", ")}):not(:disabled)`;
const $e3e23e1e89ad903c$export$ef584e37c331a849 = {
    EscapeGroupper: 1,
    Restorer: 2,
    Deloser: 3
};
const $e3e23e1e89ad903c$export$4c90aef933fea154 = {
    Any: 0,
    Accessible: 1,
    Focusable: 2
};
const $e3e23e1e89ad903c$export$4f32fe00a6fbdffb = {
    Waiting: 0,
    Succeeded: 1,
    Canceled: 2,
    TimedOut: 3
};
const $e3e23e1e89ad903c$export$a4de902e8828c943 = {
    CanceledFocusChange: 1,
    TimeoutElementNotInDOM: 2,
    TimeoutElementNotAccessible: 3,
    TimeoutElementNotFocusable: 4,
    TimeoutElementNotReady: 5,
    SupersededByNewRequest: 6,
    FocusCallFailed: 7
};
const $e3e23e1e89ad903c$export$469ba0ed3bc01311 = {
    History: 0,
    DeloserDefault: 1,
    RootDefault: 2,
    DeloserFirst: 3,
    RootFirst: 4
};
const $e3e23e1e89ad903c$export$5b8aeea6fc4d16f4 = {
    /**
   * If the focus is lost, the focus will be restored automatically using all available focus history.
   * This is the default strategy.
   */ Auto: 0,
    /**
   * If the focus is lost from this Deloser instance, the focus will not be restored automatically.
   * The application might listen to the event and restore the focus manually.
   * But if it is lost from another Deloser instance, the history of this Deloser could be used finding
   * the element to focus.
   */ Manual: 1
};
const $e3e23e1e89ad903c$export$878d96173d57e644 = {
    Invisible: 0,
    PartiallyVisible: 1,
    Visible: 2
};
const $e3e23e1e89ad903c$export$86e1fd7e23a4fab4 = {
    Source: 0,
    Target: 1
};
const $e3e23e1e89ad903c$export$7c43ed5d018e9c17 = {
    Both: 0,
    // Default, both left/up keys move to the previous, right/down move to the next.
    Vertical: 1,
    // Only up/down arrows move to the next/previous.
    Horizontal: 2,
    // Only left/right arrows move to the next/previous.
    Grid: 3,
    // Two-dimentional movement depending on the visual placement.
    GridLinear: 4 // Two-dimentional movement depending on the visual placement. Allows linear movement.
};
const $e3e23e1e89ad903c$export$cb3e5a20e92ebf87 = {
    ArrowUp: 1,
    ArrowDown: 2,
    ArrowLeft: 3,
    ArrowRight: 4,
    PageUp: 5,
    PageDown: 6,
    Home: 7,
    End: 8
};
const $e3e23e1e89ad903c$export$7ee1c0e36fdd1f6d = {
    Unlimited: 0,
    Limited: 1,
    // The tabbability is limited to the container and explicit Enter is needed to go inside.
    LimitedTrapFocus: 2 // The focus is limited as above, plus trapped when inside.
};
const $e3e23e1e89ad903c$export$16ef694586cb4846 = {
    Enter: 1,
    Escape: 2
};
const $e3e23e1e89ad903c$export$982c91672ba981ed = {
    Auto: 0,
    // Tabster will place dummy inputs depending on the container tag name and on the default behaviour.
    Inside: 1,
    // Tabster will always place dummy inputs inside the container.
    Outside: 2 // Tabster will always place dummy inputs outside of the container.
};
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, element) {
    var _a;
    return (_a = tabster.storageEntry(element)) === null || _a === void 0 ? void 0 : _a.tabster;
}
function $e3e23e1e89ad903c$var$updateTabsterByAttribute(tabster, element, dispose) {
    var _a, _b, _c;
    const newAttrValue = dispose || tabster._noop ? undefined : element.getAttribute($e3e23e1e89ad903c$export$a1195ad1c253d145);
    let entry = tabster.storageEntry(element);
    let newAttr;
    if (newAttrValue) {
        if (newAttrValue !== ((_a = entry === null || entry === void 0 ? void 0 : entry.attr) === null || _a === void 0 ? void 0 : _a.string)) try {
            const newValue = JSON.parse(newAttrValue);
            if (typeof newValue !== "object") throw new Error(`Value is not a JSON object, got '${newAttrValue}'.`);
            newAttr = {
                string: newAttrValue,
                object: newValue
            };
        } catch (e) {}
        else return;
    } else if (!entry) return;
    if (!entry) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entry = tabster.storageEntry(element, true);
    if (!entry.tabster) entry.tabster = {};
    const tabsterOnElement = entry.tabster || {};
    const oldTabsterProps = ((_b = entry.attr) === null || _b === void 0 ? void 0 : _b.object) || {};
    const newTabsterProps = (newAttr === null || newAttr === void 0 ? void 0 : newAttr.object) || {};
    for (const key of Object.keys(oldTabsterProps))if (!newTabsterProps[key]) {
        if (key === "root") {
            const root = tabsterOnElement[key];
            if (root) tabster.root.onRoot(root, true);
        }
        switch(key){
            case "deloser":
            case "root":
            case "groupper":
            case "modalizer":
            case "restorer":
            case "mover":
                // eslint-disable-next-line no-case-declarations
                const part = tabsterOnElement[key];
                if (part) {
                    part.dispose();
                    delete tabsterOnElement[key];
                }
                break;
            case "observed":
                delete tabsterOnElement[key];
                if (tabster.observedElement) tabster.observedElement.onObservedElementUpdate(element);
                break;
            case "focusable":
            case "outline":
            case "uncontrolled":
            case "sys":
                delete tabsterOnElement[key];
                break;
        }
    }
    for (const key of Object.keys(newTabsterProps)){
        const sys = newTabsterProps.sys;
        switch(key){
            case "deloser":
                if (tabsterOnElement.deloser) tabsterOnElement.deloser.setProps(newTabsterProps.deloser);
                else if (tabster.deloser) tabsterOnElement.deloser = tabster.deloser.createDeloser(element, newTabsterProps.deloser);
                break;
            case "root":
                if (tabsterOnElement.root) tabsterOnElement.root.setProps(newTabsterProps.root);
                else tabsterOnElement.root = tabster.root.createRoot(element, newTabsterProps.root, sys);
                tabster.root.onRoot(tabsterOnElement.root);
                break;
            case "modalizer":
                {
                    let newModalizerProps;
                    const modalizerAPI = tabster.modalizer;
                    if (tabsterOnElement.modalizer) {
                        const props = newTabsterProps.modalizer;
                        const newModalizerId = props.id;
                        if (newModalizerId && ((_c = oldTabsterProps === null || oldTabsterProps === void 0 ? void 0 : oldTabsterProps.modalizer) === null || _c === void 0 ? void 0 : _c.id) !== newModalizerId) {
                            // Modalizer id is changed, given the modalizers have complex logic and could be
                            // composite, it is easier to recreate the Modalizer instance than to implement
                            // the id update.
                            tabsterOnElement.modalizer.dispose();
                            newModalizerProps = props;
                        } else tabsterOnElement.modalizer.setProps(props);
                    } else if (modalizerAPI) newModalizerProps = newTabsterProps.modalizer;
                    if (modalizerAPI && newModalizerProps) tabsterOnElement.modalizer = modalizerAPI.createModalizer(element, newModalizerProps, sys);
                }
                break;
            case "restorer":
                if (tabsterOnElement.restorer) tabsterOnElement.restorer.setProps(newTabsterProps.restorer);
                else {
                    if (tabster.restorer) {
                        if (newTabsterProps.restorer) tabsterOnElement.restorer = tabster.restorer.createRestorer(element, newTabsterProps.restorer);
                    }
                }
                break;
            case "focusable":
                tabsterOnElement.focusable = newTabsterProps.focusable;
                break;
            case "groupper":
                if (tabsterOnElement.groupper) tabsterOnElement.groupper.setProps(newTabsterProps.groupper);
                else if (tabster.groupper) tabsterOnElement.groupper = tabster.groupper.createGroupper(element, newTabsterProps.groupper, sys);
                break;
            case "mover":
                if (tabsterOnElement.mover) tabsterOnElement.mover.setProps(newTabsterProps.mover);
                else if (tabster.mover) tabsterOnElement.mover = tabster.mover.createMover(element, newTabsterProps.mover, sys);
                break;
            case "observed":
                if (tabster.observedElement) {
                    tabsterOnElement.observed = newTabsterProps.observed;
                    tabster.observedElement.onObservedElementUpdate(element);
                }
                break;
            case "uncontrolled":
                tabsterOnElement.uncontrolled = newTabsterProps.uncontrolled;
                break;
            case "outline":
                if (tabster.outline) tabsterOnElement.outline = newTabsterProps.outline;
                break;
            case "sys":
                tabsterOnElement.sys = newTabsterProps.sys;
                break;
            default:
                console.error(`Unknown key '${key}' in data-tabster attribute value.`);
        }
    }
    if (newAttr) entry.attr = newAttr;
    else {
        if (Object.keys(tabsterOnElement).length === 0) {
            delete entry.tabster;
            delete entry.attr;
        }
        tabster.storageEntry(element, false);
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Events sent by Tabster.
 */ const $e3e23e1e89ad903c$export$ae0b8c64bcbb585d = "tabster:focusin";
const $e3e23e1e89ad903c$export$f9101ff89ea52cc1 = "tabster:focusout";
// Event is dispatched when Tabster wants to move focus as the result of
// handling keyboard event. This allows to preventDefault() if you want to have
// some custom logic.
const $e3e23e1e89ad903c$export$80541a59aecfcfb5 = "tabster:movefocus";
/**
 * Events sent by Deloser.
 */ const $e3e23e1e89ad903c$export$7478210b325f123a = "tabster:deloser:focus-lost";
/**
 * Events to be sent to Deloser by the application.
 */ const $e3e23e1e89ad903c$export$87ff539c9b9c8c83 = "tabster:deloser:restore-focus";
/**
 * Events sent by Modalizer.
 */ const $e3e23e1e89ad903c$export$4c6486520efccc97 = "tabster:modalizer:active";
const $e3e23e1e89ad903c$export$b7bdb381786195e3 = "tabster:modalizer:inactive";
const $e3e23e1e89ad903c$export$f92ec62f67d1a1fb = "tabster:modalizer:focusin";
const $e3e23e1e89ad903c$export$7d57d7582dee5261 = "tabster:modalizer:focusout";
/**
 * Events sent by Mover.
 */ const $e3e23e1e89ad903c$export$1ec4dd77f5612bf6 = "tabster:mover:state";
/**
 * Events to be sent to Mover by the application.
 */ // Event that can be dispatched by the application to programmatically move
// focus inside Mover.
const $e3e23e1e89ad903c$export$3a927ee2f95ddfa = "tabster:mover:movefocus";
// Event that can be dispatched by the application to forget or modify
// memorized element in Mover with memorizeCurrent property.
const $e3e23e1e89ad903c$export$f538b9d389680b27 = "tabster:mover:memorized-element";
/**
 * Events sent by Groupper.
 */ /**
 * Events to be sent to Groupper by the application.
 */ // Event that can be dispatched by the application to programmatically enter
// or escape Groupper.
const $e3e23e1e89ad903c$export$7e4efd5c8bf2a678 = "tabster:groupper:movefocus";
/**
 * Events sent by Restorer.
 */ const $e3e23e1e89ad903c$export$3d63c9b40c6a05c3 = "tabster:restorer:restore-focus";
/**
 * Events sent by Root.
 */ const $e3e23e1e89ad903c$export$2e2b4254629c7d58 = "tabster:root:focus";
const $e3e23e1e89ad903c$export$88131e0157680e6a = "tabster:root:blur";
// Node.js environments do not have CustomEvent and it is needed for the events to be
// evaluated. It doesn't matter if it works or not in Node.js environment.
// So, we just need to make sure that it doesn't throw undefined reference.
const $e3e23e1e89ad903c$var$CustomEvent_ = typeof CustomEvent !== "undefined" ? CustomEvent : function() {
/* no-op */ };
class $e3e23e1e89ad903c$export$208738e9f5d41bd1 extends $e3e23e1e89ad903c$var$CustomEvent_ {
    constructor(type, detail){
        super(type, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
        this.details = detail;
    }
}
class $e3e23e1e89ad903c$export$2409322399d631d9 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$ae0b8c64bcbb585d, detail);
    }
}
class $e3e23e1e89ad903c$export$731508468a1b9ed2 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$f9101ff89ea52cc1, detail);
    }
}
class $e3e23e1e89ad903c$export$94e7298c3ba0dcfc extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$80541a59aecfcfb5, detail);
    }
}
class $e3e23e1e89ad903c$export$4237cba23bf0663d extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$1ec4dd77f5612bf6, detail);
    }
}
class $e3e23e1e89ad903c$export$6f00fc054b25f3c9 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$3a927ee2f95ddfa, detail);
    }
}
class $e3e23e1e89ad903c$export$bb8a944455e0ecdf extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$f538b9d389680b27, detail);
    }
}
class $e3e23e1e89ad903c$export$e6a82560201109 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$7e4efd5c8bf2a678, detail);
    }
}
class $e3e23e1e89ad903c$export$c375a7c49fb7a7ca extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$4c6486520efccc97, detail);
    }
}
class $e3e23e1e89ad903c$export$2ee7f26c7f1dcf9c extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$b7bdb381786195e3, detail);
    }
}
class $e3e23e1e89ad903c$export$4dbd4cf004af5f30 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$7478210b325f123a, detail);
    }
}
class $e3e23e1e89ad903c$export$553c0cff9981e8af extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(){
        super($e3e23e1e89ad903c$export$87ff539c9b9c8c83);
    }
}
class $e3e23e1e89ad903c$export$39f4c1150b8485d9 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(){
        super($e3e23e1e89ad903c$export$3d63c9b40c6a05c3);
    }
}
class $e3e23e1e89ad903c$export$8606e9d746120bb0 extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$2e2b4254629c7d58, detail);
    }
}
class $e3e23e1e89ad903c$export$4122e0ec6dadc59a extends $e3e23e1e89ad903c$export$208738e9f5d41bd1 {
    constructor(detail){
        super($e3e23e1e89ad903c$export$88131e0157680e6a, detail);
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$_createMutationObserver = (callback)=>new MutationObserver(callback);
const $e3e23e1e89ad903c$var$_createTreeWalker = (doc, root, whatToShow, filter)=>doc.createTreeWalker(root, whatToShow, filter);
const $e3e23e1e89ad903c$var$_getParentNode = (node)=>node ? node.parentNode : null;
const $e3e23e1e89ad903c$var$_getParentElement = (element)=>element ? element.parentElement : null;
const $e3e23e1e89ad903c$var$_nodeContains = (parent, child)=>!!(child && (parent === null || parent === void 0 ? void 0 : parent.contains(child)));
const $e3e23e1e89ad903c$var$_getActiveElement = (doc)=>doc.activeElement;
const $e3e23e1e89ad903c$var$_querySelector = (element, selector)=>element.querySelector(selector);
const $e3e23e1e89ad903c$var$_querySelectorAll = (element, selector)=>Array.prototype.slice.call(element.querySelectorAll(selector), 0);
const $e3e23e1e89ad903c$var$_getElementById = (doc, id)=>doc.getElementById(id);
const $e3e23e1e89ad903c$var$_getFirstChild = (node)=>(node === null || node === void 0 ? void 0 : node.firstChild) || null;
const $e3e23e1e89ad903c$var$_getLastChild = (node)=>(node === null || node === void 0 ? void 0 : node.lastChild) || null;
const $e3e23e1e89ad903c$var$_getNextSibling = (node)=>(node === null || node === void 0 ? void 0 : node.nextSibling) || null;
const $e3e23e1e89ad903c$var$_getPreviousSibling = (node)=>(node === null || node === void 0 ? void 0 : node.previousSibling) || null;
const $e3e23e1e89ad903c$var$_getFirstElementChild = (element)=>(element === null || element === void 0 ? void 0 : element.firstElementChild) || null;
const $e3e23e1e89ad903c$var$_getLastElementChild = (element)=>(element === null || element === void 0 ? void 0 : element.lastElementChild) || null;
const $e3e23e1e89ad903c$var$_getNextElementSibling = (element)=>(element === null || element === void 0 ? void 0 : element.nextElementSibling) || null;
const $e3e23e1e89ad903c$var$_getPreviousElementSibling = (element)=>(element === null || element === void 0 ? void 0 : element.previousElementSibling) || null;
const $e3e23e1e89ad903c$var$_appendChild = (parent, child)=>parent.appendChild(child);
const $e3e23e1e89ad903c$var$_insertBefore = (parent, child, referenceChild)=>parent.insertBefore(child, referenceChild);
const $e3e23e1e89ad903c$var$_getSelection = (ref)=>{
    var _a;
    return ((_a = ref.ownerDocument) === null || _a === void 0 ? void 0 : _a.getSelection()) || null;
};
const $e3e23e1e89ad903c$var$_getElementsByName = (referenceElement, name)=>referenceElement.ownerDocument.getElementsByName(name);
const $e3e23e1e89ad903c$var$dom = {
    createMutationObserver: $e3e23e1e89ad903c$var$_createMutationObserver,
    createTreeWalker: $e3e23e1e89ad903c$var$_createTreeWalker,
    getParentNode: $e3e23e1e89ad903c$var$_getParentNode,
    getParentElement: $e3e23e1e89ad903c$var$_getParentElement,
    nodeContains: $e3e23e1e89ad903c$var$_nodeContains,
    getActiveElement: $e3e23e1e89ad903c$var$_getActiveElement,
    querySelector: $e3e23e1e89ad903c$var$_querySelector,
    querySelectorAll: $e3e23e1e89ad903c$var$_querySelectorAll,
    getElementById: $e3e23e1e89ad903c$var$_getElementById,
    getFirstChild: $e3e23e1e89ad903c$var$_getFirstChild,
    getLastChild: $e3e23e1e89ad903c$var$_getLastChild,
    getNextSibling: $e3e23e1e89ad903c$var$_getNextSibling,
    getPreviousSibling: $e3e23e1e89ad903c$var$_getPreviousSibling,
    getFirstElementChild: $e3e23e1e89ad903c$var$_getFirstElementChild,
    getLastElementChild: $e3e23e1e89ad903c$var$_getLastElementChild,
    getNextElementSibling: $e3e23e1e89ad903c$var$_getNextElementSibling,
    getPreviousElementSibling: $e3e23e1e89ad903c$var$_getPreviousElementSibling,
    appendChild: $e3e23e1e89ad903c$var$_appendChild,
    insertBefore: $e3e23e1e89ad903c$var$_insertBefore,
    getSelection: $e3e23e1e89ad903c$var$_getSelection,
    getElementsByName: $e3e23e1e89ad903c$var$_getElementsByName
};
function $e3e23e1e89ad903c$var$setDOMAPI(domapi) {
    for (const key of Object.keys(domapi))$e3e23e1e89ad903c$var$dom[key] = domapi[key];
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ let $e3e23e1e89ad903c$var$_isBrokenIE11;
const $e3e23e1e89ad903c$var$_DOMRect = typeof DOMRect !== "undefined" ? DOMRect : class {
    constructor(x, y, width, height){
        this.left = x || 0;
        this.top = y || 0;
        this.right = (x || 0) + (width || 0);
        this.bottom = (y || 0) + (height || 0);
    }
};
let $e3e23e1e89ad903c$var$_uidCounter = 0;
try {
    // IE11 only accepts `filter` argument as a function (not object with the `acceptNode`
    // property as the docs define). Also `entityReferenceExpansion` argument is not
    // optional. And it throws exception when the above arguments aren't there.
    document.createTreeWalker(document, NodeFilter.SHOW_ELEMENT);
    $e3e23e1e89ad903c$var$_isBrokenIE11 = false;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
} catch (e) {
    $e3e23e1e89ad903c$var$_isBrokenIE11 = true;
}
const $e3e23e1e89ad903c$var$_updateDummyInputsTimeout = 100;
function $e3e23e1e89ad903c$var$getInstanceContext(getWindow) {
    const win = getWindow();
    let ctx = win.__tabsterInstanceContext;
    if (!ctx) {
        ctx = {
            elementByUId: {},
            basics: {
                Promise: win.Promise || undefined,
                WeakRef: win.WeakRef || undefined
            },
            containerBoundingRectCache: {},
            lastContainerBoundingRectCacheId: 0,
            fakeWeakRefs: [],
            fakeWeakRefsStarted: false
        };
        win.__tabsterInstanceContext = ctx;
    }
    return ctx;
}
function $e3e23e1e89ad903c$var$disposeInstanceContext(win) {
    const ctx = win.__tabsterInstanceContext;
    if (ctx) {
        ctx.elementByUId = {};
        delete ctx.WeakRef;
        ctx.containerBoundingRectCache = {};
        if (ctx.containerBoundingRectCacheTimer) win.clearTimeout(ctx.containerBoundingRectCacheTimer);
        if (ctx.fakeWeakRefsTimer) win.clearTimeout(ctx.fakeWeakRefsTimer);
        ctx.fakeWeakRefs = [];
        delete win.__tabsterInstanceContext;
    }
}
function $e3e23e1e89ad903c$var$createWeakMap(win) {
    const ctx = win.__tabsterInstanceContext;
    return new ((ctx === null || ctx === void 0 ? void 0 : ctx.basics.WeakMap) || WeakMap)();
}
function $e3e23e1e89ad903c$var$hasSubFocusable(element) {
    return !!element.querySelector($e3e23e1e89ad903c$export$9352ce9777935162);
}
class $e3e23e1e89ad903c$var$FakeWeakRef {
    constructor(target){
        this._target = target;
    }
    deref() {
        return this._target;
    }
    static cleanup(fwr, forceRemove) {
        if (!fwr._target) return true;
        if (forceRemove || !$e3e23e1e89ad903c$var$documentContains(fwr._target.ownerDocument, fwr._target)) {
            delete fwr._target;
            return true;
        }
        return false;
    }
}
class $e3e23e1e89ad903c$var$WeakHTMLElement {
    constructor(getWindow, element, data){
        const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
        let ref;
        if (context.WeakRef) ref = new context.WeakRef(element);
        else {
            ref = new $e3e23e1e89ad903c$var$FakeWeakRef(element);
            context.fakeWeakRefs.push(ref);
        }
        this._ref = ref;
        this._data = data;
    }
    get() {
        const ref = this._ref;
        let element;
        if (ref) {
            element = ref.deref();
            if (!element) delete this._ref;
        }
        return element;
    }
    getData() {
        return this._data;
    }
}
function $e3e23e1e89ad903c$var$cleanupFakeWeakRefs(getWindow, forceRemove) {
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    context.fakeWeakRefs = context.fakeWeakRefs.filter((e)=>!$e3e23e1e89ad903c$var$FakeWeakRef.cleanup(e, forceRemove));
}
function $e3e23e1e89ad903c$var$startFakeWeakRefsCleanup(getWindow) {
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    if (!context.fakeWeakRefsStarted) {
        context.fakeWeakRefsStarted = true;
        context.WeakRef = $e3e23e1e89ad903c$var$getWeakRef(context);
    }
    if (!context.fakeWeakRefsTimer) context.fakeWeakRefsTimer = getWindow().setTimeout(()=>{
        context.fakeWeakRefsTimer = undefined;
        $e3e23e1e89ad903c$var$cleanupFakeWeakRefs(getWindow);
        $e3e23e1e89ad903c$var$startFakeWeakRefsCleanup(getWindow);
    }, 120000); // 2 minutes.
}
function $e3e23e1e89ad903c$var$stopFakeWeakRefsCleanupAndClearStorage(getWindow) {
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    context.fakeWeakRefsStarted = false;
    if (context.fakeWeakRefsTimer) {
        getWindow().clearTimeout(context.fakeWeakRefsTimer);
        context.fakeWeakRefsTimer = undefined;
        context.fakeWeakRefs = [];
    }
}
function $e3e23e1e89ad903c$var$createElementTreeWalker(doc, root, acceptNode) {
    // IE11 will throw an exception when the TreeWalker root is not an Element.
    if (root.nodeType !== Node.ELEMENT_NODE) return undefined;
    // TypeScript isn't aware of IE11 behaving badly.
    const filter = $e3e23e1e89ad903c$var$_isBrokenIE11 ? acceptNode : {
        acceptNode: acceptNode
    };
    return $e3e23e1e89ad903c$var$dom.createTreeWalker(doc, root, NodeFilter.SHOW_ELEMENT, filter, // @ts-ignore: We still don't want to completely break IE11, so, entityReferenceExpansion argument is not optional.
    false);
}
function $e3e23e1e89ad903c$var$getBoundingRect(getWindow, element) {
    let cacheId = element.__tabsterCacheId;
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    const cached = cacheId ? context.containerBoundingRectCache[cacheId] : undefined;
    if (cached) return cached.rect;
    const scrollingElement = element.ownerDocument && element.ownerDocument.documentElement;
    if (!scrollingElement) return new $e3e23e1e89ad903c$var$_DOMRect();
    // A bounding rect of the top-level element contains the whole page regardless of the
    // scrollbar. So, we improvise a little and limiting the final result...
    let left = 0;
    let top = 0;
    let right = scrollingElement.clientWidth;
    let bottom = scrollingElement.clientHeight;
    if (element !== scrollingElement) {
        const r = element.getBoundingClientRect();
        left = Math.max(left, r.left);
        top = Math.max(top, r.top);
        right = Math.min(right, r.right);
        bottom = Math.min(bottom, r.bottom);
    }
    const rect = new $e3e23e1e89ad903c$var$_DOMRect(left < right ? left : -1, top < bottom ? top : -1, left < right ? right - left : 0, top < bottom ? bottom - top : 0);
    if (!cacheId) {
        cacheId = "r-" + ++context.lastContainerBoundingRectCacheId;
        element.__tabsterCacheId = cacheId;
    }
    context.containerBoundingRectCache[cacheId] = {
        rect: rect,
        element: element
    };
    if (!context.containerBoundingRectCacheTimer) context.containerBoundingRectCacheTimer = window.setTimeout(()=>{
        context.containerBoundingRectCacheTimer = undefined;
        for (const cId of Object.keys(context.containerBoundingRectCache))delete context.containerBoundingRectCache[cId].element.__tabsterCacheId;
        context.containerBoundingRectCache = {};
    }, 50);
    return rect;
}
function $e3e23e1e89ad903c$var$isElementVerticallyVisibleInContainer(getWindow, element, tolerance) {
    const container = $e3e23e1e89ad903c$var$getScrollableContainer(element);
    if (!container) return false;
    const containerRect = $e3e23e1e89ad903c$var$getBoundingRect(getWindow, container);
    const elementRect = element.getBoundingClientRect();
    const intersectionTolerance = elementRect.height * (1 - tolerance);
    const topIntersection = Math.max(0, containerRect.top - elementRect.top);
    const bottomIntersection = Math.max(0, elementRect.bottom - containerRect.bottom);
    const totalIntersection = topIntersection + bottomIntersection;
    return totalIntersection === 0 || totalIntersection <= intersectionTolerance;
}
function $e3e23e1e89ad903c$var$scrollIntoView(getWindow, element, alignToTop) {
    // Built-in DOM's scrollIntoView() is cool, but when we have nested containers,
    // it scrolls all of them, not just the deepest one. So, trying to work it around.
    const container = $e3e23e1e89ad903c$var$getScrollableContainer(element);
    if (container) {
        const containerRect = $e3e23e1e89ad903c$var$getBoundingRect(getWindow, container);
        const elementRect = element.getBoundingClientRect();
        if (alignToTop) container.scrollTop += elementRect.top - containerRect.top;
        else container.scrollTop += elementRect.bottom - containerRect.bottom;
    }
}
function $e3e23e1e89ad903c$var$getScrollableContainer(element) {
    const doc = element.ownerDocument;
    if (doc) {
        for(let el = $e3e23e1e89ad903c$var$dom.getParentElement(element); el; el = $e3e23e1e89ad903c$var$dom.getParentElement(el)){
            if (el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) return el;
        }
        return doc.documentElement;
    }
    return null;
}
function $e3e23e1e89ad903c$var$makeFocusIgnored(element) {
    element.__shouldIgnoreFocus = true;
}
function $e3e23e1e89ad903c$var$shouldIgnoreFocus(element) {
    return !!element.__shouldIgnoreFocus;
}
function $e3e23e1e89ad903c$var$getUId(wnd) {
    const rnd = new Uint32Array(4);
    if (wnd.crypto && wnd.crypto.getRandomValues) wnd.crypto.getRandomValues(rnd);
    else if (wnd.msCrypto && wnd.msCrypto.getRandomValues) wnd.msCrypto.getRandomValues(rnd);
    else for(let i = 0; i < rnd.length; i++)rnd[i] = 0xffffffff * Math.random();
    const srnd = [];
    for(let i = 0; i < rnd.length; i++)srnd.push(rnd[i].toString(36));
    srnd.push("|");
    srnd.push((++$e3e23e1e89ad903c$var$_uidCounter).toString(36));
    srnd.push("|");
    srnd.push(Date.now().toString(36));
    return srnd.join("");
}
function $e3e23e1e89ad903c$var$getElementUId(getWindow, element) {
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    let uid = element.__tabsterElementUID;
    if (!uid) uid = element.__tabsterElementUID = $e3e23e1e89ad903c$var$getUId(getWindow());
    if (!context.elementByUId[uid] && $e3e23e1e89ad903c$var$documentContains(element.ownerDocument, element)) context.elementByUId[uid] = new $e3e23e1e89ad903c$var$WeakHTMLElement(getWindow, element);
    return uid;
}
function $e3e23e1e89ad903c$var$getWindowUId(win) {
    let uid = win.__tabsterCrossOriginWindowUID;
    if (!uid) uid = win.__tabsterCrossOriginWindowUID = $e3e23e1e89ad903c$var$getUId(win);
    return uid;
}
function $e3e23e1e89ad903c$var$clearElementCache(getWindow, parent) {
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    for (const key of Object.keys(context.elementByUId)){
        const wel = context.elementByUId[key];
        const el = wel && wel.get();
        if (el && parent) {
            if (!$e3e23e1e89ad903c$var$dom.nodeContains(parent, el)) continue;
        }
        delete context.elementByUId[key];
    }
}
// IE11 doesn't have document.contains()...
function $e3e23e1e89ad903c$var$documentContains(doc, element) {
    return $e3e23e1e89ad903c$var$dom.nodeContains(doc === null || doc === void 0 ? void 0 : doc.body, element);
}
function $e3e23e1e89ad903c$var$matchesSelector(element, selector) {
    const matches = element.matches || element.matchesSelector || element.msMatchesSelector || element.webkitMatchesSelector;
    return matches && matches.call(element, selector);
}
function $e3e23e1e89ad903c$var$getPromise(getWindow) {
    const context = $e3e23e1e89ad903c$var$getInstanceContext(getWindow);
    if (context.basics.Promise) return context.basics.Promise;
    throw new Error("No Promise defined.");
}
function $e3e23e1e89ad903c$var$getWeakRef(context) {
    return context.basics.WeakRef;
}
let $e3e23e1e89ad903c$var$_lastTabsterPartId = 0;
class $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, props){
        const getWindow = tabster.getWindow;
        this._tabster = tabster;
        this._element = new $e3e23e1e89ad903c$var$WeakHTMLElement(getWindow, element);
        this._props = {
            ...props
        };
        this.id = "i" + ++$e3e23e1e89ad903c$var$_lastTabsterPartId;
    }
    getElement() {
        return this._element.get();
    }
    getProps() {
        return this._props;
    }
    setProps(props) {
        this._props = {
            ...props
        };
    }
}
/**
 * Dummy HTML elements that are used as focus sentinels for the DOM enclosed within them
 */ class $e3e23e1e89ad903c$var$DummyInput {
    constructor(getWindow, isOutside, props, element, fixedTarget){
        var _a;
        this._focusIn = (e)=>{
            if (this._fixedTarget) {
                const target = this._fixedTarget.get();
                if (target) (0, $7fd4889093258001$export$cf4c60ff2c946f35)(target);
                return;
            }
            const input = this.input;
            if (this.onFocusIn && input) {
                const relatedTarget = e.relatedTarget;
                this.onFocusIn(this, this._isBackward(true, input, relatedTarget), relatedTarget);
            }
        };
        this._focusOut = (e)=>{
            if (this._fixedTarget) return;
            this.useDefaultAction = false;
            const input = this.input;
            if (this.onFocusOut && input) {
                const relatedTarget = e.relatedTarget;
                this.onFocusOut(this, this._isBackward(false, input, relatedTarget), relatedTarget);
            }
        };
        const win = getWindow();
        const input = win.document.createElement("i");
        input.tabIndex = 0;
        input.setAttribute("role", "none");
        input.setAttribute($e3e23e1e89ad903c$export$22865d31b7a9c589, "");
        input.setAttribute("aria-hidden", "true");
        const style = input.style;
        style.position = "fixed";
        style.width = style.height = "1px";
        style.opacity = "0.001";
        style.zIndex = "-1";
        style.setProperty("content-visibility", "hidden");
        $e3e23e1e89ad903c$var$makeFocusIgnored(input);
        this.input = input;
        this.isFirst = props.isFirst;
        this.isOutside = isOutside;
        this._isPhantom = (_a = props.isPhantom) !== null && _a !== void 0 ? _a : false;
        this._fixedTarget = fixedTarget;
        input.addEventListener("focusin", this._focusIn);
        input.addEventListener("focusout", this._focusOut);
        input.__tabsterDummyContainer = element;
        if (this._isPhantom) {
            this._disposeTimer = win.setTimeout(()=>{
                delete this._disposeTimer;
                this.dispose();
            }, 0);
            this._clearDisposeTimeout = ()=>{
                if (this._disposeTimer) {
                    win.clearTimeout(this._disposeTimer);
                    delete this._disposeTimer;
                }
                delete this._clearDisposeTimeout;
            };
        }
    }
    dispose() {
        var _a;
        if (this._clearDisposeTimeout) this._clearDisposeTimeout();
        const input = this.input;
        if (!input) return;
        delete this._fixedTarget;
        delete this.onFocusIn;
        delete this.onFocusOut;
        delete this.input;
        input.removeEventListener("focusin", this._focusIn);
        input.removeEventListener("focusout", this._focusOut);
        delete input.__tabsterDummyContainer;
        (_a = $e3e23e1e89ad903c$var$dom.getParentNode(input)) === null || _a === void 0 || _a.removeChild(input);
    }
    setTopLeft(top, left) {
        var _a;
        const style = (_a = this.input) === null || _a === void 0 ? void 0 : _a.style;
        if (style) {
            style.top = `${top}px`;
            style.left = `${left}px`;
        }
    }
    _isBackward(isIn, current, previous) {
        return isIn && !previous ? !this.isFirst : !!(previous && current.compareDocumentPosition(previous) & Node.DOCUMENT_POSITION_FOLLOWING);
    }
}
const $e3e23e1e89ad903c$var$DummyInputManagerPriorities = {
    Root: 1,
    Modalizer: 2,
    Mover: 3,
    Groupper: 4
};
class $e3e23e1e89ad903c$var$DummyInputManager {
    constructor(tabster, element, priority, sys, outsideByDefault, callForDefaultAction){
        this._element = element;
        this._instance = new $e3e23e1e89ad903c$var$DummyInputManagerCore(tabster, element, this, priority, sys, outsideByDefault, callForDefaultAction);
    }
    _setHandlers(onFocusIn, onFocusOut) {
        this._onFocusIn = onFocusIn;
        this._onFocusOut = onFocusOut;
    }
    moveOut(backwards) {
        var _a;
        (_a = this._instance) === null || _a === void 0 || _a.moveOut(backwards);
    }
    moveOutWithDefaultAction(backwards, relatedEvent) {
        var _a;
        (_a = this._instance) === null || _a === void 0 || _a.moveOutWithDefaultAction(backwards, relatedEvent);
    }
    getHandler(isIn) {
        return isIn ? this._onFocusIn : this._onFocusOut;
    }
    setTabbable(tabbable) {
        var _a;
        (_a = this._instance) === null || _a === void 0 || _a.setTabbable(this, tabbable);
    }
    dispose() {
        if (this._instance) {
            this._instance.dispose(this);
            delete this._instance;
        }
        delete this._onFocusIn;
        delete this._onFocusOut;
    }
    static moveWithPhantomDummy(tabster, element, // The target element to move to or out of.
    moveOutOfElement, // Whether to move out of the element or into it.
    isBackward, // Are we tabbing of shift-tabbing?
    relatedEvent // The event that triggered the move.
    ) {
        // Phantom dummy is a hack to use browser's default action to move
        // focus from a specific point in the application to the next/previous
        // element. Default action is needed because next focusable element
        // is not always available to focus directly (for example, next focusable
        // is inside isolated iframe) or for uncontrolled areas we want to make
        // sure that something that controls it takes care of the focusing.
        // It works in a way that during the Tab key handling, we create a dummy
        // input element, place it to the specific place in the DOM and focus it,
        // then the default action of the Tab press will move focus from our dummy
        // input. And we remove it from the DOM right after that.
        const dummy = new $e3e23e1e89ad903c$var$DummyInput(tabster.getWindow, true, {
            isPhantom: true,
            isFirst: true
        });
        const input = dummy.input;
        if (input) {
            let parent;
            let insertBefore;
            // Let's say we have a following DOM structure:
            // <div>
            //   <button>Button1</button>
            //   <div id="uncontrolled" data-tabster={uncontrolled: {}}>
            //     <button>Button2</button>
            //     <button>Button3</button>
            //   </div>
            //   <button>Button4</button>
            // </div>
            //
            // We pass the "uncontrolled" div as the element to move to or out of.
            //
            // When we pass moveOutOfElement=true and isBackward=false,
            // the phantom dummy input will be inserted before Button4.
            //
            // When we pass moveOutOfElement=true and isBackward=true, there are
            // two cases. If the uncontrolled element is focusable (has tabindex=0),
            // the phantom dummy input will be inserted after Button1. If the
            // uncontrolled element is not focusable, the phantom dummy input will be
            // inserted before Button2.
            //
            // When we pass moveOutOfElement=false and isBackward=false, the
            // phantom dummy input will be inserted after Button1.
            //
            // When we pass moveOutOfElement=false and isBackward=true, the phantom
            // dummy input will be inserted before Button4.
            //
            // And we have a corner case for <body> and we make sure that the inserted
            // dummy is inserted properly when there are existing permanent dummies.
            if (element.tagName === "BODY") {
                // We cannot insert elements outside of BODY.
                parent = element;
                insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? $e3e23e1e89ad903c$var$dom.getFirstElementChild(element) : null;
            } else {
                if (moveOutOfElement && (!isBackward || isBackward && !tabster.focusable.isFocusable(element, false, true, true))) {
                    parent = element;
                    insertBefore = isBackward ? element.firstElementChild : null;
                } else {
                    parent = $e3e23e1e89ad903c$var$dom.getParentElement(element);
                    insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? element : $e3e23e1e89ad903c$var$dom.getNextElementSibling(element);
                }
                let potentialDummy;
                let dummyFor;
                do {
                    // This is a safety pillow for the cases when someone, combines
                    // groupper with uncontrolled on the same node. Which is technically
                    // not correct, but moving into the container element via its dummy
                    // input would produce a correct behaviour in uncontrolled mode.
                    potentialDummy = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? $e3e23e1e89ad903c$var$dom.getPreviousElementSibling(insertBefore) : insertBefore;
                    dummyFor = $e3e23e1e89ad903c$export$6c7070ee46ec4271(potentialDummy);
                    if (dummyFor === element) insertBefore = moveOutOfElement && isBackward || !moveOutOfElement && !isBackward ? potentialDummy : $e3e23e1e89ad903c$var$dom.getNextElementSibling(potentialDummy);
                    else dummyFor = null;
                }while (dummyFor);
            }
            if (parent === null || parent === void 0 ? void 0 : parent.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                by: "root",
                owner: parent,
                next: null,
                relatedEvent: relatedEvent
            }))) {
                $e3e23e1e89ad903c$var$dom.insertBefore(parent, input, insertBefore);
                (0, $7fd4889093258001$export$cf4c60ff2c946f35)(input);
            }
        }
    }
    static addPhantomDummyWithTarget(tabster, sourceElement, isBackward, targetElement) {
        const dummy = new $e3e23e1e89ad903c$var$DummyInput(tabster.getWindow, true, {
            isPhantom: true,
            isFirst: true
        }, undefined, new $e3e23e1e89ad903c$var$WeakHTMLElement(tabster.getWindow, targetElement));
        const input = dummy.input;
        if (input) {
            let dummyParent;
            let insertBefore;
            if ($e3e23e1e89ad903c$var$hasSubFocusable(sourceElement) && !isBackward) {
                dummyParent = sourceElement;
                insertBefore = $e3e23e1e89ad903c$var$dom.getFirstElementChild(sourceElement);
            } else {
                dummyParent = $e3e23e1e89ad903c$var$dom.getParentElement(sourceElement);
                insertBefore = isBackward ? sourceElement : $e3e23e1e89ad903c$var$dom.getNextElementSibling(sourceElement);
            }
            if (dummyParent) $e3e23e1e89ad903c$var$dom.insertBefore(dummyParent, input, insertBefore);
        }
    }
}
function $e3e23e1e89ad903c$var$setDummyInputDebugValue(dummy, wrappers) {
    var _a;
    const what = {
        1: "Root",
        2: "Modalizer",
        3: "Mover",
        4: "Groupper"
    };
    (_a = dummy.input) === null || _a === void 0 || _a.setAttribute($e3e23e1e89ad903c$export$22865d31b7a9c589, [
        `isFirst=${dummy.isFirst}`,
        `isOutside=${dummy.isOutside}`,
        ...wrappers.map((w)=>`(${what[w.priority]}, tabbable=${w.tabbable})`)
    ].join(", "));
}
class $e3e23e1e89ad903c$var$DummyInputObserver {
    constructor(win){
        this._updateQueue = new Set();
        this._lastUpdateQueueTime = 0;
        this._changedParents = new WeakSet();
        this._dummyElements = [];
        this._dummyCallbacks = new WeakMap();
        this._domChanged = (parent)=>{
            var _a;
            if (this._changedParents.has(parent)) return;
            this._changedParents.add(parent);
            if (this._updateDummyInputsTimer) return;
            this._updateDummyInputsTimer = (_a = this._win) === null || _a === void 0 ? void 0 : _a.call(this).setTimeout(()=>{
                delete this._updateDummyInputsTimer;
                for (const ref of this._dummyElements){
                    const dummyElement = ref.get();
                    if (dummyElement) {
                        const callback = this._dummyCallbacks.get(dummyElement);
                        if (callback) {
                            const dummyParent = $e3e23e1e89ad903c$var$dom.getParentNode(dummyElement);
                            if (!dummyParent || this._changedParents.has(dummyParent)) callback();
                        }
                    }
                }
                this._changedParents = new WeakSet();
            }, $e3e23e1e89ad903c$var$_updateDummyInputsTimeout);
        };
        this._win = win;
    }
    add(dummy, callback) {
        if (!this._dummyCallbacks.has(dummy) && this._win) {
            this._dummyElements.push(new $e3e23e1e89ad903c$var$WeakHTMLElement(this._win, dummy));
            this._dummyCallbacks.set(dummy, callback);
            this.domChanged = this._domChanged;
        }
    }
    remove(dummy) {
        this._dummyElements = this._dummyElements.filter((ref)=>{
            const element = ref.get();
            return element && element !== dummy;
        });
        this._dummyCallbacks.delete(dummy);
        if (this._dummyElements.length === 0) delete this.domChanged;
    }
    dispose() {
        var _a;
        const win = (_a = this._win) === null || _a === void 0 ? void 0 : _a.call(this);
        if (this._updateTimer) {
            win === null || win === void 0 || win.clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        if (this._updateDummyInputsTimer) {
            win === null || win === void 0 || win.clearTimeout(this._updateDummyInputsTimer);
            delete this._updateDummyInputsTimer;
        }
        this._changedParents = new WeakSet();
        this._dummyCallbacks = new WeakMap();
        this._dummyElements = [];
        this._updateQueue.clear();
        delete this.domChanged;
        delete this._win;
    }
    updatePositions(compute) {
        if (!this._win) // As this is a public method, we make sure that it has no effect when
        // called after dispose().
        return;
        this._updateQueue.add(compute);
        this._lastUpdateQueueTime = Date.now();
        this._scheduledUpdatePositions();
    }
    _scheduledUpdatePositions() {
        var _a;
        if (this._updateTimer) return;
        this._updateTimer = (_a = this._win) === null || _a === void 0 ? void 0 : _a.call(this).setTimeout(()=>{
            delete this._updateTimer;
            // updatePositions() might be called quite a lot during the scrolling.
            // So, instead of clearing the timeout and scheduling a new one, we
            // check if enough time has passed since the last updatePositions() call
            // and only schedule a new one if not.
            // At maximum, we will update dummy inputs positions
            // _updateDummyInputsTimeout * 2 after the last updatePositions() call.
            if (this._lastUpdateQueueTime + $e3e23e1e89ad903c$var$_updateDummyInputsTimeout <= Date.now()) {
                // A cache for current bulk of updates to reduce getComputedStyle() calls.
                const scrollTopLeftCache = new Map();
                const setTopLeftCallbacks = [];
                for (const compute of this._updateQueue)setTopLeftCallbacks.push(compute(scrollTopLeftCache));
                this._updateQueue.clear();
                // We're splitting the computation of offsets and setting them to avoid extra
                // reflows.
                for (const setTopLeft of setTopLeftCallbacks)setTopLeft();
                // Explicitly clear to not hold references till the next garbage collection.
                scrollTopLeftCache.clear();
            } else this._scheduledUpdatePositions();
        }, $e3e23e1e89ad903c$var$_updateDummyInputsTimeout);
    }
}
/**
 * Parent class that encapsulates the behaviour of dummy inputs (focus sentinels)
 */ class $e3e23e1e89ad903c$var$DummyInputManagerCore {
    constructor(tabster, element, manager, priority, sys, outsideByDefault, callForDefaultAction){
        this._wrappers = [];
        this._isOutside = false;
        this._transformElements = new Set();
        this._onFocusIn = (dummyInput, isBackward, relatedTarget)=>{
            this._onFocus(true, dummyInput, isBackward, relatedTarget);
        };
        this._onFocusOut = (dummyInput, isBackward, relatedTarget)=>{
            this._onFocus(false, dummyInput, isBackward, relatedTarget);
        };
        this.moveOut = (backwards)=>{
            var _a;
            const first = this._firstDummy;
            const last = this._lastDummy;
            if (first && last) {
                // For the sake of performance optimization, the dummy input
                // position in the DOM updates asynchronously from the DOM change.
                // Calling _ensurePosition() to make sure the position is correct.
                this._ensurePosition();
                const firstInput = first.input;
                const lastInput = last.input;
                const element = (_a = this._element) === null || _a === void 0 ? void 0 : _a.get();
                if (firstInput && lastInput && element) {
                    let toFocus;
                    if (backwards) {
                        firstInput.tabIndex = 0;
                        toFocus = firstInput;
                    } else {
                        lastInput.tabIndex = 0;
                        toFocus = lastInput;
                    }
                    if (toFocus) (0, $7fd4889093258001$export$cf4c60ff2c946f35)(toFocus);
                }
            }
        };
        /**
     * Prepares to move focus out of the given element by focusing
     * one of the dummy inputs and setting the `useDefaultAction` flag
     * @param backwards focus moving to an element behind the given element
     */ this.moveOutWithDefaultAction = (backwards, relatedEvent)=>{
            var _a;
            const first = this._firstDummy;
            const last = this._lastDummy;
            if (first && last) {
                // For the sake of performance optimization, the dummy input
                // position in the DOM updates asynchronously from the DOM change.
                // Calling _ensurePosition() to make sure the position is correct.
                this._ensurePosition();
                const firstInput = first.input;
                const lastInput = last.input;
                const element = (_a = this._element) === null || _a === void 0 ? void 0 : _a.get();
                if (firstInput && lastInput && element) {
                    let toFocus;
                    if (backwards) {
                        if (!first.isOutside && this._tabster.focusable.isFocusable(element, true, true, true)) toFocus = element;
                        else {
                            first.useDefaultAction = true;
                            firstInput.tabIndex = 0;
                            toFocus = firstInput;
                        }
                    } else {
                        last.useDefaultAction = true;
                        lastInput.tabIndex = 0;
                        toFocus = lastInput;
                    }
                    if (toFocus && element.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                        by: "root",
                        owner: element,
                        next: null,
                        relatedEvent: relatedEvent
                    }))) (0, $7fd4889093258001$export$cf4c60ff2c946f35)(toFocus);
                }
            }
        };
        this.setTabbable = (manager, tabbable)=>{
            var _a, _b;
            for (const w of this._wrappers)if (w.manager === manager) {
                w.tabbable = tabbable;
                break;
            }
            const wrapper = this._getCurrent();
            if (wrapper) {
                const tabIndex = wrapper.tabbable ? 0 : -1;
                let input = (_a = this._firstDummy) === null || _a === void 0 ? void 0 : _a.input;
                if (input) input.tabIndex = tabIndex;
                input = (_b = this._lastDummy) === null || _b === void 0 ? void 0 : _b.input;
                if (input) input.tabIndex = tabIndex;
            }
        };
        /**
     * Adds dummy inputs as the first and last child of the given element
     * Called each time the children under the element is mutated
     */ this._addDummyInputs = ()=>{
            if (this._addTimer) return;
            this._addTimer = this._getWindow().setTimeout(()=>{
                delete this._addTimer;
                this._ensurePosition();
                this._addTransformOffsets();
            }, 0);
        };
        this._addTransformOffsets = ()=>{
            this._tabster._dummyObserver.updatePositions(this._computeTransformOffsets);
        };
        this._computeTransformOffsets = (scrollTopLeftCache)=>{
            var _a, _b;
            const from = ((_a = this._firstDummy) === null || _a === void 0 ? void 0 : _a.input) || ((_b = this._lastDummy) === null || _b === void 0 ? void 0 : _b.input);
            const transformElements = this._transformElements;
            const newTransformElements = new Set();
            let scrollTop = 0;
            let scrollLeft = 0;
            const win = this._getWindow();
            for(let element = from; element && element.nodeType === Node.ELEMENT_NODE; element = $e3e23e1e89ad903c$var$dom.getParentElement(element)){
                let scrollTopLeft = scrollTopLeftCache.get(element);
                // getComputedStyle() and element.scrollLeft/Top() cause style recalculation,
                // so we cache the result across all elements in the current bulk.
                if (scrollTopLeft === undefined) {
                    const transform = win.getComputedStyle(element).transform;
                    if (transform && transform !== "none") scrollTopLeft = {
                        scrollTop: element.scrollTop,
                        scrollLeft: element.scrollLeft
                    };
                    scrollTopLeftCache.set(element, scrollTopLeft || null);
                }
                if (scrollTopLeft) {
                    newTransformElements.add(element);
                    if (!transformElements.has(element)) element.addEventListener("scroll", this._addTransformOffsets);
                    scrollTop += scrollTopLeft.scrollTop;
                    scrollLeft += scrollTopLeft.scrollLeft;
                }
            }
            for (const el of transformElements)if (!newTransformElements.has(el)) el.removeEventListener("scroll", this._addTransformOffsets);
            this._transformElements = newTransformElements;
            return ()=>{
                var _a, _b;
                (_a = this._firstDummy) === null || _a === void 0 || _a.setTopLeft(scrollTop, scrollLeft);
                (_b = this._lastDummy) === null || _b === void 0 || _b.setTopLeft(scrollTop, scrollLeft);
            };
        };
        const el = element.get();
        if (!el) throw new Error("No element");
        this._tabster = tabster;
        this._getWindow = tabster.getWindow;
        this._callForDefaultAction = callForDefaultAction;
        const instance = el.__tabsterDummy;
        (instance || this)._wrappers.push({
            manager: manager,
            priority: priority,
            tabbable: true
        });
        if (instance) return instance;
        el.__tabsterDummy = this;
        // Some elements allow only specific types of direct descendants and we need to
        // put our dummy inputs inside or outside of the element accordingly.
        const forcedDummyPosition = sys === null || sys === void 0 ? void 0 : sys.dummyInputsPosition;
        const tagName = el.tagName;
        this._isOutside = !forcedDummyPosition ? (outsideByDefault || tagName === "UL" || tagName === "OL" || tagName === "TABLE") && !(tagName === "LI" || tagName === "TD" || tagName === "TH") : forcedDummyPosition === $e3e23e1e89ad903c$export$982c91672ba981ed.Outside;
        this._firstDummy = new $e3e23e1e89ad903c$var$DummyInput(this._getWindow, this._isOutside, {
            isFirst: true
        }, element);
        this._lastDummy = new $e3e23e1e89ad903c$var$DummyInput(this._getWindow, this._isOutside, {
            isFirst: false
        }, element);
        // We will be checking dummy input parents to see if their child list have changed.
        // So, it is enough to have just one of the inputs observed, because
        // both dummy inputs always have the same parent.
        const dummyElement = this._firstDummy.input;
        dummyElement && tabster._dummyObserver.add(dummyElement, this._addDummyInputs);
        this._firstDummy.onFocusIn = this._onFocusIn;
        this._firstDummy.onFocusOut = this._onFocusOut;
        this._lastDummy.onFocusIn = this._onFocusIn;
        this._lastDummy.onFocusOut = this._onFocusOut;
        this._element = element;
        this._addDummyInputs();
    }
    dispose(manager, force) {
        var _a, _b, _c, _d;
        const wrappers = this._wrappers = this._wrappers.filter((w)=>w.manager !== manager && !force);
        if (wrappers.length === 0) {
            delete ((_a = this._element) === null || _a === void 0 ? void 0 : _a.get()).__tabsterDummy;
            for (const el of this._transformElements)el.removeEventListener("scroll", this._addTransformOffsets);
            this._transformElements.clear();
            const win = this._getWindow();
            if (this._addTimer) {
                win.clearTimeout(this._addTimer);
                delete this._addTimer;
            }
            const dummyElement = (_b = this._firstDummy) === null || _b === void 0 ? void 0 : _b.input;
            dummyElement && this._tabster._dummyObserver.remove(dummyElement);
            (_c = this._firstDummy) === null || _c === void 0 || _c.dispose();
            (_d = this._lastDummy) === null || _d === void 0 || _d.dispose();
        }
    }
    _onFocus(isIn, dummyInput, isBackward, relatedTarget) {
        var _a;
        const wrapper = this._getCurrent();
        if (wrapper && (!dummyInput.useDefaultAction || this._callForDefaultAction)) (_a = wrapper.manager.getHandler(isIn)) === null || _a === void 0 || _a(dummyInput, isBackward, relatedTarget);
    }
    _getCurrent() {
        this._wrappers.sort((a, b)=>{
            if (a.tabbable !== b.tabbable) return a.tabbable ? -1 : 1;
            return a.priority - b.priority;
        });
        return this._wrappers[0];
    }
    _ensurePosition() {
        var _a, _b, _c;
        const element = (_a = this._element) === null || _a === void 0 ? void 0 : _a.get();
        const firstDummyInput = (_b = this._firstDummy) === null || _b === void 0 ? void 0 : _b.input;
        const lastDummyInput = (_c = this._lastDummy) === null || _c === void 0 ? void 0 : _c.input;
        if (!element || !firstDummyInput || !lastDummyInput) return;
        if (this._isOutside) {
            const elementParent = $e3e23e1e89ad903c$var$dom.getParentNode(element);
            if (elementParent) {
                const nextSibling = $e3e23e1e89ad903c$var$dom.getNextSibling(element);
                if (nextSibling !== lastDummyInput) $e3e23e1e89ad903c$var$dom.insertBefore(elementParent, lastDummyInput, nextSibling);
                if ($e3e23e1e89ad903c$var$dom.getPreviousElementSibling(element) !== firstDummyInput) $e3e23e1e89ad903c$var$dom.insertBefore(elementParent, firstDummyInput, element);
            }
        } else {
            if ($e3e23e1e89ad903c$var$dom.getLastElementChild(element) !== lastDummyInput) $e3e23e1e89ad903c$var$dom.appendChild(element, lastDummyInput);
            const firstElementChild = $e3e23e1e89ad903c$var$dom.getFirstElementChild(element);
            if (firstElementChild && firstElementChild !== firstDummyInput && firstElementChild.parentNode) $e3e23e1e89ad903c$var$dom.insertBefore(firstElementChild.parentNode, firstDummyInput, firstElementChild);
        }
    }
}
function $e3e23e1e89ad903c$var$getLastChild$2(container) {
    let lastChild = null;
    for(let i = $e3e23e1e89ad903c$var$dom.getLastElementChild(container); i; i = $e3e23e1e89ad903c$var$dom.getLastElementChild(i))lastChild = i;
    return lastChild || undefined;
}
function $e3e23e1e89ad903c$var$getAdjacentElement(from, prev) {
    let cur = from;
    let adjacent = null;
    while(cur && !adjacent){
        adjacent = prev ? $e3e23e1e89ad903c$var$dom.getPreviousElementSibling(cur) : $e3e23e1e89ad903c$var$dom.getNextElementSibling(cur);
        cur = $e3e23e1e89ad903c$var$dom.getParentElement(cur);
    }
    return adjacent || undefined;
}
function $e3e23e1e89ad903c$var$augmentAttribute(tabster, element, name, value // Restore original value when undefined.
) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entry = tabster.storageEntry(element, true);
    let ret = false;
    if (!entry.aug) {
        if (value === undefined) return ret;
        entry.aug = {};
    }
    if (value === undefined) {
        if (name in entry.aug) {
            const origVal = entry.aug[name];
            delete entry.aug[name];
            if (origVal === null) element.removeAttribute(name);
            else element.setAttribute(name, origVal);
            ret = true;
        }
    } else {
        let origValue;
        if (!(name in entry.aug)) origValue = element.getAttribute(name);
        if (origValue !== undefined && origValue !== value) {
            entry.aug[name] = origValue;
            if (value === null) element.removeAttribute(name);
            else element.setAttribute(name, value);
            ret = true;
        }
    }
    if (value === undefined && Object.keys(entry.aug).length === 0) {
        delete entry.aug;
        tabster.storageEntry(element, false);
    }
    return ret;
}
function $e3e23e1e89ad903c$var$isDisplayNone(element) {
    var _a, _b;
    const elementDocument = element.ownerDocument;
    const computedStyle = (_a = elementDocument.defaultView) === null || _a === void 0 ? void 0 : _a.getComputedStyle(element);
    // offsetParent is null for elements with display:none, display:fixed and for <body>.
    if (element.offsetParent === null && elementDocument.body !== element && (computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.position) !== "fixed") return true;
    // For our purposes of looking for focusable elements, visibility:hidden has the same
    // effect as display:none.
    if ((computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.visibility) === "hidden") return true;
    // if an element has display: fixed, we need to check if it is also hidden with CSS,
    // or within a parent hidden with CSS
    if ((computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.position) === "fixed") {
        if (computedStyle.display === "none") return true;
        if (((_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.offsetParent) === null && elementDocument.body !== element.parentElement) return true;
    }
    return false;
}
function $e3e23e1e89ad903c$var$isRadio(element) {
    return element.tagName === "INPUT" && !!element.name && element.type === "radio";
}
function $e3e23e1e89ad903c$var$getRadioButtonGroup(element) {
    if (!$e3e23e1e89ad903c$var$isRadio(element)) return;
    const name = element.name;
    let radioButtons = Array.from($e3e23e1e89ad903c$var$dom.getElementsByName(element, name));
    let checked;
    radioButtons = radioButtons.filter((el)=>{
        if ($e3e23e1e89ad903c$var$isRadio(el)) {
            if (el.checked) checked = el;
            return true;
        }
        return false;
    });
    return {
        name: name,
        buttons: new Set(radioButtons),
        checked: checked
    };
}
/**
 * If the passed element is Tabster dummy input, returns the container element this dummy input belongs to.
 * @param element Element to check for being dummy input.
 * @returns Dummy input container element (if the passed element is a dummy input) or null.
 */ function $e3e23e1e89ad903c$export$6c7070ee46ec4271(element) {
    var _a;
    return ((_a = element === null || element === void 0 ? void 0 : element.__tabsterDummyContainer) === null || _a === void 0 ? void 0 : _a.get()) || null;
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$export$374a8d854973d904(props, plain) {
    const attr = JSON.stringify(props);
    if (plain === true) return attr;
    return {
        [$e3e23e1e89ad903c$export$a1195ad1c253d145]: attr
    };
}
/**
 * Updates Tabster props object with new props.
 * @param element an element to set data-tabster attribute on.
 * @param props current Tabster props to update.
 * @param newProps new Tabster props to add.
 *  When the value of a property in newProps is undefined, the property
 *  will be removed from the attribute.
 */ function $e3e23e1e89ad903c$export$4e343f66f0caa3b1(props, newProps) {
    for (const key of Object.keys(newProps)){
        const value = newProps[key];
        if (value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        props[key] = value;
        else delete props[key];
    }
}
/**
 * Sets or updates Tabster attribute of the element.
 * @param element an element to set data-tabster attribute on.
 * @param newProps new Tabster props to set.
 * @param update if true, newProps will be merged with the existing props.
 *  When true and the value of a property in newProps is undefined, the property
 *  will be removed from the attribute.
 */ function $e3e23e1e89ad903c$export$ab3e73b3b3dbdbbc(element, newProps, update) {
    let props;
    if (update) {
        const attr = element.getAttribute($e3e23e1e89ad903c$export$a1195ad1c253d145);
        if (attr) try {
            props = JSON.parse(attr);
        } catch (e) {}
    }
    if (!props) props = {};
    $e3e23e1e89ad903c$export$4e343f66f0caa3b1(props, newProps);
    if (Object.keys(props).length > 0) element.setAttribute($e3e23e1e89ad903c$export$a1195ad1c253d145, $e3e23e1e89ad903c$export$374a8d854973d904(props, true));
    else element.removeAttribute($e3e23e1e89ad903c$export$a1195ad1c253d145);
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$_setInformativeStyle$3(weakElement, remove, id) {}
class $e3e23e1e89ad903c$var$RootDummyManager extends $e3e23e1e89ad903c$var$DummyInputManager {
    constructor(tabster, element, setFocused, sys){
        super(tabster, element, $e3e23e1e89ad903c$var$DummyInputManagerPriorities.Root, sys, undefined, true);
        this._onDummyInputFocus = (dummyInput)=>{
            var _a;
            if (dummyInput.useDefaultAction) // When we've reached the last focusable element, we want to let the browser
            // to move the focus outside of the page. In order to do that we're synchronously
            // calling focus() of the dummy input from the Tab key handler and allowing
            // the default action to move the focus out.
            this._setFocused(false);
            else {
                // The only way a dummy input gets focused is during the keyboard navigation.
                this._tabster.keyboardNavigation.setNavigatingWithKeyboard(true);
                const element = this._element.get();
                if (element) {
                    this._setFocused(true);
                    const toFocus = this._tabster.focusedElement.getFirstOrLastTabbable(dummyInput.isFirst, {
                        container: element,
                        ignoreAccessibility: true
                    });
                    if (toFocus) {
                        (0, $7fd4889093258001$export$cf4c60ff2c946f35)(toFocus);
                        return;
                    }
                }
                (_a = dummyInput.input) === null || _a === void 0 || _a.blur();
            }
        };
        this._setHandlers(this._onDummyInputFocus);
        this._tabster = tabster;
        this._setFocused = setFocused;
    }
}
class $e3e23e1e89ad903c$var$Root extends $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, onDispose, props, sys){
        super(tabster, element, props);
        this._isFocused = false;
        this._setFocused = (hasFocused)=>{
            var _a;
            if (this._setFocusedTimer) {
                this._tabster.getWindow().clearTimeout(this._setFocusedTimer);
                delete this._setFocusedTimer;
            }
            if (this._isFocused === hasFocused) return;
            const element = this._element.get();
            if (element) {
                if (hasFocused) {
                    this._isFocused = true;
                    (_a = this._dummyManager) === null || _a === void 0 || _a.setTabbable(false);
                    element.dispatchEvent(new $e3e23e1e89ad903c$export$8606e9d746120bb0({
                        element: element
                    }));
                } else this._setFocusedTimer = this._tabster.getWindow().setTimeout(()=>{
                    var _a;
                    delete this._setFocusedTimer;
                    this._isFocused = false;
                    (_a = this._dummyManager) === null || _a === void 0 || _a.setTabbable(true);
                    element.dispatchEvent(new $e3e23e1e89ad903c$export$4122e0ec6dadc59a({
                        element: element
                    }));
                }, 0);
            }
        };
        this._onFocusIn = (event)=>{
            const getParent = this._tabster.getParent;
            const rootElement = this._element.get();
            let curElement = event.composedPath()[0];
            do {
                if (curElement === rootElement) {
                    this._setFocused(true);
                    return;
                }
                curElement = curElement && getParent(curElement);
            }while (curElement);
        };
        this._onFocusOut = ()=>{
            this._setFocused(false);
        };
        this._onDispose = onDispose;
        const win = tabster.getWindow;
        this.uid = $e3e23e1e89ad903c$var$getElementUId(win, element);
        this._sys = sys;
        if (tabster.controlTab || tabster.rootDummyInputs) this.addDummyInputs();
        const w = win();
        const doc = w.document;
        doc.addEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), this._onFocusIn);
        doc.addEventListener((0, $7fd4889093258001$export$caa225efd612bb56), this._onFocusOut);
        this._add();
    }
    addDummyInputs() {
        if (!this._dummyManager) this._dummyManager = new $e3e23e1e89ad903c$var$RootDummyManager(this._tabster, this._element, this._setFocused, this._sys);
    }
    dispose() {
        var _a;
        this._onDispose(this);
        const win = this._tabster.getWindow();
        const doc = win.document;
        doc.removeEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), this._onFocusIn);
        doc.removeEventListener((0, $7fd4889093258001$export$caa225efd612bb56), this._onFocusOut);
        if (this._setFocusedTimer) {
            win.clearTimeout(this._setFocusedTimer);
            delete this._setFocusedTimer;
        }
        (_a = this._dummyManager) === null || _a === void 0 || _a.dispose();
        this._remove();
    }
    moveOutWithDefaultAction(isBackward, relatedEvent) {
        const dummyManager = this._dummyManager;
        if (dummyManager) dummyManager.moveOutWithDefaultAction(isBackward, relatedEvent);
        else {
            const el = this.getElement();
            if (el) $e3e23e1e89ad903c$var$RootDummyManager.moveWithPhantomDummy(this._tabster, el, true, isBackward, relatedEvent);
        }
    }
    _add() {}
    _remove() {}
}
class $e3e23e1e89ad903c$var$RootAPI {
    constructor(tabster, autoRoot){
        this._autoRootWaiting = false;
        this._roots = {};
        this._forceDummy = false;
        this.rootById = {};
        this._autoRootCreate = ()=>{
            var _a;
            const doc = this._win().document;
            const body = doc.body;
            if (body) {
                this._autoRootUnwait(doc);
                const props = this._autoRoot;
                if (props) {
                    $e3e23e1e89ad903c$export$ab3e73b3b3dbdbbc(body, {
                        root: props
                    }, true);
                    $e3e23e1e89ad903c$var$updateTabsterByAttribute(this._tabster, body);
                    return (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, body)) === null || _a === void 0 ? void 0 : _a.root;
                }
            } else if (!this._autoRootWaiting) {
                this._autoRootWaiting = true;
                doc.addEventListener("readystatechange", this._autoRootCreate);
            }
            return undefined;
        };
        this._onRootDispose = (root)=>{
            delete this._roots[root.id];
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        this._autoRoot = autoRoot;
        tabster.queueInit(()=>{
            if (this._autoRoot) this._autoRootCreate();
        });
    }
    _autoRootUnwait(doc) {
        doc.removeEventListener("readystatechange", this._autoRootCreate);
        this._autoRootWaiting = false;
    }
    dispose() {
        const win = this._win();
        this._autoRootUnwait(win.document);
        delete this._autoRoot;
        Object.keys(this._roots).forEach((rootId)=>{
            if (this._roots[rootId]) {
                this._roots[rootId].dispose();
                delete this._roots[rootId];
            }
        });
        this.rootById = {};
    }
    createRoot(element, props, sys) {
        const newRoot = new $e3e23e1e89ad903c$var$Root(this._tabster, element, this._onRootDispose, props, sys);
        this._roots[newRoot.id] = newRoot;
        if (this._forceDummy) newRoot.addDummyInputs();
        return newRoot;
    }
    addDummyInputs() {
        this._forceDummy = true;
        const roots = this._roots;
        for (const id of Object.keys(roots))roots[id].addDummyInputs();
    }
    static getRootByUId(getWindow, id) {
        const tabster = getWindow().__tabsterInstance;
        return tabster && tabster.root.rootById[id];
    }
    /**
   * Fetches the tabster context for an element walking up its ancestors
   *
   * @param tabster Tabster instance
   * @param element The element the tabster context should represent
   * @param options Additional options
   * @returns undefined if the element is not a child of a tabster root, otherwise all applicable tabster behaviours and configurations
   */ static getTabsterContext(tabster, element, options = {}) {
        var _a, _b, _c, _d;
        if (!element.ownerDocument) return undefined;
        const { checkRtl: checkRtl, referenceElement: referenceElement } = options;
        const getParent = tabster.getParent;
        // Normally, the initialization starts on the next tick after the tabster
        // instance creation. However, if the application starts using it before
        // the next tick, we need to make sure the initialization is done.
        tabster.drainInitQueue();
        let root;
        let modalizer;
        let groupper;
        let mover;
        let excludedFromMover = false;
        let groupperBeforeMover;
        let modalizerInGroupper;
        let dirRightToLeft;
        let uncontrolled;
        let curElement = referenceElement || element;
        const ignoreKeydown = {};
        while(curElement && (!root || checkRtl)){
            const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, curElement);
            if (checkRtl && dirRightToLeft === undefined) {
                const dir = curElement.dir;
                if (dir) dirRightToLeft = dir.toLowerCase() === "rtl";
            }
            if (!tabsterOnElement) {
                curElement = getParent(curElement);
                continue;
            }
            const tagName = curElement.tagName;
            if ((tabsterOnElement.uncontrolled || tagName === "IFRAME" || tagName === "WEBVIEW") && tabster.focusable.isVisible(curElement)) uncontrolled = curElement;
            if (!mover && ((_a = tabsterOnElement.focusable) === null || _a === void 0 ? void 0 : _a.excludeFromMover) && !groupper) excludedFromMover = true;
            const curModalizer = tabsterOnElement.modalizer;
            const curGroupper = tabsterOnElement.groupper;
            const curMover = tabsterOnElement.mover;
            if (!modalizer && curModalizer) modalizer = curModalizer;
            if (!groupper && curGroupper && (!modalizer || curModalizer)) {
                if (modalizer) {
                    // Modalizer dominates the groupper when they are on the same node and the groupper is active.
                    if (!curGroupper.isActive() && curGroupper.getProps().tabbability && modalizer.userId !== ((_b = tabster.modalizer) === null || _b === void 0 ? void 0 : _b.activeId)) {
                        modalizer = undefined;
                        groupper = curGroupper;
                    }
                    modalizerInGroupper = curGroupper;
                } else groupper = curGroupper;
            }
            if (!mover && curMover && (!modalizer || curModalizer) && (!curGroupper || curElement !== element) && curElement.contains(element) // Mover makes sense only for really inside elements, not for virutal out of the DOM order children.
            ) {
                mover = curMover;
                groupperBeforeMover = !!groupper && groupper !== curGroupper;
            }
            if (tabsterOnElement.root) root = tabsterOnElement.root;
            if ((_c = tabsterOnElement.focusable) === null || _c === void 0 ? void 0 : _c.ignoreKeydown) Object.assign(ignoreKeydown, tabsterOnElement.focusable.ignoreKeydown);
            curElement = getParent(curElement);
        }
        // No root element could be found, try to get an auto root
        if (!root) {
            const rootAPI = tabster.root;
            const autoRoot = rootAPI._autoRoot;
            if (autoRoot) {
                if ((_d = element.ownerDocument) === null || _d === void 0 ? void 0 : _d.body) root = rootAPI._autoRootCreate();
            }
        }
        if (groupper && !mover) groupperBeforeMover = true;
        const shouldIgnoreKeydown = (event)=>!!ignoreKeydown[event.key];
        return root ? {
            root: root,
            modalizer: modalizer,
            groupper: groupper,
            mover: mover,
            groupperBeforeMover: groupperBeforeMover,
            modalizerInGroupper: modalizerInGroupper,
            rtl: checkRtl ? !!dirRightToLeft : undefined,
            uncontrolled: uncontrolled,
            excludedFromMover: excludedFromMover,
            ignoreKeydown: shouldIgnoreKeydown
        } : undefined;
    }
    static getRoot(tabster, element) {
        var _a;
        const getParent = tabster.getParent;
        for(let el = element; el; el = getParent(el)){
            const root = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, el)) === null || _a === void 0 ? void 0 : _a.root;
            if (root) return root;
        }
        return undefined;
    }
    onRoot(root, removed) {
        if (removed) delete this.rootById[root.uid];
        else this.rootById[root.uid] = root;
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$_containerHistoryLength = 10;
class $e3e23e1e89ad903c$var$DeloserItemBase {
}
class $e3e23e1e89ad903c$var$DeloserItem extends $e3e23e1e89ad903c$var$DeloserItemBase {
    constructor(tabster, deloser){
        super();
        this.uid = deloser.uid;
        this._tabster = tabster;
        this._deloser = deloser;
    }
    belongsTo(deloser) {
        return deloser === this._deloser;
    }
    unshift(element) {
        this._deloser.unshift(element);
    }
    async focusAvailable() {
        const available = this._deloser.findAvailable();
        const deloserElement = this._deloser.getElement();
        if (available && deloserElement) {
            if (!deloserElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                by: "deloser",
                owner: deloserElement,
                next: available
            }))) // Default action is prevented, don't look further.
            return null;
            return this._tabster.focusedElement.focus(available);
        }
        return false;
    }
    async resetFocus() {
        const getWindow = this._tabster.getWindow;
        return $e3e23e1e89ad903c$var$getPromise(getWindow).resolve(this._deloser.resetFocus());
    }
}
class $e3e23e1e89ad903c$var$DeloserHistoryByRootBase {
    constructor(tabster, rootUId){
        this._history = [];
        this._tabster = tabster;
        this.rootUId = rootUId;
    }
    getLength() {
        return this._history.length;
    }
    removeDeloser(deloser) {
        this._history = this._history.filter((c)=>!c.belongsTo(deloser));
    }
    hasDeloser(deloser) {
        return this._history.some((d)=>d.belongsTo(deloser));
    }
}
class $e3e23e1e89ad903c$var$DeloserHistoryByRoot extends $e3e23e1e89ad903c$var$DeloserHistoryByRootBase {
    unshiftToDeloser(deloser, element) {
        let item;
        for(let i = 0; i < this._history.length; i++)if (this._history[i].belongsTo(deloser)) {
            item = this._history[i];
            this._history.splice(i, 1);
            break;
        }
        if (!item) item = new $e3e23e1e89ad903c$var$DeloserItem(this._tabster, deloser);
        item.unshift(element);
        this._history.unshift(item);
        this._history.splice($e3e23e1e89ad903c$var$_containerHistoryLength, this._history.length - $e3e23e1e89ad903c$var$_containerHistoryLength);
    }
    async focusAvailable(from) {
        let skip = !!from;
        for (const i of this._history){
            if (from && i.belongsTo(from)) skip = false;
            if (!skip) {
                const result = await i.focusAvailable();
                // Result is null when the default action is prevented by the application
                // and we don't need to look further.
                if (result || result === null) return result;
            }
        }
        return false;
    }
    async resetFocus(from) {
        let skip = !!from;
        const resetQueue = {};
        for (const i of this._history){
            if (from && i.belongsTo(from)) skip = false;
            if (!skip && !resetQueue[i.uid]) resetQueue[i.uid] = i;
        }
        // Nothing is found, at least try to reset.
        for (const id of Object.keys(resetQueue)){
            if (await resetQueue[id].resetFocus()) return true;
        }
        return false;
    }
}
class $e3e23e1e89ad903c$var$DeloserHistory {
    constructor(tabster){
        this._history = [];
        this._tabster = tabster;
    }
    dispose() {
        this._history = [];
    }
    process(element) {
        var _a;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, element);
        const rootUId = ctx && ctx.root.uid;
        const deloser = $e3e23e1e89ad903c$var$DeloserAPI.getDeloser(this._tabster, element);
        if (!rootUId || !deloser) return undefined;
        const historyByRoot = this.make(rootUId, ()=>new $e3e23e1e89ad903c$var$DeloserHistoryByRoot(this._tabster, rootUId));
        if (!ctx || !ctx.modalizer || ((_a = ctx.modalizer) === null || _a === void 0 ? void 0 : _a.isActive())) historyByRoot.unshiftToDeloser(deloser, element);
        return deloser;
    }
    make(rootUId, createInstance) {
        let historyByRoot;
        for(let i = 0; i < this._history.length; i++){
            const hbr = this._history[i];
            if (hbr.rootUId === rootUId) {
                historyByRoot = hbr;
                this._history.splice(i, 1);
                break;
            }
        }
        if (!historyByRoot) historyByRoot = createInstance();
        this._history.unshift(historyByRoot);
        this._history.splice($e3e23e1e89ad903c$var$_containerHistoryLength, this._history.length - $e3e23e1e89ad903c$var$_containerHistoryLength);
        return historyByRoot;
    }
    removeDeloser(deloser) {
        this._history.forEach((i)=>{
            i.removeDeloser(deloser);
        });
        this._history = this._history.filter((i)=>i.getLength() > 0);
    }
    async focusAvailable(from) {
        let skip = !!from;
        for (const h of this._history){
            if (from && h.hasDeloser(from)) skip = false;
            if (!skip) {
                const result = await h.focusAvailable(from);
                // Result is null when the default action is prevented by the application
                // and we don't need to look further.
                if (result || result === null) return result;
            }
        }
        return false;
    }
    async resetFocus(from) {
        let skip = !!from;
        for (const h of this._history){
            if (from && h.hasDeloser(from)) skip = false;
            if (!skip && await h.resetFocus(from)) return true;
        }
        return false;
    }
}
function $e3e23e1e89ad903c$var$_setInformativeStyle$2(weakElement, remove, isActive, snapshotIndex) {}
function $e3e23e1e89ad903c$var$buildElementSelector(element, withClass, withIndex) {
    const selector = [];
    const escapeRegExp = /(:|\.|\[|\]|,|=|@)/g;
    const escapeReplaceValue = "\\$1";
    const elementId = element.getAttribute("id");
    if (elementId) selector.push("#" + elementId.replace(escapeRegExp, escapeReplaceValue));
    if (withClass !== false && element.className) element.className.split(" ").forEach((cls)=>{
        cls = cls.trim();
        if (cls) selector.push("." + cls.replace(escapeRegExp, escapeReplaceValue));
    });
    let index = 0;
    let el;
    if (withIndex !== false && selector.length === 0) {
        el = element;
        while(el){
            index++;
            el = el.previousElementSibling;
        }
        selector.unshift(":nth-child(" + index + ")");
    }
    selector.unshift(element.tagName.toLowerCase());
    return selector.join("");
}
function $e3e23e1e89ad903c$var$buildSelector(element) {
    if (!$e3e23e1e89ad903c$var$documentContains(element.ownerDocument, element)) return undefined;
    const selector = [
        $e3e23e1e89ad903c$var$buildElementSelector(element)
    ];
    let node = $e3e23e1e89ad903c$var$dom.getParentNode(element);
    while(node && node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE){
        // Stop at the shadow root as cross shadow selectors won't work.
        if (node.nodeType === Node.ELEMENT_NODE) {
            const isBody = node.tagName === "BODY";
            selector.unshift($e3e23e1e89ad903c$var$buildElementSelector(node, false, !isBody));
            if (isBody) break;
        }
        node = $e3e23e1e89ad903c$var$dom.getParentNode(node);
    }
    return selector.join(" ");
}
class $e3e23e1e89ad903c$var$Deloser extends $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, onDispose, props){
        super(tabster, element, props);
        this._isActive = false;
        this._history = [
            []
        ];
        this._snapshotIndex = 0;
        this.isActive = ()=>{
            return this._isActive;
        };
        this.setSnapshot = (index)=>{
            this._snapshotIndex = index;
            if (this._history.length > index + 1) this._history.splice(index + 1, this._history.length - index - 1);
            if (!this._history[index]) this._history[index] = [];
        };
        this.focusFirst = ()=>{
            const e = this._element.get();
            return !!e && this._tabster.focusedElement.focusFirst({
                container: e
            });
        };
        this.focusDefault = ()=>{
            const e = this._element.get();
            return !!e && this._tabster.focusedElement.focusDefault(e);
        };
        this.resetFocus = ()=>{
            const e = this._element.get();
            return !!e && this._tabster.focusedElement.resetFocus(e);
        };
        this.clearHistory = (preserveExisting)=>{
            const element = this._element.get();
            if (!element) {
                this._history[this._snapshotIndex] = [];
                return;
            }
            this._history[this._snapshotIndex] = this._history[this._snapshotIndex].filter((we)=>{
                const e = we.get();
                return e && preserveExisting ? $e3e23e1e89ad903c$var$dom.nodeContains(element, e) : false;
            });
        };
        this.uid = $e3e23e1e89ad903c$var$getElementUId(tabster.getWindow, element);
        this.strategy = props.strategy || $e3e23e1e89ad903c$export$5b8aeea6fc4d16f4.Auto;
        this._onDispose = onDispose;
    }
    dispose() {
        this._remove();
        this._onDispose(this);
        this._isActive = false;
        this._snapshotIndex = 0;
        this._props = {};
        this._history = [];
    }
    setActive(active) {
        this._isActive = active;
    }
    getActions() {
        return {
            focusDefault: this.focusDefault,
            focusFirst: this.focusFirst,
            resetFocus: this.resetFocus,
            clearHistory: this.clearHistory,
            setSnapshot: this.setSnapshot,
            isActive: this.isActive
        };
    }
    unshift(element) {
        let cur = this._history[this._snapshotIndex];
        cur = this._history[this._snapshotIndex] = cur.filter((we)=>{
            const e = we.get();
            return e && e !== element;
        });
        cur.unshift(new $e3e23e1e89ad903c$var$WeakHTMLElement(this._tabster.getWindow, element, $e3e23e1e89ad903c$var$buildSelector(element)));
        while(cur.length > $e3e23e1e89ad903c$var$_containerHistoryLength)cur.pop();
    }
    findAvailable() {
        const element = this._element.get();
        if (!element || !this._tabster.focusable.isVisible(element)) return null;
        let restoreFocusOrder = this._props.restoreFocusOrder;
        let available = null;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, element);
        if (!ctx) return null;
        const root = ctx.root;
        const rootElement = root.getElement();
        if (!rootElement) return null;
        if (restoreFocusOrder === undefined) restoreFocusOrder = root.getProps().restoreFocusOrder;
        if (restoreFocusOrder === $e3e23e1e89ad903c$export$469ba0ed3bc01311.RootDefault) available = this._tabster.focusable.findDefault({
            container: rootElement
        });
        if (!available && restoreFocusOrder === $e3e23e1e89ad903c$export$469ba0ed3bc01311.RootFirst) available = this._findFirst(rootElement);
        if (available) return available;
        const availableInHistory = this._findInHistory();
        if (availableInHistory && restoreFocusOrder === $e3e23e1e89ad903c$export$469ba0ed3bc01311.History) return availableInHistory;
        const availableDefault = this._tabster.focusable.findDefault({
            container: element
        });
        if (availableDefault && restoreFocusOrder === $e3e23e1e89ad903c$export$469ba0ed3bc01311.DeloserDefault) return availableDefault;
        const availableFirst = this._findFirst(element);
        if (availableFirst && restoreFocusOrder === $e3e23e1e89ad903c$export$469ba0ed3bc01311.DeloserFirst) return availableFirst;
        return availableDefault || availableInHistory || availableFirst || null;
    }
    customFocusLostHandler(element) {
        return element.dispatchEvent(new $e3e23e1e89ad903c$export$4dbd4cf004af5f30(this.getActions()));
    }
    _findInHistory() {
        const cur = this._history[this._snapshotIndex].slice(0);
        this.clearHistory(true);
        for(let i = 0; i < cur.length; i++){
            const we = cur[i];
            const e = we.get();
            const element = this._element.get();
            if (e && element && $e3e23e1e89ad903c$var$dom.nodeContains(element, e)) {
                if (this._tabster.focusable.isFocusable(e)) return e;
            } else if (!this._props.noSelectorCheck) {
                // Element is not in the DOM, try to locate the node by it's
                // selector. This might return not exactly the right node,
                // but it would be easily fixable by having more detailed selectors.
                const selector = we.getData();
                if (selector && element) {
                    let els;
                    try {
                        els = $e3e23e1e89ad903c$var$dom.querySelectorAll(element.ownerDocument, selector);
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    } catch (e) {
                        continue;
                    }
                    for(let i = 0; i < els.length; i++){
                        const el = els[i];
                        if (el && this._tabster.focusable.isFocusable(el)) return el;
                    }
                }
            }
        }
        return null;
    }
    _findFirst(element) {
        if (this._tabster.keyboardNavigation.isNavigatingWithKeyboard()) {
            const first = this._tabster.focusable.findFirst({
                container: element,
                useActiveModalizer: true
            });
            if (first) return first;
        }
        return null;
    }
    _remove() {}
}
class $e3e23e1e89ad903c$var$DeloserAPI {
    constructor(tabster, props){
        /**
     * Tracks if focus is inside a deloser
     */ this._inDeloser = false;
        this._isRestoringFocus = false;
        this._isPaused = false;
        this._onRestoreFocus = (event)=>{
            var _a;
            const target = event.composedPath()[0];
            if (target) {
                const available = (_a = $e3e23e1e89ad903c$var$DeloserAPI.getDeloser(this._tabster, target)) === null || _a === void 0 ? void 0 : _a.findAvailable();
                if (available) this._tabster.focusedElement.focus(available);
                event.stopImmediatePropagation();
            }
        };
        this._onFocus = (e)=>{
            if (this._restoreFocusTimer) {
                this._win().clearTimeout(this._restoreFocusTimer);
                this._restoreFocusTimer = undefined;
            }
            if (!e) {
                this._scheduleRestoreFocus();
                return;
            }
            const deloser = this._history.process(e);
            if (deloser) this._activate(deloser);
            else this._deactivate();
        };
        this._onDeloserDispose = (deloser)=>{
            this._history.removeDeloser(deloser);
            if (deloser.isActive()) this._scheduleRestoreFocus();
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        this._history = new $e3e23e1e89ad903c$var$DeloserHistory(tabster);
        tabster.queueInit(()=>{
            this._tabster.focusedElement.subscribe(this._onFocus);
            const doc = this._win().document;
            doc.addEventListener($e3e23e1e89ad903c$export$87ff539c9b9c8c83, this._onRestoreFocus);
            const activeElement = $e3e23e1e89ad903c$var$dom.getActiveElement(doc);
            if (activeElement && activeElement !== doc.body) // Adding currently focused element to the deloser history.
            this._onFocus(activeElement);
        });
        const autoDeloser = props === null || props === void 0 ? void 0 : props.autoDeloser;
        if (autoDeloser) this._autoDeloser = autoDeloser;
    }
    dispose() {
        const win = this._win();
        if (this._restoreFocusTimer) {
            win.clearTimeout(this._restoreFocusTimer);
            this._restoreFocusTimer = undefined;
        }
        if (this._autoDeloserInstance) {
            this._autoDeloserInstance.dispose();
            delete this._autoDeloserInstance;
            delete this._autoDeloser;
        }
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        win.document.removeEventListener($e3e23e1e89ad903c$export$87ff539c9b9c8c83, this._onRestoreFocus);
        this._history.dispose();
        delete this._curDeloser;
    }
    createDeloser(element, props) {
        var _a;
        const deloser = new $e3e23e1e89ad903c$var$Deloser(this._tabster, element, this._onDeloserDispose, props);
        if ($e3e23e1e89ad903c$var$dom.nodeContains(element, (_a = this._tabster.focusedElement.getFocusedElement()) !== null && _a !== void 0 ? _a : null)) this._activate(deloser);
        return deloser;
    }
    getActions(element) {
        for(let e = element; e; e = $e3e23e1e89ad903c$var$dom.getParentElement(e)){
            const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, e);
            if (tabsterOnElement && tabsterOnElement.deloser) return tabsterOnElement.deloser.getActions();
        }
        return undefined;
    }
    pause() {
        this._isPaused = true;
        if (this._restoreFocusTimer) {
            this._win().clearTimeout(this._restoreFocusTimer);
            this._restoreFocusTimer = undefined;
        }
    }
    resume(restore) {
        this._isPaused = false;
        if (restore) this._scheduleRestoreFocus();
    }
    /**
   * Activates and sets the current deloser
   */ _activate(deloser) {
        const curDeloser = this._curDeloser;
        if (curDeloser !== deloser) {
            this._inDeloser = true;
            curDeloser === null || curDeloser === void 0 || curDeloser.setActive(false);
            deloser.setActive(true);
            this._curDeloser = deloser;
        }
    }
    /**
   * Called when focus should no longer be in a deloser
   */ _deactivate() {
        var _a;
        this._inDeloser = false;
        (_a = this._curDeloser) === null || _a === void 0 || _a.setActive(false);
        this._curDeloser = undefined;
    }
    _scheduleRestoreFocus(force) {
        if (this._isPaused || this._isRestoringFocus) return;
        const restoreFocus = async ()=>{
            this._restoreFocusTimer = undefined;
            const lastFocused = this._tabster.focusedElement.getLastFocusedElement();
            if (!force && (this._isRestoringFocus || !this._inDeloser || lastFocused && !$e3e23e1e89ad903c$var$isDisplayNone(lastFocused))) return;
            const curDeloser = this._curDeloser;
            let isManual = false;
            if (curDeloser) {
                if (lastFocused && curDeloser.customFocusLostHandler(lastFocused)) return;
                if (curDeloser.strategy === $e3e23e1e89ad903c$export$5b8aeea6fc4d16f4.Manual) isManual = true;
                else {
                    const curDeloserElement = curDeloser.getElement();
                    const el = curDeloser.findAvailable();
                    if (el && (!(curDeloserElement === null || curDeloserElement === void 0 ? void 0 : curDeloserElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                        by: "deloser",
                        owner: curDeloserElement,
                        next: el
                    }))) || this._tabster.focusedElement.focus(el))) return;
                }
            }
            this._deactivate();
            if (isManual) return;
            this._isRestoringFocus = true;
            // focusAvailable returns null when the default action is prevented by the application, false
            // when nothing was focused and true when something was focused.
            if (await this._history.focusAvailable(null) === false) await this._history.resetFocus(null);
            this._isRestoringFocus = false;
        };
        if (force) restoreFocus();
        else this._restoreFocusTimer = this._win().setTimeout(restoreFocus, 100);
    }
    static getDeloser(tabster, element) {
        var _a;
        let root;
        for(let e = element; e; e = $e3e23e1e89ad903c$var$dom.getParentElement(e)){
            const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, e);
            if (tabsterOnElement) {
                if (!root) root = tabsterOnElement.root;
                const deloser = tabsterOnElement.deloser;
                if (deloser) return deloser;
            }
        }
        const deloserAPI = tabster.deloser && tabster.deloser;
        if (deloserAPI) {
            if (deloserAPI._autoDeloserInstance) return deloserAPI._autoDeloserInstance;
            const autoDeloserProps = deloserAPI._autoDeloser;
            if (root && !deloserAPI._autoDeloserInstance && autoDeloserProps) {
                const body = (_a = element.ownerDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (body) deloserAPI._autoDeloserInstance = new $e3e23e1e89ad903c$var$Deloser(tabster, body, tabster.deloser._onDeloserDispose, autoDeloserProps);
            }
            return deloserAPI._autoDeloserInstance;
        }
        return undefined;
    }
    static getHistory(instance) {
        return instance._history;
    }
    static forceRestoreFocus(instance) {
        instance._scheduleRestoreFocus(true);
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$Subscribable {
    constructor(){
        this._callbacks = [];
    }
    dispose() {
        this._callbacks = [];
        delete this._val;
    }
    subscribe(callback) {
        const callbacks = this._callbacks;
        const index = callbacks.indexOf(callback);
        if (index < 0) callbacks.push(callback);
    }
    subscribeFirst(callback) {
        const callbacks = this._callbacks;
        const index = callbacks.indexOf(callback);
        if (index >= 0) callbacks.splice(index, 1);
        callbacks.unshift(callback);
    }
    unsubscribe(callback) {
        const index = this._callbacks.indexOf(callback);
        if (index >= 0) this._callbacks.splice(index, 1);
    }
    setVal(val, detail) {
        if (this._val === val) return;
        this._val = val;
        this._callCallbacks(val, detail);
    }
    getVal() {
        return this._val;
    }
    trigger(val, detail) {
        this._callCallbacks(val, detail);
    }
    _callCallbacks(val, detail) {
        this._callbacks.forEach((callback)=>callback(val, detail));
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$_transactionTimeout = 1500;
const $e3e23e1e89ad903c$var$_pingTimeout = 3000;
const $e3e23e1e89ad903c$var$_targetIdUp = "up";
const $e3e23e1e89ad903c$var$CrossOriginTransactionTypes = {
    Bootstrap: 1,
    FocusElement: 2,
    State: 3,
    GetElement: 4,
    RestoreFocusInDeloser: 5,
    Ping: 6
};
class $e3e23e1e89ad903c$var$CrossOriginDeloserItem extends $e3e23e1e89ad903c$var$DeloserItemBase {
    constructor(tabster, deloser, trasactions){
        super();
        this._deloser = deloser;
        this._transactions = trasactions;
    }
    belongsTo(deloser) {
        return deloser.deloserUId === this._deloser.deloserUId;
    }
    async focusAvailable() {
        const data = {
            ...this._deloser,
            reset: false
        };
        return this._transactions.beginTransaction($e3e23e1e89ad903c$var$RestoreFocusInDeloserTransaction, data).then((value)=>!!value);
    }
    async resetFocus() {
        const data = {
            ...this._deloser,
            reset: true
        };
        return this._transactions.beginTransaction($e3e23e1e89ad903c$var$RestoreFocusInDeloserTransaction, data).then((value)=>!!value);
    }
}
class $e3e23e1e89ad903c$var$CrossOriginDeloserHistoryByRoot extends $e3e23e1e89ad903c$var$DeloserHistoryByRootBase {
    constructor(tabster, rootUId, transactions){
        super(tabster, rootUId);
        this._transactions = transactions;
    }
    unshift(deloser) {
        let item;
        for(let i = 0; i < this._history.length; i++)if (this._history[i].belongsTo(deloser)) {
            item = this._history[i];
            this._history.splice(i, 1);
            break;
        }
        if (!item) item = new $e3e23e1e89ad903c$var$CrossOriginDeloserItem(this._tabster, deloser, this._transactions);
        this._history.unshift(item);
        this._history.splice(10, this._history.length - 10);
    }
    async focusAvailable() {
        for (const i of this._history){
            if (await i.focusAvailable()) return true;
        }
        return false;
    }
    async resetFocus() {
        for (const i of this._history){
            if (await i.resetFocus()) return true;
        }
        return false;
    }
}
class $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(tabster, getOwner, knownTargets, value, timeout, sentTo, targetId, sendUp){
        this._inProgress = {};
        this._isDone = false;
        this._isSelfResponding = false;
        this._sentCount = 0;
        this.tabster = tabster;
        this.owner = getOwner;
        this.ownerId = $e3e23e1e89ad903c$var$getWindowUId(getOwner());
        this.id = $e3e23e1e89ad903c$var$getUId(getOwner());
        this.beginData = value;
        this._knownTargets = knownTargets;
        this._sentTo = sentTo || {
            [this.ownerId]: true
        };
        this.targetId = targetId;
        this.sendUp = sendUp;
        this.timeout = timeout;
        this._promise = new ($e3e23e1e89ad903c$var$getPromise(getOwner))((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    getTargets(knownTargets) {
        return this.targetId === $e3e23e1e89ad903c$var$_targetIdUp ? this.sendUp ? {
            [$e3e23e1e89ad903c$var$_targetIdUp]: {
                send: this.sendUp
            }
        } : null : this.targetId ? knownTargets[this.targetId] ? {
            [this.targetId]: {
                send: knownTargets[this.targetId].send
            }
        } : null : Object.keys(knownTargets).length === 0 && this.sendUp ? {
            [$e3e23e1e89ad903c$var$_targetIdUp]: {
                send: this.sendUp
            }
        } : Object.keys(knownTargets).length > 0 ? knownTargets : null;
    }
    begin(selfResponse) {
        const targets = this.getTargets(this._knownTargets);
        const sentTo = {
            ...this._sentTo
        };
        if (targets) for (const id of Object.keys(targets))sentTo[id] = true;
        const data = {
            transaction: this.id,
            type: this.type,
            isResponse: false,
            timestamp: Date.now(),
            owner: this.ownerId,
            sentto: sentTo,
            timeout: this.timeout,
            beginData: this.beginData
        };
        if (this.targetId) data.target = this.targetId;
        if (selfResponse) {
            this._isSelfResponding = true;
            selfResponse(data).then((value)=>{
                this._isSelfResponding = false;
                if (value !== undefined) {
                    if (!this.endData) this.endData = value;
                }
                if (this.endData || this._sentCount === 0) this.end();
            });
        }
        if (targets) {
            for (const id of Object.keys(targets))if (!(id in this._sentTo)) this._send(targets[id].send, id, data);
        }
        if (this._sentCount === 0 && !this._isSelfResponding) this.end();
        return this._promise;
    }
    _send(send, targetId, data) {
        if (this._inProgress[targetId] === undefined) {
            this._inProgress[targetId] = true;
            this._sentCount++;
            send(data);
        }
    }
    end(error) {
        if (this._isDone) return;
        this._isDone = true;
        if (this.endData === undefined && error) {
            if (this._reject) this._reject(error);
        } else if (this._resolve) this._resolve(this.endData);
    }
    onResponse(data) {
        const endData = data.endData;
        if (endData !== undefined && !this.endData) this.endData = endData;
        const inProgressId = data.target === $e3e23e1e89ad903c$var$_targetIdUp ? $e3e23e1e89ad903c$var$_targetIdUp : data.owner;
        if (this._inProgress[inProgressId]) {
            this._inProgress[inProgressId] = false;
            this._sentCount--;
            if (this.endData || this._sentCount === 0 && !this._isSelfResponding) this.end();
        }
    }
}
class $e3e23e1e89ad903c$var$BootstrapTransaction extends $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(){
        super(...arguments);
        this.type = $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.Bootstrap;
    }
    static shouldForward() {
        return false;
    }
    static async makeResponse(tabster) {
        return {
            isNavigatingWithKeyboard: tabster.keyboardNavigation.isNavigatingWithKeyboard()
        };
    }
}
class $e3e23e1e89ad903c$var$FocusElementTransaction extends $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(){
        super(...arguments);
        this.type = $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.FocusElement;
    }
    static shouldSelfRespond() {
        return true;
    }
    static shouldForward(tabster, data, getOwner) {
        const el = $e3e23e1e89ad903c$var$GetElementTransaction.findElement(tabster, getOwner, data.beginData);
        return !el || !tabster.focusable.isFocusable(el);
    }
    static async makeResponse(tabster, data, getOwner, ownerId, transactions, forwardResult) {
        const el = $e3e23e1e89ad903c$var$GetElementTransaction.findElement(tabster, getOwner, data.beginData);
        return !!el && tabster.focusedElement.focus(el, true) || !!await forwardResult;
    }
}
const $e3e23e1e89ad903c$var$CrossOriginStates = {
    Focused: 1,
    Blurred: 2,
    Observed: 3,
    DeadWindow: 4,
    KeyboardNavigation: 5,
    Outline: 6
};
class $e3e23e1e89ad903c$var$StateTransaction extends $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(){
        super(...arguments);
        this.type = $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.State;
    }
    static shouldSelfRespond(tabster, data) {
        return data.state !== $e3e23e1e89ad903c$var$CrossOriginStates.DeadWindow && data.state !== $e3e23e1e89ad903c$var$CrossOriginStates.KeyboardNavigation;
    }
    static async makeResponse(tabster, data, getOwner, ownerId, transactions, forwardResult, isSelfResponse) {
        const timestamp = data.timestamp;
        const beginData = data.beginData;
        if (timestamp && beginData) switch(beginData.state){
            case $e3e23e1e89ad903c$var$CrossOriginStates.Focused:
                return $e3e23e1e89ad903c$var$StateTransaction._makeFocusedResponse(tabster, timestamp, beginData, transactions, isSelfResponse);
            case $e3e23e1e89ad903c$var$CrossOriginStates.Blurred:
                return $e3e23e1e89ad903c$var$StateTransaction._makeBlurredResponse(tabster, timestamp, beginData, transactions.ctx);
            case $e3e23e1e89ad903c$var$CrossOriginStates.Observed:
                return $e3e23e1e89ad903c$var$StateTransaction._makeObservedResponse(tabster, beginData);
            case $e3e23e1e89ad903c$var$CrossOriginStates.DeadWindow:
                return $e3e23e1e89ad903c$var$StateTransaction._makeDeadWindowResponse(tabster, beginData, transactions, forwardResult);
            case $e3e23e1e89ad903c$var$CrossOriginStates.KeyboardNavigation:
                return $e3e23e1e89ad903c$var$StateTransaction._makeKeyboardNavigationResponse(tabster, transactions.ctx, beginData.isNavigatingWithKeyboard);
            case $e3e23e1e89ad903c$var$CrossOriginStates.Outline:
                return $e3e23e1e89ad903c$var$StateTransaction._makeOutlineResponse(tabster, transactions.ctx, beginData.outline);
        }
        return true;
    }
    static createElement(tabster, beginData) {
        return beginData.uid ? new $e3e23e1e89ad903c$var$CrossOriginElement(tabster, beginData.uid, beginData.ownerUId, beginData.id, beginData.rootUId, beginData.observedName, beginData.observedDetails) : null;
    }
    static async _makeFocusedResponse(tabster, timestamp, beginData, transactions, isSelfResponse) {
        const element = $e3e23e1e89ad903c$var$StateTransaction.createElement(tabster, beginData);
        if (beginData && beginData.ownerUId && element) {
            transactions.ctx.focusOwner = beginData.ownerUId;
            transactions.ctx.focusOwnerTimestamp = timestamp;
            if (!isSelfResponse && beginData.rootUId && beginData.deloserUId) {
                const deloserAPI = tabster.deloser;
                if (deloserAPI) {
                    const history = $e3e23e1e89ad903c$var$DeloserAPI.getHistory(deloserAPI);
                    const deloser = {
                        ownerUId: beginData.ownerUId,
                        deloserUId: beginData.deloserUId,
                        rootUId: beginData.rootUId
                    };
                    const historyItem = history.make(beginData.rootUId, ()=>new $e3e23e1e89ad903c$var$CrossOriginDeloserHistoryByRoot(tabster, deloser.rootUId, transactions));
                    historyItem.unshift(deloser);
                }
            }
            $e3e23e1e89ad903c$var$CrossOriginFocusedElementState.setVal(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tabster.crossOrigin.focusedElement, element, {
                isFocusedProgrammatically: beginData.isFocusedProgrammatically
            });
        }
        return true;
    }
    static async _makeBlurredResponse(tabster, timestamp, beginData, context) {
        if (beginData && (beginData.ownerUId === context.focusOwner || beginData.force) && (!context.focusOwnerTimestamp || context.focusOwnerTimestamp < timestamp)) $e3e23e1e89ad903c$var$CrossOriginFocusedElementState.setVal(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tabster.crossOrigin.focusedElement, undefined, {});
        return true;
    }
    static async _makeObservedResponse(tabster, beginData) {
        const name = beginData.observedName;
        const element = $e3e23e1e89ad903c$var$StateTransaction.createElement(tabster, beginData);
        if (name && element) $e3e23e1e89ad903c$var$CrossOriginObservedElementState.trigger(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tabster.crossOrigin.observedElement, element, {
            names: [
                name
            ],
            details: beginData.observedDetails
        });
        return true;
    }
    static async _makeDeadWindowResponse(tabster, beginData, transactions, forwardResult) {
        const deadUId = beginData && beginData.ownerUId;
        if (deadUId) transactions.removeTarget(deadUId);
        return forwardResult.then(()=>{
            if (deadUId === transactions.ctx.focusOwner) {
                const deloserAPI = tabster.deloser;
                if (deloserAPI) $e3e23e1e89ad903c$var$DeloserAPI.forceRestoreFocus(deloserAPI);
            }
            return true;
        });
    }
    static async _makeKeyboardNavigationResponse(tabster, context, isNavigatingWithKeyboard) {
        if (isNavigatingWithKeyboard !== undefined && tabster.keyboardNavigation.isNavigatingWithKeyboard() !== isNavigatingWithKeyboard) {
            context.ignoreKeyboardNavigationStateUpdate = true;
            tabster.keyboardNavigation.setNavigatingWithKeyboard(isNavigatingWithKeyboard);
            context.ignoreKeyboardNavigationStateUpdate = false;
        }
        return true;
    }
    static async _makeOutlineResponse(tabster, context, props) {
        if (context.origOutlineSetup) context.origOutlineSetup.call(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tabster.outline, props);
        return true;
    }
}
class $e3e23e1e89ad903c$var$GetElementTransaction extends $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(){
        super(...arguments);
        this.type = $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.GetElement;
    }
    static shouldSelfRespond() {
        return true;
    }
    static findElement(tabster, getOwner, data) {
        let element;
        if (data && (!data.ownerId || data.ownerId === $e3e23e1e89ad903c$var$getWindowUId(getOwner()))) {
            if (data.id) {
                element = $e3e23e1e89ad903c$var$dom.getElementById(getOwner().document, data.id);
                if (element && data.rootId) {
                    const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, element);
                    if (!ctx || ctx.root.uid !== data.rootId) return null;
                }
            } else if (data.uid) {
                const ref = $e3e23e1e89ad903c$var$getInstanceContext(getOwner).elementByUId[data.uid];
                element = ref && ref.get();
            } else if (data.observedName) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            element = tabster.observedElement.getElement(data.observedName, data.accessibility);
        }
        return element || null;
    }
    static getElementData(tabster, element, getOwner, context, ownerUId) {
        const deloser = $e3e23e1e89ad903c$var$DeloserAPI.getDeloser(tabster, element);
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, element);
        const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, element);
        const observed = tabsterOnElement && tabsterOnElement.observed;
        return {
            uid: $e3e23e1e89ad903c$var$getElementUId(getOwner, element),
            ownerUId: ownerUId,
            id: element.id || undefined,
            rootUId: ctx ? ctx.root.uid : undefined,
            deloserUId: deloser ? $e3e23e1e89ad903c$var$getDeloserUID(getOwner, context, deloser) : undefined,
            observedName: observed && observed.names && observed.names[0],
            observedDetails: observed && observed.details
        };
    }
    static async makeResponse(tabster, data, getOwner, ownerUId, transactions, forwardResult) {
        const beginData = data.beginData;
        let element;
        let dataOut;
        if (beginData === undefined) element = tabster.focusedElement.getFocusedElement();
        else if (beginData) element = $e3e23e1e89ad903c$var$GetElementTransaction.findElement(tabster, getOwner, beginData) || undefined;
        if (!element && beginData) {
            const name = beginData.observedName;
            const timeout = data.timeout;
            const accessibility = beginData.accessibility;
            if (name && timeout) {
                const e = await new ($e3e23e1e89ad903c$var$getPromise(getOwner))((resolve)=>{
                    let isWaitElementResolved = false;
                    let isForwardResolved = false;
                    let isResolved = false;
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    tabster.observedElement.waitElement(name, timeout, accessibility).result.then((value)=>{
                        isWaitElementResolved = true;
                        if (!isResolved && (value || isForwardResolved)) {
                            isResolved = true;
                            resolve({
                                element: value
                            });
                        }
                    });
                    forwardResult.then((value)=>{
                        isForwardResolved = true;
                        if (!isResolved && (value || isWaitElementResolved)) {
                            isResolved = true;
                            resolve({
                                crossOrigin: value
                            });
                        }
                    });
                });
                if (e.element) element = e.element;
                else if (e.crossOrigin) dataOut = e.crossOrigin;
            }
        }
        return element ? $e3e23e1e89ad903c$var$GetElementTransaction.getElementData(tabster, element, getOwner, transactions.ctx, ownerUId) : dataOut;
    }
}
class $e3e23e1e89ad903c$var$RestoreFocusInDeloserTransaction extends $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(){
        super(...arguments);
        this.type = $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.RestoreFocusInDeloser;
    }
    static async makeResponse(tabster, data, getOwner, ownerId, transactions, forwardResult) {
        const forwardRet = await forwardResult;
        const begin = !forwardRet && data.beginData;
        const uid = begin && begin.deloserUId;
        const deloser = uid && transactions.ctx.deloserByUId[uid];
        const deloserAPI = tabster.deloser;
        if (begin && deloser && deloserAPI) {
            const history = $e3e23e1e89ad903c$var$DeloserAPI.getHistory(deloserAPI);
            return begin.reset ? history.resetFocus(deloser) : history.focusAvailable(deloser);
        }
        return !!forwardRet;
    }
}
class $e3e23e1e89ad903c$var$PingTransaction extends $e3e23e1e89ad903c$var$CrossOriginTransaction {
    constructor(){
        super(...arguments);
        this.type = $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.Ping;
    }
    static shouldForward() {
        return false;
    }
    static async makeResponse() {
        return true;
    }
}
class $e3e23e1e89ad903c$var$CrossOriginTransactions {
    constructor(tabster, getOwner, context){
        this._knownTargets = {};
        this._transactions = {};
        this._isDefaultSendUp = false;
        this.isSetUp = false;
        this._onMessage = (e)=>{
            if (e.data.owner === this._ownerUId || !this._tabster) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const data = e.data;
            let transactionId;
            if (!data || !(transactionId = data.transaction) || !data.type || !data.timestamp || !data.owner || !data.sentto) return;
            let knownTarget = this._knownTargets[data.owner];
            if (!knownTarget && e.send && data.owner !== this._ownerUId) knownTarget = this._knownTargets[data.owner] = {
                send: e.send
            };
            if (knownTarget) knownTarget.last = Date.now();
            if (data.isResponse) {
                const t = this._transactions[transactionId];
                if (t && t.transaction && t.transaction.type === data.type) t.transaction.onResponse(data);
            } else {
                const Transaction = this._getTransactionClass(data.type);
                const forwardResult = this.forwardTransaction(data);
                if (Transaction && e.send) Transaction.makeResponse(this._tabster, data, this._owner, this._ownerUId, this, forwardResult, false).then((r)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const response = {
                        transaction: data.transaction,
                        type: data.type,
                        isResponse: true,
                        timestamp: Date.now(),
                        owner: this._ownerUId,
                        timeout: data.timeout,
                        sentto: {},
                        target: data.target === $e3e23e1e89ad903c$var$_targetIdUp ? $e3e23e1e89ad903c$var$_targetIdUp : data.owner,
                        endData: r
                    };
                    e.send(response);
                });
            }
        };
        this._onPageHide = ()=>{
            this._dead();
        };
        this._onBrowserMessage = (e)=>{
            if (e.source === this._owner()) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const send = (data)=>{
                if (e.source && e.source.postMessage) e.source.postMessage(JSON.stringify(data), "*");
            };
            try {
                this._onMessage({
                    data: JSON.parse(e.data),
                    send: send
                });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (e) {
            /* Ignore */ }
        };
        this._tabster = tabster;
        this._owner = getOwner;
        this._ownerUId = $e3e23e1e89ad903c$var$getWindowUId(getOwner());
        this.ctx = context;
    }
    setup(sendUp) {
        if (this.isSetUp) ;
        else {
            this.isSetUp = true;
            this.setSendUp(sendUp);
            this._owner().addEventListener("pagehide", this._onPageHide);
            this._ping();
        }
        return this._onMessage;
    }
    setSendUp(sendUp) {
        if (!this.isSetUp) throw new Error("CrossOrigin is not set up.");
        this.sendUp = sendUp || undefined;
        const owner = this._owner();
        if (sendUp === undefined) {
            if (!this._isDefaultSendUp) {
                if (owner.document) {
                    this._isDefaultSendUp = true;
                    if (owner.parent && owner.parent !== owner && owner.parent.postMessage) this.sendUp = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    data)=>{
                        owner.parent.postMessage(JSON.stringify(data), "*");
                    };
                    owner.addEventListener("message", this._onBrowserMessage);
                }
            }
        } else if (this._isDefaultSendUp) {
            owner.removeEventListener("message", this._onBrowserMessage);
            this._isDefaultSendUp = false;
        }
        return this._onMessage;
    }
    async dispose() {
        const owner = this._owner();
        if (this._pingTimer) {
            owner.clearTimeout(this._pingTimer);
            this._pingTimer = undefined;
        }
        owner.removeEventListener("message", this._onBrowserMessage);
        owner.removeEventListener("pagehide", this._onPageHide);
        await this._dead();
        delete this._deadPromise;
        for (const id of Object.keys(this._transactions)){
            const t = this._transactions[id];
            if (t.timer) {
                owner.clearTimeout(t.timer);
                delete t.timer;
            }
            t.transaction.end();
        }
        this._knownTargets = {};
        delete this.sendUp;
    }
    beginTransaction(Transaction, value, timeout, sentTo, targetId, withReject) {
        if (!this._owner) return $e3e23e1e89ad903c$var$getPromise(this._owner).reject();
        const transaction = new Transaction(this._tabster, this._owner, this._knownTargets, value, timeout, sentTo, targetId, this.sendUp);
        let selfResponse;
        if (Transaction.shouldSelfRespond && Transaction.shouldSelfRespond(this._tabster, value, this._owner, this._ownerUId)) selfResponse = (data)=>{
            return Transaction.makeResponse(this._tabster, data, this._owner, this._ownerUId, this, $e3e23e1e89ad903c$var$getPromise(this._owner).resolve(undefined), true);
        };
        return this._beginTransaction(transaction, timeout, selfResponse, withReject);
    }
    removeTarget(uid) {
        delete this._knownTargets[uid];
    }
    _beginTransaction(transaction, timeout, selfResponse, withReject) {
        const owner = this._owner();
        const wrapper = {
            transaction: transaction,
            timer: owner.setTimeout(()=>{
                delete wrapper.timer;
                transaction.end("Cross origin transaction timed out.");
            }, $e3e23e1e89ad903c$var$_transactionTimeout + (timeout || 0))
        };
        this._transactions[transaction.id] = wrapper;
        const ret = transaction.begin(selfResponse);
        ret.catch(()=>{
        /**/ }).finally(()=>{
            if (wrapper.timer) owner.clearTimeout(wrapper.timer);
            delete this._transactions[transaction.id];
        });
        return ret.then((value)=>value, withReject ? undefined : ()=>undefined);
    }
    forwardTransaction(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    data) {
        const owner = this._owner;
        let targetId = data.target;
        if (targetId === this._ownerUId) return $e3e23e1e89ad903c$var$getPromise(owner).resolve();
        const Transaction = this._getTransactionClass(data.type);
        if (Transaction) {
            if (Transaction.shouldForward === undefined || Transaction.shouldForward(this._tabster, data, owner, this._ownerUId)) {
                const sentTo = data.sentto;
                if (targetId === $e3e23e1e89ad903c$var$_targetIdUp) {
                    targetId = undefined;
                    sentTo[this._ownerUId] = true;
                }
                delete sentTo[$e3e23e1e89ad903c$var$_targetIdUp];
                return this._beginTransaction(new Transaction(this._tabster, owner, this._knownTargets, data.beginData, data.timeout, sentTo, targetId, this.sendUp), data.timeout);
            } else return $e3e23e1e89ad903c$var$getPromise(owner).resolve();
        }
        return $e3e23e1e89ad903c$var$getPromise(owner).reject(`Unknown transaction type ${data.type}`);
    }
    _getTransactionClass(type) {
        switch(type){
            case $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.Bootstrap:
                return $e3e23e1e89ad903c$var$BootstrapTransaction;
            case $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.FocusElement:
                return $e3e23e1e89ad903c$var$FocusElementTransaction;
            case $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.State:
                return $e3e23e1e89ad903c$var$StateTransaction;
            case $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.GetElement:
                return $e3e23e1e89ad903c$var$GetElementTransaction;
            case $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.RestoreFocusInDeloser:
                return $e3e23e1e89ad903c$var$RestoreFocusInDeloserTransaction;
            case $e3e23e1e89ad903c$var$CrossOriginTransactionTypes.Ping:
                return $e3e23e1e89ad903c$var$PingTransaction;
            default:
                return null;
        }
    }
    async _dead() {
        if (!this._deadPromise && this.ctx.focusOwner === this._ownerUId) this._deadPromise = this.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, {
            ownerUId: this._ownerUId,
            state: $e3e23e1e89ad903c$var$CrossOriginStates.DeadWindow
        });
        if (this._deadPromise) await this._deadPromise;
    }
    async _ping() {
        if (this._pingTimer) return;
        let deadWindows;
        const now = Date.now();
        const targets = Object.keys(this._knownTargets).filter((uid)=>now - (this._knownTargets[uid].last || 0) > $e3e23e1e89ad903c$var$_pingTimeout);
        if (this.sendUp) targets.push($e3e23e1e89ad903c$var$_targetIdUp);
        if (targets.length) await $e3e23e1e89ad903c$var$getPromise(this._owner).all(targets.map((uid)=>this.beginTransaction($e3e23e1e89ad903c$var$PingTransaction, undefined, undefined, undefined, uid, true).then(()=>true, ()=>{
                if (uid !== $e3e23e1e89ad903c$var$_targetIdUp) {
                    if (!deadWindows) deadWindows = {};
                    deadWindows[uid] = true;
                    delete this._knownTargets[uid];
                }
                return false;
            })));
        if (deadWindows) {
            const focused = await this.beginTransaction($e3e23e1e89ad903c$var$GetElementTransaction, undefined);
            if (!focused && this.ctx.focusOwner && this.ctx.focusOwner in deadWindows) {
                await this.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, {
                    ownerUId: this._ownerUId,
                    state: $e3e23e1e89ad903c$var$CrossOriginStates.Blurred,
                    force: true
                });
                const deloserAPI = this._tabster.deloser;
                if (deloserAPI) $e3e23e1e89ad903c$var$DeloserAPI.forceRestoreFocus(deloserAPI);
            }
        }
        this._pingTimer = this._owner().setTimeout(()=>{
            this._pingTimer = undefined;
            this._ping();
        }, $e3e23e1e89ad903c$var$_pingTimeout);
    }
}
class $e3e23e1e89ad903c$var$CrossOriginElement {
    constructor(tabster, uid, ownerId, id, rootId, observedName, observedDetails){
        this._tabster = tabster;
        this.uid = uid;
        this.ownerId = ownerId;
        this.id = id;
        this.rootId = rootId;
        this.observedName = observedName;
        this.observedDetails = observedDetails;
    }
    focus(noFocusedProgrammaticallyFlag, noAccessibleCheck) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tabster.crossOrigin.focusedElement.focus(this, noFocusedProgrammaticallyFlag, noAccessibleCheck);
    }
}
class $e3e23e1e89ad903c$var$CrossOriginFocusedElementState extends $e3e23e1e89ad903c$var$Subscribable {
    constructor(transactions){
        super();
        this._transactions = transactions;
    }
    async focus(element, noFocusedProgrammaticallyFlag, noAccessibleCheck) {
        return this._focus({
            uid: element.uid,
            id: element.id,
            rootId: element.rootId,
            ownerId: element.ownerId,
            observedName: element.observedName
        }, noFocusedProgrammaticallyFlag, noAccessibleCheck);
    }
    async focusById(elementId, rootId, noFocusedProgrammaticallyFlag, noAccessibleCheck) {
        return this._focus({
            id: elementId,
            rootId: rootId
        }, noFocusedProgrammaticallyFlag, noAccessibleCheck);
    }
    async focusByObservedName(observedName, timeout, rootId, noFocusedProgrammaticallyFlag, noAccessibleCheck) {
        return this._focus({
            observedName: observedName,
            rootId: rootId
        }, noFocusedProgrammaticallyFlag, noAccessibleCheck, timeout);
    }
    async _focus(elementData, noFocusedProgrammaticallyFlag, noAccessibleCheck, timeout) {
        return this._transactions.beginTransaction($e3e23e1e89ad903c$var$FocusElementTransaction, {
            ...elementData,
            noFocusedProgrammaticallyFlag: noFocusedProgrammaticallyFlag,
            noAccessibleCheck: noAccessibleCheck
        }, timeout).then((value)=>!!value);
    }
    static setVal(instance, val, detail) {
        instance.setVal(val, detail);
    }
}
class $e3e23e1e89ad903c$var$CrossOriginObservedElementState extends $e3e23e1e89ad903c$var$Subscribable {
    constructor(tabster, transactions){
        super();
        this._lastRequestFocusId = 0;
        this._tabster = tabster;
        this._transactions = transactions;
    }
    async getElement(observedName, accessibility) {
        return this.waitElement(observedName, 0, accessibility);
    }
    async waitElement(observedName, timeout, accessibility) {
        return this._transactions.beginTransaction($e3e23e1e89ad903c$var$GetElementTransaction, {
            observedName: observedName,
            accessibility: accessibility
        }, timeout).then((value)=>value ? $e3e23e1e89ad903c$var$StateTransaction.createElement(this._tabster, value) : null);
    }
    async requestFocus(observedName, timeout) {
        const requestId = ++this._lastRequestFocusId;
        return this.waitElement(observedName, timeout, $e3e23e1e89ad903c$export$4c90aef933fea154.Focusable).then((element)=>this._lastRequestFocusId === requestId && element ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this._tabster.crossOrigin.focusedElement.focus(element, true) : false);
    }
    static trigger(instance, element, details) {
        instance.trigger(element, details);
    }
}
class $e3e23e1e89ad903c$var$CrossOriginAPI {
    constructor(tabster){
        this._init = ()=>{
            const tabster = this._tabster;
            tabster.keyboardNavigation.subscribe(this._onKeyboardNavigationStateChanged);
            tabster.focusedElement.subscribe(this._onFocus);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tabster.observedElement.subscribe(this._onObserved);
            if (!this._ctx.origOutlineSetup) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this._ctx.origOutlineSetup = tabster.outline.setup;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tabster.outline.setup = this._outlineSetup;
            }
            this._transactions.beginTransaction($e3e23e1e89ad903c$var$BootstrapTransaction, undefined, undefined, undefined, $e3e23e1e89ad903c$var$_targetIdUp).then((data)=>{
                if (data && this._tabster.keyboardNavigation.isNavigatingWithKeyboard() !== data.isNavigatingWithKeyboard) {
                    this._ctx.ignoreKeyboardNavigationStateUpdate = true;
                    this._tabster.keyboardNavigation.setNavigatingWithKeyboard(data.isNavigatingWithKeyboard);
                    this._ctx.ignoreKeyboardNavigationStateUpdate = false;
                }
            });
        };
        this._onKeyboardNavigationStateChanged = (value)=>{
            if (!this._ctx.ignoreKeyboardNavigationStateUpdate) this._transactions.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, {
                state: $e3e23e1e89ad903c$var$CrossOriginStates.KeyboardNavigation,
                ownerUId: $e3e23e1e89ad903c$var$getWindowUId(this._win()),
                isNavigatingWithKeyboard: value
            });
        };
        this._onFocus = (element)=>{
            const win = this._win();
            const ownerUId = $e3e23e1e89ad903c$var$getWindowUId(win);
            if (this._blurTimer) {
                win.clearTimeout(this._blurTimer);
                this._blurTimer = undefined;
            }
            if (element) this._transactions.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, {
                ...$e3e23e1e89ad903c$var$GetElementTransaction.getElementData(this._tabster, element, this._win, this._ctx, ownerUId),
                state: $e3e23e1e89ad903c$var$CrossOriginStates.Focused
            });
            else this._blurTimer = win.setTimeout(()=>{
                this._blurTimer = undefined;
                if (this._ctx.focusOwner && this._ctx.focusOwner === ownerUId) this._transactions.beginTransaction($e3e23e1e89ad903c$var$GetElementTransaction, undefined).then((value)=>{
                    if (!value && this._ctx.focusOwner === ownerUId) this._transactions.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, {
                        ownerUId: ownerUId,
                        state: $e3e23e1e89ad903c$var$CrossOriginStates.Blurred,
                        force: false
                    });
                });
            }, 0);
        };
        this._onObserved = (element, details)=>{
            var _a;
            const d = $e3e23e1e89ad903c$var$GetElementTransaction.getElementData(this._tabster, element, this._win, this._ctx, $e3e23e1e89ad903c$var$getWindowUId(this._win()));
            d.state = $e3e23e1e89ad903c$var$CrossOriginStates.Observed;
            d.observedName = (_a = details.names) === null || _a === void 0 ? void 0 : _a[0];
            d.observedDetails = details.details;
            this._transactions.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, d);
        };
        this._outlineSetup = (props)=>{
            this._transactions.beginTransaction($e3e23e1e89ad903c$var$StateTransaction, {
                state: $e3e23e1e89ad903c$var$CrossOriginStates.Outline,
                ownerUId: $e3e23e1e89ad903c$var$getWindowUId(this._win()),
                outline: props
            });
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        this._ctx = {
            ignoreKeyboardNavigationStateUpdate: false,
            deloserByUId: {}
        };
        this._transactions = new $e3e23e1e89ad903c$var$CrossOriginTransactions(tabster, this._win, this._ctx);
        this.focusedElement = new $e3e23e1e89ad903c$var$CrossOriginFocusedElementState(this._transactions);
        this.observedElement = new $e3e23e1e89ad903c$var$CrossOriginObservedElementState(tabster, this._transactions);
    }
    setup(sendUp) {
        if (this.isSetUp()) return this._transactions.setSendUp(sendUp);
        else {
            this._tabster.queueInit(this._init);
            return this._transactions.setup(sendUp);
        }
    }
    isSetUp() {
        return this._transactions.isSetUp;
    }
    dispose() {
        var _a;
        const tabster = this._tabster;
        tabster.keyboardNavigation.unsubscribe(this._onKeyboardNavigationStateChanged);
        tabster.focusedElement.unsubscribe(this._onFocus);
        (_a = tabster.observedElement) === null || _a === void 0 || _a.unsubscribe(this._onObserved);
        this._transactions.dispose();
        this.focusedElement.dispose();
        this.observedElement.dispose();
        this._ctx.deloserByUId = {};
    }
}
function $e3e23e1e89ad903c$var$getDeloserUID(getWindow, context, deloser) {
    const deloserElement = deloser.getElement();
    if (deloserElement) {
        const uid = $e3e23e1e89ad903c$var$getElementUId(getWindow, deloserElement);
        if (!context.deloserByUId[uid]) context.deloserByUId[uid] = deloser;
        return uid;
    }
    return undefined;
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$FocusableAPI {
    constructor(tabster){
        this._tabster = tabster;
    }
    dispose() {
    /**/ }
    getProps(element) {
        const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, element);
        return tabsterOnElement && tabsterOnElement.focusable || {};
    }
    isFocusable(el, includeProgrammaticallyFocusable, noVisibleCheck, noAccessibleCheck) {
        if ($e3e23e1e89ad903c$var$matchesSelector(el, $e3e23e1e89ad903c$export$9352ce9777935162) && (includeProgrammaticallyFocusable || el.tabIndex !== -1)) return (noVisibleCheck || this.isVisible(el)) && (noAccessibleCheck || this.isAccessible(el));
        return false;
    }
    isVisible(el) {
        if (!el.ownerDocument || el.nodeType !== Node.ELEMENT_NODE) return false;
        if ($e3e23e1e89ad903c$var$isDisplayNone(el)) return false;
        const rect = el.ownerDocument.body.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) // This might happen, for example, if our <body> is in hidden <iframe>.
        return false;
        return true;
    }
    isAccessible(el) {
        var _a;
        for(let e = el; e; e = $e3e23e1e89ad903c$var$dom.getParentElement(e)){
            const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, e);
            if (this._isHidden(e)) return false;
            const ignoreDisabled = (_a = tabsterOnElement === null || tabsterOnElement === void 0 ? void 0 : tabsterOnElement.focusable) === null || _a === void 0 ? void 0 : _a.ignoreAriaDisabled;
            if (!ignoreDisabled && this._isDisabled(e)) return false;
        }
        return true;
    }
    _isDisabled(el) {
        return el.hasAttribute("disabled");
    }
    _isHidden(el) {
        var _a;
        const attrVal = el.getAttribute("aria-hidden");
        if (attrVal && attrVal.toLowerCase() === "true") {
            if (!((_a = this._tabster.modalizer) === null || _a === void 0 ? void 0 : _a.isAugmented(el))) return true;
        }
        return false;
    }
    findFirst(options, out) {
        return this.findElement({
            ...options
        }, out);
    }
    findLast(options, out) {
        return this.findElement({
            isBackward: true,
            ...options
        }, out);
    }
    findNext(options, out) {
        return this.findElement({
            ...options
        }, out);
    }
    findPrev(options, out) {
        return this.findElement({
            ...options,
            isBackward: true
        }, out);
    }
    findDefault(options, out) {
        return this.findElement({
            ...options,
            acceptCondition: (el)=>this.isFocusable(el, options.includeProgrammaticallyFocusable) && !!this.getProps(el).isDefault
        }, out) || null;
    }
    findAll(options) {
        return this._findElements(true, options) || [];
    }
    findElement(options, out) {
        const found = this._findElements(false, options, out);
        return found ? found[0] : found;
    }
    _findElements(isFindAll, options, out) {
        var _a, _b, _c;
        const { container: container, currentElement: currentElement = null, includeProgrammaticallyFocusable: includeProgrammaticallyFocusable, useActiveModalizer: useActiveModalizer, ignoreAccessibility: ignoreAccessibility, modalizerId: modalizerId, isBackward: isBackward, onElement: onElement } = options;
        if (!out) out = {};
        const elements = [];
        let { acceptCondition: acceptCondition } = options;
        const hasCustomCondition = !!acceptCondition;
        if (!container) return null;
        if (!acceptCondition) acceptCondition = (el)=>this.isFocusable(el, includeProgrammaticallyFocusable, false, ignoreAccessibility);
        const acceptElementState = {
            container: container,
            modalizerUserId: modalizerId === undefined && useActiveModalizer ? (_a = this._tabster.modalizer) === null || _a === void 0 ? void 0 : _a.activeId : modalizerId || ((_c = (_b = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, container)) === null || _b === void 0 ? void 0 : _b.modalizer) === null || _c === void 0 ? void 0 : _c.userId),
            from: currentElement || container,
            isBackward: isBackward,
            isFindAll: isFindAll,
            acceptCondition: acceptCondition,
            hasCustomCondition: hasCustomCondition,
            includeProgrammaticallyFocusable: includeProgrammaticallyFocusable,
            ignoreAccessibility: ignoreAccessibility,
            cachedGrouppers: {},
            cachedRadioGroups: {}
        };
        const walker = $e3e23e1e89ad903c$var$createElementTreeWalker(container.ownerDocument, container, (node)=>this._acceptElement(node, acceptElementState));
        if (!walker) return null;
        const prepareForNextElement = (shouldContinueIfNotFound)=>{
            var _a, _b;
            const foundElement = (_a = acceptElementState.foundElement) !== null && _a !== void 0 ? _a : acceptElementState.foundBackward;
            if (foundElement) elements.push(foundElement);
            if (isFindAll) {
                if (foundElement) {
                    acceptElementState.found = false;
                    delete acceptElementState.foundElement;
                    delete acceptElementState.foundBackward;
                    delete acceptElementState.fromCtx;
                    acceptElementState.from = foundElement;
                    if (onElement && !onElement(foundElement)) return false;
                }
                return !!(foundElement || shouldContinueIfNotFound);
            } else {
                if (foundElement && out) out.uncontrolled = (_b = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, foundElement)) === null || _b === void 0 ? void 0 : _b.uncontrolled;
                return !!(shouldContinueIfNotFound && !foundElement);
            }
        };
        if (!currentElement) out.outOfDOMOrder = true;
        if (currentElement && $e3e23e1e89ad903c$var$dom.nodeContains(container, currentElement)) walker.currentNode = currentElement;
        else if (isBackward) {
            const lastChild = $e3e23e1e89ad903c$var$getLastChild$2(container);
            if (!lastChild) return null;
            if (this._acceptElement(lastChild, acceptElementState) === NodeFilter.FILTER_ACCEPT && !prepareForNextElement(true)) {
                if (acceptElementState.skippedFocusable) out.outOfDOMOrder = true;
                return elements;
            }
            walker.currentNode = lastChild;
        }
        do if (isBackward) walker.previousNode();
        else walker.nextNode();
        while (prepareForNextElement());
        if (acceptElementState.skippedFocusable) out.outOfDOMOrder = true;
        return elements.length ? elements : null;
    }
    _acceptElement(element, state) {
        var _a, _b, _c;
        if (state.found) return NodeFilter.FILTER_ACCEPT;
        const foundBackward = state.foundBackward;
        if (foundBackward && (element === foundBackward || !$e3e23e1e89ad903c$var$dom.nodeContains(foundBackward, element))) {
            state.found = true;
            state.foundElement = foundBackward;
            return NodeFilter.FILTER_ACCEPT;
        }
        const container = state.container;
        if (element === container) return NodeFilter.FILTER_SKIP;
        if (!$e3e23e1e89ad903c$var$dom.nodeContains(container, element)) return NodeFilter.FILTER_REJECT;
        if ($e3e23e1e89ad903c$export$6c7070ee46ec4271(element)) return NodeFilter.FILTER_REJECT;
        if ($e3e23e1e89ad903c$var$dom.nodeContains(state.rejectElementsFrom, element)) return NodeFilter.FILTER_REJECT;
        const ctx = state.currentCtx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, element);
        // Tabster is opt in, if it is not managed, don't try and get do anything special
        if (!ctx) return NodeFilter.FILTER_SKIP;
        if ($e3e23e1e89ad903c$var$shouldIgnoreFocus(element)) {
            if (this.isFocusable(element, undefined, true, true)) state.skippedFocusable = true;
            return NodeFilter.FILTER_SKIP;
        }
        // We assume iframes are focusable because native tab behaviour would tab inside.
        // But we do it only during the standard search when there is no custom accept
        // element condition.
        if (!state.hasCustomCondition && (element.tagName === "IFRAME" || element.tagName === "WEBVIEW")) {
            if (this.isVisible(element) && ((_a = ctx.modalizer) === null || _a === void 0 ? void 0 : _a.userId) === ((_b = this._tabster.modalizer) === null || _b === void 0 ? void 0 : _b.activeId)) {
                state.found = true;
                state.rejectElementsFrom = state.foundElement = element;
                return NodeFilter.FILTER_ACCEPT;
            } else return NodeFilter.FILTER_REJECT;
        }
        if (!state.ignoreAccessibility && !this.isAccessible(element)) {
            if (this.isFocusable(element, false, true, true)) state.skippedFocusable = true;
            return NodeFilter.FILTER_REJECT;
        }
        let result;
        let fromCtx = state.fromCtx;
        if (!fromCtx) fromCtx = state.fromCtx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, state.from);
        const fromMover = fromCtx === null || fromCtx === void 0 ? void 0 : fromCtx.mover;
        let groupper = ctx.groupper;
        let mover = ctx.mover;
        result = (_c = this._tabster.modalizer) === null || _c === void 0 ? void 0 : _c.acceptElement(element, state);
        if (result !== undefined) state.skippedFocusable = true;
        if (result === undefined && (groupper || mover || fromMover)) {
            const groupperElement = groupper === null || groupper === void 0 ? void 0 : groupper.getElement();
            const fromMoverElement = fromMover === null || fromMover === void 0 ? void 0 : fromMover.getElement();
            let moverElement = mover === null || mover === void 0 ? void 0 : mover.getElement();
            if (moverElement && $e3e23e1e89ad903c$var$dom.nodeContains(fromMoverElement, moverElement) && $e3e23e1e89ad903c$var$dom.nodeContains(container, fromMoverElement) && (!groupperElement || !mover || $e3e23e1e89ad903c$var$dom.nodeContains(fromMoverElement, groupperElement))) {
                mover = fromMover;
                moverElement = fromMoverElement;
            }
            if (groupperElement) {
                if (groupperElement === container || !$e3e23e1e89ad903c$var$dom.nodeContains(container, groupperElement)) groupper = undefined;
                else if (!$e3e23e1e89ad903c$var$dom.nodeContains(groupperElement, element)) // _acceptElement() callback is called during the tree walking.
                // Given the potentiality of virtual parents (driven by the custom getParent() function),
                // we need to make sure that the groupper from the current element's context is not,
                // portaling us out of the DOM order.
                return NodeFilter.FILTER_REJECT;
            }
            if (moverElement) {
                if (!$e3e23e1e89ad903c$var$dom.nodeContains(container, moverElement)) mover = undefined;
                else if (!$e3e23e1e89ad903c$var$dom.nodeContains(moverElement, element)) // _acceptElement() callback is called during the tree walking.
                // Given the potentiality of virtual parents (driven by the custom getParent() function),
                // we need to make sure that the mover from the current element's context is not,
                // portaling us out of the DOM order.
                return NodeFilter.FILTER_REJECT;
            }
            if (groupper && mover) {
                if (moverElement && groupperElement && !$e3e23e1e89ad903c$var$dom.nodeContains(groupperElement, moverElement)) mover = undefined;
                else groupper = undefined;
            }
            if (groupper) result = groupper.acceptElement(element, state);
            if (mover) result = mover.acceptElement(element, state);
        }
        if (result === undefined) {
            result = state.acceptCondition(element) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            if (result === NodeFilter.FILTER_SKIP && this.isFocusable(element, false, true, true)) state.skippedFocusable = true;
        }
        if (result === NodeFilter.FILTER_ACCEPT && !state.found) {
            if (!state.isFindAll && $e3e23e1e89ad903c$var$isRadio(element) && !element.checked) {
                // We need to mimic the browser's behaviour to skip unchecked radio buttons.
                const radioGroupName = element.name;
                let radioGroup = state.cachedRadioGroups[radioGroupName];
                if (!radioGroup) {
                    radioGroup = $e3e23e1e89ad903c$var$getRadioButtonGroup(element);
                    if (radioGroup) state.cachedRadioGroups[radioGroupName] = radioGroup;
                }
                if ((radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.checked) && radioGroup.checked !== element) // Currently found element is a radio button in a group that has another radio button checked.
                return NodeFilter.FILTER_SKIP;
            }
            if (state.isBackward) {
                // When TreeWalker goes backwards, it visits the container first,
                // then it goes inside. So, if the container is accepted, we remember it,
                // but allowing the TreeWalker to check inside.
                state.foundBackward = element;
                result = NodeFilter.FILTER_SKIP;
            } else {
                state.found = true;
                state.foundElement = element;
            }
        }
        return result;
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$Keys = {
    Tab: "Tab",
    Enter: "Enter",
    Escape: "Escape",
    PageUp: "PageUp",
    PageDown: "PageDown",
    End: "End",
    Home: "Home",
    ArrowLeft: "ArrowLeft",
    ArrowUp: "ArrowUp",
    ArrowRight: "ArrowRight",
    ArrowDown: "ArrowDown"
};
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$getUncontrolledCompletelyContainer(tabster, element) {
    var _a;
    const getParent = tabster.getParent;
    let el = element;
    do {
        const uncontrolledOnElement = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, el)) === null || _a === void 0 ? void 0 : _a.uncontrolled;
        if (uncontrolledOnElement && tabster.uncontrolled.isUncontrolledCompletely(el, !!uncontrolledOnElement.completely)) return el;
        el = getParent(el);
    }while (el);
    return undefined;
}
const $e3e23e1e89ad903c$var$AsyncFocusIntentPriorityBySource = {
    [$e3e23e1e89ad903c$export$ef584e37c331a849.Restorer]: 0,
    [$e3e23e1e89ad903c$export$ef584e37c331a849.Deloser]: 1,
    [$e3e23e1e89ad903c$export$ef584e37c331a849.EscapeGroupper]: 2
};
class $e3e23e1e89ad903c$var$FocusedElementState extends $e3e23e1e89ad903c$var$Subscribable {
    constructor(tabster, getWindow){
        super();
        this._init = ()=>{
            const win = this._win();
            const doc = win.document;
            // Add these event listeners as capture - we want Tabster to run before user event handlers
            doc.addEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), this._onFocusIn, true);
            doc.addEventListener((0, $7fd4889093258001$export$caa225efd612bb56), this._onFocusOut, true);
            win.addEventListener("keydown", this._onKeyDown, true);
            const activeElement = $e3e23e1e89ad903c$var$dom.getActiveElement(doc);
            if (activeElement && activeElement !== doc.body) this._setFocusedElement(activeElement);
            this.subscribe(this._onChanged);
        };
        this._onFocusIn = (e)=>{
            const target = e.composedPath()[0];
            if (target) this._setFocusedElement(target, e.detail.relatedTarget, e.detail.isFocusedProgrammatically);
        };
        this._onFocusOut = (e)=>{
            var _a;
            this._setFocusedElement(undefined, (_a = e.detail) === null || _a === void 0 ? void 0 : _a.originalEvent.relatedTarget);
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._validateFocusedElement = (element)=>{
        // TODO: Make sure this is not needed anymore and write tests.
        };
        this._onKeyDown = (event)=>{
            if (event.key !== $e3e23e1e89ad903c$var$Keys.Tab || event.ctrlKey) return;
            const currentElement = this.getVal();
            if (!currentElement || !currentElement.ownerDocument || currentElement.contentEditable === "true") return;
            const tabster = this._tabster;
            const controlTab = tabster.controlTab;
            const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, currentElement);
            if (!ctx || ctx.ignoreKeydown(event)) return;
            const isBackward = event.shiftKey;
            const next = $e3e23e1e89ad903c$var$FocusedElementState.findNextTabbable(tabster, ctx, undefined, currentElement, undefined, isBackward, true);
            const rootElement = ctx.root.getElement();
            if (!rootElement) return;
            const nextElement = next === null || next === void 0 ? void 0 : next.element;
            const uncontrolledCompletelyContainer = $e3e23e1e89ad903c$var$getUncontrolledCompletelyContainer(tabster, currentElement);
            if (nextElement) {
                const nextUncontrolled = next.uncontrolled;
                if (ctx.uncontrolled || $e3e23e1e89ad903c$var$dom.nodeContains(nextUncontrolled, currentElement)) {
                    if (!next.outOfDOMOrder && nextUncontrolled === ctx.uncontrolled || uncontrolledCompletelyContainer && !$e3e23e1e89ad903c$var$dom.nodeContains(uncontrolledCompletelyContainer, nextElement)) // Nothing to do, everything will be done by the browser or something
                    // that controls the uncontrolled area.
                    return;
                    // We are in uncontrolled area. We allow whatever controls it to move
                    // focus, but we add a phantom dummy to make sure the focus is moved
                    // to the correct place if the uncontrolled area allows default action.
                    // We only need that in the controlled mode, because in uncontrolled
                    // mode we have dummy inputs around everything that redirects focus.
                    $e3e23e1e89ad903c$var$DummyInputManager.addPhantomDummyWithTarget(tabster, currentElement, isBackward, nextElement);
                    return;
                }
                if (nextUncontrolled && tabster.focusable.isVisible(nextUncontrolled) || nextElement.tagName === "IFRAME" && tabster.focusable.isVisible(nextElement)) {
                    // For iframes and uncontrolled areas we always want to use default action to
                    // move focus into.
                    if (rootElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                        by: "root",
                        owner: rootElement,
                        next: nextElement,
                        relatedEvent: event
                    }))) $e3e23e1e89ad903c$var$DummyInputManager.moveWithPhantomDummy(tabster, nextUncontrolled !== null && nextUncontrolled !== void 0 ? nextUncontrolled : nextElement, false, isBackward, event);
                    return;
                }
                if (controlTab || (next === null || next === void 0 ? void 0 : next.outOfDOMOrder)) {
                    if (rootElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                        by: "root",
                        owner: rootElement,
                        next: nextElement,
                        relatedEvent: event
                    }))) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        (0, $7fd4889093258001$export$cf4c60ff2c946f35)(nextElement);
                    }
                }
            } else if (!uncontrolledCompletelyContainer && rootElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                by: "root",
                owner: rootElement,
                next: null,
                relatedEvent: event
            }))) ctx.root.moveOutWithDefaultAction(isBackward, event);
        };
        this._onChanged = (element, detail)=>{
            var _a, _b;
            if (element) element.dispatchEvent(new $e3e23e1e89ad903c$export$2409322399d631d9(detail));
            else {
                const last = (_a = this._lastVal) === null || _a === void 0 ? void 0 : _a.get();
                if (last) {
                    const d = {
                        ...detail
                    };
                    const lastCtx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, last);
                    const modalizerId = (_b = lastCtx === null || lastCtx === void 0 ? void 0 : lastCtx.modalizer) === null || _b === void 0 ? void 0 : _b.userId;
                    if (modalizerId) d.modalizerId = modalizerId;
                    last.dispatchEvent(new $e3e23e1e89ad903c$export$731508468a1b9ed2(d));
                }
            }
        };
        this._tabster = tabster;
        this._win = getWindow;
        tabster.queueInit(this._init);
    }
    dispose() {
        super.dispose();
        const win = this._win();
        const doc = win.document;
        doc.removeEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), this._onFocusIn, true);
        doc.removeEventListener((0, $7fd4889093258001$export$caa225efd612bb56), this._onFocusOut, true);
        win.removeEventListener("keydown", this._onKeyDown, true);
        this.unsubscribe(this._onChanged);
        const asyncFocus = this._asyncFocus;
        if (asyncFocus) {
            win.clearTimeout(asyncFocus.timeout);
            delete this._asyncFocus;
        }
        delete $e3e23e1e89ad903c$var$FocusedElementState._lastResetElement;
        delete this._nextVal;
        delete this._lastVal;
    }
    static forgetMemorized(instance, parent) {
        var _a, _b;
        let wel = $e3e23e1e89ad903c$var$FocusedElementState._lastResetElement;
        let el = wel && wel.get();
        if (el && $e3e23e1e89ad903c$var$dom.nodeContains(parent, el)) delete $e3e23e1e89ad903c$var$FocusedElementState._lastResetElement;
        el = (_b = (_a = instance._nextVal) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.get();
        if (el && $e3e23e1e89ad903c$var$dom.nodeContains(parent, el)) delete instance._nextVal;
        wel = instance._lastVal;
        el = wel && wel.get();
        if (el && $e3e23e1e89ad903c$var$dom.nodeContains(parent, el)) delete instance._lastVal;
    }
    getFocusedElement() {
        return this.getVal();
    }
    getLastFocusedElement() {
        var _a;
        let el = (_a = this._lastVal) === null || _a === void 0 ? void 0 : _a.get();
        if (!el || el && !$e3e23e1e89ad903c$var$documentContains(el.ownerDocument, el)) this._lastVal = el = undefined;
        return el;
    }
    focus(element, noFocusedProgrammaticallyFlag, noAccessibleCheck, preventScroll) {
        if (!this._tabster.focusable.isFocusable(element, noFocusedProgrammaticallyFlag, false, noAccessibleCheck)) return false;
        element.focus({
            preventScroll: preventScroll
        });
        return true;
    }
    focusDefault(container) {
        const el = this._tabster.focusable.findDefault({
            container: container
        });
        if (el) {
            this._tabster.focusedElement.focus(el);
            return true;
        }
        return false;
    }
    getFirstOrLastTabbable(isFirst, props) {
        var _a;
        const { container: container, ignoreAccessibility: ignoreAccessibility } = props;
        let toFocus;
        if (container) {
            const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, container);
            if (ctx) toFocus = (_a = $e3e23e1e89ad903c$var$FocusedElementState.findNextTabbable(this._tabster, ctx, container, undefined, undefined, !isFirst, ignoreAccessibility)) === null || _a === void 0 ? void 0 : _a.element;
        }
        if (toFocus && !$e3e23e1e89ad903c$var$dom.nodeContains(container, toFocus)) toFocus = undefined;
        return toFocus || undefined;
    }
    _focusFirstOrLast(isFirst, props) {
        const toFocus = this.getFirstOrLastTabbable(isFirst, props);
        if (toFocus) {
            this.focus(toFocus, false, true);
            return true;
        }
        return false;
    }
    focusFirst(props) {
        return this._focusFirstOrLast(true, props);
    }
    focusLast(props) {
        return this._focusFirstOrLast(false, props);
    }
    resetFocus(container) {
        if (!this._tabster.focusable.isVisible(container)) return false;
        if (!this._tabster.focusable.isFocusable(container, true, true, true)) {
            const prevTabIndex = container.getAttribute("tabindex");
            const prevAriaHidden = container.getAttribute("aria-hidden");
            container.tabIndex = -1;
            container.setAttribute("aria-hidden", "true");
            $e3e23e1e89ad903c$var$FocusedElementState._lastResetElement = new $e3e23e1e89ad903c$var$WeakHTMLElement(this._win, container);
            this.focus(container, true, true);
            this._setOrRemoveAttribute(container, "tabindex", prevTabIndex);
            this._setOrRemoveAttribute(container, "aria-hidden", prevAriaHidden);
        } else this.focus(container);
        return true;
    }
    requestAsyncFocus(source, callback, delay) {
        const win = this._tabster.getWindow();
        const currentAsyncFocus = this._asyncFocus;
        if (currentAsyncFocus) {
            if ($e3e23e1e89ad903c$var$AsyncFocusIntentPriorityBySource[source] > $e3e23e1e89ad903c$var$AsyncFocusIntentPriorityBySource[currentAsyncFocus.source]) // Previously registered intent has higher priority.
            return;
            // New intent has higher priority.
            win.clearTimeout(currentAsyncFocus.timeout);
        }
        this._asyncFocus = {
            source: source,
            callback: callback,
            timeout: win.setTimeout(()=>{
                this._asyncFocus = undefined;
                callback();
            }, delay)
        };
    }
    cancelAsyncFocus(source) {
        const asyncFocus = this._asyncFocus;
        if ((asyncFocus === null || asyncFocus === void 0 ? void 0 : asyncFocus.source) === source) {
            this._tabster.getWindow().clearTimeout(asyncFocus.timeout);
            this._asyncFocus = undefined;
        }
    }
    _setOrRemoveAttribute(element, name, value) {
        if (value === null) element.removeAttribute(name);
        else element.setAttribute(name, value);
    }
    _setFocusedElement(element, relatedTarget, isFocusedProgrammatically) {
        var _a, _b;
        if (this._tabster._noop) return;
        const detail = {
            relatedTarget: relatedTarget
        };
        if (element) {
            const lastResetElement = (_a = $e3e23e1e89ad903c$var$FocusedElementState._lastResetElement) === null || _a === void 0 ? void 0 : _a.get();
            $e3e23e1e89ad903c$var$FocusedElementState._lastResetElement = undefined;
            if (lastResetElement === element || $e3e23e1e89ad903c$var$shouldIgnoreFocus(element)) return;
            detail.isFocusedProgrammatically = isFocusedProgrammatically;
            const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, element);
            const modalizerId = (_b = ctx === null || ctx === void 0 ? void 0 : ctx.modalizer) === null || _b === void 0 ? void 0 : _b.userId;
            if (modalizerId) detail.modalizerId = modalizerId;
        }
        const nextVal = this._nextVal = {
            element: element ? new $e3e23e1e89ad903c$var$WeakHTMLElement(this._win, element) : undefined,
            detail: detail
        };
        if (element && element !== this._val) this._validateFocusedElement(element);
        // _validateFocusedElement() might cause the refocus which will trigger
        // another call to this function. Making sure that the value is correct.
        if (this._nextVal === nextVal) this.setVal(element, detail);
        this._nextVal = undefined;
    }
    setVal(val, detail) {
        super.setVal(val, detail);
        if (val) this._lastVal = new $e3e23e1e89ad903c$var$WeakHTMLElement(this._win, val);
    }
    static findNextTabbable(tabster, ctx, container, currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const actualContainer = container || ctx.root.getElement();
        if (!actualContainer) return null;
        let next = null;
        const isTabbingTimer = $e3e23e1e89ad903c$var$FocusedElementState._isTabbingTimer;
        const win = tabster.getWindow();
        if (isTabbingTimer) win.clearTimeout(isTabbingTimer);
        $e3e23e1e89ad903c$var$FocusedElementState.isTabbing = true;
        $e3e23e1e89ad903c$var$FocusedElementState._isTabbingTimer = win.setTimeout(()=>{
            delete $e3e23e1e89ad903c$var$FocusedElementState._isTabbingTimer;
            $e3e23e1e89ad903c$var$FocusedElementState.isTabbing = false;
        }, 0);
        const modalizer = ctx.modalizer;
        const groupper = ctx.groupper;
        const mover = ctx.mover;
        const callFindNext = (what)=>{
            next = what.findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility);
            if (currentElement && !(next === null || next === void 0 ? void 0 : next.element)) {
                const parentElement = what !== modalizer && $e3e23e1e89ad903c$var$dom.getParentElement(what.getElement());
                if (parentElement) {
                    const parentCtx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, currentElement, {
                        referenceElement: parentElement
                    });
                    if (parentCtx) {
                        const currentScopeElement = what.getElement();
                        const newCurrent = isBackward ? currentScopeElement : currentScopeElement && $e3e23e1e89ad903c$var$getLastChild$2(currentScopeElement) || currentScopeElement;
                        if (newCurrent) {
                            next = $e3e23e1e89ad903c$var$FocusedElementState.findNextTabbable(tabster, parentCtx, container, newCurrent, parentElement, isBackward, ignoreAccessibility);
                            if (next) next.outOfDOMOrder = true;
                        }
                    }
                }
            }
        };
        if (groupper && mover) callFindNext(ctx.groupperBeforeMover ? groupper : mover);
        else if (groupper) callFindNext(groupper);
        else if (mover) callFindNext(mover);
        else if (modalizer) callFindNext(modalizer);
        else {
            const findProps = {
                container: actualContainer,
                currentElement: currentElement,
                referenceElement: referenceElement,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            const nextElement = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            next = {
                element: nextElement,
                outOfDOMOrder: findPropsOut.outOfDOMOrder,
                uncontrolled: findPropsOut.uncontrolled
            };
        }
        return next;
    }
}
$e3e23e1e89ad903c$var$FocusedElementState.isTabbing = false;
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$GroupperDummyManager extends $e3e23e1e89ad903c$var$DummyInputManager {
    constructor(element, groupper, tabster, sys){
        super(tabster, element, $e3e23e1e89ad903c$var$DummyInputManagerPriorities.Groupper, sys, true);
        this._setHandlers((dummyInput, isBackward, relatedTarget)=>{
            var _a, _b;
            const container = element.get();
            const input = dummyInput.input;
            if (container && input) {
                const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, input);
                if (ctx) {
                    let next;
                    next = (_a = groupper.findNextTabbable(relatedTarget || undefined, undefined, isBackward, true)) === null || _a === void 0 ? void 0 : _a.element;
                    if (!next) next = (_b = $e3e23e1e89ad903c$var$FocusedElementState.findNextTabbable(tabster, ctx, undefined, dummyInput.isOutside ? input : $e3e23e1e89ad903c$var$getAdjacentElement(container, !isBackward), undefined, isBackward, true)) === null || _b === void 0 ? void 0 : _b.element;
                    if (next) (0, $7fd4889093258001$export$cf4c60ff2c946f35)(next);
                }
            }
        });
    }
}
class $e3e23e1e89ad903c$var$Groupper extends $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, onDispose, props, sys){
        super(tabster, element, props);
        this._shouldTabInside = false;
        this.makeTabbable(false);
        this._onDispose = onDispose;
        if (!tabster.controlTab) this.dummyManager = new $e3e23e1e89ad903c$var$GroupperDummyManager(this._element, this, tabster, sys);
    }
    dispose() {
        var _a;
        this._onDispose(this);
        const element = this._element.get();
        (_a = this.dummyManager) === null || _a === void 0 || _a.dispose();
        delete this.dummyManager;
        element;
        delete this._first;
    }
    findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const groupperElement = this.getElement();
        if (!groupperElement) return null;
        const currentIsDummy = $e3e23e1e89ad903c$export$6c7070ee46ec4271(currentElement) === groupperElement;
        if (!this._shouldTabInside && currentElement && $e3e23e1e89ad903c$var$dom.nodeContains(groupperElement, currentElement) && !currentIsDummy) return {
            element: undefined,
            outOfDOMOrder: true
        };
        const groupperFirstFocusable = this.getFirst(true);
        if (!currentElement || !$e3e23e1e89ad903c$var$dom.nodeContains(groupperElement, currentElement) || currentIsDummy) return {
            element: groupperFirstFocusable,
            outOfDOMOrder: true
        };
        const tabster = this._tabster;
        let next = null;
        let outOfDOMOrder = false;
        let uncontrolled;
        if (this._shouldTabInside && groupperFirstFocusable) {
            const findProps = {
                container: groupperElement,
                currentElement: currentElement,
                referenceElement: referenceElement,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            next = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
            if (!next && this._props.tabbability === $e3e23e1e89ad903c$export$7ee1c0e36fdd1f6d.LimitedTrapFocus) {
                next = tabster.focusable[isBackward ? "findLast" : "findFirst"]({
                    container: groupperElement,
                    ignoreAccessibility: ignoreAccessibility,
                    useActiveModalizer: true
                }, findPropsOut);
                outOfDOMOrder = true;
            }
            uncontrolled = findPropsOut.uncontrolled;
        }
        return {
            element: next,
            uncontrolled: uncontrolled,
            outOfDOMOrder: outOfDOMOrder
        };
    }
    makeTabbable(isTabbable) {
        this._shouldTabInside = isTabbable || !this._props.tabbability;
    }
    isActive(noIfFirstIsFocused) {
        var _a;
        const element = this.getElement() || null;
        let isParentActive = true;
        for(let e = $e3e23e1e89ad903c$var$dom.getParentElement(element); e; e = $e3e23e1e89ad903c$var$dom.getParentElement(e)){
            const g = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, e)) === null || _a === void 0 ? void 0 : _a.groupper;
            if (g) {
                if (!g._shouldTabInside) isParentActive = false;
            }
        }
        let ret = isParentActive ? this._props.tabbability ? this._shouldTabInside : false : undefined;
        if (ret && noIfFirstIsFocused) {
            const focused = this._tabster.focusedElement.getFocusedElement();
            if (focused) ret = focused !== this.getFirst(true);
        }
        return ret;
    }
    getFirst(orContainer) {
        var _a;
        const groupperElement = this.getElement();
        let first;
        if (groupperElement) {
            if (orContainer && this._tabster.focusable.isFocusable(groupperElement)) return groupperElement;
            first = (_a = this._first) === null || _a === void 0 ? void 0 : _a.get();
            if (!first) {
                first = this._tabster.focusable.findFirst({
                    container: groupperElement,
                    useActiveModalizer: true
                }) || undefined;
                if (first) this.setFirst(first);
            }
        }
        return first;
    }
    setFirst(element) {
        if (element) this._first = new $e3e23e1e89ad903c$var$WeakHTMLElement(this._tabster.getWindow, element);
        else delete this._first;
    }
    acceptElement(element, state) {
        const cachedGrouppers = state.cachedGrouppers;
        const parentElement = $e3e23e1e89ad903c$var$dom.getParentElement(this.getElement());
        const parentCtx = parentElement && $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, parentElement);
        const parentCtxGroupper = parentCtx === null || parentCtx === void 0 ? void 0 : parentCtx.groupper;
        const parentGroupper = (parentCtx === null || parentCtx === void 0 ? void 0 : parentCtx.groupperBeforeMover) ? parentCtxGroupper : undefined;
        let parentGroupperElement;
        const getIsActive = (groupper)=>{
            let cached = cachedGrouppers[groupper.id];
            let isActive;
            if (cached) isActive = cached.isActive;
            else {
                isActive = this.isActive(true);
                cached = cachedGrouppers[groupper.id] = {
                    isActive: isActive
                };
            }
            return isActive;
        };
        if (parentGroupper) {
            parentGroupperElement = parentGroupper.getElement();
            if (!getIsActive(parentGroupper) && parentGroupperElement && state.container !== parentGroupperElement && $e3e23e1e89ad903c$var$dom.nodeContains(state.container, parentGroupperElement)) {
                // Do not fall into a child groupper of inactive parent groupper if it's in the scope of the search.
                state.skippedFocusable = true;
                return NodeFilter.FILTER_REJECT;
            }
        }
        const isActive = getIsActive(this);
        const groupperElement = this.getElement();
        if (groupperElement) {
            if (isActive !== true) {
                if (groupperElement === element && parentCtxGroupper) {
                    if (!parentGroupperElement) parentGroupperElement = parentCtxGroupper.getElement();
                    if (parentGroupperElement && !getIsActive(parentCtxGroupper) && $e3e23e1e89ad903c$var$dom.nodeContains(state.container, parentGroupperElement) && parentGroupperElement !== state.container) {
                        state.skippedFocusable = true;
                        return NodeFilter.FILTER_REJECT;
                    }
                }
                if (groupperElement !== element && $e3e23e1e89ad903c$var$dom.nodeContains(groupperElement, element)) {
                    state.skippedFocusable = true;
                    return NodeFilter.FILTER_REJECT;
                }
                const cached = cachedGrouppers[this.id];
                let first;
                if ("first" in cached) first = cached.first;
                else first = cached.first = this.getFirst(true);
                if (first && state.acceptCondition(first)) {
                    state.rejectElementsFrom = groupperElement;
                    state.skippedFocusable = true;
                    if (first !== state.from) {
                        state.found = true;
                        state.foundElement = first;
                        return NodeFilter.FILTER_ACCEPT;
                    } else return NodeFilter.FILTER_REJECT;
                }
            }
        }
        return undefined;
    }
}
class $e3e23e1e89ad903c$var$GroupperAPI {
    constructor(tabster, getWindow){
        this._current = {};
        this._grouppers = {};
        this._init = ()=>{
            const win = this._win();
            // Making sure groupper's onFocus is called before modalizer's onFocus.
            this._tabster.focusedElement.subscribeFirst(this._onFocus);
            const doc = win.document;
            const activeElement = $e3e23e1e89ad903c$var$dom.getActiveElement(doc);
            if (activeElement) this._onFocus(activeElement);
            doc.addEventListener("mousedown", this._onMouseDown, true);
            win.addEventListener("keydown", this._onKeyDown, true);
            win.addEventListener($e3e23e1e89ad903c$export$7e4efd5c8bf2a678, this._onMoveFocus);
        };
        this._onGroupperDispose = (groupper)=>{
            delete this._grouppers[groupper.id];
        };
        this._onFocus = (element)=>{
            if (element) this._updateCurrent(element);
        };
        this._onMouseDown = (e)=>{
            let target = e.target;
            while(target && !this._tabster.focusable.isFocusable(target))target = this._tabster.getParent(target);
            if (target) this._updateCurrent(target);
        };
        this._onKeyDown = (event)=>{
            if (event.key !== $e3e23e1e89ad903c$var$Keys.Enter && event.key !== $e3e23e1e89ad903c$var$Keys.Escape) return;
            // Give a chance to other listeners to handle the event.
            if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) return;
            const element = this._tabster.focusedElement.getFocusedElement();
            if (element) this.handleKeyPress(element, event);
        };
        this._onMoveFocus = (e)=>{
            var _a;
            const element = e.composedPath()[0];
            const action = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.action;
            if (element && action !== undefined && !e.defaultPrevented) {
                if (action === $e3e23e1e89ad903c$export$16ef694586cb4846.Enter) this._enterGroupper(element);
                else this._escapeGroupper(element);
                e.stopImmediatePropagation();
            }
        };
        this._tabster = tabster;
        this._win = getWindow;
        tabster.queueInit(this._init);
    }
    dispose() {
        const win = this._win();
        this._tabster.focusedElement.cancelAsyncFocus($e3e23e1e89ad903c$export$ef584e37c331a849.EscapeGroupper);
        this._current = {};
        if (this._updateTimer) {
            win.clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        win.document.removeEventListener("mousedown", this._onMouseDown, true);
        win.removeEventListener("keydown", this._onKeyDown, true);
        win.removeEventListener($e3e23e1e89ad903c$export$7e4efd5c8bf2a678, this._onMoveFocus);
        Object.keys(this._grouppers).forEach((groupperId)=>{
            if (this._grouppers[groupperId]) {
                this._grouppers[groupperId].dispose();
                delete this._grouppers[groupperId];
            }
        });
    }
    createGroupper(element, props, sys) {
        const tabster = this._tabster;
        const newGroupper = new $e3e23e1e89ad903c$var$Groupper(tabster, element, this._onGroupperDispose, props, sys);
        this._grouppers[newGroupper.id] = newGroupper;
        const focusedElement = tabster.focusedElement.getFocusedElement();
        // Newly created groupper contains currently focused element, update the state on the next tick (to
        // make sure all grouppers are processed).
        if (focusedElement && $e3e23e1e89ad903c$var$dom.nodeContains(element, focusedElement) && !this._updateTimer) this._updateTimer = this._win().setTimeout(()=>{
            delete this._updateTimer;
            // Making sure the focused element hasn't changed.
            if (focusedElement === tabster.focusedElement.getFocusedElement()) this._updateCurrent(focusedElement);
        }, 0);
        return newGroupper;
    }
    forgetCurrentGrouppers() {
        this._current = {};
    }
    _updateCurrent(element) {
        var _a;
        if (this._updateTimer) {
            this._win().clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        const tabster = this._tabster;
        const newIds = {};
        for(let el = tabster.getParent(element); el; el = tabster.getParent(el)){
            const groupper = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, el)) === null || _a === void 0 ? void 0 : _a.groupper;
            if (groupper) {
                newIds[groupper.id] = true;
                this._current[groupper.id] = groupper;
                const isTabbable = groupper.isActive() || element !== el && (!groupper.getProps().delegated || groupper.getFirst(false) !== element);
                groupper.makeTabbable(isTabbable);
            }
        }
        for (const id of Object.keys(this._current)){
            const groupper = this._current[id];
            if (!(groupper.id in newIds)) {
                groupper.makeTabbable(false);
                groupper.setFirst(undefined);
                delete this._current[id];
            }
        }
    }
    _enterGroupper(element, relatedEvent) {
        const tabster = this._tabster;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, element);
        const groupper = (ctx === null || ctx === void 0 ? void 0 : ctx.groupper) || (ctx === null || ctx === void 0 ? void 0 : ctx.modalizerInGroupper);
        const groupperElement = groupper === null || groupper === void 0 ? void 0 : groupper.getElement();
        if (groupper && groupperElement && (element === groupperElement || groupper.getProps().delegated && element === groupper.getFirst(false))) {
            const next = tabster.focusable.findNext({
                container: groupperElement,
                currentElement: element,
                useActiveModalizer: true
            });
            if (next && (!relatedEvent || relatedEvent && groupperElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                by: "groupper",
                owner: groupperElement,
                next: next,
                relatedEvent: relatedEvent
            })))) {
                if (relatedEvent) {
                    // When the application hasn't prevented default,
                    // we consider the event completely handled, hence we
                    // prevent the initial event's default action and stop
                    // propagation.
                    relatedEvent.preventDefault();
                    relatedEvent.stopImmediatePropagation();
                }
                next.focus();
                return next;
            }
        }
        return null;
    }
    _escapeGroupper(element, relatedEvent, fromModalizer) {
        const tabster = this._tabster;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, element);
        let groupper = (ctx === null || ctx === void 0 ? void 0 : ctx.groupper) || (ctx === null || ctx === void 0 ? void 0 : ctx.modalizerInGroupper);
        const groupperElement = groupper === null || groupper === void 0 ? void 0 : groupper.getElement();
        if (groupper && groupperElement && $e3e23e1e89ad903c$var$dom.nodeContains(groupperElement, element)) {
            let next;
            if (element !== groupperElement || fromModalizer) next = groupper.getFirst(true);
            else {
                const parentElement = $e3e23e1e89ad903c$var$dom.getParentElement(groupperElement);
                const parentCtx = parentElement ? $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, parentElement) : undefined;
                groupper = parentCtx === null || parentCtx === void 0 ? void 0 : parentCtx.groupper;
                next = groupper === null || groupper === void 0 ? void 0 : groupper.getFirst(true);
            }
            if (next && (!relatedEvent || relatedEvent && groupperElement.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
                by: "groupper",
                owner: groupperElement,
                next: next,
                relatedEvent: relatedEvent
            })))) {
                if (groupper) groupper.makeTabbable(false);
                // This part happens asynchronously inside setTimeout,
                // so no need to prevent default or stop propagation.
                next.focus();
                return next;
            }
        }
        return null;
    }
    moveFocus(element, action) {
        return action === $e3e23e1e89ad903c$export$16ef694586cb4846.Enter ? this._enterGroupper(element) : this._escapeGroupper(element);
    }
    handleKeyPress(element, event, fromModalizer) {
        const tabster = this._tabster;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, element);
        if (ctx && ((ctx === null || ctx === void 0 ? void 0 : ctx.groupper) || (ctx === null || ctx === void 0 ? void 0 : ctx.modalizerInGroupper))) {
            tabster.focusedElement.cancelAsyncFocus($e3e23e1e89ad903c$export$ef584e37c331a849.EscapeGroupper);
            if (ctx.ignoreKeydown(event)) return;
            if (event.key === $e3e23e1e89ad903c$var$Keys.Enter) this._enterGroupper(element, event);
            else if (event.key === $e3e23e1e89ad903c$var$Keys.Escape) {
                // We will handle Esc asynchronously, if something in the application will
                // move focus during the keypress handling, we will not interfere.
                const focusedElement = tabster.focusedElement.getFocusedElement();
                tabster.focusedElement.requestAsyncFocus($e3e23e1e89ad903c$export$ef584e37c331a849.EscapeGroupper, ()=>{
                    if (focusedElement !== tabster.focusedElement.getFocusedElement() && // A part of Modalizer that has called this handler to escape the active groupper
                    // might have been removed from DOM, if the focus is on body, we still want to handle Esc.
                    (fromModalizer && !focusedElement || !fromModalizer)) // Something else in the application has moved focus, we will not handle Esc.
                    return;
                    this._escapeGroupper(element, event, fromModalizer);
                }, 0);
            }
        }
    }
}
function $e3e23e1e89ad903c$var$_setInformativeStyle$1(weakElement, remove) {}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$KeyboardNavigationState extends $e3e23e1e89ad903c$var$Subscribable {
    constructor(getWindow){
        super();
        this._onChange = (isNavigatingWithKeyboard)=>{
            this.setVal(isNavigatingWithKeyboard, undefined);
        };
        this._keyborg = (0, $7fd4889093258001$export$9ccd7417191c0e4b)(getWindow());
        this._keyborg.subscribe(this._onChange);
    }
    dispose() {
        super.dispose();
        if (this._keyborg) {
            this._keyborg.unsubscribe(this._onChange);
            (0, $7fd4889093258001$export$6c71cf8529293a97)(this._keyborg);
            delete this._keyborg;
        }
    }
    setNavigatingWithKeyboard(isNavigatingWithKeyboard) {
        var _a;
        (_a = this._keyborg) === null || _a === void 0 || _a.setVal(isNavigatingWithKeyboard);
    }
    isNavigatingWithKeyboard() {
        var _a;
        return !!((_a = this._keyborg) === null || _a === void 0 ? void 0 : _a.isNavigatingWithKeyboard());
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ let $e3e23e1e89ad903c$var$_wasFocusedCounter = 0;
const $e3e23e1e89ad903c$var$_ariaHidden = "aria-hidden";
function $e3e23e1e89ad903c$var$_setInformativeStyle(weakElement, remove, internalId, userId, isActive, wasFocused) {}
/**
 * Manages the dummy inputs for the Modalizer.
 */ class $e3e23e1e89ad903c$var$ModalizerDummyManager extends $e3e23e1e89ad903c$var$DummyInputManager {
    constructor(element, tabster, sys){
        super(tabster, element, $e3e23e1e89ad903c$var$DummyInputManagerPriorities.Modalizer, sys);
        this._setHandlers((dummyInput, isBackward)=>{
            var _a, _b;
            const el = element.get();
            const container = el && ((_a = $e3e23e1e89ad903c$var$RootAPI.getRoot(tabster, el)) === null || _a === void 0 ? void 0 : _a.getElement());
            const input = dummyInput.input;
            let toFocus;
            if (container && input) {
                const dummyContainer = $e3e23e1e89ad903c$export$6c7070ee46ec4271(input);
                const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, dummyContainer || input);
                if (ctx) toFocus = (_b = $e3e23e1e89ad903c$var$FocusedElementState.findNextTabbable(tabster, ctx, container, input, undefined, isBackward, true)) === null || _b === void 0 ? void 0 : _b.element;
                if (toFocus) (0, $7fd4889093258001$export$cf4c60ff2c946f35)(toFocus);
            }
        });
    }
}
class $e3e23e1e89ad903c$var$Modalizer extends $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, onDispose, props, sys, activeElements){
        super(tabster, element, props);
        this._wasFocused = 0;
        this.userId = props.id;
        this._onDispose = onDispose;
        this._activeElements = activeElements;
        if (!tabster.controlTab) this.dummyManager = new $e3e23e1e89ad903c$var$ModalizerDummyManager(this._element, tabster, sys);
    }
    makeActive(isActive) {
        if (this._isActive !== isActive) {
            this._isActive = isActive;
            const element = this.getElement();
            if (element) {
                const activeElements = this._activeElements;
                const index = activeElements.map((e)=>e.get()).indexOf(element);
                if (isActive) {
                    if (index < 0) activeElements.push(new $e3e23e1e89ad903c$var$WeakHTMLElement(this._tabster.getWindow, element));
                } else if (index >= 0) activeElements.splice(index, 1);
            }
            this._dispatchEvent(isActive);
        }
    }
    focused(noIncrement) {
        if (!noIncrement) this._wasFocused = ++$e3e23e1e89ad903c$var$_wasFocusedCounter;
        return this._wasFocused;
    }
    setProps(props) {
        if (props.id) this.userId = props.id;
        this._props = {
            ...props
        };
    }
    dispose() {
        var _a;
        this.makeActive(false);
        this._onDispose(this);
        (_a = this.dummyManager) === null || _a === void 0 || _a.dispose();
        delete this.dummyManager;
        this._activeElements = [];
        this._remove();
    }
    isActive() {
        return !!this._isActive;
    }
    contains(element) {
        return $e3e23e1e89ad903c$var$dom.nodeContains(this.getElement(), element);
    }
    findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
        var _a, _b;
        const modalizerElement = this.getElement();
        if (!modalizerElement) return null;
        const tabster = this._tabster;
        let next = null;
        let outOfDOMOrder = false;
        let uncontrolled;
        const container = currentElement && ((_a = $e3e23e1e89ad903c$var$RootAPI.getRoot(tabster, currentElement)) === null || _a === void 0 ? void 0 : _a.getElement());
        if (container) {
            const findProps = {
                container: container,
                currentElement: currentElement,
                referenceElement: referenceElement,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            next = tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            if (!next && this._props.isTrapped && ((_b = tabster.modalizer) === null || _b === void 0 ? void 0 : _b.activeId)) {
                next = tabster.focusable[isBackward ? "findLast" : "findFirst"]({
                    container: container,
                    ignoreAccessibility: ignoreAccessibility,
                    useActiveModalizer: true
                }, findPropsOut);
                if (next === null) next = currentElement;
                outOfDOMOrder = true;
            } else outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
            uncontrolled = findPropsOut.uncontrolled;
        }
        return {
            element: next,
            uncontrolled: uncontrolled,
            outOfDOMOrder: outOfDOMOrder
        };
    }
    _dispatchEvent(isActive, allElements) {
        const element = this.getElement();
        let defaultPrevented = false;
        if (element) {
            const elements = allElements ? this._activeElements.map((e)=>e.get()) : [
                element
            ];
            for (const el of elements)if (el) {
                const eventDetail = {
                    id: this.userId,
                    element: element
                };
                const event = isActive ? new $e3e23e1e89ad903c$export$c375a7c49fb7a7ca(eventDetail) : new $e3e23e1e89ad903c$export$2ee7f26c7f1dcf9c(eventDetail);
                el.dispatchEvent(event);
                if (event.defaultPrevented) defaultPrevented = true;
            }
        }
        return defaultPrevented;
    }
    _remove() {}
}
class $e3e23e1e89ad903c$var$ModalizerAPI {
    constructor(tabster, // @deprecated use accessibleCheck.
    alwaysAccessibleSelector, accessibleCheck){
        this._onModalizerDispose = (modalizer)=>{
            const id = modalizer.id;
            const userId = modalizer.userId;
            const part = this._parts[userId];
            delete this._modalizers[id];
            if (part) {
                delete part[id];
                if (Object.keys(part).length === 0) {
                    delete this._parts[userId];
                    const activationHistory = this._activationHistory;
                    const cleanActivationHistory = [];
                    let prevHistoryItem;
                    // The history order is from most recent to oldest.
                    for(let i = activationHistory.length; i--;){
                        // Remove from activation history, making sure there are no duplicates
                        // for cases like [modal2, modal1, modal2, modal1]: just removing modal2
                        // will result in [modal1, modal1] and we want just [modal1]. Otherwise,
                        // there is a chance for this array to grow forever in a narrow case of
                        // a modalizer that stays in DOM forever and is being activated/deactivated
                        // switching between other modalizers that come and go.
                        const modalizerUserIdFromHistory = activationHistory[i];
                        if (modalizerUserIdFromHistory === userId) continue;
                        if (modalizerUserIdFromHistory !== prevHistoryItem) {
                            prevHistoryItem = modalizerUserIdFromHistory;
                            if (modalizerUserIdFromHistory || cleanActivationHistory.length > 0) cleanActivationHistory.unshift(modalizerUserIdFromHistory);
                        }
                    }
                    this._activationHistory = cleanActivationHistory;
                    if (this.activeId === userId) {
                        const prevActiveId = cleanActivationHistory[0];
                        const prevActive = prevActiveId ? Object.values(this._parts[prevActiveId])[0] : undefined;
                        this.setActive(prevActive);
                    }
                }
            }
        };
        this._onKeyDown = (event)=>{
            var _a;
            if (event.key !== $e3e23e1e89ad903c$var$Keys.Escape) return;
            const tabster = this._tabster;
            const element = tabster.focusedElement.getFocusedElement();
            if (element) {
                const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, element);
                const modalizer = ctx === null || ctx === void 0 ? void 0 : ctx.modalizer;
                if (ctx && !ctx.groupper && (modalizer === null || modalizer === void 0 ? void 0 : modalizer.isActive()) && !ctx.ignoreKeydown(event)) {
                    const activeId = modalizer.userId;
                    if (activeId) {
                        const part = this._parts[activeId];
                        if (part) {
                            const focusedSince = Object.keys(part).map((id)=>{
                                var _a;
                                const m = part[id];
                                const el = m.getElement();
                                let groupper;
                                if (el) groupper = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, el)) === null || _a === void 0 ? void 0 : _a.groupper;
                                return m && el && groupper ? {
                                    el: el,
                                    focusedSince: m.focused(true)
                                } : {
                                    focusedSince: 0
                                };
                            }).filter((f)=>f.focusedSince > 0).sort((a, b)=>a.focusedSince > b.focusedSince ? -1 : a.focusedSince < b.focusedSince ? 1 : 0);
                            if (focusedSince.length) {
                                const groupperElement = focusedSince[0].el;
                                if (groupperElement) (_a = tabster.groupper) === null || _a === void 0 || _a.handleKeyPress(groupperElement, event, true);
                            }
                        }
                    }
                }
            }
        };
        /**
     * Subscribes to the focus state and handles modalizer related focus events
     * @param focusedElement - Element that is focused
     * @param detail - Additional data about the focus event
     */ this._onFocus = (focusedElement, detail)=>{
            var _a;
            const tabster = this._tabster;
            const ctx = focusedElement && $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, focusedElement);
            // Modalizer behaviour is opt in, only apply to elements that have a tabster context
            if (!ctx || !focusedElement) return;
            const augmentedMap = this._augMap;
            for(let e = focusedElement; e; e = $e3e23e1e89ad903c$var$dom.getParentElement(e))// If the newly focused element is inside some of the hidden containers,
            // remove aria-hidden from those synchronously for the screen readers
            // to be able to read the element. The rest of aria-hiddens, will be removed
            // acynchronously for the sake of performance.
            if (augmentedMap.has(e)) {
                augmentedMap.delete(e);
                $e3e23e1e89ad903c$var$augmentAttribute(tabster, e, $e3e23e1e89ad903c$var$_ariaHidden);
            }
            let modalizer = ctx.modalizer;
            const tabsterOnFocusedElement = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, focusedElement);
            const modalizerOnFocusedElement = tabsterOnFocusedElement === null || tabsterOnFocusedElement === void 0 ? void 0 : tabsterOnFocusedElement.modalizer;
            if (modalizerOnFocusedElement) {
                modalizerOnFocusedElement.focused();
                if (modalizerOnFocusedElement.userId === this.activeId && tabsterOnFocusedElement.groupper) {
                    const parentElement = tabster.getParent(focusedElement);
                    const parentModalizer = parentElement && ((_a = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, parentElement)) === null || _a === void 0 ? void 0 : _a.modalizer);
                    if (parentModalizer) modalizer = parentModalizer;
                    else {
                        this.setActive(undefined);
                        return;
                    }
                }
            }
            // An inactive groupper with the modalizer on the same node will not give the modalizer
            // in the context, yet we still want to track that the modalizer's container was focused.
            modalizer === null || modalizer === void 0 || modalizer.focused();
            if ((modalizer === null || modalizer === void 0 ? void 0 : modalizer.userId) === this.activeId) {
                this.currentIsOthersAccessible = modalizer === null || modalizer === void 0 ? void 0 : modalizer.getProps().isOthersAccessible;
                return;
            }
            // Developers calling `element.focus()` should change/deactivate active modalizer
            if (detail.isFocusedProgrammatically || this.currentIsOthersAccessible || (modalizer === null || modalizer === void 0 ? void 0 : modalizer.getProps().isAlwaysAccessible)) this.setActive(modalizer);
            else {
                // Focused outside of the active modalizer, try pull focus back to current modalizer
                const win = this._win();
                win.clearTimeout(this._restoreModalizerFocusTimer);
                // TODO some rendering frameworks (i.e. React) might async rerender the DOM so we need to wait for a duration
                // Figure out a better way of doing this rather than a 100ms timeout
                this._restoreModalizerFocusTimer = win.setTimeout(()=>this._restoreModalizerFocus(focusedElement), 100);
            }
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        this._modalizers = {};
        this._parts = {};
        this._augMap = new WeakMap();
        this._aug = [];
        this._alwaysAccessibleSelector = alwaysAccessibleSelector;
        this._accessibleCheck = accessibleCheck;
        this._activationHistory = [];
        this.activeElements = [];
        if (!tabster.controlTab) tabster.root.addDummyInputs();
        const win = this._win();
        win.addEventListener("keydown", this._onKeyDown, true);
        tabster.queueInit(()=>{
            this._tabster.focusedElement.subscribe(this._onFocus);
        });
    }
    dispose() {
        const win = this._win();
        win.removeEventListener("keydown", this._onKeyDown, true);
        // Dispose all modalizers managed by the API
        Object.keys(this._modalizers).forEach((modalizerId)=>{
            if (this._modalizers[modalizerId]) {
                this._modalizers[modalizerId].dispose();
                delete this._modalizers[modalizerId];
            }
        });
        win.clearTimeout(this._restoreModalizerFocusTimer);
        win.clearTimeout(this._hiddenUpdateTimer);
        this._parts = {};
        delete this.activeId;
        this.activeElements = [];
        this._augMap = new WeakMap();
        this._aug = [];
        this._tabster.focusedElement.unsubscribe(this._onFocus);
    }
    createModalizer(element, props, sys) {
        var _a;
        const modalizer = new $e3e23e1e89ad903c$var$Modalizer(this._tabster, element, this._onModalizerDispose, props, sys, this.activeElements);
        const id = modalizer.id;
        const userId = props.id;
        this._modalizers[id] = modalizer;
        let part = this._parts[userId];
        if (!part) part = this._parts[userId] = {};
        part[id] = modalizer;
        const focusedElement = (_a = this._tabster.focusedElement.getFocusedElement()) !== null && _a !== void 0 ? _a : null;
        // Adding a modalizer which is already focused, activate it
        if (element !== focusedElement && $e3e23e1e89ad903c$var$dom.nodeContains(element, focusedElement)) {
            if (userId !== this.activeId) this.setActive(modalizer);
            else modalizer.makeActive(true);
        }
        return modalizer;
    }
    isAugmented(element) {
        return this._augMap.has(element);
    }
    hiddenUpdate() {
        if (this._hiddenUpdateTimer) return;
        this._hiddenUpdateTimer = this._win().setTimeout(()=>{
            delete this._hiddenUpdateTimer;
            this._hiddenUpdate();
        }, 250);
    }
    setActive(modalizer) {
        const userId = modalizer === null || modalizer === void 0 ? void 0 : modalizer.userId;
        const activeId = this.activeId;
        if (activeId === userId) return;
        this.activeId = userId;
        if (activeId) {
            const part = this._parts[activeId];
            if (part) for (const id of Object.keys(part))part[id].makeActive(false);
        }
        if (userId) {
            const part = this._parts[userId];
            if (part) for (const id of Object.keys(part))part[id].makeActive(true);
        }
        this.currentIsOthersAccessible = modalizer === null || modalizer === void 0 ? void 0 : modalizer.getProps().isOthersAccessible;
        this.hiddenUpdate();
        const activationHistory = this._activationHistory;
        if (activationHistory[0] !== userId && (userId !== undefined || activationHistory.length > 0)) activationHistory.unshift(userId);
    }
    focus(elementFromModalizer, noFocusFirst, noFocusDefault) {
        const tabster = this._tabster;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, elementFromModalizer);
        const modalizer = ctx === null || ctx === void 0 ? void 0 : ctx.modalizer;
        if (modalizer) {
            this.setActive(modalizer);
            const props = modalizer.getProps();
            const modalizerRoot = modalizer.getElement();
            if (modalizerRoot) {
                if (noFocusFirst === undefined) noFocusFirst = props.isNoFocusFirst;
                if (!noFocusFirst && tabster.keyboardNavigation.isNavigatingWithKeyboard() && tabster.focusedElement.focusFirst({
                    container: modalizerRoot
                })) return true;
                if (noFocusDefault === undefined) noFocusDefault = props.isNoFocusDefault;
                if (!noFocusDefault && tabster.focusedElement.focusDefault(modalizerRoot)) return true;
                tabster.focusedElement.resetFocus(modalizerRoot);
            }
        }
        return false;
    }
    activate(modalizerElementOrContainer) {
        var _a;
        const modalizerToActivate = modalizerElementOrContainer ? (_a = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, modalizerElementOrContainer)) === null || _a === void 0 ? void 0 : _a.modalizer : undefined;
        if (!modalizerElementOrContainer || modalizerToActivate) {
            this.setActive(modalizerToActivate);
            return true;
        }
        return false;
    }
    acceptElement(element, state) {
        var _a;
        const modalizerUserId = state.modalizerUserId;
        const currentModalizer = (_a = state.currentCtx) === null || _a === void 0 ? void 0 : _a.modalizer;
        if (modalizerUserId) for (const e of this.activeElements){
            const el = e.get();
            if (el && ($e3e23e1e89ad903c$var$dom.nodeContains(element, el) || el === element)) // We have a part of currently active modalizer somewhere deeper in the DOM,
            // skipping all other checks.
            return NodeFilter.FILTER_SKIP;
        }
        const ret = modalizerUserId === (currentModalizer === null || currentModalizer === void 0 ? void 0 : currentModalizer.userId) || !modalizerUserId && (currentModalizer === null || currentModalizer === void 0 ? void 0 : currentModalizer.getProps().isAlwaysAccessible) ? undefined : NodeFilter.FILTER_SKIP;
        if (ret !== undefined) state.skippedFocusable = true;
        return ret;
    }
    _hiddenUpdate() {
        var _a;
        const tabster = this._tabster;
        const body = tabster.getWindow().document.body;
        const activeId = this.activeId;
        const parts = this._parts;
        const visibleElements = [];
        const hiddenElements = [];
        const alwaysAccessibleSelector = this._alwaysAccessibleSelector;
        const alwaysAccessibleElements = alwaysAccessibleSelector ? Array.from($e3e23e1e89ad903c$var$dom.querySelectorAll(body, alwaysAccessibleSelector)) : [];
        const activeModalizerElements = [];
        for (const userId of Object.keys(parts)){
            const modalizerParts = parts[userId];
            for (const id of Object.keys(modalizerParts)){
                const modalizer = modalizerParts[id];
                const el = modalizer.getElement();
                const props = modalizer.getProps();
                const isAlwaysAccessible = props.isAlwaysAccessible;
                if (el) {
                    if (userId === activeId) {
                        activeModalizerElements.push(el);
                        if (!this.currentIsOthersAccessible) visibleElements.push(el);
                    } else if (isAlwaysAccessible) alwaysAccessibleElements.push(el);
                    else hiddenElements.push(el);
                }
            }
        }
        const augmentedMap = this._augMap;
        const allVisibleElements = visibleElements.length > 0 ? [
            ...visibleElements,
            ...alwaysAccessibleElements
        ] : undefined;
        const newAugmented = [];
        const newAugmentedMap = new WeakMap();
        const toggle = (element, hide)=>{
            var _a;
            const tagName = element.tagName;
            if (tagName === "SCRIPT" || tagName === "STYLE") return;
            let isAugmented = false;
            if (augmentedMap.has(element)) {
                if (hide) isAugmented = true;
                else {
                    augmentedMap.delete(element);
                    $e3e23e1e89ad903c$var$augmentAttribute(tabster, element, $e3e23e1e89ad903c$var$_ariaHidden);
                }
            } else if (hide && !((_a = this._accessibleCheck) === null || _a === void 0 ? void 0 : _a.call(this, element, activeModalizerElements)) && $e3e23e1e89ad903c$var$augmentAttribute(tabster, element, $e3e23e1e89ad903c$var$_ariaHidden, "true")) {
                augmentedMap.set(element, true);
                isAugmented = true;
            }
            if (isAugmented) {
                newAugmented.push(new $e3e23e1e89ad903c$var$WeakHTMLElement(tabster.getWindow, element));
                newAugmentedMap.set(element, true);
            }
        };
        const walk = (element)=>{
            var _a;
            for(let el = $e3e23e1e89ad903c$var$dom.getFirstElementChild(element); el; el = $e3e23e1e89ad903c$var$dom.getNextElementSibling(el)){
                let skip = false;
                let containsModalizer = false;
                let containedByModalizer = false;
                if (allVisibleElements) {
                    const elParent = tabster.getParent(el);
                    for (const c of allVisibleElements){
                        if (el === c) {
                            skip = true;
                            break;
                        }
                        if ($e3e23e1e89ad903c$var$dom.nodeContains(el, c)) {
                            containsModalizer = true;
                            break;
                        } else if ($e3e23e1e89ad903c$var$dom.nodeContains(c, elParent)) // tabster.getParent() could be provided by the application to
                        // handle, for example, virtual parents. Making sure, we are
                        // not setting aria-hidden on elements which are virtually
                        // inside modalizer.
                        containedByModalizer = true;
                    }
                    if (containsModalizer || ((_a = el.__tabsterElementFlags) === null || _a === void 0 ? void 0 : _a.noDirectAriaHidden)) walk(el);
                    else if (!skip && !containedByModalizer) toggle(el, true);
                } else toggle(el, false);
            }
        };
        if (!allVisibleElements) alwaysAccessibleElements.forEach((e)=>toggle(e, false));
        hiddenElements.forEach((e)=>toggle(e, true));
        if (body) walk(body);
        (_a = this._aug) === null || _a === void 0 || _a.map((e)=>e.get()).forEach((e)=>{
            if (e && !newAugmentedMap.get(e)) toggle(e, false);
        });
        this._aug = newAugmented;
        this._augMap = newAugmentedMap;
    }
    /**
   * Called when an element is focused outside of an active modalizer.
   * Attempts to pull focus back into the active modalizer
   * @param outsideElement - An element being focused outside of the modalizer
   */ _restoreModalizerFocus(outsideElement) {
        var _a;
        const ownerDocument = outsideElement === null || outsideElement === void 0 ? void 0 : outsideElement.ownerDocument;
        if (!outsideElement || !ownerDocument) return;
        const focusedElement = this._tabster.focusedElement.getFocusedElement();
        const focusedElementModalizer = focusedElement && ((_a = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, focusedElement)) === null || _a === void 0 ? void 0 : _a.modalizer);
        if (!focusedElement || focusedElement && (focusedElementModalizer === null || focusedElementModalizer === void 0 ? void 0 : focusedElementModalizer.userId) === this.activeId) // If there is no currently focused element, or the currently focused element
        // is in the active modalizer, we don't need to do anything.
        return;
        const tabster = this._tabster;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, outsideElement);
        const modalizer = ctx === null || ctx === void 0 ? void 0 : ctx.modalizer;
        const activeId = this.activeId;
        if (!modalizer && !activeId || modalizer && activeId === modalizer.userId) return;
        const container = ctx === null || ctx === void 0 ? void 0 : ctx.root.getElement();
        if (container) {
            let toFocus = tabster.focusable.findFirst({
                container: container,
                useActiveModalizer: true
            });
            if (toFocus) {
                if (outsideElement.compareDocumentPosition(toFocus) & document.DOCUMENT_POSITION_PRECEDING) {
                    toFocus = tabster.focusable.findLast({
                        container: container,
                        useActiveModalizer: true
                    });
                    if (!toFocus) // This only might mean that findFirst/findLast are buggy and inconsistent.
                    throw new Error("Something went wrong.");
                }
                tabster.focusedElement.focus(toFocus);
                return;
            }
        }
        // Current Modalizer doesn't seem to have focusable elements.
        // Blurring the currently focused element which is outside of the current Modalizer.
        outsideElement.blur();
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$_inputSelector = /*#__PURE__*/ [
    "input",
    "textarea",
    "*[contenteditable]"
].join(", ");
class $e3e23e1e89ad903c$var$MoverDummyManager extends $e3e23e1e89ad903c$var$DummyInputManager {
    constructor(element, tabster, getMemorized, sys){
        super(tabster, element, $e3e23e1e89ad903c$var$DummyInputManagerPriorities.Mover, sys);
        this._onFocusDummyInput = (dummyInput)=>{
            var _a, _b;
            const container = this._element.get();
            const input = dummyInput.input;
            if (container && input) {
                const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, container);
                let toFocus;
                if (ctx) toFocus = (_a = $e3e23e1e89ad903c$var$FocusedElementState.findNextTabbable(this._tabster, ctx, undefined, input, undefined, !dummyInput.isFirst, true)) === null || _a === void 0 ? void 0 : _a.element;
                const memorized = (_b = this._getMemorized()) === null || _b === void 0 ? void 0 : _b.get();
                if (memorized && this._tabster.focusable.isFocusable(memorized)) toFocus = memorized;
                if (toFocus) (0, $7fd4889093258001$export$cf4c60ff2c946f35)(toFocus);
            }
        };
        this._tabster = tabster;
        this._getMemorized = getMemorized;
        this._setHandlers(this._onFocusDummyInput);
    }
}
// TypeScript enums produce depressing JavaScript code, so, we're just using
// a few old style constants here.
const $e3e23e1e89ad903c$var$_moverUpdateAdd = 1;
const $e3e23e1e89ad903c$var$_moverUpdateAttr = 2;
const $e3e23e1e89ad903c$var$_moverUpdateRemove = 3;
class $e3e23e1e89ad903c$var$Mover extends $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, onDispose, props, sys){
        var _a;
        super(tabster, element, props);
        this._visible = {};
        this._onIntersection = (entries)=>{
            for (const entry of entries){
                const el = entry.target;
                const id = $e3e23e1e89ad903c$var$getElementUId(this._win, el);
                let newVisibility;
                let fullyVisible = this._fullyVisible;
                if (entry.intersectionRatio >= 0.25) {
                    newVisibility = entry.intersectionRatio >= 0.75 ? $e3e23e1e89ad903c$export$878d96173d57e644.Visible : $e3e23e1e89ad903c$export$878d96173d57e644.PartiallyVisible;
                    if (newVisibility === $e3e23e1e89ad903c$export$878d96173d57e644.Visible) fullyVisible = id;
                } else newVisibility = $e3e23e1e89ad903c$export$878d96173d57e644.Invisible;
                if (this._visible[id] !== newVisibility) {
                    if (newVisibility === undefined) {
                        delete this._visible[id];
                        if (fullyVisible === id) delete this._fullyVisible;
                    } else {
                        this._visible[id] = newVisibility;
                        this._fullyVisible = fullyVisible;
                    }
                    const state = this.getState(el);
                    if (state) el.dispatchEvent(new $e3e23e1e89ad903c$export$4237cba23bf0663d(state));
                }
            }
        };
        this._win = tabster.getWindow;
        this.visibilityTolerance = (_a = props.visibilityTolerance) !== null && _a !== void 0 ? _a : 0.8;
        if (this._props.trackState || this._props.visibilityAware) {
            this._intersectionObserver = new IntersectionObserver(this._onIntersection, {
                threshold: [
                    0,
                    0.25,
                    0.5,
                    0.75,
                    1
                ]
            });
            this._observeState();
        }
        this._onDispose = onDispose;
        const getMemorized = ()=>props.memorizeCurrent ? this._current : undefined;
        if (!tabster.controlTab) this.dummyManager = new $e3e23e1e89ad903c$var$MoverDummyManager(this._element, tabster, getMemorized, sys);
    }
    dispose() {
        var _a;
        this._onDispose(this);
        if (this._intersectionObserver) {
            this._intersectionObserver.disconnect();
            delete this._intersectionObserver;
        }
        delete this._current;
        delete this._fullyVisible;
        delete this._allElements;
        delete this._updateQueue;
        if (this._unobserve) {
            this._unobserve();
            delete this._unobserve;
        }
        const win = this._win();
        if (this._setCurrentTimer) {
            win.clearTimeout(this._setCurrentTimer);
            delete this._setCurrentTimer;
        }
        if (this._updateTimer) {
            win.clearTimeout(this._updateTimer);
            delete this._updateTimer;
        }
        (_a = this.dummyManager) === null || _a === void 0 || _a.dispose();
        delete this.dummyManager;
    }
    setCurrent(element) {
        if (element) this._current = new $e3e23e1e89ad903c$var$WeakHTMLElement(this._win, element);
        else this._current = undefined;
        if ((this._props.trackState || this._props.visibilityAware) && !this._setCurrentTimer) this._setCurrentTimer = this._win().setTimeout(()=>{
            var _a;
            delete this._setCurrentTimer;
            const changed = [];
            if (this._current !== this._prevCurrent) {
                changed.push(this._current);
                changed.push(this._prevCurrent);
                this._prevCurrent = this._current;
            }
            for (const weak of changed){
                const el = weak === null || weak === void 0 ? void 0 : weak.get();
                if (el && ((_a = this._allElements) === null || _a === void 0 ? void 0 : _a.get(el)) === this) {
                    const props = this._props;
                    if (el && (props.visibilityAware !== undefined || props.trackState)) {
                        const state = this.getState(el);
                        if (state) el.dispatchEvent(new $e3e23e1e89ad903c$export$4237cba23bf0663d(state));
                    }
                }
            }
        });
    }
    getCurrent() {
        var _a;
        return ((_a = this._current) === null || _a === void 0 ? void 0 : _a.get()) || null;
    }
    findNextTabbable(currentElement, referenceElement, isBackward, ignoreAccessibility) {
        const container = this.getElement();
        const currentIsDummy = container && $e3e23e1e89ad903c$export$6c7070ee46ec4271(currentElement) === container;
        if (!container) return null;
        let next = null;
        let outOfDOMOrder = false;
        let uncontrolled;
        if (this._props.tabbable || currentIsDummy || currentElement && !$e3e23e1e89ad903c$var$dom.nodeContains(container, currentElement)) {
            const findProps = {
                currentElement: currentElement,
                referenceElement: referenceElement,
                container: container,
                ignoreAccessibility: ignoreAccessibility,
                useActiveModalizer: true
            };
            const findPropsOut = {};
            next = this._tabster.focusable[isBackward ? "findPrev" : "findNext"](findProps, findPropsOut);
            outOfDOMOrder = !!findPropsOut.outOfDOMOrder;
            uncontrolled = findPropsOut.uncontrolled;
        }
        return {
            element: next,
            uncontrolled: uncontrolled,
            outOfDOMOrder: outOfDOMOrder
        };
    }
    acceptElement(element, state) {
        var _a, _b;
        if (!$e3e23e1e89ad903c$var$FocusedElementState.isTabbing) return ((_a = state.currentCtx) === null || _a === void 0 ? void 0 : _a.excludedFromMover) ? NodeFilter.FILTER_REJECT : undefined;
        const { memorizeCurrent: memorizeCurrent, visibilityAware: visibilityAware, hasDefault: hasDefault = true } = this._props;
        const moverElement = this.getElement();
        if (moverElement && (memorizeCurrent || visibilityAware || hasDefault) && (!$e3e23e1e89ad903c$var$dom.nodeContains(moverElement, state.from) || $e3e23e1e89ad903c$export$6c7070ee46ec4271(state.from) === moverElement)) {
            let found;
            if (memorizeCurrent) {
                const current = (_b = this._current) === null || _b === void 0 ? void 0 : _b.get();
                if (current && state.acceptCondition(current)) found = current;
            }
            if (!found && hasDefault) found = this._tabster.focusable.findDefault({
                container: moverElement,
                useActiveModalizer: true
            });
            if (!found && visibilityAware) found = this._tabster.focusable.findElement({
                container: moverElement,
                useActiveModalizer: true,
                isBackward: state.isBackward,
                acceptCondition: (el)=>{
                    var _a;
                    const id = $e3e23e1e89ad903c$var$getElementUId(this._win, el);
                    const visibility = this._visible[id];
                    return moverElement !== el && !!((_a = this._allElements) === null || _a === void 0 ? void 0 : _a.get(el)) && state.acceptCondition(el) && (visibility === $e3e23e1e89ad903c$export$878d96173d57e644.Visible || visibility === $e3e23e1e89ad903c$export$878d96173d57e644.PartiallyVisible && (visibilityAware === $e3e23e1e89ad903c$export$878d96173d57e644.PartiallyVisible || !this._fullyVisible));
                }
            });
            if (found) {
                state.found = true;
                state.foundElement = found;
                state.rejectElementsFrom = moverElement;
                state.skippedFocusable = true;
                return NodeFilter.FILTER_ACCEPT;
            }
        }
        return undefined;
    }
    _observeState() {
        const element = this.getElement();
        if (this._unobserve || !element || typeof MutationObserver === "undefined") return;
        const win = this._win();
        const allElements = this._allElements = new WeakMap();
        const tabsterFocusable = this._tabster.focusable;
        let updateQueue = this._updateQueue = [];
        const observer = $e3e23e1e89ad903c$var$dom.createMutationObserver((mutations)=>{
            for (const mutation of mutations){
                const target = mutation.target;
                const removed = mutation.removedNodes;
                const added = mutation.addedNodes;
                if (mutation.type === "attributes") {
                    if (mutation.attributeName === "tabindex") updateQueue.push({
                        element: target,
                        type: $e3e23e1e89ad903c$var$_moverUpdateAttr
                    });
                } else {
                    for(let i = 0; i < removed.length; i++)updateQueue.push({
                        element: removed[i],
                        type: $e3e23e1e89ad903c$var$_moverUpdateRemove
                    });
                    for(let i = 0; i < added.length; i++)updateQueue.push({
                        element: added[i],
                        type: $e3e23e1e89ad903c$var$_moverUpdateAdd
                    });
                }
            }
            requestUpdate();
        });
        const setElement = (element, remove)=>{
            var _a, _b;
            const current = allElements.get(element);
            if (current && remove) {
                (_a = this._intersectionObserver) === null || _a === void 0 || _a.unobserve(element);
                allElements.delete(element);
            }
            if (!current && !remove) {
                allElements.set(element, this);
                (_b = this._intersectionObserver) === null || _b === void 0 || _b.observe(element);
            }
        };
        const updateElement = (element)=>{
            const isFocusable = tabsterFocusable.isFocusable(element);
            const current = allElements.get(element);
            if (current) {
                if (!isFocusable) setElement(element, true);
            } else if (isFocusable) setElement(element);
        };
        const addNewElements = (element)=>{
            const { mover: mover } = getMoverGroupper(element);
            if (mover && mover !== this) {
                if (mover.getElement() === element && tabsterFocusable.isFocusable(element)) setElement(element);
                else return;
            }
            const walker = $e3e23e1e89ad903c$var$createElementTreeWalker(win.document, element, (node)=>{
                const { mover: mover, groupper: groupper } = getMoverGroupper(node);
                if (mover && mover !== this) return NodeFilter.FILTER_REJECT;
                const groupperFirstFocusable = groupper === null || groupper === void 0 ? void 0 : groupper.getFirst(true);
                if (groupper && groupper.getElement() !== node && groupperFirstFocusable && groupperFirstFocusable !== node) return NodeFilter.FILTER_REJECT;
                if (tabsterFocusable.isFocusable(node)) setElement(node);
                return NodeFilter.FILTER_SKIP;
            });
            if (walker) {
                walker.currentNode = element;
                while(walker.nextNode());
            }
        };
        const removeWalk = (element)=>{
            const current = allElements.get(element);
            if (current) setElement(element, true);
            for(let el = $e3e23e1e89ad903c$var$dom.getFirstElementChild(element); el; el = $e3e23e1e89ad903c$var$dom.getNextElementSibling(el))removeWalk(el);
        };
        const requestUpdate = ()=>{
            if (!this._updateTimer && updateQueue.length) this._updateTimer = win.setTimeout(()=>{
                delete this._updateTimer;
                for (const { element: element, type: type } of updateQueue)switch(type){
                    case $e3e23e1e89ad903c$var$_moverUpdateAttr:
                        updateElement(element);
                        break;
                    case $e3e23e1e89ad903c$var$_moverUpdateAdd:
                        addNewElements(element);
                        break;
                    case $e3e23e1e89ad903c$var$_moverUpdateRemove:
                        removeWalk(element);
                        break;
                }
                updateQueue = this._updateQueue = [];
            }, 0);
        };
        const getMoverGroupper = (element)=>{
            const ret = {};
            for(let el = element; el; el = $e3e23e1e89ad903c$var$dom.getParentElement(el)){
                const toe = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, el);
                if (toe) {
                    if (toe.groupper && !ret.groupper) ret.groupper = toe.groupper;
                    if (toe.mover) {
                        ret.mover = toe.mover;
                        break;
                    }
                }
            }
            return ret;
        };
        updateQueue.push({
            element: element,
            type: $e3e23e1e89ad903c$var$_moverUpdateAdd
        });
        requestUpdate();
        observer.observe(element, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "tabindex"
            ]
        });
        this._unobserve = ()=>{
            observer.disconnect();
        };
    }
    getState(element) {
        const id = $e3e23e1e89ad903c$var$getElementUId(this._win, element);
        if (id in this._visible) {
            const visibility = this._visible[id] || $e3e23e1e89ad903c$export$878d96173d57e644.Invisible;
            const isCurrent = this._current ? this._current.get() === element : undefined;
            return {
                isCurrent: isCurrent,
                visibility: visibility
            };
        }
        return undefined;
    }
}
/**
 * Calculates distance between two rectangles.
 *
 * @param ax1 first rectangle left
 * @param ay1 first rectangle top
 * @param ax2 first rectangle right
 * @param ay2 first rectangle bottom
 * @param bx1 second rectangle left
 * @param by1 second rectangle top
 * @param bx2 second rectangle right
 * @param by2 second rectangle bottom
 * @returns number, shortest distance between the rectangles.
 */ function $e3e23e1e89ad903c$var$getDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
    const xDistance = ax2 < bx1 ? bx1 - ax2 : bx2 < ax1 ? ax1 - bx2 : 0;
    const yDistance = ay2 < by1 ? by1 - ay2 : by2 < ay1 ? ay1 - by2 : 0;
    return xDistance === 0 ? yDistance : yDistance === 0 ? xDistance : Math.sqrt(xDistance * xDistance + yDistance * yDistance);
}
class $e3e23e1e89ad903c$var$MoverAPI {
    constructor(tabster, getWindow){
        this._init = ()=>{
            const win = this._win();
            win.addEventListener("keydown", this._onKeyDown, true);
            win.addEventListener($e3e23e1e89ad903c$export$3a927ee2f95ddfa, this._onMoveFocus);
            win.addEventListener($e3e23e1e89ad903c$export$f538b9d389680b27, this._onMemorizedElement);
            this._tabster.focusedElement.subscribe(this._onFocus);
        };
        this._onMoverDispose = (mover)=>{
            delete this._movers[mover.id];
        };
        this._onFocus = (element)=>{
            var _a;
            // When something in the app gets focused, we are making sure that
            // the relevant context Mover is aware of it.
            // Looking for the relevant context Mover from the currently
            // focused element parent, not from the element itself, because the
            // Mover element itself cannot be its own current (but might be
            // current for its parent Mover).
            let currentFocusableElement = element;
            let deepestFocusableElement = element;
            for(let el = $e3e23e1e89ad903c$var$dom.getParentElement(element); el; el = $e3e23e1e89ad903c$var$dom.getParentElement(el)){
                // We go through all Movers up from the focused element and
                // set their current element to the deepest focusable of that
                // Mover.
                const mover = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, el)) === null || _a === void 0 ? void 0 : _a.mover;
                if (mover) {
                    mover.setCurrent(deepestFocusableElement);
                    currentFocusableElement = undefined;
                }
                if (!currentFocusableElement && this._tabster.focusable.isFocusable(el)) currentFocusableElement = deepestFocusableElement = el;
            }
        };
        this._onKeyDown = async (event)=>{
            var _a;
            if (this._ignoredInputTimer) {
                this._win().clearTimeout(this._ignoredInputTimer);
                delete this._ignoredInputTimer;
            }
            (_a = this._ignoredInputResolve) === null || _a === void 0 || _a.call(this, false);
            // Give a chance to other listeners to handle the event (for example,
            // to scroll instead of moving focus).
            if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) return;
            const key = event.key;
            let moverKey;
            if (key === $e3e23e1e89ad903c$var$Keys.ArrowDown) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowDown;
            else if (key === $e3e23e1e89ad903c$var$Keys.ArrowRight) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowRight;
            else if (key === $e3e23e1e89ad903c$var$Keys.ArrowUp) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowUp;
            else if (key === $e3e23e1e89ad903c$var$Keys.ArrowLeft) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowLeft;
            else if (key === $e3e23e1e89ad903c$var$Keys.PageDown) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.PageDown;
            else if (key === $e3e23e1e89ad903c$var$Keys.PageUp) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.PageUp;
            else if (key === $e3e23e1e89ad903c$var$Keys.Home) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.Home;
            else if (key === $e3e23e1e89ad903c$var$Keys.End) moverKey = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.End;
            if (!moverKey) return;
            const focused = this._tabster.focusedElement.getFocusedElement();
            if (!focused || await this._isIgnoredInput(focused, key)) return;
            this._moveFocus(focused, moverKey, event);
        };
        this._onMoveFocus = (e)=>{
            var _a;
            const element = e.composedPath()[0];
            const key = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.key;
            if (element && key !== undefined && !e.defaultPrevented) {
                this._moveFocus(element, key);
                e.stopImmediatePropagation();
            }
        };
        this._onMemorizedElement = (e)=>{
            var _a;
            const target = e.composedPath()[0];
            let memorizedElement = (_a = e.detail) === null || _a === void 0 ? void 0 : _a.memorizedElement;
            if (target) {
                const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(this._tabster, target);
                const mover = ctx === null || ctx === void 0 ? void 0 : ctx.mover;
                if (mover) {
                    if (memorizedElement && !$e3e23e1e89ad903c$var$dom.nodeContains(mover.getElement(), memorizedElement)) memorizedElement = undefined;
                    mover.setCurrent(memorizedElement);
                    e.stopImmediatePropagation();
                }
            }
        };
        this._tabster = tabster;
        this._win = getWindow;
        this._movers = {};
        tabster.queueInit(this._init);
    }
    dispose() {
        var _a;
        const win = this._win();
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        (_a = this._ignoredInputResolve) === null || _a === void 0 || _a.call(this, false);
        if (this._ignoredInputTimer) {
            win.clearTimeout(this._ignoredInputTimer);
            delete this._ignoredInputTimer;
        }
        win.removeEventListener("keydown", this._onKeyDown, true);
        win.removeEventListener($e3e23e1e89ad903c$export$3a927ee2f95ddfa, this._onMoveFocus);
        win.removeEventListener($e3e23e1e89ad903c$export$f538b9d389680b27, this._onMemorizedElement);
        Object.keys(this._movers).forEach((moverId)=>{
            if (this._movers[moverId]) {
                this._movers[moverId].dispose();
                delete this._movers[moverId];
            }
        });
    }
    createMover(element, props, sys) {
        const newMover = new $e3e23e1e89ad903c$var$Mover(this._tabster, element, this._onMoverDispose, props, sys);
        this._movers[newMover.id] = newMover;
        return newMover;
    }
    moveFocus(fromElement, key) {
        return this._moveFocus(fromElement, key);
    }
    _moveFocus(fromElement, key, relatedEvent) {
        var _a, _b;
        const tabster = this._tabster;
        const ctx = $e3e23e1e89ad903c$var$RootAPI.getTabsterContext(tabster, fromElement, {
            checkRtl: true
        });
        if (!ctx || !ctx.mover || ctx.excludedFromMover || relatedEvent && ctx.ignoreKeydown(relatedEvent)) return null;
        const mover = ctx.mover;
        const container = mover.getElement();
        if (ctx.groupperBeforeMover) {
            const groupper = ctx.groupper;
            if (groupper && !groupper.isActive(true)) // For the cases when we have Mover/Active Groupper/Inactive Groupper, we need to check
            // the grouppers between the current element and the current mover.
            for(let el = $e3e23e1e89ad903c$var$dom.getParentElement(groupper.getElement()); el && el !== container; el = $e3e23e1e89ad903c$var$dom.getParentElement(el)){
                if ((_b = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(tabster, el)) === null || _a === void 0 ? void 0 : _a.groupper) === null || _b === void 0 ? void 0 : _b.isActive(true)) return null;
            }
            else return null;
        }
        if (!container) return null;
        const focusable = tabster.focusable;
        const moverProps = mover.getProps();
        const direction = moverProps.direction || $e3e23e1e89ad903c$export$7c43ed5d018e9c17.Both;
        const isBoth = direction === $e3e23e1e89ad903c$export$7c43ed5d018e9c17.Both;
        const isVertical = isBoth || direction === $e3e23e1e89ad903c$export$7c43ed5d018e9c17.Vertical;
        const isHorizontal = isBoth || direction === $e3e23e1e89ad903c$export$7c43ed5d018e9c17.Horizontal;
        const isGridLinear = direction === $e3e23e1e89ad903c$export$7c43ed5d018e9c17.GridLinear;
        const isGrid = isGridLinear || direction === $e3e23e1e89ad903c$export$7c43ed5d018e9c17.Grid;
        const isCyclic = moverProps.cyclic;
        let next;
        let scrollIntoViewArg;
        let focusedElementRect;
        let focusedElementX1 = 0;
        let focusedElementX2 = 0;
        if (isGrid) {
            focusedElementRect = fromElement.getBoundingClientRect();
            focusedElementX1 = Math.ceil(focusedElementRect.left);
            focusedElementX2 = Math.floor(focusedElementRect.right);
        }
        if (ctx.rtl) {
            if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowRight) key = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowLeft;
            else if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowLeft) key = $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowRight;
        }
        if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowDown && isVertical || key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowRight && (isHorizontal || isGrid)) {
            next = focusable.findNext({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true
            });
            if (next && isGrid) {
                const nextElementX1 = Math.ceil(next.getBoundingClientRect().left);
                if (!isGridLinear && focusedElementX2 > nextElementX1) next = undefined;
            } else if (!next && isCyclic) next = focusable.findFirst({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowUp && isVertical || key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowLeft && (isHorizontal || isGrid)) {
            next = focusable.findPrev({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true
            });
            if (next && isGrid) {
                const nextElementX2 = Math.floor(next.getBoundingClientRect().right);
                if (!isGridLinear && nextElementX2 > focusedElementX1) next = undefined;
            } else if (!next && isCyclic) next = focusable.findLast({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.Home) {
            if (isGrid) focusable.findElement({
                container: container,
                currentElement: fromElement,
                useActiveModalizer: true,
                isBackward: true,
                acceptCondition: (el)=>{
                    var _a;
                    if (!focusable.isFocusable(el)) return false;
                    const nextElementX1 = Math.ceil((_a = el.getBoundingClientRect().left) !== null && _a !== void 0 ? _a : 0);
                    if (el !== fromElement && focusedElementX1 <= nextElementX1) return true;
                    next = el;
                    return false;
                }
            });
            else next = focusable.findFirst({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.End) {
            if (isGrid) focusable.findElement({
                container: container,
                currentElement: fromElement,
                useActiveModalizer: true,
                acceptCondition: (el)=>{
                    var _a;
                    if (!focusable.isFocusable(el)) return false;
                    const nextElementX1 = Math.ceil((_a = el.getBoundingClientRect().left) !== null && _a !== void 0 ? _a : 0);
                    if (el !== fromElement && focusedElementX1 >= nextElementX1) return true;
                    next = el;
                    return false;
                }
            });
            else next = focusable.findLast({
                container: container,
                useActiveModalizer: true
            });
        } else if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.PageUp) {
            focusable.findElement({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true,
                isBackward: true,
                acceptCondition: (el)=>{
                    if (!focusable.isFocusable(el)) return false;
                    if ($e3e23e1e89ad903c$var$isElementVerticallyVisibleInContainer(this._win, el, mover.visibilityTolerance)) {
                        next = el;
                        return false;
                    }
                    return true;
                }
            });
            // will be on the first column move forward and preserve previous column
            if (isGrid && next) {
                const firstColumnX1 = Math.ceil(next.getBoundingClientRect().left);
                focusable.findElement({
                    currentElement: next,
                    container: container,
                    useActiveModalizer: true,
                    acceptCondition: (el)=>{
                        if (!focusable.isFocusable(el)) return false;
                        const nextElementX1 = Math.ceil(el.getBoundingClientRect().left);
                        if (focusedElementX1 < nextElementX1 || firstColumnX1 >= nextElementX1) return true;
                        next = el;
                        return false;
                    }
                });
            }
            scrollIntoViewArg = false;
        } else if (key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.PageDown) {
            focusable.findElement({
                currentElement: fromElement,
                container: container,
                useActiveModalizer: true,
                acceptCondition: (el)=>{
                    if (!focusable.isFocusable(el)) return false;
                    if ($e3e23e1e89ad903c$var$isElementVerticallyVisibleInContainer(this._win, el, mover.visibilityTolerance)) {
                        next = el;
                        return false;
                    }
                    return true;
                }
            });
            // will be on the last column move backwards and preserve previous column
            if (isGrid && next) {
                const lastColumnX1 = Math.ceil(next.getBoundingClientRect().left);
                focusable.findElement({
                    currentElement: next,
                    container: container,
                    useActiveModalizer: true,
                    isBackward: true,
                    acceptCondition: (el)=>{
                        if (!focusable.isFocusable(el)) return false;
                        const nextElementX1 = Math.ceil(el.getBoundingClientRect().left);
                        if (focusedElementX1 > nextElementX1 || lastColumnX1 <= nextElementX1) return true;
                        next = el;
                        return false;
                    }
                });
            }
            scrollIntoViewArg = true;
        } else if (isGrid) {
            const isBackward = key === $e3e23e1e89ad903c$export$cb3e5a20e92ebf87.ArrowUp;
            const ax1 = focusedElementX1;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const ay1 = Math.ceil(focusedElementRect.top);
            const ax2 = focusedElementX2;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const ay2 = Math.floor(focusedElementRect.bottom);
            let targetElement;
            let lastDistance;
            let lastIntersection = 0;
            focusable.findAll({
                container: container,
                currentElement: fromElement,
                isBackward: isBackward,
                onElement: (el)=>{
                    // Find element which has maximal intersection with the focused element horizontally,
                    // or the closest one.
                    const rect = el.getBoundingClientRect();
                    const bx1 = Math.ceil(rect.left);
                    const by1 = Math.ceil(rect.top);
                    const bx2 = Math.floor(rect.right);
                    const by2 = Math.floor(rect.bottom);
                    if (isBackward && ay1 < by2 || !isBackward && ay2 > by1) // Only consider elements which are below/above curretly focused.
                    return true;
                    const xIntersectionWidth = Math.ceil(Math.min(ax2, bx2)) - Math.floor(Math.max(ax1, bx1));
                    const minWidth = Math.ceil(Math.min(ax2 - ax1, bx2 - bx1));
                    if (xIntersectionWidth > 0 && minWidth >= xIntersectionWidth) {
                        // Element intersects with the focused element on X axis.
                        const intersection = xIntersectionWidth / minWidth;
                        if (intersection > lastIntersection) {
                            targetElement = el;
                            lastIntersection = intersection;
                        }
                    } else if (lastIntersection === 0) {
                        // If we didn't have intersection, try just the closest one.
                        const distance = $e3e23e1e89ad903c$var$getDistance(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2);
                        if (lastDistance === undefined || distance < lastDistance) {
                            lastDistance = distance;
                            targetElement = el;
                        }
                    } else if (lastIntersection > 0) // Element doesn't intersect, but we had intersection already, stop search.
                    return false;
                    return true;
                }
            });
            next = targetElement;
        }
        if (next && (!relatedEvent || relatedEvent && container.dispatchEvent(new $e3e23e1e89ad903c$export$94e7298c3ba0dcfc({
            by: "mover",
            owner: container,
            next: next,
            relatedEvent: relatedEvent
        })))) {
            if (scrollIntoViewArg !== undefined) $e3e23e1e89ad903c$var$scrollIntoView(this._win, next, scrollIntoViewArg);
            if (relatedEvent) {
                relatedEvent.preventDefault();
                relatedEvent.stopImmediatePropagation();
            }
            (0, $7fd4889093258001$export$cf4c60ff2c946f35)(next);
            return next;
        }
        return null;
    }
    async _isIgnoredInput(element, key) {
        if (element.getAttribute("aria-expanded") === "true" && (element.hasAttribute("aria-activedescendant") || element.getAttribute("role") === "combobox")) // It is likely a combobox with expanded options and arrow keys are
        // controlled by it.
        return true;
        if ($e3e23e1e89ad903c$var$matchesSelector(element, $e3e23e1e89ad903c$var$_inputSelector)) {
            let selectionStart = 0;
            let selectionEnd = 0;
            let textLength = 0;
            let asyncRet;
            if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
                const type = element.type;
                const value = element.value;
                textLength = (value || "").length;
                if (type === "email" || type === "number") // For these types Chromium doesn't provide selectionStart and selectionEnd.
                // Hence the ugly workaround to find if the caret position is changed with
                // the keypress.
                // TODO: Have a look at range, week, time, time, date, datetime-local.
                {
                    if (textLength) {
                        const selection = $e3e23e1e89ad903c$var$dom.getSelection(element);
                        if (selection) {
                            const initialLength = selection.toString().length;
                            const isBackward = key === $e3e23e1e89ad903c$var$Keys.ArrowLeft || key === $e3e23e1e89ad903c$var$Keys.ArrowUp;
                            selection.modify("extend", isBackward ? "backward" : "forward", "character");
                            if (initialLength !== selection.toString().length) {
                                // The caret is moved, so, we're not on the edge of the value.
                                // Restore original selection.
                                selection.modify("extend", isBackward ? "forward" : "backward", "character");
                                return true;
                            } else textLength = 0;
                        }
                    }
                } else {
                    const selStart = element.selectionStart;
                    if (selStart === null) // Do not ignore not text editable inputs like checkboxes and radios (but ignore hidden).
                    return type === "hidden";
                    selectionStart = selStart || 0;
                    selectionEnd = element.selectionEnd || 0;
                }
            } else if (element.contentEditable === "true") asyncRet = new ($e3e23e1e89ad903c$var$getPromise(this._win))((resolve)=>{
                this._ignoredInputResolve = (value)=>{
                    delete this._ignoredInputResolve;
                    resolve(value);
                };
                const win = this._win();
                if (this._ignoredInputTimer) win.clearTimeout(this._ignoredInputTimer);
                const { anchorNode: prevAnchorNode, focusNode: prevFocusNode, anchorOffset: prevAnchorOffset, focusOffset: prevFocusOffset } = $e3e23e1e89ad903c$var$dom.getSelection(element) || {};
                // Get selection gives incorrect value if we call it syncronously onKeyDown.
                this._ignoredInputTimer = win.setTimeout(()=>{
                    var _a, _b, _c;
                    delete this._ignoredInputTimer;
                    const { anchorNode: anchorNode, focusNode: focusNode, anchorOffset: anchorOffset, focusOffset: focusOffset } = $e3e23e1e89ad903c$var$dom.getSelection(element) || {};
                    if (anchorNode !== prevAnchorNode || focusNode !== prevFocusNode || anchorOffset !== prevAnchorOffset || focusOffset !== prevFocusOffset) {
                        (_a = this._ignoredInputResolve) === null || _a === void 0 || _a.call(this, false);
                        return;
                    }
                    selectionStart = anchorOffset || 0;
                    selectionEnd = focusOffset || 0;
                    textLength = ((_b = element.textContent) === null || _b === void 0 ? void 0 : _b.length) || 0;
                    if (anchorNode && focusNode) {
                        if ($e3e23e1e89ad903c$var$dom.nodeContains(element, anchorNode) && $e3e23e1e89ad903c$var$dom.nodeContains(element, focusNode)) {
                            if (anchorNode !== element) {
                                let anchorFound = false;
                                const addOffsets = (node)=>{
                                    if (node === anchorNode) anchorFound = true;
                                    else if (node === focusNode) return true;
                                    const nodeText = node.textContent;
                                    if (nodeText && !$e3e23e1e89ad903c$var$dom.getFirstChild(node)) {
                                        const len = nodeText.length;
                                        if (anchorFound) {
                                            if (focusNode !== anchorNode) selectionEnd += len;
                                        } else {
                                            selectionStart += len;
                                            selectionEnd += len;
                                        }
                                    }
                                    let stop = false;
                                    for(let e = $e3e23e1e89ad903c$var$dom.getFirstChild(node); e && !stop; e = e.nextSibling)stop = addOffsets(e);
                                    return stop;
                                };
                                addOffsets(element);
                            }
                        }
                    }
                    (_c = this._ignoredInputResolve) === null || _c === void 0 || _c.call(this, true);
                }, 0);
            });
            if (asyncRet && !await asyncRet) return true;
            if (selectionStart !== selectionEnd) return true;
            if (selectionStart > 0 && (key === $e3e23e1e89ad903c$var$Keys.ArrowLeft || key === $e3e23e1e89ad903c$var$Keys.ArrowUp || key === $e3e23e1e89ad903c$var$Keys.Home)) return true;
            if (selectionStart < textLength && (key === $e3e23e1e89ad903c$var$Keys.ArrowRight || key === $e3e23e1e89ad903c$var$Keys.ArrowDown || key === $e3e23e1e89ad903c$var$Keys.End)) return true;
        }
        return false;
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$observeMutations(doc, tabster, updateTabsterByAttribute, syncState) {
    if (typeof MutationObserver === "undefined") return ()=>{
    /* Noop */ };
    const getWindow = tabster.getWindow;
    let elementByUId;
    const onMutation = (mutations)=>{
        var _a, _b, _c, _d, _e;
        const removedNodes = new Set();
        for (const mutation of mutations){
            const target = mutation.target;
            const removed = mutation.removedNodes;
            const added = mutation.addedNodes;
            if (mutation.type === "attributes") {
                if (mutation.attributeName === $e3e23e1e89ad903c$export$a1195ad1c253d145) // removedNodes helps to make sure we are not recreating things
                // for the removed elements.
                // For some reason, if we do removeChild() and setAttribute() on the
                // removed child in the same tick, both the child removal and the attribute
                // change will be present in the mutation records. And the attribute change
                // will follow the child removal.
                // So, we remember the removed nodes and ignore attribute changes for them.
                {
                    if (!removedNodes.has(target)) updateTabsterByAttribute(tabster, target);
                }
            } else {
                for(let i = 0; i < removed.length; i++){
                    const removedNode = removed[i];
                    removedNodes.add(removedNode);
                    updateTabsterElements(removedNode, true);
                    (_b = (_a = tabster._dummyObserver).domChanged) === null || _b === void 0 || _b.call(_a, target);
                }
                for(let i = 0; i < added.length; i++){
                    updateTabsterElements(added[i]);
                    (_d = (_c = tabster._dummyObserver).domChanged) === null || _d === void 0 || _d.call(_c, target);
                }
            }
        }
        removedNodes.clear();
        (_e = tabster.modalizer) === null || _e === void 0 || _e.hiddenUpdate();
    };
    function updateTabsterElements(node, removed) {
        if (!elementByUId) elementByUId = $e3e23e1e89ad903c$var$getInstanceContext(getWindow).elementByUId;
        processNode(node, removed);
        const walker = $e3e23e1e89ad903c$var$createElementTreeWalker(doc, node, (element)=>{
            return processNode(element, removed);
        });
        if (walker) {
            while(walker.nextNode());
        }
    }
    function processNode(element, removed) {
        var _a;
        if (!element.getAttribute) // It might actually be a text node.
        return NodeFilter.FILTER_SKIP;
        const uid = element.__tabsterElementUID;
        if (uid && elementByUId) {
            if (removed) delete elementByUId[uid];
            else (_a = elementByUId[uid]) !== null && _a !== void 0 ? _a : elementByUId[uid] = new $e3e23e1e89ad903c$var$WeakHTMLElement(getWindow, element);
        }
        if ($e3e23e1e89ad903c$var$getTabsterOnElement(tabster, element) || element.hasAttribute($e3e23e1e89ad903c$export$a1195ad1c253d145)) updateTabsterByAttribute(tabster, element, removed);
        return NodeFilter.FILTER_SKIP;
    }
    const observer = $e3e23e1e89ad903c$var$dom.createMutationObserver(onMutation);
    if (syncState) updateTabsterElements(getWindow().document.body);
    observer.observe(doc, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            $e3e23e1e89ad903c$export$a1195ad1c253d145
        ]
    });
    return ()=>{
        observer.disconnect();
    };
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$_conditionCheckTimeout = 100;
class $e3e23e1e89ad903c$var$ObservedElementAPI extends $e3e23e1e89ad903c$var$Subscribable {
    constructor(tabster){
        super();
        this._waiting = {};
        this._lastRequestFocusId = 0;
        this._observedById = {};
        this._observedByName = {};
        this._currentRequestTimestamp = 0;
        this._onFocus = (e)=>{
            if (e) {
                const current = this._currentRequest;
                if (current) {
                    const delta = Date.now() - this._currentRequestTimestamp;
                    const settleTime = 300;
                    if (delta >= settleTime) {
                        // Giving some time for the focus to settle before
                        // automatically cancelling the current request on focus change.
                        delete this._currentRequest;
                        // Provide callback to access focused element using WeakRef to avoid memory leaks
                        const elementRef = new WeakRef(e);
                        current.diagnostics.getCancelTriggeringElement = ()=>{
                            var _a;
                            return (_a = elementRef.deref()) !== null && _a !== void 0 ? _a : null;
                        };
                        current.diagnostics.reason = $e3e23e1e89ad903c$export$a4de902e8828c943.CanceledFocusChange;
                        current.cancel();
                    }
                }
            }
        };
        this.onObservedElementUpdate = (element)=>{
            var _a, _b;
            const observed = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, element)) === null || _a === void 0 ? void 0 : _a.observed;
            const uid = $e3e23e1e89ad903c$var$getElementUId(this._win, element);
            let info = this._observedById[uid];
            if (observed && $e3e23e1e89ad903c$var$documentContains(element.ownerDocument, element)) {
                const isNewElement = !info;
                if (!info) info = this._observedById[uid] = {
                    element: new $e3e23e1e89ad903c$var$WeakHTMLElement(this._win, element)
                };
                observed.names.sort();
                const observedNames = observed.names;
                const prevNames = info.prevNames; // prevNames are already sorted
                if (this._isObservedNamesUpdated(observedNames, prevNames)) {
                    if (prevNames) prevNames.forEach((prevName)=>{
                        const obn = this._observedByName[prevName];
                        if (obn && obn[uid]) {
                            if (Object.keys(obn).length > 1) delete obn[uid];
                            else delete this._observedByName[prevName];
                        }
                    });
                    info.prevNames = observedNames;
                    this._notifyObservedElementChange(element, observedNames, prevNames, isNewElement);
                }
                observedNames.forEach((observedName)=>{
                    let obn = this._observedByName[observedName];
                    if (!obn) obn = this._observedByName[observedName] = {};
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    obn[uid] = info;
                    this._waitConditional(observedName);
                });
            } else if (info) {
                const prevNames = info.prevNames;
                if (prevNames) {
                    prevNames.forEach((prevName)=>{
                        const obn = this._observedByName[prevName];
                        if (obn && obn[uid]) {
                            if (Object.keys(obn).length > 1) delete obn[uid];
                            else delete this._observedByName[prevName];
                        }
                    });
                    (_b = this.onObservedElementChange) === null || _b === void 0 || _b.call(this, {
                        element: element,
                        type: "removed",
                        names: [],
                        removedNames: prevNames
                    });
                }
                delete this._observedById[uid];
            }
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        tabster.queueInit(()=>{
            this._tabster.focusedElement.subscribe(this._onFocus);
        });
    }
    dispose() {
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        for (const key of Object.keys(this._waiting))this._rejectWaiting(key);
        this._observedById = {};
        this._observedByName = {};
        this.onObservedElementChange = undefined;
    }
    _rejectWaiting(key, shouldResolve) {
        const w = this._waiting[key];
        if (w) {
            const win = this._win();
            if (w.timer) win.clearTimeout(w.timer);
            if (w.conditionTimer) win.clearTimeout(w.conditionTimer);
            if (!shouldResolve && w.reject) w.reject();
            else if (shouldResolve && w.resolve) w.resolve(null);
            delete this._waiting[key];
        }
    }
    _populateTimeoutDiagnostics(request, observedName, timeout, startTime) {
        const elementInDOM = this.getElement(observedName);
        const inDOM = !!elementInDOM;
        let isAccessible;
        let isFocusable;
        let reason;
        if (!elementInDOM) reason = $e3e23e1e89ad903c$export$a4de902e8828c943.TimeoutElementNotInDOM;
        else {
            isAccessible = this._tabster.focusable.isAccessible(elementInDOM);
            isFocusable = this._tabster.focusable.isFocusable(elementInDOM, true);
            if (!isAccessible) reason = $e3e23e1e89ad903c$export$a4de902e8828c943.TimeoutElementNotAccessible;
            else if (!isFocusable) reason = $e3e23e1e89ad903c$export$a4de902e8828c943.TimeoutElementNotFocusable;
            else reason = $e3e23e1e89ad903c$export$a4de902e8828c943.TimeoutElementNotReady;
        }
        request.diagnostics.reason = reason;
        request.diagnostics.waitForElementDuration = Date.now() - startTime;
        request.diagnostics.targetState = {
            inDOM: inDOM,
            isAccessible: isAccessible,
            isFocusable: isFocusable
        };
    }
    _isObservedNamesUpdated(cur, prev) {
        if (!prev || cur.length !== prev.length) return true;
        for(let i = 0; i < cur.length; ++i){
            if (cur[i] !== prev[i]) return true;
        }
        return false;
    }
    _notifyObservedElementChange(element, observedNames, prevNames, isNewElement) {
        if (!this.onObservedElementChange) return;
        const addedNames = observedNames.filter((name)=>!prevNames || !prevNames.includes(name));
        const removedNames = prevNames ? prevNames.filter((name)=>!observedNames.includes(name)) : [];
        if (isNewElement) // Brand new element added
        this.onObservedElementChange({
            element: element,
            type: "added",
            names: observedNames,
            addedNames: observedNames
        });
        else if (addedNames.length > 0 || removedNames.length > 0) // Existing element with names updated
        this.onObservedElementChange({
            element: element,
            type: "updated",
            names: observedNames,
            addedNames: addedNames.length > 0 ? addedNames : undefined,
            removedNames: removedNames.length > 0 ? removedNames : undefined
        });
    }
    /**
   * Returns all registered observed names with their respective elements and full names arrays
   *
   * @returns Map<string, Array<{ element: HTMLElement; names: string[] }>> A map where keys are observed names
   * and values are arrays of objects containing the element and its complete names array (in the order they were defined)
   */ getAllObservedElements() {
        const result = new Map();
        for (const name of Object.keys(this._observedByName)){
            const elementsWithNames = [];
            const observed = this._observedByName[name];
            for (const uid of Object.keys(observed)){
                const el = observed[uid].element.get();
                if (el) {
                    const info = this._observedById[uid];
                    elementsWithNames.push({
                        element: el,
                        names: (info === null || info === void 0 ? void 0 : info.prevNames) || []
                    });
                }
            }
            if (elementsWithNames.length > 0) result.set(name, elementsWithNames);
        }
        return result;
    }
    /**
   * Returns existing element by observed name
   *
   * @param observedName An observed name
   * @param accessibility Optionally, return only if the element is accessible or focusable
   * @returns HTMLElement | null
   */ getElement(observedName, accessibility) {
        const o = this._observedByName[observedName];
        if (o) for (const uid of Object.keys(o)){
            let el = o[uid].element.get() || null;
            if (el) {
                if (accessibility === $e3e23e1e89ad903c$export$4c90aef933fea154.Accessible && !this._tabster.focusable.isAccessible(el) || accessibility === $e3e23e1e89ad903c$export$4c90aef933fea154.Focusable && !this._tabster.focusable.isFocusable(el, true)) el = null;
            } else {
                delete o[uid];
                delete this._observedById[uid];
            }
            return el;
        }
        return null;
    }
    /**
   * Waits for the element to appear in the DOM and returns it.
   *
   * @param observedName An observed name
   * @param timeout Wait no longer than this timeout
   * @param accessibility Optionally, wait for the element to also become accessible or focusable before returning it
   * @returns Promise<HTMLElement | null>
   */ waitElement(observedName, timeout, accessibility) {
        const startTime = Date.now();
        const el = this.getElement(observedName, accessibility);
        if (el) return {
            result: $e3e23e1e89ad903c$var$getPromise(this._win).resolve(el),
            cancel: ()=>{
            /**/ },
            status: $e3e23e1e89ad903c$export$4f32fe00a6fbdffb.Succeeded,
            diagnostics: {
                waitForElementDuration: Date.now() - startTime
            }
        };
        let prefix;
        if (accessibility === $e3e23e1e89ad903c$export$4c90aef933fea154.Accessible) prefix = "a";
        else if (accessibility === $e3e23e1e89ad903c$export$4c90aef933fea154.Focusable) prefix = "f";
        else prefix = "_";
        const key = prefix + observedName;
        let w = this._waiting[key];
        if (w && w.request) return w.request;
        w = this._waiting[key] = {
            timer: this._win().setTimeout(()=>{
                if (w.conditionTimer) this._win().clearTimeout(w.conditionTimer);
                delete this._waiting[key];
                if (w.request) {
                    w.request.status = $e3e23e1e89ad903c$export$4f32fe00a6fbdffb.TimedOut;
                    this._populateTimeoutDiagnostics(w.request, observedName, timeout, startTime);
                }
                if (w.resolve) w.resolve(null);
            }, timeout)
        };
        const promise = new ($e3e23e1e89ad903c$var$getPromise(this._win))((resolve, reject)=>{
            w.resolve = resolve;
            w.reject = reject;
        }).catch(()=>{
            // Ignore the error, it is expected to be rejected when the request is canceled.
            return null;
        });
        const request = {
            result: promise,
            cancel: ()=>{
                if (request.status === $e3e23e1e89ad903c$export$4f32fe00a6fbdffb.Waiting) {
                    // cancel() function is callable by user, someone might call it after request is finished,
                    // we are making sure that status of a finished request is not overriden.
                    request.status = $e3e23e1e89ad903c$export$4f32fe00a6fbdffb.Canceled;
                    request.diagnostics.waitForElementDuration = Date.now() - startTime;
                }
                this._rejectWaiting(key, true);
            },
            status: $e3e23e1e89ad903c$export$4f32fe00a6fbdffb.Waiting,
            diagnostics: {}
        };
        w.request = request;
        if (accessibility && this.getElement(observedName)) // If the observed element is alread in DOM, but not accessible yet,
        // we need to run the wait logic.
        this._waitConditional(observedName);
        return request;
    }
    requestFocus(observedName, timeout, options = {}) {
        const requestId = ++this._lastRequestFocusId;
        const currentRequestFocus = this._currentRequest;
        if (currentRequestFocus) {
            currentRequestFocus.diagnostics.reason = $e3e23e1e89ad903c$export$a4de902e8828c943.SupersededByNewRequest;
            currentRequestFocus.cancel();
        }
        const request = this.waitElement(observedName, timeout, $e3e23e1e89ad903c$export$4c90aef933fea154.Focusable);
        this._currentRequest = request;
        this._currentRequestTimestamp = Date.now();
        const ret = {
            result: request.result.then((element)=>{
                if (this._lastRequestFocusId !== requestId) {
                    request.diagnostics.reason = $e3e23e1e89ad903c$export$a4de902e8828c943.SupersededByNewRequest;
                    return false;
                }
                if (!element) {
                    // Element was not found - reason should already be set by timeout or cancellation
                    // If not set, default to timeout reason
                    if (request.diagnostics.reason === undefined) request.diagnostics.reason = $e3e23e1e89ad903c$export$a4de902e8828c943.TimeoutElementNotInDOM;
                    return false;
                }
                const focusResult = this._tabster.focusedElement.focus(element, true, undefined, options.preventScroll);
                if (!focusResult) // Focus call failed
                request.diagnostics.reason = $e3e23e1e89ad903c$export$a4de902e8828c943.FocusCallFailed;
                return focusResult;
            }),
            cancel: ()=>{
                request.cancel();
            },
            status: request.status,
            diagnostics: request.diagnostics
        };
        request.result.finally(()=>{
            if (this._currentRequest === request) delete this._currentRequest;
            ret.status = request.status;
        });
        return ret;
    }
    _waitConditional(observedName) {
        const waitingElementKey = "_" + observedName;
        const waitingAccessibleElementKey = "a" + observedName;
        const waitingFocusableElementKey = "f" + observedName;
        const waitingElement = this._waiting[waitingElementKey];
        const waitingAccessibleElement = this._waiting[waitingAccessibleElementKey];
        const waitingFocusableElement = this._waiting[waitingFocusableElementKey];
        const win = this._win();
        const resolve = (element, key, waiting, accessibility)=>{
            var _a;
            const observed = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, element)) === null || _a === void 0 ? void 0 : _a.observed;
            if (!observed || !observed.names.includes(observedName)) return;
            if (waiting.timer) win.clearTimeout(waiting.timer);
            delete this._waiting[key];
            if (waiting.request) waiting.request.status = $e3e23e1e89ad903c$export$4f32fe00a6fbdffb.Succeeded;
            if (waiting.resolve) waiting.resolve(element);
            this.trigger(element, {
                names: [
                    observedName
                ],
                details: observed.details,
                accessibility: accessibility
            });
        };
        if (waitingElement) {
            const element = this.getElement(observedName);
            if (element && $e3e23e1e89ad903c$var$documentContains(element.ownerDocument, element)) resolve(element, waitingElementKey, waitingElement, $e3e23e1e89ad903c$export$4c90aef933fea154.Any);
        }
        if (waitingAccessibleElement && !waitingAccessibleElement.conditionTimer) {
            const resolveAccessible = ()=>{
                const element = this.getElement(observedName);
                if (element && $e3e23e1e89ad903c$var$documentContains(element.ownerDocument, element) && this._tabster.focusable.isAccessible(element)) resolve(element, waitingAccessibleElementKey, waitingAccessibleElement, $e3e23e1e89ad903c$export$4c90aef933fea154.Accessible);
                else waitingAccessibleElement.conditionTimer = win.setTimeout(resolveAccessible, $e3e23e1e89ad903c$var$_conditionCheckTimeout);
            };
            resolveAccessible();
        }
        if (waitingFocusableElement && !waitingFocusableElement.conditionTimer) {
            const resolveFocusable = ()=>{
                const element = this.getElement(observedName);
                if (element && $e3e23e1e89ad903c$var$documentContains(element.ownerDocument, element) && this._tabster.focusable.isFocusable(element, true)) resolve(element, waitingFocusableElementKey, waitingFocusableElement, $e3e23e1e89ad903c$export$4c90aef933fea154.Focusable);
                else waitingFocusableElement.conditionTimer = win.setTimeout(resolveFocusable, $e3e23e1e89ad903c$var$_conditionCheckTimeout);
            };
            resolveFocusable();
        }
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3e23e1e89ad903c$var$defaultProps = {
    areaClass: "tabster-focus-outline-area",
    outlineClass: "tabster-focus-outline",
    outlineColor: "#ff4500",
    outlineWidth: 2,
    zIndex: 2147483647
};
let $e3e23e1e89ad903c$var$_props = $e3e23e1e89ad903c$var$defaultProps;
class $e3e23e1e89ad903c$var$OutlinePosition {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
    equalsTo(other) {
        return this.left === other.left && this.top === other.top && this.right === other.right && this.bottom === other.bottom;
    }
    clone() {
        return new $e3e23e1e89ad903c$var$OutlinePosition(this.left, this.top, this.right, this.bottom);
    }
}
class $e3e23e1e89ad903c$var$OutlineAPI {
    constructor(tabster){
        this._isVisible = false;
        this._allOutlineElements = [];
        this._init = ()=>{
            this._tabster.keyboardNavigation.subscribe(this._onKeyboardNavigationStateChanged);
            this._tabster.focusedElement.subscribe(this._onFocus);
            const win = this._win();
            win.addEventListener("scroll", this._onScroll, true); // Capture!
            if (this._fullScreenEventName) win.document.addEventListener(this._fullScreenEventName, this._onFullScreenChanged);
        };
        this._onFullScreenChanged = (e)=>{
            if (!this._fullScreenElementName || !e.target) return;
            const target = e.target.body || e.target;
            const outlineElements = this._getDOM(target);
            if (target.ownerDocument && outlineElements) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const fsElement = target.ownerDocument[this._fullScreenElementName];
                if (fsElement) {
                    fsElement.appendChild(outlineElements.container);
                    this._fullScreenElement = fsElement;
                } else {
                    target.ownerDocument.body.appendChild(outlineElements.container);
                    this._fullScreenElement = undefined;
                }
            }
        };
        this._onKeyboardNavigationStateChanged = ()=>{
            this._onFocus(this._tabster.focusedElement.getFocusedElement());
        };
        this._onFocus = (e)=>{
            if (!this._updateElement(e) && this._isVisible) this._setVisibility(false);
        };
        this._onScroll = (e)=>{
            if (!this._outlinedElement || !$e3e23e1e89ad903c$var$OutlineAPI._isParentChild(e.target, this._outlinedElement)) return;
            this._curPos = undefined;
            this._setOutlinePosition();
        };
        this._tabster = tabster;
        this._win = tabster.getWindow;
        tabster.queueInit(this._init);
        if (typeof document !== "undefined") {
            if ("onfullscreenchange" in document) {
                this._fullScreenEventName = "fullscreenchange";
                this._fullScreenElementName = "fullscreenElement";
            } else if ("onwebkitfullscreenchange" in document) {
                this._fullScreenEventName = "webkitfullscreenchange";
                this._fullScreenElementName = "webkitFullscreenElement";
            } else if ("onmozfullscreenchange" in document) {
                this._fullScreenEventName = "mozfullscreenchange";
                this._fullScreenElementName = "mozFullScreenElement";
            } else if ("onmsfullscreenchange" in document) {
                this._fullScreenEventName = "msfullscreenchange";
                this._fullScreenElementName = "msFullscreenElement";
            }
        }
    }
    setup(props) {
        $e3e23e1e89ad903c$var$_props = {
            ...$e3e23e1e89ad903c$var$_props,
            ...props
        };
        const win = this._win();
        if (!win.__tabsterOutline) win.__tabsterOutline = {};
        if (!win.__tabsterOutline.style) win.__tabsterOutline.style = $e3e23e1e89ad903c$var$appendStyles(win.document, $e3e23e1e89ad903c$var$_props);
        if (!props || !props.areaClass) win.document.body.classList.add($e3e23e1e89ad903c$var$defaultProps.areaClass);
        else win.document.body.classList.remove($e3e23e1e89ad903c$var$defaultProps.areaClass);
    }
    dispose() {
        const win = this._win();
        if (this._updateTimer) {
            win.clearTimeout(this._updateTimer);
            this._updateTimer = undefined;
        }
        this._tabster.keyboardNavigation.unsubscribe(this._onKeyboardNavigationStateChanged);
        this._tabster.focusedElement.unsubscribe(this._onFocus);
        win.removeEventListener("scroll", this._onScroll, true);
        if (this._fullScreenEventName) win.document.removeEventListener(this._fullScreenEventName, this._onFullScreenChanged);
        this._allOutlineElements.forEach((outlineElements)=>this._removeDOM(outlineElements.container));
        this._allOutlineElements = [];
        delete this._outlinedElement;
        delete this._curPos;
        delete this._curOutlineElements;
        delete this._fullScreenElement;
    }
    _shouldShowCustomOutline(element) {
        const tabsterOnElement = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, element);
        if (tabsterOnElement && tabsterOnElement.outline && tabsterOnElement.outline.isIgnored) return false;
        for(let i = element; i; i = i.parentElement){
            if (i.classList && i.classList.contains($e3e23e1e89ad903c$var$_props.areaClass)) return true;
        }
        return false;
    }
    _updateElement(e) {
        this._outlinedElement = undefined;
        if (this._updateTimer) {
            this._win().clearTimeout(this._updateTimer);
            this._updateTimer = undefined;
        }
        this._curPos = undefined;
        if (!this._tabster.keyboardNavigation.isNavigatingWithKeyboard()) return false;
        if (e) {
            // TODO: It's hard (and not necessary) to come up with every possible
            // condition when there should be no outline, it's better to add an
            // API to customize the ignores.
            if (e.tagName === "INPUT") {
                const inputType = e.type;
                const outlinedInputTypes = {
                    button: true,
                    checkbox: true,
                    file: true,
                    image: true,
                    radio: true,
                    range: true,
                    reset: true,
                    submit: true
                };
                if (!(inputType in outlinedInputTypes)) return false;
            } else if (e.tagName === "TEXTAREA" || e.contentEditable === "true" || e.tagName === "IFRAME") return false;
            if (!this._shouldShowCustomOutline(e)) return false;
            if (this._tabster.keyboardNavigation.isNavigatingWithKeyboard()) {
                this._outlinedElement = e;
                this._updateOutline();
            }
            return true;
        }
        return false;
    }
    _updateOutline() {
        this._setOutlinePosition();
        if (this._updateTimer) {
            this._win().clearTimeout(this._updateTimer);
            this._updateTimer = undefined;
        }
        if (!this._outlinedElement) return;
        this._updateTimer = this._win().setTimeout(()=>{
            this._updateTimer = undefined;
            this._updateOutline();
        }, 30);
    }
    _setVisibility(visible) {
        this._isVisible = visible;
        if (this._curOutlineElements) {
            if (visible) this._curOutlineElements.container.classList.add(`${$e3e23e1e89ad903c$var$_props.outlineClass}_visible`);
            else {
                this._curOutlineElements.container.classList.remove(`${$e3e23e1e89ad903c$var$_props.outlineClass}_visible`);
                this._curPos = undefined;
            }
        }
    }
    _setOutlinePosition() {
        if (!this._outlinedElement) return;
        let boundingRect = $e3e23e1e89ad903c$var$getBoundingRect(this._win, this._outlinedElement);
        const position = new $e3e23e1e89ad903c$var$OutlinePosition(boundingRect.left, boundingRect.top, boundingRect.right, boundingRect.bottom);
        if (this._curPos && position.equalsTo(this._curPos)) return;
        const outlineElements = this._getDOM(this._outlinedElement);
        const win = this._outlinedElement.ownerDocument && this._outlinedElement.ownerDocument.defaultView;
        if (!outlineElements || !win) return;
        if (this._curOutlineElements !== outlineElements) {
            this._setVisibility(false);
            this._curOutlineElements = outlineElements;
        }
        this._curPos = position;
        const p = position.clone();
        let hasAbsolutePositionedParent = false;
        let hasFixedPositionedParent = false;
        const container = outlineElements.container;
        const scrollingElement = container && container.ownerDocument && container.ownerDocument.scrollingElement;
        if (!scrollingElement) return;
        for(let parent = this._outlinedElement.parentElement; parent && parent.nodeType === Node.ELEMENT_NODE; parent = parent.parentElement){
            // The element might be partially visible within its scrollable parent,
            // reduce the bounding rect if this is the case.
            if (parent === this._fullScreenElement) break;
            boundingRect = $e3e23e1e89ad903c$var$getBoundingRect(this._win, parent);
            const win = parent.ownerDocument && parent.ownerDocument.defaultView;
            if (!win) return;
            const computedStyle = win.getComputedStyle(parent);
            const position = computedStyle.position;
            if (position === "absolute") hasAbsolutePositionedParent = true;
            else if (position === "fixed" || position === "sticky") hasFixedPositionedParent = true;
            if (computedStyle.overflow === "visible") continue;
            if (!hasAbsolutePositionedParent && !hasFixedPositionedParent || computedStyle.overflow === "hidden") {
                if (boundingRect.left > p.left) p.left = boundingRect.left;
                if (boundingRect.top > p.top) p.top = boundingRect.top;
                if (boundingRect.right < p.right) p.right = boundingRect.right;
                if (boundingRect.bottom < p.bottom) p.bottom = boundingRect.bottom;
            }
        }
        const allRect = $e3e23e1e89ad903c$var$getBoundingRect(this._win, scrollingElement);
        const allWidth = allRect.left + allRect.right;
        const allHeight = allRect.top + allRect.bottom;
        const ow = $e3e23e1e89ad903c$var$_props.outlineWidth;
        p.left = p.left > ow ? p.left - ow : 0;
        p.top = p.top > ow ? p.top - ow : 0;
        p.right = p.right < allWidth - ow ? p.right + ow : allWidth;
        p.bottom = p.bottom < allHeight - ow ? p.bottom + ow : allHeight;
        const width = p.right - p.left;
        const height = p.bottom - p.top;
        if (width > ow * 2 && height > ow * 2) {
            const leftBorderNode = outlineElements.left;
            const topBorderNode = outlineElements.top;
            const rightBorderNode = outlineElements.right;
            const bottomBorderNode = outlineElements.bottom;
            const sx = this._fullScreenElement || hasFixedPositionedParent ? 0 : win.pageXOffset;
            const sy = this._fullScreenElement || hasFixedPositionedParent ? 0 : win.pageYOffset;
            container.style.position = hasFixedPositionedParent ? "fixed" : "absolute";
            container.style.background = $e3e23e1e89ad903c$var$_props.outlineColor;
            leftBorderNode.style.width = rightBorderNode.style.width = topBorderNode.style.height = bottomBorderNode.style.height = $e3e23e1e89ad903c$var$_props.outlineWidth + "px";
            leftBorderNode.style.left = topBorderNode.style.left = bottomBorderNode.style.left = p.left + sx + "px";
            rightBorderNode.style.left = p.left + sx + width - ow + "px";
            leftBorderNode.style.top = rightBorderNode.style.top = topBorderNode.style.top = p.top + sy + "px";
            bottomBorderNode.style.top = p.top + sy + height - ow + "px";
            leftBorderNode.style.height = rightBorderNode.style.height = height + "px";
            topBorderNode.style.width = bottomBorderNode.style.width = width + "px";
            this._setVisibility(true);
        } else this._setVisibility(false);
    }
    _getDOM(contextElement) {
        const doc = contextElement.ownerDocument;
        const win = doc && doc.defaultView;
        if (!doc || !win || !win.__tabsterOutline) return undefined;
        if (!win.__tabsterOutline.style) win.__tabsterOutline.style = $e3e23e1e89ad903c$var$appendStyles(doc, $e3e23e1e89ad903c$var$_props);
        if (!win.__tabsterOutline.elements) {
            const outlineElements = {
                container: doc.createElement("div"),
                left: doc.createElement("div"),
                top: doc.createElement("div"),
                right: doc.createElement("div"),
                bottom: doc.createElement("div")
            };
            outlineElements.container.className = $e3e23e1e89ad903c$var$_props.outlineClass;
            outlineElements.left.className = `${$e3e23e1e89ad903c$var$_props.outlineClass}__left`;
            outlineElements.top.className = `${$e3e23e1e89ad903c$var$_props.outlineClass}__top`;
            outlineElements.right.className = `${$e3e23e1e89ad903c$var$_props.outlineClass}__right`;
            outlineElements.bottom.className = `${$e3e23e1e89ad903c$var$_props.outlineClass}__bottom`;
            outlineElements.container.appendChild(outlineElements.left);
            outlineElements.container.appendChild(outlineElements.top);
            outlineElements.container.appendChild(outlineElements.right);
            outlineElements.container.appendChild(outlineElements.bottom);
            doc.body.appendChild(outlineElements.container);
            win.__tabsterOutline.elements = outlineElements;
            // TODO: Make a garbage collector to remove the references
            // to the outlines which are nowhere in the DOM anymore.
            this._allOutlineElements.push(outlineElements);
        }
        return win.__tabsterOutline.elements;
    }
    _removeDOM(contextElement) {
        const win = contextElement.ownerDocument && contextElement.ownerDocument.defaultView;
        const outline = win && win.__tabsterOutline;
        if (!outline) return;
        if (outline.style && outline.style.parentNode) {
            outline.style.parentNode.removeChild(outline.style);
            delete outline.style;
        }
        const outlineElements = outline && outline.elements;
        if (outlineElements) {
            if (outlineElements.container.parentNode) outlineElements.container.parentNode.removeChild(outlineElements.container);
            delete outline.elements;
        }
    }
    static _isParentChild(parent, child) {
        return child === parent || // tslint:disable-next-line:no-bitwise
        !!(parent.compareDocumentPosition(child) & document.DOCUMENT_POSITION_CONTAINED_BY);
    }
}
function $e3e23e1e89ad903c$var$appendStyles(document1, props) {
    const style = document1.createElement("style");
    style.type = "text/css";
    style.appendChild(document1.createTextNode($e3e23e1e89ad903c$var$getOutlineStyles(props)));
    document1.head.appendChild(style);
    return style;
}
function $e3e23e1e89ad903c$var$getOutlineStyles(props) {
    return `
.${props.areaClass} *, .${props.areaClass} *:focus {
outline: none !important;
}

.${props.outlineClass} {
display: none;
position: absolute;
width: 0;
height: 0;
left: 0;
top: 0;
z-index: ${props.zIndex};
}

.${props.outlineClass}.${props.outlineClass}_visible {
display: block;
}

.${props.outlineClass}__left,
.${props.outlineClass}__top,
.${props.outlineClass}__right,
.${props.outlineClass}__bottom {
position: absolute;
background: inherit;
}`;
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Allows default or user focus behaviour on the DOM subtree
 * i.e. Tabster will not control focus events within an uncontrolled area
 */ class $e3e23e1e89ad903c$var$UncontrolledAPI {
    constructor(isUncontrolledCompletely){
        this._isUncontrolledCompletely = isUncontrolledCompletely;
    }
    isUncontrolledCompletely(element, completely) {
        var _a;
        const isUncontrolledCompletely = (_a = this._isUncontrolledCompletely) === null || _a === void 0 ? void 0 : _a.call(this, element, completely);
        // If isUncontrolledCompletely callback is not defined or returns undefined, then the default
        // behaviour is to return the uncontrolled.completely value from the element.
        return isUncontrolledCompletely === undefined ? completely : isUncontrolledCompletely;
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$Restorer extends $e3e23e1e89ad903c$var$TabsterPart {
    constructor(tabster, element, props){
        var _a;
        super(tabster, element, props);
        this._hasFocus = false;
        this._onFocusOut = (e)=>{
            var _a;
            const element = (_a = this._element) === null || _a === void 0 ? void 0 : _a.get();
            if (element && e.relatedTarget === null) element.dispatchEvent(new $e3e23e1e89ad903c$export$39f4c1150b8485d9());
            if (element && !$e3e23e1e89ad903c$var$dom.nodeContains(element, e.relatedTarget)) this._hasFocus = false;
        };
        this._onFocusIn = ()=>{
            this._hasFocus = true;
        };
        if (this._props.type === $e3e23e1e89ad903c$export$86e1fd7e23a4fab4.Source) {
            const element = (_a = this._element) === null || _a === void 0 ? void 0 : _a.get();
            element === null || element === void 0 || element.addEventListener("focusout", this._onFocusOut);
            element === null || element === void 0 || element.addEventListener("focusin", this._onFocusIn);
            // set hasFocus when the instance is created, in case focus has already moved within it
            this._hasFocus = $e3e23e1e89ad903c$var$dom.nodeContains(element, element && $e3e23e1e89ad903c$var$dom.getActiveElement(element.ownerDocument));
        }
    }
    dispose() {
        var _a;
        if (this._props.type === $e3e23e1e89ad903c$export$86e1fd7e23a4fab4.Source) {
            const element = (_a = this._element) === null || _a === void 0 ? void 0 : _a.get();
            element === null || element === void 0 || element.removeEventListener("focusout", this._onFocusOut);
            element === null || element === void 0 || element.removeEventListener("focusin", this._onFocusIn);
            if (this._hasFocus) {
                const doc = this._tabster.getWindow().document;
                doc.body.dispatchEvent(new $e3e23e1e89ad903c$export$39f4c1150b8485d9());
            }
        }
    }
}
class $e3e23e1e89ad903c$var$History {
    constructor(getWindow){
        this._stack = [];
        this._getWindow = getWindow;
    }
    /**
   * Push a weak element to the top of the history stack.
   * If the stack is full, the bottom weak element is removed.
   * If the element is already at the top of the stack, it is not duplicated.
   */ push(element) {
        var _a;
        // Don't duplicate the top of history
        if (((_a = this._stack[this._stack.length - 1]) === null || _a === void 0 ? void 0 : _a.get()) === element) return;
        if (this._stack.length > $e3e23e1e89ad903c$var$History.DEPTH) this._stack.shift();
        this._stack.push(new $e3e23e1e89ad903c$var$WeakHTMLElement(this._getWindow, element));
    }
    /**
   * Pop the first element from the history that satisfies the callback.
   * The history is searched from the top to the bottom (from the most recent to the least recent).
   *
   * If a weak reference to the element is broken,
   * or the element is no longer in the DOM,
   * the element is removed from the top of the stack while popping.
   *
   * If no matching element is found, undefined is returned.
   * If the stack is empty, undefined is returned.
   */ pop(filter = ()=>true) {
        var _a;
        const doc = this._getWindow().document;
        for(let index = this._stack.length - 1; index >= 0; index--){
            const maybeElement = (_a = this._stack.pop()) === null || _a === void 0 ? void 0 : _a.get();
            if (maybeElement && $e3e23e1e89ad903c$var$dom.nodeContains(doc.body, $e3e23e1e89ad903c$var$dom.getParentElement(maybeElement)) && filter(maybeElement)) return maybeElement;
        }
        return undefined;
    }
}
$e3e23e1e89ad903c$var$History.DEPTH = 10;
class $e3e23e1e89ad903c$var$RestorerAPI {
    constructor(tabster){
        this._onRestoreFocus = (e)=>{
            var _a, _b;
            this._focusedElementState.cancelAsyncFocus($e3e23e1e89ad903c$export$ef584e37c331a849.Restorer);
            // ShadowDOM will have shadowRoot as e.target.
            const source = e.composedPath()[0];
            if (source) {
                // source id must be recovered before source is removed from DOM
                // otherwise it'll be unreachable
                // (as tabster on element will not be available through getTabsterOnElement)
                const sourceId = (_b = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, source)) === null || _a === void 0 ? void 0 : _a.restorer) === null || _b === void 0 ? void 0 : _b.getProps().id;
                this._focusedElementState.requestAsyncFocus($e3e23e1e89ad903c$export$ef584e37c331a849.Restorer, ()=>this._restoreFocus(source, sourceId), 0);
            }
        };
        this._onFocusIn = (element)=>{
            var _a;
            if (!element) return;
            const tabsterAttribute = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, element);
            if (((_a = tabsterAttribute === null || tabsterAttribute === void 0 ? void 0 : tabsterAttribute.restorer) === null || _a === void 0 ? void 0 : _a.getProps().type) !== $e3e23e1e89ad903c$export$86e1fd7e23a4fab4.Target) return;
            this._history.push(element);
        };
        this._restoreFocus = (source, sourceId)=>{
            var _a;
            // don't restore focus if focus isn't lost to body
            const doc = this._getWindow().document;
            if ($e3e23e1e89ad903c$var$dom.getActiveElement(doc) !== doc.body) return;
            if (// clicking on any empty space focuses body - this is can be a false positive
            !this._keyboardNavState.isNavigatingWithKeyboard() && // Source no longer exists on DOM - always restore focus
            $e3e23e1e89ad903c$var$dom.nodeContains(doc.body, source)) return;
            const getId = (element)=>{
                var _a, _b;
                const restorerProps = (_b = (_a = $e3e23e1e89ad903c$var$getTabsterOnElement(this._tabster, element)) === null || _a === void 0 ? void 0 : _a.restorer) === null || _b === void 0 ? void 0 : _b.getProps();
                // We return id or undefined if there is actual restorer on the element,
                // and null otherwise. To filter out elements that had restorers in their lifetime
                // but don't have them anymore.
                return restorerProps ? restorerProps.id : null;
            };
            // sourceId is undefined or string, if there is no Restorer on the target, the element will
            // be filtered out because getId() will return null.
            (_a = this._history.pop((target)=>sourceId === getId(target))) === null || _a === void 0 || _a.focus();
        };
        this._tabster = tabster;
        this._getWindow = tabster.getWindow;
        this._getWindow().addEventListener($e3e23e1e89ad903c$export$3d63c9b40c6a05c3, this._onRestoreFocus);
        this._history = new $e3e23e1e89ad903c$var$History(this._getWindow);
        this._keyboardNavState = tabster.keyboardNavigation;
        this._focusedElementState = tabster.focusedElement;
        this._focusedElementState.subscribe(this._onFocusIn);
    }
    dispose() {
        const win = this._getWindow();
        this._focusedElementState.unsubscribe(this._onFocusIn);
        this._focusedElementState.cancelAsyncFocus($e3e23e1e89ad903c$export$ef584e37c331a849.Restorer);
        win.removeEventListener($e3e23e1e89ad903c$export$3d63c9b40c6a05c3, this._onRestoreFocus);
    }
    createRestorer(element, props) {
        const restorer = new $e3e23e1e89ad903c$var$Restorer(this._tabster, element, props);
        // Focus might already be on a restorer target when it gets created so the focusin will not do anything
        if (props.type === $e3e23e1e89ad903c$export$86e1fd7e23a4fab4.Target && $e3e23e1e89ad903c$var$dom.getActiveElement(element.ownerDocument) === element) this._history.push(element);
        return restorer;
    }
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$getActiveElement(doc) {
    var _a;
    let activeElement = doc.activeElement;
    while((_a = activeElement === null || activeElement === void 0 ? void 0 : activeElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement)activeElement = activeElement.shadowRoot.activeElement;
    return activeElement;
}
function $e3e23e1e89ad903c$var$nodeContains(node, otherNode) {
    var _a, _b;
    if (!node || !otherNode) return false;
    let currentNode = otherNode;
    while(currentNode){
        if (currentNode === node) return true;
        if (typeof currentNode.assignedElements !== "function" && ((_a = currentNode.assignedSlot) === null || _a === void 0 ? void 0 : _a.parentNode)) // Element is slotted
        currentNode = (_b = currentNode.assignedSlot) === null || _b === void 0 ? void 0 : _b.parentNode;
        else if (currentNode.nodeType === document.DOCUMENT_FRAGMENT_NODE) // Element is in shadow root
        currentNode = currentNode.host;
        else currentNode = currentNode.parentNode;
    }
    return false;
}
function $e3e23e1e89ad903c$var$getParentNode(node) {
    if (!node) return null;
    if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE && node.host) return node.host;
    return node.parentNode;
}
function $e3e23e1e89ad903c$var$getParentElement(element) {
    for(let parentNode = $e3e23e1e89ad903c$var$getParentNode(element); parentNode; parentNode = $e3e23e1e89ad903c$var$getParentNode(parentNode)){
        if (parentNode.nodeType === Node.ELEMENT_NODE) return parentNode;
    }
    return null;
}
function $e3e23e1e89ad903c$var$getFirstChild(node) {
    if (!node) return null;
    if (node.shadowRoot) {
        const child = $e3e23e1e89ad903c$var$getFirstChild(node.shadowRoot);
        if (child) return child;
    // If the attached shadowRoot has no children, just try ordinary children,
    // that might come after.
    }
    return node.firstChild;
}
function $e3e23e1e89ad903c$var$getLastChild$1(node) {
    if (!node) return null;
    if (!node.lastChild && node.shadowRoot) return $e3e23e1e89ad903c$var$getLastChild$1(node.shadowRoot);
    return node.lastChild;
}
function $e3e23e1e89ad903c$var$getNextSibling(node) {
    return (node === null || node === void 0 ? void 0 : node.nextSibling) || null;
}
function $e3e23e1e89ad903c$var$getPreviousSibling(node) {
    var _a;
    if (!node) return null;
    let sibling = node.previousSibling;
    if (!sibling && ((_a = node.parentElement) === null || _a === void 0 ? void 0 : _a.shadowRoot)) sibling = $e3e23e1e89ad903c$var$getLastChild$1(node.parentElement.shadowRoot);
    return sibling;
}
function $e3e23e1e89ad903c$var$getFirstElementChild(element) {
    let child = $e3e23e1e89ad903c$var$getFirstChild(element);
    while(child && child.nodeType !== Node.ELEMENT_NODE)child = $e3e23e1e89ad903c$var$getNextSibling(child);
    return child;
}
function $e3e23e1e89ad903c$var$getLastElementChild(element) {
    let child = $e3e23e1e89ad903c$var$getLastChild$1(element);
    while(child && child.nodeType !== Node.ELEMENT_NODE)child = $e3e23e1e89ad903c$var$getPreviousSibling(child);
    return child;
}
function $e3e23e1e89ad903c$var$getNextElementSibling(element) {
    let sibling = $e3e23e1e89ad903c$var$getNextSibling(element);
    while(sibling && sibling.nodeType !== Node.ELEMENT_NODE)sibling = $e3e23e1e89ad903c$var$getNextSibling(sibling);
    return sibling;
}
function $e3e23e1e89ad903c$var$getPreviousElementSibling(element) {
    let sibling = $e3e23e1e89ad903c$var$getPreviousSibling(element);
    while(sibling && sibling.nodeType !== Node.ELEMENT_NODE)sibling = $e3e23e1e89ad903c$var$getPreviousSibling(sibling);
    return sibling;
}
function $e3e23e1e89ad903c$var$appendChild(parent, child) {
    const shadowRoot = parent.shadowRoot;
    return shadowRoot ? shadowRoot.appendChild(child) : parent.appendChild(child);
}
function $e3e23e1e89ad903c$var$insertBefore(parent, child, referenceChild) {
    const shadowRoot = parent.shadowRoot;
    return shadowRoot ? shadowRoot.insertBefore(child, referenceChild) : parent.insertBefore(child, referenceChild);
}
function $e3e23e1e89ad903c$var$getSelection(ref) {
    var _a;
    const win = (_a = ref.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    if (!win) return null;
    for(let el = ref; el; el = el.parentNode)if (el.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        const tmp = el;
        // ShadowRoot.getSelection() exists only in Chrome.
        if (tmp.getSelection) return tmp.getSelection() || null;
        break;
    }
    return win.getSelection() || null;
}
function $e3e23e1e89ad903c$var$getElementsByName(referenceElement, name) {
    for(let el = referenceElement; el; el = el.parentNode){
        if (el.nodeType === Node.DOCUMENT_FRAGMENT_NODE) // Shadow root doesn't have getElementsByName()...
        return el.querySelectorAll(`[name=${name}]`);
    }
    return referenceElement.ownerDocument.getElementsByName(name);
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$getLastChild(container) {
    let lastChild = null;
    for(let i = $e3e23e1e89ad903c$var$getLastElementChild(container); i; i = $e3e23e1e89ad903c$var$getLastElementChild(i))lastChild = i;
    return lastChild || undefined;
}
class $e3e23e1e89ad903c$var$ShadowTreeWalker {
    constructor(doc, root, whatToShow, filter){
        this._walkerStack = [];
        this._currentSetFor = new Set();
        this._acceptNode = (node)=>{
            var _a;
            if (node.nodeType === Node.ELEMENT_NODE) {
                const shadowRoot = node.shadowRoot;
                if (shadowRoot) {
                    const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                        acceptNode: this._acceptNode
                    });
                    this._walkerStack.unshift(walker);
                    return NodeFilter.FILTER_ACCEPT;
                } else {
                    if (typeof this.filter === "function") return this.filter(node);
                    else if ((_a = this.filter) === null || _a === void 0 ? void 0 : _a.acceptNode) return this.filter.acceptNode(node);
                    else if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
                }
            }
            return NodeFilter.FILTER_SKIP;
        };
        this._doc = doc;
        this.root = root;
        this.filter = filter !== null && filter !== void 0 ? filter : null;
        this.whatToShow = whatToShow !== null && whatToShow !== void 0 ? whatToShow : NodeFilter.SHOW_ALL;
        this._currentNode = root;
        this._walkerStack.unshift(doc.createTreeWalker(root, whatToShow, this._acceptNode));
        const shadowRoot = root.shadowRoot;
        if (shadowRoot) {
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            this._walkerStack.unshift(walker);
        }
    }
    get currentNode() {
        return this._currentNode;
    }
    set currentNode(node) {
        if (!$e3e23e1e89ad903c$var$nodeContains(this.root, node)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
        const walkers = [];
        let curNode = node;
        let currentWalkerCurrentNode = node;
        this._currentNode = node;
        while(curNode && curNode !== this.root)if (curNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            const shadowRoot = curNode;
            const walker = this._doc.createTreeWalker(shadowRoot, this.whatToShow, {
                acceptNode: this._acceptNode
            });
            walkers.push(walker);
            walker.currentNode = currentWalkerCurrentNode;
            this._currentSetFor.add(walker);
            curNode = currentWalkerCurrentNode = shadowRoot.host;
        } else curNode = curNode.parentNode;
        const walker = this._doc.createTreeWalker(this.root, this.whatToShow, {
            acceptNode: this._acceptNode
        });
        walkers.push(walker);
        walker.currentNode = currentWalkerCurrentNode;
        this._currentSetFor.add(walker);
        this._walkerStack = walkers;
    }
    firstChild() {
        return null;
    }
    lastChild() {
        return null;
    }
    nextNode() {
        var _a;
        const nextNode = this._walkerStack[0].nextNode();
        if (nextNode) {
            const shadowRoot = nextNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === "function") nodeResult = this.filter(nextNode);
                else if ((_a = this.filter) === null || _a === void 0 ? void 0 : _a.acceptNode) nodeResult = this.filter.acceptNode(nextNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) return nextNode;
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                return this.nextNode();
            }
            return nextNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                return this.nextNode();
            } else return null;
        }
    }
    previousNode() {
        var _a, _b;
        const currentWalker = this._walkerStack[0];
        if (currentWalker.currentNode === currentWalker.root) {
            if (this._currentSetFor.has(currentWalker)) {
                this._currentSetFor.delete(currentWalker);
                if (this._walkerStack.length > 1) {
                    this._walkerStack.shift();
                    return this.previousNode();
                } else return null;
            }
            const lastChild = $e3e23e1e89ad903c$var$getLastChild(currentWalker.root);
            if (lastChild) {
                currentWalker.currentNode = lastChild;
                let nodeResult;
                if (typeof this.filter === "function") nodeResult = this.filter(lastChild);
                else if ((_a = this.filter) === null || _a === void 0 ? void 0 : _a.acceptNode) nodeResult = this.filter.acceptNode(lastChild);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) return lastChild;
            }
        }
        const previousNode = currentWalker.previousNode();
        if (previousNode) {
            const shadowRoot = previousNode.shadowRoot;
            if (shadowRoot) {
                let nodeResult;
                if (typeof this.filter === "function") nodeResult = this.filter(previousNode);
                else if ((_b = this.filter) === null || _b === void 0 ? void 0 : _b.acceptNode) nodeResult = this.filter.acceptNode(previousNode);
                if (nodeResult === NodeFilter.FILTER_ACCEPT) return previousNode;
                // _acceptNode should have added new walker for this shadow,
                // go in recursively.
                return this.previousNode();
            }
            return previousNode;
        } else {
            if (this._walkerStack.length > 1) {
                this._walkerStack.shift();
                return this.previousNode();
            } else return null;
        }
    }
    nextSibling() {
        return null;
    }
    previousSibling() {
        return null;
    }
    parentNode() {
        return null;
    }
}
function $e3e23e1e89ad903c$var$createShadowTreeWalker(doc, root, whatToShow, filter) {
    return new $e3e23e1e89ad903c$var$ShadowTreeWalker(doc, root, whatToShow, filter);
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$ShadowMutationObserver {
    static _overrideAttachShadow(win) {
        const origAttachShadow = win.Element.prototype.attachShadow;
        if (origAttachShadow.__origAttachShadow) return;
        Element.prototype.attachShadow = function(options) {
            const shadowRoot = origAttachShadow.call(this, options);
            for (const shadowObserver of $e3e23e1e89ad903c$var$ShadowMutationObserver._shadowObservers)shadowObserver._addSubObserver(shadowRoot);
            return shadowRoot;
        };
        Element.prototype.attachShadow.__origAttachShadow = origAttachShadow;
    }
    constructor(callback){
        this._isObserving = false;
        this._callbackWrapper = (mutations, observer)=>{
            for (const mutation of mutations)if (mutation.type === "childList") {
                const removed = mutation.removedNodes;
                const added = mutation.addedNodes;
                for(let i = 0; i < removed.length; i++)this._walkShadows(removed[i], true);
                for(let i = 0; i < added.length; i++)this._walkShadows(added[i]);
            }
            this._callback(mutations, observer);
        };
        this._callback = callback;
        this._observer = new MutationObserver(this._callbackWrapper);
        this._subObservers = new Map();
    }
    _addSubObserver(shadowRoot) {
        if (!this._options || !this._callback || this._subObservers.has(shadowRoot)) return;
        if (this._options.subtree && $e3e23e1e89ad903c$var$nodeContains(this._root, shadowRoot)) {
            const subObserver = new MutationObserver(this._callbackWrapper);
            this._subObservers.set(shadowRoot, subObserver);
            if (this._isObserving) subObserver.observe(shadowRoot, this._options);
            this._walkShadows(shadowRoot);
        }
    }
    disconnect() {
        this._isObserving = false;
        delete this._options;
        $e3e23e1e89ad903c$var$ShadowMutationObserver._shadowObservers.delete(this);
        for (const subObserver of this._subObservers.values())subObserver.disconnect();
        this._subObservers.clear();
        this._observer.disconnect();
    }
    observe(target, options) {
        const doc = target.nodeType === Node.DOCUMENT_NODE ? target : target.ownerDocument;
        const win = doc === null || doc === void 0 ? void 0 : doc.defaultView;
        if (!doc || !win) return;
        $e3e23e1e89ad903c$var$ShadowMutationObserver._overrideAttachShadow(win);
        $e3e23e1e89ad903c$var$ShadowMutationObserver._shadowObservers.add(this);
        this._root = target;
        this._options = options;
        this._isObserving = true;
        this._observer.observe(target, options);
        this._walkShadows(target);
    }
    _walkShadows(target, remove) {
        const doc = target.nodeType === Node.DOCUMENT_NODE ? target : target.ownerDocument;
        if (!doc) return;
        if (target === doc) target = doc.body;
        else {
            const shadowRoot = target.shadowRoot;
            if (shadowRoot) {
                this._addSubObserver(shadowRoot);
                return;
            }
        }
        const walker = doc.createTreeWalker(target, NodeFilter.SHOW_ELEMENT, {
            acceptNode: (node)=>{
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (remove) {
                        const subObserver = this._subObservers.get(node);
                        if (subObserver) {
                            subObserver.disconnect();
                            this._subObservers.delete(node);
                        }
                    } else {
                        const shadowRoot = node.shadowRoot;
                        if (shadowRoot) this._addSubObserver(shadowRoot);
                    }
                }
                return NodeFilter.FILTER_SKIP;
            }
        });
        walker.nextNode();
    }
    takeRecords() {
        const records = this._observer.takeRecords();
        for (const subObserver of this._subObservers.values())records.push(...subObserver.takeRecords());
        return records;
    }
}
$e3e23e1e89ad903c$var$ShadowMutationObserver._shadowObservers = /*#__PURE__*/ new Set();
function $e3e23e1e89ad903c$var$createShadowMutationObserver(callback) {
    return new $e3e23e1e89ad903c$var$ShadowMutationObserver(callback);
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e3e23e1e89ad903c$var$shadowQuerySelector(node, selector, all) {
    // TODO: This is probably slow. Optimize to use each shadowRoot's querySelector/querySelectorAll
    //       instead of walking the tree.
    const elements = [];
    walk(node, selector);
    return elements;
    function walk(from, selector) {
        let el = null;
        const walker = document.createTreeWalker(from, NodeFilter.SHOW_ELEMENT, {
            acceptNode: (n)=>{
                if (n.nodeType === Node.ELEMENT_NODE) {
                    if (n.matches(selector)) {
                        el = n;
                        elements.push(el);
                        return all ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                    }
                    const shadowRoot = n.shadowRoot;
                    if (shadowRoot) {
                        walk(shadowRoot, selector);
                        return !all && elements.length ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                    }
                }
                return NodeFilter.FILTER_SKIP;
            }
        });
        walker.nextNode();
    }
}
function $e3e23e1e89ad903c$var$querySelectorAll(node, selector) {
    return $e3e23e1e89ad903c$var$shadowQuerySelector(node, selector, true);
}
function $e3e23e1e89ad903c$var$querySelector(node, selector) {
    return $e3e23e1e89ad903c$var$shadowQuerySelector(node, selector, false)[0] || null;
}
function $e3e23e1e89ad903c$var$getElementById(doc, id) {
    return $e3e23e1e89ad903c$var$querySelector(doc, "#" + id);
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // TODO: The functions below do not consider Shadow DOM slots yet. We will be adding
// support for slots as the need arises.
var $e3e23e1e89ad903c$var$shadowDOMAPI = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    appendChild: $e3e23e1e89ad903c$var$appendChild,
    createMutationObserver: $e3e23e1e89ad903c$var$createShadowMutationObserver,
    createTreeWalker: $e3e23e1e89ad903c$var$createShadowTreeWalker,
    getActiveElement: $e3e23e1e89ad903c$var$getActiveElement,
    getElementById: $e3e23e1e89ad903c$var$getElementById,
    getElementsByName: $e3e23e1e89ad903c$var$getElementsByName,
    getFirstChild: $e3e23e1e89ad903c$var$getFirstChild,
    getFirstElementChild: $e3e23e1e89ad903c$var$getFirstElementChild,
    getLastChild: $e3e23e1e89ad903c$var$getLastChild$1,
    getLastElementChild: $e3e23e1e89ad903c$var$getLastElementChild,
    getNextElementSibling: $e3e23e1e89ad903c$var$getNextElementSibling,
    getNextSibling: $e3e23e1e89ad903c$var$getNextSibling,
    getParentElement: $e3e23e1e89ad903c$var$getParentElement,
    getParentNode: $e3e23e1e89ad903c$var$getParentNode,
    getPreviousElementSibling: $e3e23e1e89ad903c$var$getPreviousElementSibling,
    getPreviousSibling: $e3e23e1e89ad903c$var$getPreviousSibling,
    getSelection: $e3e23e1e89ad903c$var$getSelection,
    insertBefore: $e3e23e1e89ad903c$var$insertBefore,
    nodeContains: $e3e23e1e89ad903c$var$nodeContains,
    querySelector: $e3e23e1e89ad903c$var$querySelector,
    querySelectorAll: $e3e23e1e89ad903c$var$querySelectorAll
});
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e3e23e1e89ad903c$var$Tabster {
    constructor(tabster){
        this.keyboardNavigation = tabster.keyboardNavigation;
        this.focusedElement = tabster.focusedElement;
        this.focusable = tabster.focusable;
        this.root = tabster.root;
        this.uncontrolled = tabster.uncontrolled;
        this.core = tabster;
    }
}
/**
 * Extends Window to include an internal Tabster instance.
 */ class $e3e23e1e89ad903c$var$TabsterCore {
    constructor(win, props){
        var _a, _b;
        this._forgetMemorizedElements = [];
        this._wrappers = new Set();
        this._initQueue = [];
        this._version = "8.7.0";
        this._noop = false;
        this.getWindow = ()=>{
            if (!this._win) throw new Error("Using disposed Tabster.");
            return this._win;
        };
        this._storage = $e3e23e1e89ad903c$var$createWeakMap(win);
        this._win = win;
        const getWindow = this.getWindow;
        if (props === null || props === void 0 ? void 0 : props.DOMAPI) $e3e23e1e89ad903c$var$setDOMAPI({
            ...props.DOMAPI
        });
        this.keyboardNavigation = new $e3e23e1e89ad903c$var$KeyboardNavigationState(getWindow);
        this.focusedElement = new $e3e23e1e89ad903c$var$FocusedElementState(this, getWindow);
        this.focusable = new $e3e23e1e89ad903c$var$FocusableAPI(this);
        this.root = new $e3e23e1e89ad903c$var$RootAPI(this, props === null || props === void 0 ? void 0 : props.autoRoot);
        this.uncontrolled = new $e3e23e1e89ad903c$var$UncontrolledAPI(// TODO: Remove checkUncontrolledTrappingFocus in the next major version.
        (props === null || props === void 0 ? void 0 : props.checkUncontrolledCompletely) || (props === null || props === void 0 ? void 0 : props.checkUncontrolledTrappingFocus));
        this.controlTab = (_a = props === null || props === void 0 ? void 0 : props.controlTab) !== null && _a !== void 0 ? _a : true;
        this.rootDummyInputs = !!(props === null || props === void 0 ? void 0 : props.rootDummyInputs);
        this._dummyObserver = new $e3e23e1e89ad903c$var$DummyInputObserver(getWindow);
        this.getParent = (_b = props === null || props === void 0 ? void 0 : props.getParent) !== null && _b !== void 0 ? _b : $e3e23e1e89ad903c$var$dom.getParentNode;
        this.internal = {
            stopObserver: ()=>{
                if (this._unobserve) {
                    this._unobserve();
                    delete this._unobserve;
                }
            },
            resumeObserver: (syncState)=>{
                if (!this._unobserve) {
                    const doc = getWindow().document;
                    this._unobserve = $e3e23e1e89ad903c$var$observeMutations(doc, this, $e3e23e1e89ad903c$var$updateTabsterByAttribute, syncState);
                }
            }
        };
        $e3e23e1e89ad903c$var$startFakeWeakRefsCleanup(getWindow);
        // Gives a tick to the host app to initialize other tabster
        // APIs before tabster starts observing attributes.
        this.queueInit(()=>{
            this.internal.resumeObserver(true);
        });
    }
    /**
   * Merges external props with the current props. Not all
   * props can/should be mergeable, so let's add more as we move on.
   * @param props Tabster props
   */ _mergeProps(props) {
        var _a;
        if (!props) return;
        this.getParent = (_a = props.getParent) !== null && _a !== void 0 ? _a : this.getParent;
    }
    createTabster(noRefCount, props) {
        const wrapper = new $e3e23e1e89ad903c$var$Tabster(this);
        if (!noRefCount) this._wrappers.add(wrapper);
        this._mergeProps(props);
        return wrapper;
    }
    disposeTabster(wrapper, allInstances) {
        if (allInstances) this._wrappers.clear();
        else this._wrappers.delete(wrapper);
        if (this._wrappers.size === 0) this.dispose();
    }
    dispose() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.internal.stopObserver();
        const win = this._win;
        win === null || win === void 0 || win.clearTimeout(this._initTimer);
        delete this._initTimer;
        this._initQueue = [];
        this._forgetMemorizedElements = [];
        if (win && this._forgetMemorizedTimer) {
            win.clearTimeout(this._forgetMemorizedTimer);
            delete this._forgetMemorizedTimer;
        }
        (_a = this.outline) === null || _a === void 0 || _a.dispose();
        (_b = this.crossOrigin) === null || _b === void 0 || _b.dispose();
        (_c = this.deloser) === null || _c === void 0 || _c.dispose();
        (_d = this.groupper) === null || _d === void 0 || _d.dispose();
        (_e = this.mover) === null || _e === void 0 || _e.dispose();
        (_f = this.modalizer) === null || _f === void 0 || _f.dispose();
        (_g = this.observedElement) === null || _g === void 0 || _g.dispose();
        (_h = this.restorer) === null || _h === void 0 || _h.dispose();
        this.keyboardNavigation.dispose();
        this.focusable.dispose();
        this.focusedElement.dispose();
        this.root.dispose();
        this._dummyObserver.dispose();
        $e3e23e1e89ad903c$var$stopFakeWeakRefsCleanupAndClearStorage(this.getWindow);
        $e3e23e1e89ad903c$var$clearElementCache(this.getWindow);
        this._storage = new WeakMap();
        this._wrappers.clear();
        if (win) {
            $e3e23e1e89ad903c$var$disposeInstanceContext(win);
            delete win.__tabsterInstance;
            delete this._win;
        }
    }
    storageEntry(element, addremove) {
        const storage = this._storage;
        let entry = storage.get(element);
        if (entry) {
            if (addremove === false && Object.keys(entry).length === 0) storage.delete(element);
        } else if (addremove === true) {
            entry = {};
            storage.set(element, entry);
        }
        return entry;
    }
    forceCleanup() {
        if (!this._win) return;
        this._forgetMemorizedElements.push(this._win.document.body);
        if (this._forgetMemorizedTimer) return;
        this._forgetMemorizedTimer = this._win.setTimeout(()=>{
            delete this._forgetMemorizedTimer;
            for(let el = this._forgetMemorizedElements.shift(); el; el = this._forgetMemorizedElements.shift()){
                $e3e23e1e89ad903c$var$clearElementCache(this.getWindow, el);
                $e3e23e1e89ad903c$var$FocusedElementState.forgetMemorized(this.focusedElement, el);
            }
        }, 0);
        $e3e23e1e89ad903c$var$cleanupFakeWeakRefs(this.getWindow, true);
    }
    queueInit(callback) {
        var _a;
        if (!this._win) return;
        this._initQueue.push(callback);
        if (!this._initTimer) this._initTimer = (_a = this._win) === null || _a === void 0 ? void 0 : _a.setTimeout(()=>{
            delete this._initTimer;
            this.drainInitQueue();
        }, 0);
    }
    drainInitQueue() {
        if (!this._win) return;
        const queue = this._initQueue;
        // Resetting the queue before calling the callbacks to avoid recursion.
        this._initQueue = [];
        queue.forEach((callback)=>callback());
    }
}
function $e3e23e1e89ad903c$export$23e58ab32962d3d5(tabster) {
    // The only legit case for calling this method is when you've completely removed
    // the application DOM and not going to add the new one for a while.
    const tabsterCore = tabster.core;
    tabsterCore.forceCleanup();
}
/**
 * Creates an instance of Tabster, returns the current window instance if it already exists.
 */ function $e3e23e1e89ad903c$export$456f6b7a70dafcba(win, props) {
    let tabster = $e3e23e1e89ad903c$var$getCurrentTabster(win);
    if (tabster) return tabster.createTabster(false, props);
    tabster = new $e3e23e1e89ad903c$var$TabsterCore(win, props);
    win.__tabsterInstance = tabster;
    return tabster.createTabster();
}
/**
 * Returns an instance of Tabster if it was created before or null.
 */ function $e3e23e1e89ad903c$export$ada8b61eee6ee48a(win) {
    const tabster = $e3e23e1e89ad903c$var$getCurrentTabster(win);
    return tabster ? tabster.createTabster(true) : null;
}
function $e3e23e1e89ad903c$export$b3b3c8193388a30() {
    return $e3e23e1e89ad903c$var$shadowDOMAPI;
}
/**
 * Creates a new groupper instance or returns an existing one
 * @param tabster Tabster instance
 */ function $e3e23e1e89ad903c$export$d2ade2e151331a73(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.groupper) tabsterCore.groupper = new $e3e23e1e89ad903c$var$GroupperAPI(tabsterCore, tabsterCore.getWindow);
    return tabsterCore.groupper;
}
/**
 * Creates a new mover instance or returns an existing one
 * @param tabster Tabster instance
 */ function $e3e23e1e89ad903c$export$f38e08cc6ea819e7(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.mover) tabsterCore.mover = new $e3e23e1e89ad903c$var$MoverAPI(tabsterCore, tabsterCore.getWindow);
    return tabsterCore.mover;
}
function $e3e23e1e89ad903c$export$f835050eb96854fc(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.outline) tabsterCore.outline = new $e3e23e1e89ad903c$var$OutlineAPI(tabsterCore);
    return tabsterCore.outline;
}
/**
 * Creates a new new deloser instance or returns an existing one
 * @param tabster Tabster instance
 * @param props Deloser props
 */ function $e3e23e1e89ad903c$export$5e425ca4dbf4e1e1(tabster, props) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.deloser) tabsterCore.deloser = new $e3e23e1e89ad903c$var$DeloserAPI(tabsterCore, props);
    return tabsterCore.deloser;
}
/**
 * Creates a new modalizer instance or returns an existing one
 * @param tabster Tabster instance
 * @param alwaysAccessibleSelector When Modalizer is active, we put
 * aria-hidden to everything else to hide it from screen readers. This CSS
 * selector allows to exclude some elements from this behaviour. For example,
 * this could be used to exclude aria-live region with the application-wide
 * status announcements.
 * @param accessibleCheck An optional callback that will be called when
 * active Modalizer wants to hide an element that doesn't belong to it from
 * the screen readers by setting aria-hidden. Similar to alwaysAccessibleSelector
 * but allows to address the elements programmatically rather than with a selector.
 * If the callback returns true, the element will not receive aria-hidden.
 */ function $e3e23e1e89ad903c$export$af216543e1ef674(tabster, // @deprecated use accessibleCheck.
alwaysAccessibleSelector, accessibleCheck) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.modalizer) tabsterCore.modalizer = new $e3e23e1e89ad903c$var$ModalizerAPI(tabsterCore, alwaysAccessibleSelector, accessibleCheck);
    return tabsterCore.modalizer;
}
function $e3e23e1e89ad903c$export$5fc66cc4e6b8ba75(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.observedElement) tabsterCore.observedElement = new $e3e23e1e89ad903c$var$ObservedElementAPI(tabsterCore);
    return tabsterCore.observedElement;
}
function $e3e23e1e89ad903c$export$28e0a3ebfc16e573(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.crossOrigin) {
        $e3e23e1e89ad903c$export$5e425ca4dbf4e1e1(tabster);
        $e3e23e1e89ad903c$export$af216543e1ef674(tabster);
        $e3e23e1e89ad903c$export$f38e08cc6ea819e7(tabster);
        $e3e23e1e89ad903c$export$d2ade2e151331a73(tabster);
        $e3e23e1e89ad903c$export$f835050eb96854fc(tabster);
        $e3e23e1e89ad903c$export$5fc66cc4e6b8ba75(tabster);
        tabsterCore.crossOrigin = new $e3e23e1e89ad903c$var$CrossOriginAPI(tabsterCore);
    }
    return tabsterCore.crossOrigin;
}
function $e3e23e1e89ad903c$export$32586705faae7c2d(tabster) {
    const tabsterCore = tabster.core;
    return tabsterCore.internal;
}
function $e3e23e1e89ad903c$export$80ddb24d84708237(tabster) {
    const tabsterCore = tabster.core;
    if (!tabsterCore.restorer) tabsterCore.restorer = new $e3e23e1e89ad903c$var$RestorerAPI(tabsterCore);
    return tabsterCore.restorer;
}
function $e3e23e1e89ad903c$export$baba89a9d6c164be(tabster, allInstances) {
    tabster.core.disposeTabster(tabster, allInstances);
}
/**
 * Returns an instance of Tabster if it already exists on the window .
 * @param win window instance that could contain an Tabster instance.
 */ function $e3e23e1e89ad903c$var$getCurrentTabster(win) {
    return win.__tabsterInstance;
}
/**
 * Allows to make Tabster non operational. Intended for performance debugging (and other
 * kinds of debugging), you can switch Tabster off without changing the application code
 * that consumes it.
 * @param tabster a reference created by createTabster().
 * @param noop true if you want to make Tabster noop, false if you want to turn it back.
 */ function $e3e23e1e89ad903c$export$f5e4f944136f94a1(tabster, noop) {
    const core = tabster.core;
    if (core._noop !== noop) {
        core._noop = noop;
        const processNode = (element)=>{
            if (!element.getAttribute) return NodeFilter.FILTER_SKIP;
            if ($e3e23e1e89ad903c$var$getTabsterOnElement(core, element) || element.hasAttribute($e3e23e1e89ad903c$export$a1195ad1c253d145)) $e3e23e1e89ad903c$var$updateTabsterByAttribute(core, element);
            return NodeFilter.FILTER_SKIP;
        };
        const doc = core.getWindow().document;
        const body = doc.body;
        processNode(body);
        const walker = $e3e23e1e89ad903c$var$createElementTreeWalker(doc, body, processNode);
        if (walker) {
            while(walker.nextNode());
        }
    }
}
function $e3e23e1e89ad903c$export$429d1a71f461eaed(tabster) {
    return tabster._noop;
}
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $e3e23e1e89ad903c$export$4624c240901a6889 = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $e3e23e1e89ad903c$export$8c87ed4a1ac417eb = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @deprecated This function is obsolete, use native element.dispatchEvent(new GroupperMoveFocusEvent(...)). */ function $e3e23e1e89ad903c$export$b9e983757913e6df(target, action) {
    return target.dispatchEvent(new $e3e23e1e89ad903c$export$e6a82560201109({
        action: action
    }));
}
/** @deprecated This function is obsolete, use native element.dispatchEvent(new MoverMoveFocusEvent(...)). */ function $e3e23e1e89ad903c$export$53eca8a1fad66316(target, key) {
    return target.dispatchEvent(new $e3e23e1e89ad903c$export$6f00fc054b25f3c9({
        key: key
    }));
}
/** @deprecated This function is obsolete, use native element.dispatchEvent(new MoverMemorizedElementEvent(...)). */ function $e3e23e1e89ad903c$export$589f5eda775784e4(target, memorizedElement) {
    return target.dispatchEvent(new $e3e23e1e89ad903c$export$bb8a944455e0ecdf({
        memorizedElement: memorizedElement
    }));
}




var $acw62 = parcelRequire("acw62");


/**
 * Determines whether or not an element has the virtual hierarchy extension.
 * @internal
 */ function $cd9f9b76846385e4$export$405b1af69064399d(element) {
    return element && !!element._virtual;
}


/**
 * Gets the virtual parent given the child element, if it exists.
 * @internal
 */ function $a84b79cd75c90fa5$var$getVirtualParent(child) {
    return (0, $cd9f9b76846385e4$export$405b1af69064399d)(child) ? child._virtual.parent || null : null;
}
function $a84b79cd75c90fa5$export$58081aedf094d85b(child, options = {}) {
    if (!child) return null;
    if (!options.skipVirtual) {
        const virtualParent = $a84b79cd75c90fa5$var$getVirtualParent(child);
        if (virtualParent) return virtualParent;
    }
    const parent = child.parentNode;
    // Node.DOCUMENT_FRAGMENT_NODE = 11
    if (parent && parent.nodeType === 11) return parent.host;
    return parent;
}


'use client';
const $b04ae062f6cbb081$var$DEFAULT_FACTORY = (tabster)=>{
    return tabster;
};
function $b04ae062f6cbb081$export$4da13d8c35aea7a4(targetDocument) {
    const defaultView = (targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) || undefined;
    const shadowDOMAPI = defaultView === null || defaultView === void 0 ? void 0 : defaultView.__tabsterShadowDOMAPI;
    if (defaultView) return (0, $e3e23e1e89ad903c$export$456f6b7a70dafcba)(defaultView, {
        autoRoot: {},
        controlTab: false,
        getParent: $a84b79cd75c90fa5$export$58081aedf094d85b,
        // The non-undefined return value of checkUncontrolledCompletely() dominates the value that the element might
        // have in its `uncontrolled: { completely: true }` part of the tabster attribute. We must make sure to return
        // undefined if we want the value from tabster attribute to be respected.
        checkUncontrolledCompletely: (element)=>{
            var _element_firstElementChild;
            return ((_element_firstElementChild = element.firstElementChild) === null || _element_firstElementChild === void 0 ? void 0 : _element_firstElementChild.hasAttribute('data-is-focus-trap-zone-bumper')) === true || undefined;
        },
        DOMAPI: shadowDOMAPI
    });
}
function $b04ae062f6cbb081$export$f3f635a6897e7f0c(factory = $b04ae062f6cbb081$var$DEFAULT_FACTORY) {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const factoryResultRef = $acw62.useRef(null);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        const tabster = $b04ae062f6cbb081$export$4da13d8c35aea7a4(targetDocument);
        if (tabster) {
            factoryResultRef.current = factory(tabster);
            return ()=>{
                (0, $e3e23e1e89ad903c$export$baba89a9d6c164be)(tabster);
                factoryResultRef.current = null;
            };
        }
    }, [
        targetDocument,
        factory
    ]);
    return factoryResultRef;
}



var $acw62 = parcelRequire("acw62");
'use client';
const $3cadb56bf5cf7176$export$52c56c2e556091a6 = (props)=>{
    // A tabster instance is not necessary to generate tabster attributes
    // but calling the hook will ensure that a tabster instance exists internally and avoids consumers doing the same
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)();
    const strAttr = (0, $e3e23e1e89ad903c$export$374a8d854973d904)(props, true);
    return $acw62.useMemo(()=>({
            [(0, $e3e23e1e89ad903c$export$a1195ad1c253d145)]: strAttr
        }), [
        strAttr
    ]);
};



'use client';
const $d560ba8cc00a7511$export$ce58b15831f653b8 = (options = {})=>{
    const { circular: circular, axis: axis, memorizeCurrent: memorizeCurrent = true, tabbable: tabbable, ignoreDefaultKeydown: ignoreDefaultKeydown, unstable_hasDefault: unstable_hasDefault } = options;
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)((0, $e3e23e1e89ad903c$export$f38e08cc6ea819e7));
    return (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        mover: {
            cyclic: !!circular,
            direction: $d560ba8cc00a7511$var$axisToMoverDirection(axis !== null && axis !== void 0 ? axis : 'vertical'),
            memorizeCurrent: memorizeCurrent,
            tabbable: tabbable,
            hasDefault: unstable_hasDefault
        },
        ...ignoreDefaultKeydown && {
            focusable: {
                ignoreKeydown: ignoreDefaultKeydown
            }
        }
    });
};
function $d560ba8cc00a7511$var$axisToMoverDirection(axis) {
    switch(axis){
        case 'horizontal':
            return (0, $e3e23e1e89ad903c$export$7c43ed5d018e9c17).Horizontal;
        case 'grid':
            return (0, $e3e23e1e89ad903c$export$7c43ed5d018e9c17).Grid;
        case 'grid-linear':
            return (0, $e3e23e1e89ad903c$export$7c43ed5d018e9c17).GridLinear;
        case 'both':
            return (0, $e3e23e1e89ad903c$export$7c43ed5d018e9c17).Both;
        case 'vertical':
        default:
            return (0, $e3e23e1e89ad903c$export$7c43ed5d018e9c17).Vertical;
    }
}



var $acw62 = parcelRequire("acw62");
'use client';
function $18a7d7467c2b10b3$var$isFactoryDispatch(newState) {
    return typeof newState === 'function';
}
const $18a7d7467c2b10b3$export$6f32135080cb4c3 = (options)=>{
    'use no memo';
    const [internalState, setInternalState] = $acw62.useState(()=>{
        if (options.defaultState === undefined) return options.initialState;
        return $18a7d7467c2b10b3$var$isInitializer(options.defaultState) ? options.defaultState() : options.defaultState;
    });
    // Heads up!
    // This part is specific for controlled mode and mocks behavior of React dispatcher function.
    const stateValueRef = $acw62.useRef(options.state);
    $acw62.useEffect(()=>{
        stateValueRef.current = options.state;
    }, [
        options.state
    ]);
    const setControlledState = $acw62.useCallback((newState)=>{
        if ($18a7d7467c2b10b3$var$isFactoryDispatch(newState)) newState(stateValueRef.current);
    }, []);
    return $18a7d7467c2b10b3$var$useIsControlled(options.state) ? [
        options.state,
        setControlledState
    ] : [
        internalState,
        setInternalState
    ];
};
function $18a7d7467c2b10b3$var$isInitializer(value) {
    return typeof value === 'function';
}
/**
 * Helper hook to handle previous comparison of controlled/uncontrolled
 * Prints an error when isControlled value switches between subsequent renders
 * @returns - whether the value is controlled
 */ const $18a7d7467c2b10b3$var$useIsControlled = (controlledValue)=>{
    'use no memo';
    const [isControlled] = $acw62.useState(()=>controlledValue !== undefined);
    return isControlled;
};


var $acw62 = parcelRequire("acw62");

'use client';
const $7d6a37de2d9c3d24$export$ee5b5d04074a389e = (fn)=>{
    const callbackRef = $acw62.useRef(()=>{
        throw new Error('Cannot call an event handler while rendering');
    });
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        callbackRef.current = fn;
    }, [
        fn
    ]);
    return $acw62.useCallback((...args)=>{
        const callback = callbackRef.current;
        return callback(...args);
    }, [
        callbackRef
    ]);
};


'use client';
const $7d57cd7ee5fa6068$export$19dcf9478947b8a5 = (props, ref)=>{
    const { appearance: appearance = 'transparent', reserveSelectedTabSpace: reserveSelectedTabSpace = true, size: size = 'medium' } = props;
    const state = $7d57cd7ee5fa6068$export$1f6f992d65c965f3(props, ref);
    const focusAttributes = $7d57cd7ee5fa6068$export$d9063a31c0181968({
        vertical: state.vertical
    });
    return {
        ...state,
        root: {
            ...focusAttributes,
            ...state.root
        },
        appearance: appearance,
        reserveSelectedTabSpace: reserveSelectedTabSpace,
        size: size
    };
};
const $7d57cd7ee5fa6068$export$1f6f992d65c965f3 = (props, ref)=>{
    const { disabled: disabled = false, onTabSelect: onTabSelect, selectTabOnFocus: selectTabOnFocus = false, vertical: vertical = false, selectedValue: controlledSelectedValue, defaultSelectedValue: defaultSelectedValue, ...rest } = props;
    const innerRef = $acw62.useRef(null);
    const [selectedValue, setSelectedValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: controlledSelectedValue,
        defaultState: defaultSelectedValue,
        initialState: undefined
    });
    // considered usePrevious, but it is sensitive to re-renders
    // this could cause the previous to move to current in the case where the tab list re-renders.
    // these refs avoid getRegisteredTabs changing when selectedValue changes and causing
    // renders for tabs that have not changed.
    const currentSelectedValue = $acw62.useRef(undefined);
    const previousSelectedValue = $acw62.useRef(undefined);
    $acw62.useEffect(()=>{
        previousSelectedValue.current = currentSelectedValue.current;
        currentSelectedValue.current = selectedValue;
    }, [
        selectedValue
    ]);
    const onSelect = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event, data)=>{
        setSelectedValue(data.value);
        onTabSelect === null || onTabSelect === void 0 || onTabSelect(event, data);
    });
    const registeredTabs = $acw62.useRef({});
    const onRegister = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((data)=>{
        const key = JSON.stringify(data.value);
        key;
        registeredTabs.current[key] = data;
    });
    const onUnregister = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((data)=>{
        delete registeredTabs.current[JSON.stringify(data.value)];
    });
    const getRegisteredTabs = $acw62.useCallback(()=>{
        return {
            selectedValue: currentSelectedValue.current,
            previousSelectedValue: previousSelectedValue.current,
            registeredTabs: registeredTabs.current
        };
    }, []);
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, innerRef),
            role: 'tablist',
            'aria-orientation': vertical ? 'vertical' : 'horizontal',
            ...rest
        }, {
            elementType: 'div'
        }),
        disabled: disabled,
        selectTabOnFocus: selectTabOnFocus,
        selectedValue: selectedValue,
        onRegister: onRegister,
        onUnregister: onUnregister,
        onSelect: onSelect,
        getRegisteredTabs: getRegisteredTabs,
        vertical: vertical
    };
};
const $7d57cd7ee5fa6068$export$d9063a31c0181968 = ({ vertical: vertical })=>{
    return (0, $d560ba8cc00a7511$export$ce58b15831f653b8)({
        circular: true,
        axis: vertical ? 'vertical' : 'horizontal',
        memorizeCurrent: false,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        unstable_hasDefault: true
    });
};






var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
'use client';
const $b76441dd4bb0583c$var$createProvider = (Original)=>{
    const Provider = (props)=>{
        // Holds an actual "props.value"
        const valueRef = $acw62.useRef(props.value);
        // Used to sync context updates and avoid stale values, can be considered as render/effect counter of Provider.
        const versionRef = $acw62.useRef(0);
        // A stable object, is used to avoid context updates via mutation of its values.
        const contextValue = $acw62.useRef(null);
        if (!contextValue.current) contextValue.current = {
            value: valueRef,
            version: versionRef,
            listeners: []
        };
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            valueRef.current = props.value;
            versionRef.current += 1;
            (0, $fO90s.unstable_runWithPriority)((0, $fO90s.unstable_NormalPriority), ()=>{
                contextValue.current.listeners.forEach((listener)=>{
                    listener([
                        versionRef.current,
                        props.value
                    ]);
                });
            });
        }, [
            props.value
        ]);
        return $acw62.createElement(Original, {
            value: contextValue.current
        }, props.children);
    };
    return Provider;
};
const $b76441dd4bb0583c$export$fd42f52fd3ae1109 = (defaultValue)=>{
    // eslint-disable-next-line @fluentui/no-context-default-value
    const context = $acw62.createContext({
        value: {
            current: defaultValue
        },
        version: {
            current: -1
        },
        listeners: []
    });
    context.Provider = $b76441dd4bb0583c$var$createProvider(context.Provider);
    // We don't support Consumer API
    delete context.Consumer;
    return context;
};



var $acw62 = parcelRequire("acw62");
'use client';
const $6c13c651ac1cfc27$export$30b2013e16e635d0 = (context, selector)=>{
    const contextValue = $acw62.useContext(context);
    const { value: { current: value }, version: { current: version }, listeners: listeners } = contextValue;
    const selected = selector(value);
    const [state, setState] = $acw62.useState([
        value,
        selected
    ]);
    const dispatch = (payload)=>{
        setState((prevState)=>{
            if (!payload) // early bail out when is dispatched during render
            return [
                value,
                selected
            ];
            if (payload[0] <= version) {
                if (Object.is(prevState[1], selected)) return prevState; // bail out
                return [
                    value,
                    selected
                ];
            }
            try {
                if (Object.is(prevState[0], payload[1])) return prevState; // do not update
                const nextSelected = selector(payload[1]);
                if (Object.is(prevState[1], nextSelected)) return prevState; // do not update
                return [
                    payload[1],
                    nextSelected
                ];
            } catch (e) {
            // ignored (stale props or some other reason)
            }
            // explicitly spread to enforce typing
            return [
                prevState[0],
                prevState[1]
            ]; // schedule update
        });
    };
    if (!Object.is(state[1], selected)) // schedule re-render
    // this is safe because it's self contained
    dispatch(undefined);
    const stableDispatch = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(dispatch);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        listeners.push(stableDispatch);
        return ()=>{
            const index = listeners.indexOf(stableDispatch);
            listeners.splice(index, 1);
        };
    }, [
        stableDispatch,
        listeners
    ]);
    return state[1];
};


'use client';
const $10b5578c8a01fa19$var$tabListContextDefaultValue = {
    appearance: 'transparent',
    reserveSelectedTabSpace: true,
    selectTabOnFocus: false,
    disabled: false,
    selectedValue: undefined,
    onRegister: ()=>{
    /* noop */ },
    onUnregister: ()=>{
    /* noop */ },
    onSelect: ()=>{
    /* noop */ },
    getRegisteredTabs: ()=>{
        return {
            registeredTabs: {}
        };
    },
    size: 'medium',
    vertical: false
};
const $10b5578c8a01fa19$export$aa6907f9fd69e93b = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $10b5578c8a01fa19$export$1bc26eb4ac1fc352 = $10b5578c8a01fa19$export$aa6907f9fd69e93b.Provider;
const $10b5578c8a01fa19$export$6818f85b899576ef = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($10b5578c8a01fa19$export$aa6907f9fd69e93b, (ctx = $10b5578c8a01fa19$var$tabListContextDefaultValue)=>selector(ctx));


const $6c813607aa319ab7$export$3a0816208dfcce0 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $10b5578c8a01fa19$export$1bc26eb4ac1fc352), {
            value: contextValues.tabList,
            children: state.root.children
        })
    });
};




'use client';
const $4b0a54425b1e0a36$export$20c03e495c7ca8a0 = {
    root: 'fui-TabList'
};
/**
 * Styles for the root slot
 */ const $4b0a54425b1e0a36$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1063pyq",
        Bnnss6s: "fi64zpg",
        Eh141a: "flvyvdh",
        qhf8xq: "f10pi13n"
    },
    horizontal: {
        Bt984gj: "f1q9h2pe",
        Beiy3e4: "f1063pyq"
    },
    vertical: {
        Bt984gj: "f1q9h2pe",
        Beiy3e4: "f1vx9l62"
    },
    roundedSmall: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f1eyhf9v"
    },
    rounded: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "faqewft"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".fi64zpg{flex-shrink:0;}",
        ".flvyvdh{flex-wrap:nowrap;}",
        ".f10pi13n{position:relative;}",
        ".f1q9h2pe{align-items:stretch;}",
        ".f1vx9l62{flex-direction:column;}",
        [
            ".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        [
            ".faqewft{gap:var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ]
    ]
});
const $4b0a54425b1e0a36$export$3757b77a4bdc4556 = (state)=>{
    'use no memo';
    const { appearance: appearance, vertical: vertical, size: size } = state;
    const styles = $4b0a54425b1e0a36$var$useStyles();
    const isRounded = appearance === 'subtle-circular' || appearance === 'filled-circular';
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($4b0a54425b1e0a36$export$20c03e495c7ca8a0.root, styles.root, vertical ? styles.vertical : styles.horizontal, isRounded && (size === 'small' ? styles.roundedSmall : styles.rounded), state.root.className);
    return state;
};


function $ea4d2d9b8ebf5f47$export$90bc632c6be1b5b2(state) {
    const { appearance: appearance, reserveSelectedTabSpace: reserveSelectedTabSpace, disabled: disabled, selectTabOnFocus: selectTabOnFocus, selectedValue: selectedKey, onRegister: onRegister, onUnregister: onUnregister, onSelect: onSelect, getRegisteredTabs: getRegisteredTabs, size: size, vertical: vertical } = state;
    const tabList = {
        appearance: appearance,
        reserveSelectedTabSpace: reserveSelectedTabSpace,
        disabled: disabled,
        selectTabOnFocus: selectTabOnFocus,
        selectedValue: selectedKey,
        onSelect: onSelect,
        onRegister: onRegister,
        onUnregister: onUnregister,
        getRegisteredTabs: getRegisteredTabs,
        size: size,
        vertical: vertical
    };
    return {
        tabList: tabList
    };
}



'use client';
const $900345cf912ae8c0$export$e51a686c67fdaa2d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $7d57cd7ee5fa6068$export$19dcf9478947b8a5)(props, ref);
    const contextValues = (0, $ea4d2d9b8ebf5f47$export$90bc632c6be1b5b2)(state);
    (0, $4b0a54425b1e0a36$export$3757b77a4bdc4556)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTabListStyles_unstable')(state);
    return (0, $6c813607aa319ab7$export$3a0816208dfcce0)(state, contextValues);
});
$900345cf912ae8c0$export$e51a686c67fdaa2d.displayName = 'TabList';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * Tiny helper to do the minimal amount of work in duplicating an object but omitting some
 * props. This ends up faster than using object ...rest or reduce to filter.
 *
 * This behaves very much like filteredAssign, but does not merge many objects together,
 * uses an exclusion object map, and avoids spreads all for optimal performance.
 *
 * See perf test for background:
 * https://jsperf.com/omit-vs-rest-vs-reduce/1
 *
 * @param obj - The object to clone
 * @param exclusions - The array of keys to exclude
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7c0ff279f695a700$export$30a06c8d3562193f(obj, exclusions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for(const key in obj)if (exclusions.indexOf(key) === -1 && obj.hasOwnProperty(key)) result[key] = obj[key];
    return result;
}

/**
 * @internal
 * Combine two event callbacks into a single callback function that calls each one in order.
 *
 * Usage example:
 * ```ts
 * state.slot.onChange = mergeCallbacks(state.slot.onChange, ev => {
 *   // Handle onChange
 * });
 * ```
 *
 * The primary use is to avoid the need to capture an existing callback (`state.slot.onChange` in the example) to a
 * local variable before replacing with a new listener that calls the existing one. This helps avoid bugs like:
 * * Infinite recursion by calling the re-assigned state.slot.onChange if it's not captured to a local variable.
 * * Missing a call to the original onChange due to an early return or other conditional.
 *
 * If you need a callback that is stable between renders, wrap the result in {@link useEventCallback}.
 *
 * @param callback1 - The first callback to be called, or undefined
 * @param callback2 - The second callback to be called, or undefined
 *
 * @returns A function that that calls the provided functions in order
 */ function $5a086c5c32116b33$export$f05a241035b5c5eb(callback1, callback2) {
    return (...args)=>{
        callback1 === null || callback1 === void 0 || callback1(...args);
        callback2 === null || callback2 === void 0 || callback2(...args);
    };
}



'use client';
const $5657584a340f9723$export$272a80fa5efc2477 = (props, ref)=>{
    const { content: content } = props;
    const state = $5657584a340f9723$export$ac53a678bf9062df(props, ref);
    const focusAttributes = $5657584a340f9723$export$a06d8240a859b3c5(state);
    const appearance = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.appearance);
    const reserveSelectedTabSpace = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.reserveSelectedTabSpace);
    const size = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>{
        var _ctx_size;
        return (_ctx_size = ctx.size) !== null && _ctx_size !== void 0 ? _ctx_size : 'medium';
    });
    const contentReservedSpace = content && typeof content === 'object' ? (0, $7c0ff279f695a700$export$30a06c8d3562193f)(content, [
        'ref'
    ]) : content;
    return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        components: {
            ...state.components,
            contentReservedSpace: 'span'
        },
        root: {
            ...focusAttributes,
            ...state.root
        },
        contentReservedSpace: (0, $fcf7ddccaab7fd8f$exports).optional(contentReservedSpace, {
            renderByDefault: !state.selected && !state.iconOnly && reserveSelectedTabSpace,
            defaultProps: {
                children: props.children
            },
            elementType: 'span'
        }),
        appearance: appearance,
        size: size
    };
};
const $5657584a340f9723$export$ac53a678bf9062df = (props, ref)=>{
    const { content: content, disabled: tabDisabled = false, icon: icon, onClick: onClick, onFocus: onFocus, value: value, ...rest } = props;
    const selectTabOnFocus = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.selectTabOnFocus);
    const listDisabled = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.disabled);
    const selected = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.selectedValue === value);
    const onRegister = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.onRegister);
    const onUnregister = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.onUnregister);
    const onSelect = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.onSelect);
    const vertical = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>!!ctx.vertical);
    const disabled = listDisabled || tabDisabled;
    const innerRef = $acw62.useRef(null);
    const onSelectCallback = (event)=>onSelect(event, {
            value: value
        });
    const onTabClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onClick, onSelectCallback));
    const onTabFocus = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(onFocus, onSelectCallback));
    $acw62.useEffect(()=>{
        onRegister({
            value: value,
            ref: innerRef
        });
        return ()=>{
            onUnregister({
                value: value,
                ref: innerRef
            });
        };
    }, [
        onRegister,
        onUnregister,
        innerRef,
        value
    ]);
    const iconSlot = (0, $fcf7ddccaab7fd8f$exports).optional(icon, {
        elementType: 'span'
    });
    const contentSlot = (0, $fcf7ddccaab7fd8f$exports).always(content, {
        defaultProps: {
            children: props.children
        },
        elementType: 'span'
    });
    const iconOnly = Boolean((iconSlot === null || iconSlot === void 0 ? void 0 : iconSlot.children) && !contentSlot.children);
    return {
        components: {
            root: 'button',
            icon: 'span',
            content: 'span',
            contentReservedSpace: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, innerRef),
            role: 'tab',
            type: 'button',
            // aria-selected undefined indicates it is not selectable
            // according to https://www.w3.org/TR/wai-aria-1.1/#aria-selected
            'aria-selected': disabled ? undefined : `${selected}`,
            value: value,
            ...rest,
            disabled: disabled,
            onClick: onTabClick,
            onFocus: selectTabOnFocus ? onTabFocus : onFocus
        }, {
            elementType: 'button'
        }),
        icon: iconSlot,
        iconOnly: iconOnly,
        content: contentSlot,
        disabled: disabled,
        selected: selected,
        value: value,
        vertical: vertical
    };
};
const $5657584a340f9723$export$a06d8240a859b3c5 = ({ selected: selected })=>{
    return (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        focusable: {
            isDefault: selected
        }
    });
};




const $ae8d80517c3a17a0$export$7c9a304efcb2001d = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            !state.iconOnly && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.content, {}),
            state.contentReservedSpace && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.contentReservedSpace, {})
        ]
    });
};






var $acw62 = parcelRequire("acw62");





'use client';
const $b13e6753fef1f098$var$setAnimationFrameNoop = (callback)=>{
    callback(0);
    return 0;
};
const $b13e6753fef1f098$var$cancelAnimationFrameNoop = (handle)=>handle;
function $b13e6753fef1f098$export$641fa9c94086b46e() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const setAnimationFrame = win ? win.requestAnimationFrame : $b13e6753fef1f098$var$setAnimationFrameNoop;
    const clearAnimationFrame = win ? win.cancelAnimationFrame : $b13e6753fef1f098$var$cancelAnimationFrameNoop;
    return (0, $9521bdea52bd87ae$export$adc464bf5eb3c05c)(setAnimationFrame, clearAnimationFrame);
}


'use client';
// eslint-disable-next-line @typescript-eslint/naming-convention
const $823bb986c9572888$var$tabIndicatorCssVars_unstable = {
    offsetVar: '--fui-Tab__indicator--offset',
    scaleVar: '--fui-Tab__indicator--scale'
};
const $823bb986c9572888$var$useActiveIndicatorStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg"
    },
    animated: {
        Ba2ppi3: "fhwpy7i",
        F2fol1: "f6zz20j",
        B1dyfl9: "f1ai4sc1",
        Bu93a1u: "f1rnm8gg",
        Bdasjez: "f1x3cmqg"
    },
    horizontal: {
        sjv3b2: [
            "fug4aj8",
            "f1i5xzg7"
        ],
        b1kco5: "f1q7ujh"
    },
    vertical: {
        sjv3b2: "f1hqboyk",
        b1kco5: "f1dxupa6"
    }
}, {
    d: [
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        ".fhwpy7i::after{transition-property:transform;}",
        ".f6zz20j::after{transition-duration:var(--durationSlow);}",
        ".f1ai4sc1::after{transition-timing-function:var(--curveDecelerateMax);}",
        ".fug4aj8::after{transform-origin:left;}",
        ".f1i5xzg7::after{transform-origin:right;}",
        ".f1q7ujh::after{transform:translateX(var(--fui-Tab__indicator--offset)) scaleX(var(--fui-Tab__indicator--scale));}",
        ".f1hqboyk::after{transform-origin:top;}",
        ".f1dxupa6::after{transform:translateY(var(--fui-Tab__indicator--offset)) scaleY(var(--fui-Tab__indicator--scale));}"
    ],
    m: [
        [
            "@media (prefers-reduced-motion: reduce){.f1rnm8gg::after{transition-property:none;}}",
            {
                m: "(prefers-reduced-motion: reduce)"
            }
        ],
        [
            "@media (prefers-reduced-motion: reduce){.f1x3cmqg::after{transition-duration:0.01ms;}}",
            {
                m: "(prefers-reduced-motion: reduce)"
            }
        ]
    ]
});
const $823bb986c9572888$var$calculateTabRect = (element)=>{
    if (element) {
        var _element_parentElement;
        const parentRect = ((_element_parentElement = element.parentElement) === null || _element_parentElement === void 0 ? void 0 : _element_parentElement.getBoundingClientRect()) || {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const tabRect = element.getBoundingClientRect();
        return {
            x: tabRect.x - parentRect.x,
            y: tabRect.y - parentRect.y,
            width: tabRect.width,
            height: tabRect.height
        };
    }
    return undefined;
};
const $823bb986c9572888$var$getRegisteredTabRect = (registeredTabs, value)=>{
    var _registeredTabs_JSON_stringify;
    const element = $823bb986c9572888$var$isValueDefined(value) ? (_registeredTabs_JSON_stringify = registeredTabs[JSON.stringify(value)]) === null || _registeredTabs_JSON_stringify === void 0 ? void 0 : _registeredTabs_JSON_stringify.ref.current : undefined;
    return element ? $823bb986c9572888$var$calculateTabRect(element) : undefined;
};
// eslint-disable-next-line eqeqeq
const $823bb986c9572888$var$isValueDefined = (value)=>value != null;
const $823bb986c9572888$export$f8d2e05e3dc813b7 = (state)=>{
    const { disabled: disabled, selected: selected, vertical: vertical } = state;
    const activeIndicatorStyles = $823bb986c9572888$var$useActiveIndicatorStyles();
    const [lastAnimatedFrom, setLastAnimatedFrom] = $acw62.useState();
    const [animationValues, setAnimationValues] = $acw62.useState({
        offset: 0,
        scale: 1
    });
    const getRegisteredTabs = (0, $10b5578c8a01fa19$export$6818f85b899576ef)((ctx)=>ctx.getRegisteredTabs);
    const [requestAnimationFrame] = (0, $b13e6753fef1f098$export$641fa9c94086b46e)();
    if (selected) {
        const { previousSelectedValue: previousSelectedValue, selectedValue: selectedValue, registeredTabs: registeredTabs } = getRegisteredTabs();
        if ($823bb986c9572888$var$isValueDefined(previousSelectedValue) && lastAnimatedFrom !== previousSelectedValue) {
            const previousSelectedTabRect = $823bb986c9572888$var$getRegisteredTabRect(registeredTabs, previousSelectedValue);
            const selectedTabRect = $823bb986c9572888$var$getRegisteredTabRect(registeredTabs, selectedValue);
            if (selectedTabRect && previousSelectedTabRect) {
                const offset = vertical ? previousSelectedTabRect.y - selectedTabRect.y : previousSelectedTabRect.x - selectedTabRect.x;
                const scale = vertical ? previousSelectedTabRect.height / selectedTabRect.height : previousSelectedTabRect.width / selectedTabRect.width;
                setAnimationValues({
                    offset: offset,
                    scale: scale
                });
                setLastAnimatedFrom(previousSelectedValue);
                // Reset the animation values after the animation is complete
                requestAnimationFrame(()=>setAnimationValues({
                        offset: 0,
                        scale: 1
                    }));
            }
        }
    } else if ($823bb986c9572888$var$isValueDefined(lastAnimatedFrom)) // need to clear the last animated from so that if this tab is selected again
    // from the same previous tab as last time, that animation still happens.
    setLastAnimatedFrom(undefined);
    // do not apply any animation if the tab is disabled
    if (disabled) return state;
    // the animation should only happen as the selection indicator returns to its
    // original position and not when set at the previous tabs position.
    const animating = animationValues.offset === 0 && animationValues.scale === 1;
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(state.root.className, selected && activeIndicatorStyles.base, selected && animating && activeIndicatorStyles.animated, selected && (vertical ? activeIndicatorStyles.vertical : activeIndicatorStyles.horizontal));
    const rootCssVars = {
        [$823bb986c9572888$var$tabIndicatorCssVars_unstable.offsetVar]: `${animationValues.offset}px`,
        [$823bb986c9572888$var$tabIndicatorCssVars_unstable.scaleVar]: `${animationValues.scale}`
    };
    state.root.style = {
        ...rootCssVars,
        ...state.root.style
    };
    return state;
};


'use client';
const $cca6131b04bae038$export$d2cf99ac72de8868 = {
    root: 'fui-Tab',
    icon: 'fui-Tab__icon',
    content: 'fui-Tab__content'
};
const $cca6131b04bae038$export$6053ee58c1392397 = {
    content: 'fui-Tab__content--reserved-space'
};
// These should match the constants defined in @fluentui/react-icons
// This package avoids taking a dependency on the icons package for only the constants.
const $cca6131b04bae038$var$iconClassNames = {
    filled: 'fui-Icon-filled',
    regular: 'fui-Icon-regular'
};
/**
 * Styles for the root slot
 */ const $cca6131b04bae038$var$useRootStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        Bt984gj: "f122n59",
        mc9l5x: "f13qh94s",
        Bnnss6s: "fi64zpg",
        Bxotwcr: "f1u07yai",
        Budl1dq: "frn2hmy",
        wkccdc: "f1olsevy",
        oeaueh: "f1s6fcnf",
        qhf8xq: "f10pi13n"
    },
    button: {
        Bt984gj: "f122n59",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bceei9c: "f1k6fduh",
        mc9l5x: "f13qh94s",
        Bnnss6s: "fi64zpg",
        Bxotwcr: "f1u07yai",
        Budl1dq: "frn2hmy",
        wkccdc: "f1olsevy",
        Bahqtrf: "fk6fouc",
        Bg96gwp: "f1i3iumi",
        oeaueh: "f1s6fcnf",
        qhf8xq: "f10pi13n",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        B9bfxx9: "f1cxpek8"
    },
    horizontal: {
        Brf1p80: "f4d9j23"
    },
    vertical: {
        Brf1p80: "f1s9ku6b"
    },
    smallHorizontal: {
        i8kkvl: "f14mj54c",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1wmopi4"
    },
    smallVertical: {
        i8kkvl: "f14mj54c",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f12or63q"
    },
    mediumHorizontal: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1w08f2p"
    },
    mediumVertical: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fymxs25"
    },
    largeHorizontal: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1ssfvub"
    },
    largeVertical: {
        i8kkvl: "f1rjii52",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fwkd1rq"
    },
    transparent: {
        De3pzq: "f1c21dwh",
        B95qlz1: "f9rvdkv",
        B7xitij: "f1051ucx",
        Bptxc3x: "fmmjozx",
        Bwqhzpy: "fqhzt5g",
        iyk698: "f7l5cgy",
        cl4aha: "fpkze5g",
        B0q3jbp: "f1iywnoi",
        Be9ayug: "f9n45c4"
    },
    subtle: {
        De3pzq: "fhovq9v",
        B95qlz1: "f1bifk9c",
        B7xitij: "fo6hitd",
        Bptxc3x: "fmmjozx",
        Bwqhzpy: "fqhzt5g",
        iyk698: "f7l5cgy",
        cl4aha: "fpkze5g",
        B0q3jbp: "f1iywnoi",
        Be9ayug: "f9n45c4"
    },
    disabledCursor: {
        Bceei9c: "fdrzuqr"
    },
    disabled: {
        De3pzq: "f1c21dwh",
        Bptxc3x: "fato7r6",
        cl4aha: "fao1bnu"
    },
    selected: {
        Bptxc3x: "f1cadz5z",
        Bwqhzpy: "fwhdxxj",
        iyk698: "fintccb",
        cl4aha: "ffplhdr",
        B0q3jbp: "fjo17wb",
        Be9ayug: "f148789c"
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f13qh94s{display:grid;}",
        ".fi64zpg{flex-shrink:0;}",
        ".f1u07yai{grid-auto-flow:column;}",
        ".frn2hmy{grid-template-columns:auto;}",
        ".f1olsevy{grid-template-rows:auto;}",
        ".f1s6fcnf{outline-style:none;}",
        ".f10pi13n{position:relative;}",
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f1k6fduh{cursor:pointer;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f1cxpek8{text-transform:none;}",
        ".f4d9j23{justify-content:center;}",
        ".f1s9ku6b{justify-content:start;}",
        ".f14mj54c{column-gap:var(--spacingHorizontalXXS);}",
        [
            ".f1wmopi4{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f12or63q{padding:var(--spacingVerticalXXS) var(--spacingHorizontalSNudge);}",
            {
                p: -1
            }
        ],
        ".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}",
        [
            ".f1w08f2p{padding:var(--spacingVerticalM) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".fymxs25{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".f1ssfvub{padding:var(--spacingVerticalL) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        [
            ".fwkd1rq{padding:var(--spacingVerticalS) var(--spacingHorizontalMNudge);}",
            {
                p: -1
            }
        ],
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f9rvdkv:enabled:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f1051ucx:enabled:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".fmmjozx .fui-Tab__icon{color:var(--colorNeutralForeground2);}",
        ".fqhzt5g:enabled:hover .fui-Tab__icon{color:var(--colorNeutralForeground2Hover);}",
        ".f7l5cgy:enabled:active .fui-Tab__icon{color:var(--colorNeutralForeground2Pressed);}",
        ".fpkze5g .fui-Tab__content{color:var(--colorNeutralForeground2);}",
        ".f1iywnoi:enabled:hover .fui-Tab__content{color:var(--colorNeutralForeground2Hover);}",
        ".f9n45c4:enabled:active .fui-Tab__content{color:var(--colorNeutralForeground2Pressed);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".fato7r6 .fui-Tab__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".fao1bnu .fui-Tab__content{color:var(--colorNeutralForegroundDisabled);}",
        ".f1cadz5z .fui-Tab__icon{color:var(--colorCompoundBrandForeground1);}",
        ".fwhdxxj:enabled:hover .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Hover);}",
        ".fintccb:enabled:active .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Pressed);}",
        ".ffplhdr .fui-Tab__content{color:var(--colorNeutralForeground1);}",
        ".fjo17wb:enabled:hover .fui-Tab__content{color:var(--colorNeutralForeground1Hover);}",
        ".f148789c:enabled:active .fui-Tab__content{color:var(--colorNeutralForeground1Pressed);}"
    ]
});
const $cca6131b04bae038$var$useCircularAppearanceStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f44lkw9",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fp7rvkm",
        Bptxc3x: "ftorr8m",
        cl4aha: "f16lqpmv"
    },
    small: {
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "fzklhed"
    },
    medium: {
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "f1j721cc"
    },
    large: {
        Dbcxam: 0,
        rjzwhg: 0,
        Bblux5w: "frx9knr"
    },
    subtle: {
        De3pzq: "fhovq9v",
        sj55zd: "fkfq4zb",
        B95qlz1: "f1bifk9c",
        Eo63ln: 0,
        r9osk6: 0,
        Itrz8y: 0,
        zeg6vx: 0,
        l65xgk: 0,
        Bw4olcx: 0,
        Folb0i: 0,
        I2h8y4: 0,
        Bgxgoyi: 0,
        Bvlkotb: 0,
        Fwyncl: 0,
        Byh5edv: 0,
        Becqvjq: 0,
        uumbiq: 0,
        B73q3dg: 0,
        Bblwbaf: 0,
        B0ezav: "ft57sj0",
        r4wkhp: "f1fcoy83",
        B7xitij: "fo6hitd",
        d3wsvi: 0,
        Hdqn7s: 0,
        zu5y1p: 0,
        owqphb: 0,
        g9c53k: 0,
        Btmu08z: 0,
        Bthxvy6: 0,
        gluvuq: 0,
        tb88gp: 0,
        wns6jk: 0,
        kdfdk4: 0,
        Bbw008l: 0,
        Bayi1ib: 0,
        B1kkfu3: 0,
        J1oqyp: 0,
        kem6az: 0,
        goa3yj: "fhn220o",
        p743kt: "f15qf7sh",
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1mljprk"
    },
    subtleSelected: {
        De3pzq: "f16xkysk",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f1c2pc3t",
        sj55zd: "faj9fo0",
        B95qlz1: "fsm7zmf",
        Eo63ln: 0,
        r9osk6: 0,
        Itrz8y: 0,
        zeg6vx: 0,
        l65xgk: 0,
        Bw4olcx: 0,
        Folb0i: 0,
        I2h8y4: 0,
        Bgxgoyi: 0,
        Bvlkotb: 0,
        Fwyncl: 0,
        Byh5edv: 0,
        Becqvjq: 0,
        uumbiq: 0,
        B73q3dg: 0,
        Bblwbaf: 0,
        B0ezav: "f1wo0sfq",
        r4wkhp: "f1afuynh",
        B7xitij: "f94ddyl",
        d3wsvi: 0,
        Hdqn7s: 0,
        zu5y1p: 0,
        owqphb: 0,
        g9c53k: 0,
        Btmu08z: 0,
        Bthxvy6: 0,
        gluvuq: 0,
        tb88gp: 0,
        wns6jk: 0,
        kdfdk4: 0,
        Bbw008l: 0,
        Bayi1ib: 0,
        B1kkfu3: 0,
        J1oqyp: 0,
        kem6az: 0,
        goa3yj: "fmle6oo",
        p743kt: "f1d3itm4",
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1e9l2u"
    },
    subtleDisabled: {
        De3pzq: "fhovq9v",
        sj55zd: "f1s2aq7o"
    },
    subtleDisabledSelected: {
        De3pzq: "f1bg9a2p",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fegtqic",
        sj55zd: "f1s2aq7o"
    },
    filled: {
        De3pzq: "f16xq7d1",
        sj55zd: "fkfq4zb",
        B95qlz1: "fwwxidx",
        r4wkhp: "f1fcoy83",
        B7xitij: "f14i52sd",
        p743kt: "f15qf7sh",
        Hhssn: "f1cpi5f4",
        uaurb9: "f6pj1s0",
        B401qx7: "f12sz5kj",
        Buyp1jb: "f17588c3",
        gsp74p: "fnthgdt"
    },
    filledSelected: {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk",
        B95qlz1: "f1lm9dni",
        r4wkhp: "f1mn5ei1",
        B7xitij: "f1g6ncd0",
        p743kt: "fl71aob",
        Gedr8k: "f14zl92z",
        Bm69vlq: "f16zy3eu",
        Bodipah: "f1gdgb7p",
        B5kpen0: "f1tua9ng"
    },
    filledDisabled: {
        De3pzq: "f1bg9a2p",
        sj55zd: "f1s2aq7o"
    },
    filledDisabledSelected: {
        De3pzq: "f1bg9a2p",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "fegtqic",
        sj55zd: "f1s2aq7o"
    }
}, {
    d: [
        [
            ".f44lkw9{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".fp7rvkm{border:solid var(--strokeWidthThin) var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".ftorr8m .fui-Tab__icon{color:inherit;}",
        ".f16lqpmv .fui-Tab__content{color:inherit;}",
        [
            ".fzklhed{padding-block:calc(var(--spacingVerticalXXS) - var(--strokeWidthThin));}",
            {
                p: -1
            }
        ],
        [
            ".f1j721cc{padding-block:calc(var(--spacingVerticalSNudge) - var(--strokeWidthThin));}",
            {
                p: -1
            }
        ],
        [
            ".frx9knr{padding-block:calc(var(--spacingVerticalS) - var(--strokeWidthThin));}",
            {
                p: -1
            }
        ],
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",
        [
            ".ft57sj0:enabled:hover{border:solid var(--strokeWidthThin) var(--colorNeutralStroke1Hover);}",
            {
                p: -2
            }
        ],
        ".f1fcoy83:enabled:hover{color:var(--colorNeutralForeground2Hover);}",
        ".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",
        [
            ".fhn220o:enabled:active{border:solid var(--strokeWidthThin) var(--colorNeutralStroke1Pressed);}",
            {
                p: -2
            }
        ],
        ".f15qf7sh:enabled:active{color:var(--colorNeutralForeground2Pressed);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        [
            ".f1c2pc3t{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStroke);}",
            {
                p: -2
            }
        ],
        ".faj9fo0{color:var(--colorBrandForeground2);}",
        ".fsm7zmf:enabled:hover{background-color:var(--colorBrandBackground2Hover);}",
        [
            ".f1wo0sfq:enabled:hover{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStrokeHover);}",
            {
                p: -2
            }
        ],
        ".f1afuynh:enabled:hover{color:var(--colorBrandForeground2Hover);}",
        ".f94ddyl:enabled:active{background-color:var(--colorBrandBackground2Pressed);}",
        [
            ".fmle6oo:enabled:active{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStrokePressed);}",
            {
                p: -2
            }
        ],
        ".f1d3itm4:enabled:active{color:var(--colorBrandForeground2Pressed);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        [
            ".fegtqic{border:solid var(--strokeWidthThin) var(--colorNeutralStrokeDisabled);}",
            {
                p: -2
            }
        ],
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fwwxidx:enabled:hover{background-color:var(--colorNeutralBackground3Hover);}",
        ".f14i52sd:enabled:active{background-color:var(--colorNeutralBackground3Pressed);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1lm9dni:enabled:hover{background-color:var(--colorBrandBackgroundHover);}",
        ".f1mn5ei1:enabled:hover{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1g6ncd0:enabled:active{background-color:var(--colorBrandBackgroundPressed);}",
        ".fl71aob:enabled:active{color:var(--colorNeutralForegroundOnBrand);}",
        [
            ".fegtqic{border:solid var(--strokeWidthThin) var(--colorNeutralStrokeDisabled);}",
            {
                p: -2
            }
        ]
    ],
    m: [
        [
            "@media (forced-colors: active){.f1mljprk{border:solid var(--strokeWidthThin) Canvas;}}",
            {
                p: -2,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1e9l2u{border:solid var(--strokeWidthThin) Highlight;}}",
            {
                p: -2,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cpi5f4:enabled:hover{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f6pj1s0:enabled:hover{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f12sz5kj:enabled:hover .fui-Tab__content{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f17588c3:enabled:hover .fui-Icon-filled{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fnthgdt:enabled:hover .fui-Icon-regular{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14zl92z:enabled{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f16zy3eu:enabled .fui-Tab__content{color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1gdgb7p:enabled .fui-Tab__content{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1tua9ng:enabled .fui-Tab__icon{color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
/**
 * Focus styles for the root slot
 */ const $cca6131b04bae038$var$useFocusStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bn4voq9: "f1p7hgxw",
        Bfpq7zp: "f1way5bb",
        g9k6zt: "f9znhxp",
        j6ew2k: [
            "fqa318h",
            "fqa318h"
        ],
        Bhxq17a: "f1vjpng2"
    },
    circular: {
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bn4voq9: "f1p7hgxw",
        Bfpq7zp: "f1way5bb",
        g9k6zt: "f9znhxp",
        j6ew2k: [
            "fzgyhws",
            "fqxug60"
        ],
        Bhxq17a: "f1vjpng2"
    }
}, {
    d: [
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f1p7hgxw[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);}",
        ".f1way5bb[data-fui-focus-visible]{outline-color:transparent;}",
        ".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",
        ".fqa318h[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2);}",
        ".f1vjpng2[data-fui-focus-visible]{z-index:1;}",
        ".fzgyhws[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2),0 0 0 var(--strokeWidthThin) var(--colorNeutralStrokeOnBrand) inset;}",
        ".fqxug60[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2),0 0 0 var(--strokeWidthThin) var(--colorNeutralStrokeOnBrand) inset;}"
    ]
});
/** Indicator styles for when pending selection */ const $cca6131b04bae038$var$usePendingIndicatorStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        az7l2e: "fhw179n",
        vqofr: 0,
        Bv4n3vi: 0,
        Bgqb9hq: 0,
        B0uxbk8: 0,
        Bf3jju6: "fg9j5n4",
        amg5m6: "f1kmhr4c",
        zkfqfm: "fl1ydde",
        Bkydozb: "f1y7maxz",
        Bka2azo: 0,
        vzq8l0: 0,
        csmgbd: 0,
        Br4ovkg: 0,
        aelrif: "fceyvr4",
        y36c18: "f16cxu0",
        B1ctymy: "f1nwgacf",
        xzc5d: "fm6alxz",
        h5yqg8: "fhx32z1"
    },
    disabled: {
        az7l2e: "f1ut20fw",
        Bkydozb: "fhrzcfn",
        xzc5d: "fw15awd",
        h5yqg8: "faqmq51"
    },
    smallHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1r53b5e",
        Fbdkly: [
            "f1s6rxz5",
            "fo35v8s"
        ],
        mdwyqc: [
            "fo35v8s",
            "f1s6rxz5"
        ]
    },
    smallVertical: {
        lawp4y: "fze4zud",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "fdp32p8",
        Ccq8qp: "f1aij3q"
    },
    mediumHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1s2r9ax",
        Fbdkly: [
            "f1o0nnkk",
            "fxb7rol"
        ],
        mdwyqc: [
            "fxb7rol",
            "f1o0nnkk"
        ]
    },
    mediumVertical: {
        lawp4y: "f17jracn",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "f117lcb2",
        Ccq8qp: "f1aij3q"
    },
    largeHorizontal: {
        lawp4y: "fchca7p",
        Baz25je: "f1s2r9ax",
        Fbdkly: [
            "f1o0nnkk",
            "fxb7rol"
        ],
        mdwyqc: [
            "fxb7rol",
            "f1o0nnkk"
        ]
    },
    largeVertical: {
        lawp4y: "fel9d3z",
        Fbdkly: [
            "f1fzr1x6",
            "f1f351id"
        ],
        Bciustq: "f6vqlre",
        Ccq8qp: "f1aij3q"
    }
}, {
    h: [
        ".fhw179n:hover::before{background-color:var(--colorNeutralStroke1Hover);}",
        [
            ".fg9j5n4:hover::before{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f1kmhr4c:hover::before{content:\"\";}",
        ".fl1ydde:hover::before{position:absolute;}",
        ".f1ut20fw:hover::before{background-color:var(--colorTransparentStroke);}"
    ],
    a: [
        ".f1y7maxz:active::before{background-color:var(--colorNeutralStroke1Pressed);}",
        [
            ".fceyvr4:active::before{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f16cxu0:active::before{content:\"\";}",
        ".f1nwgacf:active::before{position:absolute;}",
        ".fhrzcfn:active::before{background-color:var(--colorTransparentStroke);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fm6alxz:hover::before{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fhx32z1:active::before{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fw15awd:hover::before{background-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.faqmq51:active::before{background-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    d: [
        ".fchca7p::before{bottom:0;}",
        ".f1r53b5e::before{height:var(--strokeWidthThick);}",
        ".f1s6rxz5::before{left:var(--spacingHorizontalSNudge);}",
        ".fo35v8s::before{right:var(--spacingHorizontalSNudge);}",
        ".fze4zud::before{bottom:var(--spacingVerticalXS);}",
        ".f1fzr1x6::before{left:0;}",
        ".f1f351id::before{right:0;}",
        ".fdp32p8::before{top:var(--spacingVerticalXS);}",
        ".f1aij3q::before{width:var(--strokeWidthThicker);}",
        ".f1s2r9ax::before{height:var(--strokeWidthThicker);}",
        ".f1o0nnkk::before{left:var(--spacingHorizontalM);}",
        ".fxb7rol::before{right:var(--spacingHorizontalM);}",
        ".f17jracn::before{bottom:var(--spacingVerticalS);}",
        ".f117lcb2::before{top:var(--spacingVerticalS);}",
        ".fel9d3z::before{bottom:var(--spacingVerticalMNudge);}",
        ".f6vqlre::before{top:var(--spacingVerticalMNudge);}"
    ]
});
const $cca6131b04bae038$var$useActiveIndicatorStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        Bjyk6c5: "f1rp0jgh",
        d9w3h3: 0,
        B3778ie: 0,
        B4j8arr: 0,
        Bl18szs: 0,
        Blrzh8d: "f3b9emi",
        Bsft5z2: "f13zj6fq",
        E3zdtr: "f1mdlcz9"
    },
    selected: {
        Bjyk6c5: "f1ksivud",
        Bej4dhw: "f1476jrx",
        B7wqxwa: "f18q216b",
        Hwb57: "f1wf6u82",
        Beg08s0: "f1xwit7m",
        Bo27r1v: "f1ksfgwi"
    },
    disabled: {
        Bjyk6c5: "f13lkzet"
    },
    smallHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f9bb2ob",
        Eqx8gd: [
            "f1q70ajw",
            "f18rbzdx"
        ],
        B1piin3: [
            "f18rbzdx",
            "f1q70ajw"
        ]
    },
    smallVertical: {
        By385i5: "fqbue9b",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "fk1klkt",
        a2br6o: "f1o25lip"
    },
    mediumHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f1vx7lu8",
        Eqx8gd: [
            "fna7m5n",
            "f1oxpfwv"
        ],
        B1piin3: [
            "f1oxpfwv",
            "fna7m5n"
        ]
    },
    mediumVertical: {
        By385i5: "fipylg0",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "fqchiol",
        a2br6o: "f1o25lip"
    },
    largeHorizontal: {
        By385i5: "fo72kxq",
        Dlnsje: "f1vx7lu8",
        Eqx8gd: [
            "fna7m5n",
            "f1oxpfwv"
        ],
        B1piin3: [
            "f1oxpfwv",
            "fna7m5n"
        ]
    },
    largeVertical: {
        By385i5: "f1w7dm5g",
        Eqx8gd: [
            "f1n6gb5g",
            "f15yvnhg"
        ],
        bn5sak: "f1p6em4m",
        a2br6o: "f1o25lip"
    }
}, {
    d: [
        ".f1rp0jgh::after{background-color:var(--colorTransparentStroke);}",
        [
            ".f3b9emi::after{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        ".f13zj6fq::after{content:\"\";}",
        ".f1mdlcz9::after{position:absolute;}",
        ".f1ksivud::after{background-color:var(--colorCompoundBrandStroke);}",
        ".f1476jrx:enabled:hover::after{background-color:var(--colorCompoundBrandStrokeHover);}",
        ".f18q216b:enabled:active::after{background-color:var(--colorCompoundBrandStrokePressed);}",
        ".f13lkzet::after{background-color:var(--colorNeutralForegroundDisabled);}",
        ".fo72kxq::after{bottom:0;}",
        ".f9bb2ob::after{height:var(--strokeWidthThick);}",
        ".f1q70ajw::after{left:var(--spacingHorizontalSNudge);}",
        ".f18rbzdx::after{right:var(--spacingHorizontalSNudge);}",
        ".fqbue9b::after{bottom:var(--spacingVerticalXS);}",
        ".f1n6gb5g::after{left:0;}",
        ".f15yvnhg::after{right:0;}",
        ".fk1klkt::after{top:var(--spacingVerticalXS);}",
        ".f1o25lip::after{width:var(--strokeWidthThicker);}",
        ".f1vx7lu8::after{height:var(--strokeWidthThicker);}",
        ".fna7m5n::after{left:var(--spacingHorizontalM);}",
        ".f1oxpfwv::after{right:var(--spacingHorizontalM);}",
        ".fipylg0::after{bottom:var(--spacingVerticalS);}",
        ".fqchiol::after{top:var(--spacingVerticalS);}",
        ".f1w7dm5g::after{bottom:var(--spacingVerticalMNudge);}",
        ".f1p6em4m::after{top:var(--spacingVerticalMNudge);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1wf6u82::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1xwit7m:enabled:hover::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ksfgwi:enabled:active::after{background-color:ButtonText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
/**
 * Styles for the icon slot.
 */ const $cca6131b04bae038$var$useIconStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        Br312pm: "fwpfdsa",
        Ijaq50: "f16hsg94",
        Bt984gj: "f122n59",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        D0sxk3: "f16u1re",
        t6yez3: "f8bsbmo"
    },
    small: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3"
    },
    medium: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3"
    },
    large: {
        Be2twd7: "f1rt2boy",
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun"
    },
    selected: {
        D0sxk3: "fxoiby5",
        t6yez3: "f15q0o9g"
    }
}, {
    d: [
        ".fwpfdsa{grid-column-start:1;}",
        ".f16hsg94{grid-row-start:1;}",
        ".f122n59{align-items:center;}",
        ".ftuwxu6{display:inline-flex;}",
        ".f4d9j23{justify-content:center;}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        ".f16u1re .fui-Icon-filled{display:none;}",
        ".f8bsbmo .fui-Icon-regular{display:inline;}",
        ".fe5j1ua{font-size:20px;}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".f1rt2boy{font-size:24px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".fxoiby5 .fui-Icon-filled{display:inline;}",
        ".f15q0o9g .fui-Icon-regular{display:none;}"
    ]
});
/**
 * Styles for the content slot (children)
 */ const $cca6131b04bae038$var$useContentStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1a3p1vp",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1bwptpd"
    },
    selected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "figsok6",
        Bg96gwp: "faaz57k"
    },
    largeSelected: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    noIconBefore: {
        Br312pm: "fwpfdsa",
        Ijaq50: "f16hsg94"
    },
    iconBefore: {
        Br312pm: "fd46tj4",
        Ijaq50: "f16hsg94"
    },
    placeholder: {
        Bcdw1i0: "fd7fpy0"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".f1a3p1vp{overflow:hidden;}",
            {
                p: -1
            }
        ],
        [
            ".f1bwptpd{padding:var(--spacingVerticalNone) var(--spacingHorizontalXXS);}",
            {
                p: -1
            }
        ],
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fwpfdsa{grid-column-start:1;}",
        ".f16hsg94{grid-row-start:1;}",
        ".fd46tj4{grid-column-start:2;}",
        ".fd7fpy0{visibility:hidden;}"
    ]
});
const $cca6131b04bae038$export$c914f0c90bb795be = (state)=>{
    'use no memo';
    $cca6131b04bae038$export$b351243d2ff13d6b(state);
    $cca6131b04bae038$export$61fc88aa2d7333b8(state, state.root);
    $cca6131b04bae038$export$8a41eb0bebca9fad(state);
    return state;
};
const $cca6131b04bae038$export$b351243d2ff13d6b = (state)=>{
    'use no memo';
    const rootStyles = $cca6131b04bae038$var$useRootStyles();
    const pendingIndicatorStyles = $cca6131b04bae038$var$usePendingIndicatorStyles();
    const activeIndicatorStyles = $cca6131b04bae038$var$useActiveIndicatorStyles();
    const { appearance: appearance, disabled: disabled, selected: selected, size: size, vertical: vertical } = state;
    const classes = [
        $cca6131b04bae038$export$d2cf99ac72de8868.root,
        rootStyles.root
    ];
    if (appearance !== 'subtle-circular' && appearance !== 'filled-circular') classes.push(// pending indicator (before pseudo element)
    pendingIndicatorStyles.base, size === 'small' && (vertical ? pendingIndicatorStyles.smallVertical : pendingIndicatorStyles.smallHorizontal), size === 'medium' && (vertical ? pendingIndicatorStyles.mediumVertical : pendingIndicatorStyles.mediumHorizontal), size === 'large' && (vertical ? pendingIndicatorStyles.largeVertical : pendingIndicatorStyles.largeHorizontal), disabled && pendingIndicatorStyles.disabled, // active indicator (after pseudo element)
    selected && activeIndicatorStyles.base, selected && !disabled && activeIndicatorStyles.selected, selected && size === 'small' && (vertical ? activeIndicatorStyles.smallVertical : activeIndicatorStyles.smallHorizontal), selected && size === 'medium' && (vertical ? activeIndicatorStyles.mediumVertical : activeIndicatorStyles.mediumHorizontal), selected && size === 'large' && (vertical ? activeIndicatorStyles.largeVertical : activeIndicatorStyles.largeHorizontal), selected && disabled && activeIndicatorStyles.disabled);
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(...classes, state.root.className);
    (0, $823bb986c9572888$export$f8d2e05e3dc813b7)(state);
    return state;
};
const $cca6131b04bae038$export$61fc88aa2d7333b8 = (state, slot)=>{
    'use no memo';
    const rootStyles = $cca6131b04bae038$var$useRootStyles();
    const focusStyles = $cca6131b04bae038$var$useFocusStyles();
    const circularStyles = $cca6131b04bae038$var$useCircularAppearanceStyles();
    const { appearance: appearance, disabled: disabled, selected: selected, size: size, vertical: vertical } = state;
    const isSubtleCircular = appearance === 'subtle-circular';
    const isFilledCircular = appearance === 'filled-circular';
    const isCircular = isSubtleCircular || isFilledCircular;
    const circularAppearance = [
        circularStyles.base,
        focusStyles.circular,
        // sizes
        size === 'small' && circularStyles.small,
        size === 'medium' && circularStyles.medium,
        size === 'large' && circularStyles.large,
        // subtle-circular appearance
        isSubtleCircular && circularStyles.subtle,
        selected && isSubtleCircular && circularStyles.subtleSelected,
        disabled && isSubtleCircular && circularStyles.subtleDisabled,
        selected && disabled && isSubtleCircular && circularStyles.subtleDisabledSelected,
        // filled-circular appearance
        isFilledCircular && circularStyles.filled,
        selected && isFilledCircular && circularStyles.filledSelected,
        disabled && isFilledCircular && circularStyles.filledDisabled,
        selected && disabled && isFilledCircular && circularStyles.filledDisabledSelected
    ];
    const regularAppearance = [
        focusStyles.base,
        !disabled && appearance === 'subtle' && rootStyles.subtle,
        !disabled && appearance === 'transparent' && rootStyles.transparent,
        !disabled && selected && rootStyles.selected,
        disabled && rootStyles.disabled
    ];
    slot.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(rootStyles.button, // orientation
    vertical ? rootStyles.vertical : rootStyles.horizontal, // size
    size === 'small' && (vertical ? rootStyles.smallVertical : rootStyles.smallHorizontal), size === 'medium' && (vertical ? rootStyles.mediumVertical : rootStyles.mediumHorizontal), size === 'large' && (vertical ? rootStyles.largeVertical : rootStyles.largeHorizontal), ...isCircular ? circularAppearance : regularAppearance, disabled && rootStyles.disabledCursor, slot.className);
    return state;
};
const $cca6131b04bae038$export$8a41eb0bebca9fad = (state)=>{
    'use no memo';
    const iconStyles = $cca6131b04bae038$var$useIconStyles();
    const contentStyles = $cca6131b04bae038$var$useContentStyles();
    const { selected: selected, size: size } = state;
    if (state.icon) state.icon.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($cca6131b04bae038$export$d2cf99ac72de8868.icon, iconStyles.base, iconStyles[size], selected && iconStyles.selected, state.icon.className);
    // This needs to be before state.content.className is updated
    if (state.contentReservedSpace) {
        state.contentReservedSpace.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($cca6131b04bae038$export$6053ee58c1392397.content, contentStyles.base, size === 'large' ? contentStyles.largeSelected : contentStyles.selected, state.icon ? contentStyles.iconBefore : contentStyles.noIconBefore, contentStyles.placeholder, state.content.className);
        // FIXME: this is a deprecated API
        // should be removed in the next major version
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        state.contentReservedSpaceClassName = state.contentReservedSpace.className;
    }
    state.content.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($cca6131b04bae038$export$d2cf99ac72de8868.content, contentStyles.base, size === 'large' && contentStyles.large, selected && (size === 'large' ? contentStyles.largeSelected : contentStyles.selected), state.icon ? contentStyles.iconBefore : contentStyles.noIconBefore, state.content.className);
    return state;
};



'use client';
const $71e914794eade933$export$3e41faf802a29e71 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $5657584a340f9723$export$272a80fa5efc2477)(props, ref);
    (0, $cca6131b04bae038$export$c914f0c90bb795be)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTabStyles_unstable')(state);
    return (0, $ae8d80517c3a17a0$export$7c9a304efcb2001d)(state);
});
$71e914794eade933$export$3e41faf802a29e71.displayName = 'Tab';



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

const $0330a494ead718f0$export$ae4a83dd80e6ba2d = (props, ref)=>{
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : props.noNativeElements) ? 'div' : 'table';
    var _props_size, _props_noNativeElements, _props_sortable;
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'table' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        size: (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : 'medium',
        noNativeElements: (_props_noNativeElements = props.noNativeElements) !== null && _props_noNativeElements !== void 0 ? _props_noNativeElements : false,
        sortable: (_props_sortable = props.sortable) !== null && _props_sortable !== void 0 ? _props_sortable : false
    };
};





var $acw62 = parcelRequire("acw62");
'use client';
const $bf449bf33e2cb0a3$var$tableContext = $acw62.createContext(undefined);
const $bf449bf33e2cb0a3$export$d59e8974491c2a47 = {
    size: 'medium',
    noNativeElements: false,
    sortable: false
};
const $bf449bf33e2cb0a3$export$2304abde66e33a52 = $bf449bf33e2cb0a3$var$tableContext.Provider;
const $bf449bf33e2cb0a3$export$3cb274deb6c2d854 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($bf449bf33e2cb0a3$var$tableContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $bf449bf33e2cb0a3$export$d59e8974491c2a47;
};


const $908feebcfd4b84d6$export$72bba67a585be2a8 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $bf449bf33e2cb0a3$export$2304abde66e33a52), {
        value: contextValues.table,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};




'use client';
const $b9ca328e1ef003e1$export$e7ef44113e912046 = 'fui-Table';
const $b9ca328e1ef003e1$export$17b698a4158bc91 = {
    root: 'fui-Table'
};
const $b9ca328e1ef003e1$var$useTableLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1w4nmp0",
        ha4doy: "fmrv4ls",
        a9b677: "fly5x3f",
        B73mfa3: "f14m3nip"
    }
}, {
    d: [
        ".f1w4nmp0{display:table;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".fly5x3f{width:100%;}",
        ".f14m3nip{table-layout:fixed;}"
    ]
});
const $b9ca328e1ef003e1$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
/**
 * Styles for the root slot
 */ const $b9ca328e1ef003e1$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        po53p8: "fgkb47j",
        De3pzq: "fhovq9v"
    }
}, {
    d: [
        ".fgkb47j{border-collapse:collapse;}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}"
    ]
});
const $b9ca328e1ef003e1$export$9521445d686d1f01 = (state)=>{
    'use no memo';
    const styles = $b9ca328e1ef003e1$var$useStyles();
    const layoutStyles = {
        table: $b9ca328e1ef003e1$var$useTableLayoutStyles(),
        flex: $b9ca328e1ef003e1$var$useFlexLayoutStyles()
    };
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($b9ca328e1ef003e1$export$e7ef44113e912046, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
};



var $acw62 = parcelRequire("acw62");
'use client';
function $d662d145b5ed04e3$export$10e27e49d8711f5d(state) {
    const { size: size, noNativeElements: noNativeElements, sortable: sortable } = state;
    const tableContext = $acw62.useMemo(()=>({
            noNativeElements: noNativeElements,
            size: size,
            sortable: sortable
        }), [
        noNativeElements,
        size,
        sortable
    ]);
    return {
        table: tableContext
    };
}



'use client';
const $bf8e3f93ce344917$export$54ec01a60f47d33d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $0330a494ead718f0$export$ae4a83dd80e6ba2d)(props, ref);
    (0, $b9ca328e1ef003e1$export$9521445d686d1f01)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableStyles_unstable')(state);
    return (0, $908feebcfd4b84d6$export$72bba67a585be2a8)(state, (0, $d662d145b5ed04e3$export$10e27e49d8711f5d)(state));
});
$bf8e3f93ce344917$export$54ec01a60f47d33d.displayName = 'Table';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");


'use client';
const $21b88dc000471395$export$9d04d359fb79e4d0 = (props, ref)=>{
    const { noNativeElements: noNativeElements } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'thead';
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'rowgroup' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements: noNativeElements
    };
};





var $acw62 = parcelRequire("acw62");
'use client';
const $b32b2b077c08c135$var$tableHeaderContext = $acw62.createContext(undefined);
const $b32b2b077c08c135$var$tableHeaderContextDefaultValue = '';
const $b32b2b077c08c135$export$ede65b1f183bac91 = $b32b2b077c08c135$var$tableHeaderContext.Provider;
const $b32b2b077c08c135$export$e9d05040fc93d3a3 = ()=>$acw62.useContext($b32b2b077c08c135$var$tableHeaderContext) === $b32b2b077c08c135$var$tableHeaderContextDefaultValue;


const $a13f3cfe0a234387$export$d1541071f0707ce5 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $b32b2b077c08c135$export$ede65b1f183bac91), {
        value: "",
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
    });
};



'use client';
const $97e73014970bcab3$export$ecabfa1fd8cfc61e = 'fui-TableHeader';
const $97e73014970bcab3$export$84932ebc2effbb7e = {
    root: 'fui-TableHeader'
};
const $97e73014970bcab3$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
const $97e73014970bcab3$var$useTableLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1tp1avn"
    }
}, {
    d: [
        ".f1tp1avn{display:table-row-group;}"
    ]
});
const $97e73014970bcab3$export$431076ffea51440d = (state)=>{
    'use no memo';
    const layoutStyles = {
        table: $97e73014970bcab3$var$useTableLayoutStyles(),
        flex: $97e73014970bcab3$var$useFlexLayoutStyles()
    };
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($97e73014970bcab3$export$ecabfa1fd8cfc61e, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
};



'use client';
const $a43c21910348d1c5$export$f850895b287ef28e = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $21b88dc000471395$export$9d04d359fb79e4d0)(props, ref);
    (0, $97e73014970bcab3$export$431076ffea51440d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableHeaderStyles_unstable')(state);
    return (0, $a13f3cfe0a234387$export$d1541071f0707ce5)(state);
});
$a43c21910348d1c5$export$f850895b287ef28e.displayName = 'TableHeader';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



function $a512b3ba371ced77$export$9c146637081c1506(element, win) {
    const keyborg = (0, $7fd4889093258001$export$9ccd7417191c0e4b)(win);
    // When navigation mode changes to mouse, remove the focus-within selector
    keyborg.subscribe((isNavigatingWithKeyboard)=>{
        if (!isNavigatingWithKeyboard) $a512b3ba371ced77$var$removeFocusWithinClass(element);
    });
    // Keyborg's focusin event is delegated so it's only registered once on the window
    // and contains metadata about the focus event
    const keyborgListener = (e)=>{
        if (keyborg.isNavigatingWithKeyboard() && $a512b3ba371ced77$var$isHTMLElement(e.target)) // Griffel can't create chained global styles so use the parent element for now
        $a512b3ba371ced77$var$applyFocusWithinClass(element);
    };
    // Make sure that when focus leaves the scope, the focus within class is removed
    const blurListener = (e)=>{
        if (!e.relatedTarget || $a512b3ba371ced77$var$isHTMLElement(e.relatedTarget) && !element.contains(e.relatedTarget)) $a512b3ba371ced77$var$removeFocusWithinClass(element);
    };
    element.addEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), keyborgListener);
    element.addEventListener('focusout', blurListener);
    // Return disposer
    return ()=>{
        element.removeEventListener((0, $7fd4889093258001$export$5644ea5c8a31b6ce), keyborgListener);
        element.removeEventListener('focusout', blurListener);
        (0, $7fd4889093258001$export$6c71cf8529293a97)(keyborg);
    };
}
function $a512b3ba371ced77$var$applyFocusWithinClass(el) {
    el.setAttribute((0, $adb94d615d1e4f94$export$922950948586e05d), '');
}
function $a512b3ba371ced77$var$removeFocusWithinClass(el) {
    el.removeAttribute((0, $adb94d615d1e4f94$export$922950948586e05d));
}
function $a512b3ba371ced77$var$isHTMLElement(target) {
    if (!target) return false;
    return Boolean(target && typeof target === 'object' && 'classList' in target && 'contains' in target);
}


'use client';
function $4f816f386fc6883e$export$420e68273165f4ec() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const elementRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if ((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) && elementRef.current) return (0, $a512b3ba371ced77$export$9c146637081c1506)(elementRef.current, targetDocument.defaultView);
    }, [
        elementRef,
        targetDocument
    ]);
    return elementRef;
}




'use client';
const $0525c5816e797ed3$export$2d6ce122abd61a5f = (props, ref)=>{
    const { noNativeElements: noNativeElements, size: size } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'tr';
    const focusVisibleRef = (0, $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6)();
    const focusWithinRef = (0, $4f816f386fc6883e$export$420e68273165f4ec)();
    const isHeaderRow = (0, $b32b2b077c08c135$export$e9d05040fc93d3a3)();
    var _props_appearance;
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, focusVisibleRef, focusWithinRef),
            role: rootComponent === 'div' ? 'row' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        size: size,
        noNativeElements: noNativeElements,
        appearance: (_props_appearance = props.appearance) !== null && _props_appearance !== void 0 ? _props_appearance : 'none',
        isHeaderRow: isHeaderRow
    };
};




const $299cbfe3a9336f33$export$b3ca4727b08e080c = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};







'use client';
const $05695486cd30430c$export$97637e2826dd4389 = 'fui-TableRow';
const $05695486cd30430c$export$94acc091767159fc = {
    root: $05695486cd30430c$export$97637e2826dd4389
};
const $05695486cd30430c$var$useTableLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1u0rzck"
    }
}, {
    d: [
        ".f1u0rzck{display:table-row;}"
    ]
});
const $05695486cd30430c$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}"
    ]
});
/**
 * Styles for the root slot
 */ const $05695486cd30430c$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f19n0e5",
        B7ck84d: "f1ewtqcl",
        Bconypa: "f1jazu75",
        B6guboy: "f1xeqee6",
        Bfpq7zp: 0,
        g9k6zt: 0,
        Bn4voq9: 0,
        giviqs: "f1dxfoyt",
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f2krc9w"
    },
    rootInteractive: {
        B6guboy: "f1xeqee6",
        ecr2s2: "f1wfn5kd",
        lj723h: "f1g4hkjv",
        B43xm9u: "f15ngxrw",
        i921ia: "fjbbrdp",
        Jwef8y: "f1t94bn6",
        Bi91k9c: "feu1g3u",
        Bpt6rm4: "f1uorfem",
        ff6mpl: "fw60kww",
        Bahaeuw: "f1v3eptx",
        F230oe: "f8gmj8i",
        Bdw8ktp: [
            "f1ap8nzx",
            "fjag8bx"
        ],
        Bj1xduy: "f1igan7k",
        Bhh2cfd: [
            "fjag8bx",
            "f1ap8nzx"
        ]
    },
    medium: {
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f1facbz3"
    },
    small: {
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        Bgfg5da: "f1facbz3"
    },
    "extra-small": {
        Be2twd7: "fy9rknc"
    },
    brand: {
        De3pzq: "f16xkysk",
        g2u3we: "f1bh3yvw",
        h3c5rm: [
            "fmi79ni",
            "f11fozsx"
        ],
        B9xav0g: "fnzw4c6",
        zhjwy3: [
            "f11fozsx",
            "fmi79ni"
        ],
        ecr2s2: "f7tkmfy",
        lj723h: "f1r2dosr",
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1msmgpi",
        Bmclvqj: 0,
        psczho: 0,
        B0tx59b: 0,
        sk7i8k: 0,
        zlwzm7: "fbo0xvd",
        Bkp2nk: "fjuvmhu",
        gy0h4g: "f1kvufhq"
    },
    neutral: {
        wmvzou: 0,
        sc4o1m: 0,
        wymq9i: 0,
        u9orzk: 0,
        puiv5t: 0,
        Bosien3: 0,
        b2z72d: 0,
        Beulxaw: 0,
        B57pkaw: 0,
        Jcjdmf: 0,
        B8qgbzl: 0,
        Bbmb0sr: 0,
        B14q8qp: 0,
        Bcq6wej: 0,
        Byz1pjr: 0,
        kr9cjb: 0,
        Ff9ifp: "f1msmgpi",
        Bmclvqj: 0,
        psczho: 0,
        B0tx59b: 0,
        sk7i8k: 0,
        zlwzm7: "fbo0xvd",
        Bkp2nk: "fjuvmhu",
        gy0h4g: "f1kvufhq",
        De3pzq: "fq5gl1p",
        sj55zd: "f1cgsbmv",
        ecr2s2: "fa9o754",
        g2u3we: "frmsihh",
        h3c5rm: [
            "frttxa5",
            "f11o2r7f"
        ],
        B9xav0g: "fem5et0",
        zhjwy3: [
            "f11o2r7f",
            "frttxa5"
        ]
    },
    none: {}
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1jazu75[data-fui-focus-within]:focus-within .fui-TableSelectionCell{opacity:1;}",
        ".f1xeqee6[data-fui-focus-within]:focus-within .fui-TableCellActions{opacity:1;}",
        [
            ".f1dxfoyt[data-fui-focus-visible]{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f2krc9w[data-fui-focus-visible]{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f1facbz3{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStroke2);}",
            {
                p: -1
            }
        ],
        [
            ".f1facbz3{border-bottom:var(--strokeWidthThin) solid var(--colorNeutralStroke2);}",
            {
                p: -1
            }
        ],
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        ".f1bh3yvw{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".fmi79ni{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".f11fozsx{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".fnzw4c6{border-bottom-color:var(--colorTransparentStrokeInteractive);}",
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1cgsbmv{color:var(--colorNeutralForeground1Hover);}",
        ".frmsihh{border-top-color:var(--colorNeutralStrokeOnBrand);}",
        ".frttxa5{border-right-color:var(--colorNeutralStrokeOnBrand);}",
        ".f11o2r7f{border-left-color:var(--colorNeutralStrokeOnBrand);}",
        ".fem5et0{border-bottom-color:var(--colorNeutralStrokeOnBrand);}"
    ],
    a: [
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f15ngxrw:active .fui-TableCellActions{opacity:1;}",
        ".fjbbrdp:active .fui-TableSelectionCell{opacity:1;}",
        ".f7tkmfy:active{background-color:var(--colorBrandBackground2);}",
        ".f1r2dosr:active{color:var(--colorNeutralForeground1);}",
        ".fa9o754:active{background-color:var(--colorSubtleBackgroundSelected);}"
    ],
    h: [
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1uorfem:hover .fui-TableCellActions{opacity:1;}",
        ".fw60kww:hover .fui-TableSelectionCell{opacity:1;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1v3eptx:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f8gmj8i:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ap8nzx:hover{border-right-color:Highlight;}.fjag8bx:hover{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1igan7k:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1msmgpi{border:2px solid transparent;}}",
            {
                p: -2,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbo0xvd{border-radius:var(--borderRadiusMedium);}}",
            {
                p: -1,
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fjuvmhu{box-sizing:border-box;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1kvufhq:focus-visible{outline-offset:-4px;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $05695486cd30430c$export$3e437c052026a79e = (state)=>{
    'use no memo';
    const styles = $05695486cd30430c$var$useStyles();
    const layoutStyles = {
        table: $05695486cd30430c$var$useTableLayoutStyles(),
        flex: $05695486cd30430c$var$useFlexLayoutStyles()
    };
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($05695486cd30430c$export$94acc091767159fc.root, styles.root, !state.isHeaderRow && styles.rootInteractive, styles[state.size], state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, styles[state.appearance], state.root.className);
    return state;
};



'use client';
const $4f29ac2e18a97c20$export$b05581f4e764e162 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $0525c5816e797ed3$export$2d6ce122abd61a5f)(props, ref);
    (0, $05695486cd30430c$export$3e437c052026a79e)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableRowStyles_unstable')(state);
    return (0, $299cbfe3a9336f33$export$b3ca4727b08e080c)(state);
});
$4f29ac2e18a97c20$export$b05581f4e764e162.displayName = 'TableRow';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




const $2c238c51189631dd$export$28e6b9b82ee883c = (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1w7gpdv",
        Bg96gwp: "fez10in"
    },
    rtl: {
        Bz10aip: "f13rod7r"
    }
}, {
    d: [
        ".f1w7gpdv{display:inline;}",
        ".fez10in{line-height:0;}",
        ".f13rod7r{transform:scaleX(-1);}"
    ]
});


const $46caa65ac410bb30$export$8546d02a2c1ddd5 = (props, options)=>{
    const { filled: // remove unwanted props to be set on the svg/html element
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filled, title: title, primaryFill: primaryFill = 'currentColor', ...rest } = props;
    const state = {
        ...rest,
        fill: primaryFill
    };
    const styles = (0, $2c238c51189631dd$export$28e6b9b82ee883c)();
    const iconContext = (0, $29e9ce9867929ff7$export$6bed2dfdd7bea160)();
    state.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(styles.root, (options === null || options === void 0 ? void 0 : options.flipInRtl) && (iconContext === null || iconContext === void 0 ? void 0 : iconContext.textDirection) === 'rtl' && styles.rtl, state.className);
    if (title) state['aria-label'] = title;
    if (!state['aria-label'] && !state['aria-labelledby']) state['aria-hidden'] = true;
    else state['role'] = 'img';
    return state;
};



const $8329439bd3b4436f$export$eb68ef9436d8b207 = (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        B8gzw0y: "f1dd5bof"
    }
}, {
    m: [
        [
            "@media (forced-colors: active){.f1dd5bof{forced-color-adjust:auto;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});


const $3ca67d612ed7abba$export$538bd0cdf03fed48 = 'fui-Icon';
const $3ca67d612ed7abba$export$cc86ffec8c6eb24e = 'fui-Icon-filled';
const $3ca67d612ed7abba$export$f8a5601dfd94d0c1 = 'fui-Icon-regular';
const $3ca67d612ed7abba$export$600d83c6d1ab213f = 'fui-Icon-light';
const $3ca67d612ed7abba$export$ff76996064ccabf9 = 'fui-Icon-color';
const $3ca67d612ed7abba$export$8a40db2be112c945 = 'fui-Icon-font';


const $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87 = (displayName, width, pathsOrSvg, options)=>{
    const viewBoxWidth = width === '1em' ? '20' : width;
    const Icon = $acw62.forwardRef((props, ref)=>{
        const styles = (0, $8329439bd3b4436f$export$eb68ef9436d8b207)();
        const iconState = (0, $46caa65ac410bb30$export$8546d02a2c1ddd5)(props, {
            flipInRtl: options === null || options === void 0 ? void 0 : options.flipInRtl
        }); // HTML attributes/props for things like accessibility can be passed in, and will be expanded on the svg object at the start of the object
        const state = {
            ...iconState,
            className: (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)((0, $3ca67d612ed7abba$export$538bd0cdf03fed48), iconState.className, styles.root),
            ref: ref,
            width: width,
            height: width,
            viewBox: `0 0 ${viewBoxWidth} ${viewBoxWidth}`,
            xmlns: 'http://www.w3.org/2000/svg'
        };
        if (typeof pathsOrSvg === 'string') // Color icon: render raw SVG children
        return $acw62.createElement('svg', {
            ...state,
            dangerouslySetInnerHTML: {
                __html: pathsOrSvg
            }
        });
        else // Non-color icon: render paths as before
        return $acw62.createElement('svg', state, ...pathsOrSvg.map((d)=>$acw62.createElement('path', {
                d: d,
                fill: state.fill
            })));
    });
    Icon.displayName = displayName;
    return Icon;
};


"use client";
const $4125b41377e9d21d$export$81f1ab08b795f6b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitContentFilled', "1em", [
    "M5.35 3.65c.2.2.2.5 0 .7L4.71 5H7.5a.5.5 0 0 1 0 1H4.7l.65.65a.5.5 0 1 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5c.2-.2.5-.2.7 0ZM5.5 9A2.5 2.5 0 0 0 3 11.5v3A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 14.5 9h-9Zm.5 3.5h8a.5.5 0 0 1 0 1H6a.5.5 0 0 1 0-1Zm8.65-8.15a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H12.5a.5.5 0 0 1 0-1h2.8l-.65-.65Z"
]);
const $4125b41377e9d21d$export$562f0c444450654c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitContentRegular', "1em", [
    "M5.35 3.65c.2.2.2.5 0 .7L4.71 5H7.5a.5.5 0 0 1 0 1H4.7l.65.65a.5.5 0 1 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5c.2-.2.5-.2.7 0ZM5.5 9A2.5 2.5 0 0 0 3 11.5v3A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 14.5 9h-9ZM4 11.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-3Zm2 1a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H6Zm8.65-8.15a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H12.5a.5.5 0 0 1 0-1h2.8l-.65-.65Z"
]);
const $4125b41377e9d21d$export$da538470c4a217ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitDownFilled', "1em", [
    "m15.71 14.77-.7.73V2.75a.75.75 0 1 0-1.5 0v12.76l-.72-.74a.75.75 0 0 0-1.08 1.04l1.82 1.88a1 1 0 0 0 1.44 0l1.82-1.88a.75.75 0 0 0-1.08-1.04ZM5 17a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h6.25a.75.75 0 0 1 0 1.5H5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h4.25a.75.75 0 0 1 0 1.5H5Z"
]);
const $4125b41377e9d21d$export$9b0a5d8813adfeca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitDownRegular', "1em", [
    "M16.14 15.2 15 16.36V2.5a.5.5 0 1 0-1 0v13.87l-1.14-1.18a.5.5 0 1 0-.72.7l1.82 1.88c.3.3.79.3 1.08 0l1.82-1.88a.5.5 0 1 0-.72-.7ZM5 17a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h6.5a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.5a.5.5 0 1 1 0 1H5Z"
]);
const $4125b41377e9d21d$export$d528e932c63ee6fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightFilled', "1em", [
    "m15 4.5.71.73A.75.75 0 0 0 16.8 4.2l-1.82-1.88a1 1 0 0 0-1.44 0l-1.82 1.88a.75.75 0 0 0 1.08 1.04l.71-.74v2.76a.75.75 0 0 0 1.5 0V4.5ZM3 5c0-1.1.9-2 2-2h4.25a.75.75 0 0 1 0 1.5H5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h4.25a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2V5Zm12.71 9.77-.7.73v-2.75a.75.75 0 1 0-1.5 0v2.76l-.72-.74a.75.75 0 0 0-1.08 1.04l1.82 1.88a1 1 0 0 0 1.44 0l1.82-1.88a.75.75 0 0 0-1.08-1.04Z"
]);
const $4125b41377e9d21d$export$fc9e9f312f7da94c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightRegular', "1em", [
    "m15 3.63 1.14 1.18a.5.5 0 1 0 .72-.7l-1.82-1.88a.75.75 0 0 0-1.08 0L12.14 4.1a.5.5 0 1 0 .72.7L14 3.63V7.5a.5.5 0 0 0 1 0V3.63ZM3 5c0-1.1.9-2 2-2h4.5a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-2-2V5Zm13.14 10.2L15 16.36V12.5a.5.5 0 1 0-1 0v3.87l-1.14-1.18a.5.5 0 1 0-.72.7l1.82 1.88c.3.3.79.3 1.08 0l1.82-1.88a.5.5 0 1 0-.72-.7Z"
]);
const $4125b41377e9d21d$export$49284021115565a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightDottedFilled', "1em", [
    "m15.71 5.23-1.46-1.51-1.46 1.51a.75.75 0 0 1-1.08-1.04l1.82-1.88a1 1 0 0 1 1.44 0l1.82 1.88a.75.75 0 0 1-1.08 1.04Zm0 9.54-1.46 1.51-1.46-1.51a.75.75 0 0 0-1.08 1.04l1.82 1.88a1 1 0 0 0 1.44 0l1.82-1.88a.75.75 0 0 0-1.08-1.04ZM14.25 12c.42 0 .75.34.75.75v.5a.75.75 0 1 1-1.5 0v-.5c0-.41.34-.75.75-.75Zm.75-1.75a.75.75 0 1 1-1.5 0v-.5a.75.75 0 0 1 1.5 0v.5ZM14.25 8c.42 0 .75-.34.75-.75v-.5a.75.75 0 1 0-1.5 0v.5c0 .41.34.75.75.75ZM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4.25a.75.75 0 0 0 0-1.5H5a.5.5 0 0 1-.5-.5V5c0-.28.22-.5.5-.5h4.25a.75.75 0 0 0 0-1.5H5Z"
]);
const $4125b41377e9d21d$export$5cbc4d338c3d93fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightDottedRegular', "1em", [
    "M16.14 4.8 14.5 3.12l-1.64 1.7a.5.5 0 0 1-.72-.7l1.82-1.88c.3-.3.79-.3 1.08 0l1.82 1.88a.5.5 0 1 1-.72.7ZM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4.5a.5.5 0 0 0 0-1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4.5a.5.5 0 0 0 0-1H5Zm9.5 2c.28 0 .5.22.5.5V7a.5.5 0 1 1-1 0V5.5c0-.28.23-.5.5-.5Zm.5 8a.5.5 0 1 0-1 0v1.5a.5.5 0 0 0 1 0V13Zm-.5-4c.28 0 .5.22.5.5v1a.5.5 0 1 1-1 0v-1c0-.28.23-.5.5-.5Zm1.64 6.2-1.64 1.69-1.64-1.7a.5.5 0 1 0-.72.7l1.82 1.88c.3.3.79.3 1.08 0l1.82-1.88a.5.5 0 1 0-.72-.7Z"
]);
const $4125b41377e9d21d$export$9323341c434e7653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightInFilled', "1em", [
    "m14.78 7.78 2-2a.75.75 0 0 0-1.06-1.06l-.72.72V2.75a.75.75 0 0 0-1.5 0v2.69l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0ZM3 5c0-1.1.9-2 2-2h4.25a.75.75 0 0 1 0 1.5H5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h4.25a.75.75 0 0 1 0 1.5H5a2 2 0 0 1-2-2V5Zm13.78 9.22-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v2.69a.75.75 0 0 0 1.5 0v-2.69l.72.72a.75.75 0 1 0 1.06-1.06Z"
]);
const $4125b41377e9d21d$export$271f2e60c2fd072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitHeightInRegular', "1em", [
    "m14.85 7.85 2-2a.5.5 0 0 0-.7-.7L15 6.29V2.5a.5.5 0 0 0-1 0v3.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0ZM3 5c0-1.1.9-2 2-2h4.5a.5.5 0 0 1 0 1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h4.5a.5.5 0 0 1 0 1H5a2 2 0 0 1-2-2V5Zm13.85 9.15-2-2a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.7L14 13.71v3.79a.5.5 0 0 0 1 0v-3.8l1.15 1.15a.5.5 0 0 0 .7-.7Z"
]);
const $4125b41377e9d21d$export$9bf9ed08b9b02d7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitUpFilled', "1em", [
    "m15.71 5.23-.7-.73v12.75a.75.75 0 1 1-1.5 0V4.49l-.72.74a.75.75 0 0 1-1.08-1.04l1.82-1.88a1 1 0 0 1 1.44 0l1.82 1.88a.75.75 0 0 1-1.08 1.04ZM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6.25a.75.75 0 0 0 0-1.5H5a.5.5 0 0 1-.5-.5V5c0-.28.22-.5.5-.5h4.25a.75.75 0 0 0 0-1.5H5Z"
]);
const $4125b41377e9d21d$export$dd484eb136093469 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitUpRegular', "1em", [
    "M16.14 4.8 15 3.64V17.5a.5.5 0 1 1-1 0V3.63L12.86 4.8a.5.5 0 0 1-.72-.7l1.82-1.88c.3-.3.79-.3 1.08 0l1.82 1.88a.5.5 0 1 1-.72.7ZM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6.5a.5.5 0 0 0 0-1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4.5a.5.5 0 0 0 0-1H5Z"
]);
const $4125b41377e9d21d$export$4c7d2602b11ab8f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthFilled', "1em", [
    "m15.5 15-.73.71a.75.75 0 1 0 1.04 1.08l1.89-1.82a1 1 0 0 0 0-1.44l-1.89-1.82a.75.75 0 0 0-1.04 1.08l.74.71h-2.76a.75.75 0 0 0 0 1.5h2.75ZM15 3a2 2 0 0 1 2 2v4.25a.75.75 0 0 1-1.5 0V5a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v4.25a.75.75 0 0 1-1.5 0V5c0-1.1.9-2 2-2h10ZM5.23 15.71l-.73-.7h2.75a.75.75 0 1 0 0-1.5H4.5l.73-.72a.75.75 0 0 0-1.04-1.08l-1.88 1.82a1 1 0 0 0 0 1.44l1.88 1.82a.75.75 0 0 0 1.04-1.08Z"
]);
const $4125b41377e9d21d$export$c768ea48f6bb30b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthRegular', "1em", [
    "m16.37 15-1.18 1.14a.5.5 0 1 0 .7.72l1.88-1.82c.3-.3.3-.78 0-1.08l-1.88-1.82a.5.5 0 1 0-.7.72L16.38 14H12.5a.5.5 0 1 0 0 1h3.87ZM15 3a2 2 0 0 1 2 2v4.5a.5.5 0 0 1-1 0V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4.5a.5.5 0 0 1-1 0V5c0-1.1.9-2 2-2h10ZM4.81 16.14 3.63 15H7.5a.5.5 0 1 0 0-1H3.63l1.18-1.14a.5.5 0 0 0-.7-.72l-1.88 1.82c-.3.3-.3.79 0 1.08l1.89 1.82a.5.5 0 1 0 .69-.72Z"
]);
const $4125b41377e9d21d$export$990164d257816228 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthDottedFilled', "1em", [
    "m14.77 15.71 1.51-1.46-1.51-1.46a.75.75 0 1 1 1.04-1.08l1.89 1.82a1 1 0 0 1 0 1.44l-1.89 1.82a.75.75 0 0 1-1.04-1.08Zm-9.54 0-1.5-1.46 1.5-1.46a.75.75 0 0 0-1.04-1.08l-1.88 1.82a1 1 0 0 0 0 1.44l1.88 1.82a.75.75 0 0 0 1.04-1.08ZM8 14.25c0 .42-.33.75-.75.75h-.5a.75.75 0 1 1 0-1.5h.5c.42 0 .75.34.75.75Zm1.75.75a.75.75 0 1 1 0-1.5h.5a.75.75 0 0 1 0 1.5h-.5Zm2.25-.75c0 .42.34.75.75.75h.5a.75.75 0 1 0 0-1.5h-.5a.75.75 0 0 0-.75.75ZM17 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4.25a.75.75 0 0 0 1.5 0V5c0-.28.22-.5.5-.5h10c.28 0 .5.22.5.5v4.25a.75.75 0 1 0 1.5 0V5Z"
]);
const $4125b41377e9d21d$export$fa826e4afc52cab9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowAutofitWidthDottedRegular', "1em", [
    "m15.2 16.14 1.7-1.64-1.7-1.64a.5.5 0 0 1 .69-.72l1.88 1.82c.3.3.3.79 0 1.08l-1.88 1.82a.5.5 0 1 1-.7-.72ZM17 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4.5a.5.5 0 0 0 1 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4.5a.5.5 0 1 0 1 0V5Zm-2 9.5a.5.5 0 0 1-.5.5H13a.5.5 0 1 1 0-1h1.5c.28 0 .5.23.5.5ZM7 15a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0 0 1H7Zm4-.5a.5.5 0 0 1-.5.5h-1a.5.5 0 1 1 0-1h1c.28 0 .5.23.5.5Zm-6.19 1.64-1.7-1.64 1.7-1.64a.5.5 0 0 0-.7-.72l-1.88 1.82c-.3.3-.3.79 0 1.08l1.89 1.82a.5.5 0 1 0 .69-.72Z"
]);
const $4125b41377e9d21d$export$e9d8dd8ccbafe719 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenDownFilled', "1em", [
    "M5 1.75a.75.75 0 0 0-1.5 0v.5C3.5 3.22 4.28 4 5.25 4h9C15.22 4 16 3.22 16 2.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .14-.11.25-.25.25h-9A.25.25 0 0 1 5 2.25v-.5ZM9.75 5c.41 0 .75.34.75.75v6.69l2.97-2.97a.75.75 0 1 1 1.06 1.06l-4.25 4.25c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 1 1 1.06-1.06L9 12.44V5.75c0-.41.34-.75.75-.75ZM3.5 17.75c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 0 1-1.5 0v-.5a.25.25 0 0 0-.25-.25h-9a.25.25 0 0 0-.25.25v.5a.75.75 0 0 1-1.5 0v-.5Z"
]);
const $4125b41377e9d21d$export$3c260a31c2f92d54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenDownRegular', "1em", [
    "M4 2a.5.5 0 0 0-1 0v.5C3 3.33 3.67 4 4.5 4h10c.83 0 1.5-.67 1.5-1.5V2a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V2Zm5.5 3c.28 0 .5.22.5.5v7.8l3.65-3.65a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 .7-.7L9 13.29V5.5c0-.28.22-.5.5-.5ZM3 17.5c0-.83.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 1-1 0v-.5Z"
]);
const $4125b41377e9d21d$export$c6d71ca70f6a72c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenUpFilled', "1em", [
    "M5 18.25a.75.75 0 0 1-1.5 0v-.5c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 0 1-1.5 0v-.5a.25.25 0 0 0-.25-.25h-9a.25.25 0 0 0-.25.25v.5ZM9.75 15c.41 0 .75-.34.75-.75V7.56l2.97 2.97a.75.75 0 1 0 1.06-1.06l-4.25-4.25a.75.75 0 0 0-1.06 0L4.97 9.47a.75.75 0 1 0 1.06 1.06L9 7.56v6.69c0 .41.34.75.75.75ZM3.5 2.25C3.5 3.22 4.28 4 5.25 4h9C15.22 4 16 3.22 16 2.25v-.5a.75.75 0 0 0-1.5 0v.5c0 .14-.11.25-.25.25h-9A.25.25 0 0 1 5 2.25v-.5a.75.75 0 0 0-1.5 0v.5Z"
]);
const $4125b41377e9d21d$export$36cada2ac198cf6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBetweenUpRegular', "1em", [
    "M4 18a.5.5 0 0 1-1 0v-.5c0-.83.67-1.5 1.5-1.5h10c.83 0 1.5.67 1.5 1.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v.5Zm5.5-3a.5.5 0 0 0 .5-.5V6.7l3.65 3.65a.5.5 0 0 0 .7-.7l-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 .7.7L9 6.71v7.79c0 .28.22.5.5.5ZM3 2.5C3 3.33 3.67 4 4.5 4h10c.83 0 1.5-.67 1.5-1.5V2a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V2a.5.5 0 0 0-1 0v.5Z"
]);
const $4125b41377e9d21d$export$d703aa9bd4d9285c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalLeftRightFilled', "1em", [
    "M7.78 5.72c.3.3.3.77 0 1.06L5.56 9h8.88l-2.22-2.22a.75.75 0 0 1 1.06-1.06l3.5 3.5c.3.3.3.77 0 1.06l-3.5 3.5a.75.75 0 1 1-1.06-1.06l2.22-2.22H5.56l2.22 2.22a.75.75 0 1 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 0-1.06l3.5-3.5c.3-.3.77-.3 1.06 0Z"
]);
const $4125b41377e9d21d$export$750e6f43637ff5b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalLeftRightRegular', "1em", [
    "M7.35 5.65c.2.2.2.5 0 .7L4.71 9h10.58l-2.64-2.65a.5.5 0 0 1 .7-.7l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7L15.29 10H4.71l2.64 2.65a.5.5 0 0 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5c.2-.2.5-.2.7 0Z"
]);
const $4125b41377e9d21d$export$2e20c88f68456396 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalUpDownFilled', "1em", [
    "M6.78 7.78a.75.75 0 0 1-1.06-1.06l3.5-3.5c.3-.3.77-.3 1.06 0l3.5 3.5a.75.75 0 0 1-1.06 1.06L10.5 5.56v8.88l2.22-2.22a.75.75 0 1 1 1.06 1.06l-3.5 3.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 1 1 1.06-1.06L9 14.44V5.56L6.78 7.78Z"
]);
const $4125b41377e9d21d$export$c47982668fe8aa64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBidirectionalUpDownRegular', "1em", [
    "M6.35 7.35a.5.5 0 1 1-.7-.7l3.5-3.5c.2-.2.5-.2.7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 4.71v10.58l2.65-2.64a.5.5 0 0 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 .7-.7L9 15.29V4.71L6.35 7.35Z"
]);
const $4125b41377e9d21d$export$e4563b275f6ff56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBounceFilled', "1em", [
    "M2.75 6a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0V8.56l6.47 6.47c.3.3.77.3 1.06 0l6.75-6.75a.75.75 0 0 0-1.06-1.06l-6.22 6.22L4.56 7.5h4.69a.75.75 0 0 0 0-1.5h-6.5Z"
]);
const $4125b41377e9d21d$export$619e65a8cfe9ea51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowBounceRegular', "1em", [
    "M2.5 6a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0V7.7l7.15 7.15c.2.2.5.2.7 0l7-7a.5.5 0 0 0-.7-.7l-6.65 6.64L3.7 7h5.8a.5.5 0 0 0 0-1h-7Z"
]);
const $4125b41377e9d21d$export$a932112762a5b169 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4.65.85a.5.5 0 0 0-.7-.7l-2.15 2.14V6.5a.5.5 0 0 0-1 0v5.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3Z"
]);
const $4125b41377e9d21d$export$bb58229b00acea55 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownRegular', "1em", [
    "m13.35 10.85-3 3a.5.5 0 0 1-.7 0l-3-3a.5.5 0 0 1 .7-.7l2.15 2.14V6.5a.5.5 0 0 1 1 0v5.8l2.15-2.15a.5.5 0 0 1 .7.7ZM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
]);
const $4125b41377e9d21d$export$daa3739d8c2be624 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownDoubleFilled', "1em", [
    "M7.35 13.85 9 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0ZM18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-4.65 3.85L15 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0Z"
]);
const $4125b41377e9d21d$export$9412ecbe4d6573ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownDoubleRegular', "1em", [
    "m9 12.2-1.65 1.65a.5.5 0 0 1-.7 0L5 12.21a.5.5 0 1 1 .7-.71l.8.8V6.5a.5.5 0 0 1 1 0v5.8l.8-.8a.5.5 0 1 1 .7.7Zm1 5.8a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-3.65 3.85L15 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0Z"
]);
const $4125b41377e9d21d$export$be5ae7ef64a01a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownRightFilled', "1em", [
    "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm2.85 10.86a.5.5 0 0 1-.35.14h-5a.5.5 0 0 1 0-1h3.8L7.14 7.85a.5.5 0 1 1 .7-.7L12 11.29V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.14.35Z"
]);
const $4125b41377e9d21d$export$1d8e506adf99680a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownRightRegular', "1em", [
    "M12.85 12.86a.5.5 0 0 1-.35.14h-5a.5.5 0 0 1 0-1h3.8L7.14 7.85a.5.5 0 1 1 .7-.7L12 11.29V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.14.35ZM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
]);
const $4125b41377e9d21d$export$8f694347b18269c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownSplitFilled', "1em", [
    "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-9.2 2.41a.5.5 0 1 0-.71-.7l-.59.58V9h5v3.3l-.59-.6a.5.5 0 0 0-.7.71l1.44 1.44c.2.2.5.2.7 0l1.44-1.44a.5.5 0 0 0-.7-.7l-.59.58V8.5A.5.5 0 0 0 13 8h-2.5V5.5a.5.5 0 0 0-1 0V8H7a.5.5 0 0 0-.5.5v3.8l-.59-.6a.5.5 0 0 0-.7.71l1.44 1.44c.2.2.5.2.7 0l1.44-1.44Z"
]);
const $4125b41377e9d21d$export$521e83b1fa451b76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownSplitRegular', "1em", [
    "m8.8 12.41-1.45 1.44a.5.5 0 0 1-.7 0L5.2 12.41a.5.5 0 0 1 .7-.7l.59.58V8.5c0-.28.22-.5.5-.5h2.5V5.5a.5.5 0 0 1 1 0V8H13c.28 0 .5.22.5.5v3.8l.59-.6a.5.5 0 0 1 .7.71l-1.44 1.44a.5.5 0 0 1-.7 0l-1.44-1.44a.5.5 0 0 1 .7-.7l.59.58V9h-5v3.3l.59-.6a.5.5 0 1 1 .7.71ZM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
]);
const $4125b41377e9d21d$export$26052ea08b2b4c21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownUpFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-5.8-1.65 1.65a.5.5 0 0 1-.7 0L5 12.21a.5.5 0 1 1 .7-.71l.8.8V6.5a.5.5 0 0 1 1 0v5.8l.8-.8a.5.5 0 1 1 .7.7Zm6-4.4a.5.5 0 0 1-.7.7l-.8-.8v5.8a.5.5 0 0 1-1 0V7.7l-.8.8a.5.5 0 1 1-.7-.7l1.65-1.65c.2-.2.5-.2.7 0L15 7.79Z"
]);
const $4125b41377e9d21d$export$22336a144360c270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleDownUpRegular', "1em", [
    "M7.35 13.85 9 12.21a.5.5 0 1 0-.7-.71l-.8.8V6.5a.5.5 0 0 0-1 0v5.8l-.8-.8a.5.5 0 1 0-.7.7l1.65 1.65c.2.2.5.2.7 0ZM15 7.8l-1.65-1.64a.5.5 0 0 0-.7 0L11 7.79a.5.5 0 1 0 .7.71l.8-.8v5.8a.5.5 0 1 0 1 0V7.7l.8.8a.5.5 0 1 0 .7-.7ZM18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
]);
const $4125b41377e9d21d$export$1aa4b48f1610416e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleLeftFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-.85-4.65a.5.5 0 0 0 .7-.7L7.71 10.5h5.79a.5.5 0 0 0 0-1H7.7l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0 0 .7l3 3Z"
]);
const $4125b41377e9d21d$export$918eaebc11f90d3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleLeftRegular', "1em", [
    "m9.15 13.35-3-3a.5.5 0 0 1 0-.7l3-3a.5.5 0 1 1 .7.7L7.71 9.5h5.79a.5.5 0 0 1 0 1H7.7l2.15 2.15a.5.5 0 0 1-.7.7ZM2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm8 7a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
]);
const $4125b41377e9d21d$export$dbb7528fff39860d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleRightFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.85-4.65a.5.5 0 0 1-.7-.7l2.14-2.15H6.5a.5.5 0 0 1 0-1h5.8l-2.15-2.15a.5.5 0 0 1 .7-.7l3 3c.2.2.2.5 0 .7l-3 3Z"
]);
const $4125b41377e9d21d$export$cece181a3846acba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleRightRegular', "1em", [
    "m10.85 13.35 3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 0 0-.7.7l2.14 2.15H6.5a.5.5 0 0 0 0 1h5.8l-2.15 2.15a.5.5 0 0 0 .7.7ZM18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
]);
const $4125b41377e9d21d$export$4566eee4af93d514 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpFilled', "1em", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm4.65-.85a.5.5 0 1 0 .7.7L9.5 7.71v5.79a.5.5 0 0 0 1 0V7.7l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3a.5.5 0 0 0-.7 0l-3 3Z"
]);
const $4125b41377e9d21d$export$e11cc8232e1f29c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpRegular', "1em", [
    "m6.65 9.15 3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-1 0V7.7L7.35 9.86a.5.5 0 0 1-.7-.7ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
]);
const $4125b41377e9d21d$export$ed20c52033d4d170 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpLeftFilled', "1em", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM7.15 7.14A.5.5 0 0 1 7.5 7h5a.5.5 0 0 1 0 1H8.7l4.15 4.15a.5.5 0 0 1-.7.7L8 8.71v3.79a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .14-.35Z"
]);
const $4125b41377e9d21d$export$52bce8519c334ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpLeftRegular', "1em", [
    "M7.15 7.14A.5.5 0 0 1 7.5 7h5a.5.5 0 0 1 0 1H8.7l4.15 4.15a.5.5 0 0 1-.7.7L8 8.71v3.79a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .14-.35ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
]);
const $4125b41377e9d21d$export$9ef3d98ee597c56f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpRightFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm2.85-10.86A.5.5 0 0 0 12.5 7h-5a.5.5 0 0 0 0 1h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L12 8.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.14-.35Z"
]);
const $4125b41377e9d21d$export$834bff389cdcc290 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpRightRegular', "1em", [
    "M12.85 7.14A.5.5 0 0 0 12.5 7h-5a.5.5 0 0 0 0 1h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L12 8.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.14-.35ZM10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm7 8a7 7 0 1 0-14 0 7 7 0 0 0 14 0Z"
]);
const $4125b41377e9d21d$export$98f240455e015698 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.27 0-.52-.08-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a.52.52 0 0 0-.14-.22.64.64 0 0 0-.22-.14l-.77-.25c-.27-.1-.49-.26-.65-.48a1.3 1.3 0 0 1-.12-1.3 1.32 1.32 0 0 1-.45-.22 1.51 1.51 0 0 1-.52-.69l-.36-1.09a1.27 1.27 0 0 0-.29-.47 1.3 1.3 0 0 0-.47-.3l-1.06-.34A1.41 1.41 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9l-.26.02ZM6.65 9.15l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-1 0V7.7L7.35 9.86a.5.5 0 0 1-.7-.7Z"
]);
const $4125b41377e9d21d$export$baaacfb3a9294f25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCircleUpSparkleRegular', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.26 0-.51-.08-.73-.22A7 7 0 1 1 10.1 3a1.42 1.42 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9l-.26.02ZM6.65 9.15l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-1 0V7.7L7.35 9.86a.5.5 0 0 1-.7-.7Z"
]);
const $4125b41377e9d21d$export$49df0a05c9149d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseFilled', "1em", [
    "M4 10a6 6 0 0 1 9.97-4.5h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3a.75.75 0 0 0-1.5 0v1.16a7.5 7.5 0 1 0 2.5 5.31.75.75 0 0 0-1.5.06V10a6 6 0 0 1-12 0Z"
]);
const $4125b41377e9d21d$export$5e244be41a28c44c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseRegular', "1em", [
    "M4 10a6 6 0 0 1 10.47-4H12.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.6a7 7 0 1 0 1.98 4.36.5.5 0 1 0-1 .08L16 10a6 6 0 0 1-12 0Z"
]);
const $4125b41377e9d21d$export$8e37c3e6b3eea9e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesColor', "1em", `<path d="M10 2c-.42 0-.84.03-1.25.1a1 1 0 0 0 .31 1.97 6.05 6.05 0 0 1 1.7-.02 1 1 0 1 0 .26-1.99A8.07 8.07 0 0 0 10 2Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__a)"/><path d="M10 2c-.42 0-.84.03-1.25.1a1 1 0 0 0 .31 1.97 6.05 6.05 0 0 1 1.7-.02 1 1 0 1 0 .26-1.99A8.07 8.07 0 0 0 10 2Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__b)"/><path d="M13.92 3.03a1 1 0 1 0-.98 1.74c.37.2.71.45 1.03.73H13a1 1 0 1 0 0 2h3.5a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v1.2c-.47-.46-1-.85-1.58-1.17Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__c)"/><path d="M13.92 3.03a1 1 0 1 0-.98 1.74c.37.2.71.45 1.03.73H13a1 1 0 1 0 0 2h3.5a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v1.2c-.47-.46-1-.85-1.58-1.17Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__d)"/><path d="M6.47 5.14A1 1 0 0 0 5.3 3.53c-.68.5-1.28 1.09-1.77 1.77a1 1 0 0 0 1.61 1.17c.38-.5.82-.95 1.33-1.33Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__e)"/><path d="M6.47 5.14A1 1 0 0 0 5.3 3.53c-.68.5-1.28 1.09-1.77 1.77a1 1 0 0 0 1.61 1.17c.38-.5.82-.95 1.33-1.33Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__f)"/><path d="M4.07 9.06a1 1 0 0 0-1.97-.31 8.05 8.05 0 0 0 0 2.5 1 1 0 0 0 1.97-.31 6.05 6.05 0 0 1 0-1.88Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__g)"/><path d="M4.07 9.06a1 1 0 0 0-1.97-.31 8.05 8.05 0 0 0 0 2.5 1 1 0 0 0 1.97-.31 6.05 6.05 0 0 1 0-1.88Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__h)"/><path d="M17.92 11.14a1 1 0 0 0-1.98-.28c-.04.28-.1.56-.18.83a1 1 0 0 0 1.92.57c.1-.36.18-.74.24-1.12Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__i)"/><path d="M17.92 11.14a1 1 0 0 0-1.98-.28c-.04.28-.1.56-.18.83a1 1 0 0 0 1.92.57c.1-.36.18-.74.24-1.12Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__j)"/><path d="M5.14 13.53a1 1 0 1 0-1.61 1.17c.5.68 1.09 1.28 1.77 1.77a1 1 0 0 0 1.17-1.61c-.5-.38-.95-.82-1.33-1.33Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__k)"/><path d="M5.14 13.53a1 1 0 1 0-1.61 1.17c.5.68 1.09 1.28 1.77 1.77a1 1 0 0 0 1.17-1.61c-.5-.38-.95-.82-1.33-1.33Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__l)"/><path d="M16.04 15.24a1 1 0 1 0-1.5-1.31c-.38.43-.82.8-1.3 1.12a1 1 0 0 0 1.08 1.68 8.04 8.04 0 0 0 1.72-1.49Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__m)"/><path d="M16.04 15.24a1 1 0 1 0-1.5-1.31c-.38.43-.82.8-1.3 1.12a1 1 0 0 0 1.08 1.68 8.04 8.04 0 0 0 1.72-1.49Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__n)"/><path d="M9.06 15.93a1 1 0 0 0-.31 1.97 8.06 8.06 0 0 0 2.39.02 1 1 0 0 0-.28-1.98 6.06 6.06 0 0 1-1.8-.01Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__o)"/><path d="M9.06 15.93a1 1 0 0 0-.31 1.97 8.06 8.06 0 0 0 2.39.02 1 1 0 0 0-.28-1.98 6.06 6.06 0 0 1-1.8-.01Z" fill="url(#ic_fluent_arrow_clockwise_dashes_20_color__p)"/><defs><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__a" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__b" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__c" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__d" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__e" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__f" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__g" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__h" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__i" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__j" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__k" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__l" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__m" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__n" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__o" x1="4.25" y1="2" x2="18" y2="23" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_20_color__p" x1="9.96" y1=".1" x2="13.57" y2="27.14" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$9300e9d76420e6ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesFilled', "1em", [
    "M16.5 3.25a.75.75 0 0 0-1.5 0v1.16a7.48 7.48 0 0 0-3.42-1.74c-.44-.1-.83.26-.83.7 0 .39.29.7.66.8.97.23 1.84.7 2.56 1.33h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3Zm-8.08-.58c.44-.1.83.26.83.7 0 .39-.29.7-.66.8-.61.14-1.2.39-1.72.7a.83.83 0 0 1-1.02-.08c-.32-.32-.3-.85.08-1.1a7.46 7.46 0 0 1 2.5-1.02Zm8.2 8.08c-.38 0-.7.29-.79.66-.14.61-.39 1.2-.7 1.72-.2.32-.19.75.09 1.02.31.32.84.3 1.08-.08.49-.75.84-1.6 1.03-2.5.1-.43-.26-.82-.7-.82Zm-5.2 5.08a.83.83 0 0 0-.67.8c0 .44.39.8.83.7.9-.19 1.74-.54 2.49-1.03.38-.24.4-.77.08-1.09a.83.83 0 0 0-1.02-.09c-.53.32-1.1.57-1.72.71Zm-4.55-.7a.83.83 0 0 0-1.02.08c-.32.32-.3.85.08 1.1.75.48 1.6.83 2.5 1.02.43.1.82-.26.82-.7 0-.39-.29-.7-.66-.8-.61-.14-1.2-.39-1.72-.7Zm-2.7-3.72a.83.83 0 0 0-.8-.66c-.44 0-.8.39-.7.83.2.9.55 1.74 1.03 2.49.24.38.77.4 1.09.08.27-.27.29-.7.09-1.02a5.96 5.96 0 0 1-.71-1.72Zm.71-4.54a.83.83 0 0 0-.1-1.02c-.31-.32-.84-.3-1.08.08a7.46 7.46 0 0 0-1.03 2.5c-.1.43.26.82.7.82.39 0 .7-.29.8-.66.15-.62.39-1.2.71-1.72Z"
]);
const $4125b41377e9d21d$export$84f7bfdc0afdfd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesRegular', "1em", [
    "M16 3.5a.5.5 0 0 0-1 0v1.6c-.98-1-2.26-1.7-3.7-1.98a.48.48 0 0 0-.55.48c0 .26.19.47.44.52A6 6 0 0 1 14.47 6H12.5a.5.5 0 0 0 0 1h3.02c.3-.01.5-.25.48-.51V3.5Zm-7.3-.38c.29-.05.55.18.55.48 0 .26-.19.47-.44.52-.77.15-1.5.46-2.13.88a.54.54 0 0 1-.67-.05.48.48 0 0 1 .05-.74 6.96 6.96 0 0 1 2.63-1.09Zm7.7 7.63a.54.54 0 0 0-.52.44c-.15.77-.46 1.5-.88 2.13-.14.21-.13.5.05.67.22.22.57.2.74-.05.53-.78.9-1.67 1.09-2.63a.48.48 0 0 0-.48-.56Zm-5.21 5.13a.54.54 0 0 0-.44.52c0 .3.26.53.56.48a6.96 6.96 0 0 0 2.63-1.1.47.47 0 0 0 .05-.73.54.54 0 0 0-.67-.05c-.64.42-1.36.73-2.13.88ZM6.69 15a.54.54 0 0 0-.68.05c-.22.22-.2.57.05.74.78.53 1.67.9 2.63 1.09.3.05.56-.18.56-.48a.54.54 0 0 0-.44-.52A5.97 5.97 0 0 1 6.68 15Zm-2.57-3.81a.54.54 0 0 0-.52-.44c-.3 0-.53.26-.48.56.18.96.56 1.85 1.1 2.63.16.25.51.27.73.05.18-.18.2-.46.05-.67a5.97 5.97 0 0 1-.88-2.13ZM5 6.69A.54.54 0 0 0 4.95 6a.48.48 0 0 0-.74.05 6.96 6.96 0 0 0-1.09 2.63c-.05.3.18.56.48.56.26 0 .47-.19.52-.44.15-.77.46-1.5.88-2.13Z"
]);
const $4125b41377e9d21d$export$199aa0f43303497a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesSettingsColor', "1em", `<path d="M8.75 2.1a8.05 8.05 0 0 1 2.27-.04 1 1 0 1 1-.25 1.99 6.06 6.06 0 0 0-1.71.02 1 1 0 1 1-.31-1.97Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__a)"/><path d="M8.75 2.1a8.05 8.05 0 0 1 2.27-.04 1 1 0 1 1-.25 1.99 6.06 6.06 0 0 0-1.71.02 1 1 0 1 1-.31-1.97Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__b)"/><path d="M12.56 3.4a1 1 0 0 1 1.36-.37c.58.32 1.1.71 1.58 1.16V3a1 1 0 1 1 2 0v3.5a1 1 0 0 1-1 1H13a1 1 0 1 1 0-2h.97a6.02 6.02 0 0 0-1.03-.73 1 1 0 0 1-.38-1.36Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__c)"/><path d="M12.56 3.4a1 1 0 0 1 1.36-.37c.58.32 1.1.71 1.58 1.16V3a1 1 0 1 1 2 0v3.5a1 1 0 0 1-1 1H13a1 1 0 1 1 0-2h.97a6.02 6.02 0 0 0-1.03-.73 1 1 0 0 1-.38-1.36Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__d)"/><path d="M6.47 5.14A1 1 0 0 0 5.3 3.53c-.68.5-1.28 1.09-1.77 1.77a1 1 0 0 0 1.61 1.17c.38-.5.82-.95 1.33-1.33Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__e)"/><path d="M6.47 5.14A1 1 0 0 0 5.3 3.53c-.68.5-1.28 1.09-1.77 1.77a1 1 0 0 0 1.61 1.17c.38-.5.82-.95 1.33-1.33Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__f)"/><path d="M3.24 7.92a1 1 0 0 1 .83 1.14 6.05 6.05 0 0 0 0 1.88 1 1 0 0 1-1.97.31 8.05 8.05 0 0 1 0-2.5 1 1 0 0 1 1.14-.83Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__g)"/><path d="M3.24 7.92a1 1 0 0 1 .83 1.14 6.05 6.05 0 0 0 0 1.88 1 1 0 0 1-1.97.31 8.05 8.05 0 0 1 0-2.5 1 1 0 0 1 1.14-.83Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__h)"/><path d="M3.75 13.3a1 1 0 0 1 1.4.23c.37.5.81.95 1.32 1.33a1 1 0 0 1-1.17 1.61 8.04 8.04 0 0 1-1.77-1.77 1 1 0 0 1 .22-1.4Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__i)"/><path d="M3.75 13.3a1 1 0 0 1 1.4.23c.37.5.81.95 1.32 1.33a1 1 0 0 1-1.17 1.61 8.04 8.04 0 0 1-1.77-1.77 1 1 0 0 1 .22-1.4Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__j)"/><path d="M7.92 16.76a1 1 0 0 1 1.14-.83c.26.04.52.06.8.07l.1.03.34.08c.56.13.9.7.73 1.26l-.12.42a1 1 0 0 0-.04.16 8.07 8.07 0 0 1-2.12-.05 1 1 0 0 1-.83-1.14Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__k)"/><path d="M7.92 16.76a1 1 0 0 1 1.14-.83c.26.04.52.06.8.07l.1.03.34.08c.56.13.9.7.73 1.26l-.12.42a1 1 0 0 0-.04.16 8.07 8.07 0 0 1-2.12-.05 1 1 0 0 1-.83-1.14Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__l)"/><path d="M10.64 13.92a2 2 0 0 0 1.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.71 4.71 0 0 1 0-1.01l.46-.12Zm4.86.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z" fill="url(#ic_fluent_arrow_clockwise_dashes_settings_20_color__m)"/><defs><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__a" x1="4.25" y1="2" x2="3.58" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__b" x1="9.96" y1=".1" x2="22.05" y2="22.58" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__c" x1="4.25" y1="2" x2="3.58" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__d" x1="9.96" y1=".1" x2="22.05" y2="22.58" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__e" x1="4.25" y1="2" x2="3.58" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__f" x1="9.96" y1=".1" x2="22.05" y2="22.58" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__g" x1="4.25" y1="2" x2="3.58" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__h" x1="9.96" y1=".1" x2="22.05" y2="22.58" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__i" x1="4.25" y1="2" x2="3.58" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__j" x1="9.96" y1=".1" x2="22.05" y2="22.58" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__k" x1="4.25" y1="2" x2="3.58" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset=".92" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__l" x1="9.96" y1=".1" x2="22.05" y2="22.58" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_arrow_clockwise_dashes_settings_20_color__m" x1="16.67" y1="18.29" x2="12.28" y2="10.74" gradientUnits="userSpaceOnUse"><stop stop-color="#70777D"/><stop offset="1" stop-color="#B9C0C7"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$3684efbc8bf94838 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesSettingsFilled', "1em", [
    "M16.5 3.25a.75.75 0 0 0-1.5 0v1.16a7.48 7.48 0 0 0-3.42-1.74c-.44-.1-.83.26-.83.7 0 .39.29.7.66.8.97.23 1.84.7 2.56 1.33h-1.22a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3Zm-8.08-.58c.44-.1.83.26.83.7 0 .39-.29.7-.66.8-.61.14-1.2.39-1.72.7a.83.83 0 0 1-1.02-.08c-.32-.32-.3-.85.08-1.1a7.46 7.46 0 0 1 2.5-1.02ZM6.87 15.12a.83.83 0 0 0-1.02.1c-.32.31-.3.84.08 1.08.75.49 1.6.84 2.5 1.03.43.1.82-.26.82-.7 0-.39-.29-.7-.66-.8-.61-.14-1.2-.39-1.72-.7Zm-2.7-3.71a.83.83 0 0 0-.8-.66c-.44 0-.8.39-.7.83.2.9.55 1.74 1.03 2.49.24.38.77.4 1.09.08.27-.27.29-.7.09-1.02a5.96 5.96 0 0 1-.71-1.72Zm.71-4.54a.83.83 0 0 0-.1-1.02c-.31-.32-.84-.3-1.08.08a7.46 7.46 0 0 0-1.03 2.5c-.1.43.26.82.7.82.39 0 .7-.29.8-.66.15-.62.39-1.2.71-1.72Zm7.19 4.57a2 2 0 0 1-1.43 2.48l-.46.12a4.7 4.7 0 0 0 0 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $4125b41377e9d21d$export$9345eef788730b1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowClockwiseDashesSettingsRegular', "1em", [
    "M16 3.5a.5.5 0 0 0-1 0v1.6c-.98-1-2.26-1.7-3.7-1.98a.48.48 0 0 0-.55.48c0 .26.19.47.44.52A6 6 0 0 1 14.47 6H12.5a.5.5 0 0 0 0 1h3c.3 0 .52-.25.5-.51V3.5Zm-7.3-.38c.29-.05.55.18.55.48 0 .26-.19.47-.44.52-.77.15-1.5.46-2.13.88a.54.54 0 0 1-.67-.05.48.48 0 0 1 .05-.74 6.96 6.96 0 0 1 2.63-1.09ZM6.67 15a.54.54 0 0 0-.67.05c-.22.22-.2.57.05.74.78.53 1.67.9 2.63 1.09.3.05.56-.18.56-.48a.54.54 0 0 0-.44-.52A5.97 5.97 0 0 1 6.68 15Zm-2.56-3.81a.54.54 0 0 0-.52-.44c-.3 0-.53.26-.48.56.18.96.56 1.85 1.1 2.63.16.25.51.27.73.05.18-.18.2-.46.05-.67a5.97 5.97 0 0 1-.88-2.13ZM5 6.69A.54.54 0 0 0 4.95 6a.48.48 0 0 0-.74.05 6.96 6.96 0 0 0-1.09 2.63c-.05.3.18.56.48.56.26 0 .47-.19.52-.44.15-.77.46-1.5.88-2.13Zm7.07 4.75a2 2 0 0 1-1.43 2.48l-.46.12a4.7 4.7 0 0 0 0 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $4125b41377e9d21d$export$b67625b859d915df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCollapseAllFilled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm8 3c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-3.72-.53a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06L5 9.56v5.69a.75.75 0 0 0 1.5 0V9.56l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9e8d0d9b7ba08ec2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCollapseAllRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm3.15 2.65c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L6 8.71v6.79a.5.5 0 0 1-1 0V8.7l-1.65 1.65a.5.5 0 0 1-.7-.7l2.5-2.5ZM17.5 8h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$c04cf751873330aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseFilled', "1em", [
    "M16 10a6 6 0 0 0-9.97-4.5h1.22a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v1.16a7.5 7.5 0 1 1-2.5 5.31.75.75 0 1 1 1.5.06V10a6 6 0 0 0 12 0Z"
]);
const $4125b41377e9d21d$export$f09074358c38ba97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseRegular', "1em", [
    "M16 10A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.6a7 7 0 1 1-1.98 4.36.5.5 0 0 1 1 .08L4 10a6 6 0 0 0 12 0Z"
]);
const $4125b41377e9d21d$export$6432bdd407f3f0d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseDashesFilled', "1em", [
    "M3.5 3.25a.75.75 0 1 1 1.5 0V4.4a7.48 7.48 0 0 1 3.42-1.73c.44-.1.83.26.83.7 0 .39-.29.7-.66.8-.97.23-1.84.7-2.56 1.33h1.22a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3Zm8.08-.58c-.44-.1-.83.26-.83.7 0 .39.29.7.66.8.61.14 1.2.39 1.72.7.32.2.75.19 1.02-.08.32-.32.3-.85-.08-1.1a7.46 7.46 0 0 0-2.5-1.02Zm-8.2 8.08c.38 0 .7.29.78.66.15.61.4 1.2.72 1.72.2.32.18.75-.1 1.02-.31.32-.84.3-1.08-.08a7.46 7.46 0 0 1-1.04-2.5c-.09-.43.26-.82.71-.82Zm5.2 5.08c.38.1.67.41.67.8 0 .44-.4.8-.83.7-.9-.19-1.74-.54-2.5-1.03-.37-.24-.4-.77-.07-1.09.27-.27.7-.29 1.02-.09.53.32 1.1.57 1.72.71Zm4.55-.7a.83.83 0 0 1 1.02.08c.32.32.3.85-.08 1.1-.75.48-1.6.83-2.5 1.02-.43.1-.82-.26-.82-.7 0-.39.29-.7.66-.8.61-.14 1.2-.39 1.72-.7Zm2.7-3.72c.1-.37.4-.66.8-.66.44 0 .8.39.7.83-.2.9-.55 1.74-1.03 2.49-.24.38-.77.4-1.09.08a.83.83 0 0 1-.1-1.02c.33-.53.57-1.1.72-1.72Zm-.71-4.54a.83.83 0 0 1 .1-1.02c.31-.32.84-.3 1.08.08.48.75.84 1.6 1.03 2.5.1.43-.26.82-.7.82a.83.83 0 0 1-.8-.66c-.15-.62-.39-1.2-.71-1.72Z"
]);
const $4125b41377e9d21d$export$f3276fb06fbcac76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseDashesRegular', "1em", [
    "M4 3.5a.5.5 0 0 1 1 0v1.6c.98-1 2.26-1.7 3.7-1.98.29-.05.55.18.55.48 0 .26-.19.47-.44.52A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1H4.48A.49.49 0 0 1 4 6.49V3.5Zm7.3-.38a.48.48 0 0 0-.55.48c0 .26.19.47.44.52.77.15 1.5.46 2.13.88.21.14.5.13.67-.05a.48.48 0 0 0-.05-.74 6.96 6.96 0 0 0-2.63-1.09Zm-7.7 7.63c.26 0 .47.19.52.44.15.77.46 1.5.88 2.13.14.21.13.5-.05.67a.48.48 0 0 1-.74-.05 6.96 6.96 0 0 1-1.09-2.63.48.48 0 0 1 .48-.56Zm5.21 5.13c.25.05.44.26.44.52 0 .3-.26.53-.56.48a6.96 6.96 0 0 1-2.63-1.1.48.48 0 0 1-.05-.73c.18-.18.46-.2.67-.05.64.42 1.36.73 2.13.88Zm4.5-.88c.22-.14.5-.13.68.05.22.22.2.57-.05.74-.78.53-1.67.9-2.63 1.09a.48.48 0 0 1-.56-.48c0-.26.19-.47.44-.52.77-.15 1.5-.46 2.13-.88Zm2.57-3.81a.54.54 0 0 1 .52-.44c.3 0 .53.26.48.56a6.96 6.96 0 0 1-1.1 2.63.48.48 0 0 1-.73.05.54.54 0 0 1-.05-.67c.42-.64.73-1.36.88-2.13ZM15 6.69a.54.54 0 0 1 .05-.68c.22-.22.57-.2.74.05.53.78.9 1.67 1.09 2.63.05.3-.18.56-.48.56a.54.54 0 0 1-.52-.44A5.97 5.97 0 0 0 15 6.68Z"
]);
const $4125b41377e9d21d$export$dece865717c1b9ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseInfoFilled', "1em", [
    "M17.5 9.89c-.47-.3-1-.55-1.55-.7A6 6 0 0 0 6.03 5.5h1.22a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v1.16a7.5 7.5 0 0 1 12.5 5.48ZM2.5 10a7.5 7.5 0 0 0 7.39 7.5c-.3-.47-.55-1-.7-1.55A6 6 0 0 1 4 9.78a.75.75 0 1 0-1.5-.06V10Zm7.5 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5 2.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5Zm0-5.13a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.24Z"
]);
const $4125b41377e9d21d$export$4c95e51d8211ddb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCounterclockwiseInfoRegular', "1em", [
    "M16.99 9.6c-.33-.17-.68-.3-1.04-.4A6 6 0 0 0 5.53 6H7.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.6a7 7 0 0 1 11.99 4.5ZM3 10a7 7 0 0 0 6.6 6.99c-.17-.33-.3-.68-.4-1.04a6 6 0 0 1-5.18-6.41.5.5 0 1 0-1-.08A7.1 7.1 0 0 0 3 10Zm7 4.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.5 2.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5Zm0-5.13a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.24Z"
]);
const $4125b41377e9d21d$export$77ba0725dc3e9287 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownLeftFilled', "1em", [
    "M13.39 3.14a.75.75 0 1 0-.78-1.28 7.2 7.2 0 0 0-2.98 3.13A11.6 11.6 0 0 0 8.75 10v5.44l-2.72-2.72a.75.75 0 1 0-1.06 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 0 0-1.06-1.06l-2.72 2.72V10c0-1.95.25-3.32.74-4.37a5.71 5.71 0 0 1 2.4-2.49Z"
]);
const $4125b41377e9d21d$export$97c6f3d24036e2bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownLeftRegular', "1em", [
    "M13.26 2.93a.5.5 0 0 0-.52-.86A6.95 6.95 0 0 0 9.86 5.1C9.26 6.38 9 7.96 9 10v6.3l-3.15-3.15a.5.5 0 1 0-.7.7l4 4c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7L10 16.29V10c0-1.96.25-3.38.76-4.47a5.96 5.96 0 0 1 2.5-2.6Z"
]);
const $4125b41377e9d21d$export$ea9e7d3d5d4ffaf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownRightFilled', "1em", [
    "M6.61 3.14a.75.75 0 1 1 .78-1.28 7.2 7.2 0 0 1 2.98 3.13c.63 1.33.88 2.96.88 5.01v5.44l2.72-2.72a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l2.72 2.72V10c0-1.95-.25-3.32-.74-4.37a5.71 5.71 0 0 0-2.4-2.49Z"
]);
const $4125b41377e9d21d$export$ce2ddd95bd6128d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveDownRightRegular', "1em", [
    "M6.74 2.93a.5.5 0 1 1 .52-.86 6.95 6.95 0 0 1 2.88 3.03c.6 1.28.86 2.86.86 4.9v6.3l3.15-3.15a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7L10 16.29V10c0-1.96-.25-3.38-.76-4.47a5.96 5.96 0 0 0-2.5-2.6Z"
]);
const $4125b41377e9d21d$export$5fda05ac50543d6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpLeftFilled', "1em", [
    "M6.03 7.03a.75.75 0 0 1-1.06-1.06l4-4c.3-.3.77-.3 1.06 0l4 4a.75.75 0 0 1-1.06 1.06l-2.72-2.72v5.44c0 1.95.25 3.32.74 4.37a5.71 5.71 0 0 0 2.4 2.49.75.75 0 1 1-.78 1.28 7.2 7.2 0 0 1-2.98-3.13 11.6 11.6 0 0 1-.88-5.01V4.31L6.03 7.03Z"
]);
const $4125b41377e9d21d$export$78d4bfb3366d848f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpLeftRegular', "1em", [
    "M5.85 6.85a.5.5 0 1 1-.7-.7l4-4c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L10 3.71V10c0 1.96.25 3.38.76 4.47a5.96 5.96 0 0 0 2.5 2.6.5.5 0 0 1-.52.86 6.95 6.95 0 0 1-2.88-3.03C9.26 13.62 9 12.04 9 10V3.7L5.85 6.86Z"
]);
const $4125b41377e9d21d$export$b21340e6c4bba809 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpRightFilled', "1em", [
    "M13.97 7.03a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72v5.44c0 1.95-.25 3.32-.74 4.37a5.71 5.71 0 0 1-2.4 2.49.75.75 0 1 0 .78 1.28 7.2 7.2 0 0 0 2.98-3.13c.63-1.33.88-2.96.88-5.01V4.31l2.72 2.72Z"
]);
const $4125b41377e9d21d$export$26cf11afc84fe35c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowCurveUpRightRegular', "1em", [
    "M14.15 6.85a.5.5 0 0 0 .7-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L10 3.71V10c0 1.96-.25 3.38-.76 4.47a5.96 5.96 0 0 1-2.5 2.6.5.5 0 0 0 .52.86 6.95 6.95 0 0 0 2.88-3.03c.6-1.28.86-2.86.86-4.9V3.7l3.15 3.15Z"
]);
const $4125b41377e9d21d$export$405224ab6047adeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownFilled', "1em", [
    "M16.8 11.27a.75.75 0 0 0-1.1-1.04l-4.95 5.24V2.75a.75.75 0 0 0-1.5 0v12.73l-4.96-5.25a.75.75 0 0 0-1.09 1.04l6.07 6.41a1 1 0 0 0 1.45 0l6.07-6.41Z"
]);
const $4125b41377e9d21d$export$55d639d200f88b40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownRegular', "1em", [
    "M16.87 10.84a.5.5 0 1 0-.74-.68l-5.63 6.17V2.5a.5.5 0 0 0-1 0v13.83l-5.63-6.17a.5.5 0 0 0-.74.68l6.31 6.91a.75.75 0 0 0 1.11 0l6.32-6.91Z"
]);
const $4125b41377e9d21d$export$954c55302f7edf7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownExclamationFilled', "1em", [
    "M3 5a3 3 0 0 1 6 0c0 2.25-.79 5.21-1.22 6.69C7.54 12.49 6.8 13 6 13s-1.54-.52-1.78-1.31C3.8 10.2 3 7.23 3 5Zm1 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM15 2.5a.5.5 0 0 0-1 0v13.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7L15 16.29V2.5Z"
]);
const $4125b41377e9d21d$export$6373b407eb2bd09a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownExclamationRegular', "1em", [
    "M4 5a2 2 0 1 1 4 0c0 2.09-.75 4.93-1.18 6.4-.1.36-.43.6-.82.6a.84.84 0 0 1-.82-.6C4.75 9.91 4 7.07 4 5Zm2-3a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69C4.46 12.48 5.2 13 6 13s1.54-.52 1.78-1.31C8.2 10.2 9 7.25 9 5a3 3 0 0 0-3-3ZM5 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm9-11.5a.5.5 0 0 0-1 0v13.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7L15 16.29V2.5Z"
]);
const $4125b41377e9d21d$export$558c0c18017a9872 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownLeftFilled', "1em", [
    "M12 16.25c0 .41-.34.75-.75.75h-7.5a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v5.69L15.72 3.22a.75.75 0 1 1 1.06 1.06L5.56 15.5h5.7c.4 0 .74.34.74.75Z"
]);
const $4125b41377e9d21d$export$4739191049be74c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownLeftRegular', "1em", [
    "M11.5 16a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 1 0v6.8L16.15 3.14a.5.5 0 1 1 .7.7L4.71 16h6.79Z"
]);
const $4125b41377e9d21d$export$8fc55281e811512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownRightFilled', "1em", [
    "M8 16.25c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75v-7.5a.75.75 0 1 0-1.5 0v5.69L4.28 3.22a.75.75 0 1 0-1.06 1.06L14.44 15.5h-5.7a.75.75 0 0 0-.74.75Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$8ccdf9b9977f84fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownRightRegular', "1em", [
    "M8.5 16a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-1 0v6.8L3.85 3.14a.5.5 0 1 0-.7.7L15.29 16H8.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ce05f8bcba31eb0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadFilled', "1em", [
    "M15.24 16.5a.75.75 0 0 1 .1 1.5H4.76a.75.75 0 0 1-.1-1.5h10.6ZM10 2c.38 0 .7.28.75.65V12.95l2.97-2.98c.27-.26.68-.29.98-.07l.08.07c.27.27.3.68.07.98l-.07.08-4.24 4.25-.07.07-.1.05-.03.03-.1.03-.11.03-.07.01H10l-.15-.01-.08-.03a.73.73 0 0 1-.26-.14l-4.29-4.29A.75.75 0 0 1 6.2 9.9l.08.07 2.97 2.97V2.75c0-.41.34-.75.75-.75Z"
]);
const $4125b41377e9d21d$export$3738a1f2e0f49231 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadRegular', "1em", [
    "M15.5 17a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H15.5ZM10 2a.5.5 0 0 1 .5.41V14.3l3.64-3.65a.5.5 0 0 1 .64-.06l.07.06c.17.17.2.44.06.63l-.06.07-4.5 4.5a.5.5 0 0 1-.25.14L10 16a.5.5 0 0 1-.4-.2l-4.46-4.45a.5.5 0 0 1 .64-.76l.07.06 3.65 3.64V2.5c0-.27.22-.5.5-.5Z"
]);
const $4125b41377e9d21d$export$ce0dcf5815a814dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadOffFilled', "1em", [
    "m9.25 9.96-7.1-7.1a.5.5 0 1 1 .7-.71l15 15a.5.5 0 0 1-.7.7l-4.6-4.59-2.01 2.02-.07.06-.1.06-.03.02-.1.04-.11.03-.07.01H10l-.15-.01-.08-.03a.73.73 0 0 1-.26-.14l-4.29-4.29A.75.75 0 0 1 6.2 9.9l.08.07 2.97 2.97V9.96Zm2.24 2.24-.74-.74v1.48l.74-.74Zm2.48-.35-1.06-1.06.8-.82c.27-.26.7-.29.99-.07l.08.07c.27.27.3.68.07.98l-.07.08-.81.82ZM9.25 7.13l1.5 1.5V2.65a.75.75 0 0 0-1.5.1v4.38Zm6 9.37a.75.75 0 0 1 .1 1.5H4.75a.75.75 0 0 1-.1-1.5h10.6Z"
]);
const $4125b41377e9d21d$export$e71f5070a7e64083 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowDownloadOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L9.5 10.2v4.09l-3.65-3.64-.07-.06a.5.5 0 0 0-.64.76l4.46 4.46c.1.11.24.19.4.19l.1-.01a.5.5 0 0 0 .26-.14l2.39-2.4 4.4 4.4a.5.5 0 0 0 .7-.7l-15-15Zm9.2 10.6-1.55 1.54V11.2l1.54 1.55Zm2.11-.7-.7-.72.68-.68a.5.5 0 0 1 .64-.06l.07.06c.17.17.2.44.06.63l-.06.07-.69.7ZM9.5 7.37l1 1V2.4a.5.5 0 0 0-1 .1v4.87Zm6 9.62a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H15.5Z"
]);
const $4125b41377e9d21d$export$e9e6fd456da86d78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEjectFilled', "1em", [
    "M11.2 4.6c-.6-.8-1.8-.8-2.4 0l-4.5 6A1.5 1.5 0 0 0 5.5 13h9a1.5 1.5 0 0 0 1.2-2.4l-4.5-6ZM4 15a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H4Z"
]);
const $4125b41377e9d21d$export$6f0593125d926925 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEjectRegular', "1em", [
    "M9.6 5.2a.5.5 0 0 1 .8 0l4.5 6a.5.5 0 0 1-.4.8h-9a.5.5 0 0 1-.4-.8l4.5-6Zm1.6-.6c-.6-.8-1.8-.8-2.4 0l-4.5 6A1.5 1.5 0 0 0 5.5 13h9a1.5 1.5 0 0 0 1.2-2.4l-4.5-6ZM4 15a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H4Z"
]);
const $4125b41377e9d21d$export$7de405ddef04207b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterFilled', "1em", [
    "M7.75 17.5a.75.75 0 0 1 0-1.5H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H7.75a.75.75 0 0 1 0-1.5H14A3.5 3.5 0 0 1 17.5 6v8a3.5 3.5 0 0 1-3.5 3.5H7.75Zm0-11.3a.75.75 0 0 1 1.05.04l3 3.25c.27.29.27.73 0 1.02l-3 3.25a.75.75 0 1 1-1.1-1.02l1.84-1.99H1.75a.75.75 0 0 1 0-1.5h7.79l-1.84-2a.75.75 0 0 1 .04-1.05Z"
]);
const $4125b41377e9d21d$export$21d5b20f97c2874c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterRegular', "1em", [
    "M7.5 17a.5.5 0 0 1 0-1H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H7.5a.5.5 0 0 1 0-1H14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H7.5Zm.15-10.85c.2-.2.5-.2.7 0l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7l2.64-2.65H1.5a.5.5 0 0 1 0-1h8.8L7.64 6.85a.5.5 0 0 1 0-.7Z"
]);
const $4125b41377e9d21d$export$bcef3798dcc891cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterLeftFilled', "1em", [
    "m4.64 12.5 2.87 2.7a.75.75 0 0 1-1.02 1.1l-4.25-4a.75.75 0 0 1 0-1.1l4.25-4A.75.75 0 1 1 7.5 8.3L4.64 11h10.11c.97 0 1.75-.78 1.75-1.75v-4.5a.75.75 0 0 1 1.5 0v4.5c0 1.8-1.46 3.25-3.25 3.25H4.65Z"
]);
const $4125b41377e9d21d$export$9fb632b08ee6fca2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterLeftRegular', "1em", [
    "m3.76 12 3.33 3.14a.5.5 0 0 1-.68.72l-4.25-4a.5.5 0 0 1 0-.72l4.25-4a.5.5 0 1 1 .68.72L3.76 11H15a2 2 0 0 0 2-2V4.5a.5.5 0 0 1 1 0V9a3 3 0 0 1-3 3H3.76Z"
]);
const $4125b41377e9d21d$export$5161b9fd08acdbf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterUpFilled', "1em", [
    "M8.8 2.24a.75.75 0 0 0-1.1 0l-4 4.25A.75.75 0 1 0 4.8 7.5l2.7-2.87v10.11c0 1.8 1.46 3.25 3.25 3.25h4.5a.75.75 0 0 0 0-1.5h-4.5c-.97 0-1.75-.78-1.75-1.75V4.65l2.7 2.86a.75.75 0 1 0 1.1-1.02l-4-4.25Z"
]);
const $4125b41377e9d21d$export$1bc5df14b5526a6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowEnterUpRegular', "1em", [
    "M8.86 2.16a.5.5 0 0 0-.72 0l-4 4.25a.5.5 0 0 0 .72.68L8 3.76V15a3 3 0 0 0 3 3h4.5a.5.5 0 0 0 0-1H11a2 2 0 0 1-2-2V3.76l3.14 3.33a.5.5 0 0 0 .72-.68l-4-4.25Z"
]);
const $4125b41377e9d21d$export$403acc41649655a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExitFilled', "1em", [
    "M12.25 17.5a.75.75 0 0 0 0-1.5H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.25a.75.75 0 0 0 0-1.5H6A3.5 3.5 0 0 0 2.5 6v8A3.5 3.5 0 0 0 6 17.5h6.25Zm1.5-11.3a.75.75 0 0 1 1.05.04l3 3.25c.27.29.27.73 0 1.02l-3 3.25a.75.75 0 1 1-1.1-1.02l1.84-1.99H7.75a.75.75 0 0 1 0-1.5h7.79l-1.84-2a.75.75 0 0 1 .04-1.05Z"
]);
const $4125b41377e9d21d$export$4280fbca678ba65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExitRegular', "1em", [
    "M12.5 17a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h6.5Zm1.15-10.85c.2-.2.5-.2.7 0l3.5 3.5c.2.2.2.5 0 .7l-3.5 3.5a.5.5 0 0 1-.7-.7l2.64-2.65H7.5a.5.5 0 0 1 0-1h8.8l-2.65-2.65a.5.5 0 0 1 0-.7Z"
]);
const $4125b41377e9d21d$export$56b1e38b7ff9d475 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandFilled', "1em", [
    "M3.75 3a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V5.56l2.22 2.22a.75.75 0 0 0 1.06-1.06L5.56 4.5h1.69a.75.75 0 0 0 0-1.5h-3.5Zm0 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v1.69l2.22-2.22a.75.75 0 0 1 1.06 1.06L5.56 15.5h1.69a.75.75 0 0 1 0 1.5h-3.5ZM17 3.75a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0 0 1.5h1.69l-2.22 2.22a.75.75 0 0 0 1.06 1.06l2.22-2.22v1.69a.75.75 0 0 0 1.5 0v-3.5ZM16.25 17c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-1.5 0v1.69l-2.22-2.22a.75.75 0 1 0-1.06 1.06l2.22 2.22h-1.69a.75.75 0 0 0 0 1.5h3.5Z"
]);
const $4125b41377e9d21d$export$66fc52b4c78954a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandRegular', "1em", [
    "M3.5 3a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0V4.7l3.15 3.15a.5.5 0 1 0 .7-.7L4.71 4H7.5a.5.5 0 0 0 0-1h-4Zm0 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.8l3.15-3.15a.5.5 0 0 1 .7.7L4.71 16H7.5a.5.5 0 0 1 0 1h-4ZM17 3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.8l-3.15 3.15a.5.5 0 0 0 .7.7L16 4.71V7.5a.5.5 0 0 0 1 0v-4ZM16.5 17a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v2.8l-3.15-3.15a.5.5 0 0 0-.7.7L15.29 16H12.5a.5.5 0 0 0 0 1h4Z"
]);
const $4125b41377e9d21d$export$13cf836a135b8dc3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandAllFilled', "1em", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm8 3c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Zm-1.22 5.53-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L5 13.44V7.75a.75.75 0 0 1 1.5 0v5.69l1.22-1.22a.75.75 0 0 1 1.06 1.06Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7be52597ebe02122 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExpandAllRegular', "1em", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm3.15 11.35c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L6 14.29V7.5a.5.5 0 0 0-1 0v6.8l-1.65-1.65a.5.5 0 0 0-.7.7l2.5 2.5ZM17.5 8h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b4ce74701e76f3f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportFilled', "1em", [
    "M2.75 3.75c.41 0 .75.34.75.75v11a.75.75 0 0 1-1.5 0v-11c0-.41.34-.75.75-.75ZM5 10c0-.41.34-.75.75-.75h10.19l-2.72-2.72a.75.75 0 0 1 1.06-1.06l4 4a.77.77 0 0 1 .15.22.75.75 0 0 1-.15.84l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H5.75A.75.75 0 0 1 5 10Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$98d9ca104115acc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportRegular', "1em", [
    "M2.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5ZM5 10c0-.28.22-.5.5-.5h10.8l-3.15-3.15a.5.5 0 0 1 .7-.7l4 4a.5.5 0 0 1 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H5.5A.5.5 0 0 1 5 10Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$3d3077b2b2c62cc7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportLtrFilled', "1em", [
    "M2.75 3.75c.41 0 .75.34.75.75v11a.75.75 0 0 1-1.5 0v-11c0-.41.34-.75.75-.75ZM5 10c0-.41.34-.75.75-.75h10.19l-2.72-2.72a.75.75 0 0 1 1.06-1.06l4 4a.77.77 0 0 1 .15.22.75.75 0 0 1-.15.84l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H5.75A.75.75 0 0 1 5 10Z"
]);
const $4125b41377e9d21d$export$57e2ae32d397b459 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportLtrRegular', "1em", [
    "M2.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5ZM5 10c0-.28.22-.5.5-.5h10.8l-3.15-3.15a.5.5 0 0 1 .7-.7l4 4a.5.5 0 0 1 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H5.5A.5.5 0 0 1 5 10Z"
]);
const $4125b41377e9d21d$export$9d3676d3f96b04ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportRtlFilled', "1em", [
    "M17.25 3.75a.75.75 0 0 0-.75.75v11a.75.75 0 0 0 1.5 0v-11a.75.75 0 0 0-.75-.75ZM15 10a.75.75 0 0 0-.75-.75H4.06l2.72-2.72a.75.75 0 0 0-1.06-1.06l-4 4a.76.76 0 0 0-.22.53.75.75 0 0 0 .22.53l4 4a.75.75 0 1 0 1.06-1.06l-2.72-2.72h10.19c.41 0 .75-.34.75-.75Z"
]);
const $4125b41377e9d21d$export$61dc9f102323fc08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportRtlRegular', "1em", [
    "M17.5 4a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-.5-.5ZM15 10a.5.5 0 0 0-.5-.5H3.7l3.15-3.15a.5.5 0 0 0-.7-.7l-4 4a.5.5 0 0 0 0 .7l4 4a.5.5 0 0 0 .7-.7L3.71 10.5H14.5a.5.5 0 0 0 .5-.5Z"
]);
const $4125b41377e9d21d$export$68bbee72e73fed3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportUpFilled', "1em", [
    "M10.53 1.72a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72v10.19a.75.75 0 0 0 1.5 0V4.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4ZM4.5 16.5a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5h-11Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$fbefb716e743b72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowExportUpRegular', "1em", [
    "M9.65 2.15c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L10.5 3.71V14.5a.5.5 0 0 1-1 0V3.7L6.35 6.86a.5.5 0 1 1-.7-.7l4-4ZM4 17.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$64bd6bf4ad62d1e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitFilled', "1em", [
    "M5.8 6.72c.28.3.28.77-.01 1.06L4.57 9h3.68a.75.75 0 0 1 0 1.5H4.56l1.22 1.22a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.51-2.5c.3-.3.77-.3 1.06 0Zm8.42 0c.3-.3.77-.3 1.06 0l2.5 2.5c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22h-3.69a.75.75 0 0 1 0-1.5h3.69l-1.22-1.22a.75.75 0 0 1 0-1.06Z"
]);
const $4125b41377e9d21d$export$fe6a8ee4bb3e3734 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitRegular', "1em", [
    "M5.35 6.65c.2.2.2.5 0 .7L3.71 9H8.5a.5.5 0 0 1 0 1H3.7l1.65 1.65a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5c.2-.2.5-.2.7 0Zm9.3 0c.2-.2.5-.2.7 0l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7L16.29 10H11.5a.5.5 0 0 1 0-1h4.8l-1.65-1.65a.5.5 0 0 1 0-.7Z"
]);
const $4125b41377e9d21d$export$c83e2da7ab994ee0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitInFilled', "1em", [
    "M5.21 7.78a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 .01 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22H2.75a.75.75 0 0 1 0-1.5h3.68L5.21 7.78Zm9.58 0a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0-.01 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h3.69a.75.75 0 0 0 0-1.5h-3.68l1.22-1.22Z"
]);
const $4125b41377e9d21d$export$a95fc6db8a97fe05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFitInRegular', "1em", [
    "M5.65 7.35a.5.5 0 1 1 .7-.7l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7L7.29 10H2.5a.5.5 0 0 1 0-1h4.8L5.64 7.35Zm8.7 0a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L12.71 10h4.79a.5.5 0 0 0 0-1h-4.8l1.65-1.65Z"
]);
const $4125b41377e9d21d$export$3e05a4c580525a72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowDiagonalUpRightFilled', "1em", [
    "M10.5 4a.5.5 0 0 0 0 1h3.8l-6.56 6.55a3 3 0 1 0 .7.7L15 5.72V9.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5h-5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$2681f8bee4f68ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowDiagonalUpRightRegular', "1em", [
    "M10.5 4a.5.5 0 0 0 0 1h3.8l-6.56 6.55a3 3 0 1 0 .7.7L15 5.72V9.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5h-5ZM4 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$940c460610bb5016 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowSquareMultipleFilled', "1em", [
    "M16 5.17A3 3 0 0 1 18 8v5a5 5 0 0 1-5 5H8a3 3 0 0 1-2.83-2H12a4 4 0 0 0 4-4V5.17ZM12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8.18A1.75 1.75 0 0 0 4.18 7h.52c.96 0 1.85.48 2.38 1.28A3.87 3.87 0 0 0 10.3 10h1l-1.65 1.65a.5.5 0 1 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 1 0-.7.7L11.29 9h-.99c-.96 0-1.85-.48-2.38-1.28A3.87 3.87 0 0 0 4.7 6h-.52A1.75 1.75 0 0 0 2 4.82 3 3 0 0 1 5 2h7ZM2.5 5.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7f79a8152dd16bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowSquareMultipleRegular', "1em", [
    "M16 5.17A3 3 0 0 1 18 8v5a5 5 0 0 1-5 5H8a3 3 0 0 1-2.83-2h1.1c.34.6.99 1 1.73 1h5a4 4 0 0 0 4-4V8a2 2 0 0 0-1-1.73v-1.1ZM12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8.43a2 2 0 0 0 1 0V12c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-1.95 1.58 2 2 0 0 0-1.02-.02A3 3 0 0 1 5 2h7ZM2.5 5.5c.37 0 .7.2.87.5h.83c1.3 0 2.5.65 3.22 1.72C7.95 8.52 8.84 9 9.8 9h1.5L9.64 7.35a.5.5 0 1 1 .7-.7l2.5 2.5a.5.5 0 0 1 0 .7l-2.5 2.5a.5.5 0 1 1-.7-.7L11.29 10H9.8c-1.3 0-2.5-.65-3.22-1.72A2.87 2.87 0 0 0 4.2 7h-.83a1 1 0 1 1-.87-1.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$33237199321c003a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightFilled', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ae677046e260983f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightRegular', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5ZM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f2f8c681b642cfec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightRectangleMultipleFilled', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4Zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2v-2.5ZM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$86833126bab126cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowFlowUpRightRectangleMultipleRegular', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4Zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2v-2.5ZM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5ZM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$795f2f85c11fdac7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardFilled', "1em", [
    "M12.22 4.78a.75.75 0 0 1 1.06-1.06l4.5 4.5c.3.3.3.77 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H9.25a5.75 5.75 0 0 0-5.75 5.75.75.75 0 0 1-1.5 0C2 11.25 5.25 8 9.25 8h6.19l-3.22-3.22Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$afacd6b1db450f86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardRegular', "1em", [
    "M12.65 3.65a.5.5 0 0 0 0 .7L16.29 8H9.5A7.5 7.5 0 0 0 2 15.5a.5.5 0 0 0 1 0A6.5 6.5 0 0 1 9.5 9h6.8l-3.65 3.65a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7l-4.5-4.5a.5.5 0 0 0-.7 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$1974b7b28e2bcde0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownLightningFilled', "1em", [
    "M13.43 4.75 15.7 7h-3.95c-2.8-.1-4.49-1.62-4.49-3.75a.75.75 0 0 0-1.5 0v.21C5.87 6.42 8.35 8.5 12 8.5h3.69l-2.26 2.26-.07.08a.75.75 0 0 0 1.14.98l3.53-3.54a.75.75 0 0 0 .09-.1l.03-.06.05-.1.03-.1.02-.1V7.68l-.01-.06-.02-.07-.03-.09-.05-.1-.04-.05-.07-.08-3.53-3.54-.09-.07a.75.75 0 0 0-.98 1.14ZM2.5 16h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66H4.59a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f54a1ed63ea37634 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownLightningRegular', "1em", [
    "M13.61 4.32 16.3 7h-4.55C8.8 6.9 7 5.27 7 3a.5.5 0 0 0-1 0v.2C6.12 6.03 8.48 8 12 8h4.3l-2.69 2.68-.06.07a.5.5 0 0 0 .77.64l3.55-3.55.05-.07.04-.08.02-.06.02-.09v-.06.02a.5.5 0 0 0-.01-.1v-.03l-.03-.06-.03-.06-.05-.07-3.56-3.57-.07-.06a.5.5 0 0 0-.64.77ZM2.51 16h1.74l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66H4.59a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9b498e17d6d87b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownPersonFilled', "1em", [
    "M13.43 4.74 15.7 7h-3.95c-2.8-.1-4.49-1.62-4.49-3.75a.75.75 0 0 0-1.5 0v.21C5.87 6.42 8.35 8.5 12 8.5h3.69l-2.26 2.26-.07.08a.75.75 0 0 0 1.13.98l3.54-3.54a.75.75 0 0 0 .09-.1l.03-.06.05-.1.03-.1.02-.1V7.68l-.01-.06-.02-.07-.03-.09-.05-.1-.04-.05-.07-.08-3.54-3.54-.08-.07a.75.75 0 0 0-.98 1.13ZM7.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM9 15.5C9 16.74 8 18 5.5 18S2 16.75 2 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$450c3d33e60a3015 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowForwardDownPersonRegular', "1em", [
    "M13.61 4.32 16.3 7h-4.55C8.8 6.9 7 5.27 7 3a.5.5 0 0 0-1 0v.2C6.11 6.03 8.48 8 12 8h4.3l-2.69 2.68-.06.07a.5.5 0 0 0 .77.64l3.55-3.55.05-.07.04-.08.02-.06.02-.09v-.06.02a.5.5 0 0 0-.01-.1v-.03l-.03-.06-.03-.06-.05-.07-3.56-3.57-.07-.06a.5.5 0 0 0-.64.77ZM7.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM9 15.5C9 16.74 8 18 5.5 18S2 16.75 2 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f3d3fe7904d7b8ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownLeftFilled', "1em", [
    "M6 4.75c0-.41.34-.75.75-.75h4.5c1.59 0 2.7.62 3.53 1.59C15.6 6.54 16 7.79 16 9c0 1.22-.3 2.46-1.12 3.41A4.62 4.62 0 0 1 11.25 14H6.56l2.22 2.22a.75.75 0 1 1-1.06 1.06l-3.5-3.5a.75.75 0 0 1 .02-1.08l3.5-3.25a.75.75 0 0 1 1.02 1.1l-2.1 1.95h4.59c1.16 0 1.86-.44 2.4-1.07.55-.64.85-1.52.85-2.43 0-.9-.3-1.79-.85-2.43a2.92 2.92 0 0 0-2.4-1.07h-4.5A.75.75 0 0 1 6 4.75Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6d84a10395212e57 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownLeftRegular', "1em", [
    "M6 4.5c0-.28.22-.5.5-.5H11c1.64 0 2.9.62 3.75 1.57C15.59 6.52 16 7.77 16 9s-.41 2.48-1.25 3.43A4.85 4.85 0 0 1 11 14H5.7l2.65 2.65a.5.5 0 0 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5a.5.5 0 1 1 .7.7L5.71 13H11c1.36 0 2.35-.5 3-1.24.66-.74 1-1.74 1-2.76 0-1.02-.34-2.02-1-2.76A3.86 3.86 0 0 0 11 5H6.5a.5.5 0 0 1-.5-.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9e95969bd4e18768 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownRightFilled', "1em", [
    "M9 14c.06 0-.06 0 0 0h4.65l-2.27 2.27a.75.75 0 1 0 1.06 1.06l3.35-3.35a.75.75 0 0 0 .21-.64.75.75 0 0 0-.21-.45l-3.25-3.24a.75.75 0 1 0-1.06 1.06l1.8 1.79H9a3.5 3.5 0 1 1 0-7h4.25a.75.75 0 0 0 0-1.5H9a5 5 0 0 0 0 10Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$8df3efd039ba0589 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookDownRightRegular', "1em", [
    "M4 9a5 5 0 0 1 5-5h4.5a.5.5 0 0 1 0 1H9a4 4 0 1 0 0 8h5.3l-2.7-2.7a.5.5 0 1 1 .7-.7l3.54 3.53a.5.5 0 0 1 .13.5.5.5 0 0 1-.14.25L12.3 17.4a.5.5 0 0 1-.71-.7l2.7-2.71H9a5 5 0 0 1-5-5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$aad49cd3a23f9a2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpLeftFilled', "1em", [
    "M6 15.25c0 .41.34.75.75.75h4.5a4.4 4.4 0 0 0 3.53-1.59A5.24 5.24 0 0 0 16 11c0-1.22-.3-2.46-1.12-3.41A4.62 4.62 0 0 0 11.25 6H6.56l2.22-2.22a.75.75 0 0 0-1.06-1.06l-3.5 3.5a.75.75 0 0 0 .02 1.08l3.5 3.25a.75.75 0 0 0 1.02-1.1L6.66 7.5h4.59c1.16 0 1.86.44 2.4 1.07.55.64.85 1.52.85 2.43 0 .9-.3 1.79-.85 2.43a2.92 2.92 0 0 1-2.4 1.07h-4.5a.75.75 0 0 0-.75.75Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e99e7c341e0e8f3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpLeftRegular', "1em", [
    "M6 15.5c0 .28.22.5.5.5H11c1.64 0 2.9-.62 3.75-1.57A5.16 5.16 0 0 0 16 11c0-1.23-.41-2.48-1.25-3.43A4.85 4.85 0 0 0 11 6H5.7l2.65-2.65a.5.5 0 1 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L5.71 7H11c1.36 0 2.35.5 3 1.24.66.74 1 1.74 1 2.76 0 1.02-.34 2.02-1 2.76A3.86 3.86 0 0 1 11 15H6.5a.5.5 0 0 0-.5.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$bf914eef418f5eca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpRightFilled', "1em", [
    "M9 6c.06 0-.06 0 0 0h4.65l-2.27-2.27a.75.75 0 1 1 1.06-1.06l3.35 3.35c.17.18.24.42.21.64a.75.75 0 0 1-.21.45l-3.25 3.24a.75.75 0 1 1-1.06-1.06l1.8-1.79H9a3.5 3.5 0 1 0 0 7h4.25a.75.75 0 0 1 0 1.5H9A5 5 0 0 1 9 6Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$fb5716a6500c86f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowHookUpRightRegular', "1em", [
    "M4 11a5 5 0 0 0 5 5h4.5a.5.5 0 0 0 0-1H9a4 4 0 0 1 0-8h5.3l-2.7 2.7a.5.5 0 1 0 .7.7l3.54-3.53a.5.5 0 0 0 .13-.5.5.5 0 0 0-.14-.25L12.3 2.6a.5.5 0 1 0-.71.7L14.29 6H9a5 5 0 0 0-5 5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$543176e4d5f48977 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowImportFilled', "1em", [
    "M17.25 3.75c.41 0 .75.34.75.75v11a.75.75 0 0 1-1.5 0v-11c0-.41.34-.75.75-.75ZM2 10c0-.41.34-.75.75-.75h10.19l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4a.77.77 0 0 1 .15.22.75.75 0 0 1-.15.84l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H2.75A.75.75 0 0 1 2 10Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e547d0a1c90936e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowImportRegular', "1em", [
    "M17.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-1 0v-11c0-.28.22-.5.5-.5ZM2 10c0-.28.22-.5.5-.5h10.8l-3.15-3.15a.5.5 0 0 1 .7-.7l4 4A.5.5 0 0 1 15 10a.5.5 0 0 1-.15.35l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H2.5A.5.5 0 0 1 2 10Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b12055510e53b54b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowJoinFilled', "1em", [
    "M4.5 2c.28 0 .5.22.5.5C5 6.12 7.88 9 11.5 9h.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L12.29 10h-.79A6.46 6.46 0 0 0 5 16.5a.5.5 0 0 1-1 0 7.45 7.45 0 0 1 4.78-7A7.45 7.45 0 0 1 4 2.5c0-.28.22-.5.5-.5Zm5.53 9.2A5.43 5.43 0 0 0 7 13.3v.7c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v.7a5.43 5.43 0 0 0 3.03 2.1 1.5 1.5 0 0 1 2.53-1.36l2 2a1.5 1.5 0 0 1 0 2.12l-2 2a1.5 1.5 0 0 1-2.53-1.37Z"
]);
const $4125b41377e9d21d$export$32a67ff96b2fecf2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowJoinRegular', "1em", [
    "M5 2.5a.5.5 0 0 0-1 0 7.45 7.45 0 0 0 4.78 7 7.45 7.45 0 0 0-4.78 7 .5.5 0 0 0 1 0c0-3.62 2.88-6.5 6.5-6.5h.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L12.29 9h-.79A6.46 6.46 0 0 1 5 2.5ZM8.5 4a.5.5 0 0 0 0 1H15c.52 0 1 .48 1 1v7c0 .52-.48 1-1 1H8.5a.5.5 0 0 0 0 1H15c1.08 0 2-.92 2-2V6c0-1.08-.92-2-2-2H8.5Z"
]);
const $4125b41377e9d21d$export$80afbaf4e3398453 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowLeftFilled', "1em", [
    "M8.73 16.8a.75.75 0 0 0 1.03-1.1l-5.24-4.95h12.73a.75.75 0 0 0 0-1.5H4.52l5.24-4.96A.75.75 0 1 0 8.73 3.2L2.31 9.27a1 1 0 0 0 0 1.46l6.42 6.07Z"
]);
const $4125b41377e9d21d$export$8040f9d0b476c0b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowLeftRegular', "1em", [
    "M9.16 16.87a.5.5 0 1 0 .67-.74L3.67 10.5H17.5a.5.5 0 0 0 0-1H3.67l6.16-5.63a.5.5 0 0 0-.67-.74L2.24 9.44a.75.75 0 0 0 0 1.11l6.92 6.32Z"
]);
const $4125b41377e9d21d$export$cab30ef18d0a5bed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeFilled', "1em", [
    "M15.75 3.5c.41 0 .75.34.75.75v6a.75.75 0 0 1-1.5 0V6.06L6.06 15h4.19a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 1.5 0v4.19L13.94 5H9.75a.75.75 0 0 1 0-1.5h6Z"
]);
const $4125b41377e9d21d$export$52fa252c94e2d235 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeRegular', "1em", [
    "M15.5 4c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V5.7L5.7 15h4.8a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v4.8L14.3 5H9.5a.5.5 0 0 1 0-1h6Z"
]);
const $4125b41377e9d21d$export$7cba9603e2109c47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeTopLeftBottomRightFilled', "1em", [
    "M10.25 3.5a.75.75 0 0 1 0 1.5H6.06L15 13.94V9.75a.75.75 0 0 1 1.5 0v6c0 .41-.34.75-.75.75h-6a.75.75 0 0 1 0-1.5h4.19L5 6.06v4.19a.75.75 0 0 1-1.5 0v-6c0-.41.34-.75.75-.75h6Z"
]);
const $4125b41377e9d21d$export$1e331543faecb350 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeTopLeftBottomRightRegular', "1em", [
    "M10.5 4a.5.5 0 0 1 0 1H5.7l9.3 9.3V9.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.8L5 5.7v4.8a.5.5 0 0 1-1 0v-6c0-.28.22-.5.5-.5h6Z"
]);
const $4125b41377e9d21d$export$fd26c3e355491b5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeVerticalFilled', "1em", [
    "M9.58 1.33a.6.6 0 0 1 .84 0l2.13 2.13a.6.6 0 0 1-.85.84l-1.1-1.1v4.3a.6.6 0 1 1-1.2 0V3.2L8.3 4.3a.6.6 0 0 1-.85-.84l2.13-2.13ZM3.9 10c0-.33.27-.6.6-.6h11a.6.6 0 1 1 0 1.2h-11a.6.6 0 0 1-.6-.6Zm6.7 6.8v-4.3a.6.6 0 0 0-1.2 0v4.3l-1.1-1.1a.6.6 0 0 0-.85.85l2.13 2.12a.6.6 0 0 0 .84 0l2.13-2.12a.6.6 0 1 0-.85-.85l-1.1 1.1Z"
]);
const $4125b41377e9d21d$export$81a1019b3e60955 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMaximizeVerticalRegular', "1em", [
    "M9.65 1.4c.2-.2.5-.2.7 0l2.12 2.13a.5.5 0 0 1-.7.7L10.5 2.96V7.5a.5.5 0 0 1-1 0V2.96L8.23 4.23a.5.5 0 1 1-.7-.7L9.65 1.4ZM4 10c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 4 10Zm6.5 7.04V12.5a.5.5 0 0 0-1 0v4.54l-1.27-1.27a.5.5 0 1 0-.7.7l2.12 2.13c.2.2.5.2.7 0l2.12-2.12a.5.5 0 0 0-.7-.71l-1.27 1.27Z"
]);
const $4125b41377e9d21d$export$ed28000a0be5e908 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeFilled', "1em", [
    "M3.75 11h4.5c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 0 1-1.5.1v-2.79l-4.47 4.47a.75.75 0 0 1-1.13-.98l.07-.08 4.47-4.47H3.75a.75.75 0 0 1-.74-.65l-.01-.1c0-.38.28-.7.65-.74l.1-.01h4.5-4.5Zm14.28-9.03c.27.27.3.68.07.98l-.07.08L13.06 8h3.19c.38 0 .7.28.74.65l.01.1c0 .38-.28.7-.65.74l-.1.01h-5a.75.75 0 0 1-.74-.65l-.01-.1v-5a.75.75 0 0 1 1.5-.1v3.29l4.97-4.97c.3-.3.77-.3 1.06 0Z"
]);
const $4125b41377e9d21d$export$b2bd1a3059522320 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeRegular', "1em", [
    "M8.5 11c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-3.8l-5.15 5.15a.5.5 0 0 1-.7-.7L7.29 12H3.5a.5.5 0 0 1 0-1h5Zm8.65-8.85a.5.5 0 1 1 .7.7L12.71 8h3.79a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v3.8l5.15-5.15Z"
]);
const $4125b41377e9d21d$export$2cd8708b41c56c4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeTopLeftBottomRightFilled', "1em", [
    "M16.25 11h.1c.37.06.65.37.65.75v.1a.75.75 0 0 1-.75.65h-2.69l4.47 4.47.07.08a.75.75 0 0 1-1.13.98l-4.47-4.47v2.79a.75.75 0 0 1-1.5-.1v-4.6a.75.75 0 0 1 .75-.65h4.5ZM1.97 1.97c.3-.3.77-.3 1.06 0L8 6.94V3.65a.75.75 0 0 1 1.5.1v5.1a.75.75 0 0 1-.75.65h-5.1A.75.75 0 0 1 3 8.74v-.1A.75.75 0 0 1 3.76 8h3.19L1.97 3.03l-.07-.08a.75.75 0 0 1 .07-.98Z"
]);
const $4125b41377e9d21d$export$93caa8cfc35e0d45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeTopLeftBottomRightRegular', "1em", [
    "M16.5 11a.5.5 0 0 1 0 1h-3.8l5.15 5.15a.5.5 0 0 1-.7.7L12 12.71v3.79a.5.5 0 1 1-1 0v-5c0-.28.22-.5.5-.5h5ZM2.15 2.15c.2-.2.5-.2.7 0L8 7.29V3.5a.5.5 0 1 1 1 0v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.8L2.14 2.85a.5.5 0 0 1 0-.7Z"
]);
const $4125b41377e9d21d$export$d6e452796dc7a9c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeVerticalFilled', "1em", [
    "M9.75 1.5c.41 0 .75.34.75.75v2.69l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l.72.72V2.25c0-.41.34-.75.75-.75ZM3.5 9.75c0-.41.34-.75.75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75Zm8.78 4.47-2-2a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v2.69a.75.75 0 0 0 1.5 0v-2.69l.72.72a.75.75 0 1 0 1.06-1.06Z"
]);
const $4125b41377e9d21d$export$17c6fe9d995a9764 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMinimizeVerticalRegular', "1em", [
    "M9.5 1c.28 0 .5.22.5.5v3.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 5.29V1.5c0-.28.22-.5.5-.5Zm-6 8.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm6.5 4.2v3.8a.5.5 0 0 1-1 0v-3.8l-1.15 1.15a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7L10 13.71Z"
]);
const $4125b41377e9d21d$export$bdd89c4834cac7eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveFilled', "1em", [
    "M10.53 2.22a.75.75 0 0 0-1.06 0L7.22 4.47a.75.75 0 0 0 1.06 1.06l.97-.97v2.69a.75.75 0 0 0 1.5 0V4.56l.97.97a.75.75 0 1 0 1.06-1.06l-2.25-2.25ZM2.22 9.47c-.3.3-.3.77 0 1.06l2.25 2.25a.75.75 0 0 0 1.06-1.06l-.97-.97h2.69a.75.75 0 0 0 0-1.5H4.56l.97-.97a.75.75 0 0 0-1.06-1.06L2.22 9.47Zm8.31 8.31 2.25-2.25a.75.75 0 1 0-1.06-1.06l-.97.97v-2.69a.75.75 0 0 0-1.5 0v2.69l-.97-.97a.75.75 0 0 0-1.06 1.06l2.25 2.25c.3.3.77.3 1.06 0Zm5-10.56 2.25 2.25c.3.3.3.77 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l.97-.97h-2.69a.75.75 0 0 1 0-1.5h2.69l-.97-.97a.75.75 0 0 1 1.06-1.06Z"
]);
const $4125b41377e9d21d$export$fe8f2442bbb78559 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveRegular', "1em", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 1 0 .7.7L9.5 3.71V7.5a.5.5 0 0 0 1 0V3.7l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5Zm-8.2 7.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L3.71 10.5H7.5a.5.5 0 0 0 0-1H3.7l1.65-1.65a.5.5 0 1 0-.7-.7l-2.5 2.5ZM10 18a.5.5 0 0 1-.35-.15l-2.5-2.5a.5.5 0 0 1 .7-.7l1.65 1.64V12.5a.5.5 0 0 1 1 0v3.8l1.65-1.65a.5.5 0 0 1 .7.7l-2.5 2.5A.5.5 0 0 1 10 18Zm7.85-7.65a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7l1.64 1.65H12.5a.5.5 0 0 0 0 1h3.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5Z"
]);
const $4125b41377e9d21d$export$612fa7126a0ddf5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveInwardFilled', "1em", [
    "M13.03 3.72c.3.3.3.77 0 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.22 1.22V1.75a.75.75 0 0 1 1.5 0v3.19l1.22-1.22c.3-.3.77-.3 1.06 0ZM3.72 6.97c.3-.3.77-.3 1.06 0l2.5 2.5c.3.3.3.77 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.22-1.22H1.75a.75.75 0 0 1 0-1.5h3.19L3.72 8.03a.75.75 0 0 1 0-1.06Zm11.5 0a.75.75 0 1 1 1.06 1.06l-1.22 1.22h3.19a.75.75 0 0 1 0 1.5h-3.19l1.22 1.22a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5Zm-2.19 9.31c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06l1.22-1.22v3.19a.75.75 0 0 0 1.5 0v-3.19l1.22 1.22c.3.3.77.3 1.06 0Z"
]);
const $4125b41377e9d21d$export$95a6e9ad7cb82897 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowMoveInwardRegular', "1em", [
    "M7.15 16.35c.2.2.5.2.7 0l1.65-1.64v3.79a.5.5 0 0 0 1 0v-3.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 0 .7Zm9.2-8.5a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7l-1.64-1.65h3.79a.5.5 0 0 0 0-1h-3.8l1.65-1.65Zm-12.7 0a.5.5 0 1 1 .7-.7l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7l1.64-1.65H1.5a.5.5 0 0 1 0-1h3.8L3.64 7.85Zm4.2-4.2a.5.5 0 1 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7L10.5 5.29V1.5a.5.5 0 0 0-1 0v3.8L7.85 3.64Z"
]);
const $4125b41377e9d21d$export$782aaa18c363dfcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowNextFilled', "1em", [
    "M13.75 4.75c.38 0 .7.28.74.65l.01.1v9a.75.75 0 0 1-1.5.1V5.5c0-.41.34-.75.75-.75Zm-8.28.22a.75.75 0 0 1 .98-.07l.08.07 4.5 4.5c.27.27.3.68.07.98l-.07.08-4.5 4.5a.75.75 0 0 1-1.13-.98l.07-.08L9.44 10 5.47 6.03a.75.75 0 0 1 0-1.06Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b8f9a77ed394a968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowNextRegular', "1em", [
    "M13.5 5a.5.5 0 0 1 .5.41v9.09a.5.5 0 0 1-1 .09V5.5c0-.28.22-.5.5-.5Zm-7.85.15a.5.5 0 0 1 .63-.06l.07.06 4.5 4.5c.18.17.2.44.06.63l-.06.07-4.5 4.5a.5.5 0 0 1-.76-.63l.06-.07L9.79 10 5.65 5.85a.5.5 0 0 1 0-.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4b1df7fe0b4c6227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineDownLeftFilled', "1em", [
    "M3.67 17.99A1.5 1.5 0 0 1 2 16.33l1.08-9.7a1.5 1.5 0 0 1 2.55-.9L6.7 6.8l4.36-4.36a1.5 1.5 0 0 1 2.12 0l4.37 4.37a1.5 1.5 0 0 1 0 2.12l-4.36 4.36 1.06 1.07a1.5 1.5 0 0 1-.9 2.55L3.67 18Z"
]);
const $4125b41377e9d21d$export$b69d8bf68bb911ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineDownLeftRegular', "1em", [
    "M3 16.44a.5.5 0 0 0 .56.56l9.7-1.08a.5.5 0 0 0 .3-.85l-1.42-1.42a.5.5 0 0 1 0-.71l4.71-4.72a.5.5 0 0 0 0-.7l-4.37-4.37a.5.5 0 0 0-.7 0L7.06 7.86a.5.5 0 0 1-.7 0L4.92 6.44a.5.5 0 0 0-.85.3L3 16.44ZM3.67 18A1.5 1.5 0 0 1 2 16.33l1.08-9.7a1.5 1.5 0 0 1 2.55-.9L6.7 6.8l4.36-4.36a1.5 1.5 0 0 1 2.12 0l4.37 4.37a1.5 1.5 0 0 1 0 2.12l-4.36 4.36 1.06 1.07a1.5 1.5 0 0 1-.9 2.55L3.67 18Z"
]);
const $4125b41377e9d21d$export$6ec3b3ef60310b61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineUpRightFilled', "1em", [
    "M16.33 2c.96-.1 1.77.71 1.66 1.67l-1.08 9.7a1.5 1.5 0 0 1-2.55.9L13.3 13.2l-4.36 4.36a1.5 1.5 0 0 1-2.12 0l-4.37-4.37a1.5 1.5 0 0 1 0-2.12L6.8 6.7 5.74 5.64a1.5 1.5 0 0 1 .89-2.55L16.33 2Z"
]);
const $4125b41377e9d21d$export$6eda91a02f89d145 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowOutlineUpRightRegular', "1em", [
    "M17 3.56a.5.5 0 0 0-.56-.56l-9.7 1.08a.5.5 0 0 0-.3.85l1.42 1.42a.5.5 0 0 1 0 .71l-4.71 4.72a.5.5 0 0 0 0 .7l4.37 4.37c.2.2.5.2.7 0l4.72-4.71c.2-.2.51-.2.7 0l1.43 1.42c.3.3.8.12.85-.3L17 3.56ZM16.33 2c.96-.1 1.77.7 1.66 1.66l-1.08 9.7a1.5 1.5 0 0 1-2.55.9L13.3 13.2l-4.36 4.36a1.5 1.5 0 0 1-2.12 0l-4.37-4.37a1.5 1.5 0 0 1 0-2.12L6.8 6.7 5.74 5.64a1.5 1.5 0 0 1 .89-2.55L16.33 2Z"
]);
const $4125b41377e9d21d$export$49c7f05f3a3cdb3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowParagraphFilled', "1em", [
    "M17.25 2c.41 0 .75.34.75.75v2.5A2.75 2.75 0 0 1 15.25 8h-3.8l1.36 1.5a.75.75 0 0 1-1.12 1L9.2 7.75a.75.75 0 0 1 0-1L11.7 4a.75.75 0 0 1 1.12 1l-1.36 1.5h3.8c.69 0 1.25-.56 1.25-1.25v-2.5c0-.41.34-.75.75-.75ZM8.3 9.5a.75.75 0 1 0-1.1 1L8.55 12h-5.8a.75.75 0 0 0 0 1.5h5.8L7.2 15a.75.75 0 0 0 1.1 1l2.5-2.75a.75.75 0 0 0 0-1L8.3 9.5Z"
]);
const $4125b41377e9d21d$export$b120e22a27a3572c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowParagraphRegular', "1em", [
    "M12.15 10.85a.5.5 0 0 0 .7-.7L10.71 8h4.79A2.5 2.5 0 0 0 18 5.5v-3s0-.5-.5-.5-.5.5-.5.5v3c0 .83-.67 1.5-1.5 1.5h-4.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0 0 .7l3 3Zm-4.3-1.7a.5.5 0 1 0-.7.7L9.29 12H2.5s-.5 0-.5.5.5.5.5.5h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 0-.7l-3-3Z"
]);
const $4125b41377e9d21d$export$be8501585e31ad0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowPreviousFilled', "1em", [
    "M6 4.75c-.38 0-.7.28-.74.65l-.01.1v9a.75.75 0 0 0 1.5.1V5.5A.75.75 0 0 0 6 4.75Zm8.28.22a.75.75 0 0 0-.98-.07l-.08.07-4.5 4.5a.75.75 0 0 0-.07.98l.07.08 4.5 4.5a.75.75 0 0 0 1.13-.98l-.07-.08L10.31 10l3.97-3.97c.3-.3.3-.77 0-1.06Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$98b528749acfb707 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowPreviousRegular', "1em", [
    "M6 5a.5.5 0 0 0-.5.41v9.09a.5.5 0 0 0 1 .09V5.5A.5.5 0 0 0 6 5Zm7.85.15a.5.5 0 0 0-.63-.06l-.07.06-4.5 4.5a.5.5 0 0 0-.06.63l.06.07 4.5 4.5a.5.5 0 0 0 .76-.63l-.06-.07L9.71 10l4.14-4.15a.5.5 0 0 0 0-.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6f417fd7cd228c34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRedoFilled', "1em", [
    "M13.14 6.5h-2.39a.75.75 0 1 0 0 1.5h4.4c.47 0 .85-.38.85-.85v-4.4a.75.75 0 0 0-1.5 0V5.7l-3.06-2.66a5.25 5.25 0 0 0-6.88 7.92l8.17 7.1a.75.75 0 1 0 .98-1.13l-8.17-7.1a3.75 3.75 0 1 1 4.92-5.66l2.68 2.33Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9781b7c58fa34512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRedoRegular', "1em", [
    "M15 2.5a.5.5 0 0 1 1 0v4.9a.6.6 0 0 1-.6.6h-4.9a.5.5 0 0 1 0-1h3.6l-3.48-3.02a4 4 0 1 0-5.24 6.04l8.17 7.1a.5.5 0 1 1-.66.76l-8.17-7.1a5 5 0 1 1 6.56-7.55L15 6.46V2.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$c1c7cf5cbe11ee39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeat1Filled', "1em", [
    "M15.75 6.01c.18 0 .35.06.48.17a4.98 4.98 0 0 1 1.74 4.4c-.46-.23-.95-.4-1.47-.49V10a3.5 3.5 0 0 0-1.26-2.69.75.75 0 0 1 .5-1.3Zm-5.38 7.49c-.18.47-.3.98-.35 1.5H8.56l1.22 1.22c.27.27.3.68.08.98l-.08.08a.75.75 0 0 1-.97.07l-.09-.07-2.5-2.5a.75.75 0 0 1-.07-.98l.07-.08 2.5-2.5a.75.75 0 0 1 1.14.98l-.08.08-1.22 1.22h1.81Zm-.15-10.78a.75.75 0 0 1 .98-.07l.08.07 2.5 2.5.08.08c.19.26.2.62 0 .89l-.08.09-2.5 2.5-.08.07c-.26.2-.62.2-.88.01l-.1-.08-.07-.08a.75.75 0 0 1 0-.89l.07-.09 1.22-1.22H7a3.5 3.5 0 0 0-3.5 3.3v.2c0 1.08.5 2.05 1.26 2.7.15.13.24.32.24.54a.75.75 0 0 1-1.25.56A5 5 0 0 1 6.78 5h4.66l-1.22-1.22-.07-.08a.75.75 0 0 1 .07-.98ZM20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.95-2.66a.62.62 0 0 0-.68.23c-.21.3-.58.73-1.1.98a.5.5 0 1 0 .45.9c.3-.15.56-.34.78-.53v3.08a.5.5 0 0 0 1 0v-4.08a.61.61 0 0 0-.45-.58Z"
]);
const $4125b41377e9d21d$export$a4a6d8dc78facf85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeat1Regular', "1em", [
    "M16.5 6.67a.5.5 0 0 1 .3.1l.08.07.01.02a4.98 4.98 0 0 1 1.08 3.72c-.31-.15-.64-.28-.98-.37a4 4 0 0 0-.88-2.73.5.5 0 0 1 .39-.81ZM10.2 14c-.08.32-.15.66-.18 1H6.7l1.65 1.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06-2.5-2.5a.5.5 0 0 1-.06-.63l.06-.07 2.5-2.5a.5.5 0 0 1 .76.63l-.06.07L6.72 14h.14L7 14h3.2Zm1.45-11.35a.5.5 0 0 1 .63-.06l.07.06 2.5 2.5.06.07a.5.5 0 0 1 0 .56l-.06.07-2.5 2.5-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.07a.5.5 0 0 1 0-.56l.06-.07L13.28 6h-.14L13 6H7a4 4 0 0 0-3.1 6.52c.06.09.1.2.1.31a.5.5 0 0 1-.9.3A4.99 4.99 0 0 1 6.77 5h6.52l-1.65-1.65-.06-.07a.5.5 0 0 1 .06-.63ZM20 15.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.95-2.66a.62.62 0 0 0-.68.23c-.21.3-.58.73-1.1.98a.5.5 0 1 0 .45.9c.3-.15.56-.34.78-.53v3.08a.5.5 0 0 0 1 0v-4.08a.61.61 0 0 0-.45-.58Z"
]);
const $4125b41377e9d21d$export$a429ffe945931d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllFilled', "1em", [
    "M15.75 6.01c.18 0 .34.06.47.17a5 5 0 0 1-3 8.82H8.56l1.22 1.22c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1-.07-.98l.07-.08 2.5-2.5a.75.75 0 0 1 1.13.98l-.07.08-1.22 1.22H13a3.5 3.5 0 0 0 3.5-3.3V10a3.5 3.5 0 0 0-1.26-2.69.75.75 0 0 1 .5-1.3Zm-5.53-3.29a.75.75 0 0 1 .98-.07l.08.07 2.5 2.5.07.08c.2.26.2.62.01.89l-.08.09-2.5 2.5-.08.07c-.26.2-.62.2-.89.01l-.09-.08-.07-.08a.75.75 0 0 1-.01-.89l.08-.09 1.22-1.22H7a3.5 3.5 0 0 0-3.5 3.3v.2c0 1.08.49 2.05 1.26 2.7.15.13.24.32.24.54a.75.75 0 0 1-1.25.56A5 5 0 0 1 6.78 5h4.66l-1.22-1.22-.07-.08a.75.75 0 0 1 .07-.98Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4c7ec5c83bf3d62e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllRegular', "1em", [
    "M16.5 6.67a.5.5 0 0 1 .3.1l.08.07.01.02A5 5 0 0 1 13.22 15L13 15H6.7l1.65 1.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06-2.5-2.5a.5.5 0 0 1-.06-.63l.06-.07 2.5-2.5a.5.5 0 0 1 .76.63l-.06.07L6.72 14h.14L7 14h6a4 4 0 0 0 3.11-6.52.5.5 0 0 1 .39-.81Zm-4.85-4.02a.5.5 0 0 1 .63-.06l.07.06 2.5 2.5.06.07a.5.5 0 0 1 0 .56l-.06.07-2.5 2.5-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.07a.5.5 0 0 1 0-.56l.06-.07L13.28 6h-.14L13 6H7a4 4 0 0 0-3.1 6.52c.06.09.1.2.1.31a.5.5 0 0 1-.9.3A4.99 4.99 0 0 1 6.77 5h6.52l-1.65-1.65-.06-.07a.5.5 0 0 1 .06-.63Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9f06c0fa65ea1f69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllOffFilled', "1em", [
    "M2.22 2.22a.75.75 0 0 1 .98-.07l.08.07 14.5 14.5.07.08a.75.75 0 0 1-1.05 1.05l-.08-.07-2.86-2.85c-.18.03-.37.05-.57.06L13 15H8.56l1.22 1.22c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1-.07-.98l.07-.08 2.5-2.5a.75.75 0 0 1 1.13.98l-.07.08-1.22 1.22h3.88L5.69 6.75A3.5 3.5 0 0 0 3.5 9.81V10c0 1.08.49 2.05 1.26 2.7.15.13.24.32.24.54a.75.75 0 0 1-1.25.56 4.98 4.98 0 0 1 .82-8.17L2.22 3.28l-.07-.08a.75.75 0 0 1 .07-.98Zm13.53 3.79c.18 0 .34.06.47.17a4.98 4.98 0 0 1 .03 7.62l-1.06-1.07a3.5 3.5 0 0 0 .05-5.42.75.75 0 0 1 .5-1.3Zm-5.53-3.3a.75.75 0 0 1 .98-.06l.08.07 2.5 2.5.07.08c.2.26.2.62.01.89l-.08.09-2.5 2.5-.02.02-1.06-1.06.02-.02 1.22-1.22H8.95L7.45 5h3.99l-1.22-1.22-.07-.08a.75.75 0 0 1 .07-.98Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ecca820be091fae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRepeatAllOffRegular', "1em", [
    "M2.15 2.15a.5.5 0 0 1 .63-.06l.07.06 15 15 .06.07a.5.5 0 0 1-.7.7l-.06-.07-3-2.98a5 5 0 0 1-.85.12L13 15H6.7l1.65 1.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06-2.5-2.5a.5.5 0 0 1-.06-.63l.06-.07 2.5-2.5a.5.5 0 0 1 .76.63l-.06.07L6.72 14h.14L7 14h6l.28-.01-7.72-7.72a4 4 0 0 0-1.66 6.25c.06.09.1.2.1.31a.5.5 0 0 1-.9.3A4.99 4.99 0 0 1 4.8 5.5L2.15 2.85l-.06-.07a.5.5 0 0 1 .06-.63ZM16.5 6.67a.5.5 0 0 1 .3.1l.08.07.01.02a4.98 4.98 0 0 1-.83 7.1l-.71-.72a4 4 0 0 0 .76-5.76.5.5 0 0 1 .39-.81ZM12.28 2.6l.07.06 2.5 2.5c.18.17.2.44.06.63l-.06.07-2.5 2.5a.5.5 0 0 1-.76-.63l.06-.07L13.28 6h-.14L13 6H8.1l-1-1h6.2l-1.65-1.65a.5.5 0 0 1-.06-.63l.06-.07a.5.5 0 0 1 .63-.06Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$da0896c91fdc6493 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyFilled', "1em", [
    "M7.78 4.78a.75.75 0 0 0-1.06-1.06l-4.5 4.5c-.3.3-.3.77 0 1.06l4.5 4.5a.75.75 0 0 0 1.06-1.06L4.56 9.5h6.19a5.75 5.75 0 0 1 5.75 5.75.75.75 0 0 0 1.5 0c0-4-3.25-7.25-7.25-7.25H4.56l3.22-3.22Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$648439722953a702 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyRegular', "1em", [
    "M7.35 3.65c.2.2.2.5 0 .7L3.71 8h6.79a7.5 7.5 0 0 1 7.5 7.5.5.5 0 0 1-1 0A6.5 6.5 0 0 0 10.5 9H3.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$357919a9d708b114 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyAllFilled', "1em", [
    "M7.78 4.78a.75.75 0 0 0-1.06-1.06l-4.5 4.5c-.3.3-.3.77 0 1.06l4.5 4.5a.75.75 0 0 0 1.06-1.06L3.81 8.75l3.97-3.97Zm3.5 0a.75.75 0 0 0-1.06-1.06l-4.5 4.5c-.3.3-.3.77 0 1.06l4.5 4.5a.75.75 0 1 0 1.06-1.06L8.06 9.5h2.69a5.75 5.75 0 0 1 5.75 5.75.75.75 0 0 0 1.5 0c0-4-3.25-7.25-7.25-7.25H8.06l3.22-3.22Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$dbda007b02d61c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyAllRegular', "1em", [
    "M7.35 3.65c.2.2.2.5 0 .7L3.21 8.5l4.14 4.15a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0Zm3 0c.2.2.2.5 0 .7L6.71 8h3.79a7.5 7.5 0 0 1 7.5 7.5.5.5 0 0 1-1 0A6.5 6.5 0 0 0 10.5 9H6.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e79bef3b6c5a645e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyDownFilled', "1em", [
    "M17.25 4c.41 0 .75.34.75.75 0 4-3.25 7.25-7.25 7.25H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 10.5h6.19a5.75 5.75 0 0 0 5.75-5.75c0-.41.34-.75.75-.75Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f19afc7f489e25f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowReplyDownRegular', "1em", [
    "M17.5 4c.28 0 .5.22.5.5a7.5 7.5 0 0 1-7.5 7.5H3.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5a.5.5 0 1 1 .7.7L3.71 11h6.79A6.5 6.5 0 0 0 17 4.5c0-.28.22-.5.5-.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$bc36415eb5085b0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowResetFilled', "1em", [
    "M6.03 2.47c.3.3.3.77 0 1.06L4.81 4.75H11A6.25 6.25 0 1 1 4.75 11a.75.75 0 0 1 1.5 0A4.75 4.75 0 1 0 11 6.25H4.81l1.22 1.22a.75.75 0 0 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1 0-1.06l2.5-2.5c.3-.3.77-.3 1.06 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$74b1db8905a7ae75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowResetRegular', "1em", [
    "M5.85 2.65c.2.2.2.5 0 .7L4.21 5H11a6 6 0 1 1-6 6 .5.5 0 0 1 1 0 5 5 0 1 0 5-5H4.2l1.65 1.65a.5.5 0 1 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5c.2-.2.5-.2.7 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$117f159384bb678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRightFilled', "1em", [
    "M11.27 3.2a.75.75 0 0 0-1.04 1.1l5.24 4.95H2.75a.75.75 0 0 0 0 1.5h12.73l-5.25 4.96a.75.75 0 1 0 1.04 1.09l6.41-6.07a1 1 0 0 0 0-1.46l-6.41-6.06Z"
]);
const $4125b41377e9d21d$export$39be26c8d2d2bd90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRightRegular', "1em", [
    "M10.84 3.13a.5.5 0 0 0-.68.74l6.17 5.63H2.5a.5.5 0 0 0 0 1h13.83l-6.17 5.63a.5.5 0 0 0 .68.74l6.91-6.32a.75.75 0 0 0 0-1.1l-6.91-6.32Z"
]);
const $4125b41377e9d21d$export$614f669b48a4b1a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateClockwiseFilled', "1em", [
    "M10 3.5A6.5 6.5 0 0 0 3.5 10 .75.75 0 0 1 2 10a8 8 0 1 1 12.66 6.5h1.09a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 1.5 0v1.23A6.5 6.5 0 0 0 10 3.5Zm2.5 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM11 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b524cdecb7b0e2df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateClockwiseRegular', "1em", [
    "M3 10a7 7 0 1 1 10 6.33V14.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-1.62A8 8 0 1 0 2 10a.5.5 0 0 0 1 0Zm7 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$26ba62f49807bd9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateCounterclockwiseFilled', "1em", [
    "M10 3.5a6.5 6.5 0 0 1 6.5 6.5.75.75 0 0 0 1.5 0 8 8 0 1 0-12.66 6.5H4.25a.75.75 0 0 0 0 1.5h3c.41 0 .75-.34.75-.75v-3a.75.75 0 0 0-1.5 0v1.23A6.5 6.5 0 0 1 10 3.5ZM7.5 10a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM9 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$8478f1ec7b46a39d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRotateCounterclockwiseRegular', "1em", [
    "M17 10a7 7 0 1 0-10 6.33V14.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.62A8 8 0 1 1 18 10a.5.5 0 0 1-1 0Zm-7 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$967d423e60bd9933 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingFilled', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5Z"
]);
const $4125b41377e9d21d$export$a7c4bdb2e1724460 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingRegular', "1em", [
    "M14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5ZM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $4125b41377e9d21d$export$86754837cdb96bac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingRectangleMultipleFilled', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4Zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2v-2.5ZM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5Z"
]);
const $4125b41377e9d21d$export$8c3434b3d18b98f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowRoutingRectangleMultipleRegular', "1em", [
    "M11 12.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-4Zm8 2a.5.5 0 0 0-1 0V17a1 1 0 0 1-1 1h-3.5a.5.5 0 0 0 0 1H17a2 2 0 0 0 2-2v-2.5ZM14.31 3.15a.5.5 0 0 0-.7.7l2.64 2.65H12A2.5 2.5 0 0 0 9.5 9v2c0 .83-.67 1.5-1.5 1.5h-.04a3 3 0 1 0 0 1H8a2.5 2.5 0 0 0 2.5-2.5V9c0-.83.67-1.5 1.5-1.5h4.25l-2.64 2.65a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5ZM7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $4125b41377e9d21d$export$c9e6045c552a00d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleFilled', "1em", [
    "M15.78 3.72a.75.75 0 1 0-1.06 1.06l.75.75c-3.09.28-4.88 2.2-6.47 3.9l-.05.06C7.2 11.38 5.65 13 2.75 13a.75.75 0 0 0 0 1.5c3.58 0 5.53-2.09 7.25-3.94l.05-.05c1.58-1.7 2.98-3.17 5.34-3.46l-.67.67a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2ZM2.75 5.5c2.78 0 4.58 1.26 6.05 2.7l-.48.5-.1.1-.45.49C6.42 7.97 4.99 7 2.75 7a.75.75 0 1 1 0-1.5Zm12.72 8.97c-2.34-.21-3.94-1.37-5.27-2.66l.49-.51.09-.1.45-.49c1.17 1.14 2.4 2.02 4.16 2.24l-.67-.67a.75.75 0 1 1 1.06-1.06l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.75-.75Z"
]);
const $4125b41377e9d21d$export$372717d58e7de81b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleRegular', "1em", [
    "M15.85 4.15a.5.5 0 0 0-.7.7L16.3 6c-3.33.07-5.29 1.9-7.1 3.6l-.04.03C7.28 11.4 5.53 13 2.5 13a.5.5 0 0 0 0 1c3.45 0 5.45-1.87 7.3-3.6l.04-.03C11.68 8.65 13.4 7.07 16.3 7l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2ZM2.5 6c2.81 0 4.66 1.24 6.26 2.64l-.28.26-.46.43C6.52 8.03 4.92 7 2.5 7a.5.5 0 0 1 0-1Zm13.8 8c-2.7-.06-4.5-1.28-6.06-2.64l.28-.26.46-.43c1.46 1.27 3 2.27 5.31 2.33l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L16.3 14Z"
]);
const $4125b41377e9d21d$export$c785d80fd75571f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l3 3a7.9 7.9 0 0 0-2.4-.35.75.75 0 0 0 0 1.5c2.24 0 3.67.97 5.02 2.29l.4-.42.7.7C7.14 11.44 5.6 13 2.75 13a.75.75 0 0 0 0 1.5c3.53 0 5.47-2.03 7.18-3.86l.7.7c-.13.16-.28.31-.43.47.85.82 1.8 1.6 3 2.1l1.43 1.42a.75.75 0 0 0 1.04 1.04l1.48 1.48a.5.5 0 0 0 .7-.7l-15-15Zm12.16 10.74 2.08 2.08.69-.69c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.67.67a6.32 6.32 0 0 1-.38-.06Zm-4.75-4.75 1.06 1.06a6.92 6.92 0 0 1 4.07-2.15l-.67.67a.75.75 0 0 0 1.06 1.06l2-2c.3-.3.3-.77 0-1.06l-2-2a.75.75 0 1 0-1.06 1.06l.75.75c-2.3.21-3.9 1.34-5.21 2.6Z"
]);
const $4125b41377e9d21d$export$824d4389f6f1cf91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowShuffleOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L6.09 6.8A8.12 8.12 0 0 0 2.5 6a.5.5 0 1 0 0 1c2.42 0 4.02 1.02 5.52 2.33l.31-.3.7.72C7.2 11.45 5.48 13 2.5 13a.5.5 0 0 0 0 1c3.4 0 5.4-1.83 7.25-3.55l.7.71-.2.2c.53.47 1.1.92 1.72 1.32l5.18 5.17a.5.5 0 0 0 .7-.7l-15-15Zm12.12 10.7 1.14 1.14h.19l-.1.1.71.7.94-.94a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.29 13a7.5 7.5 0 0 1-1.32-.15ZM10.52 8.4l.71.71c1.39-1.16 2.9-2.05 5.06-2.1l-1.14 1.14a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.3 6c-2.54.06-4.28 1.14-5.78 2.4Z"
]);
const $4125b41377e9d21d$export$a82caaf86ff08f76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortFilled', "1em", [
    "M14.84 16.72a.76.76 0 0 1-.59.28.73.73 0 0 1-.53-.22l-3-3a.75.75 0 0 1 1.06-1.07l1.72 1.73V3.75a.75.75 0 0 1 1.5 0v10.68l1.72-1.71a.75.75 0 1 1 1.06 1.06l-2.94 2.94ZM6.34 3.28A.76.76 0 0 0 5.75 3c-.2 0-.38.07-.53.22l-3 3A.75.75 0 0 0 3.28 7.3L5 5.56v10.69a.75.75 0 0 0 1.5 0V5.57l1.72 1.71a.75.75 0 1 0 1.06-1.06L6.34 3.28Z"
]);
const $4125b41377e9d21d$export$5f7722d3cf58b26e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortRegular', "1em", [
    "M2.35 7.35 5 4.71V16.5a.5.5 0 0 0 1 0V4.7l2.65 2.65a.5.5 0 0 0 .7-.7l-3.49-3.5A.5.5 0 0 0 5.5 3a.5.5 0 0 0-.39.18L1.65 6.65a.5.5 0 1 0 .7.7Zm15.3 5.3L15 15.29V3.5a.5.5 0 0 0-1 0v11.8l-2.65-2.65a.5.5 0 0 0-.7.7l3.49 3.5a.5.5 0 0 0 .36.15.5.5 0 0 0 .39-.18l3.46-3.47a.5.5 0 1 0-.7-.7Z"
]);
const $4125b41377e9d21d$export$a4ac5a40e31a5caf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownFilled', "1em", [
    "M9.75 17c.23 0 .45-.1.59-.28l2.94-2.94a.75.75 0 0 0-1.06-1.06l-1.72 1.71V3.75a.75.75 0 0 0-1.5 0v10.7L7.28 12.7a.75.75 0 1 0-1.06 1.06l3 3.01c.15.15.34.22.53.22Z"
]);
const $4125b41377e9d21d$export$3b76f0280a8089c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownRegular', "1em", [
    "m10 15.29 2.65-2.64a.5.5 0 0 1 .7.7L9.9 16.82a.5.5 0 0 1-.74.03h-.01l-3.5-3.5a.5.5 0 1 1 .71-.7L9 15.29V3.5a.5.5 0 0 1 1 0v11.79Z"
]);
const $4125b41377e9d21d$export$7fdc76a38aa6815d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownLinesFilled', "1em", [
    "M15 2.75a.75.75 0 0 0-1.5 0v12.57l-1.45-1.58a.75.75 0 0 0-1.1 1.02l2.75 3a.75.75 0 0 0 1.1 0l2.75-3a.75.75 0 0 0-1.1-1.02L15 15.32V2.75ZM2.75 3.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM5 7.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 5 7.25ZM8.75 9.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
]);
const $4125b41377e9d21d$export$d4b807e9a13c5fe1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortDownLinesRegular', "1em", [
    "M15 2.5a.5.5 0 0 0-1 0v13.8l-2.15-2.15a.5.5 0 0 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7L15 16.29V2.5ZM2.5 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9ZM5 7.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5ZM8.5 10a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
]);
const $4125b41377e9d21d$export$fa5f63f22eca476e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpFilled', "1em", [
    "M9.75 3c.23 0 .45.1.59.28l2.94 2.94a.75.75 0 0 1-1.06 1.06L10.5 5.57v10.68a.75.75 0 0 1-1.5 0V5.55L7.28 7.3a.75.75 0 1 1-1.06-1.06l3-3.01A.73.73 0 0 1 9.75 3Z"
]);
const $4125b41377e9d21d$export$90a2de0eda90cb12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpRegular', "1em", [
    "M9 4.71 6.35 7.35a.5.5 0 1 1-.7-.7L9.1 3.18a.5.5 0 0 1 .74-.03h.01l3.5 3.5a.5.5 0 1 1-.71.7L10 4.71V16.5a.5.5 0 0 1-1 0V4.71Z"
]);
const $4125b41377e9d21d$export$7e4d18ce7c6d51da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpLinesFilled', "1em", [
    "M15 17.25a.75.75 0 0 1-1.5 0V4.68l-1.45 1.58a.75.75 0 0 1-1.1-1.02l2.75-3a.75.75 0 0 1 1.1 0l2.75 3a.75.75 0 0 1-1.1 1.02L15 4.68v12.57ZM2.75 16.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 0 1.5h-8.5ZM5 12.75c0 .41.34.75.75.75h5.5a.75.75 0 0 0 0-1.5h-5.5a.75.75 0 0 0-.75.75Zm3.75-2.25a.75.75 0 0 1 0-1.5h2.5a.75.75 0 0 1 0 1.5h-2.5Z"
]);
const $4125b41377e9d21d$export$44fa18755446c11c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSortUpLinesRegular', "1em", [
    "M15 17.5a.5.5 0 0 1-1 0V3.7l-2.15 2.15a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L15 3.71V17.5ZM2.5 16a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1h-9ZM5 12.5c0 .28.22.5.5.5h6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0-.5.5ZM8.5 10a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Z"
]);
const $4125b41377e9d21d$export$37f69e1bf92fc0d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSplitFilled', "1em", [
    "M10 3c.41 0 .75.34.75.75V8h2.24a2 2 0 0 1 2 2v4.44l1.23-1.22a.75.75 0 1 1 1.06 1.06l-2.5 2.5c-.3.3-.77.3-1.07 0l-2.5-2.5a.75.75 0 1 1 1.07-1.06l1.21 1.22V10a.5.5 0 0 0-.5-.5H7a.5.5 0 0 0-.5.5v4.44l1.23-1.22a.75.75 0 0 1 1.06 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5a.75.75 0 1 1 1.06-1.06L5 14.44V10c0-1.1.9-2 2-2h2.25V3.75c0-.41.34-.75.75-.75Z"
]);
const $4125b41377e9d21d$export$2832d93f19fae54a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSplitRegular', "1em", [
    "M10 3c.28 0 .5.22.5.5V8H13a2 2 0 0 1 2 2v5.3l1.65-1.65a.5.5 0 0 1 .7.7l-2.5 2.5a.5.5 0 0 1-.7 0l-2.5-2.5a.5.5 0 0 1 .7-.7L14 15.29V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v5.3l1.65-1.65a.5.5 0 0 1 .7.7l-2.5 2.5a.5.5 0 0 1-.7 0l-2.5-2.5a.5.5 0 0 1 .7-.7L5 15.29V10c0-1.1.9-2 2-2h2.5V3.5c0-.28.22-.5.5-.5Z"
]);
const $4125b41377e9d21d$export$b9873c5d8e57f261 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSprintFilled', "1em", [
    "M10 6.5a3 3 0 1 0 0 6h6.44l-.72-.72a.75.75 0 1 1 1.06-1.06l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H10a4.5 4.5 0 1 1 4.03-2.5h-1.8a3 3 0 0 0-2.24-5Zm-7.25 6h2.64c.38.59.87 1.1 1.45 1.5H2.75a.75.75 0 0 1 0-1.5Z"
]);
const $4125b41377e9d21d$export$1ce0c5c3bc673d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSprintRegular', "1em", [
    "M10 6a3.5 3.5 0 1 0 0 7h7.3l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L17.29 14H10a4.5 4.5 0 1 1 3.74-2h-1.29A3.49 3.49 0 0 0 10 6Zm-7.5 7h3.26c.31.38.67.72 1.08 1H2.5a.5.5 0 0 1 0-1Z"
]);
const $4125b41377e9d21d$export$2e9dd1dd98ca5130 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareColor', "1em", `<path d="M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z" fill="url(#ic_fluent_arrow_square_20_color__a)"/><path d="M10.5 6.5a.5.5 0 0 0-1 0v5.8L6.85 9.64a.5.5 0 1 0-.7.7l3.5 3.5c.2.2.5.2.7 0l3.5-3.5a.5.5 0 0 0-.7-.7l-2.65 2.64V6.5Z" fill="url(#ic_fluent_arrow_square_20_color__b)"/><defs><linearGradient id="ic_fluent_arrow_square_20_color__a" x1="3.5" y1="5.63" x2="14.5" y2="14.38" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_arrow_square_20_color__b" x1="7.54" y1="6.62" x2="14" y2="20.62" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$ad8d0744550a63e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareDownColor', "1em", `<path d="M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Z" fill="url(#ic_fluent_arrow_square_down_20_color__a)"/><path d="M10.5 6.5a.5.5 0 0 0-1 0v5.8L6.85 9.64a.5.5 0 1 0-.7.7l3.5 3.5c.2.2.5.2.7 0l3.5-3.5a.5.5 0 0 0-.7-.7l-2.65 2.64V6.5Z" fill="url(#ic_fluent_arrow_square_down_20_color__b)"/><defs><linearGradient id="ic_fluent_arrow_square_down_20_color__a" x1="3.5" y1="5.63" x2="14.5" y2="14.38" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_arrow_square_down_20_color__b" x1="7.54" y1="6.62" x2="14" y2="20.62" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$9910268128d410ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareDownFilled', "1em", [
    "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm5.5 3.5v5.8l2.65-2.65a.5.5 0 0 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 .7-.7l2.65 2.64V6.5a.5.5 0 0 1 1 0Z"
]);
const $4125b41377e9d21d$export$9d32183472891caa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareDownRegular', "1em", [
    "M10.5 6.5a.5.5 0 0 0-1 0v5.8L6.85 9.64a.5.5 0 1 0-.7.7l3.5 3.5c.2.2.5.2.7 0l3.5-3.5a.5.5 0 1 0-.7-.7l-2.65 2.64V6.5ZM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5ZM4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5Z"
]);
const $4125b41377e9d21d$export$d9243fdb331c1f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareUpRightFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.7 1.04a.5.5 0 0 0-.2-.04h-5a.5.5 0 0 0 0 1h3.8l-4.15 4.15a.5.5 0 0 0 .7.7L12 8.71v3.79a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.14-.35.5.5 0 0 0-.17-.11Z"
]);
const $4125b41377e9d21d$export$3ede8de92b77ba80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSquareUpRightRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm8.7 1.04a.5.5 0 0 1 .3.46v5a.5.5 0 0 1-1 0V8.7l-4.15 4.15a.5.5 0 0 1-.7-.7L11.29 8H7.5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .2.04Z"
]);
const $4125b41377e9d21d$export$3a35402abf5cb0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepBackFilled', "1em", [
    "M7.85 3.15c.2.2.2.5 0 .7L4.71 7H10a8 8 0 0 1 6.94 4.04.5.5 0 1 1-.88.5A7 7 0 0 0 10 8H4.7l3.15 3.15a.5.5 0 0 1-.7.7L3.15 7.87a.5.5 0 0 1-.01-.72l4-4c.19-.2.5-.2.7 0ZM12 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $4125b41377e9d21d$export$5d2c50fa87f6e97f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepBackRegular', "1em", [
    "M7.85 3.15c.2.2.2.5 0 .7L4.71 7H10a8 8 0 0 1 6.94 4.04.5.5 0 1 1-.88.5A7 7 0 0 0 10 8H4.7l3.15 3.15a.5.5 0 0 1-.7.7L3.15 7.87a.5.5 0 0 1-.01-.72l4-4c.19-.2.5-.2.7 0ZM8 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
]);
const $4125b41377e9d21d$export$a3be9a3d6a44038a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInFilled', "1em", [
    "M12 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM10 2c.28 0 .5.22.5.5v7.8l3.15-3.15a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7l3.15 3.14V2.5c0-.28.22-.5.5-.5Z"
]);
const $4125b41377e9d21d$export$23f7469f896cb988 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInRegular', "1em", [
    "M10 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-14c.28 0 .5.22.5.5v7.8l3.15-3.15a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7l3.15 3.14V2.5c0-.28.22-.5.5-.5Z"
]);
const $4125b41377e9d21d$export$8d83fb3bdd2fc285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInDiagonalDownLeftFilled', "1em", [
    "M16.85 3.15c.2.2.2.5 0 .7L9.71 11h4.79a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v4.8l7.15-7.15c.2-.2.5-.2.7 0ZM5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $4125b41377e9d21d$export$9979b9e73db7fda6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInDiagonalDownLeftRegular', "1em", [
    "M16.85 3.15c.2.2.2.5 0 .7L9.71 11h4.79a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v4.8l7.15-7.15c.2-.2.5-.2.7 0ZM7 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
]);
const $4125b41377e9d21d$export$1a1735a46072d4dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInLeftFilled', "1em", [
    "M4 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm14-2a.5.5 0 0 1-.5.5H9.7l3.15 3.15a.5.5 0 0 1-.7.7l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 0 1 .7.7L9.71 9.5h7.79c.28 0 .5.22.5.5Z"
]);
const $4125b41377e9d21d$export$45b5ef41296ff1f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInLeftRegular', "1em", [
    "M5 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM4 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm14 2a.5.5 0 0 1-.5.5H9.7l3.15 3.15a.5.5 0 0 1-.7.7l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 0 1 .7.7L9.71 9.5h7.79c.28 0 .5.22.5.5Z"
]);
const $4125b41377e9d21d$export$4144b2eaf4c44181 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInRightFilled', "1em", [
    "M16 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM2 10c0-.28.22-.5.5-.5h7.8L7.14 6.35a.5.5 0 1 1 .7-.7l4 4c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H2.5A.5.5 0 0 1 2 10Z"
]);
const $4125b41377e9d21d$export$71bb2b8cc631df20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepInRightRegular', "1em", [
    "M15 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm1 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM2 10c0-.28.22-.5.5-.5h7.8L7.14 6.35a.5.5 0 1 1 .7-.7l4 4c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7l3.14-3.15H2.5A.5.5 0 0 1 2 10Z"
]);
const $4125b41377e9d21d$export$53bac810d5e41ce8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOutFilled', "1em", [
    "M12 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2-4a.5.5 0 0 0 .5-.5V3.7l3.15 3.15a.5.5 0 0 0 .7-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L9.5 3.71v7.79c0 .28.22.5.5.5Z"
]);
const $4125b41377e9d21d$export$11ace01496244ce4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOutRegular', "1em", [
    "M10 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a.5.5 0 0 0 .5-.5V3.7l3.15 3.15a.5.5 0 0 0 .7-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L9.5 3.71v7.79c0 .28.22.5.5.5Z"
]);
const $4125b41377e9d21d$export$24f66ea488a40da8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOverFilled', "1em", [
    "M12.15 3.15a.5.5 0 0 0 0 .7L15.29 7H10a8 8 0 0 0-6.94 4.04.5.5 0 1 0 .88.5A7 7 0 0 1 10 8h5.3l-3.15 3.15a.5.5 0 1 0 .7.7l3.99-3.98a.5.5 0 0 0 .01-.72l-4-4a.5.5 0 0 0-.7 0ZM8 15a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$121a2436d1e30a30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowStepOverRegular', "1em", [
    "M12.15 3.15a.5.5 0 0 0 0 .7L15.29 7H10a8 8 0 0 0-6.94 4.04.5.5 0 1 0 .88.5A7 7 0 0 1 10 8h5.3l-3.15 3.15a.5.5 0 1 0 .7.7l3.99-3.98a.5.5 0 0 0 .01-.72l-4-4a.5.5 0 0 0-.7 0ZM12 15a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm-2-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$857eb1bb3d9a770d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSwapFilled', "1em", [
    "M12.78 3.22a.75.75 0 1 0-1.06 1.06L13.44 6H4.75a.75.75 0 0 0 0 1.5h8.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3c.3-.3.3-.77 0-1.06l-3-3Zm-4.5 7.56a.75.75 0 1 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06-1.06L6.56 14h8.69a.75.75 0 0 0 0-1.5H6.56l1.72-1.72Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$1039164ceb56cfd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSwapRegular', "1em", [
    "M12.15 3.15c.2-.2.5-.2.7 0l3 3c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7-.7L14.29 7H4.5a.5.5 0 0 1 0-1h9.8l-2.15-2.15a.5.5 0 0 1 0-.7Zm-4.3 7c.2.2.2.5 0 .7L5.71 13h9.79a.5.5 0 0 1 0 1H5.7l2.15 2.15a.5.5 0 0 1-.7.7l-3-3a.5.5 0 0 1 0-.7l3-3c.2-.2.5-.2.7 0Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$fb1425a65692e285 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncColor', "1em", `<path fill-rule="evenodd" clip-rule="evenodd" d="M8.3.3a1 1 0 0 1 1.4 0l2.5 2.5a1 1 0 0 1 0 1.4L9.7 6.7a1 1 0 0 1-1.4-1.4l.7-.7a5.5 5.5 0 0 0-2.51 9.63 1 1 0 0 1-1.28 1.54A7.49 7.49 0 0 1 9.14 2.55l-.85-.84a1 1 0 0 1 0-1.42Zm5.11 4.08a1 1 0 0 1 1.41-.12 7.49 7.49 0 0 1-3.96 13.2l.85.83a1 1 0 0 1-1.42 1.42l-2.5-2.5a1 1 0 0 1 0-1.42l2.5-2.5a1 1 0 0 1 1.42 1.42l-.7.7a5.5 5.5 0 0 0 2.53-9.62 1 1 0 0 1-.13-1.41Z" fill="url(#ic_fluent_arrow_sync_20_color__a)"/><defs><linearGradient id="ic_fluent_arrow_sync_20_color__a" x1="14" y1="16.5" x2="6" y2="0" gradientUnits="userSpaceOnUse"><stop stop-color="#22918B"/><stop offset="1" stop-color="#20AC9D"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$1e5b39d5a72a35d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncFilled', "1em", [
    "M9.89 3.75a6.25 6.25 0 0 0-3.63 11.26.75.75 0 0 1-.9 1.2 7.75 7.75 0 0 1 4-13.93l-.6-.59A.75.75 0 0 1 9.82.63l2.12 2.12c.3.3.3.77 0 1.06L9.82 5.93a.75.75 0 0 1-1.06-1.06L9.9 3.75Zm.22 12.5a6.25 6.25 0 0 0 3.63-11.26.75.75 0 0 1 .9-1.2 7.75 7.75 0 0 1-4 13.93l.6.59a.75.75 0 1 1-1.06 1.06l-2.12-2.12a.75.75 0 0 1 0-1.06l2.12-2.13a.75.75 0 1 1 1.06 1.07l-1.13 1.12Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$443272156fef2fb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncRegular', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8A6.5 6.5 0 0 1 10.14 3.5L8.59 5.04a.5.5 0 0 0 .7.7l2.12-2.11ZM8.6 16.36a.5.5 0 0 0 0 .71l2.12 2.12a.5.5 0 0 0 .7-.7l-1-1a7.5 7.5 0 0 0 4.07-13.5.5.5 0 1 0-.59.8A6.5 6.5 0 0 1 9.86 16.5l1.55-1.55a.5.5 0 1 0-.7-.7l-2.12 2.11Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ec407c48735e25c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCheckmarkFilled', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8A6.5 6.5 0 0 1 11.4 3.66l.01-.02ZM8.6 16.36l.01-.01c.41.09.83.14 1.27.15h-.01.07A6.5 6.5 0 0 0 13.9 4.8a.5.5 0 1 1 .6-.8 7.5 7.5 0 0 1-4.07 13.5l1 .98a.5.5 0 1 1-.71.71l-2.12-2.12a.5.5 0 0 1 0-.7ZM15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-2.65-1.85a.5.5 0 0 0-.7 0L9 10.79 7.85 9.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9a33574dc1966552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCheckmarkRegular', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8A6.5 6.5 0 0 1 11.4 3.66l.01-.02ZM8.6 16.36l.01-.01c.41.09.83.14 1.27.15h-.01a6.48 6.48 0 0 0 4.74-1.9 6.5 6.5 0 0 0-.7-9.8.5.5 0 1 1 .6-.8 7.5 7.5 0 0 1-4.07 13.5l.98.98a.5.5 0 1 1-.7.71l-2.12-2.12a.5.5 0 0 1 0-.7Zm3.76-8.21c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L9 10.79l2.65-2.64c.2-.2.5-.2.7 0ZM5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7d9613a6f676efb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCircleFilled', "1em", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm3.5-8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.7a3.5 3.5 0 0 0-5.6-.53.5.5 0 1 0 .74.66 2.5 2.5 0 0 1 4.15.67h-.79a.5.5 0 1 0 0 1h2Zm-7.5.5v2a.5.5 0 0 0 1 0v-.7a3.5 3.5 0 0 0 5.6.53.5.5 0 0 0-.74-.66A2.5 2.5 0 0 1 7.71 11h.79a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$caf00c62123be032 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncCircleRegular', "1em", [
    "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm8 7a8 8 0 1 0-16 0 8 8 0 0 0 16 0Zm-8-2.5c1.02 0 1.9.62 2.3 1.5h-.8a.5.5 0 1 0 0 1h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.7a3.5 3.5 0 0 0-5.6-.53.5.5 0 0 0 .74.66A2.5 2.5 0 0 1 10 7.5Zm-3 4.3v.7a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.8a2.5 2.5 0 0 0 4.16.67.5.5 0 0 1 .75.66A3.5 3.5 0 0 1 7 11.8Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f918c8ab953aea44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncDismissFilled', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1a7.5 7.5 0 0 0-4.08 13.5.5.5 0 0 0 .6-.8 6.5 6.5 0 0 1 5.28-11.55l.02-.02ZM8.6 16.36l.02-.02a6.48 6.48 0 0 0 5.99-1.74 6.5 6.5 0 0 0-.7-9.8.5.5 0 1 1 .6-.8 7.5 7.5 0 0 1-4.07 13.5l.98.98a.5.5 0 1 1-.7.71l-2.12-2.12a.5.5 0 0 1 0-.7ZM15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-3.15-1.15a.5.5 0 0 0-.7-.7L10 9.29 8.85 8.15a.5.5 0 0 0-.7.7L9.29 10l-1.14 1.15a.5.5 0 1 0 .7.7L10 10.71l1.15 1.14a.5.5 0 0 0 .7-.7L10.71 10l1.14-1.15Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$a515c39e0bcfe044 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncDismissRegular', "1em", [
    "M11.41 2.93c.2.2.2.51 0 .7l-.01.02a6.48 6.48 0 0 0-6 1.75 6.5 6.5 0 0 0 .7 9.8.5.5 0 1 1-.6.8A7.5 7.5 0 0 1 9.59 2.5l-1-.99a.5.5 0 0 1 .71-.7l2.12 2.12Zm-2.8 13.42-.02.01a.5.5 0 0 0 0 .71l2.12 2.12a.5.5 0 0 0 .7-.7l-1-1a7.5 7.5 0 0 0 4.07-13.5.5.5 0 1 0-.59.8 6.5 6.5 0 0 1-5.3 11.55Zm3.24-8.2c.2.2.2.5 0 .7L10.71 10l1.14 1.15a.5.5 0 0 1-.7.7L10 10.71l-1.15 1.14a.5.5 0 0 1-.7-.7L9.29 10 8.15 8.85a.5.5 0 1 1 .7-.7L10 9.29l1.15-1.14c.2-.2.5-.2.7 0ZM5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4ec27fc1158233e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncOffFilled', "1em", [
    "M9.89 3.75a6.24 6.24 0 0 0-3.12.9L5.68 3.56a7.73 7.73 0 0 1 3.67-1.28l-.59-.59A.75.75 0 0 1 9.82.63l2.12 2.12c.3.3.3.77 0 1.06L9.82 5.93a.75.75 0 0 1-1.06-1.06L9.9 3.75ZM4.18 4.88a7.75 7.75 0 0 0 1.18 11.33.75.75 0 1 0 .9-1.2 6.25 6.25 0 0 1-1.02-9.06l8.81 8.8a6.23 6.23 0 0 1-3.94 1.5l1.13-1.12a.75.75 0 0 0-1.06-1.07L8.06 16.2c-.3.29-.3.76 0 1.06l2.12 2.12a.75.75 0 1 0 1.06-1.06l-.59-.59a7.72 7.72 0 0 0 4.47-1.9l2.03 2.03a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7l2.03 2.03Zm11.17 8.35 1.09 1.09a7.75 7.75 0 0 0-1.8-10.53.75.75 0 0 0-.9 1.2 6.25 6.25 0 0 1 1.6 8.24Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6df263960ce9d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowSyncOffRegular', "1em", [
    "M11.41 3.64a.5.5 0 0 0 0-.71L9.3.8a.5.5 0 0 0-.7.7l1 1c-1.3.07-2.6.48-3.73 1.23l.73.73a6.49 6.49 0 0 1 3.55-.98L8.59 5.05a.5.5 0 0 0 .7.7l2.12-2.11ZM4.35 5.06a7.5 7.5 0 0 0 1.16 10.95.5.5 0 0 0 .6-.8 6.5 6.5 0 0 1-1.04-9.44l9.16 9.17a6.48 6.48 0 0 1-4.37 1.56l1.55-1.55a.5.5 0 1 0-.7-.7l-2.12 2.11a.5.5 0 0 0 0 .71l2.12 2.12a.5.5 0 0 0 .7-.7l-1-1a7.47 7.47 0 0 0 4.53-1.85l2.2 2.21a.5.5 0 0 0 .71-.7l-15-15a.5.5 0 1 0-.7.7l2.2 2.21ZM15.3 4.7a7.5 7.5 0 0 1 .96 9.44l-.73-.73A6.5 6.5 0 0 0 13.9 4.8a.5.5 0 1 1 .6-.8c.29.21.56.45.81.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$a0317b775455963a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingFilled', "1em", [
    "M17.94 5.46a.75.75 0 0 0-.7-.46h-5.49a.75.75 0 0 0 0 1.5h3.69l-4.94 4.94-1.97-1.97a.75.75 0 0 0-1.06 0l-5.25 5.25a.75.75 0 1 0 1.06 1.06L8 11.06l1.97 1.97c.3.3.77.3 1.06 0l5.47-5.47v3.69a.75.75 0 0 0 1.5 0v-5.5c0-.1-.02-.2-.06-.29Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b93cd1eaf7dc2db0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingRegular', "1em", [
    "M17.96 5.3a.5.5 0 0 0-.46-.3h-6a.5.5 0 0 0 0 1h4.8l-5.8 5.8-2.15-2.15a.5.5 0 0 0-.7 0l-5.5 5.5a.5.5 0 0 0 .7.7L8 10.71l2.15 2.14c.2.2.5.2.7 0L17 6.71v4.79a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.04-.2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$5dc7a8f8587b1b3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingCheckmarkFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.8l-4.5 4.1a.75.75 0 0 1-1.03-.02L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25a.75.75 0 0 1 1.06 0l1.5 1.5 3.79-3.47h-2.57a.75.75 0 1 1 0-1.5h4.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.62-1.83a.5.5 0 0 0-.7-.05l-3.15 2.7-1.18-1.17a.5.5 0 0 0-.7.7l1.5 1.5c.18.19.48.2.68.03l3.5-3a.5.5 0 0 0 .05-.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b68dee8aae62cb8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingCheckmarkRegular', "1em", [
    "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V4.7l-4.65 4.65a.5.5 0 0 1-.7 0L9 7.71l-5.15 5.14a.5.5 0 0 1-.7-.7l5.5-5.5a.5.5 0 0 1 .7 0L11 8.29 15.3 4h-2.8a.5.5 0 0 1 0-1h4ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-1.62-1.83a.5.5 0 0 0-.7-.05l-3.15 2.7-1.18-1.17a.5.5 0 0 0-.7.7l1.5 1.5c.18.19.48.2.68.03l3.5-3a.5.5 0 0 0 .05-.7Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$91378963d8ff563c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingDownFilled', "1em", [
    "M17.94 14.54a.75.75 0 0 1-.7.46h-5.49a.75.75 0 0 1 0-1.5h3.69L10.5 8.56l-1.97 1.97c-.3.3-.77.3-1.06 0L2.22 5.28a.75.75 0 0 1 1.06-1.06L8 8.94l1.97-1.97c.3-.3.77-.3 1.06 0l5.47 5.47V8.75a.75.75 0 0 1 1.5 0v5.5c0 .1-.02.2-.06.29Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$31ff5dc4b3890428 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingDownRegular', "1em", [
    "M17.96 14.7a.5.5 0 0 1-.46.3h-6a.5.5 0 0 1 0-1h4.8l-5.8-5.8-2.15 2.15a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L8 9.29l2.15-2.14c.2-.2.5-.2.7 0L17 13.29V8.5a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.04.2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4f7c0c2778921a3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingLinesColor', "1em", `<path d="M17 10a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-7Z" fill="url(#ic_fluent_arrow_trending_lines_20_color__a)"/><path d="M9 12a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z" fill="url(#ic_fluent_arrow_trending_lines_20_color__b)"/><path d="M5 15a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z" fill="url(#ic_fluent_arrow_trending_lines_20_color__c)"/><path d="M12 13a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z" fill="url(#ic_fluent_arrow_trending_lines_20_color__d)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14 4a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-.59l-3.8 3.8a1 1 0 0 1-1.4 0L8.5 6.9l-4.3 4.3a1 1 0 0 1-1.4-1.42l5-5a1 1 0 0 1 1.4 0l2.3 2.3L14.59 4H14Z" fill="url(#ic_fluent_arrow_trending_lines_20_color__e)"/><defs><linearGradient id="ic_fluent_arrow_trending_lines_20_color__a" x1="17.91" y1="8.48" x2="2.09" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0094F0"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_arrow_trending_lines_20_color__b" x1="17.91" y1="8.48" x2="2.09" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0094F0"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_arrow_trending_lines_20_color__c" x1="17.91" y1="8.48" x2="2.09" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0094F0"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_arrow_trending_lines_20_color__d" x1="17.91" y1="8.48" x2="2.09" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0094F0"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_arrow_trending_lines_20_color__e" x1="3.05" y1="11.5" x2="18" y2="1.22" gradientUnits="userSpaceOnUse"><stop stop-color="#22918B"/><stop offset="1" stop-color="#20AC9D"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$c5e571b712ec807d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingLinesFilled', "1em", [
    "M14 2.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-.69l-4.47 4.47c-.3.3-.77.3-1.06 0L8.5 6.56l-4.22 4.22a.75.75 0 1 1-1.06-1.06l4.75-4.75c.3-.3.77-.3 1.06 0l2.47 2.47 3.94-3.94h-.69a.75.75 0 0 1-.75-.75ZM3.75 14c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75Zm4.75-2.25a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5ZM11.75 13c.41 0 .75.34.75.75v3.5a.75.75 0 0 1-1.5 0v-3.5c0-.41.34-.75.75-.75Zm4.75-3.25a.75.75 0 0 0-1.5 0v7.5a.75.75 0 0 0 1.5 0v-7.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$f868d183594f21f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingLinesRegular', "1em", [
    "M14.5 2a.5.5 0 0 0 0 1h1.8l-4.8 4.8-2.65-2.65a.5.5 0 0 0-.7 0l-5 5a.5.5 0 0 0 .7.7L8.5 6.21l2.65 2.64c.2.2.5.2.7 0L17 3.71V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5h-3Zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5Zm-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5Zm3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4Zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$54d9e567d82f9e2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSettingsFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5h4.5Zm-4.68 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$dd1fa542155a1f19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSettingsRegular', "1em", [
    "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V4.7l-4.65 4.65a.5.5 0 0 1-.7 0L9 7.71l-5.15 5.14a.5.5 0 0 1-.7-.7l5.5-5.5a.5.5 0 0 1 .7 0L11 8.29 15.3 4h-2.8a.5.5 0 0 1 0-1h4Zm-4.43 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$cb086a24df351a99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSparkleFilled', "1em", [
    "m5.88 2.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 8.72a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L2.28 5.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0ZM16.75 6a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V8.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 11.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5h4.5Zm-.73 8.96.76.25h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.58 1.58 0 0 0 1 1Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$5b3388f8caa131ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingSparkleRegular', "1em", [
    "m5.88 2.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 8.72a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L2.28 5.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0ZM17 6.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.8L11 11.3 9.35 9.64a.5.5 0 0 0-.7 0l-5.5 5.5a.5.5 0 0 0 .7.7L9 10.71l1.65 1.64a.5.5 0 0 0 .7 0L16 7.71v2.79a.5.5 0 0 0 1 0v-4Zm-.98 8.46.76.25h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.58 1.58 0 0 0 1 1Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$53c229b6980143f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingTextFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5h4.5ZM10 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4Zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1Zm-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1h-4Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e4b276dde3c314c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingTextRegular', "1em", [
    "M17 3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0 0 1h2.8L11 8.3 9.35 6.64a.5.5 0 0 0-.7 0l-5.5 5.5a.5.5 0 0 0 .7.7L9 7.71l1.65 1.64a.5.5 0 0 0 .7 0L16 4.71V7.5a.5.5 0 0 0 1 0v-4ZM10 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4Zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1Zm-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1h-4Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$6475d0e96f072621 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingWrenchFilled', "1em", [
    "M16.75 3a.75.75 0 0 1 .75.75v4.5c0 .26-.14.5-.34.63a1.38 1.38 0 0 0-1.15-.9H16V5.56l-4.22 4.22c-.3.3-.77.3-1.06 0L9 8.06l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25c.3-.3.77-.3 1.06 0l1.72 1.72 3.69-3.69h-2.69a.75.75 0 0 1 0-1.5h4.5Zm-.65 6.71c.26-.26.16-.7-.2-.74a3.5 3.5 0 0 0-3.71 4.66l-2.72 2.7a1.5 1.5 0 0 0 2.13 2.13l2.7-2.71a3.5 3.5 0 0 0 4.66-3.7c-.04-.37-.48-.48-.74-.22l-.97.97a1.5 1.5 0 1 1-2.12-2.12l.97-.97Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$bd98be12e0ed88ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTrendingWrenchRegular', "1em", [
    "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V4.7l-4.65 4.65a.5.5 0 0 1-.7 0L9 7.71l-5.15 5.14a.5.5 0 0 1-.7-.7l5.5-5.5a.5.5 0 0 1 .7 0L11 8.29 15.3 4h-2.8a.5.5 0 0 1 0-1h4Zm-.4 6.71c.26-.26.16-.7-.2-.74a3.5 3.5 0 0 0-3.71 4.66l-2.72 2.7a1.5 1.5 0 0 0 2.13 2.13l2.7-2.71a3.5 3.5 0 0 0 4.66-3.7c-.04-.37-.48-.48-.74-.22l-.97.97a1.5 1.5 0 1 1-2.12-2.12l.97-.97Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$df95da6fe65b7b90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnBidirectionalDownRightFilled', "1em", [
    "M13.78 2.22a.75.75 0 1 0-1.06 1.06L15.44 6H9a3 3 0 0 0-3 3v6.44l-2.72-2.72a.75.75 0 0 0-1.06 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L7.5 15.44V9c0-.83.67-1.5 1.5-1.5h6.44l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4Z"
]);
const $4125b41377e9d21d$export$7691ae86acd529e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnBidirectionalDownRightRegular', "1em", [
    "M13.85 2.15a.5.5 0 0 0-.7.7L16.29 6H9a3 3 0 0 0-3 3v7.3l-3.15-3.15a.5.5 0 0 0-.7.7l4 4c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7L7 16.29V9c0-1.1.9-2 2-2h7.3l-3.15 3.15a.5.5 0 0 0 .7.7l4-4a.5.5 0 0 0 0-.7l-4-4Z"
]);
const $4125b41377e9d21d$export$33b299bff1fcd54c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownLeftFilled', "1em", [
    "M9.28 16.78c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L6.56 11.5H13c.83 0 1.5-.67 1.5-1.5V3.75a.75.75 0 0 1 1.5 0V10a3 3 0 0 1-3 3H6.56l2.72 2.72c.3.3.3.77 0 1.06Z"
]);
const $4125b41377e9d21d$export$b1763a86e46e16f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownLeftRegular', "1em", [
    "M8.85 16.85a.5.5 0 0 1-.7 0l-4-4a.5.5 0 0 1 0-.7l4-4a.5.5 0 1 1 .7.7L5.71 12H12a2 2 0 0 0 2-2V3.5a.5.5 0 0 1 1 0V10a3 3 0 0 1-3 3H5.7l3.15 3.15c.2.2.2.5 0 .7Z"
]);
const $4125b41377e9d21d$export$2250fb084f5452a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownRightFilled', "1em", [
    "M10.72 16.78c.3.3.77.3 1.06 0l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06l2.72 2.72H7A1.5 1.5 0 0 1 5.5 10V3.75a.75.75 0 0 0-1.5 0V10a3 3 0 0 0 3 3h6.44l-2.72 2.72c-.3.3-.3.77 0 1.06Z"
]);
const $4125b41377e9d21d$export$5e9b570e502d236d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownRightRegular', "1em", [
    "M11.15 16.85c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7l-4-4a.5.5 0 0 0-.7.7L14.29 12H8a2 2 0 0 1-2-2V3.5a.5.5 0 0 0-1 0V10a3 3 0 0 0 3 3h6.3l-3.15 3.15a.5.5 0 0 0 0 .7Z"
]);
const $4125b41377e9d21d$export$55de8f2a161fd955 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownUpFilled', "1em", [
    "M16.45 3.47a.75.75 0 0 0-1.03-.4l-5 2.5a.75.75 0 1 0 .67 1.35l3.24-1.62L10 15.12 5.44 4.45a.75.75 0 0 0-1.38.6l4.8 11.19c.43 1 1.85 1 2.29 0l4.6-10.46 1.3 3.25a.75.75 0 1 0 1.4-.56l-2-5Z"
]);
const $4125b41377e9d21d$export$4ba6f05dd6da68bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnDownUpRegular', "1em", [
    "M15.57 3a.5.5 0 0 1 .4.31l2 5a.5.5 0 1 1-.93.38L15.5 4.85l-4.59 11.52a1 1 0 0 1-1.85.03L4.04 4.7a.5.5 0 0 1 .92-.4L9.98 16l4.57-11.47-3.83 1.92a.5.5 0 1 1-.44-.9l4.98-2.49a.5.5 0 0 1 .3-.06Z"
]);
const $4125b41377e9d21d$export$1f160008dc5653bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftDownFilled', "1em", [
    "M3.22 10.72c-.3.3-.3.77 0 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L8.5 13.44V7c0-.83.67-1.5 1.5-1.5h6.25a.75.75 0 0 0 0-1.5H10a3 3 0 0 0-3 3v6.44l-2.72-2.72a.75.75 0 0 0-1.06 0Z"
]);
const $4125b41377e9d21d$export$9a78e8fe7088db5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftDownRegular', "1em", [
    "M3.15 11.15a.5.5 0 0 0 0 .7l4 4c.2.2.5.2.7 0l4-4a.5.5 0 0 0-.7-.7L8 14.29V8c0-1.1.9-2 2-2h6.5a.5.5 0 0 0 0-1H10a3 3 0 0 0-3 3v6.3l-3.15-3.15a.5.5 0 0 0-.7 0Z"
]);
const $4125b41377e9d21d$export$d1b36ba864106051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftRightFilled', "1em", [
    "M15.53 15.45a.75.75 0 0 0 .4-1.03l-2.5-5a.75.75 0 1 0-1.35.67l1.62 3.24L3.88 9l10.67-4.57a.75.75 0 1 0-.6-1.38L2.77 7.86a1.25 1.25 0 0 0 0 2.29l10.46 4.6-3.25 1.3a.75.75 0 1 0 .56 1.4l5-2Z"
]);
const $4125b41377e9d21d$export$ea7826c9c314f9b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftRightRegular', "1em", [
    "M16 14.57a.5.5 0 0 1-.31.4l-5 2a.5.5 0 0 1-.38-.93l3.84-1.54L2.63 9.91a1 1 0 0 1-.03-1.85l11.7-5.02a.5.5 0 0 1 .4.92L3 8.98l11.47 4.57-1.92-3.83a.5.5 0 0 1 .9-.44l2.49 4.98c.05.1.07.2.06.3Z"
]);
const $4125b41377e9d21d$export$cb815fa73b49ea78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftUpFilled', "1em", [
    "M3.22 9.28a.75.75 0 0 1 0-1.06l4-4c.3-.3.77-.3 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L8.5 6.56V13c0 .83.67 1.5 1.5 1.5h6.25a.75.75 0 0 1 0 1.5H10a3 3 0 0 1-3-3V6.56L4.28 9.28c-.3.3-.77.3-1.06 0Z"
]);
const $4125b41377e9d21d$export$5afcd746c17de329 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnLeftUpRegular', "1em", [
    "M3.15 8.85a.5.5 0 0 1 0-.7l4-4c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L8 5.71V12c0 1.1.9 2 2 2h6.5a.5.5 0 0 1 0 1H10a3 3 0 0 1-3-3V5.7L3.85 8.86a.5.5 0 0 1-.7 0Z"
]);
const $4125b41377e9d21d$export$e6f0f0a91732380b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightFilled', "1em", [
    "M10.72 3.22c.3-.3.77-.3 1.06 0l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72H7c-.83 0-1.5.67-1.5 1.5v6.25a.75.75 0 0 1-1.5 0V10a3 3 0 0 1 3-3h6.44l-2.72-2.72a.75.75 0 0 1 0-1.06Z"
]);
const $4125b41377e9d21d$export$99cc176e66c8df96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightRegular', "1em", [
    "M11.15 3.15c.2-.2.5-.2.7 0l4 4c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7-.7L14.29 8H8a2 2 0 0 0-2 2v6.5a.5.5 0 0 1-1 0V10a3 3 0 0 1 3-3h6.3l-3.15-3.15a.5.5 0 0 1 0-.7Z"
]);
const $4125b41377e9d21d$export$99f409a3eb318d48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightDownFilled', "1em", [
    "M16.78 10.72c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l2.72 2.72V7c0-.83-.67-1.5-1.5-1.5H3.75a.75.75 0 0 1 0-1.5H10a3 3 0 0 1 3 3v6.44l2.72-2.72c.3-.3.77-.3 1.06 0Z"
]);
const $4125b41377e9d21d$export$f32394120bfd4b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightDownRegular', "1em", [
    "M16.85 11.15c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 0 1 .7-.7L12 14.29V8a2 2 0 0 0-2-2H3.5a.5.5 0 0 1 0-1H10a3 3 0 0 1 3 3v6.3l3.15-3.15c.2-.2.5-.2.7 0Z"
]);
const $4125b41377e9d21d$export$67f8262fe58fd894 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightLeftFilled', "1em", [
    "M4.47 15.45a.75.75 0 0 1-.4-1.03l2.5-5a.75.75 0 1 1 1.35.67L6.3 13.33 16.12 9 5.45 4.44a.75.75 0 0 1 .6-1.38l11.19 4.8c1 .43 1 1.85 0 2.29l-10.46 4.6 3.25 1.3a.75.75 0 1 1-.56 1.4l-5-2Z"
]);
const $4125b41377e9d21d$export$7f2f80c579cc1dbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightLeftRegular', "1em", [
    "M4 14.57a.5.5 0 0 0 .31.4l5 2a.5.5 0 1 0 .38-.93L5.85 14.5l11.52-4.59a1 1 0 0 0 .03-1.85L5.7 3.04a.5.5 0 0 0-.4.92L17 8.98 5.53 13.55l1.92-3.83a.5.5 0 1 0-.9-.44l-2.49 4.98a.5.5 0 0 0-.06.3Z"
]);
const $4125b41377e9d21d$export$db5f955977600eed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightUpFilled', "1em", [
    "M16.78 9.28c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 0 0 1.06 1.06l2.72-2.72V13c0 .83-.67 1.5-1.5 1.5H3.75a.75.75 0 0 0 0 1.5H10a3 3 0 0 0 3-3V6.56l2.72 2.72c.3.3.77.3 1.06 0Z"
]);
const $4125b41377e9d21d$export$7aa68723eef838f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnRightUpRegular', "1em", [
    "M16.85 8.85a.5.5 0 0 0 0-.7l-4-4a.5.5 0 0 0-.7 0l-4 4a.5.5 0 1 0 .7.7L12 5.71V12a2 2 0 0 1-2 2H3.5a.5.5 0 0 0 0 1H10a3 3 0 0 0 3-3V5.7l3.15 3.15c.2.2.5.2.7 0Z"
]);
const $4125b41377e9d21d$export$70d2b4ed66ec3788 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpDownFilled', "1em", [
    "M16.45 16.53a.75.75 0 0 1-1.03.4l-5-2.5a.75.75 0 1 1 .67-1.35l3.24 1.62L10 4.88 5.44 15.55a.75.75 0 1 1-1.38-.6l4.8-11.19c.43-1 1.85-1 2.29 0l4.6 10.46 1.3-3.25a.75.75 0 0 1 1.4.56l-2 5Z"
]);
const $4125b41377e9d21d$export$2bc99cbef6c9bc1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpDownRegular', "1em", [
    "M15.57 17a.5.5 0 0 0 .4-.31l2-5a.5.5 0 0 0-.93-.38l-1.54 3.84-4.59-11.52a1 1 0 0 0-1.85-.03L4.04 15.3a.5.5 0 0 0 .92.4L9.98 4l4.57 11.47-3.83-1.92a.5.5 0 0 0-.44.9l4.98 2.49c.1.05.2.07.3.06Z"
]);
const $4125b41377e9d21d$export$c54cf7d5ad876cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpLeftFilled', "1em", [
    "M9.28 3.22a.75.75 0 0 0-1.06 0l-4 4c-.3.3-.3.77 0 1.06l4 4a.75.75 0 0 0 1.06-1.06L6.56 8.5H13c.83 0 1.5.67 1.5 1.5v6.25a.75.75 0 0 0 1.5 0V10a3 3 0 0 0-3-3H6.56l2.72-2.72c.3-.3.3-.77 0-1.06Z"
]);
const $4125b41377e9d21d$export$922d95744c2b695a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowTurnUpLeftRegular', "1em", [
    "M8.85 3.15a.5.5 0 0 0-.7 0l-4 4a.5.5 0 0 0 0 .7l4 4a.5.5 0 0 0 .7-.7L5.71 8H12a2 2 0 0 1 2 2v6.5a.5.5 0 0 0 1 0V10a3 3 0 0 0-3-3H5.7l3.15-3.15a.5.5 0 0 0 0-.7Z"
]);
const $4125b41377e9d21d$export$d844f3e1916fe2e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUndoFilled', "1em", [
    "M6.86 6.5h2.39a.75.75 0 0 1 0 1.5h-4.4A.85.85 0 0 1 4 7.15v-4.4a.75.75 0 0 1 1.5 0V5.7l3.06-2.66a5.25 5.25 0 0 1 6.89 7.92l-8.17 7.1a.75.75 0 1 1-.99-1.13l8.17-7.1a3.75 3.75 0 1 0-4.92-5.66L6.86 6.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$4e0ffa8b18193122 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUndoRegular', "1em", [
    "M5 2.5a.5.5 0 0 0-1 0v4.9c0 .33.27.6.6.6h4.9a.5.5 0 0 0 0-1H5.9l3.48-3.02a4 4 0 0 1 5.25 6.04l-8.17 7.1a.5.5 0 0 0 .65.76l8.17-7.1a5 5 0 0 0-6.56-7.55L5 6.46V2.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$37ed199ad724f284 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpFilled', "1em", [
    "M3.2 8.73a.75.75 0 1 0 1.1 1.04l4.95-5.24v12.72a.75.75 0 0 0 1.5 0V4.52l4.95 5.25a.75.75 0 1 0 1.1-1.04l-6.08-6.41a1 1 0 0 0-1.45 0L3.2 8.73Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$caecfbc1460768bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRegular', "1em", [
    "M3.13 9.16a.5.5 0 1 0 .74.68L9.5 3.67V17.5a.5.5 0 1 0 1 0V3.67l5.63 6.17a.5.5 0 0 0 .74-.68l-6.32-6.92a.75.75 0 0 0-1.1 0L3.13 9.16Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$ebf0cb0f343a9359 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpExclamationFilled', "1em", [
    "M3 5a3 3 0 0 1 6 0c0 2.25-.79 5.21-1.22 6.69C7.54 12.49 6.8 13 6 13s-1.54-.52-1.78-1.31C3.8 10.2 3 7.23 3 5Zm1 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM15 3.7v13.8a.5.5 0 0 1-1 0V3.7l-2.15 2.15a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L15 3.71Z"
]);
const $4125b41377e9d21d$export$84097cf494f338ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpExclamationRegular', "1em", [
    "M4 5a2 2 0 1 1 4 0c0 2.09-.75 4.93-1.18 6.4-.1.36-.43.6-.82.6a.84.84 0 0 1-.82-.6C4.75 9.91 4 7.07 4 5Zm2-3a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69C4.46 12.48 5.2 13 6 13s1.54-.52 1.78-1.31C8.2 10.2 9 7.25 9 5a3 3 0 0 0-3-3ZM5 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm9-10.3v13.8a.5.5 0 0 1-1 0V3.7l-2.15 2.15a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L15 3.71Z"
]);
const $4125b41377e9d21d$export$3af68c4b0f2b78ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpLeftFilled', "1em", [
    "M12 3.75a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 1.5 0V5.56l11.22 11.22a.75.75 0 0 0 1.06-1.06L5.56 4.5h5.69c.41 0 .75-.34.75-.75Z"
]);
const $4125b41377e9d21d$export$14503af7aee997b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpLeftRegular', "1em", [
    "M11.5 4a.5.5 0 0 0 0-1h-8a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0V4.7l12.15 12.15a.5.5 0 0 0 .7-.7L4.71 4h6.79Z"
]);
const $4125b41377e9d21d$export$66b43e4a711408a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightFilled', "1em", [
    "M8 3.75c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v7.5a.75.75 0 1 1-1.5 0V5.56L4.28 16.78a.75.75 0 0 1-1.06-1.06L14.44 4.5h-5.7A.75.75 0 0 1 8 3.75Z"
]);
const $4125b41377e9d21d$export$99f8c1a2b2680ec1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightRegular', "1em", [
    "M8.5 4a.5.5 0 1 1 0-1h8c.28 0 .5.22.5.5v8a.5.5 0 0 1-1 0V4.7L3.85 16.86a.5.5 0 0 1-.7-.7L15.29 4H8.5Z"
]);
const $4125b41377e9d21d$export$71f7930d322505b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightDashesFilled', "1em", [
    "M8.75 3a.75.75 0 0 0 0 1.5h5.69l-1.47 1.47a.75.75 0 0 0 1.06 1.06l1.47-1.47v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5Zm3.03 6.28a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 1 0 1.06 1.06l2.5-2.5Zm-5 5a.75.75 0 1 0-1.06-1.06l-2.75 2.75a.75.75 0 1 0 1.06 1.06l2.75-2.75Z"
]);
const $4125b41377e9d21d$export$df89ab6ed94bf284 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUpRightDashesRegular', "1em", [
    "M17 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7L16 4.71v6.79a.5.5 0 1 0 1 0v-8ZM6.85 13.86a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0 .7.7l3-3Zm5-5.7c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0Z"
]);
const $4125b41377e9d21d$export$f8419f606f735b9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUploadFilled', "1em", [
    "M4.5 2a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 2H4.5Zm6 15.35a.75.75 0 0 1-1.5-.1V7.05l-2.97 2.98-.08.07a.75.75 0 0 1-.98-1.14l4.29-4.28a.73.73 0 0 1 .26-.15l.08-.02.15-.02h.06l.07.01.12.03.09.04.04.02.09.06.07.06 4.24 4.26.07.08c.22.3.2.71-.07.98l-.08.07c-.3.22-.72.2-.98-.07L10.5 7.05V17.35Z"
]);
const $4125b41377e9d21d$export$aa8eb2c15bf3dd94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowUploadRegular', "1em", [
    "M15 3a.5.5 0 0 0 .09-.99H4a.5.5 0 0 0-.09.98L4 3h11ZM9.5 18a.5.5 0 0 0 .5-.41V5.7l3.64 3.65c.17.18.44.2.64.06l.07-.06a.5.5 0 0 0 .06-.63l-.06-.07-4.5-4.5A.5.5 0 0 0 9.6 4h-.1a.5.5 0 0 0-.4.19L4.64 8.65a.5.5 0 0 0 .64.76l.07-.06L9 5.71V17.5c0 .28.22.5.5.5Z"
]);
const $4125b41377e9d21d$export$432fe4e3a4616f67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapFilled', "1em", [
    "M13.75 3.5a3.25 3.25 0 0 1 0 6.5h-7.5a1.75 1.75 0 1 0 0 3.5h9.19l-.22-.22a.75.75 0 1 1 1.06-1.06l1.5 1.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.22-.22H6.25a3.25 3.25 0 0 1 0-6.5h7.5a1.75 1.75 0 1 0 0-3.5h-10a.75.75 0 0 1 0-1.5h10Z"
]);
const $4125b41377e9d21d$export$b9824df71e22c041 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapRegular', "1em", [
    "M14 4a3 3 0 1 1 0 6H6a2 2 0 1 0 0 4h10.3l-.65-.65a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H6a3 3 0 1 1 0-6h8a2 2 0 1 0 0-4H3.5a.5.5 0 0 1 0-1H14Z"
]);
const $4125b41377e9d21d$export$22e3d74121737ca0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l.98.98A.75.75 0 0 0 3.75 5h.54l3.5 3.5H6.25a3.25 3.25 0 1 0 0 6.5h8.04l.71.7a.75.75 0 0 0 .8.8l1.35 1.35a.5.5 0 0 0 .7-.7l-15-15ZM12.8 13.5H6.25a1.75 1.75 0 1 1 0-3.5h3.04l3.5 3.5Z",
    "M13.75 8.5h-3.13l1.5 1.5h1.63a3.25 3.25 0 0 0 0-6.5H5.62L7.12 5h6.63a1.75 1.75 0 1 1 0 3.5Z",
    "m17.34 15.22-2.33-2.33a.75.75 0 0 1 1.27-.67l1.5 1.5c.3.3.3.77 0 1.06l-.44.44Z"
]);
const $4125b41377e9d21d$export$1589ee6766fb7b17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.17 1.18A.5.5 0 0 0 3.5 5h.8l4 4H6a3 3 0 1 0 0 6h8.3l1.35 1.35 1.5 1.5a.5.5 0 0 0 .7-.7l-15-15ZM13.3 14H6a2 2 0 1 1 0-4h3.3l4 4Z",
    "M14 9h-2.88l1 1H14a3 3 0 1 0 0-6H6.12l1 1H14a2 2 0 1 1 0 4Z",
    "M17.41 15.3 16.12 14h.17l-.64-.65a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-.44.44Z"
]);
const $4125b41377e9d21d$export$1d07c1c924616f99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapUpToDownFilled', "1em", [
    "M4 13.75a3.25 3.25 0 0 0 6.5 0v-7.5a1.75 1.75 0 1 1 3.5 0v9.19l-.22-.22a.75.75 0 1 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.22.22V6.25a3.25 3.25 0 0 0-6.5 0v7.5a1.75 1.75 0 1 1-3.5 0v-10a.75.75 0 0 0-1.5 0v10Z"
]);
const $4125b41377e9d21d$export$bb2fdda79a09c6f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowWrapUpToDownRegular', "1em", [
    "M4 14a3 3 0 1 0 6 0V6a2 2 0 1 1 4 0v10.3l-.65-.65a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 0 0-.7-.7l-.65.64V6a3 3 0 1 0-6 0v8a2 2 0 1 1-4 0V3.5a.5.5 0 0 0-1 0V14Z"
]);
const $4125b41377e9d21d$export$381c0fe320c79ed5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowsBidirectionalFilled', "1em", [
    "M6.68 5.03c.2.08.32.26.32.47V8h6V5.5a.5.5 0 0 1 .87-.33l4 4.5a.5.5 0 0 1 0 .66l-4 4.5a.5.5 0 0 1-.87-.33V12H7v2.5a.5.5 0 0 1-.87.33l-4-4.5a.5.5 0 0 1 0-.66l4-4.5a.5.5 0 0 1 .55-.14Z"
]);
const $4125b41377e9d21d$export$81a80127722e8549 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ArrowsBidirectionalRegular', "1em", [
    "M6.68 5.03c.2.08.32.26.32.47V8h6V5.5a.5.5 0 0 1 .87-.33l4 4.5a.5.5 0 0 1 0 .66l-4 4.5a.5.5 0 0 1-.87-.33V12H7v2.5a.5.5 0 0 1-.87.33l-4-4.5a.5.5 0 0 1 0-.66l4-4.5a.5.5 0 0 1 .55-.14ZM3.17 10 6 13.18V11.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1.68L16.83 10 14 6.82V8.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V6.82L3.17 10Z"
]);
const $4125b41377e9d21d$export$206077b8155882e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesFilled', "1em", [
    "M3.5 5.75A2.75 2.75 0 0 1 6.23 3a.75.75 0 0 1 0 1.5C5.55 4.5 5 5.06 5 5.75L5 8.38c0 .6-.21 1.17-.58 1.62.37.45.58 1.02.58 1.62v2.63c0 .7.56 1.25 1.25 1.25a.75.75 0 1 1 0 1.5 2.75 2.75 0 0 1-2.75-2.75v-2.63c0-.4-.22-.76-.57-.94a.75.75 0 0 1 0-1.36c.35-.18.57-.54.57-.94V5.75Zm13 0A2.75 2.75 0 0 0 13.77 3a.75.75 0 0 0 0 1.5c.69 0 1.25.56 1.25 1.25L15 8.38c0 .6.21 1.17.58 1.62a2.56 2.56 0 0 0-.58 1.62v2.63c0 .7-.56 1.25-1.25 1.25a.75.75 0 1 0 0 1.5 2.75 2.75 0 0 0 2.75-2.75v-2.63c0-.4.22-.76.57-.94a.75.75 0 0 0 0-1.36 1.06 1.06 0 0 1-.57-.94V5.75Z"
]);
const $4125b41377e9d21d$export$f2afabd021b77344 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesRegular', "1em", [
    "M6.5 3A2.5 2.5 0 0 0 4 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 0 0 0 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 0 0 6.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 5 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C5 4.67 5.67 4 6.5 4a.5.5 0 0 0 0-1Zm7 0A2.5 2.5 0 0 1 16 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 0 1 0 .9 1.3 1.3 0 0 0-.72 1.17v2.88a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0 1 15 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1 0-1Z"
]);
const $4125b41377e9d21d$export$d7d0c8cc30314a7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesVariableFilled', "1em", [
    "M5.75 2.5A2.75 2.75 0 0 0 3 5.25v3.13c0 .4-.22.76-.57.94a.75.75 0 0 0 0 1.36c.35.18.57.54.57.94v3.13a2.75 2.75 0 0 0 2.75 2.75.75.75 0 0 0 0-1.5c-.69 0-1.25-.56-1.25-1.25v-3.13c0-.6-.21-1.17-.58-1.62.37-.45.58-1.02.58-1.62V5.25C4.5 4.56 5.06 4 5.75 4a.75.75 0 0 0 0-1.5Zm8.5 0A2.75 2.75 0 0 1 17 5.25v3.13c0 .4.22.76.57.94a.75.75 0 0 1 0 1.36c-.35.18-.57.54-.57.94v3.13a2.75 2.75 0 0 1-2.75 2.75.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25v-3.13c0-.6.21-1.17.58-1.62a2.56 2.56 0 0 1-.58-1.62V5.25c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1 0-1.5ZM8.11 6.06a.75.75 0 1 0-1.22.88L9.08 10l-2.19 3.06a.75.75 0 0 0 1.22.88L10 11.29l1.89 2.65a.75.75 0 0 0 1.22-.88L10.92 10l2.19-3.06a.75.75 0 0 0-1.22-.88L10 8.71 8.11 6.06Z"
]);
const $4125b41377e9d21d$export$92c034cfb31ac03d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BracesVariableRegular', "1em", [
    "M5.5 3A2.5 2.5 0 0 0 3 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 0 0 0 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 0 0 5.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 4 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C4 4.67 4.67 4 5.5 4a.5.5 0 0 0 0-1Zm9 0A2.5 2.5 0 0 1 17 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 0 1 0 .9 1.3 1.3 0 0 0-.72 1.17v2.88a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0 1 16 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 0 1 0-1ZM7.9 6.2a.5.5 0 0 0-.8.6L9.38 10l-2.3 3.2a.5.5 0 0 0 .82.6L10 10.85l2.1 2.93a.5.5 0 0 0 .8-.58L10.62 10l2.3-3.2a.5.5 0 1 0-.82-.6L10 9.15 7.9 6.21Z"
]);
const $4125b41377e9d21d$export$99f2db03da0dd8c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainFilled', "1em", [
    "M10.5 17.25a2.96 2.96 0 0 0 4.89-1.64l.04-.19a3.25 3.25 0 0 0 .77-6.08c.49-.46.8-1.11.8-1.84v-.2c0-1.28-.9-2.4-2.17-2.64l-.4-.08-.13-.63a2.42 2.42 0 0 0-3.8-1.49v14.8Zm-1-14.79a2.42 2.42 0 0 0-3.8 1.49l-.12.63-.41.08A2.7 2.7 0 0 0 3 7.3v.2c0 .73.31 1.38.8 1.84a3.25 3.25 0 0 0 .78 6.08l.03.19a2.97 2.97 0 0 0 4.89 1.64V2.46Z"
]);
const $4125b41377e9d21d$export$8751176868839344 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainRegular', "1em", [
    "M5.7 3.95a2.42 2.42 0 0 1 4.3-1 2.42 2.42 0 0 1 4.3 1l.12.63.41.08A2.7 2.7 0 0 1 17 7.3v.2a2.5 2.5 0 0 1-.8 1.84 3.25 3.25 0 0 1-.77 6.08l-.04.19A2.97 2.97 0 0 1 10 16.68a2.97 2.97 0 0 1-5.39-1.07l-.03-.19a3.25 3.25 0 0 1-.78-6.08A2.5 2.5 0 0 1 3 7.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.08.13-.63ZM14.5 10a.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5v-.2c0-.8-.57-1.5-1.37-1.66l-.73-.15a.5.5 0 0 1-.39-.4l-.2-.95a1.42 1.42 0 0 0-2.81.28v10.6a1.97 1.97 0 0 0 3.9.4l.11-.52a.5.5 0 0 1 .4-.39l.28-.06a2.25 2.25 0 0 0-.44-4.45h-.25Zm-5 4V4.42a1.42 1.42 0 0 0-2.82-.28l-.19.96a.5.5 0 0 1-.4.39l-.72.15A1.7 1.7 0 0 0 4 7.3v.2C4 8.33 4.67 9 5.5 9a.5.5 0 0 1 0 1h-.25a2.25 2.25 0 0 0-.44 4.45l.29.06c.2.04.35.2.39.4l.1.5a1.97 1.97 0 0 0 3.91-.38V14Z"
]);
const $4125b41377e9d21d$export$a42f471a502626e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainCircuitFilled', "1em", [
    "M8.08 2c.53 0 1.02.17 1.42.46V6h-.59a1.5 1.5 0 1 0 0 1h.59v10.23a3 3 0 0 1-4.97-1.82A3.24 3.24 0 0 1 2.9 10h2.6c.28 0 .5.22.5.5v.59a1.5 1.5 0 1 0 1 0v-.59C7 9.67 6.33 9 5.5 9h-2c-.3-.42-.5-.94-.5-1.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.09.13-.62A2.42 2.42 0 0 1 8.08 2Zm3.84 0c1.16 0 2.15.82 2.38 1.95l.12.62.41.09A2.7 2.7 0 0 1 17 7.3v.2c0 .73-.31 1.38-.8 1.84a3.25 3.25 0 0 1-.73 6.07 3 3 0 0 1-4.97 1.82V13h2c.83 0 1.5-.67 1.5-1.5v-.59a1.5 1.5 0 1 0-1 0v.59a.5.5 0 0 1-.5.5h-2V2.46c.4-.29.89-.46 1.42-.46ZM6.5 12a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm7-3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-6-3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"
]);
const $4125b41377e9d21d$export$47c72df5b6b6212f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainCircuitRegular', "1em", [
    "M5.7 3.95a2.42 2.42 0 0 1 4.3-1 2.42 2.42 0 0 1 4.3 1l.12.63.41.08A2.7 2.7 0 0 1 17 7.3v.2a2.5 2.5 0 0 1-.8 1.84 3.25 3.25 0 0 1-.77 6.08l-.04.19A2.97 2.97 0 0 1 10 16.68a2.97 2.97 0 0 1-5.39-1.07l-.03-.19a3.25 3.25 0 0 1-.78-6.08A2.5 2.5 0 0 1 3 7.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.08.13-.63ZM14 10.9v.59c0 .83-.67 1.5-1.5 1.5h-2v2.03a1.97 1.97 0 0 0 3.9.38l.11-.5a.5.5 0 0 1 .4-.4l.28-.06a2.25 2.25 0 0 0-.28-4.44 1.5 1.5 0 0 1-.91.9Zm-1 0a1.5 1.5 0 1 1 1.9-1.96A1.5 1.5 0 0 0 16 7.5v-.2c0-.8-.57-1.5-1.37-1.66l-.73-.15a.5.5 0 0 1-.39-.4l-.2-.95a1.42 1.42 0 0 0-2.81.28V12h2a.5.5 0 0 0 .5-.5v-.59ZM9.5 6V4.42a1.42 1.42 0 0 0-2.82-.28l-.19.96a.5.5 0 0 1-.4.39l-.72.15A1.7 1.7 0 0 0 4 7.3v.2C4 8.33 4.67 9 5.5 9h1c.83 0 1.5.67 1.5 1.5v.59a1.5 1.5 0 1 1-1 0v-.59a.5.5 0 0 0-.5-.5H5.25a2.25 2.25 0 0 0-.44 4.45l.29.06c.2.04.35.2.39.4l.1.5a1.97 1.97 0 0 0 3.91-.38V7h-.59a1.5 1.5 0 1 1 0-1h.59ZM8 6.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM7.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm6-3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
]);
const $4125b41377e9d21d$export$1acbefacec652ed7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainSparkleFilled', "1em", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.27 0-.52-.08-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a.52.52 0 0 0-.14-.22.64.64 0 0 0-.22-.14l-.77-.25c-.27-.1-.49-.26-.65-.48a1.3 1.3 0 0 1-.12-1.3 1.32 1.32 0 0 1-.45-.22 1.51 1.51 0 0 1-.52-.69l-.36-1.09a1.27 1.27 0 0 0-.29-.47 1.3 1.3 0 0 0-.47-.3l-1.06-.34a1.4 1.4 0 0 1-.47-.27v12.67a2.96 2.96 0 0 0 4.89-1.64l.04-.19a3.25 3.25 0 0 0 2.55-3.5c-.15.06-.31.08-.48.08Zm-8-9.54a2.42 2.42 0 0 0-3.8 1.49l-.12.63-.41.08A2.7 2.7 0 0 0 3 7.3v.2c0 .73.31 1.38.8 1.84a3.25 3.25 0 0 0 .78 6.08l.03.19a2.97 2.97 0 0 0 4.89 1.64V2.46Z"
]);
const $4125b41377e9d21d$export$a5558abde0ed9a4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BrainSparkleRegular', "1em", [
    "M8.08 2c.78 0 1.48.37 1.92.95v.55a1.4 1.4 0 0 0 .5 1.08v10.45a1.97 1.97 0 0 0 3.9.38l.11-.5a.5.5 0 0 1 .4-.4l.28-.06a2.25 2.25 0 0 0 1.78-2.56 1.47 1.47 0 0 0 1.01.04l.02.32a3.25 3.25 0 0 1-2.58 3.17l-.03.19A2.97 2.97 0 0 1 10 16.68a2.97 2.97 0 0 1-5.39-1.07l-.03-.19a3.25 3.25 0 0 1-.78-6.08A2.5 2.5 0 0 1 3 7.5v-.2c0-1.28.9-2.4 2.17-2.64l.4-.08.13-.63A2.42 2.42 0 0 1 8.08 2Zm0 1c-.68 0-1.27.48-1.4 1.14l-.19.96a.5.5 0 0 1-.4.39l-.72.15A1.7 1.7 0 0 0 4 7.3v.2C4 8.33 4.67 9 5.5 9a.5.5 0 0 1 0 1h-.25a2.25 2.25 0 0 0-.44 4.45l.29.06c.2.04.35.2.39.4l.1.5a1.97 1.97 0 0 0 3.91-.38V4.43C9.5 3.62 8.86 3 8.08 3Zm9.4 3a.3.3 0 0 1 .29.2l.25.77a1.58 1.58 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2Zm-3-6a.42.42 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.43.43 0 0 1-.14-.2l-.35-1.06a2.22 2.22 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .4-.28Z"
]);
const $4125b41377e9d21d$export$8c1bdc4c8e05ab44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchFilled', "1em", [
    "M10 5a3 3 0 0 1-2.15 2.88A5.76 5.76 0 0 0 12 9.98a3 3 0 1 1 .17 1.01A6.8 6.8 0 0 1 7.5 9v3.05a3 3 0 1 1-1 0V7.96A3 3 0 1 1 10 5Z"
]);
const $4125b41377e9d21d$export$95189297426eda5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRegular', "1em", [
    "M10 5a3 3 0 0 1-2.15 2.88A5.76 5.76 0 0 0 12 9.98a3 3 0 1 1 .17 1.01A6.8 6.8 0 0 1 7.5 9v3.05a3 3 0 1 1-1 0V7.96A3 3 0 1 1 10 5ZM7 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 3a2 2 0 1 0-4 0 2 2 0 0 0 4 0ZM7 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $4125b41377e9d21d$export$6fb6667cbebc1c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchCompareFilled', "1em", [
    "M11.15 6.85a.5.5 0 0 0 .7-.7L10.71 5h1.79A2.5 2.5 0 0 1 15 7.5V12a3 3 0 1 0 1 .17V7.5A3.5 3.5 0 0 0 12.5 4h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2ZM5 8a3 3 0 1 0-1-.17v4.67A3.5 3.5 0 0 0 7.5 16h1.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L9.29 15H7.5A2.5 2.5 0 0 1 5 12.5V8Z"
]);
const $4125b41377e9d21d$export$c72c69cf045198f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchCompareRegular', "1em", [
    "M11.15 6.85a.5.5 0 0 0 .7-.7L10.71 5h1.79A2.5 2.5 0 0 1 15 7.5V12a3 3 0 1 0 1 .17V7.5A3.5 3.5 0 0 0 12.5 4h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2ZM17 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 5a3 3 0 0 1-3 3v4.5A2.5 2.5 0 0 0 7.5 15h1.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L9.29 16H7.5A3.5 3.5 0 0 1 4 12.5V7.83A3 3 0 1 1 8 5ZM7 5a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
]);
const $4125b41377e9d21d$export$10ff089e47b1dd2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkFilled', "1em", [
    "M9 5a3 3 0 0 1-2.5 2.96V10H12c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 1 1 1 0v.54A2.5 2.5 0 0 1 12 11H6.5v1.04a3 3 0 1 1-1 0V7.96A3 3 0 1 1 9 5Z"
]);
const $4125b41377e9d21d$export$e978afd128813fab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkRegular', "1em", [
    "M9 5a3 3 0 1 0-3.5 2.96v4.08a3 3 0 1 0 1 0V11H12a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 0 0 9 5ZM6 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM16 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $4125b41377e9d21d$export$648b1058017116c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkHintFilled', "1em", [
    "M6 2a3 3 0 0 0-.5 5.96v3.79a.5.5 0 0 0 1 0V11H12a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 0 0 6 2ZM4.87 13.4a.5.5 0 1 0-.58-.8 3.02 3.02 0 0 0-1.12 1.54.5.5 0 1 0 .96.3 1.99 1.99 0 0 1 .74-1.03Zm2.9-.8a.5.5 0 1 0-.57.8 2.02 2.02 0 0 1 .75 1.04.5.5 0 1 0 .95-.3 2.99 2.99 0 0 0-1.12-1.55ZM4.3 16a.5.5 0 0 0-.88.5 3 3 0 0 0 1.38 1.27.5.5 0 1 0 .42-.91 2 2 0 0 1-.92-.85Zm4.37.5a.5.5 0 0 0-.87-.5 2 2 0 0 1-.98.88.5.5 0 1 0 .38.92 3 3 0 0 0 1.47-1.3Z"
]);
const $4125b41377e9d21d$export$f636bf98e4c89f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkHintRegular', "1em", [
    "M6 2a3 3 0 0 0-.5 5.96v3.79a.5.5 0 0 0 1 0V11H12a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 0 0 6 2Zm8 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM6 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-1.13 6.4a.5.5 0 1 0-.58-.8 3.02 3.02 0 0 0-1.12 1.54.5.5 0 1 0 .96.3 1.99 1.99 0 0 1 .74-1.03Zm2.9-.8a.5.5 0 1 0-.57.8 2.02 2.02 0 0 1 .75 1.04.5.5 0 1 0 .95-.3 2.99 2.99 0 0 0-1.12-1.55ZM4.3 16a.5.5 0 0 0-.88.5 3 3 0 0 0 1.38 1.27.5.5 0 1 0 .42-.91 2 2 0 0 1-.92-.85Zm4.37.5a.5.5 0 0 0-.87-.5 2 2 0 0 1-.98.88.5.5 0 1 0 .38.92 3 3 0 0 0 1.47-1.3Z"
]);
const $4125b41377e9d21d$export$6153a087147cb9f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkLinkFilled', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V11H11a2.5 2.5 0 0 0 2.5-2.5v-.54a3 3 0 1 0-1 0v.54c0 .83-.67 1.5-1.5 1.5H5.5V7.96Zm7 5.04a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $4125b41377e9d21d$export$98f1255375648c61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchForkLinkRegular', "1em", [
    "M5 2a3 3 0 0 1 .5 5.96V10H11c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 1 1 1 0v.54A2.5 2.5 0 0 1 11 11H5.5v1.04a3 3 0 1 1-1 0V7.96A3 3 0 0 1 5 2ZM3 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm0 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm10-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-.5 6a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $4125b41377e9d21d$export$150f33b1180a3828 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestFilled', "1em", [
    "M8 5a3 3 0 0 1-2.5 2.96v4.08a3 3 0 1 1-1 0V7.96A3 3 0 1 1 8 5Zm3.85 1.85a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L10.71 4h1.79A3.5 3.5 0 0 1 16 7.5v4.67a3 3 0 1 1-1-.17V7.5A2.5 2.5 0 0 0 12.5 5h-1.8l1.15 1.15c.2.2.2.5 0 .7Z"
]);
const $4125b41377e9d21d$export$5198c4ba7c794498 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestRegular', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V7.96ZM5 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm2 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4.15-8.15a.5.5 0 0 0 .7-.7L10.71 5h1.79A2.5 2.5 0 0 1 15 7.5V12a3 3 0 1 0 1 .17V7.5A3.5 3.5 0 0 0 12.5 4h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2ZM17 15a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $4125b41377e9d21d$export$215547156d898279 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestClosedFilled', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V7.96ZM18 15a3 3 0 1 1-3.5-2.96V8.5a.5.5 0 0 1 1 0v3.54A3 3 0 0 1 18 15ZM13.35 2.65a.5.5 0 0 0-.7.7L14.29 5l-1.64 1.65a.5.5 0 0 0 .7.7L15 5.71l1.65 1.64a.5.5 0 0 0 .7-.7L15.71 5l1.64-1.65a.5.5 0 0 0-.7-.7L15 4.29l-1.65-1.64Z"
]);
const $4125b41377e9d21d$export$3b0af0734f9e2692 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestClosedRegular', "1em", [
    "M3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2.5 2.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V7.96ZM5 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3 2a3 3 0 0 1 2.5-2.96V8.5a.5.5 0 0 1 1 0v3.54A3 3 0 1 1 12 15Zm1.35-12.35a.5.5 0 0 0-.7.7L14.29 5l-1.64 1.65a.5.5 0 0 0 .7.7L15 5.71l1.65 1.64a.5.5 0 0 0 .7-.7L15.71 5l1.64-1.65a.5.5 0 0 0-.7-.7L15 4.29l-1.65-1.64Z"
]);
const $4125b41377e9d21d$export$838ddc19dfbb927d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestDraftFilled', "1em", [
    "M5.5 7.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V7.96ZM18 15a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.75-6.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $4125b41377e9d21d$export$b6f32296116a0b16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BranchRequestDraftRegular', "1em", [
    "M3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2.5 2.96a3 3 0 1 0-1 0v4.08a3 3 0 1 0 1 0V7.96ZM5 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-3 2a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm4.25-6.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $4125b41377e9d21d$export$e4f8c4b21d428d6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroadActivityFeedFilled', "1em", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-13Zm0 9c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4Zm9 0c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4Z"
]);
const $4125b41377e9d21d$export$3e9ffb702d1b8388 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroadActivityFeedRegular', "1em", [
    "M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 8.5v-4ZM3.5 4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-13ZM2 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 15.5v-2Zm1.5-.5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-4Zm9-1c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4Zm-.5 1.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2Z"
]);
const $4125b41377e9d21d$export$8f1c137e4dc8139e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomFilled', "1em", [
    "M17.91 2.18c.2.2.2.51 0 .7L13.3 7.5a5.6 5.6 0 0 0-.7-.7l4.6-4.62c.2-.2.51-.2.71 0Zm-5.66 5.66a4.5 4.5 0 0 0-6.36 0l-.42.42 6.36 6.36.42-.42a4.5 4.5 0 0 0 0-6.36Zm-10.5 2.75 2.9-1.74 6.5 6.5a.5.5 0 0 0 .1.08L9.5 18.35a.5.5 0 0 1-.78.1l-7.07-7.08a.5.5 0 0 1 .1-.78Z"
]);
const $4125b41377e9d21d$export$fff9200dd087a401 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomRegular', "1em", [
    "M17.91 2.18c.2.2.2.51 0 .7l-5.32 5.33a4.5 4.5 0 0 1-.34 6l-.66.66-2.09 3.48a.5.5 0 0 1-.78.1l-7.07-7.08a.5.5 0 0 1 .1-.78L5.22 8.5l.66-.66a4.5 4.5 0 0 1 5.99-.34l5.32-5.32c.2-.2.51-.2.71 0ZM6.24 8.9l4.95 4.95.36-.35A3.5 3.5 0 1 0 6.6 8.55l-.36.35Zm-.78.63L2.8 11.12l6.16 6.17 1.6-2.66-5.11-5.1Z"
]);
const $4125b41377e9d21d$export$c887823b860e27b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomSparkleFilled', "1em", [
    "M12.15 15.35a.5.5 0 0 0 .1.08l-1.75 2.92a.5.5 0 0 1-.78.1l-5.1-5.1c.04-.07.08-.14.1-.22l.02-.02.24-.76a.58.58 0 0 1 .14-.23l.05-.04A.58.58 0 0 1 5.3 12l.06-.03.76-.24.02-.01.1-.04a1.3 1.3 0 0 0 .72-1.53l5.2 5.2ZM6.89 7.84a4.5 4.5 0 0 1 6.36 6.36l-.42.42-6.36-6.36.42-.42ZM3.49 8a.3.3 0 0 1 .28.2l.25.77c.08.23.2.44.38.61v.01l.14.12a1.57 1.57 0 0 0 .48.25l.76.25h.02a.3.3 0 0 1 .2.3l-.01.08a.3.3 0 0 1-.05.09l-.06.06a.3.3 0 0 1-.08.05l-.77.25c-.23.07-.44.2-.61.38l-.13.13a1.58 1.58 0 0 0-.26.48l-.24.77a.3.3 0 0 1-.58 0l-.24-.77a1.58 1.58 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .2-.29l.77-.25a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2ZM18.2 2.18a.5.5 0 0 1 .71.7L14.3 7.5a5.6 5.6 0 0 0-.7-.7l4.6-4.62ZM5.48 0a.42.42 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 6.72a.42.42 0 0 1-.64.2l-.02-.01a.43.43 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L2.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.21 2.21 0 0 0 1.38-1.4L5.08.28a.42.42 0 0 1 .4-.28Z"
]);
const $4125b41377e9d21d$export$626bf1098fef1c63 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BroomSparkleRegular', "1em", [
    "M18.2 2.18a.5.5 0 0 1 .7.7L13.6 8.22a4.5 4.5 0 0 1-.34 6l-.66.66-2.1 3.48a.5.5 0 0 1-.77.1l-5.1-5.1c.04-.07.08-.14.1-.22l.02-.02.24-.76.02-.04 4.97 4.98 1.6-2.66-4.7-4.7-.06-.1-.05-.08-.06-.08a1.3 1.3 0 0 0-.57-.4l-.05-.01h-.02l-.7-.24.86-.52.67-.66a4.5 4.5 0 0 1 5.99-.34l5.32-5.32Zm-5.66 6.37a3.5 3.5 0 0 0-4.94 0l-.36.35 4.95 4.95.35-.35a3.5 3.5 0 0 0 0-4.95ZM3.48 8a.3.3 0 0 1 .29.2l.25.77a1.58 1.58 0 0 0 1 1l.18.05.28.1.3.1h.02a.3.3 0 0 1 .2.28.3.3 0 0 1-.2.29l-.77.25a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.58 1.58 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.2-.28.3.3 0 0 1 .2-.29l.77-.25a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2Zm2-8a.42.42 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4L5.9 6.72a.42.42 0 0 1-.64.2l-.02-.01a.43.43 0 0 1-.14-.2l-.35-1.06a2.2 2.2 0 0 0-1.4-1.4L2.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.21 2.21 0 0 0 1.38-1.4L5.08.28a.42.42 0 0 1 .4-.28Z"
]);
const $4125b41377e9d21d$export$43bd1df66c5d0bff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseFilled', "1em", [
    "M5 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5Zm8 0a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2Z"
]);
const $4125b41377e9d21d$export$a1d5428c4ec32479 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseRegular', "1em", [
    "M5 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5ZM4 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Zm9-2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2Zm-1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z"
]);
const $4125b41377e9d21d$export$a55e0973d10373e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseCircleFilled', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM8.5 6.5A.5.5 0 0 0 8 7v6a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5Zm3 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5Z"
]);
const $4125b41377e9d21d$export$f0e8401452cb2dea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseCircleRegular', "1em", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM8.5 6.5c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5Zm3 0c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V7c0-.28.22-.5.5-.5Z"
]);
const $4125b41377e9d21d$export$781e38f9fcaaac2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseOffFilled', "1em", [
    "M3 3.7v12.8c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V8.7l4 4v3.8c0 .83.67 1.5 1.5 1.5h2c.49 0 .92-.23 1.2-.6l.45.45a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7l.85.86Zm9 6.18 5 5V3.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v6.38ZM4.16 2.04 8 5.88V3.5C8 2.67 7.33 2 6.5 2h-2c-.12 0-.23.01-.34.04Z"
]);
const $4125b41377e9d21d$export$594cc908fb8c0c17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseOffRegular', "1em", [
    "m3 3.7-.85-.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-.45-.45c-.28.37-.71.6-1.2.6h-2a1.5 1.5 0 0 1-1.5-1.5v-3.8l-4-4v7.8c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 16.5V3.7Zm4 4-3-3v11.8c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5V7.7Zm6 6v2.8c0 .28.22.5.5.5h2a.5.5 0 0 0 .47-.32L13 13.7ZM7 3.5v1.38l1 1V3.5C8 2.67 7.33 2 6.5 2h-2c-.12 0-.23.01-.34.04l.96.96H6.5c.28 0 .5.22.5.5Zm5 6.38 1 1V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v10.38l1 1V3.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v6.38Z"
]);
const $4125b41377e9d21d$export$30d0ba6e6fbcdb73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseSettingsFilled', "1em", [
    "M12 3.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v6.1a5.48 5.48 0 0 0-5 0V3.5Zm-9 0C3 2.67 3.67 2 4.5 2h2C7.33 2 8 2.67 8 3.5v13c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 16.5v-13Zm9.07 7.94a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $4125b41377e9d21d$export$608e6ed7bb9d38da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PauseSettingsRegular', "1em", [
    "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-13C8 2.67 7.33 2 6.5 2h-2Zm0 1h2c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5Zm9-1c-.83 0-1.5.67-1.5 1.5v6.1c.32-.16.65-.3 1-.4V3.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v5.7c.35.1.68.24 1 .4V3.5c0-.83-.67-1.5-1.5-1.5h-2Zm-1.43 9.44a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $4125b41377e9d21d$export$ebd110977837659a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseFilled', "1em", [
    "M7.01 3c.33 0 .62.23.71.55l2.82 10.07 2.24-7.1a.75.75 0 0 1 1.4-.07L15.5 9.5h1.76a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.69-.45l-.7-1.65-2.4 7.58a.75.75 0 0 1-1.43-.03L6.97 6.41l-1.25 4.06A.75.75 0 0 1 5 11H2.75a.75.75 0 0 1 0-1.5h1.7l1.83-5.97c.1-.32.4-.53.73-.53Z"
]);
const $4125b41377e9d21d$export$8785757987de520d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseRegular', "1em", [
    "M7 3a.5.5 0 0 1 .48.37l3.05 11.3 2.5-8.31a.5.5 0 0 1 .94-.04L15.35 10h2.15a.5.5 0 0 1 0 1H15a.5.5 0 0 1-.47-.32l-.98-2.62-2.57 8.58a.5.5 0 0 1-.96-.01L6.99 5.37l-1.5 5.27A.5.5 0 0 1 5 11H2.5a.5.5 0 0 1 0-1h2.12l1.9-6.64A.5.5 0 0 1 7 3Z"
]);
const $4125b41377e9d21d$export$fbe76c926f76dc21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseSquareFilled', "1em", [
    "M3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm5.97 1.33a.5.5 0 0 0-.94 0L6.65 10H5.5a.5.5 0 0 0 0 1H7c.2 0 .4-.13.47-.32l1.02-2.73 2.04 5.72a.5.5 0 0 0 .92.05L12.8 11h1.69a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.45.28l-.97 1.95-2.1-5.9Z"
]);
const $4125b41377e9d21d$export$89df66a6b2a1b8e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PulseSquareRegular', "1em", [
    "M8.97 6.33a.5.5 0 0 0-.94 0L6.65 10H5.5a.5.5 0 0 0 0 1H7c.2 0 .4-.13.47-.32l1.02-2.73 2.04 5.72a.5.5 0 0 0 .92.05L12.8 11h1.69a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.45.28l-.97 1.95-2.1-5.9ZM5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5ZM4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5Z"
]);
const $4125b41377e9d21d$export$1f0a835c0a457798 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendColor', "1em", `<path d="M11.5 9.5a.5.5 0 0 1 0 1l-8.12 1.77.6-2.27-.6-2.27L11.5 9.5Z" fill="url(#ic_fluent_send_20_color__a)"/><path d="M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z" fill="url(#ic_fluent_send_20_color__b)"/><path d="M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z" fill="url(#ic_fluent_send_20_color__c)"/><defs><linearGradient id="ic_fluent_send_20_color__b" x1="2" y1="-4.5" x2="15.7" y2="13.71" gradientUnits="userSpaceOnUse"><stop stop-color="#3BD5FF"/><stop offset="1" stop-color="#0094F0"/></linearGradient><linearGradient id="ic_fluent_send_20_color__c" x1="10" y1="6.31" x2="14.16" y2="17.57" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#DCF8FF" stop-opacity="0"/><stop offset=".77" stop-color="#FF6CE8" stop-opacity=".7"/></linearGradient><radialGradient id="ic_fluent_send_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(7 0 0 .9275 1.5 10)"><stop stop-color="#0094F0"/><stop offset="1" stop-color="#2052CB"/></radialGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$c980a8d62c420728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendFilled', "1em", [
    "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$276d540ffe218455 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendRegular', "1em", [
    "M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1 0 .9l-15 7.5a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52Zm2.7 8.39-1.61 6.06L16.38 10 3.27 3.44 4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$859f4a8320050b02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendBeakerFilled', "1em", [
    "M2.72 1.55a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l9.74-4.87A1.5 1.5 0 0 1 13.5 10h4.11l.11-.05a.5.5 0 0 0 0-.9l-15-7.5ZM17 14.4a2 2 0 0 0 .22.92l.35.68h-4.14l.35-.67a2 2 0 0 0 .22-.92V12h-.5a.5.5 0 1 1 0-1h4a.5.5 0 0 1 0 1H17v2.4ZM12.9 17l-.8 1.54a1 1 0 0 0 .9 1.46H18a1 1 0 0 0 .89-1.46l-.8-1.54H12.9Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9ee88502946de1bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendBeakerRegular', "1em", [
    "M2.18 1.61a.5.5 0 0 1 .54-.06L17.5 10h-.01a.5.5 0 0 1-.21-.05l-14.01-7L4.88 9h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06L12 11.69c.04.35.2.66.45.89l-9.74 4.87a.5.5 0 0 1-.7-.58L3.98 9.5 2.02 2.13a.5.5 0 0 1 .16-.52Zm.54-.06L17.51 10a.5.5 0 0 0 .21-.95l-15-7.5ZM17 14.4a2 2 0 0 0 .22.92l.35.68h-4.14l.35-.67a2 2 0 0 0 .22-.92V12h-.5a.5.5 0 1 1 0-1h4a.5.5 0 0 1 0 1H17v2.4ZM12.9 17l-.8 1.54a1 1 0 0 0 .9 1.46H18a1 1 0 0 0 .89-1.46l-.8-1.54H12.9Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$a49ee3fedde2574d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendClockColor', "1em", `<path d="M11.5 9.5a.5.5 0 0 1 0 1l-8.12 1.77.6-2.27-.6-2.27L11.5 9.5Z" fill="url(#ic_fluent_send_clock_20_color__a)"/><path d="M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z" fill="url(#ic_fluent_send_clock_20_color__b)"/><path d="M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z" fill="url(#ic_fluent_send_clock_20_color__c)"/><path d="M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z" fill="url(#ic_fluent_send_clock_20_color__d)" fill-opacity=".3"/><path d="M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Z" fill="url(#ic_fluent_send_clock_20_color__e)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 12c.28 0 .5.22.5.5V14h1a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5Z" fill="url(#ic_fluent_send_clock_20_color__f)"/><defs><linearGradient id="ic_fluent_send_clock_20_color__b" x1="2" y1="-4.5" x2="15.7" y2="13.71" gradientUnits="userSpaceOnUse"><stop stop-color="#3BD5FF"/><stop offset="1" stop-color="#0094F0"/></linearGradient><linearGradient id="ic_fluent_send_clock_20_color__c" x1="10" y1="6.31" x2="14.16" y2="17.57" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#DCF8FF" stop-opacity="0"/><stop offset=".77" stop-color="#FF6CE8" stop-opacity=".7"/></linearGradient><linearGradient id="ic_fluent_send_clock_20_color__e" x1="11.5" y1="9.5" x2="16" y2="19.5" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_send_clock_20_color__f" x1="14.22" y1="12.46" x2="13.51" y2="14.89" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#D1D1FF"/></linearGradient><radialGradient id="ic_fluent_send_clock_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(7 0 0 .9275 1.5 10)"><stop stop-color="#0094F0"/><stop offset="1" stop-color="#2052CB"/></radialGradient><radialGradient id="ic_fluent_send_clock_20_color__d" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1 8.5 -6.67857 .78571 14.5 16.5)"><stop offset=".76" stop-color="#1B44B1"/><stop offset="1" stop-color="#1B44B1" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$8fa78ca90667b787 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendClockFilled', "1em", [
    "M2.72 1.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l6.33-3.16A5.5 5.5 0 0 1 17.2 9.7l.52-.26a.5.5 0 0 0 0-.9l-15-7.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$b8cc228cfd7ab64b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendClockRegular', "1em", [
    "M2.18 1.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 1 1-.44.9l-14.01-7L4.88 8.5h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06 6.1-3.06c-.15.41-.27.84-.32 1.29l-6.33 3.16a.5.5 0 0 1-.7-.58L3.98 9 2.02 1.63a.5.5 0 0 1 .16-.52ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$7ce070d58b0601ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendCopyFilled', "1em", [
    "M8.47 2.22c.3-.3.77-.3 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06L9.75 4.56v6.69a.75.75 0 0 1-1.5 0V4.56L7.03 5.78a.75.75 0 0 1-1.06-1.06l2.5-2.5ZM5.57 16.5A2 2 0 0 0 7.5 18H13a4.5 4.5 0 0 0 4.5-4.5v-2.25a.75.75 0 0 0-1.5 0v2.25a3 3 0 0 1-3 3H5.57ZM4.5 8.75a.75.75 0 0 0-1.5 0v4.75c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8.75a.75.75 0 0 0-1.5 0v4.75a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8.75Z"
]);
const $4125b41377e9d21d$export$469dbebfb94ef80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendCopyRegular', "1em", [
    "M8.65 2.15c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L9.5 3.71v7.79a.5.5 0 0 1-1 0V3.7L6.35 5.86a.5.5 0 1 1-.7-.7l3-3ZM5.27 17c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4v-3.5a.5.5 0 1 0-1 0V14a3 3 0 0 1-3 3H5.27ZM4 8.5a.5.5 0 0 0-1 0V14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-1 0V14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.5Z"
]);
const $4125b41377e9d21d$export$b4089b5b476c1ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendPersonFilled', "1em", [
    "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l9.78-4.9V13a3 3 0 0 1 4.85-2.36l.37-.2a.5.5 0 0 0 0-.89l-15-7.5ZM17.5 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 18.75 12 17.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$9a9b7f6bc7a66da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SendPersonRegular', "1em", [
    "M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1-.44.9l-14.01-7L4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06 9.47-4.74a2.99 2.99 0 0 0-.24 1.24l-9.78 4.89a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52ZM15.5 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5Z"
], {
    flipInRtl: true
});
const $4125b41377e9d21d$export$e5779971e4e4e9dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldColor', "1em", `<path d="M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z" fill="url(#ic_fluent_shield_20_color__a)"/><defs><radialGradient id="ic_fluent_shield_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(21.50002 31 -27.12496 18.81249 -2.5 -7)"><stop offset=".34" stop-color="#0FAFFF"/><stop offset=".53" stop-color="#367AF2"/><stop offset=".68" stop-color="#5750E2"/><stop offset=".86" stop-color="#CC23D1"/></radialGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$b0096c2d960f548c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z"
]);
const $4125b41377e9d21d$export$c6ece342c073f6b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM9.6 3.35A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25Z"
]);
const $4125b41377e9d21d$export$842227a15a7d777c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldAddFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6a5.5 5.5 0 0 0-6.78 8.35l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $4125b41377e9d21d$export$d6cea4ce7cfc490e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldAddRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.84.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $4125b41377e9d21d$export$85b6dee0f29e9bb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldArrowRightFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6a5.5 5.5 0 0 0-6.78 8.35l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"
]);
const $4125b41377e9d21d$export$eae1b3a6bae9f0e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldArrowRightRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.84.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"
]);
const $4125b41377e9d21d$export$c0ae2ec2f33a57e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldBadgeFilled', "1em", [
    "M4 5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6V9c3.23 0 3.75-.83 4.11-1.43.2-.32.36-.57.89-.57s.69.25.89.57c.2.32.43.7 1.11 1V7a2 2 0 0 0-2-2H4Zm10.53 3.83v.02a1.63 1.63 0 0 1-.45.5c-.4.3-1.17.65-2.58.65a.5.5 0 0 0-.5.5v2c0 1.03.13 2.14.7 3.12.56 1 1.55 1.82 3.14 2.35.1.04.22.04.32 0a5.35 5.35 0 0 0 3.15-2.35c.56-.98.69-2.09.69-3.12v-2a.5.5 0 0 0-.5-.5c-1.41 0-2.18-.35-2.57-.65a1.63 1.63 0 0 1-.46-.52.5.5 0 0 0-.94 0Zm.94 0v.01Zm-.94 0v.01Z"
]);
const $4125b41377e9d21d$export$2a08501a62f05072 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldBadgeRegular', "1em", [
    "M2 7c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v1.57a2.11 2.11 0 0 1-1-.82V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6v1H4a2 2 0 0 1-2-2V7Zm12.53 1.83a.5.5 0 0 1 .95.02 1.63 1.63 0 0 0 .45.5c.4.3 1.16.65 2.57.65.28 0 .5.22.5.5v2c0 1.03-.13 2.14-.7 3.12a5.35 5.35 0 0 1-3.14 2.35.5.5 0 0 1-.32 0 5.35 5.35 0 0 1-3.15-2.35A6.19 6.19 0 0 1 11 12.5v-2a.5.5 0 0 1 .5-.5c1.41 0 2.18-.35 2.57-.65a1.63 1.63 0 0 0 .46-.52Zm.94 0v.01Zm0 0Zm-.94 0v.01Zm.15 1.32c-.54.4-1.38.76-2.68.84v1.51c0 .97.12 1.86.56 2.63A4.27 4.27 0 0 0 15 16.97a4.27 4.27 0 0 0 2.44-1.84c.44-.77.56-1.66.56-2.63v-1.51a4.81 4.81 0 0 1-2.68-.84L15 9.87c-.1.09-.2.19-.32.28Zm-.15-1.32"
]);
const $4125b41377e9d21d$export$9eb55ec96311314 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldCheckmarkColor', "1em", `<path d="M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z" fill="url(#ic_fluent_shield_checkmark_20_color__a)"/><path d="M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z" fill="url(#ic_fluent_shield_checkmark_20_color__b)" fill-opacity=".5"/><path d="M19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Z" fill="url(#ic_fluent_shield_checkmark_20_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.85 12.65c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0Z" fill="url(#ic_fluent_shield_checkmark_20_color__d)"/><defs><radialGradient id="ic_fluent_shield_checkmark_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(21.50002 31 -27.12496 18.81249 -2.5 -7)"><stop offset=".34" stop-color="#0FAFFF"/><stop offset=".53" stop-color="#367AF2"/><stop offset=".68" stop-color="#5750E2"/><stop offset=".86" stop-color="#CC23D1"/></radialGradient><radialGradient id="ic_fluent_shield_checkmark_20_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 -.5 15) scale(6.5)"><stop offset=".5" stop-color="#1E1868"/><stop offset="1" stop-color="#1E1868" stop-opacity="0"/></radialGradient><linearGradient id="ic_fluent_shield_checkmark_20_color__c" x1="10.32" y1="11.69" x2="16.53" y2="18.14" gradientUnits="userSpaceOnUse"><stop stop-color="#52D17C"/><stop offset="1" stop-color="#22918B"/></linearGradient><linearGradient id="ic_fluent_shield_checkmark_20_color__d" x1="12.94" y1="12.91" x2="13.95" y2="17.36" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#E3FFD9"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$b2a8f9f1ac920d9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldCheckmarkFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6a5.5 5.5 0 0 0-6.78 8.35l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-2.15-1.85c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0Z"
]);
const $4125b41377e9d21d$export$ffe2ec28dcf16e42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldCheckmarkRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.84.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
]);
const $4125b41377e9d21d$export$5c59b8dfcadad84d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissFilled', "1em", [
    "M10.28 2.08c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42.5.5 0 0 1 .55 0ZM8.03 6.97a.75.75 0 0 0-1.06 1.06L8.94 10l-1.97 1.97a.75.75 0 1 0 1.06 1.06L10 11.06l1.97 1.97a.75.75 0 1 0 1.06-1.06L11.06 10l1.97-1.97a.75.75 0 0 0-1.06-1.06L10 8.94 8.03 6.97Z"
]);
const $4125b41377e9d21d$export$9e5ecef4950c3c79 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissRegular', "1em", [
    "M7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15Zm2.43-5.07a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z"
]);
const $4125b41377e9d21d$export$1d3ebf72102df51f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissShieldFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0c.34-.14.68-.27 1-.42a5.82 5.82 0 0 1-.66-1.16 7.05 7.05 0 0 1-.52-2.5V11.05l-1.97 1.97a.75.75 0 0 1-1.06-1.06L8.94 10 6.97 8.03a.75.75 0 0 1 1.06-1.06L10 8.94l1.97-1.97a.75.75 0 1 1 1.06 1.06l-1.64 1.64h.01c.9 0 1.76-.37 2.6-1.24a1.39 1.39 0 0 1 2 0 5.06 5.06 0 0 0 1 .8V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM17 10.35a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 13 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 0 0-.4-.33 4.24 4.24 0 0 1-1.6-.32Z"
]);
const $4125b41377e9d21d$export$aa1b277a01ef4148 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldDismissShieldRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0c.34-.14.68-.27 1-.42-.2-.27-.38-.56-.52-.86-.21.1-.43.18-.66.27-4.03-1.6-6-4.07-6-7.46V5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43v3a5.06 5.06 0 0 0 1 .8V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm-.24 8.67c.11-.47.46-.87.94-1.02l1.87-1.88a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l.04.04Zm6.96-.4a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 13 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 0 0-.4-.33 4.24 4.24 0 0 1-1.6-.32Z"
]);
const $4125b41377e9d21d$export$f8f100ee3ded5cde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldErrorFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM10 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5A.5.5 0 0 0 10 6Zm0 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
]);
const $4125b41377e9d21d$export$6e24440f7ba2b64a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldErrorRegular', "1em", [
    "M10 6c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5Zm0 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM9.6 3.35A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25Z"
]);
const $4125b41377e9d21d$export$27f7fcb7148cf4d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldGlobeFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm2.68 8.42a3 3 0 0 1-1.43 2.08c.24-.57.4-1.3.45-2.08h.98Zm0-1a3 3 0 0 0-1.43-2.08c.24.57.4 1.3.45 2.08h.98Zm-1.98 0a5.13 5.13 0 0 0-.46-1.88 1.72 1.72 0 0 0-.39-.54.43.43 0 0 0-.12-.08.03.03 0 0 0-.02 0h-.01a.43.43 0 0 0-.11.08c-.11.09-.25.26-.39.54-.23.46-.4 1.11-.46 1.88h1.96Zm-1.96 1c.05.77.23 1.42.46 1.88.14.28.28.45.39.54a.42.42 0 0 0 .12.08.03.03 0 0 0 .02 0h.01c.02-.01.06-.03.11-.08.11-.09.25-.26.39-.54.23-.46.4-1.11.46-1.88H9.02Zm-1 0c.04.79.2 1.5.45 2.08a3 3 0 0 1-1.43-2.08h.98Zm0-1c.04-.79.2-1.5.45-2.08A3 3 0 0 0 7.04 9.5h.98ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
]);
const $4125b41377e9d21d$export$71736ab7f929d603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldGlobeRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Zm8.96 5.07h-.98c-.04.79-.2 1.5-.45 2.08a3 3 0 0 0 1.43-2.08Zm0-1a3 3 0 0 0-1.43-2.08c.24.57.4 1.3.45 2.08h.98Zm-1.98 0a5.13 5.13 0 0 0-.46-1.88 1.72 1.72 0 0 0-.39-.54.43.43 0 0 0-.12-.08.03.03 0 0 0-.02 0h-.01a.43.43 0 0 0-.11.08c-.11.09-.25.26-.39.54-.23.46-.4 1.11-.46 1.88h1.96Zm-1.96 1c.05.77.23 1.42.46 1.88.14.28.28.45.39.54a.42.42 0 0 0 .12.08.03.03 0 0 0 .02 0h.01c.02-.01.06-.03.11-.08.11-.09.25-.26.39-.54.23-.46.4-1.11.46-1.88H9.02Zm-1 0h-.98a3 3 0 0 0 1.43 2.08c-.24-.57-.4-1.3-.45-2.08Zm0-1c.04-.79.2-1.5.45-2.08A3 3 0 0 0 7.04 9.5h.98ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
]);
const $4125b41377e9d21d$export$a31a366fb4bbd645 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldKeyholeFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 0 1-1 0v-2.09a1.5 1.5 0 1 1 2-1.41Z"
]);
const $4125b41377e9d21d$export$5c7dbf7082febbee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldKeyholeRegular', "1em", [
    "M11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 0 1-1 0v-2.09a1.5 1.5 0 1 1 2-1.41Zm-1.22-6.92a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z"
]);
const $4125b41377e9d21d$export$4954ecd7c7d05f31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldLockFilled', "1em", [
    "M12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5Zm1-1v1h2v-1a1 1 0 1 0-2 0Zm1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.34A3 3 0 0 0 11.5 11v.06A2 2 0 0 0 10 13v4a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z"
]);
const $4125b41377e9d21d$export$1437613268dc88c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldLockRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.34c-.26-.38-.6-.7-1-.94V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46V17a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5Zm1-1v1h2v-1a1 1 0 1 0-2 0Zm1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
]);
const $4125b41377e9d21d$export$b97c74b7513c3f0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM10 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 5c-2.5 0-3.5-1.25-3.5-2.5 0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5 0 1.24-1 2.5-3.5 2.5Z"
]);
const $4125b41377e9d21d$export$1de9764c74ec8e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonRegular', "1em", [
    "M10 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.26 3.5-2.5 0-.83-.67-1.5-1.5-1.5H8c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5Zm.28-12.42a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z"
]);
const $4125b41377e9d21d$export$a2a310278314a55e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonAddFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.04-.02A5.48 5.48 0 0 1 9 14.42c-1.77-.29-2.5-1.35-2.5-2.42 0-.83.67-1.5 1.5-1.5h2.73A5.48 5.48 0 0 1 17 9.6V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM10 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm9 5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $4125b41377e9d21d$export$5a96e9356ecd0786 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldPersonAddRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.04-.02a5.5 5.5 0 0 1-.74-1.2C5.8 15.15 4 12.75 4 9.5V5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.2c.35.1.68.23 1 .39V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM9 14.42a5.48 5.48 0 0 1 1.73-3.92H8c-.83 0-1.5.67-1.5 1.5 0 1.07.73 2.13 2.5 2.42Zm3-6.92a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm7 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $4125b41377e9d21d$export$69c305e06fa46b44 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldProhibitedFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.07-.03A5.5 5.5 0 1 1 17 9.26V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm.42 13.52 4.9-4.9a3.5 3.5 0 0 0-4.9 4.9Zm.7.7a3.5 3.5 0 0 0 4.9-4.9l-4.9 4.9Zm2.1 1.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z"
]);
const $4125b41377e9d21d$export$173c4af9b0825e35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldProhibitedRegular', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.07-.03c-.55-.4-1.02-.9-1.38-1.48C5.6 14.86 4 12.56 4 9.5V5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V8.6c.36.18.7.4 1 .66V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm.42 13.52 4.9-4.9a3.5 3.5 0 0 0-4.9 4.9Zm.7.7a3.5 3.5 0 0 0 4.9-4.9l-4.9 4.9Zm2.1 1.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z"
]);
const $4125b41377e9d21d$export$27dc604169fffbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldQuestionFilled', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Zm1.03 11.67a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-2-5.5a1.25 1.25 0 1 1 2.5 0c0 .46-.27.76-.73 1.22l-.03.03c-.42.42-.99.99-.99 1.9v.1a.5.5 0 0 0 1 0v-.1c0-.47.27-.77.73-1.22l.03-.04c.42-.41.99-.98.99-1.89a2.25 2.25 0 0 0-4.5 0 .5.5 0 0 0 1 0Z"
]);
const $4125b41377e9d21d$export$1cddcaeb683784d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldQuestionRegular', "1em", [
    "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM9.6 3.35A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25Zm1.15 10.4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-2-5.5a1.25 1.25 0 1 1 2.5 0c0 .46-.27.76-.73 1.22l-.03.03c-.42.42-.99.99-.99 1.9v.1a.5.5 0 0 0 1 0v-.1c0-.47.27-.77.73-1.22l.03-.04c.42-.41.99-.98.99-1.89a2.25 2.25 0 0 0-4.5 0 .5.5 0 0 0 1 0Z"
]);
const $4125b41377e9d21d$export$c7f437acb259f663 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldSettingsFilled', "1em", [
    "M13.07 10.75a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.7 4.7 0 0 1 0-1.01l.46-.12a2 2 0 0 0 1.43-2.48l-.16-.56c.25-.2.53-.36.82-.5l.34.37ZM9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.29 2.42A.5.5 0 0 1 17 5v4.6a5.5 5.5 0 0 0-6.78 8.35l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM14.5 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
]);
const $4125b41377e9d21d$export$a8564a765bb49128 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldSettingsRegular', "1em", [
    "M13.07 10.75a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.7 4.7 0 0 1 0-1.01l.46-.12a2 2 0 0 0 1.43-2.48l-.16-.56c.25-.2.53-.36.82-.5l.34.37ZM9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.29 2.42A.5.5 0 0 1 17 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.83.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM14.5 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
]);
const $4125b41377e9d21d$export$dfdb19acd2017f3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldTaskFilled', "1em", [
    "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm3.57 5.77-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 3.65-3.64a.5.5 0 0 1 .7.7Z"
]);
const $4125b41377e9d21d$export$8d1a2bd5ddecd726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShieldTaskRegular', "1em", [
    "M13.85 7.85a.5.5 0 0 0-.7-.7L9.5 10.79 7.85 9.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4Zm-3.57-5.77a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z"
]);
const $4125b41377e9d21d$export$b19bb850a92fb46b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsColor', "1em", `<path d="M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Z" fill="url(#ic_fluent_shifts_20_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 6c.28 0 .5.22.5.5V10h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-4c0-.28.22-.5.5-.5Z" fill="url(#ic_fluent_shifts_20_color__b)"/><defs><linearGradient id="ic_fluent_shifts_20_color__a" x1="5.33" y1="2.22" x2="12.33" y2="17.78" gradientUnits="userSpaceOnUse"><stop stop-color="#1EC8B0"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_shifts_20_color__b" x1="8.94" y1="6.38" x2="7.46" y2="11.33" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#DEDEFF"/></linearGradient></defs>`, {
    color: true
});
const $4125b41377e9d21d$export$2632ce7e86e6fd81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm7 .5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5Z"
]);
const $4125b41377e9d21d$export$e62c55183e8c84e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsRegular', "1em", [
    "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"
]);
const $4125b41377e9d21d$export$a747c6393d5ee15a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shifts30MinutesFilled', "1em", [
    "M10 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM8 8a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V10a2 2 0 0 0-2-2H8Zm-2.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.05-3.58c-.18.3-.3.77-.3 1.33s.12 1.03.3 1.33c.17.28.4.42.7.42.3 0 .53-.14.7-.42.18-.3.3-.77.3-1.33a2.6 2.6 0 0 0-.3-1.33c-.17-.28-.4-.42-.7-.42-.3 0-.53.14-.7.42Zm-.85-.52c.33-.53.85-.9 1.55-.9.7 0 1.22.37 1.55.9.32.5.45 1.17.45 1.85 0 .68-.13 1.34-.45 1.85-.33.53-.85.9-1.55.9-.7 0-1.22-.37-1.55-.9a3.58 3.58 0 0 1-.45-1.85c0-.68.13-1.34.45-1.85Zm-4.14.5c.46-.36.83-.43 1.08-.4.25.05.44.2.54.37.1.17.09.35 0 .48-.08.14-.32.35-.9.4a.5.5 0 0 0 0 1c.6.05.82.25.9.37.09.13.1.31 0 .5-.1.18-.3.33-.55.37-.25.04-.61-.02-1.07-.38a.5.5 0 1 0-.62.78c.62.5 1.26.68 1.85.6.57-.1 1.02-.45 1.26-.9a1.47 1.47 0 0 0-.33-1.85 1.47 1.47 0 0 0 .33-1.86c-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 0 0-1.84.6.5.5 0 0 0 .62.78Z"
]);
const $4125b41377e9d21d$export$3ec26ccae9e2023b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Shifts30MinutesRegular', "1em", [
    "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-3 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V10a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0V10Zm-1.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.05-3.58c-.18.3-.3.77-.3 1.33s.12 1.03.3 1.33c.17.28.4.42.7.42.3 0 .53-.14.7-.42.18-.3.3-.77.3-1.33a2.6 2.6 0 0 0-.3-1.33c-.17-.28-.4-.42-.7-.42-.3 0-.53.14-.7.42Zm-.85-.52c.33-.53.85-.9 1.55-.9.7 0 1.22.37 1.55.9.32.5.45 1.17.45 1.85 0 .68-.13 1.34-.45 1.85-.33.53-.85.9-1.55.9-.7 0-1.22-.37-1.55-.9a3.58 3.58 0 0 1-.45-1.85c0-.68.13-1.34.45-1.85Zm-4.14.5c.46-.36.83-.43 1.08-.4.25.05.44.2.54.37.1.17.09.35 0 .48-.08.14-.32.35-.9.4a.5.5 0 0 0 0 1c.6.05.82.25.9.37.09.13.1.31 0 .5-.1.18-.3.33-.55.37-.25.04-.61-.02-1.07-.38a.5.5 0 1 0-.62.78c.62.5 1.26.68 1.85.6.57-.1 1.02-.45 1.26-.9a1.47 1.47 0 0 0-.33-1.85 1.47 1.47 0 0 0 .33-1.86c-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 0 0-1.84.6.5.5 0 0 0 .62.78Z"
]);
const $4125b41377e9d21d$export$a53a264926ce76de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsActivityFilled', "1em", [
    "M10 2.7a.75.75 0 0 1-.67.83 6.5 6.5 0 1 0 7.14 7.14.75.75 0 1 1 1.5.16 8 8 0 1 1-8.8-8.8c.42-.04.79.26.83.68Zm1.02-.06c.1-.4.5-.65.9-.55.38.09.75.2 1.1.35a.75.75 0 0 1-.55 1.39 6.55 6.55 0 0 0-.9-.29.75.75 0 0 1-.55-.9Zm6.54 4.33a.75.75 0 0 0-1.39.56c.12.29.21.59.28.9a.75.75 0 1 0 1.46-.35c-.09-.38-.2-.75-.35-1.1ZM14.3 3.93a.75.75 0 0 1 1.06-.08c.3.27.6.56.86.87a.75.75 0 0 1-1.15.97 6.65 6.65 0 0 0-.7-.7.75.75 0 0 1-.07-1.06ZM10 5.75a.75.75 0 0 0-1.5 0v5c0 .41.34.75.75.75h3a.75.75 0 1 0 0-1.5H10V5.75Z"
]);
const $4125b41377e9d21d$export$65ab6cabeb092c4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsActivityRegular', "1em", [
    "M10 2.48a.5.5 0 0 1-.46.53 7 7 0 1 0 7.45 7.45.5.5 0 1 1 1 .07 8 8 0 1 1-8.52-8.51.5.5 0 0 1 .53.46Zm1 .07a.5.5 0 0 1 .6-.4c.56.12 1.1.3 1.6.52a.5.5 0 1 1-.4.91c-.44-.2-.91-.34-1.4-.44a.5.5 0 0 1-.4-.59Zm6.34 4.25a.5.5 0 1 0-.92.4c.2.45.34.91.44 1.4a.5.5 0 0 0 .98-.2 7.95 7.95 0 0 0-.5-1.6ZM14.4 3.92a.5.5 0 0 1 .7-.07c.4.33.75.69 1.08 1.08a.5.5 0 1 1-.78.63c-.28-.34-.6-.66-.93-.94a.5.5 0 0 1-.07-.7ZM10 5.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h3a.5.5 0 1 0 0-1H10V5.5Z"
]);
const $4125b41377e9d21d$export$d3835167447d6949 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAddFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6a5.5 5.5 0 0 1 7.4 7.4H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm4.5 3c.28 0 .5.22.5.5V9h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5Zm-.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5Z"
]);
const $4125b41377e9d21d$export$b784fa987fee2748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAddRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm-.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H6v1.5a.5.5 0 0 1-1 0V15H3.5a.5.5 0 0 1 0-1H5v-1.5c0-.28.22-.5.5-.5ZM11 6.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11V6.5Z"
]);
const $4125b41377e9d21d$export$5134bb1c9e5e3bbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAvailabilityFilled', "1em", [
    "M6 12.92A7 7 0 0 1 12.92 6 6 6 0 1 0 6 12.92Zm3.35-8.27c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6 7.29l2.65-2.64c.2-.2.5-.2.7 0ZM13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-1.65-8.35L13 12.29l1.65-1.64a.5.5 0 0 1 .7.7L13.71 13l1.64 1.65a.5.5 0 0 1-.7.7L13 13.71l-1.65 1.64a.5.5 0 0 1-.7-.7L12.29 13l-1.64-1.65a.5.5 0 0 1 .7-.7Z"
]);
const $4125b41377e9d21d$export$a925e8e56e279f15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsAvailabilityRegular', "1em", [
    "M11.92 6.08a5 5 0 1 0-5.84 5.84c-.05.32-.08.66-.08 1A6 6 0 1 1 12.92 6c-.34 0-.68.03-1 .08Zm-.57 4.57a.5.5 0 0 0-.7.7L12.29 13l-1.64 1.65a.5.5 0 0 0 .7.7L13 13.71l1.65 1.64a.5.5 0 0 0 .7-.7L13.71 13l1.64-1.65a.5.5 0 0 0-.7-.7L13 12.29l-1.65-1.64ZM13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-1a5 5 0 1 1 0-10 5 5 0 0 1 0 10ZM9.35 5.35a.5.5 0 1 0-.7-.7L6 7.29 4.85 6.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3Z"
]);
const $4125b41377e9d21d$export$cf31f2fced3f42e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsCheckmarkFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6a5.48 5.48 0 0 0-.66-6h2.76a.5.5 0 0 0 0-1H10V6.5a.5.5 0 0 0-1 0v3.76a5.48 5.48 0 0 0-6-.66V6Zm7 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
]);
const $4125b41377e9d21d$export$3a06679c600d6420 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsCheckmarkRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm3 7.26c.27.22.52.47.74.74h2.76a.5.5 0 0 0 0-1H10V6.5a.5.5 0 0 0-1 0v3.76Zm1 4.24a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
]);
const $4125b41377e9d21d$export$f233f9948113b79e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsDayFilled', "1em", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9Zm3.4 2.04a1.82 1.82 0 0 0-.34.5l-.03.08a.5.5 0 0 0 .94.34l.02-.05.13-.17c.12-.11.3-.24.65-.24.4 0 .64.23.75.54.1.33.03.72-.24.96-.15.15-.34.28-.58.44l-.04.02c-.22.15-.47.31-.7.51A2.52 2.52 0 0 0 6 12.5a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 0-1H7.07c.1-.32.29-.56.54-.77.18-.15.39-.3.62-.44l.02-.02c.23-.15.5-.33.72-.54.58-.54.71-1.34.5-2A1.74 1.74 0 0 0 7.77 7c-.64 0-1.09.26-1.36.54ZM11.5 7a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5H13v2a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v2h-1v-2a.5.5 0 0 0-.5-.5Z"
]);
const $4125b41377e9d21d$export$ec7b29e08a390351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsDayRegular', "1em", [
    "M6.4 7.54c.28-.28.73-.54 1.37-.54.88 0 1.48.56 1.7 1.23.21.66.08 1.46-.5 2-.23.21-.49.39-.72.54l-.02.02c-.23.15-.44.29-.62.44a1.6 1.6 0 0 0-.54.77H9a.5.5 0 1 1 0 1H6.5a.5.5 0 0 1-.5-.5c0-.97.44-1.59.96-2.03.23-.2.48-.36.7-.5l.04-.03c.24-.16.43-.3.58-.44a.93.93 0 0 0 .24-.96.75.75 0 0 0-.75-.54.86.86 0 0 0-.65.24.82.82 0 0 0-.15.22.5.5 0 0 1-.94-.34l.03-.07.07-.14c.05-.1.15-.23.28-.37ZM11.5 7c.28 0 .5.22.5.5v2h1v-2a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-2h-1.5a.5.5 0 0 1-.5-.5V7.5c0-.28.22-.5.5-.5Zm-6-4A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-9ZM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9Z"
]);
const $4125b41377e9d21d$export$c7eb48e3c14ae592 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsOpenFilled', "1em", [
    "M4.5 5.75c0-.69.56-1.25 1.25-1.25H7.5a.75.75 0 0 0 0-1.5H5.75A2.75 2.75 0 0 0 3 5.75v8.5A2.75 2.75 0 0 0 5.75 17H7.5a.75.75 0 0 0 0-1.5H5.75c-.69 0-1.25-.56-1.25-1.25v-8.5Zm8-2.75a.75.75 0 0 0 0 1.5h1.75c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H12.5a.75.75 0 0 0 0 1.5h1.75A2.75 2.75 0 0 0 17 14.25v-8.5A2.75 2.75 0 0 0 14.25 3H12.5Zm-2 2.75a.75.75 0 0 0-1.5 0v4.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H10.5V5.75Z"
]);
const $4125b41377e9d21d$export$9fc90238ad16d982 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsOpenRegular', "1em", [
    "M4 5.5C4 4.67 4.67 4 5.5 4h2a.5.5 0 0 0 0-1h-2A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h2a.5.5 0 0 0 0-1h-2A1.5 1.5 0 0 1 4 14.5v-9ZM12.5 3a.5.5 0 0 0 0 1h2c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-2ZM10 5.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H10V5.5Z"
]);
const $4125b41377e9d21d$export$68d2e02fd69b09e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsProhibitedFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6A5.5 5.5 0 0 0 3 9.6V6Zm8 .5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11V6.5Zm-10 8a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1ZM5.5 18c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 0 1 5.5 18Z"
]);
const $4125b41377e9d21d$export$8de8609ce8485603 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsProhibitedRegular', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6c.16-.32.3-.65.4-1H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3.2c-.35.1-.68.24-1 .4V6Zm7.5 0c.28 0 .5.22.5.5V9h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5ZM1 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1ZM5.5 18c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 0 1 5.5 18Z"
]);
const $4125b41377e9d21d$export$e06962077e953151 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsQuestionMarkFilled', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6a5.5 5.5 0 0 1 7.4 7.4H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm4.5 3c.28 0 .5.22.5.5V9h2a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5Zm-.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25Zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95Z"
]);
const $4125b41377e9d21d$export$765091294d5f2144 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsQuestionMarkRegular', "1em", [
    "M6 3a3 3 0 0 0-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm5 3.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11V6.5Zm-1 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25Zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95Z"
]);
const $4125b41377e9d21d$export$12e5ea6c35dde32d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsTeamFilled', "1em", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.02l.02-.38c0-.91-.59-1.75-1.45-2.02a2.25 2.25 0 0 0-3.31-3.01A2.75 2.75 0 0 0 3 10.1V6Zm7 .5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5Zm-6.25 8a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM4 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 0 0-1.29-1.31H2.3A1.3 1.3 0 0 0 1 16.81c0 1.1.86 2.19 3 2.19Zm3.5-.5h-.02c.35-.51.52-1.1.52-1.69 0-.48-.15-.93-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87Zm.25-4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $4125b41377e9d21d$export$3a7217ad21a2ff11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ShiftsTeamRegular', "1em", [
    "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5ZM6 3a3 3 0 0 0-3 3v4.1a2.75 2.75 0 0 1 1-.09V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.1a2.16 2.16 0 0 1 .08 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM3.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM4 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 0 0-1.29-1.31H2.3A1.3 1.3 0 0 0 1 16.81c0 1.1.86 2.19 3 2.19Zm3.5-.5h-.02c.35-.51.52-1.1.52-1.69 0-.48-.15-.93-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87Zm.25-4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $4125b41377e9d21d$export$1406d7413368d594 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardFilled', "1em", [
    "m17.33 3.46.11.1.1.11c.64.76.61 1.9-.1 2.6l-3.6 3.63c-.22.22-.5.38-.8.47l-1.96.6a.84.84 0 0 1-1.04-1.08l.62-1.94c.1-.29.25-.55.47-.76l3.6-3.63a1.9 1.9 0 0 1 2.6-.1ZM12.9 4H4.5A2.5 2.5 0 0 0 2 6.5v2.26c.52-.48 1.12-.98 1.72-1.4A6.55 6.55 0 0 1 5.7 6.32c.32-.09.66-.12.99-.05.34.08.63.28.84.59.47.67.13 1.4-.2 1.92-.16.27-.37.56-.57.83l-.02.04c-.21.29-.42.58-.61.88-.16.28-.2.62-.13.86.03.12.1.2.17.27.07.06.19.12.37.13.33.03.76-.08 1.3-.27a.5.5 0 1 1 .33.94 4.2 4.2 0 0 1-1.71.33 1.52 1.52 0 0 1-1.41-1.12 2.19 2.19 0 0 1 .21-1.65h.01v-.01c.22-.34.45-.66.66-.95l.01-.02c.21-.29.4-.54.55-.78.32-.53.3-.73.22-.84a.4.4 0 0 0-.25-.17 1.08 1.08 0 0 0-.5.03c-.47.12-1.04.44-1.66.88-.85.6-1.7 1.38-2.3 1.98v3.35A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5V7.13l-3.45 3.47a2.9 2.9 0 0 1-1.22.73l-1.96.6A1.84 1.84 0 0 1 9.1 9.58l.62-1.94c.14-.44.38-.84.7-1.17L12.9 4Z"
]);
const $4125b41377e9d21d$export$d2c83abff51cc923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardRegular', "1em", [
    "m17.33 3.46.11.1.1.11c.64.76.61 1.9-.1 2.6l-3.6 3.63c-.22.22-.5.38-.8.47l-1.96.6a.84.84 0 0 1-1.04-1.08l.62-1.94c.1-.29.25-.55.47-.76l3.6-3.63a1.9 1.9 0 0 1 2.6-.1Zm-1.88.8L11.84 7.9a.9.9 0 0 0-.23.37l-.53 1.66 1.67-.5a.9.9 0 0 0 .38-.23l3.6-3.62a.93.93 0 0 0 .06-1.24l-.06-.06-.06-.06a.9.9 0 0 0-1.22.06ZM12.89 4H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7.13l-1 1V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.23c.57-.49 1.34-1.11 2.07-1.54.41-.23.78-.38 1.07-.43.28-.05.42 0 .5.1.08.07.1.13.11.18.01.06 0 .15-.04.27-.1.28-.3.6-.6 1.02l-.1.13c-.25.35-.53.74-.73 1.14-.22.45-.4 1-.2 1.56.17.5.5.84.92 1 .4.17.85.15 1.24.08a6.5 6.5 0 0 0 2.02-.81.5.5 0 0 0-.52-.86c-.4.24-1.07.58-1.68.69-.3.05-.53.04-.7-.02-.13-.06-.26-.16-.34-.4-.06-.19-.03-.43.15-.8.16-.31.4-.64.66-1l.1-.13c.27-.39.58-.83.73-1.27.08-.23.12-.5.08-.76a1.32 1.32 0 0 0-.39-.73c-.4-.4-.91-.46-1.38-.38-.46.08-.95.3-1.4.56-.54.31-1.1.72-1.57 1.1V7c0-1.1.9-2 2-2h6.9l1-1Z"
]);
const $4125b41377e9d21d$export$1cb0a61aedb74129 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.5 4.21A2.5 2.5 0 0 0 2 6.5v2.26c.52-.48 1.12-.98 1.72-1.4.63-.45 1.3-.84 1.92-1.02L7.6 8.3c-.08.18-.17.34-.26.5-.17.26-.38.55-.58.82l-.02.04c-.21.29-.42.58-.61.88-.16.28-.2.62-.13.86.03.12.1.2.17.27.07.06.19.12.37.13.33.03.76-.08 1.3-.27a.5.5 0 1 1 .33.94 4.2 4.2 0 0 1-1.71.33 1.52 1.52 0 0 1-1.41-1.12 2.19 2.19 0 0 1 .21-1.65h.01v-.01c.22-.34.45-.66.66-.95l.01-.02c.21-.29.4-.54.55-.78.32-.53.3-.73.22-.84a.4.4 0 0 0-.25-.17 1.08 1.08 0 0 0-.5.03c-.47.12-1.04.44-1.66.88-.85.6-1.7 1.38-2.3 1.98v3.35A2.5 2.5 0 0 0 4.5 16h10.8l1.85 1.85a.5.5 0 0 0 .7-.7l-15-15Zm8.4 9.8a1.84 1.84 0 0 1-2.2-2.2l2.2 2.2Zm-.73-3.55 2.1 2.1.42-.13c.3-.09.58-.25.8-.47l3.6-3.62c.71-.71.74-1.85.1-2.6l-.1-.12-.1-.1a1.9 1.9 0 0 0-2.6.1L11.13 7.2a1.9 1.9 0 0 0-.47.76l-.14.45Zm6.8 6.8-3.9-3.9c.43-.14.8-.38 1.13-.7L18 7.13v6.37a2.5 2.5 0 0 1-.67 1.7ZM6.13 4l3.6 3.6c.15-.42.38-.8.7-1.12L12.89 4H6.12Z"
]);
const $4125b41377e9d21d$export$75507a91205ab051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WhiteboardOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.48 1.48A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h10l.28-.01 1.87 1.86a.5.5 0 0 0 .7-.7l-15-15ZM14.3 15H5a2 2 0 0 1-2-2V9.23c.57-.49 1.34-1.11 2.07-1.54.41-.23.78-.38 1.07-.43.28-.05.42 0 .5.1.08.07.1.13.11.18.01.06 0 .15-.04.27-.1.28-.3.6-.6 1.02l-.1.13c-.25.35-.53.74-.73 1.14-.22.45-.4 1-.2 1.56.17.5.5.84.92 1 .4.17.85.15 1.24.08a6.5 6.5 0 0 0 2.02-.81.5.5 0 0 0-.52-.86c-.4.24-1.07.58-1.68.69-.3.05-.53.04-.7-.02-.13-.06-.26-.16-.34-.4-.06-.19-.03-.43.15-.8.16-.31.4-.64.66-1l.1-.13c.23-.34.5-.72.67-1.1L14.3 15ZM5.64 6.35c-.36.1-.72.28-1.07.48-.54.31-1.1.72-1.57 1.1V7a2 2 0 0 1 1.39-1.9l1.25 1.25Zm7.4 4.02-.42.13-.8-.8.93-.28a.9.9 0 0 0 .38-.23l3.6-3.62a.93.93 0 0 0 .06-1.24l-.06-.06-.06-.06a.9.9 0 0 0-1.22.06l-3.61 3.62a.9.9 0 0 0-.23.37l-.3.93-.79-.8.14-.44c.1-.29.25-.55.47-.76l3.6-3.63a1.9 1.9 0 0 1 2.6-.1l.11.1.1.11c.64.76.61 1.9-.1 2.6l-3.6 3.63c-.22.22-.5.38-.8.47Zm4.14 4.69-.7-.7A2 2 0 0 0 17 13V8.14l1-1V13c0 .8-.31 1.52-.82 2.06ZM6.12 4l1 1h4.77l1-1H6.12Z"
]);


const $c823d65ebf8ac0ff$export$25ba4469a069167 = 'Alt';
const $c823d65ebf8ac0ff$export$59af8b07a9eee9db = 'AltGraph';
const $c823d65ebf8ac0ff$export$de140f0a2ba89d59 = 'CapsLock';
const $c823d65ebf8ac0ff$export$7a7fa4424cb20976 = 'Control';
const $c823d65ebf8ac0ff$export$b076717d71a1a47f = 'Fn';
const $c823d65ebf8ac0ff$export$85f6e01fa084f0f6 = 'FnLock';
const $c823d65ebf8ac0ff$export$b08a9033b36413fb = 'Meta';
const $c823d65ebf8ac0ff$export$935daf61042b74de = 'NumLock';
const $c823d65ebf8ac0ff$export$43c4ad2b7f26555a = 'ScrollLock';
const $c823d65ebf8ac0ff$export$e6d3b4e5ac18cdaf = 'Shift';
const $c823d65ebf8ac0ff$export$3e25e887b7a5b37b = 'Symbol';
const $c823d65ebf8ac0ff$export$ff2e891f6682d840 = 'SymbolLock';
const $c823d65ebf8ac0ff$export$92ce8cce26bb97e1 = 'Hyper';
const $c823d65ebf8ac0ff$export$da846968fb7f9d62 = 'Super';
const $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a = 'Enter';
const $c823d65ebf8ac0ff$export$eef1e68107c58ef2 = ' ';
const $c823d65ebf8ac0ff$export$3e41faf802a29e71 = 'Tab';
const $c823d65ebf8ac0ff$export$1fa5a43af950a186 = 'ArrowDown';
const $c823d65ebf8ac0ff$export$e4c291d45fea4cd0 = 'ArrowLeft';
const $c823d65ebf8ac0ff$export$acad20503ad73ac1 = 'ArrowRight';
const $c823d65ebf8ac0ff$export$2624c5890f1bbcf7 = 'ArrowUp';
const $c823d65ebf8ac0ff$export$290d774e6bd35c9a = 'End';
const $c823d65ebf8ac0ff$export$b94310965bed44e6 = 'Home';
const $c823d65ebf8ac0ff$export$f3f5fc7dcaa52927 = 'PageDown';
const $c823d65ebf8ac0ff$export$f1f11e2fed2d2ae0 = 'PageUp';
const $c823d65ebf8ac0ff$export$e25335cbdf9a4ec4 = 'Backspace';
const $c823d65ebf8ac0ff$export$47d037774b685574 = 'Clear';
const $c823d65ebf8ac0ff$export$92ce62e1201c4fc0 = 'Copy';
const $c823d65ebf8ac0ff$export$65b53f7e8e8587 = 'CrSel';
const $c823d65ebf8ac0ff$export$e5934e6b116b2ede = 'Cut';
const $c823d65ebf8ac0ff$export$bfadae053a633538 = 'Delete';
const $c823d65ebf8ac0ff$export$8fd09476bf36ce41 = 'EraseEof';
const $c823d65ebf8ac0ff$export$f641b683dcc3ebbb = 'ExSel';
const $c823d65ebf8ac0ff$export$ff4c1a9d41c61c5b = 'Insert';
const $c823d65ebf8ac0ff$export$80c501ac3232bb66 = 'Paste';
const $c823d65ebf8ac0ff$export$c51819d211d1dad = 'Redo';
const $c823d65ebf8ac0ff$export$897c9ed706d8ea48 = 'Undo';
const $c823d65ebf8ac0ff$export$5e41db7437457e4f = 'Accept';
const $c823d65ebf8ac0ff$export$435aa52f9ca2e684 = 'Again';
const $c823d65ebf8ac0ff$export$e0f3a40f49e6b4ff = 'Attn';
const $c823d65ebf8ac0ff$export$848c9b7ead0df967 = 'Cancel';
const $c823d65ebf8ac0ff$export$8dc6765e8be191c7 = 'ContextMenu';
const $c823d65ebf8ac0ff$export$d244daf709653685 = 'Escape';
const $c823d65ebf8ac0ff$export$560e7ab682a21a3c = 'Execute';
const $c823d65ebf8ac0ff$export$294e5983706f3c8d = 'Find';
const $c823d65ebf8ac0ff$export$1be7516c0280bee8 = 'Help';
const $c823d65ebf8ac0ff$export$59704c468e1a1527 = 'Pause';
const $c823d65ebf8ac0ff$export$480db61f4dcd7727 = 'Play';
const $c823d65ebf8ac0ff$export$ab4150be7c673f50 = 'Props';
const $c823d65ebf8ac0ff$export$ef9b1a59e592288f = 'Select';
const $c823d65ebf8ac0ff$export$d13069184bfa0730 = 'ZoomIn';
const $c823d65ebf8ac0ff$export$adc4acb67269225 = 'ZoomOut';
const $c823d65ebf8ac0ff$export$1361e444dea2380e = 'BrightnessDown';
const $c823d65ebf8ac0ff$export$52c78b8b992a9d7b = 'BrightnessUp';
const $c823d65ebf8ac0ff$export$d4dc4917073a0ad9 = 'Eject';
const $c823d65ebf8ac0ff$export$c21a1ae6c09d0c57 = 'LogOff';
const $c823d65ebf8ac0ff$export$462bb9472183e274 = 'Power';
const $c823d65ebf8ac0ff$export$71987bfdb1faebb3 = 'PowerOff';
const $c823d65ebf8ac0ff$export$898492d04dfd3de8 = 'PrintScreen';
const $c823d65ebf8ac0ff$export$a419a54b514863c2 = 'Hibernate';
const $c823d65ebf8ac0ff$export$45b51bd799a30168 = 'Standby';
const $c823d65ebf8ac0ff$export$accb22b45fb25893 = 'WakeUp';
const $c823d65ebf8ac0ff$export$f4a731e02c2e22f6 = 'AllCandidates';
const $c823d65ebf8ac0ff$export$92278791597e195 = 'Alphanumeric';
const $c823d65ebf8ac0ff$export$20d4ca75cb144ab0 = 'CodeInput';
const $c823d65ebf8ac0ff$export$5a3a146e358e1bcf = 'Compose';
const $c823d65ebf8ac0ff$export$f4e2e0de8bec13cf = 'Convert';
const $c823d65ebf8ac0ff$export$d7c1bc91029ca3fc = 'Dead';
const $c823d65ebf8ac0ff$export$1a6ade3e5895c67 = 'FinalMode';
const $c823d65ebf8ac0ff$export$3a329d64ac7f1a51 = 'GroupFirst';
const $c823d65ebf8ac0ff$export$f775ac7670e6b750 = 'GroupLast';
const $c823d65ebf8ac0ff$export$e225a46cee3c4cbf = 'GroupNext';
const $c823d65ebf8ac0ff$export$346c400effc2098d = 'GroupPrevious';
const $c823d65ebf8ac0ff$export$d5d4baa34b8f359e = 'ModeChange';
const $c823d65ebf8ac0ff$export$aa9692744b99ab14 = 'NextCandidate';
const $c823d65ebf8ac0ff$export$ac3b287d18bbde8d = 'NonConvert';
const $c823d65ebf8ac0ff$export$f2b24c1f23968e85 = 'PreviousCandidate';
const $c823d65ebf8ac0ff$export$ddab65ae98aaa487 = 'Process';
const $c823d65ebf8ac0ff$export$a3eac4bc82a98f75 = 'SingleCandidate';
const $c823d65ebf8ac0ff$export$7fe3746ef513c197 = 'HangulMode';
const $c823d65ebf8ac0ff$export$cf6da7241d7db023 = 'HanjaMode';
const $c823d65ebf8ac0ff$export$8b68c9a12bd240a4 = 'JunjaMode';
const $c823d65ebf8ac0ff$export$9d3c4c35a5b6cb1a = 'Eisu';
const $c823d65ebf8ac0ff$export$ad60463326eb8d49 = 'Hankaku';
const $c823d65ebf8ac0ff$export$944438bf8b555670 = 'Hiragana';
const $c823d65ebf8ac0ff$export$e6702f8ed49de60b = 'HiraganaKatakana';
const $c823d65ebf8ac0ff$export$5f227dee8c8f89bd = 'KanaMode';
const $c823d65ebf8ac0ff$export$bc0d53240167fa99 = 'KanjiMode';
const $c823d65ebf8ac0ff$export$dd82d5fd5fe7d4fe = 'Katakana';
const $c823d65ebf8ac0ff$export$d85cc3e8bea4280c = 'Romaji';
const $c823d65ebf8ac0ff$export$c8b3f24ac2a372b7 = 'Zenkaku';
const $c823d65ebf8ac0ff$export$58cf8ce148011bd3 = 'ZenkakuHankaku';
const $c823d65ebf8ac0ff$export$189139d8e2521ccc = 'F1';
const $c823d65ebf8ac0ff$export$1e3ae41a03c26919 = 'F2';
const $c823d65ebf8ac0ff$export$635acc0d5908ed6d = 'F3';
const $c823d65ebf8ac0ff$export$1daa073286f9821f = 'F4';
const $c823d65ebf8ac0ff$export$1946172b343c019d = 'F5';
const $c823d65ebf8ac0ff$export$75fb47052abeaeb = 'F6';
const $c823d65ebf8ac0ff$export$cb2b09ce06c88edb = 'F7';
const $c823d65ebf8ac0ff$export$a364ba9f791bbf64 = 'F8';
const $c823d65ebf8ac0ff$export$8dc034ae6f0a8c86 = 'F9';
const $c823d65ebf8ac0ff$export$607ddfc630acfa0 = 'F10';
const $c823d65ebf8ac0ff$export$ccd0054ab4cc4a07 = 'F11';
const $c823d65ebf8ac0ff$export$c9226ba6c07c198e = 'F12';
const $c823d65ebf8ac0ff$export$5b2985c878b189d2 = 'Soft1';
const $c823d65ebf8ac0ff$export$47a30c2a117456eb = 'Soft2';
const $c823d65ebf8ac0ff$export$cbb7360f9ae873c1 = 'Soft3';
const $c823d65ebf8ac0ff$export$5dd66fbf7e8260e7 = 'Soft4';
const $c823d65ebf8ac0ff$export$edd78e781e0d91ff = 'ChannelDown';
const $c823d65ebf8ac0ff$export$f69d726584685fbc = 'ChannelUp';
const $c823d65ebf8ac0ff$export$f39c2d165cd861fe = 'Close';
const $c823d65ebf8ac0ff$export$c81fc8a9aa3cbfaf = 'MailForward';
const $c823d65ebf8ac0ff$export$1072dc4384cd4b49 = 'MailReply';
const $c823d65ebf8ac0ff$export$64e48c990591dd67 = 'MailSend';
const $c823d65ebf8ac0ff$export$edf5f293e15173a6 = 'MediaClose';
const $c823d65ebf8ac0ff$export$8f522530c3047c1 = 'MediaFastForward';
const $c823d65ebf8ac0ff$export$9b4e157ea6b03dc4 = 'MediaPause';
const $c823d65ebf8ac0ff$export$1e02dc8586261377 = 'MediaPlay';
const $c823d65ebf8ac0ff$export$3c4de6c4ec72c4a9 = 'MediaPlayPause';
const $c823d65ebf8ac0ff$export$ae0d6fe390a63c9b = 'MediaRecord';
const $c823d65ebf8ac0ff$export$106df2f4ddf898f5 = 'MediaRewind';
const $c823d65ebf8ac0ff$export$93f45f2572765c74 = 'MediaStop';
const $c823d65ebf8ac0ff$export$95f1ee4a29e0c422 = 'MediaTrackNext';
const $c823d65ebf8ac0ff$export$6e7bf1921fe33a28 = 'MediaTrackPrevious';
const $c823d65ebf8ac0ff$export$6fbbeb565555321b = 'New';
const $c823d65ebf8ac0ff$export$779aeef03935e9f3 = 'Open';
const $c823d65ebf8ac0ff$export$531cef85654f2406 = 'Print';
const $c823d65ebf8ac0ff$export$be11e187edb4cb0c = 'Save';
const $c823d65ebf8ac0ff$export$ce472e30b45fe044 = 'SpellCheck';
const $c823d65ebf8ac0ff$export$1c9f0644f2f359f7 = 'Key11';
const $c823d65ebf8ac0ff$export$10026628c273d8d9 = 'Key12';
const $c823d65ebf8ac0ff$export$8122d65462c044f9 = 'AudioBalanceLeft';
const $c823d65ebf8ac0ff$export$6da512133087dc19 = 'AudioBalanceRight';
const $c823d65ebf8ac0ff$export$483279f0eb3eb6c3 = 'AudioBassBoostDown';
const $c823d65ebf8ac0ff$export$dd0b45a57e31277c = 'AudioBassBoostToggle';
const $c823d65ebf8ac0ff$export$714e09e823f1100e = 'AudioBassBoostUp';
const $c823d65ebf8ac0ff$export$7546180a9f863cb2 = 'AudioFaderFront';
const $c823d65ebf8ac0ff$export$ad637d01b6d3b5b0 = 'AudioFaderRear';
const $c823d65ebf8ac0ff$export$632aa3a36fcce0d9 = 'AudioSurroundModeNext';
const $c823d65ebf8ac0ff$export$32462dede531b63a = 'AudioTrebleDown';
const $c823d65ebf8ac0ff$export$7c316c5a895eb62 = 'AudioTrebleUp';
const $c823d65ebf8ac0ff$export$73ba68778999bb0b = 'AudioVolumeDown';
const $c823d65ebf8ac0ff$export$2727396b9ea4f301 = 'AudioVolumeUp';
const $c823d65ebf8ac0ff$export$f1cc599231f0155f = 'AudioVolumeMute';
const $c823d65ebf8ac0ff$export$f7ba91b6392d3030 = 'MicrophoneToggle';
const $c823d65ebf8ac0ff$export$1a6f6715b16c7dac = 'MicrophoneVolumeDown';
const $c823d65ebf8ac0ff$export$edac5fcbe056b9dd = 'MicrophoneVolumeUp';
const $c823d65ebf8ac0ff$export$a85734c74c77229f = 'MicrophoneVolumeMute';
const $c823d65ebf8ac0ff$export$9b0f6845932a5311 = 'SpeechCorrectionList';
const $c823d65ebf8ac0ff$export$b2ea9c6dbc054596 = 'SpeechInputToggle';
const $c823d65ebf8ac0ff$export$fbf5eb6b5b5f796e = 'LaunchApplication1';
const $c823d65ebf8ac0ff$export$b0af841ea1ac8caa = 'LaunchApplication2';
const $c823d65ebf8ac0ff$export$ee1b38b1fd2fd6ee = 'LaunchCalendar';
const $c823d65ebf8ac0ff$export$f2c32a949fcd2577 = 'LaunchContacts';
const $c823d65ebf8ac0ff$export$8b4d07d8a62ed27d = 'LaunchMail';
const $c823d65ebf8ac0ff$export$8a9d2216beeea70d = 'LaunchMediaPlayer';
const $c823d65ebf8ac0ff$export$fc0f93baa0ed8d1e = 'LaunchMusicPlayer';
const $c823d65ebf8ac0ff$export$9fc5515b060d76e3 = 'LaunchPhone';
const $c823d65ebf8ac0ff$export$67cf4f9dab019464 = 'LaunchScreenSaver';
const $c823d65ebf8ac0ff$export$e45e736041b7f018 = 'LaunchSpreadsheet';
const $c823d65ebf8ac0ff$export$db793ade57fb0147 = 'LaunchWebBrowser';
const $c823d65ebf8ac0ff$export$ad042fb7176822eb = 'LaunchWebCam';
const $c823d65ebf8ac0ff$export$7d9d2a2b3d9d2ac6 = 'LaunchWordProcessor';
const $c823d65ebf8ac0ff$export$9383a2f3942b58dc = 'BrowserBack';
const $c823d65ebf8ac0ff$export$f6274726848eadf1 = 'BrowserFavorites';
const $c823d65ebf8ac0ff$export$fcc53b6d63518134 = 'BrowserForward';
const $c823d65ebf8ac0ff$export$4a475f075adf9434 = 'BrowserHome';
const $c823d65ebf8ac0ff$export$93523c070c325fbe = 'BrowserRefresh';
const $c823d65ebf8ac0ff$export$8c96437a8d9c2d7c = 'BrowserSearch';
const $c823d65ebf8ac0ff$export$cc42d7573a67ba70 = 'BrowserStop';
const $c823d65ebf8ac0ff$export$7a6c770856067f4 = 'AppSwitch';
const $c823d65ebf8ac0ff$export$e01e40655568efad = 'Call';
const $c823d65ebf8ac0ff$export$79f141de891a5fed = 'Camera';
const $c823d65ebf8ac0ff$export$f8793b8700b5ba17 = 'CameraFocus';
const $c823d65ebf8ac0ff$export$957e375d95a01391 = 'EndCall';
const $c823d65ebf8ac0ff$export$bbadff23f5cd28e2 = 'GoBack';
const $c823d65ebf8ac0ff$export$f271c87cf8064402 = 'GoHome';
const $c823d65ebf8ac0ff$export$669d837cde3081c0 = 'HeadsetHook';
const $c823d65ebf8ac0ff$export$9ac012462c421cb2 = 'LastNumberRedial';
const $c823d65ebf8ac0ff$export$14834abbfce3b8cd = 'Notification';
const $c823d65ebf8ac0ff$export$3046760ea9ca3af0 = 'MannerMode';
const $c823d65ebf8ac0ff$export$71f79e08c826dea6 = 'VoiceDial';
const $c823d65ebf8ac0ff$export$9e799ed47e538f9d = 'TV';
const $c823d65ebf8ac0ff$export$33e0cb2ba3e36b39 = 'TV3DMode';
const $c823d65ebf8ac0ff$export$bb4f7668fbcf057d = 'TVAntennaCable';
const $c823d65ebf8ac0ff$export$63219ff5d58c45a0 = 'TVAudioDescription';
const $c823d65ebf8ac0ff$export$80792179d8ffd87b = 'TVAudioDescriptionMixDown';
const $c823d65ebf8ac0ff$export$5f010be0cd6b0b = 'TVAudioDescriptionMixUp';
const $c823d65ebf8ac0ff$export$426bc8423e6463a0 = 'TVContentsMenu';
const $c823d65ebf8ac0ff$export$a32169e4018a2b38 = 'TVDataService';
const $c823d65ebf8ac0ff$export$ae9bbd79b65e7a97 = 'TVInput';
const $c823d65ebf8ac0ff$export$93fe7d4f0cc9dd81 = 'TVInputComponent1';
const $c823d65ebf8ac0ff$export$a68eb799b6a9424 = 'TVInputComponent2';
const $c823d65ebf8ac0ff$export$bde9e691d0b9763a = 'TVInputComposite1';
const $c823d65ebf8ac0ff$export$ee37f778b870c960 = 'TVInputComposite2';
const $c823d65ebf8ac0ff$export$57441ed7d940ad4a = 'TVInputHDMI1';
const $c823d65ebf8ac0ff$export$18f2cbc95c3f5d9e = 'TVInputHDMI2';
const $c823d65ebf8ac0ff$export$d59b33776600d743 = 'TVInputHDMI3';
const $c823d65ebf8ac0ff$export$cbaf98d010a337f8 = 'TVInputHDMI4';
const $c823d65ebf8ac0ff$export$43d009fc6a4abcc = 'TVInputVGA1';
const $c823d65ebf8ac0ff$export$5229da00664eabf3 = 'TVMediaContext';
const $c823d65ebf8ac0ff$export$41b7110227dfa031 = 'TVNetwork';
const $c823d65ebf8ac0ff$export$6d808ba490e74aa3 = 'TVNumberEntry';
const $c823d65ebf8ac0ff$export$caa626888309eac9 = 'TVPower';
const $c823d65ebf8ac0ff$export$465fb7cc725b756a = 'TVRadioService';
const $c823d65ebf8ac0ff$export$b012fab6006633c1 = 'TVSatellite';
const $c823d65ebf8ac0ff$export$652ec5c6f91c9d58 = 'TVSatelliteBS';
const $c823d65ebf8ac0ff$export$375e3750892b9a0d = 'TVSatelliteCS';
const $c823d65ebf8ac0ff$export$4082bee118d1265 = 'TVSatelliteToggle';
const $c823d65ebf8ac0ff$export$11d23f8a290bea2b = 'TVTerrestrialAnalog';
const $c823d65ebf8ac0ff$export$476a62c057a18f0d = 'TVTerrestrialDigital';
const $c823d65ebf8ac0ff$export$1bf89d9356f73f3 = 'TVTimer';
const $c823d65ebf8ac0ff$export$6bfa7bac815a7be2 = 'AVRInput';
const $c823d65ebf8ac0ff$export$291a3d36bd9f5546 = 'AVRPower';
const $c823d65ebf8ac0ff$export$d65c414782d498de = 'ColorF0Red';
const $c823d65ebf8ac0ff$export$2012685419373360 = 'ColorF1Green';
const $c823d65ebf8ac0ff$export$d287aa78274089c5 = 'ColorF2Yellow';
const $c823d65ebf8ac0ff$export$816e2f41a947f921 = 'ColorF3Blue';
const $c823d65ebf8ac0ff$export$6683adba19f75ed8 = 'ColorF4Grey';
const $c823d65ebf8ac0ff$export$31f0b6897f069965 = 'ColorF5Brown';
const $c823d65ebf8ac0ff$export$28a7e8424097b671 = 'ClosedCaptionToggle';
const $c823d65ebf8ac0ff$export$3fb4601d4ead3c62 = 'Dimmer';
const $c823d65ebf8ac0ff$export$719ea771b7828713 = 'DisplaySwap';
const $c823d65ebf8ac0ff$export$7b81c82872602fae = 'DVR';
const $c823d65ebf8ac0ff$export$6b467f3d80cc56bd = 'Exit';
const $c823d65ebf8ac0ff$export$96a657f4f48c50ca = 'FavoriteClear0';
const $c823d65ebf8ac0ff$export$c6fb7f02c9847a0d = 'FavoriteClear1';
const $c823d65ebf8ac0ff$export$4581aaa801b7ec9b = 'FavoriteClear2';
const $c823d65ebf8ac0ff$export$275386adfebc5a34 = 'FavoriteClear3';
const $c823d65ebf8ac0ff$export$61b6760a9dfd8707 = 'FavoriteRecall0';
const $c823d65ebf8ac0ff$export$da3457e02421bf54 = 'FavoriteRecall1';
const $c823d65ebf8ac0ff$export$a7e09d7128a01c9a = 'FavoriteRecall2';
const $c823d65ebf8ac0ff$export$5ee77092aab711bd = 'FavoriteRecall3';
const $c823d65ebf8ac0ff$export$cf26e14238406cee = 'FavoriteStore0';
const $c823d65ebf8ac0ff$export$e360b7bbb61b98be = 'FavoriteStore1';
const $c823d65ebf8ac0ff$export$f91c8b975d30e002 = 'FavoriteStore2';
const $c823d65ebf8ac0ff$export$a1ceb59d0b811ae1 = 'FavoriteStore3';
const $c823d65ebf8ac0ff$export$dd9cef36367ff841 = 'Guide';
const $c823d65ebf8ac0ff$export$7a182cb0eeb93ab4 = 'GuideNextDay';
const $c823d65ebf8ac0ff$export$622e3910f33c3413 = 'GuidePreviousDay';
const $c823d65ebf8ac0ff$export$c4868e4a24d48fad = 'Info';
const $c823d65ebf8ac0ff$export$933386c97295d716 = 'InstantReplay';
const $c823d65ebf8ac0ff$export$a6c7ac8248d6e38a = 'Link';
const $c823d65ebf8ac0ff$export$c629d7edb8f81150 = 'ListProgram';
const $c823d65ebf8ac0ff$export$187a27311c646af3 = 'LiveContent';
const $c823d65ebf8ac0ff$export$5b9db7ce80343746 = 'Lock';
const $c823d65ebf8ac0ff$export$1b05ff7bb714f205 = 'MediaApps';
const $c823d65ebf8ac0ff$export$6a1d69c1dfd7cee6 = 'MediaAudioTrack';
const $c823d65ebf8ac0ff$export$ea32a877d9a3c04b = 'MediaLast';
const $c823d65ebf8ac0ff$export$58c0dc6dee8229d6 = 'MediaSkipBackward';
const $c823d65ebf8ac0ff$export$f02af5448c28e643 = 'MediaSkipForward';
const $c823d65ebf8ac0ff$export$d93de6b744e7f775 = 'MediaStepBackward';
const $c823d65ebf8ac0ff$export$f195c508ba45e4d4 = 'MediaStepForward';
const $c823d65ebf8ac0ff$export$73b99fd9032b72a0 = 'MediaTopMenu';
const $c823d65ebf8ac0ff$export$6147da8f2d96a041 = 'NavigateIn';
const $c823d65ebf8ac0ff$export$5863dec6788ea825 = 'NavigateNext';
const $c823d65ebf8ac0ff$export$ca474796dcd7d2f0 = 'NavigateOut';
const $c823d65ebf8ac0ff$export$38470274bd182a0d = 'NavigatePrevious';
const $c823d65ebf8ac0ff$export$7752e86e50128cee = 'NextFavoriteChannel';
const $c823d65ebf8ac0ff$export$656a8f32548ff844 = 'NextUserProfile';
const $c823d65ebf8ac0ff$export$3d988c45712b99a8 = 'OnDemand';
const $c823d65ebf8ac0ff$export$3370ee24730992a3 = 'Pairing';
const $c823d65ebf8ac0ff$export$73145bfd3a66c33b = 'PinPDown';
const $c823d65ebf8ac0ff$export$53e49b189851b15c = 'PinPMove';
const $c823d65ebf8ac0ff$export$68cff71e428f1a5b = 'PinPToggle';
const $c823d65ebf8ac0ff$export$fe62d495f9003c3 = 'PinPUp';
const $c823d65ebf8ac0ff$export$c9e688c40e07f7ea = 'PlaySpeedDown';
const $c823d65ebf8ac0ff$export$9131444076d9b49c = 'PlaySpeedReset';
const $c823d65ebf8ac0ff$export$c637ceff9b8cf24b = 'PlaySpeedUp';
const $c823d65ebf8ac0ff$export$310aa7aef35aeb17 = 'RandomToggle';
const $c823d65ebf8ac0ff$export$816fbcb54c88008b = 'RcLowBattery';
const $c823d65ebf8ac0ff$export$9078327fd65a7e30 = 'RecordSpeedNext';
const $c823d65ebf8ac0ff$export$310f6f7a8361eb35 = 'RfBypass';
const $c823d65ebf8ac0ff$export$baf269e5522c7636 = 'ScanChannelsToggle';
const $c823d65ebf8ac0ff$export$6041af62c7dea690 = 'ScreenModeNext';
const $c823d65ebf8ac0ff$export$c72f6eaae7b9adff = 'Settings';
const $c823d65ebf8ac0ff$export$a8c15e166a71c22d = 'SplitScreenToggle';
const $c823d65ebf8ac0ff$export$6c74e90fec25fa17 = 'STBInput';
const $c823d65ebf8ac0ff$export$5eec06d46080e0c0 = 'STBPower';
const $c823d65ebf8ac0ff$export$cf345ef34cd72655 = 'Subtitle';
const $c823d65ebf8ac0ff$export$b61ce10a90716b81 = 'Teletext';
const $c823d65ebf8ac0ff$export$8e4bc819629db3b = 'VideoModeNext';
const $c823d65ebf8ac0ff$export$e2454f16675bb233 = 'Wink';
const $c823d65ebf8ac0ff$export$12f95e4a6c5dfacc = 'ZoomToggle';
const $c823d65ebf8ac0ff$export$94ccd17761f5db1a = 'MediaNextTrack';
const $c823d65ebf8ac0ff$export$42737eb19882d457 = 'MediaPreviousTrack';
const $c823d65ebf8ac0ff$export$b074e60c9656b373 = 'Unidentified';



parcelRequire("acw62");
'use client';
function $ce4d8d04d71d4d52$export$d4669238f28a66b8(type, props) {
    const { disabled: disabled, disabledFocusable: disabledFocusable = false, ['aria-disabled']: ariaDisabled, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...rest } = props !== null && props !== void 0 ? props : {};
    const normalizedARIADisabled = typeof ariaDisabled === 'string' ? ariaDisabled === 'true' : ariaDisabled;
    const isDisabled = disabled || disabledFocusable || normalizedARIADisabled;
    const handleClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        if (isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
        } else onClick === null || onClick === void 0 || onClick(ev);
    });
    const handleKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(ev);
        if (ev.isDefaultPrevented()) return;
        const key = ev.key;
        if (isDisabled && (key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a) || key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2))) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2)) {
            ev.preventDefault();
            return;
        } else if (key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a)) {
            ev.preventDefault();
            ev.currentTarget.click();
        }
    });
    const handleKeyUp = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(ev);
        if (ev.isDefaultPrevented()) return;
        const key = ev.key;
        if (isDisabled && (key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a) || key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2))) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (key === (0, $c823d65ebf8ac0ff$export$eef1e68107c58ef2)) {
            ev.preventDefault();
            ev.currentTarget.click();
        }
    });
    // If a <button> tag is to be rendered we just need to set disabled and aria-disabled correctly
    if (type === 'button' || type === undefined) return {
        ...rest,
        disabled: disabled && !disabledFocusable,
        'aria-disabled': disabledFocusable ? true : normalizedARIADisabled,
        // onclick should still use internal handler to ensure prevention if disabled
        // if disabledFocusable then there's no requirement for handlers as those events should not be propagated
        onClick: disabledFocusable ? undefined : handleClick,
        onKeyUp: disabledFocusable ? undefined : onKeyUp,
        onKeyDown: disabledFocusable ? undefined : onKeyDown
    };
    else {
        // the role needs to be explicitly set if the href is undefined
        const isLink = !!rest.href;
        let roleOverride = isLink ? undefined : 'button';
        if (!roleOverride && isDisabled) // need to set role=link explicitly for disabled links
        roleOverride = 'link';
        const resultProps = {
            role: roleOverride,
            tabIndex: disabledFocusable || !isLink && !disabled ? 0 : undefined,
            ...rest,
            // If it's not a <button> than listeners are required even with disabledFocusable
            // Since you cannot assure the default behavior of the element
            // E.g: <a> will redirect on click
            onClick: handleClick,
            onKeyUp: handleKeyUp,
            onKeyDown: handleKeyDown,
            'aria-disabled': isDisabled
        };
        if (type === 'a' && isDisabled) resultProps.href = undefined;
        return resultProps;
    }
}



'use client';
const $692f4c77629d178b$var$sortIcons = {
    ascending: /*#__PURE__*/ $acw62.createElement((0, $4125b41377e9d21d$export$caecfbc1460768bd), {
        fontSize: 12
    }),
    descending: /*#__PURE__*/ $acw62.createElement((0, $4125b41377e9d21d$export$55d639d200f88b40), {
        fontSize: 12
    })
};
const $692f4c77629d178b$export$7197a71a8b2e7ea4 = (props, ref)=>{
    const { noNativeElements: noNativeElements, sortable: contextSortable } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    const { sortable: sortable = contextSortable } = props;
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'th';
    // The sort button is rendered as a div when not sortable, and as an ARIA button when sortable.
    const buttonSlot = (0, $fcf7ddccaab7fd8f$exports).always(props.button, {
        elementType: 'div',
        defaultProps: {
            as: 'div'
        }
    });
    const ariaButtonProps = (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)(buttonSlot.as, buttonSlot);
    var _props_sortDirection;
    return {
        components: {
            root: rootComponent,
            button: 'div',
            sortIcon: 'span',
            aside: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, (0, $4f816f386fc6883e$export$420e68273165f4ec)()),
            role: rootComponent === 'div' ? 'columnheader' : undefined,
            'aria-sort': sortable ? (_props_sortDirection = props.sortDirection) !== null && _props_sortDirection !== void 0 ? _props_sortDirection : 'none' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        aside: (0, $fcf7ddccaab7fd8f$exports).optional(props.aside, {
            elementType: 'span'
        }),
        sortIcon: (0, $fcf7ddccaab7fd8f$exports).optional(props.sortIcon, {
            renderByDefault: !!props.sortDirection,
            defaultProps: {
                children: props.sortDirection ? $692f4c77629d178b$var$sortIcons[props.sortDirection] : undefined
            },
            elementType: 'span'
        }),
        button: sortable ? ariaButtonProps : buttonSlot,
        sortable: sortable,
        noNativeElements: noNativeElements
    };
};




const $683e4b505f735064$export$1caee3bacbffe101 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.button, {
                children: [
                    state.root.children,
                    state.sortIcon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.sortIcon, {})
                ]
            }),
            state.aside && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.aside, {})
        ]
    });
};





'use client';
const $84d7992de60e562b$export$c4cdd744796b53d1 = 'fui-TableHeaderCell';
const $84d7992de60e562b$export$e9899c425d8ab6ea = {
    root: 'fui-TableHeaderCell',
    button: 'fui-TableHeaderCell__button',
    sortIcon: 'fui-TableHeaderCell__sortIcon',
    aside: 'fui-TableHeaderCell__aside'
};
const $84d7992de60e562b$var$useTableLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}"
    ]
});
const $84d7992de60e562b$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        xawz: 0,
        Bh6795r: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr",
        Bf4jedk: "f10tiqix"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f10tiqix{min-width:0px;}"
    ]
});
/**
 * Styles for the root slot
 */ const $84d7992de60e562b$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        Bhrd7zp: "figsok6",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f3gpkru",
        robkg1: 0,
        Bmvh20x: 0,
        B3nxjsc: 0,
        Bmkhcsx: "f14ym4q2",
        B8osjzx: 0,
        pehzd3: 0,
        Blsv9te: 0,
        u7xebq: 0,
        Bsvwmf7: "f1euou18",
        qhf8xq: "f10pi13n"
    },
    rootInteractive: {
        Bi91k9c: "feu1g3u",
        Jwef8y: "f1t94bn6",
        lj723h: "f1g4hkjv",
        ecr2s2: "f1wfn5kd"
    },
    resetButton: {
        B3rzk8w: "fq6nmtn",
        B7ck84d: "f1e4lqlz",
        De3pzq: "f1u2r49w",
        sj55zd: "f1ym3bx4",
        Bahqtrf: "f1mo0ibp",
        Be2twd7: "fjoy568",
        Bg96gwp: "fytdu2e",
        B68tc82: 0,
        Bmxbyg5: 0,
        Bpg54ce: "f1gl81tg",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1mk8lai",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f3bhgqh",
        fsow6f: "fgusgyc"
    },
    button: {
        qhf8xq: "f10pi13n",
        a9b677: "fly5x3f",
        mc9l5x: "f22iagw",
        Bh6795r: 0,
        Bqenvij: "f1l02sjl",
        Bt984gj: "f122n59",
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "fkln5zr",
        sshi5w: "f1nxs5xn",
        xawz: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr",
        oeaueh: "f1s6fcnf"
    },
    sortable: {
        Bceei9c: "f1k6fduh"
    },
    sortIcon: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z8tnut: "fclwglc"
    },
    resizeHandle: {}
}, {
    d: [
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        [
            ".f3gpkru{padding:0px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".f14ym4q2[data-fui-focus-within]:focus-within{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f1euou18[data-fui-focus-within]:focus-within{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f10pi13n{position:relative;}",
        ".fq6nmtn{resize:horizontal;}",
        ".f1e4lqlz{box-sizing:content-box;}",
        ".f1u2r49w{background-color:inherit;}",
        ".f1ym3bx4{color:inherit;}",
        ".f1mo0ibp{font-family:inherit;}",
        ".fjoy568{font-size:inherit;}",
        ".fytdu2e{line-height:normal;}",
        [
            ".f1gl81tg{overflow:visible;}",
            {
                p: -1
            }
        ],
        [
            ".f1mk8lai{padding:0;}",
            {
                p: -1
            }
        ],
        [
            ".f3bhgqh{border:none;}",
            {
                p: -2
            }
        ],
        ".fgusgyc{text-align:unset;}",
        ".fly5x3f{width:100%;}",
        ".f22iagw{display:flex;}",
        ".fqerorx{flex-grow:1;}",
        ".f1l02sjl{height:100%;}",
        ".f122n59{align-items:center;}",
        [
            ".fkln5zr{gap:var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".f1nxs5xn{min-height:32px;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f1s6fcnf{outline-style:none;}",
        ".f1k6fduh{cursor:pointer;}",
        ".fclwglc{padding-top:var(--spacingVerticalXXS);}"
    ],
    h: [
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}"
    ],
    a: [
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"
    ]
});
const $84d7992de60e562b$export$fd06fb7c91cd230d = (state)=>{
    'use no memo';
    const styles = $84d7992de60e562b$var$useStyles();
    const layoutStyles = {
        table: $84d7992de60e562b$var$useTableLayoutStyles(),
        flex: $84d7992de60e562b$var$useFlexLayoutStyles()
    };
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.root, styles.root, state.sortable && styles.rootInteractive, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    state.button.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.button, styles.resetButton, styles.button, state.sortable && styles.sortable, state.button.className);
    if (state.sortIcon) state.sortIcon.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.sortIcon, styles.sortIcon, state.sortIcon.className);
    if (state.aside) state.aside.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($84d7992de60e562b$export$e9899c425d8ab6ea.aside, styles.resizeHandle, state.aside.className);
    return state;
};



'use client';
const $9460e3ff7c1178b7$export$9e1517a3035b3e5c = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $692f4c77629d178b$export$7197a71a8b2e7ea4)(props, ref);
    (0, $84d7992de60e562b$export$fd06fb7c91cd230d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableHeaderCellStyles_unstable')(state);
    return (0, $683e4b505f735064$export$1caee3bacbffe101)(state);
});
$9460e3ff7c1178b7$export$9e1517a3035b3e5c.displayName = 'TableHeaderCell';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");


'use client';
const $8101482021a5884c$export$b741573d470b5ef8 = (props, ref)=>{
    const { noNativeElements: noNativeElements } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'tbody';
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'rowgroup' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements: noNativeElements
    };
};




const $84bc9f9e87c62eb4$export$d1288c869c03293b = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};



'use client';
const $bffb00ac76cc8178$var$useTableLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f1tp1avn"
    }
}, {
    d: [
        ".f1tp1avn{display:table-row-group;}"
    ]
});
const $bffb00ac76cc8178$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
const $bffb00ac76cc8178$export$e20b03b28efd7e23 = 'fui-TableBody';
const $bffb00ac76cc8178$export$86e68acdc819877e = {
    root: 'fui-TableBody'
};
const $bffb00ac76cc8178$export$a5642703f6d0b5f2 = (state)=>{
    'use no memo';
    const layoutStyles = {
        table: $bffb00ac76cc8178$var$useTableLayoutStyles(),
        flex: $bffb00ac76cc8178$var$useFlexLayoutStyles()
    };
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($bffb00ac76cc8178$export$e20b03b28efd7e23, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.root.className);
    return state;
};



'use client';
const $3f2f433630850f26$export$76ccd210b9029917 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8101482021a5884c$export$b741573d470b5ef8)(props, ref);
    (0, $bffb00ac76cc8178$export$a5642703f6d0b5f2)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableBodyStyles_unstable')(state);
    return (0, $84bc9f9e87c62eb4$export$d1288c869c03293b)(state);
});
$3f2f433630850f26$export$76ccd210b9029917.displayName = 'TableBody';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");


'use client';
const $00c499bc138309ea$export$6ead74c378e7a6c7 = (props, ref)=>{
    const { noNativeElements: noNativeElements, size: size } = (0, $bf449bf33e2cb0a3$export$3cb274deb6c2d854)();
    var _props_as;
    const rootComponent = ((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : noNativeElements) ? 'div' : 'td';
    return {
        components: {
            root: rootComponent
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)(rootComponent, {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            role: rootComponent === 'div' ? 'cell' : undefined,
            ...props
        }), {
            elementType: rootComponent
        }),
        noNativeElements: noNativeElements,
        size: size
    };
};




const $29e6fbfd80438988$export$386709cc44b79068 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};





'use client';
const $8f182bcf5e72beb2$export$83ece4e0726d8cb4 = 'fui-TableCell';
const $8f182bcf5e72beb2$export$966b503d9ebcb5b = {
    root: $8f182bcf5e72beb2$export$83ece4e0726d8cb4
};
const $8f182bcf5e72beb2$var$useTableLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f15pt5es",
        ha4doy: "fmrv4ls"
    },
    medium: {
        Bqenvij: "f1ft4266"
    },
    small: {
        Bqenvij: "fbsu25e"
    },
    "extra-small": {
        Bqenvij: "frvgh55"
    }
}, {
    d: [
        ".f15pt5es{display:table-cell;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f1ft4266{height:44px;}",
        ".fbsu25e{height:34px;}",
        ".frvgh55{height:24px;}"
    ]
});
const $8f182bcf5e72beb2$var$useFlexLayoutStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "f22iagw",
        Bf4jedk: "f10tiqix",
        Bt984gj: "f122n59",
        xawz: 0,
        Bh6795r: 0,
        Bnnss6s: 0,
        fkmc3a: "f1izfyrr"
    },
    medium: {
        sshi5w: "f5pgtk9"
    },
    small: {
        sshi5w: "fcep9tg"
    },
    "extra-small": {
        sshi5w: "f1pha7fy"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f10tiqix{min-width:0px;}",
        ".f122n59{align-items:center;}",
        [
            ".f1izfyrr{flex:1 1 0px;}",
            {
                p: -1
            }
        ],
        ".f5pgtk9{min-height:44px;}",
        ".fcep9tg{min-height:34px;}",
        ".f1pha7fy{min-height:24px;}"
    ]
});
/**
 * Styles for the root slot
 */ const $8f182bcf5e72beb2$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        qhf8xq: "f10pi13n",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f3gpkru",
        Bfpq7zp: 0,
        g9k6zt: 0,
        Bn4voq9: 0,
        giviqs: "f1dxfoyt",
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f2krc9w"
    }
}, {
    d: [
        ".f10pi13n{position:relative;}",
        [
            ".f3gpkru{padding:0px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".f1dxfoyt[data-fui-focus-visible]{outline:2px solid var(--colorStrokeFocus2);}",
            {
                p: -1
            }
        ],
        [
            ".f2krc9w[data-fui-focus-visible]{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ]
    ]
});
const $8f182bcf5e72beb2$export$a2f26cfede75a646 = (state)=>{
    'use no memo';
    const styles = $8f182bcf5e72beb2$var$useStyles();
    const layoutStyles = {
        table: $8f182bcf5e72beb2$var$useTableLayoutStyles(),
        flex: $8f182bcf5e72beb2$var$useFlexLayoutStyles()
    };
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($8f182bcf5e72beb2$export$966b503d9ebcb5b.root, styles.root, state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, state.noNativeElements ? layoutStyles.flex[state.size] : layoutStyles.table[state.size], state.root.className);
    return state;
};



'use client';
const $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $00c499bc138309ea$export$6ead74c378e7a6c7)(props, ref);
    (0, $8f182bcf5e72beb2$export$a2f26cfede75a646)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useTableCellStyles_unstable')(state);
    return (0, $29e6fbfd80438988$export$386709cc44b79068)(state);
});
$f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3.displayName = 'TableCell';


var $acw62 = parcelRequire("acw62");



const $9d564f25d704974e$export$f6b0663682a12f37 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.label, {}),
            state.infoButton && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.infoButton, {})
        ]
    });
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");
function $e01252a5d7f1d946$export$ac003f2d3e294800(element) {
    return Boolean(element.type.isFluentTriggerComponent);
}


function $afe88029dd4784e4$export$8e7091920a6cd3c6(children) {
    if (!$acw62.isValidElement(children)) return null;
    return (0, $e01252a5d7f1d946$export$ac003f2d3e294800)(children) ? $afe88029dd4784e4$export$8e7091920a6cd3c6(// but for some reason it's failing on build
    children.props.children) : children;
}


var $acw62 = parcelRequire("acw62");
const $4967d38ee824a4c7$var$IS_REACT_19_OR_HIGHER = parseInt($acw62.version, 10) >= 19;
function $4967d38ee824a4c7$export$4554ac6b8c3e1a5d(element) {
    if (!element) return undefined;
    if ($4967d38ee824a4c7$var$IS_REACT_19_OR_HIGHER) return element.props.ref;
    return element.ref;
}


var $acw62 = parcelRequire("acw62");

function $70e12b87c0533cc6$export$4ef26f87842d1b0(children, triggerChildProps) {
    if (typeof children === 'function') return children(triggerChildProps);
    else if (children) return $70e12b87c0533cc6$var$cloneTriggerTree(children, triggerChildProps);
    // Components in React should return either JSX elements or "null", otherwise React will throw:
    //   Nothing was returned from render.
    //   This usually means a return statement is missing. Or, to render nothing, return null.
    return children || null;
}
/**
 * Clones a React element tree, and applies the given props to the first grandchild that is not
 * a FluentTriggerComponent or React Fragment (the same element returned by {@link getTriggerChild}).
 */ function $70e12b87c0533cc6$var$cloneTriggerTree(child, triggerProps) {
    if (!$acw62.isValidElement(child) || child.type === $acw62.Fragment) throw new Error("A trigger element must be a single element for this component. Please ensure that you're not using React Fragments.");
    if ((0, $e01252a5d7f1d946$export$ac003f2d3e294800)(child)) {
        const grandchild = $70e12b87c0533cc6$var$cloneTriggerTree(child.props.children, triggerProps);
        return $acw62.cloneElement(child, undefined, grandchild);
    } else return $acw62.cloneElement(child, triggerProps);
}






'use client';
const $dc225fea5f0a0e8e$var$DangerousNeverHiddenAttribute = 'data-tabster-never-hide';
const $dc225fea5f0a0e8e$var$DangerousNeverHiddenPropObject = {
    [$dc225fea5f0a0e8e$var$DangerousNeverHiddenAttribute]: ''
};
function $dc225fea5f0a0e8e$export$42bbd7fc30f693c3() {
    return $dc225fea5f0a0e8e$var$DangerousNeverHiddenPropObject;
}
const $dc225fea5f0a0e8e$var$tabsterAccessibleCheck = (element)=>{
    return element.hasAttribute($dc225fea5f0a0e8e$var$DangerousNeverHiddenAttribute);
};
function $dc225fea5f0a0e8e$var$initTabsterModules(tabster) {
    (0, $e3e23e1e89ad903c$export$af216543e1ef674)(tabster, undefined, $dc225fea5f0a0e8e$var$tabsterAccessibleCheck);
    (0, $e3e23e1e89ad903c$export$80ddb24d84708237)(tabster);
}
const $dc225fea5f0a0e8e$export$8e5cbf21155fc1da = (options = {})=>{
    const { trapFocus: trapFocus, alwaysFocusable: alwaysFocusable, legacyTrapFocus: legacyTrapFocus } = options;
    // Initializes the modalizer and restorer APIs
    (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)($dc225fea5f0a0e8e$var$initTabsterModules);
    const id = (0, $0200d30cfa270435$export$f680877a34711e37)('modal-', options.id);
    const modalAttributes = (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        restorer: {
            type: (0, $e3e23e1e89ad903c$export$86e1fd7e23a4fab4).Source
        },
        ...trapFocus && {
            modalizer: {
                id: id,
                isOthersAccessible: !trapFocus,
                isAlwaysAccessible: alwaysFocusable,
                isTrapped: legacyTrapFocus && trapFocus
            }
        }
    });
    const triggerAttributes = (0, $3cadb56bf5cf7176$export$52c56c2e556091a6)({
        restorer: {
            type: (0, $e3e23e1e89ad903c$export$86e1fd7e23a4fab4).Target
        }
    });
    return {
        modalAttributes: modalAttributes,
        triggerAttributes: triggerAttributes
    };
};



'use client';
const $3280b7af847a1fa8$export$9b9a0cd73afb7ca4 = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $3280b7af847a1fa8$var$popoverContextDefaultValue = {
    open: false,
    setOpen: ()=>null,
    toggleOpen: ()=>null,
    triggerRef: {
        current: null
    },
    contentRef: {
        current: null
    },
    arrowRef: {
        current: null
    },
    openOnContext: false,
    openOnHover: false,
    size: 'medium',
    trapFocus: false,
    inline: false
};
const $3280b7af847a1fa8$export$bf694c7c431c162a = $3280b7af847a1fa8$export$9b9a0cd73afb7ca4.Provider;
const $3280b7af847a1fa8$export$a3cbff38f7dd8303 = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($3280b7af847a1fa8$export$9b9a0cd73afb7ca4, (ctx = $3280b7af847a1fa8$var$popoverContextDefaultValue)=>selector(ctx));




'use client';
const $38d496a21b835846$export$5c58cdff39feeb7a = (props)=>{
    const { children: children, disableButtonEnhancement: disableButtonEnhancement = false } = props;
    const child = (0, $afe88029dd4784e4$export$8e7091920a6cd3c6)(children);
    const open = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.open);
    const setOpen = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.setOpen);
    const toggleOpen = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.toggleOpen);
    const triggerRef = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.triggerRef);
    const openOnHover = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.openOnHover);
    const openOnContext = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.openOnContext);
    const { triggerAttributes: triggerAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)();
    const onContextMenu = (e)=>{
        if (openOnContext) {
            e.preventDefault();
            setOpen(e, true);
        }
    };
    const onClick = (e)=>{
        if (!openOnContext) toggleOpen(e);
    };
    const onKeyDown = (e)=>{
        if (e.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685) && open && !e.isDefaultPrevented()) {
            setOpen(e, false);
            // stop propagation to avoid conflicting with other elements that listen for `Escape`
            // e,g: Dialog, Popover, Menu and Tooltip
            e.preventDefault();
        }
    };
    const onMouseEnter = (e)=>{
        if (openOnHover) setOpen(e, true);
    };
    const onMouseLeave = (e)=>{
        if (openOnHover) setOpen(e, false);
    };
    const contextMenuProps = {
        ...triggerAttributes,
        'aria-expanded': `${open}`,
        ...child === null || child === void 0 ? void 0 : child.props,
        onMouseEnter: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onMouseEnter, onMouseEnter)),
        onMouseLeave: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onMouseLeave, onMouseLeave)),
        onContextMenu: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onContextMenu, onContextMenu)),
        ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(triggerRef, (0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child))
    };
    const triggerChildProps = {
        ...contextMenuProps,
        onClick: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onClick, onClick)),
        onKeyDown: (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(child === null || child === void 0 ? void 0 : child.props.onKeyDown, onKeyDown))
    };
    const ariaButtonTriggerChildProps = (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)((child === null || child === void 0 ? void 0 : child.type) === 'button' || (child === null || child === void 0 ? void 0 : child.type) === 'a' ? child.type : 'div', triggerChildProps);
    return {
        children: (0, $70e12b87c0533cc6$export$4ef26f87842d1b0)(props.children, (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)((child === null || child === void 0 ? void 0 : child.type) === 'button' || (child === null || child === void 0 ? void 0 : child.type) === 'a' ? child.type : 'div', openOnContext ? contextMenuProps : disableButtonEnhancement ? triggerChildProps : ariaButtonTriggerChildProps))
    };
};


/**
 * Render the final JSX of PopoverTrigger
 */ const $93edac060093c7f7$export$4882b368480af20a = (state)=>{
    return state.children;
};


'use client';
const $f1d682872ff40f20$export$7dacb05d26466c3 = (props)=>{
    const state = (0, $38d496a21b835846$export$5c58cdff39feeb7a)(props);
    return (0, $93edac060093c7f7$export$4882b368480af20a)(state);
};
$f1d682872ff40f20$export$7dacb05d26466c3.displayName = 'PopoverTrigger';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
$f1d682872ff40f20$export$7dacb05d26466c3.isFluentTriggerComponent = true;


const $3a031b21ff566868$export$9ef445a692a707f5 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.popover, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $f1d682872ff40f20$export$7dacb05d26466c3), {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
            }),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.info, {})
        ]
    });
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $1f8995744f4c8216$export$4ebf1d0fd5709b4f = (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        mc9l5x: "fjseox"
    },
    visible: {
        mc9l5x: "f1w7gpdv"
    }
}, {
    d: [
        ".fjseox{display:none;}",
        ".f1w7gpdv{display:inline;}"
    ]
});


const $544dcb7495d058dc$export$5c43b1785e5213ca = (FilledIcon, RegularIcon)=>{
    const Component = (props)=>{
        const { className: className, filled: filled, ...rest } = props;
        const styles = (0, $1f8995744f4c8216$export$4ebf1d0fd5709b4f)();
        return $acw62.createElement($acw62.Fragment, null, $acw62.createElement(FilledIcon, Object.assign({}, rest, {
            className: (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(styles.root, filled && styles.visible, (0, $3ca67d612ed7abba$export$cc86ffec8c6eb24e), className)
        })), $acw62.createElement(RegularIcon, Object.assign({}, rest, {
            className: (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(styles.root, !filled && styles.visible, (0, $3ca67d612ed7abba$export$f8a5601dfd94d0c1), className)
        })));
    };
    Component.displayName = 'CompoundIcon';
    return Component;
};


"use client";
const $7972e53b1de568ed$export$907a96fb84c6c8ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food16Color', "16", `<path d="M13.5 1A4.5 4.5 0 0 0 9 5.5V7a1 1 0 0 0 1 1h.94l-.02.2-.17 1.69A54.21 54.21 0 0 0 10.5 13a2 2 0 1 0 4 0c0-.45-.13-1.85-.25-3.11a303.81 303.81 0 0 0-.23-2.24L14 7.47V1.5a.5.5 0 0 0-.5-.5Z" fill="url(#ic_fluent_food_16_color__a)"/><path d="M6.72 1.05c.15.08.24.2.27.34.02.08.51 2.2.51 3.61a3 3 0 0 1-1.13 2.35c-.25.2-.37.41-.37.6v.55l.28 2.12c.1.94.22 1.96.22 2.38a2 2 0 1 1-4 0c0-.42.11-1.44.22-2.38A161.35 161.35 0 0 1 3 8.43v-.48c0-.19-.12-.4-.37-.6A3 3 0 0 1 1.5 5c0-1.41.49-3.52.51-3.61a.5.5 0 0 1 .5-.39c.27 0 .5.23.5.5v3a.5.5 0 1 0 .99 0v-3a.5.5 0 0 1 1 0v3.03a.5.5 0 0 0 .99-.03v-3c0-.27.23-.5.5-.5.03 0 .13 0 .23.05Z" fill="url(#ic_fluent_food_16_color__b)"/><defs><linearGradient id="ic_fluent_food_16_color__a" x1="8.15" y1="1.88" x2="21.2" y2="6.75" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_food_16_color__b" x1=".58" y1="1.88" x2="14.48" y2="7.54" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$a560a7806577e7a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food16Filled', "16", [
    "M6.72 1.05c.15.08.24.2.27.34.02.08.51 2.2.51 3.61a3 3 0 0 1-1.13 2.35c-.25.2-.37.41-.37.6v.55l.28 2.12c.1.94.22 1.96.22 2.38a2 2 0 1 1-4 0c0-.42.11-1.44.22-2.38A161.35 161.35 0 0 1 3 8.43v-.48c0-.19-.12-.4-.37-.6A3 3 0 0 1 1.5 5c0-1.41.49-3.52.51-3.61a.5.5 0 0 1 .5-.39c.27 0 .5.23.5.5v3a.5.5 0 1 0 .99 0v-3a.5.5 0 0 1 1 0v3.03a.5.5 0 0 0 .99-.03v-3c0-.27.23-.5.5-.5.03 0 .13 0 .23.05ZM9 5.5A4.5 4.5 0 0 1 13.5 1c.28 0 .5.22.5.5v5.97l.02.18a262.15 262.15 0 0 1 .23 2.24c.12 1.26.25 2.66.25 3.11a2 2 0 1 1-4 0c0-.45.13-1.85.25-3.11l.17-1.7.02-.19H10a1 1 0 0 1-1-1V5.5Z"
]);
const $7972e53b1de568ed$export$2e899b96f1bd6b6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food16Regular', "16", [
    "M1.34 1.96c.16-.6.7-.96 1.27-.96.36 0 .68.13.93.35a1.5 1.5 0 0 1 1.92 0c.25-.22.57-.35.93-.35.57 0 1.11.36 1.27.96.15.57.34 1.5.34 2.54a3.5 3.5 0 0 1-1.6 2.94c-.27.17-.4.4-.4.6v.46l.28 2.12c.1.94.22 1.96.22 2.38a2 2 0 1 1-4 0c0-.42.11-1.44.22-2.38A161.35 161.35 0 0 1 3 8.43v-.4c0-.19-.13-.42-.4-.6A3.5 3.5 0 0 1 1 4.5c0-1.05.19-1.97.34-2.54ZM6 5a.5.5 0 0 1-1 0V2.5a.5.5 0 0 0-1 0V5a.5.5 0 0 1-1 0V2.39A.39.39 0 0 0 2.61 2c-.16 0-.27.1-.3.22A9.2 9.2 0 0 0 2 4.5c0 .88.45 1.65 1.14 2.1.44.28.86.78.86 1.44v.4l-.01.2c-.04.24-.16 1.15-.27 2.1-.12.97-.22 1.92-.22 2.26a1 1 0 1 0 2 0c0-.34-.1-1.3-.22-2.26A160.25 160.25 0 0 0 5 8.44v-.4c0-.66.42-1.16.86-1.44A2.5 2.5 0 0 0 7 4.5a9.2 9.2 0 0 0-.3-2.28C6.65 2.1 6.54 2 6.38 2a.39.39 0 0 0-.39.39V5Zm3 .5A4.5 4.5 0 0 1 13.5 1c.28 0 .5.22.5.5v5.97l.02.18a261.41 261.41 0 0 1 .23 2.24c.12 1.26.25 2.66.25 3.11a2 2 0 1 1-4 0c0-.45.13-1.85.25-3.11l.17-1.7.02-.19H10a1 1 0 0 1-1-1V5.5Zm3 2.05-.02.2a385.49 385.49 0 0 0-.23 2.24A55.58 55.58 0 0 0 11.5 13a1 1 0 1 0 2 0c0-.38-.12-1.72-.25-3.01a315.13 315.13 0 0 0-.23-2.24l-.02-.2V2.04c-1.7.24-3 1.7-3 3.46V7h1.5a.5.5 0 0 1 .5.55Z"
]);
const $7972e53b1de568ed$export$5e824fcfe3044e23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food20Color', "20", `<path d="M15.5 2A4.5 4.5 0 0 0 11 6.5v2c0 .83.67 1.5 1.5 1.5h.45l-.03.36-.17 2.04c-.12 1.5-.25 3.16-.25 3.6a2 2 0 1 0 4 0c0-.44-.13-2.1-.25-3.6a528.07 528.07 0 0 0-.23-2.7L16 9.48V2.5a.5.5 0 0 0-.5-.5Z" fill="url(#ic_fluent_food_20_color__a)"/><path d="M4.5 2c.29 0 .51.23.51.5v4a.5.5 0 1 0 .99 0v-4a.5.5 0 0 1 1 0V6.53a.5.5 0 0 0 .99-.03v-4a.5.5 0 0 1 .5-.5h.02a.5.5 0 0 1 .49.42c0 .08.5 3.17.5 4.58a3 3 0 0 1-1.13 2.35c-.25.2-.37.41-.37.6v.5a318.17 318.17 0 0 1-3 0v-.5c0-.19-.12-.4-.37-.6A3 3 0 0 1 3.5 7c0-1.4.5-4.48.5-4.58A.5.5 0 0 1 4.5 2Z" fill="url(#ic_fluent_food_20_color__b)"/><defs><linearGradient id="ic_fluent_food_20_color__a" x1="10.15" y1="3" x2="23.58" y2="7.39" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_food_20_color__b" x1="2.58" y1="3" x2="16.96" y2="8.13" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$cb49f6fc94251592 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food20Filled', "20", [
    "M4.5 2a.52.52 0 0 0-.18.04.5.5 0 0 0-.31.38C3.99 2.52 3.5 5.6 3.5 7a3 3 0 0 0 1.13 2.35c.25.2.37.41.37.6v.5a318.17 318.17 0 0 0 3 0v-.5c0-.19.12-.4.37-.6A3 3 0 0 0 9.5 7c0-1.4-.5-4.5-.5-4.58a.5.5 0 0 0-.36-.4C8.58 2 8.52 2 8.5 2h-.02a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-.99.03V2.5a.5.5 0 0 0-1 0v4a.5.5 0 1 1-.99 0v-4a.5.5 0 0 0-.5-.5ZM11 6.5A4.5 4.5 0 0 1 15.5 2c.28 0 .5.22.5.5v6.98l.02.22a625.58 625.58 0 0 1 .23 2.7c.12 1.5.25 3.16.25 3.6a2 2 0 1 1-4 0c0-.44.13-2.1.25-3.6l.17-2.04.03-.36h-.45A1.5 1.5 0 0 1 11 8.5v-2ZM8.5 2Z"
]);
const $7972e53b1de568ed$export$3ab657f06a3348 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food20Regular', "20", [
    "M4.67 2a1.3 1.3 0 0 0-1.29 1.07C3.23 3.89 3 5.34 3 6.5a3.5 3.5 0 0 0 1.6 2.94c.27.17.4.4.4.6v.4a318.17 318.17 0 0 0 3 0v-.4c0-.2.13-.43.4-.6A3.5 3.5 0 0 0 10 6.5c0-1.16-.23-2.61-.38-3.43A1.3 1.3 0 0 0 8.32 2c-.33 0-.64.13-.87.34a1.5 1.5 0 0 0-1.9 0C5.32 2.13 5.01 2 4.67 2ZM6 3.5a.5.5 0 0 1 1 0v3a.5.5 0 0 0 1 0V3.33c0-.18.15-.33.33-.33.16 0 .28.1.3.25.15.81.37 2.19.37 3.25a2.5 2.5 0 0 1-1.14 2.1c-.44.28-.86.78-.86 1.44V10.6c.04.25.16 1.42.28 2.62.11 1.21.22 2.41.22 2.77a1 1 0 1 1-2 0c0-.36.1-1.56.22-2.77A318.23 318.23 0 0 1 6 10.45v-.41c0-.66-.42-1.16-.86-1.44A2.5 2.5 0 0 1 4 6.5c0-1.06.22-2.44.36-3.25A.3.3 0 0 1 4.67 3c.18 0 .33.15.33.33V6.5a.5.5 0 0 0 1 0v-3Zm5 3A4.5 4.5 0 0 1 15.5 2c.28 0 .5.22.5.5v6.98l.02.22a625.58 625.58 0 0 1 .23 2.7c.12 1.5.25 3.16.25 3.6a2 2 0 1 1-4 0c0-.44.13-2.1.25-3.6l.17-2.04.03-.36h-.45A1.5 1.5 0 0 1 11 8.5v-2Zm3 3.04-.02.25a1240.9 1240.9 0 0 0-.23 2.69A86.58 86.58 0 0 0 13.5 16a1 1 0 1 0 2 0c0-.39-.12-1.98-.25-3.52a565.06 565.06 0 0 0-.23-2.7L15 9.55a.5.5 0 0 1 0-.04V3.04c-1.7.24-3 1.7-3 3.46v2c0 .28.22.5.5.5h1a.5.5 0 0 1 .5.54Z"
]);
const $7972e53b1de568ed$export$b20525e5a9055705 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food24Color', "24", `<path d="M18.75 2A5.75 5.75 0 0 0 13 7.75v2.5c0 .97.78 1.75 1.75 1.75h.7l-.03.35-.17 2.61c-.12 1.93-.25 4.02-.25 4.54a2.5 2.5 0 0 0 5 0c0-.54-.14-2.62-.27-4.53v-.08c-.12-1.75-.23-3.32-.23-3.64v-8.5a.75.75 0 0 0-.75-.75Z" fill="url(#ic_fluent_food_24_color__a)"/><path d="M3.74 2.82a.88.88 0 0 1 1.76.06v4.5a.62.62 0 1 0 1.25 0V2.74a.75.75 0 0 1 1.5 0v4.62a.62.62 0 1 0 1.25 0V2.88a.88.88 0 0 1 1.76-.06c.04.6.24 3.55.24 5.18a4 4 0 0 1-1.7 3.27c-.2.15-.26.31-.25.4.12 1.87.45 7.01.45 7.83a2.5 2.5 0 0 1-5 0c0-.82.33-5.96.45-7.84.01-.08-.04-.24-.26-.4A4 4 0 0 1 3.5 8c0-1.63.2-4.57.24-5.18Z" fill="url(#ic_fluent_food_24_color__b)"/><defs><linearGradient id="ic_fluent_food_24_color__a" x1="11.92" y1="3.25" x2="28.95" y2="8.92" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_food_24_color__b" x1="2.27" y1="3.25" x2="21.16" y2="10.44" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$f6a457dc69e0f49d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food24Filled', "24", [
    "M3.74 2.82a.88.88 0 0 1 1.76.06v4.5a.62.62 0 1 0 1.25 0V2.74a.75.75 0 0 1 1.5 0v4.62a.62.62 0 1 0 1.25 0V2.88a.88.88 0 0 1 1.76-.06c.04.6.24 3.55.24 5.18a4 4 0 0 1-1.7 3.27c-.2.15-.26.31-.25.4.12 1.87.45 7.01.45 7.83a2.5 2.5 0 0 1-5 0c0-.82.33-5.96.45-7.84.01-.08-.04-.24-.26-.4A4 4 0 0 1 3.5 8c0-1.63.2-4.57.24-5.18ZM13 7.75A5.75 5.75 0 0 1 18.75 2c.41 0 .75.34.75.75v8.5c0 .32.1 1.9.22 3.64l.01.08c.13 1.91.27 3.99.27 4.53a2.5 2.5 0 0 1-5 0c0-.52.13-2.61.25-4.54l.17-2.6.03-.36h-.7c-.97 0-1.75-.78-1.75-1.75v-2.5Z"
]);
const $7972e53b1de568ed$export$e3b52be451665286 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food24Regular', "24", [
    "M3.2 3.73a1.9 1.9 0 0 1 3.09-1.31 2 2 0 0 1 2.43 0 1.9 1.9 0 0 1 3.09 1.3c.08.98.19 2.49.19 3.78a4.5 4.5 0 0 1-2.18 3.85c-.22.14-.28.3-.27.39.13 1.93.45 6.95.45 7.76a2.5 2.5 0 0 1-5 0c0-.8.32-5.83.45-7.76 0-.09-.05-.25-.27-.39A4.5 4.5 0 0 1 3 7.5c0-1.3.1-2.8.2-3.77Zm6.3 3.52a.75.75 0 0 1-1.5 0V4a.5.5 0 0 0-1 0v3.25a.75.75 0 0 1-1.5 0V3.92a.42.42 0 0 0-.42-.42.4.4 0 0 0-.4.36A46 46 0 0 0 4.5 7.5a3 3 0 0 0 1.45 2.57c.55.33 1.05.96 1 1.77-.13 1.98-.45 6.92-.45 7.66a1 1 0 1 0 2 0c0-.74-.32-5.68-.45-7.66-.05-.81.45-1.44 1-1.77A3 3 0 0 0 10.5 7.5a46 46 0 0 0-.19-3.64.4.4 0 0 0-.4-.36.42.42 0 0 0-.41.42v3.33Zm3.5.5A5.75 5.75 0 0 1 18.75 2c.41 0 .75.34.75.75v8.5c0 .32.1 1.9.22 3.64l.01.08c.13 1.91.27 3.99.27 4.53a2.5 2.5 0 0 1-5 0c0-.52.13-2.61.25-4.54l.17-2.6.03-.36h-.7c-.97 0-1.75-.78-1.75-1.75v-2.5Zm4 3.55-.02.32a797.81 797.81 0 0 0-.48 7.88 1 1 0 1 0 2 0c0-.48-.14-2.53-.27-4.5v-.11a119.4 119.4 0 0 1-.23-3.64V3.57a4.25 4.25 0 0 0-3.5 4.18v2.5c0 .14.11.25.25.25h1.5a.75.75 0 0 1 .75.8Z"
]);
const $7972e53b1de568ed$export$784c0df6a71cbd53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food28Color', "28", `<path d="m18.92 14.56.04-.56h-1.21c-.97 0-1.75-.78-1.75-1.75v-3.5A6.75 6.75 0 0 1 22.75 2h.5c.41 0 .75.34.75.75v10.5c0 .3.1 1.93.2 3.83v.07c.14 2.38.3 5.13.3 5.85a3 3 0 1 1-6 0c0-.65.13-3.11.25-5.38l.17-3.06Z" fill="url(#ic_fluent_food_28_color__a)"/><path d="M5.5 2.79a.88.88 0 0 1 1.75.1v5.86a.75.75 0 1 0 1.5 0v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 0 1.5 0V2.88a.88.88 0 0 1 1.76-.09c.07.72.49 4.79.49 6.71a4.5 4.5 0 0 1-1.51 3.36c-.33.3-.49.6-.49.86v.78c.04.6.5 7.28.5 8.5a3 3 0 1 1-6 0 312.24 312.24 0 0 1 .5-8.55v-.73c0-.25-.16-.56-.49-.86A4.5 4.5 0 0 1 5 9.5c0-1.92.42-5.99.5-6.71Z" fill="url(#ic_fluent_food_28_color__b)"/><defs><linearGradient id="ic_fluent_food_28_color__a" x1="14.69" y1="3.5" x2="35.33" y2="10.45" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_food_28_color__b" x1="3.62" y1="3.5" x2="25.2" y2="11.2" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$76c60eefc45b5774 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food28Filled', "28", [
    "M5.5 2.79a.88.88 0 0 1 1.75.1v5.86a.75.75 0 1 0 1.5 0v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 0 1.5 0V2.88a.88.88 0 0 1 1.76-.09c.07.72.49 4.79.49 6.71a4.5 4.5 0 0 1-1.51 3.36c-.33.3-.49.6-.49.86v.78c.04.6.5 7.28.5 8.5a3 3 0 1 1-6 0 312.24 312.24 0 0 1 .5-8.55v-.73c0-.25-.16-.56-.49-.86A4.5 4.5 0 0 1 5 9.5c0-1.92.42-5.99.5-6.71ZM18.95 14l-.04.56-.17 3.06c-.12 2.27-.25 4.73-.25 5.38a3 3 0 1 0 6 0c0-.72-.16-3.47-.3-5.86v-.06c-.1-1.9-.2-3.53-.2-3.83V2.75a.75.75 0 0 0-.75-.75h-.5A6.75 6.75 0 0 0 16 8.75v3.5c0 .97.78 1.75 1.75 1.75h1.2Z"
]);
const $7972e53b1de568ed$export$1d7a459de57d801b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food28Regular', "28", [
    "M7.06 2c-.98 0-1.82.74-1.92 1.73-.15 1.4-.39 3.95-.39 5.52 0 1.48.68 2.8 1.74 3.67.35.29.51.6.51.87V14.5c-.04.6-.5 7.28-.5 8.5a3 3 0 1 0 6 0 312.03 312.03 0 0 0-.5-8.55v-.66c0-.27.16-.58.51-.87a4.74 4.74 0 0 0 1.74-3.67c0-1.57-.24-4.12-.39-5.52a1.93 1.93 0 0 0-3.13-1.3 2 2 0 0 0-2.46 0A1.93 1.93 0 0 0 7.06 2ZM9 4a.5.5 0 0 1 1 0v5.25a.75.75 0 0 0 1.5 0V3.94c0-.24.2-.44.44-.44.23 0 .4.17.43.38.15 1.42.38 3.9.38 5.37 0 1.01-.46 1.92-1.19 2.51a2.68 2.68 0 0 0-1.06 2.03v.81c.05.64.5 7.25.5 8.4a1.5 1.5 0 0 1-3 0 318.86 318.86 0 0 1 .5-8.55v-.66c0-.89-.52-1.58-1.06-2.03a3.24 3.24 0 0 1-1.19-2.51c0-1.48.23-3.95.38-5.37.02-.21.2-.38.43-.38.24 0 .44.2.44.44v5.31a.75.75 0 0 0 1.5 0V4Zm13.5-.5v9.75c0 .35.1 2 .2 3.81v.1c.14 2.44.3 5.17.3 5.84a1.5 1.5 0 0 1-3 0c0-.6.12-3 .25-5.3a1209.66 1209.66 0 0 1 .23-4.04l.02-.37v-.04a.75.75 0 0 0-.75-.75h-2a.25.25 0 0 1-.25-.25v-3.5a5.25 5.25 0 0 1 5-5.24ZM18.96 14l-.04.56-.17 3.06c-.12 2.27-.25 4.73-.25 5.38a3 3 0 1 0 6 0c0-.72-.16-3.47-.3-5.86v-.06c-.1-1.9-.2-3.53-.2-3.83V2.75a.75.75 0 0 0-.75-.75h-.5A6.75 6.75 0 0 0 16 8.75v3.5c0 .97.78 1.75 1.75 1.75h1.2Z"
]);
const $7972e53b1de568ed$export$52dd972a0396dbc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food32Color', "32", `<path d="M25.5 2A7.5 7.5 0 0 0 18 9.5v4a2.5 2.5 0 0 0 2.5 2.5h.39l-.43 4.26c-.23 2.37-.46 4.9-.46 5.74a4 4 0 1 0 8 0c0-.98-.32-4.03-.59-6.63v-.12A425.1 425.1 0 0 1 27 15V3a1 1 0 0 0-1-1h-.5Z" fill="url(#ic_fluent_food_32_color__a)"/><path d="M14.97 2.77A1 1 0 0 0 13.94 2a1 1 0 0 0-.95 1v6a1 1 0 0 1-1.99.04V3a1 1 0 1 0-2 0v6.06a1 1 0 0 1-1.99-.05V3a1 1 0 0 0-1.98-.24C5 2.87 4 7.14 4 10a6 6 0 0 0 2.27 4.7c.5.4.73.82.73 1.18V16c-.07.5-.31 2.59-.55 4.75A76.48 76.48 0 0 0 6 26a4 4 0 0 0 8 0c0-.84-.23-3.13-.45-5.25a461.5 461.5 0 0 0-.55-4.87c0-.36.23-.79.73-1.18A6 6 0 0 0 16 10c0-2.86-1-7.14-1.03-7.23Zm-1.08-.76h.02-.01Z" fill="url(#ic_fluent_food_32_color__b)"/><defs><linearGradient id="ic_fluent_food_32_color__a" x1="16.46" y1="3.75" x2="40.69" y2="11.98" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_food_32_color__b" x1="2.15" y1="3.75" x2="29.97" y2="15.09" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$ad1185821a8e3507 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food32Filled', "32", [
    "M18 9.5A7.5 7.5 0 0 1 25.5 2h.5a1 1 0 0 1 1 1v12a425.1 425.1 0 0 0 .4 4.25l.01.12c.27 2.6.59 5.65.59 6.63a4 4 0 1 1-8 0c0-.84.23-3.37.46-5.74l.43-4.26h-.39a2.5 2.5 0 0 1-2.5-2.5v-4Zm-3.03-6.73A1 1 0 0 0 13.94 2a1 1 0 0 0-.95 1v6a1 1 0 0 1-1.99.04V3a1 1 0 1 0-2 0v6.06a1 1 0 0 1-1.99-.05V3a1 1 0 0 0-1.98-.24C5 2.87 4 7.14 4 10a6 6 0 0 0 2.27 4.7c.5.4.73.82.73 1.18V16c-.07.5-.31 2.59-.55 4.75A76.48 76.48 0 0 0 6 26a4 4 0 0 0 8 0c0-.84-.23-3.13-.45-5.25a461.5 461.5 0 0 0-.55-4.87c0-.36.23-.79.73-1.18A6 6 0 0 0 16 10c0-2.86-1-7.14-1.03-7.23Zm-1.08-.76h.02-.01Z"
]);
const $7972e53b1de568ed$export$2861260d870dcc82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food32Regular', "32", [
    "M6.68 2a2.5 2.5 0 0 0-2.44 1.92A26.3 26.3 0 0 0 3.5 9.5a6.5 6.5 0 0 0 2.82 5.36c.47.32.68.71.68 1.03v.1c-.06.49-.31 2.58-.54 4.74A76.75 76.75 0 0 0 6 26a4 4 0 0 0 8 0c0-.84-.23-3.14-.46-5.27A464.85 464.85 0 0 0 13 15.9c0-.32.21-.71.68-1.03A6.5 6.5 0 0 0 16.5 9.5c0-2.07-.44-4.3-.74-5.58A2.5 2.5 0 0 0 13.32 2c-.62 0-1.19.22-1.63.58a2.74 2.74 0 0 0-3.38 0A2.56 2.56 0 0 0 6.68 2Zm6.07 2.57c0-.31.26-.57.57-.57a.5.5 0 0 1 .5.37c.29 1.25.68 3.3.68 5.13a4.5 4.5 0 0 1-1.95 3.71 3.33 3.33 0 0 0-1.53 3.02l.54 4.72c.23 2.18.44 4.35.44 5.05a2 2 0 1 1-4 0c0-.7.2-2.87.44-5.05A460.08 460.08 0 0 1 9 15.89c0-1.2-.76-2.14-1.55-2.68A4.5 4.5 0 0 1 5.5 9.5c0-1.84.4-3.88.68-5.13a.5.5 0 0 1 .5-.37c.31 0 .57.26.57.57V10a1 1 0 1 0 2 0V4.75a.75.75 0 0 1 1.5 0V10a1 1 0 1 0 2 0V4.57ZM20 9.5a5.5 5.5 0 0 1 5-5.48V15c0 .28.05.9.13 1.66l.28 2.79c.28 2.71.59 5.69.59 6.55a2 2 0 1 1-4 0c0-.71.21-3.11.45-5.54a635.2 635.2 0 0 1 .55-5.4A1 1 0 0 0 22 14h-1.5a.5.5 0 0 1-.5-.5v-4ZM25.5 2A7.5 7.5 0 0 0 18 9.5v4a2.5 2.5 0 0 0 2.5 2.5h.39l-.43 4.26c-.23 2.37-.46 4.9-.46 5.74a4 4 0 1 0 8 0c0-.98-.32-4.03-.59-6.63v-.12A425.1 425.1 0 0 1 27 15V3a1 1 0 0 0-1-1h-.5Z"
]);
const $7972e53b1de568ed$export$db4fc131f98bd5d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food48Color', "48", `<path d="m30.85 24.91.06-.91h-1.66A3.25 3.25 0 0 1 26 20.75v-5.5C26 9.04 31.04 4 37.25 4h.5c.69 0 1.25.56 1.25 1.25v17.5c0 .49.19 3.2.4 6.37l.01.13c.27 3.96.59 8.54.59 9.75a5 5 0 0 1-10 0c0-1.09.25-5.21.5-8.98l.35-5.1Z" fill="url(#ic_fluent_food_48_color__a)"/><path d="M10.61 4c-.64 0-1.26.46-1.36 1.18C9.1 6.12 8 13.67 8 17c0 2.2.95 4.17 2.45 5.54.7.64 1.05 1.28 1.05 1.85v.12c-.1 1.17-1 12.47-1 14.49a5 5 0 0 0 10 0 461.83 461.83 0 0 0-1-14.61c0-.57.36-1.21 1.05-1.85A7.48 7.48 0 0 0 23 17c0-3.33-1.1-10.88-1.25-11.82A1.38 1.38 0 0 0 20.4 4h-.02c-.8 0-1.37.65-1.37 1.37v10.51a1.12 1.12 0 1 1-2.24 0V5.32a1.26 1.26 0 1 0-2.52.05v10.51a1.12 1.12 0 1 1-2.24 0V5.37C12 4.65 11.43 4 10.63 4h-.02Z" fill="url(#ic_fluent_food_48_color__b)"/><defs><linearGradient id="ic_fluent_food_48_color__a" x1="23.85" y1="6.5" x2="57.91" y2="17.84" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_food_48_color__b" x1="5.69" y1="6.5" x2="41.66" y2="19.33" gradientUnits="userSpaceOnUse"><stop stop-color="#6CE0FF"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$662beb7947ae3a7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food48Filled', "48", [
    "M10.61 4c-.64 0-1.26.46-1.36 1.18C9.1 6.12 8 13.67 8 17c0 2.2.95 4.17 2.45 5.54.7.64 1.05 1.28 1.05 1.85v.12c-.1 1.17-1 12.47-1 14.49a5 5 0 0 0 10 0 461.83 461.83 0 0 0-1-14.61c0-.57.36-1.21 1.05-1.85A7.48 7.48 0 0 0 23 17c0-3.33-1.1-10.88-1.25-11.82A1.38 1.38 0 0 0 20.4 4h-.02c-.8 0-1.37.65-1.37 1.37v10.51a1.12 1.12 0 1 1-2.24 0V5.32a1.26 1.26 0 1 0-2.52.05v10.51a1.12 1.12 0 1 1-2.24 0V5.37C12 4.65 11.43 4 10.63 4h-.02Zm20.3 20-.06.91-.35 5.1c-.25 3.78-.5 7.9-.5 8.99a5 5 0 0 0 10 0c0-1.2-.32-5.8-.59-9.75v-.13c-.22-3.17-.41-5.88-.41-6.37V5.25C39 4.56 38.44 4 37.75 4h-.5A11.25 11.25 0 0 0 26 15.25v5.5c0 1.8 1.46 3.25 3.25 3.25h1.66Z"
]);
const $7972e53b1de568ed$export$e421092700e8ed71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Food48Regular', "48", [
    "M7.98 6.73a3.26 3.26 0 0 1 5.34-1.96 3.49 3.49 0 0 1 4.36 0 3.28 3.28 0 0 1 5.34 1.96c.37 2.25.98 6.4.98 9.27 0 2.85-1.4 5.37-3.55 6.9-.64.47-.95 1.02-.95 1.5v.1c.1 1.09 1 12.47 1 14.5a5 5 0 0 1-10 0 463.71 463.71 0 0 1 1-14.6c0-.48-.31-1.03-.95-1.5A8.49 8.49 0 0 1 7 16c0-2.87.61-7.02.98-9.27ZM19 16.75a1.25 1.25 0 1 1-2.5 0V7.5a1 1 0 1 0-2 0v9.25a1.25 1.25 0 1 1-2.5 0V7.3a.8.8 0 0 0-.8-.8c-.38 0-.7.27-.75.63A65.05 65.05 0 0 0 9.5 16c0 2 .99 3.79 2.5 4.88A4.44 4.44 0 0 1 14 24.69C13.89 25.88 13 37.1 13 39a2.5 2.5 0 0 0 5 0 475.5 475.5 0 0 0-1-14.6c0-1.57.98-2.79 2-3.52A5.99 5.99 0 0 0 21.5 16c0-2.64-.57-6.6-.95-8.87a.76.76 0 0 0-.75-.63.8.8 0 0 0-.8.8v9.45ZM36.5 6.53v16.22c0 .59.19 3.33.4 6.34v.2c.29 4.07.6 8.6.6 9.71a2.5 2.5 0 0 1-5 0c0-.98.25-4.99.5-8.82a1682.83 1682.83 0 0 1 .45-6.73l.05-.61a1.25 1.25 0 0 0-1.25-1.34h-3a.75.75 0 0 1-.75-.75v-5.5a8.75 8.75 0 0 1 8-8.72ZM30.91 24l-.06.91-.35 5.1c-.25 3.78-.5 7.9-.5 8.99a5 5 0 0 0 10 0c0-1.2-.32-5.8-.59-9.75v-.13c-.22-3.17-.41-5.88-.41-6.37V5.25C39 4.56 38.44 4 37.75 4h-.5A11.25 11.25 0 0 0 26 15.25v5.5c0 1.8 1.46 3.25 3.25 3.25h1.66Z"
]);
const $7972e53b1de568ed$export$d9efaa8f8ea0fe37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple20Filled', "20", [
    "M12.16 2.97a.5.5 0 1 0-.32-.94 3.18 3.18 0 0 0-1.86 1.9c-.05.11-.1.23-.13.34A4 4 0 0 0 6.2 2.14c-.58.01-1.04.48-1.06 1.06A3.99 3.99 0 0 0 6.3 6.14l.03.03A4 4 0 0 0 3.2 9.76v.07a8.5 8.5 0 0 0 1 4.75l.36.66a.5.5 0 0 0 .03.05l1 1.4a2.69 2.69 0 0 0 4.09.34.46.46 0 0 1 .64 0 2.69 2.69 0 0 0 4.09-.34l1-1.4a.51.51 0 0 0 .03-.05l.36-.66a8.5 8.5 0 0 0 1-4.75v-.07a4 4 0 0 0-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34Zm-5.25 6c-.27.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 0 1-.99.12c-.13-1.06 0-1.86.31-2.45.32-.6.8-.93 1.28-1.08a.5.5 0 0 1 .32.94Z"
]);
const $7972e53b1de568ed$export$33500dddbbc57a84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple20Regular', "20", [
    "M7.22 8.34a.5.5 0 0 1-.31.63c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 0 1-.99.12c-.13-1.06 0-1.86.31-2.45.32-.6.8-.93 1.28-1.08a.5.5 0 0 1 .63.31Zm4.94-5.37a.5.5 0 1 0-.32-.94 3.18 3.18 0 0 0-1.86 1.9c-.05.11-.1.23-.13.34A4 4 0 0 0 6.2 2.14c-.58.01-1.04.48-1.06 1.06a3.99 3.99 0 0 0 1.2 2.97A4 4 0 0 0 3.2 9.76v.07a8.5 8.5 0 0 0 1 4.75l.36.66a.5.5 0 0 0 .03.05l1 1.4a2.69 2.69 0 0 0 4.09.34.46.46 0 0 1 .64 0 2.69 2.69 0 0 0 4.09-.34l1-1.4a.51.51 0 0 0 .03-.05l.36-.66a8.5 8.5 0 0 0 1-4.75v-.07a4 4 0 0 0-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34ZM8.72 6.28l-.16-.03a2.98 2.98 0 0 1-2.42-3.02c0-.05.04-.09.09-.1a2.99 2.99 0 0 1 3.08 3.1c0 .04-.04.08-.09.08-.17 0-.33 0-.5-.03Zm-.33.96.17.03.78.13a4 4 0 0 0 1.32 0l1.66-.28a3 3 0 0 1 3.49 2.72v.07a7.5 7.5 0 0 1-.89 4.2l-.34.62-.99 1.38c-.6.85-1.82.95-2.56.21a1.46 1.46 0 0 0-2.06 0c-.74.74-1.96.64-2.56-.21l-.99-1.38-.34-.63a7.5 7.5 0 0 1-.9-4.19l.01-.07a3 3 0 0 1 3.49-2.72l.71.12Z"
]);
const $7972e53b1de568ed$export$1985304da9118b40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple24Filled', "24", [
    "M5.47 3.42A5.18 5.18 0 0 0 6.9 7.3a5.12 5.12 0 0 0-3.66 4.22c-.33 2.35.15 4.75 1.37 6.8l.35.58.04.07 1.42 1.9a3.46 3.46 0 0 0 5.28.34.44.44 0 0 1 .62 0 3.46 3.46 0 0 0 5.28-.34l1.42-1.9a.74.74 0 0 0 .04-.07l.35-.59a10.46 10.46 0 0 0 1.37-6.8 5.12 5.12 0 0 0-6.1-4.3l-1.9.4h-.01a8.7 8.7 0 0 1 .39-2.34c.29-.87.7-1.4 1.14-1.58a.75.75 0 1 0-.58-1.38c-1.05.44-1.65 1.48-1.98 2.48l-.05.15a5.19 5.19 0 0 0-4.92-2.8c-.7.04-1.25.59-1.29 1.28Zm2.93 7.81c-.35.07-.67.32-.87.78-.2.48-.27 1.18-.05 2.06a.75.75 0 0 1-1.46.36 4.74 4.74 0 0 1 .13-3A2.7 2.7 0 0 1 8.1 9.75a.75.75 0 1 1 .3 1.47Z"
]);
const $7972e53b1de568ed$export$97a63929f7590163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodApple24Regular', "24", [
    "M8.4 11.23a.75.75 0 0 0-.3-1.47 2.7 2.7 0 0 0-1.95 1.66 4.74 4.74 0 0 0-.13 3.01.75.75 0 1 0 1.46-.36A3.27 3.27 0 0 1 7.53 12c.2-.46.52-.7.87-.78ZM5.47 3.42A5.18 5.18 0 0 0 6.9 7.3a5.12 5.12 0 0 0-3.66 4.22c-.33 2.35.15 4.75 1.37 6.8l.35.58.04.07 1.42 1.9a3.46 3.46 0 0 0 5.28.34.44.44 0 0 1 .62 0 3.46 3.46 0 0 0 5.28-.34l1.42-1.9a.74.74 0 0 0 .04-.07l.35-.59a10.46 10.46 0 0 0 1.37-6.8 5.12 5.12 0 0 0-6.1-4.3l-1.9.4h-.01a8.7 8.7 0 0 1 .39-2.34c.29-.87.7-1.4 1.14-1.58a.75.75 0 1 0-.58-1.38c-1.05.44-1.65 1.48-1.98 2.48l-.05.15a5.19 5.19 0 0 0-4.92-2.8c-.7.04-1.25.59-1.29 1.28Zm1.5.2a3.68 3.68 0 0 1 3.79 3.8c-.19 0-.37 0-.55-.03l-.61-.12a3.67 3.67 0 0 1-2.64-3.64Zm2.06 5.06.2.04c.25.07.49.12.73.15l.97.2c.7.15 1.43.15 2.14 0l1.9-.39a3.62 3.62 0 0 1 4.32 3.04 8.96 8.96 0 0 1-1.18 5.83l-.33.55-1.4 1.88a1.96 1.96 0 0 1-2.98.19c-.77-.8-2.03-.8-2.8 0-.84.87-2.26.78-2.99-.2L6.22 18.1l-.33-.55a8.96 8.96 0 0 1-1.18-5.83 3.62 3.62 0 0 1 4.32-3.04Z"
]);
const $7972e53b1de568ed$export$84ba82e7d64d0f9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake12Filled', "12", [
    "M4.93 1.65c-.18.3-.29.64-.3.88-.02.43.04.85.3 1.16.28.33.68.44 1.07.44.4 0 .8-.12 1.07-.45.26-.32.33-.73.3-1.15a2.06 2.06 0 0 0-.3-.87C6.87 1.36 6.53 1 6 1s-.88.36-1.07.65ZM3.5 5C2.67 5 2 5.67 2 6.5l1.87 1.46c.08.07.2.07.3 0l1.1-.78c.44-.31 1.02-.31 1.46 0l1.1.79c.1.06.22.06.3 0L10 6.5V6.5C10 5.67 9.33 5 8.5 5h-5Zm5.25 3.75L10 7.77V10h.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H2V7.77l1.25.98c.44.34 1.05.35 1.5.03L5.85 8c.1-.06.2-.06.3 0l1.1.8c.45.31 1.06.3 1.5-.04Z"
]);
const $7972e53b1de568ed$export$30f4c3f120b2a359 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake12Regular', "12", [
    "M6 1c-.53 0-.88.36-1.06.65-.19.3-.3.64-.3.88-.03.43.03.85.3 1.16.27.33.67.44 1.06.44.4 0 .8-.12 1.07-.45.26-.32.33-.73.3-1.15a2.06 2.06 0 0 0-.3-.87C6.89 1.36 6.54 1 6 1Zm-.37 1.6c0-.07.05-.26.15-.42.1-.16.19-.18.22-.18.04 0 .12.02.22.19s.15.35.16.4c.02.3-.04.41-.08.45-.02.03-.1.09-.3.09-.22 0-.28-.06-.3-.08-.02-.03-.08-.15-.07-.46ZM10 10V6.5C10 5.67 9.33 5 8.5 5h-5C2.67 5 2 5.67 2 6.5V10h-.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H10ZM3.5 6h5c.28 0 .5.22.5.5v.79l-.87.67a.25.25 0 0 1-.3 0l-1.1-.78c-.44-.31-1.02-.31-1.46 0l-1.1.79a.25.25 0 0 1-.3 0L3 7.28V6.5c0-.28.22-.5.5-.5ZM3 8.55l.25.2c.44.34 1.04.35 1.5.03L5.85 8c.1-.06.2-.06.3 0l1.1.8c.45.31 1.06.3 1.5-.04l.25-.2V10H3V8.55Z"
]);
const $7972e53b1de568ed$export$a7054ca0a73cffc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake16Filled', "16", [
    "M6.81 1.67C7.08 1.32 7.48 1 8 1c.52 0 .92.32 1.19.67.26.35.45.81.5 1.26a2 2 0 0 1-.26 1.38C9.13 4.75 8.64 5 8 5c-.64 0-1.13-.25-1.43-.7a2 2 0 0 1-.27-1.37c.06-.45.25-.9.51-1.26ZM2.03 7.65A2 2 0 0 1 4 6h8a2 2 0 0 1 1.99 1.8 30.48 30.48 0 0 1-1.43 1.32c-.43.37-.88.73-1.27 1-.2.13-.38.23-.53.3a.78.78 0 0 1-.26.08c-.26 0-.43-.17-.82-.59C9.34 9.54 8.84 9 8 9s-1.34.54-1.68.9v.01c-.39.42-.56.59-.82.59l-.06-.01-.18-.07a4.1 4.1 0 0 1-.51-.3c-.4-.27-.85-.63-1.29-1A32.88 32.88 0 0 1 2.01 7.8a2 2 0 0 1 .02-.15ZM2 9.15a15.74 15.74 0 0 0 2.2 1.79c.21.15.43.29.64.38.2.1.43.18.66.18.73 0 1.2-.51 1.5-.84l.06-.07c.35-.39.58-.59.94-.59s.59.2.94.59l.06.07c.3.33.77.84 1.5.84.24 0 .47-.08.68-.17.21-.1.44-.23.66-.38.45-.3.93-.7 1.38-1.07l.78-.7V13h.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H2V9.16Z"
]);
const $7972e53b1de568ed$export$eb060aa5e4e77ec0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake16Regular', "16", [
    "M6.81 1.67C7.08 1.32 7.48 1 8 1c.52 0 .92.32 1.19.67.26.35.45.81.5 1.26a2 2 0 0 1-.26 1.38C9.13 4.75 8.64 5 8 5c-.64 0-1.13-.25-1.43-.7a2 2 0 0 1-.27-1.37c.06-.45.25-.9.51-1.26Zm.6 2.08c.07.12.23.25.59.25s.52-.13.6-.25c.1-.14.14-.38.1-.68-.04-.3-.15-.6-.31-.8C8.23 2.05 8.09 2 8 2c-.08 0-.23.05-.39.27-.16.2-.27.5-.31.8-.04.3 0 .54.1.68ZM2 8c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5h.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H2V8Zm1 5h10v-2.98l-.28.25a8.2 8.2 0 0 1-1.05.81c-.34.22-.76.42-1.17.42-.73 0-1.2-.51-1.5-.84l-.06-.07C8.6 10.2 8.36 10 8 10s-.59.2-.94.59l-.06.07c-.3.33-.77.84-1.5.84-.4 0-.8-.21-1.14-.42A8.9 8.9 0 0 1 3 10v3Zm0-4.4a16.64 16.64 0 0 0 .97.92c.3.27.63.53.92.71.32.2.52.27.61.27.26 0 .43-.17.82-.59C6.66 9.54 7.16 9 8 9s1.34.54 1.68.9v.01c.39.42.56.59.82.59.11 0 .33-.07.64-.27.3-.18.62-.44.92-.7A14.38 14.38 0 0 0 13 8.6V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v.6Z"
]);
const $7972e53b1de568ed$export$a80f4b193f8f067f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake20Filled', "20", [
    "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67.64 0 1.22-.2 1.6-.7.37-.47.49-1.11.44-1.83a3.56 3.56 0 0 0-.47-1.43C11.28 2.55 10.77 2 10 2ZM3 9.78l3.2 2.94a1 1 0 0 0 1.43-.07l.86-.98a2 2 0 0 1 3 0l.86.98a1 1 0 0 0 1.43.07l3.2-2.94A2 2 0 0 0 15 8H5a2 2 0 0 0-1.99 1.79ZM17 11.14l-2.54 2.33a2 2 0 0 1-2.85-.15l-.86-.97a1 1 0 0 0-1.5 0l-.86.97a2 2 0 0 1-2.85.15L3 11.14V16h-.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H17v-4.86Z"
]);
const $7972e53b1de568ed$export$d2d274b534edd91c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake20Regular', "20", [
    "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67.64 0 1.22-.2 1.6-.7.37-.47.49-1.11.44-1.83a3.56 3.56 0 0 0-.47-1.43C11.28 2.55 10.77 2 10 2ZM8.96 4.51c0-.2.11-.63.33-.99.22-.37.46-.54.7-.54.25 0 .5.17.72.55.21.37.32.8.33.98.04.6-.07.96-.23 1.16-.14.18-.38.31-.81.31-.45 0-.69-.12-.82-.3-.15-.18-.26-.54-.22-1.17ZM5 8a2 2 0 0 0-2 2v6h-.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H17v-6a2 2 0 0 0-2-2H5Zm11 8H4v-3.88l1.54 1.38a2 2 0 0 0 2.83-.16l.88-1a1 1 0 0 1 1.5 0l.88 1a2 2 0 0 0 2.83.16L16 12.12V16Zm0-5.22-2.21 1.97a1 1 0 0 1-1.42-.08l-.87-.99a2 2 0 0 0-3 0l-.87 1a1 1 0 0 1-1.42.07L4 10.78V10a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.78Z"
]);
const $7972e53b1de568ed$export$e490e45c9e31e260 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake24Filled', "24", [
    "M12 7c1.71 0 2-1.34 2-2.44 0-1.1-.74-3.06-2-3.06s-2 1.95-2 3.06c0 1.1.29 2.44 2 2.44Zm-8.5 3.25C3.5 9.01 4.5 8 5.75 8h12.5c1.24 0 2.25 1 2.25 2.25v.88l-3.63 2.72c-.4.3-.95.33-1.39.08l-2.04-1.2c-.9-.53-2-.5-2.88.06L8.8 13.92c-.41.27-.94.27-1.35 0L3.5 11.42v-1.16Zm0 2.94v5.31h-.75a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-.75V13l-2.73 2.05c-.9.67-2.1.73-3.05.17l-2.04-1.2c-.4-.24-.91-.23-1.3.03L9.6 15.18c-.9.59-2.06.59-2.97.01l-3.14-2Z"
]);
const $7972e53b1de568ed$export$f2915d7ee88f5794 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCake24Regular', "24", [
    "M12 1c-.95 0-1.59.68-1.94 1.28a4.15 4.15 0 0 0-.56 1.97c0 .5.06 1.17.43 1.75.41.63 1.1 1 2.07 1 .96 0 1.66-.37 2.07-1 .37-.58.43-1.26.43-1.75 0-.6-.2-1.35-.56-1.97C13.59 1.68 12.95 1 12 1Zm-1 3.25c0-.3.12-.8.36-1.21.25-.42.49-.54.64-.54.15 0 .4.12.64.54.24.4.36.9.36 1.21 0 .41-.06.73-.2.93-.08.14-.26.32-.8.32s-.72-.18-.8-.32c-.14-.2-.2-.52-.2-.93Zm9.5 6v8.25h.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.75v-8.25C3.5 9.01 4.5 8 5.75 8h12.5c1.24 0 2.25 1 2.25 2.25Zm-15.5 0v2.1l2.45 1.57c.41.27.94.27 1.35 0l1.75-1.13c.88-.56 2-.58 2.9-.05l2 1.2c.43.25.96.23 1.37-.05L19 12.36v-2.11a.75.75 0 0 0-.75-.75H5.75a.75.75 0 0 0-.75.75Zm12.68 4.87c-.89.62-2.06.67-2.99.11l-2-1.2c-.42-.24-.93-.23-1.33.02l-1.74 1.13c-.91.59-2.08.59-2.99 0L5 14.13v4.37h14v-4.3l-1.32.92Z"
]);
const $7972e53b1de568ed$export$4f4e7636db9fce98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot20Filled', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14 5.29V2.5a.5.5 0 1 0-1 0v2.88a3.66 3.66 0 0 0-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.42.62 2.05.18l8.93-6.18A3.57 3.57 0 0 0 14.63 7h2.87a.5.5 0 1 0 0-1h-2.8l3.15-3.15Z"
]);
const $7972e53b1de568ed$export$30f4d315bde87163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot20Regular', "20", [
    "M17.85 2.85a.5.5 0 0 0-.7-.7L14 5.29V2.5a.5.5 0 0 0-1 0v2.88a3.66 3.66 0 0 0-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.41.62 2.05.18l8.93-6.18A3.57 3.57 0 0 0 14.63 7h2.87a.5.5 0 0 0 0-1h-2.8l3.15-3.15ZM9.2 7.14a2.64 2.64 0 0 1 4.04-.39 2.58 2.58 0 0 1-.35 3.96L3.95 16.9a.6.6 0 0 1-.77-.07.59.59 0 0 1-.07-.75l6.08-8.94Z"
]);
const $7972e53b1de568ed$export$4bcebf1203eec024 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot24Filled', "24", [
    "M17.5 2.75a.75.75 0 0 0-1.5 0v4.01a4.56 4.56 0 0 0-6.3 1.22l-7.35 10.8c-.55.82-.45 1.92.26 2.61.71.71 1.84.8 2.67.23l10.78-7.46A4.45 4.45 0 0 0 17.24 8h4.01a.75.75 0 0 0 0-1.5h-2.69l3.22-3.22a.75.75 0 0 0-1.06-1.06L17.5 5.44V2.75Z"
]);
const $7972e53b1de568ed$export$3714d4e420052403 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodCarrot24Regular', "24", [
    "M17.5 2.75a.75.75 0 0 0-1.5 0v4.01a4.56 4.56 0 0 0-6.3 1.22l-7.34 10.8c-.56.82-.45 1.92.25 2.61.71.71 1.84.8 2.67.23l10.79-7.46A4.45 4.45 0 0 0 17.24 8h4.01a.75.75 0 0 0 0-1.5h-2.69l3.22-3.22a.75.75 0 0 0-1.06-1.06L17.5 5.44V2.75Zm-6.54 6.06a3.04 3.04 0 0 1 4.65-.44 2.97 2.97 0 0 1-.4 4.56L4.4 20.4a.58.58 0 0 1-.73-.06.56.56 0 0 1-.07-.72l7.35-10.8Z"
]);
const $7972e53b1de568ed$export$4157042fade15b66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg16Filled', "16", [
    "M15 5a4 4 0 0 0-7.94-.68c-.2.62-.38 1.1-.54 1.45L4.15 8.15A.5.5 0 0 0 4.5 9h.08l-1.49 1.48h-.01a.25.25 0 0 1-.08.02 2 2 0 0 0-1.22 3.59c.05.03.1.08.13.13A2 2 0 0 0 5.5 13l.01-.08v-.01L7 11.43v.07a.5.5 0 0 0 .85.35l2.36-2.35c.37-.17.88-.37 1.56-.57A4 4 0 0 0 15 5ZM5.99 9H7v1.01l-2.2 2.2c-.23.23-.3.54-.3.79a1 1 0 0 1-1.8.6c-.08-.1-.2-.22-.3-.3a1 1 0 0 1 .6-1.8c.25 0 .56-.07.8-.3L5.99 9Z"
]);
const $7972e53b1de568ed$export$88f77685a030330 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg16Regular', "16", [
    "M15 5a4 4 0 0 0-7.94-.68c-.2.62-.38 1.1-.54 1.45L4.15 8.15A.5.5 0 0 0 4.5 9h.08l-1.49 1.48h-.01a.25.25 0 0 1-.08.02 2 2 0 0 0-1.22 3.59c.05.03.1.08.13.13A2 2 0 0 0 5.5 13l.01-.08v-.01L7 11.43v.07a.5.5 0 0 0 .85.35l2.36-2.35c.37-.17.88-.37 1.56-.57A4 4 0 0 0 15 5Zm-8 5.01-2.2 2.2c-.23.23-.3.54-.3.79a1 1 0 0 1-1.8.6c-.08-.1-.2-.22-.3-.3a1 1 0 0 1 .6-1.8c.25 0 .56-.07.8-.3L5.99 9H7v1.01ZM11 2a3 3 0 0 1 .5 5.96c-.78.24-1.36.47-1.79.67a.5.5 0 0 0-.14.1L8 10.29V8.5a.5.5 0 0 0-.5-.5H5.7l1.6-1.59a.5.5 0 0 0 .1-.14 14.19 14.19 0 0 0 .64-1.75A3 3 0 0 1 11 2Z"
]);
const $7972e53b1de568ed$export$5d15dae821440c7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg20Filled', "20", [
    "M18 7a5 5 0 0 0-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 0 0 .35.85h.39l-2 2a2 2 0 0 0-1.15 3.55c.08.06.15.13.2.21A2 2 0 0 0 6.5 16.1l2-2v.4a.5.5 0 0 0 .85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A4.97 4.97 0 0 0 18 7ZM7.3 11.5h1.2v1.19l-2.78 2.78a.75.75 0 0 0-.22.53 1 1 0 0 1-1.78.63c-.1-.13-.22-.25-.35-.35A1 1 0 0 1 4 14.5c.18 0 .37-.06.51-.21l2.8-2.79Z"
]);
const $7972e53b1de568ed$export$15c05b9cc35ede65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg20Regular', "20", [
    "M18 7a5 5 0 0 0-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 0 0 .35.85h.39l-2 2a2 2 0 0 0-1.15 3.55c.08.06.15.13.2.21A2 2 0 0 0 6.5 16.1l2-2v.4a.5.5 0 0 0 .85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A4.97 4.97 0 0 0 18 7Zm-9.5 5.69-2.78 2.78a.75.75 0 0 0-.22.53 1 1 0 0 1-1.78.63c-.1-.13-.22-.25-.35-.35A1 1 0 0 1 4 14.5c.18 0 .37-.06.51-.21l2.8-2.79H8.5v1.19ZM13 3a4 4 0 0 1 1.37 7.76 11.6 11.6 0 0 0-3.8 1.47L9.49 13.3v-2.23a.5.5 0 0 0-.15-.35l-.06-.06a.5.5 0 0 0-.35-.15H6.71l1.07-1.07a11.53 11.53 0 0 0 1.28-3.1 3.97 3.97 0 0 1 .23-.82A4 4 0 0 1 13 3Z"
]);
const $7972e53b1de568ed$export$52b302f6c10681af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg24Filled', "24", [
    "M22 8a6 6 0 0 0-11.9-1.1 15.12 15.12 0 0 1-1.36 3.3l-2.52 2.52a.75.75 0 0 0 .28 1.24L4.46 16a2.5 2.5 0 0 0-1.42 4.53c.17.12.31.26.43.43A2.5 2.5 0 0 0 8 19.53l2.04-2.04a.75.75 0 0 0 1.24.29l2.52-2.52c.48-.29 1.48-.8 3.32-1.36A6 6 0 0 0 22 8ZM8.58 14H10v1.41l-3.12 3.12c-.29.3-.38.67-.38.97a1 1 0 0 1-1.81.58c-.21-.3-.48-.55-.77-.77a1 1 0 0 1 .58-1.81c.3 0 .67-.09.96-.38L8.58 14Z"
]);
const $7972e53b1de568ed$export$6d2d62107ebb3957 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg24Regular', "24", [
    "M22 8a6 6 0 0 0-11.9-1.1 15.12 15.12 0 0 1-1.36 3.3l-2.52 2.52a.75.75 0 0 0 .28 1.24L4.46 16a2.5 2.5 0 0 0-1.42 4.53c.17.12.31.26.43.43A2.5 2.5 0 0 0 8 19.53l2.04-2.04a.75.75 0 0 0 1.24.29l2.52-2.52c.48-.29 1.48-.8 3.32-1.36A6 6 0 0 0 22 8Zm-12 7.41-3.12 3.12c-.29.3-.38.67-.38.97a1 1 0 0 1-1.81.58c-.21-.3-.48-.56-.77-.77a1 1 0 0 1 .58-1.81c.3 0 .67-.09.96-.38L8.58 14H10v1.41ZM16 3.5a4.5 4.5 0 0 1 .72 8.95 16.28 16.28 0 0 0-3.91 1.68l-1.31 1.3v-2.18a.75.75 0 0 0-.75-.75H8.56l1.3-1.3a16.12 16.12 0 0 0 1.71-4A4.5 4.5 0 0 1 16 3.5Z"
]);
const $7972e53b1de568ed$export$34780e512626054 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg32Filled', "32", [
    "M30 10.5a8.5 8.5 0 0 0-16.86-1.53 21.28 21.28 0 0 1-1.86 4.34l-3.99 3.98A1 1 0 0 0 8 19h.1l-3.02 3.02a3.5 3.5 0 0 0-1.71 6.26c.13.1.26.22.36.36a3.5 3.5 0 0 0 6.25-1.74L13 23.88V24a1 1 0 0 0 1.7.7l4-3.98c.65-.4 1.99-1.09 4.37-1.86A8.5 8.5 0 0 0 30 10.5ZM10.94 19H13v2.05l-4.68 4.68c-.21.21-.32.49-.32.77a1.5 1.5 0 0 1-2.69.92 3.98 3.98 0 0 0-.73-.73A1.5 1.5 0 0 1 5.5 24c.28 0 .55-.11.75-.31L10.94 19Z"
]);
const $7972e53b1de568ed$export$39a67631f79f7dbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodChickenLeg32Regular', "32", [
    "M30 10.5a8.5 8.5 0 0 0-16.86-1.53 21.28 21.28 0 0 1-1.86 4.34l-3.99 3.98A1 1 0 0 0 8 19h.1l-3.02 3.02a3.5 3.5 0 0 0-1.71 6.26c.13.1.26.22.36.36a3.5 3.5 0 0 0 6.25-1.74L13 23.88V24a1 1 0 0 0 1.7.7l4-3.98c.65-.4 1.99-1.09 4.37-1.86A8.5 8.5 0 0 0 30 10.5ZM13 21.05l-4.68 4.68c-.21.21-.32.49-.32.77a1.5 1.5 0 0 1-2.69.92 3.98 3.98 0 0 0-.73-.73A1.5 1.5 0 0 1 5.5 24c.28 0 .55-.11.75-.31L10.94 19H13v2.05ZM21.5 4a6.5 6.5 0 0 1 1.01 12.93c-2.67.87-4.19 1.67-4.97 2.15a1 1 0 0 0-.18.14L15 21.6V18a1 1 0 0 0-1-1h-3.59l2.36-2.36a1 1 0 0 0 .14-.18 22.68 22.68 0 0 0 2.19-5.08A6.5 6.5 0 0 1 21.5 4Z"
]);
const $7972e53b1de568ed$export$cddbeef1db13636e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg16Filled', "16", [
    "M7.7 8.22a.73.73 0 0 1 .2-.37.38.38 0 0 1 .11-.07.5.5 0 0 0 .19-.99c-.4-.08-.76.13-.98.33-.24.23-.43.54-.5.9a.5.5 0 1 0 .97.2ZM3.51 5.83c-1.79 1.42-1.83 3.84-1 5.46a3.61 3.61 0 0 0 3.28 2.07l.92-.02c.69-.03.82-.04 1.78.35 1.28.52 2.65.37 3.79-.35 1.03-.65 1.62-2.15 1.52-3.37-.06-.65 0-.91.07-1.21.05-.27.12-.56.12-1.18 0-1.32-.39-2.16-.78-2.84a5.32 5.32 0 0 0-2.01-2.13 4.54 4.54 0 0 0-4.33-.11A5.31 5.31 0 0 0 4.6 4.74c-.24.41-.48.61-1.08 1.09ZM11.6 8.3a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0Z"
]);
const $7972e53b1de568ed$export$b764d83fa48211bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg16Regular', "16", [
    "M7.7 8.22a.73.73 0 0 1 .2-.36.38.38 0 0 1 .11-.08.5.5 0 0 0 .19-.99c-.4-.08-.76.13-.98.34-.24.22-.43.53-.5.88a.5.5 0 1 0 .97.21Zm.6 3.38a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6Zm0-1a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6ZM9.2 2c.79.06 1.53.29 2.07.63a5.38 5.38 0 0 1 2.02 2.12c.39.67.79 1.53.79 2.85 0 .62-.07.93-.13 1.2v.04c-.05.21-.1.4-.05.91a4.2 4.2 0 0 1-.35 1.98c-.27.62-.7 1.2-1.28 1.57-1.19.74-2.62.9-3.96.37-.59-.24-.77-.29-.97-.3H6.87L6 13.4a3.84 3.84 0 0 1-3.46-2.16C1.68 9.6 1.7 7.1 3.59 5.61a3 3 0 0 0 .88-.87c.31-.52.61-.93.98-1.29s.78-.65 1.3-.94a4.47 4.47 0 0 1 2.45-.5Zm-.06 1a3.47 3.47 0 0 0-1.9.39c-.47.26-.8.5-1.09.77-.28.28-.53.62-.82 1.1-.28.46-.57.7-1.12 1.13-1.41 1.12-1.48 3.04-.79 4.38.46.88 1.31 1.62 2.58 1.62.36 0 .62 0 .83-.02H7.4c.38.02.7.13 1.29.37 1.03.4 2.12.29 3.05-.29.36-.23.68-.63.9-1.12.2-.49.3-1.03.26-1.5-.05-.61 0-.9.07-1.2v-.06a4.37 4.37 0 0 0-.55-3.32 4.4 4.4 0 0 0-1.69-1.78A3.53 3.53 0 0 0 9.13 3Z"
]);
const $7972e53b1de568ed$export$b93311058e1a4520 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg20Filled', "20", [
    "M10.47 9.6a.5.5 0 0 0 .14-.98 2.14 2.14 0 0 0-2.35 2.16.5.5 0 0 0 1 0c0-.8.7-1.24 1.2-1.17ZM3.99 7.14c-2.41 1.91-2.48 5.15-1.34 7.32a4.89 4.89 0 0 0 4.42 2.77c.54 0 .94-.01 1.24-.03.94-.03 1.11-.04 2.42.48a5.6 5.6 0 0 0 5.12-.47c1.39-.87 2.19-2.88 2.05-4.52-.08-.98 0-1.36.09-1.86.06-.33.13-.7.17-1.34a7.1 7.1 0 0 0-1.05-3.81 7.63 7.63 0 0 0-2.72-2.85 6.18 6.18 0 0 0-5.86-.15 7.15 7.15 0 0 0-3.07 3 5.1 5.1 0 0 1-1.47 1.46Zm10.91 3.33a4.5 4.5 0 1 1-8.99 0 4.5 4.5 0 0 1 8.99 0Z"
]);
const $7972e53b1de568ed$export$dace4b19db3eee6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg20Regular', "20", [
    "M10.06 9.58a.5.5 0 1 0 .14-1c-.94-.12-1.78.6-1.78 1.64a.5.5 0 0 0 1 0c0-.46.32-.68.64-.64Zm.35 5.38a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9Zm0-1a3.5 3.5 0 1 1 0-6.99 3.5 3.5 0 0 1 0 7Zm1.22-11.89c1.04.07 2.02.38 2.72.83a7.6 7.6 0 0 1 2.7 2.83 7.1 7.1 0 0 1 1.05 3.82 9.84 9.84 0 0 1-.21 1.53c-.06.32-.1.66-.04 1.38.07.85-.1 1.78-.46 2.6a4.54 4.54 0 0 1-1.68 2.07 5.71 5.71 0 0 1-5.22.48c-.8-.33-1.08-.4-1.38-.42a6.7 6.7 0 0 0-.65 0c-.3.02-.67.03-1.18.03a5.05 5.05 0 0 1-4.56-2.84C1.59 12.2 1.62 8.9 4.1 6.94c.75-.6.98-.8 1.24-1.22.42-.7.82-1.25 1.3-1.73A7.7 7.7 0 0 1 8.4 2.74a5.9 5.9 0 0 1 3.23-.67Zm-.07 1c-.9-.06-1.85.1-2.68.55a6.7 6.7 0 0 0-1.53 1.09c-.4.39-.75.86-1.14 1.52-.37.6-.73.9-1.49 1.5-2 1.59-2.1 4.31-1.11 6.19a4.05 4.05 0 0 0 3.67 2.3l1.14-.02h.02c.27-.01.5-.02.73 0 .48.02.89.16 1.7.48 1.46.58 3 .41 4.31-.4.54-.34 1-.92 1.3-1.61.3-.7.43-1.46.38-2.13a5.82 5.82 0 0 1 .08-1.87c.06-.3.12-.63.16-1.19a6.12 6.12 0 0 0-.91-3.26 6.6 6.6 0 0 0-2.37-2.48 4.99 4.99 0 0 0-2.26-.67Z"
]);
const $7972e53b1de568ed$export$b16bea3d3913ad3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg24Filled', "24", [
    "M11.5 12.25c0-.41.34-.75.75-.75a.75.75 0 0 0 0-1.5C11.01 10 10 11 10 12.25a.75.75 0 0 0 1.5 0ZM13.5 2a8.38 8.38 0 0 0-7.29 4.5c-.24.43-.6.8-1.05 1.1A7.38 7.38 0 0 0 2 13.76C2 17.7 4.97 21 8.75 21c.32 0 .64-.02.95-.07.87-.13 1.8 0 2.57.38A6.75 6.75 0 0 0 21.9 14a3.14 3.14 0 0 1-.03-1.07c.1-.54.14-1.1.14-1.66C22 6.22 18.26 2 13.5 2Zm3.75 10.5a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0Z"
]);
const $7972e53b1de568ed$export$fd6cb36ad22ee65a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodEgg24Regular', "24", [
    "M11.5 12.25c0-.41.34-.75.75-.75a.75.75 0 0 0 0-1.5C11.01 10 10 11 10 12.25a.75.75 0 0 0 1.5 0ZM7 12.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm5.5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-6.29-2A8.38 8.38 0 0 1 13.5 2c4.76 0 8.5 4.22 8.5 9.28 0 .56-.05 1.12-.14 1.66-.05.34-.04.7.03 1.08a6.75 6.75 0 0 1-9.62 7.3 4.4 4.4 0 0 0-2.57-.4c-.3.06-.63.08-.95.08C4.97 21 2 17.7 2 13.75a7.38 7.38 0 0 1 3.16-6.14c.45-.3.81-.68 1.05-1.12Zm7.29-3a6.88 6.88 0 0 0-5.97 3.72A4.8 4.8 0 0 1 6 8.85a5.88 5.88 0 0 0-2.5 4.9c0 3.23 2.4 5.75 5.25 5.75.25 0 .5-.02.73-.05a5.9 5.9 0 0 1 3.45.51 5.25 5.25 0 0 0 7.48-5.67 4.64 4.64 0 0 1-.03-1.6c.08-.46.12-.93.12-1.41 0-4.37-3.2-7.78-7-7.78Z"
]);
const $7972e53b1de568ed$export$82d59b9aedd30fa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish20Filled', "20", [
    "M8.63 3.7c-1.5 1.5-1.76 3.87-1.72 5.67a.4.4 0 0 1-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52.35.1.65.21.9.33.26.12.42.22.5.3.09.09.2.25.31.5.12.26.23.57.33.91.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 0 1 .4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25.2-1.17.17-2.37.08-3.32a3 3 0 0 0-2.73-2.73 12.7 12.7 0 0 0-3.32.08c-1.17.2-2.35.65-3.25 1.54Zm4.62.8a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $7972e53b1de568ed$export$7e9f4b46b75cbe1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish20Regular', "20", [
    "M7.91 9.35c-.04-1.76.24-3.76 1.43-4.95.7-.7 1.66-1.08 2.71-1.26a11.7 11.7 0 0 1 3.06-.07c.98.09 1.73.84 1.82 1.82.09.9.11 2-.07 3.06a4.97 4.97 0 0 1-1.26 2.71c-1.19 1.2-3.19 1.47-4.95 1.43a1.4 1.4 0 0 0-1.43 1.3c-.1 1.47-.4 3.17-1.11 4.52-.04.07-.07.08-.08.09a.1.1 0 0 1-.06 0c-.07-.02-.16-.1-.2-.25-.13-.7-.3-1.54-.53-2.28a8.35 8.35 0 0 0-.38-1.03c-.13-.3-.3-.58-.5-.8-.21-.2-.5-.36-.8-.5-.3-.14-.66-.27-1.03-.38-.74-.22-1.57-.4-2.28-.54-.16-.03-.23-.13-.25-.2a.1.1 0 0 1 0-.06c.01 0 .03-.04.09-.07a11.53 11.53 0 0 1 4.52-1.11 1.4 1.4 0 0 0 1.3-1.43Zm.72-5.66c-1.5 1.5-1.76 3.88-1.72 5.68a.4.4 0 0 1-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52.35.1.65.21.9.33.26.12.42.22.5.3.09.09.2.25.31.5.12.26.23.57.33.91.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 0 1 .4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25.2-1.17.17-2.37.08-3.32a3 3 0 0 0-2.73-2.73 12.7 12.7 0 0 0-3.32.08c-1.17.2-2.35.65-3.25 1.54Zm4.62.8a.75.75 0 1 1 0 1.51.75.75 0 0 1 0-1.5Z"
]);
const $7972e53b1de568ed$export$51cfa87b42084916 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish24Filled', "24", [
    "M10.36 4.1c-1 1-1.58 2.34-1.91 3.68A16.66 16.66 0 0 0 8 11.73c0 .17-.14.32-.32.32-1.77 0-4.01.22-5.83 1.09-.68.32-.97 1-.82 1.63.13.6.61 1.09 1.26 1.25.8.19 1.72.44 2.52.72.4.15.76.3 1.05.44.3.15.49.28.58.37.1.1.22.28.37.58.15.29.3.65.44 1.05.28.8.53 1.72.72 2.52.16.65.65 1.13 1.25 1.26.64.14 1.3-.14 1.63-.82.87-1.82 1.08-4.06 1.1-5.82 0-.18.14-.33.32-.33 1.2 0 2.6-.1 3.95-.43a7.78 7.78 0 0 0 3.67-1.91 7.4 7.4 0 0 0 1.92-4.06c.25-1.45.2-2.92.1-4.09a3.77 3.77 0 0 0-3.41-3.4 15.68 15.68 0 0 0-4.1.09 7.4 7.4 0 0 0-4.05 1.91ZM16 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
]);
const $7972e53b1de568ed$export$4cb8c67b91971787 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodFish24Regular', "24", [
    "M9.51 11.72c0-1.13.1-2.4.4-3.58a6.3 6.3 0 0 1 1.5-2.98 5.93 5.93 0 0 1 3.26-1.5 14.2 14.2 0 0 1 3.69-.08c1.1.11 1.95.96 2.06 2.07.1 1.09.14 2.42-.08 3.69a5.93 5.93 0 0 1-1.5 3.25 6.3 6.3 0 0 1-2.97 1.52c-1.19.3-2.46.38-3.6.38-1 0-1.81.82-1.82 1.82 0 1.7-.22 3.66-.93 5.17a.25.25 0 0 1-.08-.14c-.2-.82-.46-1.8-.77-2.66-.15-.44-.32-.86-.5-1.22s-.4-.71-.66-.97a3.76 3.76 0 0 0-.97-.65c-.36-.19-.78-.36-1.22-.5-.87-.32-1.85-.58-2.66-.78a.25.25 0 0 1-.14-.08c1.51-.71 3.48-.92 5.18-.93 1 0 1.82-.82 1.81-1.83Zm.85-7.62c-1 1-1.58 2.34-1.91 3.68A16.66 16.66 0 0 0 8 11.73c0 .17-.14.32-.32.32-1.77 0-4.01.22-5.83 1.09-.68.32-.97 1-.82 1.63.13.6.61 1.09 1.26 1.25.8.19 1.72.44 2.52.72.4.15.76.3 1.05.44.3.15.49.28.58.37.1.1.22.28.37.58.15.29.3.65.44 1.05.28.8.53 1.72.72 2.52.16.65.65 1.13 1.25 1.26.64.14 1.3-.14 1.63-.82.87-1.82 1.08-4.06 1.1-5.82 0-.18.14-.33.32-.33 1.2 0 2.6-.1 3.95-.43a7.78 7.78 0 0 0 3.67-1.91 7.4 7.4 0 0 0 1.92-4.06c.25-1.45.2-2.92.1-4.09a3.77 3.77 0 0 0-3.41-3.4 15.68 15.68 0 0 0-4.1.09 7.4 7.4 0 0 0-4.05 1.91ZM16 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
]);
const $7972e53b1de568ed$export$342253f3e7924c4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains20Filled', "20", [
    "M10.43 2.21a.65.65 0 0 0-.86 0 5.72 5.72 0 0 0-1.92 4.35c0 .18.09.34.24.43A7.4 7.4 0 0 1 9.63 8.4a.5.5 0 0 0 .74 0 7.4 7.4 0 0 1 1.74-1.42.5.5 0 0 0 .24-.43c.02-1.59-.62-3.2-1.92-4.35Zm-7.41 10a.66.66 0 0 1 .6-.72A6.36 6.36 0 0 1 10 15.33a6.36 6.36 0 0 1 6.38-3.84c.36.03.64.35.6.72A6.37 6.37 0 0 1 10.64 18h-.46c-.07 0-.12 0-.18-.02a.66.66 0 0 1-.18.02h-.46a6.37 6.37 0 0 1-6.34-5.8ZM10 10.83a6.36 6.36 0 0 0-6.38-3.84.66.66 0 0 0-.6.72c.08.9.35 1.75.76 2.5a.5.5 0 0 0 .43.26c2.1.01 4.03.92 5.37 2.39.11.12.27.18.42.16a.5.5 0 0 0 .42-.16 7.36 7.36 0 0 1 5.36-2.4.5.5 0 0 0 .44-.25c.41-.75.68-1.6.76-2.5a.66.66 0 0 0-.6-.72A6.36 6.36 0 0 0 10 10.83Z"
]);
const $7972e53b1de568ed$export$aa97ea1e409a5b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains20Regular', "20", [
    "M10.43 2.21a.65.65 0 0 0-.86 0 5.73 5.73 0 0 0-1.74 5.74 7.11 7.11 0 0 0-4.2-.96.66.66 0 0 0-.61.72 6.99 6.99 0 0 0 1.65 3.77c-.35-.02-.7-.02-1.05 0a.66.66 0 0 0-.6.73A6.37 6.37 0 0 0 9.36 18h1.28c3.3 0 6.04-2.51 6.34-5.8a.66.66 0 0 0-.6-.71c-.36-.03-.7-.03-1.05-.01a6.99 6.99 0 0 0 1.65-3.77.66.66 0 0 0-.6-.72 7.1 7.1 0 0 0-4.21.96c.52-2-.06-4.24-1.74-5.74ZM10 14.43a7.15 7.15 0 0 0-3.47-2.6 6.17 6.17 0 0 1-2.47-3.86c1.54-.05 3 .5 4.12 1.45.76.64.96 1.23 1.15 1.76l.22.54a.5.5 0 0 0 .9 0l.22-.54c.18-.53.4-1.12 1.15-1.76a6.12 6.12 0 0 1 4.12-1.45 6.17 6.17 0 0 1-2.5 3.9A7.15 7.15 0 0 0 10 14.42ZM9.36 17a5.37 5.37 0 0 1-5.3-4.53 6.13 6.13 0 0 1 5.5 3.13.5.5 0 0 0 .88 0 6.13 6.13 0 0 1 5.5-3.13 5.37 5.37 0 0 1-5.3 4.53H9.36ZM10 9.82a4.74 4.74 0 0 1 0-6.64 4.74 4.74 0 0 1 0 6.64Z"
]);
const $7972e53b1de568ed$export$4b3679628877c6ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains24Filled', "24", [
    "M12.61 2.29a.93.93 0 0 0-1.22 0A7.2 7.2 0 0 0 8.9 7.57c0 .19.11.36.28.45a9.06 9.06 0 0 1 2.4 1.83c.23.24.62.24.84 0a9.04 9.04 0 0 1 2.4-1.83.5.5 0 0 0 .28-.45 7.2 7.2 0 0 0-2.49-5.28Zm-.6 15.75a8.16 8.16 0 0 1 8.16-4.06c.49.07.85.5.81 1A7.6 7.6 0 0 1 13.41 22H10.6a7.6 7.6 0 0 1-7.57-7.01.94.94 0 0 1 .81-1A8.16 8.16 0 0 1 12 18.03Zm7.64-5.11a9.9 9.9 0 0 0-5.13 1.16 8.61 8.61 0 0 0-2.32 1.78c-.1.11-.3.11-.4 0a8.6 8.6 0 0 0-2.32-1.78 9.9 9.9 0 0 0-5.11-1.16 8.66 8.66 0 0 1-1.35-3.8.96.96 0 0 1 .87-1.04c2.46-.2 4.5.28 6.35 1.84.82.7 1.38 1.54 1.76 2.26.38-.72.94-1.56 1.77-2.26 1.84-1.56 3.9-2.04 6.35-1.84.53.04.93.5.88 1.04a8.66 8.66 0 0 1-1.35 3.8Z"
]);
const $7972e53b1de568ed$export$61ddd807022b6034 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodGrains24Regular', "24", [
    "M11.39 2.29a7.23 7.23 0 0 0-2.37 6.78 8.5 8.5 0 0 0-5.13-.98.96.96 0 0 0-.87 1.04 8.97 8.97 0 0 0 2.06 4.78c-.41 0-.83.02-1.25.07-.5.07-.85.5-.81 1A7.6 7.6 0 0 0 10.59 22H13.4a7.6 7.6 0 0 0 7.57-7.01.94.94 0 0 0-.81-1 8.8 8.8 0 0 0-1.23-.08A8.97 8.97 0 0 0 21 9.13a.96.96 0 0 0-.88-1.04 8.55 8.55 0 0 0-5.14.98A7.23 7.23 0 0 0 12.6 2.3a.93.93 0 0 0-1.22 0Zm.61 9.44a5.74 5.74 0 0 1 0-7.96 5.74 5.74 0 0 1 0 7.96Zm0 5.6a9.02 9.02 0 0 0-4.23-2.97 7.75 7.75 0 0 1-3.18-4.8 6.43 6.43 0 0 1 4.67 1.51c1.03.87 1.48 1.93 1.82 2.72l.25.55a.75.75 0 0 0 1.34 0l.25-.55a6.8 6.8 0 0 1 1.81-2.72 6.46 6.46 0 0 1 4.7-1.52 7.75 7.75 0 0 1-3.17 4.8A9.02 9.02 0 0 0 12 17.33Zm.64 1.71c1.4-2.33 4-3.78 6.78-3.62a6.1 6.1 0 0 1-6.01 5.08H10.59a6.1 6.1 0 0 1-6.01-5.08 7.45 7.45 0 0 1 6.78 3.62.75.75 0 0 0 1.28 0Z"
]);
const $7972e53b1de568ed$export$977e3cce023b9979 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza20Filled', "20", [
    "M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86l-.25.19-.4-.44V9.3A16.37 16.37 0 0 0 4.88 4.5H4v-.55ZM4 5.5V16.5a1.5 1.5 0 0 0 2.4 1.2L8 16.5a1 1 0 0 0 2 0v-2a.5.5 0 0 1 1-.06V15a1 1 0 0 0 2 0v-2.24c.82-.6 2.09-1.56 3.19-2.4l-.33-.37A15.37 15.37 0 0 0 4.87 5.5H4Zm4.25 2.74a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.97 2a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-2.96 2.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
]);
const $7972e53b1de568ed$export$9c3290e2ac5743b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza20Regular', "20", [
    "M7.5 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.72 1.26a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86-1.24.95-3.12 2.4-4.23 3.2v1.74c0 .72-.55 1.5-1.5 1.5-.18 0-.34-.03-.5-.08v.09c0 .7-.55 1.49-1.5 1.49-.75 0-1.25-.5-1.42-1.05L6.4 17.7A1.5 1.5 0 0 1 4 16.5V3.96Zm7 10.54c0 .26.2.5.5.5s.5-.24.5-.5v-2a.5.5 0 0 1 .21-.4c.78-.56 2.1-1.57 3.28-2.47A15.43 15.43 0 0 0 5 5.51V16.5c0 .41.47.64.8.4l2.4-1.8a.5.5 0 0 1 .8.4v.5c0 .25.2.5.5.5a.5.5 0 0 0 .5-.5v-1.5a.5.5 0 0 1 1 0Zm5.62-5.73c.46-.36.5-1 .12-1.36-2.86-2.72-6.52-4.15-10.77-4.4a.93.93 0 0 0-.97.95v.55c4.33.04 8.4 1.7 11.3 4.5l.32-.24Z"
]);
const $7972e53b1de568ed$export$36bca581e0958eac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza24Filled', "24", [
    "M5 4.66a2.6 2.6 0 0 1 2.82-2.65 20.78 20.78 0 0 1 13.45 6.83 2.6 2.6 0 0 1-.48 3.85l-.43.3-.36-.54A17.55 17.55 0 0 0 5.74 5.16H5v-.5Zm13.77 8.65.38.56-3.95 2.87-.2.15v2.1a1 1 0 0 1-2 0v-.06a.5.5 0 0 0-1 .06v1.5a1 1 0 0 1-2 .1l-1.43 1.04A2.25 2.25 0 0 1 5 19.81V6.67h.75c5.36 0 10.1 2.61 13.02 6.64ZM9 10.99a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$b0dee51b6d8c7449 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodPizza24Regular', "24", [
    "M9 10.99a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 4.66a2.6 2.6 0 0 1 2.82-2.65 20.78 20.78 0 0 1 13.44 6.83 2.6 2.6 0 0 1-.48 3.85l-5.28 3.83V18.24a1.75 1.75 0 0 1-2.06 1.72c-.2.83-.93 1.53-1.94 1.53-.7 0-1.26-.34-1.61-.82l-1.33.96A2.25 2.25 0 0 1 5 19.81V4.66Zm2.67-1.15c-.6-.06-1.17.44-1.17 1.15v.52c5.25.22 9.91 2.75 12.98 6.6l.42-.3c.58-.43.65-1.18.25-1.64A19.28 19.28 0 0 0 7.66 3.51ZM6.5 19.8c0 .6.69.96 1.19.6.72-.52 1.5-1.07 2.12-1.53a.75.75 0 0 1 1.2.6c0 .28.2.5.49.5.3 0 .5-.22.5-.5v-1.24a.75.75 0 0 1 1.5 0 .25.25 0 1 0 .5 0v-2.12c0-.23.12-.45.31-.6l3.96-2.86A16.04 16.04 0 0 0 6.5 6.68v13.13Z"
]);
const $7972e53b1de568ed$export$ba6c4701a2449225 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast16Filled', "16", [
    "M4.85 6.5c0-.28.22-.5.5-.5h3.2c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3.2a.5.5 0 0 1-.5-.5v-3Zm1 2.5h2.2V7h-2.2v2ZM1.27 4.01A3.29 3.29 0 0 1 4.2 2H12c1.44 0 3 1.19 3 3 0 1.06-.6 1.95-1 2.4-.01.55.01 1.28.04 2.06v.23c.03.8.06 1.62.06 2.31 0 .64-.06 1.24-.5 1.61-.2.2-.46.28-.72.33-.26.05-.56.06-.88.06H4c-.94 0-1.55-.28-1.87-.8A2.1 2.1 0 0 1 1.9 12V7.42a2.97 2.97 0 0 1-.63-3.4ZM4.2 3c-.87 0-1.66.6-2.02 1.41-.35.8-.26 1.72.54 2.4.12.1.18.24.18.39v4.87c0 .27 0 .46.1.61.05.1.24.32 1 .32h6c.31 0 .53-.01.68-.04.14-.03.18-.07.2-.08 0-.01.04-.05.07-.2.04-.15.05-.36.05-.68v-1.57c-.01-1.11-.02-2.26 0-3.04a.5.5 0 0 1 .15-.34l.23-.23c.2-.18.36-.34.52-.57.19-.28.34-.65.34-1.25 0-.66-.3-1.14-.73-1.48A2.55 2.55 0 0 0 10 3H4.2Z"
]);
const $7972e53b1de568ed$export$8a99187daf6c325c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast16Regular', "16", [
    "M4.85 6.5c0-.28.22-.5.5-.5h3.2c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3.2a.5.5 0 0 1-.5-.5v-3Zm1 2.5h2.2V7h-2.2v2ZM1.27 4.01A3.29 3.29 0 0 1 4.2 2H12c1.44 0 3 1.19 3 3 0 1.06-.6 1.95-1 2.4-.01.55.01 1.28.04 2.06v.23c.03.8.06 1.62.06 2.31 0 .64-.06 1.24-.5 1.61-.2.2-.46.28-.72.33-.26.05-.56.06-.88.06H4c-.94 0-1.55-.28-1.87-.8A2.1 2.1 0 0 1 1.9 12V7.42a2.97 2.97 0 0 1-.63-3.4ZM4.2 3c-.87 0-1.66.6-2.02 1.41-.35.8-.26 1.72.54 2.4.12.1.18.24.18.39v4.87c0 .27 0 .46.1.61.05.1.24.32 1 .32h6c.31 0 .53-.01.68-.04.14-.03.18-.07.2-.08 0-.01.04-.05.07-.2.04-.15.05-.36.05-.68v-1.57c-.01-1.11-.02-2.26 0-3.04a.5.5 0 0 1 .15-.34l.23-.23c.2-.18.36-.34.52-.57.19-.28.34-.65.34-1.25 0-.66-.3-1.14-.73-1.48A2.55 2.55 0 0 0 10 3H4.2Zm7.73 9.88-.02.12H12c.31 0 .53-.01.7-.04.16-.03.22-.07.25-.1.05-.05.15-.2.15-.86 0-.67-.03-1.48-.05-2.28l-.01-.23c-.03-.86-.06-1.7-.04-2.3a.5.5 0 0 1 .16-.35c.3-.29.84-1.03.84-1.84 0-.98-.71-1.71-1.5-1.93.44.48.74 1.13.74 1.93s-.21 1.37-.52 1.82c-.22.32-.5.59-.71.78l-.02.02v2.77L12 12c0 .33-.01.63-.07.88Z"
]);
const $7972e53b1de568ed$export$c1a474b6af95c1dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast20Filled', "20", [
    "M6.78 7.45a.5.5 0 0 0-.5.5v4.1c0 .27.22.5.5.5h4.34a.5.5 0 0 0 .5-.5v-4.1a.5.5 0 0 0-.5-.5H6.78Zm.5 1h3.34v3.1H7.28v-3.1ZM5.45 2.5c-1.63 0-3 1.1-3.6 2.48-.6 1.33-.49 3 .81 4.22v5.98c0 .3-.01.87.28 1.36.36.6 1.08.96 2.26.96h10.18c.4 0 .78-.02 1.1-.07.3-.06.6-.17.85-.39.5-.43.59-1.13.59-1.95 0-.88-.04-1.92-.07-2.93a66.88 66.88 0 0 1-.07-2.97 4.68 4.68 0 0 0 1.28-3 3.73 3.73 0 0 0-3.68-3.69H5.45Zm7.38 1c.62 0 1.39.3 2 .82.6.51.99 1.18 1 1.85-.05.75-.21 1.24-.41 1.58-.16.27-.35.48-.56.69l-.16.15a13.81 13.81 0 0 0-.31.3l-.14.13v.2c-.04 1-.03 2.44-.02 3.84v.01l.01 2.02c0 .4-.02.7-.06.9-.04.2-.1.28-.14.32-.04.04-.12.1-.32.13a9.84 9.84 0 0 1-.89.06H5.2c-1 0-1.3-.29-1.4-.47-.14-.23-.14-.51-.14-.84V8.99a.5.5 0 0 0-.18-.39 2.65 2.65 0 0 1-.72-3.22 3.05 3.05 0 0 1 2.7-1.88h7.37Z"
]);
const $7972e53b1de568ed$export$7be872dcc60479a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast20Regular', "20", [
    "M6.23 7.95c0-.27.22-.5.5-.5h4.34c.28 0 .5.23.5.5v4.1a.5.5 0 0 1-.5.5H6.73a.5.5 0 0 1-.5-.5v-4.1Zm1 3.6h3.34v-3.1H7.23v3.1ZM1.79 4.98A4.05 4.05 0 0 1 5.4 2.5h9.93A3.73 3.73 0 0 1 19 6.18c0 1.33-.76 2.46-1.28 3.01 0 .7.02 1.66.06 2.67v.3c.04 1 .08 2.05.08 2.93 0 .82-.1 1.52-.59 1.95-.24.22-.54.33-.86.39-.31.05-.68.07-1.1.07H5.16c-1.18 0-1.9-.35-2.26-.96a2.53 2.53 0 0 1-.28-1.45V9.2a3.64 3.64 0 0 1-.82-4.22ZM5.4 3.5c-1.16 0-2.21.8-2.7 1.88a2.65 2.65 0 0 0 .73 3.22c.12.1.18.24.18.38v6.21c0 .33 0 .6.14.84.1.18.4.47 1.4.47h7.63c.4 0 .68-.02.89-.06.2-.03.28-.09.32-.13.05-.04.1-.12.14-.32.04-.2.06-.5.06-.9v-2c-.02-1.42-.03-2.87 0-3.87a.5.5 0 0 1 .15-.34l.3-.3c.24-.21.44-.4.63-.68.25-.35.46-.86.5-1.73 0-.67-.39-1.34-1-1.85a3.28 3.28 0 0 0-1.99-.82H5.4Zm9.71 12.69-.08.31h.3c.4 0 .69-.02.9-.06.23-.04.33-.1.4-.15.12-.1.24-.36.24-1.2 0-.86-.04-1.89-.07-2.9l-.01-.3c-.04-1.1-.07-2.16-.05-2.92a.5.5 0 0 1 .15-.35 3.73 3.73 0 0 0 1.12-2.44 2.73 2.73 0 0 0-2.65-2.68l.06.06a3.52 3.52 0 0 1 1.35 2.62v.03a4.24 4.24 0 0 1-.67 2.26c-.26.38-.58.67-.84.91l-.07.07c-.02.97-.02 2.3 0 3.6v2.04c0 .42-.02.8-.08 1.1Z"
]);
const $7972e53b1de568ed$export$c0f148ebc60ed22f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast24Filled', "24", [
    "M8.25 9a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75h-4.5ZM9 13.5v-3h3v3H9ZM2 7.75A4.75 4.75 0 0 1 6.75 3h10.5a4.75 4.75 0 0 1 3.5 7.96v7.79c0 1.24-1 2.25-2.25 2.25h-13c-1.24 0-2.25-1-2.25-2.25v-7.79A4.74 4.74 0 0 1 2 7.75ZM6.75 4.5a3.25 3.25 0 0 0-2.23 5.61c.15.14.23.34.23.54v8.1c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-7.7c0-.24.12-.47.33-.61a3.25 3.25 0 0 0-1.83-5.94h-8Z"
]);
const $7972e53b1de568ed$export$f0b5ddf9f146cf8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FoodToast24Regular', "24", [
    "M8.25 9a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 0 0-.75-.75h-4.5ZM9 13.5v-3h3v3H9ZM2 7.75A4.75 4.75 0 0 1 6.75 3h10.5a4.75 4.75 0 0 1 3.5 7.96v7.79c0 1.24-1 2.25-2.25 2.25h-13c-1.24 0-2.25-1-2.25-2.25v-7.79A4.74 4.74 0 0 1 2 7.75ZM6.75 4.5a3.25 3.25 0 0 0-2.23 5.61c.15.14.23.34.23.54v8.1c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-7.7c0-.24.12-.47.33-.61a3.25 3.25 0 0 0-1.83-5.94h-8ZM19.5 7.75c0 1.49-.68 2.81-1.75 3.68v7.32c0 .26-.05.52-.13.75h.88c.41 0 .75-.34.75-.75v-8.1c0-.2.08-.4.23-.54a3.24 3.24 0 0 0-1.08-5.4c.69.82 1.1 1.88 1.1 3.04Z"
]);
const $7972e53b1de568ed$export$27ee5ac8ab5ded84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info12Filled', "12", [
    "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0Zm-5.5.5V8a.5.5 0 0 0 1 0V6.5a.5.5 0 0 0-1 0ZM6 3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
]);
const $7972e53b1de568ed$export$515949b0e3098366 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info12Regular', "12", [
    "M5.5 6.5a.5.5 0 0 1 1 0V8a.5.5 0 0 1-1 0V6.5ZM6 3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm5-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
]);
const $7972e53b1de568ed$export$994e675395c5ac42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 5.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.5 1.25a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Z"
]);
const $7972e53b1de568ed$export$fb9cc08986d6ea9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info16Regular', "16", [
    "M8.5 7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0v-3Zm.25-2a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z"
]);
const $7972e53b1de568ed$export$6faa23478c869acb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM9.5 8.91a.5.5 0 0 1 1 0V13.6a.5.5 0 0 1-1 0V8.9Zm-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
]);
const $7972e53b1de568ed$export$92e1c56f07f9445f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info20Regular', "20", [
    "M10.5 8.91a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91Zm.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
]);
const $7972e53b1de568ed$export$1a3d73bdedb2c3fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 8.5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75ZM12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$91f70b808248a723 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm0 7c.41 0 .75.34.75.75v5a.75.75 0 0 1-1.5 0v-5c0-.41.34-.75.75-.75ZM12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$afd7c8a05656084c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info28Filled', "28", [
    "M2 14a12 12 0 1 0 24 0 12 12 0 0 0-24 0Zm12-2.5c.41 0 .75.34.75.75v7a.75.75 0 0 1-1.5 0v-7c0-.41.34-.75.75-.75Zm0-1.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $7972e53b1de568ed$export$db09393bb96a6ae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info28Regular', "28", [
    "M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0ZM14 3.5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Zm0 8c.41 0 .75.34.75.75v7a.75.75 0 0 1-1.5 0v-7c0-.41.34-.75.75-.75Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$d91efc6eb9bba50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info32Filled', "32", [
    "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28Zm0 11a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1Zm0-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
]);
const $7972e53b1de568ed$export$a2a92ff38706a4ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info32Regular', "32", [
    "M16 13a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0ZM16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z"
]);
const $7972e53b1de568ed$export$5eeb28de4fe433cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info48Filled', "48", [
    "M44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0Zm-20-4c-.69 0-1.25.56-1.25 1.25v12.5a1.25 1.25 0 1 0 2.5 0v-12.5c0-.69-.56-1.25-1.25-1.25Zm0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $7972e53b1de568ed$export$44afdc466b0959b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Info48Regular', "48", [
    "M24 6.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35ZM4 24a20 20 0 1 1 40 0 20 20 0 0 1-40 0Zm20-4c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25Zm0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $7972e53b1de568ed$export$fc74f811a0c06a24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoShield20Filled', "20", [
    "M17 9a8 8 0 1 0-6.28 7.81 7.05 7.05 0 0 1-.72-2.93v-2.79c0-.75.59-1.42 1.4-1.42.9 0 1.76-.37 2.6-1.24a1.39 1.39 0 0 1 2 0 5.06 5.06 0 0 0 1 .8V9ZM8.5 7.91a.5.5 0 0 1 1 0V12.6a.5.5 0 0 1-1 0V7.9Zm-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm8.75 4.6a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 13 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 0 0-.4-.33 4.24 4.24 0 0 1-1.6-.32Z"
]);
const $7972e53b1de568ed$export$d0f7fdb5d26a4dd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoShield20Regular', "20", [
    "M17 9a8 8 0 1 0-6.28 7.81 5.93 5.93 0 0 1-.39-.94 7 7 0 1 1 5.64-7.47c.02 0 .03.02.04.03a5.06 5.06 0 0 0 .99.8V9ZM9.05 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM9 7.5a.5.5 0 0 1 .5.41v4.59a.5.5 0 0 1-1 .1V8c0-.28.22-.5.5-.5Zm8 2.85a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 13 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 0 0-.4-.33 4.24 4.24 0 0 1-1.6-.32Z"
]);
const $7972e53b1de568ed$export$bdf48a5fdc483960 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle16Filled', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02Zm-3.02 3.56a1.33 1.33 0 0 0 1 .21A7 7 0 1 1 8.78 1.04a1.2 1.2 0 0 1-.29.47c-.13.13-.29.24-.45.3l-1.09.34A1.43 1.43 0 0 0 6 3.5a1.41 1.41 0 0 0 .97 1.35l.47.15a.75.75 0 1 0 1.26.76l.1.2.35 1.1c.1.24.25.47.52.68.14.1.3.17.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25c.08.03.16.08.22.14.07.06.1.14.14.22l.26.8c.1.25.26.46.48.62ZM8 7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 8 7Z"
]);
const $7972e53b1de568ed$export$f33cf63a7abcd693 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle16Regular', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02Zm-3.02 3.56a1.33 1.33 0 0 0 1 .21A7 7 0 1 1 8.78 1.04a1.2 1.2 0 0 1-.29.47c-.13.13-.29.24-.45.3l-.73.23a6 6 0 1 0 5.4 9.69l.05.04ZM7.44 5l.6.2c.14.05.28.13.46.29.08.07.14.16.2.27A.75.75 0 1 1 7.44 5ZM8 7c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5Z"
]);
const $7972e53b1de568ed$export$1ec6ffb10c9b38e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle20Filled', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.27 0-.52-.08-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a.52.52 0 0 0-.14-.22.64.64 0 0 0-.22-.14l-.77-.25c-.27-.1-.49-.26-.65-.48a1.3 1.3 0 0 1-.12-1.3 1.32 1.32 0 0 1-.45-.22 1.51 1.51 0 0 1-.52-.69l-.36-1.09a1.27 1.27 0 0 0-.29-.47 1.3 1.3 0 0 0-.47-.3l-1.06-.34A1.41 1.41 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07a8 8 0 1 0 6.59 9.9l-.26.02Zm-8-3.09a.5.5 0 0 1 1 0V13.6a.5.5 0 0 1-1 0V8.9Zm-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
]);
const $7972e53b1de568ed$export$def13e18ca0cdc87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle20Regular', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.26 0-.51-.08-.73-.22A7 7 0 1 1 10.1 3a1.42 1.42 0 0 1 .86-.85l.22-.07a8 8 0 1 0 6.59 9.9l-.26.02Zm-7-3.09a.5.5 0 0 0-1 .09v4.6a.5.5 0 0 0 1-.1V8.91Zm.3-2.16a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
]);
const $7972e53b1de568ed$export$a1afa409381c3c8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle24Filled', "24", [
    "M16.09 6.41a2.84 2.84 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.84 2.84 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.84 2.84 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.84 2.84 0 0 0-1.8 1.8l-.45 1.38a.54.54 0 0 1-1.03 0l-.44-1.38c-.1-.3-.25-.6-.45-.85Zm7.7 3.8-.77-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02Zm-2.33 3.84c.13 0 .24-.02.34-.04a10 10 0 1 1-7.04-11.63 1.8 1.8 0 0 1-.37.18L13.05 3c-.63.22-1.05.8-1.05 1.47 0 .63.42 1.28 1 1.53l1.4.46c.52.17 1.01.57 1.19 1.09L16 9a1.55 1.55 0 0 0 2.14.89c-.12.2-.18.43-.18.66 0 .54.36 1.05.87 1.23l.24.07c.36.09.8.2.91.55l.01.04c.24.75.51 1.61 1.47 1.61ZM12 10.5a.75.75 0 0 0-.75.75v5a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.75-.75ZM12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$8382febde417d016 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle24Regular', "24", [
    "M16.09 6.41a2.84 2.84 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.84 2.84 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.84 2.84 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.84 2.84 0 0 0-1.8 1.8l-.45 1.38a.54.54 0 0 1-1.03 0l-.44-1.38c-.1-.3-.25-.6-.45-.85Zm7.7 3.8-.77-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM12 22.01a10 10 0 0 0 9.8-8c-.1.03-.21.04-.34.04-.53 0-.85-.27-1.07-.63a8.5 8.5 0 1 1-8.05-9.91c.18-.23.42-.4.71-.51l1.34-.44c.13-.04.25-.1.37-.18A10 10 0 1 0 12 22Zm0-11.51c.41 0 .75.34.75.75v5a.75.75 0 0 1-1.5 0v-5c0-.41.34-.75.75-.75ZM12 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$276e9ead41033e1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle28Filled', "28", [
    "M18.17 6.83a3.16 3.16 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.15 3.15 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.54-.5a3.15 3.15 0 0 1-2-2L20.55.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.15 3.15 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5c.47.15.9.41 1.24.76Zm8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM14 2a12 12 0 0 1 3.45.5c-.24.23-.53.4-.84.5l-1.52.5c-.32.1-.6.31-.8.59a1.58 1.58 0 0 0 0 1.85c.2.27.47.48.78.59l1.56.5a2.25 2.25 0 0 1 1 .73c.16.19.28.4.35.64l.5 1.53c.11.32.32.6.59.8a1.64 1.64 0 0 0 1.86 0l.13-.11a1.34 1.34 0 0 0 .85 1.66l.94.3c.13.05.24.12.34.22.1.1.17.22.22.35l.3.92A1.34 1.34 0 0 0 25 15a1.37 1.37 0 0 0 .99-.42A12 12 0 1 1 14 2Zm0 9.5a.75.75 0 0 0-.75.75v7a.75.75 0 0 0 1.5 0v-7a.75.75 0 0 0-.75-.75Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$c3b7847c00ce29ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle28Regular', "28", [
    "M18.17 6.83a3.16 3.16 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.15 3.15 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.54-.5a3.15 3.15 0 0 1-2-2L20.55.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.15 3.15 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5c.47.15.9.41 1.24.76Zm8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM14 2a12 12 0 0 1 3.45.5c-.24.23-.53.4-.84.5l-1.52.5-.12.04a10.5 10.5 0 1 0 9.5 11.35 1.37 1.37 0 0 0 1.52-.31A12 12 0 1 1 14 2Zm0 9.5c.41 0 .75.34.75.75v7a.75.75 0 0 1-1.5 0v-7c0-.41.34-.75.75-.75Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $7972e53b1de568ed$export$c69e0fcbfbdabc35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle32Filled', "32", [
    "M21.49 7.51a3.49 3.49 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.47 3.47 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.47 3.47 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.47 3.47 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55c.51.17.98.46 1.36.84Zm9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM16 2a14 14 0 0 1 4.14.62c-.15.11-.32.2-.5.26L18 3.44a2.17 2.17 0 0 0-1.5 2.06 2.17 2.17 0 0 0 1.45 2l1.71.56c.29.1.55.25.77.47 0 .04.04.07.08.11l.08.08c.14.17.24.37.31.58l.55 1.7a2.16 2.16 0 0 0 3.3 1.08 1.9 1.9 0 0 0-.25.9 1.84 1.84 0 0 0 1.24 1.75l1 .3.14.11c.04.04.08.1.09.15l.3.91a2 2 0 0 0 .69.94 1.89 1.89 0 0 0 1.99.1A14 14 0 1 1 16 2Zm0 11a1 1 0 0 0-1 1v9a1 1 0 1 0 2 0v-9a1 1 0 0 0-1-1Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
]);
const $7972e53b1de568ed$export$85f5207e1f9549e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle32Regular', "32", [
    "M21.49 7.51a3.49 3.49 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.47 3.47 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.47 3.47 0 0 1-2.2-2.2L24.1.45a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.47 3.47 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55c.51.17.98.46 1.36.84Zm9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM16 2a14 14 0 0 1 4.14.62c-.15.11-.32.2-.5.26L18 3.44c-.36.12-.68.33-.94.6-.35-.02-.7-.04-1.06-.04a12 12 0 1 0 11.95 13.13l.01.01a1.89 1.89 0 0 0 1.99.1A14 14 0 1 1 16 2Zm0 11a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
]);
const $7972e53b1de568ed$export$1a41eb167badf834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle48Filled', "48", [
    "M32.83 12.11a5.36 5.36 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.36 5.36 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.36 5.36 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.36 5.36 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5.35 5.35 0 0 0-.85-1.6Zm14.78 6.87-1.38-.44a2.84 2.84 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.84 2.84 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45c.15.05.3.11.44.18v.02a2.84 2.84 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01a.5.5 0 0 0 .02-.04l.45-1.38a2.84 2.84 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03ZM29.64 4.82h.02A20 20 0 1 0 43.9 25.96a2.55 2.55 0 0 1-1.9-.43 2.54 2.54 0 0 1-.89-1.35l-.44-1.37a.86.86 0 0 0-.4-.48l-.12-.06-1.42-.46a2.55 2.55 0 0 1-1.7-2.4c0-.34.08-.69.22-1a3 3 0 0 1-4.59-1.51l-.84-2.59a3.24 3.24 0 0 0-2.17-2.11L27 11.35a3 3 0 0 1-1.44-4.58c.37-.52.9-.91 1.51-1.12l2.57-.83ZM24 20c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25Zm0-3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
]);
const $7972e53b1de568ed$export$7e5bc54f0ff205b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InfoSparkle48Regular', "48", [
    "M32.83 12.11a5.36 5.36 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.36 5.36 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.36 5.36 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.36 5.36 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5.35 5.35 0 0 0-.85-1.6Zm14.78 6.87-1.38-.44a2.84 2.84 0 0 1-1.8-1.8L44 15.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.84 2.84 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45c.15.05.3.11.44.18v.02a2.84 2.84 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01a.5.5 0 0 0 .02-.04l.45-1.38a2.84 2.84 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03ZM24 4a20 20 0 0 1 5.66.81l-.02.01-2.57.83c-.53.18-1 .5-1.36.93a17.5 17.5 0 1 0 15.77 18.4c.14.21.32.4.52.56a2.55 2.55 0 0 0 1.9.43A20 20 0 1 1 24 4Zm0 16c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 1 1-2.5 0v-12.5c0-.69.56-1.25 1.25-1.25Zm0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $7972e53b1de568ed$export$7b729b0e7343614c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line20Filled', "20", [
    "M17.78 2.22c.3.3.3.77 0 1.06l-14.5 14.5a.75.75 0 0 1-1.06-1.06l14.5-14.5c.3-.3.77-.3 1.06 0Z"
]);
const $7972e53b1de568ed$export$934d180254a51d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line20Regular', "20", [
    "M17.85 2.15c.2.2.2.51 0 .7l-15 15a.5.5 0 0 1-.7-.7l15-15c.2-.2.5-.2.7 0Z"
]);
const $7972e53b1de568ed$export$48c493393fbebb6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line24Filled', "24", [
    "M21.7 2.3a1 1 0 0 1 0 1.4l-18 18a1 1 0 0 1-1.4-1.4l18-18a1 1 0 0 1 1.4 0Z"
]);
const $7972e53b1de568ed$export$817d3350af5a5d67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line24Regular', "24", [
    "M21.78 2.22c.3.3.3.77 0 1.06l-18.5 18.5a.75.75 0 1 1-1.06-1.06l18.5-18.5c.3-.3.77-.3 1.06 0Z"
]);
const $7972e53b1de568ed$export$55108d36cbb578cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line32Filled', "32", [
    "M28.63 3.37c.5.48.5 1.28 0 1.76l-23.5 23.5a1.25 1.25 0 0 1-1.76-1.76l23.5-23.5a1.25 1.25 0 0 1 1.76 0Z"
]);
const $7972e53b1de568ed$export$4696827e857d7514 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line32Regular', "32", [
    "M28.7 3.3a1 1 0 0 1 0 1.4l-24 24a1 1 0 0 1-1.4-1.4l24-24a1 1 0 0 1 1.4 0Z"
]);
const $7972e53b1de568ed$export$7dd994fe2a5e27e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line48Filled', "48", [
    "M43.56 4.44a1.5 1.5 0 0 1 0 2.12l-37 37a1.5 1.5 0 0 1-2.12-2.12l37-37a1.5 1.5 0 0 1 2.12 0Z"
]);
const $7972e53b1de568ed$export$fb78822440a412ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Line48Regular', "48", [
    "M43.63 4.37c.5.48.5 1.28 0 1.76l-37.5 37.5a1.25 1.25 0 0 1-1.76-1.76l37.5-37.5a1.25 1.25 0 0 1 1.76 0Z"
]);
const $7972e53b1de568ed$export$cff7fcbe83f9f34a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes20Filled', "20", [
    "M16.78 4.28a.75.75 0 0 0-1.06-1.06l-.5.5a.75.75 0 0 0 1.06 1.06l.5-.5Zm-3 1.94c.3.3.3.77 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0Zm-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 1 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0Zm-3 3c.3.3.3.77 0 1.06l-.5.5a.75.75 0 0 1-1.06-1.06l.5-.5c.3-.3.77-.3 1.06 0Zm-3 4.06a.75.75 0 1 0-1.06-1.06l-.5.5a.75.75 0 1 0 1.06 1.06l.5-.5Z"
]);
const $7972e53b1de568ed$export$a8c558eb2b406886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes20Regular', "20", [
    "M16.85 3.85a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 .7.7l1-1Zm-3 2.3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0Zm-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0Zm-3 3c.2.2.2.5 0 .7l-1 1a.5.5 0 0 1-.7-.7l1-1c.2-.2.5-.2.7 0Zm-3 3.7a.5.5 0 0 0-.7-.7l-1 1a.5.5 0 0 0 .7.7l1-1Z"
]);
const $7972e53b1de568ed$export$997d6ac9cb01979d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes24Filled', "24", [
    "M21.7 2.3a1 1 0 0 1 0 1.41l-.5.5a1 1 0 1 1-1.4-1.41l.5-.5a1 1 0 0 1 1.4 0Zm-4 4a1 1 0 0 1 0 1.41l-1 1a1 1 0 1 1-1.4-1.42l.99-1a1 1 0 0 1 1.41 0Zm-4.5 4.5a1 1 0 0 1 0 1.4l-1 1a1 1 0 0 1-1.4-1.4l1-1a1 1 0 0 1 1.4 0ZM8.7 16.7A1 1 0 1 0 7.3 15.3l-1 1a1 1 0 1 0 1.42 1.4l1-.99Zm-4.49 4.5a1 1 0 0 0-1.41-1.42l-.5.5a1 1 0 0 0 1.41 1.42l.5-.5Z"
]);
const $7972e53b1de568ed$export$2cc11456eeb2aa18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes24Regular', "24", [
    "M21.79 2.22c.29.3.29.77 0 1.06l-1 1a.75.75 0 1 1-1.07-1.06l1-1c.3-.29.77-.29 1.07 0Zm-4.01 4c.29.3.29.77 0 1.06l-1.5 1.5a.75.75 0 0 1-1.06-1.06l1.5-1.5c.29-.29.76-.29 1.06 0Zm-4.5 4.5c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l1.5-1.5c.3-.3.77-.3 1.06 0Zm-4.5 5.56a.75.75 0 0 0-1.06-1.06l-1.5 1.5a.75.75 0 0 0 1.06 1.06l1.5-1.5Zm-4.5 4.5a.75.75 0 1 0-1.06-1.06l-1 1a.75.75 0 1 0 1.06 1.06l1-1Z"
]);
const $7972e53b1de568ed$export$f323d5181c516640 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes32Filled', "32", [
    "M28.63 3.37c.5.48.5 1.28 0 1.76l-.98.98a1.25 1.25 0 1 1-1.76-1.76l.98-.98a1.25 1.25 0 0 1 1.76 0Zm-4.9 4.9c.5.48.5 1.27 0 1.76l-1.95 1.96a1.25 1.25 0 1 1-1.77-1.77l1.96-1.96a1.25 1.25 0 0 1 1.77 0Zm-5.87 5.87c.5.49.5 1.28 0 1.76l-1.96 1.96a1.25 1.25 0 1 1-1.76-1.76l1.96-1.96a1.25 1.25 0 0 1 1.76 0ZM12 20c.49.49.49 1.28 0 1.77l-1.96 1.96a1.25 1.25 0 0 1-1.77-1.77l1.96-1.96a1.25 1.25 0 0 1 1.77 0ZM6.1 25.9c.5.49.5 1.28 0 1.76l-.98.98a1.25 1.25 0 0 1-1.76-1.76l.98-.98a1.25 1.25 0 0 1 1.76 0Z"
]);
const $7972e53b1de568ed$export$1030f38758473d10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes32Regular', "32", [
    "M28.7 3.3a1 1 0 0 1 0 1.4l-1 1a1 1 0 1 1-1.4-1.4l1-1a1 1 0 0 1 1.4 0Zm-5 5a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 0Zm-6 6a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 0Zm-6 6a1 1 0 0 1 0 1.4l-2 2a1 1 0 0 1-1.4-1.4l2-2a1 1 0 0 1 1.4 0Zm-6 6a1 1 0 0 1 0 1.4l-1 1a1 1 0 0 1-1.4-1.4l1-1a1 1 0 0 1 1.4 0Z"
]);
const $7972e53b1de568ed$export$25aa0a4264f7b401 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes48Filled', "48", [
    "M43.56 6.56a1.5 1.5 0 0 0-2.12-2.12l-2 2a1.5 1.5 0 0 0 2.12 2.12l2-2Zm-8 5.88a1.5 1.5 0 0 1 0 2.12l-3 3a1.5 1.5 0 0 1-2.12-2.12l3-3a1.5 1.5 0 0 1 2.12 0Zm-9 11.12a1.5 1.5 0 0 0-2.12-2.12l-3 3a1.5 1.5 0 0 0 2.12 2.12l3-3Zm-9 6.88a1.5 1.5 0 0 1 0 2.12l-3 3a1.5 1.5 0 0 1-2.12-2.12l3-3a1.5 1.5 0 0 1 2.12 0Zm-9 9a1.5 1.5 0 0 1 0 2.12l-2 2a1.5 1.5 0 0 1-2.12-2.12l2-2a1.5 1.5 0 0 1 2.12 0Z"
]);
const $7972e53b1de568ed$export$18f4b3b9c71a7407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineDashes48Regular', "48", [
    "M43.63 6.14a1.25 1.25 0 1 0-1.77-1.77l-2.5 2.5a1.25 1.25 0 0 0 1.77 1.76l2.5-2.5Zm-8 6.23c.5.48.5 1.28 0 1.76l-3.5 3.5a1.25 1.25 0 0 1-1.76-1.76l3.5-3.5a1.25 1.25 0 0 1 1.76 0Zm-9 10.76a1.25 1.25 0 0 0-1.76-1.76l-3.5 3.5a1.25 1.25 0 0 0 1.76 1.76l3.5-3.5Zm-9 7.24c.5.48.5 1.28 0 1.76l-3.5 3.5a1.25 1.25 0 0 1-1.76-1.76l3.5-3.5a1.25 1.25 0 0 1 1.76 0Zm-9 9c.5.48.5 1.28 0 1.76l-2.5 2.5a1.25 1.25 0 0 1-1.76-1.77l2.5-2.5a1.25 1.25 0 0 1 1.76 0Z"
]);
const $7972e53b1de568ed$export$7f470abe81eda80d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight16Filled', "16", [
    "M12.85 3.85a.5.5 0 0 0-.7-.7L5.88 9.4a2.5 2.5 0 1 0 .7.7l6.27-6.26Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$4adc033448c48eed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight16Regular', "16", [
    "M12.85 3.85a.5.5 0 0 0-.7-.7L5.88 9.4a2.5 2.5 0 1 0 .7.7l6.27-6.26ZM3 11.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$76f233f5996438c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight20Filled', "20", [
    "M15.85 4.85a.5.5 0 0 0-.7-.7l-7.41 7.4a3 3 0 1 0 .7.7l7.41-7.4Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$8903dda37df2699f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight20Regular', "20", [
    "M15.85 4.85a.5.5 0 0 0-.7-.7l-7.41 7.4a3 3 0 1 0 .7.7l7.41-7.4ZM4 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$b706997fb905e671 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight24Filled', "24", [
    "M19.78 5.28a.75.75 0 0 0-1.06-1.06l-9.47 9.47a4 4 0 1 0 1.06 1.06l9.47-9.47Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$e687a225424e99a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight24Regular', "24", [
    "M19.78 5.28a.75.75 0 0 0-1.06-1.06l-9.47 9.47a4 4 0 1 0 1.06 1.06l9.47-9.47ZM4.5 17a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$20ff6a2cdc232ca9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight32Filled', "32", [
    "M26.7 6.7a1 1 0 0 0-1.4-1.4L11.61 18.96a5.5 5.5 0 1 0 1.41 1.41L26.71 6.71Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$b63a5eb01ff9f12b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineFlowDiagonalUpRight32Regular', "32", [
    "M26.7 6.7a1 1 0 0 0-1.4-1.4L11.61 18.96a5.5 5.5 0 1 0 1.41 1.41L26.71 6.71ZM5 23.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z"
], {
    flipInRtl: true
});
const $7972e53b1de568ed$export$a1809c19046e8bb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal116Filled', "16", [
    "M2 7.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75Z"
]);
const $7972e53b1de568ed$export$aa7d0f295573ab1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal116Regular', "16", [
    "M2 7.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$20ae25676d2d990e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal120Filled', "20", [
    "M2 9.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75Z"
]);
const $7972e53b1de568ed$export$1751b69ed8d10fd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal120Regular', "20", [
    "M2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$3dbdca8bfeba8133 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal124Filled', "24", [
    "M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z"
]);
const $7972e53b1de568ed$export$5ecadb77040d4abd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal124Regular', "24", [
    "M2 11.75c0-.41.34-.75.75-.75h18.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$8aa5f1e667dac18f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal128Filled', "28", [
    "M2 14a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z"
]);
const $7972e53b1de568ed$export$10dda66b1b1a29e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal128Regular', "28", [
    "M2 13.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$5f77b5b2fe607c59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashDotDash20Filled', "20", [
    "M10 11.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM2.75 9a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Zm12 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
]);
const $7972e53b1de568ed$export$16b9eca4fd995229 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1DashDotDash20Regular', "20", [
    "M10 10.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM2 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm11 0c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$839756025d262635 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes16Filled', "16", [
    "M2 7.75c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 2 7.75Zm4.5 0c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4.5 0c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$a1fd0d02e4be867c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes16Regular', "16", [
    "M2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm4.5 0c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5Zm4.5 0c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$1875b427bd8e9ae8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes20Filled', "20", [
    "M2 9.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 2 9.75Zm6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 9.75Zm6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$6656d070b673f36c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes20Regular', "20", [
    "M2 9.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$36494c08782f121 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes24Filled', "24", [
    "M2 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm7.5 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm7.5 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z"
]);
const $7972e53b1de568ed$export$399807c987a06911 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes24Regular', "24", [
    "M2 11.75c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Zm7.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Zm7.5 0c0-.41.34-.75.75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$a105a655c1c8d446 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes28Filled', "28", [
    "M2 14a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm9 0a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z"
]);
const $7972e53b1de568ed$export$88e3bc65583f145e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dashes28Regular', "28", [
    "M2 13.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm9 0c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm9 0c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$b64c943f9e0f548a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dot20Filled', "20", [
    "M3.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM8 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm4.5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
]);
const $7972e53b1de568ed$export$bacc4707885ef000 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal1Dot20Regular', "20", [
    "M3.25 10.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM18 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
]);
const $7972e53b1de568ed$export$774b926484a255bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid16Filled', "16", [
    "M2.75 5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Zm4.5 0a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Zm4.5 0a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Zm-9 5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$d6503597de79e746 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid16Regular', "16", [
    "M2.5 5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM7 5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H7Zm4.5 0a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Zm-9 5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
]);
const $7972e53b1de568ed$export$16b0f3eb5c928fb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid20Filled', "20", [
    "M2.75 6a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Zm6 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Zm6 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Zm-12 6a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$36378d0880ae1455 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid20Regular', "20", [
    "M2.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm6 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm6 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm-12 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"
]);
const $7972e53b1de568ed$export$9060c649127f8d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid24Filled', "24", [
    "M3 7a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2H3Zm7.5 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3ZM18 7a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3ZM3 15a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"
]);
const $7972e53b1de568ed$export$54d574c856094bc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid24Regular', "24", [
    "M2.75 7a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm-15 8a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$5a1d1a5f7143aa64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid28Filled', "28", [
    "M3 9a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H3Zm9 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm9 0a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4ZM3 17a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H3Z"
]);
const $7972e53b1de568ed$export$d3b41551a72805d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal2DashesSolid28Regular', "28", [
    "M2.75 9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm9 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm9 0a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Zm-18 8a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$513403f818b2bc43 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal316Filled', "16", [
    "M2 3.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75Zm0 4c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75Zm0 4c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$bc2a2779392400df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal316Regular', "16", [
    "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 4c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 4c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$58dba1ca981cde30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal320Filled', "20", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75ZM2.75 14a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$8b4a5498541f8a3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal320Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm.5 4.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"
]);
const $7972e53b1de568ed$export$87bb06d7b0434575 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal324Filled', "24", [
    "M3 17h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2H21 3Zm0-6h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2H21 3Zm0-6h18a1 1 0 0 1 .12 2H3a1 1 0 0 1-.12-2H21 3Z"
]);
const $7972e53b1de568ed$export$85994846335a9990 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal324Regular', "24", [
    "M2.75 18h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5h18.6-18.5Zm0-6.5h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.5h18.6-18.5Zm0-6.5h18.5a.75.75 0 0 1 .1 1.5H2.75a.75.75 0 0 1-.1-1.49h18.6-18.5Z"
]);
const $7972e53b1de568ed$export$34506bf943ac18c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal328Filled', "28", [
    "M2 6a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 16a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1-9a1 1 0 1 0 0 2h22a1 1 0 1 0 0-2H3Z"
]);
const $7972e53b1de568ed$export$be1c91892fc1b7eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal328Regular', "28", [
    "M2 5.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75Zm0 16c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75ZM2.75 13a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$f92806d119397e5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal332Filled', "32", [
    "M2 6.25C2 5.56 2.56 5 3.25 5h25.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 7.5 2 6.94 2 6.25Zm0 10c0-.69.56-1.25 1.25-1.25h25.5a1.25 1.25 0 1 1 0 2.5H3.25c-.69 0-1.25-.56-1.25-1.25ZM3.25 25a1.25 1.25 0 1 0 0 2.5h25.5a1.25 1.25 0 1 0 0-2.5H3.25Z"
]);
const $7972e53b1de568ed$export$dd6373240d8c479b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal332Regular', "32", [
    "M2 6a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 10a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1 9a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2H3Z"
]);
const $7972e53b1de568ed$export$18e30ec78d5b98a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal348Filled', "48", [
    "M4 11.5c0-.83.67-1.5 1.5-1.5h37a1.5 1.5 0 0 1 0 3h-37A1.5 1.5 0 0 1 4 11.5Zm0 13c0-.83.67-1.5 1.5-1.5h37a1.5 1.5 0 0 1 0 3h-37A1.5 1.5 0 0 1 4 24.5ZM5.5 36a1.5 1.5 0 0 0 0 3h37a1.5 1.5 0 0 0 0-3h-37Z"
]);
const $7972e53b1de568ed$export$e217b9a2131067f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal348Regular', "48", [
    "M4 11.25c0-.69.56-1.25 1.25-1.25h37.5a1.25 1.25 0 1 1 0 2.5H5.25c-.69 0-1.25-.56-1.25-1.25Zm0 13c0-.69.56-1.25 1.25-1.25h37.5a1.25 1.25 0 1 1 0 2.5H5.25c-.69 0-1.25-.56-1.25-1.25ZM5.25 36a1.25 1.25 0 1 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5H5.25Z"
]);
const $7972e53b1de568ed$export$72545c0ba3a8e3ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal416Filled', "16", [
    "M2.75 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Zm0 3a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75ZM2 9.75c0-.41.34-.75.75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75ZM2.75 12a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$4cb211faa6a4fcd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal416Regular', "16", [
    "M2.5 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Zm0 3a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11ZM2 9.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
]);
const $7972e53b1de568ed$export$19a7954b149e11ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal420Filled', "20", [
    "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75Zm0 4c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 7.75ZM2.75 11a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75ZM2 15.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$b335eb7ff470eeb9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal420Regular', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Zm0 4h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1ZM2 11.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm.5 3.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"
]);
const $7972e53b1de568ed$export$875b3f217fc5f44b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search16Filled', "16", [
    "M10.5 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 6.6A3.5 3.5 0 1 0 10.5 8Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm3.43 3.06L12.88 9H2.75a.75.75 0 0 0 0 1.5h10.5c.3 0 .57-.18.68-.44ZM7.15 7.5a4.5 4.5 0 0 1-.9-1.5h-3.5a.75.75 0 0 0 0 1.5h4.4ZM6.25 3A4.5 4.5 0 0 0 6 4.5H2.75a.75.75 0 0 1 0-1.5h3.5Zm-3.5 9a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$f960074d03fe4de1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search16Regular', "16", [
    "M10.5 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 6.6A3.5 3.5 0 1 0 10.5 8Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm3.29 2.9-.91-.9H2.5a.5.5 0 0 0 0 1h11c.1 0 .2-.03.29-.1ZM6.76 7c-.2-.3-.38-.64-.5-1H2.5a.5.5 0 0 0 0 1h4.26Zm-.5-4c-.12.32-.2.65-.23 1H2.5a.5.5 0 0 1 0-1h3.76ZM2.5 12a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
]);
const $7972e53b1de568ed$export$15aafaccddcd15f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search20Filled', "20", [
    "M12.5 10c.97 0 1.87-.3 2.6-.83l3.62 3.61a.75.75 0 1 0 1.06-1.06l-3.61-3.61A4.5 4.5 0 1 0 12.5 10Zm0-7.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm3.03 8.5 1.5 1.5H2.75a.75.75 0 0 1 0-1.5h12.78ZM2.75 3H7.6c-.24.47-.41.97-.5 1.5H2.74a.75.75 0 0 1 0-1.5Zm0 4h4.46c.15.54.38 1.04.68 1.5H2.75a.75.75 0 0 1 0-1.5ZM2 15.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
]);
const $7972e53b1de568ed$export$370f8642b7d3d0d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal4Search20Regular', "20", [
    "M12.5 10c1.06 0 2.04-.37 2.8-.98l3.85 3.83a.5.5 0 0 0 .7-.7L16.02 8.3A4.5 4.5 0 1 0 12.5 10Zm0-8a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm.02 9h3.36l1 1H2.5a.5.5 0 0 1 0-1h10.02ZM2.5 3h5.1c-.16.32-.3.65-.4 1H2.5a.5.5 0 0 1 0-1Zm5.1 5c-.16-.32-.3-.65-.4-1H2.5a.5.5 0 0 0 0 1h5.1ZM2 15.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Z"
]);
const $7972e53b1de568ed$export$8fd9514a40a7db8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal520Filled', "20", [
    "M2 3.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75Zm0 6c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75ZM2.75 12a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75ZM2 6.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 6.75ZM2.75 15a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75Z"
]);
const $7972e53b1de568ed$export$ddf3e5775351de38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal520Regular', "20", [
    "M2 3.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 6c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5ZM2.5 6a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15ZM2 12.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"
]);
const $7972e53b1de568ed$export$bfa66526d796c93c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5Error20Filled', "20", [
    "M2.75 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75Zm0 6a.75.75 0 0 0 0 1.5h7.14c.38-.59.87-1.1 1.45-1.5H2.75Zm0 3h6.46c-.14.48-.21.98-.21 1.5H2.75a.75.75 0 0 1 0-1.5Zm0 3h6.46c.15.54.38 1.04.68 1.5H2.75a.75.75 0 0 1 0-1.5Zm0-9a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75ZM19 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24Z"
]);
const $7972e53b1de568ed$export$b5fc716bbf57022 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineHorizontal5Error20Regular', "20", [
    "M2.5 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Zm0 6a.5.5 0 0 0 0 1h7.76c.31-.38.67-.72 1.08-1H2.5Zm0 3h6.7c-.08.32-.15.66-.18 1H2.5a.5.5 0 0 1 0-1Zm0 3h6.7c.1.35.24.68.4 1H2.5a.5.5 0 0 1 0-1Zm0-9a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15ZM19 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24Z"
]);
const $7972e53b1de568ed$export$a11b23076db21503 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle20Filled', "20", [
    "M2 4.75c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 2 4.75Zm6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 8 4.75Zm6 0c0-.41.34-.75.75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm-12 5c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75ZM3.25 14a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5H3.25Z"
]);
const $7972e53b1de568ed$export$4844189aca972e9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm6 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-12 5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5ZM3 14a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H3Z"
]);
const $7972e53b1de568ed$export$b68bad75a4792260 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle24Filled', "24", [
    "M3 5a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2H3Zm7.5 0a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3ZM18 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3ZM2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm1.5 5a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3h-17Z"
]);
const $7972e53b1de568ed$export$4234409d0e156bf0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyle24Regular', "24", [
    "M2.75 5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm7.5 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm3.5 6.5H2.75l-.1.01a.75.75 0 0 0 .1 1.5h18.5l.1-.01a.75.75 0 0 0-.1-1.5Zm-18 5.5a1.25 1.25 0 0 0 0 2.5h17.5a1.25 1.25 0 1 0 0-2.5H3.25Z"
]);
const $7972e53b1de568ed$export$af1412774b2c7c6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch16Filled', "16", [
    "M1 3.75c0-.41.34-.75.75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.75Zm6.65 4.7c.6.25 1.31.55 2.32.55.89 0 1.57-.23 2.11-.42l.22-.08c.58-.19 1.08-.31 1.82-.18a.75.75 0 0 0 .26-1.47 4.79 4.79 0 0 0-2.8.31c-.54.19-.99.34-1.6.34-.7 0-1.18-.2-1.77-.44l-.02-.01c-.6-.25-1.32-.55-2.33-.55a5.6 5.6 0 0 0-2.32.55h-.02a4.2 4.2 0 0 1-1.77.45.75.75 0 0 0 0 1.5c1.01 0 1.73-.3 2.32-.55h.03A4.2 4.2 0 0 1 5.86 8c.7 0 1.18.2 1.77.44l.02.01Zm-5.33 4.8a.75.75 0 0 1-1.14-1 2.25 2.25 0 0 1 .21-.2c.12-.12.3-.27.51-.42.43-.3 1.09-.63 1.88-.63.4 0 .74.09 1.03.27.25.15.43.35.53.47l.02.02c.11.13.15.17.2.2.01 0 .07.04.24.04.36 0 .63-.14 1.07-.4l.04-.02c.42-.24 1-.58 1.78-.58.8 0 1.36.35 1.75.6l.04.01c.41.26.65.39 1 .39.4 0 .97-.19 1.5-.43a9.31 9.31 0 0 0 .87-.46.75.75 0 0 1 .8 1.28 5.38 5.38 0 0 1-.3.17c-.2.1-.45.24-.74.37-.57.26-1.39.57-2.14.57a3.2 3.2 0 0 1-1.75-.6l-.03-.01c-.41-.26-.65-.39-1-.39s-.62.14-1.07.4l-.03.02c-.42.24-1 .58-1.79.58-.4 0-.74-.09-1.03-.27-.25-.15-.43-.35-.53-.47l-.02-.02a.95.95 0 0 0-.2-.2c-.01 0-.07-.04-.24-.04-.37 0-.73.16-1.02.37a2.9 2.9 0 0 0-.44.37Z"
]);
const $7972e53b1de568ed$export$ea648934e327ac1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch16Regular', "16", [
    "M1 3.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Zm6.74 4.47c.62.25 1.32.53 2.31.53a6.3 6.3 0 0 0 2.1-.4l.23-.08c.62-.2 1.2-.34 2.03-.2a.5.5 0 1 0 .18-.98 4.86 4.86 0 0 0-2.76.3c-.57.2-1.08.36-1.78.36a4.8 4.8 0 0 1-1.95-.46l-.01-.01c-.63-.25-1.32-.53-2.31-.53-1 0-1.7.28-2.31.53h-.02a4.8 4.8 0 0 1-1.95.47.5.5 0 0 0 0 1c1 0 1.69-.28 2.31-.53h.01a4.8 4.8 0 0 1 1.96-.47c.79 0 1.33.22 1.95.46l.01.01Zm-6.58 4.9c.2.19.53.17.71-.03L2 12.7c.08-.08.22-.19.38-.3.33-.21.76-.41 1.23-.41.22 0 .34.05.41.09.09.05.15.11.27.25h.01c.11.13.27.3.5.44.24.14.54.22.92.22.73 0 1.28-.3 1.71-.55l.03-.01c.46-.26.8-.44 1.26-.44.45 0 .77.18 1.2.43l.02.01c.4.25.93.56 1.67.56.71 0 1.52-.29 2.1-.54a11.14 11.14 0 0 0 1.04-.53.5.5 0 0 0-.5-.86 5.29 5.29 0 0 1-.27.14c-.16.1-.4.21-.67.33-.57.25-1.2.46-1.7.46-.45 0-.76-.18-1.19-.43l-.02-.01c-.41-.25-.94-.56-1.68-.56-.73 0-1.28.3-1.72.55l-.02.01c-.46.26-.8.44-1.26.44a.78.78 0 0 1-.42-.09 1.18 1.18 0 0 1-.27-.25c-.12-.13-.27-.3-.5-.44A1.77 1.77 0 0 0 3.6 11c-.74 0-1.36.3-1.78.58a4.28 4.28 0 0 0-.7.58.5.5 0 0 0 .03.71Z"
]);
const $7972e53b1de568ed$export$4ec364e701e77c13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch20Filled', "20", [
    "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm2.9 4.29c.7-.25 1.49-.54 2.62-.54 1.13 0 1.92.29 2.62.54h.02c.68.25 1.27.46 2.13.46.76 0 1.3-.16 1.94-.35l.28-.08a6.14 6.14 0 0 1 2.86-.23.75.75 0 1 1-.24 1.48 4.66 4.66 0 0 0-2.46.27c-.64.19-1.4.41-2.38.41-1.13 0-1.93-.29-2.62-.54h-.02A5.73 5.73 0 0 0 7.52 10c-.86 0-1.45.2-2.13.46h-.02c-.7.25-1.49.54-2.62.54a.75.75 0 0 1 0-1.5c.86 0 1.44-.2 2.13-.46h.02ZM17.9 14.4a.75.75 0 0 0-1.01-.31 5.14 5.14 0 0 1-.29.14c-.18.09-.44.2-.74.32-.62.25-1.32.45-1.84.45a2.5 2.5 0 0 1-1.26-.41l-.03-.02a3.9 3.9 0 0 0-1.93-.57c-.85 0-1.5.32-1.98.56l-.03.02c-.52.25-.87.42-1.35.42a.83.83 0 0 1-.4-.07 1.1 1.1 0 0 1-.24-.21l-.02-.02c-.12-.12-.32-.31-.6-.46A2.3 2.3 0 0 0 5.1 14c-.85 0-1.58.32-2.06.6a4.94 4.94 0 0 0-.81.61.75.75 0 0 0 1.05 1.08l.12-.11c.1-.08.23-.18.4-.29.36-.2.81-.39 1.3-.39.24 0 .35.04.4.07.06.03.12.08.25.21l.01.02c.12.12.32.31.6.46.3.16.66.24 1.1.24.84 0 1.48-.32 1.97-.56l.03-.02c.51-.25.87-.42 1.35-.42.46 0 .78.16 1.25.41l.03.02a3.9 3.9 0 0 0 1.94.57c.82 0 1.73-.3 2.39-.55a13.26 13.26 0 0 0 1.18-.54c.37-.2.5-.65.31-1.01Z"
]);
const $7972e53b1de568ed$export$300c2b0050e23ca8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm7.75 5.48c.72.25 1.5.52 2.62.52a8.1 8.1 0 0 0 2.64-.48c.72-.2 1.41-.34 2.42-.2a.5.5 0 0 0 .14-.98c-1.2-.18-2.04 0-2.82.22l-.29.08a7.1 7.1 0 0 1-2.1.36c-.94 0-1.58-.22-2.3-.47a7.33 7.33 0 0 0-2.63-.53c-1.12 0-1.9.27-2.62.52-.72.26-1.37.48-2.31.48a.5.5 0 0 0 0 1c1.12 0 1.9-.27 2.62-.52h.01a6.39 6.39 0 0 1 2.3-.48c.95 0 1.6.22 2.3.47h.02Zm8.2 4.3a.5.5 0 0 0-.68-.22 6.17 6.17 0 0 1-.3.14c-.2.1-.48.21-.8.33-.64.25-1.4.47-2 .47-.56 0-.95-.2-1.44-.44l-.02-.02a3.86 3.86 0 0 0-1.88-.54c-.8 0-1.41.3-1.92.54h-.03c-.52.26-.95.46-1.52.46-.28 0-.44-.05-.54-.1-.1-.06-.2-.13-.33-.26v-.01c-.13-.12-.3-.3-.56-.42a2.15 2.15 0 0 0-1-.21c-.81 0-1.5.3-1.98.57a4.85 4.85 0 0 0-.8.57.5.5 0 1 0 .73.7 2.83 2.83 0 0 1 .56-.4c.4-.23.92-.44 1.5-.44.28 0 .43.05.54.1.1.06.19.13.32.26l.01.01c.13.12.3.3.56.42.27.14.58.21 1 .21.8 0 1.41-.3 1.92-.54h.03c.52-.26.95-.46 1.51-.46s.95.2 1.44.44l.02.02c.48.24 1.06.54 1.88.54.79 0 1.7-.28 2.36-.53a13.67 13.67 0 0 0 1.2-.52.5.5 0 0 0 .21-.68Z"
]);
const $7972e53b1de568ed$export$fe0ee0ffb2ec37cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch24Filled', "24", [
    "M3 4a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm2.6 6.82A7.77 7.77 0 0 1 8.91 10c1.45 0 2.47.45 3.33.82l.03.01a5.9 5.9 0 0 0 2.56.67c.9 0 1.55-.23 2.34-.51l.35-.12a6.6 6.6 0 0 1 3.66-.35 1 1 0 1 1-.38 1.96 4.63 4.63 0 0 0-2.63.28l-.31.1c-.8.3-1.76.64-3.03.64a7.77 7.77 0 0 1-3.33-.82l-.03-.01A5.9 5.9 0 0 0 8.92 12c-1.01 0-1.7.3-2.56.67l-.03.01c-.86.37-1.88.82-3.33.82a1 1 0 1 1 0-2c1.01 0 1.7-.3 2.56-.67l.03-.01Zm14.86 6.34a1 1 0 1 1 1.08 1.68 8.08 8.08 0 0 1-.43.26c-.26.15-.63.35-1.06.55-.8.39-1.98.85-3.05.85-1.13 0-1.93-.51-2.5-.88l-.04-.03c-.6-.38-.95-.59-1.46-.59-.52 0-.92.22-1.57.6l-.05.04c-.6.36-1.43.86-2.54.86a2.65 2.65 0 0 1-2.2-1.08l-.03-.03c-.17-.2-.23-.27-.3-.31-.04-.03-.14-.08-.4-.08-.53 0-1.05.25-1.5.56a4.33 4.33 0 0 0-.65.58 1 1 0 0 1-1.53-1.28l.03-.03a3.9 3.9 0 0 1 .26-.28c.17-.17.42-.39.73-.61.6-.44 1.54-.94 2.67-.94a2.65 2.65 0 0 1 2.2 1.08l.03.03c.16.2.23.27.3.31.04.03.13.08.39.08.52 0 .92-.22 1.56-.6l.06-.04c.6-.36 1.43-.86 2.54-.86 1.13 0 1.93.51 2.5.88l.04.03c.6.38.95.59 1.46.59.6 0 1.42-.29 2.2-.65a13.3 13.3 0 0 0 1.26-.7Z"
]);
const $7972e53b1de568ed$export$a107488d8362ced8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch24Regular', "24", [
    "M2.75 4a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75Zm2.77 6.8c.89-.37 1.89-.8 3.31-.8 1.43 0 2.43.43 3.32.8l.02.01c.88.37 1.64.69 2.75.69.98 0 1.7-.25 2.5-.53l.36-.12a6.66 6.66 0 0 1 3.6-.34.75.75 0 1 1-.27 1.48 5.18 5.18 0 0 0-2.85.28l-.33.12c-.81.28-1.77.61-3.01.61-1.43 0-2.43-.43-3.31-.8l-.03-.01a6.48 6.48 0 0 0-2.75-.69c-1.1 0-1.87.32-2.74.69l-.03.01c-.88.37-1.88.8-3.31.8a.75.75 0 0 1 0-1.5c1.11 0 1.87-.32 2.75-.69l.02-.01Zm16.37 6.55a.75.75 0 0 0-1.04-.24 6.12 6.12 0 0 1-.37.22c-.24.13-.57.31-.96.49-.8.37-1.71.68-2.38.68-.62 0-1.05-.25-1.66-.64l-.04-.02a4.36 4.36 0 0 0-2.41-.84c-1.06 0-1.86.46-2.48.83l-.04.02c-.66.39-1.13.65-1.76.65a1 1 0 0 1-.56-.12 1.7 1.7 0 0 1-.37-.37L7.8 18c-.15-.18-.38-.44-.7-.64-.37-.23-.8-.35-1.35-.35-1.07 0-1.97.47-2.57.89a6.2 6.2 0 0 0-1 .87.75.75 0 0 0 1.14.98 2.16 2.16 0 0 1 .18-.18c.12-.12.3-.28.54-.45a3.07 3.07 0 0 1 1.71-.61 1 1 0 0 1 .56.12c.11.07.2.17.37.37l.02.02c.15.18.38.44.7.64.37.23.8.35 1.35.35 1.06 0 1.86-.46 2.47-.83l.05-.02c.65-.39 1.13-.65 1.76-.65.61 0 1.05.25 1.66.64l.03.02c.59.37 1.35.84 2.42.84 1.03 0 2.18-.44 3.01-.82a15.54 15.54 0 0 0 1.5-.8.75.75 0 0 0 .24-1.03Z"
]);
const $7972e53b1de568ed$export$3257e483dc35bf5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch28Filled', "28", [
    "M2 6a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm11.46 7.92A8.74 8.74 0 0 0 17.47 15c1.52 0 2.69-.46 3.65-.83l.39-.15a5.35 5.35 0 0 1 3.29-.37 1 1 0 0 0 .4-1.96 7.32 7.32 0 0 0-4.4.46l-.42.16c-.97.37-1.78.69-2.9.69-1.28 0-2.15-.4-3.2-.9l-.03-.02A8.74 8.74 0 0 0 10.24 11c-1.75 0-2.97.58-4.02 1.08l-.03.02c-1.05.5-1.92.9-3.19.9a1 1 0 1 0 0 2c1.74 0 2.97-.58 4.01-1.08l.04-.02c1.05-.5 1.92-.9 3.19-.9s2.14.4 3.18.9l.04.02ZM2.39 22.79a1 1 0 0 0 1.45-.23 4.6 4.6 0 0 1 .8-.77A3.25 3.25 0 0 1 6.57 21c.33 0 .47.07.56.13.12.09.22.21.43.48l.02.03c.18.23.45.6.86.87.45.31 1 .49 1.7.49 1.32 0 2.3-.65 3.02-1.12l.07-.04c.79-.52 1.31-.84 2-.84.66 0 1.13.3 1.86.82l.06.04A5 5 0 0 0 20.1 23c1.28 0 2.69-.6 3.67-1.11a17.98 17.98 0 0 0 1.8-1.07 1 1 0 0 0-1.15-1.64 6.55 6.55 0 0 1-.44.29c-.28.17-.68.4-1.13.64-.95.5-1.99.89-2.75.89-.66 0-1.13-.3-1.87-.82l-.06-.04A5 5 0 0 0 15.22 19a5.4 5.4 0 0 0-3.03 1.12l-.06.04c-.8.52-1.32.84-2 .84-.32 0-.47-.07-.56-.13a2.1 2.1 0 0 1-.42-.48l-.03-.03c-.18-.23-.45-.6-.85-.87a2.9 2.9 0 0 0-1.7-.49c-1.34 0-2.45.65-3.17 1.21a7.7 7.7 0 0 0-1.2 1.18 1 1 0 0 0 .2 1.4Z"
]);
const $7972e53b1de568ed$export$4705987cef792ac3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch28Regular', "28", [
    "M2 5.75c0-.41.34-.75.75-.75h22.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 5.75Zm11.56 8.2A8.83 8.83 0 0 0 17.55 15c1.5 0 2.64-.44 3.63-.81l.4-.15a5.87 5.87 0 0 1 3.52-.39.75.75 0 1 0 .3-1.47 7.35 7.35 0 0 0-4.34.45l-.43.16c-.99.38-1.87.71-3.08.71a7.43 7.43 0 0 1-3.38-.93l-.03-.01c-1.07-.5-2.27-1.06-3.99-1.06-1.72 0-2.92.56-3.99 1.06l-.03.01c-1.07.5-2.01.93-3.38.93a.75.75 0 0 0 0 1.5c1.72 0 2.92-.56 3.99-1.06l.03-.01a7.43 7.43 0 0 1 3.38-.93c1.37 0 2.31.43 3.38.93l.03.01ZM2.3 22.84c.32.25.8.19 1.05-.14a2.78 2.78 0 0 1 .23-.25c.16-.17.4-.4.68-.62.6-.45 1.34-.84 2.15-.84.39 0 .6.09.73.18.17.11.3.27.5.53l.02.03c.19.23.44.56.82.82.42.28.92.44 1.58.44 1.26 0 2.2-.6 2.95-1.09l.05-.03c.8-.51 1.4-.88 2.2-.88.78 0 1.33.36 2.08.87l.04.03c.7.48 1.6 1.1 2.88 1.1 1.23 0 2.62-.57 3.62-1.08a18.25 18.25 0 0 0 1.8-1.05.75.75 0 0 0-.84-1.24 7.4 7.4 0 0 1-.46.3c-.3.17-.7.41-1.18.65-.97.5-2.09.92-2.94.92-.78 0-1.33-.36-2.08-.87l-.04-.03c-.7-.48-1.6-1.1-2.88-1.1-1.26 0-2.2.6-2.96 1.09l-.05.03c-.8.51-1.4.88-2.2.88-.38 0-.59-.09-.73-.18-.16-.11-.3-.27-.5-.53l-.02-.03a2.72 2.72 0 0 0-2.4-1.26c-1.27 0-2.34.6-3.05 1.16a7.54 7.54 0 0 0-1.18 1.13c-.26.32-.2.8.13 1.05Z"
]);
const $7972e53b1de568ed$export$2b86a724a5309e6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch32Filled', "32", [
    "M2 7.25C2 6.56 2.56 6 3.25 6h25.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 8.5 2 7.94 2 7.25Zm13.3 9.39c1.22.62 2.66 1.36 4.72 1.36 1.8 0 3.19-.58 4.3-1.05l.45-.19c1.18-.48 2.2-.8 3.7-.46a1.25 1.25 0 0 0 .55-2.44 8.09 8.09 0 0 0-5.2.59l-.49.2a8.03 8.03 0 0 1-3.3.85c-1.43 0-2.41-.49-3.63-1.11l-.05-.03c-1.2-.62-2.65-1.36-4.71-1.36s-3.51.74-4.72 1.36l-.05.03c-1.22.62-2.2 1.11-3.62 1.11a1.25 1.25 0 1 0 0 2.5c2.06 0 3.5-.74 4.72-1.36L8 16.6c1.22-.62 2.2-1.11 3.63-1.11 1.42 0 2.4.49 3.62 1.11l.05.03ZM2.24 25.03a1.25 1.25 0 0 0 2.04 1.45l.05-.07a5.73 5.73 0 0 1 .92-.96 3.5 3.5 0 0 1 2.15-.95c.34 0 .48.08.56.14.13.1.24.24.48.58l.03.04c.2.3.53.75 1 1.1.55.4 1.22.64 2.06.64 1.58 0 2.75-.83 3.59-1.42l.08-.06c.93-.66 1.5-1.02 2.23-1.02.7 0 1.21.34 2.08 1l.07.05c.79.6 1.9 1.45 3.51 1.45 1.53 0 3.2-.77 4.33-1.4a20.63 20.63 0 0 0 2.1-1.35 1.25 1.25 0 0 0-1.51-2 10.75 10.75 0 0 1-.5.36c-.33.21-.78.5-1.3.8-1.11.61-2.28 1.09-3.12 1.09-.7 0-1.21-.34-2.08-1l-.07-.05A5.68 5.68 0 0 0 17.42 22c-1.59 0-2.76.83-3.59 1.42l-.08.06c-.93.66-1.5 1.02-2.23 1.02-.34 0-.48-.08-.56-.14-.13-.1-.25-.24-.49-.58l-.03-.04c-.2-.3-.52-.75-1-1.1A3.33 3.33 0 0 0 7.4 22c-1.62 0-2.94.84-3.77 1.55a9.27 9.27 0 0 0-1.35 1.43l-.04.04Z"
]);
const $7972e53b1de568ed$export$1006995812a0c7af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineStyleSketch32Regular', "32", [
    "M29 8H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h26a1 1 0 0 1 1 1 1 1 0 0 1-1 1Zm-8.9 9.5a9.86 9.86 0 0 1-4.72-1.36l-.02-.01c-1.21-.6-2.26-1.13-3.8-1.13-1.56 0-2.6.52-3.81 1.13l-.02.01A9.82 9.82 0 0 1 3 17.5a1 1 0 0 1 0-2c1.55 0 2.6-.53 3.83-1.14A9.82 9.82 0 0 1 11.55 13c2.03 0 3.46.72 4.73 1.36l.02.01c1.21.6 2.26 1.13 3.8 1.13a8.6 8.6 0 0 0 3.45-.86l.06-.02c1.48-.61 3.16-1.3 5.6-.77a1 1 0 1 1-.42 1.95c-1.84-.4-3.04.09-4.43.66h-.02c-1.16.49-2.49 1.03-4.24 1.03v.01Zm-.35 7.53c.9.68 1.95 1.45 3.47 1.45v.02c2.66 0 6-2.41 6.37-2.7a1 1 0 0 0 .21-1.4 1 1 0 0 0-1.4-.2c-.86.64-3.48 2.3-5.18 2.3-.86 0-1.52-.49-2.27-1.04l-.01-.01c-.91-.68-1.96-1.45-3.48-1.45-1.51 0-2.6.75-3.56 1.41l-.02.02-.02.01c-.82.56-1.54 1.05-2.42 1.05-.68 0-.87-.25-1.27-.79l-.03-.04C9.66 23 8.94 22 7.22 22c-2.85 0-4.89 2.72-5.02 2.9a.98.98 0 0 0 .21 1.4c.45.31 1.08.21 1.4-.23l.02-.01c.15-.2 1.62-2.07 3.4-2.07.67 0 .86.25 1.26.79l.03.04c.48.66 1.21 1.66 2.92 1.66 1.51 0 2.6-.75 3.56-1.41l.02-.02c.83-.57 1.57-1.06 2.44-1.06.87 0 1.53.47 2.29 1.04Z"
]);
const $7972e53b1de568ed$export$7fedf7e85e8feb9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness20Filled', "20", [
    "M2.75 4a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75ZM2 9.25C2 8.56 2.56 8 3.25 8h13.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 10.5 2 9.94 2 9.25Zm0 5.5c0-.97.78-1.75 1.75-1.75h12.5a1.75 1.75 0 1 1 0 3.5H3.75c-.97 0-1.75-.78-1.75-1.75Z"
]);
const $7972e53b1de568ed$export$19db97b4eabd1ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness20Regular', "20", [
    "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm0 10c0-.83.67-1.5 1.5-1.5h13a1.5 1.5 0 0 1 0 3h-13A1.5 1.5 0 0 1 2 14.5ZM3 8a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2H3Z"
]);
const $7972e53b1de568ed$export$5992ccaf41073ea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness24Filled', "24", [
    "M3 3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3Zm-1 7.5C2 9.67 2.67 9 3.5 9h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 10.5ZM2 18c0-1.1.9-2 2-2h16a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Z"
]);
const $7972e53b1de568ed$export$1c2e65b07475c070 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LineThickness24Regular', "24", [
    "M2.75 3.5a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5H2.75ZM2 10.75c0-.69.56-1.25 1.25-1.25h17.5a1.25 1.25 0 1 1 0 2.5H3.25C2.56 12 2 11.44 2 10.75Zm0 7.5c0-.97.78-1.75 1.75-1.75h16.5a1.75 1.75 0 1 1 0 3.5H3.75C2.78 20 2 19.22 2 18.25Z"
]);
const $7972e53b1de568ed$export$c00293a2c85493b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link12Filled', "12", [
    "M1.5 5.2c0-1.5 1.2-2.7 2.7-2.7h.05a.75.75 0 0 1 0 1.5H4.2C3.54 4 3 4.54 3 5.2v.6C3 6.46 3.54 7 4.2 7h.05a.75.75 0 0 1 0 1.5H4.2a2.7 2.7 0 0 1-2.7-2.7v-.6Zm9 0c0-1.5-1.2-2.7-2.7-2.7h-.05a.75.75 0 0 0 0 1.5h.05C8.46 4 9 4.54 9 5.2v.6C9 6.46 8.46 7 7.8 7h-.05a.75.75 0 0 0 0 1.5h.05c1.5 0 2.7-1.2 2.7-2.7v-.6Zm-5.75-.45a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
]);
const $7972e53b1de568ed$export$7f23d7ac1501b48d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link12Regular', "12", [
    "M2 5.4A2.4 2.4 0 0 1 4.4 3h.1a.5.5 0 0 1 0 1h-.1C3.63 4 3 4.63 3 5.4v.2C3 6.37 3.63 7 4.4 7h.1a.5.5 0 0 1 0 1h-.1A2.4 2.4 0 0 1 2 5.6v-.2Zm8 0A2.4 2.4 0 0 0 7.6 3h-.1a.5.5 0 0 0 0 1h.1C8.37 4 9 4.63 9 5.4v.2C9 6.37 8.37 7 7.6 7h-.1a.5.5 0 0 0 0 1h.1A2.4 2.4 0 0 0 10 5.6v-.2ZM4.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
]);
const $7972e53b1de568ed$export$8046b841ac4c016f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link16Filled', "16", [
    "M9.75 4h.52a3.74 3.74 0 0 1 .2 7.5h-.71a.75.75 0 0 1-.12-1.49h.1l.53-.01c1.23 0 2.23-1 2.23-2.25 0-1.2-.92-2.17-2.08-2.24l-.15-.01h-.52a.75.75 0 0 1-.1-1.5h.62-.52Zm-4 0h.5a.75.75 0 0 1 .1 1.5h-.6A2.25 2.25 0 0 0 5.6 10h.65a.75.75 0 0 1 .1 1.5h-.6a3.75 3.75 0 0 1-.2-7.5h.7-.5Zm0 3h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6-4.5Z"
]);
const $7972e53b1de568ed$export$88722466d3a220e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link16Regular', "16", [
    "M9.5 4h1a3.5 3.5 0 0 1 .2 7H9.5a.5.5 0 0 1-.1-.99h.1l1-.01a2.5 2.5 0 0 0 .16-5H9.5a.5.5 0 0 1-.09-1h1.09-1Zm-4 0h1a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.5a.5.5 0 0 1 .09 1H5.5a3.5 3.5 0 0 1-.2-7h1.2-1Zm0 3h5a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h.09Z"
]);
const $7972e53b1de568ed$export$9c96fa1ea6f6c59b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link20Color', "20", `<path d="M14 6a4 4 0 0 1 .2 8H12a.75.75 0 0 1-.1-1.5H14a2.5 2.5 0 0 0 .16-5H12a.75.75 0 0 1-.1-1.5H14ZM8 6a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8ZM6.25 9.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h7.6-7.5Z" fill="url(#ic_fluent_link_20_color__a)"/><defs><linearGradient id="ic_fluent_link_20_color__a" x1="-3.14" y1="2.5" x2="3.2" y2="21.58" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$ef737b7be8ff51b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link20Filled', "20", [
    "M14 6a4 4 0 0 1 .2 8H12a.75.75 0 0 1-.1-1.5H14a2.5 2.5 0 0 0 .16-5H12a.75.75 0 0 1-.1-1.5H14ZM8 6a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8ZM6.25 9.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h7.6-7.5Z"
]);
const $7972e53b1de568ed$export$44f98338b7f512bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link20Regular', "20", [
    "M8 6a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8Zm6 0a4 4 0 0 1 .22 8H12a.5.5 0 0 1-.09-1H14a3 3 0 0 0 .2-6H12a.5.5 0 0 1-.09-1H14ZM6 9.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1H14 6Z"
]);
const $7972e53b1de568ed$export$4819af48490fccbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link24Color', "24", `<path d="M9 7a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9Zm8 0a5 5 0 0 1 .22 10H15a1 1 0 0 1-.12-2H17a3 3 0 0 0 .18-6H15a1 1 0 0 1-.12-2H17ZM7 11h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2H17 7Z" fill="url(#ic_fluent_link_24_color__a)"/><defs><linearGradient id="ic_fluent_link_24_color__a" x1="-4.43" y1="2.63" x2="3.5" y2="26.48" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$6ad003eb7d87e60f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link24Filled', "24", [
    "M9 7a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9Zm8 0a5 5 0 0 1 .22 10H15a1 1 0 0 1-.12-2H17a3 3 0 0 0 .18-6H15a1 1 0 0 1-.12-2H17ZM7 11h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2H17 7Z"
]);
const $7972e53b1de568ed$export$abc41a13a016ef8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link24Regular', "24", [
    "M9.25 7a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5ZM17 7a5 5 0 0 1 .25 10h-2.5a.75.75 0 0 1-.11-1.5H17a3.5 3.5 0 0 0 .2-7h-2.45a.75.75 0 0 1-.11-1.5H17ZM7 11.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5H17 7Z"
]);
const $7972e53b1de568ed$export$1ac813cd0ce18e4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link28Color', "28", `<path d="M11 8a1 1 0 0 1 .12 2H8a4 4 0 0 0-.2 8H11a1 1 0 0 1 .12 2H8a6 6 0 0 1-.22-12H11Zm9 0a6 6 0 0 1 .22 12H17a1 1 0 0 1-.12-2H20a4 4 0 0 0 .2-8H17a1 1 0 0 1-.12-2H20ZM8 13h12a1 1 0 0 1 .12 2H8a1 1 0 0 1-.12-2H20 8Z" fill="url(#ic_fluent_link_28_color__a)"/><defs><linearGradient id="ic_fluent_link_28_color__a" x1="-5.71" y1="2.75" x2="3.81" y2="31.38" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$3da22c0efc281878 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link28Filled', "28", [
    "M11 8a1 1 0 0 1 .12 2H8a4 4 0 0 0-.2 8H11a1 1 0 0 1 .12 2H8a6 6 0 0 1-.22-12H11Zm9 0a6 6 0 0 1 .22 12H17a1 1 0 0 1-.12-2H20a4 4 0 0 0 .2-8H17a1 1 0 0 1-.12-2H20ZM8 13h12a1 1 0 0 1 .12 2H8a1 1 0 0 1-.12-2H20 8Z"
]);
const $7972e53b1de568ed$export$594bc4bc55f4df0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link28Regular', "28", [
    "M11 8a.75.75 0 0 1 .1 1.5H8a4.5 4.5 0 0 0-.21 9H11a.75.75 0 0 1 .1 1.5H8a6 6 0 0 1-.22-12H11Zm9 0a6 6 0 0 1 .22 12H17a.75.75 0 0 1-.1-1.5H20a4.5 4.5 0 0 0 .21-9H17a.75.75 0 0 1-.1-1.5H20ZM8 13.25h12a.75.75 0 0 1 .1 1.5H8a.75.75 0 0 1-.1-1.5H20 8Z"
]);
const $7972e53b1de568ed$export$97cc07605a6150bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Color', "32", `<path d="M2 16.25C2 12.25 5.25 9 9.25 9h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a4.75 4.75 0 1 0 0 9.5h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-4 0-7.25-3.25-7.25-7.25Zm28 0c0-4-3.25-7.25-7.25-7.25h-3.5a1.25 1.25 0 1 0 0 2.5h3.5a4.75 4.75 0 1 1 0 9.5h-3.5a1.25 1.25 0 1 0 0 2.5h3.5c4 0 7.25-3.25 7.25-7.25ZM9.75 15a1.25 1.25 0 1 0 0 2.5h12.5a1.25 1.25 0 1 0 0-2.5H9.75Z" fill="url(#ic_fluent_link_32_color__a)"/><defs><linearGradient id="ic_fluent_link_32_color__a" x1="-7" y1="2.66" x2="4.83" y2="37" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$3d6bd6f3c4fb1f36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Filled', "32", [
    "M2 16.25C2 12.25 5.25 9 9.25 9h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a4.75 4.75 0 1 0 0 9.5h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-4 0-7.25-3.25-7.25-7.25Zm28 0c0-4-3.25-7.25-7.25-7.25h-3.5a1.25 1.25 0 1 0 0 2.5h3.5a4.75 4.75 0 1 1 0 9.5h-3.5a1.25 1.25 0 1 0 0 2.5h3.5c4 0 7.25-3.25 7.25-7.25ZM9.75 15a1.25 1.25 0 1 0 0 2.5h12.5a1.25 1.25 0 1 0 0-2.5H9.75Z"
]);
const $7972e53b1de568ed$export$ca2bd101c59ea045 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Light', "32", [
    "M2 15.5A6.5 6.5 0 0 1 8.5 9h5a.5.5 0 0 1 0 1h-5a5.5 5.5 0 1 0 0 11h5a.5.5 0 0 1 0 1h-5A6.5 6.5 0 0 1 2 15.5Zm28 0A6.5 6.5 0 0 0 23.5 9h-5a.5.5 0 0 0 0 1h5a5.5 5.5 0 1 1 0 11h-5a.5.5 0 0 0 0 1h5a6.5 6.5 0 0 0 6.5-6.5ZM9.5 15a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z"
]);
const $7972e53b1de568ed$export$cbbb641296c2180 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link32Regular', "32", [
    "M2 16a7 7 0 0 1 7-7h4a1 1 0 1 1 0 2H9a5 5 0 0 0 0 10h4a1 1 0 1 1 0 2H9a7 7 0 0 1-7-7Zm28 0a7 7 0 0 0-7-7h-4a1 1 0 1 0 0 2h4a5 5 0 0 1 0 10h-4a1 1 0 1 0 0 2h4a7 7 0 0 0 7-7ZM9.5 15a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2h-13Z"
]);
const $7972e53b1de568ed$export$2f7464e195ffa606 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link48Filled', "48", [
    "M33.25 13c5.84 0 10.6 4.66 10.75 10.46v.79c0 5.84-4.66 10.6-10.46 10.75h-4.79a1.75 1.75 0 0 1-.14-3.5h4.64a7.25 7.25 0 0 0 7.25-7.01v-.74a7.25 7.25 0 0 0-7.01-7.25h-4.74a1.75 1.75 0 0 1-.14-3.5h4.64Zm-14 0a1.75 1.75 0 0 1 .14 3.5h-4.64a7.25 7.25 0 0 0-7.25 7.01v.74a7.25 7.25 0 0 0 7.01 7.25h4.74a1.75 1.75 0 0 1 .14 3.5h-4.64C8.91 35 4.15 30.34 4 24.54v-.79C4 17.91 8.66 13.15 14.46 13h4.79ZM14 22.25h20a1.75 1.75 0 0 1 .14 3.5H14a1.75 1.75 0 0 1-.14-3.5H34 14Z"
]);
const $7972e53b1de568ed$export$bcdc3f59f71243bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Link48Regular', "48", [
    "M34 14a10 10 0 0 1 .28 20h-6.03a1.25 1.25 0 0 1-.13-2.5H34a7.5 7.5 0 0 0 .24-15h-5.99a1.25 1.25 0 0 1-.13-2.5H34Zm-14.25 0a1.25 1.25 0 0 1 .13 2.5H14a7.5 7.5 0 0 0-.24 15h5.99a1.25 1.25 0 0 1 .13 2.5H14a10 10 0 0 1-.28-20h6.03ZM13 22.75h22a1.25 1.25 0 0 1 .13 2.5H13a1.25 1.25 0 0 1-.13-2.5H35 13Z"
]);
const $7972e53b1de568ed$export$8ef5c6a0156192b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd16Filled', "16", [
    "M9.75 3h.52c2 0 3.65 1.6 3.73 3.6a5.46 5.46 0 0 0-1.6-.53 2.24 2.24 0 0 0-1.98-1.56l-.15-.01h-.52a.75.75 0 0 1-.1-1.5h.1Zm-3.66 7.5c.1-.5.25-.98.47-1.43A.75.75 0 0 0 6.25 9H5.6a2.25 2.25 0 0 1 .15-4.5h.6a.75.75 0 0 0-.1-1.5h-.7a3.75 3.75 0 0 0 .2 7.5h.34Zm1.64-3a5.48 5.48 0 0 1 2.85-1.42.75.75 0 0 0-.33-.08h-4.6a.75.75 0 0 0 .1 1.5h1.98Zm8.27 4a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
]);
const $7972e53b1de568ed$export$ec757a5abd117183 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd16Regular', "16", [
    "M9.5 3h1A3.5 3.5 0 0 1 14 6.6c-.32-.17-.66-.3-1.02-.4A2.5 2.5 0 0 0 10.66 4H9.5a.5.5 0 0 1-.09-1h.09Zm-3.3 7c.1-.35.24-.68.4-1a.5.5 0 0 0-.1 0H5.34a2.5 2.5 0 0 1 .16-5h1.09a.5.5 0 0 0-.09-1H5.3a3.5 3.5 0 0 0 .2 7h.7Zm2.14-3c.69-.49 1.5-.82 2.38-.95A.5.5 0 0 0 10.5 6H5.41a.5.5 0 0 0 .09 1h2.84ZM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
]);
const $7972e53b1de568ed$export$8bcb62cd58cc021e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd20Filled', "20", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 2 3.76c.49.15.94.37 1.36.64.3-.56.48-1.21.48-1.9ZM8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75Zm5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $7972e53b1de568ed$export$9f404c349cb73bce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd20Regular', "20", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5ZM18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.44 4.43c.3.13.6.29.88.47.3-.56.48-1.21.48-1.9Zm-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1Zm5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $7972e53b1de568ed$export$e88262683062ffa7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd24Filled', "24", [
    "M9 5a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9Zm8 0a5 5 0 0 1 4.43 7.32 6.48 6.48 0 0 0-1.76-.95A3 3 0 0 0 17.17 7H15a1 1 0 0 1-.12-2H17ZM7 9h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2H7Zm16 8.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
]);
const $7972e53b1de568ed$export$8c09e551469358f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkAdd24Regular', "24", [
    "M9.25 5a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5ZM17 5a5 5 0 0 1 4.43 7.32 6.5 6.5 0 0 0-1.3-.76A3.5 3.5 0 0 0 17.2 6.5L17 6.5h-2.25a.75.75 0 0 1-.11-1.5H17ZM7 9.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5H7Zm16 8.25a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
]);
const $7972e53b1de568ed$export$823703571d909351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss16Filled', "16", [
    "M10.27 3h-.62a.75.75 0 0 0 .1 1.5h.67c.93.07 1.7.7 1.98 1.57.56.1 1.1.28 1.6.53-.08-2-1.72-3.6-3.73-3.6Zm-3.7 6.07c-.23.45-.39.93-.48 1.43h-.34a3.75 3.75 0 0 1-.2-7.5h.7a.75.75 0 0 1 .1 1.5h-.6A2.25 2.25 0 0 0 5.6 9h.65c.11 0 .22.03.31.07Zm4.01-3c-1.1.2-2.08.7-2.85 1.43H5.75a.75.75 0 0 1-.1-1.5h4.6c.12 0 .23.03.33.08ZM11.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0Z"
]);
const $7972e53b1de568ed$export$39689b681c7a806 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss16Regular', "16", [
    "M10.5 3H9.41a.5.5 0 0 0 .09 1h1.16a2.5 2.5 0 0 1 2.32 2.2c.36.1.7.23 1.02.4v-.1A3.5 3.5 0 0 0 10.5 3ZM6.6 9c-.16.32-.3.65-.4 1h-.7a3.5 3.5 0 0 1-.2-7h1.2a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.5a.5.5 0 0 1 .1 0Zm4.12-2.95c-.88.13-1.69.46-2.38.95H5.5a.5.5 0 0 1-.09-1h5.09a.5.5 0 0 1 .22.05ZM11.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0Z"
]);
const $7972e53b1de568ed$export$8e000df0be771abc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss20Filled', "20", [
    "M14 4a4 4 0 0 1 3.52 5.9c-.42-.27-.87-.5-1.36-.64a2.5 2.5 0 0 0-2-3.75L14 5.5h-2a.75.75 0 0 1-.1-1.5H14ZM8 4a.75.75 0 0 1 .1 1.5H6a2.5 2.5 0 0 0-.16 5H8a.75.75 0 0 1 .1 1.5H6a4 4 0 0 1-.2-8H8ZM6.25 7.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h.1ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.73-1.06a.5.5 0 0 0-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 0 0-.7.7l1.05 1.07-1.06 1.06a.5.5 0 0 0 .7.7l1.07-1.05 1.06 1.06a.5.5 0 0 0 .7-.7l-1.05-1.07 1.06-1.06Z"
]);
const $7972e53b1de568ed$export$b097a138c0022014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss20Regular', "20", [
    "M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8Zm6 0a4 4 0 0 1 3.52 5.9 5.49 5.49 0 0 0-.88-.47 3 3 0 0 0-2.44-4.42L14 5h-2a.5.5 0 0 1-.09-1H14ZM6 7.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1H6Zm13 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.73-1.06a.5.5 0 0 0-.7-.7l-1.07 1.05-1.06-1.06a.5.5 0 0 0-.7.7l1.05 1.07-1.06 1.06a.5.5 0 0 0 .7.7l1.07-1.05 1.06 1.06a.5.5 0 0 0 .7-.7l-1.05-1.07 1.06-1.06Z"
]);
const $7972e53b1de568ed$export$32f580bf224b1962 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss24Filled', "24", [
    "M9 5a1 1 0 0 1 .12 2H7a3 3 0 0 0-.18 6H9a1 1 0 0 1 .12 2H7a5 5 0 0 1-.22-10H9Zm8 0a5 5 0 0 1 4.43 7.32 6.48 6.48 0 0 0-1.76-.95A3 3 0 0 0 17.17 7H15a1 1 0 0 1-.12-2H17ZM7 9h10a1 1 0 0 1 .12 2H7a1 1 0 0 1-.12-2H7Zm16 8.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
]);
const $7972e53b1de568ed$export$840a9b568b1ce6a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkDismiss24Regular', "24", [
    "M9.25 5a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5ZM17 5a5 5 0 0 1 4.43 7.32 6.5 6.5 0 0 0-1.3-.76A3.5 3.5 0 0 0 17.2 6.5L17 6.5h-2.25a.75.75 0 0 1-.11-1.5H17ZM7 9.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5H7Zm16 8.25a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
]);
const $7972e53b1de568ed$export$abcf470e5f5f58a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit16Filled', "16", [
    "M10.26 3h-.61a.75.75 0 0 0 .1 1.5h.67c.67.05 1.26.4 1.63.9.46-.3 1-.43 1.52-.4a3.73 3.73 0 0 0-3.3-2Zm.67 3.44L9.88 7.5H5.75a.75.75 0 0 1-.1-1.5h4.6c.3 0 .57.18.68.44Zm2.26-.42a1.58 1.58 0 0 0-.86.44L9 9.78l-.95.95c-.36.36-.61.8-.73 1.3l-.3 1.2a.6.6 0 0 0 .73.74l1.22-.3c.48-.12.93-.38 1.29-.73l4.28-4.29a1.56 1.56 0 0 0-1.35-2.64ZM6.25 3h-.7a3.75 3.75 0 0 0 .2 7.5h.6a.75.75 0 0 0-.1-1.5H5.6a2.25 2.25 0 0 1 .15-4.5h.6a.75.75 0 0 0-.1-1.5Z"
]);
const $7972e53b1de568ed$export$65a17f2954d2e295 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit16Regular', "16", [
    "M10.5 3H9.4a.5.5 0 0 0 .1 1h1.16c.81.06 1.52.5 1.94 1.14.34-.12.7-.16 1.06-.13A3.5 3.5 0 0 0 10.5 3Zm.49 3.39-.61.61H5.5a.5.5 0 0 1-.09-1h5.09a.5.5 0 0 1 .49.39Zm2.15-.36c-.06 0-.12.02-.18.04-.23.08-.44.2-.62.38L9.06 9.73l-1.01 1.01c-.36.36-.61.8-.73 1.3l-.3 1.2a.6.6 0 0 0 .73.74l1.22-.3c.48-.12.93-.38 1.29-.73l4.28-4.29a1.56 1.56 0 0 0-1.4-2.63ZM6.5 3H5.3a3.5 3.5 0 0 0 .2 7h1l.09-.01a.5.5 0 0 0-.1-1H5.35A2.5 2.5 0 0 1 5.5 4h1.09a.5.5 0 0 0-.1-1Z"
]);
const $7972e53b1de568ed$export$6c67f1752e0c4092 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit20Filled', "20", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16A2.5 2.5 0 0 1 16.5 8v.02c.52.07 1.02.28 1.45.63.03-.21.05-.43.05-.65ZM8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75Zm5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5Zm-3.77 7.13 4.83-4.83a1.87 1.87 0 0 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01Z"
]);
const $7972e53b1de568ed$export$f7436826a7ddbac9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit20Regular', "20", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09a.5.5 0 0 0-.1-1H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .4-.5ZM18 8a4 4 0 0 0-4-4h-2.1a.5.5 0 0 0 .1 1h2.2A3 3 0 0 1 17 8.14c.33.1.66.28.95.52.03-.21.05-.43.05-.65Zm-4-.5H5.9a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.1-1Zm-4.02 6.88 4.83-4.83a1.87 1.87 0 0 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01Z"
]);
const $7972e53b1de568ed$export$5eb4108855ac04fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit24Filled', "24", [
    "M10 6a1 1 0 0 0-1-1H6.78A5 5 0 0 0 7 15h2.12A1 1 0 0 0 9 13H6.82A3 3 0 0 1 7 7h2.12A1 1 0 0 0 10 6Zm12 4a5 5 0 0 0-5-5h-2.12A1 1 0 0 0 15 7h2.17A3 3 0 0 1 20 10V10c.7.06 1.37.34 1.93.84.04-.27.07-.56.07-.85Zm-4.23.64c-.1.07-.2.15-.29.24a1 1 0 0 1-.36.11H7a1 1 0 0 1-.12-1.98L7 9h10a1 1 0 0 1 .77 1.64Zm.33 1.03-5.9 5.9c-.35.34-.6.78-.71 1.25l-.46 1.83c-.2.8.52 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24Z"
]);
const $7972e53b1de568ed$export$9f32c233a9965a7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkEdit24Regular', "24", [
    "M10 5.75A.75.75 0 0 0 9.25 5h-2.5A5 5 0 0 0 7 15h2.36a.75.75 0 0 0-.11-1.5H6.8a3.5 3.5 0 0 1 .2-7h2.36a.75.75 0 0 0 .64-.75ZM22 10a5 5 0 0 0-5-5h-2.36a.75.75 0 0 0 .1 1.5h2.46a3.5 3.5 0 0 1 3.3 3.6c.51.12 1 .37 1.43.75.04-.27.07-.56.07-.85Zm-5-.75H6.9a.75.75 0 0 0 .1 1.5h10.1a.75.75 0 0 0-.1-1.5Zm1.1 2.42-5.9 5.9c-.35.34-.6.78-.71 1.25l-.46 1.83c-.2.8.52 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24Z"
]);
const $7972e53b1de568ed$export$9342e7344c53516d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple16Color', "16", `<path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.25C1 4.45 2.46 3 4.25 3h4.5a3.25 3.25 0 0 1 0 6.5h-4.5A3.25 3.25 0 0 1 1 6.25ZM4.25 4.5a1.75 1.75 0 1 0 0 3.5h4.5a1.75 1.75 0 1 0 0-3.5h-4.5Z" fill="url(#ic_fluent_link_multiple_16_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.25C1 4.45 2.46 3 4.25 3h4.5a3.25 3.25 0 0 1 0 6.5h-4.5A3.25 3.25 0 0 1 1 6.25ZM4.25 4.5a1.75 1.75 0 1 0 0 3.5h4.5a1.75 1.75 0 1 0 0-3.5h-4.5Z" fill="url(#ic_fluent_link_multiple_16_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.25C1 4.45 2.46 3 4.25 3h4.5a3.25 3.25 0 0 1 0 6.5h-4.5A3.25 3.25 0 0 1 1 6.25ZM4.25 4.5a1.75 1.75 0 1 0 0 3.5h4.5a1.75 1.75 0 1 0 0-3.5h-4.5Z" fill="url(#ic_fluent_link_multiple_16_color__c)"/><path d="M10.48 6.5H7.25a3.25 3.25 0 1 0 0 6.5h4.5a3.25 3.25 0 0 0 .24-6.5 3.23 3.23 0 0 1-.5 1.5h.26a1.75 1.75 0 1 1 0 3.5h-4.5A1.75 1.75 0 0 1 7 8.02V8h1.75c.88 0 1.61-.65 1.73-1.5Z" fill="url(#ic_fluent_link_multiple_16_color__d)"/><path d="M10.48 6.5H7.25a3.25 3.25 0 1 0 0 6.5h4.5a3.25 3.25 0 0 0 .24-6.5 3.23 3.23 0 0 1-.5 1.5h.26a1.75 1.75 0 1 1 0 3.5h-4.5A1.75 1.75 0 0 1 7 8.02V8h1.75c.88 0 1.61-.65 1.73-1.5Z" fill="url(#ic_fluent_link_multiple_16_color__e)"/><path d="M10.48 6.5H7.25a3.25 3.25 0 1 0 0 6.5h4.5a3.25 3.25 0 0 0 .24-6.5 3.23 3.23 0 0 1-.5 1.5h.26a1.75 1.75 0 1 1 0 3.5h-4.5A1.75 1.75 0 0 1 7 8.02V8h1.75c.88 0 1.61-.65 1.73-1.5Z" fill="url(#ic_fluent_link_multiple_16_color__f)"/><defs><radialGradient id="ic_fluent_link_multiple_16_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(9.00003 7.00003 -6.27 8.06142 1.5 3)"><stop stop-color="#0FAFFF"/><stop offset=".43" stop-color="#367AF2"/><stop offset=".94" stop-color="#5750E2"/><stop offset="1" stop-color="#6F47DF"/></radialGradient><radialGradient id="ic_fluent_link_multiple_16_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-5 0 0 -5.07351 7.5 10)"><stop offset=".27" stop-color="#261D82" stop-opacity="0"/><stop offset=".5" stop-color="#261D82"/><stop offset=".56" stop-color="#261D82"/><stop offset=".87" stop-color="#261D82" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_link_multiple_16_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(4.5 0 0 4.56616 9 6)"><stop offset=".26" stop-color="#2764E7" stop-opacity="0"/><stop offset=".45" stop-color="#2764E7"/><stop offset=".58" stop-color="#2764E7"/><stop offset=".77" stop-color="#2764E7" stop-opacity="0"/></radialGradient><linearGradient id="ic_fluent_link_multiple_16_color__c" x1="12" y1="8" x2="6.36" y2="3.58" gradientUnits="userSpaceOnUse"><stop stop-color="#5157E4" stop-opacity="0"/><stop offset=".07" stop-color="#5157E4"/><stop offset=".33" stop-color="#5157E4"/><stop offset=".6" stop-color="#5157E4" stop-opacity="0"/></linearGradient><linearGradient id="ic_fluent_link_multiple_16_color__d" x1=".46" y1="3.66" x2="6.33" y2="18.57" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_link_multiple_16_color__f" x1="4" y1="5" x2="9.53" y2="7.95" gradientUnits="userSpaceOnUse"><stop stop-color="#31B3EE" stop-opacity=".24"/><stop offset=".21" stop-color="#31B3EE"/><stop offset=".54" stop-color="#31B3EE"/><stop offset=".76" stop-color="#31B3EE" stop-opacity=".9"/><stop offset="1" stop-color="#31B3EE" stop-opacity="0"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$5fa721e60ed026c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple16Filled', "16", [
    "M1 6.5A3.5 3.5 0 0 1 4.5 3h4a3.5 3.5 0 0 1 3.47 3.03 3.54 3.54 0 0 1-.12 1.5A3.5 3.5 0 0 1 8.5 10h-.75a.75.75 0 0 1 0-1.5h.75a2 2 0 1 0 0-4h-4a2 2 0 0 0-1.26 3.55A4.5 4.5 0 0 0 3 9.66 3.5 3.5 0 0 1 1 6.5Zm8 .25c0 .41-.34.75-.75.75H7.5a2 2 0 1 0 0 4h4a2 2 0 0 0 1.26-3.55A4.5 4.5 0 0 0 13 6.34 3.5 3.5 0 0 1 11.5 13h-4a3.5 3.5 0 1 1 0-7h.75c.41 0 .75.34.75.75Z"
]);
const $7972e53b1de568ed$export$56d5e3c599109c15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple16Regular', "16", [
    "M12 6.5A3.5 3.5 0 0 0 8.5 3H4.3A3.5 3.5 0 0 0 3 9.67a4.57 4.57 0 0 1 .1-1.1A2.5 2.5 0 0 1 4.5 4h4.16a2.5 2.5 0 0 1-.16 5h-1l-.1.01a.5.5 0 0 0 .1 1l1-.01h.2A3.5 3.5 0 0 0 12 6.5Zm2 3a2.5 2.5 0 0 0-1.1-2.07 4.52 4.52 0 0 0 .1-1.1A3.5 3.5 0 0 1 11.7 13l-.2.01h-4a3.5 3.5 0 0 1-.2-7h1.2a.5.5 0 0 1 .09 1H7.5a2.5 2.5 0 0 0-.16 5h4.16A2.5 2.5 0 0 0 14 9.5Z"
]);
const $7972e53b1de568ed$export$3f8b07c3e79171 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple20Color', "20", `<path fill-rule="evenodd" clip-rule="evenodd" d="M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8Zm6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4Z" fill="url(#ic_fluent_link_multiple_20_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8Zm6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4Z" fill="url(#ic_fluent_link_multiple_20_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4h6a4 4 0 0 1 0 8H5a4 4 0 0 1 0-8Zm6 2H5a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4Z" fill="url(#ic_fluent_link_multiple_20_color__c)"/><path d="M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8c0 .73-.2 1.41-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2Z" fill="url(#ic_fluent_link_multiple_20_color__d)"/><path d="M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8c0 .73-.2 1.41-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2Z" fill="url(#ic_fluent_link_multiple_20_color__e)"/><path d="M13 8H9a4 4 0 1 0 0 8h6a4 4 0 0 0 0-8c0 .73-.2 1.41-.54 2H15a2 2 0 1 1 0 4H9a2 2 0 1 1 0-4h2a2 2 0 0 0 2-2Z" fill="url(#ic_fluent_link_multiple_20_color__f)"/><defs><radialGradient id="ic_fluent_link_multiple_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(36.95 -5.17 4.45) scale(14.3329 12.726)"><stop stop-color="#0FAFFF"/><stop offset=".43" stop-color="#367AF2"/><stop offset=".94" stop-color="#5750E2"/><stop offset="1" stop-color="#6F47DF"/></radialGradient><radialGradient id="ic_fluent_link_multiple_20_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-6 0 0 -5.8875 9 12)"><stop offset=".23" stop-color="#261D82" stop-opacity="0"/><stop offset=".4" stop-color="#261D82"/><stop offset=".58" stop-color="#261D82"/><stop offset=".78" stop-color="#261D82" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_link_multiple_20_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6 0 0 5.8875 11 8)"><stop offset=".23" stop-color="#2764E7" stop-opacity="0"/><stop offset=".4" stop-color="#2764E7"/><stop offset=".58" stop-color="#2764E7"/><stop offset=".78" stop-color="#2764E7" stop-opacity="0"/></radialGradient><linearGradient id="ic_fluent_link_multiple_20_color__c" x1="13.5" y1="13" x2="8" y2="4.5" gradientUnits="userSpaceOnUse"><stop stop-color="#5157E4" stop-opacity="0"/><stop offset=".07" stop-color="#5157E4"/><stop offset=".27" stop-color="#5157E4"/><stop offset=".6" stop-color="#5157E4" stop-opacity="0"/></linearGradient><linearGradient id="ic_fluent_link_multiple_20_color__d" x1=".5" y1="4.5" x2="7.54" y2="23.02" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_link_multiple_20_color__f" x1="9.5" y1="5" x2="13" y2="11" gradientUnits="userSpaceOnUse"><stop stop-color="#31B3EE" stop-opacity=".24"/><stop offset=".21" stop-color="#31B3EE"/><stop offset=".57" stop-color="#31B3EE"/><stop offset=".88" stop-color="#31B3EE" stop-opacity="0"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$8b77bb1b2a400ede = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple20Filled', "20", [
    "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H9.75a.75.75 0 0 1 0-1.5H11a2.5 2.5 0 0 0 0-5H5a2.5 2.5 0 0 0-.74 4.89c-.15.47-.25.97-.26 1.48A4 4 0 0 1 1 8Zm15 .13c-.01.51-.1 1.01-.26 1.48A2.5 2.5 0 0 1 15 14.5H9a2.5 2.5 0 0 1 0-5h1.25a.75.75 0 0 0 0-1.5H9a4 4 0 1 0 0 8h6a4 4 0 0 0 1-7.87Z"
]);
const $7972e53b1de568ed$export$2d1665b8a4dbd1b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple20Regular', "20", [
    "M1 8a4 4 0 0 1 4-4h6a4 4 0 0 1 0 8H9.5a.5.5 0 0 1 0-1H11a3 3 0 1 0 0-6H5a3 3 0 0 0-.87 5.87 5 5 0 0 0-.13 1A4 4 0 0 1 1 8Zm17 4a3 3 0 0 0-2.13-2.87c.08-.32.12-.66.13-1A4 4 0 0 1 15 16H9a4 4 0 0 1 0-8h1.5a.5.5 0 0 1 0 1H9a3 3 0 1 0 0 6h6a3 3 0 0 0 3-3Z"
]);
const $7972e53b1de568ed$export$75cc9e5735b9e300 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple24Color', "24", `<path fill-rule="evenodd" clip-rule="evenodd" d="M1 10a5 5 0 0 1 5-5h7a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5Zm5-3a3 3 0 0 0 0 6h7a3 3 0 1 0 0-6H6Z" fill="url(#ic_fluent_link_multiple_24_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 10a5 5 0 0 1 5-5h7a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5Zm5-3a3 3 0 0 0 0 6h7a3 3 0 1 0 0-6H6Z" fill="url(#ic_fluent_link_multiple_24_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 10a5 5 0 0 1 5-5h7a5 5 0 0 1 0 10H6a5 5 0 0 1-5-5Zm5-3a3 3 0 0 0 0 6h7a3 3 0 1 0 0-6H6Z" fill="url(#ic_fluent_link_multiple_24_color__c)"/><path d="M15.83 9H11a5 5 0 0 0 0 10h7a5 5 0 0 0 0-10h-.1a5.02 5.02 0 0 1 0 2h.1a3 3 0 1 1 0 6h-7a3 3 0 1 1 0-6h4.83a3 3 0 0 0 0-2Z" fill="url(#ic_fluent_link_multiple_24_color__d)"/><path d="M15.83 9H11a5 5 0 0 0 0 10h7a5 5 0 0 0 0-10h-.1a5.02 5.02 0 0 1 0 2h.1a3 3 0 1 1 0 6h-7a3 3 0 1 1 0-6h4.83a3 3 0 0 0 0-2Z" fill="url(#ic_fluent_link_multiple_24_color__e)"/><path d="M15.83 9H11a5 5 0 0 0 0 10h7a5 5 0 0 0 0-10h-.1a5.02 5.02 0 0 1 0 2h.1a3 3 0 1 1 0 6h-7a3 3 0 1 1 0-6h4.83a3 3 0 0 0 0-2Z" fill="url(#ic_fluent_link_multiple_24_color__f)"/><defs><radialGradient id="ic_fluent_link_multiple_24_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(13.90911 10.76923 -9.6353 12.44458 1.77 5)"><stop stop-color="#0FAFFF"/><stop offset=".43" stop-color="#367AF2"/><stop offset=".94" stop-color="#5750E2"/><stop offset="1" stop-color="#6F47DF"/></radialGradient><radialGradient id="ic_fluent_link_multiple_24_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-7 0 0 -7.77785 10.5 14.5)"><stop offset=".24" stop-color="#261D82" stop-opacity="0"/><stop offset=".42" stop-color="#261D82"/><stop offset=".57" stop-color="#261D82"/><stop offset=".75" stop-color="#261D82" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_link_multiple_24_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(7 0 0 7.77785 13.5 9.5)"><stop offset=".25" stop-color="#2764E7" stop-opacity="0"/><stop offset=".4" stop-color="#2764E7"/><stop offset=".58" stop-color="#2764E7"/><stop offset=".75" stop-color="#2764E7" stop-opacity="0"/></radialGradient><linearGradient id="ic_fluent_link_multiple_24_color__c" x1="17" y1="15.5" x2="8.38" y2="5.67" gradientUnits="userSpaceOnUse"><stop stop-color="#5157E4" stop-opacity="0"/><stop offset=".07" stop-color="#5157E4"/><stop offset=".32" stop-color="#5157E4"/><stop offset=".6" stop-color="#5157E4" stop-opacity="0"/></linearGradient><linearGradient id="ic_fluent_link_multiple_24_color__d" x1=".54" y1="4.19" x2="11.12" y2="28.78" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_link_multiple_24_color__f" x1="8.5" y1="5" x2="16.77" y2="12.1" gradientUnits="userSpaceOnUse"><stop stop-color="#31B3EE" stop-opacity=".24"/><stop offset=".21" stop-color="#31B3EE"/><stop offset=".57" stop-color="#31B3EE"/><stop offset=".76" stop-color="#31B3EE" stop-opacity="0"/></linearGradient></defs>`, {
    color: true
});
const $7972e53b1de568ed$export$b80331c424392f59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple24Filled', "24", [
    "M6.5 4a5.5 5.5 0 0 0-1.99 10.63c.04-.7.19-1.37.43-2A3.5 3.5 0 0 1 6.5 6h6a3.5 3.5 0 1 1 0 7H12a1 1 0 1 0 0 2h.5a5.5 5.5 0 1 0 0-11h-6Zm12.61 8.21A3 3 0 0 1 18 18h-7a3 3 0 1 1 0-6h1a1 1 0 0 0 0-2h-1a5 5 0 0 0 0 10h7a5 5 0 0 0 1.5-9.77c-.03.7-.16 1.36-.39 1.98Z"
]);
const $7972e53b1de568ed$export$af23332fe76c60ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkMultiple24Regular', "24", [
    "M6.25 4a5.25 5.25 0 0 0-1.7 10.22c.06-.51.18-1 .35-1.47A3.75 3.75 0 0 1 6.25 5.5h6.5a3.75 3.75 0 1 1 0 7.5h-1a.75.75 0 0 0 0 1.5h1a5.25 5.25 0 1 0 0-10.5h-6.5Zm13.14 6.2c-.1.5-.24.98-.44 1.43A3.5 3.5 0 0 1 18 18.5h-7a3.5 3.5 0 1 1 0-7h1.25a.75.75 0 0 0 0-1.5H11a5 5 0 0 0 0 10h7a5 5 0 0 0 1.4-9.8Z"
]);
const $7972e53b1de568ed$export$422cfe50ece1c997 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson16Filled', "16", [
    "M9.75 3h.52a3.74 3.74 0 0 1 3.7 4.29 3 3 0 0 0-1.55-1.15 2.24 2.24 0 0 0-2-1.63l-.15-.01h-.52a.75.75 0 0 1-.1-1.5h.1ZM8.9 7.5a3 3 0 0 1 1.76-1.38.75.75 0 0 0-.41-.12h-4.6a.75.75 0 0 0 .1 1.5H8.9ZM5.75 3h.5a.75.75 0 0 1 .1 1.5h-.6A2.25 2.25 0 0 0 5.6 9h.65a.75.75 0 0 1 .1 1.5h-.6a3.75 3.75 0 0 1-.2-7.5h.2Zm7.75 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 14.75 8 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $7972e53b1de568ed$export$78cb7947f3dfb1a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson16Regular', "16", [
    "M9.5 3h1a3.5 3.5 0 0 1 3.42 4.23A3.02 3.02 0 0 0 13 6.4 2.5 2.5 0 0 0 10.66 4H9.5a.5.5 0 0 1-.09-1h.09Zm-.24 4a3 3 0 0 1 1.52-.91.5.5 0 0 0-.28-.09H5.41a.5.5 0 0 0 .09 1h3.76ZM5.5 3h1a.5.5 0 0 1 .09 1H5.5a2.5 2.5 0 0 0-.16 5H6.5a.5.5 0 0 1 .09 1H5.5a3.5 3.5 0 0 1-.2-7h.2Zm8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 14.75 8 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $7972e53b1de568ed$export$7ba79c488ddff905 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson20Filled', "20", [
    "M18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 1.89 3.93c.44.27.8.64 1.06 1.09.56-.69.89-1.57.89-2.52ZM8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75Zm5 2.5h-7.6a.75.75 0 0 0 .1 1.5h7.6a.75.75 0 0 0-.1-1.5ZM16.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $7972e53b1de568ed$export$a3b455cc73b7bea9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson20Regular', "20", [
    "M8.5 4.5A.5.5 0 0 0 8 4H5.78A4 4 0 0 0 6 12h2.09A.5.5 0 0 0 8 11H5.8A3 3 0 0 1 6 5h2.09a.5.5 0 0 0 .41-.5ZM18 8a4 4 0 0 0-4-4h-2.09A.5.5 0 0 0 12 5h2.2a3 3 0 0 1 2.26 4.72c.26.23.48.5.65.8.56-.69.89-1.57.89-2.52Zm-4-.5H5.91a.5.5 0 0 0 .09 1h8.09a.5.5 0 0 0-.09-1Zm2.5 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $7972e53b1de568ed$export$9682907bb580f218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson24Filled', "24", [
    "M10 6a1 1 0 0 0-1-1H6.78A5 5 0 0 0 7 15h2.12A1 1 0 0 0 9 13H6.82A3 3 0 0 1 7 7h2.12A1 1 0 0 0 10 6Zm12 4a5 5 0 0 0-5-5h-2.12A1 1 0 0 0 15 7h2.18a3 3 0 0 1 2.33 4.64c.58.4 1.02.97 1.27 1.63A4.98 4.98 0 0 0 22 10Zm-5-1H6.88A1 1 0 0 0 7 11h10.12A1 1 0 0 0 17 9Zm3 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S13 21.44 13 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $7972e53b1de568ed$export$8d42f29144ca1b51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson24Regular', "24", [
    "M10 5.75A.75.75 0 0 0 9.25 5h-2.5A5 5 0 0 0 7 15h2.36a.75.75 0 0 0-.11-1.5H6.8a3.5 3.5 0 0 1 .2-7h2.36a.75.75 0 0 0 .64-.75ZM22 10a5 5 0 0 0-5-5h-2.36a.75.75 0 0 0 .11 1.5h2.45a3.5 3.5 0 0 1 2.7 5.46c.39.36.69.8.88 1.31A4.98 4.98 0 0 0 22 10Zm-5-.75H6.9a.75.75 0 0 0 .1 1.5h10.1a.75.75 0 0 0-.1-1.5Zm3 5.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S13 21.44 13 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $7972e53b1de568ed$export$4c2dde386fb7379e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson32Filled', "32", [
    "M9.25 6a7.25 7.25 0 0 0 0 14.5h3.5a1.25 1.25 0 1 0 0-2.5h-3.5a4.75 4.75 0 1 1 0-9.5h3.5a1.25 1.25 0 1 0 0-2.5h-3.5Zm13.5 0a7.25 7.25 0 0 1 5.97 11.36 5.01 5.01 0 0 0-1.6-2.26 4.74 4.74 0 0 0-4.37-6.6h-3.5a1.25 1.25 0 1 1 0-2.5h3.5Zm.45 8.06c-.49.08-.95.23-1.38.44H9.75a1.25 1.25 0 1 1 0-2.5h12.5a1.25 1.25 0 0 1 .95 2.06ZM27.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06A2.43 2.43 0 0 1 20.42 24h7.16c1.34 0 2.42 1.1 2.42 2.44Z"
]);
const $7972e53b1de568ed$export$49f83461f2814cdc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson32Regular', "32", [
    "M9 6a7 7 0 0 0 0 14h4a1 1 0 1 0 0-2H9A5 5 0 0 1 9 8h4a1 1 0 1 0 0-2H9Zm14 0a7 7 0 0 1 5.64 11.14c-.27-.68-.7-1.3-1.22-1.8A5 5 0 0 0 23 8h-4a1 1 0 1 1 0-1.99h4ZM8.5 13a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2h-13a1 1 0 0 1-1-1Zm19 6a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06A2.43 2.43 0 0 1 20.42 24h7.16c1.34 0 2.42 1.1 2.42 2.44Z"
]);
const $7972e53b1de568ed$export$d684c0a81b768e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson48Filled', "48", [
    "M44 19.46A10.75 10.75 0 0 0 33.25 9h-4.64a1.75 1.75 0 0 0 .14 3.5h4.74a7.25 7.25 0 0 1 7.01 7.25v.74a7.21 7.21 0 0 1-.89 3.24 7 7 0 0 1 2.07 3.19A10.7 10.7 0 0 0 44 20.25v-.79Zm-23-8.71C21 9.78 20.22 9 19.25 9h-4.79C8.66 9.16 4 13.9 4 19.75v.79C4.16 26.34 8.9 31 14.75 31h4.64a1.75 1.75 0 0 0-.14-3.5h-4.74a7.25 7.25 0 0 1-7.01-7.25v-.74a7.25 7.25 0 0 1 7.25-7.01h4.64c.9-.08 1.61-.83 1.61-1.75Zm13 7.5H13.86a1.75 1.75 0 0 0 .14 3.5h20.14a1.75 1.75 0 0 0-.14-3.5ZM40 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v.5Z"
]);
const $7972e53b1de568ed$export$a38c6723fb193eb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkPerson48Regular', "48", [
    "M44 20a10 10 0 0 0-10-10h-5.88a1.25 1.25 0 0 0 .13 2.5h5.99a7.5 7.5 0 0 1 5.92 11.77 7 7 0 0 1 1.4 2.28A9.96 9.96 0 0 0 44 20Zm-23-8.75c0-.69-.56-1.25-1.25-1.25h-6.03A10 10 0 0 0 14 30h5.88a1.25 1.25 0 0 0-.13-2.5h-5.99a7.5 7.5 0 0 1 .24-15h5.88c.63-.07 1.12-.6 1.12-1.25Zm14 7.5H12.87a1.25 1.25 0 0 0 .13 2.5h22.13a1.25 1.25 0 0 0-.13-2.5ZM40 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v.5Z"
]);
const $7972e53b1de568ed$export$b5ab8edfeb06bec0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettings24Filled', "24", [
    "M10 6a1 1 0 0 0-1-1H6.78A5 5 0 0 0 7 15h2.12A1 1 0 0 0 9 13H6.82A3 3 0 0 1 7 7h2.12A1 1 0 0 0 10 6Zm12 4a5 5 0 0 0-5-5h-2.12A1 1 0 0 0 15 7h2.18a3 3 0 0 1 2.49 4.37c.64.23 1.23.55 1.76.95.36-.7.57-1.48.57-2.32Zm-5-1H6.88A1 1 0 0 0 7 11h10.12A1 1 0 0 0 17 9Zm-4.16 7.47a2 2 0 0 0 1.44-2.5l-.2-.68c.44-.38.94-.7 1.48-.91l.5.52a2 2 0 0 0 2.9 0l.5-.52c.54.23 1.04.54 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a5.73 5.73 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68c-.44.38-.94.7-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5.28 5.28 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a5.72 5.72 0 0 1 0-1.8l.58-.15Zm6.11 1.03c0-.83-.65-1.5-1.45-1.5-.8 0-1.45.67-1.45 1.5S16.7 19 17.5 19c.8 0 1.45-.67 1.45-1.5Z"
]);
const $7972e53b1de568ed$export$8e8332b703692cd8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSettings24Regular', "24", [
    "M9.25 5a.75.75 0 0 1 .11 1.5H7a3.5 3.5 0 0 0-.2 7h2.45a.75.75 0 0 1 .11 1.5H7a5 5 0 0 1-.25-10h2.5ZM17 5a5 5 0 0 1 4.43 7.32 6.5 6.5 0 0 0-1.3-.76A3.5 3.5 0 0 0 17.2 6.5L17 6.5h-2.25a.75.75 0 0 1-.11-1.5H17ZM7 9.25h10a.75.75 0 0 1 .1 1.5H7a.75.75 0 0 1-.1-1.5H7Zm7.28 4.73a2 2 0 0 1-1.44 2.5l-.59.14a5.73 5.73 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64c.44.38.94.7 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5.28 5.28 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a5.72 5.72 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63c-.44-.39-.94-.7-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52c-.54.22-1.04.53-1.48.9l.2.7ZM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19Z"
]);
const $7972e53b1de568ed$export$d05361b31e9df05b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare12Filled', "12", [
    "M1 3.25C1 2 2 1 3.25 1h2.5c1.22 0 2.2.96 2.25 2.16v2.68a2.25 2.25 0 0 1-1.5 2.03V3.25a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5c0 .33.2.6.5.71v1.53a2.25 2.25 0 0 1-2-2.24v-2.5Zm3 5.5C4 9.99 5 11 6.25 11h2.5C9.99 11 11 10 11 8.75v-2.5c0-1.16-.88-2.11-2-2.24v1.53c.3.1.5.38.5.71v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 1-.75-.75V4.13C4.63 4.43 4 5.27 4 6.25v2.5Z"
]);
const $7972e53b1de568ed$export$1bd10b3bef9008b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare12Regular', "12", [
    "M1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2V7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1v1a2 2 0 0 1-2-2V3Zm3 6c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2v1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1V4a2 2 0 0 0-2 2v3Z"
]);
const $7972e53b1de568ed$export$757432f0e5a66227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare16Filled', "16", [
    "M2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5c0 .98-.63 1.81-1.5 2.12V4.25a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75H5V10h-.75C3.01 10 2 9 2 7.75v-3.5Zm4 7.5C6 12.99 7 14 8.25 14h3.5c1.24 0 2.25-1 2.25-2.25v-3.5C14 7.01 13 6 11.75 6H11v1.5h.75c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75h-3.5a.75.75 0 0 1-.75-.75V6.13C6.63 6.43 6 7.27 6 8.25v3.5Z"
]);
const $7972e53b1de568ed$export$772830f113bcc6bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare16Regular', "16", [
    "M4 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h1V9H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm7 4v1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1V6a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-1Z"
]);
const $7972e53b1de568ed$export$5fc818bf5326fd69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare20Filled', "20", [
    "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25H6V13H4.75A2.75 2.75 0 0 1 2 10.25v-5.5A2.75 2.75 0 0 1 4.75 2h5.5A2.75 2.75 0 0 1 13 4.75v5.5A2.75 2.75 0 0 1 10.25 13H9.5v-1.5h.75c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-5.5ZM7 9.75A2.75 2.75 0 0 1 9.75 7h1v1.5h-1c-.69 0-1.25.56-1.25 1.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5c0-.69-.56-1.25-1.25-1.25h-1.5V7h1.5A2.75 2.75 0 0 1 18 9.75v5.5A2.75 2.75 0 0 1 15.25 18h-5.5A2.75 2.75 0 0 1 7 15.25v-5.5Z"
]);
const $7972e53b1de568ed$export$a9ff7d20ed23a3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare20Regular', "20", [
    "M4.5 3C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H6v1H4.5A2.5 2.5 0 0 1 2 10.5v-6A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5H9v-1h1.5c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-6Zm5 4H11v1H9.5C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H14V7h1.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5v-6A2.5 2.5 0 0 1 9.5 7Z"
]);
const $7972e53b1de568ed$export$2cae4b14e0a42c14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare24Filled', "24", [
    "M6.5 3A3.5 3.5 0 0 0 3 6.5v6A3.5 3.5 0 0 0 6.5 16H7v-2h-.5A1.5 1.5 0 0 1 5 12.5v-6C5 5.67 5.67 5 6.5 5h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5H11v2h1.5a3.5 3.5 0 0 0 3.5-3.5v-6A3.5 3.5 0 0 0 12.5 3h-6Zm3.5 8.5c0-.83.67-1.5 1.5-1.5H13V8h-1.5A3.5 3.5 0 0 0 8 11.5v6a3.5 3.5 0 0 0 3.5 3.5h6a3.5 3.5 0 0 0 3.5-3.5v-6A3.5 3.5 0 0 0 17.5 8H17v2h.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-6Z"
]);
const $7972e53b1de568ed$export$72f492535159e05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkSquare24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v6c0 1.8 1.46 3.25 3.25 3.25H7.5V14H6.25c-.97 0-1.75-.78-1.75-1.75v-6c0-.97.78-1.75 1.75-1.75h6c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75H11v1.5h1.25c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25h-6ZM10 11.75c0-.97.78-1.75 1.75-1.75H13V8.5h-1.25a3.25 3.25 0 0 0-3.25 3.25v6c0 1.8 1.46 3.25 3.25 3.25h6c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25H16.5V10h1.25c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-6c-.97 0-1.75-.78-1.75-1.75v-6Z"
]);
const $7972e53b1de568ed$export$4c2c12bb4d2904ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkToolbox20Filled', "20", [
    "M8.75 4.75A.75.75 0 0 0 8 4H5.8a4 4 0 0 0 .2 8h2.1a.75.75 0 0 0-.1-1.5H5.84a2.5 2.5 0 0 1 .16-5h2.1a.75.75 0 0 0 .65-.75ZM18 8a4 4 0 0 0-4-4h-2.1a.75.75 0 0 0 .1 1.5h2.16a2.5 2.5 0 0 1 2.08 3.61c.5.16.93.46 1.24.86.33-.58.52-1.25.52-1.97ZM6.25 7.25h7.5a.75.75 0 0 1 .1 1.5h-7.6a.75.75 0 0 1-.1-1.5h.1ZM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z"
]);
const $7972e53b1de568ed$export$8809e39ad856fe5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('LinkToolbox20Regular', "20", [
    "M8 4a.5.5 0 0 1 .09 1H6a3 3 0 0 0-.2 6H8a.5.5 0 0 1 .09 1H6a4 4 0 0 1-.22-8H8Zm6 0a4 4 0 0 1 3.48 5.97c-.21-.27-.48-.5-.78-.66A3 3 0 0 0 14.2 5L14 5h-2a.5.5 0 0 1-.09-1H14ZM6 7.5h8a.5.5 0 0 1 .09 1H6a.5.5 0 0 1-.09-1H6Zm6 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z"
]);
const $7972e53b1de568ed$export$cbc2cd2b7bb5a01b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Memory16Filled', "16", [
    "M14.41 4.59A2 2 0 0 0 13 4V2.5a.5.5 0 0 0-.5-.5.5.5 0 0 0-.5.5V4h-2V2.5a.5.5 0 1 0-1 0V4H7V2.5a.5.5 0 1 0-1 0V4H4V2.5a.5.5 0 1 0-1 0V4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v1.5c0 .13.05.26.15.35A.5.5 0 0 0 4 13.5V12h2v1.5c0 .13.05.26.15.35A.5.5 0 0 0 7 13.5V12h2v1.5c0 .13.05.26.15.35a.5.5 0 0 0 .85-.35V12h2v1.5c0 .13.05.26.15.35a.5.5 0 0 0 .85-.35V12a2 2 0 0 0 2-2V6a2 2 0 0 0-.59-1.41ZM13 9.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v3ZM4 9h8V7H4v2Z"
]);
const $7972e53b1de568ed$export$441d0876aa73e5d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Memory16Regular', "16", [
    "M14.41 4.59A2 2 0 0 0 13 4V2.5a.5.5 0 0 0-1 0V4h-2V2.5a.5.5 0 1 0-1 0V4H7V2.5a.5.5 0 1 0-1 0V4H4V2.5a.5.5 0 1 0-1 0V4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2v1.5a.5.5 0 0 0 1 0V12h2v1.5a.5.5 0 0 0 1 0V12h2v1.5a.5.5 0 0 0 1 0V12h2v1.5a.5.5 0 0 0 1 0V12a2 2 0 0 0 2-2V6a2 2 0 0 0-.59-1.41ZM14 10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4Zm-1.5-4h-9a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5ZM12 9H4V7h8v2Z"
]);
const $7972e53b1de568ed$export$67351f07bdf517de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd16Filled', "16", [
    "M8 1a7 7 0 0 1 5.36 11.5h-2.2A5.5 5.5 0 0 0 8 2.5H1.75a.75.75 0 0 1 0-1.5H8Zm0 14A7 7 0 0 1 2.64 3.5h2.2A5.5 5.5 0 0 0 8 13.5h6.25a.75.75 0 0 1 0 1.5H8Zm.75-9.25a.75.75 0 0 0-1.5 0v1.5h-1.5a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5Z"
]);
const $7972e53b1de568ed$export$4fac5ca8c1d9927c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd16Regular', "16", [
    "M1 1.5c0-.28.22-.5.5-.5H8a7.03 7.03 0 0 1 6.84 5.5A7 7 0 0 1 12.9 13h-1.58A6 6 0 0 0 8 2H1.5a.5.5 0 0 1-.5-.5ZM1 8a7 7 0 0 0 7 7h6.5a.5.5 0 0 0 0-1H8a6.02 6.02 0 0 1-6-6 6 6 0 0 1 2.68-5H3.1A6.98 6.98 0 0 0 1 8Zm7-3c.28 0 .5.22.5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2c0-.28.22-.5.5-.5Z"
]);
const $7972e53b1de568ed$export$5096578c2dbf9d71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd20Filled', "20", [
    "M2.75 2a.75.75 0 0 0 0 1.5H10a6.52 6.52 0 0 1 6.5 6.5 6.5 6.5 0 0 1-3.03 5.5h2.34A8 8 0 0 0 10 2H2.75Zm5.6 15.83A8 8 0 0 1 4.19 4.5h2.34a6.5 6.5 0 0 0 3.47 12h7.25a.75.75 0 0 1 0 1.5H10c-.57 0-1.12-.06-1.65-.17ZM10 7c.41 0 .75.34.75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5c0-.41.34-.75.75-.75Z"
]);
const $7972e53b1de568ed$export$35429768b51acc72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd20Regular', "20", [
    "M2 2.5c0-.28.22-.5.5-.5H10a7.98 7.98 0 0 1 5.3 14h-1.7A7 7 0 0 0 10 3H2.5a.5.5 0 0 1-.5-.5ZM10 18A8 8 0 0 1 4.7 4h1.7A7 7 0 0 0 10 17h7.5a.5.5 0 0 1 0 1H10Zm.5-10.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 1 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2Z"
]);
const $7972e53b1de568ed$export$684b11648fee5bf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd24Filled', "24", [
    "M2 3a1 1 0 0 1 1-1h9a10 10 0 0 1 7.14 17h-3.26A8 8 0 0 0 12 4H3a1 1 0 0 1-1-1Zm8.18 18.84c.6.1 1.2.16 1.82.16h9a1 1 0 1 0 0-2h-9A8 8 0 0 1 8.12 5H4.86a10 10 0 0 0 5.32 16.83ZM12 8a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H9a1 1 0 1 1 0-2h2V9a1 1 0 0 1 1-1Z"
]);
const $7972e53b1de568ed$export$e466deb7afeae2ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd24Regular', "24", [
    "M2 2.75c0-.41.34-.75.75-.75H12a10 10 0 0 1 6.61 17.5h-2.6A8.5 8.5 0 0 0 12 3.5H2.75A.75.75 0 0 1 2 2.75Zm8.36 19.12c.53.08 1.08.13 1.64.13h9.25a.75.75 0 0 0 0-1.5H12a8.5 8.5 0 0 1-4-16H5.39a10 10 0 0 0 4.98 17.37ZM12 8c.41 0 .75.34.75.75v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5c0-.41.34-.75.75-.75Z"
]);
const $7972e53b1de568ed$export$979e72591e743af9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd32Filled', "32", [
    "M2 3.25C2 2.56 2.56 2 3.25 2H16a14 14 0 0 1 9.8 24h-4.12A11.5 11.5 0 0 0 16 4.5H3.25C2.56 4.5 2 3.94 2 3.25ZM2 16a13.94 13.94 0 0 0 2.04 7.29A14 14 0 0 0 16 30h11.75a1.25 1.25 0 1 0 0-2.5H16A11.5 11.5 0 0 1 10.32 6H6.2A13.96 13.96 0 0 0 2 16Zm14-6c.69 0 1.25.56 1.25 1.25v3.5h3.5a1.25 1.25 0 1 1 0 2.5h-3.5v3.5a1.25 1.25 0 1 1-2.5 0v-3.5h-3.5a1.25 1.25 0 1 1 0-2.5h3.5v-3.5c0-.69.56-1.25 1.25-1.25Z"
]);
const $7972e53b1de568ed$export$43673a089203cf70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('RemixAdd32Regular', "32", [
    "M2 3a1 1 0 0 1 1-1h13a14 14 0 0 1 9.26 24.5h-3.45A12 12 0 0 0 16 4H3a1 1 0 0 1-1-1Zm0 13a13.95 13.95 0 0 0 1.28 5.85A14 14 0 0 0 16 30h13a1 1 0 1 0 0-2H16a12 12 0 0 1-5.81-22.5H6.74A13.97 13.97 0 0 0 2 16Zm14-6a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4h-4a1 1 0 1 1 0-2h4v-4a1 1 0 0 1 1-1Z"
]);
const $7972e53b1de568ed$export$568585a28f6e8796 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote16Filled', "16", [
    "M13.8 3.26a.75.75 0 1 0-1.1-1.02l-4 4.25a.75.75 0 0 0 0 1.02l4 4.25a.75.75 0 1 0 1.1-1.02L10.28 7l3.52-3.74Zm-10.5.98a.75.75 0 1 0-1.1 1.02L5.72 9 2.2 12.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25Z"
]);
const $7972e53b1de568ed$export$37ab5357f8b722b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote16Regular', "16", [
    "M13.85 2.85a.5.5 0 0 0-.7-.7l-4.5 4.5a.5.5 0 0 0 0 .7l4.5 4.5a.5.5 0 0 0 .7-.7L9.71 7l4.14-4.15Zm-11 1.3a.5.5 0 1 0-.7.7L6.29 9l-4.14 4.15a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7l-4.5-4.5Z"
]);
const $7972e53b1de568ed$export$760a94ac13bee930 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote20Filled', "20", [
    "M16.97 15.03a.75.75 0 1 0 1.06-1.06L12.56 8.5l5.47-5.47a.75.75 0 0 0-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06l6 6ZM3.03 4.97a.75.75 0 0 0-1.06 1.06l5.47 5.47-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6c.3-.3.3-.77 0-1.06l-6-6Z"
]);
const $7972e53b1de568ed$export$ef4467a9cf061563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Remote20Regular', "20", [
    "M17.15 14.85a.5.5 0 0 0 .7-.7L12.21 8.5l5.64-5.65a.5.5 0 0 0-.7-.7l-6 6a.5.5 0 0 0 0 .7l6 6Zm-14.3-9.7a.5.5 0 1 0-.7.7l5.64 5.65-5.64 5.65a.5.5 0 0 0 .7.7l6-6a.5.5 0 0 0 0-.7l-6-6Z"
]);
const $7972e53b1de568ed$export$8017c91d6b17c2da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut20Filled', "20", [
    "M11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11V3.5Zm-2.5 7.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm4 4.75H12v-5h1v4.5a.5.5 0 0 1-.5.5ZM12 8V4h.5c.28 0 .5.22.5.5V8h-1Z"
]);
const $7972e53b1de568ed$export$f7c6ac52f3ea7a12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut20Regular', "20", [
    "M8.5 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11V3.5Zm-1 .58v11.84L4 15V5l6-.92ZM12.5 16H12v-5h1v4.5a.5.5 0 0 1-.5.5ZM12 8V4h.5c.28 0 .5.22.5.5V8h-1Z"
]);
const $7972e53b1de568ed$export$45ef50a7922e9d88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut24Filled', "24", [
    "M12 4.35V11h7.44l-1.72-1.72a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07l.08.07 3 3c.26.26.29.68.07.97l-.07.09-3 3a.75.75 0 0 1-1.13-.97l.07-.09 1.71-1.72H12v6.75c0 .47-.42.82-.88.74l-8.5-1.5a.75.75 0 0 1-.62-.74v-12c0-.37.27-.68.63-.74l8.5-1.4c.46-.07.87.28.87.74ZM8.5 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4.5 7h.87a.75.75 0 0 0 .65-.75l-.01-4.25H13v5Zm0-8.5V5h.75c.37 0 .69.28.74.65v.1L14.5 10H13Z"
]);
const $7972e53b1de568ed$export$e3aa6cff83390753 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SignOut24Regular', "24", [
    "M8.5 11.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 4.35V11h7.44l-1.72-1.72a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07l.08.07 3 3c.26.26.29.68.07.97l-.07.09-3 3a.75.75 0 0 1-1.13-.97l.07-.09 1.71-1.72H12v6.75c0 .47-.42.82-.88.74l-8.5-1.5a.75.75 0 0 1-.62-.74v-12c0-.37.27-.68.63-.74l8.5-1.4c.46-.07.87.28.87.74Zm-1.5.89-7 1.15v10.73l7 1.24V5.24ZM13 18.5h.87a.75.75 0 0 0 .65-.75l-.01-4.25H13v5Zm0-8.5V5h.75c.37 0 .69.28.74.65v.1L14.5 10H13Z"
]);
const $7972e53b1de568ed$export$de35447401ae8b38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature16Filled', "16", [
    "M12.48 1.77a2.44 2.44 0 0 0-3.46 0L2.4 8.4a.5.5 0 0 0-.12.2l-1.25 3.74a.5.5 0 0 0 .6.65l4-1a.5.5 0 0 0 .22-.14l5.65-5.64.09.08a1 1 0 0 1 0 1.42l-1.44 1.44a.5.5 0 0 0 .7.7l1.44-1.44a2 2 0 0 0 0-2.82l-.08-.09.27-.27c.95-.96.95-2.5 0-3.46ZM4.97 15c-1.24 0-2.21-.57-2.86-1.1l1.29-.33c.44.25.97.43 1.57.43.4 0 .82-.16 1.27-.46.44-.29.87-.68 1.31-1.1l.11-.1c.39-.36.79-.74 1.17-1 .4-.27.95-.53 1.52-.3.37.14.62.4.79.73.16.3.27.69.38 1.1.05.2.13.38.23.5.04.06.08.1.11.12l.04.01c.12 0 .33-.08.63-.29.19-.12.34-.25.5-.37l.3-.24a4.76 4.76 0 0 1 .98-.56l.02-.01h.01l.16.47-.16-.47a.5.5 0 0 1 .32.94l-.03.02-.15.06c-.13.07-.32.18-.55.35l-.22.17c-.18.15-.4.33-.62.47-.3.21-.74.46-1.19.46a1.2 1.2 0 0 1-.95-.52c-.2-.25-.33-.57-.4-.85a4.4 4.4 0 0 0-.3-.9c-.09-.16-.17-.23-.26-.26-.08-.03-.25-.04-.6.2-.31.21-.65.53-1.06.91l-.1.1c-.43.4-.92.85-1.45 1.2-.52.35-1.14.62-1.81.62Z"
]);
const $7972e53b1de568ed$export$8658fab8dcce1b53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature16Regular', "16", [
    "M9.02 1.77a2.44 2.44 0 0 1 3.46 3.46l-.27.27.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-5.65 5.64a.5.5 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65L2.29 8.6a.5.5 0 0 1 .12-.2l6.62-6.62Zm2.75.7a1.44 1.44 0 0 0-2.04 0L3.19 9.03l-.93 2.77 2.98-.74 6.53-6.53c.57-.56.57-1.48 0-2.04ZM4.97 15c-1.24 0-2.21-.57-2.86-1.1l1.29-.33c.44.25.97.43 1.57.43.4 0 .82-.16 1.27-.46.44-.29.87-.68 1.31-1.1l.11-.1c.39-.36.79-.74 1.17-1 .4-.27.95-.53 1.52-.3.37.14.62.4.79.73.16.3.27.69.38 1.1.05.2.13.38.23.5.04.06.08.1.11.12l.04.01c.12 0 .33-.08.63-.29.19-.12.34-.25.5-.37l.3-.24a4.76 4.76 0 0 1 .98-.56l.02-.01h.01l.16.47-.16-.47a.5.5 0 0 1 .32.94l-.03.02-.15.06c-.13.07-.32.18-.55.35l-.22.17c-.18.15-.4.33-.62.47-.3.21-.74.46-1.19.46a1.2 1.2 0 0 1-.95-.52c-.2-.25-.33-.57-.4-.85a4.4 4.4 0 0 0-.3-.9c-.09-.16-.17-.23-.26-.26-.08-.03-.25-.04-.6.2-.31.21-.65.53-1.06.91l-.1.1c-.43.4-.92.85-1.45 1.2-.52.35-1.14.62-1.81.62Z"
]);
const $7972e53b1de568ed$export$93f3d91e0dcca555 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature20Filled', "20", [
    "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a.5.5 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a.5.5 0 0 1 .12-.2l8.62-8.62ZM3.27 16.9c-.02 0-.04-.02-.05-.03l1.35-.34c.53.27 1.18.47 1.93.47.5 0 1.01-.18 1.53-.47.53-.3 1.03-.7 1.53-1.1l.13-.11c.44-.36.9-.74 1.34-1 .47-.27 1.04-.49 1.63-.3.82.28 1.08 1.04 1.32 1.84.05.18.15.36.26.49.11.12.2.15.26.15.19 0 .46-.1.8-.3a9.43 9.43 0 0 0 .93-.62 5.6 5.6 0 0 1 1.1-.55h.03l.14.47-.14-.48a.5.5 0 0 1 .28.96 2.74 2.74 0 0 0-.21.08 4.6 4.6 0 0 0-.92.54l-.7.46a2.7 2.7 0 0 1-1.31.44c-.44 0-.78-.23-1-.49a2.33 2.33 0 0 1-.48-.87c-.26-.87-.41-1.08-.68-1.17-.16-.05-.4-.02-.8.22-.37.21-.77.54-1.23.92l-.12.1c-.5.4-1.06.84-1.66 1.19-.6.34-1.29.6-2.03.6a5.49 5.49 0 0 1-3.23-1.1Z"
]);
const $7972e53b1de568ed$export$7102775a33860f22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature20Regular', "20", [
    "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a.5.5 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a.5.5 0 0 1 .12-.2l8.62-8.62Zm2.75.7a1.44 1.44 0 0 0-2.04 0l-8.54 8.55-.93 2.77 2.98-.74 8.53-8.53c.57-.56.57-1.48 0-2.04ZM3.22 16.88l.05.03C4 17.44 5.1 18 6.5 18c.74 0 1.42-.26 2.03-.6.6-.35 1.16-.8 1.66-1.2l.12-.1c.46-.37.86-.7 1.23-.91.4-.24.64-.27.8-.22.27.1.42.3.68 1.17.09.3.24.61.47.87.23.26.57.49 1.01.49.47 0 .94-.23 1.3-.44a12.61 12.61 0 0 0 .97-.64 4.6 4.6 0 0 1 .82-.42l.04-.02h.01a.5.5 0 0 0-.28-.96h-.01l-.02.01a2.35 2.35 0 0 0-.31.12c-.2.09-.47.22-.8.43l-.33.23c-.19.13-.38.26-.6.39-.33.2-.6.3-.79.3-.06 0-.15-.03-.26-.15-.11-.13-.2-.31-.26-.5-.24-.8-.5-1.55-1.32-1.82-.59-.2-1.16.02-1.63.3-.44.25-.9.63-1.34.99l-.13.1c-.5.41-1 .8-1.53 1.1-.52.3-1.02.48-1.53.48-.75 0-1.4-.2-1.93-.47l-1.35.34ZM17.5 15.5l-.14-.48.14.48Z"
]);
const $7972e53b1de568ed$export$9cbbb54110437f30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature24Filled', "24", [
    "M14.75 16.5c1.3 0 1.82.58 2.2 1.87l.07.24c.19.66.3.86.52.95.26.1.43.09.7-.05l.15-.08.17-.11.67-.46c.61-.4 1.17-.67 1.84-.84a.75.75 0 1 1 .36 1.46c-.4.1-.76.25-1.14.49l-.3.19-.48.33c-.23.15-.4.26-.58.35a2.2 2.2 0 0 1-1.96.1c-.75-.3-1.05-.78-1.33-1.72l-.16-.54c-.18-.59-.3-.68-.73-.68-.3 0-.63.16-1.07.52l-.18.16-.92.88c-1.41 1.32-2.61 1.97-4.33 1.97-1.69 0-3.15-.26-4.37-.77l2.95-.8c.45.04.92.07 1.42.07 1.18 0 2.03-.42 3.09-1.37l.25-.24.54-.5a12 12 0 0 1 .59-.55c.68-.57 1.3-.87 2.03-.87Zm4.28-13.53a3.58 3.58 0 0 1 0 5.06l-.29.29c1.15 1.4 1.11 2.89.04 3.96l-2 2a.75.75 0 0 1-1.06-1.06l2-2c.48-.49.54-1.09-.04-1.84L9.06 18c-.27.28-.62.48-1 .58l-5.11 1.4a.75.75 0 0 1-.92-.93l1.4-5.11c.1-.38.3-.72.57-1l9.97-9.97a3.58 3.58 0 0 1 5.06 0Z"
]);
const $7972e53b1de568ed$export$603d858711029590 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature24Regular', "24", [
    "M14.75 16.5c1.3 0 1.82.58 2.2 1.87l.07.24c.19.66.3.86.52.95.26.1.43.09.7-.05l.15-.08.17-.11.67-.46c.61-.4 1.17-.67 1.84-.84a.75.75 0 1 1 .36 1.46c-.4.1-.76.25-1.14.49l-.3.19-.48.33c-.23.15-.4.26-.58.35a2.2 2.2 0 0 1-1.96.1c-.75-.3-1.05-.78-1.33-1.72l-.16-.54c-.18-.59-.3-.68-.73-.68-.3 0-.63.16-1.07.52l-.18.16-.92.88c-1.41 1.32-2.61 1.97-4.33 1.97-1.69 0-3.15-.26-4.37-.77l2.95-.8c.45.04.92.07 1.42.07 1.18 0 2.03-.42 3.09-1.37l.25-.24.54-.5a12 12 0 0 1 .59-.55c.68-.57 1.3-.87 2.03-.87Zm4.28-13.53a3.58 3.58 0 0 1 0 5.06l-.29.29c1.15 1.4 1.11 2.89.04 3.96l-2 2a.75.75 0 0 1-1.06-1.06l2-2c.48-.49.54-1.09-.04-1.84L9.06 18c-.27.28-.62.48-1 .58l-5.11 1.4a.75.75 0 0 1-.92-.93l1.4-5.11c.1-.38.3-.72.57-1l9.97-9.97a3.58 3.58 0 0 1 5.06 0Zm-4 1.06L5.06 14c-.09.1-.16.2-.19.33l-1.05 3.85 3.85-1.05c.13-.03.24-.1.33-.2l9.97-9.96a2.08 2.08 0 1 0-2.94-2.94Z"
]);
const $7972e53b1de568ed$export$59c9feb2af9f84a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature28Filled', "28", [
    "M16.48 21h.27c1.22 0 1.86.5 2.65 1.7l.4.61c.3.46.5.65.74.75.43.18.79.09 2.1-.55l.4-.2a9.8 9.8 0 0 1 2.03-.79.75.75 0 1 1 .36 1.46 7 7 0 0 0-1.27.47l-1.15.55c-1.57.74-2.1.83-3.05.44-.62-.25-.98-.63-1.5-1.42l-.2-.3c-.6-.95-.9-1.22-1.5-1.22h-.17c-.43.03-.71.23-2.58 1.61-1.74 1.3-3.07 1.92-4.76 1.92-2.06 0-4-.38-5.82-1.14l2.88-.67c.95.2 1.93.3 2.94.3 1.29 0 2.36-.5 3.87-1.61l1.16-.86c1.27-.92 1.55-1.03 2.2-1.05Zm6.3-17.78a4.29 4.29 0 0 1 0 6.06l-1.04 1.04c1.15 1.4 1.11 2.89.04 3.96l-3 3a.75.75 0 1 1-1.06-1.06l3-3c.48-.49.54-1.09-.04-1.84l-10.6 10.6c-.3.3-.67.5-1.08.6l-6.08 1.4a.75.75 0 0 1-.9-.9L3.42 17c.1-.41.3-.79.6-1.08l12.7-12.7a4.29 4.29 0 0 1 6.06 0Z"
]);
const $7972e53b1de568ed$export$c7a44917cc963d0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature28Regular', "28", [
    "M16.48 21h.27c1.22 0 1.86.5 2.65 1.7l.4.61c.3.46.5.65.74.75.43.18.79.09 2.1-.55l.4-.2a9.8 9.8 0 0 1 2.03-.79.75.75 0 1 1 .36 1.46 7 7 0 0 0-1.27.47l-1.15.55c-1.57.74-2.1.83-3.05.44-.62-.25-.98-.63-1.5-1.42l-.2-.3c-.55-.9-.85-1.18-1.4-1.22h-.1c-.56 0-.67.07-2.75 1.61-1.74 1.3-3.07 1.92-4.76 1.92-2.06 0-4-.38-5.82-1.14l2.88-.67c.95.2 1.93.3 2.94.3 1.29 0 2.36-.5 3.87-1.61l1.16-.86c1.27-.92 1.55-1.03 2.2-1.05Zm6.3-17.78a4.29 4.29 0 0 1 0 6.06l-1.04 1.04c1.15 1.4 1.11 2.89.04 3.96l-3 3a.75.75 0 1 1-1.06-1.06l3-3c.48-.49.54-1.09-.04-1.84l-10.6 10.6c-.3.3-.67.5-1.08.6l-6.08 1.4a.75.75 0 0 1-.9-.9L3.42 17c.1-.41.3-.79.6-1.08l12.7-12.7a4.29 4.29 0 0 1 6.06 0Zm-5 1.06-12.7 12.7c-.1.1-.16.22-.2.36l-1.13 4.9 4.91-1.12c.14-.04.27-.1.36-.2l12.7-12.7a2.79 2.79 0 0 0-3.94-3.94Z"
]);
const $7972e53b1de568ed$export$25991def0078110c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature32Filled', "32", [
    "M24.54 3.46a5 5 0 0 0-7.07 0L4.39 16.54a3 3 0 0 0-.8 1.45l-1.56 6.79a1 1 0 0 0 1.2 1.2L10 24.41a3 3 0 0 0 1.45-.8l10.87-10.88.2.2a1.5 1.5 0 0 1 0 2.12l-3.24 3.23a1 1 0 0 0 1.42 1.42l3.23-3.23a3.5 3.5 0 0 0 0-4.95l-.2-.2.8-.8a5 5 0 0 0 0-7.07ZM8.56 29.9a8.76 8.76 0 0 1-4.71-2.53l2.42-.55c.7.5 1.61.93 2.62 1.1 1.54.27 3.43-.07 5.4-2.03a33.28 33.28 0 0 1 2.85-2.57c.78-.6 1.5-1.05 2.19-1.23.76-.2 1.5-.08 2.09.44.5.45.8 1.12 1.03 1.78l.03.1c.41 1.22.62 1.84.83 2.22.1.17.16.24.2.28.05.03.13.08.3.14 0 0 .12.04.45-.13.32-.17.7-.45 1.18-.83l.27-.22c.38-.3.8-.65 1.23-.94a5.65 5.65 0 0 1 1.82-.9 1 1 0 0 1 .48 1.94c-.32.08-.7.28-1.16.6-.36.25-.7.53-1.08.83l-.31.25c-.47.37-1 .78-1.52 1.05a2.55 2.55 0 0 1-2.92-.25c-.3-.24-.51-.53-.69-.85-.3-.55-.56-1.34-.92-2.38l-.09-.27c-.2-.59-.36-.83-.46-.92-.02-.02-.05-.06-.24 0-.3.07-.76.31-1.48.87-.7.55-1.58 1.34-2.67 2.41-2.42 2.4-4.94 2.96-7.14 2.59Z"
]);
const $7972e53b1de568ed$export$b9a43e68d5e123d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature32Light', "32", [
    "M17.9 3.39a4.74 4.74 0 1 1 6.7 6.7l-.65.67.02.03a3.5 3.5 0 0 1 0 4.95l-3.11 3.11a.5.5 0 1 1-.71-.7l3.12-3.12a2.5 2.5 0 0 0 0-3.53l-.03-.03-11.95 11.95c-.45.45-1 .76-1.62.92l-6.42 1.62a1 1 0 0 1-1.22-1.21l1.63-6.43a3.5 3.5 0 0 1 .92-1.61L17.9 3.39Zm6 .7a3.74 3.74 0 0 0-5.3 0L5.3 17.42a2.5 2.5 0 0 0-.66 1.16L3 25l6.42-1.63a2.5 2.5 0 0 0 1.16-.66L23.9 9.4a3.74 3.74 0 0 0 0-5.3ZM4 27.33c.38.36.81.71 1.28 1.03A8.8 8.8 0 0 0 10 30c1.22 0 2.4-.45 3.46-1.08a19.35 19.35 0 0 0 2.96-2.23c.35-.31.68-.61.98-.9.5-.44.94-.85 1.34-1.18.32-.26.59-.44.8-.55.1-.05.18-.07.24-.08a.25.25 0 0 1 .06 0c.25.08.46.29.66.69.17.34.3.74.45 1.2l.1.28c.35 1.07.86 2.47 2.33 2.84.64.16 1.2.03 1.71-.23.48-.25.93-.64 1.36-1l.02-.02c.88-.75 1.78-1.52 3.11-1.75a.5.5 0 1 0-.16-.98 7.17 7.17 0 0 0-3.55 1.93l-.07.06c-.45.38-.81.68-1.17.87-.34.17-.65.23-1 .14-.88-.21-1.25-1.03-1.63-2.17l-.09-.26c-.15-.46-.3-.95-.51-1.36a2.2 2.2 0 0 0-1.24-1.2c-.38-.12-.76 0-1.06.15-.32.15-.65.4-1 .67-.41.34-.9.78-1.4 1.25l-.94.85c-.88.77-1.82 1.54-2.8 2.12-.99.58-1.98.94-2.96.94a7.8 7.8 0 0 1-4.16-1.48 9.56 9.56 0 0 1-.67-.5l-1.17.3Zm-1.97-2.57.49.12-.49-.12Z"
]);
const $7972e53b1de568ed$export$e41a7cdf33a2bc27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Signature32Regular', "32", [
    "M17.47 3.46a5 5 0 1 1 7.07 7.08l-.8.79.2.2a3.5 3.5 0 0 1 0 4.95L20.7 19.7a1 1 0 1 1-1.42-1.42l3.23-3.23a1.5 1.5 0 0 0 0-2.12l-.2-.2-10.86 10.88a3 3 0 0 1-1.45.8l-6.79 1.55a1 1 0 0 1-1.2-1.2L3.59 18a3 3 0 0 1 .8-1.45L17.48 3.46Zm5.65 1.42a3 3 0 0 0-4.24 0L5.8 17.96a1 1 0 0 0-.27.48l-1.2 5.23 5.23-1.2a1 1 0 0 0 .48-.27L23.12 9.12a3 3 0 0 0 0-4.24ZM8.56 29.9a8.76 8.76 0 0 1-4.71-2.53l2.42-.55c.7.5 1.61.93 2.62 1.1 1.54.27 3.43-.07 5.4-2.03a33.28 33.28 0 0 1 2.85-2.57c.78-.6 1.5-1.05 2.19-1.23.76-.2 1.5-.08 2.09.44.5.45.8 1.12 1.03 1.78l.03.1c.41 1.22.62 1.84.83 2.22.1.17.16.24.2.28.05.03.13.08.3.14 0 0 .12.04.45-.13.32-.17.7-.45 1.18-.83l.27-.22c.38-.3.8-.65 1.23-.94a5.65 5.65 0 0 1 1.82-.9 1 1 0 0 1 .48 1.94c-.32.08-.7.28-1.16.6-.36.25-.7.53-1.08.83l-.31.25c-.47.37-1 .78-1.52 1.05a2.55 2.55 0 0 1-2.92-.25c-.3-.24-.51-.53-.69-.85-.3-.55-.56-1.34-.92-2.38l-.09-.27c-.2-.59-.36-.83-.46-.92-.02-.02-.05-.06-.24 0-.3.07-.76.31-1.48.87-.7.55-1.58 1.34-2.67 2.41-2.42 2.4-4.94 2.96-7.14 2.59Z"
]);


const $b11634e761ce411b$export$ea2f5cb61d899ae6 = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $7972e53b1de568ed$export$27ee5ac8ab5ded84), (0, $7972e53b1de568ed$export$515949b0e3098366));
const $b11634e761ce411b$export$57e1bf38e1f55571 = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $7972e53b1de568ed$export$994e675395c5ac42), (0, $7972e53b1de568ed$export$fb9cc08986d6ea9a));
const $b11634e761ce411b$export$7ed1b62a96a5843e = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $7972e53b1de568ed$export$6faa23478c869acb), (0, $7972e53b1de568ed$export$92e1c56f07f9445f));



function $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd(parent, child) {
    if (!parent || !child) return false;
    if (parent === child) return true;
    else {
        // Tracks references of nodes that have been visited to prevent infinite loops
        const set = new WeakSet();
        while(child){
            const nextParent = (0, $a84b79cd75c90fa5$export$58081aedf094d85b)(child, {
                skipVirtual: set.has(child)
            });
            set.add(child);
            if (nextParent === parent) return true;
            child = nextParent;
        }
    }
    return false;
}


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


'use client';
const $090a6633426263f1$var$DEFAULT_CONTAINS = (parent, child)=>!!(parent === null || parent === void 0 ? void 0 : parent.contains(child));
const $090a6633426263f1$export$9afc64c180e82dc4 = (options)=>{
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const win = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView;
    const { refs: refs, callback: callback, element: element, disabled: disabled, disabledFocusOnIframe: disabledFocusOnIframe, contains: contains = $090a6633426263f1$var$DEFAULT_CONTAINS } = options;
    const timeoutId = $acw62.useRef(undefined);
    $090a6633426263f1$var$useIFrameFocus({
        element: element,
        disabled: disabledFocusOnIframe || disabled,
        callback: callback,
        refs: refs,
        contains: contains
    });
    const isMouseDownInsideRef = $acw62.useRef(false);
    const listener = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        if (isMouseDownInsideRef.current) {
            isMouseDownInsideRef.current = false;
            return;
        }
        const target = ev.composedPath()[0];
        const isOutside = refs.every((ref)=>!contains(ref.current || null, target));
        if (isOutside && !disabled) callback(ev);
    });
    const handleMouseDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        // Selecting text from inside to outside will rigger click event.
        // In this case click event target is outside but mouse down event target is inside.
        // And this click event should be considered as inside click.
        isMouseDownInsideRef.current = refs.some((ref)=>contains(ref.current || null, ev.target));
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        // Store the current event to avoid triggering handlers immediately
        // Note this depends on a deprecated but extremely well supported quirk of the web platform
        // https://github.com/facebook/react/issues/20074
        let currentEvent = $090a6633426263f1$var$getWindowEvent(win);
        const conditionalHandler = (event)=>{
            // Skip if this event is the same as the one running when we added the handlers
            if (event === currentEvent) {
                currentEvent = undefined;
                return;
            }
            listener(event);
        };
        // use capture phase because React can update DOM before the event bubbles to the document
        element === null || element === void 0 || element.addEventListener('click', conditionalHandler, true);
        element === null || element === void 0 || element.addEventListener('touchstart', conditionalHandler, true);
        element === null || element === void 0 || element.addEventListener('contextmenu', conditionalHandler, true);
        element === null || element === void 0 || element.addEventListener('mousedown', handleMouseDown, true);
        // Garbage collect this event after it's no longer useful to avoid memory leaks
        timeoutId.current = win === null || win === void 0 ? void 0 : win.setTimeout(()=>{
            currentEvent = undefined;
        }, 1);
        return ()=>{
            element === null || element === void 0 || element.removeEventListener('click', conditionalHandler, true);
            element === null || element === void 0 || element.removeEventListener('touchstart', conditionalHandler, true);
            element === null || element === void 0 || element.removeEventListener('contextmenu', conditionalHandler, true);
            element === null || element === void 0 || element.removeEventListener('mousedown', handleMouseDown, true);
            win === null || win === void 0 || win.clearTimeout(timeoutId.current);
            currentEvent = undefined;
        };
    }, [
        listener,
        element,
        disabled,
        handleMouseDown,
        win
    ]);
};
const $090a6633426263f1$var$getWindowEvent = (target)=>{
    if (target) {
        var _target_ownerDocument_defaultView, _target_ownerDocument;
        if (typeof target.window === 'object' && target.window === target) // eslint-disable-next-line @typescript-eslint/no-deprecated
        return target.event;
        var _target_ownerDocument_defaultView_event;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        return (_target_ownerDocument_defaultView_event = (_target_ownerDocument = target.ownerDocument) === null || _target_ownerDocument === void 0 ? void 0 : (_target_ownerDocument_defaultView = _target_ownerDocument.defaultView) === null || _target_ownerDocument_defaultView === void 0 ? void 0 : _target_ownerDocument_defaultView.event) !== null && _target_ownerDocument_defaultView_event !== void 0 ? _target_ownerDocument_defaultView_event : undefined;
    }
    return undefined;
};
const $090a6633426263f1$var$FUI_FRAME_EVENT = 'fuiframefocus';
/**
 * Since click events do not propagate past iframes, we use focus to detect if a
 * click has happened inside an iframe, since the only ways of focusing inside an
 * iframe are:
 *   - clicking inside
 *   - tabbing inside
 *
 * Polls the value of `document.activeElement`. If it is an iframe, then dispatch
 * a custom DOM event. When the custom event is received call the provided callback
 */ const $090a6633426263f1$var$useIFrameFocus = (options)=>{
    const { disabled: disabled, element: targetDocument, callback: callback, contains: contains = $090a6633426263f1$var$DEFAULT_CONTAINS, pollDuration: pollDuration = 100, refs: refs } = options;
    const timeoutRef = $acw62.useRef(undefined);
    const listener = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        const isOutside = refs.every((ref)=>!contains(ref.current || null, e.target));
        if (isOutside && !disabled) callback(e);
    });
    // Adds listener to the custom iframe focus event
    $acw62.useEffect(()=>{
        if (disabled) return;
        targetDocument === null || targetDocument === void 0 || targetDocument.addEventListener($090a6633426263f1$var$FUI_FRAME_EVENT, listener, true);
        return ()=>{
            targetDocument === null || targetDocument === void 0 || targetDocument.removeEventListener($090a6633426263f1$var$FUI_FRAME_EVENT, listener, true);
        };
    }, [
        targetDocument,
        disabled,
        listener
    ]);
    // Starts polling for the active element
    $acw62.useEffect(()=>{
        var _targetDocument_defaultView;
        if (disabled) return;
        timeoutRef.current = targetDocument === null || targetDocument === void 0 ? void 0 : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.setInterval(()=>{
            const activeElement = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.activeElement;
            if ((activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) === 'IFRAME' || (activeElement === null || activeElement === void 0 ? void 0 : activeElement.tagName) === 'WEBVIEW') {
                const event = new CustomEvent($090a6633426263f1$var$FUI_FRAME_EVENT, {
                    bubbles: true
                });
                activeElement.dispatchEvent(event);
            }
        }, pollDuration);
        return ()=>{
            var _targetDocument_defaultView;
            targetDocument === null || targetDocument === void 0 || (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 || _targetDocument_defaultView.clearInterval(timeoutRef.current);
        };
    }, [
        targetDocument,
        disabled,
        pollDuration
    ]);
};


var $acw62 = parcelRequire("acw62");

'use client';
const $8748bb6e2a770b32$export$ee62ea5c36ea709a = (options)=>{
    const { refs: refs, callback: callback, element: element, disabled: disabled, contains: containsProp } = options;
    const listener = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((ev)=>{
        const contains = containsProp || ((parent, child)=>!!(parent === null || parent === void 0 ? void 0 : parent.contains(child)));
        const target = ev.composedPath()[0];
        const isOutside = refs.every((ref)=>!contains(ref.current || null, target));
        if (isOutside && !disabled) callback(ev);
    });
    $acw62.useEffect(()=>{
        if (disabled) return;
        element === null || element === void 0 || element.addEventListener('wheel', listener);
        element === null || element === void 0 || element.addEventListener('touchmove', listener);
        return ()=>{
            element === null || element === void 0 || element.removeEventListener('wheel', listener);
            element === null || element === void 0 || element.removeEventListener('touchmove', listener);
        };
    }, [
        listener,
        element,
        disabled
    ]);
};



'use client';
function $4f638fdc3c53bf8c$export$fef5d4d23735b493(userOffset, arrowHeight) {
    if (typeof userOffset === 'number') return $4f638fdc3c53bf8c$var$addArrowOffset(userOffset, arrowHeight);
    if (typeof userOffset === 'object' && userOffset !== null) return $4f638fdc3c53bf8c$var$addArrowOffset(userOffset, arrowHeight);
    if (typeof userOffset === 'function') return (offsetParams)=>{
        const offset = userOffset(offsetParams);
        return $4f638fdc3c53bf8c$var$addArrowOffset(offset, arrowHeight);
    };
    return {
        mainAxis: arrowHeight
    };
}
const $4f638fdc3c53bf8c$var$addArrowOffset = (offset, arrowHeight)=>{
    if (typeof offset === 'number') return {
        mainAxis: offset + arrowHeight
    };
    var _offset_mainAxis;
    return {
        ...offset,
        mainAxis: ((_offset_mainAxis = offset.mainAxis) !== null && _offset_mainAxis !== void 0 ? _offset_mainAxis : 0) + arrowHeight
    };
};

// Look up table for shorthand to avoid parsing strings
const $ab5990c77a5c99b2$var$shorthandLookup = {
    above: {
        position: 'above',
        align: 'center'
    },
    'above-start': {
        position: 'above',
        align: 'start'
    },
    'above-end': {
        position: 'above',
        align: 'end'
    },
    below: {
        position: 'below',
        align: 'center'
    },
    'below-start': {
        position: 'below',
        align: 'start'
    },
    'below-end': {
        position: 'below',
        align: 'end'
    },
    before: {
        position: 'before',
        align: 'center'
    },
    'before-top': {
        position: 'before',
        align: 'top'
    },
    'before-bottom': {
        position: 'before',
        align: 'bottom'
    },
    after: {
        position: 'after',
        align: 'center'
    },
    'after-top': {
        position: 'after',
        align: 'top'
    },
    'after-bottom': {
        position: 'after',
        align: 'bottom'
    }
};
function $ab5990c77a5c99b2$export$c06895f23267d8a3(shorthand) {
    if (shorthand === undefined || shorthand === null) return {};
    if (typeof shorthand === 'string') return $ab5990c77a5c99b2$var$shorthandLookup[shorthand];
    return shorthand;
}



var $acw62 = parcelRequire("acw62");
const $1bc41beff6061826$export$18f93cc75fae324c = 'data-popper-is-intersecting';
const $1bc41beff6061826$export$db3793a183377cb7 = 'data-popper-escaped';
const $1bc41beff6061826$export$63274a89f08cfb16 = 'data-popper-reference-hidden';
const $1bc41beff6061826$export$b301c2866e7d3d24 = 'data-popper-placement';
const $1bc41beff6061826$export$f663401a4492542c = 'fui-positioningend';
const $1bc41beff6061826$export$d8cee2f3784ae17a = '--fui-positioning-slide-direction-x';
const $1bc41beff6061826$export$9cbb0ef067e89ae6 = '--fui-positioning-slide-direction-y';


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $10310cf078d13212$var$lrPlacement = [
    'left',
    'right'
];
const $10310cf078d13212$var$rlPlacement = [
    'right',
    'left'
];
const $10310cf078d13212$var$tbPlacement = [
    'top',
    'bottom'
];
const $10310cf078d13212$var$btPlacement = [
    'bottom',
    'top'
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    const side = $10310cf078d13212$export$3c915306cb7fc97a(placement);
    return $10310cf078d13212$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $973e4da43f2a375d$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $973e4da43f2a375d$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $973e4da43f2a375d$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $10310cf078d13212$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $10310cf078d13212$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $238ac70369f38756$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $238ac70369f38756$var$containRe = /paint|layout|strict|content/;
const $238ac70369f38756$var$isNotNone = (value)=>!!value && value !== 'none';
let $238ac70369f38756$var$isWebKitValue;
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$isNotNone(css.transform) || $238ac70369f38756$var$isNotNone(css.translate) || $238ac70369f38756$var$isNotNone(css.scale) || $238ac70369f38756$var$isNotNone(css.rotate) || $238ac70369f38756$var$isNotNone(css.perspective) || !$238ac70369f38756$export$78551043582a6a98() && ($238ac70369f38756$var$isNotNone(css.backdropFilter) || $238ac70369f38756$var$isNotNone(css.filter)) || $238ac70369f38756$var$willChangeRe.test(css.willChange || '') || $238ac70369f38756$var$containRe.test(css.contain || '');
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if ($238ac70369f38756$var$isWebKitValue == null) $238ac70369f38756$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $238ac70369f38756$var$isWebKitValue;
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $461947879dcdbcd4$var$SCROLLBAR_MAX = 25;
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $461947879dcdbcd4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $461947879dcdbcd4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $461947879dcdbcd4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, top);
        right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $238ac70369f38756$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



/**
 * Promise microtask debouncer used by Popper.js v2
 * This is no longer exported in Floating UI (Popper.js v3)
 * https://github.com/floating-ui/floating-ui/blob/v2.x/src/utils/debounce.js
 * @param fn function that will be debounced
 */ function $bcc8133f5ab99157$export$61fc7d43ac8f84b0(fn) {
    let pending;
    return ()=>{
        if (!pending) pending = new Promise((resolve)=>{
            Promise.resolve().then(()=>{
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

/**
 * Writes all DOM element updates after position is computed
 */ function $7a07c92faae73d90$export$711a2b3ae6af6e60(options) {
    const { arrow: arrow, middlewareData: middlewareData } = options;
    if (!middlewareData.arrow || !arrow) return;
    const { x: arrowX, y: arrowY } = middlewareData.arrow;
    Object.assign(arrow.style, {
        left: arrowX !== null && arrowX !== undefined ? `${arrowX}px` : '',
        top: arrowY !== null && arrowY !== undefined ? `${arrowY}px` : ''
    });
}


function $ec7dd1615eef7a1d$export$d75dade18d09f343(options) {
    var _middlewareData_hide, _middlewareData_hide1, _container_ownerDocument_defaultView;
    const { container: container, placement: placement, middlewareData: middlewareData, strategy: strategy, lowPPI: lowPPI, coordinates: coordinates, useTransform: useTransform = true } = options;
    if (!container) return;
    container.setAttribute((0, $1bc41beff6061826$export$b301c2866e7d3d24), placement);
    container.removeAttribute((0, $1bc41beff6061826$export$18f93cc75fae324c));
    if (middlewareData.intersectionObserver.intersecting) container.setAttribute((0, $1bc41beff6061826$export$18f93cc75fae324c), '');
    container.removeAttribute((0, $1bc41beff6061826$export$db3793a183377cb7));
    if ((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.escaped) container.setAttribute((0, $1bc41beff6061826$export$db3793a183377cb7), '');
    container.removeAttribute((0, $1bc41beff6061826$export$63274a89f08cfb16));
    if ((_middlewareData_hide1 = middlewareData.hide) === null || _middlewareData_hide1 === void 0 ? void 0 : _middlewareData_hide1.referenceHidden) container.setAttribute((0, $1bc41beff6061826$export$63274a89f08cfb16), '');
    // Round so that the coordinates land on device pixels.
    // This prevents blurriness in cases where the browser doesn't apply pixel snapping, such as when other effects like
    // `backdrop-filter: blur()` are applied to the container, and the browser is zoomed in.
    // See https://github.com/microsoft/fluentui/issues/26764 for more info.
    const devicePixelRatio = ((_container_ownerDocument_defaultView = container.ownerDocument.defaultView) === null || _container_ownerDocument_defaultView === void 0 ? void 0 : _container_ownerDocument_defaultView.devicePixelRatio) || 1;
    const x = Math.round(coordinates.x * devicePixelRatio) / devicePixelRatio;
    const y = Math.round(coordinates.y * devicePixelRatio) / devicePixelRatio;
    Object.assign(container.style, {
        position: strategy
    });
    if (useTransform) {
        Object.assign(container.style, {
            transform: lowPPI ? `translate(${x}px, ${y}px)` : `translate3d(${x}px, ${y}px, 0)`
        });
        return;
    }
    Object.assign(container.style, {
        left: `${x}px`,
        top: `${y}px`
    });
}


/**
 * Returns the parent node or the host of the node argument.
 * @param node - DOM node.
 * @returns - parent DOM node.
 */ 'use client';
const $e515cff1a47b86b6$export$4e12058fc4d51d56 = (node)=>{
    if (node.nodeName === 'HTML') return node;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return node.parentNode || node.host;
};
const $e515cff1a47b86b6$export$e1697824cae8c971 = (node)=>{
    var _node_ownerDocument;
    if (node.nodeType !== 1) return {};
    const targetWindow = (_node_ownerDocument = node.ownerDocument) === null || _node_ownerDocument === void 0 ? void 0 : _node_ownerDocument.defaultView;
    if (targetWindow) return targetWindow.getComputedStyle(node, null);
    return {};
};
const $e515cff1a47b86b6$export$cfa2225e87938781 = (node)=>{
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    const parentNode = node && $e515cff1a47b86b6$export$4e12058fc4d51d56(node);
    // eslint-disable-next-line
    if (!parentNode) return document.body;
    switch(parentNode.nodeName){
        case 'HTML':
        case 'BODY':
            return parentNode.ownerDocument.body;
        case '#document':
            return parentNode.body;
    }
    // If any of the overflow props is defined for the node then we return it as the parent
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY } = $e515cff1a47b86b6$export$e1697824cae8c971(parentNode);
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return parentNode;
    return $e515cff1a47b86b6$export$cfa2225e87938781(parentNode);
};
const $e515cff1a47b86b6$export$4cb81e0871943e44 = (node)=>{
    var _scrollParentElement_ownerDocument;
    const scrollParentElement = $e515cff1a47b86b6$export$cfa2225e87938781(node);
    return scrollParentElement ? scrollParentElement !== ((_scrollParentElement_ownerDocument = scrollParentElement.ownerDocument) === null || _scrollParentElement_ownerDocument === void 0 ? void 0 : _scrollParentElement_ownerDocument.body) : false;
};


function $fd919ccf2ea75239$export$a3eb7ad9381d72(node) {
    const scrollParents = [];
    let cur = node;
    while(cur){
        const scrollParent = (0, $e515cff1a47b86b6$export$cfa2225e87938781)(cur);
        if (node.ownerDocument.body === scrollParent) {
            scrollParents.push(scrollParent);
            break;
        }
        if (scrollParent.nodeName === 'BODY' && scrollParent !== node.ownerDocument.body) break;
        scrollParents.push(scrollParent);
        cur = scrollParent;
    }
    return scrollParents;
}



function $6d24f1ed2c4b15f4$export$1c0b3b43c08b019d(targetWindow, callback) {
    return new targetWindow.ResizeObserver(callback);
}


function $10f45662864422ce$export$3b0153980f731a95(options) {
    let isDestroyed = false;
    const { container: container, target: target, arrow: arrow, strategy: strategy, middleware: middleware, placement: placement, useTransform: useTransform = true, disableUpdateOnResize: disableUpdateOnResize = false } = options;
    const targetWindow = container.ownerDocument.defaultView;
    if (!target || !container || !targetWindow) return {
        updatePosition: ()=>undefined,
        dispose: ()=>undefined
    };
    // When the dimensions of the target or the container change - trigger a position update
    const resizeObserver = disableUpdateOnResize ? null : (0, $6d24f1ed2c4b15f4$export$1c0b3b43c08b019d)(targetWindow, (entries)=>{
        // If content rect dimensions to go 0 -> very likely that `display: none` is being used to hide the element
        // In this case don't update and let users update imperatively
        const shouldUpdateOnResize = entries.every((entry)=>{
            return entry.contentRect.width > 0 && entry.contentRect.height > 0;
        });
        if (shouldUpdateOnResize) updatePosition();
    });
    let isFirstUpdate = true;
    const scrollParents = new Set();
    // When the container is first resolved, set position `fixed` to avoid scroll jumps.
    // Without this scroll jumps can occur when the element is rendered initially and receives focus
    Object.assign(container.style, {
        position: 'fixed',
        left: 0,
        top: 0,
        margin: 0
    });
    const forceUpdate = ()=>{
        // debounced update can still occur afterwards
        // early return to avoid memory leaks
        if (isDestroyed) return;
        if (isFirstUpdate) {
            (0, $fd919ccf2ea75239$export$a3eb7ad9381d72)(container).forEach((scrollParent)=>scrollParents.add(scrollParent));
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(target)) (0, $fd919ccf2ea75239$export$a3eb7ad9381d72)(target).forEach((scrollParent)=>scrollParents.add(scrollParent));
            scrollParents.forEach((scrollParent)=>{
                scrollParent.addEventListener('scroll', updatePosition, {
                    passive: true
                });
            });
            resizeObserver === null || resizeObserver === void 0 || resizeObserver.observe(container);
            if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(target)) resizeObserver === null || resizeObserver === void 0 || resizeObserver.observe(target);
            isFirstUpdate = false;
        }
        Object.assign(container.style, {
            position: strategy
        });
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(target, container, {
            placement: placement,
            middleware: middleware,
            strategy: strategy
        }).then(({ x: x, y: y, middlewareData: middlewareData, placement: computedPlacement })=>{
            // Promise can still resolve after destruction
            // early return to avoid applying outdated position
            if (isDestroyed) return;
            (0, $7a07c92faae73d90$export$711a2b3ae6af6e60)({
                arrow: arrow,
                middlewareData: middlewareData
            });
            (0, $ec7dd1615eef7a1d$export$d75dade18d09f343)({
                container: container,
                middlewareData: middlewareData,
                placement: computedPlacement,
                coordinates: {
                    x: x,
                    y: y
                },
                lowPPI: ((targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.devicePixelRatio) || 1) <= 1,
                strategy: strategy,
                useTransform: useTransform
            });
            container.dispatchEvent(new CustomEvent((0, $1bc41beff6061826$export$f663401a4492542c), {
                detail: {
                    // Cast from Floating UI's Placement to the Fluent-owned PositioningPlacement.
                    // These are equivalent string unions; the cast avoids leaking @floating-ui/dom
                    // types into the public API surface.
                    placement: computedPlacement
                }
            }));
        }).catch((err)=>{});
    };
    const updatePosition = (0, $bcc8133f5ab99157$export$61fc7d43ac8f84b0)(()=>forceUpdate());
    const dispose = ()=>{
        isDestroyed = true;
        if (targetWindow) {
            targetWindow.removeEventListener('scroll', updatePosition);
            targetWindow.removeEventListener('resize', updatePosition);
        }
        scrollParents.forEach((scrollParent)=>{
            scrollParent.removeEventListener('scroll', updatePosition);
        });
        scrollParents.clear();
        resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
    };
    if (targetWindow) {
        targetWindow.addEventListener('scroll', updatePosition, {
            passive: true
        });
        targetWindow.addEventListener('resize', updatePosition);
    }
    // Update the position on initialization
    updatePosition();
    return {
        updatePosition: updatePosition,
        dispose: dispose
    };
}


/**
 * @internal
 */ const $ee15f01cf7c6286b$var$CONTROLLER = '__FUIDT_CONTROLLER__';
/**
 * @internal
 */ const $ee15f01cf7c6286b$var$ELEMENT_METADATA = '__FUIDT_ELEMENT_METADATA__';
/**
 * @internal
 */ const $ee15f01cf7c6286b$var$HTML_ELEMENT_REFERENCE = '__FUIDT_HTML_ELEMENT_REFERENCE__';
/**
 * @internal
 */ const $ee15f01cf7c6286b$var$SERIALIZED_DATA_CHANGE = '__FUIDT_SERIALIZED_DATA_CHANGE__';
/**
 * Verifies if a given node is an HTMLElement,
 * this method works seamlessly with frames and elements from different documents
 *
 * This is preferred over simply using `instanceof`.
 * Since `instanceof` might be problematic while operating with [multiple realms](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/instanceof#instanceof_and_multiple_realms)
 *
 * @example
 * ```ts
 * isHTMLElement(event.target) && event.target.focus()
 * isHTMLElement(event.target, {constructorName: 'HTMLInputElement'}) && event.target.value // some value
 * ```
 *
 */ function $ee15f01cf7c6286b$var$isHTMLElement(element, options) {
    var _typedElement$ownerDo, _options$constructorN;
    const typedElement = element;
    return Boolean((typedElement == null || (_typedElement$ownerDo = typedElement.ownerDocument) == null ? void 0 : _typedElement$ownerDo.defaultView) && typedElement instanceof typedElement.ownerDocument.defaultView[_options$constructorN = void 0, 'HTMLElement']);
}
/**
 * @internal
 */ const $ee15f01cf7c6286b$var$isHTMLElementWithMetadata = (element)=>Boolean($ee15f01cf7c6286b$var$isHTMLElement(element) && $ee15f01cf7c6286b$var$ELEMENT_METADATA in element && element.parentElement !== null);
const $ee15f01cf7c6286b$var$createController = (defaultView)=>{
    let selectedElement = null;
    const observer = new MutationObserver((mutations)=>{
        if (!selectedElement) return;
        for (const mutation of mutations)if (mutation.type === 'childList' && Array.from(mutation.removedNodes).includes(selectedElement)) controller.withdraw();
    });
    const controller = {
        get selectedElement () {
            return selectedElement;
        },
        select: (nextSelectedElement)=>{
            if ($ee15f01cf7c6286b$var$isHTMLElementWithMetadata(nextSelectedElement)) {
                selectedElement = nextSelectedElement;
                observer.observe(nextSelectedElement.parentElement, {
                    childList: true,
                    subtree: false
                });
            }
            if (selectedElement && nextSelectedElement) {
                const metadata = selectedElement[$ee15f01cf7c6286b$var$ELEMENT_METADATA];
                if (metadata.references.has(nextSelectedElement)) return selectedElement;
            }
            controller.withdraw();
            return selectedElement;
        },
        withdraw: ()=>{
            selectedElement = null;
            observer.disconnect();
            defaultView.postMessage($ee15f01cf7c6286b$var$SERIALIZED_DATA_CHANGE);
        }
    };
    return controller;
};
const $ee15f01cf7c6286b$var$injectController = (_ref)=>{
    let { defaultView: defaultView } = _ref;
    if (!defaultView) return;
    if (!defaultView[$ee15f01cf7c6286b$var$CONTROLLER]) defaultView[$ee15f01cf7c6286b$var$CONTROLLER] = $ee15f01cf7c6286b$var$createController(defaultView);
};
const $ee15f01cf7c6286b$var$getController = (targetDocument)=>{
    var _targetDocument$defau, _targetDocument$defau2;
    $ee15f01cf7c6286b$var$injectController(targetDocument);
    return (_targetDocument$defau = (_targetDocument$defau2 = targetDocument.defaultView) == null ? void 0 : _targetDocument$defau2[$ee15f01cf7c6286b$var$CONTROLLER]) != null ? _targetDocument$defau : null;
};
const $ee15f01cf7c6286b$var$serialize = (data, references)=>{
    const serializedData = JSON.parse(JSON.stringify(data, (_, value)=>{
        if ($ee15f01cf7c6286b$var$isHTMLElement(value)) return references.add(value);
        if (typeof value === 'object' && value && Object.getPrototypeOf(value) !== Object.prototype && Object.getPrototypeOf(value) !== Array.prototype) {
            if ('toString' in value) return value.toString();
            return undefined;
        }
        return value;
    }));
    return serializedData;
};
let $ee15f01cf7c6286b$var$counter = 0;
const $ee15f01cf7c6286b$var$generateReferenceId = ()=>$ee15f01cf7c6286b$var$HTML_ELEMENT_REFERENCE + ":" + $ee15f01cf7c6286b$var$counter++;
const $ee15f01cf7c6286b$var$createReferences = ()=>{
    const map = new Map();
    const weakMap = new WeakMap();
    const references = {
        add: (element)=>{
            if (weakMap.has(element)) return weakMap.get(element);
            const id = $ee15f01cf7c6286b$var$generateReferenceId();
            map.set(id, element);
            weakMap.set(element, id);
            return id;
        },
        get: (id)=>{
            const element = map.get(id);
            if (element && weakMap.has(element)) return element;
        },
        has: (element)=>{
            return weakMap.has(element);
        }
    };
    return references;
};
/**
 * devtools middleware
 * @public
 */ const $ee15f01cf7c6286b$export$6922d3b3a607469e = function(targetDocument, middlewareDataCallback) {
    if (targetDocument === void 0) targetDocument = document;
    if (middlewareDataCallback === void 0) middlewareDataCallback = $ee15f01cf7c6286b$var$floatingUIMiddlewareDataCallback;
    return {
        name: '@floating-ui/devtools',
        fn: (state)=>{
            const { [$ee15f01cf7c6286b$var$ELEMENT_METADATA]: metadata } = $ee15f01cf7c6286b$var$isHTMLElementWithMetadata(state.elements.floating) ? state.elements.floating : Object.assign(state.elements.floating, {
                [$ee15f01cf7c6286b$var$ELEMENT_METADATA]: {
                    references: $ee15f01cf7c6286b$var$createReferences(),
                    serializedData: []
                }
            });
            const serializedData = $ee15f01cf7c6286b$var$serialize(middlewareDataCallback(state), metadata.references);
            metadata.serializedData.unshift(serializedData);
            const controller = $ee15f01cf7c6286b$var$getController(targetDocument);
            if (metadata.serializedData.length > 1 && state.elements.floating === (controller == null ? void 0 : controller.selectedElement)) {
                var _targetDocument$defau;
                (_targetDocument$defau = targetDocument.defaultView) == null || _targetDocument$defau.postMessage($ee15f01cf7c6286b$var$SERIALIZED_DATA_CHANGE);
            }
            return {};
        }
    };
};
const $ee15f01cf7c6286b$var$floatingUIMiddlewareDataCallback = (state)=>({
        ...state,
        type: 'FloatingUIMiddleware'
    });





var $acw62 = parcelRequire("acw62");
/**
 * Parses Floating UI placement and returns the different components
 * @param placement - the floating ui placement (i.e. bottom-start)
 *
 * @returns side and alignment components of the placement
 */ function $5d7daea11695cb50$export$84066e57d1671351(placement) {
    const tokens = placement.split('-');
    return {
        side: tokens[0],
        alignment: tokens[1]
    };
}


function $f21d8008604c3594$export$bc121fb05ccba5fd() {
    return {
        name: 'coverTarget',
        fn: (middlewareArguments)=>{
            const { placement: placement, rects: rects, x: x, y: y } = middlewareArguments;
            const basePlacement = (0, $5d7daea11695cb50$export$84066e57d1671351)(placement).side;
            const newCoords = {
                x: x,
                y: y
            };
            switch(basePlacement){
                case 'bottom':
                    newCoords.y -= rects.reference.height;
                    break;
                case 'top':
                    newCoords.y += rects.reference.height;
                    break;
                case 'left':
                    newCoords.x += rects.reference.width;
                    break;
                case 'right':
                    newCoords.x -= rects.reference.width;
                    break;
            }
            return newCoords;
        }
    };
}



function $9784e2fc818dfbcc$export$c9eba72a6709d7a3(element, boundary) {
    if (boundary === 'window') return element === null || element === void 0 ? void 0 : element.ownerDocument.documentElement;
    if (boundary === 'clippingParents') return 'clippingAncestors';
    if (boundary === 'scrollParent') {
        let boundariesNode = (0, $e515cff1a47b86b6$export$cfa2225e87938781)(element);
        if (boundariesNode.nodeName === 'BODY') boundariesNode = element === null || element === void 0 ? void 0 : element.ownerDocument.documentElement;
        return boundariesNode;
    }
    return boundary;
}

const $7940a40b7ec26b4c$var$getPositionMap = (rtl)=>({
        above: 'top',
        below: 'bottom',
        before: rtl ? 'right' : 'left',
        after: rtl ? 'left' : 'right'
    });
// Floating UI automatically flips alignment
// https://github.com/floating-ui/floating-ui/issues/1563
const $7940a40b7ec26b4c$var$getAlignmentMap = ()=>({
        start: 'start',
        end: 'end',
        top: 'start',
        bottom: 'end',
        center: undefined
    });
const $7940a40b7ec26b4c$var$shouldAlignToCenter = (p, a)=>{
    const positionedVertically = p === 'above' || p === 'below';
    const alignedVertically = a === 'top' || a === 'bottom';
    return positionedVertically && alignedVertically || !positionedVertically && !alignedVertically;
};
const $7940a40b7ec26b4c$export$70b0694e84cc93ec = (align, position, rtl)=>{
    const alignment = $7940a40b7ec26b4c$var$shouldAlignToCenter(position, align) ? 'center' : align;
    const computedPosition = position && $7940a40b7ec26b4c$var$getPositionMap(rtl)[position];
    const computedAlignment = alignment && $7940a40b7ec26b4c$var$getAlignmentMap()[alignment];
    if (computedPosition && computedAlignment) return `${computedPosition}-${computedAlignment}`;
    return computedPosition;
};


function $0a76753505471a91$export$8a83211c878a3f1f(options) {
    const { hasScrollableElement: hasScrollableElement, flipBoundary: flipBoundary, container: container, fallbackPositions: fallbackPositions = [], isRtl: isRtl } = options;
    const fallbackPlacements = fallbackPositions.reduce((acc, shorthand)=>{
        const { position: position, align: align } = (0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(shorthand);
        const placement = (0, $7940a40b7ec26b4c$export$70b0694e84cc93ec)(align, position, isRtl);
        if (placement) acc.push(placement);
        return acc;
    }, []);
    return (0, $461947879dcdbcd4$export$8a83211c878a3f1f)({
        ...hasScrollableElement && {
            boundary: 'clippingAncestors'
        },
        ...flipBoundary && {
            altBoundary: true,
            boundary: (0, $9784e2fc818dfbcc$export$c9eba72a6709d7a3)(container, flipBoundary)
        },
        fallbackStrategy: 'bestFit',
        ...fallbackPlacements.length && {
            fallbackPlacements: fallbackPlacements
        }
    });
}


function $3d42e14dbd78712d$export$4fbe37c24af0fe3() {
    return {
        name: 'intersectionObserver',
        fn: async (middlewareArguments)=>{
            const floatingRect = middlewareArguments.rects.floating;
            const altOverflow = await (0, $461947879dcdbcd4$export$37b6bde19b108ecc)(middlewareArguments, {
                altBoundary: true
            });
            const isIntersectingTop = altOverflow.top < floatingRect.height && altOverflow.top > 0;
            const isIntersectingBottom = altOverflow.bottom < floatingRect.height && altOverflow.bottom > 0;
            const isIntersecting = isIntersectingTop || isIntersectingBottom;
            return {
                data: {
                    intersecting: isIntersecting
                }
            };
        }
    };
}

const $42ed931fb16d27cb$export$7e23759dcf6b2f2b = '--fui-match-target-size';
function $42ed931fb16d27cb$export$76bfd61eff29b426() {
    return {
        name: 'matchTargetSize',
        fn: async (middlewareArguments)=>{
            const { rects: { reference: referenceRect, floating: floatingRect }, elements: { floating: floatingElement }, middlewareData: { matchTargetSize: { matchTargetSizeAttempt: matchTargetSizeAttempt = false } = {} } } = middlewareArguments;
            if (referenceRect.width === floatingRect.width || matchTargetSizeAttempt) return {};
            const { width: width } = referenceRect;
            floatingElement.style.setProperty($42ed931fb16d27cb$export$7e23759dcf6b2f2b, `${width}px`);
            if (!floatingElement.style.width) floatingElement.style.width = `var(${$42ed931fb16d27cb$export$7e23759dcf6b2f2b})`;
            return {
                data: {
                    matchTargetSizeAttempt: true
                },
                reset: {
                    rects: true
                }
            };
        }
    };
}



function $418961ea2f17ecf4$export$b2df6fd8f0508393(padding, isRtl) {
    if (typeof padding === 'number') return padding;
    const { start: start, end: end, ...verticalPadding } = padding;
    const paddingObject = verticalPadding;
    const left = isRtl ? 'end' : 'start';
    const right = isRtl ? 'start' : 'end';
    // assign properties explicitly since undefined values are actually handled by floating UI
    // TODO create floating UI issue
    if (padding[left]) paddingObject.left = padding[left];
    if (padding[right]) paddingObject.right = padding[right];
    return paddingObject;
}


const $c2da2e5908a16b1f$export$7cafc617ede8cfa1 = (autoSize)=>({
        name: 'resetMaxSize',
        fn ({ middlewareData: middlewareData, elements: elements }) {
            var _middlewareData_resetMaxSize;
            if ((_middlewareData_resetMaxSize = middlewareData.resetMaxSize) === null || _middlewareData_resetMaxSize === void 0 ? void 0 : _middlewareData_resetMaxSize.maxSizeAlreadyReset) return {};
            const { applyMaxWidth: applyMaxWidth, applyMaxHeight: applyMaxHeight } = autoSize;
            if (applyMaxWidth) {
                elements.floating.style.removeProperty('box-sizing');
                elements.floating.style.removeProperty('max-width');
                elements.floating.style.removeProperty('width');
            }
            if (applyMaxHeight) {
                elements.floating.style.removeProperty('box-sizing');
                elements.floating.style.removeProperty('max-height');
                elements.floating.style.removeProperty('height');
            }
            return {
                data: {
                    maxSizeAlreadyReset: true
                },
                reset: {
                    rects: true
                }
            };
        }
    });
function $c2da2e5908a16b1f$export$e121b7707a6fdbfa(autoSize, options) {
    const { container: container, overflowBoundary: overflowBoundary, overflowBoundaryPadding: overflowBoundaryPadding, isRtl: isRtl } = options;
    return (0, $461947879dcdbcd4$export$346677f925de839c)({
        ...overflowBoundaryPadding && {
            padding: (0, $418961ea2f17ecf4$export$b2df6fd8f0508393)(overflowBoundaryPadding, isRtl)
        },
        ...overflowBoundary && {
            altBoundary: true,
            boundary: (0, $9784e2fc818dfbcc$export$c9eba72a6709d7a3)(container, overflowBoundary)
        },
        apply ({ availableHeight: availableHeight, availableWidth: availableWidth, elements: elements, rects: rects }) {
            const applyMaxSizeStyles = (apply, dimension, availableSize)=>{
                if (!apply) return;
                elements.floating.style.setProperty('box-sizing', 'border-box');
                elements.floating.style.setProperty(`max-${dimension}`, `${availableSize}px`);
                if (rects.floating[dimension] > availableSize) {
                    elements.floating.style.setProperty(dimension, `${availableSize}px`);
                    const axis = dimension === 'width' ? 'x' : 'y';
                    if (!elements.floating.style.getPropertyValue(`overflow-${axis}`)) elements.floating.style.setProperty(`overflow-${axis}`, 'auto');
                }
            };
            const { applyMaxWidth: applyMaxWidth, applyMaxHeight: applyMaxHeight } = autoSize;
            applyMaxSizeStyles(applyMaxWidth, 'width', availableWidth);
            applyMaxSizeStyles(applyMaxHeight, 'height', availableHeight);
        }
    });
}



const $c239dfc32dd96645$var$getPositionMap = ()=>({
        top: 'above',
        bottom: 'below',
        right: 'after',
        left: 'before'
    });
// Floating UI automatically flips alignment
// https://github.com/floating-ui/floating-ui/issues/1563
const $c239dfc32dd96645$var$getAlignmentMap = (position)=>{
    if (position === 'above' || position === 'below') return {
        start: 'start',
        end: 'end'
    };
    return {
        start: 'top',
        end: 'bottom'
    };
};
const $c239dfc32dd96645$export$90406cf3e6e1d68c = (placement)=>{
    const { side: side, alignment: floatingUIAlignment } = (0, $5d7daea11695cb50$export$84066e57d1671351)(placement);
    const position = $c239dfc32dd96645$var$getPositionMap()[side];
    const alignment = floatingUIAlignment && $c239dfc32dd96645$var$getAlignmentMap(position)[floatingUIAlignment];
    return {
        position: position,
        alignment: alignment
    };
};


function $efd287bc14f882e0$export$1f06a4ae906dbabc(rawOffset) {
    if (!rawOffset) return rawOffset;
    if (typeof rawOffset === 'number' || typeof rawOffset === 'object') return rawOffset;
    return ({ rects: { floating: floating, reference: reference }, placement: placement })=>{
        const { position: position, alignment: alignment } = (0, $c239dfc32dd96645$export$90406cf3e6e1d68c)(placement);
        return rawOffset({
            positionedRect: floating,
            targetRect: reference,
            position: position,
            alignment: alignment
        });
    };
}


function $1d6a29ef94a430aa$export$cc800923e997bb8(offsetValue) {
    const floatingUIOffset = (0, $efd287bc14f882e0$export$1f06a4ae906dbabc)(offsetValue);
    return (0, $461947879dcdbcd4$export$cc800923e997bb8)(floatingUIOffset);
}



function $592f66020b8c60c7$export$fba63a578e423eb(options) {
    const { hasScrollableElement: hasScrollableElement, shiftToCoverTarget: shiftToCoverTarget, disableTether: disableTether, overflowBoundary: overflowBoundary, container: container, overflowBoundaryPadding: overflowBoundaryPadding, isRtl: isRtl } = options;
    return (0, $461947879dcdbcd4$export$fba63a578e423eb)({
        ...hasScrollableElement && {
            boundary: 'clippingAncestors'
        },
        ...shiftToCoverTarget && {
            crossAxis: true,
            limiter: (0, $461947879dcdbcd4$export$7bf07e38f3dc4b69)({
                crossAxis: true,
                mainAxis: false
            })
        },
        ...disableTether && {
            crossAxis: disableTether === 'all',
            limiter: (0, $461947879dcdbcd4$export$7bf07e38f3dc4b69)({
                crossAxis: disableTether !== 'all',
                mainAxis: false
            })
        },
        ...overflowBoundaryPadding && {
            padding: (0, $418961ea2f17ecf4$export$b2df6fd8f0508393)(overflowBoundaryPadding, isRtl)
        },
        ...overflowBoundary && {
            altBoundary: true,
            boundary: (0, $9784e2fc818dfbcc$export$c9eba72a6709d7a3)(container, overflowBoundary)
        }
    });
}


/**
 * AutoSizes contains many options from historic implementation.
 * Now options 'always'/'height-always'/'width-always' are obsolete.
 * This function maps them to true/'height'/'width'
 */ const $b5626e25a174fab6$export$df3e4d039c7bd0e9 = (autoSize)=>{
    switch(autoSize){
        case 'always':
        case true:
            return {
                applyMaxWidth: true,
                applyMaxHeight: true
            };
        case 'width-always':
        case 'width':
            return {
                applyMaxWidth: true,
                applyMaxHeight: false
            };
        case 'height-always':
        case 'height':
            return {
                applyMaxWidth: false,
                applyMaxHeight: true
            };
        default:
            return false;
    }
};




var $acw62 = parcelRequire("acw62");
'use client';
// ---
const $4811ac60e3af8c67$var$DEFAULT_CONFIGURATION = ({ options: options })=>{
    return options;
};
// ---
const $4811ac60e3af8c67$var$PositioningConfigurationContext = $acw62.createContext(undefined);
const $4811ac60e3af8c67$export$48c0b97fe1a4961b = $4811ac60e3af8c67$var$PositioningConfigurationContext.Provider;
const $4811ac60e3af8c67$export$a9c86432286e6813 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($4811ac60e3af8c67$var$PositioningConfigurationContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $4811ac60e3af8c67$var$DEFAULT_CONFIGURATION;
};


'use client';
/**
 * @internal
 *
 * This is redundant and exists only to manage React dependencies properly & avoid leaking individual options to the
 * scope of `usePositioningOptions`.
 */ function $55ce4aaa90243706$var$usePositioningConfigFn(configFn, options) {
    const { align: align, arrowPadding: arrowPadding, autoSize: autoSize, coverTarget: coverTarget, disableUpdateOnResize: disableUpdateOnResize, flipBoundary: flipBoundary, offset: offset, overflowBoundary: overflowBoundary, pinned: pinned, position: position, unstable_disableTether: unstable_disableTether, strategy: strategy, overflowBoundaryPadding: overflowBoundaryPadding, fallbackPositions: fallbackPositions, useTransform: useTransform, matchTargetSize: matchTargetSize, shiftToCoverTarget: shiftToCoverTarget } = options;
    return $acw62.useCallback((container, arrow)=>{
        return configFn({
            container: container,
            arrow: arrow,
            options: {
                autoSize: autoSize,
                disableUpdateOnResize: disableUpdateOnResize,
                matchTargetSize: matchTargetSize,
                offset: offset,
                strategy: strategy,
                coverTarget: coverTarget,
                flipBoundary: flipBoundary,
                overflowBoundary: overflowBoundary,
                useTransform: useTransform,
                overflowBoundaryPadding: overflowBoundaryPadding,
                pinned: pinned,
                arrowPadding: arrowPadding,
                align: align,
                fallbackPositions: fallbackPositions,
                shiftToCoverTarget: shiftToCoverTarget,
                position: position,
                unstable_disableTether: // eslint-disable-next-line @typescript-eslint/naming-convention
                unstable_disableTether
            }
        });
    }, [
        autoSize,
        disableUpdateOnResize,
        matchTargetSize,
        offset,
        strategy,
        coverTarget,
        flipBoundary,
        overflowBoundary,
        useTransform,
        overflowBoundaryPadding,
        pinned,
        arrowPadding,
        align,
        fallbackPositions,
        shiftToCoverTarget,
        position,
        unstable_disableTether,
        configFn
    ]);
}
function $55ce4aaa90243706$export$820081cf79526185(options) {
    const { dir: dir, targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const isRtl = dir === 'rtl';
    const configFn = $55ce4aaa90243706$var$usePositioningConfigFn((0, $4811ac60e3af8c67$export$a9c86432286e6813)(), options);
    const { positionFixed: positionFixed } = options;
    return $acw62.useCallback((container, arrow)=>{
        const hasScrollableElement = (0, $e515cff1a47b86b6$export$4cb81e0871943e44)(container);
        const optionsAfterEnhancement = configFn(container, arrow);
        const { autoSize: autoSize, disableUpdateOnResize: disableUpdateOnResize, matchTargetSize: matchTargetSize, offset: offset, coverTarget: coverTarget, flipBoundary: flipBoundary, overflowBoundary: overflowBoundary, useTransform: useTransform, overflowBoundaryPadding: overflowBoundaryPadding, pinned: pinned, position: position, arrowPadding: arrowPadding, strategy: strategy, align: align, fallbackPositions: fallbackPositions, shiftToCoverTarget: shiftToCoverTarget, unstable_disableTether: unstable_disableTether } = optionsAfterEnhancement;
        const normalizedAutoSize = (0, $b5626e25a174fab6$export$df3e4d039c7bd0e9)(autoSize);
        const middleware = [
            normalizedAutoSize && (0, $c2da2e5908a16b1f$export$7cafc617ede8cfa1)(normalizedAutoSize),
            matchTargetSize && (0, $42ed931fb16d27cb$export$76bfd61eff29b426)(),
            offset && (0, $1d6a29ef94a430aa$export$cc800923e997bb8)(offset),
            coverTarget && (0, $f21d8008604c3594$export$bc121fb05ccba5fd)(),
            !pinned && (0, $0a76753505471a91$export$8a83211c878a3f1f)({
                container: container,
                flipBoundary: flipBoundary,
                hasScrollableElement: hasScrollableElement,
                isRtl: isRtl,
                fallbackPositions: fallbackPositions
            }),
            (0, $592f66020b8c60c7$export$fba63a578e423eb)({
                container: container,
                hasScrollableElement: hasScrollableElement,
                overflowBoundary: overflowBoundary,
                disableTether: unstable_disableTether,
                overflowBoundaryPadding: overflowBoundaryPadding,
                isRtl: isRtl,
                shiftToCoverTarget: shiftToCoverTarget
            }),
            normalizedAutoSize && (0, $c2da2e5908a16b1f$export$e121b7707a6fdbfa)(normalizedAutoSize, {
                container: container,
                overflowBoundary: overflowBoundary,
                overflowBoundaryPadding: overflowBoundaryPadding,
                isRtl: isRtl
            }),
            (0, $3d42e14dbd78712d$export$4fbe37c24af0fe3)(),
            arrow && (0, $461947879dcdbcd4$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            (0, $461947879dcdbcd4$export$fe8985bb6374093c)({
                strategy: 'referenceHidden'
            }),
            (0, $461947879dcdbcd4$export$fe8985bb6374093c)({
                strategy: 'escaped'
            }),
            false
        ].filter(Boolean);
        const placement = (0, $7940a40b7ec26b4c$export$70b0694e84cc93ec)(align, position, isRtl);
        return {
            placement: placement,
            middleware: middleware,
            strategy: (strategy !== null && strategy !== void 0 ? strategy : positionFixed) ? 'fixed' : 'absolute',
            disableUpdateOnResize: disableUpdateOnResize,
            useTransform: useTransform
        };
    }, [
        configFn,
        isRtl,
        targetDocument,
        positionFixed
    ]);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $73ed5348e2751387$export$25bec8c6f54ee79a(initialValue, callback, skipInitialResolve) {
    const isFirst = $acw62.useRef(true);
    const [ref] = $acw62.useState(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        if (skipInitialResolve && isFirst.current) return;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        isFirst.current = false;
    }, []);
    // update callback
    ref.callback = callback;
    return ref.facade;
}


'use client';
function $52c6e5e426b327c0$export$76e597284ffc020(options) {
    'use no memo';
    const managerRef = $acw62.useRef(null);
    const targetRef = $acw62.useRef(null);
    const overrideTargetRef = $acw62.useRef(null);
    const containerRef = $acw62.useRef(null);
    const arrowRef = $acw62.useRef(null);
    const { enabled: enabled = true } = options;
    const resolvePositioningOptions = (0, $55ce4aaa90243706$export$820081cf79526185)(options);
    const updatePositionManager = $acw62.useCallback(()=>{
        if (managerRef.current) managerRef.current.dispose();
        managerRef.current = null;
        var _overrideTargetRef_current;
        const target = (_overrideTargetRef_current = overrideTargetRef.current) !== null && _overrideTargetRef_current !== void 0 ? _overrideTargetRef_current : targetRef.current;
        if (enabled && (0, $993af50b96092e61$export$71594e8a50f746f4)() && target && containerRef.current) managerRef.current = (0, $10f45662864422ce$export$3b0153980f731a95)({
            container: containerRef.current,
            target: target,
            arrow: arrowRef.current,
            ...resolvePositioningOptions(containerRef.current, arrowRef.current)
        });
    }, [
        enabled,
        resolvePositioningOptions
    ]);
    const setOverrideTarget = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((target)=>{
        overrideTargetRef.current = target;
        updatePositionManager();
    });
    $acw62.useImperativeHandle(options.positioningRef, ()=>({
            updatePosition: ()=>{
                var _managerRef_current;
                return (_managerRef_current = managerRef.current) === null || _managerRef_current === void 0 ? void 0 : _managerRef_current.updatePosition();
            },
            setTarget: (target)=>{
                options.target;
                setOverrideTarget(target);
            }
        }), [
        options.target,
        setOverrideTarget
    ]);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        var _options_target;
        setOverrideTarget((_options_target = options.target) !== null && _options_target !== void 0 ? _options_target : null);
    }, [
        options.target,
        setOverrideTarget
    ]);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        updatePositionManager();
    }, [
        updatePositionManager
    ]);
    var _contentNode_ownerDocument;
    const setTarget = (0, $73ed5348e2751387$export$25bec8c6f54ee79a)(null, (target)=>{
        if (targetRef.current !== target) {
            targetRef.current = target;
            updatePositionManager();
        }
    });
    const onPositioningEnd = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        var _options_onPositioningEnd;
        return (_options_onPositioningEnd = options.onPositioningEnd) === null || _options_onPositioningEnd === void 0 ? void 0 : _options_onPositioningEnd.call(options, e);
    });
    const setContainer = (0, $73ed5348e2751387$export$25bec8c6f54ee79a)(null, (container)=>{
        if (containerRef.current !== container) {
            var _containerRef_current;
            (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 || _containerRef_current.removeEventListener((0, $1bc41beff6061826$export$f663401a4492542c), onPositioningEnd);
            container === null || container === void 0 || container.addEventListener((0, $1bc41beff6061826$export$f663401a4492542c), onPositioningEnd);
            containerRef.current = container;
            updatePositionManager();
        }
    });
    const setArrow = (0, $73ed5348e2751387$export$25bec8c6f54ee79a)(null, (arrow)=>{
        if (arrowRef.current !== arrow) {
            arrowRef.current = arrow;
            updatePositionManager();
        }
    });
    // Let users use callback refs so they feel like 'normal' DOM refs
    return {
        targetRef: setTarget,
        containerRef: setContainer,
        arrowRef: setArrow
    };
}


var $acw62 = parcelRequire("acw62");
/**
 * Creates a virtual element based on the position of a click event
 * Can be used as a target for popper in scenarios such as context menus
 */ function $6f0b845df0e5db1c$export$f818735569cff5ae(nativeEvent) {
    const left = nativeEvent.clientX;
    const top = nativeEvent.clientY;
    const right = left + 1;
    const bottom = top + 1;
    function getBoundingClientRect() {
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom,
            x: left,
            y: top,
            height: 1,
            width: 1
        };
    }
    return {
        getBoundingClientRect: getBoundingClientRect
    };
}


'use client';
const $638f597d0f0765e2$export$5f3472545b83f7fe = (initialState)=>{
    const [virtualElement, setVirtualElement] = $acw62.useState(initialState);
    const setVirtualMouseTarget = (event)=>{
        if (event === undefined || event === null) {
            setVirtualElement(undefined);
            return;
        }
        let mouseevent;
        if (!(event instanceof MouseEvent)) mouseevent = event.nativeEvent;
        else mouseevent = event;
        MouseEvent;
        const contextTarget = (0, $6f0b845df0e5db1c$export$f818735569cff5ae)(mouseevent);
        setVirtualElement(contextTarget);
    };
    return [
        virtualElement,
        setVirtualMouseTarget
    ];
};


var $acw62 = parcelRequire("acw62");


'use client';
function $a9f840906894d8a8$export$38e73b6ffbca39a6(placement) {
    const side = placement.split('-')[0];
    // Default to sliding down from the top side
    let x = 0;
    let y = 1;
    if (side === 'right') {
        x = -1;
        y = 0;
    } else if (side === 'bottom') {
        x = 0;
        y = -1;
    } else if (side === 'left') {
        x = 1;
        y = 0;
    }
    return {
        x: x,
        y: y
    };
}
function $a9f840906894d8a8$export$8ac94e7c1d8a7c08(options) {
    const { targetDocument: targetDocument, onPositioningEnd: onPositioningEnd } = options;
    const handlePositionEnd = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e)=>{
        onPositioningEnd === null || onPositioningEnd === void 0 || onPositioningEnd(e);
        const element = e.target;
        const placement = e.detail.placement;
        if (!(0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(element)) return;
        const { x: x, y: y } = $a9f840906894d8a8$export$38e73b6ffbca39a6(placement);
        element.style.setProperty((0, $1bc41beff6061826$export$d8cee2f3784ae17a), `${x}px`);
        element.style.setProperty((0, $1bc41beff6061826$export$9cbb0ef067e89ae6), `${y}px`);
    });
    // Register the CSS custom properties so they can be interpolated during animations.
    // CSS.registerProperty is idempotent — the try/catch handles the case where
    // properties are already registered.
    $acw62.useEffect(()=>{
        var _targetDocument_defaultView_CSS, _targetDocument_defaultView;
        var _targetDocument_defaultView_CSS_registerProperty;
        const registerProperty = (_targetDocument_defaultView_CSS_registerProperty = targetDocument === null || targetDocument === void 0 ? void 0 : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : (_targetDocument_defaultView_CSS = _targetDocument_defaultView.CSS) === null || _targetDocument_defaultView_CSS === void 0 ? void 0 : _targetDocument_defaultView_CSS.registerProperty) !== null && _targetDocument_defaultView_CSS_registerProperty !== void 0 ? _targetDocument_defaultView_CSS_registerProperty : ()=>{
        // No-op if registerProperty is not supported
        };
        try {
            registerProperty({
                name: (0, $1bc41beff6061826$export$d8cee2f3784ae17a),
                syntax: '<length>',
                inherits: false,
                initialValue: '0px'
            });
            registerProperty({
                name: (0, $1bc41beff6061826$export$9cbb0ef067e89ae6),
                syntax: '<length>',
                inherits: false,
                initialValue: '0px'
            });
        } catch (e) {
        // Ignore errors from registerProperty, which can occur if the properties are already registered
        }
    }, [
        targetDocument
    ]);
    return handlePositionEnd;
}



var $acw62 = parcelRequire("acw62");


'use client';
const $708e79e1f2ab4237$export$2b0519dd5d2bc6d4 = ()=>{
    const tabsterRef = (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    // Narrow props for now and let need dictate additional props in the future
    const findAllFocusable = $acw62.useCallback((container, acceptCondition)=>{
        var _tabsterRef_current;
        return container && ((_tabsterRef_current = tabsterRef.current) === null || _tabsterRef_current === void 0 ? void 0 : _tabsterRef_current.focusable.findAll({
            container: container,
            acceptCondition: acceptCondition
        })) || [];
    }, [
        tabsterRef
    ]);
    const findFirstFocusable = $acw62.useCallback((container)=>{
        var _tabsterRef_current;
        return container && ((_tabsterRef_current = tabsterRef.current) === null || _tabsterRef_current === void 0 ? void 0 : _tabsterRef_current.focusable.findFirst({
            container: container
        }));
    }, [
        tabsterRef
    ]);
    const findLastFocusable = $acw62.useCallback((container)=>{
        var _tabsterRef_current;
        return container && ((_tabsterRef_current = tabsterRef.current) === null || _tabsterRef_current === void 0 ? void 0 : _tabsterRef_current.focusable.findLast({
            container: container
        }));
    }, [
        tabsterRef
    ]);
    const findNextFocusable = $acw62.useCallback((currentElement, options = {})=>{
        if (!tabsterRef.current || !targetDocument || !currentElement) return null;
        const { container: container = targetDocument.body } = options;
        return tabsterRef.current.focusable.findNext({
            currentElement: currentElement,
            container: container
        });
    }, [
        tabsterRef,
        targetDocument
    ]);
    const findPrevFocusable = $acw62.useCallback((currentElement, options = {})=>{
        if (!tabsterRef.current || !targetDocument || !currentElement) return null;
        const { container: container = targetDocument.body } = options;
        return tabsterRef.current.focusable.findPrev({
            currentElement: currentElement,
            container: container
        });
    }, [
        tabsterRef,
        targetDocument
    ]);
    return {
        findAllFocusable: findAllFocusable,
        findFirstFocusable: findFirstFocusable,
        findLastFocusable: findLastFocusable,
        findNextFocusable: findNextFocusable,
        findPrevFocusable: findPrevFocusable
    };
};


var $acw62 = parcelRequire("acw62");



'use client';
function $90683aaf3b536711$export$7e2271c66fded443() {
    const modalizerRefAPI = (0, $b04ae062f6cbb081$export$f3f635a6897e7f0c)((0, $e3e23e1e89ad903c$export$af216543e1ef674));
    const [setActivateModalTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    const activateModal = $acw62.useCallback((elementFromModal)=>{
        // We call the actual activation function on the next tick, because with the typical use case,
        // the hook will be called on the same tick when other Tabster attributes are being applied,
        // and on the current tick the element has just received the attributes, but Tabster has not
        // instantiated the Modalizer yet.
        setActivateModalTimeout(()=>{
            var _modalizerRefAPI_current;
            (_modalizerRefAPI_current = modalizerRefAPI.current) === null || _modalizerRefAPI_current === void 0 || _modalizerRefAPI_current.activate(elementFromModal);
        }, 0);
    }, [
        modalizerRefAPI,
        setActivateModalTimeout
    ]);
    return activateModal;
}





'use client';
const $b0397c93cedc8a09$export$785785b511aa51f7 = {
    root: 'fui-PopoverSurface'
};
const $b0397c93cedc8a09$export$a2b615cb523a0f18 = {
    small: 6,
    medium: 8,
    large: 8
};
/**
 * Styles for the root slot
 */ const $b0397c93cedc8a09$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bgfg5da: 0,
        B9xav0g: 0,
        oivjwe: 0,
        Bn0qgzm: 0,
        B4g9neb: 0,
        zhjwy3: 0,
        wvpqe5: 0,
        ibv6hh: 0,
        u1mtju: 0,
        h3c5rm: 0,
        vrafjx: 0,
        Bekrc4i: 0,
        i8vvqc: 0,
        g2u3we: 0,
        icvyot: 0,
        B4j52fo: 0,
        irswps: "f9ggezi",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Bhu2qc9: "fymb6k8"
    },
    inline: {
        Bj3rh1h: "f19g0ac"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    brand: {
        De3pzq: "ffp7eso",
        sj55zd: "f1phragk"
    },
    smallPadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1sy4kr4"
    },
    mediumPadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f4zyqsv"
    },
    largePadding: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fop8ug2"
    },
    smallArrow: {
        rhnwrx: "f1s3jn22",
        Bdy53xb: "fv40uqz"
    },
    mediumLargeArrow: {
        rhnwrx: "f1f72gjr",
        Bdy53xb: "f69yoe5"
    },
    arrow: {
        B7ck84d: "f1ewtqcl",
        qhf8xq: "f1euv43f",
        Bj3rh1h: "f1bsuimh",
        De3pzq: "f1u2r49w",
        B2eet1l: "fqhgnl",
        Beyfa6y: "f17bz04i",
        Bz10aip: "f36o3x3",
        Bqenvij: "fzofk8q",
        a9b677: "f1wbx1ie",
        Ftih45: "f1wl9k8s",
        Br0sdwz: "f1aocrix",
        cmx5o7: "f1ljr5q2",
        susq4k: 0,
        Biibvgv: 0,
        Bicfajf: 0,
        qehafq: 0,
        Brs5u8j: "f155f1qt",
        Ccq8qp: "f9mhzq7",
        Baz25je: "fr6rhvx",
        Bcgcnre: 0,
        Bqjgrrk: 0,
        qa3bma: 0,
        y0oebl: 0,
        Biqmznv: 0,
        Bm6vgfq: 0,
        Bbv0w2i: 0,
        uvfttm: 0,
        eqrjj: 0,
        Bk5zm6e: 0,
        m598lv: 0,
        B4f6apu: 0,
        ydt019: 0,
        Bq4z7u6: 0,
        Bdkvgpv: 0,
        B0qfbqy: 0,
        kj8mxx: "f1kc0wz4",
        r59vdv: "fgq90dz",
        Bkw5xw4: "fq0y47f",
        hl6cv3: "f1pwrbz6",
        aea9ga: "f1hxxcvm",
        yayu3t: "fw8rgyo",
        Bhsv975: "f1wnzycx",
        rhl9o9: "f1730wal",
        B7gxrvb: "f1fy4ixr",
        B6q6orb: "fobkauc",
        B0lu1f8: "f16bqv1l"
    }
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f9ggezi{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fymb6k8{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 8px 16px var(--colorNeutralShadowKey));}",
        ".f19g0ac{z-index:1;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        [
            ".f1sy4kr4{padding:12px;}",
            {
                p: -1
            }
        ],
        [
            ".f4zyqsv{padding:16px;}",
            {
                p: -1
            }
        ],
        [
            ".fop8ug2{padding:20px;}",
            {
                p: -1
            }
        ],
        ".f1s3jn22{--fui-positioning-arrow-height:8.484px;}",
        ".fv40uqz{--fui-positioning-arrow-offset:-4.242px;}",
        ".f1f72gjr{--fui-positioning-arrow-height:11.312px;}",
        ".f69yoe5{--fui-positioning-arrow-offset:-5.656px;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1euv43f{position:absolute;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fqhgnl{background-clip:content-box;}",
        ".f17bz04i{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f36o3x3{transform:rotate(var(--fui-positioning-arrow-angle));}",
        ".fzofk8q{height:var(--fui-positioning-arrow-height);}",
        ".f1wbx1ie{width:var(--fui-positioning-arrow-height);}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1aocrix::before{display:block;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        [
            ".f155f1qt::before{margin:-1px;}",
            {
                p: -1
            }
        ],
        ".f9mhzq7::before{width:100%;}",
        ".fr6rhvx::before{height:100%;}",
        [
            ".f1kc0wz4::before{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".fgq90dz::before{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".fq0y47f::before{clip-path:polygon(0% 0%, 100% 100%, 0% 100%);}",
        "[data-popper-placement^=\"top\"] .f1pwrbz6{bottom:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"top\"] .f1hxxcvm{--fui-positioning-arrow-angle:-45deg;}",
        "[data-popper-placement^=\"right\"] .fw8rgyo{left:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"right\"] .f1wnzycx{--fui-positioning-arrow-angle:45deg;}",
        "[data-popper-placement^=\"bottom\"] .f1730wal{top:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"bottom\"] .f1fy4ixr{--fui-positioning-arrow-angle:135deg;}",
        "[data-popper-placement^=\"left\"] .fobkauc{right:var(--fui-positioning-arrow-offset);}",
        "[data-popper-placement^=\"left\"] .f16bqv1l{--fui-positioning-arrow-angle:225deg;}"
    ]
});
const $b0397c93cedc8a09$export$8e46f2e5324a79b8 = (state)=>{
    'use no memo';
    const styles = $b0397c93cedc8a09$var$useStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($b0397c93cedc8a09$export$785785b511aa51f7.root, styles.root, state.inline && styles.inline, state.size === 'small' && styles.smallPadding, state.size === 'medium' && styles.mediumPadding, state.size === 'large' && styles.largePadding, state.appearance === 'inverted' && styles.inverted, state.appearance === 'brand' && styles.brand, state.root.className);
    state.arrowClassName = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(styles.arrow, state.size === 'small' ? styles.smallArrow : styles.mediumLargeArrow);
    return state;
};


/**
 * The default value of the tooltip's border radius (borderRadiusMedium).
 *
 * Unfortunately, Popper requires it to be specified as a variable instead of using CSS.
 * While we could use getComputedStyle, that adds a performance penalty for something that
 * will likely never change.
 *
 * @internal
 */ const $478fe93b25bc64cb$export$c3e7e32ff8175118 = 4;



var $acw62 = parcelRequire("acw62");

function $c44df703e8f8e21f$export$1834a16e35f276c5(motion, options) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const { as: as, children: children, ...rest } = motion !== null && motion !== void 0 ? motion : {};
    if (motion === null) {
        // Heads up!
        // Render function is used there to avoid rendering a motion component and handle unmounting logic
        const isUnmounted = !options.defaultProps.visible && options.defaultProps.unmountOnExit;
        const renderFn = (_, props)=>isUnmounted ? null : /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, props.children);
        /**
     * Casting is required here as SlotComponentType is a function, not an object.
     * Although SlotComponentType has a function signature, it is still just an object.
     * This is required to make a slot callable (JSX compatible), this is the exact same approach
     * that is used on `@types/react` components
     */ return {
            [(0, $a9190614d56c943f$export$2eb147a2bf7697ad)]: renderFn,
            [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: options.elementType
        };
    }
    /**
   * Casting is required here as SlotComponentType is a function, not an object.
   * Although SlotComponentType has a function signature, it is still just an object.
   * This is required to make a slot callable (JSX compatible), this is the exact same approach
   * that is used on `@types/react` components
   */ const propsWithMetadata = {
        ...options.defaultProps,
        ...rest,
        [(0, $a9190614d56c943f$export$b8c826907bbed9b7)]: options.elementType
    };
    if (typeof children === 'function') propsWithMetadata[0, $a9190614d56c943f$export$2eb147a2bf7697ad] = children;
    return propsWithMetadata;
}


// Copied from packages/tokens/src/global/durations.ts
// Values are numeric in milliseconds for ease of use in Web Animations API
// (rather than parsing '__ms')
const $a9dd808ce2ff0a37$export$38b928a7167ce124 = {
    durationUltraFast: 50,
    durationFaster: 100,
    durationFast: 150,
    durationNormal: 200,
    durationGentle: 250,
    durationSlow: 300,
    durationSlower: 400,
    durationUltraSlow: 500
};
const $a9dd808ce2ff0a37$export$6894093bf294bea5 = {
    curveAccelerateMax: 'cubic-bezier(0.9,0.1,1,0.2)',
    curveAccelerateMid: 'cubic-bezier(1,0,1,1)',
    curveAccelerateMin: 'cubic-bezier(0.8,0,0.78,1)',
    curveDecelerateMax: 'cubic-bezier(0.1,0.9,0.2,1)',
    curveDecelerateMid: 'cubic-bezier(0,0,0,1)',
    curveDecelerateMin: 'cubic-bezier(0.33,0,0.1,1)',
    curveEasyEaseMax: 'cubic-bezier(0.8,0,0.2,1)',
    curveEasyEase: 'cubic-bezier(0.33,0,0.67,1)',
    curveLinear: 'cubic-bezier(0,0,1,1)'
};
const $a9dd808ce2ff0a37$export$24b36403afffca36 = {
    ...$a9dd808ce2ff0a37$export$38b928a7167ce124,
    ...$a9dd808ce2ff0a37$export$6894093bf294bea5
}; /*
TODO: enforce naming conventions when TypeScript 4.4 features are supported in Fluent:

type DurationKey = `duration${Capitalize<string>}`;
type CurveKey = `curve${Capitalize<string>}`;
type CurveValue = `cubic-bezier(${number},${number},${number},${number})`;

type DurationTokens = Record<DurationKey, number>;
type CurveTokens = Record<CurveKey, CurveValue>;
*/ 


var $acw62 = parcelRequire("acw62");
'use client';
function $949974c661be515d$export$c3c1287055233f8d() {
    const isFirst = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirst.current) isFirst.current = false;
    }, []);
    return isFirst.current;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $78d58227f0aa0a73$export$812dfa23d18e6d81 = $acw62.createContext(undefined);
const $78d58227f0aa0a73$export$67ca7631e583a58f = $78d58227f0aa0a73$export$812dfa23d18e6d81.Provider;
const $78d58227f0aa0a73$export$5bfaa3767a974d5 = ()=>$acw62.useContext($78d58227f0aa0a73$export$812dfa23d18e6d81);



var $acw62 = parcelRequire("acw62");
/**
 * Checks if the animation is running at the moment.
 */ function $265839c0cb798a52$export$6eca332e8811d22d(animation) {
    if (animation.playState === 'running') {
        var _animation_effect;
        // Heads up!
        //
        // There is an edge case where the animation is running, but the overall progress is 0 or 1. In this case, we
        // consider the animation to be not running. If it will be reversed it will flip from 1 to 0, and we will observe a
        // glitch.
        // "overallProgress" is not supported in all browsers, so we need to check if it exists.
        // We will fall back to the currentTime and duration if "overallProgress" is not supported.
        if (animation.overallProgress !== undefined) {
            var _animation_overallProgress;
            const overallProgress = (_animation_overallProgress = animation.overallProgress) !== null && _animation_overallProgress !== void 0 ? _animation_overallProgress : 0;
            return overallProgress > 0 && overallProgress < 1;
        }
        var _animation_currentTime;
        const currentTime = Number((_animation_currentTime = animation.currentTime) !== null && _animation_currentTime !== void 0 ? _animation_currentTime : 0);
        var _animation_effect_getTiming_duration;
        const totalTime = Number((_animation_effect_getTiming_duration = (_animation_effect = animation.effect) === null || _animation_effect === void 0 ? void 0 : _animation_effect.getTiming().duration) !== null && _animation_effect_getTiming_duration !== void 0 ? _animation_effect_getTiming_duration : 0);
        return currentTime > 0 && currentTime < totalTime;
    }
    return false;
}


'use client';
const $82feaafe3a438e6d$export$999a2a2cf78cf234 = {
    fill: 'forwards'
};
// A motion atom's default reduced motion is a simple 1 ms duration.
// But an atom can define a custom reduced motion, overriding keyframes and/or params like duration, easing, iterations, etc.
const $82feaafe3a438e6d$var$DEFAULT_REDUCED_MOTION_ATOM = {
    duration: 1
};
/**
 * Creates an animation handle that controls multiple animations.
 * Is used to avoid leaking "element" references from the hook.
 *
 * @param animations
 */ function $82feaafe3a438e6d$var$createHandle(animations) {
    return {
        set playbackRate (rate){
            animations.forEach((animation)=>{
                animation.playbackRate = rate;
            });
        },
        setMotionEndCallbacks (onfinish, oncancel) {
            // Heads up!
            // This could use "Animation:finished", but it's causing a memory leak in Chromium.
            // See: https://issues.chromium.org/u/2/issues/383016426
            const promises = animations.map((animation)=>{
                return new Promise((resolve, reject)=>{
                    animation.onfinish = ()=>resolve();
                    animation.oncancel = ()=>reject();
                });
            });
            Promise.all(promises).then(()=>{
                onfinish();
            }).catch(()=>{
                oncancel();
            });
        },
        isRunning () {
            return animations.some((animation)=>(0, $265839c0cb798a52$export$6eca332e8811d22d)(animation));
        },
        dispose: ()=>{
            animations.length = 0;
        },
        cancel: ()=>{
            animations.forEach((animation)=>{
                animation.cancel();
            });
        },
        pause: ()=>{
            animations.forEach((animation)=>{
                animation.pause();
            });
        },
        play: ()=>{
            animations.forEach((animation)=>{
                animation.play();
            });
        },
        finish: ()=>{
            animations.forEach((animation)=>{
                animation.finish();
            });
        },
        reverse: ()=>{
            // Heads up!
            //
            // This is used for the interruptible motion. If the animation is running, we need to reverse it.
            //
            // TODO: what do with animations that have "delay"?
            // TODO: what do with animations that have different "durations"?
            animations.forEach((animation)=>{
                animation.reverse();
            });
        }
    };
}
function $82feaafe3a438e6d$var$useAnimateAtomsInSupportedEnvironment() {
    var _window_Animation;
    // eslint-disable-next-line @nx/workspace-no-restricted-globals
    const SUPPORTS_PERSIST = typeof window !== 'undefined' && typeof ((_window_Animation = window.Animation) === null || _window_Animation === void 0 ? void 0 : _window_Animation.prototype.persist) === 'function';
    return $acw62.useCallback((element, value, options)=>{
        const atoms = Array.isArray(value) ? value : [
            value
        ];
        const { isReducedMotion: isReducedMotion } = options;
        const animations = atoms.map((motion)=>{
            // Grab the custom reduced motion definition if it exists, or fall back to the default reduced motion.
            const { keyframes: motionKeyframes, reducedMotion: reducedMotion = $82feaafe3a438e6d$var$DEFAULT_REDUCED_MOTION_ATOM, ...params } = motion;
            // Grab the reduced motion keyframes if they exist, or fall back to the regular keyframes.
            const { keyframes: reducedMotionKeyframes = motionKeyframes, ...reducedMotionParams } = reducedMotion;
            const animationKeyframes = isReducedMotion ? reducedMotionKeyframes : motionKeyframes;
            const animationParams = {
                ...$82feaafe3a438e6d$export$999a2a2cf78cf234,
                ...params,
                // Use reduced motion overrides (e.g. duration, easing) when reduced motion is enabled
                ...isReducedMotion && reducedMotionParams
            };
            try {
                // Firefox can throw an error when calling `element.animate()`.
                // See: https://github.com/microsoft/fluentui/issues/33902
                const animation = element.animate(animationKeyframes, animationParams);
                if (SUPPORTS_PERSIST) // Chromium browsers can return null when calling `element.animate()`.
                // See: https://github.com/microsoft/fluentui/issues/33902
                animation === null || animation === void 0 || animation.persist();
                else {
                    const resultKeyframe = animationKeyframes[animationKeyframes.length - 1];
                    var _element_style;
                    Object.assign((_element_style = element.style) !== null && _element_style !== void 0 ? _element_style : {}, resultKeyframe);
                }
                return animation;
            } catch (e) {
                return null;
            }
        }).filter((animation)=>!!animation);
        return $82feaafe3a438e6d$var$createHandle(animations);
    }, [
        SUPPORTS_PERSIST
    ]);
}
/**
 * In test environments, this hook is used to delay the execution of a callback until the next render. This is necessary
 * to ensure that the callback is not executed synchronously, which would cause the test to fail.
 *
 * @see https://github.com/microsoft/fluentui/issues/31701
 */ function $82feaafe3a438e6d$var$useAnimateAtomsInTestEnvironment() {
    const [count, setCount] = $acw62.useState(0);
    const callbackRef = $acw62.useRef(undefined);
    const realAnimateAtoms = $82feaafe3a438e6d$var$useAnimateAtomsInSupportedEnvironment();
    $acw62.useEffect(()=>{
        if (count > 0) {
            var _callbackRef_current;
            (_callbackRef_current = callbackRef.current) === null || _callbackRef_current === void 0 || _callbackRef_current.call(callbackRef);
        }
    }, [
        count
    ]);
    return $acw62.useCallback((element, value, options)=>{
        const ELEMENT_SUPPORTS_WEB_ANIMATIONS = typeof element.animate === 'function';
        // Heads up!
        // If the environment supports Web Animations API, we can use the native implementation.
        if (ELEMENT_SUPPORTS_WEB_ANIMATIONS) return realAnimateAtoms(element, value, options);
        return {
            setMotionEndCallbacks (onfinish) {
                callbackRef.current = onfinish;
                setCount((v)=>v + 1);
            },
            set playbackRate (rate){
            /* no-op */ },
            isRunning () {
                return false;
            },
            dispose () {
            /* no-op */ },
            cancel () {
            /* no-op */ },
            pause () {
            /* no-op */ },
            play () {
            /* no-op */ },
            finish () {
            /* no-op */ },
            reverse () {
            /* no-op */ }
        };
    }, [
        realAnimateAtoms
    ]);
}
function $82feaafe3a438e6d$export$93989c19398647ca() {
    'use no memo';
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $82feaafe3a438e6d$var$useAnimateAtomsInSupportedEnvironment();
}



var $acw62 = parcelRequire("acw62");
'use client';
function $e3f25356fa59d907$export$a38b9ad22b295ac4(imperativeRef) {
    const animationRef = $acw62.useRef(undefined);
    $acw62.useImperativeHandle(imperativeRef, ()=>({
            setPlayState: (state)=>{
                if (state === 'running') {
                    var _animationRef_current;
                    (_animationRef_current = animationRef.current) === null || _animationRef_current === void 0 || _animationRef_current.play();
                }
                if (state === 'paused') {
                    var _animationRef_current1;
                    (_animationRef_current1 = animationRef.current) === null || _animationRef_current1 === void 0 || _animationRef_current1.pause();
                }
            },
            setPlaybackRate: (rate)=>{
                if (animationRef.current) animationRef.current.playbackRate = rate;
            }
        }));
    return animationRef;
}



var $acw62 = parcelRequire("acw62");
'use client';
function $f910bf47b194652c$export$91db9bc4f8ac944a() {
    return $acw62.useReducer((x)=>x + 1, 0)[1];
}



var $acw62 = parcelRequire("acw62");
'use client';
function $30b9020f7ddef003$export$92e5afcdc0d187b6(visible = false, unmountOnExit = false) {
    const mountedRef = $acw62.useRef(unmountOnExit ? visible : true);
    const forceUpdate = (0, $f910bf47b194652c$export$91db9bc4f8ac944a)();
    const setMounted = $acw62.useCallback((newValue)=>{
        if (mountedRef.current !== newValue) {
            mountedRef.current = newValue;
            forceUpdate();
        }
    }, [
        forceUpdate
    ]);
    $acw62.useEffect(()=>{
        if (visible) mountedRef.current = visible;
    });
    return [
        visible || mountedRef.current,
        setMounted
    ];
}





var $acw62 = parcelRequire("acw62");
'use client';
const $a6ea602503e7be50$var$REDUCED_MEDIA_QUERY = 'screen and (prefers-reduced-motion: reduce)';
function $a6ea602503e7be50$export$c537e63161742ce3() {
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    var _targetDocument_defaultView;
    const targetWindow = (_targetDocument_defaultView = targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.defaultView) !== null && _targetDocument_defaultView !== void 0 ? _targetDocument_defaultView : null;
    const queryValue = $acw62.useRef(false);
    const isEnabled = $acw62.useCallback(()=>queryValue.current, []);
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        if (targetWindow === null || typeof targetWindow.matchMedia !== 'function') return;
        const queryMatch = targetWindow.matchMedia($a6ea602503e7be50$var$REDUCED_MEDIA_QUERY);
        if (queryMatch.matches) queryValue.current = true;
        const matchListener = (e)=>{
            queryValue.current = e.matches;
        };
        queryMatch.addEventListener('change', matchListener);
        return ()=>{
            queryMatch.removeEventListener('change', matchListener);
        };
    }, [
        targetWindow
    ]);
    return isEnabled;
}



var $acw62 = parcelRequire("acw62");

'use client';
const $00f5a53f1344b220$var$CHILD_ERROR_MESSAGE = [
    '@fluentui/react-motion: Invalid child element.',
    '\n',
    'Motion factories require a single child element to be passed. ',
    'That element element should support ref forwarding i.e. it should be either an intrinsic element (e.g. div) or a component that uses React.forwardRef().'
].join('');
function $00f5a53f1344b220$export$7dc11cdee8dc0d18(children, mounted = true) {
    const childRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{}, [
        mounted
    ]);
    try {
        const child = $acw62.Children.only(children);
        if ($acw62.isValidElement(child)) return [
            $acw62.cloneElement(child, {
                ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(childRef, (0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child))
            }),
            childRef
        ];
    } catch  {
    /* empty */ }
    throw new Error($00f5a53f1344b220$var$CHILD_ERROR_MESSAGE);
}



var $acw62 = parcelRequire("acw62");
'use client';
const $69721b48206ed2ce$var$MotionBehaviourContext = $acw62.createContext(undefined);
const $69721b48206ed2ce$export$3f59f148e5942239 = $69721b48206ed2ce$var$MotionBehaviourContext.Provider;
const $69721b48206ed2ce$export$6553b01af246e5fe = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($69721b48206ed2ce$var$MotionBehaviourContext)) !== null && _React_useContext !== void 0 ? _React_useContext : 'default';
};




var $acw62 = parcelRequire("acw62");





'use client';
const $963d4b42e27ff431$export$8a98be0d1dccdceb = Symbol('MOTION_DEFINITION');
function $963d4b42e27ff431$export$46b7e4b9dc6110c3(value) {
    const Atom = (props)=>{
        'use no memo';
        const { children: children, imperativeRef: imperativeRef, onMotionFinish: onMotionFinishProp, onMotionStart: onMotionStartProp, onMotionCancel: onMotionCancelProp, ..._rest } = props;
        const params = _rest;
        const [child, childRef] = (0, $00f5a53f1344b220$export$7dc11cdee8dc0d18)(children);
        const handleRef = (0, $e3f25356fa59d907$export$a38b9ad22b295ac4)(imperativeRef);
        const skipMotions = (0, $69721b48206ed2ce$export$6553b01af246e5fe)() === 'skip';
        const optionsRef = $acw62.useRef({
            skipMotions: skipMotions,
            params: params
        });
        const animateAtoms = (0, $82feaafe3a438e6d$export$93989c19398647ca)();
        const isReducedMotion = (0, $a6ea602503e7be50$export$c537e63161742ce3)();
        const onMotionStart = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
            onMotionStartProp === null || onMotionStartProp === void 0 || onMotionStartProp(null);
        });
        const onMotionFinish = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
            onMotionFinishProp === null || onMotionFinishProp === void 0 || onMotionFinishProp(null);
        });
        const onMotionCancel = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)(()=>{
            onMotionCancelProp === null || onMotionCancelProp === void 0 || onMotionCancelProp(null);
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            // Heads up!
            // We store the params in a ref to avoid re-rendering the component when the params change.
            optionsRef.current = {
                skipMotions: skipMotions,
                params: params
            };
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            const element = childRef.current;
            if (element) {
                const atoms = typeof value === 'function' ? value({
                    element: element,
                    ...optionsRef.current.params
                }) : value;
                onMotionStart();
                const handle = animateAtoms(element, atoms, {
                    isReducedMotion: isReducedMotion()
                });
                handleRef.current = handle;
                handle.setMotionEndCallbacks(onMotionFinish, onMotionCancel);
                if (optionsRef.current.skipMotions) handle.finish();
                return ()=>{
                    handle.cancel();
                };
            }
        }, [
            animateAtoms,
            childRef,
            handleRef,
            isReducedMotion,
            onMotionFinish,
            onMotionStart,
            onMotionCancel
        ]);
        return child;
    };
    return Object.assign(Atom, {
        // Heads up!
        // Always normalize it to a function to simplify types
        [$963d4b42e27ff431$export$8a98be0d1dccdceb]: typeof value === 'function' ? value : ()=>value
    });
}


'use client';
const $a90210c34a8674c7$export$a121f71575b68679 = Symbol('PRESENCE_MOTION_DEFINITION');
const $a90210c34a8674c7$var$INTERRUPTABLE_MOTION_SYMBOL = Symbol.for('interruptablePresence');
function $a90210c34a8674c7$export$e943b41c81f8ae82(value) {
    return Object.assign((props)=>{
        'use no memo';
        const itemContext = $acw62.useContext((0, $78d58227f0aa0a73$export$812dfa23d18e6d81));
        const merged = {
            ...itemContext,
            ...props
        };
        const skipMotions = (0, $69721b48206ed2ce$export$6553b01af246e5fe)() === 'skip';
        const { appear: appear, children: children, imperativeRef: imperativeRef, onExit: onExit, onMotionFinish: onMotionFinish, onMotionStart: onMotionStart, onMotionCancel: onMotionCancel, visible: visible, unmountOnExit: unmountOnExit, ..._rest } = merged;
        const params = _rest;
        const [mounted, setMounted] = (0, $30b9020f7ddef003$export$92e5afcdc0d187b6)(visible, unmountOnExit);
        const [child, childRef] = (0, $00f5a53f1344b220$export$7dc11cdee8dc0d18)(children, mounted);
        const handleRef = (0, $e3f25356fa59d907$export$a38b9ad22b295ac4)(imperativeRef);
        const optionsRef = $acw62.useRef({
            appear: appear,
            params: params,
            skipMotions: skipMotions
        });
        const animateAtoms = (0, $82feaafe3a438e6d$export$93989c19398647ca)();
        const isFirstMount = (0, $949974c661be515d$export$c3c1287055233f8d)();
        const isReducedMotion = (0, $a6ea602503e7be50$export$c537e63161742ce3)();
        const handleMotionStart = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((direction)=>{
            onMotionStart === null || onMotionStart === void 0 || onMotionStart(null, {
                direction: direction
            });
        });
        const handleMotionFinish = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((direction)=>{
            onMotionFinish === null || onMotionFinish === void 0 || onMotionFinish(null, {
                direction: direction
            });
            if (direction === 'exit' && unmountOnExit) {
                setMounted(false);
                onExit === null || onExit === void 0 || onExit();
            }
        });
        const handleMotionCancel = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((direction)=>{
            onMotionCancel === null || onMotionCancel === void 0 || onMotionCancel(null, {
                direction: direction
            });
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            // Heads up!
            // We store the params in a ref to avoid re-rendering the component when the params change.
            optionsRef.current = {
                appear: appear,
                params: params,
                skipMotions: skipMotions
            };
        });
        (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
            const element = childRef.current;
            if (!element) return;
            let handle;
            function cleanup() {
                if (!handle) return;
                // Heads up!
                //
                // If the animation is interruptible & is running, we don't want to cancel it as it will be reversed in
                // the next effect.
                if (IS_EXPERIMENTAL_INTERRUPTIBLE_MOTION && handle.isRunning()) return;
                handle.cancel();
                handleRef.current = undefined;
            }
            const presenceMotion = typeof value === 'function' ? value({
                element: element,
                ...optionsRef.current.params
            }) : value;
            const IS_EXPERIMENTAL_INTERRUPTIBLE_MOTION = presenceMotion[$a90210c34a8674c7$var$INTERRUPTABLE_MOTION_SYMBOL];
            if (IS_EXPERIMENTAL_INTERRUPTIBLE_MOTION) {
                handle = handleRef.current;
                if (handle && handle.isRunning()) {
                    handle.reverse();
                    return cleanup;
                }
            }
            const atoms = visible ? presenceMotion.enter : presenceMotion.exit;
            const direction = visible ? 'enter' : 'exit';
            // Heads up!
            // Initial styles are applied when the component is mounted for the first time and "appear" is set to "false" (otherwise animations are triggered)
            const applyInitialStyles = !optionsRef.current.appear && isFirstMount;
            const skipAnimationByConfig = optionsRef.current.skipMotions;
            if (!applyInitialStyles) handleMotionStart(direction);
            handle = animateAtoms(element, atoms, {
                isReducedMotion: isReducedMotion()
            });
            if (applyInitialStyles) {
                // Heads up!
                // .finish() is used in this case to skip animation and apply animation styles immediately
                handle.finish();
                return cleanup;
            }
            handleRef.current = handle;
            handle.setMotionEndCallbacks(()=>handleMotionFinish(direction), ()=>handleMotionCancel(direction));
            if (skipAnimationByConfig) handle.finish();
            return cleanup;
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            animateAtoms,
            childRef,
            handleRef,
            isReducedMotion,
            handleMotionFinish,
            handleMotionStart,
            handleMotionCancel,
            visible
        ]);
        $acw62.useEffect(()=>{
            // Heads up!
            //
            // Dispose the handle when unmounting the component to clean up retained references. Doing it in a separate
            // effect to ensure that the component is unmounted.
            if (unmountOnExit && !mounted) {
                var _handleRef_current;
                (_handleRef_current = handleRef.current) === null || _handleRef_current === void 0 || _handleRef_current.dispose();
            }
        }, [
            handleRef,
            unmountOnExit,
            mounted
        ]);
        if (mounted) return child;
        return null;
    }, {
        // Heads up!
        // Always normalize it to a function to simplify types
        [$a90210c34a8674c7$export$a121f71575b68679]: typeof value === 'function' ? value : ()=>value
    }, {
        // Wrap `enter` in its own motion component as a static method, e.g. <Fade.In>
        In: (0, $963d4b42e27ff431$export$46b7e4b9dc6110c3)(// Otherwise, pass the `enter` motion object directly.
        typeof value === 'function' ? (...args)=>value(...args).enter : value.enter),
        // Wrap `exit` in its own motion component as a static method, e.g. <Fade.Out>
        Out: (0, $963d4b42e27ff431$export$46b7e4b9dc6110c3)(// Otherwise, pass the `exit` motion object directly.
        typeof value === 'function' ? (...args)=>value(...args).exit : value.exit)
    });
}



const $0dbab70b2cf389f1$export$22f96d8a4ace81f0 = ({ direction: direction, duration: duration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear, delay: delay = 0, outOpacity: outOpacity = 0, inOpacity: inOpacity = 1 })=>{
    const keyframes = [
        {
            opacity: outOpacity
        },
        {
            opacity: inOpacity
        }
    ];
    if (direction === 'exit') keyframes.reverse();
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay,
        // Applying opacity backwards and forwards in time is important
        // to avoid a bug where a delayed animation is not hidden when it should be.
        fill: 'both'
    };
};


const $0dd91e49840ce398$export$353ebd9eed5e1f73 = ({ direction: direction, duration: duration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear, delay: delay = 0, outX: outX = '0px', outY: outY = '0px', inX: inX = '0px', inY: inY = '0px' })=>{
    const keyframes = [
        {
            translate: `${outX} ${outY}`
        },
        {
            translate: `${inX} ${inY}`
        }
    ];
    if (direction === 'exit') keyframes.reverse();
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay
    };
};



// Shared timing constants for the enter animation.
const $bf3d2ea43c9b9f59$var$duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlower;
const $bf3d2ea43c9b9f59$var$easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMid;
const $bf3d2ea43c9b9f59$export$b8b7538ff1048313 = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(({ distance: distance = 10 })=>({
        enter: [
            (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
                duration: $bf3d2ea43c9b9f59$var$duration,
                easing: $bf3d2ea43c9b9f59$var$easing,
                direction: 'enter'
            }),
            {
                // slideAtom produces translate keyframes from `outX`/`outY` → `0px`.
                // The `outX`/`outY` values read the positioning-provided CSS variables and scale
                // them by `distance` so the surface slides in from the correct direction.
                ...(0, $0dd91e49840ce398$export$353ebd9eed5e1f73)({
                    duration: $bf3d2ea43c9b9f59$var$duration,
                    easing: $bf3d2ea43c9b9f59$var$easing,
                    direction: 'enter',
                    outX: `calc(var(${(0, $1bc41beff6061826$export$d8cee2f3784ae17a)}, 0px) * ${distance})`,
                    outY: `calc(var(${(0, $1bc41beff6061826$export$9cbb0ef067e89ae6)}, 0px) * ${distance})`
                }),
                // 'accumulate' compositing adds this effect's transform on top of the element's
                // existing transform, preserving any transform applied by the positioning engine.
                composite: 'accumulate'
            }
        ],
        // No exit animation — the surface unmounts immediately on close.
        exit: []
    }));


'use client';
const $11d8a9d2f43b7db3$export$38ececae71530e62 = (props)=>{
    const { appearance: appearance, size: size = 'medium' } = props;
    const positioning = (0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(props.positioning);
    const withArrow = props.withArrow && !positioning.coverTarget;
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const handlePositionEnd = (0, $a9f840906894d8a8$export$8ac94e7c1d8a7c08)({
        targetDocument: targetDocument,
        onPositioningEnd: positioning.onPositioningEnd
    });
    const state = $11d8a9d2f43b7db3$export$fa4a63cb34cfe041({
        ...props,
        positioning: {
            ...positioning,
            onPositioningEnd: handlePositionEnd,
            // Update the offset with the arrow size only when it's available
            ...withArrow ? {
                offset: (0, $4f638fdc3c53bf8c$export$fef5d4d23735b493)(positioning.offset, (0, $b0397c93cedc8a09$export$a2b615cb523a0f18)[size])
            } : {}
        }
    });
    return {
        components: {
            surfaceMotion: (0, $bf3d2ea43c9b9f59$export$b8b7538ff1048313)
        },
        appearance: appearance,
        size: size,
        ...state,
        surfaceMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(props.surfaceMotion, {
            elementType: (0, $bf3d2ea43c9b9f59$export$b8b7538ff1048313),
            defaultProps: {
                visible: state.open,
                appear: true,
                unmountOnExit: true
            }
        })
    };
};
const $11d8a9d2f43b7db3$export$fa4a63cb34cfe041 = (props)=>{
    const [contextTarget, setContextTarget] = (0, $638f597d0f0765e2$export$5f3472545b83f7fe)();
    const initialState = {
        contextTarget: contextTarget,
        setContextTarget: setContextTarget,
        ...props
    };
    const children = $acw62.Children.toArray(props.children);
    let popoverTrigger = undefined;
    let popoverSurface = undefined;
    if (children.length === 2) {
        popoverTrigger = children[0];
        popoverSurface = children[1];
    } else if (children.length === 1) popoverSurface = children[0];
    const [open, setOpenState] = $11d8a9d2f43b7db3$var$useOpenState(initialState);
    const [setOpenTimeout, clearOpenTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    const setOpen = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, shouldOpen)=>{
        clearOpenTimeout();
        if (!(e instanceof Event) && e.persist) // < React 17 still uses pooled synthetic events
        e.persist();
        if (e.type === 'mouseleave') {
            var _props_mouseLeaveDelay;
            // FIXME leaking Node timeout type
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            setOpenTimeout(()=>{
                setOpenState(e, shouldOpen);
            }, (_props_mouseLeaveDelay = props.mouseLeaveDelay) !== null && _props_mouseLeaveDelay !== void 0 ? _props_mouseLeaveDelay : 500);
        } else setOpenState(e, shouldOpen);
    });
    const toggleOpen = $acw62.useCallback((e)=>{
        setOpen(e, !open);
    }, [
        setOpen,
        open
    ]);
    const positioningRefs = $11d8a9d2f43b7db3$var$usePopoverRefs(initialState);
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    var _props_closeOnIframeFocus;
    (0, $090a6633426263f1$export$9afc64c180e82dc4)({
        contains: (0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd),
        element: targetDocument,
        callback: (ev)=>setOpen(ev, false),
        refs: [
            positioningRefs.triggerRef,
            positioningRefs.contentRef
        ],
        disabled: !open,
        disabledFocusOnIframe: !((_props_closeOnIframeFocus = props.closeOnIframeFocus) !== null && _props_closeOnIframeFocus !== void 0 ? _props_closeOnIframeFocus : true)
    });
    // only close on scroll for context, or when closeOnScroll is specified
    const closeOnScroll = initialState.openOnContext || initialState.closeOnScroll;
    (0, $8748bb6e2a770b32$export$ee62ea5c36ea709a)({
        contains: (0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd),
        element: targetDocument,
        callback: (ev)=>setOpen(ev, false),
        refs: [
            positioningRefs.triggerRef,
            positioningRefs.contentRef
        ],
        disabled: !open || !closeOnScroll
    });
    const { findFirstFocusable: findFirstFocusable } = (0, $708e79e1f2ab4237$export$2b0519dd5d2bc6d4)();
    const activateModal = (0, $90683aaf3b536711$export$7e2271c66fded443)();
    $acw62.useEffect(()=>{
        if (props.unstable_disableAutoFocus) return;
        const contentElement = positioningRefs.contentRef.current;
        if (open && contentElement) {
            var _contentElement_getAttribute;
            const shouldFocusContainer = !isNaN((_contentElement_getAttribute = contentElement.getAttribute('tabIndex')) !== null && _contentElement_getAttribute !== void 0 ? _contentElement_getAttribute : undefined);
            const firstFocusable = shouldFocusContainer ? contentElement : findFirstFocusable(contentElement);
            firstFocusable === null || firstFocusable === void 0 || firstFocusable.focus();
            if (shouldFocusContainer) // Modal activation happens automatically when something inside the modal is focused programmatically.
            // When the container is focused, we need to activate the modal manually.
            activateModal(contentElement);
        }
    }, [
        findFirstFocusable,
        activateModal,
        open,
        positioningRefs.contentRef,
        props.unstable_disableAutoFocus
    ]);
    var _props_inertTrapFocus, _props_inline;
    return {
        ...initialState,
        ...positioningRefs,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        inertTrapFocus: (_props_inertTrapFocus = props.inertTrapFocus) !== null && _props_inertTrapFocus !== void 0 ? _props_inertTrapFocus : props.legacyTrapFocus === undefined ? false : !props.legacyTrapFocus,
        popoverTrigger: popoverTrigger,
        popoverSurface: popoverSurface,
        open: open,
        setOpen: setOpen,
        toggleOpen: toggleOpen,
        setContextTarget: setContextTarget,
        contextTarget: contextTarget,
        inline: (_props_inline = props.inline) !== null && _props_inline !== void 0 ? _props_inline : false
    };
};
/**
 * Creates and manages the Popover open state
 */ function $11d8a9d2f43b7db3$var$useOpenState(state) {
    'use no memo';
    const onOpenChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((e, data)=>{
        var _state_onOpenChange;
        return (_state_onOpenChange = state.onOpenChange) === null || _state_onOpenChange === void 0 ? void 0 : _state_onOpenChange.call(state, e, data);
    });
    const [open, setOpenState] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: state.open,
        defaultState: state.defaultOpen,
        initialState: false
    });
    state.open = open !== undefined ? open : state.open;
    const setContextTarget = state.setContextTarget;
    const setOpen = $acw62.useCallback((e, shouldOpen)=>{
        if (shouldOpen && e.type === 'contextmenu') setContextTarget(e);
        if (!shouldOpen) setContextTarget(undefined);
        setOpenState(shouldOpen);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(e, {
            open: shouldOpen
        });
    }, [
        setOpenState,
        onOpenChange,
        setContextTarget
    ]);
    return [
        open,
        setOpen
    ];
}
/**
 * Creates and sets the necessary trigger, target and content refs used by Popover
 */ function $11d8a9d2f43b7db3$var$usePopoverRefs(state) {
    'use no memo';
    const positioningOptions = {
        position: 'above',
        align: 'center',
        arrowPadding: 2 * (0, $478fe93b25bc64cb$export$c3e7e32ff8175118),
        target: state.openOnContext ? state.contextTarget : undefined,
        ...(0, $ab5990c77a5c99b2$export$c06895f23267d8a3)(state.positioning)
    };
    // no reason to render arrow when covering the target
    if (positioningOptions.coverTarget) state.withArrow = false;
    const { targetRef: triggerRef, containerRef: contentRef, arrowRef: arrowRef } = (0, $52c6e5e426b327c0$export$76e597284ffc020)(positioningOptions);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef,
        arrowRef: arrowRef
    };
}



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $59b10a9d6ce22ca1$var$MotionRefForwarderContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $59b10a9d6ce22ca1$export$303310ce19d9244b() {
    return $acw62.useContext($59b10a9d6ce22ca1$var$MotionRefForwarderContext);
}
const $59b10a9d6ce22ca1$export$a606ed35b13f65f2 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($59b10a9d6ce22ca1$var$MotionRefForwarderContext.Provider, {
        value: ref
    }, props.children);
});
$59b10a9d6ce22ca1$export$a606ed35b13f65f2.displayName = 'MotionRefForwarder';
const $59b10a9d6ce22ca1$export$521eca9e79de5335 = (props)=>{
    return /*#__PURE__*/ $acw62.createElement($59b10a9d6ce22ca1$var$MotionRefForwarderContext.Provider, {
        value: undefined
    }, props.children);
};
$59b10a9d6ce22ca1$export$521eca9e79de5335.displayName = 'MotionRefForwarderReset';



const $111559e04c221f40$export$c1ed8784e14550ed = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const { appearance: appearance, arrowRef: arrowRef, contentRef: contentRef, inline: inline, mountNode: mountNode, open: open, openOnContext: openOnContext, openOnHover: openOnHover, setOpen: setOpen, size: size, toggleOpen: toggleOpen, trapFocus: trapFocus, triggerRef: triggerRef, withArrow: withArrow, inertTrapFocus: inertTrapFocus } = state;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $3280b7af847a1fa8$export$9b9a0cd73afb7ca4).Provider, {
        value: {
            appearance: appearance,
            arrowRef: arrowRef,
            contentRef: contentRef,
            inline: inline,
            mountNode: mountNode,
            open: open,
            openOnContext: openOnContext,
            openOnHover: openOnHover,
            setOpen: setOpen,
            toggleOpen: toggleOpen,
            triggerRef: triggerRef,
            size: size,
            trapFocus: trapFocus,
            inertTrapFocus: inertTrapFocus,
            withArrow: withArrow
        },
        children: [
            state.popoverTrigger,
            state.popoverSurface && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.surfaceMotion, {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $59b10a9d6ce22ca1$export$a606ed35b13f65f2), {
                    children: state.popoverSurface
                })
            })
        ]
    });
};


'use client';
const $d4448b917a5b7f9a$export$5b6b19405a83ff9d = (props)=>{
    const state = (0, $11d8a9d2f43b7db3$export$38ececae71530e62)(props);
    return (0, $111559e04c221f40$export$c1ed8784e14550ed)(state);
};
$d4448b917a5b7f9a$export$5b6b19405a83ff9d.displayName = 'Popover';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");




'use client';
const $6c8e51502d1b9754$export$439337d8d48a56fd = (props, ref)=>{
    const size = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.size);
    const appearance = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.appearance);
    const motionForwardedRef = (0, $59b10a9d6ce22ca1$export$303310ce19d9244b)();
    const state = $6c8e51502d1b9754$export$33f99fe49c8c60e1(props, (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, motionForwardedRef));
    return {
        appearance: appearance,
        size: size,
        ...state
    };
};
const $6c8e51502d1b9754$export$33f99fe49c8c60e1 = (props, ref)=>{
    const contentRef = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.contentRef);
    const openOnHover = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.openOnHover);
    const setOpen = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.setOpen);
    const mountNode = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.mountNode);
    const arrowRef = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.arrowRef);
    const withArrow = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.withArrow);
    const trapFocus = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.trapFocus);
    const inertTrapFocus = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.inertTrapFocus);
    const inline = (0, $3280b7af847a1fa8$export$a3cbff38f7dd8303)((context)=>context.inline);
    const { modalAttributes: modalAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)({
        trapFocus: trapFocus,
        legacyTrapFocus: !inertTrapFocus,
        alwaysFocusable: !trapFocus
    });
    const state = {
        inline: inline,
        withArrow: withArrow,
        arrowRef: arrowRef,
        mountNode: mountNode,
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always({
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, contentRef),
            role: trapFocus ? 'dialog' : 'group',
            'aria-modal': trapFocus ? true : undefined,
            ...modalAttributes,
            ...props
        }, {
            elementType: 'div'
        })
    };
    const { onMouseEnter: onMouseEnterOriginal, onMouseLeave: onMouseLeaveOriginal, onKeyDown: onKeyDownOriginal } = state.root;
    state.root.onMouseEnter = (e)=>{
        if (openOnHover) setOpen(e, true);
        onMouseEnterOriginal === null || onMouseEnterOriginal === void 0 || onMouseEnterOriginal(e);
    };
    state.root.onMouseLeave = (e)=>{
        if (openOnHover) setOpen(e, false);
        onMouseLeaveOriginal === null || onMouseLeaveOriginal === void 0 || onMouseLeaveOriginal(e);
    };
    state.root.onKeyDown = (e)=>{
        var _contentRef_current;
        // only close if the event happened inside the current popover
        // If using a stack of inline popovers, the user should call `stopPropagation` to avoid dismissing the entire stack
        if (e.key === 'Escape' && ((_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.contains(e.target))) {
            e.preventDefault();
            setOpen(e, false);
        }
        onKeyDownOriginal === null || onKeyDownOriginal === void 0 || onKeyDownOriginal(e);
    };
    return state;
};




parcelRequire("acw62");
/**
 * Sets the virtual parent of an element.
 *
 * @internal
 * @param child - Theme element to set the virtual parent
 * @param parent - The virtual parent, use `undefined` to remove a virtual parent relationship
 */ function $a62d9fc7d6a8280d$export$9bba5276a9c4d47(child, parent) {
    if (!child) return;
    Object.assign(child, {
        _virtual: {
            parent: parent
        }
    });
}



var $acw62 = parcelRequire("acw62");

function $9ed5fe7220c8736b$export$7bd6d57efd912bd1(mountNode) {
    if ((0, $d23f05efbdb19e52$export$1b3bfaa9684536aa)(mountNode)) return {
        element: mountNode
    };
    if (typeof mountNode === 'object') {
        if (mountNode === null) return {
            element: null
        };
        return mountNode;
    }
    return {};
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * Provides a mount node for portals to render into.
 *
 * @internal
 */ const $de8cc288a4bee6b5$var$PortalMountNodeContext = $acw62.createContext(undefined);
const $de8cc288a4bee6b5$export$16fe5a8de449eeb8 = $de8cc288a4bee6b5$var$PortalMountNodeContext.Provider;
function $de8cc288a4bee6b5$export$8c7eb8a8bdc26bd6() {
    return $acw62.useContext($de8cc288a4bee6b5$var$PortalMountNodeContext);
}





'use client';
const $e72daaf780566451$export$ec6dc86269acedaa = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    root: {
        qhf8xq: "f1euv43f",
        Bhzewxz: "f15twtuk",
        oyh7mz: [
            "f1vgc2s3",
            "f1e31b4d"
        ],
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        Bj3rh1h: "f494woh"
    }
}, {
    d: [
        ".f1euv43f{position:absolute;}",
        ".f15twtuk{top:0;}",
        ".f1vgc2s3{left:0;}",
        ".f1e31b4d{right:0;}",
        ".f494woh{z-index:1000000;}"
    ]
});


'use client';
const $7c03bb17e4640573$var$useInsertionEffect = $acw62.useInsertionEffect;
/**
 * Legacy element factory for React 17 and below. It's not safe for concurrent rendering.
 *
 * Creates a new element on a "document.body" to mount portals.
 */ const $7c03bb17e4640573$var$useLegacyElementFactory = (options)=>{
    'use no memo';
    const { className: className, dir: dir, focusVisibleRef: focusVisibleRef, targetNode: targetNode } = options;
    const targetElement = $acw62.useMemo(()=>{
        if (targetNode === undefined || options.disabled) return null;
        const element = targetNode.ownerDocument.createElement('div');
        targetNode.appendChild(element);
        return element;
    }, [
        targetNode,
        options.disabled
    ]);
    // Heads up!
    // This useMemo() call is intentional for React 17 & below.
    //
    // We don't want to re-create the portal element when its attributes change. This also cannot not be done in an effect
    // because, changing the value of CSS variables after an initial mount will trigger interesting CSS side effects like
    // transitions.
    $acw62.useMemo(()=>{
        if (!targetElement) return;
        targetElement.className = className;
        targetElement.setAttribute('dir', dir);
        targetElement.setAttribute('data-portal-node', 'true');
        focusVisibleRef.current = targetElement;
    }, [
        className,
        dir,
        targetElement,
        focusVisibleRef
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            targetElement === null || targetElement === void 0 || targetElement.remove();
        };
    }, [
        targetElement
    ]);
    return targetElement;
};
const $7c03bb17e4640573$var$initializeElementFactory = ()=>{
    let currentElement = undefined;
    function get(targetRoot, forceCreation) {
        if (currentElement) return currentElement;
        if (forceCreation) {
            currentElement = targetRoot.ownerDocument.createElement('div');
            targetRoot.appendChild(currentElement);
        }
        return currentElement;
    }
    function dispose() {
        if (currentElement) {
            currentElement.remove();
            currentElement = undefined;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
};
/**
 * This is a modern element factory for React 18 and above. It is safe for concurrent rendering.
 *
 * It abuses the fact that React will mount DOM once (unlike hooks), so by using a proxy we can intercept:
 * - the `remove()` method (we call it in `useEffect()`) and remove the element only when the portal is unmounted
 * - all other methods (and properties) will be called by React once a portal is mounted
 */ const $7c03bb17e4640573$var$useModernElementFactory = (options)=>{
    'use no memo';
    const { className: className, dir: dir, focusVisibleRef: focusVisibleRef, targetNode: targetNode } = options;
    const [elementFactory] = $acw62.useState($7c03bb17e4640573$var$initializeElementFactory);
    const elementProxy = $acw62.useMemo(()=>{
        if (targetNode === undefined || options.disabled) return null;
        return new Proxy({}, {
            get (_, property) {
                // Heads up!
                // `createPortal()` performs a check for `nodeType` property to determine if the mount node is a valid DOM node
                // before mounting the portal. We hardcode the value to `Node.ELEMENT_NODE` to pass this check and avoid
                // premature node creation
                if (property === 'nodeType') // Can't use the `Node.ELEMENT_NODE` as it's a browser API and  not available in all environments, e.g SSR
                return 1; // `Node.ELEMENT_NODE`
                // Heads up!
                // We intercept the `remove()` method to remove the mount node only when portal has been unmounted already.
                if (property === 'remove') {
                    const targetElement = elementFactory.get(targetNode, false);
                    if (targetElement) {
                        // If the mountElement has children, the portal is still mounted, otherwise we can dispose of it
                        const portalHasNoChildren = targetElement.childNodes.length === 0;
                        if (portalHasNoChildren) elementFactory.dispose();
                    }
                    return ()=>{
                    // Always return a no-op function to avoid errors in the code
                    };
                }
                const targetElement = elementFactory.get(targetNode, true);
                const targetProperty = targetElement ? targetElement[property] : undefined;
                if (typeof targetProperty === 'function') return targetProperty.bind(targetElement);
                return targetProperty;
            },
            set (_, property, value) {
                const ignoredProperty = property === '_virtual' || property === 'focusVisible';
                // We should use the `elementFactory.get(targetNode, !ignoredProperty)`,
                // but TypeScript requires a literal `true` or `false` for the overload signature.
                // This workaround ensures the correct overload is called and avoids TypeScript errors.
                const targetElement = ignoredProperty ? elementFactory.get(targetNode, false) : elementFactory.get(targetNode, true);
                if (ignoredProperty && !targetElement) // We ignore the `_virtual` and `focusVisible` properties to avoid conflicts with the proxy
                return true;
                if (targetElement) {
                    Object.assign(targetElement, {
                        [property]: value
                    });
                    return true;
                }
                return false;
            }
        });
    }, [
        elementFactory,
        targetNode,
        options.disabled
    ]);
    $7c03bb17e4640573$var$useInsertionEffect(()=>{
        if (!elementProxy) return;
        const classesToApply = className.split(' ').filter(Boolean);
        elementProxy.classList.add(...classesToApply);
        elementProxy.setAttribute('dir', dir);
        elementProxy.setAttribute('data-portal-node', 'true');
        focusVisibleRef.current = elementProxy;
        return ()=>{
            elementProxy.classList.remove(...classesToApply);
            elementProxy.removeAttribute('dir');
        };
    }, [
        className,
        dir,
        elementProxy,
        focusVisibleRef
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            elementProxy === null || elementProxy === void 0 || elementProxy.remove();
        };
    }, [
        elementProxy
    ]);
    return elementProxy;
};
/**
 * Element factory based on the React version.
 *
 * React 17 and below:
 * - useLegacyElementFactory
 *
 * React 18 and above:
 * - useModernElementFactory
 */ const $7c03bb17e4640573$var$useElementFactory = $7c03bb17e4640573$var$useInsertionEffect ? $7c03bb17e4640573$var$useModernElementFactory : $7c03bb17e4640573$var$useLegacyElementFactory;
const $7c03bb17e4640573$export$8c7eb8a8bdc26bd6 = (options)=>{
    'use no memo';
    const { targetDocument: targetDocument, dir: dir } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const mountNode = (0, $de8cc288a4bee6b5$export$8c7eb8a8bdc26bd6)();
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const focusVisibleRef = (0, $ca4cc8ffa907112a$export$ffd9e5021c1fb2d6)();
    const classes = (0, $e72daaf780566451$export$ec6dc86269acedaa)();
    const themeClassName = (0, $74a09e92d7894ea3$export$4996399749b19890)();
    const factoryOptions = {
        dir: dir,
        disabled: options.disabled,
        focusVisibleRef: focusVisibleRef,
        className: (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)(themeClassName, classes.root, options.className),
        targetNode: mountNode !== null && mountNode !== void 0 ? mountNode : targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.body
    };
    return $7c03bb17e4640573$var$useElementFactory(factoryOptions);
};


'use client';
const $b67d1705a4bed2eb$export$bec3100fd3eeaea0 = (props)=>{
    const { element: element, className: className } = (0, $9ed5fe7220c8736b$export$7bd6d57efd912bd1)(props.mountNode);
    const virtualParentRootRef = $acw62.useRef(null);
    const fallbackElement = (0, $7c03bb17e4640573$export$8c7eb8a8bdc26bd6)({
        disabled: !!element,
        className: className
    });
    const mountNode = element !== null && element !== void 0 ? element : fallbackElement;
    const state = {
        children: props.children,
        mountNode: mountNode,
        virtualParentRootRef: virtualParentRootRef
    };
    $acw62.useEffect(()=>{
        if (!mountNode) return;
        const virtualParent = virtualParentRootRef.current;
        // By default, we create a mount node for portal on `document.body` (see usePortalMountNode()) and have following structure:
        //
        // <body>
        //   <!-- ⚛️ application root -->
        //   <div id="root">
        //     <!-- ⬇️ portal node rendered in a tree to anchor (virtual parent node) -->
        //     <span aria-hidden="true"></span>
        //   </div>
        //   <div id="portal-mount-node">
        //     <!-- 🧩portal content -->
        //   </div>
        // </body>
        //
        // To make sure that `.elementContains()` works correctly, we link a virtual parent to a portal node (a virtual parent node becomes a parent of mount node):
        //   virtual.contains(mountNode) === false
        //   (while we need ⬇️⬇️⬇️)
        //   elementsContains(virtualParent, mountNode) === true
        //   elementsContains(mountNode, virtualParent) === false
        //
        // For more details, check docs for virtual parent utils.
        //
        // However, if a user provides a custom mount node (via `props`) the structure could be different:
        //
        // <body>
        //   <!-- application root -->
        //   <div id="root">
        //     <div id="portal-mount-node">
        //       <!-- 🧩portal content -->
        //
        //       <span aria-hidden="true"></span>
        //     </div>
        //   </div>
        // </body>
        //
        // A mount node in this case contains portal's content and a virtual parent node. In this case nodes linking is redundant and the check below avoids it.
        //
        // Otherwise, there is a circular reference - both elements are parents of each other:
        //   elementsContains(mountNode, virtualParent) === true
        //   elementsContains(virtualParent, mountNode) === true
        const isVirtualParentInsideChild = mountNode.contains(virtualParent);
        if (virtualParent && !isVirtualParentInsideChild) {
            (0, $a62d9fc7d6a8280d$export$9bba5276a9c4d47)(mountNode, virtualParent);
            return ()=>{
                (0, $a62d9fc7d6a8280d$export$9bba5276a9c4d47)(mountNode, undefined);
            };
        }
    }, [
        virtualParentRootRef,
        mountNode
    ]);
    return state;
};



var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");
const $8f16234fd734c188$export$a4ab4d705b845138 = (state)=>{
    return /*#__PURE__*/ $acw62.createElement("span", {
        hidden: true,
        ref: state.virtualParentRootRef
    }, state.mountNode && /*#__PURE__*/ $1u0KT.createPortal(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, state.children, /*#__PURE__*/ $acw62.createElement("span", {
        hidden: true
    })), state.mountNode));
};


'use client';
const $aa8a2d30f790b072$export$602eac185826482c = (props)=>{
    const state = (0, $b67d1705a4bed2eb$export$bec3100fd3eeaea0)(props);
    return (0, $8f16234fd734c188$export$a4ab4d705b845138)(state);
};
$aa8a2d30f790b072$export$602eac185826482c.displayName = 'Portal';


const $3381809413785a79$export$e181f1710656c571 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const surface = /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            state.withArrow && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)("div", {
                ref: state.arrowRef,
                className: state.arrowClassName
            }),
            state.root.children
        ]
    });
    if (state.inline) return surface;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $aa8a2d30f790b072$export$602eac185826482c), {
        mountNode: state.mountNode,
        children: surface
    });
};




'use client';
const $e8c10046741b8692$export$8b7437164e479115 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $6c8e51502d1b9754$export$439337d8d48a56fd)(props, ref);
    (0, $b0397c93cedc8a09$export$8e46f2e5324a79b8)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('usePopoverSurfaceStyles_unstable')(state);
    return (0, $3381809413785a79$export$e181f1710656c571)(state);
});
$e8c10046741b8692$export$8b7437164e479115.displayName = 'PopoverSurface';


'use client';
const $0f3d4dea9209d885$var$infoButtonIconMap = {
    small: /*#__PURE__*/ $acw62.createElement((0, $b11634e761ce411b$export$ea2f5cb61d899ae6), null),
    medium: /*#__PURE__*/ $acw62.createElement((0, $b11634e761ce411b$export$57e1bf38e1f55571), null),
    large: /*#__PURE__*/ $acw62.createElement((0, $b11634e761ce411b$export$7ed1b62a96a5843e), null)
};
const $0f3d4dea9209d885$var$popoverSizeMap = {
    small: 'small',
    medium: 'small',
    large: 'medium'
};
const $0f3d4dea9209d885$export$d64b8a2bdde1dfcc = (props, ref)=>{
    const { size: size = 'medium', inline: inline = true, popover: popover, info: info, ...rest } = props;
    const rootRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref);
    const state = {
        inline: inline,
        size: size,
        components: {
            root: 'button',
            popover: (0, $d4448b917a5b7f9a$export$5b6b19405a83ff9d),
            info: (0, $e8c10046741b8692$export$8b7437164e479115)
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('button', {
            children: $0f3d4dea9209d885$var$infoButtonIconMap[size],
            type: 'button',
            'aria-label': 'information',
            ...rest,
            ref: rootRef
        }), {
            elementType: 'button'
        }),
        popover: (0, $fcf7ddccaab7fd8f$exports).always(popover, {
            defaultProps: {
                inline: inline,
                positioning: 'above-start',
                size: $0f3d4dea9209d885$var$popoverSizeMap[size],
                withArrow: true
            },
            elementType: (0, $d4448b917a5b7f9a$export$5b6b19405a83ff9d)
        }),
        info: (0, $fcf7ddccaab7fd8f$exports).always(info, {
            defaultProps: {
                role: 'note',
                tabIndex: -1
            },
            elementType: (0, $e8c10046741b8692$export$8b7437164e479115)
        })
    };
    const [popoverOpen, setPopoverOpen] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: state.popover.open,
        defaultState: state.popover.defaultOpen,
        initialState: false
    });
    state.popover.open = popoverOpen;
    state.popover.onOpenChange = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.popover.onOpenChange, (e, data)=>setPopoverOpen(data.open));
    const infoRef = (0, $de7d48ea62179626$export$9cf7d991616612b3)(state.info.ref);
    state.info.ref = infoRef;
    // Hide the popover when focus moves out of the button and popover
    const onBlurButtonOrInfo = (e)=>{
        const nextFocused = e.relatedTarget;
        if (nextFocused && rootRef.current !== nextFocused && !(0, $d4795d85cdbb4ee3$export$12de49ec5e3dd0cd)(infoRef.current, nextFocused)) setPopoverOpen(false);
    };
    state.root.onBlur = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.root.onBlur, onBlurButtonOrInfo));
    state.info.onBlurCapture = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.info.onBlurCapture, onBlurButtonOrInfo));
    return state;
};






'use client';
const $b0af19cd4a72b4a2$export$51800f574cdd94c9 = {
    root: 'fui-InfoButton',
    // this className won't be used, but it's needed to satisfy the type checker
    popover: 'fui-InfoButton__popover',
    info: 'fui-InfoButton__info'
};
/**
 * Styles for the root slot
 */ const $b0af19cd4a72b4a2$var$useButtonStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        Bt984gj: "f122n59",
        B7ck84d: "f1ewtqcl",
        mc9l5x: "ftuwxu6",
        Brf1p80: "f4d9j23",
        w71qe1: "f1iuv45f",
        ha4doy: "fmrv4ls",
        qhf8xq: "f10pi13n",
        De3pzq: "f1c21dwh",
        sj55zd: "fkfq4zb",
        icvyot: "f1ern45e",
        vrafjx: [
            "f1n71otn",
            "f1deefiw"
        ],
        oivjwe: "f1h8hb77",
        wvpqe5: [
            "f1deefiw",
            "f1n71otn"
        ],
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "f1s184ao",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f16d74zd",
        D0sxk3: "f16u1re",
        t6yez3: "f1rw4040",
        Jwef8y: "fjxutwb",
        Bi91k9c: "f139oj5f",
        eoavqd: "f8491dx",
        Bk3fhr4: "f1jpd6y0",
        Bmfj8id: "fuxngvv",
        iro3zm: "fwiml72",
        B2d53fq: "f1fg1p5m"
    },
    selected: {
        De3pzq: "f1q9pm1r",
        sj55zd: "f1qj7y59",
        D0sxk3: "fgzdkf0",
        t6yez3: "f15q0o9g",
        By8wz76: "f1nz3ub2",
        B7iucu3: "f1205bnn"
    },
    highContrast: {
        B7iucu3: "fslfhp6",
        Bfsdueo: "f11s1vgy",
        pb71ee: "f12b7wpn",
        ik86qs: "f1u668rv"
    },
    focusIndicator: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f8hki3x",
        Bci5o5g: [
            "f1d2448m",
            "ffh67wi"
        ],
        n8qw10: "f1bjia2o",
        Bdrgwmp: [
            "ffh67wi",
            "f1d2448m"
        ],
        Bqhya38: "f1j6vpng",
        Bwxa6fj: [
            "f1pniga2",
            "f1ffjurs"
        ],
        Bdhvstf: "f987i1v",
        B7zbvrb: [
            "f1ffjurs",
            "f1pniga2"
        ],
        Bm4h7ae: "f15bsgw9",
        B7ys5i9: "f14e48fq",
        Busjfv9: "f18yb2kv",
        Bhk32uz: "fd6o370",
        f6g5ot: 0,
        Boxcth7: 0,
        Bhdgwq3: 0,
        hgwjuy: 0,
        Bshpdp8: 0,
        Bsom6fd: 0,
        Blkhhs4: 0,
        Bonggc9: 0,
        Ddfuxk: 0,
        i03rao: 0,
        kclons: 0,
        clg4pj: 0,
        Bpqj9nj: 0,
        B6dhp37: 0,
        Bf4ptjt: 0,
        Bqtpl0w: 0,
        i4rwgc: "ffwy5si",
        Dah5zi: 0,
        B1tsrr9: 0,
        qqdqy8: 0,
        Bkh64rk: 0,
        e3fwne: "f3znvyf",
        J0r882: "f57olzd",
        Bule8hv: [
            "f4stah7",
            "fs1por5"
        ],
        Bjwuhne: "f480a47",
        Ghsupd: [
            "fs1por5",
            "f4stah7"
        ]
    },
    large: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1kx978o"
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".ftuwxu6{display:inline-flex;}",
        ".f4d9j23{justify-content:center;}",
        ".f1iuv45f{text-decoration-line:none;}",
        ".fmrv4ls{vertical-align:middle;}",
        ".f10pi13n{position:relative;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f1ern45e{border-top-style:none;}",
        ".f1n71otn{border-right-style:none;}",
        ".f1deefiw{border-left-style:none;}",
        ".f1h8hb77{border-bottom-style:none;}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        [
            ".f1s184ao{margin:0;}",
            {
                p: -1
            }
        ],
        [
            ".f16d74zd{padding:var(--spacingVerticalXS) var(--spacingHorizontalXS);}",
            {
                p: -1
            }
        ],
        ".f16u1re .fui-Icon-filled{display:none;}",
        ".f1rw4040 .fui-Icon-regular{display:inline-flex;}",
        ".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}",
        ".f1qj7y59{color:var(--colorNeutralForeground2BrandSelected);}",
        ".fgzdkf0 .fui-Icon-filled{display:inline-flex;}",
        ".f15q0o9g .fui-Icon-regular{display:none;}",
        ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",
        ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",
        ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",
        ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",
        ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}",
        ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",
        ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",
        ".fd6o370[data-fui-focus-visible]::after{z-index:1;}",
        [
            ".ffwy5si[data-fui-focus-visible]::after{border:2px solid var(--colorStrokeFocus2);}",
            {
                p: -2
            }
        ],
        [
            ".f3znvyf[data-fui-focus-visible]::after{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}",
        ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}",
        ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}",
        ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}",
        [
            ".f1kx978o{padding:var(--spacingVerticalXXS) var(--spacingVerticalXXS);}",
            {
                p: -1
            }
        ]
    ],
    h: [
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f8491dx:hover{cursor:pointer;}",
        ".f1jpd6y0:hover .fui-Icon-filled{display:inline-flex;}",
        ".fuxngvv:hover .fui-Icon-regular{display:none;}",
        ".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f1fg1p5m:hover:active{color:var(--colorNeutralForeground2BrandPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1nz3ub2{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1205bnn{color:Canvas;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fslfhp6{color:CanvasText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f11s1vgy:hover,.f11s1vgy:hover:active{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f12b7wpn:hover,.f12b7wpn:hover:active{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1u668rv:hover,.f1u668rv:hover:active{color:Canvas;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1j6vpng[data-fui-focus-visible]::after{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ffjurs[data-fui-focus-visible]::after{border-left-color:Highlight;}.f1pniga2[data-fui-focus-visible]::after{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f987i1v[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ]
});
const $b0af19cd4a72b4a2$var$usePopoverSurfaceStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        B2u0y6b: "f1qmtlvf"
    },
    smallMedium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f1qmtlvf{max-width:264px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const $b0af19cd4a72b4a2$export$5f0c18bb69638ffa = (state)=>{
    'use no memo';
    const { size: size } = state;
    const { open: open } = state.popover;
    const buttonStyles = $b0af19cd4a72b4a2$var$useButtonStyles();
    const popoverSurfaceStyles = $b0af19cd4a72b4a2$var$usePopoverSurfaceStyles();
    state.info.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($b0af19cd4a72b4a2$export$51800f574cdd94c9.info, popoverSurfaceStyles.base, size === 'large' ? popoverSurfaceStyles.large : popoverSurfaceStyles.smallMedium, state.info.className);
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($b0af19cd4a72b4a2$export$51800f574cdd94c9.root, buttonStyles.base, buttonStyles.highContrast, buttonStyles.focusIndicator, open && buttonStyles.selected, size === 'large' && buttonStyles.large, state.root.className);
    return state;
};


'use client';
const $c411844bf030ee28$export$10d4b9c1046c21df = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $0f3d4dea9209d885$export$d64b8a2bdde1dfcc)(props, ref);
    (0, $b0af19cd4a72b4a2$export$5f0c18bb69638ffa)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useInfoButtonStyles_unstable')(state);
    return (0, $3a031b21ff566868$export$9ef445a692a707f5)(state);
});
$c411844bf030ee28$export$10d4b9c1046c21df.displayName = 'InfoButton';


'use client';
const $afd8ebd6dc0e5442$export$d262c2e297b8bb80 = (props, ref)=>{
    const { root: rootShorthand, label: labelShorthand, infoButton: infoButtonShorthand, info: info, size: size, className: className, style: style, ...labelProps } = props;
    const baseId = (0, $0200d30cfa270435$export$f680877a34711e37)('infolabel-');
    const [open, setOpen] = $acw62.useState(false);
    const root = (0, $fcf7ddccaab7fd8f$exports).always(rootShorthand, {
        defaultProps: {
            className: className,
            style: style
        },
        elementType: 'span'
    });
    const label = (0, $fcf7ddccaab7fd8f$exports).always(labelShorthand, {
        defaultProps: {
            id: baseId + '__label',
            ref: ref,
            size: size,
            ...labelProps
        },
        elementType: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5)
    });
    const infoButton = (0, $fcf7ddccaab7fd8f$exports).optional(infoButtonShorthand, {
        renderByDefault: !!info,
        defaultProps: {
            id: baseId + '__infoButton',
            size: size,
            info: info
        },
        elementType: (0, $c411844bf030ee28$export$10d4b9c1046c21df)
    });
    const infoButtonPopover = (0, $fcf7ddccaab7fd8f$exports).always(infoButton === null || infoButton === void 0 ? void 0 : infoButton.popover, {
        elementType: 'div'
    });
    infoButtonPopover.onOpenChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((0, $5a086c5c32116b33$export$f05a241035b5c5eb)(infoButtonPopover.onOpenChange, (_, data)=>{
        setOpen(data.open);
    }));
    if (infoButton) {
        var _infoButton, _arialabelledby;
        infoButton.popover = infoButtonPopover;
        const infoPopupId = baseId + '__info'; // used as a self-referencing aria-labelledby to name the popup
        infoButton.info = (0, $fcf7ddccaab7fd8f$exports).optional(infoButton === null || infoButton === void 0 ? void 0 : infoButton.info, {
            defaultProps: {
                id: infoPopupId,
                'aria-labelledby': infoPopupId
            },
            elementType: 'div'
        });
        var _;
        (_ = (_infoButton = infoButton)[_arialabelledby = 'aria-labelledby']) !== null && _ !== void 0 ? _ : _infoButton[_arialabelledby] = `${label.id} ${infoButton.id}`;
        if (open) {
            var _infoButton_info;
            var _root, _ariaowns;
            var _1;
            (_1 = (_root = root)[_ariaowns = 'aria-owns']) !== null && _1 !== void 0 ? _1 : _root[_ariaowns] = (_infoButton_info = infoButton.info) === null || _infoButton_info === void 0 ? void 0 : _infoButton_info.id;
        }
    }
    return {
        size: size,
        components: {
            root: 'span',
            label: (0, $0d13e5c2b1019ada$export$b04be29aa201d4f5),
            infoButton: (0, $c411844bf030ee28$export$10d4b9c1046c21df)
        },
        root: root,
        label: label,
        infoButton: infoButton
    };
};




'use client';
const $76bc261a2cb36f06$export$fad2dd3120c384c0 = {
    root: 'fui-InfoLabel',
    label: 'fui-InfoLabel__label',
    infoButton: 'fui-InfoLabel__infoButton'
};
const $76bc261a2cb36f06$var$useLabelStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        ha4doy: "f12kltsn",
        Bceei9c: "fpo1scq",
        sj55zd: "f1ym3bx4"
    }
}, {
    d: [
        ".f12kltsn{vertical-align:top;}",
        ".fpo1scq{cursor:inherit;}",
        ".f1ym3bx4{color:inherit;}"
    ]
});
const $76bc261a2cb36f06$var$useInfoButtonStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        ha4doy: "f12kltsn",
        B6of3ja: "f1bmzb36",
        jrapky: "f1nyzk09"
    },
    large: {
        B6of3ja: "fkrn0sh",
        jrapky: "fmxx68s"
    }
}, {
    d: [
        ".f12kltsn{vertical-align:top;}",
        ".f1bmzb36{margin-top:calc(0px - var(--spacingVerticalXXS));}",
        ".f1nyzk09{margin-bottom:calc(0px - var(--spacingVerticalXXS));}",
        ".fkrn0sh{margin-top:-1px;}",
        ".fmxx68s{margin-bottom:-1px;}"
    ]
});
const $76bc261a2cb36f06$export$a61a8874c3d5fd23 = (state)=>{
    'use no memo';
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($76bc261a2cb36f06$export$fad2dd3120c384c0.root, state.root.className);
    const labelStyles = $76bc261a2cb36f06$var$useLabelStyles();
    state.label.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($76bc261a2cb36f06$export$fad2dd3120c384c0.label, labelStyles.base, state.label.className);
    const infoButtonStyles = $76bc261a2cb36f06$var$useInfoButtonStyles();
    if (state.infoButton) state.infoButton.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($76bc261a2cb36f06$export$fad2dd3120c384c0.infoButton, infoButtonStyles.base, state.size === 'large' && infoButtonStyles.large, state.infoButton.className);
    return state;
};


'use client';
const $123fb63dcb21233c$export$6fdf58e0e61e341c = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $afd8ebd6dc0e5442$export$d262c2e297b8bb80)(props, ref);
    (0, $76bc261a2cb36f06$export$a61a8874c3d5fd23)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useInfoLabelStyles_unstable')(state);
    return (0, $9d564f25d704974e$export$f6b0663682a12f37)(state);
});
$123fb63dcb21233c$export$6fdf58e0e61e341c.displayName = 'InfoLabel';


function $8c4a1369613a4589$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: "My Stats"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bf8e3f93ce344917$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a43c21910348d1c5$export$f850895b287ef28e), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                    children: "Stat"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                    children: "Value"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3f2f433630850f26$export$76ccd210b9029917), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Health",
                                            info: "Your current and maximum health points."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: "100 / 100"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Effects",
                                            info: "Positive and negative effects applied to your character which may affect other stats."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: "None"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $6df4f37e48127749$export$fa847e2f8b096512 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    const { iconOnly: iconOnly, iconPosition: iconPosition } = state;
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            iconPosition !== 'after' && state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {}),
            !iconOnly && state.root.children,
            iconPosition === 'after' && state.icon && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.icon, {})
        ]
    });
};


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $dc087adc5dbcef9a$var$buttonContext = $acw62.createContext(undefined);
const $dc087adc5dbcef9a$var$buttonContextDefaultValue = {};
const $dc087adc5dbcef9a$export$e87f888e47863634 = $dc087adc5dbcef9a$var$buttonContext.Provider;
const $dc087adc5dbcef9a$export$d891409b33cf7746 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($dc087adc5dbcef9a$var$buttonContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $dc087adc5dbcef9a$var$buttonContextDefaultValue;
};




'use client';
const $8b87161d0930eae0$export$12d06f80de047e9c = (props, ref)=>{
    const { size: contextSize } = (0, $dc087adc5dbcef9a$export$d891409b33cf7746)();
    const { appearance: appearance = 'secondary', shape: shape = 'rounded', size: size = contextSize !== null && contextSize !== void 0 ? contextSize : 'medium', ...buttonProps } = props;
    const state = $8b87161d0930eae0$export$c7a7c16b2f498556(buttonProps, ref);
    return {
        appearance: appearance,
        shape: shape,
        size: size,
        ...state
    };
};
const $8b87161d0930eae0$export$c7a7c16b2f498556 = (props, ref)=>{
    const { icon: icon, iconPosition: iconPosition = 'before', ...buttonProps } = props;
    const iconShorthand = (0, $fcf7ddccaab7fd8f$exports).optional(icon, {
        elementType: 'span'
    });
    var _props_disabled, _props_disabledFocusable;
    return {
        disabled: (_props_disabled = props.disabled) !== null && _props_disabled !== void 0 ? _props_disabled : false,
        disabledFocusable: (_props_disabledFocusable = props.disabledFocusable) !== null && _props_disabledFocusable !== void 0 ? _props_disabledFocusable : false,
        iconPosition: iconPosition,
        iconOnly: Boolean((iconShorthand === null || iconShorthand === void 0 ? void 0 : iconShorthand.children) && !props.children),
        components: {
            root: 'button',
            icon: 'span'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)(buttonProps.as, buttonProps), {
            elementType: 'button',
            defaultProps: {
                ref: ref,
                type: props.as !== 'a' ? 'button' : undefined
            }
        }),
        icon: iconShorthand
    };
};






'use client';
const $fc006584baa1fb60$export$d740529b277354ec = {
    root: 'fui-Button',
    icon: 'fui-Button__icon'
};
const $fc006584baa1fb60$var$iconSpacingVar = '--fui-Button__icon--spacing';
const $fc006584baa1fb60$var$buttonSpacingSmall = '3px';
const $fc006584baa1fb60$var$buttonSpacingSmallWithIcon = '1px';
const $fc006584baa1fb60$var$buttonSpacingMedium = '5px';
const $fc006584baa1fb60$var$buttonSpacingLarge = '8px';
const $fc006584baa1fb60$var$buttonSpacingLargeWithIcon = '7px';
/* Firefox has box shadow sizing issue at some zoom levels
 * this will ensure the inset boxShadow is always uniform
 * without affecting other browser platforms
 */ const $fc006584baa1fb60$var$boxShadowStrokeWidthThinMoz = `calc(${(0, $4e9eda319b2a962b$export$6ad93df59e712c43).strokeWidthThin} + 0.25px)`;
const $fc006584baa1fb60$var$useRootBaseClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r1f29ykk", null, {
    r: [
        ".r1f29ykk{align-items:center;box-sizing:border-box;display:inline-flex;justify-content:center;text-decoration-line:none;vertical-align:middle;margin:0;overflow:hidden;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);font-family:var(--fontFamilyBase);outline-style:none;padding:5px var(--spacingHorizontalM);min-width:96px;border-radius:var(--borderRadiusMedium);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);transition-duration:var(--durationFaster);transition-property:background,border,color;transition-timing-function:var(--curveEasyEase);}",
        ".r1f29ykk:hover{background-color:var(--colorNeutralBackground1Hover);border-color:var(--colorNeutralStroke1Hover);color:var(--colorNeutralForeground1Hover);cursor:pointer;}",
        ".r1f29ykk:hover:active,.r1f29ykk:active:focus-visible{background-color:var(--colorNeutralBackground1Pressed);border-color:var(--colorNeutralStroke1Pressed);color:var(--colorNeutralForeground1Pressed);outline-style:none;}",
        ".r1f29ykk[data-fui-focus-visible]{border-color:var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);border-width:1px;outline:var(--strokeWidthThick) solid var(--colorTransparentStroke);box-shadow:0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;z-index:1;}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.r1f29ykk{transition-duration:0.01ms;}}",
        "@media (forced-colors: active){.r1f29ykk:focus{border-color:ButtonText;}.r1f29ykk:hover{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}.r1f29ykk:hover:active,.r1f29ykk:active:focus-visible{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}}",
        "@supports (-moz-appearance:button){.r1f29ykk[data-fui-focus-visible]{box-shadow:0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"
    ]
});
const $fc006584baa1fb60$var$useIconBaseClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rywnvv2", null, [
    ".rywnvv2{align-items:center;display:inline-flex;justify-content:center;font-size:20px;height:20px;width:20px;--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}"
]);
const $fc006584baa1fb60$var$useRootStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    outline: {
        De3pzq: "f1c21dwh",
        Jwef8y: "fjxutwb",
        Bpjbzib: "fkoldzo"
    },
    primary: {
        De3pzq: "ffp7eso",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "f1phragk",
        Jwef8y: "f15wkkf3",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f1rq72xc",
        Bpjbzib: "f1ksv2xa",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ],
        Brsut9c: "f1d6mv4x",
        By8wz76: "f1nz3ub2",
        Bcq6wej: "fag2qd2",
        Jcjdmf: [
            "fmvhcg7",
            "f14bpyus"
        ],
        sc4o1m: "f1o3dhpw",
        Bosien3: [
            "f14bpyus",
            "fmvhcg7"
        ],
        B7iucu3: "fqc85l4",
        B8gzw0y: "f1h3a8gf",
        Bbkh6qg: "fkiggi6",
        F230oe: "f8gmj8i",
        Bdw8ktp: [
            "f1ap8nzx",
            "fjag8bx"
        ],
        Bj1xduy: "f1igan7k",
        Bhh2cfd: [
            "fjag8bx",
            "f1ap8nzx"
        ],
        Bahaeuw: "f1v3eptx",
        Bv2bamp: "f1ysmecq",
        vxuvv6: "faulsx",
        Bli9q98: [
            "f79t15f",
            "f8qmx7k"
        ],
        Bx2tt8t: "fbtzoaq",
        yad0b3: [
            "f8qmx7k",
            "f79t15f"
        ],
        j2fop7: "fd4bjan"
    },
    secondary: {},
    subtle: {
        De3pzq: "fhovq9v",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "fkfq4zb",
        Jwef8y: "f1t94bn6",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "fnwyq0v",
        Bk3fhr4: "ft1hn21",
        Bmfj8id: "fuxngvv",
        Bbdnnc7: "fy5bs14",
        Bpjbzib: "f1q1yqic",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ],
        Brsut9c: "fwga7ee",
        Bqou3pl: "f1nhwcv0",
        Bsnehw8: "f1gm6xmp",
        wsxvnf: "f1xxsver",
        Bahaeuw: "f1v3eptx",
        Buhizc3: "fivsta0",
        j2fop7: "fd4bjan",
        Bqabnb4: "f3m6zum"
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "fkfq4zb",
        Jwef8y: "fjxutwb",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f139oj5f",
        Bk3fhr4: "ft1hn21",
        Bmfj8id: "fuxngvv",
        Bpjbzib: "fkoldzo",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ],
        Brsut9c: "f1l983o9",
        Bqou3pl: "f1nhwcv0",
        Bsnehw8: "f1gm6xmp",
        Bbkh6qg: "fxoo9op",
        Bahaeuw: "f1v3eptx",
        Bv2bamp: "f1i0gk12",
        j2fop7: "fd4bjan"
    },
    circular: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f44lkw9"
    },
    rounded: {},
    square: {
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "f1fabniw"
    },
    small: {
        Bf4jedk: "fh7ncta",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fneth5b",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    smallWithIcon: {
        Byoj8tv: "f1brlhvm",
        z8tnut: "f1sl3k7w"
    },
    medium: {},
    large: {
        Bf4jedk: "f14es27b",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f4db1ww",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    largeWithIcon: {
        Byoj8tv: "fy7v416",
        z8tnut: "f1a1bwwz"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        [
            ".f44lkw9{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".f1fabniw{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        ".fh7ncta{min-width:64px;}",
        [
            ".fneth5b{padding:3px var(--spacingHorizontalS);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f1brlhvm{padding-bottom:1px;}",
        ".f1sl3k7w{padding-top:1px;}",
        ".f14es27b{min-width:96px;}",
        [
            ".f4db1ww{padding:8px var(--spacingHorizontalL);}",
            {
                p: -1
            }
        ],
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fy7v416{padding-bottom:7px;}",
        ".f1a1bwwz{padding-top:7px;}"
    ],
    h: [
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".fkoldzo:hover:active,.fkoldzo:active:focus-visible{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f15wkkf3:hover{background-color:var(--colorBrandBackgroundHover);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".f1rq72xc:hover{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1ksv2xa:hover:active,.f1ksv2xa:active:focus-visible{background-color:var(--colorBrandBackgroundPressed);}",
        ".fhvnf4x:hover:active,.fhvnf4x:active:focus-visible{border-top-color:transparent;}",
        ".fb6swo4:hover:active,.fb6swo4:active:focus-visible{border-right-color:transparent;}",
        ".f232fm2:hover:active,.f232fm2:active:focus-visible{border-left-color:transparent;}",
        ".f1klyf7k:hover:active,.f1klyf7k:active:focus-visible{border-bottom-color:transparent;}",
        ".f1d6mv4x:hover:active,.f1d6mv4x:active:focus-visible{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",
        ".ft1hn21:hover .fui-Icon-filled{display:inline;}",
        ".fuxngvv:hover .fui-Icon-regular{display:none;}",
        ".fy5bs14:hover .fui-Button__icon{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1q1yqic:hover:active,.f1q1yqic:active:focus-visible{background-color:var(--colorSubtleBackgroundPressed);}",
        ".fwga7ee:hover:active,.fwga7ee:active:focus-visible{color:var(--colorNeutralForeground2Pressed);}",
        ".f1nhwcv0:hover:active .fui-Icon-filled,.f1nhwcv0:active:focus-visible .fui-Icon-filled{display:inline;}",
        ".f1gm6xmp:hover:active .fui-Icon-regular,.f1gm6xmp:active:focus-visible .fui-Icon-regular{display:none;}",
        ".f1xxsver:hover:active .fui-Button__icon,.f1xxsver:active:focus-visible .fui-Button__icon{color:var(--colorNeutralForeground2BrandPressed);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1l983o9:hover:active,.f1l983o9:active:focus-visible{color:var(--colorNeutralForeground2BrandPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1nz3ub2{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fag2qd2{border-top-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14bpyus{border-left-color:HighlightText;}.fmvhcg7{border-right-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1o3dhpw{border-bottom-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fqc85l4{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1h3a8gf{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkiggi6:hover{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f8gmj8i:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ap8nzx:hover{border-right-color:Highlight;}.fjag8bx:hover{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1igan7k:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1v3eptx:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ysmecq:hover:active,.f1ysmecq:active:focus-visible{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.faulsx:hover:active,.faulsx:active:focus-visible{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f79t15f:hover:active,.f79t15f:active:focus-visible{border-right-color:Highlight;}.f8qmx7k:hover:active,.f8qmx7k:active:focus-visible{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbtzoaq:hover:active,.fbtzoaq:active:focus-visible{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fd4bjan:hover:active,.fd4bjan:active:focus-visible{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fivsta0:hover .fui-Button__icon{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3m6zum:hover:active .fui-Button__icon,.f3m6zum:active:focus-visible .fui-Button__icon{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fxoo9op:hover{background-color:var(--colorTransparentBackground);}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1i0gk12:hover:active,.f1i0gk12:active:focus-visible{background-color:var(--colorTransparentBackground);}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $fc006584baa1fb60$var$useRootDisabledStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    base: {
        De3pzq: "f1bg9a2p",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr",
        Bfinmwp: "f15x8b5r",
        Jwef8y: "f1falr9n",
        Bgoe8wy: "f12mpcsy",
        Bwzppfd: [
            "f1gwvigk",
            "f18rmfxp"
        ],
        oetu4i: "f1jnshp0",
        gg5e9n: [
            "f18rmfxp",
            "f1gwvigk"
        ],
        Bi91k9c: "fvgxktp",
        eoavqd: "fphbwmw",
        Bk3fhr4: "f19vpps7",
        Bmfj8id: "fv5swzo",
        Bbdnnc7: "f1al02dq",
        Bpjbzib: "f1jct5ie",
        im15vp: "f13txml0",
        Hjvxdg: [
            "f1ncddno",
            "f1axfvow"
        ],
        Gpfmf1: "f1z04ada",
        ustxxc: [
            "f1axfvow",
            "f1ncddno"
        ],
        Brsut9c: "f1uhomfy",
        Bses4qk: "fy9mucy",
        Bqou3pl: "f1g9va8i",
        Bsnehw8: "fwgvudy",
        wsxvnf: "fom6jww"
    },
    highContrast: {
        By8wz76: "f14ptb23",
        Bcq6wej: "f9dbb4x",
        Jcjdmf: [
            "f3qs60o",
            "f5u9ap2"
        ],
        sc4o1m: "fwd1oij",
        Bosien3: [
            "f5u9ap2",
            "f3qs60o"
        ],
        B7iucu3: "f1cyfu5x",
        Grqk0h: "f127ot8j",
        h3ptyc: "f19etb0b",
        Buw724y: [
            "f4f984j",
            "fw441p0"
        ],
        Buk7464: "f3d22hf",
        Hwei09: [
            "fw441p0",
            "f4f984j"
        ],
        Bbkh6qg: "fj8k9ua",
        F230oe: "fifrq0d",
        Bdw8ktp: [
            "f196mwp7",
            "fnekfq"
        ],
        Bj1xduy: "f1l6uprw",
        Bhh2cfd: [
            "fnekfq",
            "f196mwp7"
        ],
        Bahaeuw: "fa9u7a5",
        Buhizc3: "f1m71e0y",
        Bv2bamp: "fw24f3",
        vxuvv6: "f1nznrny",
        Bli9q98: [
            "fq8nxuu",
            "f1ao3jkc"
        ],
        Bx2tt8t: "ftoixeo",
        yad0b3: [
            "f1ao3jkc",
            "fq8nxuu"
        ],
        j2fop7: "fpmuzpx",
        Bqabnb4: "f168odog"
    },
    outline: {
        De3pzq: "f1c21dwh",
        Jwef8y: "f9ql6rf",
        Bpjbzib: "f9r0db0"
    },
    primary: {
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ]
    },
    secondary: {},
    subtle: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "f9ql6rf",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bpjbzib: "f9r0db0",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ]
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "f9ql6rf",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bpjbzib: "f9r0db0",
        im15vp: "fhvnf4x",
        Hjvxdg: [
            "fb6swo4",
            "f232fm2"
        ],
        Gpfmf1: "f1klyf7k",
        ustxxc: [
            "f232fm2",
            "fb6swo4"
        ]
    }
}, {
    d: [
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f15x8b5r .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}"
    ],
    h: [
        ".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".fphbwmw:hover{cursor:not-allowed;}",
        ".f19vpps7:hover .fui-Icon-filled{display:none;}",
        ".fv5swzo:hover .fui-Icon-regular{display:inline;}",
        ".f1al02dq:hover .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".f1jct5ie:hover:active,.f1jct5ie:active:focus-visible{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f13txml0:hover:active,.f13txml0:active:focus-visible{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1ncddno:hover:active,.f1ncddno:active:focus-visible{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f1axfvow:hover:active,.f1axfvow:active:focus-visible{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1z04ada:hover:active,.f1z04ada:active:focus-visible{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1uhomfy:hover:active,.f1uhomfy:active:focus-visible{color:var(--colorNeutralForegroundDisabled);}",
        ".fy9mucy:hover:active,.fy9mucy:active:focus-visible{cursor:not-allowed;}",
        ".f1g9va8i:hover:active .fui-Icon-filled,.f1g9va8i:active:focus-visible .fui-Icon-filled{display:none;}",
        ".fwgvudy:hover:active .fui-Icon-regular,.fwgvudy:active:focus-visible .fui-Icon-regular{display:inline;}",
        ".fom6jww:hover:active .fui-Button__icon,.fom6jww:active:focus-visible .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}",
        ".f9r0db0:hover:active,.f9r0db0:active:focus-visible{background-color:var(--colorTransparentBackground);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".fhvnf4x:hover:active,.fhvnf4x:active:focus-visible{border-top-color:transparent;}",
        ".fb6swo4:hover:active,.fb6swo4:active:focus-visible{border-right-color:transparent;}",
        ".f232fm2:hover:active,.f232fm2:active:focus-visible{border-left-color:transparent;}",
        ".f1klyf7k:hover:active,.f1klyf7k:active:focus-visible{border-bottom-color:transparent;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f14ptb23{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9dbb4x{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3qs60o{border-right-color:GrayText;}.f5u9ap2{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fwd1oij{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cyfu5x{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f127ot8j .fui-Button__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f19etb0b:focus{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f4f984j:focus{border-right-color:GrayText;}.fw441p0:focus{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f3d22hf:focus{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fj8k9ua:hover{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fifrq0d:hover{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f196mwp7:hover{border-right-color:GrayText;}.fnekfq:hover{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1l6uprw:hover{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fa9u7a5:hover{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1m71e0y:hover .fui-Button__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fw24f3:hover:active,.fw24f3:active:focus-visible{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1nznrny:hover:active,.f1nznrny:active:focus-visible{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ao3jkc:hover:active,.f1ao3jkc:active:focus-visible{border-left-color:GrayText;}.fq8nxuu:hover:active,.fq8nxuu:active:focus-visible{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.ftoixeo:hover:active,.ftoixeo:active:focus-visible{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fpmuzpx:hover:active,.fpmuzpx:active:focus-visible{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f168odog:hover:active .fui-Button__icon,.f168odog:active:focus-visible .fui-Button__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $fc006584baa1fb60$var$useRootFocusStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    circular: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f1062rbf"
    },
    rounded: {},
    square: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "fj0ryk1"
    },
    primary: {
        B8q5s1w: "f17t0x8g",
        Bci5o5g: [
            "f194v5ow",
            "fk7jm04"
        ],
        n8qw10: "f1qgg65p",
        Bdrgwmp: [
            "fk7jm04",
            "f194v5ow"
        ],
        j6ew2k: [
            "fhgccpy",
            "fjo7pq6"
        ],
        he4mth: "f32wu9k",
        Byr4aka: "fu5nqqq",
        lks7q5: [
            "f13prjl2",
            "f1nl83rv"
        ],
        Bnan3qt: "f1czftr5",
        k1dn9: [
            "f1nl83rv",
            "f13prjl2"
        ],
        Bqsb82s: [
            "fixhny3",
            "f18mfu3r"
        ],
        jg1oma: "feygou5"
    },
    small: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "fazmxh"
    },
    medium: {},
    large: {
        Bw81rd7: 0,
        kdpuga: 0,
        dm238s: 0,
        B6xbmo0: 0,
        B3whbx2: "f1b6alqh"
    }
}, {
    d: [
        [
            ".f1062rbf[data-fui-focus-visible]{border-radius:var(--borderRadiusCircular);}",
            {
                p: -1
            }
        ],
        [
            ".fj0ryk1[data-fui-focus-visible]{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        ".f17t0x8g[data-fui-focus-visible]{border-top-color:var(--colorStrokeFocus2);}",
        ".f194v5ow[data-fui-focus-visible]{border-right-color:var(--colorStrokeFocus2);}",
        ".fk7jm04[data-fui-focus-visible]{border-left-color:var(--colorStrokeFocus2);}",
        ".f1qgg65p[data-fui-focus-visible]{border-bottom-color:var(--colorStrokeFocus2);}",
        ".fhgccpy[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}",
        ".fjo7pq6[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}",
        ".f32wu9k[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;}",
        ".fu5nqqq[data-fui-focus-visible]:hover{border-top-color:var(--colorStrokeFocus2);}",
        ".f13prjl2[data-fui-focus-visible]:hover{border-right-color:var(--colorStrokeFocus2);}",
        ".f1nl83rv[data-fui-focus-visible]:hover{border-left-color:var(--colorStrokeFocus2);}",
        ".f1czftr5[data-fui-focus-visible]:hover{border-bottom-color:var(--colorStrokeFocus2);}",
        [
            ".fazmxh[data-fui-focus-visible]{border-radius:var(--borderRadiusSmall);}",
            {
                p: -1
            }
        ],
        [
            ".f1b6alqh[data-fui-focus-visible]{border-radius:var(--borderRadiusLarge);}",
            {
                p: -1
            }
        ]
    ],
    t: [
        "@supports (-moz-appearance:button){.f18mfu3r[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}.fixhny3[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}}",
        "@supports (-moz-appearance:button){.feygou5[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"
    ]
});
const $fc006584baa1fb60$var$useRootIconOnlyStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    small: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fu97m5z",
        Bf4jedk: "f17fgpbq",
        B2u0y6b: "f1jt17bm"
    },
    medium: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f18ktai2",
        Bf4jedk: "fwbmr0d",
        B2u0y6b: "f44c6la"
    },
    large: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1hbd1aw",
        Bf4jedk: "f12clzc2",
        B2u0y6b: "fjy1crr"
    }
}, {
    d: [
        [
            ".fu97m5z{padding:1px;}",
            {
                p: -1
            }
        ],
        ".f17fgpbq{min-width:24px;}",
        ".f1jt17bm{max-width:24px;}",
        [
            ".f18ktai2{padding:5px;}",
            {
                p: -1
            }
        ],
        ".fwbmr0d{min-width:32px;}",
        ".f44c6la{max-width:32px;}",
        [
            ".f1hbd1aw{padding:7px;}",
            {
                p: -1
            }
        ],
        ".f12clzc2{min-width:40px;}",
        ".fjy1crr{max-width:40px;}"
    ]
});
const $fc006584baa1fb60$var$useIconStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    small: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3",
        Bqrlyyl: "fbaiahx"
    },
    medium: {},
    large: {
        Be2twd7: "f1rt2boy",
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun",
        Bqrlyyl: "f1exjqw5"
    },
    before: {
        t21cq0: [
            "f1nizpg2",
            "f1a695kz"
        ]
    },
    after: {
        Frg6f3: [
            "f1a695kz",
            "f1nizpg2"
        ]
    }
}, {
    d: [
        ".fe5j1ua{font-size:20px;}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".fbaiahx{--fui-Button__icon--spacing:var(--spacingHorizontalXS);}",
        ".f1rt2boy{font-size:24px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".f1exjqw5{--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}",
        ".f1nizpg2{margin-right:var(--fui-Button__icon--spacing);}",
        ".f1a695kz{margin-left:var(--fui-Button__icon--spacing);}"
    ]
});
const $fc006584baa1fb60$export$4caadad6dc3cda7b = (state)=>{
    'use no memo';
    const rootBaseClassName = $fc006584baa1fb60$var$useRootBaseClassName();
    const iconBaseClassName = $fc006584baa1fb60$var$useIconBaseClassName();
    const rootStyles = $fc006584baa1fb60$var$useRootStyles();
    const rootDisabledStyles = $fc006584baa1fb60$var$useRootDisabledStyles();
    const rootFocusStyles = $fc006584baa1fb60$var$useRootFocusStyles();
    const rootIconOnlyStyles = $fc006584baa1fb60$var$useRootIconOnlyStyles();
    const iconStyles = $fc006584baa1fb60$var$useIconStyles();
    const { appearance: appearance, disabled: disabled, disabledFocusable: disabledFocusable, icon: icon, iconOnly: iconOnly, iconPosition: iconPosition, shape: shape, size: size } = state;
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($fc006584baa1fb60$export$d740529b277354ec.root, rootBaseClassName, appearance && rootStyles[appearance], rootStyles[size], icon && size === 'small' && rootStyles.smallWithIcon, icon && size === 'large' && rootStyles.largeWithIcon, rootStyles[shape], // Disabled styles
    (disabled || disabledFocusable) && rootDisabledStyles.base, (disabled || disabledFocusable) && rootDisabledStyles.highContrast, appearance && (disabled || disabledFocusable) && rootDisabledStyles[appearance], // Focus styles
    appearance === 'primary' && rootFocusStyles.primary, rootFocusStyles[size], rootFocusStyles[shape], // Icon-only styles
    iconOnly && rootIconOnlyStyles[size], // User provided class name
    state.root.className);
    if (state.icon) state.icon.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($fc006584baa1fb60$export$d740529b277354ec.icon, iconBaseClassName, !!state.root.children && iconStyles[iconPosition], iconStyles[size], state.icon.className);
    return state;
};



'use client';
const $4b2f31b5d520190a$export$353f5b6fc5456de1 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $8b87161d0930eae0$export$12d06f80de047e9c)(props, ref);
    (0, $fc006584baa1fb60$export$4caadad6dc3cda7b)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useButtonStyles_unstable')(state);
    return (0, $6df4f37e48127749$export$fa847e2f8b096512)(state);
// Casting is required due to lack of distributive union to support unions on @types/react
});
$4b2f31b5d520190a$export$353f5b6fc5456de1.displayName = 'Button';



"use client";
const $61c84b424f99a7b1$export$dfd24591b5ec6a83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditColor', "1em", `<path d="M12.25 3.54 4 11.8l1.05 3.16 3.17 1.03 8.24-8.23-4.2-4.2Z" fill="url(#ic_fluent_edit_20_color__a)"/><path d="m4.12 11.67-.57.58c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68l.56-.56s-1.6-.48-2.67-1.54a7.23 7.23 0 0 1-1.54-2.67Z" fill="url(#ic_fluent_edit_20_color__b)"/><path d="M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-2.08 2.08-4.2-4.2 2.08-2.09Z" fill="url(#ic_fluent_edit_20_color__c)"/><path d="M10.26 5.53 11.9 3.9s.47 1.6 1.54 2.67A7.2 7.2 0 0 0 16.1 8.1L14.5 9.72s-1.62-.47-2.68-1.53a7.28 7.28 0 0 1-1.55-2.66Z" fill="url(#ic_fluent_edit_20_color__d)"/><defs><linearGradient id="ic_fluent_edit_20_color__a" x1="10.89" y1="7.02" x2="12.79" y2="12.24" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA43D"/><stop offset="1" stop-color="#FB5937"/></linearGradient><linearGradient id="ic_fluent_edit_20_color__b" x1="1.09" y1="13.44" x2="5.65" y2="17.97" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#FFD394"/><stop offset="1" stop-color="#FF921F"/></linearGradient><linearGradient id="ic_fluent_edit_20_color__c" x1="16.5" y1="3.49" x2="13.86" y2="5.97" gradientUnits="userSpaceOnUse"><stop stop-color="#F97DBD"/><stop offset="1" stop-color="#DD3CE2"/></linearGradient><linearGradient id="ic_fluent_edit_20_color__d" x1="13.28" y1="7.88" x2="9.16" y2="6.07" gradientUnits="userSpaceOnUse"><stop stop-color="#FF921F"/><stop offset="1" stop-color="#FFE994"/></linearGradient></defs>`, {
    color: true
});
const $61c84b424f99a7b1$export$a18b2635075e93d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Zm-1.38 1.38-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68l7.98-7.98-4.2-4.21Z"
]);
const $61c84b424f99a7b1$export$e57a7ca8375c5ccb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68l9.36-9.36a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 1 1 2.8 2.8l-.68.66-2.8-2.79.68-.67Zm-1.38 1.38 2.8 2.8-7.99 7.97c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l8-8Z"
]);
const $61c84b424f99a7b1$export$6a53b7a3e1b270ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditArrowBackFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Zm-1.38 1.38-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l.75-.74-4.2-4.21ZM13.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 16 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z"
]);
const $61c84b424f99a7b1$export$a0c3de9099ce897b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditArrowBackRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16c-.11-.39-.18-.8-.2-1.21l-.95.94c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l7.99-8 2.8 2.8L13.78 9c.41.02.82.09 1.21.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79.68-.67ZM13.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 16 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z"
]);
const $61c84b424f99a7b1$export$b3e109f56af24945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLineHorizontal3Filled', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-.67.67 4.2 4.2.68-.66a2.97 2.97 0 0 0 .05-4.15ZM3.55 12.25l8-8 4.2 4.2-7.98 7.99c-.34.34-.77.57-1.24.68l-3.92.87a.5.5 0 0 1-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2ZM2.5 3h8.88l-1 1H2.5a.5.5 0 0 1 0-1Zm0 3h5.88l-1 1H2.5a.5.5 0 0 1 0-1Zm0 3h2.88l-1 1H2.5a.5.5 0 0 1 0-1Z"
]);
const $61c84b424f99a7b1$export$bcfc204258d47752 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLineHorizontal3Regular', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-9.35 9.36c-.34.34-.77.57-1.23.68l-3.93.87a.5.5 0 0 1-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l9.37-9.37Zm3.54.75a1.97 1.97 0 0 0-2.83-.04l-.67.67 2.8 2.8.66-.68c.76-.75.77-1.98.04-2.75Zm-1.42 4.13-2.79-2.8-8 8c-.19.2-.32.44-.38.7l-.71 3.2 3.16-.71c.28-.06.54-.2.74-.4l7.98-7.99ZM2.5 3h8.88l-1 1H2.5a.5.5 0 0 1 0-1Zm0 3h5.88l-1 1H2.5a.5.5 0 0 1 0-1Zm0 3h2.88l-1 1H2.5a.5.5 0 0 1 0-1Z"
]);
const $61c84b424f99a7b1$export$6f22a3a056317eb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLockFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Zm-1.38 1.38-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L10 14.2V13a2 2 0 0 1 1.5-1.94V11a3 3 0 0 1 3.95-2.85l-3.9-3.9ZM12.5 11v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $61c84b424f99a7b1$export$57e5b44263d4b8fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditLockRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68L10 14.2V13l.01-.22-2.95 2.95c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l8-8 2.78 2.8-.26.25c.4.04.76.15 1.1.32l1.25-1.25a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 0 1 2.8 2.8l-.68.66-2.8-2.79.68-.67ZM12.5 11v1H12a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $61c84b424f99a7b1$export$1873fa39af5835de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l5.4 5.4-4 4c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 0 0 .7-.71l-15-15Zm12.9 6.3-2.59 2.6-4.2-4.21 2.58-2.6 4.21 4.22Zm-2.83-5.58a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Z"
]);
const $61c84b424f99a7b1$export$d594ddd1ee32b455 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l5.4 5.4-4 4c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68l3.98-3.98 5.4 5.4a.5.5 0 0 0 .7-.71l-15-15Zm8.2 9.6-3.99 3.98c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l3.99-4 2.8 2.79Zm4-4-2.6 2.59.71.7 3.97-3.96a2.97 2.97 0 0 0-4.21-4.2L8.96 6.83l.7.7 2.59-2.58 2.8 2.8Zm-1.42-4.17a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79.68-.67Z"
]);
const $61c84b424f99a7b1$export$959d9b72f4d06c7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditPersonFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Zm-1.38 1.38-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68l4.06-4.07a3 3 0 0 1 3.61-4.22l-3.9-3.9ZM16.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 16.75 11 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $61c84b424f99a7b1$export$dc8449dfaca6bdb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditPersonRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68l4.06-4.06c-.17-.34-.28-.7-.32-1.1l-4.45 4.45c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l8-8 2.78 2.8-.26.25c.4.04.76.15 1.1.32l1.25-1.25a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 0 1 2.8 2.8l-.68.66-2.8-2.79.68-.67ZM16.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 16.75 11 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $61c84b424f99a7b1$export$d81a612856492086 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditProhibitedFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Zm-1.38 1.38-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l.75-.74-4.2-4.21ZM9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"
]);
const $61c84b424f99a7b1$export$af21cddb104ee01a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditProhibitedRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16c-.11-.39-.18-.8-.2-1.21l-.95.94c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l7.99-8 2.8 2.8L13.78 9c.41.02.82.09 1.21.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79.68-.67ZM9 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"
]);
const $61c84b424f99a7b1$export$a287ccc2edd11292 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditSettingsFilled', "1em", [
    "M12.92 2.87a2.97 2.97 0 0 1 4.2 4.21l-.66.67-4.2-4.2.66-.68Zm-1.38 1.38-8 8c-.32.33-.55.74-.65 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16A5.5 5.5 0 0 1 15 9.2l.75-.74-4.2-4.21Zm-.47 7.2a2 2 0 0 1-1.43 2.47l-.46.12a4.7 4.7 0 0 0 0 1.02l.35.08A2 2 0 0 1 11 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 16 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55Zm2.43 4.05a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $61c84b424f99a7b1$export$6e46f2395bc6e163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EditSettingsRegular', "1em", [
    "M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.92-.87c.47-.1.9-.34 1.24-.68L8.2 16c-.11-.39-.18-.8-.2-1.21l-.95.94c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l7.99-8 2.8 2.8L13.78 9c.41.02.82.09 1.21.2l2.13-2.13a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 0 1 2.79 2.8l-.67.66-2.8-2.79.68-.67Zm-2.56 7.86a2 2 0 0 1-1.43 2.48l-.46.12a4.7 4.7 0 0 0 0 1.02l.35.08A2 2 0 0 1 11 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 16 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $61c84b424f99a7b1$export$fad8cf09a35ef3ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdRegular', "1em", [
    "M5.5 7c.28 0 .5.22.5.5V10h2.5V7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0V11H6v1.5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5ZM11 7a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1.42A2.58 2.58 0 0 0 15 10.42v-.84A2.58 2.58 0 0 0 12.42 7H11Zm1.42 5h-.92V8h.92c.87 0 1.58.7 1.58 1.58v.84c0 .87-.7 1.58-1.58 1.58ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z"
]);
const $61c84b424f99a7b1$export$e5f052432bf5baba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrFilled', "1em", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4H4.75ZM4.5 7.5c.28 0 .5.22.5.5v1.5h2V8a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-1.5H5V12a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5ZM9 8c0-.28.22-.5.5-.5h.25c1.24 0 2.25 1 2.25 2.25v.5c0 1.24-1 2.25-2.25 2.25H9.5A.5.5 0 0 1 9 12V8Zm1 3.47c.57-.11 1-.62 1-1.22v-.5c0-.6-.43-1.1-1-1.22v2.95ZM13 8c0-.28.22-.5.5-.5h1a1.5 1.5 0 0 1 .87 2.72l.6 1.6a.5.5 0 0 1-.94.36l-.63-1.68H14V12a.5.5 0 0 1-1 0V8Zm1 1.5h.5a.5.5 0 0 0 0-1H14v1Z"
]);
const $61c84b424f99a7b1$export$62f852357c8b1898 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrRegular', "1em", [
    "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4H4.75ZM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25v-6.5Zm1.5.75c.28 0 .5.22.5.5v1.5h2V8a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-1.5H5V12a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5ZM9 8c0-.28.22-.5.5-.5h.25c1.24 0 2.25 1 2.25 2.25v.5c0 1.24-1 2.25-2.25 2.25H9.5A.5.5 0 0 1 9 12V8Zm1 3.47c.57-.11 1-.62 1-1.22v-.5c0-.6-.43-1.1-1-1.22v2.95ZM13 8c0-.28.22-.5.5-.5h1a1.5 1.5 0 0 1 .87 2.72l.6 1.6a.5.5 0 0 1-.94.36l-.63-1.68H14V12a.5.5 0 0 1-1 0V8Zm1 1.5h.5a.5.5 0 0 0 0-1H14v1Z"
]);
const $61c84b424f99a7b1$export$8374f1ae2159ca64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrOffFilled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.41 1.42A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.54l1.86 1.85a.5.5 0 0 0 .7-.7l-15-15Zm8.38 9.8c-.4.34-.91.55-1.48.55H9.5A.5.5 0 0 1 9 12V9.7l1 1v.78c.2-.04.37-.13.52-.25l.71.71ZM8 8.7V12a.5.5 0 0 1-1 0v-1.5H5V12a.5.5 0 0 1-1 0V8a.5.5 0 0 1 1 0v1.5h2V8a.5.5 0 0 1 .06-.23L8 8.7Zm4 1.04v.13l1 1V8c0-.28.22-.5.5-.5h1a1.5 1.5 0 0 1 .87 2.72l.6 1.6a.5.5 0 0 1-.94.36l-.63-1.68H14v1.38l3.25 3.25c.47-.49.75-1.15.75-1.88v-6.5A2.75 2.75 0 0 0 15.25 4H6.12l3.5 3.5h.13c1.24 0 2.25 1 2.25 2.25Zm2-.25h.5a.5.5 0 0 0 0-1H14v1Z"
]);
const $61c84b424f99a7b1$export$ba160e19d247cd80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HdrOffRegular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l1.41 1.42A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.54l1.86 1.85a.5.5 0 0 0 .7-.7l-15-15ZM14.3 15H4.75C3.78 15 3 14.22 3 13.25v-6.5c0-.83.57-1.52 1.34-1.7l2.72 2.72A.5.5 0 0 0 7 8v1.5H5V8a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-1.5h2V12a.5.5 0 0 0 1 0V8.7l1 1V12c0 .28.22.5.5.5h.25c.57 0 1.09-.21 1.48-.56L14.3 15ZM10 10.7l.52.53c-.15.12-.32.2-.52.24v-.76Zm-.38-3.2L12 9.88v-.13c0-1.24-1-2.25-2.25-2.25h-.13ZM13 10.88l1 1V10.5h.4l.63 1.68a.5.5 0 0 0 .94-.36l-.6-1.6a1.5 1.5 0 0 0-.87-2.72h-1a.5.5 0 0 0-.5.5v2.88Zm4 2.37c0 .45-.17.86-.45 1.18l.7.7c.47-.49.75-1.15.75-1.88v-6.5A2.75 2.75 0 0 0 15.25 4H6.12l1 1h8.13c.97 0 1.75.78 1.75 1.75v6.5ZM14 9.5v-1h.5a.5.5 0 0 1 0 1H14Z"
]);
const $61c84b424f99a7b1$export$44061294fbe26040 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImportantFilled', "1em", [
    "M10 2a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69.24.79.97 1.31 1.78 1.31s1.54-.52 1.78-1.31C12.2 10.2 13 7.25 13 5a3 3 0 0 0-3-3Zm0 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
]);
const $61c84b424f99a7b1$export$810b2bfb11640d06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ImportantRegular', "1em", [
    "M10 3a2 2 0 0 0-2 2c0 2.07.75 4.91 1.18 6.4.1.36.44.6.82.6.39 0 .71-.24.82-.6C11.25 9.94 12 7.1 12 5a2 2 0 0 0-2-2ZM7 5a3 3 0 0 1 6 0c0 2.25-.79 5.21-1.22 6.69-.24.8-.97 1.31-1.78 1.31s-1.54-.52-1.78-1.31C7.8 10.2 7 7.23 7 5Zm3 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
]);
const $61c84b424f99a7b1$export$d066cb181a3a8680 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote1Filled', "1em", [
    "M10.15 2.02a.5.5 0 0 0-.65.48v9.9A3.24 3.24 0 0 0 4 14.75a3.25 3.25 0 1 0 6.5-.25V7.18l5.85 1.8A.5.5 0 0 0 17 8.5V5.98a2.5 2.5 0 0 0-1.76-2.4l-5.1-1.56Z"
]);
const $61c84b424f99a7b1$export$5dd1b4706dc9b693 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote1Regular', "1em", [
    "M10.15 2.02a.5.5 0 0 0-.65.48v9.9A3.24 3.24 0 0 0 4 14.75a3.25 3.25 0 1 0 6.5-.25V7.18l5.85 1.8A.5.5 0 0 0 17 8.5V5.98a2.5 2.5 0 0 0-1.76-2.4l-5.1-1.56ZM16 7.82l-5.5-1.69V3.18l4.44 1.36c.63.2 1.06.78 1.06 1.44v1.84ZM5 14.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z"
]);
const $61c84b424f99a7b1$export$8b4dc0ffbaf0d6e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2Filled', "1em", [
    "M15.99 3.02a1 1 0 0 0-1.29-.8l-7 2.2a1 1 0 0 0-.7.95v8.13a2.5 2.5 0 1 0 1 2V8.37l7-2.19v5.32a2.5 2.5 0 1 0 1 2V3.18l-.01-.16Z"
]);
const $61c84b424f99a7b1$export$e378832c42c93786 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2Regular', "1em", [
    "M14.7 2.23a1 1 0 0 1 1.3.95V13.5a2.5 2.5 0 1 1-1-2V6.18L8 8.37v7.13a2.5 2.5 0 1 1-1-2V5.37a1 1 0 0 1 .7-.96l7-2.18ZM8 7.32l7-2.19V3.18L8 5.37v1.95ZM5.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm6.5-.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"
]);
const $61c84b424f99a7b1$export$3feb6342b87cb135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2PlayFilled', "1em", [
    "M15.99 3.02a1 1 0 0 0-1.29-.8l-7 2.2a1 1 0 0 0-.7.95v8.13a2.5 2.5 0 1 0 1 2V8.37l7-2.19v2.84c.34.03.68.1 1 .19V3.18l-.01-.16ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.26-.44-3-1.65a.5.5 0 0 0-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 0 0 0-.88Z"
]);
const $61c84b424f99a7b1$export$1b5048f89851206f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNote2PlayRegular', "1em", [
    "M14.7 2.23a1 1 0 0 1 1.3.95v6.03c-.32-.1-.66-.16-1-.19V6.18L8 8.37v7.13a2.5 2.5 0 1 1-1-2V5.37a1 1 0 0 1 .7-.96l7-2.18ZM8 7.32l7-2.19V3.18L8 5.37v1.95ZM5.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm13.5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.26-.44-3-1.65a.5.5 0 0 0-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 0 0 0-.88Z"
]);
const $61c84b424f99a7b1$export$dda849a51acec17 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff1Filled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l7.35 7.36v2.2A3.24 3.24 0 0 0 4 14.74a3.25 3.25 0 1 0 6.5-.25v-3.3l6.65 6.65a.5.5 0 0 0 .7-.7l-15-15Zm7.65 5.03v1.2l-1-1V2.5a.5.5 0 0 1 .65-.48l5.09 1.57A2.5 2.5 0 0 1 17 5.98V8.5a.5.5 0 0 1-.65.48l-5.85-1.8Z"
]);
const $61c84b424f99a7b1$export$70a781a1c4c183a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff1Regular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l7.35 7.36v2.2A3.24 3.24 0 0 0 4 14.74a3.25 3.25 0 1 0 6.5-.25v-3.3l6.65 6.65a.5.5 0 0 0 .7-.7l-15-15ZM5 14.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm5.5-7.57v1.2l-1-1V2.5a.5.5 0 0 1 .65-.48l5.09 1.57A2.5 2.5 0 0 1 17 5.98V8.5a.5.5 0 0 1-.65.48l-5.85-1.8Zm5.5.64V5.98a1.5 1.5 0 0 0-1.06-1.44L10.5 3.18v2.95l5.5 1.7Z"
]);
const $61c84b424f99a7b1$export$64e0a039a3c9817d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff2Filled', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7 7.71v5.79a2.5 2.5 0 1 0 1 2V8.7l3.41 3.42a2.5 2.5 0 0 0 3.46 3.46l2.28 2.27a.5.5 0 0 0 .7-.7l-15-15ZM13.5 11c-.12 0-.24 0-.35.02l2.83 2.83.02-.35V3.18l-.01-.16a1 1 0 0 0-1.29-.8l-7 2.2a1 1 0 0 0-.61.54l2.8 2.82L15 6.18v5.32c-.42-.31-.94-.5-1.5-.5Z"
]);
const $61c84b424f99a7b1$export$627cad633e3fa534 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MusicNoteOff2Regular', "1em", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L7 7.71v5.79a2.5 2.5 0 1 0 1 2V8.7l3.41 3.42a2.5 2.5 0 0 0 3.46 3.46l2.28 2.27a.5.5 0 0 0 .7-.7l-15-15Zm11.3 12.7a1.5 1.5 0 0 1-2-2l2 2ZM5.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm8-3c-.12 0-.24 0-.35.02l2.83 2.83.02-.35V3.18a1 1 0 0 0-1.3-.95l-7 2.18a1 1 0 0 0-.61.55l.91.92v-.51l7-2.19v1.95L9.1 6.98l.8.8 5.1-1.6v5.32c-.42-.31-.94-.5-1.5-.5Z"
]);
const $61c84b424f99a7b1$export$cf4018408ad66c4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureFilled', "1em", [
    "M4.75 3A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15H9v-2.5a2.5 2.5 0 0 1 2.5-2.5h6c.17 0 .34.02.5.05v-4.3A2.75 2.75 0 0 0 15.25 3H4.75ZM18 11.09a1.5 1.5 0 0 0-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41Z"
]);
const $61c84b424f99a7b1$export$8b4cce9af7c6e608 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureRegular', "1em", [
    "M2 5.75A2.75 2.75 0 0 1 4.75 3h10.5A2.75 2.75 0 0 1 18 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 0 1 2 12.25v-6.5ZM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-6Z"
]);
const $61c84b424f99a7b1$export$8cd5fae880589d2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureEnterFilled', "1em", [
    "M4.75 3A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15H9v-2.5a2.5 2.5 0 0 1 2.5-2.5h6c.17 0 .34.02.5.05v-4.3A2.75 2.75 0 0 0 15.25 3H4.75Zm.6 2.65L8 8.29V6.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.8L4.64 6.35a.5.5 0 1 1 .7-.7ZM18 11.09a1.5 1.5 0 0 0-.5-.09h-6c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.65-.42-1.2-1-1.41Z"
]);
const $61c84b424f99a7b1$export$6dbf210ed444df50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureEnterRegular', "1em", [
    "M2 5.75A2.75 2.75 0 0 1 4.75 3h10.5A2.75 2.75 0 0 1 18 5.75V10h-1V5.75C17 4.78 16.22 4 15.25 4H4.75C3.78 4 3 4.78 3 5.75v6.5c0 .97.78 1.75 1.75 1.75H9v1H4.75A2.75 2.75 0 0 1 2 12.25v-6.5ZM11.5 11c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-6ZM4.65 5.65c.2-.2.5-.2.7 0L8 8.29V6.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.8L4.64 6.35a.5.5 0 0 1 0-.7Z"
]);
const $61c84b424f99a7b1$export$a3e7551381343f18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureExitFilled', "1em", [
    "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4A1.5 1.5 0 0 0 2.5 9h6Zm0 1h-6c-.17 0-.34-.02-.5-.05v4.3A2.75 2.75 0 0 0 4.75 17h10.5A2.75 2.75 0 0 0 18 14.25v-6.5A2.75 2.75 0 0 0 15.25 5H11v2.5A2.5 2.5 0 0 1 8.5 10Zm3.85.65L15 13.29V11.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.8l-2.65-2.65a.5.5 0 0 1 .7-.7Z"
]);
const $61c84b424f99a7b1$export$13be2317a578fd97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PictureInPictureExitRegular', "1em", [
    "M8.5 9c.83 0 1.5-.67 1.5-1.5v-4C10 2.67 9.33 2 8.5 2h-6C1.67 2 1 2.67 1 3.5v4c0 .65.42 1.2 1 1.41l.02.01c.15.05.31.08.48.08h6Zm6.75-3H11V5h4.25A2.75 2.75 0 0 1 18 7.75v6.5A2.75 2.75 0 0 1 15.25 17H4.75A2.75 2.75 0 0 1 2 14.25v-4.3c.16.03.33.05.5.05H3v4.25c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 6.78 16.22 6 15.25 6ZM14 12.3l-2.65-2.65a.5.5 0 0 0-.7.7L13.29 13H11.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.8Z"
]);
const $61c84b424f99a7b1$export$8e014e26ebf22935 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbDislikeFilled', "1em", [
    "M12.48 18.3c-.8.83-2.09.38-2.43-.6-.28-.8-.64-1.77-1-2.48C8 13.1 7.38 11.9 5.67 10.37c-.23-.2-.52-.36-.84-.49-1.13-.44-2.2-1.61-1.91-3l.35-1.77a2.5 2.5 0 0 1 1.8-1.92l5.6-1.53a4.5 4.5 0 0 1 5.6 3.54l.69 3.76A3 3 0 0 1 14 12.5h-.89l.01.05c.08.41.18.97.24 1.58.07.62.1 1.29.05 1.92a3.68 3.68 0 0 1-.5 1.73c-.11.16-.27.35-.44.52Z"
]);
const $61c84b424f99a7b1$export$f18afe37ff73a6c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbDislikeRegular', "1em", [
    "M10.05 17.7c.34.98 1.63 1.43 2.43.6.17-.17.33-.36.44-.52.32-.48.45-1.12.5-1.73.05-.63.02-1.3-.05-1.92-.06-.6-.16-1.17-.24-1.58v-.05H14a3 3 0 0 0 2.95-3.54l-.69-3.76a4.5 4.5 0 0 0-5.6-3.54L5.06 3.2c-.92.25-1.62 1-1.8 1.92l-.35 1.77c-.28 1.39.78 2.56 1.9 3 .33.13.62.3.85.5 1.7 1.5 2.32 2.72 3.38 4.84.36.71.72 1.68 1 2.49Zm1.97-5.58v.04a14.2 14.2 0 0 1 .36 2.08c.06.58.09 1.18.04 1.73-.04.55-.15.98-.33 1.25-.06.1-.18.22-.33.39-.2.2-.63.16-.76-.23-.29-.82-.67-1.83-1.05-2.6-1.07-2.14-1.76-3.5-3.62-5.15-.34-.3-.74-.52-1.13-.68-.88-.34-1.45-1.14-1.3-1.87l.35-1.77c.11-.56.53-1 1.08-1.15l5.6-1.53a3.5 3.5 0 0 1 4.36 2.75l.68 3.76a2 2 0 0 1-1.96 2.36h-1.5a.5.5 0 0 0-.5.62Z"
]);
const $61c84b424f99a7b1$export$6894c403b1075697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeFilled', "1em", [
    "M12.48 1.7c-.8-.83-2.09-.38-2.43.6-.28.8-.64 1.77-1 2.48C8 6.9 7.38 8.1 5.67 9.63c-.23.2-.52.36-.84.49-1.13.44-2.2 1.61-1.91 3l.35 1.77a2.5 2.5 0 0 0 1.8 1.92l5.6 1.52a4.5 4.5 0 0 0 5.6-3.53l.69-3.76A3 3 0 0 0 14 7.5h-.89l.01-.05c.08-.41.18-.97.24-1.59.07-.6.1-1.28.05-1.9a3.68 3.68 0 0 0-.5-1.74 4.16 4.16 0 0 0-.44-.52Z"
]);
const $61c84b424f99a7b1$export$c59ff23c086df313 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeRegular', "1em", [
    "M10.05 2.3c.34-.98 1.63-1.43 2.43-.6.17.17.33.36.44.52.32.48.45 1.12.5 1.73.05.63.02 1.3-.05 1.91-.06.62-.16 1.18-.24 1.59v.05H14a3 3 0 0 1 2.95 3.54l-.69 3.76a4.5 4.5 0 0 1-5.6 3.53l-5.6-1.52a2.5 2.5 0 0 1-1.8-1.92l-.35-1.77c-.28-1.39.78-2.56 1.9-3 .33-.13.62-.3.85-.5 1.7-1.5 2.32-2.72 3.38-4.84.36-.71.72-1.68 1-2.49Zm1.97 5.58v-.04a13.7 13.7 0 0 0 .13-.58c.08-.4.17-.93.23-1.5.06-.58.09-1.18.04-1.73a2.73 2.73 0 0 0-.33-1.25 3.26 3.26 0 0 0-.33-.39c-.2-.2-.63-.16-.76.23-.29.82-.67 1.83-1.05 2.6-1.07 2.14-1.76 3.5-3.62 5.15-.34.3-.74.52-1.13.68-.88.34-1.45 1.14-1.3 1.87l.35 1.77c.11.56.53 1 1.08 1.15l5.6 1.53c1.98.54 4-.73 4.36-2.75l.68-3.76a2 2 0 0 0-1.96-2.36h-1.5a.5.5 0 0 1-.5-.62Z"
]);
const $61c84b424f99a7b1$export$18ec8d6f1838f328 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeDislikeFilled', "1em", [
    "M8 6h-.73c.13-.3.26-.7.34-1.11.1-.5.14-1.06-.02-1.58-.17-.55-.56-1-1.23-1.23-.86-.3-1.6.31-1.92.92L3.14 5.5a2.5 2.5 0 0 1-.97 1.02L1 7.17a2 2 0 0 0-.88 2.44l.3.83a2 2 0 0 0 1.32 1.22l4.24 1.24a2.5 2.5 0 0 0 3.1-1.66L9.9 8.6A2 2 0 0 0 8 6Zm4.73 8H12a2 2 0 0 1-1.91-2.59l.82-2.65A2.5 2.5 0 0 1 14 7.1l4.24 1.24a2 2 0 0 1 1.31 1.22l.31.84a2 2 0 0 1-.88 2.43l-1.16.67c-.41.24-.75.59-.97 1.02L15.56 17c-.31.61-1.06 1.22-1.92.93a1.84 1.84 0 0 1-1.23-1.24 3.24 3.24 0 0 1-.02-1.57c.08-.41.21-.8.34-1.12Z"
]);
const $61c84b424f99a7b1$export$92f0baeab2c3fcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ThumbLikeDislikeRegular', "1em", [
    "M5.32 3.46c.2-.38.52-.5.72-.43.36.12.52.32.6.58.09.29.08.66 0 1.08a6.04 6.04 0 0 1-.57 1.55v.02h-.01A.5.5 0 0 0 6.5 7H8a1 1 0 0 1 .95 1.3l-.82 2.65a1.5 1.5 0 0 1-1.86 1L2.03 10.7a1 1 0 0 1-.66-.6l-.3-.84a1 1 0 0 1 .43-1.22l1.16-.67a3.5 3.5 0 0 0 1.37-1.42l1.3-2.49ZM8 6h-.72c.13-.3.26-.7.34-1.11.1-.5.14-1.06-.02-1.58-.17-.55-.56-1-1.23-1.23-.86-.3-1.6.31-1.92.92L3.14 5.5a2.5 2.5 0 0 1-.97 1.02L1 7.17a2 2 0 0 0-.88 2.44l.3.83a2 2 0 0 0 1.32 1.22l4.24 1.24a2.5 2.5 0 0 0 3.1-1.66L9.9 8.6A2 2 0 0 0 8 6Zm6.69 10.54c-.2.39-.52.5-.72.44-.36-.12-.52-.33-.6-.58a2.27 2.27 0 0 1 0-1.08 6.03 6.03 0 0 1 .57-1.55v-.02l.01-.01a.5.5 0 0 0-.44-.74H12a1 1 0 0 1-.95-1.3l.82-2.64a1.5 1.5 0 0 1 1.86-1l4.24 1.24a1 1 0 0 1 .66.61l.3.84a1 1 0 0 1-.43 1.22l-1.16.66a3.5 3.5 0 0 0-1.37 1.42l-1.3 2.5ZM12 14h.72c-.13.31-.26.7-.34 1.12-.1.49-.14 1.05.02 1.57.17.55.56 1.01 1.23 1.24.86.29 1.6-.32 1.92-.93l1.3-2.48c.22-.43.56-.78.97-1.02l1.16-.67a2 2 0 0 0 .88-2.43l-.3-.84a2 2 0 0 0-1.32-1.22L14.01 7.1a2.5 2.5 0 0 0-3.1 1.66l-.81 2.65a2 2 0 0 0 1.9 2.6Z"
]);
const $61c84b424f99a7b1$export$bec833e8785bf899 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleLeftFilled', "1em", [
    "M14 6a4 4 0 0 1 0 8H6a4 4 0 0 1 0-8h8Zm-8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $61c84b424f99a7b1$export$8c2a45bcb99eaa4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleLeftRegular', "1em", [
    "M6 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12-2a4 4 0 0 0-4-4H6a4 4 0 1 0 0 8h8a4 4 0 0 0 4-4Zm-4-3a3 3 0 1 1 0 6H6a3 3 0 1 1 0-6h8Z"
]);
const $61c84b424f99a7b1$export$c79d60a89fcc04e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleMultipleFilled', "1em", [
    "M3 5.5A3.5 3.5 0 0 1 6.5 2h7a3.5 3.5 0 1 1 0 7h-7A3.5 3.5 0 0 1 3 5.5Zm5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM6.5 11a3.5 3.5 0 1 0 0 7h7a3.5 3.5 0 1 0 0-7h-7Zm7 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
]);
const $61c84b424f99a7b1$export$4545fffaa3265c65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleMultipleRegular', "1em", [
    "M8 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-5 0A3.5 3.5 0 0 0 6.5 9h7a3.5 3.5 0 1 0 0-7h-7A3.5 3.5 0 0 0 3 5.5ZM6.5 3h7a2.5 2.5 0 0 1 0 5h-7a2.5 2.5 0 0 1 0-5Zm7 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM3 14.5A3.5 3.5 0 0 0 6.5 18h7a3.5 3.5 0 1 0 0-7h-7A3.5 3.5 0 0 0 3 14.5ZM6.5 12h7a2.5 2.5 0 0 1 0 5h-7a2.5 2.5 0 0 1 0-5Z"
]);
const $61c84b424f99a7b1$export$cb0d44125da6a0f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleRightFilled', "1em", [
    "M6 6a4 4 0 1 0 0 8h8a4 4 0 0 0 0-8H6Zm8 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
]);
const $61c84b424f99a7b1$export$28fba8cf3cfa6e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ToggleRightRegular', "1em", [
    "M14 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM2 10a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H6a4 4 0 0 1-4-4Zm4-3a3 3 0 0 0 0 6h8a3 3 0 1 0 0-6H6Z"
]);
const $61c84b424f99a7b1$export$6295cd581b71ddb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeDeciduousFilled', "1em", [
    "M10 2a3.5 3.5 0 0 0-3.39 2.61A3.5 3.5 0 0 0 4.05 8.6 3.5 3.5 0 0 0 6 15h2v1.75c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h2a3.5 3.5 0 0 0 1.95-6.4 3.52 3.52 0 0 0-2.56-3.99A3.5 3.5 0 0 0 10 2ZM9 15h2v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15Z"
]);
const $61c84b424f99a7b1$export$f4d5690d1c77096c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeDeciduousRegular', "1em", [
    "M10 2a3.5 3.5 0 0 0-3.39 2.61A3.5 3.5 0 0 0 4.05 8.6 3.5 3.5 0 0 0 6 15h2v1.75c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h2a3.5 3.5 0 0 0 1.95-6.4 3.52 3.52 0 0 0-2.56-3.99A3.5 3.5 0 0 0 10 2Zm1 13v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15h2ZM7.53 5.11a2.5 2.5 0 0 1 4.94 0c.03.22.2.39.42.42A2.5 2.5 0 0 1 14.9 8.7a.5.5 0 0 0 .25.58A2.5 2.5 0 0 1 14 14H6a2.5 2.5 0 0 1-1.15-4.72.5.5 0 0 0 .25-.58A2.5 2.5 0 0 1 7.1 5.53a.5.5 0 0 0 .42-.42Z"
]);
const $61c84b424f99a7b1$export$57cca59e0c188479 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeEvergreenFilled', "1em", [
    "M10.62 2.21a1 1 0 0 0-1.24 0l-3.3 2.61A1.5 1.5 0 0 0 6 7.14l-1.46 1.2a1.5 1.5 0 0 0 .51 2.6l-1.59 1.48A1.49 1.49 0 0 0 4.5 15H8v1.75c0 .69.57 1.25 1.26 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h3.5c1.35 0 2-1.66 1.02-2.58l-1.59-1.48a1.5 1.5 0 0 0 .52-2.6l-1.47-1.2a1.5 1.5 0 0 0-.05-2.32l-3.31-2.6ZM9 15h2v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15Z"
]);
const $61c84b424f99a7b1$export$bc70de4cceef56f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TreeEvergreenRegular', "1em", [
    "M10.62 2.21a1 1 0 0 0-1.24 0l-3.3 2.61A1.5 1.5 0 0 0 6 7.14l-1.46 1.2a1.5 1.5 0 0 0 .51 2.6l-1.59 1.48A1.49 1.49 0 0 0 4.5 15H8v1.75c0 .69.57 1.25 1.26 1.25h1.5c.69 0 1.25-.56 1.25-1.25V15h3.5c1.35 0 2-1.66 1.02-2.58l-1.59-1.48a1.5 1.5 0 0 0 .52-2.6l-1.47-1.2a1.5 1.5 0 0 0-.05-2.32l-3.31-2.6ZM11 15v1.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V15h2ZM10 3l3.3 2.6a.5.5 0 0 1-.28.9.5.5 0 0 0-.3.88l2.09 1.73a.5.5 0 0 1-.32.89h-.76a.5.5 0 0 0-.34.86l2.45 2.3c.32.3.1.84-.34.84h-11a.49.49 0 0 1-.34-.85l2.44-2.29a.5.5 0 0 0-.34-.86H5.5a.5.5 0 0 1-.31-.89l2.1-1.73a.5.5 0 0 0-.3-.88.5.5 0 0 1-.3-.9L10 3Z"
]);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $43f01c3e5f4f08d3$export$ed40f17238e0af3f(context) {
    const contextValue = $acw62.useContext(context);
    if (contextValue.version) return contextValue.version.current !== -1;
    return false;
}






var $acw62 = parcelRequire("acw62");


'use client';
function $47d27724afc6da6d$export$d0f293dfa88e13b7(open, modalType) {
    const { findFirstFocusable: findFirstFocusable } = (0, $708e79e1f2ab4237$export$2b0519dd5d2bc6d4)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const dialogRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!open) return;
        const element = dialogRef.current && findFirstFocusable(dialogRef.current);
        if (element) element.focus();
        else {
            var _dialogRef_current;
            (_dialogRef_current = dialogRef.current) === null || _dialogRef_current === void 0 || _dialogRef_current.focus(); // https://github.com/microsoft/fluentui/issues/25150
        }
    }, [
        findFirstFocusable,
        open,
        modalType,
        targetDocument
    ]);
    return dialogRef;
}


parcelRequire("acw62");

'use client';
const $1df5e8bcad6e85cf$var$defaultContextValue = {
    open: false,
    inertTrapFocus: false,
    modalType: 'modal',
    isNestedDialog: false,
    unmountOnClose: true,
    dialogRef: {
        current: null
    },
    requestOpenChange () {
    /* noop */ }
};
const $1df5e8bcad6e85cf$export$8b93a07348a7730c = (0, $b76441dd4bb0583c$export$fd42f52fd3ae1109)(undefined);
const $1df5e8bcad6e85cf$export$7ab5cfe96fae86d3 = $1df5e8bcad6e85cf$export$8b93a07348a7730c.Provider;
const $1df5e8bcad6e85cf$export$907394755222dc8e = (selector)=>(0, $6c13c651ac1cfc27$export$30b2013e16e635d0)($1df5e8bcad6e85cf$export$8b93a07348a7730c, (ctx = $1df5e8bcad6e85cf$var$defaultContextValue)=>selector(ctx));



function $e67c3d746f23a482$export$c5514cb9a2262e43(presenceFn, variantParams) {
    const variantFn = (runtimeParams)=>presenceFn({
            ...variantParams,
            ...runtimeParams
        });
    return variantFn;
}
function $e67c3d746f23a482$export$2911c0c000be902b(component, variantParams) {
    const originalFn = component[0, $a90210c34a8674c7$export$a121f71575b68679];
    // The variant params become new defaults, but they can still be overridden by runtime params.
    const variantFn = $e67c3d746f23a482$export$c5514cb9a2262e43(originalFn, variantParams);
    return (0, $a90210c34a8674c7$export$e943b41c81f8ae82)(variantFn);
}





const $9d936c159f9ee23b$export$9ef44f32700e8ee4 = ({ direction: direction, duration: duration, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveLinear, delay: delay = 0, outScale: outScale = 0.9, inScale: inScale = 1 })=>{
    const keyframes = [
        {
            scale: outScale
        },
        {
            scale: inScale
        }
    ];
    if (direction === 'exit') keyframes.reverse();
    return {
        keyframes: keyframes,
        duration: duration,
        easing: easing,
        delay: delay
    };
};


/**
 * Define a presence motion for scale in/out
 *
 * @param duration - Time (ms) for the enter transition (scale-in). Defaults to the `durationGentle` value (250 ms).
 * @param easing - Easing curve for the enter transition (scale-in). Defaults to the `curveDecelerateMax` value.
 * @param delay - Time (ms) to delay the enter transition. Defaults to 0.
 * @param exitDuration - Time (ms) for the exit transition (scale-out). Defaults to the `durationNormal` value (200 ms).
 * @param exitEasing - Easing curve for the exit transition (scale-out). Defaults to the `curveAccelerateMax` value.
 * @param exitDelay - Time (ms) to delay the exit transition. Defaults to the `delay` param for symmetry.
 * @param outScale - Scale for the out state (exited). Defaults to `0.9`.
 * @param inScale - Scale for the in state (entered). Defaults to `1`.
 * @param animateOpacity - Whether to animate the opacity. Defaults to `true`.
 */ const $f0c450e3c364eadd$var$scalePresenceFn = ({ duration: duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMax, delay: delay = 0, exitDuration: exitDuration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal, exitEasing: exitEasing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveAccelerateMax, exitDelay: exitDelay = delay, outScale: outScale = 0.9, inScale: inScale = 1, animateOpacity: animateOpacity = true })=>{
    const enterAtoms = [
        (0, $9d936c159f9ee23b$export$9ef44f32700e8ee4)({
            direction: 'enter',
            duration: duration,
            easing: easing,
            delay: delay,
            outScale: outScale,
            inScale: inScale
        })
    ];
    const exitAtoms = [
        (0, $9d936c159f9ee23b$export$9ef44f32700e8ee4)({
            direction: 'exit',
            duration: exitDuration,
            easing: exitEasing,
            delay: exitDelay,
            outScale: outScale,
            inScale: inScale
        })
    ];
    // Only add fade atoms if animateOpacity is true.
    if (animateOpacity) {
        enterAtoms.push((0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'enter',
            duration: duration,
            easing: easing,
            delay: delay
        }));
        exitAtoms.push((0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'exit',
            duration: exitDuration,
            easing: exitEasing,
            delay: exitDelay
        }));
    }
    return {
        enter: enterAtoms,
        exit: exitAtoms
    };
};
const $f0c450e3c364eadd$export$d60cfc58d3c358b6 = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)($f0c450e3c364eadd$var$scalePresenceFn);
const $f0c450e3c364eadd$export$4f87c7c81689dfda = (0, $e67c3d746f23a482$export$2911c0c000be902b)($f0c450e3c364eadd$export$d60cfc58d3c358b6, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal,
    exitDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationFast
});
const $f0c450e3c364eadd$export$f36d19a56ef9455c = (0, $e67c3d746f23a482$export$2911c0c000be902b)($f0c450e3c364eadd$export$d60cfc58d3c358b6, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationSlow,
    exitDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle
});


const $7eee099111577ca5$export$e4cdcfcd8eb9ef32 = (0, $e67c3d746f23a482$export$2911c0c000be902b)((0, $f0c450e3c364eadd$export$d60cfc58d3c358b6), {
    outScale: 0.85,
    easing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveDecelerateMid,
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle,
    exitEasing: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveAccelerateMin,
    exitDuration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle
});


'use client';
const $8ab8c0cd141e2cd6$export$f2800d8e1c3f3762 = (props)=>{
    const { children: children, modalType: modalType = 'modal', onOpenChange: onOpenChange, inertTrapFocus: inertTrapFocus = false, unmountOnClose: unmountOnClose = true } = props;
    const dialogTitleId = (0, $0200d30cfa270435$export$f680877a34711e37)('dialog-title-');
    const [trigger, content] = $8ab8c0cd141e2cd6$var$childrenToTriggerAndContent(children);
    const [open, setOpen] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: props.open,
        defaultState: props.defaultOpen,
        initialState: false
    });
    const requestOpenChange = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((data)=>{
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(data.event, data);
        // if user prevents default then do not change state value
        // otherwise updates state value and trigger reference to the element that caused the opening
        if (!data.event.isDefaultPrevented()) setOpen(data.open);
    });
    const dialogRef = (0, $47d27724afc6da6d$export$d0f293dfa88e13b7)(open, modalType);
    const { modalAttributes: modalAttributes, triggerAttributes: triggerAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)({
        trapFocus: modalType !== 'non-modal',
        legacyTrapFocus: !inertTrapFocus
    });
    const isNestedDialog = (0, $43f01c3e5f4f08d3$export$ed40f17238e0af3f)((0, $1df5e8bcad6e85cf$export$8b93a07348a7730c));
    return {
        components: {
            surfaceMotion: (0, $7eee099111577ca5$export$e4cdcfcd8eb9ef32)
        },
        inertTrapFocus: inertTrapFocus,
        open: open,
        modalType: modalType,
        content: content,
        trigger: trigger,
        requestOpenChange: requestOpenChange,
        dialogTitleId: dialogTitleId,
        isNestedDialog: isNestedDialog,
        unmountOnClose: unmountOnClose,
        dialogRef: dialogRef,
        modalAttributes: modalAttributes,
        triggerAttributes: triggerAttributes,
        surfaceMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(props.surfaceMotion, {
            elementType: (0, $7eee099111577ca5$export$e4cdcfcd8eb9ef32),
            defaultProps: {
                visible: open,
                appear: unmountOnClose,
                unmountOnExit: unmountOnClose
            }
        })
    };
};
/**
 * Extracts trigger and content from children
 */ function $8ab8c0cd141e2cd6$var$childrenToTriggerAndContent(children) {
    const childrenArray = $acw62.Children.toArray(children);
    switch(childrenArray.length){
        // case where there's a trigger followed by content
        case 2:
            return childrenArray;
        // case where there's only content
        case 1:
            return [
                undefined,
                childrenArray[0]
            ];
        // unknown case
        default:
            return [
                undefined,
                undefined
            ];
    }
}




parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $dfbb1f6223498329$var$defaultContextValue = false;
const $dfbb1f6223498329$export$ea577bedbf99c71d = $acw62.createContext(undefined);
const $dfbb1f6223498329$export$63e7a5d6b0cd8dfc = $dfbb1f6223498329$export$ea577bedbf99c71d.Provider;
const $dfbb1f6223498329$export$6e6c677beea48331 = ()=>{
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($dfbb1f6223498329$export$ea577bedbf99c71d)) !== null && _React_useContext !== void 0 ? _React_useContext : $dfbb1f6223498329$var$defaultContextValue;
};


const $f8b896f57d82c2d1$export$94fd76a80f9e6817 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $1df5e8bcad6e85cf$export$7ab5cfe96fae86d3), {
        value: contextValues.dialog,
        children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $dfbb1f6223498329$export$63e7a5d6b0cd8dfc), {
            value: contextValues.dialogSurface,
            children: [
                state.trigger,
                state.content && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.surfaceMotion, {
                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $59b10a9d6ce22ca1$export$a606ed35b13f65f2), {
                        children: state.content
                    })
                })
            ]
        })
    });
};


function $a61348354a9ebe01$export$a71b5c378a8f663e(state) {
    const { modalType: modalType, open: open, dialogRef: dialogRef, dialogTitleId: dialogTitleId, isNestedDialog: isNestedDialog, inertTrapFocus: inertTrapFocus, requestOpenChange: requestOpenChange, modalAttributes: modalAttributes, triggerAttributes: triggerAttributes, unmountOnClose: unmountOnClose } = state;
    /**
   * This context is created with "@fluentui/react-context-selector",
   * there is no sense to memoize it
   */ const dialog = {
        open: open,
        modalType: modalType,
        dialogRef: dialogRef,
        dialogTitleId: dialogTitleId,
        isNestedDialog: isNestedDialog,
        inertTrapFocus: inertTrapFocus,
        modalAttributes: modalAttributes,
        triggerAttributes: triggerAttributes,
        unmountOnClose: unmountOnClose,
        requestOpenChange: requestOpenChange
    };
    const dialogSurface = false;
    return {
        dialog: dialog,
        dialogSurface: dialogSurface
    };
}


'use client';
const $432da315193df471$export$3ddf2d174ce01153 = /*#__PURE__*/ $acw62.memo((props)=>{
    const state = (0, $8ab8c0cd141e2cd6$export$f2800d8e1c3f3762)(props);
    const contextValues = (0, $a61348354a9ebe01$export$a71b5c378a8f663e)(state);
    return (0, $f8b896f57d82c2d1$export$94fd76a80f9e6817)(state, contextValues);
});
$432da315193df471$export$3ddf2d174ce01153.displayName = 'Dialog';


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $d0895351777ecebe$export$1b77b191c557a246(shorthand) {
    return shorthand !== null && typeof shorthand === 'object' && !Array.isArray(shorthand) && !$acw62.isValidElement(shorthand);
}


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $8437f6f9e3d4e19d$export$f6c0b973170d8075 = $acw62.createContext(undefined);
const $8437f6f9e3d4e19d$export$4a03e186098d7552 = $8437f6f9e3d4e19d$export$f6c0b973170d8075.Provider;
const $8437f6f9e3d4e19d$export$eb243cc61b0c603d = ()=>{
    return $acw62.useContext($8437f6f9e3d4e19d$export$f6c0b973170d8075);
};



var $acw62 = parcelRequire("acw62");


'use client';
const $411b3368175ad511$export$b2684b2f85ffad11 = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r6pzz3z", null, [
    ".r6pzz3z{overflow-y:hidden;overflow-y:clip;scrollbar-gutter:stable;}"
]);
const $411b3368175ad511$export$89a84ea48b2421a6 = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r144vlu9", null, [
    ".r144vlu9{overflow-y:hidden;}"
]);


'use client';
function $55b8006a7a00ad22$export$e1d95e7d6867c884() {
    const htmlNoScrollStyles = (0, $411b3368175ad511$export$b2684b2f85ffad11)();
    const bodyNoScrollStyles = (0, $411b3368175ad511$export$89a84ea48b2421a6)();
    const { targetDocument: targetDocument } = (0, $8221ac192738ccc4$export$6ab36604f9d4fd68)();
    const disableBodyScroll = $acw62.useCallback(()=>{
        var _targetDocument_defaultView;
        if (!targetDocument) return;
        var _targetDocument_defaultView_innerHeight;
        const isHorizontalScrollbarVisible = // To properly compare the body clientHeight to the window innerHeight, manually round down the fractional value to match innerHeight's calculation.
        Math.floor(targetDocument.body.getBoundingClientRect().height) > ((_targetDocument_defaultView_innerHeight = (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.innerHeight) !== null && _targetDocument_defaultView_innerHeight !== void 0 ? _targetDocument_defaultView_innerHeight : 0);
        if (!isHorizontalScrollbarVisible) return;
        targetDocument.documentElement.classList.add(htmlNoScrollStyles);
        targetDocument.body.classList.add(bodyNoScrollStyles);
        return;
    }, [
        targetDocument,
        htmlNoScrollStyles,
        bodyNoScrollStyles
    ]);
    const enableBodyScroll = $acw62.useCallback(()=>{
        if (!targetDocument) return;
        targetDocument.documentElement.classList.remove(htmlNoScrollStyles);
        targetDocument.body.classList.remove(bodyNoScrollStyles);
    }, [
        targetDocument,
        htmlNoScrollStyles,
        bodyNoScrollStyles
    ]);
    return {
        disableBodyScroll: disableBodyScroll,
        enableBodyScroll: enableBodyScroll
    };
}




const $e354535bc8023a8f$export$982d379e3680c623 = ({ duration: duration = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationNormal, easing: easing = (0, $a9dd808ce2ff0a37$export$24b36403afffca36).curveEasyEase, delay: delay = 0, exitDuration: exitDuration = duration, exitEasing: exitEasing = easing, exitDelay: exitDelay = delay, outOpacity: outOpacity = 0, inOpacity: inOpacity = 1 })=>{
    return {
        enter: (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'enter',
            duration: duration,
            easing: easing,
            delay: delay,
            outOpacity: outOpacity,
            inOpacity: inOpacity
        }),
        exit: (0, $0dbab70b2cf389f1$export$22f96d8a4ace81f0)({
            direction: 'exit',
            duration: exitDuration,
            easing: exitEasing,
            delay: exitDelay,
            outOpacity: outOpacity,
            inOpacity: inOpacity
        })
    };
};
const $e354535bc8023a8f$export$c983850c6c9d8b0e = (0, $a90210c34a8674c7$export$e943b41c81f8ae82)($e354535bc8023a8f$export$982d379e3680c623);
const $e354535bc8023a8f$export$aa352a7bdc8c037b = (0, $e67c3d746f23a482$export$2911c0c000be902b)($e354535bc8023a8f$export$c983850c6c9d8b0e, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationFast
});
const $e354535bc8023a8f$export$af499063868f6bf7 = (0, $e67c3d746f23a482$export$2911c0c000be902b)($e354535bc8023a8f$export$c983850c6c9d8b0e, {
    duration: (0, $a9dd808ce2ff0a37$export$24b36403afffca36).durationGentle
});


const $abbadddd1f7e274f$export$8ddeecc2d91e9cdd = (0, $e354535bc8023a8f$export$af499063868f6bf7);


'use client';
const $254eec9f6c345877$export$c76c7ec047fdba7d = (props, ref)=>{
    const contextRef = (0, $59b10a9d6ce22ca1$export$303310ce19d9244b)();
    const modalType = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.modalType);
    const isNestedDialog = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.isNestedDialog);
    const backdropOverride = (0, $8437f6f9e3d4e19d$export$eb243cc61b0c603d)();
    const treatBackdropAsNested = backdropOverride !== null && backdropOverride !== void 0 ? backdropOverride : isNestedDialog;
    const modalAttributes = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.modalAttributes);
    const dialogRef = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogRef);
    const requestOpenChange = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.requestOpenChange);
    const dialogTitleID = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogTitleId);
    const open = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.open);
    const unmountOnClose = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.unmountOnClose);
    const handledBackdropClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        if ((0, $d0895351777ecebe$export$1b77b191c557a246)(props.backdrop)) {
            var _props_backdrop_onClick, _props_backdrop;
            (_props_backdrop_onClick = (_props_backdrop = props.backdrop).onClick) === null || _props_backdrop_onClick === void 0 || _props_backdrop_onClick.call(_props_backdrop, event);
        }
        if (modalType === 'modal' && !event.isDefaultPrevented()) requestOpenChange({
            event: event,
            open: false,
            type: 'backdropClick'
        });
    });
    const handleKeyDown = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        var _props_onKeyDown;
        (_props_onKeyDown = props.onKeyDown) === null || _props_onKeyDown === void 0 || _props_onKeyDown.call(props, event);
        if (event.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685) && !event.isDefaultPrevented()) {
            requestOpenChange({
                event: event,
                open: false,
                type: 'escapeKeyDown'
            });
            // stop propagation to avoid conflicting with other elements that listen for `Escape`
            // e,g: nested Dialog, Popover, Menu and Tooltip
            event.preventDefault();
        }
    });
    const backdrop = (0, $fcf7ddccaab7fd8f$exports).optional(props.backdrop, {
        renderByDefault: modalType !== 'non-modal',
        defaultProps: {
            'aria-hidden': 'true'
        },
        elementType: 'div'
    });
    const backdropAppearance = backdrop === null || backdrop === void 0 ? void 0 : backdrop.appearance;
    if (backdrop) {
        backdrop.onClick = handledBackdropClick;
        // remove backdrop.appearance so it is not passed to the DOM
        delete backdrop.appearance;
    }
    const { disableBodyScroll: disableBodyScroll, enableBodyScroll: enableBodyScroll } = (0, $55b8006a7a00ad22$export$e1d95e7d6867c884)();
    (0, $4e48a6f126575b5a$export$700979bc83e7db82)(()=>{
        if (!open) {
            enableBodyScroll();
            return;
        }
        if (isNestedDialog || modalType === 'non-modal') return;
        disableBodyScroll();
        return ()=>enableBodyScroll();
    }, [
        open,
        modalType,
        isNestedDialog,
        disableBodyScroll,
        enableBodyScroll
    ]);
    return {
        components: {
            backdrop: 'div',
            root: 'div',
            backdropMotion: (0, $abbadddd1f7e274f$export$8ddeecc2d91e9cdd)
        },
        open: open,
        backdrop: backdrop,
        isNestedDialog: isNestedDialog,
        treatBackdropAsNested: treatBackdropAsNested,
        backdropAppearance: backdropAppearance,
        unmountOnClose: unmountOnClose,
        mountNode: props.mountNode,
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            tabIndex: -1,
            role: modalType === 'alert' ? 'alertdialog' : 'dialog',
            'aria-modal': modalType !== 'non-modal',
            'aria-labelledby': props['aria-label'] ? undefined : dialogTitleID,
            'aria-hidden': !unmountOnClose && !open ? true : undefined,
            ...props,
            ...modalAttributes,
            onKeyDown: handleKeyDown,
            // FIXME:
            // `DialogSurfaceElement` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: (0, $de7d48ea62179626$export$9cf7d991616612b3)(ref, contextRef, dialogRef)
        }), {
            elementType: 'div'
        }),
        backdropMotion: (0, $c44df703e8f8e21f$export$1834a16e35f276c5)(props.backdropMotion, {
            elementType: (0, $abbadddd1f7e274f$export$8ddeecc2d91e9cdd),
            defaultProps: {
                appear: unmountOnClose,
                visible: open
            }
        }),
        // Deprecated properties
        transitionStatus: undefined
    };
};







const $408594075e348c01$export$621d9bedb04ddc81 = (state, contextValues)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $aa8a2d30f790b072$export$602eac185826482c), {
        mountNode: state.mountNode,
        children: [
            state.backdrop && // TODO: state.backdropMotion is non nullable, but assertSlots asserts it as nullable
            // FIXME: this should be resolved by properly splitting props and state slots declaration
            state.backdropMotion && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.backdropMotion, {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.backdrop, {})
            }),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $59b10a9d6ce22ca1$export$521eca9e79de5335), {
                children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)((0, $dfbb1f6223498329$export$63e7a5d6b0cd8dfc), {
                    value: contextValues.dialogSurface,
                    children: /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {})
                })
            })
        ]
    });
};






'use client';
const $2e078eac8a385109$export$f923d4e087228f8d = {
    root: 'fui-DialogSurface',
    backdrop: 'fui-DialogSurface__backdrop'
};
/**
 * Styles for the root slot
 */ const $2e078eac8a385109$var$useRootBaseStyle = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r1u3t6p6", "r5coedp", {
    r: [
        ".r1u3t6p6{inset:0;padding:24px;margin:auto;border-style:none;overflow:unset;border:1px solid var(--colorTransparentStroke);border-radius:var(--borderRadiusXLarge);display:block;-webkit-user-select:unset;-moz-user-select:unset;user-select:unset;visibility:unset;position:fixed;height:fit-content;max-width:600px;max-height:100vh;max-height:100dvh;box-sizing:border-box;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);box-shadow:var(--shadow64);}",
        ".r1u3t6p6:focus{outline-style:none;}",
        ".r1u3t6p6:focus-visible{outline-style:none;}",
        ".r1u3t6p6[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".r1u3t6p6[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".r5coedp{inset:0;padding:24px;margin:auto;border-style:none;overflow:unset;border:1px solid var(--colorTransparentStroke);border-radius:var(--borderRadiusXLarge);display:block;-webkit-user-select:unset;-moz-user-select:unset;user-select:unset;visibility:unset;position:fixed;height:fit-content;max-width:600px;max-height:100vh;max-height:100dvh;box-sizing:border-box;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);box-shadow:var(--shadow64);}",
        ".r5coedp:focus{outline-style:none;}",
        ".r5coedp:focus-visible{outline-style:none;}",
        ".r5coedp[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".r5coedp[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.r1u3t6p6[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media screen and (max-width: 480px){.r1u3t6p6{max-width:100vw;}}",
        "@media screen and (max-height: 359px){.r1u3t6p6{overflow-y:auto;padding-right:calc(24px - 4px);border-right-width:4px;border-top-width:4px;border-bottom-width:4px;}}",
        "@media (forced-colors: active){.r5coedp[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}",
        "@media screen and (max-width: 480px){.r5coedp{max-width:100vw;}}",
        "@media screen and (max-height: 359px){.r5coedp{overflow-y:auto;padding-left:calc(24px - 4px);border-left-width:4px;border-top-width:4px;border-bottom-width:4px;}}"
    ]
});
const $2e078eac8a385109$var$useBackdropBaseStyle = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r1e18s3l", null, [
    ".r1e18s3l{inset:0px;background-color:var(--colorBackgroundOverlay);position:fixed;}"
]);
const $2e078eac8a385109$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    nestedDialogBackdrop: {
        De3pzq: "f1c21dwh"
    },
    dialogHidden: {
        Bkecrkj: "f1aehjj5"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1aehjj5{pointer-events:none;}"
    ]
});
const $2e078eac8a385109$export$60c1cf33f8375d66 = (state)=>{
    'use no memo';
    const { root: root, backdrop: backdrop, open: open, unmountOnClose: unmountOnClose, treatBackdropAsNested: treatBackdropAsNested, backdropAppearance: backdropAppearance } = state;
    const rootBaseStyle = $2e078eac8a385109$var$useRootBaseStyle();
    const backdropBaseStyle = $2e078eac8a385109$var$useBackdropBaseStyle();
    const styles = $2e078eac8a385109$var$useStyles();
    const isBackdropTransparent = backdropAppearance ? backdropAppearance === 'transparent' : treatBackdropAsNested;
    const mountedAndClosed = !unmountOnClose && !open;
    root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($2e078eac8a385109$export$f923d4e087228f8d.root, rootBaseStyle, mountedAndClosed && styles.dialogHidden, root.className);
    if (backdrop) backdrop.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($2e078eac8a385109$export$f923d4e087228f8d.backdrop, backdropBaseStyle, mountedAndClosed && styles.dialogHidden, isBackdropTransparent && styles.nestedDialogBackdrop, backdrop.className);
    return state;
};


function $dcf0dbbf13f87385$export$127901f2ae2690e3(state) {
    const dialogSurface = true;
    return {
        dialogSurface: dialogSurface
    };
}



'use client';
const $73cdd34c0b870187$export$8d5c5a60a915d482 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $254eec9f6c345877$export$c76c7ec047fdba7d)(props, ref);
    const contextValues = (0, $dcf0dbbf13f87385$export$127901f2ae2690e3)(state);
    (0, $2e078eac8a385109$export$60c1cf33f8375d66)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogSurfaceStyles_unstable')(state);
    return (0, $408594075e348c01$export$621d9bedb04ddc81)(state, contextValues);
});
$73cdd34c0b870187$export$8d5c5a60a915d482.displayName = 'DialogSurface';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

const $28a5d610d22ec260$export$2eb5650081e5becf = (props, ref)=>{
    var _props_as;
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : 'div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        })
    };
};




const $adaf5421c7f0dc1e$export$56f94778760af4a0 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    // TODO Add additional slots in the appropriate place
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};




'use client';
const $d204977a0cbd09d2$export$3d0920dbde491190 = {
    root: 'fui-DialogBody'
};
/**
 * Styles for the root slot
 */ const $d204977a0cbd09d2$var$useResetStyles = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rhwx3p8", null, {
    r: [
        ".rhwx3p8{overflow:unset;gap:8px;display:grid;max-height:calc(100vh - 2 * 24px);max-height:calc(100dvh - 2 * 24px);box-sizing:border-box;grid-template-rows:auto 1fr;grid-template-columns:1fr 1fr auto;}"
    ],
    s: [
        "@media screen and (max-width: 480px){.rhwx3p8{max-width:100vw;grid-template-rows:auto 1fr auto;}}",
        "@media screen and (max-height: 359px){.rhwx3p8{max-height:unset;}}"
    ]
});
const $d204977a0cbd09d2$export$e2cbfda03de88892 = (state)=>{
    'use no memo';
    const resetStyles = $d204977a0cbd09d2$var$useResetStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($d204977a0cbd09d2$export$3d0920dbde491190.root, resetStyles, state.root.className);
    return state;
};



'use client';
const $4346adda79f54b9d$export$5d20f2c38fcde41f = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $28a5d610d22ec260$export$2eb5650081e5becf)(props, ref);
    (0, $d204977a0cbd09d2$export$e2cbfda03de88892)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogBodyStyles_unstable')(state);
    return (0, $adaf5421c7f0dc1e$export$56f94778760af4a0)(state);
});
$4346adda79f54b9d$export$5d20f2c38fcde41f.displayName = 'DialogBody';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



"use client";
const $cdb0ff5c001a8842$export$beb4804b6728d8f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony16Filled', "16", [
    "M14.5 6a.5.5 0 0 1 0 1H14v4.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V7h-.5a.5.5 0 0 1 0-1h13ZM3 11.5c0 .18.03.34.09.5H5.5V7H3v4.5Zm7.5.5h2.41c.06-.16.09-.32.09-.5V7h-2.5v5Zm-4 0h3V7h-3v5ZM9.76 1.01A2.5 2.5 0 0 1 12 3.5V5H4V3.5A2.5 2.5 0 0 1 6.5 1h3l.26.01Z"
]);
const $cdb0ff5c001a8842$export$3661742ceb995f77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony16Regular', "16", [
    "M9.76 1.01A2.5 2.5 0 0 1 12 3.5V6h2.5a.5.5 0 0 1 0 1H14v4.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V7h-.5a.5.5 0 0 1 0-1H4V3.5A2.5 2.5 0 0 1 6.5 1h3l.26.01ZM3.09 12c.2.58.76 1 1.41 1h7c.65 0 1.2-.42 1.41-1H3.1ZM3 11h2.5V7H3v4Zm7.5 0H13V7h-2.5v4Zm-4 0h3V7h-3v4Zm0-9C5.67 2 5 2.67 5 3.5V6h6V3.5A1.5 1.5 0 0 0 9.65 2H6.5Z"
]);
const $cdb0ff5c001a8842$export$40f4650798a8b709 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony20Filled', "20", [
    "M17.6 8.01a.5.5 0 0 1 0 .98l-.1.01H17v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9h-.5a.5.5 0 0 1 0-1h15l.1.01ZM14 14h2V9h-2v5ZM4 14h2V9H4v5Zm3 0h2.5V9H7v5Zm3.5 0H13V9h-2.5v5ZM12 2a3 3 0 0 1 3 3v2H5V5a3 3 0 0 1 3-3h4Z"
]);
const $cdb0ff5c001a8842$export$1ab8d5e6352f83e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balcony20Regular', "20", [
    "M14 8V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v3h8ZM4 14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2H4Zm0-1h2V9H4v4Zm3 0h2.5V9H7v4Zm3.5 0H13V9h-2.5v4Zm3.5 0h2V9h-2v4Zm3.6-4.99a.5.5 0 0 1 0 .98l-.1.01H17v5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9h-.5a.5.5 0 0 1 0-1H5V5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3h2.5l.1.01Z"
]);
const $cdb0ff5c001a8842$export$a626769e5058ffff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon12Filled', "12", [
    "M5.5 1C7.41 1 9 2.48 9 4.36c0 1.24-.46 2.38-1.1 3.21A3.65 3.65 0 0 1 6 8.94v.46c0 .22.18.4.4.4h1.2c.77 0 1.4.63 1.4 1.4v.3a.5.5 0 0 1-1 0v-.3a.4.4 0 0 0-.4-.4H6.4A1.4 1.4 0 0 1 5 9.4v-.46a3.65 3.65 0 0 1-1.9-1.37A5.32 5.32 0 0 1 2 4.37 3.43 3.43 0 0 1 5.5 1Zm.07 2a.5.5 0 0 0-.14 1c.3.04.53.27.58.57A.5.5 0 0 0 7 4.43 1.68 1.68 0 0 0 5.57 3Z"
]);
const $cdb0ff5c001a8842$export$e0125020d57da6dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon12Regular', "12", [
    "M5 3.43A.5.5 0 0 1 5.57 3c.74.11 1.32.7 1.43 1.43a.5.5 0 1 1-1 .14.68.68 0 0 0-.57-.57.5.5 0 0 1-.43-.57Zm-3 .93A3.43 3.43 0 0 1 5.5 1C7.41 1 9 2.48 9 4.36c0 1.24-.46 2.38-1.1 3.21A3.65 3.65 0 0 1 6 8.94v.46c0 .22.18.4.4.4h1.2c.77 0 1.4.63 1.4 1.4v.3a.5.5 0 0 1-1 0v-.3a.4.4 0 0 0-.4-.4H6.4A1.4 1.4 0 0 1 5 9.4v-.46a3.65 3.65 0 0 1-1.9-1.37A5.32 5.32 0 0 1 2 4.37ZM5.5 2C4.1 2 3 3.08 3 4.36c0 1 .37 1.93.9 2.6C4.43 7.66 5.05 8 5.5 8c.45 0 1.07-.34 1.6-1.04.53-.68.9-1.6.9-2.6C8 3.08 6.9 2 5.5 2Z"
]);
const $cdb0ff5c001a8842$export$3787b9a469c9475d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon16Filled', "16", [
    "M8 1a4.44 4.44 0 0 0-4.5 4.5c0 1.37.55 2.73 1.36 3.74.7.87 1.62 1.55 2.64 1.72V11c0 1.1.9 2 2 2H11a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V14a2 2 0 0 0-2-2H9.5a1 1 0 0 1-1-1v-.04a4.49 4.49 0 0 0 2.64-1.72A6.15 6.15 0 0 0 12.5 5.5C12.5 3.27 10.82 1 8 1Zm0 2c.66 0 1.28.33 1.73.77.44.45.77 1.07.77 1.73a.5.5 0 0 1-1 0c0-.34-.17-.72-.48-1.02C8.72 4.18 8.34 4 8 4a.5.5 0 0 1 0-1Z"
]);
const $cdb0ff5c001a8842$export$601fb2c8722a2b73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon16Regular', "16", [
    "M7.5 3.5c0-.28.22-.5.5-.5.66 0 1.28.33 1.73.77.44.45.77 1.07.77 1.73a.5.5 0 0 1-1 0c0-.34-.17-.72-.48-1.02C8.72 4.18 8.34 4 8 4a.5.5 0 0 1-.5-.5Zm1 7.46a4.49 4.49 0 0 0 2.64-1.72A6.15 6.15 0 0 0 12.5 5.5C12.5 3.27 10.82 1 8 1a4.44 4.44 0 0 0-4.5 4.5c0 1.37.55 2.73 1.36 3.74.7.87 1.62 1.55 2.64 1.72V11c0 1.1.9 2 2 2H11a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V14a2 2 0 0 0-2-2H9.5a1 1 0 0 1-1-1v-.04ZM8 2c2.18 0 3.5 1.73 3.5 3.5 0 1.12-.45 2.26-1.14 3.12C9.66 9.49 8.79 10 8 10c-.8 0-1.66-.5-2.36-1.38-.69-.86-1.14-2-1.14-3.12C4.5 3.73 5.82 2 8 2Z"
]);
const $cdb0ff5c001a8842$export$3a8deeb680c417f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon20Filled', "20", [
    "M5 7a5 5 0 0 1 10 0c0 1.87-.66 3.6-1.6 4.86a5.06 5.06 0 0 1-2.9 2.1V14a1 1 0 0 0 1 1H14a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V17a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-2-2v-.05a5.06 5.06 0 0 1-2.9-2.09C5.66 10.6 5 8.86 5 7Zm5.57-3a.5.5 0 1 0-.14 1c.81.11 1.46.76 1.57 1.57a.5.5 0 0 0 1-.14A2.86 2.86 0 0 0 10.56 4Z"
]);
const $cdb0ff5c001a8842$export$2c0428df00534116 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon20Regular', "20", [
    "M10 4.43a.5.5 0 0 1 .57-.43 2.86 2.86 0 0 1 2.42 2.43.5.5 0 0 1-.99.14A1.86 1.86 0 0 0 10.43 5a.5.5 0 0 1-.43-.57ZM5 7a5 5 0 0 1 10 0c0 1.87-.66 3.6-1.6 4.86a5.06 5.06 0 0 1-2.9 2.1V14a1 1 0 0 0 1 1H14a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V17a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-2-2v-.05a5.06 5.06 0 0 1-2.9-2.09C5.66 10.6 5 8.86 5 7Zm5-4a4 4 0 0 0-4 4c0 1.64.59 3.16 1.4 4.27C8.24 12.4 9.23 13 10 13s1.76-.6 2.6-1.73A7.31 7.31 0 0 0 14 7a4 4 0 0 0-4-4Z"
]);
const $cdb0ff5c001a8842$export$4480b8e51556ca31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon24Filled', "24", [
    "M5 9a7 7 0 0 1 14 0c0 2.03-.67 4.24-1.85 5.96a6.58 6.58 0 0 1-4.4 2.99v.3c0 .41.34.75.75.75h3.25c1.24 0 2.25 1 2.25 2.25v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 0-.75-.75H13.5c-1.24 0-2.25-1-2.25-2.25v-.3a6.58 6.58 0 0 1-4.4-3A10.88 10.88 0 0 1 5 9Zm7.92-3.9a.75.75 0 0 0-.34 1.47 2.5 2.5 0 0 1 1.85 1.85.75.75 0 1 0 1.46-.35 4 4 0 0 0-2.97-2.96Z"
]);
const $cdb0ff5c001a8842$export$dfdeabd230bd4d2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Balloon24Regular', "24", [
    "M12.02 5.66c.1-.4.5-.65.9-.55a4 4 0 0 1 2.97 2.96.75.75 0 0 1-1.46.35 2.5 2.5 0 0 0-1.85-1.85.75.75 0 0 1-.56-.9ZM5 9a7 7 0 0 1 14 0c0 2.03-.67 4.24-1.85 5.96a6.58 6.58 0 0 1-4.4 2.99v.3c0 .41.34.75.75.75h3.25c1.24 0 2.25 1 2.25 2.25v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 0-.75-.75H13.5c-1.24 0-2.25-1-2.25-2.25v-.3a6.58 6.58 0 0 1-4.4-3A10.88 10.88 0 0 1 5 9Zm7-5.5A5.5 5.5 0 0 0 6.5 9c0 1.73.58 3.64 1.59 5.1 1 1.47 2.36 2.4 3.91 2.4 1.55 0 2.9-.93 3.91-2.4A9.38 9.38 0 0 0 17.5 9 5.5 5.5 0 0 0 12 3.5Z"
]);
const $cdb0ff5c001a8842$export$4263436f4ba5a01d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box16Filled', "16", [
    "m4.04 2.49 6.6 2.83L8 6.46 1.43 3.64c.14-.15.33-.27.53-.35l2.08-.8Zm1.33-.52 1.55-.6a3 3 0 0 1 2.16 0l4.96 1.92c.2.08.39.2.53.35l-2.65 1.14-6.55-2.8ZM15 4.55 8.5 7.33v7.45a3 3 0 0 0 .58-.16l4.96-1.9c.58-.23.96-.79.96-1.4V4.54ZM7.5 14.78V7.33L1 4.55v6.76c0 .62.38 1.18.96 1.4l4.96 1.91a3 3 0 0 0 .58.16Z"
]);
const $cdb0ff5c001a8842$export$1d928b67ef55d3db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box16Regular', "16", [
    "M6.92 1.38a3 3 0 0 1 2.16 0l4.96 1.9c.58.23.96.79.96 1.4v6.63a1.5 1.5 0 0 1-.96 1.4l-4.96 1.91a3 3 0 0 1-2.16 0l-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V4.68c0-.62.38-1.18.96-1.4l4.96-1.91Zm1.8.93a2 2 0 0 0-1.44 0l-1.38.53 5.59 2.12 1.95-.83L8.72 2.3ZM14 4.97 8.5 7.33v6.43a2 2 0 0 0 .22-.07l4.96-1.91a.5.5 0 0 0 .32-.47V4.97Zm-6.5 8.79V7.33L2 4.97v6.34c0 .2.13.4.32.47l4.96 1.9a2 2 0 0 0 .22.08ZM2.56 4.13 8 6.46l2.16-.93L4.5 3.38l-1.94.75Z"
]);
const $cdb0ff5c001a8842$export$90bc44ded265ae96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box20Filled', "20", [
    "m10 7.96 3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96Zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-8.9L2.04 5.86Zm8.46 11.87c.27-.04.54-.1.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18c0-.11-.01-.22-.04-.33L10.5 8.84v8.9ZM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21Z"
]);
const $cdb0ff5c001a8842$export$3a5fe68708ee1bc0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 0 0 2.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01Zm4.13 4.35 6.5-2.6v7.58a.5.5 0 0 1-.31.47l-5.76 2.3c-.14.06-.28.1-.43.13V8.84Zm-1 0v7.88a2.5 2.5 0 0 1-.43-.13l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6Z"
]);
const $cdb0ff5c001a8842$export$e3a7383fec4fc177 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v10.92c.22-.05.44-.11.66-.2l7.5-3.04c.66-.27 1.09-.91 1.09-1.62V7.19ZM11.25 21.7V10.77L2 7.19v9.64c0 .71.43 1.35 1.1 1.62l7.5 3.04c.2.09.43.15.65.2ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28Z"
]);
const $cdb0ff5c001a8842$export$cac4450e1fb6312b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v9.66c0 .71-.43 1.35-1.1 1.62l-7.5 3.04c-.9.37-1.9.37-2.8 0l-7.5-3.04c-.67-.27-1.1-.91-1.1-1.62V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04Zm2.25 1.4a2.25 2.25 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68Zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45l2.7-1.04ZM3.5 16.83c0 .1.06.2.16.23l7.5 3.04.09.04v-9.38L3.5 7.75v9.08Zm9.35 3.27 7.5-3.04c.09-.04.15-.13.15-.23V7.77l-7.75 3v9.37l.1-.04Z"
]);
const $cdb0ff5c001a8842$export$4ceb937f21f70b4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box28Filled', "28", [
    "M15.4 2.5c-.9-.36-1.9-.36-2.8 0L9.7 3.67l11.25 4.5 4.1-1.65c-.22-.2-.48-.35-.77-.47L15.4 2.5Zm3.52 6.47L7.67 4.47 3.73 6.06c-.29.12-.55.28-.77.47L14 10.94l4.92-1.97ZM2 8.6c0-.27.05-.54.12-.8l11.13 4.46v13.43c-.22-.04-.43-.1-.64-.19l-8.88-3.55A2.75 2.75 0 0 1 2 19.4V8.6Zm13.4 16.9c-.21.08-.43.15-.65.2V12.25L25.88 7.8c.08.25.12.52.12.8V19.4c0 1.12-.68 2.13-1.73 2.55L15.4 25.5Z"
]);
const $cdb0ff5c001a8842$export$2eced87885eda57a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box28Regular', "28", [
    "M15.4 2.5c-.9-.36-1.9-.36-2.8 0L3.74 6.05A2.75 2.75 0 0 0 2 8.6v10.8c0 1.12.69 2.13 1.73 2.55l8.88 3.55c.9.36 1.9.36 2.79 0l8.87-3.55A2.75 2.75 0 0 0 26 19.4V8.6c0-1.12-.68-2.13-1.73-2.55L15.4 2.5Zm-2.23 1.4a2.25 2.25 0 0 1 1.67 0l8.4 3.35-3.61 1.44L10.4 5l2.77-1.1Zm-4.8 1.9 9.24 3.7-3.6 1.44-9.24-3.69 3.6-1.44ZM3.54 8.38l9.72 3.89v11.88a2.27 2.27 0 0 1-.08-.03l-8.88-3.55a1.25 1.25 0 0 1-.79-1.16V8.6c0-.08.01-.16.03-.23Zm11.22 15.77V12.26l9.73-3.9.02.24v10.8c0 .5-.31.97-.79 1.16l-8.87 3.55-.09.03Z"
]);
const $cdb0ff5c001a8842$export$f4c1fc5288405bce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box32Filled', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L11.3 3.74l13 5L28.79 7c-.26-.2-.55-.38-.87-.5l-10.3-3.96Zm3.9 7.26-13-5-4.44 1.7c-.32.12-.6.3-.87.5L16 11.93l5.51-2.12ZM2 9.55c0-.29.04-.56.1-.82L15 13.69v15.95a4.5 4.5 0 0 1-.62-.19l-10.3-3.96A3.25 3.25 0 0 1 2 22.45V9.55Zm15.62 19.9c-.2.08-.41.14-.62.19V13.69l12.9-4.96c.06.26.1.53.1.82v12.9c0 1.35-.83 2.56-2.08 3.04l-10.3 3.96Z"
]);
const $cdb0ff5c001a8842$export$c28c99066d4d0cca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box32Regular', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L4.08 6.51A3.25 3.25 0 0 0 2 9.55v12.9c0 1.35.83 2.56 2.08 3.04l10.3 3.96c1.04.4 2.2.4 3.24 0l10.3-3.96A3.25 3.25 0 0 0 30 22.45V9.55c0-1.35-.83-2.56-2.08-3.04l-10.3-3.96ZM15.1 4.42a2.5 2.5 0 0 1 1.8 0L26.2 8 22.5 9.43 12.29 5.5l2.81-1.08ZM9.5 6.57l10.21 3.93L16 11.93 5.79 8 9.5 6.57ZM4 9.46l11 4.23v13.85L4.8 23.62c-.48-.18-.8-.65-.8-1.17v-13Zm13 18.08V13.7l11-4.23v12.99c0 .52-.32.99-.8 1.17L17 27.54Z"
]);
const $cdb0ff5c001a8842$export$51f471a39ca544eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box48Filled', "48", [
    "M26.32 4.83a6.25 6.25 0 0 0-4.64 0l-5.3 2.12 18.75 7.5 7.34-2.93a4.25 4.25 0 0 0-1.14-.69l-15-6Zm5.44 10.97L13.02 8.3l-6.35 2.53c-.42.17-.8.4-1.14.69L24 18.9l7.76-3.1ZM4 14.78c0-.39.05-.76.15-1.12l18.6 7.44v22.39a6.24 6.24 0 0 1-1.07-.32l-15-6A4.25 4.25 0 0 1 4 33.21V14.78Zm22.32 28.39c-.35.14-.7.24-1.07.32v-22.4l18.6-7.43c.1.36.15.73.15 1.12v18.44c0 1.74-1.06 3.3-2.67 3.94l-15 6Z"
]);
const $cdb0ff5c001a8842$export$b16006a7ea3a34d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Box48Regular', "48", [
    "M26.32 4.83a6.25 6.25 0 0 0-4.64 0l-15 6A4.25 4.25 0 0 0 4 14.78v18.44c0 1.74 1.06 3.3 2.67 3.94l15 6c1.5.6 3.16.6 4.65 0l15-6A4.25 4.25 0 0 0 44 33.22V14.78c0-1.74-1.06-3.3-2.67-3.95l-15-6Zm-3.71 2.32c.9-.35 1.89-.35 2.78 0l14 5.6-6.02 2.4L18 9l4.62-1.85Zm-7.98 3.2L30 16.5 24 18.9 8.62 12.75l6-2.4ZM6.5 14.6l16.24 6.5v19.8l-.14-.05-15.01-6c-.66-.27-1.1-.92-1.1-1.63V14.6Zm18.74 26.3V21.1l16.24-6.5.01.18v18.44c0 .71-.44 1.36-1.1 1.62l-15 6-.15.06Z"
]);
const $cdb0ff5c001a8842$export$33abc44d5e4771f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96ZM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 0 0 0 4.6v.93a3.5 3.5 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18Zm16 0v4.08a5.48 5.48 0 0 0-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33Zm1 8.32a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-6.86-.35 2-2a.5.5 0 1 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35Z"
]);
const $cdb0ff5c001a8842$export$a1e5d7d26664f889 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 0 1-.62-1.06 2.5 2.5 0 0 1-.39-.12l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01Zm12.63 10a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-6.86-.34 2-2a.5.5 0 1 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35Z"
]);
const $cdb0ff5c001a8842$export$43dab14c595963f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0 1 22 12.8V7.19Zm-10.75 8.52v-4.94L2 7.19v9.64c0 .71.43 1.35 1.1 1.62l7.5 3.04c.2.09.43.15.65.2v-2.4a6.5 6.5 0 0 1 0-3.58ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28ZM17.5 12a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM14 17.46l.02-.09.02-.06.03-.07.03-.04 2.55-2.55.07-.06a.5.5 0 0 1 .7.7l-.07.06L15.71 17h5.38c.2.05.36.2.4.41l.01.1v.08a.5.5 0 0 1-.41.4L21 18h-5.3l1.65 1.65.06.07a.5.5 0 0 1 0 .57l-.06.06-.07.06a.5.5 0 0 1-.56 0l-.07-.06-2.52-2.5-.04-.06-.04-.08-.03-.08-.01-.06-.01-.06v-.05Z"
]);
const $cdb0ff5c001a8842$export$dc8d8be51b52d58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowLeft24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04.19.07.18.06c.25.53.56 1.01.94 1.45-.66.1-1.34.02-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04Zm2.25 1.4a2.25 2.25 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68ZM4.59 6.55 12 9.45l2.7-1.04L7.21 5.5 4.59 6.56ZM17.5 12a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM14 17.46l.02-.09.02-.06.03-.07.03-.04 2.55-2.55.07-.06a.5.5 0 0 1 .7.7l-.07.06L15.71 17h5.38c.2.05.36.2.4.41l.01.1v.08a.5.5 0 0 1-.41.4L21 18h-5.3l1.65 1.65.06.07a.5.5 0 0 1 0 .57l-.06.06-.07.06a.5.5 0 0 1-.56 0l-.07-.06-2.52-2.5-.04-.06-.04-.08-.03-.08-.01-.06-.01-.06v-.05Z"
]);
const $cdb0ff5c001a8842$export$69a8c9edffb61880 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96ZM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 0 0 0 4.6v.93a3.5 3.5 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18Zm16 0v4.08a5.48 5.48 0 0 0-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-6.86 2 2a.5.5 0 1 1-.7.71L15 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.14Z"
]);
const $cdb0ff5c001a8842$export$b0b66b7fa944e349 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 0 1-.62-1.06 2.5 2.5 0 0 1-.39-.12l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01Zm8.13 14.5a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9Zm.35-6.85 2 2a.5.5 0 1 1-.7.71L15 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.14Z"
]);
const $cdb0ff5c001a8842$export$b071b9dc0b9e1239 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0 1 22 12.8V7.19Zm-10.75 3.58v4.94a6.5 6.5 0 0 0 0 3.58v2.4a3.75 3.75 0 0 1-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0ZM17.54 14l.09.02.06.02.07.03.05.04 2.54 2.54.06.07a.5.5 0 0 1-.7.7l-.06-.07L18 15.71v5.38a.5.5 0 0 1-.41.4l-.09.01h-.09a.5.5 0 0 1-.4-.4L17 21v-5.3l-1.65 1.65-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.06a.5.5 0 0 1 0-.57l.06-.07 2.5-2.51.07-.05.07-.04.08-.03.06-.01h.11Z"
]);
const $cdb0ff5c001a8842$export$78117a98a042e98c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxArrowUp24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04.19.07.18.06c.25.53.56 1.01.94 1.45-.66.1-1.34.02-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04Zm2.25 1.4a2.25 2.25 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68ZM4.59 6.55 12 9.45l2.7-1.04L7.21 5.5 4.59 6.56ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0ZM17.54 14l.09.02.06.02.07.03.05.04 2.54 2.54.06.07a.5.5 0 0 1-.7.7l-.06-.07L18 15.71v5.38a.5.5 0 0 1-.41.4l-.09.01h-.09a.5.5 0 0 1-.4-.4L17 21v-5.3l-1.65 1.65-.07.06a.5.5 0 0 1-.56 0l-.07-.06-.06-.06a.5.5 0 0 1 0-.57l.06-.07 2.5-2.51.07-.05.07-.04.08-.03.06-.01h.11Z"
]);
const $cdb0ff5c001a8842$export$2d52f74ee13afc68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark16Filled', "16", [
    "m4.04 2.49 6.6 2.83L8 6.46 1.43 3.64c.14-.15.33-.27.53-.35l2.08-.8Zm1.33-.52 1.55-.6a3 3 0 0 1 2.16 0l4.96 1.92c.2.08.39.2.53.35l-2.65 1.14-6.55-2.8ZM15 4.55 11.6 6c1.3.02 2.47.5 3.4 1.26V4.55ZM7.5 7.33v.4a5.48 5.48 0 0 0-.51 6.92 2.6 2.6 0 0 1-.07-.03l-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V4.54l6.5 2.78ZM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0Z"
]);
const $cdb0ff5c001a8842$export$d2e2e5452a975b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark16Regular', "16", [
    "M6.92 1.38a3 3 0 0 1 2.16 0l4.96 1.9c.58.23.96.79.96 1.4v2.58a5.5 5.5 0 0 0-1-.66V4.97L11.6 6a5.54 5.54 0 0 0-4.1 1.73v-.4L2 4.97v6.34c0 .21.13.4.32.47l3.99 1.53c.16.48.4.93.68 1.34a2.6 2.6 0 0 1-.07-.03l-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V4.68c0-.62.38-1.18.96-1.4l4.96-1.91Zm1.8.93a2 2 0 0 0-1.44 0l-1.38.53 5.59 2.12 1.95-.83L8.72 2.3ZM2.56 4.13 8 6.46l2.16-.93L4.5 3.38l-1.94.75ZM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.15 1.85 3-3a.5.5 0 0 0-.7-.7l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0Z"
]);
const $cdb0ff5c001a8842$export$4c844e83b6e786fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96ZM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 0 0 0 4.6v.93a3.5 3.5 0 0 1-.8-.21l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18Zm16 0v4.08a5.48 5.48 0 0 0-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-1-3.7 2.65-2.65a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64Z"
]);
const $cdb0ff5c001a8842$export$3954fb8a62ded44c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 0 1-.62-1.06 2.5 2.5 0 0 1-.39-.12l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01Zm8.13 14.5a4.5 4.5 0 1 0 0-8.99 4.5 4.5 0 0 0 0 9Zm-1-3.7 2.65-2.64a.5.5 0 0 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64Z"
]);
const $cdb0ff5c001a8842$export$ffb4ea4349881d15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0 1 22 12.8V7.19Zm-10.75 3.58v4.94a6.5 6.5 0 0 0 0 3.58v2.4a3.75 3.75 0 0 1-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28ZM17.5 23a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm2.65-7.85a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 3.65-3.64Z"
]);
const $cdb0ff5c001a8842$export$c27718e0c02278e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04.19.07.18.06c.25.53.56 1.01.94 1.45-.66.1-1.34.02-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04Zm2.25 1.4a2.25 2.25 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68ZM4.59 6.55 12 9.45l2.7-1.04L7.21 5.5 4.59 6.56ZM17.5 23a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm-1-4.2 3.65-3.65a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64Z"
]);
const $cdb0ff5c001a8842$export$6e441a3c493a2ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark28Filled', "28", [
    "M12.6 2.5c.9-.36 1.9-.36 2.8 0l8.87 3.55c.3.12.55.28.78.47l-4.11 1.65-11.25-4.5 2.92-1.17ZM7.68 4.48l11.25 4.5L14 10.93 2.96 6.52c.22-.2.48-.35.77-.47l3.94-1.57ZM2.12 7.8c-.07.25-.12.52-.12.8V19.4c0 1.12.69 2.13 1.73 2.55l8.88 3.55c.2.08.42.15.64.2v-3.26a7.51 7.51 0 0 1 0-3.88v-6.3L2.12 7.8ZM26 15.4a7.48 7.48 0 0 0-11.25.27v-3.42L25.88 7.8c.08.25.12.52.12.8v6.8Zm1 5.09a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-7.65 2.85 5-5a.5.5 0 0 0-.7-.7L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0Z"
]);
const $cdb0ff5c001a8842$export$95ed48d7e1db9c94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark28Regular', "28", [
    "M15.4 2.5c-.9-.36-1.9-.36-2.8 0L3.74 6.05A2.75 2.75 0 0 0 2 8.6v10.8c0 1.12.69 2.13 1.73 2.55l8.88 3.55c.77.31 1.62.35 2.42.13A7.52 7.52 0 0 1 14 24.27c-.28 0-.57-.05-.84-.16l-4.51-1.8-.03-.02-4.34-1.73a1.25 1.25 0 0 1-.79-1.16V8.6c0-.08.01-.16.03-.23l9.72 3.89v6.3c.29-1.07.8-2.05 1.5-2.88v-3.42l9.73-3.9.02.24v5.55c.55.35 1.06.77 1.5 1.25V8.6c0-1.12-.68-2.13-1.73-2.55L15.4 2.5Zm-2.23 1.4a2.25 2.25 0 0 1 1.67 0l8.4 3.35-3.61 1.44L10.4 5l2.77-1.1Zm-4.8 1.9 9.24 3.7-3.6 1.44-9.24-3.69 3.6-1.44ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-7.65 2.85 5-5a.5.5 0 0 0-.7-.7L19 22.29l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0Z"
]);
const $cdb0ff5c001a8842$export$a39dd93165f30c87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark32Filled', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L11.3 3.74l13 5L28.79 7c-.26-.2-.55-.38-.87-.5l-10.3-3.96Zm3.9 7.26-13-5-4.44 1.7c-.32.12-.6.3-.87.5L16 11.93l5.51-2.12ZM2 9.55c0-.29.04-.56.1-.82L15 13.69v5.18a8.96 8.96 0 0 0 0 8.26v2.5a4.5 4.5 0 0 1-.62-.18l-10.3-3.96A3.25 3.25 0 0 1 2 22.45V9.55ZM23 14c2.83 0 5.35 1.3 7 3.34v-7.8c0-.28-.04-.55-.1-.81L17 13.69v2.6A8.97 8.97 0 0 1 23 14Zm0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm-.72 11.03 5.25-5.25a.75.75 0 1 0-1.06-1.06l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0Z"
]);
const $cdb0ff5c001a8842$export$6daf757148544816 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark32Regular', "32", [
    "M17.62 2.55a4.5 4.5 0 0 0-3.24 0L4.08 6.51A3.25 3.25 0 0 0 2 9.55v12.9c0 1.35.83 2.56 2.08 3.04l10.3 3.96c.82.31 1.7.38 2.56.2a9.04 9.04 0 0 1-1.65-2 2.51 2.51 0 0 1-.19-.07l-5.24-2.01h-.01L4.8 23.61c-.48-.18-.8-.65-.8-1.17v-13l11 4.24v5.18a9.04 9.04 0 0 1 2-2.58v-2.6l11-4.23v6.06c.76.5 1.43 1.12 2 1.82v-7.8c0-1.34-.83-2.55-2.08-3.03l-10.3-3.96ZM15.1 4.42a2.5 2.5 0 0 1 1.8 0L26.2 8 22.5 9.43 12.29 5.5l2.81-1.08ZM9.5 6.57l10.21 3.93L16 11.93 5.79 8 9.5 6.57ZM23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm-.72 11.03 5.25-5.25a.75.75 0 1 0-1.06-1.06l-4.72 4.72-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0Z"
]);
const $cdb0ff5c001a8842$export$e95b387dc6599a12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark48Filled', "48", [
    "M26.32 4.83a6.25 6.25 0 0 0-4.64 0l-5.3 2.12 18.75 7.5 7.34-2.93a4.25 4.25 0 0 0-1.14-.69l-15-6Zm5.44 10.97L13.02 8.3l-6.35 2.53c-.42.17-.8.4-1.14.69L24 18.9l7.76-3.1ZM4 14.78c0-.39.05-.76.15-1.12l18.6 7.44v9.54a12.98 12.98 0 0 0 0 8.72v4.13a6.24 6.24 0 0 1-1.07-.32l-15-6A4.25 4.25 0 0 1 4 33.21V14.78ZM35 22c3.5 0 6.66 1.38 9 3.62V14.78c0-.39-.05-.76-.15-1.12l-18.6 7.44v5.3C27.63 23.7 31.12 22 35 22Zm11 13a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-12.3 4.7 8-8a1 1 0 0 0-1.4-1.4L33 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0Z"
]);
const $cdb0ff5c001a8842$export$778173dd721d2571 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxCheckmark48Regular', "48", [
    "M26.32 4.83a6.25 6.25 0 0 0-4.64 0l-15 6A4.25 4.25 0 0 0 4 14.78v18.44c0 1.74 1.06 3.3 2.67 3.94l7.46 2.99.03.01 7.52 3c1.11.45 2.32.57 3.49.34-.64-.73-1.2-1.55-1.66-2.42-.3-.04-.61-.12-.9-.23l-15.01-6c-.66-.27-1.1-.92-1.1-1.63V14.6l16.25 6.5v9.54c.56-1.58 1.42-3.01 2.5-4.24v-5.3l16.24-6.5.01.18v8.96c.9.52 1.75 1.16 2.5 1.88V14.78c0-1.74-1.06-3.3-2.67-3.95l-15-6Zm-3.71 2.32c.9-.35 1.89-.35 2.78 0l14 5.6-6.02 2.4L18 9l4.62-1.85Zm-7.98 3.2L30 16.5 24 18.9 8.62 12.75l6-2.4ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-12.3 4.7 8-8a1 1 0 0 0-1.4-1.4L33 37.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0Z"
]);
const $cdb0ff5c001a8842$export$420b606af784319f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96Zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-.94a5.48 5.48 0 0 1 0-4.58V8.84L2.04 5.85ZM18 6.17v4.08a5.48 5.48 0 0 0-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33Zm1 8.32a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$e6cfc7e81dede018 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 0 1-.62-1.06 2.51 2.51 0 0 1-.39-.12l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v3.37c.25-.55.6-1.05 1-1.49V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$5b18e9cf6b84ff65 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0 1 22 12.8V7.19Zm-10.75 3.58v4.94a6.5 6.5 0 0 0 0 3.58v2.4a3.75 3.75 0 0 1-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
]);
const $cdb0ff5c001a8842$export$99420b490497101a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxDismiss24Regular', "24", [
    "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 0 0-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 0 0-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04v-.85c.26.91.71 1.73 1.3 2.43-.65.1-1.33.02-1.96-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04Zm2.25 1.4a2.25 2.25 0 0 0-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68Zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45l2.7-1.04ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.36a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
]);
const $cdb0ff5c001a8842$export$1a66cbcfcf9b290e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96Zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.37-1.49.07-.23V8.84L2.04 5.85ZM18 6.17v2.95a2.87 2.87 0 0 0-2.9.71l-4.6 4.6v-5.6l7.46-2.99c.03.1.04.22.04.33Zm-7.02 9.2 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z"
]);
const $cdb0ff5c001a8842$export$ef9c16d279c91381 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.24-.97a2.53 2.53 0 0 1-.23-.08l-5.76-2.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6v7.08c.16-.47.42-.9.77-1.25l.23-.23v-5.6l6.5-2.6V9c.34-.01.68.03 1 .13V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01Zm4.61 10.89 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z"
]);
const $cdb0ff5c001a8842$export$75fc9e3dd7726b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v6.84l5.64-5.65a3.29 3.29 0 0 1 3.61-.7V7.2Zm-10.75 3.58v9.9l-.19.74-.04.22a3.73 3.73 0 0 1-.43-.14l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28Zm16.47 6.84-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24Z"
]);
const $cdb0ff5c001a8842$export$4c619b105e3e610e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxEdit24Regular', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v9.66c0 .71.43 1.35 1.1 1.62l7.5 3.04c.13.06.27.1.42.14l.04-.22.46-1.83c.16-.65.5-1.24.97-1.71l.26-.26v-6.84l7.75-3v3.24a3.3 3.3 0 0 1 1.5.25V7.17c0-.7-.43-1.35-1.1-1.62l-7.5-3.04Zm-2.25 1.4a2.25 2.25 0 0 1 1.7 0l6.59 2.67-2.67 1.03-7.53-2.93 1.91-.78ZM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56 7.21 5.5ZM3.5 7.75l7.75 3.01v9.38a2.13 2.13 0 0 1-.1-.04l-7.5-3.04a.25.25 0 0 1-.15-.23V7.75Zm15.6 4.92-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24Z"
]);
const $cdb0ff5c001a8842$export$7c54ac7343988191 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34A2.5 2.5 0 0 1 14 10.1v4.78c0 .2-.03.4-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.1a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33Zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0l2.77-1.07ZM6.42 7.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v4.78a1.5 1.5 0 0 1-.96 1.4l-3.46 1.33a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33Zm4.67 2.91a.5.5 0 0 0-.64-.28L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.8-1.07a.5.5 0 0 0 .3-.65Z"
]);
const $cdb0ff5c001a8842$export$7a5904599c8de3da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.71A1.5 1.5 0 0 0 7 5.11v1.1a4 4 0 0 1 1 0v-1.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33c.2.08.32.26.32.47v7.78c0 .2-.13.4-.32.47L14 14.39v.5c0 .2-.03.4-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.11a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33Zm2.51 2.92a.5.5 0 0 0-.64-.3l-2.77 1.07a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 1 0-.35.93l2.76 1.07c.35.13.73.13 1.08 0l2.76-1.07a.5.5 0 0 0 .3-.64Zm-5 5a.5.5 0 0 0-.64-.3L7.5 11.15l-2.95-1.13a.5.5 0 0 0-.35.93L7 12.02v2.49a.5.5 0 1 0 1 0v-2.49l2.8-1.08a.5.5 0 0 0 .3-.64ZM8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.71a1.5 1.5 0 0 0-.96 1.4v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l3.46-1.33c.58-.22.96-.78.96-1.4v-4.78a1.5 1.5 0 0 0-.96-1.4L8.58 7.38Zm-1.8.93a2 2 0 0 1 1.44 0l3.46 1.33c.2.08.32.26.32.47v4.78c0 .2-.13.4-.32.47l-3.46 1.33a2 2 0 0 1-1.44 0l-3.46-1.33a.5.5 0 0 1-.32-.47v-4.78c0-.2.13-.4.32-.47l3.46-1.33Z"
]);
const $cdb0ff5c001a8842$export$ec5f02843edeb791 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple24Filled', "24", [
    "M16.3 2.33a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c1.08.4 1.8 1.42 1.8 2.57v5.67c0 .32-.06.64-.16.93l4.02-1.49c.68-.25 1.14-.9 1.14-1.64V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33Zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92ZM7.7 9.53a3.75 3.75 0 0 1 2.6 0l4.3 1.6c.7.24 1.15.9 1.15 1.63v5.67c0 .73-.46 1.39-1.14 1.64l-4.31 1.6c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6ZM5.3 13.7c-.13.4.08.82.47.96l2.48.85v2.7a.75.75 0 0 0 1.5 0v-2.7l2.47-.85a.75.75 0 0 0-.49-1.42L9 14.2l-2.74-.95a.75.75 0 0 0-.95.46Z"
]);
const $cdb0ff5c001a8842$export$7693ebb461ff8129 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultiple24Regular', "24", [
    "M15.78 3.74a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v10.67c0 .74-.46 1.4-1.14 1.64l-4.02 1.49c.1-.3.16-.6.16-.93v-.73l3.34-1.23c.1-.04.16-.13.16-.24V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6Zm-4.01 3.93a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92Zm-6 7a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95a.75.75 0 1 1 .5 1.42l-2.48.85v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85Zm4.53-5.14a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.24-1.15.9-1.15 1.63v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l4.3-1.6c.7-.25 1.15-.9 1.15-1.64v-5.67c0-.73-.46-1.39-1.14-1.64l-4.31-1.6Zm-2.08 1.4c.5-.18 1.06-.18 1.56 0l4.3 1.6c.1.03.17.13.17.23v5.67c0 .1-.07.2-.16.24l-4.31 1.59c-.5.18-1.06.18-1.56 0l-4.3-1.6a.25.25 0 0 1-.17-.23v-5.67c0-.1.07-.2.16-.23l4.31-1.6Z"
]);
const $cdb0ff5c001a8842$export$29f81a03dc56c947 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33Zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0l2.77-1.07Zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.48 5.48 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0l3.46 1.33ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 1 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $cdb0ff5c001a8842$export$47451f95c6ddae33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33ZM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 0 0-.12-.07L8.22 8.31a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0l3.46 1.33Zm-1.6 1.3a.5.5 0 0 1 .61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13L10.45 10Zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.34a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 1 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $cdb0ff5c001a8842$export$2a8d19d22362d940 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft24Filled', "24", [
    "M16.3 2.33a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c.52.18.95.52 1.26.94a6.53 6.53 0 0 1 5.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33Zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92Zm2.84 3.91c.2.08.38.18.53.32a6.52 6.52 0 0 0-2.68 1.95.75.75 0 0 0-.73-.14L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.79-.62a6.48 6.48 0 0 0 .5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 0 1 2.6 0l4.3 1.6ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-2.5.5a.5.5 0 1 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18h4.79Z"
]);
const $cdb0ff5c001a8842$export$5c14d5f8b15ffe3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowLeft24Regular', "24", [
    "M15.78 3.74a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a6.5 6.5 0 0 0-1.5-.97V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6Zm-1.17 7.38c.2.08.38.18.53.32-.57.22-1.1.52-1.58.9l-3.78-1.4a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v5.67c0 .1.07.2.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59c.16.48.39.93.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 0 1 2.6 0l4.3 1.6Zm-2.88 2.13a.75.75 0 0 1 .73.14 6.5 6.5 0 0 0-.92 1.51l-1.79.62v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95Zm.04-5.58a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-2.5.5a.5.5 0 1 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18h4.79Z"
]);
const $cdb0ff5c001a8842$export$f984f542c9a972a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33Zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0l2.77-1.07Zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.48 5.48 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0l3.46 1.33ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
]);
const $cdb0ff5c001a8842$export$ef1483bf61600ba2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33ZM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 0 0-.12-.07L8.22 8.31a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0l3.46 1.33Zm-1.6 1.3a.5.5 0 0 1 .61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13L10.45 10Zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.36a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
]);
const $cdb0ff5c001a8842$export$afb98287708ec813 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight24Filled', "24", [
    "M16.3 2.33a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c.52.18.95.52 1.26.94a6.53 6.53 0 0 1 5.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33Zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92Zm2.84 3.91c.2.08.38.18.53.32a6.52 6.52 0 0 0-2.68 1.95.75.75 0 0 0-.73-.14L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.79-.62a6.48 6.48 0 0 0 .5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 0 1 2.6 0l4.3 1.6ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17H14.5Z"
]);
const $cdb0ff5c001a8842$export$6ffe25e836555e15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleArrowRight24Regular', "24", [
    "M15.78 3.74a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a6.5 6.5 0 0 0-1.5-.97V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6Zm-1.17 7.38c.2.08.38.18.53.32-.57.22-1.1.52-1.58.9l-3.78-1.4a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v5.67c0 .1.07.2.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59c.16.48.39.93.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 0 1 2.6 0l4.3 1.6Zm-2.88 2.13a.75.75 0 0 1 .73.14 6.5 6.5 0 0 0-.92 1.51l-1.79.62v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95Zm.04-5.58a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-8.5-.5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17H14.5Z"
]);
const $cdb0ff5c001a8842$export$3c8d8fdb171078d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark20Filled', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 0 1 4.24 1.2V5.12a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33Zm1.87 2.15a.5.5 0 1 1 .35.94l-2.76 1.06a1.5 1.5 0 0 1-1.08 0L9.2 5.47a.5.5 0 0 1 .35-.94l2.77 1.07a.5.5 0 0 0 .36 0l2.77-1.07Zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 0 0-.6-.2L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l2.09-.8a5.48 5.48 0 0 0-.39 5.98l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0l3.46 1.33ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$bfe0970a991f39b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark20Regular', "20", [
    "M13.58 2.38a3 3 0 0 0-2.16 0L7.96 3.7A1.5 1.5 0 0 0 7 5.1v1.1a4 4 0 0 1 1 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 0 0-.96-1.4l-3.46-1.33ZM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 0 0-.12-.07L8.22 8.31a2 2 0 0 0-1.44 0L3.32 9.64a.5.5 0 0 0-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 0 0 1.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 0 1-2.16 0l-3.46-1.33a1.5 1.5 0 0 1-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 0 1 2.16 0l3.46 1.33Zm-1.6 1.3a.5.5 0 0 1 .61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13L10.45 10Zm5.65-4.72a.5.5 0 0 0-.64-.28l-2.77 1.06a.5.5 0 0 1-.36 0L9.55 5.01a.5.5 0 0 0-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.84a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$beffb9012a43a834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark24Filled', "24", [
    "M16.3 2.33a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c.52.18.95.52 1.26.94a6.53 6.53 0 0 1 5.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33Zm-4.53 4.88a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92Zm2.84 3.91c.2.08.38.18.53.32a6.52 6.52 0 0 0-2.68 1.95.75.75 0 0 0-.73-.14L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.79-.62a6.48 6.48 0 0 0 .5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 0 1 2.6 0l4.3 1.6ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$59b8245a73db5ab4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleCheckmark24Regular', "24", [
    "M15.78 3.74a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a6.5 6.5 0 0 0-1.5-.97V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6Zm-1.17 7.38c.2.08.38.18.53.32-.57.22-1.1.52-1.58.9l-3.78-1.4a2.25 2.25 0 0 0-1.56 0l-4.3 1.59a.25.25 0 0 0-.17.23v5.67c0 .1.07.2.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59c.16.48.39.93.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 0 1-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 0 1 2.6 0l4.3 1.6Zm-2.88 2.13a.75.75 0 0 1 .73.14 6.5 6.5 0 0 0-.92 1.51l-1.79.62v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95Zm.04-5.58a.75.75 0 1 1 .49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 1 1 .5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-2.15-2.35a.5.5 0 0 0-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$eaa9a10e07a403ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch20Filled', "20", [
    "M11.42 2.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78c0 .07 0 .15-.02.22A4.5 4.5 0 0 0 13.74 9a2.5 2.5 0 0 0-1.34-1.23L8.94 6.44A4 4 0 0 0 7 6.21V5.1c0-.62.38-1.18.96-1.4l3.46-1.33Zm4.67 2.44a.5.5 0 0 0-.64-.29L12.68 5.6a.5.5 0 0 1-.36 0L9.55 4.53a.5.5 0 0 0-.35.94l2.76 1.06c.35.13.73.13 1.08 0l2.76-1.06a.5.5 0 0 0 .3-.65ZM12.6 9.09a1.5 1.5 0 0 0-.56-.38L8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.7A1.5 1.5 0 0 0 2 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l1.94-.75a4.49 4.49 0 0 1-1.02-5.43l-1.5.58v2.49a.5.5 0 0 1-1 0V12l-2.8-1.07a.5.5 0 1 1 .35-.93l2.95 1.13L10.45 10a.5.5 0 0 1 .25-.03c.54-.44 1.2-.75 1.9-.9Zm3.7 6.5a3.5 3.5 0 1 0-.7.7l2.55 2.56a.5.5 0 0 0 .7-.7L16.3 15.6Zm-.3-2.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
]);
const $cdb0ff5c001a8842$export$33b385621f3b6da3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch20Regular', "20", [
    "M11.42 2.38a3 3 0 0 1 2.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78c0 .07 0 .15-.02.22a4.48 4.48 0 0 0-.98-2.44V5.11a.5.5 0 0 0-.32-.47l-3.46-1.33a2 2 0 0 0-1.44 0L8.32 4.64a.5.5 0 0 0-.32.47v1.1a4 4 0 0 0-1 0V5.1c0-.62.38-1.18.96-1.4l3.46-1.33Zm1.18 6.7a1.5 1.5 0 0 0-.56-.37L8.58 7.38a3 3 0 0 0-2.16 0L2.96 8.7A1.5 1.5 0 0 0 2 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 0 0 2.16 0l1.94-.75c-.27-.23-.5-.5-.71-.8l-1.6.62a2 2 0 0 1-1.43 0l-3.46-1.33a.5.5 0 0 1-.32-.47V10.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 0 1 1.44 0l3.16 1.22c.38-.2.79-.35 1.22-.44Zm-1.9.9a.5.5 0 0 0-.25.03L7.5 11.14 4.55 10a.5.5 0 1 0-.35.93L7 12.02v2.49a.5.5 0 0 0 1 0V12l1.5-.57c.29-.57.7-1.07 1.2-1.46ZM15.45 5a.5.5 0 1 1 .35.93L13.04 7a1.5 1.5 0 0 1-1.08 0L9.2 5.94A.5.5 0 0 1 9.55 5l2.77 1.06a.5.5 0 0 0 .36 0l2.77-1.06Zm.85 10.59a3.5 3.5 0 1 0-.7.7l2.55 2.55a.5.5 0 0 0 .7-.7L16.3 15.6Zm-.3-2.1a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
]);
const $cdb0ff5c001a8842$export$42888c1b2ef6009c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch24Filled', "24", [
    "M13.7 2.33a3.75 3.75 0 0 1 2.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v9.3A5.5 5.5 0 0 0 16.12 11c-.3-.36-.7-.65-1.17-.83l-4.3-1.59a4.75 4.75 0 0 0-2.4-.23v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59Zm-2.4 3.92c-.13.4.08.82.47.96l2.66.92c.37.13.77.13 1.14 0l2.65-.92a.75.75 0 0 0-.49-1.42l-2.65.92a.25.25 0 0 1-.16 0l-2.66-.92a.75.75 0 0 0-.95.46Zm3.57 5a1.74 1.74 0 0 0-.26-.13l-4.31-1.6a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.91-1.15 1.64v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l2.64-.98a5.49 5.49 0 0 1-1.74-5.67l-1.45.5v2.7a.75.75 0 0 1-1.5 0v-2.7l-2.48-.85a.75.75 0 0 1 .49-1.42L9 14.2l2.73-.95a.75.75 0 0 1 .36-.03 5.5 5.5 0 0 1 2.78-1.98Zm5.3 7.86a4.5 4.5 0 1 0-1.06 1.06l2.61 2.6a.75.75 0 0 0 1.06-1.05l-2.61-2.61Zm-.67-2.61a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
]);
const $cdb0ff5c001a8842$export$e5a4c86d373e39bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxMultipleSearch24Regular', "24", [
    "M14.22 3.74c.5-.19 1.06-.19 1.56 0l4.3 1.59c.1.04.17.13.17.23v6.92a5.5 5.5 0 0 1 1.5 2.37V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.5-.08 1-.08 1.5 0v-2.8c0-.1.07-.2.16-.23l4.31-1.6Zm.65 7.5a1.74 1.74 0 0 0-.26-.12l-4.31-1.6a3.75 3.75 0 0 0-2.6 0l-4.3 1.6c-.7.25-1.15.91-1.15 1.64v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l2.64-.98c-.41-.35-.77-.75-1.06-1.2l-2.1.77c-.5.18-1.06.18-1.56 0l-4.3-1.6a.25.25 0 0 1-.17-.23v-5.67c0-.1.07-.2.16-.23l4.31-1.6c.5-.18 1.06-.18 1.56 0l3.33 1.24c.52-.41 1.12-.73 1.76-.93Zm-2.78 1.98a.75.75 0 0 0-.36.03L9 14.2l-2.74-.95a.75.75 0 1 0-.5 1.42l2.49.85v2.7a.75.75 0 0 0 1.5 0v-2.7l1.45-.5c.18-.66.49-1.27.89-1.8Zm-.78-6.5c-.14.38.07.81.46.95l2.66.92c.37.12.77.12 1.14 0l2.65-.92a.75.75 0 0 0-.49-1.42l-2.65.92a.25.25 0 0 1-.16 0l-2.66-.92a.75.75 0 0 0-.95.46Zm8.86 12.39a4.5 4.5 0 1 0-1.06 1.06l2.61 2.6a.75.75 0 0 0 1.06-1.05l-2.61-2.61Zm-.67-2.61a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
]);
const $cdb0ff5c001a8842$export$df530466113928f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch16Filled', "16", [
    "M11.65 4.32 5.04 1.5l-2.08.8c-.2.08-.39.2-.53.35L9 5.46l2.65-1.14ZM7.92.38l-1.55.6 6.55 2.8 2.65-1.14a1.5 1.5 0 0 0-.53-.35L10.08.38a3 3 0 0 0-2.16 0ZM9.5 6.33 16 3.55v6.76a1.5 1.5 0 0 1-.96 1.4l-4.96 1.91a3 3 0 0 1-.58.16V6.33Zm-1 4.17V6.33L2 3.55v2.71A4.5 4.5 0 0 1 3.5 6c2.76 0 5 2.01 5 4.5Zm-5 3.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 12.6A3.5 3.5 0 1 0 3.5 14Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$f96c4c06e7dfffcd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch16Regular', "16", [
    "M10.08.38a3 3 0 0 0-2.16 0l-4.96 1.9A1.5 1.5 0 0 0 2 3.69v2.58c.32-.12.65-.2 1-.23V3.97l5.5 2.36v7.05l.44.44a3 3 0 0 0 1.14-.2l4.96-1.9c.58-.23.96-.79.96-1.4V3.68a1.5 1.5 0 0 0-.96-1.4L10.08.38Zm-1.8.93a2 2 0 0 1 1.44 0l4.72 1.82-1.95.83-5.6-2.12 1.4-.53ZM9.5 6.33 15 3.97v6.34c0 .21-.13.4-.32.47l-4.96 1.9c-.07.04-.15.06-.22.08V6.33ZM9 5.46 3.56 3.13l1.94-.75 5.66 2.15L9 5.46ZM3.5 14c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 12.6A3.5 3.5 0 1 0 3.5 14Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$34d95cccedc0f8cf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch20Filled', "20", [
    "m10 7.96 3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96Zm-7.96-2.1c-.03.1-.04.2-.04.32v3.08a4.5 4.5 0 0 1 5.56 6.18l1.94 1.94V8.84L2.04 5.85Zm8.46 11.87c.27-.04.54-.1.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18c0-.11-.01-.22-.04-.33L10.5 8.84v8.9ZM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM3.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 15.6A3.5 3.5 0 1 0 3.5 17Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$4b35fbbf731a3600 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch20Regular', "20", [
    "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v7.64a1.5 1.5 0 0 1-.94 1.4l-5.76 2.3c-.48.19-.99.27-1.5.24a1.5 1.5 0 0 0-.24-.32l-.06-.06V8.84L3 6.24v2.79c-.35.04-.68.11-1 .23V6.18c0-.62.37-1.17.94-1.4l5.76-2.3Zm2.23.93a2.5 2.5 0 0 0-1.86 0l-1.35.54 6.16 2.46 2.27-.91-5.22-2.1Zm1.6 3.54L6.38 4.49l-2.53 1L10 7.97l2.53-1.01ZM17 6.24l-6.5 2.6v7.88c.15-.03.29-.07.43-.13l5.76-2.3a.5.5 0 0 0 .31-.47V6.24ZM3.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L6.3 15.6A3.5 3.5 0 1 0 3.5 17Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$879052b336dedf00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.89L18 7.13l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.57V21.7c.22-.05.44-.11.66-.2l7.5-3.04c.66-.27 1.09-.91 1.09-1.62V7.19Zm-10.75 3.57v10.01l-1.82-1.82A5.5 5.5 0 0 0 2 11.6V7.19l9.25 3.57ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28ZM4.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 4.5 21Zm0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
]);
const $cdb0ff5c001a8842$export$685fdae2ba6d1b45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxSearch24Regular', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v4.43c.47-.24.97-.41 1.5-.5V7.74l7.75 3.01v10.02l.24.23c.21.22.36.48.44.75.5.01 1-.08 1.48-.27l7.5-3.04c.66-.27 1.09-.91 1.09-1.62V7.17c0-.7-.43-1.35-1.1-1.62l-7.5-3.04Zm-2.25 1.4a2.25 2.25 0 0 1 1.7 0l6.59 2.66-2.67 1.04-7.53-2.93 1.91-.78ZM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56 7.21 5.5Zm13.13 11.56-7.5 3.04-.09.03v-9.37l7.75-2.99v9.06c0 .1-.06.19-.16.23ZM4.5 21c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 4.5 21Zm0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
]);
const $cdb0ff5c001a8842$export$d9cd89e289f4c0a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox20Filled', "20", [
    "M17.42 5 14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.13.06.25.13.36.21ZM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 0 0-.36.21L10 7.96Zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1V13.5c0-.56.19-1.08.5-1.5V8.84L2.04 5.85ZM18 6.17v4.87h-.04A2.5 2.5 0 0 0 15.5 9h-2a2.5 2.5 0 0 0-2.46 2.04c-.19.04-.37.1-.54.17V8.84l7.46-2.99c.03.1.04.22.04.33ZM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0Z"
]);
const $cdb0ff5c001a8842$export$d7c9a19f2bdf5748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox20Regular', "20", [
    "M11.3 2.48a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1v-1.06L3.31 14.3a.5.5 0 0 1-.31-.47V6.24l6.5 2.6V12c.26-.34.6-.62 1-.8V8.85l6.5-2.6V9.5c.5.37.84.91.96 1.54l.04.01V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54Zm-2.7 1.08 6.16 2.46L10 7.96 3.85 5.5l2.53-1.01Zm5.63 7.5v-.5c0-.82.67-1.49 1.5-1.49h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm3.5-1h-2a.5.5 0 0 0-.5.5v.5h3v-.5a.5.5 0 0 0-.5-.5ZM17 16.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 1 0 1 0V16h3v.5a.5.5 0 1 0 1 0Z"
]);
const $cdb0ff5c001a8842$export$481471f1d6407116 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox24Filled', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04ZM22 7.2l-9.25 3.58v3.35l.25-.07V14a2.75 2.75 0 0 1 2.75-2.75h3.5A2.75 2.75 0 0 1 22 14v-6.8Zm-10.75 3.58v4.64c-.16.33-.25.7-.25 1.1v5.12a3.73 3.73 0 0 1-.4-.14l-7.5-3.04c-.67-.27-1.1-.91-1.1-1.62V7.19l9.25 3.58ZM2.63 5.83 12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28ZM14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1Zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1ZM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5Z"
]);
const $cdb0ff5c001a8842$export$771102eba01260fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('BoxToolbox24Regular', "24", [
    "M13.4 2.51a3.75 3.75 0 0 0-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v9.66c0 .71.43 1.35 1.1 1.62l7.5 3.04.4.14V20.04l-7.34-2.98a.25.25 0 0 1-.16-.23V7.75l7.75 3.01v4.65a2.5 2.5 0 0 1 1.5-1.3v-3.34l7.75-3v3.78C21.39 12 22 12.93 22 14V7.17c0-.7-.43-1.35-1.1-1.62l-7.5-3.04Zm-2.25 1.4a2.25 2.25 0 0 1 1.7 0l6.59 2.67-2.67 1.03-7.53-2.93 1.91-.78ZM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56 7.21 5.5ZM14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 0 1 1.5 0V18h3v-.25a.75.75 0 0 1 1.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1Zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1ZM12 21.5v-2h2.5v.75a.75.75 0 0 0 1.5 0v-.75h3v.75a.75.75 0 0 0 1.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5Z"
]);
const $cdb0ff5c001a8842$export$625eb710d5531409 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03c.36.06.7.2 1 .4V5a3 3 0 0 0-3-3H5Zm.5 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM5 8.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM6.5 11a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42H6.5Z"
]);
const $cdb0ff5c001a8842$export$63c7f4837099fa0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03c.36.06.7.2 1 .4V5a3 3 0 0 0-3-3H5Zm1.5 9a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42H6.5Zm3.34 3.5L7.6 12h6.98a.5.5 0 0 1 .35.14L17.9 15l-2.95 2.86a.5.5 0 0 1-.35.14H7.61l2.23-2.5a.75.75 0 0 0 0-1ZM5 5.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5.5 8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z"
]);
const $cdb0ff5c001a8842$export$390fd890611ff40a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram24Filled', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h10.5C17.55 2 19 3.46 19 5.25v6.03a2.75 2.75 0 0 0-1.22-.28h-.28V5.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h3.37L7.36 20H5.25A3.25 3.25 0 0 1 2 16.75V5.25ZM6.75 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm.32 6.43a.75.75 0 0 1 .68-.43h10.03c.52 0 1.01.23 1.34.62l3.7 4.4c.24.28.24.68 0 .96l-3.7 4.4c-.33.4-.82.62-1.34.62H7.75a.75.75 0 0 1-.57-1.23l3.59-4.27-3.6-4.27a.75.75 0 0 1-.1-.8ZM6.75 9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
]);
const $cdb0ff5c001a8842$export$a1d9aa6eb9f55883 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diagram24Regular', "24", [
    "M2 5.25C2 3.45 3.46 2 5.25 2h10.5C17.55 2 19 3.46 19 5.25v6.03a2.75 2.75 0 0 0-1.22-.28h-.28V5.25c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h3.37L7.36 20H5.25A3.25 3.25 0 0 1 2 16.75V5.25ZM6.75 6a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5Zm.32 6.43a.75.75 0 0 1 .68-.43h10.03c.52 0 1.01.23 1.34.62l3.7 4.4c.24.28.24.68 0 .96l-3.7 4.4c-.33.4-.82.62-1.34.62H7.75a.75.75 0 0 1-.57-1.23l3.59-4.27-3.6-4.27a.75.75 0 0 1-.1-.8Zm2.3 1.07 2.95 3.52c.24.28.24.68 0 .96L9.36 21.5h8.42c.08 0 .15-.03.2-.09l3.29-3.91-3.3-3.91a.25.25 0 0 0-.19-.09H9.36ZM6.74 9a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
]);
const $cdb0ff5c001a8842$export$320b0461b1da4175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad20Filled', "20", [
    "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM7.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM14 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $cdb0ff5c001a8842$export$f132371f8df12155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad20Regular', "20", [
    "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $cdb0ff5c001a8842$export$172f3c5de5a6fb7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad24Filled', "24", [
    "M12 17.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
]);
const $cdb0ff5c001a8842$export$ca341f40ab6d57b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad24Regular', "24", [
    "M12 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm0-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-10 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-10 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-10 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $cdb0ff5c001a8842$export$5c51a26323a650bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad28Filled', "28", [
    "M7.5 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6.5-12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6.5-18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $cdb0ff5c001a8842$export$c7ba0b979c7181d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad28Regular', "28", [
    "M9 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.5-12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.5-18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
]);
const $cdb0ff5c001a8842$export$e054f1196e062a8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad32Filled', "32", [
    "M9 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm7-14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm7-21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
]);
const $cdb0ff5c001a8842$export$52b33ac2b3a08f61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad32Regular', "32", [
    "M11 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm7-14a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm7-21a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $cdb0ff5c001a8842$export$b62b51f49b1aee4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad48Filled', "48", [
    "M13.5 11.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm10.5-20a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm10.5-30a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
]);
const $cdb0ff5c001a8842$export$c3a7ae4bd8598ec6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dialpad48Regular', "48", [
    "M16 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm10.5-20a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM37 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
]);
const $cdb0ff5c001a8842$export$79597ee4189115be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l3.9 3.9H6a1.25 1.25 0 1 0 1.25 1.2l2.8 2.8H10a1.25 1.25 0 1 0 1.25 1.2l5.9 5.9a.5.5 0 0 0 .7-.7l-15-15ZM15.25 12c0 .31-.12.6-.3.82l-1.77-1.76a1.25 1.25 0 0 1 2.07.94Zm-4-4c0 .31-.12.6-.3.82L9.17 7.06a1.25 1.25 0 0 1 2.07.94Zm-4-4c0 .31-.12.6-.3.82L5.17 3.06A1.25 1.25 0 0 1 7.25 4Zm0 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
]);
const $cdb0ff5c001a8842$export$80e5a244ea31ac0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7l4.2 4.22A1 1 0 0 0 5 8a1 1 0 1 0 1.93-.36l3.43 3.43a1 1 0 1 0 .57.57l6.22 6.21a.5.5 0 0 0 .7-.7l-15-15ZM15 12a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 15 12Zm-4-4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 11 8ZM7 4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 7 4Zm0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
]);
const $cdb0ff5c001a8842$export$6f1d80b2122cf889 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.5 4.5a1.5 1.5 0 1 0 1.76 1.76l3.24 3.24a1.5 1.5 0 1 0 1.75 1.75l7.25 7.25a.75.75 0 0 0 1.06-1.06L3.28 2.22ZM18.5 14.25c0 .3-.1.58-.25.82l-2.07-2.08a1.5 1.5 0 0 1 2.32 1.26Zm-5-5c0 .3-.09.59-.25.82L11.18 8a1.5 1.5 0 0 1 2.32 1.25Zm-5-5c0 .3-.09.59-.24.83L6.18 3A1.5 1.5 0 0 1 8.5 4.25Zm3.5 13.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm10-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
]);
const $cdb0ff5c001a8842$export$2ed0277692c788a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4.5 4.5a1.25 1.25 0 1 0 1.5 1.5l3.5 3.5a1.25 1.25 0 1 0 1.5 1.5l7.5 7.5a.75.75 0 0 0 1.06-1.06L3.28 2.22ZM18.25 14c0 .3-.1.57-.28.79l-1.76-1.76a1.25 1.25 0 0 1 2.04.97Zm-5-5c0 .3-.1.57-.28.79l-1.76-1.76a1.25 1.25 0 0 1 2.04.97Zm-5-5c0 .3-.1.58-.28.79L6.21 3.03c.22-.17.5-.28.8-.28.68 0 1.24.56 1.24 1.25ZM12 17.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm10-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm-5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $cdb0ff5c001a8842$export$a63f80c9ad224013 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark20Filled', "20", [
    "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4-8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm.41 1.57a5.5 5.5 0 0 0-1.2 2.15 1.25 1.25 0 0 1 1.2-2.15Zm4.33-1.81a1.25 1.25 0 1 0-1.32.1 5.53 5.53 0 0 1 1.32-.1ZM14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.62-2a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0Zm-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 0 1-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 1 1-1 0Z"
]);
const $cdb0ff5c001a8842$export$addd50f5230d316f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark20Regular', "20", [
    "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a1 1 0 0 1 .23.03 5.5 5.5 0 0 0-.93 1.68A1 1 0 0 1 10 11Zm5-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25Zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95Z"
]);
const $cdb0ff5c001a8842$export$79752ba09487d58d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark24Filled', "24", [
    "M12 2.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm1.5 6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM7 12.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0c.3 0 .58.09.82.24a6.5 6.5 0 0 0-1.53 2.58 1.5 1.5 0 0 1 .71-2.82Zm5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-8.5 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm10-5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM7 2.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-6.12 2.88a.62.62 0 1 1 1.24 0 .62.62 0 0 1-1.24 0Zm-1.23-4.55c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .51-.15.85-.53 1.3l-.13.15-.27.3-.1.1-.08.11c-.18.23-.24.39-.24.6a.5.5 0 1 1-1 0c0-.53.15-.86.53-1.32l.14-.16.27-.29.1-.1.09-.12c.17-.22.22-.37.22-.57 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 1 1-1 0Z"
]);
const $cdb0ff5c001a8842$export$c2a0825d2db73f9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DialpadQuestionMark24Regular', "24", [
    "M12 2.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM13.25 9a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM7 12.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm5 0c.3 0 .57.1.78.28a6.5 6.5 0 0 0-1.33 2.1 1.25 1.25 0 0 1 .55-2.38Zm5-5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM8.25 9a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Zm10-5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM7 2.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm0 7.75a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25Zm0-5.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 0 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.05.35-.22.57l-.1.11-.1.11-.26.3-.14.15c-.38.46-.53.8-.53 1.31a.5.5 0 0 0 1 0c0-.2.06-.36.24-.59l.08-.1.1-.12.27-.29.13-.15c.38-.45.53-.79.53-1.3 0-1.1-.82-1.95-1.85-1.95Z"
]);
const $cdb0ff5c001a8842$export$d0ba88dff23ce453 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond16Filled', "16", [
    "M1.73 6.23a2.5 2.5 0 0 0 0 3.54l4.5 4.5a2.5 2.5 0 0 0 3.54 0l4.5-4.5a2.5 2.5 0 0 0 0-3.54l-4.5-4.5a2.5 2.5 0 0 0-3.54 0l-4.5 4.5Z"
]);
const $cdb0ff5c001a8842$export$fd00e1f210c37de5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond16Regular', "16", [
    "M1.73 9.77a2.5 2.5 0 0 1 0-3.54l4.5-4.5a2.5 2.5 0 0 1 3.54 0l4.5 4.5a2.5 2.5 0 0 1 0 3.54l-4.5 4.5a2.5 2.5 0 0 1-3.54 0l-4.5-4.5Zm.7-2.83a1.5 1.5 0 0 0 0 2.12l4.51 4.5a1.5 1.5 0 0 0 2.12 0l4.5-4.5a1.5 1.5 0 0 0 0-2.12l-4.5-4.5a1.5 1.5 0 0 0-2.12 0l-4.5 4.5Z"
]);
const $cdb0ff5c001a8842$export$68987415441b9598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond20Filled', "20", [
    "M12.12 2.88a3 3 0 0 0-4.24 0l-5 5a3 3 0 0 0 0 4.24l5 5a3 3 0 0 0 4.24 0l5-5a3 3 0 0 0 0-4.24l-5-5Z"
]);
const $cdb0ff5c001a8842$export$7ab72549f2ef4d4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond20Regular', "20", [
    "M7.88 2.88a3 3 0 0 1 4.24 0l5 5a3 3 0 0 1 0 4.24l-5 5a3 3 0 0 1-4.24 0l-5-5a3 3 0 0 1 0-4.24l5-5Zm3.53.7a2 2 0 0 0-2.83 0l-5 5a2 2 0 0 0 0 2.83l5 5a2 2 0 0 0 2.83 0l5-5a2 2 0 0 0 0-2.83l-5-5Z"
]);
const $cdb0ff5c001a8842$export$a4be75541bffd0b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond24Filled', "24", [
    "M2.95 9.7a3.25 3.25 0 0 0 0 4.6l6.75 6.75a3.25 3.25 0 0 0 4.6 0l6.75-6.75a3.25 3.25 0 0 0 0-4.6L14.3 2.95a3.25 3.25 0 0 0-4.6 0L2.95 9.7Z"
]);
const $cdb0ff5c001a8842$export$8c510bc11a7b2fd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond24Regular', "24", [
    "M2.95 14.3a3.25 3.25 0 0 1 0-4.6L9.7 2.95a3.25 3.25 0 0 1 4.6 0l6.75 6.75a3.25 3.25 0 0 1 0 4.6l-6.75 6.75a3.25 3.25 0 0 1-4.6 0L2.95 14.3Zm1.06-3.54c-.68.69-.68 1.8 0 2.48l6.75 6.75c.69.68 1.8.68 2.48 0l6.75-6.75c.68-.69.68-1.8 0-2.48l-6.75-6.75a1.75 1.75 0 0 0-2.48 0l-6.75 6.75Z"
]);
const $cdb0ff5c001a8842$export$8a5503f457e8ee69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond28Filled', "28", [
    "M3.1 11.35a3.75 3.75 0 0 0 0 5.3l8.25 8.25a3.75 3.75 0 0 0 5.3 0l8.25-8.25a3.75 3.75 0 0 0 0-5.3L16.65 3.1a3.75 3.75 0 0 0-5.3 0L3.1 11.35Z"
]);
const $cdb0ff5c001a8842$export$a24551263daabfb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond28Regular', "28", [
    "M3.1 16.65a3.75 3.75 0 0 1 0-5.3l8.25-8.25a3.75 3.75 0 0 1 5.3 0l8.25 8.25a3.75 3.75 0 0 1 0 5.3l-8.25 8.25a3.75 3.75 0 0 1-5.3 0L3.1 16.65Zm1.06-4.24c-.88.88-.88 2.3 0 3.18l8.25 8.25c.88.88 2.3.88 3.18 0l8.25-8.25c.88-.88.88-2.3 0-3.18L15.6 4.16a2.25 2.25 0 0 0-3.18 0L4.16 12.4Z"
]);
const $cdb0ff5c001a8842$export$b96d872f2a40a4c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond32Filled', "32", [
    "M3.32 12.82a4.5 4.5 0 0 0 0 6.36l9.5 9.5a4.5 4.5 0 0 0 6.36 0l9.5-9.5a4.5 4.5 0 0 0 0-6.36l-9.5-9.5a4.5 4.5 0 0 0-6.36 0l-9.5 9.5Z"
]);
const $cdb0ff5c001a8842$export$770b1ea9dd679a19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond32Regular', "32", [
    "M3.32 19.18a4.5 4.5 0 0 1 0-6.36l9.5-9.5a4.5 4.5 0 0 1 6.36 0l9.5 9.5a4.5 4.5 0 0 1 0 6.36l-9.5 9.5a4.5 4.5 0 0 1-6.36 0l-9.5-9.5Zm1.41-4.95a2.5 2.5 0 0 0 0 3.54l9.5 9.5a2.5 2.5 0 0 0 3.54 0l9.5-9.5a2.5 2.5 0 0 0 0-3.54l-9.5-9.5a2.5 2.5 0 0 0-3.54 0l-9.5 9.5Z"
]);
const $cdb0ff5c001a8842$export$2c9ebb3af0d9c309 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond48Filled', "48", [
    "M5.83 19.58a6.25 6.25 0 0 0 0 8.84l13.75 13.75a6.25 6.25 0 0 0 8.84 0l13.75-13.75a6.25 6.25 0 0 0 0-8.84L28.42 5.83a6.25 6.25 0 0 0-8.84 0L5.83 19.58Z"
]);
const $cdb0ff5c001a8842$export$cc0042640c9a646 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Diamond48Regular', "48", [
    "M5.83 28.42a6.25 6.25 0 0 1 0-8.84L19.58 5.83a6.25 6.25 0 0 1 8.84 0l13.75 13.75a6.25 6.25 0 0 1 0 8.84L28.42 42.17a6.25 6.25 0 0 1-8.84 0L5.83 28.42Zm1.77-7.07a3.75 3.75 0 0 0 0 5.3L21.35 40.4a3.75 3.75 0 0 0 5.3 0L40.4 26.65a3.75 3.75 0 0 0 0-5.3L26.65 7.6a3.75 3.75 0 0 0-5.3 0L7.6 21.35Z"
]);
const $cdb0ff5c001a8842$export$170661f7405b6172 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss12Filled', "12", [
    "M4.58 1.58a2 2 0 0 1 2.83 0l3 3a2 2 0 0 1 0 2.83l-3 3a2 2 0 0 1-2.83 0l-3-3a2 2 0 0 1-.14-2.68l.14-.15 3-3Zm3.27 2.57a.5.5 0 0 0-.7 0L6 5.29 4.85 4.15l-.07-.07a.5.5 0 0 0-.7.7l.07.07L5.29 6 4.15 7.15a.5.5 0 0 0 .7.7L6 6.71l1.15 1.14.07.07a.5.5 0 0 0 .7-.7l-.07-.07L6.71 6l1.14-1.15a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$a91795412409208f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss12Regular', "12", [
    "M4.58 1.58a2 2 0 0 1 2.83 0l3 3a2 2 0 0 1 0 2.83l-3 3a2 2 0 0 1-2.83 0l-3-3a2 2 0 0 1-.14-2.68l.14-.15 3-3Zm2.12.7a1 1 0 0 0-1.41 0l-3 3-.07.09a1 1 0 0 0 .07 1.33l3 3a1 1 0 0 0 1.41 0l3-3a1 1 0 0 0 0-1.41l-3-3Zm.2 2.12a.5.5 0 1 1 .7.7l-.9.9.9.9.07.07a.5.5 0 0 1-.7.7L6.9 7.6 6 6.7l-.9.9a.5.5 0 0 1-.7-.7l.9-.9-.9-.9-.07-.07a.5.5 0 0 1 .7-.7l.07.07.9.9.9-.9Z"
]);
const $cdb0ff5c001a8842$export$4268910a0e116ef8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss16Filled', "16", [
    "M6.23 1.23a2.5 2.5 0 0 1 3.54 0l5 5a2.5 2.5 0 0 1 0 3.54l-5 5a2.5 2.5 0 0 1-3.54 0l-5-5a2.5 2.5 0 0 1 0-3.54l5-5Zm4.38 4.17a.5.5 0 0 0-.71 0L8 7.3 6.1 5.4a.5.5 0 0 0-.7.7L7.3 8 5.4 9.9a.5.5 0 0 0 .7.7L8 8.7l1.9 1.9a.5.5 0 0 0 .7-.7L8.7 8l1.9-1.9a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$a9c402885e246512 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss16Regular', "16", [
    "M6.23 1.23a2.5 2.5 0 0 1 3.54 0l5 5a2.5 2.5 0 0 1 0 3.54l-5 5a2.5 2.5 0 0 1-3.54 0l-5-5a2.5 2.5 0 0 1 0-3.54l5-5Zm2.83.7a1.5 1.5 0 0 0-2.12 0l-5 5a1.5 1.5 0 0 0 0 2.13l5 5a1.5 1.5 0 0 0 2.12 0l5-5a1.5 1.5 0 0 0 0-2.12l-5-5ZM9.9 5.4a.5.5 0 1 1 .7.7L8.7 8l1.9 1.9a.5.5 0 0 1-.7.7L8 8.7l-1.9 1.9a.5.5 0 0 1-.7-.7L7.3 8 5.4 6.1a.5.5 0 1 1 .7-.7L8 7.3l1.9-1.9Z"
]);
const $cdb0ff5c001a8842$export$6092703789225435 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss20Filled', "20", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24l6-6ZM13.1 6.9a.5.5 0 0 0-.7 0L10 9.3 7.6 6.9a.5.5 0 0 0-.7.7L9.3 10l-2.4 2.4a.5.5 0 0 0 .7.7l2.4-2.4 2.4 2.4a.5.5 0 0 0 .7-.7L10.7 10l2.4-2.4a.5.5 0 0 0 0-.7Z"
]);
const $cdb0ff5c001a8842$export$5eff2aa96beae8f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss20Regular', "20", [
    "M7.88 1.88a3 3 0 0 1 4.24 0l6 6a3 3 0 0 1 0 4.24l-6 6a3 3 0 0 1-4.24 0l-6-6a3 3 0 0 1 0-4.24l6-6Zm3.53.7a2 2 0 0 0-2.83 0l-6 6a2 2 0 0 0 0 2.83l6 6a2 2 0 0 0 2.83 0l6-6a2 2 0 0 0 0-2.83l-6-6Zm.99 4.32a.5.5 0 1 1 .7.7L10.7 10l2.4 2.4a.5.5 0 0 1-.7.7L10 10.7l-2.4 2.4a.5.5 0 0 1-.7-.7L9.3 10 6.9 7.6a.5.5 0 0 1 .7-.7L10 9.3l2.4-2.4Z"
]);
const $cdb0ff5c001a8842$export$73291f56b0cec2a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss24Filled', "24", [
    "M2.95 14.3a3.25 3.25 0 0 1 0-4.6L9.7 2.95a3.25 3.25 0 0 1 4.6 0l6.75 6.75a3.25 3.25 0 0 1 0 4.6l-6.75 6.75a3.25 3.25 0 0 1-4.6 0L2.95 14.3Zm6.83-5.58a.75.75 0 0 0-1.06 1.06L10.94 12l-2.22 2.22a.75.75 0 1 0 1.06 1.06L12 13.06l2.22 2.22a.75.75 0 1 0 1.06-1.06L13.06 12l2.22-2.22a.75.75 0 0 0-1.06-1.06L12 10.94 9.78 8.72Z"
]);
const $cdb0ff5c001a8842$export$6e6257d096cd22ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss24Regular', "24", [
    "M2.95 9.7a3.25 3.25 0 0 0 0 4.6l6.75 6.75a3.25 3.25 0 0 0 4.6 0l6.75-6.75a3.25 3.25 0 0 0 0-4.6L14.3 2.95a3.25 3.25 0 0 0-4.6 0L2.95 9.7Zm1.06 3.54a1.75 1.75 0 0 1 0-2.48l6.75-6.75c.69-.68 1.8-.68 2.48 0l6.75 6.75c.68.69.68 1.8 0 2.48l-6.75 6.75c-.69.68-1.8.68-2.48 0l-6.75-6.75Zm5.77-4.52a.75.75 0 0 0-1.06 1.06L10.94 12l-2.22 2.22a.75.75 0 1 0 1.06 1.06L12 13.06l2.22 2.22a.75.75 0 1 0 1.06-1.06L13.06 12l2.22-2.22a.75.75 0 0 0-1.06-1.06L12 10.94 9.78 8.72Z"
]);
const $cdb0ff5c001a8842$export$b4601eccd62510a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss28Filled', "28", [
    "M3.1 16.65a3.75 3.75 0 0 1 0-5.3l8.25-8.25a3.75 3.75 0 0 1 5.3 0l8.25 8.25a3.75 3.75 0 0 1 0 5.3l-8.25 8.25a3.75 3.75 0 0 1-5.3 0L3.1 16.65Zm7.68-6.93a.75.75 0 1 0-1.06 1.06L12.94 14l-3.22 3.22a.75.75 0 1 0 1.06 1.06L14 15.06l3.22 3.22a.75.75 0 1 0 1.06-1.06L15.06 14l3.22-3.22a.75.75 0 1 0-1.06-1.06L14 12.94l-3.22-3.22Z"
]);
const $cdb0ff5c001a8842$export$b282ccf6151fd322 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss28Regular', "28", [
    "M3.1 11.35a3.75 3.75 0 0 0 0 5.3l8.25 8.25a3.75 3.75 0 0 0 5.3 0l8.25-8.25a3.75 3.75 0 0 0 0-5.3L16.65 3.1a3.75 3.75 0 0 0-5.3 0L3.1 11.35Zm1.06 4.24a2.25 2.25 0 0 1 0-3.18l8.25-8.25c.88-.88 2.3-.88 3.18 0l8.25 8.25c.88.88.88 2.3 0 3.18l-8.25 8.25c-.88.88-2.3.88-3.18 0L4.16 15.6Zm6.62-5.87a.75.75 0 1 0-1.06 1.06L12.94 14l-3.22 3.22a.75.75 0 1 0 1.06 1.06L14 15.06l3.22 3.22a.75.75 0 1 0 1.06-1.06L15.06 14l3.22-3.22a.75.75 0 1 0-1.06-1.06L14 12.94l-3.22-3.22Z"
]);
const $cdb0ff5c001a8842$export$1722697d3b3609c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss32Filled', "32", [
    "M3.32 19.18a4.5 4.5 0 0 1 0-6.36l9.5-9.5a4.5 4.5 0 0 1 6.36 0l9.5 9.5a4.5 4.5 0 0 1 0 6.36l-9.5 9.5a4.5 4.5 0 0 1-6.36 0l-9.5-9.5Zm9.39-7.89a1 1 0 0 0-1.42 1.42L14.6 16l-3.3 3.3a1 1 0 0 0 1.42 1.4L16 17.42l3.3 3.3a1 1 0 0 0 1.4-1.42L17.42 16l3.3-3.3a1 1 0 0 0-1.42-1.4L16 14.58l-3.3-3.3Z"
]);
const $cdb0ff5c001a8842$export$52eef6c15ff013a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss32Regular', "32", [
    "M3.32 12.82a4.5 4.5 0 0 0 0 6.36l9.5 9.5a4.5 4.5 0 0 0 6.36 0l9.5-9.5a4.5 4.5 0 0 0 0-6.36l-9.5-9.5a4.5 4.5 0 0 0-6.36 0l-9.5 9.5Zm1.41 4.95a2.5 2.5 0 0 1 0-3.54l9.5-9.5a2.5 2.5 0 0 1 3.54 0l9.5 9.5a2.5 2.5 0 0 1 0 3.54l-9.5 9.5a2.5 2.5 0 0 1-3.54 0l-9.5-9.5Zm7.98-6.48a1 1 0 0 0-1.42 1.42L14.6 16l-3.3 3.3a1 1 0 0 0 1.42 1.4L16 17.42l3.3 3.3a1 1 0 0 0 1.4-1.42L17.42 16l3.3-3.3a1 1 0 0 0-1.42-1.4L16 14.58l-3.3-3.3Z"
]);
const $cdb0ff5c001a8842$export$acc758acc25613dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss48Filled', "48", [
    "M5.83 28.42a6.25 6.25 0 0 1 0-8.84L19.58 5.83a6.25 6.25 0 0 1 8.84 0l13.75 13.75a6.25 6.25 0 0 1 0 8.84L28.42 42.17a6.25 6.25 0 0 1-8.84 0L5.83 28.42Zm13.3-11.05a1.25 1.25 0 0 0-1.76 1.76L22.23 24l-4.86 4.87a1.25 1.25 0 0 0 1.76 1.76L24 25.77l4.87 4.86a1.25 1.25 0 0 0 1.76-1.76L25.77 24l4.86-4.87a1.25 1.25 0 0 0-1.76-1.76L24 22.23l-4.87-4.86Z"
]);
const $cdb0ff5c001a8842$export$544d292f7a6e87c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondDismiss48Regular', "48", [
    "M5.83 19.58a6.25 6.25 0 0 0 0 8.84l13.75 13.75a6.25 6.25 0 0 0 8.84 0l13.75-13.75a6.25 6.25 0 0 0 0-8.84L28.42 5.83a6.25 6.25 0 0 0-8.84 0L5.83 19.58Zm1.77 7.07a3.75 3.75 0 0 1 0-5.3L21.35 7.6a3.75 3.75 0 0 1 5.3 0L40.4 21.35a3.75 3.75 0 0 1 0 5.3L26.65 40.4a3.75 3.75 0 0 1-5.3 0L7.6 26.65Zm11.53-9.28a1.25 1.25 0 0 0-1.76 1.76L22.23 24l-4.86 4.87a1.25 1.25 0 0 0 1.76 1.76L24 25.77l4.87 4.86a1.25 1.25 0 0 0 1.76-1.76L25.77 24l4.86-4.87a1.25 1.25 0 0 0-1.76-1.76L24 22.23l-4.87-4.86Z"
]);
const $cdb0ff5c001a8842$export$7b073d1be7705e9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink16Filled', "16", [
    "M7.38 4.36a5.54 5.54 0 0 1 2.96 9.12l-.2.2-.72.74a2 2 0 0 1-2.83 0l-5-5a2 2 0 0 1 0-2.83l.73-.73c.31-.32.66-.59 1.03-.81A6.57 6.57 0 0 0 3.29 7l-.64.64a.5.5 0 0 0 0 .7l5 5c.2.2.51.2.7 0l.74-.72.14-.16a4.04 4.04 0 0 0-2.45-6.7c.07-.5.27-.99.6-1.41ZM6.6 1.59a2 2 0 0 1 2.83 0l5 5a2 2 0 0 1 0 2.82l-.73.73c-.32.32-.67.59-1.03.81.12-.64.13-1.3.06-1.96l.64-.64a.5.5 0 0 0 0-.7l-5-5a.5.5 0 0 0-.7 0l-.74.73a4.03 4.03 0 0 0 2.3 6.85c-.07.5-.27 1-.6 1.41a5.54 5.54 0 0 1-2.76-9.33l.73-.72Z"
]);
const $cdb0ff5c001a8842$export$ea81dc8db1170627 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink16Regular', "16", [
    "M6.82 4.28a5.54 5.54 0 0 1 3.31 9.42l-.72.72a2 2 0 0 1-2.82 0l-5-5a2 2 0 0 1 0-2.83l.71-.72c.33-.32.68-.6 1.05-.82-.08.43-.11.87-.1 1.3L3 6.59l-.72.71a1 1 0 0 0 0 1.42l5 5a1 1 0 0 0 1.42 0l.71-.72a4.54 4.54 0 0 0-3.04-7.74c.1-.34.24-.66.44-.97Zm-.23-2.7a2 2 0 0 1 2.83 0l5 5a2 2 0 0 1 0 2.83l-.72.72c-.33.33-.68.6-1.05.82.08-.43.11-.87.1-1.3l.24-.22.72-.72a1 1 0 0 0 0-1.42l-5-5a1 1 0 0 0-1.42 0l-.72.72a4.54 4.54 0 0 0 3.05 7.74c-.1.34-.24.67-.44.97A5.54 5.54 0 0 1 5.87 2.3l.72-.71Z"
]);
const $cdb0ff5c001a8842$export$5b79ea4154f75cd2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink20Filled', "20", [
    "M8.66 5.43a6.75 6.75 0 0 1 4 11.47h-.01l-.89.88a2.5 2.5 0 0 1-3.53 0l-6-6a2.5 2.5 0 0 1 0-3.55l.88-.88c.44-.43.93-.8 1.44-1.1-.14.65-.2 1.31-.17 1.96l-.2.2-.9.89a1 1 0 0 0 0 1.41l6.01 6a1 1 0 0 0 1.41 0l.89-.88a5.25 5.25 0 0 0-3.6-8.95c.13-.51.35-1 .67-1.45Zm-.43-3.2a2.5 2.5 0 0 1 3.53 0l6 6a2.5 2.5 0 0 1 .01 3.54l-.88.88c-.44.44-.92.8-1.44 1.1.14-.65.2-1.3.17-1.96l.2-.2.89-.88a1 1 0 0 0 0-1.41l-6-6a1 1 0 0 0-1.42 0l-.88.87a5.25 5.25 0 0 0 3.6 8.95c-.13.52-.35 1.01-.67 1.46A6.75 6.75 0 0 1 7.35 3.11l.88-.87Z"
]);
const $cdb0ff5c001a8842$export$424cd85b2b6dbff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink20Regular', "20", [
    "M8.07 5.47a6.75 6.75 0 0 1 4.5 11.5l-.8.8a2.5 2.5 0 0 1-3.54 0l-6-6a2.5 2.5 0 0 1 0-3.54l.8-.8a6.75 6.75 0 0 1 1.59-1.17c-.09.41-.14.84-.15 1.26-.26.19-.5.4-.74.63l-.8.79a1.5 1.5 0 0 0 0 2.12l6.01 6a1.5 1.5 0 0 0 2.12 0l.8-.79.2-.21a5.75 5.75 0 0 0-4.4-9.6c.1-.34.23-.67.4-.99Zm.16-3.24a2.5 2.5 0 0 1 3.54 0l6 6a2.5 2.5 0 0 1 0 3.54l-.8.8c-.47.47-1.01.87-1.59 1.17.09-.41.14-.84.15-1.26.26-.19.5-.4.74-.63l.8-.79a1.5 1.5 0 0 0 0-2.12l-6.01-6a1.5 1.5 0 0 0-2.12 0l-.8.79a5.75 5.75 0 0 0 4.21 9.8c-.1.35-.24.68-.42 1a6.75 6.75 0 0 1-4.5-11.5l.8-.8Z"
]);
const $cdb0ff5c001a8842$export$87a32f3137469b2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink24Filled', "24", [
    "M10.23 6.27a8.38 8.38 0 0 1 5.09 14.25l-1.03 1.03a3.25 3.25 0 0 1-4.6 0L2.46 14.3a3.25 3.25 0 0 1 0-4.6l1.02-1.02c.61-.61 1.3-1.1 2.02-1.49-.2.84-.28 1.71-.25 2.58-.12.1-.24.21-.35.33L3.85 11.1a1.25 1.25 0 0 0 0 1.77l7.25 7.25c.49.49 1.28.49 1.77 0l1.02-1.02A6.38 6.38 0 0 0 9.36 8.23c.15-.7.44-1.36.87-1.96ZM9.7 2.45a3.25 3.25 0 0 1 4.6 0l7.24 7.25a3.25 3.25 0 0 1 0 4.6l-1 1v.01c-.62.61-1.3 1.1-2.03 1.5.2-.85.29-1.72.25-2.59l.36-.32 1-1.02c.5-.48.5-1.28 0-1.76l-7.24-7.25a1.25 1.25 0 0 0-1.77 0l-1 1a6.38 6.38 0 0 0 4.53 10.9c-.15.68-.44 1.35-.87 1.95A8.38 8.38 0 0 1 8.68 3.47L9.7 2.45Z"
]);
const $cdb0ff5c001a8842$export$45cfc9ff1a1c1a2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink24Regular', "24", [
    "M9.63 6.33a8.38 8.38 0 0 1 5.6 14.29l-.93.93a3.25 3.25 0 0 1-4.6 0L2.45 14.3a3.25 3.25 0 0 1 0-4.6l.93-.93A8.36 8.36 0 0 1 5.56 7.2a9.41 9.41 0 0 0-.23 1.89c-.31.22-.61.47-.89.74l-.93.93c-.68.69-.68 1.8 0 2.48l7.25 7.25c.68.68 1.8.68 2.48 0l.92-.93A6.88 6.88 0 0 0 9.01 7.83c.13-.52.34-1.03.62-1.5Zm.07-3.88a3.25 3.25 0 0 1 4.6 0l7.24 7.25a3.25 3.25 0 0 1 0 4.6l-.93.93a8.36 8.36 0 0 1-2.17 1.56c.14-.62.22-1.25.24-1.88.3-.22.6-.47.87-.74l.93-.93c.69-.69.69-1.8 0-2.48l-7.24-7.25a1.75 1.75 0 0 0-2.48 0l-.93.93a6.88 6.88 0 0 0 5.16 11.73 5.84 5.84 0 0 1-.62 1.5 8.38 8.38 0 0 1-5.6-14.29l.93-.93Z"
]);
const $cdb0ff5c001a8842$export$3ac8ec1b88b8f941 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink28Filled', "28", [
    "M11.46 7.46a9.59 9.59 0 0 1 6.28 16.35l-1.09 1.1a3.75 3.75 0 0 1-5.3 0L3.1 16.64a3.75 3.75 0 0 1 0-5.3l1.08-1.09a9.57 9.57 0 0 1 2.58-1.84c-.2.83-.3 1.67-.3 2.52-.3.22-.6.46-.86.73l-1.09 1.1c-.68.68-.68 1.79 0 2.47l8.25 8.25c.69.68 1.8.68 2.48 0l1.09-1.09a7.59 7.59 0 0 0-5.7-12.94c.16-.7.44-1.37.83-2Zm-.1-4.36a3.75 3.75 0 0 1 5.3 0l8.24 8.25a3.75 3.75 0 0 1 0 5.3l-1.09 1.1a9.57 9.57 0 0 1-2.57 1.83c.2-.82.3-1.67.3-2.52.3-.22.59-.46.86-.73l1.09-1.1c.68-.67.68-1.78 0-2.47l-8.25-8.25a1.75 1.75 0 0 0-2.48 0l-1.09 1.1a7.59 7.59 0 0 0 5.7 12.93c-.16.7-.44 1.37-.83 2a9.59 9.59 0 0 1-6.28-16.35l1.1-1.1Z"
]);
const $cdb0ff5c001a8842$export$dd864622f5e3cb6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink28Regular', "28", [
    "M10.87 7.54a9.58 9.58 0 0 1 6.78 16.36l-1 1a3.75 3.75 0 0 1-5.3 0L3.1 16.65a3.75 3.75 0 0 1 0-5.3l1-1a9.57 9.57 0 0 1 2.72-1.91c-.14.6-.23 1.23-.27 1.85-.49.32-.96.69-1.4 1.12l-1 1c-.87.88-.87 2.3 0 3.18l8.26 8.25c.88.88 2.3.88 3.18 0l1-1a8.08 8.08 0 0 0-6.32-13.78c.14-.52.34-1.03.6-1.52Zm.48-4.44a3.75 3.75 0 0 1 5.3 0l8.25 8.25a3.75 3.75 0 0 1 0 5.3l-1 1a9.57 9.57 0 0 1-2.73 1.92c.15-.61.24-1.24.27-1.86.5-.31.97-.68 1.4-1.11l1-1c.88-.89.88-2.31 0-3.19L15.6 4.16a2.25 2.25 0 0 0-3.18 0l-1 1a8.09 8.09 0 0 0 6.31 13.78 7.05 7.05 0 0 1-.6 1.52A9.59 9.59 0 0 1 10.35 4.1l1-1Z"
]);
const $cdb0ff5c001a8842$export$80fb57c47d2f7f52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink32Filled', "32", [
    "M13.6 8.36a11.22 11.22 0 0 1 7.22 18.68l-.4.42-1.24 1.23a4.5 4.5 0 0 1-6.36 0l-9.5-9.5a4.5 4.5 0 0 1 0-6.37l1.22-1.23c.79-.78 1.66-1.42 2.58-1.93a12.78 12.78 0 0 0-.3 3.23c-.18.15-.35.3-.5.47l-1.23 1.23a2 2 0 0 0 0 2.82l9.5 9.5a2 2 0 0 0 2.83 0l1.22-1.22A8.72 8.72 0 0 0 12.5 10.8c.2-.86.57-1.69 1.1-2.44Zm-.78-5.05a4.5 4.5 0 0 1 6.36 0l9.5 9.5a4.5 4.5 0 0 1 0 6.37l-1.22 1.23c-.78.78-1.65 1.42-2.58 1.92.24-1.06.34-2.14.3-3.23.18-.14.35-.3.51-.46l1.22-1.22a2 2 0 0 0 0-2.83l-9.5-9.5a2 2 0 0 0-2.83 0L13.36 6.3a8.72 8.72 0 0 0 6.14 14.88c-.2.86-.57 1.7-1.1 2.45a11.22 11.22 0 0 1-6.82-19.1l1.24-1.23Z"
]);
const $cdb0ff5c001a8842$export$5f9945537103e661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink32Regular', "32", [
    "M13 8.41a11.22 11.22 0 0 1 7.72 18.72l-.4.42-1.14 1.13a4.5 4.5 0 0 1-6.36 0l-9.5-9.5a4.5 4.5 0 0 1 0-6.36l1.13-1.14c.83-.83 1.75-1.5 2.74-2.01-.18.83-.28 1.69-.3 2.54-.35.26-.7.56-1.02.89l-1.14 1.13a2.5 2.5 0 0 0 0 3.54l9.5 9.5a2.5 2.5 0 0 0 3.54 0l1.14-1.14a9.22 9.22 0 0 0-6.76-15.73c.19-.7.47-1.36.84-1.99Zm-.18-5.1a4.5 4.5 0 0 1 6.36 0l9.5 9.5a4.5 4.5 0 0 1 0 6.37l-1.13 1.14c-.83.83-1.75 1.5-2.74 2.01.18-.83.28-1.68.3-2.53.35-.27.7-.57 1.02-.9l1.14-1.13a2.5 2.5 0 0 0 0-3.54l-9.5-9.5a2.5 2.5 0 0 0-3.54 0L13.1 5.87a9.22 9.22 0 0 0 6.76 15.73A7.67 7.67 0 0 1 19 23.6a11.22 11.22 0 0 1-7.33-19.14l1.14-1.14Z"
]);
const $cdb0ff5c001a8842$export$477b789cba460b07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink48Filled', "48", [
    "M19.75 13.17a15.98 15.98 0 0 1 10.72 26.95l-.3.3-1.75 1.75a6.25 6.25 0 0 1-8.84 0L5.83 28.42a6.25 6.25 0 0 1 0-8.84l1.76-1.76c1.2-1.2 2.55-2.18 4-2.92a18.05 18.05 0 0 0-.45 3.8c-.5.38-.98.79-1.43 1.24L7.95 21.7a3.25 3.25 0 0 0 0 4.6L21.7 40.05a3.25 3.25 0 0 0 4.6 0l1.76-1.76a12.98 12.98 0 0 0-9.57-22.14 10.9 10.9 0 0 1 1.26-2.98Zm-.17-7.34a6.25 6.25 0 0 1 8.84 0l13.75 13.75a6.25 6.25 0 0 1 0 8.84l-1.76 1.76a15.96 15.96 0 0 1-4 2.92c.28-1.25.43-2.53.44-3.8.5-.37.99-.79 1.44-1.24l1.76-1.76a3.25 3.25 0 0 0 0-4.6L26.3 7.95a3.25 3.25 0 0 0-4.6 0l-1.76 1.76a12.97 12.97 0 0 0 9.57 22.14 10.9 10.9 0 0 1-1.26 2.98A15.98 15.98 0 0 1 17.82 7.58l1.76-1.75Z"
]);
const $cdb0ff5c001a8842$export$5c36d06458439cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DiamondLink48Regular', "48", [
    "M19.17 13.23A15.98 15.98 0 0 1 30.09 40.5l-1.67 1.67a6.25 6.25 0 0 1-8.84 0L5.83 28.42a6.25 6.25 0 0 1 0-8.84l1.67-1.67a15.96 15.96 0 0 1 4.15-3 18.04 18.04 0 0 0-.4 3.13c-.7.47-1.37 1.02-1.99 1.64L7.6 21.35a3.75 3.75 0 0 0 0 5.3l13.76 13.76a3.75 3.75 0 0 0 5.3 0l1.67-1.68.24-.25a13.48 13.48 0 0 0-10.42-22.73c.24-.87.58-1.71 1.03-2.52Zm.41-7.4a6.25 6.25 0 0 1 8.84 0l13.75 13.75a6.25 6.25 0 0 1 0 8.84l-1.67 1.67a15.95 15.95 0 0 1-4.15 3c.23-1.03.36-2.08.4-3.13.7-.48 1.37-1.02 1.99-1.64l1.67-1.67a3.75 3.75 0 0 0 0-5.3L26.65 7.6a3.75 3.75 0 0 0-5.3 0l-1.67 1.67a13.47 13.47 0 0 0 10.18 22.98 11.4 11.4 0 0 1-1.02 2.51A15.98 15.98 0 0 1 17.92 7.5l1.66-1.66Z"
]);
const $cdb0ff5c001a8842$export$3ab8df74a84ca8db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v2h14V6a3 3 0 0 0-3-3H6Zm8 14H6.91a1.5 1.5 0 0 0-.91-.91v-1.43a3.5 3.5 0 0 0 2-3.16v-2c0-.17-.03-.34-.09-.5H17v5a3 3 0 0 1-3 3ZM6.75 6.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM10 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5h-4Z"
]);
const $cdb0ff5c001a8842$export$4ac6eb83d7570036 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v2h13v6a2 2 0 0 1-2 2H6v.09c.43.15.76.48.91.91H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm10 3v1H4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2Zm-8.5-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.5 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5h-4Z"
]);
const $cdb0ff5c001a8842$export$8ec71be7e5761292 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25V9H3V6.25Zm5.99 4.26-.02-.01H21v7.25c0 1.8-1.46 3.25-3.25 3.25H8.48A1.75 1.75 0 0 0 7 19.52v-1.9a4.25 4.25 0 0 0 2.5-3.87v-2c0-.46-.18-.9-.51-1.24ZM9 6.25a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3.75-.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Zm-10 5.5a.75.75 0 0 0-.75.75v2a3.25 3.25 0 0 0 2.5 3.16v3.59h-.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H6v-3.59a3.25 3.25 0 0 0 2.5-3.16v-2a.75.75 0 0 0-.75-.75h-5Z"
]);
const $cdb0ff5c001a8842$export$c875a5cfc9ea062f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25V10h1.5v-.5h15v8.25c0 .97-.78 1.75-1.75 1.75H7v.02c.77.1 1.37.71 1.48 1.48h9.27c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25ZM19.5 8h-15V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75V8ZM9 6.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.75-.75a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5ZM2 11.75c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75v2A3.25 3.25 0 0 1 6 16.91v3.59h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-3.59A3.25 3.25 0 0 1 2 13.75v-2Z"
]);
const $cdb0ff5c001a8842$export$ee7d0f8c274dcc3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher32Filled', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5V12H3V7.5Zm8.77 6.73a2.51 2.51 0 0 0-.27-.23H29v10.5a4.5 4.5 0 0 1-4.5 4.5h-14A2.5 2.5 0 0 0 9 26.7v-2a6 6 0 0 0 3.5-5.45V16c0-.66-.26-1.3-.73-1.77ZM11.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM17 7a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5ZM3 15a1 1 0 0 0-1 1v3.25a4.5 4.5 0 0 0 3.5 4.39V28H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-.5v-4.36a4.5 4.5 0 0 0 3.5-4.39V16a1 1 0 0 0-1-1H3Z"
]);
const $cdb0ff5c001a8842$export$3325fc91d4cbfad3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher32Regular', "32", [
    "M3 7.5A4.5 4.5 0 0 1 7.5 3h17A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-14c0-.82-.4-1.54-1-2h15a2.5 2.5 0 0 0 2.5-2.5V13H5v.5H3v-6Zm24 0A2.5 2.5 0 0 0 24.5 5h-17A2.5 2.5 0 0 0 5 7.5V11h22V7.5ZM11.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 8a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1ZM3 15a1 1 0 0 0-1 1v3.25a4.5 4.5 0 0 0 3.5 4.39V28H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-.5v-4.36a4.5 4.5 0 0 0 3.5-4.39V16a1 1 0 0 0-1-1H3Z"
]);
const $cdb0ff5c001a8842$export$f32afe9607e8285f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher48Filled', "48", [
    "M12 6a6 6 0 0 0-6 6v5.5h36V12a6 6 0 0 0-6-6H12Zm30 14H16.25a3.25 3.25 0 0 1 3.25 3.25v5a8.75 8.75 0 0 1-5.5 8.13v3.2A3.25 3.25 0 0 1 16.41 42H36a6 6 0 0 0 6-6V20Zm-24-7.75a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM25.25 11h7.5a1.25 1.25 0 1 1 0 2.5h-7.5a1.25 1.25 0 1 1 0-2.5Zm-20 11C4.56 22 4 22.56 4 23.25v5c0 3.3 2.37 6.05 5.5 6.63v6.62H8.25a1.25 1.25 0 1 0 0 2.5h5a1.25 1.25 0 1 0 0-2.5H12v-6.62a6.75 6.75 0 0 0 5.5-6.63v-5c0-.69-.56-1.25-1.25-1.25h-11Z"
]);
const $cdb0ff5c001a8842$export$51d983a86a15639a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dishwasher48Regular', "48", [
    "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42H16.41A3.25 3.25 0 0 0 14 39.59v-.09h21.75a3.75 3.75 0 0 0 3.75-3.75V18.5h-31V20H6v-7.75Zm33.5 0a3.75 3.75 0 0 0-3.75-3.75h-23.5a3.75 3.75 0 0 0-3.75 3.75V16h31v-3.75Zm-21.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm6 0c0-.69.56-1.25 1.25-1.25h7.5a1.25 1.25 0 1 1 0 2.5h-7.5c-.69 0-1.25-.56-1.25-1.25ZM5.25 22C4.56 22 4 22.56 4 23.25v5c0 3.3 2.37 6.05 5.5 6.63v6.62H8.25a1.25 1.25 0 1 0 0 2.5h5a1.25 1.25 0 1 0 0-2.5H12v-6.62a6.75 6.75 0 0 0 5.5-6.63v-5c0-.69-.56-1.25-1.25-1.25h-11Z"
]);
const $cdb0ff5c001a8842$export$f4344078770ebe25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss12Filled', "12", [
    "m1.9 2.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L6 4.94l2.97-2.97a.75.75 0 1 1 1.06 1.06L7.06 6l2.97 2.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L6 7.06l-2.97 2.97a.75.75 0 1 1-1.06-1.06L4.94 6 1.97 3.03a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"
]);
const $cdb0ff5c001a8842$export$ff76805637bbf529 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss12Regular', "12", [
    "m2.09 2.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L6 5.29l3.15-3.14a.5.5 0 1 1 .7.7L6.71 6l3.14 3.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L6 6.71 2.85 9.85a.5.5 0 0 1-.7-.7L5.29 6 2.15 2.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"
]);
const $cdb0ff5c001a8842$export$fe3a08578d7b9af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss16Filled', "16", [
    "m2.4 2.55.07-.08a.75.75 0 0 1 .98-.07l.08.07L8 6.94l4.47-4.47a.75.75 0 1 1 1.06 1.06L9.06 8l4.47 4.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L8 9.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06L6.94 8 2.47 3.53a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"
]);
const $cdb0ff5c001a8842$export$6b9f0f6797d2b702 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss16Regular', "16", [
    "m2.59 2.72.06-.07a.5.5 0 0 1 .63-.06l.07.06L8 7.29l4.65-4.64a.5.5 0 0 1 .7.7L8.71 8l4.64 4.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L8 8.71l-4.65 4.64a.5.5 0 0 1-.7-.7L7.29 8 2.65 3.35a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"
]);
const $cdb0ff5c001a8842$export$fb9faba164c82835 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss20Filled', "20", [
    "m3.9 4.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L10 8.94l4.97-4.97a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08L11.06 10l4.97 4.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L10 11.06l-4.97 4.97a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L8.94 10 3.97 5.03a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"
]);
const $cdb0ff5c001a8842$export$5b53e1eb03c72ac3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss20Regular', "20", [
    "m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"
]);
const $cdb0ff5c001a8842$export$15b5f0a44e7ae60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss24Filled', "24", [
    "m4.21 4.39.08-.1a1 1 0 0 1 1.32-.08l.1.08L12 10.6l6.3-6.3a1 1 0 1 1 1.4 1.42L13.42 12l6.3 6.3a1 1 0 0 1 .08 1.31l-.08.1a1 1 0 0 1-1.32.08l-.1-.08L12 13.4l-6.3 6.3a1 1 0 0 1-1.4-1.42L10.58 12l-6.3-6.3a1 1 0 0 1-.08-1.31l.08-.1-.08.1Z"
]);
const $cdb0ff5c001a8842$export$209e755d5656d93f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss24Regular', "24", [
    "m4.4 4.55.07-.08a.75.75 0 0 1 .98-.07l.08.07L12 10.94l6.47-6.47a.75.75 0 1 1 1.06 1.06L13.06 12l6.47 6.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L12 13.06l-6.47 6.47a.75.75 0 0 1-1.06-1.06L10.94 12 4.47 5.53a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z"
]);
const $cdb0ff5c001a8842$export$84e4c4a0298f9a53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss28Filled', "28", [
    "M22.3 4.3a1 1 0 1 1 1.4 1.4L15.42 14l8.3 8.3a1 1 0 0 1-1.42 1.4L14 15.42l-8.3 8.3a1 1 0 0 1-1.4-1.42L12.58 14l-8.3-8.3a1 1 0 0 1 1.42-1.4L14 12.58l8.3-8.3Z"
]);
const $cdb0ff5c001a8842$export$87fa4a8a433c5a73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss28Regular', "28", [
    "M22.47 4.47a.75.75 0 1 1 1.06 1.06L15.06 14l8.47 8.47a.75.75 0 1 1-1.06 1.06L14 15.06l-8.47 8.47a.75.75 0 0 1-1.06-1.06L12.94 14 4.47 5.53a.75.75 0 0 1 1.06-1.06L14 12.94l8.47-8.47Z"
]);
const $cdb0ff5c001a8842$export$5f08da71c69d66e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss32Filled', "32", [
    "M26.11 4.12a1.25 1.25 0 0 1 1.77 1.76L17.77 16 27.88 26.1a1.25 1.25 0 1 1-1.77 1.77L16 17.77 5.88 27.88a1.25 1.25 0 1 1-1.76-1.77L14.23 16 4.12 5.88a1.25 1.25 0 1 1 1.76-1.76L16 14.23 26.1 4.12Z"
]);
const $cdb0ff5c001a8842$export$48d099711b16a532 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss32Light', "32", [
    "M27.85 4.85a.5.5 0 0 0-.7-.7L16 15.29 4.85 4.15a.5.5 0 1 0-.7.7L15.29 16 4.15 27.15a.5.5 0 0 0 .7.7L16 16.71l11.15 11.14a.5.5 0 0 0 .7-.7L16.71 16 27.85 4.85Z"
]);
const $cdb0ff5c001a8842$export$2997120479b965ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss32Regular', "32", [
    "M26.29 4.3a1 1 0 1 1 1.41 1.4L17.41 16l10.3 10.29a1 1 0 1 1-1.42 1.41l-10.3-10.29-10.28 10.3a1 1 0 0 1-1.42-1.42l10.3-10.3L4.28 5.72a1 1 0 0 1 1.42-1.42L16 14.6l10.29-10.3Z"
]);
const $cdb0ff5c001a8842$export$68289010717b7708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss48Filled', "48", [
    "M8.56 6.44a1.5 1.5 0 1 0-2.12 2.12L21.88 24 6.44 39.44a1.5 1.5 0 1 0 2.12 2.12L24 26.12l15.44 15.44a1.5 1.5 0 1 0 2.12-2.12L26.12 24 41.56 8.56a1.5 1.5 0 1 0-2.12-2.12L24 21.88 8.56 6.44Z"
]);
const $cdb0ff5c001a8842$export$38d273f1c35ccb6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Dismiss48Regular', "48", [
    "M8.38 6.62a1.25 1.25 0 1 0-1.76 1.76L22.23 24 6.62 39.62a1.25 1.25 0 0 0 1.76 1.76L24 25.77l15.62 15.61a1.25 1.25 0 1 0 1.76-1.76L25.77 24 41.38 8.38a1.25 1.25 0 1 0-1.76-1.76L24 22.23 8.38 6.62Z"
]);
const $cdb0ff5c001a8842$export$b5d2fd2fcfbf9313 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle12Filled', "12", [
    "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Zm1.85-6.85c.2.2.2.5 0 .7L6.71 6l1.14 1.15a.5.5 0 1 1-.7.7L6 6.71 4.85 7.85a.5.5 0 1 1-.7-.7L5.29 6 4.15 4.85a.5.5 0 1 1 .7-.7L6 5.29l1.15-1.14c.2-.2.5-.2.7 0Z"
]);
const $cdb0ff5c001a8842$export$4e77e8175961a747 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle12Regular', "12", [
    "M7.85 4.15c.2.2.2.5 0 .7L6.71 6l1.14 1.15a.5.5 0 1 1-.7.7L6 6.71 4.85 7.85a.5.5 0 1 1-.7-.7L5.29 6 4.15 4.85a.5.5 0 1 1 .7-.7L6 5.29l1.15-1.14c.2-.2.5-.2.7 0ZM6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
]);
const $cdb0ff5c001a8842$export$a01098c8897dd9b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle16Color', "16", `<path d="M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Z" fill="url(#ic_fluent_dismiss_circle_16_color__a)"/><path d="M5.9 5.9a.5.5 0 0 1 .63-.06l.07.06L8 7.3l1.4-1.4a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L8.7 8l1.4 1.4c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L8 8.7l-1.4 1.4a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L7.3 8 5.9 6.6a.5.5 0 0 1-.06-.63l.06-.07Z" fill="url(#ic_fluent_dismiss_circle_16_color__b)"/><defs><linearGradient id="ic_fluent_dismiss_circle_16_color__a" x1="3.88" y1="2.75" x2="13" y2="16" gradientUnits="userSpaceOnUse"><stop stop-color="#F83F54"/><stop offset="1" stop-color="#CA2134"/></linearGradient><linearGradient id="ic_fluent_dismiss_circle_16_color__b" x1="6.01" y1="8.2" x2="8.35" y2="10.64" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#FECBE6"/></linearGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$81af4b7599e01e26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle16Filled', "16", [
    "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM6.35 5.65 8 7.29l1.65-1.64a.5.5 0 0 1 .7.7L8.71 8l1.64 1.65a.5.5 0 0 1-.7.7L8 8.71l-1.65 1.64a.5.5 0 0 1-.7-.7L7.29 8 5.65 6.35a.5.5 0 1 1 .7-.7Z"
]);
const $cdb0ff5c001a8842$export$8dc1b859c30ab69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM6.35 5.65a.5.5 0 1 0-.7.7L7.29 8 5.65 9.65a.5.5 0 0 0 .7.7L8 8.71l1.65 1.64a.5.5 0 0 0 .7-.7L8.71 8l1.64-1.65a.5.5 0 0 0-.7-.7L8 7.29 6.35 5.65Z"
]);
const $cdb0ff5c001a8842$export$24014d37cf5ea207 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle20Color', "20", `<path d="M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Z" fill="url(#ic_fluent_dismiss_circle_20_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7Z" fill="url(#ic_fluent_dismiss_circle_20_color__b)"/><defs><linearGradient id="ic_fluent_dismiss_circle_20_color__a" x1="4.5" y1="3" x2="15" y2="18.5" gradientUnits="userSpaceOnUse"><stop stop-color="#F83F54"/><stop offset="1" stop-color="#CA2134"/></linearGradient><linearGradient id="ic_fluent_dismiss_circle_20_color__b" x1="7.35" y1="10.27" x2="10.47" y2="13.51" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#FECBE6"/></linearGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$b0e095d81813923 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM7.8 7.11a.5.5 0 0 0-.63.06l-.06.07a.5.5 0 0 0 .06.64L9.3 10l-2.12 2.12-.06.07a.5.5 0 0 0 .06.64l.07.06c.2.13.47.11.64-.06L10 10.7l2.12 2.12.07.06c.2.13.46.11.64-.06l.06-.07a.5.5 0 0 0-.06-.64L10.7 10l2.12-2.12.06-.07a.5.5 0 0 0-.06-.64l-.07-.06a.5.5 0 0 0-.64.06L10 9.3 7.88 7.17l-.07-.06Z"
]);
const $cdb0ff5c001a8842$export$c6bbf9574e7e7679 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle20Regular', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM7.8 7.11l.08.06L10 9.3l2.12-2.12a.5.5 0 0 1 .64-.06l.07.06c.17.18.2.44.06.64l-.06.07L10.7 10l2.12 2.12c.17.17.2.44.06.64l-.06.07a.5.5 0 0 1-.64.06l-.07-.06L10 10.7l-2.12 2.12a.5.5 0 0 1-.64.06l-.07-.06a.5.5 0 0 1-.06-.64l.06-.07L9.3 10 7.17 7.88a.5.5 0 0 1-.06-.64l.06-.07a.5.5 0 0 1 .64-.06Z"
]);
const $cdb0ff5c001a8842$export$69521afd2e8ef7c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle24Color', "24", `<path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z" fill="url(#ic_fluent_dismiss_circle_24_color__a)"/><path d="m15.53 8.47-.08-.07a.75.75 0 0 0-.89-.01l-.09.08L12 10.94 9.53 8.47l-.08-.07a.75.75 0 0 0-.89-.01l-.09.08-.07.08c-.2.26-.2.62-.01.89l.08.09L10.94 12l-2.47 2.47-.07.08c-.2.26-.2.62-.01.89l.08.09.08.07c.26.2.62.2.89.01l.09-.08L12 13.06l2.47 2.47.08.07c.26.2.62.2.89.01l.09-.08.07-.08c.2-.26.2-.62.01-.89l-.08-.09L13.06 12l2.47-2.47.07-.08c.2-.26.2-.62.01-.89l-.08-.09Z" fill="url(#ic_fluent_dismiss_circle_24_color__b)"/><defs><linearGradient id="ic_fluent_dismiss_circle_24_color__a" x1="5.13" y1="3.25" x2="18.25" y2="22.63" gradientUnits="userSpaceOnUse"><stop stop-color="#F83F54"/><stop offset="1" stop-color="#CA2134"/></linearGradient><linearGradient id="ic_fluent_dismiss_circle_24_color__b" x1="8.69" y1="12.33" x2="12.59" y2="16.39" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#FECBE6"/></linearGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$9bced2eb0e9e3f4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm3.53 6.47-.08-.07a.75.75 0 0 0-.89-.01l-.09.08L12 10.94 9.53 8.47l-.08-.07a.75.75 0 0 0-.89-.01l-.09.08-.07.08c-.2.26-.2.62-.01.89l.08.09L10.94 12l-2.47 2.47-.07.08c-.2.26-.2.62-.01.89l.08.09.08.07c.26.2.62.2.89.01l.09-.08L12 13.06l2.47 2.47.08.07c.26.2.62.2.89.01l.09-.08.07-.08c.2-.26.2-.62.01-.89l-.08-.09L13.06 12l2.47-2.47.07-.08c.2-.26.2-.62.01-.89l-.08-.09-.08-.07.08.07Z"
]);
const $cdb0ff5c001a8842$export$123b9be479117e05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm3.45 4.9.08.07c.27.27.3.68.07.98l-.07.08L13.06 12l2.47 2.47c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L12 13.06l-2.47 2.47a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L10.94 12 8.47 9.53a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07l.08.07L12 10.94l2.47-2.47a.75.75 0 0 1 .98-.07Z"
]);
const $cdb0ff5c001a8842$export$391651d82fa698e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle28Color', "28", `<path d="M26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0Z" fill="url(#ic_fluent_dismiss_circle_28_color__a)"/><path d="M18.28 9.72c.3.3.3.77 0 1.06L15.06 14l3.22 3.22a.75.75 0 1 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 1 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94l3.22-3.22c.3-.3.77-.3 1.06 0Z" fill="url(#ic_fluent_dismiss_circle_28_color__b)"/><defs><linearGradient id="ic_fluent_dismiss_circle_28_color__a" x1="5.75" y1="3.5" x2="21.5" y2="26.75" gradientUnits="userSpaceOnUse"><stop stop-color="#F83F54"/><stop offset="1" stop-color="#CA2134"/></linearGradient><linearGradient id="ic_fluent_dismiss_circle_28_color__b" x1="10.02" y1="14.4" x2="14.71" y2="19.27" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#FECBE6"/></linearGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$a1041ae3e91a7bed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle28Filled', "28", [
    "M26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0Zm-7.72-4.28c.3.3.3.77 0 1.06L15.06 14l3.22 3.22a.75.75 0 1 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 1 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94l3.22-3.22c.3-.3.77-.3 1.06 0Z"
]);
const $cdb0ff5c001a8842$export$eec292ca7e8c99fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle28Regular', "28", [
    "M18.28 9.72c.3.3.3.77 0 1.06L15.06 14l3.22 3.22a.75.75 0 1 1-1.06 1.06L14 15.06l-3.22 3.22a.75.75 0 1 1-1.06-1.06L12.94 14l-3.22-3.22a.75.75 0 1 1 1.06-1.06L14 12.94l3.22-3.22c.3-.3.77-.3 1.06 0ZM26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0ZM3.5 14a10.5 10.5 0 1 1 21 0 10.5 10.5 0 0 1-21 0Z"
]);
const $cdb0ff5c001a8842$export$cbe9d7bd2750df4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Color', "32", `<path d="M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28Z" fill="url(#ic_fluent_dismiss_circle_32_color__a)"/><path d="M21.7 10.3a1 1 0 0 1 0 1.4L17.42 16l4.3 4.3a1 1 0 0 1-1.42 1.4L16 17.42l-4.3 4.3a1 1 0 0 1-1.4-1.42L14.58 16l-4.3-4.3a1 1 0 1 1 1.42-1.4L16 14.58l4.3-4.3a1 1 0 0 1 1.4 0Z" fill="url(#ic_fluent_dismiss_circle_32_color__b)"/><defs><linearGradient id="ic_fluent_dismiss_circle_32_color__a" x1="6.38" y1="3.75" x2="24.75" y2="30.88" gradientUnits="userSpaceOnUse"><stop stop-color="#F83F54"/><stop offset="1" stop-color="#CA2134"/></linearGradient><linearGradient id="ic_fluent_dismiss_circle_32_color__b" x1="10.7" y1="16.53" x2="16.95" y2="23.03" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#FECBE6"/></linearGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$bca0ab54a9a0f9b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0Zm19.7-5.7a1 1 0 0 0-1.4 0L16 14.58l-4.3-4.3a1 1 0 1 0-1.4 1.42L14.58 16l-4.3 4.3a1 1 0 1 0 1.42 1.4L16 17.42l4.3 4.3a1 1 0 0 0 1.4-1.42L17.42 16l4.3-4.3a1 1 0 0 0 0-1.4Z"
]);
const $cdb0ff5c001a8842$export$cfb8e33d0b575756 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Light', "32", [
    "M10.15 10.15a.5.5 0 0 0 0 .7L15.29 16l-5.14 5.15a.5.5 0 0 0 .7.7L16 16.71l5.15 5.14a.5.5 0 0 0 .7-.7L16.71 16l5.14-5.15a.5.5 0 0 0-.7-.7L16 15.29l-5.15-5.14a.5.5 0 0 0-.7 0ZM2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0ZM16 3a13 13 0 1 0 0 26 13 13 0 0 0 0-26Z"
]);
const $cdb0ff5c001a8842$export$abf3bf54934b4de9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle32Regular', "32", [
    "M21.7 10.3a1 1 0 0 1 0 1.4L17.42 16l4.3 4.3a1 1 0 0 1-1.42 1.4L16 17.42l-4.3 4.3a1 1 0 0 1-1.4-1.42L14.58 16l-4.3-4.3a1 1 0 1 1 1.42-1.4L16 14.58l4.3-4.3a1 1 0 0 1 1.4 0ZM16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28ZM4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0Z"
]);
const $cdb0ff5c001a8842$export$a310b9381080f725 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle48Color', "48", `<path d="M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Z" fill="url(#ic_fluent_dismiss_circle_48_color__a)"/><path d="m17.78 16.02.1.1L24 22.23l6.12-6.11a1.25 1.25 0 0 1 1.66-.1l.1.1c.46.45.49 1.17.1 1.66l-.1.1L25.77 24l6.11 6.12c.46.45.49 1.17.1 1.66l-.1.1c-.45.46-1.17.49-1.66.1l-.1-.1L24 25.77l-6.12 6.11c-.45.46-1.17.49-1.66.1l-.1-.1a1.25 1.25 0 0 1-.1-1.66l.1-.1L22.23 24l-6.11-6.12a1.25 1.25 0 0 1-.1-1.66l.1-.1a1.25 1.25 0 0 1 1.66-.1Z" fill="url(#ic_fluent_dismiss_circle_48_color__b)"/><defs><linearGradient id="ic_fluent_dismiss_circle_48_color__a" x1="10.25" y1="6.5" x2="36.5" y2="45.25" gradientUnits="userSpaceOnUse"><stop stop-color="#F83F54"/><stop offset="1" stop-color="#CA2134"/></linearGradient><linearGradient id="ic_fluent_dismiss_circle_48_color__b" x1="16.71" y1="24.73" x2="25.3" y2="33.66" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#FECBE6"/></linearGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$2ab534e539bdf78e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Zm-6.12 12.12-.1-.1a1.25 1.25 0 0 0-1.56 0l-.1.1-.1.1c-.36.45-.36 1.1 0 1.56l.1.1L22.23 24l-6.11 6.12-.1.1c-.36.45-.36 1.1 0 1.56l.1.1.1.1c.45.36 1.1.36 1.56 0l.1-.1L24 25.77l6.12 6.11.1.1c.45.36 1.1.36 1.56 0l.1-.1.1-.1c.36-.45.36-1.1 0-1.56l-.1-.1L25.77 24l6.11-6.12.1-.1c.36-.45.36-1.1 0-1.56l-.1-.1-.1-.1a1.25 1.25 0 0 0-1.56 0l-.1.1L24 22.23l-6.12-6.11-.1-.1.1.1Z"
]);
const $cdb0ff5c001a8842$export$4d7bb8476b4ee227 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissCircle48Regular', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Zm0 2.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35Zm-6.22 9.52.1.1L24 22.23l6.12-6.11a1.25 1.25 0 0 1 1.66-.1l.1.1c.46.45.49 1.17.1 1.66l-.1.1L25.77 24l6.11 6.12c.46.45.49 1.17.1 1.66l-.1.1c-.45.46-1.17.49-1.66.1l-.1-.1L24 25.77l-6.12 6.11c-.45.46-1.17.49-1.66.1l-.1-.1a1.25 1.25 0 0 1-.1-1.66l.1-.1L22.23 24l-6.11-6.12a1.25 1.25 0 0 1-.1-1.66l.1-.1a1.25 1.25 0 0 1 1.66-.1Z"
]);
const $cdb0ff5c001a8842$export$4c8e27c1b3cf5b75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.15 1.15a.5.5 0 0 0 0 .7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 0 0-.7 0Z"
]);
const $cdb0ff5c001a8842$export$62ccf8f64e9091ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare20Regular', "20", [
    "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z"
]);
const $cdb0ff5c001a8842$export$dfe2de482451b605 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Zm1.97 5.22c.3-.3.77-.3 1.06 0L12 10.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 0-1.06Z"
]);
const $cdb0ff5c001a8842$export$6d344683e5592c94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare24Regular', "24", [
    "M8.22 8.22c.3-.3.77-.3 1.06 0L12 10.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 0-1.06ZM6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25ZM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25Z"
]);
const $cdb0ff5c001a8842$export$5c487918c4861c20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare28Filled', "28", [
    "M21.25 3A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3h14.5Zm-2.47 6.22a.75.75 0 0 0-1.06 0L14 12.94l-3.72-3.72a.75.75 0 1 0-1.06 1.06L12.94 14l-3.72 3.72a.75.75 0 1 0 1.06 1.06L14 15.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L15.06 14l3.72-3.72c.3-.3.3-.77 0-1.06Z"
]);
const $cdb0ff5c001a8842$export$2a3c0896f8c34acc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare28Regular', "28", [
    "M21.25 3A3.75 3.75 0 0 1 25 6.75v14.5A3.75 3.75 0 0 1 21.25 25H6.75A3.75 3.75 0 0 1 3 21.25V6.75A3.75 3.75 0 0 1 6.75 3h14.5ZM6.75 4.5c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25h14.5c1.24 0 2.25-1 2.25-2.25V6.75c0-1.24-1-2.25-2.25-2.25H6.75Zm10.97 4.72a.75.75 0 1 1 1.06 1.06L15.06 14l3.72 3.72a.75.75 0 1 1-1.06 1.06L14 15.06l-3.72 3.72a.75.75 0 1 1-1.06-1.06L12.94 14l-3.72-3.72a.75.75 0 1 1 1.06-1.06L14 12.94l3.72-3.72Z"
]);
const $cdb0ff5c001a8842$export$1983754dfdb1ee3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare32Filled', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3h17Zm-2.8 7.3a1 1 0 0 0-1.4 0L16 14.58l-4.3-4.3a1 1 0 1 0-1.4 1.42L14.58 16l-4.3 4.3a1 1 0 1 0 1.42 1.4L16 17.42l4.3 4.3a1 1 0 1 0 1.4-1.42L17.42 16l4.3-4.3a1 1 0 0 0 0-1.4Z"
]);
const $cdb0ff5c001a8842$export$57f3ab54efd56e2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare32Light', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3h17Zm-17 1A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4h-17Zm13.65 6.15a.5.5 0 1 1 .7.7L16.71 16l5.14 5.15a.5.5 0 1 1-.7.7L16 16.71l-5.15 5.14a.5.5 0 1 1-.7-.7L15.29 16l-5.14-5.15a.5.5 0 1 1 .7-.7L16 15.29l5.15-5.14Z"
]);
const $cdb0ff5c001a8842$export$57e5e82459d1a5af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare32Regular', "32", [
    "M24.5 3A4.5 4.5 0 0 1 29 7.5v17a4.5 4.5 0 0 1-4.5 4.5h-17A4.5 4.5 0 0 1 3 24.5v-17A4.5 4.5 0 0 1 7.5 3h17Zm-17 2A2.5 2.5 0 0 0 5 7.5v17A2.5 2.5 0 0 0 7.5 27h17a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 24.5 5h-17Zm12.8 5.3a1 1 0 1 1 1.4 1.4L17.42 16l4.3 4.3a1 1 0 1 1-1.42 1.4L16 17.42l-4.3 4.3a1 1 0 1 1-1.4-1.42L14.58 16l-4.3-4.3a1 1 0 1 1 1.42-1.4L16 14.58l4.3-4.3Z"
]);
const $cdb0ff5c001a8842$export$8106395b74553fed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare48Filled', "48", [
    "M35.75 6C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6h23.5Zm-4.12 10.37a1.25 1.25 0 0 0-1.76 0L24 22.23l-5.87-5.86a1.25 1.25 0 0 0-1.76 1.76L22.23 24l-5.86 5.87a1.25 1.25 0 0 0 1.76 1.76L24 25.77l5.87 5.86a1.25 1.25 0 0 0 1.76-1.76L25.77 24l5.86-5.87c.5-.48.5-1.28 0-1.76Z"
]);
const $cdb0ff5c001a8842$export$b331b78a24ec136f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquare48Regular', "48", [
    "M35.75 6C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75v-23.5C6 8.8 8.8 6 12.25 6h23.5Zm-23.5 2.5a3.75 3.75 0 0 0-3.75 3.75v23.5a3.75 3.75 0 0 0 3.75 3.75h23.5a3.75 3.75 0 0 0 3.75-3.75v-23.5a3.75 3.75 0 0 0-3.75-3.75h-23.5Zm17.62 7.87a1.25 1.25 0 0 1 1.76 1.76L25.77 24l5.86 5.87a1.25 1.25 0 0 1-1.76 1.76L24 25.77l-5.87 5.86a1.25 1.25 0 0 1-1.76-1.76L22.23 24l-5.86-5.87a1.25 1.25 0 0 1 1.76-1.76L24 22.23l5.87-5.86Z"
]);
const $cdb0ff5c001a8842$export$cb3d4c98932050ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple16Filled', "16", [
    "M4 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm.65 2.65c.2-.2.5-.2.7 0L7 6.29l1.65-1.64a.5.5 0 1 1 .7.7L7.71 7l1.64 1.65a.5.5 0 1 1-.7.7L7 7.71 5.35 9.35a.5.5 0 1 1-.7-.7L6.29 7 4.65 5.35a.5.5 0 0 1 0-.7ZM13 10.5a2.5 2.5 0 0 1-2.5 2.5H3.27c.34.6.99 1 1.73 1h5.5a3.5 3.5 0 0 0 3.5-3.5V5a2 2 0 0 0-1-1.73v7.23Z"
]);
const $cdb0ff5c001a8842$export$44d32114ff60489e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple16Regular', "16", [
    "M4.65 4.65c.2-.2.5-.2.7 0L7 6.29l1.65-1.64a.5.5 0 1 1 .7.7L7.71 7l1.64 1.65a.5.5 0 1 1-.7.7L7 7.71 5.35 9.35a.5.5 0 1 1-.7-.7L6.29 7 4.65 5.35a.5.5 0 0 1 0-.7ZM4 2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4ZM3 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm10-.73c.6.34 1 .99 1 1.73v5.5a3.5 3.5 0 0 1-3.5 3.5H5a2 2 0 0 1-1.73-1h7.23a2.5 2.5 0 0 0 2.5-2.5V3.27Z"
]);
const $cdb0ff5c001a8842$export$ef5926354a49c152 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple20Filled', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5v-7Zm3.15.65a.5.5 0 0 0 0 .7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29 6.85 6.15a.5.5 0 0 0-.7 0ZM5.5 16c.46.6 1.18 1 2 1h5a4.5 4.5 0 0 0 4.5-4.5v-5c0-.82-.4-1.54-1-2v7a3.5 3.5 0 0 1-3.5 3.5h-7Z"
]);
const $cdb0ff5c001a8842$export$75c801830042f196 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DismissSquareMultiple20Regular', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5v-7ZM5.5 4C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7Zm2 13a2.5 2.5 0 0 1-2-1h7a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5h-5ZM6.85 6.15a.5.5 0 1 0-.7.7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29 6.85 6.15Z"
]);
const $cdb0ff5c001a8842$export$7ed5f61fd9b3cf4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Z"
]);
const $cdb0ff5c001a8842$export$17860ebed1b09acd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-7ZM2 7v4.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2Z"
]);
const $cdb0ff5c001a8842$export$571fe248b10678c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Z"
]);
const $cdb0ff5c001a8842$export$cc085cb1a0643386 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5ZM3 8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5V8Z"
]);
const $cdb0ff5c001a8842$export$a51b6aa254865438 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h13.5c1.8 0 3.25-1.46 3.25-3.25v-9c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Z"
]);
const $cdb0ff5c001a8842$export$44c7e2ed5c596085 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v9c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM3.5 9.5v8.25c0 .97.78 1.75 1.75 1.75h13.5c.97 0 1.75-.78 1.75-1.75v-9c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5Z"
]);
const $cdb0ff5c001a8842$export$1dc1d2ce4cfb16b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2Z"
]);
const $cdb0ff5c001a8842$export$d6de7afe194c959a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v10.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V9.83Zm1.5.67v9.75c0 1.24 1.01 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5Z"
]);
const $cdb0ff5c001a8842$export$c616433a79cf406d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Z"
]);
const $cdb0ff5c001a8842$export$5c488096ed9e653b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v11.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15ZM4 13v10.5A2.5 2.5 0 0 0 6.5 26h19a2.5 2.5 0 0 0 2.5-2.5V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4Z"
]);
const $cdb0ff5c001a8842$export$86b2c3e870c73218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-17.5C44 13.8 41.2 11 37.75 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4Z"
]);
const $cdb0ff5c001a8842$export$b66d415a8fd2fef1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Folder48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v17.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-22.5Zm2.5 6.25v16.25a3.75 3.75 0 0 0 3.75 3.75h27.5a3.75 3.75 0 0 0 3.75-3.75v-17.5a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5Z"
]);
const $cdb0ff5c001a8842$export$30b180a4501d8327 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm15 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
]);
const $cdb0ff5c001a8842$export$f79fdb009e811ea6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm15 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
]);
const $cdb0ff5c001a8842$export$1169ebbe42e81a69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm17 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $cdb0ff5c001a8842$export$5971ab25790e8376 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm16 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $cdb0ff5c001a8842$export$5793f757fc13df72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm21 8a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
]);
const $cdb0ff5c001a8842$export$31a94f852f67c764 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a6.52 6.52 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06c.18.53.42 1.04.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
]);
const $cdb0ff5c001a8842$export$a30e809ccec4b43b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2Zm25 9a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V19h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V20h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
]);
const $cdb0ff5c001a8842$export$a583a1881ff7ed0b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65c-.44-.48-.95-.9-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87c.24.54.53 1.04.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25V9.83Zm25 9.67a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V19h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V20h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
]);
const $cdb0ff5c001a8842$export$d91282fdbd93bad5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm22 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm1-12.25V22h3.75a.75.75 0 0 1 0 1.5H25v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0Z"
]);
const $cdb0ff5c001a8842$export$44bdc45e7f5dfee7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3c-.6-.55-1.27-1-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15Zm22 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm1-12.25V22h3.75a.75.75 0 0 1 0 1.5H25v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0Z"
]);
const $cdb0ff5c001a8842$export$89a7f6405589afc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4ZM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
]);
const $cdb0ff5c001a8842$export$fd847aaae7eace22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderAdd48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37c-.75-.72-1.6-1.36-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8c.33.88.74 1.72 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-22.5ZM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
]);
const $cdb0ff5c001a8842$export$ff8f3d71542c8557 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm10.5 9a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $cdb0ff5c001a8842$export$d5a9170169f5cb6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7ZM11.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $cdb0ff5c001a8842$export$9fa8cc4b98af39fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm12.5 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $cdb0ff5c001a8842$export$fdc3e40067989657 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5ZM14.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $cdb0ff5c001a8842$export$ad649fee66185d89 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2ZM17.5 23a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Zm3-5a.5.5 0 0 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18h4.79Z"
]);
const $cdb0ff5c001a8842$export$157e31eef8e7888e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a6.52 6.52 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06c.18.53.42 1.04.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM17.5 23a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Zm3-5a.5.5 0 0 0 0-1h-4.8l1.65-1.65a.5.5 0 0 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L15.71 18h4.79Z"
]);
const $cdb0ff5c001a8842$export$4a8cc74cca132358 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2ZM20.5 26a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Zm4-6a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35c0 .13.05.26.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 20h6.79Z"
]);
const $cdb0ff5c001a8842$export$dcce8e4af0ae14b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65c-.44-.48-.95-.9-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87c.24.54.53 1.04.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25V9.83ZM20.5 26a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Zm4-6a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35c0 .13.05.26.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 20h6.79Z"
]);
const $cdb0ff5c001a8842$export$644f447565e1cdbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm14.5 10a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0Zm12.25 1h-7.69l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06l-2.72 2.72h7.69a.75.75 0 0 1 0 1.5Z"
]);
const $cdb0ff5c001a8842$export$9f4f3f8d34ed6270 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3c-.6-.55-1.27-1-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15ZM16.5 23a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0Zm12.25 1h-7.69l2.72 2.72a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06l-2.72 2.72h7.69a.75.75 0 0 1 0 1.5Z"
]);
const $cdb0ff5c001a8842$export$aac62fd678c1f06c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4ZM35 45a11 11 0 1 1 0-22 11 11 0 0 1 0 22Zm8-11a1 1 0 0 0-1-1H30.41l3.3-3.3a1 1 0 0 0-1.42-1.4l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.42-1.4L30.4 35H42a1 1 0 0 0 1-1Z"
]);
const $cdb0ff5c001a8842$export$3b65fce055e33add = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowLeft48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37c-.75-.72-1.6-1.36-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8c.33.88.74 1.72 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-22.5ZM35 45a11 11 0 1 1 0-22 11 11 0 0 1 0 22Zm8-11a1 1 0 0 0-1-1H30.41l3.3-3.3a1 1 0 0 0-1.42-1.4l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.42-1.4L30.4 35H42a1 1 0 0 0 1-1Z"
]);
const $cdb0ff5c001a8842$export$302f2aaa74d3013c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm10.5 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L12.29 11H9.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$68090fca8b3d983e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7ZM11.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L12.29 11H9.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e0dae068ad9f4ccf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm12.5 2a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$24f627cd110213ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5ZM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$90a62fb19e17928f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17H14.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9339cb80e5862ba9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a6.52 6.52 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06c.18.53.42 1.04.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17H14.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6077ab72d9c944b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2ZM20.5 13a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm-4 6a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 19H16.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c303fcd0f756ce6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65c-.44-.48-.95-.9-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87c.24.54.53 1.04.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25V9.83ZM20.5 13a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm-4 6a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 19H16.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$221156a8556f81d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm29.5 10a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Zm-12.25-1h7.69l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72h-7.69a.75.75 0 0 1 0-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$baf075ba95515c73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight32Light', "32", [
    "M3 12h7.6c.71 0 1.4-.31 1.87-.85L15.23 8H25.5a3.5 3.5 0 0 1 3.5 3.5v4.02c.35.23.69.49 1 .77V11.5A4.5 4.5 0 0 0 25.5 7H14.7l-2.26-2.27A2.5 2.5 0 0 0 10.67 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h10.02a9 9 0 0 1-.58-1H6.5A3.5 3.5 0 0 1 3 23.5V12Zm0-3.5A3.5 3.5 0 0 1 6.5 5h4.17c.4 0 .78.16 1.06.44l2.35 2.35-2.36 2.7c-.28.32-.7.51-1.13.51H3V8.5ZM31.5 23a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm-12.25-1a.75.75 0 0 0 0 1.5h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06L26.94 22h-7.69Z"
]);
const $cdb0ff5c001a8842$export$c99fc446560e27f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3c-.6-.55-1.27-1-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15ZM31.5 23a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Zm-12.25-1h7.69l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4c.3.3.3.77 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06l2.72-2.72h-7.69a.75.75 0 0 1 0-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9db0c29b9f63827a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4ZM35 23a11 11 0 1 1 0 22 11 11 0 0 1 0-22Zm-8 11a1 1 0 0 0 1 1h11.59l-3.3 3.3a1 1 0 0 0 1.42 1.4l5-5a1 1 0 0 0 0-1.4l-5-5a1 1 0 0 0-1.42 1.4l3.3 3.3H28a1 1 0 0 0-1 1Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e392d21e88e31a24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowRight48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37c-.75-.72-1.6-1.36-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8c.33.88.74 1.72 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-22.5ZM35 23a11 11 0 1 1 0 22 11 11 0 0 1 0-22Zm-8 11a1 1 0 0 0 1 1h11.59l-3.3 3.3a1 1 0 0 0 1.42 1.4l5-5a1 1 0 0 0 0-1.4l-5-5a1 1 0 0 0-1.42 1.4l3.3 3.3H28a1 1 0 0 0-1 1Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$aca497960b9b66f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm15 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85-2.35-2 2a.5.5 0 0 0 .7.7L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9a.5.5 0 0 0-.35.14Z"
]);
const $cdb0ff5c001a8842$export$4f298807578b4683 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm15 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85-2.35-2 2a.5.5 0 0 0 .7.7L11 10.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2A.5.5 0 0 0 11.5 9a.5.5 0 0 0-.35.14Z"
]);
const $cdb0ff5c001a8842$export$f8044c8c3ffaee0d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm17 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14Z"
]);
const $cdb0ff5c001a8842$export$c6ba17e1da0c19e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm16 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85-2.35-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.14Z"
]);
const $cdb0ff5c001a8842$export$1ff0118277724ae1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm21 8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-6 3a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 .7.7L17 15.71v4.79Z"
]);
const $cdb0ff5c001a8842$export$647230c4d8916834 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a6.52 6.52 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06c.18.53.42 1.04.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-6 3a.5.5 0 0 0 1 0v-4.8l1.65 1.65a.5.5 0 0 0 .7-.7l-2.5-2.5a.5.5 0 0 0-.7 0l-2.5 2.5a.5.5 0 0 0 .7.7L17 15.71v4.79Z"
]);
const $cdb0ff5c001a8842$export$c180386908c8e886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2Zm25 9a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-7 4a.5.5 0 0 0 1 0v-6.8l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.15l-3 3a.5.5 0 0 0 .7.7L20 16.71v6.79Z"
]);
const $cdb0ff5c001a8842$export$7dc1838a2b686dd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65c-.44-.48-.95-.9-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87c.24.54.53 1.04.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25V9.83Zm25 9.67a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-7 4a.5.5 0 0 0 1 0v-6.8l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.15l-3 3a.5.5 0 0 0 .7.7L20 16.71v6.79Z"
]);
const $cdb0ff5c001a8842$export$a1cd7460a9c95f56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm29.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0ZM25 20.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72v7.69a.75.75 0 0 0 1.5 0v-7.69Z"
]);
const $cdb0ff5c001a8842$export$2219fb60cfab9f98 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3c-.6-.55-1.27-1-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15ZM31.5 23a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0ZM25 20.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4a.75.75 0 1 0 1.06 1.06l2.72-2.72v7.69a.75.75 0 0 0 1.5 0v-7.69Z"
]);
const $cdb0ff5c001a8842$export$fe95a3b9f86f41a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4ZM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10.3-7.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 1.4 1.4l3.3-3.29V41a1 1 0 1 0 2 0V29.41l3.3 3.3a1 1 0 0 0 1.4-1.42l-5-5Z"
]);
const $cdb0ff5c001a8842$export$5d5f76cdaf32a7b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderArrowUp48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37c-.75-.72-1.6-1.36-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8c.33.88.74 1.72 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-22.5ZM46 34a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10.3-7.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 1.4 1.4l3.3-3.29V41a1 1 0 1 0 2 0V29.41l3.3 3.3a1 1 0 0 0 1.4-1.42l-5-5Z"
]);
const $cdb0ff5c001a8842$export$c89ae2c1a2e2f012 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderBriefcase20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17H9v-3.5a2.5 2.5 0 0 1 2.04-2.46A2.5 2.5 0 0 1 13.5 9h2a2.5 2.5 0 0 1 2.46 2.04l.04.01V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm10 3.5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5Zm1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5Z"
]);
const $cdb0ff5c001a8842$export$e6390fb8878c4576 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderBriefcase20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H9v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2c.5.37.84.91.96 1.54l.04.01V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm9 6v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5Zm1.5-.5h2c.28 0 .5.22.5.5v.5h-3v-.5c0-.28.22-.5.5-.5Z"
]);
const $cdb0ff5c001a8842$export$37f788851c63a1b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14H8V8c0-1.1.9-2 2-2h2.59a2 2 0 0 1 1.41.59l1 1V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm9.25 0H12v2.5c0 .83.67 1.5 1.5 1.5H16v3.75c0 .69-.56 1.25-1.25 1.25h-4.5C9.56 16 9 15.44 9 14.75v-6.5C9 7.56 9.56 7 10.25 7ZM13 7l3 3h-2.5a.5.5 0 0 1-.5-.5V7Z"
]);
const $cdb0ff5c001a8842$export$2829e83e9161162f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument16Regular', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v1.09l-1-1V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5H8v1H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm1 0V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5ZM10.25 7H12v2.5c0 .83.67 1.5 1.5 1.5H16v3.75c0 .69-.56 1.25-1.25 1.25h-4.5C9.56 16 9 15.44 9 14.75v-6.5C9 7.56 9.56 7 10.25 7ZM13 7l3 3h-2.5a.5.5 0 0 1-.5-.5V7Z"
]);
const $cdb0ff5c001a8842$export$fb6126671c3cbbd6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17H11v-6c0-1.1.9-2 2-2h2.59a2 2 0 0 1 1.41.59l1 1V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm11.25 2H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25ZM16 10l3 3h-2.5a.5.5 0 0 1-.5-.5V10Z"
]);
const $cdb0ff5c001a8842$export$6fd9f466e295e9b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H11v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.09l1 1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5ZM13.25 10H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25ZM16 10l3 3h-2.5a.5.5 0 0 1-.5-.5V10Z"
]);
const $cdb0ff5c001a8842$export$2aa77493853ade7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21H13v-7.5a2.5 2.5 0 0 1 2.5-2.5h2.92a2 2 0 0 1 1.42.59L22 13.75v-5c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm16 5.75V12h-2.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V17h-3.25c-.97 0-1.75-.78-1.75-1.75Zm1 0V12l4 4h-3.25a.75.75 0 0 1-.75-.75Z"
]);
const $cdb0ff5c001a8842$export$f6be6d517c2c0cc1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument24Regular', "24", [
    "M2 6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.84l-1.5-1.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75H13V21H5.25A3.25 3.25 0 0 1 2 17.75V6.25Zm1.5 0V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm14.5 9V12h-2.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5V17h-3.25c-.97 0-1.75-.78-1.75-1.75Zm1 0V12l4 4h-3.25a.75.75 0 0 1-.75-.75Z"
]);
const $cdb0ff5c001a8842$export$56a1be16651fd86d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24H15v-8.25A2.75 2.75 0 0 1 17.75 13h4.84a2 2 0 0 1 1.41.59l2 2V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2ZM22 17v-3h-4.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V19h-3a2 2 0 0 1-2-2Zm1 0v-3l4 4h-3a1 1 0 0 1-1-1Z"
]);
const $cdb0ff5c001a8842$export$2d8bdea185e151d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderDocument28Regular', "28", [
    "M2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v5.84l-1.5-1.5V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25H15V24H5.75A3.75 3.75 0 0 1 2 20.25V9.83Zm1.5-3.15V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM22 17v-3h-4.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V19h-3a2 2 0 0 1-2-2Zm1 0v-3l4 4h-3a1 1 0 0 1-1-1Z"
]);
const $cdb0ff5c001a8842$export$bebece98c3340332 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm9.55 1.15a8.9 8.9 0 0 0-.54 2.85h2.98a8.9 8.9 0 0 0-.54-2.85 2.93 2.93 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24-.18.19-.36.5-.53.91Zm-.72-.83A9.92 9.92 0 0 0 9 11H7.03a4.5 4.5 0 0 1 2.8-3.68Zm3.34 0a9.92 9.92 0 0 1 .82 3.68h1.98a4.5 4.5 0 0 0-2.8-3.68Zm2.8 4.68H14a9.92 9.92 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68Zm-4.47 4c.1 0 .23-.05.42-.24.18-.19.36-.5.53-.91.3-.73.5-1.72.54-2.85h-2.98a8.9 8.9 0 0 0 .54 2.85c.17.42.35.72.53.91.19.2.33.24.42.24Zm-1.67-.32A4.5 4.5 0 0 1 7.03 12H9a9.92 9.92 0 0 0 .82 3.68Z"
]);
const $cdb0ff5c001a8842$export$60c849b1d818fcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm9.55 3.65a8.9 8.9 0 0 0-.54 2.85h2.98a8.9 8.9 0 0 0-.54-2.85 2.93 2.93 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24-.18.19-.36.5-.53.91Zm-.72-.83A9.92 9.92 0 0 0 9 11H7.03a4.5 4.5 0 0 1 2.8-3.68Zm3.34 0a9.92 9.92 0 0 1 .82 3.68h1.98a4.5 4.5 0 0 0-2.8-3.68Zm2.8 4.68H14a9.92 9.92 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68Zm-4.47 4c.1 0 .23-.05.42-.24.18-.19.36-.5.53-.91.3-.73.5-1.72.54-2.85h-2.98a8.9 8.9 0 0 0 .54 2.85c.17.42.35.72.53.91.19.2.33.24.42.24Zm-1.67-.32A4.5 4.5 0 0 1 7.03 12H9a9.92 9.92 0 0 0 .82 3.68Z"
]);
const $cdb0ff5c001a8842$export$20f3837e2021246e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm11.55 3.15a8.9 8.9 0 0 0-.54 2.85h2.98a8.9 8.9 0 0 0-.54-2.85 2.93 2.93 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24-.18.19-.36.5-.53.91Zm-.72-.83A9.92 9.92 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68Zm3.34 0a9.92 9.92 0 0 1 .82 3.68h1.98a4.5 4.5 0 0 0-2.8-3.68Zm2.8 4.68H17a9.92 9.92 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68Zm-4.47 4c.1 0 .23-.05.42-.24.18-.19.36-.5.53-.91.3-.73.5-1.72.54-2.85h-2.98a8.9 8.9 0 0 0 .54 2.85c.17.42.35.72.53.91.19.2.33.24.42.24Zm-1.67-.32a4.5 4.5 0 0 1-2.8-3.68H12a9.92 9.92 0 0 0 .82 3.68Z"
]);
const $cdb0ff5c001a8842$export$f64c7ead07b985cb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderGlobe20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm10.55 5.65a8.9 8.9 0 0 0-.54 2.85h2.98a8.9 8.9 0 0 0-.54-2.85 2.93 2.93 0 0 0-.53-.91c-.19-.2-.33-.24-.42-.24-.1 0-.23.05-.42.24-.18.19-.36.5-.53.91Zm-.72-.83A9.92 9.92 0 0 0 12 14h-1.98a4.5 4.5 0 0 1 2.8-3.68Zm3.34 0a9.92 9.92 0 0 1 .82 3.68h1.98a4.5 4.5 0 0 0-2.8-3.68Zm2.8 4.68H17a9.92 9.92 0 0 1-.82 3.68 4.5 4.5 0 0 0 2.8-3.68Zm-4.47 4c.1 0 .23-.05.42-.24.18-.19.36-.5.53-.91.3-.73.5-1.72.54-2.85h-2.98a8.9 8.9 0 0 0 .54 2.85c.17.42.35.72.53.91.19.2.33.24.42.24Zm-1.67-.32a4.5 4.5 0 0 1-2.8-3.68H12a9.92 9.92 0 0 0 .82 3.68Z"
]);
const $cdb0ff5c001a8842$export$f8a0c8e725b6e9ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h5a1.5 1.5 0 0 1-1.38-2.08l2.08-5A1.5 1.5 0 0 1 10.58 6h3.48c.36 0 .68.12.93.33A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm7.5 6h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z"
]);
const $cdb0ff5c001a8842$export$34611243394b3d1a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.33c-.26-.2-.58-.33-.94-.33h-.15c-.2-.58-.76-1-1.41-1H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h3.59c.2.57.74 1 1.41 1h-5A2.5 2.5 0 0 1 1 11.5v-7ZM8.5 13h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z"
]);
const $cdb0ff5c001a8842$export$8f0f89148beb19a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h8a1.5 1.5 0 0 1-1.38-2.08l2.08-5A1.5 1.5 0 0 1 14.58 9H18V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm10.5 8h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z"
]);
const $cdb0ff5c001a8842$export$6e79196f449a3c06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h8a1.5 1.5 0 0 1-1.41-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V9h1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5ZM12.5 16h1.75l-.59 2.36c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-1.1l.78-2.34a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7Z"
]);
const $cdb0ff5c001a8842$export$ddb88d7b3f55e7a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h10.72l.25-1H14.5a1.5 1.5 0 0 1-1.36-2.14l2.82-6a1.5 1.5 0 0 1 1.36-.86H22V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2ZM17.32 12h4.83a.5.5 0 0 1 .43.75L20.75 16h1.5c.64 0 .99.76.56 1.24L18 22.75c-.5.58-1.45.09-1.26-.66L17.5 19h-3a.5.5 0 0 1-.45-.71l2.82-6a.5.5 0 0 1 .45-.29Z"
]);
const $cdb0ff5c001a8842$export$f694f162b3fc96c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLightning24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25V11h-1.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h8.13c.27.3.66.5 1.12.5h1.72l-.25 1H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM17.32 12h4.83a.5.5 0 0 1 .43.75L20.75 16h1.5c.64 0 .99.76.56 1.24L18 22.75c-.5.58-1.45.09-1.26-.66L17.5 19h-3a.5.5 0 0 1-.45-.71l2.82-6a.5.5 0 0 1 .45-.29Z"
]);
const $cdb0ff5c001a8842$export$1387df90dd354d83 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h2.84A3.5 3.5 0 0 1 9.5 9h4c.54 0 1.05.12 1.5.34V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm8.5 3a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H13a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H13Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$93838779ab60ec7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v2.84a3.48 3.48 0 0 0-1-.3V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.54c.05.35.15.69.3 1H3.5A2.5 2.5 0 0 1 1 11.5v-7ZM9.5 10a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H13a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H13Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$6431cd10ce4968 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.84a3.5 3.5 0 0 1 3.16-5h4c.54 0 1.05.12 1.5.34V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm10.5 5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$135708c5e5eebb97 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.84a3.48 3.48 0 0 1-.3-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v4.54c.35.05.69.15 1 .3V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm9.5 7.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$9376cd2034e0cd5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.63a4.75 4.75 0 0 1 3.87-7.5h3.5c1.02 0 1.97.32 2.75.88V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm21 8.75a3.75 3.75 0 0 0-3.75-3.75h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5V22h.2A3.75 3.75 0 0 0 23 18.24Zm-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75Zm3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75Z"
]);
const $cdb0ff5c001a8842$export$dd1261793e9cadfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v5.63a4.73 4.73 0 0 0-1.5-.71V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h5.92c.14.55.39 1.05.7 1.5H5.26A3.25 3.25 0 0 1 2 17.75V6.25Zm21 12a3.75 3.75 0 0 0-3.75-3.75h-.1a.75.75 0 0 0 .1 1.5h.15a2.25 2.25 0 0 1-.15 4.5l-.1.01a.75.75 0 0 0 .1 1.5V22h.2A3.75 3.75 0 0 0 23 18.24Zm-6.5-3a.75.75 0 0 0-.75-.75h-.2a3.75 3.75 0 0 0 .2 7.5h.1a.75.75 0 0 0-.1-1.5h-.15a2.25 2.25 0 0 1 .15-4.5h.1a.75.75 0 0 0 .65-.75Zm3.5 3a.75.75 0 0 0-.75-.75h-3.6a.75.75 0 0 0 .1 1.5h3.6a.75.75 0 0 0 .65-.75Z"
]);
const $cdb0ff5c001a8842$export$b4f37aed129d813e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.13a4.75 4.75 0 0 1 3.87-7.5h5.5c1.03 0 1.97.32 2.75.88V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2ZM17.75 19a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5h.5a.75.75 0 0 1 0 1.5h-.5ZM17 21.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm6.25 2.25a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5h.5Z"
]);
const $cdb0ff5c001a8842$export$fee84c6e7c0e583b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v7.63a4.73 4.73 0 0 0-1.5-.71V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.42c.14.55.39 1.05.7 1.5H5.76A3.75 3.75 0 0 1 2 20.25V9.83ZM17.75 19a2.25 2.25 0 0 0 0 4.5h.5a.75.75 0 0 1 0 1.5h-.5a3.75 3.75 0 1 1 0-7.5h.5a.75.75 0 0 1 0 1.5h-.5ZM17 21.25c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm6.25 2.25a2.25 2.25 0 0 0 0-4.5h-.5a.75.75 0 0 1 0-1.5h.5a3.75 3.75 0 1 1 0 7.5h-.5a.75.75 0 0 1 0-1.5h.5Z"
]);
const $cdb0ff5c001a8842$export$ab9b3d29a061650c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h8.3a6 6 0 0 1 5.2-9h6c1.54 0 2.94.58 4 1.53V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm19.5 8.5a1 1 0 0 0-1-1H20a4.5 4.5 0 1 0 0 9h.5a1 1 0 1 0 0-2H20a2.5 2.5 0 0 1 0-5h.5a1 1 0 0 0 1-1Zm4-1a1 1 0 1 0 0 2h.5a2.5 2.5 0 0 1 0 5h-.5a1 1 0 1 0 0 2h.5a4.5 4.5 0 1 0 0-9h-.5Zm-5 3.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z"
]);
const $cdb0ff5c001a8842$export$201e1522ee318f00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v8.53a6 6 0 0 0-2-1.19V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h7.58c.12.72.37 1.4.72 2H6.5A4.5 4.5 0 0 1 2 23.5v-15Zm19.5 13a1 1 0 0 0-1-1H20a4.5 4.5 0 1 0 0 9h.5a1 1 0 1 0 0-2H20a2.5 2.5 0 0 1 0-5h.5a1 1 0 0 0 1-1Zm4-1a1 1 0 1 0 0 2h.5a2.5 2.5 0 0 1 0 5h-.5a1 1 0 1 0 0 2h.5a4.5 4.5 0 1 0 0-9h-.5Zm-5 3.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z"
]);
const $cdb0ff5c001a8842$export$5f528ccd5100b2a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h11.62a8.42 8.42 0 0 1-.87-3.75A8.13 8.13 0 0 1 29 29h10c1.9 0 3.63.68 5 1.8V17.26C44 13.8 41.2 11 37.75 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4Zm19 18.75C23 33.8 25.8 31 29.25 31h1.5a1.25 1.25 0 1 1 0 2.5h-1.5a3.75 3.75 0 1 0 0 7.5h1.5a1.25 1.25 0 1 1 0 2.5h-1.5A6.25 6.25 0 0 1 23 37.25Zm22 0C45 33.8 42.2 31 38.75 31h-1.5a1.25 1.25 0 1 0 0 2.5h1.5a3.75 3.75 0 1 1 0 7.5h-1.5a1.25 1.25 0 1 0 0 2.5h1.5c3.45 0 6.25-2.8 6.25-6.25Zm-17 0c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25Z"
]);
const $cdb0ff5c001a8842$export$3030e71dd0785627 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderLink48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v13.56a7.91 7.91 0 0 0-2.5-1.4V17.25a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75h10.84c.13.89.4 1.73.78 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-22.5Zm19 25C23 33.8 25.8 31 29.25 31h1.5a1.25 1.25 0 1 1 0 2.5h-1.5a3.75 3.75 0 1 0 0 7.5h1.5a1.25 1.25 0 1 1 0 2.5h-1.5A6.25 6.25 0 0 1 23 37.25Zm22 0C45 33.8 42.2 31 38.75 31h-1.5a1.25 1.25 0 1 0 0 2.5h1.5a3.75 3.75 0 1 1 0 7.5h-1.5a1.25 1.25 0 1 0 0 2.5h1.5c3.45 0 6.25-2.8 6.25-6.25Zm-17 0c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25Z"
]);
const $cdb0ff5c001a8842$export$b11100896c8ec3b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h4.59c.06-.19.16-.36.3-.5a1.5 1.5 0 0 1 0-2A1.5 1.5 0 0 1 9.5 9h4.99c.18 0 .34.03.5.09V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm8.5 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM9 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$db6b71742cfb9a76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v2.59a1.5 1.5 0 0 0-.5-.09H14V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h4.59c.06.19.16.36.3.5a1.5 1.5 0 0 0-.3.5H3.5A2.5 2.5 0 0 1 1 11.5v-7ZM9.5 10a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM9 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$a9a88f6de9e73da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h6.59c.06-.19.16-.36.3-.5a1.5 1.5 0 0 1 0-2A1.5 1.5 0 0 1 12.5 12h5.49V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm10.5 5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm-.5 2.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$5d1f5708bbc6ec59 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderList20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h6.59c.06-.19.16-.36.3-.5a1.5 1.5 0 0 1-.3-.5H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V12h1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm9.5 7.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm-.5 2.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5Z"
]);
const $cdb0ff5c001a8842$export$df8a41e72faae368 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h2.55a2.51 2.51 0 0 1-.05-.5v-4A2.5 2.5 0 0 1 8.5 7h6c.17 0 .34.02.5.05V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm10.51 4.93L7.01 9.3c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43Zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 7 13.5v-3.05l4.25 2.48c.15.09.33.1.49.01Z"
]);
const $cdb0ff5c001a8842$export$75385421ca2c0a6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.55a2.51 2.51 0 0 0-.5-.05H14v-.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5H6v.5c0 .17.02.34.05.5H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm10.51 7.43L7.01 9.3c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43Zm.23 1.01 4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 7 13.5v-3.05l4.25 2.48c.15.09.33.1.49.01Z"
]);
const $cdb0ff5c001a8842$export$3836904429653055 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.55a2.51 2.51 0 0 1-.05-.5v-4a2.5 2.5 0 0 1 2.5-2.5h6c.17 0 .34.02.5.05V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm8.01 4.3 4.5 2.63L19 12.5v-.01c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3ZM19 13.64l-4.26 2.3a.5.5 0 0 1-.5 0L10 13.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-2.86Z"
]);
const $cdb0ff5c001a8842$export$f92cafa0f044d570 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.55a2.51 2.51 0 0 1-.05-.5V16H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5V10h.5c.17 0 .34.02.5.05V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm7.01 6.8 4.5 2.63L19 12.5v-.01c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3ZM19 13.64l-4.26 2.3a.5.5 0 0 1-.5 0L10 13.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-2.86Z"
]);
const $cdb0ff5c001a8842$export$77d6150857088f3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h5.92a3 3 0 0 1-.17-1v-5a3 3 0 0 1 3-3h7a3 3 0 0 1 1 .17V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm10.02 5.22 5.49 3.2L23 14.98A2 2 0 0 0 21 13h-7a2 2 0 0 0-1.98 1.72ZM23 16.11l-5.26 2.83a.5.5 0 0 1-.5 0L12 15.86V20c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2v-3.9Z"
]);
const $cdb0ff5c001a8842$export$29b58f2a5bb979d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v3.42a3 3 0 0 0-1-.17h-.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75H11v.5a3 3 0 0 0 .17 1H5.25A3.25 3.25 0 0 1 2 17.75V6.25Zm10.02 8.47 5.49 3.2L23 14.98A2 2 0 0 0 21 13h-7a2 2 0 0 0-1.98 1.72ZM23 16.11l-5.26 2.83a.5.5 0 0 1-.5 0L12 15.86V20c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2v-3.9Z"
]);
const $cdb0ff5c001a8842$export$8d8587b434fa2bf1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h7.59a3.49 3.49 0 0 1-.34-1.5v-6a3.5 3.5 0 0 1 3.5-3.5h8c.54 0 1.05.12 1.5.34V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2ZM16.5 14a2.5 2.5 0 0 0-2.5 2.5v.2l6.5 3.24L27 16.7v-.19a2.5 2.5 0 0 0-2.5-2.5h-8ZM27 17.8l-6.28 3.15a.5.5 0 0 1-.44 0L14 17.8v4.69a2.5 2.5 0 0 0 2.5 2.5h8a2.5 2.5 0 0 0 2.5-2.5v-4.7Z"
]);
const $cdb0ff5c001a8842$export$4d4be69fde0fbbe7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v3.59a3.49 3.49 0 0 0-1.5-.34V9.75c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25H13c0 .54.12 1.05.34 1.5H5.75A3.75 3.75 0 0 1 2 20.25V9.83ZM16.5 14a2.5 2.5 0 0 0-2.5 2.5v.2l6.5 3.24L27 16.7v-.19a2.5 2.5 0 0 0-2.5-2.5h-8ZM27 17.8l-6.28 3.15a.5.5 0 0 1-.44 0L14 17.8v4.69a2.5 2.5 0 0 0 2.5 2.5h8a2.5 2.5 0 0 0 2.5-2.5v-4.7Z"
]);
const $cdb0ff5c001a8842$export$45de31f056023c39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h7.11a4.51 4.51 0 0 1-.11-1v-8a4.5 4.5 0 0 1 4.5-4.5h10c.72 0 1.4.17 2 .47V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm13 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v.2l-8 4.44-8-4.44V19Zm8.36 6.16L31 20.9V27a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6.09l7.64 4.25c.22.12.5.12.72 0Z"
]);
const $cdb0ff5c001a8842$export$a80194b03a34969 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail32Light', "32", [
    "M3 12h7.6c.71 0 1.4-.31 1.87-.85L15.23 8H25.5a3.5 3.5 0 0 1 3.5 3.5v3.11c.35.08.69.2 1 .36V11.5A4.5 4.5 0 0 0 25.5 7H14.7l-2.26-2.27A2.5 2.5 0 0 0 10.67 4H6.5A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h7.11a4.51 4.51 0 0 1-.11-1h-7A3.5 3.5 0 0 1 3 23.5V12Zm0-3.5A3.5 3.5 0 0 1 6.5 5h4.17c.4 0 .78.16 1.06.44l2.35 2.35-2.36 2.7c-.28.32-.7.51-1.13.51H3V8.5ZM15 19a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v.2l-8 4.44-8-4.44V19Zm8.36 6.16L31 20.9V27a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6.09l7.64 4.25c.22.12.5.12.72 0Z"
]);
const $cdb0ff5c001a8842$export$c32b8a88939e009b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMail32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v2.97c-.6-.3-1.28-.47-2-.47V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h7v1c0 .34.04.68.11 1H6.5A4.5 4.5 0 0 1 2 23.5v-15ZM15 19a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v.2l-8 4.44-8-4.44V19Zm8.36 6.16L31 20.9V27a3 3 0 0 1-3 3H18a3 3 0 0 1-3-3v-6.09l7.64 4.25c.22.12.5.12.72 0Z"
]);
const $cdb0ff5c001a8842$export$6e64c7f454e1cc1b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple16Filled', "16", [
    "m6.15 2.44.85.85-1.56 1.56a.5.5 0 0 1-.35.15H1v-.5A2.5 2.5 0 0 1 3.5 2h1.59c.4 0 .78.16 1.06.44ZM1 9.5V6h4.09c.4 0 .78-.16 1.06-.44L8.2 3.5h2.29A2.5 2.5 0 0 1 13 6v3.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 1 9.5ZM14 6v3.5a3.5 3.5 0 0 1-3.5 3.5h-7c.46.6 1.18 1 2 1h5A4.5 4.5 0 0 0 15 9.5V8c0-.82-.4-1.54-1-2Z"
]);
const $cdb0ff5c001a8842$export$7fbc89f41cb5db8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple16Regular', "16", [
    "M3.5 3C2.67 3 2 3.67 2 4.5V5h3.09a.5.5 0 0 0 .35-.15L6.29 4l-.85-.85A.5.5 0 0 0 5.09 3H3.5ZM1 4.44A2.5 2.5 0 0 1 3.5 2h1.59c.4 0 .78.16 1.06.44L7.2 3.5h3.29A2.5 2.5 0 0 1 13 6v3.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 1 9.5V4.44Zm6.2.06L6.16 5.56A1.5 1.5 0 0 1 5.09 6H2v3.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5H7.2ZM14 6c.6.46 1 1.18 1 2v1.5a4.5 4.5 0 0 1-4.5 4.5h-5a2.5 2.5 0 0 1-2-1h7A3.5 3.5 0 0 0 14 9.5V6Z"
]);
const $cdb0ff5c001a8842$export$d52c30e37f766338 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple20Filled', "20", [
    "M17 7.76c.6.55 1 1.35 1 2.24v2a5 5 0 0 1-5 5H7a3 3 0 0 1-2.24-1H13a4 4 0 0 0 4-4V7.76ZM13 5a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8h4.88a2 2 0 0 0 1.41-.59L10.71 5H13ZM6.88 3a2 2 0 0 1 1.41.59l1.21 1.2-1.91 1.92a1 1 0 0 1-.71.29H2V6a3 3 0 0 1 3-3h1.88Z"
]);
const $cdb0ff5c001a8842$export$411675fbaaebe016 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple20Regular', "20", [
    "M17 7.76c.6.55 1 1.35 1 2.24v2a5 5 0 0 1-5 5H7a3 3 0 0 1-2.24-1H13a4 4 0 0 0 4-4V7.76ZM6.87 3a2 2 0 0 1 1.41.59L9.71 5H13a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.88Zm1.41 4.41A2 2 0 0 1 6.88 8H3v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H9.7L8.3 7.41ZM5 4a2 2 0 0 0-2 2v1h3.88a1 1 0 0 0 .7-.3L8.8 5.5 7.6 4.3a1 1 0 0 0-.71-.3H5Z"
]);
const $cdb0ff5c001a8842$export$5d47f08b6cb77e64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple24Filled', "24", [
    "M20.5 8.5c.9.58 1.5 1.6 1.5 2.75v4A5.75 5.75 0 0 1 16.25 21h-8.5c-1.15 0-2.17-.6-2.74-1.5h11.24c2.35 0 4.25-1.9 4.25-4.25V8.51Zm-4.25-3c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.46 3.25-3.25 3.25h-11A3.25 3.25 0 0 1 2 15.25V9.5h5.4c.58 0 1.14-.23 1.56-.63.8-.78 2.53-2.48 3.37-3.37h3.92ZM7.41 3c.57 0 1.12.22 1.54.62.4.39 1.03 1 1.58 1.57a215 215 0 0 1-2.62 2.6.74.74 0 0 1-.52.21H2V6.25C2 4.45 3.46 3 5.25 3h2.16Z"
]);
const $cdb0ff5c001a8842$export$581a31c575c76175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple24Regular', "24", [
    "M20.5 8.5c.9.58 1.5 1.6 1.5 2.75v4A5.75 5.75 0 0 1 16.25 21h-8.5c-1.15 0-2.17-.6-2.74-1.5h11.24c2.35 0 4.25-1.9 4.25-4.25V8.51ZM7.4 3c.58 0 1.13.22 1.55.62.48.46 1.27 1.23 1.88 1.88h5.42c1.8 0 3.25 1.46 3.25 3.25v6.5c0 1.8-1.46 3.25-3.25 3.25h-11A3.25 3.25 0 0 1 2 15.25v-9C2 4.45 3.46 3 5.25 3h2.16Zm3.43 4c-.6.65-1.4 1.42-1.88 1.88-.42.4-.97.62-1.54.62H3.5v5.75c0 .97.78 1.75 1.75 1.75h11c.97 0 1.75-.78 1.75-1.75v-6.5C18 7.78 17.22 7 16.25 7h-5.42ZM5.25 4.5c-.97 0-1.75.78-1.75 1.75V8h3.9c.2 0 .38-.07.51-.2.41-.4 1.04-1 1.56-1.55A59.41 59.41 0 0 0 7.91 4.7a.73.73 0 0 0-.5-.2H5.25Z"
]);
const $cdb0ff5c001a8842$export$104a0571d57b411f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple28Filled', "28", [
    "M24.47 9.23A3.74 3.74 0 0 1 26 12.25v5.5C26 21.2 23.2 24 19.75 24H8.25c-1.24 0-2.34-.6-3.02-1.53.17.02.35.03.52.03h14a4.75 4.75 0 0 0 4.75-4.75v-8c0-.18 0-.35-.03-.52ZM19.75 6a3.75 3.75 0 0 1 3.75 3.75v8a3.75 3.75 0 0 1-3.75 3.75h-14A3.75 3.75 0 0 1 2 17.75V10.5h6.17c.73 0 1.43-.29 1.95-.8L13.8 6h5.94ZM8.17 3c.73 0 1.43.29 1.95.8L12 5.7 9.06 8.63c-.24.24-.56.37-.89.37H2V6.75A3.75 3.75 0 0 1 5.75 3h2.42Z"
]);
const $cdb0ff5c001a8842$export$43d4e5d437cbdf0c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple28Regular', "28", [
    "M24.47 9.23A3.74 3.74 0 0 1 26 12.25v5.5C26 21.2 23.2 24 19.75 24H8.25c-1.24 0-2.34-.6-3.02-1.53.17.02.35.03.52.03h14a4.75 4.75 0 0 0 4.75-4.75v-8c0-.18 0-.35-.03-.52ZM8.17 3c.73 0 1.43.29 1.95.8L12.3 6h7.44a3.75 3.75 0 0 1 3.75 3.75v8a3.75 3.75 0 0 1-3.75 3.75h-14A3.75 3.75 0 0 1 2 17.75v-11A3.75 3.75 0 0 1 5.75 3h2.42Zm1.95 6.7c-.52.51-1.22.8-1.95.8H3.5v7.25C3.5 18.99 4.51 20 5.75 20h14C21 20 22 19 22 17.75v-8c0-1.24-1-2.25-2.25-2.25h-7.44l-2.2 2.2ZM5.75 4.5c-1.24 0-2.25 1-2.25 2.25V9h4.67c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75Z"
]);
const $cdb0ff5c001a8842$export$feb6cef32ad33711 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple32Filled', "32", [
    "M27.99 10.25c1.21.8 2 2.19 2 3.75v6a8 8 0 0 1-8 8H10a4.5 4.5 0 0 1-3.74-2H22a6 6 0 0 0 6-6v-9.5l-.01-.25ZM22 6a4.5 4.5 0 0 1 4.5 4.5V20a4.5 4.5 0 0 1-4.5 4.5H6.5A4.5 4.5 0 0 1 2 20v-9h7.96a3.5 3.5 0 0 0 2.48-1.03l3.77-3.76a1 1 0 0 0 .15-.21H22ZM9.96 3c.93 0 1.82.37 2.48 1.03L14 5.59l-2.97 2.97A1.5 1.5 0 0 1 9.96 9H2V7.5A4.5 4.5 0 0 1 6.5 3h3.46Z"
]);
const $cdb0ff5c001a8842$export$5b1e0bd80267d6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple32Regular', "32", [
    "M27.99 10.25c1.21.8 2 2.19 2 3.75v6a8 8 0 0 1-8 8H10a4.5 4.5 0 0 1-3.74-2H22a6 6 0 0 0 6-6v-9.5l-.01-.25ZM9.96 3c.93 0 1.82.37 2.48 1.03L14.41 6H22a4.5 4.5 0 0 1 4.5 4.5V20a4.5 4.5 0 0 1-4.5 4.5H6.5A4.5 4.5 0 0 1 2 20V7.5A4.5 4.5 0 0 1 6.5 3h3.46Zm2.48 6.97A3.5 3.5 0 0 1 9.96 11H4v9a2.5 2.5 0 0 0 2.5 2.5H22a2.5 2.5 0 0 0 2.5-2.5v-9.5A2.5 2.5 0 0 0 22 8h-7.59l-1.97 1.97ZM6.5 5A2.5 2.5 0 0 0 4 7.5V9h5.96c.4 0 .78-.16 1.07-.44L12.59 7l-1.56-1.56A1.5 1.5 0 0 0 9.96 5H6.5Z"
]);
const $cdb0ff5c001a8842$export$c9a7406d3c105943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple48Filled', "48", [
    "M41.48 15.74A6.24 6.24 0 0 1 44 20.75v9.5C44 36.19 39.19 41 33.25 41h-18.5a6.24 6.24 0 0 1-5.02-2.52l.52.02h23c4.55 0 8.25-3.7 8.25-8.25v-14c0-.17 0-.34-.02-.51ZM33.25 10c3.45 0 6.25 2.8 6.25 6.25v14c0 3.45-2.8 6.25-6.25 6.25h-23A6.25 6.25 0 0 1 4 30.25V17h11.76c1.12 0 2.2-.45 3-1.25L24.52 10h8.73Zm-17.5-4.5c1.13 0 2.22.45 3.01 1.25l2.74 2.73-4.5 4.5c-.33.34-.78.52-1.24.52H4v-2.75C4 8.3 6.8 5.5 10.25 5.5h5.5Z"
]);
const $cdb0ff5c001a8842$export$6e6e2f02c98e4902 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderMultiple48Regular', "48", [
    "M41.48 15.74A6.24 6.24 0 0 1 44 20.75v9.5C44 36.19 39.19 41 33.25 41h-18.5a6.24 6.24 0 0 1-5.02-2.52l.52.02h23c4.55 0 8.25-3.7 8.25-8.25v-14c0-.17 0-.34-.02-.51ZM15.76 5.5c1.12 0 2.2.45 3 1.25L22.02 10h11.23c3.45 0 6.25 2.8 6.25 6.25v14c0 3.45-2.8 6.25-6.25 6.25h-23A6.25 6.25 0 0 1 4 30.25v-18.5C4 8.3 6.8 5.5 10.25 5.5h5.5Zm3 10.25c-.8.8-1.88 1.25-3 1.25H6.5v13.25A3.75 3.75 0 0 0 10.25 34h23A3.75 3.75 0 0 0 37 30.25v-14a3.75 3.75 0 0 0-3.75-3.75H22.02l-3.26 3.25ZM10.25 8a3.75 3.75 0 0 0-3.75 3.75v2.75h9.26c.46 0 .9-.18 1.24-.51l2.73-2.74L17 8.51A1.75 1.75 0 0 0 15.76 8h-5.51Z"
]);
const $cdb0ff5c001a8842$export$19e16a61075adfae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen16Filled', "16", [
    "M1 4.5v4.97l1-1.72A3.5 3.5 0 0 1 5.01 6h7.93a2.5 2.5 0 0 0-2.45-2H7.2L5.66 2.44A1.5 1.5 0 0 0 4.59 2H3.5A2.5 2.5 0 0 0 1 4.5ZM5.02 7H13a2 2 0 0 1 1.73 3l-1.59 2.75A2.5 2.5 0 0 1 10.98 14H3a2 2 0 0 1-1.73-3l1.59-2.75A2.5 2.5 0 0 1 5.02 7Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ad18ab6762eea7cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen16Regular', "16", [
    "M2 4.5v4.6l.92-1.6A3 3 0 0 1 5.52 6h6.4c-.21-.58-.77-1-1.42-1H7a.5.5 0 0 1-.35-.15l-1.71-1.7A.5.5 0 0 0 4.59 3H3.5C2.67 3 2 3.67 2 4.5ZM7.07 14A.5.5 0 0 1 7 14H3.5A2.5 2.5 0 0 1 1 11.5v-7A2.5 2.5 0 0 1 3.5 2h1.09c.4 0 .78.16 1.06.44L7.2 4h3.29a2.5 2.5 0 0 1 2.46 2.04 2.5 2.5 0 0 1 1.7 3.71l-1.58 2.75a3 3 0 0 1-2.6 1.5H7.07ZM5.52 7A2 2 0 0 0 3.8 8L2.2 10.75A1.5 1.5 0 0 0 3.5 13h6.98a2 2 0 0 0 1.73-1l1.59-2.75A1.5 1.5 0 0 0 12.5 7H5.52Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c143d94da5945b56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen20Filled', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v6.97l1.57-2.72A3.5 3.5 0 0 1 6.6 8H16v-.5A2.5 2.5 0 0 0 13.5 5H9.7L8.16 3.44A1.5 1.5 0 0 0 7.09 3H4.5Zm-.07 7.25A2.5 2.5 0 0 1 6.6 9H17a2 2 0 0 1 1.73 3l-2.16 3.75A2.5 2.5 0 0 1 14.4 17H4a2 2 0 0 1-1.73-3l2.16-3.75Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1fad2891ebd54b46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen20Regular', "20", [
    "M3 5.5v6.6l1.5-2.6A3 3 0 0 1 7.1 8H15v-.5c0-.83-.67-1.5-1.5-1.5h-4a.5.5 0 0 1-.35-.15l-1.71-1.7A.5.5 0 0 0 7.09 4H4.5C3.67 4 3 4.67 3 5.5Zm1.28 10.48.22.02h9.4a2 2 0 0 0 1.73-1l2.17-3.75A1.5 1.5 0 0 0 16.5 9H7.1a2 2 0 0 0-1.73 1L3.2 13.75a1.5 1.5 0 0 0 1.08 2.23ZM2 14.46V5.5A2.5 2.5 0 0 1 4.5 3h2.59c.4 0 .78.16 1.06.44L9.7 5h3.79A2.5 2.5 0 0 1 16 7.5V8h.5a2.5 2.5 0 0 1 2.16 3.75L16.5 15.5a3 3 0 0 1-2.6 1.5H4.5a2.54 2.54 0 0 1-1.62-.6A2.5 2.5 0 0 1 2 14.46Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ddb3b82b55d0e31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen24Filled', "24", [
    "M5.25 3A3.25 3.25 0 0 0 2 6.25v8.91l2.04-3.54A4.25 4.25 0 0 1 7.73 9.5H20v-.75c0-1.8-1.46-3.25-3.25-3.25h-5.19L9.72 3.66c-.42-.42-1-.66-1.6-.66H5.26Zm2.48 8h13.01a2.25 2.25 0 0 1 1.95 3.37l-3.03 5.26c-.5.85-1.4 1.37-2.38 1.37H4.26a2.25 2.25 0 0 1-1.95-3.37l3.03-5.26c.5-.85 1.4-1.37 2.39-1.37Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$500e61c6971f6840 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen24Regular', "24", [
    "M3.5 6.25c0-.97.78-1.75 1.75-1.75h2.88c.2 0 .39.08.53.22l2.06 2.06c.14.14.33.22.53.22h5.5c.97 0 1.75.78 1.75 1.75 0 .09.01.17.04.25H8.72c-1.34 0-2.58.71-3.25 1.87L3.5 14.28V6.25ZM2 17.79A3.25 3.25 0 0 0 5.25 21h11.04c1.33 0 2.57-.72 3.24-1.88l3.03-5.25A3.25 3.25 0 0 0 19.96 9a.75.75 0 0 0 .04-.25c0-1.8-1.45-3.25-3.25-3.25h-5.19L9.72 3.66c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25V17.79Zm6.72-7.3h11.03a1.75 1.75 0 0 1 1.51 2.63l-3.03 5.25c-.4.7-1.14 1.13-1.95 1.13H5.25a1.75 1.75 0 0 1-1.51-2.63l3.03-5.25c.4-.7 1.14-1.12 1.95-1.12Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3d017608e2b36d61 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen28Filled', "28", [
    "M5.75 3A3.75 3.75 0 0 0 2 6.75v11.76l2.65-5.53A5.25 5.25 0 0 1 9.4 10H23v-.25A3.75 3.75 0 0 0 19.25 6h-5.59a.25.25 0 0 1-.17-.07L11.37 3.8A2.75 2.75 0 0 0 9.42 3H5.75ZM2.12 21.76l-.01.03a1.64 1.64 0 0 0 1.53 2.2h15.97c1.34 0 2.58-.7 3.25-1.86l3.77-6.5a2.75 2.75 0 0 0-2.38-4.13H9.39c-1.44 0-2.76.83-3.38 2.13l-3.85 8.02-.04.11Z"
]);
const $cdb0ff5c001a8842$export$3f517a9ca79cdb4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpen28Regular', "28", [
    "M5.75 3A3.75 3.75 0 0 0 2 6.75v14.3A2.86 2.86 0 0 0 4.88 24h14.6c1.34 0 2.58-.71 3.25-1.87l3.77-6.5A3.75 3.75 0 0 0 23.24 10H23v-.25A3.75 3.75 0 0 0 19.25 6h-5.59a.25.25 0 0 1-.17-.07L11.37 3.8A2.75 2.75 0 0 0 9.42 3H5.75Zm15.75 7H9.39c-1.44 0-2.76.83-3.38 2.13l-2.5 5.23V6.75c0-1.24 1-2.25 2.24-2.25h3.67c.33 0 .65.13.89.37l2.12 2.12c.33.33.77.51 1.23.51h5.59c1.24 0 2.25 1 2.25 2.25V10Zm-2.03 12.5H4.87a1.36 1.36 0 0 1-1.23-1.95l3.72-7.77a2.25 2.25 0 0 1 2.03-1.28h13.85a2.25 2.25 0 0 1 1.95 3.38l-3.77 6.5c-.4.7-1.15 1.12-1.95 1.12Z"
]);
const $cdb0ff5c001a8842$export$e1d6cdd4f5018324 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown16Filled', "16", [
    "M1 11.5V6.53l1 1.72A3.5 3.5 0 0 0 5.01 10h7.93a2.5 2.5 0 0 1-2.45 2H7.2l-1.55 1.56a1.5 1.5 0 0 1-1.06.44H3.5A2.5 2.5 0 0 1 1 11.5ZM5.02 9H13a2 2 0 0 0 1.73-3l-1.59-2.75A2.5 2.5 0 0 0 10.98 2H3a2 2 0 0 0-1.73 3l1.59 2.75A2.5 2.5 0 0 0 5.02 9Z"
]);
const $cdb0ff5c001a8842$export$77cc83f3510a112d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown16Regular', "16", [
    "M2 11.5V6.9l.92 1.6a3 3 0 0 0 2.6 1.5h6.4c-.21.58-.77 1-1.42 1H7a.5.5 0 0 0-.35.15l-1.71 1.7a.5.5 0 0 1-.35.15H3.5A1.5 1.5 0 0 1 2 11.5ZM7.07 2A.5.5 0 0 0 7 2H3.5A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h1.09c.4 0 .78-.16 1.06-.44L7.2 12h3.29a2.5 2.5 0 0 0 2.46-2.04 2.5 2.5 0 0 0 1.7-3.71L13.08 3.5a3 3 0 0 0-2.6-1.5H7.07ZM5.52 9A2 2 0 0 1 3.8 8L2.2 5.25A1.5 1.5 0 0 1 3.5 3h6.98a2 2 0 0 1 1.73 1l1.59 2.75A1.5 1.5 0 0 1 12.5 9H5.52Z"
]);
const $cdb0ff5c001a8842$export$aae55a69808bf56a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown20Filled', "20", [
    "M4.5 17A2.5 2.5 0 0 1 2 14.5V7.53l1.57 2.72A3.5 3.5 0 0 0 6.6 12H16v.5a2.5 2.5 0 0 1-2.5 2.5H9.7l-1.55 1.56a1.5 1.5 0 0 1-1.06.44H4.5Zm-.07-7.25A2.5 2.5 0 0 0 6.6 11H17a2 2 0 0 0 1.73-3l-2.16-3.75A2.5 2.5 0 0 0 14.4 3H4a2 2 0 0 0-1.73 3l2.16 3.75Z"
]);
const $cdb0ff5c001a8842$export$4de85368af242f00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown20Regular', "20", [
    "M3 14.5V7.9l1.5 2.6A3 3 0 0 0 7.1 12H15v.5c0 .83-.67 1.5-1.5 1.5h-4a.5.5 0 0 0-.35.15l-1.71 1.7a.5.5 0 0 1-.35.15H4.5A1.5 1.5 0 0 1 3 14.5ZM4.28 4.02 4.5 4h9.4a2 2 0 0 1 1.73 1l2.17 3.75A1.5 1.5 0 0 1 16.5 11H7.1a2 2 0 0 1-1.73-1L3.2 6.25a1.5 1.5 0 0 1 1.08-2.23ZM2 5.54v8.96A2.5 2.5 0 0 0 4.5 17h2.59c.4 0 .78-.16 1.06-.44L9.7 15h3.79a2.5 2.5 0 0 0 2.5-2.5V12h.5a2.5 2.5 0 0 0 2.16-3.75L16.5 4.5A3 3 0 0 0 13.9 3H4.5a2.54 2.54 0 0 0-1.62.6A2.5 2.5 0 0 0 2 5.54Z"
]);
const $cdb0ff5c001a8842$export$6d9210a95c9e9317 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown24Filled', "24", [
    "M5.25 21A3.25 3.25 0 0 1 2 17.75v-8.9l2.04 3.53a4.25 4.25 0 0 0 3.69 2.13H20v.74c0 1.8-1.46 3.25-3.25 3.25h-5.19l-1.84 1.85c-.42.42-1 .65-1.6.65H5.26Zm2.48-8h13.01a2.25 2.25 0 0 0 1.95-3.37l-3.03-5.26A2.75 2.75 0 0 0 17.28 3H4.26A2.25 2.25 0 0 0 2.3 6.37l3.03 5.26c.5.85 1.4 1.38 2.39 1.38Z"
]);
const $cdb0ff5c001a8842$export$38daf38a18e9a41a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown24Regular', "24", [
    "M3.5 17.75c0 .97.78 1.75 1.75 1.75h2.88c.2 0 .39-.08.53-.22l2.06-2.06a.75.75 0 0 1 .53-.22h5.5c.97 0 1.75-.78 1.75-1.75 0-.09.01-.17.04-.25H8.72a3.75 3.75 0 0 1-3.25-1.87L3.5 9.72v8.03ZM2 6.21A3.25 3.25 0 0 1 5.25 3h11.04c1.33 0 2.57.72 3.24 1.88l3.03 5.25a3.25 3.25 0 0 1-2.6 4.87c.02.08.04.16.04.25 0 1.8-1.45 3.25-3.25 3.25h-5.19l-1.84 1.84c-.42.42-1 .66-1.6.66H5.26A3.25 3.25 0 0 1 2 17.75V6.21Zm6.72 7.3h11.03a1.75 1.75 0 0 0 1.51-2.63l-3.03-5.25a2.25 2.25 0 0 0-1.95-1.13H5.25a1.75 1.75 0 0 0-1.51 2.63l3.03 5.25c.4.7 1.14 1.12 1.95 1.12Z"
]);
const $cdb0ff5c001a8842$export$ec3219a76d7d9d68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown28Filled', "28", [
    "M5.75 25A3.75 3.75 0 0 1 2 21.25V9.48l2.65 5.53A5.25 5.25 0 0 0 9.4 18H23v.25A3.75 3.75 0 0 1 19.25 22h-5.59a.25.25 0 0 0-.17.07l-2.12 2.12c-.52.52-1.22.8-1.95.8H5.75ZM2.12 6.23l-.01-.02A1.64 1.64 0 0 1 3.64 4h15.97c1.34 0 2.58.71 3.25 1.87l3.77 6.5a2.75 2.75 0 0 1-2.38 4.13H9.39A3.75 3.75 0 0 1 6 14.37L2.16 6.34a1.64 1.64 0 0 1-.04-.1Z"
]);
const $cdb0ff5c001a8842$export$e5e5bd7fba19ee03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenDown28Regular', "28", [
    "M5.75 25A3.75 3.75 0 0 1 2 21.25V6.95A2.87 2.87 0 0 1 4.88 4h14.6c1.34 0 2.58.71 3.25 1.87l3.77 6.5A3.75 3.75 0 0 1 23.24 18H23v.25A3.75 3.75 0 0 1 19.25 22h-5.59a.25.25 0 0 0-.17.07l-2.12 2.12c-.52.52-1.22.81-1.95.81H5.75Zm15.75-7H9.39A3.75 3.75 0 0 1 6 15.87l-2.5-5.23v10.61c0 1.24 1 2.25 2.24 2.25h3.67c.33 0 .65-.13.89-.37l2.12-2.12c.33-.33.77-.51 1.23-.51h5.59c1.24 0 2.25-1 2.25-2.25V18ZM19.47 5.5H4.87a1.36 1.36 0 0 0-1.23 1.95l3.72 7.77a2.25 2.25 0 0 0 2.03 1.28h13.85a2.25 2.25 0 0 0 1.95-3.38l-3.77-6.5a2.25 2.25 0 0 0-1.95-1.12Z"
]);
const $cdb0ff5c001a8842$export$908e711d7460b5f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical16Filled', "16", [
    "M11.5 1H6.53l1.72 1A3.5 3.5 0 0 1 10 5.01v7.93a2.5 2.5 0 0 0 2-2.45V7.2l1.56-1.55c.28-.28.44-.67.44-1.06V3.5A2.5 2.5 0 0 0 11.5 1ZM9 5.02V13a2 2 0 0 1-3 1.73l-2.75-1.59A2.5 2.5 0 0 1 2 10.98V3a2 2 0 0 1 3-1.73l2.75 1.59A2.5 2.5 0 0 1 9 5.02Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e0ec99b270325676 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical16Regular', "16", [
    "M11.5 2H6.9l1.6.92a3 3 0 0 1 1.5 2.6v6.4c.58-.21 1-.77 1-1.42V7a.5.5 0 0 1 .15-.35l1.7-1.71a.5.5 0 0 0 .15-.35V3.5c0-.83-.67-1.5-1.5-1.5ZM2 7.07A.5.5 0 0 1 2 7V3.5A2.5 2.5 0 0 1 4.5 1h7A2.5 2.5 0 0 1 14 3.5v1.09c0 .4-.16.78-.44 1.06L12 7.2v3.29a2.5 2.5 0 0 1-2.04 2.46 2.5 2.5 0 0 1-3.71 1.7L3.5 13.08a3 3 0 0 1-1.5-2.6V7.07Zm7-1.55A2 2 0 0 0 8 3.8L5.25 2.2A1.5 1.5 0 0 0 3 3.5v6.98a2 2 0 0 0 1 1.73l2.75 1.59A1.5 1.5 0 0 0 9 12.5V5.52Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$29b8516e20a9bc2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical20Filled', "20", [
    "M17 4.5A2.5 2.5 0 0 0 14.5 2H7.53l2.72 1.57A3.5 3.5 0 0 1 12 6.6V16h.5a2.5 2.5 0 0 0 2.5-2.5V9.7l1.56-1.55c.28-.28.44-.67.44-1.06V4.5Zm-7.25-.07A2.5 2.5 0 0 1 11 6.6V17a2 2 0 0 1-3 1.73l-3.75-2.16A2.5 2.5 0 0 1 3 14.4V4a2 2 0 0 1 3-1.73l3.75 2.16Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$5e37fbf3be69228c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical20Regular', "20", [
    "M14.5 3H7.9l2.6 1.5A3 3 0 0 1 12 7.1V15h.5c.83 0 1.5-.67 1.5-1.5v-4a.5.5 0 0 1 .15-.35l1.7-1.71a.5.5 0 0 0 .15-.35V4.5c0-.83-.67-1.5-1.5-1.5ZM4.02 4.28 4 4.5v9.4a2 2 0 0 0 1 1.73l3.75 2.17A1.5 1.5 0 0 0 11 16.5V7.1a2 2 0 0 0-1-1.73L6.25 3.2a1.5 1.5 0 0 0-2.23 1.08ZM5.54 2h8.96A2.5 2.5 0 0 1 17 4.5v2.59c0 .4-.16.77-.44 1.06L15 9.7v3.79a2.5 2.5 0 0 1-2.5 2.5H12v.5a2.5 2.5 0 0 1-3.75 2.16L4.5 16.5A3 3 0 0 1 3 13.9V4.5a2.54 2.54 0 0 1 .6-1.62A2.5 2.5 0 0 1 5.54 2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$30211e8f41d2cdff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical24Filled', "24", [
    "M21 5.25C21 3.45 19.55 2 17.75 2H8.84l3.54 2.04a4.25 4.25 0 0 1 2.12 3.69V20h.75c1.8 0 3.25-1.46 3.25-3.25v-5.19l1.84-1.84c.42-.42.66-1 .66-1.6V5.26Zm-8 2.48v13.01a2.25 2.25 0 0 1-3.37 1.95l-5.26-3.03A2.75 2.75 0 0 1 3 17.28V4.26A2.25 2.25 0 0 1 6.37 2.3l5.26 3.03c.85.5 1.37 1.4 1.37 2.39Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6d14b21d19a8f49e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderOpenVertical24Regular', "24", [
    "M17.75 3.5c.97 0 1.75.78 1.75 1.75v2.88c0 .2-.08.39-.22.53l-2.06 2.06a.75.75 0 0 0-.22.53v5.5c0 .97-.78 1.75-1.75 1.75a.75.75 0 0 0-.25.04V8.72c0-1.34-.71-2.58-1.87-3.25L9.72 3.5h8.03ZM6.21 2A3.25 3.25 0 0 0 3 5.25v11.04c0 1.33.72 2.57 1.88 3.24l5.25 3.03a3.25 3.25 0 0 0 4.87-2.6c.08.02.16.04.25.04 1.8 0 3.25-1.45 3.25-3.25v-5.19l1.84-1.84c.42-.42.66-1 .66-1.6V5.26C21 3.45 19.54 2 17.75 2H6.21Zm7.3 6.72v11.03a1.75 1.75 0 0 1-2.63 1.51l-5.25-3.03a2.25 2.25 0 0 1-1.13-1.95V5.25a1.75 1.75 0 0 1 2.63-1.51l5.25 3.03c.7.4 1.12 1.14 1.12 1.95Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fcd7f2ca060ff553 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h4.52a2.6 2.6 0 0 1 1.93-2.92 2.75 2.75 0 1 1 4.54-3 2.24 2.24 0 0 1 2.51-.35V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm12.75 4.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6Zm.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35c.34.44.55 1 .55 1.6 0 .46-.09.95-.3 1.4Z"
]);
const $cdb0ff5c001a8842$export$55de418d0b54761e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h4.52a2.6 2.6 0 0 1 .05-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v3c.36 0 .7.08 1 .23V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm11.75 6.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm3.5.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM16 16.6c0 1.18-.8 2.4-3 2.4s-3-1.22-3-2.4c0-.88.72-1.6 1.6-1.6h2.8c.88 0 1.6.72 1.6 1.6Zm.7 1.4h.05c1.65 0 2.25-.91 2.25-1.8 0-.66-.54-1.2-1.2-1.2h-1.35c.34.44.55 1 .55 1.6 0 .46-.09.95-.3 1.4Z"
]);
const $cdb0ff5c001a8842$export$77e202914547f38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h5.87a4.31 4.31 0 0 1-.12-1 3 3 0 0 1 2.33-2.93A2.99 2.99 0 0 1 15.5 12a3 3 0 0 1 2.88 2.17A2.5 2.5 0 0 1 22 13.5V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2ZM15.5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3Zm4-1.02.5.02c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.16c.47.53.76 1.23.76 2 0 .66-.14 1.35-.5 1.98ZM22 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
]);
const $cdb0ff5c001a8842$export$cebfc8f0d5a5e0e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPeople24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.75c-.42-.31-.94-.5-1.5-.5V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h5.8a4.31 4.31 0 0 0 .07 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM15.5 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 6c2.57 0 3.5-1.52 3.5-3a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2c0 1.48.93 3 3.5 3Zm4-1.02.5.02c2.2 0 3-1.22 3-2.4 0-.88-.72-1.6-1.6-1.6h-2.16c.47.53.76 1.23.76 2 0 .66-.14 1.35-.5 1.98ZM22 15.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
]);
const $cdb0ff5c001a8842$export$15e4c7ad738fee37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5V6h4.59a.5.5 0 0 0 .35-.15L8 3.8 6.65 2.44A1.5 1.5 0 0 0 5.59 2H3.5ZM1 11.5V7h4.59c.4 0 .78-.16 1.06-.44L9.2 4h3.29A2.5 2.5 0 0 1 15 6.5v.84a3 3 0 1 0-4.73 3.67A2.5 2.5 0 0 0 8.04 14H3.5A2.5 2.5 0 0 1 1 11.5ZM14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $cdb0ff5c001a8842$export$624aab655db9af8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson16Regular', "16", [
    "M2 6V4.5C2 3.67 2.67 3 3.5 3h2.09a.5.5 0 0 1 .35.15L7.29 4.5 5.94 5.85a.5.5 0 0 1-.35.15H2Zm1.5-4A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h4.54a3.29 3.29 0 0 1 .01-1H3.5A1.5 1.5 0 0 1 2 11.5V7h3.59c.4 0 .78-.16 1.06-.44L8.2 5h4.29c.8 0 1.44.62 1.5 1.4.4.23.74.55 1 .94V6.5A2.5 2.5 0 0 0 12.5 4H8.2L6.66 2.44A1.5 1.5 0 0 0 5.59 2H3.5Zm11 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $cdb0ff5c001a8842$export$fc92ba0b56bf8bb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson20Filled', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5V7h5.09a.5.5 0 0 0 .35-.15L9.5 4.8 8.22 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79A2.5 2.5 0 0 1 18 7.5v2.84a3 3 0 1 0-4.73 3.67A2.5 2.5 0 0 0 11.04 17H4.5A2.5 2.5 0 0 1 2 14.5ZM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $cdb0ff5c001a8842$export$eadca07819411a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson20Regular', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v2.84c-.26-.38-.6-.7-1-.94V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h6.55a2.51 2.51 0 0 0-.01 1H4.5A2.5 2.5 0 0 1 2 14.5v-9ZM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.75.75 0 0 0 6.98 4H4.5Zm13 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $cdb0ff5c001a8842$export$3dc709ff1bef6678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson24Filled', "24", [
    "M2 6.25V8h6.13c.2 0 .39-.08.53-.22l2.59-2.6-1.53-1.52c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25Zm0 11.5V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69c1.8 0 3.25 1.46 3.25 3.25v5.75a3.5 3.5 0 1 0-5.95 2.5h-.28A2.77 2.77 0 0 0 13 19.77v.1c0 .38.06.76.17 1.13H5.25A3.25 3.25 0 0 1 2 17.75Zm19-3.25a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $cdb0ff5c001a8842$export$bfa086208f7fd30a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson24Regular', "24", [
    "M3.5 8V6.25c0-.97.78-1.75 1.75-1.75h2.88c.2 0 .39.08.53.22l1.53 1.53-1.53 1.53a.75.75 0 0 1-.53.22H3.5Zm1.75-5A3.25 3.25 0 0 0 2 6.25v11.5C2 19.55 3.46 21 5.25 21h7.92a3.74 3.74 0 0 1-.17-1.13v-.1l.01-.27H5.25c-.97 0-1.75-.78-1.75-1.75V9.5h4.63c.6 0 1.17-.24 1.59-.66L11.56 7h7.19c.97 0 1.75.78 1.75 1.75v2.88A3.5 3.5 0 0 1 22 14.5V8.75c0-1.8-1.46-3.25-3.25-3.25h-7.19L9.72 3.66c-.42-.42-1-.66-1.6-.66H5.26ZM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $cdb0ff5c001a8842$export$9e8694636165c164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson28Filled', "28", [
    "M5.75 3A3.75 3.75 0 0 0 2 6.75V9h7.42c.33 0 .65-.13.89-.37l2.94-2.94-1.88-1.88A2.75 2.75 0 0 0 9.42 3H5.75ZM2 20.25V10.5h7.42c.73 0 1.43-.29 1.95-.8l3.7-3.7h7.18A3.75 3.75 0 0 1 26 9.75V17h-.5a4 4 0 1 0-6.65 3h-.8A3.04 3.04 0 0 0 15 23.04v.21c0 .25.02.5.07.75H5.75A3.75 3.75 0 0 1 2 20.25ZM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.5 6.25c0 1.87-1.57 3.75-5.5 3.75-3.93 0-5.5-1.88-5.5-3.75v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04v.21Z"
]);
const $cdb0ff5c001a8842$export$e75239a7136d7945 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson28Regular', "28", [
    "M3.5 6.75v-.07A2.25 2.25 0 0 1 5.75 4.5h3.67c.33 0 .65.13.89.37l1.88 1.88-1.88 1.88c-.24.24-.56.37-.89.37H3.5V6.75Zm-1.5 3v10.5A3.75 3.75 0 0 0 5.75 24h9.32c-.05-.25-.07-.5-.07-.75v-.2c0-.2.02-.37.05-.55h-9.3c-1.24 0-2.25-1-2.25-2.25V10.5h5.92c.73 0 1.43-.29 1.95-.8l2.2-2.2h8.68c1.24 0 2.25 1 2.25 2.25v4.6c.62.71 1 1.64 1 2.65h.5V9.75A3.75 3.75 0 0 0 22.25 6h-8.69l-2.2-2.2A2.75 2.75 0 0 0 9.43 3H5.75A3.75 3.75 0 0 0 2 6.75v3ZM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.5 6.25c0 1.87-1.57 3.75-5.5 3.75-3.93 0-5.5-1.88-5.5-3.75v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04v.21Z"
]);
const $cdb0ff5c001a8842$export$aebfac0f6661d28b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson32Filled', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5V11h8.46c.4 0 .78-.16 1.07-.44L15 7.1l-2.06-2.06A3.5 3.5 0 0 0 10.46 4H6.5ZM2 23.5V13h8.46a3.5 3.5 0 0 0 2.48-1.03L17.4 7.5h8.09A4.5 4.5 0 0 1 30 12v7h-.02a5 5 0 1 0-8.55 4h-.01a3.93 3.93 0 0 0-3.92 3.94 5 5 0 0 0 .11 1.06H6.5A4.5 4.5 0 0 1 2 23.5Zm26.5-4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06a2.43 2.43 0 0 1 2.42-2.44h7.16c1.34 0 2.42 1.1 2.42 2.44Z"
]);
const $cdb0ff5c001a8842$export$9a716a537fa6fa91 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson32Regular', "32", [
    "M4 11V8.5A2.5 2.5 0 0 1 6.5 6h3.96c.4 0 .78.16 1.07.44l2.06 2.06-2.06 2.06a1.5 1.5 0 0 1-1.07.44H4Zm2.5-7A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h11.11a5 5 0 0 1 0-2H6.5A2.5 2.5 0 0 1 4 23.5V13h6.46a3.5 3.5 0 0 0 2.48-1.03L15.4 9.5H25.5A2.5 2.5 0 0 1 28 12v3.5a5 5 0 0 1 1.98 3.5H30v-7a4.5 4.5 0 0 0-4.5-4.5H15.41l-2.47-2.47A3.5 3.5 0 0 0 10.46 4H6.5Zm22 15.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm2.5 7.44c0 2.02-1.71 4.06-6 4.06s-6-2.03-6-4.06a2.43 2.43 0 0 1 2.42-2.44h7.16c1.34 0 2.42 1.1 2.42 2.44Z"
]);
const $cdb0ff5c001a8842$export$91f7a70b2a2632fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson48Filled', "48", [
    "M10.25 6A6.25 6.25 0 0 0 4 12.25V16h12.71c.34 0 .65-.13.89-.37l5.15-5.15-3.38-3.38C18.67 6.4 17.7 6 16.7 6h-6.46ZM4 34.75V18.5h12.71c1 0 1.95-.4 2.66-1.1l6.4-6.4h11.98C41.2 11 44 13.8 44 17.25V29a7 7 0 1 0-11.9 5H31a5 5 0 0 0-5 5v.5c0 .51.05 1.01.15 1.5h-15.9A6.25 6.25 0 0 1 4 34.75ZM42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v.5Z"
]);
const $cdb0ff5c001a8842$export$456531f495db9677 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderPerson48Regular', "48", [
    "M6.5 16v-3.75a3.75 3.75 0 0 1 3.75-3.75h6.46c.34 0 .65.13.89.37l3.38 3.38-3.38 3.38c-.24.24-.55.37-.89.37H6.5Zm3.75-10A6.25 6.25 0 0 0 4 12.25v22.5C4 38.2 6.8 41 10.25 41h15.9c-.1-.49-.15-.99-.15-1.5V39c0-.17 0-.34.02-.5H10.25a3.75 3.75 0 0 1-3.75-3.75V18.5h10.21c1 0 1.95-.4 2.66-1.1l3.9-3.9h14.48a3.75 3.75 0 0 1 3.75 3.75v6.39A6.98 6.98 0 0 1 44 29V17.25C44 13.8 41.2 11 37.75 11H23.27l-3.9-3.9C18.67 6.4 17.7 6 16.7 6h-6.46ZM42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v.5Z"
]);
const $cdb0ff5c001a8842$export$1607886dae23522e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm6 4.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"
]);
const $cdb0ff5c001a8842$export$a23aa322810fc6f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm6 7a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"
]);
const $cdb0ff5c001a8842$export$51249d8510360eb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm8 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"
]);
const $cdb0ff5c001a8842$export$81dfc1c0b282afe5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm7 9a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"
]);
const $cdb0ff5c001a8842$export$7d3255d4588745b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm21 8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3Zm4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69Z"
]);
const $cdb0ff5c001a8842$export$73bdca25564c50dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a6.52 6.52 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06c.18.53.42 1.04.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-9.5 0c0 .83.26 1.6.7 2.25l5.55-5.56a4 4 0 0 0-6.25 3.3Zm4 4a4 4 0 0 0 3.3-6.25l-5.55 5.56c.64.44 1.42.69 2.25.69Z"
]);
const $cdb0ff5c001a8842$export$a7be6f245e6d1fc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited28Filled', "28", [
    "M2 6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l1.88 1.89-2.94 2.94c-.24.24-.56.37-.89.37H2V6.75Zm0 3.75v9.75A3.75 3.75 0 0 0 5.75 24h8.75A7.5 7.5 0 0 1 26 14.4V9.75A3.75 3.75 0 0 0 22.25 6h-7.19l-3.7 3.7c-.51.51-1.2.8-1.94.8H2ZM20.5 26a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0-1.5a4.98 4.98 0 0 1-2.97-.97l7-7a5 5 0 0 1-4.03 7.97Zm2.97-9.03-7 7a5 5 0 0 1 7-7Z"
]);
const $cdb0ff5c001a8842$export$828d220f8d97349f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited28Regular', "28", [
    "M3.5 6.68V9h5.92c.33 0 .65-.13.89-.37l1.88-1.88-1.88-1.88a1.25 1.25 0 0 0-.89-.37H5.75c-1.22 0-2.21.97-2.25 2.18ZM2 9.83V6.75A3.75 3.75 0 0 1 5.75 3h3.67c.73 0 1.43.29 1.95.8l2.2 2.2h8.68A3.75 3.75 0 0 1 26 9.75v4.65c-.44-.48-.95-.9-1.5-1.25v-3.4c0-1.24-1-2.25-2.25-2.25h-8.69l-2.2 2.2c-.51.51-1.2.8-1.94.8H3.5v9.75c0 1.24 1.01 2.25 2.25 2.25h7.87c.24.54.53 1.04.88 1.5H5.75A3.75 3.75 0 0 1 2 20.25V9.83ZM20.5 26a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0-1.5a4.98 4.98 0 0 1-2.97-.97l7-7a5 5 0 0 1-4.03 7.97Zm2.97-9.03-7 7a5 5 0 0 1 7-7Z"
]);
const $cdb0ff5c001a8842$export$92896d56835b5bfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15 7.09l-3.47 3.47a1.5 1.5 0 0 1-1.07.44H2V8.5ZM2 13v10.5A4.5 4.5 0 0 0 6.5 28h10.02A9 9 0 0 1 30 16.3V12a4.5 4.5 0 0 0-4.5-4.5h-8.09l-4.47 4.47A3.5 3.5 0 0 1 10.46 13H2Zm22 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-2a5.48 5.48 0 0 1-3.12-.97l7.65-7.65A5.5 5.5 0 0 1 24 28.5Zm3.12-10.03-7.65 7.65a5.5 5.5 0 0 1 7.65-7.65Z"
]);
const $cdb0ff5c001a8842$export$64d4a7360bfa740d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited32Regular', "32", [
    "M4 8.5V11h6.46c.4 0 .78-.16 1.07-.44l2.06-2.06-2.06-2.06A1.5 1.5 0 0 0 10.46 6H6.5A2.5 2.5 0 0 0 4 8.5Zm-2 0A4.5 4.5 0 0 1 6.5 4h3.96c.93 0 1.82.37 2.48 1.03L15.4 7.5H25.5A4.5 4.5 0 0 1 30 12v4.3c-.6-.55-1.27-1-2-1.36V12a2.5 2.5 0 0 0-2.5-2.5H15.41l-2.47 2.47A3.5 3.5 0 0 1 10.46 13H4v10.5A2.5 2.5 0 0 0 6.5 26h9.01c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15Zm22 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-2a5.48 5.48 0 0 1-3.12-.97l7.65-7.65A5.5 5.5 0 0 1 24 28.5Zm3.12-10.03-7.65 7.65a5.5 5.5 0 0 1 7.65-7.65Z"
]);
const $cdb0ff5c001a8842$export$1584824f0540934c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited48Filled', "48", [
    "M4 12.25C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.38 3.38-5.15 5.15c-.24.24-.55.37-.89.37H4v-3.75Zm0 6.25v16.25C4 38.2 6.8 41 10.25 41h13.8A13 13 0 0 1 44 24.62v-7.37C43.99 13.8 41.2 11 37.74 11H25.77l-6.4 6.4c-.7.7-1.66 1.1-2.66 1.1H4ZM35 45a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm0-2.5c-1.9 0-3.65-.62-5.06-1.67l11.89-11.9A8.5 8.5 0 0 1 35 42.5Zm5.06-15.33-11.89 11.9a8.5 8.5 0 0 1 11.9-11.9Z"
]);
const $cdb0ff5c001a8842$export$c94a2a983c654f9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderProhibited48Regular', "48", [
    "M6.5 12.25V16h10.21c.34 0 .65-.13.89-.37l3.38-3.38-3.38-3.38a1.25 1.25 0 0 0-.89-.37h-6.46a3.75 3.75 0 0 0-3.75 3.75Zm-2.5 0C4 8.8 6.8 6 10.25 6h6.46c1 0 1.95.4 2.66 1.1l3.9 3.9h14.48C41.2 11 44 13.8 44 17.25v7.37c-.75-.72-1.6-1.36-2.5-1.88v-5.49a3.75 3.75 0 0 0-3.75-3.75H23.27l-3.9 3.9c-.7.7-1.66 1.1-2.66 1.1H6.5v16.25a3.75 3.75 0 0 0 3.75 3.75H22.8c.33.88.74 1.72 1.24 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-22.5ZM35 45a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm0-2.5c-1.9 0-3.65-.62-5.06-1.67l11.89-11.9A8.5 8.5 0 0 1 35 42.5Zm5.06-15.33-11.89 11.9a8.5 8.5 0 0 1 11.9-11.9Z"
]);
const $cdb0ff5c001a8842$export$7a90f22b36758c52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5V6h4.59a.5.5 0 0 0 .35-.15L8 3.8 6.65 2.44A1.5 1.5 0 0 0 5.59 2H3.5ZM1 11.5V7h4.59c.4 0 .78-.16 1.06-.44L9.2 4h3.29A2.5 2.5 0 0 1 15 6.5V10h-.03a4.5 4.5 0 1 0-7.3 4H3.5A2.5 2.5 0 0 1 1 11.5Zm9.5 2.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 12.6a3.5 3.5 0 1 0-2.8 1.4Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$2ccd8ffbfbdec873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch16Regular', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.5 14h4.17a4.53 4.53 0 0 1-.91-1H3.5A1.5 1.5 0 0 1 2 11.5V7h3.59c.4 0 .78-.16 1.06-.44L8.2 5h4.29c.83 0 1.5.67 1.5 1.5v1.17c.53.65.88 1.45.97 2.33H15V6.5A2.5 2.5 0 0 0 12.5 4H8.2L6.66 2.44A1.5 1.5 0 0 0 5.59 2H3.5ZM2 6V4.5C2 3.67 2.67 3 3.5 3h2.09a.5.5 0 0 1 .35.15L7.29 4.5 5.94 5.85a.5.5 0 0 1-.35.15H2Zm8.5 8c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L13.3 12.6a3.5 3.5 0 1 0-2.8 1.4Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$c19f7124bc90ec5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch20Filled', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5V7h5.09a.5.5 0 0 0 .35-.15L9.5 4.8 8.22 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79A2.5 2.5 0 0 1 18 7.5V12h-.03A4.5 4.5 0 1 0 13 16.97V17H4.5A2.5 2.5 0 0 1 2 14.5ZM13.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 14.6a3.5 3.5 0 1 0-2.8 1.4Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$7cd2d5a500d8d5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch20Regular', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5V12h-.03A4.48 4.48 0 0 0 17 9.67V7.5c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5h6.17c.65.53 1.45.88 2.33.97V17H4.5A2.5 2.5 0 0 1 2 14.5v-9ZM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.75.75 0 0 0 6.98 4H4.5Zm9 12c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 14.6a3.5 3.5 0 1 0-2.8 1.4Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"
]);
const $cdb0ff5c001a8842$export$544adf2310035877 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch24Filled', "24", [
    "M2 6.25V8h6.13c.2 0 .39-.08.53-.22l2.59-2.6-1.53-1.52c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25Zm0 11.5V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69c1.8 0 3.25 1.46 3.25 3.25V15h-.02a5.5 5.5 0 1 0-5.48 6H5.25A3.25 3.25 0 0 1 2 17.75ZM16.5 21c.17 0 .34 0 .5-.02V21h-.5Zm0-1c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 16.5 20Zm0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
]);
const $cdb0ff5c001a8842$export$67550ebb27033d87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSearch24Regular', "24", [
    "M5.25 3A3.25 3.25 0 0 0 2 6.25v11.5C2 19.55 3.46 21 5.25 21H17v-.02a5.59 5.59 0 0 1-4.27-1.48H5.25c-.97 0-1.75-.78-1.75-1.75V9.5h4.63c.6 0 1.17-.24 1.59-.66L11.56 7h7.19c.97 0 1.75.78 1.75 1.75v2.98A5.48 5.48 0 0 1 21.98 15H22V8.75c0-1.8-1.46-3.25-3.25-3.25h-7.19L9.72 3.66c-.42-.42-1-.66-1.6-.66H5.26ZM3.5 8V6.25c0-.97.78-1.75 1.75-1.75h2.88c.2 0 .39.08.53.22l1.53 1.53-1.53 1.53a.75.75 0 0 1-.53.22H3.5Zm13 12c.97 0 1.87-.3 2.6-.83l2.62 2.61a.75.75 0 1 0 1.06-1.06l-2.61-2.61A4.5 4.5 0 1 0 16.5 20Zm0-1.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
]);
const $cdb0ff5c001a8842$export$f5701a0f692af73d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h2.38l-.44-.44a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 9.9 11h1.18a1.5 1.5 0 0 1 2.47-1.56L15 10.88V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm7.85 3.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L7.71 13h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L13.29 12H7.71l1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$50a6cf702f650f9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v4.38l-1-1V6.5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h1.59c.07.2.19.4.35.56l.44.44H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm7.85 6.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L7.71 13h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L13.29 12H7.71l1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$b3d831d4ec14e349 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.38l-.44-.44a1.5 1.5 0 0 1 0-2.12l2-2A1.5 1.5 0 0 1 13.9 14h1.18a1.5 1.5 0 0 1 2.47-1.56l.44.44V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm10.85 5.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58l1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$1bc1cce9d8687adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.38l-.44-.44a1.5 1.5 0 0 1-.35-.56H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v4.59c.2.07.4.19.56.35l.44.44V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm9.85 8.35a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 16h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L17.29 15h-5.58l1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$6c983157a9f9d4de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap24Filled', "24", [
    "M2 6.25V8h6.13c.2 0 .39-.08.53-.22l2.59-2.6-1.53-1.52c-.42-.42-1-.66-1.6-.66H5.26A3.25 3.25 0 0 0 2 6.25Zm0 11.5V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69c1.8 0 3.25 1.46 3.25 3.25v7.28L20.99 15A1.75 1.75 0 0 0 18.17 17h-1.34a1.75 1.75 0 0 0-2.82-1.99l-2.5 2.5c-.68.69-.68 1.8 0 2.48L12.53 21H5.25A3.25 3.25 0 0 1 2 17.75Zm13.78-.97a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h5.88l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06L20.44 18h-5.88l1.22-1.22Z"
]);
const $cdb0ff5c001a8842$export$fd5a03beb13e1c22 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSwap24Regular', "24", [
    "M3.5 8V6.25c0-.97.78-1.75 1.75-1.75h2.88c.2 0 .39.08.53.22l1.53 1.53-1.53 1.53a.75.75 0 0 1-.53.22H3.5Zm1.75-5A3.25 3.25 0 0 0 2 6.25v11.5C2 19.55 3.46 21 5.25 21h7.28l-1.02-1.01a1.75 1.75 0 0 1-.34-.49H5.25c-.97 0-1.75-.78-1.75-1.75V9.5h4.63c.6 0 1.17-.24 1.59-.66L11.56 7h7.19c.97 0 1.75.78 1.75 1.75v5.92c.18.08.34.2.49.34L22 16.03V8.75c0-1.8-1.46-3.25-3.25-3.25h-7.19L9.72 3.66c-.42-.42-1-.66-1.6-.66H5.26Zm10.53 13.78a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h5.88l-1.22 1.22a.75.75 0 1 0 1.06 1.06l2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 1 0-1.06 1.06L20.44 18h-5.88l1.22-1.22Z"
]);
const $cdb0ff5c001a8842$export$aa0ab355e9a49a80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5ZM1 7v4.5A2.5 2.5 0 0 0 3.5 14h3.1A5.5 5.5 0 0 1 15 7.26V6.5A2.5 2.5 0 0 0 12.5 4H9.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H1Zm6 4.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a1.98 1.98 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $cdb0ff5c001a8842$export$468d741e37cb9473 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync16Regular', "16", [
    "M2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5C2.67 3 2 3.67 2 4.5Zm-1 0A2.5 2.5 0 0 1 3.5 2h2.09c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v.76a5.5 5.5 0 0 0-1-.66v-.1c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5h2.7c.1.35.24.68.4 1H3.5A2.5 2.5 0 0 1 1 11.5v-7Zm6 7a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a1.98 1.98 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $cdb0ff5c001a8842$export$d9db346fc09348b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync20Filled', "20", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h2.48c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5ZM2 8v6.5A2.5 2.5 0 0 0 4.5 17h5.1a5.5 5.5 0 0 1 8.4-6.74V7.5A2.5 2.5 0 0 0 15.5 5h-4.8L8.16 7.56A1.5 1.5 0 0 1 7.09 8H2Zm8 6.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $cdb0ff5c001a8842$export$4ee5bf5e22fc6239 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync20Regular', "20", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.1c.36.18.7.4 1 .66V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5Zm7 9a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $cdb0ff5c001a8842$export$603670d19d386dd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync24Filled', "24", [
    "M2 8V6.25C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2Zm0 1.5v8.25C2 19.55 3.46 21 5.25 21h6.77A6.5 6.5 0 0 1 22 12.81V8.75c0-1.8-1.46-3.25-3.25-3.25h-5.69L9.72 8.84c-.42.42-1 .66-1.6.66H2Zm10 8a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0Zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5ZM15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19Z"
]);
const $cdb0ff5c001a8842$export$6cc3ccb930af7799 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderSync24Regular', "24", [
    "M3.5 6.25V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25c-.97 0-1.75.78-1.75 1.75Zm-1.5 0C2 4.45 3.46 3 5.25 3h2.88c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v4.06a6.52 6.52 0 0 0-1.5-1.08V8.75c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75h6.06c.18.53.42 1.04.71 1.5H5.25A3.25 3.25 0 0 1 2 17.75V6.25ZM12 17.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0Zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h1a2.5 2.5 0 0 0-4.03.04.5.5 0 0 1-.8-.59 3.5 3.5 0 0 1 5.33-.4v-.55c0-.28.22-.5.5-.5ZM15 19.95v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-1a2.5 2.5 0 0 0 3.91.11.5.5 0 0 1 .77.65 3.5 3.5 0 0 1-5.18.19Z"
]);
const $cdb0ff5c001a8842$export$f61051c8fbc12fc2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip16Filled', "16", [
    "M11 11a1 1 0 0 1 1 1v2.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V11.9a1 1 0 0 1 1-.9Zm1.5-7A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2 2.45V12a2 2 0 1 0-4 0v2H3.5A2.5 2.5 0 0 1 1 11.5V7h4.59c.4 0 .78-.16 1.06-.44L9.2 4h3.29ZM11 10h1.5a.5.5 0 0 0 0-1H11v1ZM9.5 8a.5.5 0 0 0 0 1H11V8H9.5ZM11 8h1.5a.5.5 0 0 0 0-1H11v1ZM9.5 6a.5.5 0 0 0 0 1H11V6H9.5ZM5.59 2c.4 0 .78.16 1.06.44L8 3.79 5.94 5.85a.5.5 0 0 1-.35.15H1V4.5A2.5 2.5 0 0 1 3.5 2h2.09Z"
]);
const $cdb0ff5c001a8842$export$d50dc786c074ae76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip16Regular', "16", [
    "M5.59 2c.4 0 .78.16 1.06.44L8.2 4h4.29A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2 2.45v.67c0 .18-.13.34-.3.37l-.08.01H9.3a.39.39 0 0 1-.31-.38V14H3.5A2.5 2.5 0 0 1 1 11.5v-7A2.5 2.5 0 0 1 3.5 2h2.09ZM11 11a1 1 0 0 0-1 .9V14h2v-2a1 1 0 0 0-1-1ZM6.65 6.56A1.5 1.5 0 0 1 5.59 7H2v4.5c0 .83.67 1.5 1.5 1.5H9v-1a2 2 0 1 1 4 0v.91c.58-.2 1-.76 1-1.41v-5c0-.83-.67-1.5-1.5-1.5H8.2L6.66 6.56ZM12.5 9a.5.5 0 0 1 0 1H11V9h1.5ZM11 9H9.5a.5.5 0 0 1 0-1H11v1Zm1.5-2a.5.5 0 0 1 0 1H11V7h1.5ZM11 7H9.5a.5.5 0 0 1 0-1H11v1ZM3.5 3C2.67 3 2 3.67 2 4.5V6h3.59a.5.5 0 0 0 .35-.15L7.29 4.5 5.94 3.15A.5.5 0 0 0 5.59 3H3.5Z"
]);
const $cdb0ff5c001a8842$export$7c322acb2a9ae382 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip20Filled', "20", [
    "M13 13a1 1 0 0 1 1 1v3.75c0 .14-.11.25-.25.25h-1.5a.25.25 0 0 1-.25-.25V14a1 1 0 0 1 1-1Zm2.5-8A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v-3a2 2 0 1 0-4 0v3H4.5A2.5 2.5 0 0 1 2 14.5V8h5.09c.4 0 .78-.16 1.06-.44L10.7 5h4.79Zm-4 6a.5.5 0 0 0 0 1H13v-1h-1.5Zm1.5 0h1.5a.5.5 0 0 0 0-1H13v1Zm-1.5-2a.5.5 0 0 0 0 1H13V9h-1.5ZM13 9h1.5a.5.5 0 0 0 0-1H13v1Zm-1.5-2a.5.5 0 0 0 0 1H13V7h-1.5ZM6.98 3c.47 0 .91.18 1.24.51L9.5 4.8 7.44 6.85a.5.5 0 0 1-.35.15H2V5.5A2.5 2.5 0 0 1 4.5 3h2.48Z"
]);
const $cdb0ff5c001a8842$export$b0afb2ca0125d471 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip20Regular', "20", [
    "M6.98 3c.47 0 .91.18 1.24.51L9.71 5h5.79A2.5 2.5 0 0 1 18 7.5v7a2.5 2.5 0 0 1-2.5 2.5H15v.54c0 .25-.2.46-.46.46h-3.08l-.1-.01a.46.46 0 0 1-.36-.45V17H4.5A2.5 2.5 0 0 1 2 14.5v-9A2.5 2.5 0 0 1 4.5 3h2.48ZM13 13a1 1 0 0 0-1 1v3h2v-3a1 1 0 0 0-1-1ZM8.15 7.56A1.5 1.5 0 0 1 7.09 8H3v6.5c0 .83.67 1.5 1.5 1.5H11v-2a2 2 0 1 1 4 0v2h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H9.7L8.16 7.56ZM13 12h-1.5a.5.5 0 0 1 0-1H13v1Zm1.5-2a.5.5 0 0 1 0 1H13v-1h1.5ZM13 10h-1.5a.5.5 0 0 1 0-1H13v1Zm1.5-2a.5.5 0 0 1 0 1H13V8h1.5ZM13 8h-1.5a.5.5 0 0 1 0-1H13v1ZM4.5 4C3.67 4 3 4.67 3 5.5V7h4.09a.5.5 0 0 0 .35-.15L8.79 5.5 7.51 4.22A.75.75 0 0 0 6.98 4H4.5Z"
]);
const $cdb0ff5c001a8842$export$91fd1941ca09a722 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip24Filled', "24", [
    "M17.5 22.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V18a1.5 1.5 0 0 1 3 0v4.5Zm1.25-17c1.8 0 3.25 1.46 3.25 3.25v9a3.25 3.25 0 0 1-3 3.24V18a3 3 0 0 0-3-3v-1h-2.25a.75.75 0 0 0 0 1.5h.6A3 3 0 0 0 13 18v3H5.25A3.25 3.25 0 0 1 2 17.75V9.5h6.13c.6 0 1.17-.24 1.59-.66l3.34-3.34h5.69ZM16 14h2.25a.75.75 0 0 0 0-1.5H16V14Zm-2.25-3a.75.75 0 0 0 0 1.5H16V11h-2.25ZM16 11h2.25a.75.75 0 0 0 0-1.5H16V11Zm-2.25-3a.75.75 0 0 0 0 1.5H16V8h-2.25ZM8.13 3c.6 0 1.17.24 1.59.66l1.53 1.53-2.6 2.59a.75.75 0 0 1-.52.22H2V6.25C2 4.45 3.46 3 5.25 3h2.88Z"
]);
const $cdb0ff5c001a8842$export$7d96d03963ae695a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('FolderZip24Regular', "24", [
    "M8.13 3c.6 0 1.17.24 1.59.66l1.84 1.84h7.19c1.8 0 3.25 1.46 3.25 3.25v9a3.25 3.25 0 0 1-3 3.24v1.4l-.01.12a.62.62 0 0 1-.48.48l-.13.01h-4.76a.62.62 0 0 1-.6-.5l-.02-.12V21H5.25A3.25 3.25 0 0 1 2 17.75V6.25C2 4.45 3.46 3 5.25 3h2.88ZM16 16.5c-.83 0-1.5.67-1.5 1.5v3.5h3V18c0-.83-.67-1.5-1.5-1.5ZM9.72 8.84c-.42.42-1 .66-1.6.66H3.5v8.25c0 .97.78 1.75 1.75 1.75H13V18a3 3 0 0 1 1.34-2.5h-.59a.75.75 0 0 1 0-1.5H16v1a3 3 0 0 1 3 3v1.48c.85-.12 1.5-.85 1.5-1.73v-9c0-.97-.78-1.75-1.75-1.75h-7.19L9.72 8.84Zm8.53 3.66a.75.75 0 0 1 0 1.5H16v-1.5h2.25Zm-2.25 0h-2.25a.75.75 0 0 1 0-1.5H16v1.5Zm2.25-3a.75.75 0 0 1 0 1.5H16V9.5h2.25ZM16 9.5h-2.25a.75.75 0 0 1 0-1.5H16v1.5Zm-10.75-5c-.97 0-1.75.78-1.75 1.75V8h4.63c.2 0 .39-.08.53-.22l1.53-1.53-1.53-1.53a.75.75 0 0 0-.53-.22H5.25Z"
]);
const $cdb0ff5c001a8842$export$6f5b822199367a05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive16Filled', "16", [
    "M12.5 8c.83 0 1.5.67 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 10.5v-1C2 8.67 2.67 8 3.5 8h9Zm1.06-.77-1.68-3.5v-.01A1.23 1.23 0 0 0 10.75 3h-5.5a1.23 1.23 0 0 0-1.13.72L2.44 7.24A2.5 2.5 0 0 1 3.5 7h9c.38 0 .74.08 1.06.23ZM12 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
]);
const $cdb0ff5c001a8842$export$c893d188235a8b09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive16Regular', "16", [
    "M13.85 7.85 11.9 3.73v-.01A1.23 1.23 0 0 0 10.74 3h-5.5a1.23 1.23 0 0 0-1.13.72L2.15 7.86c-.1.2-.15.43-.15.65v2A1.5 1.5 0 0 0 3.5 12h9a1.5 1.5 0 0 0 1.5-1.5v-2c0-.22-.05-.44-.15-.65ZM5.25 4h5.5a.24.24 0 0 1 .23.14L12.34 7H3.66l1.36-2.86A.24.24 0 0 1 5.25 4ZM13 10.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v2Zm-1-1a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
]);
const $cdb0ff5c001a8842$export$d987524f3e6d8781 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive20Filled', "20", [
    "M4 10c-.59 0-1.14.17-1.6.46l2.25-5.25A2 2 0 0 1 6.5 4h7.1c.75 0 1.43.41 1.77 1.09.54 1.1 1.53 3.2 2.33 5.43A2.99 2.99 0 0 0 16 10H4Zm12 1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H3.99A2 2 0 0 1 2 14v-1c0-1.1.9-2 2-2h12Zm-.5 3.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
]);
const $cdb0ff5c001a8842$export$311351340fbdb62f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive20Regular', "20", [
    "M2 12c0-.4.08-.8.24-1.16l2.41-5.63A2 2 0 0 1 6.5 4h7.1c.75 0 1.43.41 1.77 1.09a54.93 54.93 0 0 1 2.45 5.77c.13.37.19.76.19 1.14v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2Zm11.6-7H6.48a1 1 0 0 0-.92.6l-1.9 4.43L4 10h12c.15 0 .3.02.45.05a57.18 57.18 0 0 0-2-4.52.96.96 0 0 0-.86-.53ZM16 15a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h12Zm-1.25-1.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
]);
const $cdb0ff5c001a8842$export$2ea733824e22d72f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive24Filled', "24", [
    "M7.44 4c-.86 0-1.65.5-2.02 1.27l-2.7 5.55c.47-.2.99-.32 1.53-.32h15.5c.54 0 1.06.11 1.52.32l-2.69-5.55A2.25 2.25 0 0 0 16.56 4H7.44Zm12.31 8c1.24 0 2.25 1 2.25 2.25v2.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 19 2 18 2 16.75v-2.5C2 13.01 3 12 4.25 12h15.5Zm-1.25 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $cdb0ff5c001a8842$export$f88e3ae5d04a604f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive24Regular', "24", [
    "M5.42 5.27A2.25 2.25 0 0 1 7.44 4h9.12c.86 0 1.65.5 2.02 1.27l3.1 6.39c.2.44.32.92.32 1.41v3.68c0 1.24-1 2.25-2.25 2.25H4.25C3.01 19 2 18 2 16.75v-3.68c0-.49.11-.97.32-1.41l3.1-6.39Zm11.81.65a.75.75 0 0 0-.67-.42H7.44a.75.75 0 0 0-.67.42L4.3 11h15.38l-2.46-5.08ZM3.5 13.25v3.5c0 .41.34.75.75.75h15.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75ZM18 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $cdb0ff5c001a8842$export$bd6f5854d76a2dce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive28Filled', "28", [
    "M6.53 6.44A2.75 2.75 0 0 1 8.95 5h10.1c1.02 0 1.95.55 2.43 1.44l3.46 6.41a4.24 4.24 0 0 0-1.69-.35H4.75c-.6 0-1.17.12-1.68.35l3.46-6.4ZM23.25 23A2.75 2.75 0 0 0 26 20.25v-3.5A2.75 2.75 0 0 0 23.25 14H4.75A2.75 2.75 0 0 0 2 16.75v3.5A2.75 2.75 0 0 0 4.75 23h18.5Zm-3-4.5c0-.69.55-1.24 1.24-1.25h.02a1.25 1.25 0 1 1-1.26 1.25Z"
]);
const $cdb0ff5c001a8842$export$82f81b6dd2cbde1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive28Regular', "28", [
    "M6.53 6.44A2.75 2.75 0 0 1 8.95 5h10.1c1.02 0 1.95.55 2.43 1.44l3.95 7.31a4.75 4.75 0 0 1 .57 2v4.5A2.75 2.75 0 0 1 23.25 23H4.75A2.75 2.75 0 0 1 2 20.25v-4.5a4.75 4.75 0 0 1 .57-2l3.96-7.3Zm13.63.72c-.22-.4-.64-.66-1.1-.66H8.95c-.46 0-.88.25-1.1.66L4.69 13h18.63l-3.16-5.84ZM3.58 15.33c-.05.22-.08.45-.08.68v4.24c0 .69.56 1.25 1.25 1.25h18.5c.7 0 1.25-.56 1.25-1.25v-4.24c0-.23-.02-.46-.07-.68a1.25 1.25 0 0 0-1.18-.83H4.75c-.54 0-1 .35-1.17.83ZM21 19.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $cdb0ff5c001a8842$export$eaea9f7179de4ff5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive32Filled', "32", [
    "M9.9 5c-1.24 0-2.37.7-2.92 1.8l-3.81 7.63A5.23 5.23 0 0 1 5.25 14h21.5c.74 0 1.44.15 2.08.43L25.02 6.8A3.25 3.25 0 0 0 22.1 5H9.89ZM2 19.25V19c.14-1.68 1.54-3 3.25-3h21.5A3.25 3.25 0 0 1 30 19.25v3.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 22.75v-3.5Zm23.5 3a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $cdb0ff5c001a8842$export$4e68ba7357227cf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive32Regular', "32", [
    "M6.98 6.8A3.25 3.25 0 0 1 9.9 5h12.22c1.23 0 2.36.7 2.9 1.8l4.54 9.07c.3.59.45 1.24.45 1.9v4.98c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 22.75v-4.98c0-.66.15-1.31.45-1.9L6.98 6.8Zm16.25.9c-.21-.43-.65-.7-1.12-.7H9.89c-.47 0-.9.27-1.12.7L5.12 15H26.88l-3.65-7.3ZM4 18.24v4.5c0 .69.56 1.25 1.25 1.25h21.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25H5.25C4.56 17 4 17.56 4 18.25Zm20.5 3.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
]);
const $cdb0ff5c001a8842$export$da4f8b95c03bf38c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive48Filled', "48", [
    "M15.12 9c-1.62 0-3.1.92-3.82 2.37L6.16 21.83a6.74 6.74 0 0 1 2.09-.33h31.5c.73 0 1.44.12 2.1.33L36.7 11.37A4.25 4.25 0 0 0 32.88 9H15.12ZM4 28.25v6.5C4 37.1 5.9 39 8.25 39h31.5C42.1 39 44 37.1 44 34.75v-6.5C44 25.9 42.1 24 39.75 24H8.25A4.25 4.25 0 0 0 4 28.25Zm34.5 3.25a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
]);
const $cdb0ff5c001a8842$export$2ed742a78f3cc13d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDrive48Regular', "48", [
    "M11.3 11.37A4.25 4.25 0 0 1 15.12 9h17.76c1.62 0 3.1.92 3.82 2.37l6.66 13.53.2.48c.28.57.44 1.2.44 1.87v7.5C44 37.1 42.1 39 39.75 39H8.25A4.25 4.25 0 0 1 4 34.75v-7.5c0-.67.16-1.3.43-1.87l.21-.48 6.66-13.53Zm23.15 1.1c-.3-.6-.9-.97-1.57-.97H15.12c-.67 0-1.28.38-1.57.98L8.37 23h31.26l-5.18-10.52ZM6.72 26.4c-.15.4-.22.83-.22 1.26v7.09c0 .97.78 1.75 1.75 1.75h31.5c.97 0 1.75-.78 1.75-1.75v-7.09c0-.43-.07-.85-.22-1.26-.3-.54-.87-.9-1.53-.9H8.25c-.66 0-1.23.36-1.53.9ZM36 33a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $cdb0ff5c001a8842$export$d897c6d3e9c4d678 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall24Filled', "24", [
    "M7.44 4c-.86 0-1.65.5-2.02 1.27l-2.7 5.55c.47-.2.99-.32 1.53-.32h15.16c.41-.33.93-.51 1.46-.5l-2.29-4.73A2.25 2.25 0 0 0 16.56 4H7.44Zm-3.19 8h14.26l-.25.62c-.31.8-.14 1.71.46 2.33l.59.63c-.12.67-.43 1.2-.95 1.64l-.84-.2c-.83-.2-1.7.1-2.23.77l-.8 1-.15.21H4.25C3.01 19 2 18 2 16.75v-2.5C2 13.01 3 12 4.25 12Zm14.94 1 .48-1.21c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.78 3.78 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28Z"
]);
const $cdb0ff5c001a8842$export$f0be59ab6c5adceb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall24Regular', "24", [
    "M5.42 5.27A2.25 2.25 0 0 1 7.44 4h9.12c.86 0 1.65.5 2.02 1.27l2.3 4.73a2.25 2.25 0 0 0-1.44.48l-2.2-4.56a.75.75 0 0 0-.68-.42H7.44a.75.75 0 0 0-.67.42L4.3 11h14.65c-.09.13-.16.27-.22.42l-.43 1.08H4.25a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h11.31c-.1.09-.19.18-.27.29l-.8 1-.15.21H4.25C3.01 19 2 18 2 16.75v-3.68c0-.49.11-.97.32-1.41l3.1-6.39Zm13.77 7.72.48-1.2c.24-.61.92-.93 1.55-.73l.43.14c.72.24 1.32.8 1.35 1.57.1 3.11-2.48 7.58-5.22 9.06-.67.36-1.46.12-2.03-.4l-.34-.3a1.25 1.25 0 0 1-.14-1.7l.8-1.02a1.2 1.2 0 0 1 1.22-.42l1.3.32a3.78 3.78 0 0 0 1.77-3.08l-.92-.96a1.2 1.2 0 0 1-.25-1.28Z"
]);
const $cdb0ff5c001a8842$export$9117ed25fea9a01e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall32Filled', "32", [
    "M9.9 5c-1.24 0-2.37.7-2.92 1.8l-3.81 7.63A5.23 5.23 0 0 1 5.25 14h19.7a3.47 3.47 0 0 1 3.21-.91l-3.14-6.3A3.25 3.25 0 0 0 22.1 5H9.89ZM5.24 16h18.63l-.25.72a3.03 3.03 0 0 0 .69 3.1l.97 1a3.46 3.46 0 0 1-1.17 2.09l-1.33-.35a2.97 2.97 0 0 0-3.03.96l-.93 1.11c-.35.41-.59.88-.71 1.37H5.25A3.25 3.25 0 0 1 2 22.75V19c.14-1.68 1.54-3 3.25-3Zm19.8 1.21.48-1.38a1.97 1.97 0 0 1 2.7-1.15l.5.24c.85.39 1.55 1.08 1.69 2 .67 4.52-2.88 10.76-7.07 12.43-.86.34-1.8.07-2.55-.47l-.46-.34a2.03 2.03 0 0 1-.37-2.94l.94-1.11c.37-.44.95-.62 1.5-.48l2.02.53a5.11 5.11 0 0 0 2.43-4.26l-1.46-1.5a1.53 1.53 0 0 1-.35-1.57Z"
]);
const $cdb0ff5c001a8842$export$1e055ae28e92f6d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('HardDriveCall32Regular', "32", [
    "M6.98 6.8A3.25 3.25 0 0 1 9.9 5h12.22c1.23 0 2.36.7 2.9 1.8l3.15 6.29a3.45 3.45 0 0 0-2.14.2l-2.8-5.6c-.2-.42-.64-.69-1.11-.69H9.89c-.47 0-.9.27-1.12.7L5.12 15h19.13l-.14.34-.48 1.38-.08.28H5.25C4.56 17 4 17.56 4 18.25v4.5c0 .69.56 1.25 1.25 1.25h14.11l-.53.63c-.35.41-.59.88-.71 1.37H5.25A3.25 3.25 0 0 1 2 22.75v-4.98c0-.66.15-1.31.45-1.9L6.98 6.8ZM25.05 17.2l.48-1.38a1.97 1.97 0 0 1 2.7-1.15l.5.24c.85.39 1.55 1.08 1.69 2 .67 4.52-2.88 10.76-7.07 12.43-.86.34-1.8.07-2.55-.47l-.46-.34a2.03 2.03 0 0 1-.37-2.94l.94-1.11c.37-.44.95-.62 1.5-.48l2.02.53a5.11 5.11 0 0 0 2.43-4.26l-1.46-1.5a1.53 1.53 0 0 1-.35-1.57Z"
]);
const $cdb0ff5c001a8842$export$94f22c9cc6ce5164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert16Filled', "16", [
    "M4 13V8.5H1v2A2.5 2.5 0 0 0 3.5 13H4Zm1 0h7.5a2.5 2.5 0 0 0 2.5-2.5v-2H5V13Zm2.5-2.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 7.5v-2A2.5 2.5 0 0 0 12.5 3H5v4.5h10ZM6.75 6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm2 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm2 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm2 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM4 3h-.5A2.5 2.5 0 0 0 1 5.5v2h3V3Z"
]);
const $cdb0ff5c001a8842$export$dc2792da400790e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert16Regular', "16", [
    "M7.25 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM6.5 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-5ZM3.5 4C2.67 4 2 4.67 2 5.5v2h2V4h-.5ZM5 4v3.5h9v-2c0-.83-.67-1.5-1.5-1.5H5ZM4 8.5H2v2c0 .83.67 1.5 1.5 1.5H4V8.5ZM5 12h7.5c.83 0 1.5-.67 1.5-1.5v-2H5V12Z"
]);
const $cdb0ff5c001a8842$export$79b37682908bdb86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert20Filled', "20", [
    "M6 16v-5.5H2V13a3 3 0 0 0 3 3h1Zm1 0h8a3 3 0 0 0 3-3v-2.5H7V16Zm2-2a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm2.25 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM18 9.5V7a3 3 0 0 0-3-3H7v5.5h11ZM9.75 6.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM6 4H5a3 3 0 0 0-3 3v2.5h4V4Z"
]);
const $cdb0ff5c001a8842$export$8df724de910affbe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert20Regular', "20", [
    "M9.5 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.25 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM8.75 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM11 8a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2.25 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v2.5h3V5H5Zm1 5.5H3V13c0 1.1.9 2 2 2h1v-4.5Zm1 0V15h8a2 2 0 0 0 2-2v-2.5H7Zm10-1V7a2 2 0 0 0-2-2H7v4.5h10Z"
]);
const $cdb0ff5c001a8842$export$e7469aee1b0d38ba = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert24Filled', "24", [
    "M6 4H5a3 3 0 0 0-3 3v4.25h4V4Zm-4 8.75V17a3 3 0 0 0 3 3h1v-7.25H2ZM7.5 20H19a3 3 0 0 0 3-3v-4.25H7.5V20Zm3.75-3.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.75 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2-5H7.5V4H19a3 3 0 0 1 3 3v4.25Zm-11.75-2.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3.75-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
]);
const $cdb0ff5c001a8842$export$3d6d33f0c080e8c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Likert24Regular', "24", [
    "M10.75 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.75 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-9.75 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2.75 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm14 1.5c.83 0 1.5.67 1.5 1.5v4.25h-13V5.5H19Zm1.5 7.25V17c0 .83-.67 1.5-1.5 1.5H7.5v-5.75h13ZM6 11.25H3.5V7c0-.83.67-1.5 1.5-1.5h1v5.75Zm-2.5 1.5H6v5.75H5A1.5 1.5 0 0 1 3.5 17v-4.25Z"
]);
const $cdb0ff5c001a8842$export$54b0f539cce93a29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottom20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v5h14V6a2 2 0 0 0-2-2H5Z"
]);
const $cdb0ff5c001a8842$export$3cbad97c95f0d5e6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottom20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5ZM3 6c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v5H3V6Zm0 6h14v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1Z"
]);
const $cdb0ff5c001a8842$export$dcf07f65ef0de4b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomContract20Filled', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 1 1 1 0v3.67ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4ZM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-3.83a1.5 1.5 0 0 1-.3.5l-1.74 2a1.5 1.5 0 0 1-2.26 0l-1.75-2a1.5 1.5 0 0 1-.29-.5H3V6Z"
]);
const $cdb0ff5c001a8842$export$5d342ee4f18cf7c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomContract20Regular', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 1 1 1 0v3.67ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4ZM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-3.83a1.5 1.5 0 0 1-.3.5l-.44.5H17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2h4.57l-.45-.5a1.5 1.5 0 0 1-.29-.5H3V6Z"
]);
const $cdb0ff5c001a8842$export$f7bf56625e1d7c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomExpand20Filled', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0V8.83ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4ZM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-5.5v1.5a1.5 1.5 0 1 1-3 0V11H3V6Z"
]);
const $cdb0ff5c001a8842$export$b98f062c1425ddfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelBottomExpand20Regular', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0V8.83ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4ZM3 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-5.5v1H17v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2h5.5v-1H3V6Z"
]);
const $cdb0ff5c001a8842$export$4519ad16c1af3f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft16Filled', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3h-7ZM7 4h4.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H7V4Z"
]);
const $cdb0ff5c001a8842$export$b7ce30859c6622ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft16Regular', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5v-5ZM7 4v8h4.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H7ZM6 4H4.5C3.67 4 3 4.67 3 5.5v5c0 .83.67 1.5 1.5 1.5H6V4Z"
]);
const $cdb0ff5c001a8842$export$70140ccc7786d505 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5Zm10 1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.5V4H15Z"
]);
const $cdb0ff5c001a8842$export$9a37c6312dab1007 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft20Regular', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm6.5-2v11H15a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8.5Zm-1 0H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5V4Z"
]);
const $cdb0ff5c001a8842$export$63c005c468d377e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H5.25Zm13.5 1.5c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H9.5v-13h9.25Z"
]);
const $cdb0ff5c001a8842$export$26690d86af9a133c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5ZM9.5 5.5v13h9.25c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75H9.5ZM8 5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H8v-13Z"
]);
const $cdb0ff5c001a8842$export$7fef9404d69832db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75ZM22.25 21.5c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H10.5v16h11.75Z"
]);
const $cdb0ff5c001a8842$export$bb7bf0a721f643bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM3.5 7.75c0-1.24 1.01-2.25 2.25-2.25H9v16H5.75c-1.24 0-2.25-1-2.25-2.25V7.75Zm7 13.75v-16h11.75c1.24 0 2.25 1 2.25 2.25v11.5c0 1.24-1 2.25-2.25 2.25H10.5Z"
]);
const $cdb0ff5c001a8842$export$99642ca5a32f359c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft32Filled', "32", [
    "M25.5 28a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19Zm0-22A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5H12V6h13.5Z"
]);
const $cdb0ff5c001a8842$export$dfea4301022025b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft32Regular', "32", [
    "M12 6v20h13.5a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6H12Zm-2 0H6.5A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H10V6ZM2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15Z"
]);
const $cdb0ff5c001a8842$export$4a21aab1188fdf6a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft48Filled', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-21.5ZM37.75 38.5a3.75 3.75 0 0 0 3.75-3.75v-21.5a3.75 3.75 0 0 0-3.75-3.75h-19.5v29h19.5Z"
]);
const $cdb0ff5c001a8842$export$352f31a57702afa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeft48Regular', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5C44 9.8 41.2 7 37.75 7h-27.5ZM6.5 13.25a3.75 3.75 0 0 1 3.75-3.75h5.5v29h-5.5a3.75 3.75 0 0 1-3.75-3.75v-21.5ZM18.25 38.5v-29h19.5a3.75 3.75 0 0 1 3.75 3.75v21.5a3.75 3.75 0 0 1-3.75 3.75h-19.5Z"
]);
const $cdb0ff5c001a8842$export$f1e55ff97c1c08a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h2.52a5.57 5.57 0 0 1 0-1H6V3h4.5c.83 0 1.5.67 1.5 1.5v1.52c.34.03.68.1 1 .19V4.5A2.5 2.5 0 0 0 10.5 2h-7ZM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$78dcba5182ea6765 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd16Regular', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v1.7c-.32-.08-.66-.15-1-.18V4.5c0-.83-.67-1.5-1.5-1.5H6v8h.02a5.57 5.57 0 0 0 0 1H3.5A2.5 2.5 0 0 1 1 9.5v-5ZM5 3H3.5C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5H5V3Zm11 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$eeec06a7b49e0c7f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2c-.08-.32-.15-.66-.18-1H8.5V4H15a2 2 0 0 1 2 2v3.6c.36.18.7.4 1 .66V6a3 3 0 0 0-3-3H5Zm14 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$311cd7ce16d307f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd20Regular', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a5.5 5.5 0 0 0-1-.66V6a2 2 0 0 0-2-2H8.5v11h.52c.03.34.1.68.19 1H5a3 3 0 0 1-3-3V6Zm5.5-2H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5V4ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d6374732d672bb72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25c-.2-.47-.34-.98-.42-1.5H9.5v-13h9.25c.97 0 1.75.78 1.75 1.75v4.48c.55.29 1.06.65 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4H5.25ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a68283a166bd54cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a6.52 6.52 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H9.5v13h1.58c.08.52.22 1.03.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5ZM8 5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H8v-13Zm15 12a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fdb1569604ba927f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd28Filled', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65c-.44-.48-.95-.9-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H10.5v16h2.57c.07.52.19 1.02.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25V7.75ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$4536205f860492b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.67c-.17-.48-.29-.98-.36-1.5H10.5v-16h11.75c1.24 0 2.25 1 2.25 2.25v6.4c.55.35 1.05.77 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM3.5 7.75c0-1.24 1-2.25 2.25-2.25H9v16H5.75c-1.24 0-2.25-1-2.25-2.25V7.75ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fa4119aa0bc1c6c1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd32Filled', "32", [
    "M6.5 28h9.02a8.97 8.97 0 0 1-1-2H12V6h13.5A2.5 2.5 0 0 1 28 8.5v7.02c.76.5 1.43 1.12 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28ZM23 30.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9c9fd9364c84d8c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd32Regular', "32", [
    "M12 6h13.5A2.5 2.5 0 0 1 28 8.5v7.02c.76.5 1.43 1.12 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h9.02a8.97 8.97 0 0 1-1-2H12V6Zm-2 0v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6H10Zm13 24.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ab2cc4c6e08ce03a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd48Filled', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37c-.75-.72-1.6-1.36-2.5-1.88V13.25a3.75 3.75 0 0 0-3.75-3.75h-19.5v29h4.23c.24.87.57 1.71.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-21.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c2b580e1d94e5100 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftAdd48Regular', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21c-.4-.79-.74-1.63-.98-2.5h-4.23v-29h19.5a3.75 3.75 0 0 1 3.75 3.75v10.49c.9.52 1.75 1.16 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7h-27.5ZM6.5 13.25a3.75 3.75 0 0 1 3.75-3.75h5.5v29h-5.5a3.75 3.75 0 0 1-3.75-3.75v-21.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$b13463c40f40e5b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract16Filled', "16", [
    "m9.7 8.5.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h1.79a.5.5 0 0 1 0 1H9.7ZM4 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm3 9V4h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7Z"
]);
const $cdb0ff5c001a8842$export$b0acc1ab684811c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract16Regular', "16", [
    "m9.7 8.5.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h1.79a.5.5 0 0 1 0 1H9.7ZM4 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4ZM3 5a1 1 0 0 1 1-1h2v8H4a1 1 0 0 1-1-1V5Zm4 7V4h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7Z"
]);
const $cdb0ff5c001a8842$export$70de915d02443b62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract20Filled', "20", [
    "M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76l-1-.87ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm4 11V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8Z"
]);
const $cdb0ff5c001a8842$export$e0c5a188f53a98da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract20Regular', "20", [
    "M10.82 10.5h3.68a.5.5 0 0 0 0-1h-3.68l1-.87a.5.5 0 1 0-.66-.76l-2 1.75a.5.5 0 0 0 0 .76l2 1.75a.5.5 0 1 0 .66-.76l-1-.87ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4ZM3 6a1 1 0 0 1 1-1h3v10H4a1 1 0 0 1-1-1V6Zm5 9V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8Z"
]);
const $cdb0ff5c001a8842$export$614515b5dd2cc51c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract24Filled', "24", [
    "M14.8 9.25a.75.75 0 0 0-1.05-.06l-2.5 2.25a.75.75 0 0 0 0 1.12l2.5 2.25a.75.75 0 1 0 1-1.12l-1.05-.94h3.55a.75.75 0 0 0 0-1.5H13.7l1.05-.94c.31-.28.33-.75.06-1.06ZM2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75ZM9 5.5v13h10.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25H9Z"
]);
const $cdb0ff5c001a8842$export$512e9e980f0a03f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract24Regular', "24", [
    "M14.8 9.25a.75.75 0 0 0-1.05-.06l-2.5 2.25a.75.75 0 0 0 0 1.12l2.5 2.25a.75.75 0 0 0 1-1.12l-1.05-.94h3.55a.75.75 0 1 0 0-1.5H13.7l1.05-.94c.31-.28.33-.75.06-1.06Zm-12.8 8A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5Zm2.75 1.25c-.69 0-1.25-.56-1.25-1.25V6.75c0-.7.56-1.25 1.25-1.25H8v13H4.75Zm4.75 0v-13h9.75c.69 0 1.25.56 1.25 1.25v10.5c0 .7-.56 1.25-1.25 1.25H9.5Z"
]);
const $cdb0ff5c001a8842$export$851d62af266ab69e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract28Filled', "28", [
    "M17.28 11.53a.75.75 0 1 0-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72ZM22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5Zm2.25 3.75c0-1.24-1-2.25-2.25-2.25H11v17h11.25c1.24 0 2.25-1 2.25-2.25V7.75Z"
]);
const $cdb0ff5c001a8842$export$f6962596d6fecca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftContract28Regular', "28", [
    "M17.28 11.53a.75.75 0 1 0-1.06-1.06l-3 3c-.3.3-.3.77 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72ZM26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75ZM22.25 5.5c1.24 0 2.25 1 2.25 2.25v12.5c0 1.24-1 2.25-2.25 2.25H11v-17h11.25ZM9.5 5.5v17H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25H9.5Z"
]);
const $cdb0ff5c001a8842$export$c4f6664247c2f7f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftDefault28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM11 22.5h11.25c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H11v17Z"
]);
const $cdb0ff5c001a8842$export$7cb3fc24ccfb4bcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftDefault28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-17H5.75Zm5.25 0v17h11.25c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H11Z"
]);
const $cdb0ff5c001a8842$export$129c6b81df117f67 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftDefault32Light', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15ZM25.5 27a3.5 3.5 0 0 0 3.5-3.5v-15A3.5 3.5 0 0 0 25.5 5H12v22h13.5Z"
]);
const $cdb0ff5c001a8842$export$dbe58ddf2b8f967 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand16Filled', "16", [
    "M8.5 7.5h1.8l-.66-.65a.5.5 0 0 1 .71-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 1 1-.7-.7l.64-.65H8.5a.5.5 0 0 1 0-1Z",
    "M2 5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm10-1H7v8h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
]);
const $cdb0ff5c001a8842$export$5c68ab7aa1375bd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand16Regular', "16", [
    "m9.65 9.15.64-.65H8.5a.5.5 0 0 1 0-1h1.8l-.65-.65a.5.5 0 1 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 1 1-.7-.7Z",
    "M2 5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2V4H4Zm3 0v8h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7Z"
]);
const $cdb0ff5c001a8842$export$482758427fff5b81 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand20Filled', "20", [
    "m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1h3.68ZM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8Zm6 1V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8Z"
]);
const $cdb0ff5c001a8842$export$30bb4dd174a64cbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand20Regular', "20", [
    "m13.18 10.5-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H9.5a.5.5 0 0 0 0 1h3.68ZM2 14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8Zm2 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3v10H4Zm4 0V5h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8Z"
]);
const $cdb0ff5c001a8842$export$1b39b816b184fe88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand24Filled', "24", [
    "M14.2 14.75c.27.3.74.33 1.05.06l2.5-2.25a.75.75 0 0 0 0-1.12l-2.5-2.25a.75.75 0 0 0-1 1.12l1.05.94h-3.55a.75.75 0 1 0 0 1.5h3.55l-1.05.94a.75.75 0 0 0-.06 1.06ZM2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75ZM9 5.5v13h10.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25H9Z"
]);
const $cdb0ff5c001a8842$export$d0a64c78ae5c0339 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand24Regular', "24", [
    "M14.2 14.75c.27.3.74.33 1.05.06l2.5-2.25a.75.75 0 0 0 0-1.12l-2.5-2.25a.75.75 0 0 0-1 1.12l1.05.94h-3.55a.75.75 0 1 0 0 1.5h3.55l-1.05.94a.75.75 0 0 0-.06 1.06ZM2 6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75ZM4.75 5.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25H8v-13H4.75Zm4.75 0v13h9.75c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25H9.5Z"
]);
const $cdb0ff5c001a8842$export$45c3779bd5461088 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand28Filled', "28", [
    "M17.72 11.53a.75.75 0 1 1 1.06-1.06l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-5.69a.75.75 0 0 1 0-1.5h5.69l-1.72-1.72ZM22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5Zm2.25 3.75c0-1.24-1-2.25-2.25-2.25H11v17h11.25c1.24 0 2.25-1 2.25-2.25V7.75Z"
]);
const $cdb0ff5c001a8842$export$1c52e3eae258e502 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftExpand28Regular', "28", [
    "M17.72 11.53a.75.75 0 1 1 1.06-1.06l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-5.69a.75.75 0 0 1 0-1.5h5.69l-1.72-1.72ZM26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75ZM22.25 5.5c1.24 0 2.25 1 2.25 2.25v12.5c0 1.24-1 2.25-2.25 2.25H11v-17h11.25ZM9.5 5.5v17H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25H9.5Z"
]);
const $cdb0ff5c001a8842$export$79d928601e3a2ae8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight16Filled', "16", [
    "M12 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8ZM6 4v8H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h2Z"
]);
const $cdb0ff5c001a8842$export$ec5a3911ac86e8aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight20Filled', "20", [
    "M16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12ZM7 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3Z"
]);
const $cdb0ff5c001a8842$export$257b322e868c558e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight24Filled', "24", [
    "M19.25 20A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4H4.75A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5ZM8 5.5v13H4.75c-.69 0-1.25-.56-1.25-1.25V6.75c0-.69.56-1.25 1.25-1.25H8Z"
]);
const $cdb0ff5c001a8842$export$97d734f8a938ce9d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight28Filled', "28", [
    "M2 20.25A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v12.5Zm3.75 2.25c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1.01-2.25 2.25-2.25H9v17H5.75Z"
]);
const $cdb0ff5c001a8842$export$742dbf6b59a135b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight32Filled', "32", [
    "M25.5 4A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19Zm-19 2A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H10V6H6.5Z"
]);
const $cdb0ff5c001a8842$export$bbeda8e83d4e401e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftFocusRight32Light', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15ZM6.5 5A3.5 3.5 0 0 0 3 8.5v15A3.5 3.5 0 0 0 6.5 27H11V5H6.5Z"
]);
const $cdb0ff5c001a8842$export$a5b6ff2142dde550 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader16Filled', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5v-5Zm11 1v-1c0-.83-.67-1.5-1.5-1.5H7v2.5h6Zm-6 1V12h4.5c.83 0 1.5-.67 1.5-1.5v-3H7Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d9cfc0df50a294c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader16Regular', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3h-7ZM13 6.5H7V4h4.5c.83 0 1.5.67 1.5 1.5v1ZM6 4v8H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H6Zm1 3.5h6v3c0 .83-.67 1.5-1.5 1.5H7V7.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$635efa68aa6d3d73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5Zm12 3v1H8.5V4H15a2 2 0 0 1 2 2Zm-2 9H8.5V8H17v5a2 2 0 0 1-2 2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1f7119a34f3ae0a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5Zm3.5 4V4H15a2 2 0 0 1 2 2v1H8.5Zm0 1H17v5a2 2 0 0 1-2 2H8.5V8ZM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$72fcdf428d2d8892 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5Zm18.5 0c0-.97-.78-1.75-1.75-1.75H9.5V9h11V7.25Zm0 3.25h-11v8h9.25c.97 0 1.75-.78 1.75-1.75V10.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$33d2d0ce35497e03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H5.25Zm4.25 6.5h11v6.25c0 .97-.78 1.75-1.75 1.75H9.5v-8Zm11-1.5h-11V5.5h9.25c.97 0 1.75.78 1.75 1.75V9ZM5.25 5.5H8v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$29419ef9369ae7a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM24.5 19.25c0 1.24-1 2.25-2.25 2.25H10.5v-10h14v7.75Zm0-9.25h-14V5.5h11.75c1.24 0 2.25 1 2.25 2.25V10Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$72573e195b34bcb2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9v-16H5.75Zm4.75 6v10h11.75c1.24 0 2.25-1 2.25-2.25V11.5h-14Zm14-1.5V7.75c0-1.24-1-2.25-2.25-2.25H10.5V10h14Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$abe4688010f3607a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader32Filled', "32", [
    "M30 23.5a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15Zm-2-15A2.5 2.5 0 0 0 25.5 6H12v5h16V8.5Zm0 4.5H12v13h13.5a2.5 2.5 0 0 0 2.5-2.5V13Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1388228b4bcafcf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader32Regular', "32", [
    "M6.5 4A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4h-19Zm5.5 9h16v10.5a2.5 2.5 0 0 1-2.5 2.5H12V13Zm16-2H12V6h13.5A2.5 2.5 0 0 1 28 8.5V11ZM6.5 6H10v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7bca2c71f762c82b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5C44 9.8 41.2 7 37.75 7h-27.5ZM41.5 34.75a3.75 3.75 0 0 1-3.75 3.75h-19.5v-18H41.5v14.25Zm0-16.75H18.25V9.5h19.5a3.75 3.75 0 0 1 3.75 3.75V18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$618f61f942f3f8f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeader48Regular', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-21.5Zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h5.5v-29h-5.5Zm8 11v18h19.5a3.75 3.75 0 0 0 3.75-3.75V20.5H18.25Zm0-2.5H41.5v-4.75a3.75 3.75 0 0 0-3.75-3.75h-19.5V18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$46d4baa0f67ef792 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12H6V6.5h7v-2A2.5 2.5 0 0 0 10.5 2h-7ZM12 5.5H6V3h4.5c.83 0 1.5.67 1.5 1.5v1ZM11.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm.5-6.5a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6dcde1b150151762 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd16Regular', "16", [
    "M1 4.5v5A2.5 2.5 0 0 0 3.5 12H6V6.5h7v-2A2.5 2.5 0 0 0 10.5 2h-7A2.5 2.5 0 0 0 1 4.5Zm11 0v1H6V3h4.5c.83 0 1.5.67 1.5 1.5ZM3.5 3H5v8H3.5A1.5 1.5 0 0 1 2 9.5v-5C2 3.67 2.67 3 3.5 3ZM7 11.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm5-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$519496efda3236ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a5.5 5.5 0 0 0-1-.66V8H8.5v7h.52c.03.34.1.68.19 1H5a3 3 0 0 1-3-3V6Zm15 0a2 2 0 0 0-2-2H8.5v3H17V6Zm2 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$cf32cd52190469ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2c-.08-.32-.15-.66-.18-1H8.5V8H17v1.6c.36.18.7.4 1 .66V6a3 3 0 0 0-3-3H5Zm12 4H8.5V4H15a2 2 0 0 1 2 2v1ZM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2Zm14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$abd5a878655f0baa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a6.52 6.52 0 0 0-1.5-1.08V10.5h-11v8h1.58c.08.52.22 1.03.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5Zm18.5 0c0-.97-.78-1.75-1.75-1.75H9.5V9h11V7.25ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e8bee79be68f2710 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25c-.2-.47-.34-.98-.42-1.5H9.5v-8h11v1.23c.55.29 1.06.65 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4H5.25ZM20.5 9h-11V5.5h9.25c.97 0 1.75.78 1.75 1.75V9ZM5.25 5.5H8v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$bd4354ab76dc6e4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.68c-.17-.48-.3-.98-.36-1.5H10.5v-10h14v2.65c.55.35 1.06.77 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75Zm18.75 6h-14V5.5h11.75c1.24 0 2.25 1 2.25 2.25V10ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7f13f091eae2489b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd28Regular', "28", [
    "M2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65c-.44-.48-.95-.9-1.5-1.25V11.5h-14v10h2.57c.07.52.19 1.02.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25V7.75Zm22.5 0c0-1.24-1-2.25-2.25-2.25H10.5V10h14V7.75ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9v-16H5.75ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9e91adaaf98fff0a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd32Filled', "32", [
    "M12 13v13h2.51c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9.05 9.05 0 0 0-2-1.82V13H12Zm0-2h16V8.5A2.5 2.5 0 0 0 25.5 6H12v5Zm18.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0ZM24 18.25a.75.75 0 0 0-1.5 0V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24v-3.75Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$4e289696d5c8ba27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd32Regular', "32", [
    "M12 13v13h2.51c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9.05 9.05 0 0 0-2-1.82V13H12Zm0-2h16V8.5A2.5 2.5 0 0 0 25.5 6H12v5Zm-2-5H6.5A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H10V6Zm20.5 17a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0ZM24 18.25a.75.75 0 0 0-1.5 0V22h-3.75a.75.75 0 0 0 0 1.5h3.75v3.75a.75.75 0 0 0 1.5 0V23.5h3.75a.75.75 0 0 0 0-1.5H24v-3.75Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a182c8f3a01a05d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21c-.4-.79-.74-1.63-.98-2.5h-4.23v-18H41.5v3.24c.9.52 1.75 1.16 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7h-27.5ZM41.5 18H18.25V9.5h19.5a3.75 3.75 0 0 1 3.75 3.75V18ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$233b15837dda9ef5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderAdd48Regular', "48", [
    "M4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37c-.75-.72-1.6-1.36-2.5-1.88V20.5H18.25v18h4.23c.24.87.57 1.71.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-21.5ZM18.25 18H41.5v-4.75a3.75 3.75 0 0 0-3.75-3.75h-19.5V18Zm-8-8.5a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h5.5v-29h-5.5ZM35 46a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm0-19a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6h-6a1 1 0 1 1 0-2h6v-6a1 1 0 0 1 1-1Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1494684d471fac78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v2H6V11h2.38l-1 1H3.5A2.5 2.5 0 0 1 1 9.5v-5Zm5 1h6v-1c0-.83-.67-1.5-1.5-1.5H6v2.5ZM7.5 16a.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35V14c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 0 1-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 0 1 1.61-1.57 2.94 2.94 0 0 1 3.27.64A3.01 3.01 0 0 1 12 12.84V13.52a.65.65 0 0 1-.08.24.5.5 0 0 1-.15.17.46.46 0 0 1-.27.07H11c0 .24 0 .43-.02.56a.46.46 0 0 1-.11.3.47.47 0 0 1-.3.12L10 15v.27c0 .08 0 .17-.02.25a.86.86 0 0 1-.06.24.37.37 0 0 1-.15.17.57.57 0 0 1-.27.07h-2Zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 0 0-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 0 0-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 0 0 .22-.53Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$39229b6855e75ee3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey16Regular', "16", [
    "M13 6.5H6V11h2.38l-1 1H3.5A2.5 2.5 0 0 1 1 9.5v-5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v2ZM10.5 3H6v2.5h6v-1c0-.83-.67-1.5-1.5-1.5ZM5 3H3.5C2.67 3 2 3.67 2 4.5v5c0 .83.67 1.5 1.5 1.5H5V3Zm2.5 13a.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35V14c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 0 1-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 0 1 1.61-1.57 2.94 2.94 0 0 1 3.27.64A3.01 3.01 0 0 1 12 12.84V13.52a.65.65 0 0 1-.08.24.5.5 0 0 1-.15.17.46.46 0 0 1-.27.07H11c0 .24 0 .43-.02.56a.46.46 0 0 1-.11.3.47.47 0 0 1-.3.12L10 15v.27c0 .08 0 .17-.02.25a.86.86 0 0 1-.06.24.37.37 0 0 1-.15.17.57.57 0 0 1-.27.07h-2Zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 0 0-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 0 0-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 0 0 .22-.53Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$695969fb63dc3c70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.53a4.18 4.18 0 0 0-1-.4V8H8.5v7h1.88l-.94.94-.05.06H5a3 3 0 0 1-3-3V6Zm6.5 1H17V6a2 2 0 0 0-2-2H8.5v3Zm2 12a.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35V17c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 0 1-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 0 1 1.61-1.57 2.94 2.94 0 0 1 3.27.64A3 3 0 0 1 15 15.84V16.52a.65.65 0 0 1-.08.24.5.5 0 0 1-.15.17.46.46 0 0 1-.27.07H14c0 .24 0 .43-.02.56a.46.46 0 0 1-.11.3.47.47 0 0 1-.3.12L13 18v.27c0 .08 0 .17-.02.25a.86.86 0 0 1-.06.24.37.37 0 0 1-.15.17.57.57 0 0 1-.27.07h-2Zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 0 0-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 0 0-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 0 0 .22-.53Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f00481783593dc2d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey20Regular', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.39l.05-.06.94-.94H8.5V8H17v1.12a3.85 3.85 0 0 1 1 .41V6a3 3 0 0 0-3-3H5Zm12 4H8.5V4H15a2 2 0 0 1 2 2v1ZM5 4h2.5v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2Zm5.5 15a.48.48 0 0 1-.35-.15.48.48 0 0 1-.15-.35V17c0-.14.05-.25.15-.35l2.94-2.94a3.74 3.74 0 0 1-.09-.77c0-.4.08-.79.24-1.14a3.1 3.1 0 0 1 1.61-1.57 2.94 2.94 0 0 1 3.27.64A3 3 0 0 1 15 15.84V16.52a.65.65 0 0 1-.08.24.5.5 0 0 1-.15.17.46.46 0 0 1-.27.07H14c0 .24 0 .43-.02.56a.46.46 0 0 1-.11.3.47.47 0 0 1-.3.12L13 18v.27c0 .08 0 .17-.02.25a.86.86 0 0 1-.06.24.37.37 0 0 1-.15.17.57.57 0 0 1-.27.07h-2Zm7-6.75c0-.2-.07-.39-.22-.53a.72.72 0 0 0-.53-.22c-.2 0-.39.07-.53.22a.72.72 0 0 0-.22.53c0 .2.07.39.22.53.14.15.32.22.53.22.2 0 .39-.07.53-.22a.72.72 0 0 0 .22-.53Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c55e30a436a5eb87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v4.5c-.45-.3-.96-.52-1.5-.64v-.61h-11v8h3.09l-1.08 1.07c-.12.13-.23.27-.31.43H5.25A3.25 3.25 0 0 1 2 16.75v-9.5ZM9.5 9h11V7.25c0-.97-.78-1.75-1.75-1.75H9.5V9Zm10 10a3.5 3.5 0 1 0-3.38-2.59.75.75 0 0 0-.15.12l-3.75 3.75a.75.75 0 0 0-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 0 0 .5-.5V22h1a.5.5 0 0 0 .5-.5v-1h1a.5.5 0 0 0 .5-.5v-1h1.5Zm1.5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f666b68ed728446d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftHeaderKey24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h5.95c.08-.16.19-.3.31-.43l1.08-1.07H9.5v-8h11v.61c.54.13 1.05.35 1.5.65V7.25C22 5.45 20.54 4 18.75 4H5.25ZM20.5 9h-11V5.5h9.25c.97 0 1.75.78 1.75 1.75V9ZM8 5.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75H8ZM19.5 19a3.5 3.5 0 1 0-3.38-2.59.75.75 0 0 0-.15.12l-3.75 3.75a.75.75 0 0 0-.22.53v1.44c0 .41.34.75.75.75h1.75a.5.5 0 0 0 .5-.5V22h1a.5.5 0 0 0 .5-.5v-1h1a.5.5 0 0 0 .5-.5v-1h1.5Zm1.5-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d3cd1d3354ff5d36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey16Filled', "16", [
    "M3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h3.88l1-1H6V3h4.5c.83 0 1.5.67 1.5 1.5v1.63c.32-.08.64-.12.97-.13H13V4.5A2.5 2.5 0 0 0 10.5 2h-7Zm3.65 13.85c.1.1.21.15.35.15h2c.11 0 .2-.03.27-.07.07-.04.12-.1.15-.17a.86.86 0 0 0 .06-.24l.02-.25V15l.56-.02a.47.47 0 0 0 .3-.12c.07-.07.11-.17.12-.3L11 14h.5c.1 0 .2-.02.27-.07a.5.5 0 0 0 .15-.17.65.65 0 0 0 .07-.24 2.34 2.34 0 0 0 .01-.5v-.2c.17.07.35.11.52.14a2.87 2.87 0 0 0 2.62-.86A3.11 3.11 0 0 0 16 10a2.94 2.94 0 0 0-.88-2.13 3 3 0 0 0-5.03 2.84l-2.94 2.94c-.1.1-.15.21-.15.35v1.5c0 .14.05.25.15.35Zm7.13-7.13c.15.14.22.32.22.53 0 .2-.07.39-.22.53a.72.72 0 0 1-.53.22.72.72 0 0 1-.53-.22.72.72 0 0 1-.22-.53c0-.2.07-.39.22-.53a.72.72 0 0 1 .53-.22c.2 0 .39.07.53.22Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d77fb3ef98da9756 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey16Regular', "16", [
    "M6 3h4.5c.83 0 1.5.67 1.5 1.5v1.63c.32-.08.64-.12.97-.13H13V4.5A2.5 2.5 0 0 0 10.5 2h-7A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h3.88l1-1H6V3ZM5 3v8H3.5A1.5 1.5 0 0 1 2 9.5v-5C2 3.67 2.67 3 3.5 3H5Zm2.15 12.85c.1.1.21.15.35.15h2c.11 0 .2-.03.27-.07.07-.04.12-.1.15-.17a.86.86 0 0 0 .06-.24l.02-.25V15l.56-.02a.47.47 0 0 0 .3-.12c.07-.07.11-.17.12-.3L11 14h.5c.1 0 .2-.02.27-.07a.5.5 0 0 0 .15-.17.65.65 0 0 0 .07-.24 2.34 2.34 0 0 0 .01-.5v-.2c.17.07.35.11.52.14a2.87 2.87 0 0 0 2.62-.86A3.11 3.11 0 0 0 16 10a2.94 2.94 0 0 0-.88-2.13 3 3 0 0 0-5.03 2.84l-2.94 2.94c-.1.1-.15.21-.15.35v1.5c0 .14.05.25.15.35Zm7.13-7.13c.15.14.22.32.22.53 0 .2-.07.39-.22.53a.72.72 0 0 1-.53.22.72.72 0 0 1-.53-.22.72.72 0 0 1-.22-.53c0-.2.07-.39.22-.53a.72.72 0 0 1 .53-.22c.2 0 .39.07.53.22Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$75b5e49106d3df2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey20Filled', "20", [
    "M5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.39l.05-.06.94-.94H8.5V4H15a2 2 0 0 1 2 2v3.12a3.85 3.85 0 0 1 1 .41V6a3 3 0 0 0-3-3H5Zm5.15 15.85c.1.1.21.15.35.15h2c.11 0 .2-.03.27-.07.07-.04.12-.1.15-.17a.86.86 0 0 0 .06-.24l.02-.25V18l.56-.02a.47.47 0 0 0 .3-.12c.07-.07.11-.17.12-.3L14 17h.5c.1 0 .2-.02.27-.07a.5.5 0 0 0 .15-.17.65.65 0 0 0 .07-.24 2.34 2.34 0 0 0 .01-.5v-.2c.17.07.35.11.52.14a2.87 2.87 0 0 0 2.62-.86A3.11 3.11 0 0 0 19 13a2.94 2.94 0 0 0-.88-2.13 3 3 0 0 0-5.03 2.84l-2.94 2.94c-.1.1-.15.21-.15.35v1.5c0 .14.05.25.15.35Zm7.13-7.13c.15.14.22.32.22.53 0 .2-.07.39-.22.53a.72.72 0 0 1-.53.22.72.72 0 0 1-.53-.22.72.72 0 0 1-.22-.53c0-.2.07-.39.22-.53a.72.72 0 0 1 .53-.22c.2 0 .39.07.53.22Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$de4279315932f662 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey20Regular', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.53a4.18 4.18 0 0 0-1-.4V6a2 2 0 0 0-2-2H8.5v11h1.88l-.94.94-.05.06H5a3 3 0 0 1-3-3V6Zm5.5-2H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.5V4Zm2.65 14.85c.1.1.21.15.35.15h2c.11 0 .2-.03.27-.07.07-.04.12-.1.15-.17a.86.86 0 0 0 .06-.24l.02-.25V18l.56-.02a.47.47 0 0 0 .3-.12c.07-.07.11-.17.12-.3L14 17h.5c.1 0 .2-.02.27-.07a.5.5 0 0 0 .15-.17.65.65 0 0 0 .07-.24 2.34 2.34 0 0 0 .01-.5v-.2c.17.07.35.11.52.14a2.87 2.87 0 0 0 2.62-.86A3.11 3.11 0 0 0 19 13a2.94 2.94 0 0 0-.88-2.13 3 3 0 0 0-5.03 2.84l-2.94 2.94c-.1.1-.15.21-.15.35v1.5c0 .14.05.25.15.35Zm7.13-7.13c.15.14.22.32.22.53 0 .2-.07.39-.22.53a.72.72 0 0 1-.53.22.72.72 0 0 1-.53-.22.72.72 0 0 1-.22-.53c0-.2.07-.39.22-.53a.72.72 0 0 1 .53-.22c.2 0 .39.07.53.22Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$29a10d9e540b7a8c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey24Filled', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h5.95c.08-.16.19-.3.31-.43l1.08-1.07H9.5v-13h9.25c.97 0 1.75.78 1.75 1.75v3.86c.54.13 1.05.35 1.5.65V7.25C22 5.45 20.54 4 18.75 4H5.25ZM23 15.5a3.5 3.5 0 0 1-3.5 3.5H18v1a.5.5 0 0 1-.5.5h-1v1a.5.5 0 0 1-.5.5h-1v.5a.5.5 0 0 1-.5.5h-1.75a.75.75 0 0 1-.75-.75v-1.44c0-.2.08-.39.22-.53l3.75-3.75.15-.12A3.5 3.5 0 1 1 23 15.5Zm-3 .5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$cdafd45fe73faca9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftKey24Regular', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v4.5c-.45-.3-.96-.52-1.5-.64V7.25c0-.97-.78-1.75-1.75-1.75H9.5v13h3.09l-1.08 1.07c-.12.13-.23.27-.31.43H5.25A3.25 3.25 0 0 1 2 16.75v-9.5ZM8 5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H8v-13Zm15 10a3.5 3.5 0 0 1-3.5 3.5H18v1a.5.5 0 0 1-.5.5h-1v1a.5.5 0 0 1-.5.5h-1v.5a.5.5 0 0 1-.5.5h-1.75a.75.75 0 0 1-.75-.75v-1.44c0-.2.08-.39.22-.53l3.75-3.75.15-.12A3.5 3.5 0 1 1 23 15.5Zm-3 .5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$e298c58a88e4a1ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText16Filled', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5v-5Zm9.5 6.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H8v8h3.5Zm-7-7a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM4 8c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1A.5.5 0 0 0 4 8Zm.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$9d27c90ea2340470 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText16Regular', "16", [
    "M4 5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM4 8c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 4 8Zm.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm0-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3h-7ZM3 5.5C3 4.67 3.67 4 4.5 4H7v8H4.5A1.5 1.5 0 0 1 3 10.5v-5ZM8 12V4h3.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H8Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7244e7e10f148669 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10ZM9 16h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H9v12Zm-4.59-3a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0-.09-1H4.41Zm.09-3.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM4.41 6a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0-.09-1H4.41Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$2763ec549b9cc84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText20Regular', "20", [
    "M6.5 13a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H6.5Zm0-3.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1h2Zm0-3.5a.5.5 0 0 1 .09 1H4.5a.5.5 0 0 1-.09-1H6.5ZM15 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10ZM5 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3V4H5Zm4 0v12h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H9Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$8b6d60d58e46e38a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5Zm8 11.25h8.75c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75H10v13Zm-5.25-10c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75Zm0 3.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75Zm.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H5.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3c9becb6b1460021 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText24Regular', "24", [
    "M4.75 8.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Zm0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Zm0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75ZM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H5.25Zm13.5 14.5H10v-13h8.75c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75Zm-13.5-13H8.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3206bcc3da74df3a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM11 21.5v-16h11.25c1.24 0 2.25 1 2.25 2.25v11.5c0 1.24-1 2.25-2.25 2.25H11Zm-6-13c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5Zm.75 4.25h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c4d24235461b930e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText28Regular', "28", [
    "M5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 18.5ZM2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-16H5.75Zm5.25 0v16h11.25c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H11Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f7a3c546e690b011 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19A4.5 4.5 0 0 1 2 23.5v-15ZM25.5 6H13v20h12.5a2.5 2.5 0 0 0 2.5-2.5v-15A2.5 2.5 0 0 0 25.5 6Zm-19 3a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 7a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1Zm0 6a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$7fbc88294e3858c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText32Regular', "32", [
    "M6.5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1 5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm0-17A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15A4.5 4.5 0 0 0 25.5 4h-19ZM13 26V6h12.5A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5H13ZM6.5 6H11v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f4b76882863f93f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5C44 9.8 41.2 7 37.75 7h-27.5ZM19 9.5h18.75a3.75 3.75 0 0 1 3.75 3.75v21.5a3.75 3.75 0 0 1-3.75 3.75H19v-29ZM8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 7.75h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a1.25 1.25 0 1 1 0-2.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$8e65c341d53b35f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftText48Regular', "48", [
    "M8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25ZM4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-21.5Zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h6.25v-29h-6.25Zm27.5 0H19v29h18.75a3.75 3.75 0 0 0 3.75-3.75v-21.5a3.75 3.75 0 0 0-3.75-3.75Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$20726c5508a7498d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd16Filled', "16", [
    "M1 4.5A2.5 2.5 0 0 1 3.5 2h7A2.5 2.5 0 0 1 13 4.5v1.7c-.32-.08-.66-.15-1-.18V4.5c0-.83-.67-1.5-1.5-1.5H7v5.34A5.47 5.47 0 0 0 6.02 12H3.5A2.5 2.5 0 0 1 1 9.5v-5ZM3.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM3 7c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1A.5.5 0 0 0 3 7Zm.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$aa53b90b5da844b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd16Regular', "16", [
    "M3 4.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM3 7c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 3 7Zm0 2.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM3.5 2A2.5 2.5 0 0 0 1 4.5v5A2.5 2.5 0 0 0 3.5 12h2.52A5.57 5.57 0 0 1 7 8.34V3h3.5c.83 0 1.5.67 1.5 1.5v1.52c.34.03.68.1 1 .19V4.5A2.5 2.5 0 0 0 10.5 2h-7ZM2 4.5C2 3.67 2.67 3 3.5 3H6v8H3.5A1.5 1.5 0 0 1 2 9.5v-5Zm14 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V11H9.5a.5.5 0 0 0 0 1H11v1.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H12V9.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d819b8f7c927ac24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a5.5 5.5 0 0 0-1-.66V6a2 2 0 0 0-2-2H9v11h.02c.03.34.1.68.19 1H5a3 3 0 0 1-3-3V6Zm4.59 1a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09Zm0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09ZM7 12.5a.5.5 0 0 0-.5-.5H4.41a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0 .41-.5Zm12 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$fa2be664654c4a72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd20Regular', "20", [
    "M6.59 7a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09Zm0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09ZM7 12.5a.5.5 0 0 1-.41.5H4.5a.5.5 0 0 1-.09-1H6.5c.28 0 .5.22.5.5ZM5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2c-.08-.32-.15-.66-.18-1H9V4h6a2 2 0 0 1 2 2v3.6c.36.18.7.4 1 .66V6a3 3 0 0 0-3-3H5Zm0 1h3v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2Zm14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$198b970b20ca2d6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a6.52 6.52 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H10v13h1.08c.08.52.22 1.03.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5ZM4.75 8.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75Zm0 3.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75Zm.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H5.5ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a5bb93884443355d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd24Regular', "24", [
    "M4.75 8.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Zm0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Zm.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H5.5ZM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25c-.2-.47-.34-.98-.42-1.5H10v-13h8.75c.97 0 1.75.78 1.75 1.75v4.48c.55.29 1.06.65 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4H5.25Zm0 1.5H8.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3e07a67ca03ffa7c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.68c-.17-.48-.3-.98-.36-1.5H11v-16h11.25c1.24 0 2.25 1 2.25 2.25v6.4c.55.35 1.06.77 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5Zm.75 4.25h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$988864c81b40e051 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd28Regular', "28", [
    "M5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5Zm.75 4.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65c-.44-.48-.95-.9-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H11v16h2.07c.07.52.19 1.02.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25V7.75ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-16H5.75ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a112c3813b2460b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9.05 9.05 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6H13v20h1.51c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15Zm4.5.5a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 7a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1Zm0 6a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1ZM23 30.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$542f0748e6a601da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd32Regular', "32", [
    "M6.5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1-18A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h9.02a8.97 8.97 0 0 1-1-2H13V6h12.5A2.5 2.5 0 0 1 28 8.5v7.02c.76.5 1.43 1.12 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4h-19Zm0 2H11v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6ZM23 30.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm1-12.25V22h3.75a.75.75 0 0 1 0 1.5H24v3.75a.75.75 0 0 1-1.5 0V23.5h-3.75a.75.75 0 0 1 0-1.5h3.75v-3.75a.75.75 0 0 1 1.5 0Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$ffb43c72903df67a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21c-.4-.79-.74-1.63-.98-2.5H19v-29h18.75a3.75 3.75 0 0 1 3.75 3.75v10.49c.9.52 1.75 1.16 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7h-27.5ZM8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 7.75h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a1.25 1.25 0 1 1 0-2.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$99d66493f643d036 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextAdd48Regular', "48", [
    "M8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 7.75a1.25 1.25 0 1 0 0 2.5h3.5a1.25 1.25 0 1 0 0-2.5h-3.5ZM4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37c-.75-.72-1.6-1.36-2.5-1.88V13.25a3.75 3.75 0 0 0-3.75-3.75H19v29h3.48c.24.87.57 1.71.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-21.5Zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h6.25v-29h-6.25ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$5a9339d8b7f1cd77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss16Filled', "16", [
    "M2 5.5A2.5 2.5 0 0 1 4.5 3h7A2.5 2.5 0 0 1 14 5.5v1.1c-.32-.16-.65-.3-1-.4v-.7c0-.83-.67-1.5-1.5-1.5H8v3.26A5.49 5.49 0 0 0 6.2 13H4.5A2.5 2.5 0 0 1 2 10.5v-5ZM4.5 5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM4 8c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1A.5.5 0 0 0 4 8Zm.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM16 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$751fa3f6854877d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss16Regular', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h1.7c-.08-.32-.15-.66-.18-1H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H7v4.34c.28-.4.62-.77 1-1.08V4h3.5c.83 0 1.5.67 1.5 1.5v.7c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0 0 11.5 3h-7ZM4 5.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM4 8c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1A.5.5 0 0 1 4 8Zm0 2.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm12 1a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$db73782479f2ddf3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss20Filled', "20", [
    "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v4.26a5.5 5.5 0 0 0-1-.66V6a2 2 0 0 0-2-2H9v11h.02c.03.34.1.68.19 1H5a3 3 0 0 1-3-3V6Zm4.59 1a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09Zm0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09ZM7 12.5a.5.5 0 0 0-.5-.5H4.41a.5.5 0 0 0 .09 1h2.09a.5.5 0 0 0 .41-.5Zm12 2a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$c40bb220b1ba2c5e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss20Regular', "20", [
    "M6.59 7a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09Zm0 3a.5.5 0 0 0-.09-1H4.41a.5.5 0 0 0 .09 1h2.09ZM7 12.5a.5.5 0 0 1-.41.5H4.5a.5.5 0 0 1-.09-1H6.5c.28 0 .5.22.5.5ZM5 3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h4.2c-.08-.32-.15-.66-.18-1H9V4h6a2 2 0 0 1 2 2v3.6c.36.18.7.4 1 .66V6a3 3 0 0 0-3-3H5Zm0 1h3v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2Zm14 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6abdd9470f347cc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h13.5C20.55 4 22 5.46 22 7.25v5.56a6.52 6.52 0 0 0-1.5-1.08V7.25c0-.97-.78-1.75-1.75-1.75H10v13h1.08c.08.52.22 1.03.42 1.5H5.25A3.25 3.25 0 0 1 2 16.75v-9.5ZM4.75 8.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75Zm0 3.5c0 .41.34.75.75.75h1.25a.75.75 0 0 0 0-1.5H5.5a.75.75 0 0 0-.75.75Zm.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H5.5ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$b02376765cd57afc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss24Regular', "24", [
    "M4.75 8.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Zm0 3.5c0-.41.34-.75.75-.75h1.25a.75.75 0 0 1 0 1.5H5.5a.75.75 0 0 1-.75-.75Zm.75 2.75a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H5.5ZM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h6.25c-.2-.47-.34-.98-.42-1.5H10v-13h8.75c.97 0 1.75.78 1.75 1.75v4.48c.55.29 1.06.65 1.5 1.08V7.25C22 5.45 20.54 4 18.75 4H5.25Zm0 1.5H8.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$30a2e4d00d5744eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss28Filled', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h7.68c-.17-.48-.3-.98-.36-1.5H11v-16h11.25c1.24 0 2.25 1 2.25 2.25v6.4c.55.35 1.06.77 1.5 1.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5Zm.75 4.25h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64-2.65-2.64Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$99f27e0cfdf90b24 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss28Regular', "28", [
    "M5 8.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 8.5Zm0 5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 5 13.5Zm.75 4.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM2 7.75A3.75 3.75 0 0 1 5.75 4h16.5A3.75 3.75 0 0 1 26 7.75v7.65c-.44-.48-.95-.9-1.5-1.25v-6.4c0-1.24-1-2.25-2.25-2.25H11v16h2.07c.07.52.19 1.02.36 1.5H5.75A3.75 3.75 0 0 1 2 19.25V7.75ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1.01 2.25 2.25 2.25H9.5v-16H5.75ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64-2.65-2.64Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d04349d041a8b175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss32Filled', "32", [
    "M2 8.5A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v8.84a9.05 9.05 0 0 0-2-1.82V8.5A2.5 2.5 0 0 0 25.5 6H13v20h1.51c.25.71.6 1.38 1 2H6.5A4.5 4.5 0 0 1 2 23.5v-15Zm4.5.5a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 7a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1Zm0 6a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1ZM23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm2.72 3.72L23 21.94l-2.72-2.72a.75.75 0 1 0-1.06 1.06L21.94 23l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23 24.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L24.06 23l2.72-2.72a.75.75 0 1 0-1.06-1.06Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$1c7d9b23c122dc53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss32Regular', "32", [
    "M6.5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1-18A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h9.02a8.97 8.97 0 0 1-1-2H13V6h12.5A2.5 2.5 0 0 1 28 8.5v7.02c.76.5 1.43 1.12 2 1.82V8.5A4.5 4.5 0 0 0 25.5 4h-19Zm0 2H11v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6ZM23 15.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm2.72 3.72L23 21.94l-2.72-2.72a.75.75 0 1 0-1.06 1.06L21.94 23l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23 24.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L24.06 23l2.72-2.72a.75.75 0 1 0-1.06-1.06Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$3705b959dec2b351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss48Filled', "48", [
    "M10.25 7A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h13.21c-.4-.79-.74-1.63-.98-2.5H19v-29h18.75a3.75 3.75 0 0 1 3.75 3.75v10.49c.9.52 1.75 1.16 2.5 1.88V13.25C44 9.8 41.2 7 37.75 7h-27.5ZM8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 7.75h3.5a1.25 1.25 0 1 1 0 2.5h-3.5a1.25 1.25 0 1 1 0-2.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35l4.3-4.3Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$6c21ee2efadee579 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelLeftTextDismiss48Regular', "48", [
    "M8.5 15c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm0 9c0-.69.56-1.25 1.25-1.25h3.5a1.25 1.25 0 1 1 0 2.5h-3.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 7.75a1.25 1.25 0 1 0 0 2.5h3.5a1.25 1.25 0 1 0 0-2.5h-3.5ZM4 13.25C4 9.8 6.8 7 10.25 7h27.5C41.2 7 44 9.8 44 13.25v12.37c-.75-.72-1.6-1.36-2.5-1.88V13.25a3.75 3.75 0 0 0-3.75-3.75H19v29h3.48c.24.87.57 1.71.98 2.5H10.25A6.25 6.25 0 0 1 4 34.75v-21.5Zm6.25-3.75a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h6.25v-29h-6.25ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35l4.3-4.3Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$81d74ba4e85aad40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight12Filled', "12", [
    "M9 2H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM2 8V4a1 1 0 0 1 1-1h4v6H3a1 1 0 0 1-1-1Z"
]);
const $cdb0ff5c001a8842$export$f500c357dcf9e30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight12Regular', "12", [
    "M9 2H3a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM2 8V4a1 1 0 0 1 1-1h4v6H3a1 1 0 0 1-1-1Zm8 0a1 1 0 0 1-1 1H8V3h1a1 1 0 0 1 1 1v4Z"
]);
const $cdb0ff5c001a8842$export$bd72954a245473c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight16Filled', "16", [
    "M11.5 3A2.5 2.5 0 0 1 14 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 10.5v-5A2.5 2.5 0 0 1 4.5 3h7ZM9 4H4.5C3.67 4 3 4.67 3 5.5v5c0 .83.67 1.5 1.5 1.5H9V4Z"
]);
const $cdb0ff5c001a8842$export$1760650939d63ea8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight16Regular', "16", [
    "M14 5.5A2.5 2.5 0 0 0 11.5 3h-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5ZM9 4v8H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H9Zm1 0h1.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5H10V4Z"
]);
const $cdb0ff5c001a8842$export$fdc10796714e22be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10ZM5 4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h6.5V4H5Z"
]);
const $cdb0ff5c001a8842$export$6661e79dd6ef43f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight20Regular', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6Zm-6.5-2v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.5Zm1 0H15a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2.5V4Z"
]);
const $cdb0ff5c001a8842$export$d7414cec19661827 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4h13.5ZM5.25 5.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h9.25v-13H5.25Z"
]);
const $cdb0ff5c001a8842$export$33b8cf4b06d113bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight24Regular', "24", [
    "M22 7.25C22 5.45 20.54 4 18.75 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5ZM14.5 5.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75h9.25Zm1.5 0h2.75c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H16v-13Z"
]);
const $cdb0ff5c001a8842$export$defc49b972314676 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight28Filled', "28", [
    "M26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V7.75ZM5.75 21.5c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1-2.25 2.25-2.25H17.5v16H5.75Z"
]);
const $cdb0ff5c001a8842$export$9b6c32a985718e2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5Zm2.25 3.75c0-1.24-1.01-2.25-2.25-2.25H19v16h3.25c1.24 0 2.25-1 2.25-2.25V7.75Zm-7 13.75v-16H5.75c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1 2.25 2.25 2.25H17.5Z"
]);
const $cdb0ff5c001a8842$export$1687f5df2f22c247 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight32Filled', "32", [
    "M6.5 28A4.5 4.5 0 0 1 2 23.5v-15A4.5 4.5 0 0 1 6.5 4h19A4.5 4.5 0 0 1 30 8.5v15a4.5 4.5 0 0 1-4.5 4.5h-19Zm0-22A2.5 2.5 0 0 0 4 8.5v15A2.5 2.5 0 0 0 6.5 26H20V6H6.5Z"
]);
const $cdb0ff5c001a8842$export$8e5b817562960d09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight32Regular', "32", [
    "M20 6v20H6.5A2.5 2.5 0 0 1 4 23.5v-15A2.5 2.5 0 0 1 6.5 6H20Zm2 0h3.5A2.5 2.5 0 0 1 28 8.5v15a2.5 2.5 0 0 1-2.5 2.5H22V6Zm8 2.5A4.5 4.5 0 0 0 25.5 4h-19A4.5 4.5 0 0 0 2 8.5v15A4.5 4.5 0 0 0 6.5 28h19a4.5 4.5 0 0 0 4.5-4.5v-15Z"
]);
const $cdb0ff5c001a8842$export$b54897ddbb6bdb3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight48Filled', "48", [
    "M44 13.25C44 9.8 41.2 7 37.75 7h-27.5A6.25 6.25 0 0 0 4 13.25v21.5C4 38.2 6.8 41 10.25 41h27.5C41.2 41 44 38.2 44 34.75v-21.5ZM10.25 38.5a3.75 3.75 0 0 1-3.75-3.75v-21.5a3.75 3.75 0 0 1 3.75-3.75h19.5v29h-19.5Z"
]);
const $cdb0ff5c001a8842$export$51b882ccd14b2175 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRight48Regular', "48", [
    "M37.75 7C41.2 7 44 9.8 44 13.25v21.5C44 38.2 41.2 41 37.75 41h-27.5A6.25 6.25 0 0 1 4 34.75v-21.5C4 9.8 6.8 7 10.25 7h27.5Zm3.75 6.25a3.75 3.75 0 0 0-3.75-3.75h-5.5v29h5.5a3.75 3.75 0 0 0 3.75-3.75v-21.5ZM29.75 38.5v-29h-19.5a3.75 3.75 0 0 0-3.75 3.75v21.5a3.75 3.75 0 0 0 3.75 3.75h19.5Z"
]);
const $cdb0ff5c001a8842$export$ec29313264446813 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightAdd20Filled', "20", [
    "M18 6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2c-.08-.32-.15-.66-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8v4.6a5.48 5.48 0 0 1 6 .66V6Zm-3.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z"
]);
const $cdb0ff5c001a8842$export$9d5f8421c49e11a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightAdd20Regular', "20", [
    "M18 6c0-1.1-.9-2.02-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5.2c-.08-.32-.15-.66-.18-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8v4.6c.32-.16.66-.3 1-.4V5h3a1 1 0 0 1 1 1v3.6c.36.18.7.4 1 .66V6Zm-3.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z"
]);
const $cdb0ff5c001a8842$export$6afccd389ddaded3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract16Filled', "16", [
    "M6.3 7.5H4.5a.5.5 0 0 0 0 1h1.8l-.65.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7l.64.65ZM12 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8Zm-3-1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v8Z"
]);
const $cdb0ff5c001a8842$export$b825cd59e0c68f74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract16Regular', "16", [
    "m6.3 8.5-.65.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7l.64.65H4.5a.5.5 0 1 0 0 1h1.8ZM12 13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8Zm1-2a1 1 0 0 1-1 1h-2V4h2a1 1 0 0 1 1 1v6ZM9 4v8H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5Z"
]);
const $cdb0ff5c001a8842$export$ed144c304c697d46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract20Filled', "20", [
    "m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1h3.68ZM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12ZM12 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8Z"
]);
const $cdb0ff5c001a8842$export$789bbed396bbc3f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract20Regular', "20", [
    "m9.18 10.5-1 .87a.5.5 0 1 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.66.76l1 .87H5.5a.5.5 0 0 0 0 1h3.68ZM16 16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12Zm1-2a1 1 0 0 1-1 1h-3V5h3a1 1 0 0 1 1 1v8Zm-5-9v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8Z"
]);
const $cdb0ff5c001a8842$export$c709dba07cd09e23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract24Filled', "24", [
    "M9.2 9.25a.75.75 0 0 1 1.05-.06l2.5 2.25a.75.75 0 0 1 0 1.12l-2.5 2.25a.75.75 0 1 1-1-1.12l1.05-.94H6.75a.75.75 0 0 1 0-1.5h3.55l-1.05-.94a.75.75 0 0 1-.06-1.06Zm12.8 8A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5Zm-7 1.25v-13H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25H15Z"
]);
const $cdb0ff5c001a8842$export$efeabf7ae05b5625 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract24Regular', "24", [
    "M9.2 9.25a.75.75 0 0 1 1.05-.06l2.5 2.25a.75.75 0 0 1 0 1.12l-2.5 2.25a.75.75 0 0 1-1-1.12l1.05-.94H6.75a.75.75 0 1 1 0-1.5h3.55l-1.05-.94a.75.75 0 0 1-.06-1.06Zm12.8 8A2.75 2.75 0 0 1 19.25 20H4.75A2.75 2.75 0 0 1 2 17.25V6.75A2.75 2.75 0 0 1 4.75 4h14.5A2.75 2.75 0 0 1 22 6.75v10.5Zm-2.75 1.25c.69 0 1.25-.56 1.25-1.25V6.75c0-.7-.56-1.25-1.25-1.25H16v13h3.25Zm-4.75 0v-13H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .7.56 1.25 1.25 1.25h9.75Z"
]);
const $cdb0ff5c001a8842$export$6eecc441dcc06552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17H5.75Zm4.97 4.97c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H6.75a.75.75 0 0 1 0-1.5h5.7l-1.73-1.72a.75.75 0 0 1 0-1.06Z"
]);
const $cdb0ff5c001a8842$export$73647208e141125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightContract28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17H5.75Zm12.75 0v17h3.75c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H18.5Zm-7.78 4.97c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H6.75a.75.75 0 0 1 0-1.5h5.7l-1.73-1.72a.75.75 0 0 1 0-1.06Z"
]);
const $cdb0ff5c001a8842$export$42c4e9b705ca55ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor20Filled', "20", [
    "M15 3a3 3 0 0 1 3 3v7c0 .53-.14 1.02-.38 1.45l-5.06-5.01A1.5 1.5 0 0 0 11.5 9V4H5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h5v1H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10Zm-3.14 7.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84l-6-5.94Z"
]);
const $cdb0ff5c001a8842$export$24c210f511644f87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor20Regular', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h5v-1H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h6.5v5c.36 0 .72.13 1 .38V4H15a2 2 0 0 1 2 2v7a2 2 0 0 1-.13.7l.75.75c.24-.43.38-.92.38-1.45V6Zm-6.14 4.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84l-6-5.94Z"
]);
const $cdb0ff5c001a8842$export$7a632c209c8b6ebe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25v9.5c0 .42-.08.81-.22 1.18l-5.73-6.35c-.4-.44-.98-.65-1.55-.56V5.5H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H13V20H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4h13.5Zm-4.26 8.05a.75.75 0 0 1 .82.2l6.37 7.06a.75.75 0 0 1-.74 1.23l-3.54-.88-2.03 3.01a.75.75 0 0 1-1.37-.42v-9.5c0-.31.2-.59.49-.7Z"
]);
const $cdb0ff5c001a8842$export$7a9f47bdc41d48ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightCursor24Regular', "24", [
    "M22 7.25C22 5.45 20.54 4 18.75 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20H13v-1.5H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75h9.25v5.52c.55-.08 1.1.1 1.5.5V5.5h2.75c.97 0 1.75.78 1.75 1.75v9.26l1.28 1.42c.14-.37.22-.76.22-1.18v-9.5Zm-7.51 4.8a.75.75 0 0 1 .82.2l6.37 7.06a.75.75 0 0 1-.74 1.23l-3.54-.88-2.03 3.01a.75.75 0 0 1-1.37-.42v-9.5c0-.31.2-.59.49-.7Z"
]);
const $cdb0ff5c001a8842$export$39c3609f3b5a5f1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightDefault28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17H5.75Z"
]);
const $cdb0ff5c001a8842$export$825ed40f489f9751 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightDefault28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17H5.75Zm12.75 17h3.75c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H18.5v17Z"
]);
const $cdb0ff5c001a8842$export$b0a7cc96d2e0563 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand20Filled', "20", [
    "m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1H6.82ZM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8Zm-6 1V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8Z"
]);
const $cdb0ff5c001a8842$export$df9abde7ba263ae7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand20Regular', "20", [
    "m6.82 10.5 1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .66.76l-1 .87h3.68a.5.5 0 0 1 0 1H6.82ZM18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8Zm-2 1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3v10h3Zm-4 0V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8Z"
]);
const $cdb0ff5c001a8842$export$6213d9a92b986326 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand28Filled', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17H5.75Zm3.47 4.97a.75.75 0 1 1 1.06 1.06l-1.72 1.72h5.7a.75.75 0 0 1 0 1.5h-5.7l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3Z"
]);
const $cdb0ff5c001a8842$export$6c5eae33a9ff6c32 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightExpand28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v12.5A3.75 3.75 0 0 1 22.25 24H5.75A3.75 3.75 0 0 1 2 20.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5ZM5.75 5.5c-1.24 0-2.25 1-2.25 2.25v12.5c0 1.24 1.01 2.25 2.25 2.25H17v-17H5.75Zm12.75 0v17h3.75c1.24 0 2.25-1 2.25-2.25V7.75c0-1.24-1-2.25-2.25-2.25H18.5Zm-9.28 4.97a.75.75 0 1 1 1.06 1.06l-1.72 1.72h5.7a.75.75 0 0 1 0 1.5h-5.7l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3Z"
]);
const $cdb0ff5c001a8842$export$dd7713fd0fbea73a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery16Filled', "16", [
    "M14 5.5A2.5 2.5 0 0 0 11.5 3h-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5V10h-4v2H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H10v2h4v-.5ZM14 7h-4v2h4V7Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$a55f98507f039319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery16Regular', "16", [
    "M14 5.5A2.5 2.5 0 0 0 11.5 3h-7A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5Zm-1 0V6h-3V4h1.5c.83 0 1.5.67 1.5 1.5ZM10 9V7h3v2h-3Zm0 1h3v.5c0 .83-.67 1.5-1.5 1.5H10v-2ZM9 4v8H4.5A1.5 1.5 0 0 1 3 10.5v-5C3 4.67 3.67 4 4.5 4H9Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$dcb76b6147085934 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery20Filled', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1h-5v3H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8v3h5V6Zm0 2h-5v3h5V8Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$39f93f4dfe4b8750 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery20Regular', "20", [
    "M18 6a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V6Zm-1 5h-4V8h4v3Zm-4 1h4v1a2 2 0 0 1-2 2h-2v-3Zm4-6v1h-4V4h2a2 2 0 0 1 2 2Zm-5-2v11H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h7Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$d008125ada9cabb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery24Filled', "24", [
    "M18.75 4C20.55 4 22 5.46 22 7.25V8.5h-6v-3H5.25c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75H16v-3h6v1.25c0 1.8-1.46 3.25-3.25 3.25H5.25A3.25 3.25 0 0 1 2 16.75v-9.5C2 5.45 3.46 4 5.25 4h13.5ZM22 14v-4h-6v4h6Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$8cc7a9ddbfda3eb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery24Regular', "24", [
    "M22 7.25C22 5.45 20.54 4 18.75 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5Zm-1.5 6.25h-5v-3h5v3Zm-5 1.5h5v1.75c0 .97-.78 1.75-1.75 1.75H15.5V15Zm5-7.75V9h-5V5.5h3.25c.97 0 1.75.78 1.75 1.75ZM14 5.5v13H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75H14Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$60eaf434069815bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery28Filled', "28", [
    "M26 7.75A3.75 3.75 0 0 0 22.25 4H5.75A3.75 3.75 0 0 0 2 7.75v11.5A3.75 3.75 0 0 0 5.75 23h16.5A3.75 3.75 0 0 0 26 19.25V17.5h-8v4H5.75c-1.24 0-2.25-1-2.25-2.25V7.75c0-1.24 1-2.25 2.25-2.25H18v4h8V7.75ZM18 16h8v-5h-8v5Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$f17d844d6dca5d5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelRightGallery28Regular', "28", [
    "M22.25 4A3.75 3.75 0 0 1 26 7.75v11.5A3.75 3.75 0 0 1 22.25 23H5.75A3.75 3.75 0 0 1 2 19.25V7.75A3.75 3.75 0 0 1 5.75 4h16.5Zm2.25 3.75c0-1.24-1.01-2.25-2.25-2.25H18.5V10h6V7.75Zm-6 7.75h6v-4h-6v4Zm0 1.5v4.5h3.75c1.24 0 2.25-1 2.25-2.25V17h-6ZM17 21.5v-16H5.75c-1.24 0-2.25 1-2.25 2.25v11.5c0 1.24 1 2.25 2.25 2.25H17Z"
], {
    flipInRtl: true
});
const $cdb0ff5c001a8842$export$27d327ad18e969d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelSeparateWindow20Filled', "20", [
    "M3 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Zm0 12v-3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
]);
const $cdb0ff5c001a8842$export$e0ab46bbcaf7df53 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelSeparateWindow20Regular', "20", [
    "M3 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3ZM2 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4Zm1 10v-3h1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
]);
const $cdb0ff5c001a8842$export$217d6e66e0e82a8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopContract20Filled', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0V8.83ZM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4Zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-3.83a1.5 1.5 0 0 0-.3-.5l-1.74-2a1.5 1.5 0 0 0-2.26 0l-1.75 2a1.5 1.5 0 0 0-.29.5H3v5Z"
]);
const $cdb0ff5c001a8842$export$d985d833683a1fc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopContract20Regular', "20", [
    "m10.5 8.83.87 1a.5.5 0 0 0 .76-.66l-1.75-2a.5.5 0 0 0-.76 0l-1.75 2a.5.5 0 0 0 .76.65l.87-1v3.68a.5.5 0 0 0 1 0V8.83ZM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4Zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-3.83a1.5 1.5 0 0 0-.3-.5l-.44-.5H17V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h4.57l-.45.5a1.5 1.5 0 0 0-.29.5H3v5Z"
]);
const $cdb0ff5c001a8842$export$7d6cc0c761c677a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopExpand20Filled', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 0 1 1 0v3.67ZM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4Zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5.5V7.5a1.5 1.5 0 1 0-3 0V9H3v5Z"
]);
const $cdb0ff5c001a8842$export$b278d89398ce5f2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopExpand20Regular', "20", [
    "m10.5 11.17.87-1a.5.5 0 0 1 .76.66l-1.75 2a.5.5 0 0 1-.76 0l-1.75-2a.5.5 0 1 1 .76-.65l.87 1V7.5a.5.5 0 0 1 1 0v3.67ZM4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4Zm-1-2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-5.5V8H17V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2h5.5v1H3v5Z"
]);
const $cdb0ff5c001a8842$export$7c2534fedbb7babc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery16Filled', "16", [
    "M5 3h-.5A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3H11v4h2v3.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 10.5V7h2V3Zm1 4h4V3H6v4Z"
]);
const $cdb0ff5c001a8842$export$d3c5551f9a5413e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery16Regular', "16", [
    "M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3h-7ZM3 5.5C3 4.67 3.67 4 4.5 4H6v3H3V5.5ZM3 8h10v2.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 10.5V8Zm10-1h-3V4h1.5c.83 0 1.5.67 1.5 1.5V7ZM9 4v3H7V4h2Z"
]);
const $cdb0ff5c001a8842$export$a8d31e6198f3cfc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery20Filled', "20", [
    "M7 4H5a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-2v5h4v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9h4V4Zm1 5h4V4H8v5Z"
]);
const $cdb0ff5c001a8842$export$f10040033b2f1a2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery20Regular', "20", [
    "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5ZM3 7c0-1.1.9-2 2-2h2v4H3V7Zm0 3h14v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3Zm14-1h-4V5h2a2 2 0 0 1 2 2v2Zm-5-4v4H8V5h4Z"
]);
const $cdb0ff5c001a8842$export$bfbe08ecaf370c3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery24Filled', "24", [
    "M7.5 4H5.25A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H16.5v7h4v5.75c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75V11h4V4ZM9 11h6V4H9v7Z"
]);
const $cdb0ff5c001a8842$export$505efe31bf6c4964 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery24Regular', "24", [
    "M5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H5.25ZM3.5 7.25c0-.97.78-1.75 1.75-1.75H8v5H3.5V7.25Zm0 4.75h17v4.75c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75V12Zm17-1.5H16v-5h2.75c.97 0 1.75.78 1.75 1.75v3.25Zm-6-5v5h-5v-5h5Z"
]);
const $cdb0ff5c001a8842$export$d069a0aef08f7848 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery28Filled', "28", [
    "M9 4H5.75c-.88 0-1.7.3-2.34.82-.24.16-.44.36-.59.6A3.73 3.73 0 0 0 2 7.74v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.73 3.73 0 0 0 22.25 4H19v8h5.5v8.25c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25V12H9V4Zm1.5 8h7V4h-7v8Z"
]);
const $cdb0ff5c001a8842$export$750d5a773978686f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PanelTopGallery28Regular', "28", [
    "M5.75 4A3.75 3.75 0 0 0 2 7.75v12.5A3.75 3.75 0 0 0 5.75 24h16.5A3.75 3.75 0 0 0 26 20.25V7.75A3.75 3.75 0 0 0 22.25 4H5.75ZM3.5 7.75c0-1.24 1.01-2.25 2.25-2.25H9.5v6h-6V7.75Zm0 5.25h21v7.25c0 1.24-1 2.25-2.25 2.25H5.75c-1.24 0-2.25-1-2.25-2.25V13Zm21-1.5h-6v-6h3.75c1.24 0 2.25 1 2.25 2.25v3.75Zm-7.5-6v6h-6v-6h6Z"
]);
const $cdb0ff5c001a8842$export$35825cad497fd342 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket16Filled', "16", [
    "M8.36 5.35a1.62 1.62 0 1 1 2.3 2.3 1.62 1.62 0 0 1-2.3-2.3Zm1.59.7a.62.62 0 0 0-.88 0 .62.62 0 0 0 0 .88c.25.25.64.25.88 0a.62.62 0 0 0 0-.87ZM7.5 11l.17.17c.39.4.94.52 1.44.4l.85.84c.2.2.51.2.7 0l1.08-1.07c.66-.66.75-1.66.3-2.41l.54-.55a4.84 4.84 0 0 0 1.2-4.88c-.2-.6-.67-1.08-1.27-1.27a4.84 4.84 0 0 0-4.88 1.2l-.55.54a1.97 1.97 0 0 0-2.41.3L3.6 5.34a.5.5 0 0 0 0 .7l.85.86c-.13.5 0 1.05.39 1.44L5 8.5l-.77.46a.5.5 0 0 0-.1.78l2.13 2.12a.5.5 0 0 0 .78-.1L7.5 11Zm5.32-7.2a3.84 3.84 0 0 1-.94 3.87l-2.8 2.8a.5.5 0 0 1-.7 0l-.62-.62-1.6-1.6-.62-.62a.5.5 0 0 1 0-.7l2.8-2.8a3.84 3.84 0 0 1 3.87-.95c.29.1.52.33.61.62Zm-7.97 8.06a.5.5 0 1 0-.7-.7l-1.33 1.32a.5.5 0 1 0 .7.7l1.33-1.32ZM3.79 10.1c.2.2.2.5 0 .7l-.53.53a.5.5 0 1 1-.7-.7l.52-.53c.2-.2.51-.2.7 0Zm2.12 2.83a.5.5 0 1 0-.7-.71l-.54.53a.5.5 0 1 0 .71.7l.53-.52Z"
]);
const $cdb0ff5c001a8842$export$18564c9840112cad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket16Regular', "16", [
    "M8.36 5.35a1.62 1.62 0 1 1 2.3 2.3 1.62 1.62 0 0 1-2.3-2.3Zm1.59.7a.62.62 0 0 0-.88 0 .62.62 0 0 0 0 .88c.25.25.64.25.88 0a.62.62 0 0 0 0-.87Zm3.83-2.55c-.2-.6-.67-1.08-1.27-1.27a4.84 4.84 0 0 0-4.88 1.2L7 4.04a2.38 2.38 0 0 0-2.62.5l-.78.79a.5.5 0 0 0 0 .7l.85.86c-.13.5 0 1.05.39 1.44L5 8.5l-.77.46a.5.5 0 0 0-.1.78l2.13 2.12a.5.5 0 0 0 .78-.1L7.5 11l.17.17c.39.4.94.52 1.44.4l.85.84c.2.2.51.2.7 0l.8-.78c.7-.71.87-1.76.5-2.63l.62-.62a4.84 4.84 0 0 0 1.2-4.88Zm-1.57-.32c.29.1.52.33.61.62a3.84 3.84 0 0 1-.94 3.87l-2.8 2.8a.5.5 0 0 1-.7 0L5.53 7.62a.5.5 0 0 1 0-.7l2.8-2.8a3.84 3.84 0 0 1 3.87-.95Zm-1.07 6.64c.04.39-.1.8-.4 1.1l-.43.43-.35-.35 1.18-1.18ZM5.1 5.26c.3-.3.7-.43 1.1-.4L5 6.04l-.35-.35.43-.43Zm1.68 5.01-.26.44L5.29 9.5l.44-.27 1.04 1.04Zm-1.92 1.6a.5.5 0 1 0-.7-.71l-1.33 1.32a.5.5 0 1 0 .7.7l1.33-1.32ZM3.79 10.1c.2.2.2.5 0 .7l-.53.53a.5.5 0 1 1-.7-.7l.52-.53c.2-.2.51-.2.7 0Zm2.12 2.83a.5.5 0 1 0-.7-.71l-.54.53a.5.5 0 1 0 .71.7l.53-.52Z"
]);
const $cdb0ff5c001a8842$export$ae6022de14e4977a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket20Filled', "20", [
    "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82Zm2.11.7a1 1 0 1 0-1.4 1.41 1 1 0 0 0 1.4-1.4ZM9.44 13.6l.6.6a1.5 1.5 0 0 0 1.71.3l1.12 1.12c.2.2.51.2.7 0L15 14.2c.86-.86.96-2.17.31-3.14l.85-.85a6.3 6.3 0 0 0 1.56-6.33 2.43 2.43 0 0 0-1.6-1.6A6.3 6.3 0 0 0 9.8 3.86l-.85.85A2.5 2.5 0 0 0 5.8 5L4.38 6.43a.5.5 0 0 0 0 .7L5.5 8.27a1.5 1.5 0 0 0 .3 1.7l.6.61-1.21.73a.5.5 0 0 0-.1.78l2.83 2.83a.5.5 0 0 0 .79-.1l.73-1.21Zm7.32-9.42a5.3 5.3 0 0 1-1.3 5.33l-4 4a.5.5 0 0 1-.7 0l-1.07-1.07-2.12-2.12L6.5 9.24a.5.5 0 0 1 0-.7l3.99-4a5.3 5.3 0 0 1 5.33-1.3c.44.13.8.48.93.93ZM5.8 14.91a.5.5 0 0 0-.7-.7l-1.77 1.76a.5.5 0 1 0 .7.7l1.77-1.76ZM4.4 12.79c.2.2.2.5 0 .7l-.7.71a.5.5 0 1 1-.72-.7l.71-.71c.2-.2.51-.2.71 0Zm2.83 3.53a.5.5 0 1 0-.7-.7l-.72.7a.5.5 0 1 0 .71.71l.71-.7Z"
]);
const $cdb0ff5c001a8842$export$e046528df89a0516 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket20Regular', "20", [
    "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82Zm2.11.7a1 1 0 1 0-1.4 1.42 1 1 0 0 0 1.4-1.42Zm-1.12 7.37a1.5 1.5 0 0 1-1.7-.3l-.61-.6-.74 1.22a.5.5 0 0 1-.78.1L5.1 12.09a.5.5 0 0 1 .1-.79l1.22-.73-.61-.6a1.5 1.5 0 0 1-.3-1.71L4.38 7.14a.5.5 0 0 1 0-.7l1.06-1.07a3 3 0 0 1 3.42-.59l.93-.93a6.3 6.3 0 0 1 6.33-1.56c.76.24 1.36.83 1.6 1.6a6.3 6.3 0 0 1-1.56 6.32l-.94.94a3 3 0 0 1-.58 3.41l-1.06 1.06a.5.5 0 0 1-.71 0l-1.12-1.12Zm4.08-11.26a5.3 5.3 0 0 0-5.33 1.31l-.81.82-.7.7h-.01L6.86 8.2l-.4.4a.5.5 0 0 0 .05.66l4.24 4.24c.18.18.46.2.66.05l.4-.4 2.12-2.12.7-.71.82-.81a5.3 5.3 0 0 0 1.31-5.33c-.14-.45-.49-.8-.93-.94Zm-3.31 10.62.7.7.7-.7a2 2 0 0 0 .53-1.93l-1.93 1.93Zm-4.44-8.3a2 2 0 0 0-1.93.52l-.7.7.7.71 1.93-1.93Zm.63 7.31L7.14 11.3l-.89.53 1.93 1.93.53-.89Zm-2.9 2.04a.5.5 0 1 0-.71-.7l-1.77 1.76a.5.5 0 1 0 .7.71l1.77-1.77ZM4.38 12.8c.2.2.2.51 0 .7l-.71.72a.5.5 0 0 1-.7-.71l.7-.71c.2-.2.51-.2.7 0Zm2.83 3.54a.5.5 0 0 0-.7-.71l-.72.7a.5.5 0 1 0 .7.72l.72-.71Z"
]);
const $cdb0ff5c001a8842$export$9b7cbb4d7078395a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket24Filled', "24", [
    "M13.06 7.43a2.5 2.5 0 1 1 3.53 3.54 2.5 2.5 0 0 1-3.53-3.54Zm2.47 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.42Zm4.17-5.98c.86.27 1.54.95 1.8 1.81l.21.67c.75 2.4.1 5-1.67 6.77l-1 1a3.5 3.5 0 0 1-.32 4.57l-1.25 1.24c-.29.3-.76.3-1.06 0l-1.59-1.59-.17.18c-.69.68-1.8.68-2.48 0l-.48-.49-.82 1.4a.75.75 0 0 1-1.17.14l-3.9-3.89a.75.75 0 0 1 .15-1.17l1.39-.83-.47-.47a1.75 1.75 0 0 1 0-2.47l.18-.18-1.6-1.6a.75.75 0 0 1 0-1.05L6.7 5.3a3.5 3.5 0 0 1 4.57-.32l1-1a6.75 6.75 0 0 1 6.77-1.67l.66.2Zm.38 2.26c-.13-.4-.43-.7-.83-.83l-.66-.2a5.25 5.25 0 0 0-5.27 1.3l-5.4 5.4c-.1.1-.1.25 0 .35l5.31 5.3c.1.1.26.1.36 0l5.4-5.39a5.25 5.25 0 0 0 1.3-5.27l-.21-.66ZM6.69 18.39a.75.75 0 0 0-1.06-1.06l-2.48 2.48a.75.75 0 0 0 1.06 1.06l2.48-2.48Zm-1.94-3c.29.3.29.77 0 1.06l-1.07 1.06a.75.75 0 0 1-1.06-1.06l1.06-1.06c.3-.3.77-.3 1.07 0Zm3.88 4.95a.75.75 0 1 0-1.06-1.06l-1.06 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06Z"
]);
const $cdb0ff5c001a8842$export$9376d3a9a0f0b4a1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Rocket24Regular', "24", [
    "M13.06 7.43a2.5 2.5 0 1 1 3.53 3.54 2.5 2.5 0 0 1-3.53-3.54Zm2.47 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.42Zm5.98-4.17a2.75 2.75 0 0 0-1.81-1.8l-.66-.21c-2.4-.75-5-.1-6.78 1.67l-1 1a3.5 3.5 0 0 0-4.56.32L5.45 6.55c-.29.29-.29.76 0 1.06l1.6 1.59-.18.18c-.69.68-.69 1.79 0 2.47l.5.5-1.4.8a.75.75 0 0 0-.16 1.17l3.89 3.9a.75.75 0 0 0 1.18-.16l.8-1.4.5.5c.68.68 1.78.68 2.47 0l.17-.18 1.6 1.6c.29.28.76.28 1.05 0l1.25-1.25a3.5 3.5 0 0 0 .32-4.57l1-1A6.75 6.75 0 0 0 21.72 5l-.21-.67Zm-2.26-.38c.4.13.7.43.83.83l.2.66c.58 1.86.08 3.9-1.3 5.27l-5.4 5.4c-.1.1-.25.1-.35 0l-5.3-5.3a.25.25 0 0 1 0-.36l5.4-5.4a5.25 5.25 0 0 1 5.26-1.3l.66.2Zm-1.29 9.9a2 2 0 0 1-.3 2.43l-.72.71-1.06-1.06 2.08-2.08ZM7.76 6.36a2 2 0 0 1 2.43-.3L8.1 8.14 7.05 7.08l.7-.72Zm2.82 9.2-.52.9-2.5-2.5.9-.51 2.12 2.11ZM6.69 18.4a.75.75 0 0 0-1.06-1.06l-2.48 2.48a.75.75 0 0 0 1.06 1.06l2.48-2.48Zm-1.94-3c.29.3.29.77 0 1.06l-1.07 1.06a.75.75 0 0 1-1.06-1.06l1.06-1.06c.3-.3.77-.3 1.07 0Zm3.88 4.95a.75.75 0 1 0-1.06-1.06l-1.06 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06Z"
]);
const $cdb0ff5c001a8842$export$ce3e81dd8ad743ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h5A2.5 2.5 0 0 1 12 4.5v5A2.5 2.5 0 0 1 9.5 12h-5A2.5 2.5 0 0 1 2 9.5v-5ZM7 14a2.5 2.5 0 0 1-2-1h4.5A3.5 3.5 0 0 0 13 9.5V4c.6.46 1 1.18 1 2v3.5A4.5 4.5 0 0 1 9.5 14H7Z"
]);
const $cdb0ff5c001a8842$export$9f6064aa3e5cdda6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v5A2.5 2.5 0 0 0 4.5 12h5A2.5 2.5 0 0 0 12 9.5v-5A2.5 2.5 0 0 0 9.5 2h-5ZM3 4.5C3 3.67 3.67 3 4.5 3h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 9.5v-5ZM5 13c.46.6 1.18 1 2 1h2.5A4.5 4.5 0 0 0 14 9.5V6c0-.82-.4-1.54-1-2v5.5A3.5 3.5 0 0 1 9.5 13H5Z"
]);
const $cdb0ff5c001a8842$export$105ef60c9f4c31cd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.99 11a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.77A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5h-4.5Z"
]);
const $cdb0ff5c001a8842$export$73e4532398b5d3ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm3.99 11a3 3 0 0 1-2.24-1h6.74a3.5 3.5 0 0 0 3.5-3.5V5.77A3 3 0 0 1 17 8v4.5a4.5 4.5 0 0 1-4.5 4.5h-4.5Z"
]);
const $cdb0ff5c001a8842$export$b8507b362de3735f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v9.5C3 17.55 4.46 19 6.25 19h9.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C19 4.45 17.54 3 15.75 3h-9.5Zm3 18.5c-1.16 0-2.17-.6-2.75-1.5h9.74A3.75 3.75 0 0 0 20 16.25V6.5c.9.58 1.5 1.59 1.5 2.74v7c0 2.9-2.35 5.26-5.25 5.26h-7Z"
]);
const $cdb0ff5c001a8842$export$41fe42b40caf1d1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOff24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v9c0 1.8 1.46 3.25 3.25 3.25h9c1.8 0 3.25-1.46 3.25-3.25v-9c0-1.8-1.46-3.25-3.25-3.25h-9ZM4.5 6.25c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v9c0 .97-.78 1.75-1.75 1.75h-9c-.97 0-1.75-.78-1.75-1.75v-9ZM6.01 19.5c.58.9 1.59 1.5 2.74 1.5h7c2.9 0 5.25-2.35 5.25-5.25v-7c0-1.15-.6-2.16-1.5-2.74v9.74a3.75 3.75 0 0 1-3.75 3.75H6.02Z"
]);
const $cdb0ff5c001a8842$export$5fa19454dcc06794 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v5A2.5 2.5 0 0 0 4.5 12h5A2.5 2.5 0 0 0 12 9.5v-5A2.5 2.5 0 0 0 9.5 2h-5Zm5.35 3.85-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64a.5.5 0 1 1 .7.7ZM5 13c.46.6 1.18 1 2 1h2.5A4.5 4.5 0 0 0 14 9.5V6c0-.82-.4-1.54-1-2v5.5A3.5 3.5 0 0 1 9.5 13H5Z"
]);
const $cdb0ff5c001a8842$export$caaa1f0651f864db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn16Regular', "16", [
    "M9.85 5.85a.5.5 0 0 0-.7-.7L6.5 7.79 5.35 6.65a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3ZM2 4.5A2.5 2.5 0 0 1 4.5 2h5A2.5 2.5 0 0 1 12 4.5v5A2.5 2.5 0 0 1 9.5 12h-5A2.5 2.5 0 0 1 2 9.5v-5ZM4.5 3C3.67 3 3 3.67 3 4.5v5c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-5ZM7 14a2.5 2.5 0 0 1-2-1h4.5A3.5 3.5 0 0 0 13 9.5V4c.6.46 1 1.18 1 2v3.5A4.5 4.5 0 0 1 9.5 14H7Z"
]);
const $cdb0ff5c001a8842$export$c8ae8d7572d855e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm6.33 3.62c.2.19.23.5.05.7l-3.5 4a.5.5 0 0 1-.73.03l-2-2a.5.5 0 1 1 .7-.7l1.63 1.62 3.14-3.6a.5.5 0 0 1 .7-.05ZM5.75 16A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.23v6.73a3.5 3.5 0 0 1-3.5 3.5H5.75Z"
]);
const $cdb0ff5c001a8842$export$af376b942d39900e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn20Regular', "20", [
    "M12.33 6.62c.2.19.23.5.05.7l-3.5 4a.5.5 0 0 1-.73.03l-2-2a.5.5 0 1 1 .7-.7l1.63 1.62 3.14-3.6a.5.5 0 0 1 .7-.05ZM3 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Zm-.25 12A3 3 0 0 0 8 17h4.5a4.5 4.5 0 0 0 4.5-4.5V8a3 3 0 0 0-1-2.23v6.73a3.5 3.5 0 0 1-3.5 3.5H5.75Z"
]);
const $cdb0ff5c001a8842$export$7958e49db3d07be8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h9.5C17.55 3 19 4.46 19 6.25v9.5c0 1.8-1.46 3.25-3.25 3.25h-9.5A3.25 3.25 0 0 1 3 15.75v-9.5Zm12.28 2.78a.75.75 0 0 0-1.06-1.06L10 12.19l-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l4.75-4.75ZM6.5 20c.58.9 1.59 1.5 2.74 1.5h7c2.9 0 5.26-2.35 5.26-5.25v-7c0-1.16-.6-2.17-1.5-2.75v9.75A3.75 3.75 0 0 1 16.25 20H6.5Z"
]);
const $cdb0ff5c001a8842$export$62f7ba9a249464d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectAllOn24Regular', "24", [
    "M15.28 9.03a.75.75 0 0 0-1.06-1.06L10 12.19l-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l4.75-4.75ZM3 6.25C3 4.45 4.46 3 6.25 3h9.5C17.55 3 19 4.46 19 6.25v9.5c0 1.8-1.46 3.25-3.25 3.25h-9.5A3.25 3.25 0 0 1 3 15.75v-9.5ZM6.25 4.5c-.97 0-1.75.78-1.75 1.75v9.5c0 .97.78 1.75 1.75 1.75h9.5c.97 0 1.75-.78 1.75-1.75v-9.5c0-.97-.78-1.75-1.75-1.75h-9.5Zm3 17c-1.16 0-2.17-.6-2.75-1.5h9.74A3.75 3.75 0 0 0 20 16.25V6.5c.9.58 1.5 1.59 1.5 2.74v7c0 2.9-2.35 5.26-5.25 5.26h-7Z"
]);
const $cdb0ff5c001a8842$export$25518b15f5a40d9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject20Filled', "20", [
    "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 4.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75Zm0 10.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm-3-7.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Zm10.5 0a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Z"
]);
const $cdb0ff5c001a8842$export$e866c6c61d9d9463 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject20Regular', "20", [
    "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 11c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3-8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm11 0a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Z"
]);
const $cdb0ff5c001a8842$export$aa5b7144e2bf4e26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject24Filled', "24", [
    "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 0a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H9a1 1 0 0 0-1 1ZM5 8a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Zm14 0a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1ZM9 20a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2H9Zm-4 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM21 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $cdb0ff5c001a8842$export$6c6cd6ecff2ce427 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObject24Regular', "24", [
    "M7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1-.25c0 .41.34.75.75.75h6.5a.75.75 0 0 0 0-1.5h-6.5a.75.75 0 0 0-.75.75ZM4.75 8a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5A.75.75 0 0 0 4.75 8Zm14.5 0a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75ZM8.75 20a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5h-6.5ZM5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM21 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
]);
const $cdb0ff5c001a8842$export$97788873825d0dde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew20Filled', "20", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-4 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM6 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm8.11.75H9.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5ZM3.61 13 5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Zm6.5 3.25H5.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5Zm2.5-3.25 2.37-6.51c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Z"
]);
const $cdb0ff5c001a8842$export$f394e24ed75e9b9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew20Regular', "20", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02A1.5 1.5 0 0 0 16.48 6Zm-5.4 10a1.5 1.5 0 1 0 1.42-2h-.01c-.65 0-1.2.42-1.41 1l-.01.02a1.5 1.5 0 0 0 0 .98ZM3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM7.49 6a1.5 1.5 0 1 0 .02-3 1.5 1.5 0 0 0-.02 3Zm-3.62 7.03 2.32-6.4c.28.17.6.3.94.34l-2.32 6.4c-.28-.17-.6-.3-.94-.34ZM14.05 5h-4.1a2.51 2.51 0 0 0 0-1h4.1a2.51 2.51 0 0 0 0 1Zm-8.1 11h4.1a2.51 2.51 0 0 1 0-1h-4.1a2.51 2.51 0 0 1 0 1Zm6.92-2.97 2.32-6.4c.28.17.6.3.94.34l-2.32 6.4c-.28-.17-.6-.3-.94-.34Z"
]);
const $cdb0ff5c001a8842$export$89bd950bd7ec1095 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew24Filled', "24", [
    "M18.59 6.41A2 2 0 0 0 22 5a2 2 0 1 0-3.41 1.41ZM14.27 20a2 2 0 1 0 3.46-2 2 2 0 0 0-3.46 2ZM4 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM6.59 6.41A2 2 0 0 0 10 5a2 2 0 0 0-2-2 2 2 0 0 0-1.41 3.41Zm-2.77 9.6 2.44-8.56a2.99 2.99 0 0 0 1.92.54l-2.44 8.56a2.99 2.99 0 0 0-1.92-.54ZM17.17 6h-6.34a3 3 0 0 0 0-2h6.34a3 3 0 0 0 0 2Zm-4 14a3 3 0 0 1 0-2H6.83a3 3 0 0 1 0 2h6.34Zm2.65-4 2.44-8.55a2.99 2.99 0 0 0 1.92.54l-2.44 8.56a2.99 2.99 0 0 0-1.92-.54Z"
]);
const $cdb0ff5c001a8842$export$e353e16511161759 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkew24Regular', "24", [
    "M18.88 6.66a2 2 0 0 0 1.33.33 2 2 0 1 0-1.33-.33ZM14 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM4 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM6.88 6.66a2 2 0 0 0 3-.97 2 2 0 1 0-3 .97Zm-.4.93L4.08 16c.52.01 1.01.16 1.44.41L7.92 8a2.98 2.98 0 0 1-1.44-.41ZM17.1 5.75h-6.18a3 3 0 0 0 0-1.5h6.18a3 3 0 0 0 0 1.5Zm-4 14a3 3 0 0 1 0-1.5H6.91a3 3 0 0 1 0 1.5h6.18ZM16.08 16l2.4-8.41c.43.25.92.4 1.44.4l-2.4 8.42c-.43-.25-.92-.4-1.44-.4Z"
]);
const $cdb0ff5c001a8842$export$63ea8b3fc677e465 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss20Filled', "20", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5ZM3.6 13 5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Zm2.28 3.25h3.4a5.48 5.48 0 0 1-.28-1.5H5.89a2.5 2.5 0 0 1 0 1.5ZM16.39 7l-.77 2.11a5.52 5.52 0 0 0-1.56-.1l.92-2.52c.4.3.88.48 1.41.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$aba4ac5ae3ea79d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss20Regular', "20", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64c.26.21.58.34.94.34ZM2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5ZM7.49 6h.01c.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68c.26.21.58.34.94.34Zm-1.3.63-2.32 6.4c.34.05.66.17.94.34l2.32-6.4a2.48 2.48 0 0 1-.94-.34ZM14.05 5h-4.1a2.51 2.51 0 0 0 0-1h4.1a2.51 2.51 0 0 0 0 1Zm.45 4c.3 0 .59.02.87.07l.76-2.1a2.48 2.48 0 0 1-.94-.34L14.33 9h.17Zm-5.48 6c.03.34.1.68.19 1H5.95a2.51 2.51 0 0 0 0-1h3.07Zm9.98-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $cdb0ff5c001a8842$export$8ebaad005014446b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss24Filled', "24", [
    "M18.59 6.41A2 2 0 0 0 22 5a2 2 0 1 0-3.44 1.4l.03.01ZM2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM6.59 6.41A2 2 0 0 0 10 5a2 2 0 0 0-2-2 2 2 0 0 0-1.44 3.4l.03.01Zm-.33 1.04L3.82 16a3.05 3.05 0 0 1 1.92.54L8.18 8a3.05 3.05 0 0 1-1.92-.54ZM17.17 6h-6.34a3 3 0 0 0 0-2h6.34a3 3 0 0 0 0 2ZM11.5 20a6.46 6.46 0 0 1-.48-2h-4.2a3 3 0 0 1 0 2h4.68Zm8.68-12-.92 3.24a6.5 6.5 0 0 0-2.02-.24l1.02-3.55a2.99 2.99 0 0 0 1.92.54ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
]);
const $cdb0ff5c001a8842$export$33d87ae534275c47 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewDismiss24Regular', "24", [
    "M18.88 6.66a2 2 0 0 0 1.33.33 2 2 0 1 0-1.33-.33ZM2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM6.88 6.66a2 2 0 0 0 3-.97 2 2 0 1 0-3 .97ZM4.08 16l2.4-8.41c.43.25.92.4 1.44.4l-2.4 8.42c-.43-.25-.92-.4-1.44-.4ZM17.09 5.75h-6.18a3 3 0 0 0 0-1.5h6.18a3 3 0 0 0 0 1.5Zm-5.69 14c-.18-.48-.3-.98-.36-1.5H6.91a3 3 0 0 1 0 1.5h4.49ZM19.92 8l-.9 3.18A6.52 6.52 0 0 0 17.5 11l.97-3.41c.43.25.92.4 1.44.4ZM23 17.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm-7.15-2.35a.5.5 0 0 0-.7.7l1.64 1.65-1.64 1.65a.5.5 0 0 0 .7.7l1.65-1.64 1.65 1.64a.5.5 0 0 0 .7-.7l-1.64-1.65 1.64-1.65a.5.5 0 0 0-.7-.7l-1.65 1.64-1.65-1.64Z"
]);
const $cdb0ff5c001a8842$export$2e7e31aa1b2d52f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit20Filled', "20", [
    "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5ZM3.6 13 5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Zm2.28 3.25H9.4l.02-.1c.12-.46.34-.9.65-1.26 0-.05.02-.1.03-.14H5.9a2.5 2.5 0 0 1 0 1.5ZM16.39 7l-.92 2.53-.37.31-2.1 2.1 1.98-5.45c.4.3.88.48 1.41.5Zm-5.41 8.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z"
]);
const $cdb0ff5c001a8842$export$34b79a2f990869fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit20Regular', "20", [
    "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64c.26.21.58.34.94.34ZM2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5ZM7.49 6h.01c.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68c.26.21.58.34.94.34Zm-1.3.63-2.32 6.4c.34.05.66.17.94.34l2.32-6.4a2.48 2.48 0 0 1-.94-.34ZM14.05 5h-4.1a2.51 2.51 0 0 0 0-1h4.1a2.51 2.51 0 0 0 0 1Zm-.64 6.53 1.67-1.67 1.05-2.89a2.48 2.48 0 0 1-.94-.34l-1.78 4.9ZM5.95 16h3.52c.11-.36.29-.7.52-1H5.95a2.51 2.51 0 0 1 0 1Zm5.03-.62 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z"
]);
const $cdb0ff5c001a8842$export$d17ea1ff465f1320 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit24Filled', "24", [
    "M18.59 6.41A2 2 0 0 0 22 5a2 2 0 1 0-3.44 1.4l.03.01ZM2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM6.59 6.41A2 2 0 0 0 10 5a2 2 0 0 0-2-2 2 2 0 0 0-1.44 3.4l.03.01Zm-.33 1.04L3.82 16a3.05 3.05 0 0 1 1.92.54L8.18 8a3.05 3.05 0 0 1-1.92-.54ZM17.17 6h-6.34a3 3 0 0 0 0-2h6.34a3 3 0 0 0 0 2Zm-5.65 13.58c.15-.6.44-1.13.84-1.58H6.83a3 3 0 0 1 0 2h4.59l.1-.42Zm8.66-11.59-.96 3.37c-.3.15-.58.35-.83.6l-1.99 2 1.86-6.51a2.99 2.99 0 0 0 1.92.54Zm-1.08 4.68-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24Z"
]);
const $cdb0ff5c001a8842$export$7ccbfd0c06967471 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SelectObjectSkewEdit24Regular', "24", [
    "M18.88 6.66a2 2 0 0 0 1.33.33 2 2 0 1 0-1.33-.33ZM2 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM6.88 6.66a2 2 0 0 0 3-.97 2 2 0 1 0-3 .97ZM4.08 16l2.4-8.41c.43.25.92.4 1.44.4l-2.4 8.42c-.43-.25-.92-.4-1.44-.4ZM17.09 5.75h-6.18a3 3 0 0 0 0-1.5h6.18a3 3 0 0 0 0 1.5Zm-5.57 13.83c.12-.49.34-.94.64-1.33H6.9a3 3 0 0 1 0 1.5h4.57l.04-.17ZM19.92 8l-1 3.54a3.3 3.3 0 0 0-.53.42l-1.62 1.63 1.71-6c.43.25.92.4 1.44.4Zm-.82 4.67-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 0 0-3.23-3.24Z"
]);
const $cdb0ff5c001a8842$export$df94141195c42ccf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool20Filled', "20", [
    "M5.75 4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0V7.5h5V4.75a.75.75 0 1 0-1.5 0v.5a.75.75 0 1 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0v7.03c-.4.13-.91.23-1.5.22V9H8v1.23A7.16 7.16 0 0 0 6.5 10V4.75A.75.75 0 0 0 5.75 4Zm.06 8.53c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a6.84 6.84 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.33 7.33 0 0 1-7.5-.17 5.36 5.36 0 0 0-3.32-.86Zm0 3c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a6.84 6.84 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.33 7.33 0 0 1-7.5-.17 5.36 5.36 0 0 0-3.32-.86Z"
]);
const $cdb0ff5c001a8842$export$1ec95d12ca8b0819 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool20Regular', "20", [
    "M5 5a1 1 0 0 1 2 0v5.05c.32.03.65.1 1 .19V9h5v3c.37 0 .7-.03 1-.09V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0V5a1 1 0 1 1 2 0v3H8V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0V5Zm8.08 9a7.6 7.6 0 0 1-3.83-1.08c-3.42-1.97-5.32-.15-5.39-.08a.5.5 0 0 1-.71 0 .48.48 0 0 1 0-.7c.1-.1 2.48-2.46 6.6-.1a6 6 0 0 0 6.45.05c.22-.16.53-.11.7.1a.5.5 0 0 1-.1.7 6.65 6.65 0 0 1-3.72 1.1V14Zm-3.83 1.92A7.6 7.6 0 0 0 13.08 17v-.01a6.65 6.65 0 0 0 3.71-1.1.5.5 0 0 0 .11-.7.51.51 0 0 0-.7-.1 6 6 0 0 1-6.44-.04c-4.13-2.37-6.5 0-6.61.1-.2.19-.2.5 0 .7.2.19.52.18.71 0 .07-.08 1.97-1.9 5.39.07Z"
]);
const $cdb0ff5c001a8842$export$c20104e8fa58fddb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool24Filled', "24", [
    "M6 6a1 1 0 0 1 2 0v6.03c.63.06 1.3.19 2 .41V11h6v3.48c.8 0 1.48-.17 2-.35V6a3 3 0 0 0-6 0 1 1 0 1 0 2 0 1 1 0 1 1 2 0v3h-6V6a3 3 0 0 0-6 0 1 1 0 0 0 2 0Zm.6 9.02c-1.03.13-1.7.55-2 .77a1 1 0 0 1-1.2-1.6c.49-.37 1.49-.97 2.95-1.15a8.87 8.87 0 0 1 5.51 1.32 7.5 7.5 0 0 0 7.63.18 1 1 0 0 1 1.02 1.72 9.49 9.49 0 0 1-9.64-.17C9.03 15.05 7.6 14.9 6.6 15.02Zm-2 4.77c.3-.22.97-.64 2-.77 1-.12 2.43.03 4.27 1.07a9.49 9.49 0 0 0 9.64.17 1 1 0 1 0-1.02-1.72 7.5 7.5 0 0 1-7.63-.18 8.87 8.87 0 0 0-5.51-1.32 6.14 6.14 0 0 0-2.96 1.16 1 1 0 0 0 1.22 1.6Z"
]);
const $cdb0ff5c001a8842$export$df4f3b57d4febd94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool24Regular', "24", [
    "M5.5 5.75a1.25 1.25 0 1 1 2.5 0v6.29c.48.04.98.13 1.5.27V11H16v3.5a6.52 6.52 0 0 0 1.5-.2V5.75a2.75 2.75 0 1 0-5.5 0v.5a.75.75 0 0 0 1.5 0v-.5a1.25 1.25 0 1 1 2.5 0V9.5H9.5V5.75a2.75 2.75 0 0 0-5.5 0v.5a.75.75 0 0 0 1.5 0v-.5Zm-1.22 9.78a.75.75 0 0 1-1.06-1.06l.02-.02a2.15 2.15 0 0 1 .16-.14c.1-.1.25-.2.44-.33.4-.26.96-.56 1.7-.76 1.5-.4 3.6-.37 6.2 1.11a7.94 7.94 0 0 0 5.77 1 7.5 7.5 0 0 0 2.3-.94.75.75 0 0 1 .88 1.21l-.02.02a3.06 3.06 0 0 1-.2.13c-.14.08-.33.2-.57.32a9.43 9.43 0 0 1-8.9-.43c-2.28-1.3-3.98-1.27-5.07-.97a4.43 4.43 0 0 0-1.64.85Zm-1.06 4c.3.29.77.29 1.06 0l.01-.01.07-.06a4.43 4.43 0 0 1 1.57-.79c1.1-.3 2.8-.33 5.06.96a9.43 9.43 0 0 0 6.85 1.16 8.99 8.99 0 0 0 2.83-1.17l.01-.01h.01a.75.75 0 0 0-.88-1.22l-.02.02a3.56 3.56 0 0 1-.56.31 7.94 7.94 0 0 1-7.5-.4c-2.59-1.47-4.7-1.5-6.2-1.1a5.92 5.92 0 0 0-2.3 1.23v.01h-.01v.01a.75.75 0 0 0 0 1.06Z"
]);
const $cdb0ff5c001a8842$export$4a39d859d91f56d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool32Filled', "32", [
    "M8.25 5.5c-.97 0-1.75.78-1.75 1.75v.5a1.25 1.25 0 1 1-2.5 0v-.5a4.25 4.25 0 0 1 8.5 0v4.25H22V7.25a1.75 1.75 0 1 0-3.5 0v.5a1.25 1.25 0 1 1-2.5 0v-.5a4.25 4.25 0 0 1 8.5 0v11.42A9.72 9.72 0 0 1 22 19v-5h-9.5v1.98c-.88-.23-1.71-.37-2.5-.44V7.25c0-.97-.78-1.75-1.75-1.75ZM3.39 18.9v-.01l.03-.03a2.93 2.93 0 0 1 .24-.2c.15-.11.36-.27.64-.44a8.46 8.46 0 0 1 2.42-.96c2.14-.5 5.16-.41 8.94 1.59a12.72 12.72 0 0 0 8.26 1.48 10.72 10.72 0 0 0 3.13-1.07l.03-.02a1.25 1.25 0 0 1 1.35 2.1l-.01.01-.03.02a4.62 4.62 0 0 1-.3.17 13.21 13.21 0 0 1-3.75 1.25c-2.5.44-5.95.33-9.85-1.73-3.29-1.74-5.69-1.72-7.2-1.37a5.97 5.97 0 0 0-2.18 1.01 1.25 1.25 0 0 1-1.72-1.8Zm0 6v-.01l.03-.03a2.93 2.93 0 0 1 .24-.2c.15-.11.36-.27.64-.44a8.46 8.46 0 0 1 2.42-.96c2.14-.5 5.16-.41 8.94 1.59a12.72 12.72 0 0 0 8.26 1.48 10.72 10.72 0 0 0 3.13-1.07l.03-.02a1.25 1.25 0 0 1 1.35 2.1l-.01.01-.03.02a4.62 4.62 0 0 1-.3.17 13.21 13.21 0 0 1-3.75 1.25c-2.5.44-5.95.33-9.85-1.73-3.29-1.74-5.69-1.72-7.2-1.37a5.97 5.97 0 0 0-2.18 1.01 1.25 1.25 0 0 1-1.72-1.8Z"
]);
const $cdb0ff5c001a8842$export$e73fdc418ed5e9c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool32Regular', "32", [
    "M8 5a2 2 0 0 0-2 2v1a1 1 0 0 1-2 0V7a4 4 0 1 1 8 0v5h10V7a2 2 0 1 0-4 0v1a1 1 0 1 1-2 0V7a4 4 0 0 1 8 0v11.82a10.8 10.8 0 0 1-2 .18v-5H12v1.87c-.7-.17-1.36-.27-2-.32V7a2 2 0 0 0-2-2ZM4.66 20.3a1 1 0 0 1-1.33-1.5h.01l.02-.02a2.95 2.95 0 0 1 .23-.19c.15-.1.37-.25.65-.41.56-.32 1.37-.7 2.42-.93 2.13-.49 5.14-.4 8.88 1.57 3.4 1.8 6.4 1.87 8.55 1.5a11.81 11.81 0 0 0 3.35-1.1l.03-.02h.01a1 1 0 0 1 1.04 1.7l-.03.02a4.5 4.5 0 0 1-.29.16 13.8 13.8 0 0 1-3.78 1.22c-2.5.42-5.97.32-9.81-1.71-3.34-1.76-5.86-1.77-7.5-1.4a6.83 6.83 0 0 0-2.43 1.1h-.02Zm0 6a1 1 0 0 1-1.33-1.5h.01l.02-.02a2.95 2.95 0 0 1 .23-.19c.15-.1.37-.25.65-.41.56-.32 1.37-.7 2.42-.93 2.13-.49 5.14-.4 8.88 1.57 3.4 1.8 6.4 1.87 8.55 1.5a11.81 11.81 0 0 0 3.35-1.1l.03-.02h.01a1 1 0 0 1 1.04 1.7l-.03.02a4.5 4.5 0 0 1-.29.16 13.8 13.8 0 0 1-3.78 1.22c-2.5.42-5.97.32-9.81-1.71-3.34-1.76-5.86-1.77-7.5-1.4a6.83 6.83 0 0 0-2.43 1.1h-.02Z"
]);
const $cdb0ff5c001a8842$export$f85962f75c3ea05b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool48Filled', "48", [
    "M12 8a3 3 0 0 0-3 3v1.5a1.5 1.5 0 0 1-3 0V11a6 6 0 1 1 12 0v7h15v-7a3 3 0 1 0-6 0v1.5a1.5 1.5 0 1 1-3 0V11a6 6 0 0 1 12 0v17.71a16.96 16.96 0 0 1-3 .29v-8H18v3.52a21.15 21.15 0 0 0-3-.46V11a3 3 0 0 0-3-3ZM5.34 30.48a1.5 1.5 0 0 1 .2-2.1v-.01h.01l.01-.01.03-.02a4.98 4.98 0 0 1 .34-.25 13.24 13.24 0 0 1 4.48-1.8c3.1-.61 7.47-.45 12.92 2.32a20.3 20.3 0 0 0 12.48 2.17 17.83 17.83 0 0 0 4.89-1.52l.05-.02a1.5 1.5 0 0 1 1.5 2.6h-.02l-.02.02a7.13 7.13 0 0 1-.43.22 20.82 20.82 0 0 1-5.51 1.66c-3.65.57-8.7.4-14.3-2.45-4.87-2.48-8.56-2.53-10.97-2.05a10.25 10.25 0 0 0-3.39 1.33 3.57 3.57 0 0 0-.16.12 1.5 1.5 0 0 1-2.1-.2Zm0 9a1.5 1.5 0 0 1 .2-2.1v-.01h.01l.01-.01.03-.02a4.98 4.98 0 0 1 .34-.25 13.24 13.24 0 0 1 4.48-1.79c3.1-.62 7.47-.46 12.92 2.31a20.3 20.3 0 0 0 12.48 2.17 17.83 17.83 0 0 0 4.89-1.52l.05-.02a1.5 1.5 0 0 1 1.5 2.6h-.02l-.02.02a7.13 7.13 0 0 1-.43.22 20.82 20.82 0 0 1-5.51 1.66c-3.65.57-8.7.4-14.3-2.45-4.87-2.48-8.56-2.53-10.97-2.05a10.25 10.25 0 0 0-3.39 1.33 3.57 3.57 0 0 0-.16.12 1.5 1.5 0 0 1-2.1-.2Z"
]);
const $cdb0ff5c001a8842$export$4a708e9d5405bcbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwimmingPool48Regular', "48", [
    "M9 10.75a3.25 3.25 0 0 1 6.5 0v13.4c.8.08 1.63.2 2.5.4V21h15.5v8.06a17.22 17.22 0 0 0 2.5-.27V10.75a5.75 5.75 0 0 0-11.5 0v1a1.25 1.25 0 1 0 2.5 0v-1a3.25 3.25 0 0 1 6.5 0v7.75H18v-7.75a5.75 5.75 0 0 0-11.5 0v1a1.25 1.25 0 1 0 2.5 0v-1Zm13.05 20C12.57 25.9 7.33 30.4 7.1 30.6c-.51.46-1.3.42-1.76-.09-.46-.5-.43-1.28.08-1.75.27-.25 6.69-5.94 17.8-.23 9.93 5.1 17.59.76 17.91.57a1.26 1.26 0 0 1 1.7.44c.36.59.17 1.35-.43 1.7-.23.14-3.9 2.26-9.44 2.26-3.84-.1-7.47-.98-10.9-2.75ZM7.1 39.6c.24-.2 5.48-4.71 14.96.15a24.93 24.93 0 0 0 10.9 2.75c5.54 0 9.2-2.12 9.44-2.26.6-.35.79-1.11.44-1.7a1.26 1.26 0 0 0-1.71-.44c-.32.2-7.98 4.54-17.9-.57-11.12-5.7-17.54-.02-17.81.23a1.24 1.24 0 0 0-.08 1.75c.46.51 1.25.55 1.76.1Z"
]);
const $cdb0ff5c001a8842$export$9823b288288f9a3b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown20Filled', "20", [
    "M14 6a4 4 0 0 1-2.25 3.6V8.44a3 3 0 1 0-3.5 0V9.6A4 4 0 1 1 14 6ZM9.47 17.78c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22V5.75a.75.75 0 0 0-1.5 0v9.69l-1.22-1.22a.75.75 0 0 0-1.06 1.06l2.5 2.5Z"
]);
const $cdb0ff5c001a8842$export$2acd8e09ffcf8f5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown20Regular', "20", [
    "M14 6a4 4 0 0 1-2.5 3.7V8.6a3 3 0 1 0-3 0v1.1A4 4 0 1 1 14 6ZM9.65 17.85c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7l-2.15 2.14V5.5a.5.5 0 0 0-1 0v10.8l-2.15-2.15a.5.5 0 1 0-.7.7l3 3Z"
]);
const $cdb0ff5c001a8842$export$95b7f4011e6200ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown24Filled', "24", [
    "M12 6a1 1 0 0 1 1 1v11.59l1.3-1.3a1 1 0 0 1 1.31-.08l.1.08a1 1 0 0 1 .08 1.32l-.08.1-3 3a1 1 0 0 1-1.32.08l-.1-.08-3-3a1 1 0 0 1 1.32-1.5l.1.08L11 18.6V7a1 1 0 0 1 1-1Zm0-4a5 5 0 0 1 2 9.58v-1.7a3.5 3.5 0 1 0-4 0v1.7A5 5 0 0 1 12 2Z"
]);
const $cdb0ff5c001a8842$export$f90f75f10c20900 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeDown24Regular', "24", [
    "M12 6c.38 0 .7.28.74.64l.01.1v12.7l2.22-2.22a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.69.07.98l-.07.08-3.5 3.5a.75.75 0 0 1-.98.07l-.08-.07-3.5-3.5a.75.75 0 0 1 .98-1.13l.08.07 2.22 2.22V6.74c0-.4.34-.74.75-.74Zm0-4a5 5 0 0 1 1.75 9.68v-1.66a3.5 3.5 0 1 0-3.5 0v1.66A5 5 0 0 1 12 2Z"
]);
const $cdb0ff5c001a8842$export$f77a061de0e71d5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight20Filled', "20", [
    "M6 6a4 4 0 0 1 3.6 2.25H8.44a3 3 0 1 0 0 3.5H9.6A4 4 0 1 1 6 6Zm9.28 7.03 2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06l1.22 1.22H5.75a.75.75 0 1 0 0 1.5h9.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06Z"
]);
const $cdb0ff5c001a8842$export$5706d26221fa01d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight20Regular', "20", [
    "M6 6a4 4 0 0 1 3.7 2.5H8.6a3 3 0 1 0 0 3h1.1A4 4 0 1 1 6 6Zm8.85 7.35 3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 1 0-.7.7l2.14 2.15H5.5a.5.5 0 0 0 0 1h10.8l-2.15 2.15a.5.5 0 0 0 .7.7Z"
]);
const $cdb0ff5c001a8842$export$55062d94f921f74e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight24Filled', "24", [
    "M6 12a1 1 0 0 0 1 1h11.59l-1.3 1.3a1 1 0 0 0-.08 1.31l.08.1a1 1 0 0 0 1.32.08l.1-.08 3-3a1 1 0 0 0 .08-1.32l-.08-.1-3-3a1 1 0 0 0-1.5 1.32l.08.1L18.6 11H7a1 1 0 0 0-1 1Zm-4 0a5 5 0 0 0 9.58 2h-1.7a3.5 3.5 0 1 1 0-4h1.7A5 5 0 0 0 2 12Z"
]);
const $cdb0ff5c001a8842$export$b7cf012205e79beb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeRight24Regular', "24", [
    "M6 12c0 .38.28.7.64.74l.1.01h12.7l-2.22 2.22a.75.75 0 0 0-.07.98l.07.08c.27.27.69.3.98.07l.08-.07 3.5-3.5a.75.75 0 0 0 .07-.98l-.07-.08-3.5-3.5a.75.75 0 0 0-1.13.98l.07.08 2.22 2.22H6.74A.75.75 0 0 0 6 12Zm-4 0a5 5 0 0 0 9.68 1.75h-1.66a3.5 3.5 0 1 1 0-3.5h1.66A5 5 0 0 0 2 12Z"
]);
const $cdb0ff5c001a8842$export$b70bdd910f067428 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp20Filled', "20", [
    "M10.53 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v9.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5ZM6 14a4 4 0 0 1 2.25-3.6v1.16a3 3 0 1 0 3.5 0V10.4A4 4 0 1 1 6 14Z"
]);
const $cdb0ff5c001a8842$export$9cee8614f96df716 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp20Regular', "20", [
    "M10.35 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L9.5 3.71V14.5a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3ZM6 14a4 4 0 0 1 2.5-3.7v1.1a3 3 0 1 0 3 0v-1.1A4 4 0 1 1 6 14Z"
]);
const $cdb0ff5c001a8842$export$cdf2fbf99f8b6ea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp24Filled', "24", [
    "M12 18a1 1 0 0 0 1-1V5.41l1.3 1.3a1 1 0 0 0 1.31.08l.1-.08a1 1 0 0 0 .08-1.32l-.08-.1-3-3a1 1 0 0 0-1.32-.08l-.1.08-3 3a1 1 0 0 0 1.32 1.5l.1-.08L11 5.4V17a1 1 0 0 0 1 1Zm0 4a5 5 0 0 0 2-9.58v1.7a3.5 3.5 0 1 1-4 0v-1.7A5 5 0 0 0 12 22Z"
]);
const $cdb0ff5c001a8842$export$3970155ad0f795b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('SwipeUp24Regular', "24", [
    "M12 18c.38 0 .7-.28.74-.64l.01-.1V4.55l2.22 2.22c.27.26.68.29.98.07l.08-.07a.75.75 0 0 0 .07-.98l-.07-.08-3.5-3.5a.75.75 0 0 0-.98-.07l-.08.07-3.5 3.5a.75.75 0 0 0 .98 1.13l.08-.07 2.22-2.22v12.7c0 .4.34.74.75.74Zm0 4a5 5 0 0 0 1.75-9.68v1.66a3.5 3.5 0 1 1-3.5 0v-1.66A5 5 0 0 0 12 22Z"
]);
const $cdb0ff5c001a8842$export$84fc1ff1c788ce3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble20Filled', "20", [
    "M4 8.5a5.5 5.5 0 1 1 10.97.6c.34.15.65.34.93.57A6.5 6.5 0 1 0 3.64 11.3c.25-.25.53-.45.82-.61A5.48 5.48 0 0 1 4 8.5Zm10 0-.01.33-1-.17.01-.16a3.5 3.5 0 1 0-6.57 1.69 4.4 4.4 0 0 0-1.05.13A4.48 4.48 0 0 1 9.5 4 4.5 4.5 0 0 1 14 8.5Zm-6-1a1.5 1.5 0 1 1 3 0v2.08l2.94.51a2.5 2.5 0 0 1 1.91 3.33l-.98 2.67a2.5 2.5 0 0 1-1.92 1.6l-1.52.26c-1.02.18-1.95-.45-2.43-1.23A5.87 5.87 0 0 0 4.44 14a.5.5 0 0 1-.43-.62c.15-.6.43-1.04.82-1.36.39-.32.85-.47 1.3-.52.63-.06 1.29.05 1.87.25V7.5Z"
]);
const $cdb0ff5c001a8842$export$718fcb556403ebcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble20Regular', "20", [
    "M9.5 3a5.5 5.5 0 0 0-5.04 7.7c-.3.16-.57.36-.82.61A6.5 6.5 0 1 1 15.9 9.67a3.7 3.7 0 0 0-.93-.57l.03-.6A5.5 5.5 0 0 0 9.5 3Zm4.49 5.83L14 8.5a4.5 4.5 0 1 0-8.62 1.82 4.2 4.2 0 0 1 1.05-.13A3.5 3.5 0 1 1 13 8.66l1 .17ZM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.46 4.46 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52s-.67.77-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5ZM9 7.5a.5.5 0 0 1 1 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 0 1 1.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.77 6.77 0 0 0-4.65-3.1c.08-.13.17-.23.26-.3.2-.17.47-.27.78-.3.64-.07 1.42.14 2.04.45A.5.5 0 0 0 9 12.5v-5Z"
]);
const $cdb0ff5c001a8842$export$1e9f155897907732 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble24Filled', "24", [
    "M11.75 7c1.36 0 1.95.9 2 2.33V12l2.87.41.34.07c1.4.4 2.25 1.8 1.96 3.22l-.05.17-1.22 4.44c-.17.62-.67 1.1-1.3 1.24l-.14.03-3.06.43c-.76.11-1.5-.29-1.83-.97l-.06-.14-.21-.57a4.13 4.13 0 0 0-1.18-1.67l-.2-.17-1.6-1.2a1.75 1.75 0 0 0-.27-.16l-.14-.07-2.2-.86a.75.75 0 0 1-.47-.66c-.03-.73.5-1.25 1.42-1.72.72-.36 1.73-.33 3.07.05l.27.08V9.5c0-1.54.58-2.51 2-2.51Zm0-5a7.25 7.25 0 0 1 6.67 10.1 3.74 3.74 0 0 0-1.2-.57l-.17-.04a5.75 5.75 0 1 0-9.92 1.19 3.22 3.22 0 0 0-1.51.44A7.25 7.25 0 0 1 11.75 2Zm0 2.5a4.75 4.75 0 0 1 4.27 6.82l-1.27-.18v-.65a3.24 3.24 0 0 0-.83-3.66l-.15-.12A2.85 2.85 0 0 0 11.75 6c-.89 0-1.56.26-2.04.72a3.24 3.24 0 0 0-.96 3.79v1.85a.3.3 0 0 1-.3.3 4.75 4.75 0 0 1 3.3-8.16Z"
]);
const $cdb0ff5c001a8842$export$d6ead6f6ed9251 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble24Regular', "24", [
    "M11.75 7c1.35 0 2.18.97 2.25 2.33v2.29l2.22.4a3.25 3.25 0 0 1 2.6 3.86l-.04.18L17.73 20a2.25 2.25 0 0 1-1.69 1.61l-.16.03-2.42.35a2.25 2.25 0 0 1-2.28-1.12l-.08-.16-.03-.06c-.24-.5-.59-.95-1.03-1.28l-.2-.14-1.87-1.26-.1-.06-.1-.05-2.36-1.17a.75.75 0 0 1-.41-.66 2.5 2.5 0 0 1 1.41-2.44c.7-.35 1.64-.33 2.83.02l.26.08V9.5c0-1.45.84-2.51 2.25-2.51Zm0 1.5c-.46 0-.71.27-.75.87v5.38c0 .54-.54.9-1.04.7-1.46-.6-2.44-.75-2.87-.53a.97.97 0 0 0-.51.52l-.04.12 1.9.95.18.1.18.1 1.88 1.26a4.97 4.97 0 0 1 1.63 1.8l.12.24.03.06c.12.27.39.43.68.43h.1l2.42-.35c.26-.04.48-.2.58-.45l.04-.1 1.05-3.92c.25-.94-.3-1.9-1.24-2.15l-.07-.01-2.9-.53a.75.75 0 0 1-.61-.63l-.01-.11V9.51c0-.7-.25-1.01-.75-1.01Zm0-6.5a7.25 7.25 0 0 1 6.7 10.03 4.2 4.2 0 0 0-1.3-.78 5.75 5.75 0 1 0-10.22 1.13 3.32 3.32 0 0 0-1.42.57A7.25 7.25 0 0 1 11.75 2Zm0 2.5a4.75 4.75 0 0 1 4.41 6.5L15 10.8V9.25c0-.68-.21-1.31-.57-1.83l-.09-.14A3.07 3.07 0 0 0 11.75 6c-1.18 0-2.08.53-2.64 1.35a3.24 3.24 0 0 0-.61 1.9V12.4l-.26-.04a1 1 0 0 1-.62-.32C7.21 11.58 7 10.65 7 9.25a4.75 4.75 0 0 1 4.75-4.75Z"
]);
const $cdb0ff5c001a8842$export$4e7e3718f1408e8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble32Filled', "32", [
    "M8 12a8 8 0 1 1 15.58 2.56c.67.2 1.27.52 1.8.92A10 10 0 1 0 7.3 16.93c.5-.46 1.07-.81 1.7-1.06A7.96 7.96 0 0 1 8 12Zm14.5 0c0 .79-.14 1.55-.4 2.25l-1.6-.31V12a4.5 4.5 0 1 0-9 .18v3.33a5.45 5.45 0 0 0-.97 0A6.5 6.5 0 1 1 22.5 12ZM16 9a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 15.18V12a3 3 0 0 0-3-3Z"
]);
const $cdb0ff5c001a8842$export$2c4428c7f834b068 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble32Regular', "32", [
    "M8 12a8 8 0 1 1 15.58 2.56c.67.2 1.27.52 1.8.92A10 10 0 1 0 7.3 16.93c.5-.46 1.07-.81 1.7-1.06A7.96 7.96 0 0 1 8 12Zm14.5 0c0 .79-.14 1.55-.4 2.25l-1.6-.31V12a4.5 4.5 0 1 0-9 .18v3.33a5.45 5.45 0 0 0-.97 0A6.5 6.5 0 1 1 22.5 12ZM15 12a1 1 0 1 1 2 0v4c0 .48.34.9.81.98l4.57.89a2 2 0 0 1 1.55 2.49l-1.52 5.53a1 1 0 0 1-.88.73l-4.76.38h-.02a.17.17 0 0 1-.05-.08c-.78-2.15-2.68-4.74-7.6-6.56a2 2 0 0 1 2.68-1.21l1.83.77a1 1 0 0 0 1.4-.92v-7Zm1-3a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 15.18V12a3 3 0 0 0-3-3Z"
]);
const $cdb0ff5c001a8842$export$d6e575f35562cd82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble48Filled', "48", [
    "M12.5 17.5a11 11 0 1 1 21.18 4.16l.2.05c.77.16 1.5.44 2.16.8a13.5 13.5 0 1 0-23.96 2.17 7.34 7.34 0 0 1 2.53-.7 10.95 10.95 0 0 1-2.11-6.48Zm20 0c0 1.33-.29 2.6-.81 3.74L30 20.87V17.5a6.5 6.5 0 1 0-13 .09v6.14a9 9 0 1 1 15.5-6.23Zm-9-4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3.02 3.02 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 22.5V17.5a4.5 4.5 0 0 0-4.5-4.5Z"
]);
const $cdb0ff5c001a8842$export$afb59ed8b2195b49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapDouble48Regular', "48", [
    "M12.5 17.5a11 11 0 1 1 21.18 4.16l.2.05c.77.16 1.5.44 2.16.8a13.5 13.5 0 1 0-23.96 2.17 7.34 7.34 0 0 1 2.53-.7 10.95 10.95 0 0 1-2.11-6.48Zm20 0c0 1.33-.29 2.6-.81 3.74L30 20.87V17.5a6.5 6.5 0 1 0-13 .09v6.14a9 9 0 1 1 15.5-6.23Zm-11 0a2 2 0 1 1 4 0v6c0 .59.41 1.1.99 1.22l6.44 1.39a3.25 3.25 0 0 1 2.45 4.03l-2.3 8.35c-.18.69-.77 1.2-1.48 1.27l-6.24.74c-.05 0-.12 0-.21-.07a.75.75 0 0 1-.27-.3c-1.43-3.08-5.1-6.42-12.29-9.73a2.84 2.84 0 0 1 3.68-1.77l3.55 1.3a1.25 1.25 0 0 0 1.68-1.17V17.5Zm2-4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3.02 3.02 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 22.5V17.5a4.5 4.5 0 0 0-4.5-4.5Z"
]);
const $cdb0ff5c001a8842$export$532e143e4fa3861b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle20Filled', "20", [
    "M6 8.5a3.5 3.5 0 1 1 7 .16l.99.17.01-.33a4.5 4.5 0 1 0-8.62 1.82 4.2 4.2 0 0 1 1.05-.13A3.48 3.48 0 0 1 6 8.5ZM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.46 4.46 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52s-.67.77-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5Z"
]);
const $cdb0ff5c001a8842$export$e23d413802afd8e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle20Regular', "20", [
    "M6 8.5a3.5 3.5 0 1 1 7 .16l.99.17.01-.33a4.5 4.5 0 1 0-8.62 1.82 4.2 4.2 0 0 1 1.05-.13A3.48 3.48 0 0 1 6 8.5ZM9.5 6C8.67 6 8 6.67 8 7.5v4.25a4.46 4.46 0 0 0-1.87-.25c-.45.05-.91.2-1.3.52s-.67.77-.82 1.36a.5.5 0 0 0 .43.62c2.6.28 3.92 1.7 4.56 2.72.48.78 1.4 1.41 2.43 1.23l1.52-.26a2.5 2.5 0 0 0 1.92-1.6l.98-2.67a2.5 2.5 0 0 0-1.91-3.33L11 9.58V7.5c0-.83-.67-1.5-1.5-1.5ZM9 7.5a.5.5 0 0 1 1 0V10c0 .24.17.45.41.5l3.35.58a1.5 1.5 0 0 1 1.15 2l-.98 2.67c-.19.5-.62.86-1.15.95l-1.52.27c-.5.09-1.07-.23-1.41-.77a6.77 6.77 0 0 0-4.65-3.1c.08-.13.17-.23.26-.3.2-.17.47-.27.78-.3.64-.07 1.42.14 2.04.45A.5.5 0 0 0 9 12.5v-5Z"
]);
const $cdb0ff5c001a8842$export$80e46f90adb35a9c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle24Filled', "24", [
    "M11.75 6c1.36 0 1.95.9 2 2.33V11l2.87.41a2.75 2.75 0 0 1 2.3 3.29l-.05.17-1.22 4.44c-.18.62-.67 1.1-1.3 1.24l-.14.03-3.06.43c-.76.11-1.5-.29-1.83-.97l-.06-.14-.21-.57a4.13 4.13 0 0 0-1.18-1.67l-.2-.17-1.6-1.2a1.75 1.75 0 0 0-.27-.16l-.14-.07-2.2-.86a.75.75 0 0 1-.47-.66c-.03-.73.5-1.25 1.42-1.72.72-.36 1.73-.33 3.07.05l.27.08V8.5c0-1.54.58-2.51 2-2.51Zm0-3.5a5.75 5.75 0 0 1 5.3 7.99l.17.04-.45-.1-1.27-.18a4.25 4.25 0 1 0-6.75 1.02v.41a5.6 5.6 0 0 0-1.67-.07 5.75 5.75 0 0 1 4.67-9.1Z"
]);
const $cdb0ff5c001a8842$export$29decb8c62f16fe5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle24Regular', "24", [
    "M11.75 6c1.35 0 2.18.97 2.25 2.33v2.29l2.22.4a3.25 3.25 0 0 1 2.6 3.86l-.04.18L17.73 19a2.25 2.25 0 0 1-1.69 1.61l-.16.03-2.42.35a2.25 2.25 0 0 1-2.28-1.12l-.08-.16-.03-.06c-.24-.5-.59-.95-1.03-1.28l-.19-.14-1.88-1.26-.1-.06-.1-.05-2.36-1.17a.75.75 0 0 1-.41-.66 2.5 2.5 0 0 1 1.41-2.44c.7-.35 1.64-.33 2.83.02l.26.08V8.5c0-1.46.84-2.51 2.25-2.51Zm0 1.5c-.46 0-.71.27-.75.87v5.38c0 .54-.54.9-1.04.7-1.46-.6-2.44-.75-2.87-.53a.97.97 0 0 0-.51.52l-.04.12 1.9.95.18.1.18.1 1.88 1.26a4.97 4.97 0 0 1 1.63 1.8l.12.24.03.06c.12.27.39.43.68.43h.1l2.42-.35c.26-.04.48-.2.58-.45l.04-.1 1.05-3.92c.25-.94-.3-1.9-1.24-2.15l-.07-.01-2.9-.53a.75.75 0 0 1-.61-.63l-.01-.11V8.51c0-.7-.25-1.01-.75-1.01Zm0-5a5.75 5.75 0 0 1 5.4 7.75L17 10.2a5.6 5.6 0 0 0-1.34-.3A4.24 4.24 0 0 0 11.75 4a4.25 4.25 0 0 0-3.25 7c-.32.02-.6.06-.82.11-.36.09-.6.17-.76.27a5.75 5.75 0 0 1 4.83-8.88Z"
]);
const $cdb0ff5c001a8842$export$63a1cea37f2d18f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle32Filled', "32", [
    "M16 5a6 6 0 0 0-4.88 9.5 5.5 5.5 0 0 0-2.12.37 8 8 0 1 1 14.58-1.31c-.17-.05-.35-.1-.53-.13l-1.45-.28A5.99 5.99 0 0 0 16 5Zm0 3a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 14.18V11a3 3 0 0 0-3-3Z"
]);
const $cdb0ff5c001a8842$export$60b1d98e90c24513 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle32Regular', "32", [
    "M16 5a6 6 0 0 0-4.88 9.5 5.5 5.5 0 0 0-2.12.37 8 8 0 1 1 14.58-1.31c-.17-.05-.35-.1-.53-.13l-1.45-.28A5.99 5.99 0 0 0 16 5Zm-1 6a1 1 0 1 1 2 0v4c0 .48.34.9.81.98l4.57.89a2 2 0 0 1 1.55 2.49l-1.52 5.53a1 1 0 0 1-.88.73l-4.76.38h-.02a.17.17 0 0 1-.05-.08c-.78-2.15-2.68-4.74-7.6-6.56a2 2 0 0 1 2.68-1.21l1.83.77a1 1 0 0 0 1.4-.92v-7Zm1-3a3 3 0 0 0-3 3v5.5l-.45-.2a4 4 0 0 0-5.4 2.65l-.1.33a1.5 1.5 0 0 0 .97 1.82c4.74 1.65 6.22 3.92 6.8 5.5.3.82 1.11 1.48 2.11 1.4l4.76-.39a3 3 0 0 0 2.65-2.2l1.52-5.52a4 4 0 0 0-3.1-4.99L19 14.18V11a3 3 0 0 0-3-3Z"
]);
const $cdb0ff5c001a8842$export$cb3584882b3eeb70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle48Filled', "48", [
    "M23.5 7.5A9 9 0 0 0 17 22.73v.42c-1-.24-2-.26-2.95-.1a11.5 11.5 0 1 1 20.13-2.28l-.3-.06-2.19-.47A9 9 0 0 0 23.5 7.5Zm0 4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3.02 3.02 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 21.5V16.5a4.5 4.5 0 0 0-4.5-4.5Z"
]);
const $cdb0ff5c001a8842$export$599c8815187e0e7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TapSingle48Regular', "48", [
    "M23.5 7.5A9 9 0 0 0 17 22.73v.42c-1-.24-2-.26-2.95-.1a11.5 11.5 0 1 1 20.13-2.28l-.3-.06-2.19-.47A9 9 0 0 0 23.5 7.5Zm-2 9a2 2 0 1 1 4 0v6c0 .59.41 1.1.99 1.22l6.44 1.39a3.25 3.25 0 0 1 2.45 4.03l-2.3 8.35c-.18.69-.77 1.2-1.48 1.27l-6.24.74c-.05 0-.12 0-.21-.07a.75.75 0 0 1-.27-.3c-1.43-3.08-5.1-6.42-12.29-9.73a2.84 2.84 0 0 1 3.68-1.77l3.55 1.3a1.25 1.25 0 0 0 1.68-1.17V16.5Zm2-4.5a4.5 4.5 0 0 0-4.5 4.5v9.47l-1.87-.69a5.34 5.34 0 0 0-7.1 4.13c-.15.88.32 1.73 1.11 2.08 7.3 3.29 10.4 6.38 11.48 8.7a3.02 3.02 0 0 0 3.03 1.79l6.24-.73a4.25 4.25 0 0 0 3.6-3.1l2.3-8.34a5.75 5.75 0 0 0-4.33-7.15L28 21.5V16.5a4.5 4.5 0 0 0-4.5-4.5Z"
]);
const $cdb0ff5c001a8842$export$e203fe60c281c028 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy20Filled', "20", [
    "M5.5 3a3.5 3.5 0 0 0-2.85 5.53 7.92 7.92 0 0 1 5.5-4.32A3.5 3.5 0 0 0 5.5 3ZM18 6.5c0 .76-.24 1.46-.65 2.03a7.92 7.92 0 0 0-5.5-4.32A3.5 3.5 0 0 1 18 6.5Zm-15 5C3 7.87 6.17 5 10 5s7 2.87 7 6.5a6.2 6.2 0 0 1-1.76 4.31 5.5 5.5 0 0 0-10.48 0A6.2 6.2 0 0 1 3 11.5Zm8.33 1.7a4.5 4.5 0 0 1 3.07 3.35A7.33 7.33 0 0 1 10 18c-1.66 0-3.2-.54-4.4-1.45a4.5 4.5 0 0 1 3.07-3.35 1.5 1.5 0 0 0 2.66 0Z"
]);
const $cdb0ff5c001a8842$export$5c73ce1aef509566 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy20Regular', "20", [
    "M2 6.5a3.5 3.5 0 0 0 1.4 2.8c-.26.69-.4 1.43-.4 2.2 0 3.63 3.17 6.5 7 6.5s7-2.87 7-6.5c0-.77-.14-1.51-.4-2.2a3.5 3.5 0 1 0-5.31-4.19 7.54 7.54 0 0 0-2.58 0A3.5 3.5 0 0 0 2 6.5ZM5.5 4c.97 0 1.8.55 2.22 1.35a6.92 6.92 0 0 0-3.87 3.03A2.5 2.5 0 0 1 5.5 4Zm6.78 1.35a2.5 2.5 0 1 1 3.87 3.03 6.92 6.92 0 0 0-3.87-3.03ZM10 6c3.35 0 6 2.5 6 5.5a5.2 5.2 0 0 1-1.2 3.3 5.5 5.5 0 0 0-9.6 0A5.2 5.2 0 0 1 4 11.5C4 8.5 6.65 6 10 6Zm4.06 9.55A6.27 6.27 0 0 1 10 17c-1.57 0-3-.55-4.06-1.45a4.51 4.51 0 0 1 2.73-2.35 1.5 1.5 0 0 0 2.66 0c1.2.37 2.19 1.23 2.73 2.35Z"
]);
const $cdb0ff5c001a8842$export$e6cd9408726f0906 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy24Filled', "24", [
    "M3.2 10.27a4 4 0 0 1 6.25-4.96 9.24 9.24 0 0 0-6.24 4.96Zm11.34-4.96A3.99 3.99 0 0 1 21.5 8c0 .84-.26 1.63-.7 2.27a9.24 9.24 0 0 0-6.26-4.96Zm-7.91 14A7.19 7.19 0 0 1 3.5 13.5C3.5 9.36 7.3 6 12 6s8.5 3.36 8.5 7.5a7.19 7.19 0 0 1-3.13 5.81 5.5 5.5 0 0 0-10.74 0ZM15 17.14c-.45-.4-.98-.7-1.54-.9-.17.44-.76.76-1.46.76s-1.3-.32-1.46-.76a4.5 4.5 0 0 0-3 3.65c1.3.7 2.82 1.11 4.46 1.11 1.64 0 3.16-.4 4.46-1.11A4.48 4.48 0 0 0 15 17.14Z"
]);
const $cdb0ff5c001a8842$export$bb3e29063c42e865 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Teddy24Regular', "24", [
    "M17.5 3.88a4.12 4.12 0 0 1 2.7 7.24c.27.75.43 1.55.43 2.38a7.31 7.31 0 0 1-3.19 5.91c-.28.2-.57.4-.88.57l-.04.02A9.44 9.44 0 0 1 12 21.13a9.44 9.44 0 0 1-5.4-1.68l-.04-.04a7.31 7.31 0 0 1-3.18-5.91c0-.83.15-1.63.42-2.38a4.12 4.12 0 1 1 6.34-5.07 9.75 9.75 0 0 1 3.72 0 4.12 4.12 0 0 1 3.64-2.17ZM13.52 16.4c-.1.2-.3.37-.53.5-.28.14-.62.23-.99.23s-.71-.09-.99-.24c-.23-.12-.42-.29-.53-.5a4.39 4.39 0 0 0-2.53 2.44A8.17 8.17 0 0 0 12 19.88c1.5 0 2.89-.4 4.05-1.05a4.38 4.38 0 0 0-2.53-2.43ZM12 7.13c-4.12 0-7.38 2.9-7.38 6.37a6 6 0 0 0 2.29 4.6 5.63 5.63 0 0 1 10.18 0 6 6 0 0 0 2.29-4.6c0-3.48-3.26-6.38-7.38-6.38Zm-5.5-2a2.87 2.87 0 0 0-2.13 4.8A8.4 8.4 0 0 1 8.88 6.4 2.88 2.88 0 0 0 6.5 5.13Zm11 0c-.97 0-1.86.48-2.38 1.26a8.4 8.4 0 0 1 4.5 3.55 2.87 2.87 0 0 0-2.12-4.81Z"
]);
const $cdb0ff5c001a8842$export$280e96ce2640338e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy16Color', "16", `<path d="M7.5 13v-3h1v3h-1Z" fill="#C55D5D"/><path d="M7.5 13v-3h1v3h-1Z" fill="url(#ic_fluent_trophy_16_color__a)"/><path d="M4 14c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14Z" fill="#D9D9D9"/><path d="M4 14c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14Z" fill="url(#ic_fluent_trophy_16_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5C2 3.67 2.67 3 3.5 3h2C6.33 3 7 3.67 7 4.5v1a2.5 2.5 0 0 1-5 0v-1ZM3.5 4a.5.5 0 0 0-.5.5v1a1.5 1.5 0 1 0 3 0v-1a.5.5 0 0 0-.5-.5h-2Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5C2 3.67 2.67 3 3.5 3h2C6.33 3 7 3.67 7 4.5v1a2.5 2.5 0 0 1-5 0v-1ZM3.5 4a.5.5 0 0 0-.5.5v1a1.5 1.5 0 1 0 3 0v-1a.5.5 0 0 0-.5-.5h-2Z" fill="url(#ic_fluent_trophy_16_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 4.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-5 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a1.5 1.5 0 0 0 3 0v-1a.5.5 0 0 0-.5-.5h-2Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 4.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-5 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a1.5 1.5 0 0 0 3 0v-1a.5.5 0 0 0-.5-.5h-2Z" fill="url(#ic_fluent_trophy_16_color__d)"/><path d="M6 1a2 2 0 0 0-2 2v4a4 4 0 1 0 8 0V3a2 2 0 0 0-2-2H6Z" fill="#000"/><path d="M6 1a2 2 0 0 0-2 2v4a4 4 0 1 0 8 0V3a2 2 0 0 0-2-2H6Z" fill="url(#ic_fluent_trophy_16_color__e)"/><defs><linearGradient id="ic_fluent_trophy_16_color__a" x1="7" y1="9.4" x2="12" y2="15.13" gradientUnits="userSpaceOnUse"><stop offset=".17" stop-color="#EB4824"/><stop offset=".56" stop-color="#FF921F" stop-opacity=".99"/><stop offset=".85" stop-color="#EB4824"/></linearGradient><linearGradient id="ic_fluent_trophy_16_color__b" x1="26.67" y1="24.01" x2="22.12" y2="7.31" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#FFCD0F"/><stop offset="1" stop-color="#FF6F47"/></linearGradient><linearGradient id="ic_fluent_trophy_16_color__c" x1="5.75" y1="5.08" x2=".75" y2="5.08" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><linearGradient id="ic_fluent_trophy_16_color__d" x1="10.67" y1="5.08" x2="15.25" y2="5.08" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><radialGradient id="ic_fluent_trophy_16_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-130.99 8.4 2.55) scale(11.5196 12.3112)"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></radialGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$92b456b76624267a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy16Filled', "16", [
    "M4 3h-.5C2.67 3 2 3.67 2 4.5v1a2.5 2.5 0 0 0 2.12 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V14a2 2 0 0 0-2-2H8.5v-1.03a4 4 0 0 0 3.38-3A2.5 2.5 0 0 0 14 5.5v-1c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Zm8 1h.5c.28 0 .5.22.5.5v1c0 .65-.42 1.2-1 1.41V4ZM4 4v2.91c-.58-.2-1-.76-1-1.41v-1c0-.28.22-.5.5-.5H4Z"
]);
const $cdb0ff5c001a8842$export$a27290dbb39ae614 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy16Regular', "16", [
    "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-2.12 2.47 4 4 0 0 1-3.38 3V12H10a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1C2 3.67 2.67 3 3.5 3H4Zm7 0a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a3 3 0 0 0 6 .07V3Zm1 3.91c.58-.2 1-.76 1-1.41v-1a.5.5 0 0 0-.5-.5H12v2.91ZM4 4h-.5a.5.5 0 0 0-.5.5v1c0 .65.42 1.2 1 1.41V4Zm1 10h6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Z"
]);
const $cdb0ff5c001a8842$export$2388099ba0d34c86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy20Color', "20", `<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 15.5V13h1v2.5h-1Z" fill="url(#ic_fluent_trophy_20_color__a)"/><path d="M7.5 15a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5V17a2 2 0 0 0-2-2h-5Z" fill="url(#ic_fluent_trophy_20_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.5C3 4.67 3.67 4 4.5 4h3C8.33 4 9 4.67 9 5.5V7a3 3 0 0 1-6 0V5.5ZM4.5 5a.5.5 0 0 0-.5.5V7a2 2 0 1 0 4 0V5.5a.5.5 0 0 0-.5-.5h-3Z" fill="url(#ic_fluent_trophy_20_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11 5.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5V7a3 3 0 1 1-6 0V5.5Zm1.5-.5a.5.5 0 0 0-.5.5V7a2 2 0 1 0 4 0V5.5a.5.5 0 0 0-.5-.5h-3Z" fill="url(#ic_fluent_trophy_20_color__d)"/><path d="M7.5 2a2 2 0 0 0-2 2v5a4.5 4.5 0 1 0 9 0V4a2 2 0 0 0-2-2h-5Z" fill="url(#ic_fluent_trophy_20_color__e)"/><defs><linearGradient id="ic_fluent_trophy_20_color__a" x1="9" y1="12.5" x2="13" y2="18" gradientUnits="userSpaceOnUse"><stop offset=".17" stop-color="#EB4824"/><stop offset=".56" stop-color="#FF921F" stop-opacity=".99"/><stop offset=".85" stop-color="#EB4824"/></linearGradient><linearGradient id="ic_fluent_trophy_20_color__b" x1="31" y1="27" x2="26.91" y2="10.07" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#FFCD0F"/><stop offset="1" stop-color="#FF6F47"/></linearGradient><linearGradient id="ic_fluent_trophy_20_color__c" x1="7.5" y1="6.5" x2="1.5" y2="6.5" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><linearGradient id="ic_fluent_trophy_20_color__d" x1="13" y1="6.5" x2="18.5" y2="6.5" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><radialGradient id="ic_fluent_trophy_20_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-130.37 10.26 3.15) scale(13.1244 13.98)"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></radialGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$cd2956bea43da404 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy20Filled', "20", [
    "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97 4.5 4.5 0 0 1-3.9 3.5v1.5h2a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4h1Zm9 4.94A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1v3.94ZM5.5 5h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93V5Z"
]);
const $cdb0ff5c001a8842$export$f877ac4d7737e242 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy20Regular', "20", [
    "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5a4.5 4.5 0 0 0 3.9-3.5A3 3 0 0 0 17 7V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5V7Zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5Zm10 0h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94V5Zm-1-1v5a3.5 3.5 0 0 1-7 .16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Zm-7 12.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1h-7Z"
]);
const $cdb0ff5c001a8842$export$9b787f7087dbb452 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy24Color', "24", `<path d="M11 18.5v-3.68h1.5v3.68H11Z" fill="#C55D5D"/><path d="M11 18.5v-3.68h1.5v3.68H11Z" fill="url(#ic_fluent_trophy_24_color__a)"/><path d="M14.25 17.5a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.65.74l-.1.01h-10a.75.75 0 0 1-.74-.65l-.01-.1v-.5a3.25 3.25 0 0 1 3.07-3.24l.18-.01h5Z" fill="#D9D9D9"/><path d="M14.25 17.5a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.65.74l-.1.01h-10a.75.75 0 0 1-.74-.65l-.01-.1v-.5a3.25 3.25 0 0 1 3.07-3.24l.18-.01h5Z" fill="url(#ic_fluent_trophy_24_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.75C3 4.78 3.78 4 4.75 4h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0v-3Zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25h-3Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5.75C3 4.78 3.78 4 4.75 4h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0v-3Zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25h-3Z" fill="url(#ic_fluent_trophy_24_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14 5.75c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0v-3Zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25h-3Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14 5.75c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v3a3.25 3.25 0 0 1-6.5 0v-3Zm1.75-.25a.25.25 0 0 0-.25.25v3a1.75 1.75 0 1 0 3.5 0v-3a.25.25 0 0 0-.25-.25h-3Z" fill="url(#ic_fluent_trophy_24_color__d)"/><path d="M8.25 2C7.01 2 6 3 6 4.25v6a5.75 5.75 0 0 0 11.5 0v-6c0-1.24-1-2.25-2.25-2.25h-7Z" fill="#000"/><path d="M8.25 2C7.01 2 6 3 6 4.25v6a5.75 5.75 0 0 0 11.5 0v-6c0-1.24-1-2.25-2.25-2.25h-7Z" fill="url(#ic_fluent_trophy_24_color__e)"/><defs><linearGradient id="ic_fluent_trophy_24_color__a" x1="10.25" y1="14.08" x2="16.11" y2="22.28" gradientUnits="userSpaceOnUse"><stop offset=".17" stop-color="#EB4824"/><stop offset=".56" stop-color="#FF921F" stop-opacity=".99"/><stop offset=".85" stop-color="#EB4824"/></linearGradient><linearGradient id="ic_fluent_trophy_24_color__b" x1="38.59" y1="35.5" x2="31.53" y2="10.62" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#FFCD0F"/><stop offset="1" stop-color="#FF6F47"/></linearGradient><linearGradient id="ic_fluent_trophy_24_color__c" x1="7.88" y1="7.33" x2="1.38" y2="7.33" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><linearGradient id="ic_fluent_trophy_24_color__d" x1="16.17" y1="7.33" x2="22.13" y2="7.33" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><radialGradient id="ic_fluent_trophy_24_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-131.74 12.2 3.78) scale(16.3147 17.4942)"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></radialGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$66a95805fbbeb725 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy24Filled', "24", [
    "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01a5.76 5.76 0 0 1-4.74 3.95v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2h7Zm3.5 3.5H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.25.25 0 0 0-.18-.24l-.06-.01ZM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73V5.5Z"
]);
const $cdb0ff5c001a8842$export$9d8470916016ecc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy24Regular', "24", [
    "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01a5.76 5.76 0 0 1-4.74 3.95v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2h7Zm-1 17h-5c-.83 0-1.52.58-1.7 1.35l-.03.15h8.47A1.75 1.75 0 0 0 14.4 19h-.16Zm1-15.5h-7a.75.75 0 0 0-.75.75v6a4.25 4.25 0 0 0 8.5 0v-6a.75.75 0 0 0-.75-.75Zm3.5 2H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.25.25 0 0 0-.18-.24l-.06-.01ZM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73V5.5Z"
]);
const $cdb0ff5c001a8842$export$3f09d1c001f59b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy28Color', "28", `<path d="M13 21.5v-3.68h1.5v3.68H13Z" fill="#C55D5D"/><path d="M13 21.5v-3.68h1.5v3.68H13Z" fill="url(#ic_fluent_trophy_28_color__a)"/><path d="M17.25 21c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21h7Z" fill="#D9D9D9"/><path d="M17.25 21c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21h7Z" fill="url(#ic_fluent_trophy_28_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.76C3 5.8 3.79 5 4.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0V6.76Zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26H4.76Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.76C3 5.8 3.79 5 4.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0V6.76Zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26H4.76Z" fill="url(#ic_fluent_trophy_28_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16 6.76C16 5.8 16.79 5 17.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0V6.76Zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26h-4.98Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16 6.76C16 5.8 16.79 5 17.76 5h4.98c.97 0 1.76.79 1.76 1.76v2.99a4.25 4.25 0 0 1-8.5 0V6.76Zm1.76-.26a.26.26 0 0 0-.26.26v2.99a2.75 2.75 0 1 0 5.5 0V6.76a.26.26 0 0 0-.26-.26h-4.98Z" fill="url(#ic_fluent_trophy_28_color__d)"/><path d="M9.75 2A2.75 2.75 0 0 0 7 4.75v7.5a6.75 6.75 0 0 0 13.5 0v-7.5A2.75 2.75 0 0 0 17.75 2h-8Z" fill="#000"/><path d="M9.75 2A2.75 2.75 0 0 0 7 4.75v7.5a6.75 6.75 0 0 0 13.5 0v-7.5A2.75 2.75 0 0 0 17.75 2h-8Z" fill="url(#ic_fluent_trophy_28_color__e)"/><defs><linearGradient id="ic_fluent_trophy_28_color__a" x1="12.25" y1="17.08" x2="18.11" y2="25.28" gradientUnits="userSpaceOnUse"><stop offset=".17" stop-color="#EB4824"/><stop offset=".56" stop-color="#FF921F" stop-opacity=".99"/><stop offset=".85" stop-color="#EB4824"/></linearGradient><linearGradient id="ic_fluent_trophy_28_color__b" x1="45.25" y1="41" x2="37.77" y2="13.14" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#FFCD0F"/><stop offset="1" stop-color="#FF6F47"/></linearGradient><linearGradient id="ic_fluent_trophy_28_color__c" x1="9.38" y1="8.75" x2=".88" y2="8.75" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><linearGradient id="ic_fluent_trophy_28_color__d" x1="18.83" y1="8.75" x2="26.63" y2="8.75" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><radialGradient id="ic_fluent_trophy_28_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-12.75008 -14.78258 15.78169 -13.61181 20.5 18.26)"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></radialGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$ab44a06b5ab5840c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy28Filled', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 2.34-1.9 4.24-4.23 4.25a6.76 6.76 0 0 1-5.77 4.96V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5Zm13.5 5.99c1.4-.13 2.5-1.3 2.5-2.74v-3a.25.25 0 0 0-.25-.25H20.5v5.99Z"
]);
const $cdb0ff5c001a8842$export$ab1227726d2904e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy28Regular', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 2.34-1.9 4.24-4.23 4.25a6.76 6.76 0 0 1-5.77 4.96V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5Zm13.5 5.99c1.4-.13 2.5-1.3 2.5-2.74v-3a.25.25 0 0 0-.25-.25H20.5v5.99ZM9.75 3.5c-.69 0-1.25.56-1.25 1.25v7.5a5.25 5.25 0 1 0 10.5 0v-7.5c0-.69-.56-1.25-1.25-1.25h-8ZM8.5 24.25v.25H19v-.25c0-.97-.78-1.75-1.75-1.75h-7c-.97 0-1.75.78-1.75 1.75Z"
]);
const $cdb0ff5c001a8842$export$96c00523537c896 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy32Color', "32", `<path d="M15 24.68V21h2v3.68h-2Z" fill="#C55D5D"/><path d="M15 24.68V21h2v3.68h-2Z" fill="url(#ic_fluent_trophy_32_color__a)"/><path d="M11.5 24A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5h-9Z" fill="#D9D9D9"/><path d="M11.5 24A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5h-9Z" fill="url(#ic_fluent_trophy_32_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4 7.42A2.42 2.42 0 0 1 6.42 5h4.16A2.42 2.42 0 0 1 13 7.42v4.08a4.5 4.5 0 1 1-9 0V7.42ZM6.42 7a.42.42 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.42.42 0 0 0-.42-.42H6.42Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4 7.42A2.42 2.42 0 0 1 6.42 5h4.16A2.42 2.42 0 0 1 13 7.42v4.08a4.5 4.5 0 1 1-9 0V7.42ZM6.42 7a.42.42 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.42.42 0 0 0-.42-.42H6.42Z" fill="url(#ic_fluent_trophy_32_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 7.42A2.42 2.42 0 0 1 21.42 5h4.16A2.42 2.42 0 0 1 28 7.42v4.08a4.5 4.5 0 1 1-9 0V7.42ZM21.42 7a.42.42 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.42.42 0 0 0-.42-.42h-4.16Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19 7.42A2.42 2.42 0 0 1 21.42 5h4.16A2.42 2.42 0 0 1 28 7.42v4.08a4.5 4.5 0 1 1-9 0V7.42ZM21.42 7a.42.42 0 0 0-.42.42v4.08a2.5 2.5 0 0 0 5 0V7.42a.42.42 0 0 0-.42-.42h-4.16Z" fill="url(#ic_fluent_trophy_32_color__d)"/><path d="M11 2a3 3 0 0 0-3 3v9a8 8 0 1 0 16 0V5a3 3 0 0 0-3-3H11Z" fill="#000"/><path d="M11 2a3 3 0 0 0-3 3v9a8 8 0 1 0 16 0V5a3 3 0 0 0-3-3H11Z" fill="url(#ic_fluent_trophy_32_color__e)"/><defs><linearGradient id="ic_fluent_trophy_32_color__a" x1="14" y1="20.26" x2="19.15" y2="29.89" gradientUnits="userSpaceOnUse"><stop offset=".17" stop-color="#EB4824"/><stop offset=".56" stop-color="#FF921F" stop-opacity=".99"/><stop offset=".85" stop-color="#EB4824"/></linearGradient><linearGradient id="ic_fluent_trophy_32_color__b" x1="53.33" y1="48" x2="44.26" y2="14.62" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#FFCD0F"/><stop offset="1" stop-color="#FF6F47"/></linearGradient><linearGradient id="ic_fluent_trophy_32_color__c" x1="10.75" y1="9.58" x2="1.75" y2="9.58" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><linearGradient id="ic_fluent_trophy_32_color__d" x1="22" y1="9.58" x2="30.25" y2="9.58" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><radialGradient id="ic_fluent_trophy_32_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-130.99 16.82 5.1) scale(23.0392 24.6224)"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></radialGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$ee4a42d747e74504 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy32Filled', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.06a8 8 0 0 0 6.75-5.95A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 11.95V7h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45ZM8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8Z"
]);
const $cdb0ff5c001a8842$export$7a9ae08a32b45020 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy32Regular', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-1a3.5 3.5 0 0 0-3.5-3.5H17v-2.06a8 8 0 0 0 6.75-5.95A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 5h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45V7ZM8 13.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8v6.95ZM10 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a6 6 0 0 1-12 0V5Zm0 22.5c0-.83.67-1.5 1.5-1.5h9c.83 0 1.5.67 1.5 1.5v.5H10v-.5Z"
]);
const $cdb0ff5c001a8842$export$c1490e417be0f0de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy48Color', "48", `<path d="M22.75 37.5V32h2.5v5.5h-2.5Z" fill="#C55D5D"/><path d="M22.75 37.5V32h2.5v5.5h-2.5Z" fill="url(#ic_fluent_trophy_48_color__a)"/><path d="M31 36.5a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h14Z" fill="#D9D9D9"/><path d="M31 36.5a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h14Z" fill="url(#ic_fluent_trophy_48_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28 10.75A2.75 2.75 0 0 1 30.75 8h8.5A2.75 2.75 0 0 1 42 10.75V17a7 7 0 1 1-14 0v-6.25Zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25h-8.5Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28 10.75A2.75 2.75 0 0 1 30.75 8h8.5A2.75 2.75 0 0 1 42 10.75V17a7 7 0 1 1-14 0v-6.25Zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25h-8.5Z" fill="url(#ic_fluent_trophy_48_color__c)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6 10.75A2.75 2.75 0 0 1 8.75 8h8.5A2.75 2.75 0 0 1 20 10.75V17a7 7 0 1 1-14 0v-6.25Zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25h-8.5Z" fill="#D96A6A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6 10.75A2.75 2.75 0 0 1 8.75 8h8.5A2.75 2.75 0 0 1 20 10.75V17a7 7 0 1 1-14 0v-6.25Zm2.75-.25a.25.25 0 0 0-.25.25V17a4.5 4.5 0 1 0 9 0v-6.25a.25.25 0 0 0-.25-.25h-8.5Z" fill="url(#ic_fluent_trophy_48_color__d)"/><path d="M16 4a4 4 0 0 0-4 4v13a12 12 0 0 0 24 0V8a4 4 0 0 0-4-4H16Z" fill="#000"/><path d="M16 4a4 4 0 0 0-4 4v13a12 12 0 0 0 24 0V8a4 4 0 0 0-4-4H16Z" fill="url(#ic_fluent_trophy_48_color__e)"/><defs><linearGradient id="ic_fluent_trophy_48_color__a" x1="21.5" y1="30.9" x2="29.9" y2="44.02" gradientUnits="userSpaceOnUse"><stop offset=".17" stop-color="#EB4824"/><stop offset=".56" stop-color="#FF921F" stop-opacity=".99"/><stop offset=".85" stop-color="#EB4824"/></linearGradient><linearGradient id="ic_fluent_trophy_48_color__b" x1="80" y1="66.5" x2="70.34" y2="23.88" gradientUnits="userSpaceOnUse"><stop offset=".18" stop-color="#FFCD0F"/><stop offset="1" stop-color="#FF6F47"/></linearGradient><linearGradient id="ic_fluent_trophy_48_color__c" x1="32.67" y1="14.67" x2="45.5" y2="14.67" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><linearGradient id="ic_fluent_trophy_48_color__d" x1="16.5" y1="14.67" x2="2.5" y2="14.67" gradientUnits="userSpaceOnUse"><stop stop-color="#EB4824"/><stop offset="1" stop-color="#FFCD0F" stop-opacity=".99"/></linearGradient><radialGradient id="ic_fluent_trophy_48_color__e" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-131.95 25.07 7.85) scale(33.9071 36.3886)"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></radialGradient></defs>`, {
    color: true
});
const $cdb0ff5c001a8842$export$f5272b63ebe598ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy48Filled', "48", [
    "M12 8c.14-2.23 1.99-4 4.25-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85a12.01 12.01 0 0 1-10.38 8.96v3.56H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26Zm0 2.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm24 10.91c2-.4 3.5-2.17 3.5-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91Z"
]);
const $cdb0ff5c001a8842$export$bfbf5cbbb96257a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Trophy48Regular', "48", [
    "M12 10.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm.37 13.48A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26c.13-2.23 1.98-4 4.24-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85a12.01 12.01 0 0 1-10.38 8.96v3.56H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96ZM36 21.41c2-.4 3.51-2.17 3.51-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91ZM14.5 8.25V21a9.5 9.5 0 0 0 19 0V8.25c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75Zm0 33.25h19A2.5 2.5 0 0 0 31 39H17a2.5 2.5 0 0 0-2.5 2.5Z"
]);
const $cdb0ff5c001a8842$export$6ba920c8ce6049fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock16Filled', "16", [
    "M4 3h-.5C2.67 3 2 3.67 2 4.5v1a2.5 2.5 0 0 0 2.12 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h3.77A2 2 0 0 1 8 14v-4a2 2 0 0 1 1.5-1.94V8A3 3 0 0 1 12 5.04V4h.5c.28 0 .5.22.5.5v.54c.36.06.7.19 1 .36v-.9c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2Zm0 1v2.91c-.58-.2-1-.76-1-1.41v-1c0-.28.22-.5.5-.5H4Zm6.5 4v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0Zm1 1V8a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $cdb0ff5c001a8842$export$dd53ba4c36022e80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock16Regular', "16", [
    "M4 3c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v.9c-.3-.17-.64-.3-1-.36V4.5a.5.5 0 0 0-.5-.5H12v1.04c-.36.06-.7.19-1 .36V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v4a3 3 0 0 0 3 3v3H6a1 1 0 0 0-1 1h3c0 .37.1.71.27 1H4.5a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1C2 3.67 2.67 3 3.5 3H4Zm0 1h-.5a.5.5 0 0 0-.5.5v1c0 .65.42 1.2 1 1.41V4Zm6.5 4v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0Zm1 1V8a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $cdb0ff5c001a8842$export$da8d777e9cb06c05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock20Filled', "20", [
    "M5.5 4c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7c0 .45-.1.88-.28 1.26-.3-.14-.64-.23-1-.25.18-.3.28-.64.28-1V5.5a.5.5 0 0 0-.5-.5h-1v3.17a3 3 0 0 0-2 2.83v.06A2 2 0 0 0 11 13v.39c-.16.04-.33.06-.5.08v1.5h.5V17c0 .35.1.68.25.97H6a.5.5 0 0 1-.5-.5v-.5c0-1.1.9-2 2-2h2v-1.5a4.5 4.5 0 0 1-3.9-3.5A3 3 0 0 1 3 7V5.5C3 4.67 3.67 4 4.5 4h1Zm0 1h-1a.5.5 0 0 0-.5.5V7a2 2 0 0 0 1.5 1.93V5Zm8 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $cdb0ff5c001a8842$export$e171681079d3da08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock20Regular', "20", [
    "M3 7a3 3 0 0 0 2.6 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.23.5.5.5h5.25A2 2 0 0 1 11 17v-.03H6.5a1 1 0 0 1 1-1H11v-1h-.5v-1.5c.17-.02.34-.04.5-.08V13a2 2 0 0 1 .12-.68A3.5 3.5 0 0 1 6.5 9.16V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4.76a3 3 0 0 1 1-.59V5h1c.27 0 .5.22.5.5V7c0 .37-.1.71-.27 1 .35.03.68.12 1 .26.17-.38.27-.8.27-1.26V5.5c0-.83-.68-1.5-1.5-1.5h-1a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2h-1C3.67 4 3 4.67 3 5.5V7Zm1.5-2h1v3.93A2 2 0 0 1 4 7V5.5c0-.28.22-.5.5-.5Zm9 6v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $cdb0ff5c001a8842$export$c0d0938d6bc8d18e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock24Filled', "24", [
    "M15.25 2c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15c0 .43-.08.85-.23 1.23a3.48 3.48 0 0 0-1.44-.46c.1-.2.15-.4.17-.62V5.75a.25.25 0 0 0-.18-.24l-.06-.01H17.5v4.14A3.5 3.5 0 0 0 15 13v.05a2.5 2.5 0 0 0-2 2.45v.36a5.7 5.7 0 0 1-.5.1v1.54h.5v3c0 .56.19 1.08.5 1.5H6.75a.75.75 0 0 1-.74-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3C3 4.78 3.78 4 4.75 4H6c.13-1.12 1.08-2 2.24-2h7ZM6 5.5H4.75a.25.25 0 0 0-.25.25v3c0 .88.65 1.61 1.5 1.73V5.5ZM16 14v-1a2.5 2.5 0 0 1 5 0v1h.5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h.5Zm1.5-1v1h2v-1a1 1 0 1 0-2 0Zm2 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
]);
const $cdb0ff5c001a8842$export$91a7e141c431cabb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock24Regular', "24", [
    "M17.49 4a2.25 2.25 0 0 0-2.24-2h-7c-1.16 0-2.11.88-2.24 2H4.75C3.78 4 3 4.78 3 5.75v3C3 10.55 4.45 12 6.25 12h.02A5.76 5.76 0 0 0 11 15.95v1.55H9.07A3.25 3.25 0 0 0 6 20.76v.6c.06.37.37.65.75.65h6.75c-.31-.42-.5-.94-.5-1.5H7.52l.03-.15c.18-.77.87-1.35 1.7-1.35H13v-1.5h-.5v-1.55c.17-.02.34-.05.5-.09v-.36c0-.49.14-.94.38-1.32a4.24 4.24 0 0 1-5.88-3.93v-6c0-.41.34-.75.75-.75h7c.42 0 .75.34.75.75v6.3a3.5 3.5 0 0 1 1.5-.9V5.5h1.31c.12.03.2.13.2.25V8.9c-.03.22-.09.43-.18.62.52.04 1 .2 1.44.46.15-.38.24-.8.24-1.23V5.61C20.42 4.7 19.67 4 18.75 4h-1.27ZM4.75 5.5H6v4.98a1.75 1.75 0 0 1-1.5-1.73v-3c0-.14.1-.25.25-.25Zm13.75 5A2.5 2.5 0 0 0 16 13v1h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-2.5-2.5Zm0 1.5a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 1-1Zm0 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $cdb0ff5c001a8842$export$7932c4ec533b4534 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock28Filled', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 1.27-.55 2.4-1.43 3.18a3.99 3.99 0 0 0-1.48-.78A2.75 2.75 0 0 0 23 9.75v-3a.25.25 0 0 0-.25-.25H20.5V12a4 4 0 0 0-4 4v.04A3 3 0 0 0 14 19v5c0 .77.29 1.47.76 2H8.25C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5ZM17.5 17v-1a3 3 0 1 1 6 0v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h.5Zm1.5-1v1h3v-1a1.5 1.5 0 0 0-3 0Zm3 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
]);
const $cdb0ff5c001a8842$export$bf7656d15ac2daf6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock28Regular', "28", [
    "M7 4.75A2.75 2.75 0 0 1 9.75 2h8a2.75 2.75 0 0 1 2.75 2.75V5h2.25c.97 0 1.75.78 1.75 1.75v3c0 1.27-.55 2.4-1.43 3.18a3.99 3.99 0 0 0-1.48-.78A2.75 2.75 0 0 0 23 9.75v-3a.25.25 0 0 0-.25-.25H20.5V12c-.53 0-1.04.1-1.5.3V4.74c0-.69-.56-1.25-1.25-1.25h-8c-.69 0-1.25.56-1.25 1.25v7.5a5.25 5.25 0 0 0 5.93 5.2c-.27.46-.43.99-.43 1.55v3.5h-3.75c-.97 0-1.75.78-1.75 1.75v.25h5.54c.1.57.35 1.09.72 1.5H8.25C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3C3 5.78 3.78 5 4.75 5H7v-.25ZM7 6.5H4.75a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V6.5ZM17.5 17v-1a3 3 0 1 1 6 0v1h.5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-5c0-1.1.9-2 2-2h.5Zm1.5-1v1h3v-1a1.5 1.5 0 0 0-3 0Zm3 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
]);
const $cdb0ff5c001a8842$export$f068ce8cd85fe70e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock32Filled', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h7.3c-.2-.46-.3-.97-.3-1.5v-6a4 4 0 0 1 3.08-3.9 5 5 0 0 1 6.87-3.7A4.49 4.49 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 11.95V7h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45ZM8 7v6.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8Zm13 13v-.5a3.5 3.5 0 1 1 7 0v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5Zm2-.5v.5h3v-.5a1.5 1.5 0 0 0-3 0Zm3.5 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
]);
const $cdb0ff5c001a8842$export$97bd25e5c39a0904 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock32Regular', "32", [
    "M11 2a3 3 0 0 0-3 3H6.5A2.5 2.5 0 0 0 4 7.5v4A4.5 4.5 0 0 0 8.25 16 8 8 0 0 0 15 21.93V24h-3.5A3.5 3.5 0 0 0 8 27.5v1c0 .83.67 1.5 1.5 1.5h7.3c-.2-.46-.3-.97-.3-1.5V28H10v-.5c0-.83.67-1.5 1.5-1.5h5v-3.5c0-1.04.4-2 1.05-2.7A6 6 0 0 1 10 14V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9c0 .43-.04.84-.13 1.25a4.98 4.98 0 0 1 4.58-.35A4.49 4.49 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11Zm13 5h1.5c.28 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45V7ZM8 13.95a2.5 2.5 0 0 1-2-2.45v-4c0-.28.22-.5.5-.5H8v6.95ZM21 20v-.5a3.5 3.5 0 1 1 7 0v.5h.5a2.5 2.5 0 0 1 2.5 2.5v6a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-6a2.5 2.5 0 0 1 2.5-2.5h.5Zm2-.5v.5h3v-.5a1.5 1.5 0 0 0-3 0Zm3.5 6a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
]);
const $cdb0ff5c001a8842$export$3d85e89f8e006ec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock48Filled', "48", [
    "M12 8c.14-2.23 1.99-4 4.25-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 2.14-.98 4.06-2.53 5.32a6.98 6.98 0 0 0-9.41 5.64A5 5 0 0 0 26 32.83c-.25.05-.5.08-.75.1v3.57H26V43c0 .34.03.68.1 1H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26Zm0 2.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm24 10.91c2-.4 3.5-2.17 3.5-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91ZM32 30v-1a5 5 0 0 1 10 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3h1Zm2.5-1v1h5v-1a2.5 2.5 0 0 0-5 0Zm5.5 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"
]);
const $cdb0ff5c001a8842$export$85d3d0868fa4b57a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyLock48Regular', "48", [
    "M12 10.5H8.75a.25.25 0 0 0-.25.25v6.38C8.5 19.23 10 21 12 21.4V10.5Zm.37 13.48A6.88 6.88 0 0 1 6 17.12v-6.37A2.75 2.75 0 0 1 8.75 8h3.26c.13-2.23 1.98-4 4.24-4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 2.14-.98 4.06-2.53 5.32a6.98 6.98 0 0 0-6.2.62c.15-.66.23-1.36.23-2.07V8.25c0-.97-.78-1.75-1.75-1.75h-15.5c-.97 0-1.75.78-1.75 1.75V21a9.5 9.5 0 0 0 12.48 9.02 4.98 4.98 0 0 0-.98 2.81c-.25.05-.5.08-.75.1v3.57H26V39h-9a2.5 2.5 0 0 0-2.5 2.5H26V43c0 .34.03.68.1 1H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96ZM36 21.41c2-.4 3.51-2.17 3.51-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91ZM32 30v-1a5 5 0 0 1 10 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H31a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3h1Zm2.5-1v1h5v-1a2.5 2.5 0 0 0-5 0Zm5.5 9a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"
]);
const $cdb0ff5c001a8842$export$2d3eb183908d3bc4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff16Filled', "16", [
    "m9.84 10.55 4.3 4.3a.5.5 0 0 0 .71-.7l-13-13a.5.5 0 1 0-.7.7L2.59 3.3c-.36.28-.6.71-.6 1.2v1a2.5 2.5 0 0 0 2.13 2.47 4 4 0 0 0 3.38 3V12H6a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V14a2 2 0 0 0-2-2H8.5v-1.03c.48-.06.93-.2 1.34-.42ZM3.32 4.03l.68.68v2.2c-.58-.2-1-.76-1-1.41v-1c0-.22.13-.4.32-.47Zm8.56 3.94c-.11.45-.3.87-.55 1.24L4.22 2.1A2 2 0 0 1 6 1h4a2 2 0 0 1 2 2h.5c.83 0 1.5.67 1.5 1.5v1a2.5 2.5 0 0 1-2.12 2.47ZM12 4v2.91c.58-.2 1-.76 1-1.41v-1a.5.5 0 0 0-.5-.5H12Z"
]);
const $cdb0ff5c001a8842$export$1d06b0f6fdb909a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff16Regular', "16", [
    "M3.32 4.03A.5.5 0 0 0 3 4.5v1c0 .65.42 1.2 1 1.41v-2.2l-.68-.68ZM2.6 3.3 1.15 1.85a.5.5 0 1 1 .7-.7l13 13a.5.5 0 0 1-.7.7l-4.3-4.3c-.42.21-.87.36-1.35.42V12H10a2 2 0 0 1 2 2v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V14c0-1.1.9-2 2-2h1.5v-1.03a4 4 0 0 1-3.38-3A2.5 2.5 0 0 1 2 5.5v-1c0-.49.23-.92.6-1.2Zm6.5 6.5-4.1-4.1V7a3 3 0 0 0 4.1 2.8Zm1.9-2.73c0 .51-.14 1-.38 1.41l.72.73c.25-.37.44-.8.55-1.24A2.5 2.5 0 0 0 14 5.5v-1c0-.83-.67-1.5-1.5-1.5H12a2 2 0 0 0-2-2H6a2 2 0 0 0-1.78 1.1l.79.78A1 1 0 0 1 6 2h4a1 1 0 0 1 1 1v4.07Zm1-.16V4h.5c.29 0 .5.22.5.5v1c0 .65-.4 1.2-1 1.41ZM5 14h6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Z"
]);
const $cdb0ff5c001a8842$export$b55327acbcd90fbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff20Filled', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5c.6-.07 1.19-.26 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7l-15-15ZM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5c0-.22.13-.4.32-.47L5.5 6.21Zm8.9 3.76a4.48 4.48 0 0 1-.7 1.6L5.57 3.46A2 2 0 0 1 7.5 2h5a2 2 0 0 1 2 2h1c.82 0 1.5.67 1.5 1.5V7a3 3 0 0 1-2.6 2.97Zm.1-1.03A2 2 0 0 0 16 7V5.5a.5.5 0 0 0-.5-.5h-1v3.94Z"
]);
const $cdb0ff5c001a8842$export$744f652aefe6d572 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff20Regular', "20", [
    "M2.85 2.15a.5.5 0 1 0-.7.7L3.59 4.3c-.36.28-.6.71-.6 1.2V7a3 3 0 0 0 2.62 2.97 4.5 4.5 0 0 0 3.9 3.5v1.5h-2a2 2 0 0 0-2 2v.5c0 .27.22.5.5.5h8a.5.5 0 0 0 .5-.5v-.5a2 2 0 0 0-2-2h-2v-1.5c.6-.07 1.19-.26 1.7-.55l4.94 4.93a.5.5 0 0 0 .7-.7l-15-15Zm8.62 10.03A3.5 3.5 0 0 1 6.5 9.16V7.2l4.97 4.97ZM5.5 6.2v2.72A2 2 0 0 1 4 7V5.5c0-.22.13-.4.32-.47L5.5 6.21Zm8 2.79c0 .68-.2 1.31-.53 1.85l.72.72c.33-.47.58-1.01.7-1.6A3 3 0 0 0 17 7V5.5c0-.83-.67-1.5-1.5-1.5h-.99a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.92 1.46l.92.92V4a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5Zm1-4h1c.27 0 .5.22.5.5V7a2 2 0 0 1-1.5 1.94V5Zm-8 11.97a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1h-7Z"
]);
const $cdb0ff5c001a8842$export$b167640df9915dca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff24Filled', "24", [
    "M3.48 4.54 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.39-6.39c-.56.28-1.18.48-1.83.56v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3c0-.47.18-.9.48-1.2ZM6 7.06 4.54 5.6a.25.25 0 0 0-.04.15v3c0 .88.65 1.61 1.5 1.73V7.06ZM17.23 12c-.16.5-.38.96-.66 1.39L6.3 3.12A2.25 2.25 0 0 1 8.25 2h7c1.16 0 2.12.88 2.24 2h1.27c.92 0 1.67.7 1.74 1.6v3.15a3.25 3.25 0 0 1-3.06 3.24l-.2.01Zm1.53-6.5H17.5v4.98c.8-.11 1.43-.76 1.5-1.58V5.75a.25.25 0 0 0-.18-.24l-.06-.01Z"
]);
const $cdb0ff5c001a8842$export$bb46332db634b7e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff24Regular', "24", [
    "M3.48 4.54 2.22 3.28a.75.75 0 1 1 1.06-1.06l18.5 18.5a.75.75 0 0 1-1.06 1.06l-6.39-6.39c-.56.28-1.18.48-1.83.56v1.55h1.75a3.25 3.25 0 0 1 3.25 3.07V21.25c0 .38-.28.7-.64.74l-.1.01h-10a.75.75 0 0 1-.75-.65v-.6a3.25 3.25 0 0 1 3.06-3.24l.18-.01H11v-1.55A5.76 5.76 0 0 1 6.27 12h-.02A3.25 3.25 0 0 1 3 8.75v-3c0-.47.18-.9.48-1.2Zm9.71 9.71L7.5 8.56v1.69a4.25 4.25 0 0 0 5.69 4ZM6 7.06 4.54 5.6a.25.25 0 0 0-.04.15v3c0 .88.65 1.61 1.5 1.73V7.06Zm10 3.19c0 .74-.19 1.44-.52 2.05l1.1 1.09c.27-.43.5-.9.65-1.39h.21a3.25 3.25 0 0 0 3.07-3.25V5.61C20.42 4.7 19.67 4 18.75 4h-1.27a2.25 2.25 0 0 0-2.24-2h-7c-.83 0-1.56.45-1.95 1.12l1.2 1.2v-.07c0-.41.34-.75.75-.75h7c.42 0 .75.34.75.75v6ZM9.25 19c-.83 0-1.52.58-1.7 1.35l-.03.15h8.47A1.75 1.75 0 0 0 14.4 19H9.25Zm9.5-13.5h.07c.1.03.19.13.19.25V8.9c-.08.82-.7 1.47-1.5 1.58V5.5h1.25Z"
]);
const $cdb0ff5c001a8842$export$754e8f54b5957d73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff28Filled', "28", [
    "M4.07 5.14 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06l-7.65-7.65a6.7 6.7 0 0 1-2.57.83V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3c0-.73.44-1.35 1.07-1.61ZM7 8.06 5.44 6.5h-.69a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V8.06Zm.12-4.12L19.3 16.11c.44-.63.78-1.35.98-2.11a4.25 4.25 0 0 0 4.23-4.25v-3c0-.97-.78-1.75-1.75-1.75H20.5v-.25A2.75 2.75 0 0 0 17.75 2h-8c-1.24 0-2.28.82-2.63 1.94Zm13.38 8.55V6.5h2.25c.14 0 .25.11.25.25v3c0 1.44-1.1 2.61-2.5 2.74Z"
]);
const $cdb0ff5c001a8842$export$8a7f6edc9485986 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff28Regular', "28", [
    "M4.07 5.14 2.22 3.28a.75.75 0 1 1 1.06-1.06l22.5 22.5a.75.75 0 0 1-1.06 1.06l-7.65-7.65a6.7 6.7 0 0 1-2.57.83V21h2.75c1.8 0 3.25 1.46 3.25 3.25v.5c0 .69-.56 1.25-1.25 1.25h-11C7.56 26 7 25.44 7 24.75v-.5C7 22.45 8.46 21 10.25 21H13v-2.04A6.76 6.76 0 0 1 7.23 14 4.25 4.25 0 0 1 3 9.75v-3c0-.73.44-1.35 1.07-1.61Zm11.88 11.88L8.5 9.56v2.69a5.25 5.25 0 0 0 7.46 4.77ZM7 8.06 5.44 6.5h-.69a.25.25 0 0 0-.25.25v3c0 1.44 1.1 2.61 2.5 2.74V8.06Zm.12-4.12L8.5 5.32v-.57c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v7.5c0 1.02-.3 1.97-.8 2.78l1.09 1.08c.44-.63.78-1.35.98-2.11a4.25 4.25 0 0 0 4.23-4.25v-3c0-.97-.78-1.75-1.75-1.75H20.5v-.25A2.75 2.75 0 0 0 17.75 2h-8c-1.24 0-2.28.82-2.63 1.94Zm13.38 8.55V6.5h2.25c.14 0 .25.11.25.25v3c0 1.44-1.1 2.61-2.5 2.74Zm-12 11.76v.25H19v-.25c0-.97-.78-1.75-1.75-1.75h-7c-.97 0-1.75.78-1.75 1.75Z"
]);
const $cdb0ff5c001a8842$export$ef0380a2b86905f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff32Filled', "32", [
    "M4.54 5.95 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-8.6-8.6c-.83.42-1.73.7-2.7.83V24h3.5a3.5 3.5 0 0 1 3.5 3.5v1c0 .83-.66 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 8 28.5v-1a3.5 3.5 0 0 1 3.5-3.5H15v-2.06a8 8 0 0 1-6.74-5.95A4.5 4.5 0 0 1 4 11.5v-4c0-.59.2-1.12.54-1.55ZM8 9.41l-2-2a.5.5 0 0 0 0 .09v4a2.5 2.5 0 0 0 2 2.45V9.41ZM23.75 16c-.27 1.05-.74 2.01-1.38 2.85L8.04 4.5A3 3 0 0 1 11 2h10a3 3 0 0 1 3 3h1.5A2.5 2.5 0 0 1 28 7.5v4a4.5 4.5 0 0 1-4.25 4.5Zm.25-2.04a2.5 2.5 0 0 0 2-2.45v-4a.5.5 0 0 0-.5-.5H24v6.95Z"
]);
const $cdb0ff5c001a8842$export$4b0b4756d4b51416 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff32Regular', "32", [
    "M4.54 5.95 2.29 3.71a1 1 0 0 1 1.42-1.42l26 26a1 1 0 0 1-1.42 1.42l-8.6-8.6c-.83.42-1.73.7-2.7.83V24h3.5a3.5 3.5 0 0 1 3.5 3.5v1c0 .83-.66 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 8 28.5v-1a3.5 3.5 0 0 1 3.5-3.5H15v-2.06a8 8 0 0 1-6.74-5.95A4.5 4.5 0 0 1 4 11.5v-4c0-.59.2-1.12.54-1.55ZM18.18 19.6 10 11.41V14a6 6 0 0 0 8.18 5.6ZM8 9.41l-2-2a.5.5 0 0 0 0 .09v4a2.5 2.5 0 0 0 2 2.45V9.41ZM22 14c0 1.26-.4 2.44-1.06 3.4l1.43 1.44c.64-.84 1.11-1.8 1.38-2.85A4.5 4.5 0 0 0 28 11.5v-4A2.5 2.5 0 0 0 25.5 5H24a3 3 0 0 0-3-3H11a3 3 0 0 0-2.96 2.5L10 6.46V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9Zm2-7h1.5c.27 0 .5.22.5.5v4a2.5 2.5 0 0 1-2 2.45V7ZM10 27.5v.5h12v-.5c0-.83-.67-1.5-1.5-1.5h-9c-.83 0-1.5.67-1.5 1.5Z"
]);
const $cdb0ff5c001a8842$export$ff7e98afeec242a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff48Filled', "48", [
    "M6.93 8.7 4.37 6.12a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76l-12.1-12.1a11.92 11.92 0 0 1-4.52 1.4v3.57H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37c0-.82.36-1.55.93-2.06ZM12 13.76 8.73 10.5a.25.25 0 0 0-.23.25v6.38C8.5 19.23 10 21 12 21.4V13.77Zm23.63 10.21a11.95 11.95 0 0 1-2.07 4.28L12.2 6.9A4.25 4.25 0 0 1 16.25 4h15.5a4.25 4.25 0 0 1 4.24 4h3.26A2.75 2.75 0 0 1 42 10.75v6.38c0 3.62-2.81 6.6-6.37 6.85Zm.36-2.57c2-.4 3.51-2.17 3.51-4.29v-6.37a.25.25 0 0 0-.25-.25H36v10.91Z"
]);
const $cdb0ff5c001a8842$export$361c6f73d83031ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TrophyOff48Regular', "48", [
    "M6.93 8.7 4.37 6.12a1.25 1.25 0 1 1 1.76-1.76l37.5 37.5a1.25 1.25 0 0 1-1.76 1.76l-12.1-12.1a11.92 11.92 0 0 1-4.52 1.4v3.57H31a5 5 0 0 1 5 5v.5a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-.5a5 5 0 0 1 5-5h5.75v-3.56a12.01 12.01 0 0 1-10.38-8.96A6.88 6.88 0 0 1 6 17.12v-6.37c0-.82.36-1.55.93-2.06ZM27.9 29.66l-13.4-13.4V21a9.5 9.5 0 0 0 13.4 8.67ZM12 13.77 8.73 10.5a.25.25 0 0 0-.23.25v6.38C8.5 19.23 10 21 12 21.4V13.77ZM33.5 21c0 2.04-.64 3.92-1.73 5.47l1.79 1.79c.95-1.26 1.66-2.7 2.07-4.28A6.88 6.88 0 0 0 42 17.12v-6.37A2.75 2.75 0 0 0 39.25 8h-3.26a4.25 4.25 0 0 0-4.24-4h-15.5a4.25 4.25 0 0 0-4.04 2.91L14.5 9.2v-.95c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75V21Zm2.5.41V10.5h3.25c.14 0 .25.11.25.25v6.38c0 2.11-1.5 3.88-3.5 4.28ZM33.5 41.5A2.5 2.5 0 0 0 31 39H17a2.5 2.5 0 0 0-2.5 2.5h19Z"
]);
const $cdb0ff5c001a8842$export$340f1e7ad13e94a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork16Filled', "16", [
    "M2.92 4.78a.75.75 0 1 1 1.16.94L2.22 8l1.86 2.28a.75.75 0 0 1-1.16.95L.67 8.48a.75.75 0 0 1 0-.95l2.25-2.75Zm9.1-.11a.75.75 0 0 1 1.06.1l2.25 2.76c.23.27.23.67 0 .95l-2.25 2.75a.75.75 0 0 1-1.16-.95L13.78 8l-1.86-2.28a.75.75 0 0 1 .1-1.05Zm-.9 2.46a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75Zm-6.24 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75Zm3.12 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75Z"
]);
const $cdb0ff5c001a8842$export$2bdf075e9711e04c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork16Regular', "16", [
    "M3.12 4.68a.5.5 0 0 1 .76.64L1.65 8l2.23 2.68a.5.5 0 0 1-.76.64l-2.5-3a.5.5 0 0 1 0-.64l2.5-3Zm9.06-.06a.5.5 0 0 1 .7.06l2.5 3a.5.5 0 0 1 0 .64l-2.5 3a.5.5 0 0 1-.76-.64L14.35 8l-2.23-2.68a.5.5 0 0 1 .06-.7Zm-1.05 2.51a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75Zm-6.25 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75Zm3.12 0a.88.88 0 1 1 0 1.75.88.88 0 0 1 0-1.75Z"
]);
const $cdb0ff5c001a8842$export$796f97bce9120978 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork20Filled', "20", [
    "M4.7 6.16c.34.25.4.72.14 1.05L2.7 10l2.14 2.8a.75.75 0 1 1-1.18.9l-2.5-3.24a.75.75 0 0 1 0-.92l2.5-3.25a.75.75 0 0 1 1.05-.13Zm10.46 6.63a.75.75 0 1 0 1.18.92l2.5-3.25c.21-.27.21-.65 0-.92l-2.5-3.25a.75.75 0 1 0-1.18.92L17.3 10l-2.14 2.8ZM6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $cdb0ff5c001a8842$export$5014b1422dd0f5b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork20Regular', "20", [
    "M4.83 6.12c.2.18.23.5.05.7L2.16 10l2.72 3.17a.5.5 0 1 1-.76.66l-3-3.5a.5.5 0 0 1 0-.66l3-3.5a.5.5 0 0 1 .7-.05Zm10.29 7.05a.5.5 0 0 0 .76.66l3-3.5a.5.5 0 0 0 0-.66l-3-3.5a.5.5 0 1 0-.76.66L17.84 10l-2.72 3.17ZM6 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $cdb0ff5c001a8842$export$b474be5c20aad14e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork24Filled', "24", [
    "M4.47 7.37a1 1 0 0 1 1.56 1.26L3.29 12l2.74 3.37a1 1 0 0 1-1.56 1.26l-3.25-4a1 1 0 0 1 0-1.26l3.25-4Zm13.65-.15a1 1 0 0 1 1.4.15l3.26 4c.3.37.3.9 0 1.26l-3.25 4a1 1 0 0 1-1.56-1.26L20.71 12l-2.74-3.37a1 1 0 0 1 .15-1.4ZM7.5 10.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $cdb0ff5c001a8842$export$ca62d1fae4e41932 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetwork24Regular', "24", [
    "M4.67 7.27a.75.75 0 0 1 1.16.96L2.73 12l3.1 3.77a.75.75 0 0 1-1.16.96l-3.5-4.25a.75.75 0 0 1 0-.96l3.5-4.25Zm13.6-.1a.75.75 0 0 1 1.06.1l3.5 4.25c.23.28.23.68 0 .96l-3.5 4.25a.75.75 0 0 1-1.16-.96l3.1-3.77-3.1-3.77a.75.75 0 0 1 .1-1.06ZM7.5 10.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm4.5 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $cdb0ff5c001a8842$export$a54a36f28ca6374e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkToolbox20Filled', "20", [
    "M4.84 7.2a.75.75 0 0 0-1.18-.9l-2.5 3.24c-.21.27-.21.65 0 .92l2.5 3.25a.75.75 0 1 0 1.18-.92L2.7 10l2.14-2.8Zm13.12 3.84a2.5 2.5 0 0 0-1.13-1.66l-1.67-2.17a.75.75 0 1 1 1.18-.92l2.5 3.25c.21.27.21.65 0 .92l-.52.68a2.49 2.49 0 0 0-.36-.1ZM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0V16Z"
]);
const $cdb0ff5c001a8842$export$3d496de34945c943 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('VirtualNetworkToolbox20Regular', "20", [
    "M4.88 6.83a.5.5 0 1 0-.76-.66l-3 3.5a.5.5 0 0 0 0 .66l3 3.5a.5.5 0 1 0 .76-.66L2.16 10l2.72-3.17Zm13.08 4.21c-.06-.3-.16-.57-.31-.82l.2-.22-2.73-3.17a.5.5 0 0 1 .76-.66l3 3.5a.5.5 0 0 1 0 .66l-.67.77a2.48 2.48 0 0 0-.25-.06ZM7 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2 1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0V16Z"
]);


parcelRequire("acw62");
parcelRequire("acw62");




'use client';
const $6211bebe0e26a21f$export$aaff2132faac2157 = (props)=>{
    const isInsideSurfaceDialog = (0, $dfbb1f6223498329$export$6e6c677beea48331)();
    const { children: children, disableButtonEnhancement: disableButtonEnhancement = false, action: action = isInsideSurfaceDialog ? 'close' : 'open' } = props;
    const child = (0, $afe88029dd4784e4$export$8e7091920a6cd3c6)(children);
    const requestOpenChange = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.requestOpenChange);
    const { triggerAttributes: triggerAttributes } = (0, $dc225fea5f0a0e8e$export$8e5cbf21155fc1da)();
    const handleClick = (0, $7d6a37de2d9c3d24$export$ee5b5d04074a389e)((event)=>{
        var _child_props_onClick, _child_props;
        child === null || child === void 0 || (_child_props_onClick = (_child_props = child.props).onClick) === null || _child_props_onClick === void 0 || _child_props_onClick.call(_child_props, event);
        if (!event.isDefaultPrevented()) requestOpenChange({
            event: event,
            type: 'triggerClick',
            open: action === 'open'
        });
    });
    const triggerChildProps = {
        ...child === null || child === void 0 ? void 0 : child.props,
        ref: (0, $4967d38ee824a4c7$export$4554ac6b8c3e1a5d)(child),
        onClick: handleClick,
        ...triggerAttributes
    };
    const ariaButtonTriggerChildProps = (0, $ce4d8d04d71d4d52$export$d4669238f28a66b8)((child === null || child === void 0 ? void 0 : child.type) === 'button' || (child === null || child === void 0 ? void 0 : child.type) === 'a' ? child.type : 'div', {
        ...triggerChildProps,
        type: 'button'
    });
    return {
        children: (0, $70e12b87c0533cc6$export$4ef26f87842d1b0)(children, disableButtonEnhancement ? triggerChildProps : ariaButtonTriggerChildProps)
    };
};


/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ const $2a8cf2adc5e92ade$export$cb06be6124610e3e = (state)=>state.children;


'use client';
const $16af17f31b90353f$export$2e1e1122cf0cba88 = (props)=>{
    const state = (0, $6211bebe0e26a21f$export$aaff2132faac2157)(props);
    return (0, $2a8cf2adc5e92ade$export$cb06be6124610e3e)(state);
};
$16af17f31b90353f$export$2e1e1122cf0cba88.displayName = 'DialogTrigger';
// type casting here is required to ensure internal type FluentTriggerComponent is not leaked
$16af17f31b90353f$export$2e1e1122cf0cba88.isFluentTriggerComponent = true;





'use client';
const $547cf61831bf2f2a$export$95e25609c421dd8c = {
    root: 'fui-DialogTitle',
    action: 'fui-DialogTitle__action'
};
/**
 * Styles for the root slot
 */ const $547cf61831bf2f2a$var$useRootResetStyles = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rxjm636", null, [
    ".rxjm636{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase500);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase500);margin:0;grid-row-start:1;grid-row-end:1;grid-column-start:1;grid-column-end:3;}"
]);
const $547cf61831bf2f2a$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    rootWithoutAction: {
        Bw0ie65: "fsyjsko"
    }
}, {
    d: [
        ".fsyjsko{grid-column-end:4;}"
    ]
});
/**
 * Styles for the action slot
 */ const $547cf61831bf2f2a$var$useActionResetStyles = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r13kcrze", null, [
    ".r13kcrze{grid-row-start:1;grid-row-end:1;grid-column-start:3;justify-self:end;align-self:start;}"
]);
const $547cf61831bf2f2a$export$26ca0b2a08218f64 = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r2avt6e", "roj2bbc", {
    r: [
        ".r2avt6e{overflow:visible;padding:0;border-style:none;position:relative;box-sizing:content-box;background-color:inherit;color:inherit;font-family:inherit;font-size:inherit;cursor:pointer;line-height:0;-webkit-appearance:button;text-align:unset;}",
        ".r2avt6e:focus{outline-style:none;}",
        ".r2avt6e:focus-visible{outline-style:none;}",
        ".r2avt6e[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".r2avt6e[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".roj2bbc{overflow:visible;padding:0;border-style:none;position:relative;box-sizing:content-box;background-color:inherit;color:inherit;font-family:inherit;font-size:inherit;cursor:pointer;line-height:0;-webkit-appearance:button;text-align:unset;}",
        ".roj2bbc:focus{outline-style:none;}",
        ".roj2bbc:focus-visible{outline-style:none;}",
        ".roj2bbc[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".roj2bbc[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.r2avt6e[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media (forced-colors: active){.roj2bbc[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"
    ]
});
const $547cf61831bf2f2a$export$53944469f724c3ea = (state)=>{
    'use no memo';
    const rootResetStyles = $547cf61831bf2f2a$var$useRootResetStyles();
    const actionResetStyles = $547cf61831bf2f2a$var$useActionResetStyles();
    const styles = $547cf61831bf2f2a$var$useStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($547cf61831bf2f2a$export$95e25609c421dd8c.root, rootResetStyles, !state.action && styles.rootWithoutAction, state.root.className);
    if (state.action) state.action.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($547cf61831bf2f2a$export$95e25609c421dd8c.action, actionResetStyles, state.action.className);
    return state;
};


'use client';
const $24b13530e8457cf2$export$92a9d9d589e4d9c0 = (props, ref)=>{
    const { action: action } = props;
    const modalType = (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.modalType);
    const internalStyles = (0, $547cf61831bf2f2a$export$26ca0b2a08218f64)();
    return {
        components: {
            root: 'h2',
            action: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('h2', {
            ref: ref,
            id: (0, $1df5e8bcad6e85cf$export$907394755222dc8e)((ctx)=>ctx.dialogTitleId),
            ...props
        }), {
            elementType: 'h2'
        }),
        action: (0, $fcf7ddccaab7fd8f$exports).optional(action, {
            renderByDefault: modalType === 'non-modal',
            defaultProps: {
                children: /*#__PURE__*/ $acw62.createElement((0, $16af17f31b90353f$export$2e1e1122cf0cba88), {
                    disableButtonEnhancement: true,
                    action: "close"
                }, /*#__PURE__*/ $acw62.createElement("button", {
                    type: "button",
                    className: internalStyles,
                    // TODO: find a better way to add internal labels
                    "aria-label": "close"
                }, /*#__PURE__*/ $acw62.createElement((0, $cdb0ff5c001a8842$export$5b53e1eb03c72ac3), null)))
            },
            elementType: 'div'
        })
    };
};



var $acw62 = parcelRequire("acw62");

const $113c24d46ee00056$export$aed664116b015c62 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {
                children: state.root.children
            }),
            state.action && /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.action, {})
        ]
    });
};




'use client';
const $dce7a536101527d5$export$16f7638e4a34b909 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $24b13530e8457cf2$export$92a9d9d589e4d9c0)(props, ref);
    (0, $547cf61831bf2f2a$export$53944469f724c3ea)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogTitleStyles_unstable')(state);
    return (0, $113c24d46ee00056$export$aed664116b015c62)(state);
});
$dce7a536101527d5$export$16f7638e4a34b909.displayName = 'DialogTitle';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

const $bd254132865b1d8d$export$b209aee26b208fc6 = (props, ref)=>{
    var _props_as;
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)((_props_as = props.as) !== null && _props_as !== void 0 ? _props_as : 'div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        })
    };
};




const $7361310cd8aacfc1$export$7d851008e12de2a6 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};





'use client';
const $e801766fd42220d0$export$a1e658fc8a74c104 = {
    root: 'fui-DialogContent'
};
/**
 * Styles for the root slot
 */ const $e801766fd42220d0$var$useStyles = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r1v5zwsm", null, {
    r: [
        ".r1v5zwsm{padding:var(--strokeWidthThick);margin:calc(var(--strokeWidthThick) * -1);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);overflow-y:auto;min-height:32px;box-sizing:border-box;grid-row-start:2;grid-row-end:2;grid-column-start:1;grid-column-end:4;}"
    ],
    s: [
        "@media screen and (max-height: 359px){.r1v5zwsm{overflow-y:unset;}}"
    ]
});
const $e801766fd42220d0$export$5884e4da3aea1523 = (state)=>{
    'use no memo';
    const styles = $e801766fd42220d0$var$useStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($e801766fd42220d0$export$a1e658fc8a74c104.root, styles, state.root.className);
    return state;
};



'use client';
const $330458ead2ba66c5$export$b6d9565de1e068cf = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $bd254132865b1d8d$export$b209aee26b208fc6)(props, ref);
    (0, $e801766fd42220d0$export$5884e4da3aea1523)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogContentStyles_unstable')(state);
    return (0, $7361310cd8aacfc1$export$7d851008e12de2a6)(state);
});
$330458ead2ba66c5$export$b6d9565de1e068cf.displayName = 'DialogContent';


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $9be8a0b8d40bba68$var$FieldContext = $acw62.createContext(undefined);
const $9be8a0b8d40bba68$export$f9a33f37cefdc55a = $9be8a0b8d40bba68$var$FieldContext.Provider;
const $9be8a0b8d40bba68$export$100197406d2d5de2 = ()=>$acw62.useContext($9be8a0b8d40bba68$var$FieldContext);


'use client';
function $af5cf4826b6cd175$export$fc5228adfb2d94ce(props, options) {
    return $af5cf4826b6cd175$export$6628ce0d0b903197((0, $9be8a0b8d40bba68$export$100197406d2d5de2)(), props, options);
}
function $af5cf4826b6cd175$export$6628ce0d0b903197(context, props, options) {
    if (!context) return props;
    // Create a copy of props so we don't modify the original
    props = {
        ...props
    };
    const { generatedControlId: generatedControlId, hintId: hintId, labelFor: labelFor, labelId: labelId, required: required, validationMessageId: validationMessageId, validationState: validationState } = context;
    if (generatedControlId) {
        var _props;
        var _id;
        (_id = (_props = props).id) !== null && _id !== void 0 ? _id : _props.id = generatedControlId;
    }
    // Set aria-labelledby if the control doesn't support label.htmlFor, or if the label's htmlFor doesn't refer
    // to this control (i.e. the user set this control's id prop without also setting the Field's label.htmlFor).
    if (labelId && (!(options === null || options === void 0 ? void 0 : options.supportsLabelFor) || labelFor !== props.id)) {
        var _props1, _arialabelledby;
        var _;
        (_ = (_props1 = props)[_arialabelledby = 'aria-labelledby']) !== null && _ !== void 0 ? _ : _props1[_arialabelledby] = labelId;
    }
    // The control is described by the validation message, or hint, or both.
    // We also preserve and append any aria-describedby from props.
    // For reference: https://github.com/microsoft/fluentui/pull/25580#discussion_r1017259933
    if (validationMessageId || hintId) // NOTE: Not using ??= since we're merging and overriding the user-provided value.
    props['aria-describedby'] = [
        validationMessageId,
        hintId,
        props === null || props === void 0 ? void 0 : props['aria-describedby']
    ].filter(Boolean).join(' ');
    if (validationState === 'error') {
        var _props2, _ariainvalid;
        var _1;
        (_1 = (_props2 = props)[_ariainvalid = 'aria-invalid']) !== null && _1 !== void 0 ? _1 : _props2[_ariainvalid] = true;
    }
    if (required) {
        if (options === null || options === void 0 ? void 0 : options.supportsRequired) {
            var _props3;
            var _required;
            (_required = (_props3 = props).required) !== null && _required !== void 0 ? _required : _props3.required = true;
        } else {
            var _props4, _ariarequired;
            var _2;
            (_2 = (_props4 = props)[_ariarequired = 'aria-required']) !== null && _2 !== void 0 ? _2 : _props4[_ariarequired] = true;
        }
    }
    // Include the size prop if this control supports it
    if (options === null || options === void 0 ? void 0 : options.supportsSize) {
        var _props5;
        var _size;
        (_size = (_props5 = props).size) !== null && _size !== void 0 ? _size : _props5.size = context.size;
    }
    return props;
}




/**
 * Calculates a number's precision based on the number of trailing
 * zeros if the number does not have a decimal indicated by a negative
 * precision. Otherwise, it calculates the number of digits after
 * the decimal point indicated by a positive precision.
 * @param value - the value to determine the precision of
 */ function $ad78e04db390d0d8$export$fb97a23451ff4bd8(value) {
    /**
   * Group 1:
   * [1-9]([0]+$) matches trailing zeros
   * Group 2:
   * \.([0-9]*) matches all digits after a decimal point.
   */ const groups = /[1-9]([0]+$)|\.([0-9]*)/.exec(String(value));
    if (!groups) return 0;
    if (groups[1]) return -groups[1].length;
    if (groups[2]) return groups[2].length;
    return 0;
}
function $ad78e04db390d0d8$export$21940c83e368df92(value, precision, base = 10) {
    const exp = base ** precision;
    return Math.round(value * exp) / exp;
}

const $902b29ca1597bd57$export$7d15b64cf5a3a4c4 = (value, min, max)=>{
    let nextValue = value;
    if (min !== undefined) {
        if (max !== undefined && min > max) {
            const error = new Error();
            return value;
        }
        nextValue = Math.max(min, nextValue);
    }
    if (max !== undefined) nextValue = Math.min(max, nextValue);
    return nextValue;
};

const $24bfcc54f48da074$export$e0323f9c333f1b2a = (value, min, max)=>{
    if (min !== undefined && value === min) {
        if (max === min) return 'both';
        return 'min';
    } else if (max !== undefined && value === max) return 'max';
    return 'none';
};



"use client";
const $77e1bce0ac0f7fe7$export$7bc1c4f0765ef7e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane16Filled', "16", [
    "M7.9 1A.9.9 0 0 0 7 2.05l.69 4.43-1.88.17L4.57 4.5A.96.96 0 0 0 3.73 4c-.4 0-.73.33-.73.73v2.18L1.97 7a1 1 0 0 0 0 2L3 9.1v2.17c0 .4.33.73.73.73.35 0 .67-.19.84-.49L5.8 9.35l1.88.17-.68 4.43A.9.9 0 0 0 7.9 15c.51 0 .98-.3 1.2-.77l2.02-4.4c.62.06 1.25.17 1.87.17a2 2 0 1 0 0-4c-.62 0-1.25.11-1.87.17L9.1 1.77A1.32 1.32 0 0 0 7.9 1Z"
]);
const $77e1bce0ac0f7fe7$export$38e3ca7ae182a492 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane16Regular', "16", [
    "M7.04 2.28C6.94 1.61 7.46 1 8.14 1c.68 0 1.3.4 1.57 1l1.88 4.07c.47-.03.94-.07 1.41-.07a2 2 0 1 1 0 4c-.47 0-.94-.04-1.41-.07L9.7 14c-.28.6-.9 1-1.56 1-.69 0-1.2-.6-1.1-1.28l.6-3.97-1.53-.08-.92 1.61c-.25.45-.73.72-1.24.72a.96.96 0 0 1-.96-.96V9.52l-.51-.02a1.5 1.5 0 0 1 0-3L3 6.48V4.96c0-.53.43-.96.96-.96.51 0 .99.27 1.24.72l.92 1.6 1.54-.07-.62-3.97ZM8.14 2a.11.11 0 0 0-.1.13L8.8 7.2l-3.25.16L4.33 5.2a.43.43 0 0 0-.33-.2v2.42l-1.49.07H2.5a.5.5 0 0 0 0 1h.01L4 8.57V11c.14-.01.26-.1.33-.21l1.23-2.15 3.25.16-.78 5.07c0 .07.05.13.12.13.28 0 .54-.16.65-.42l2.16-4.68 1.94.1h.1a1 1 0 1 0-.1-2l-1.94.1L8.8 2.42A.73.73 0 0 0 8.15 2Z"
]);
const $77e1bce0ac0f7fe7$export$588d994261a971a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane20Filled', "20", [
    "M9 2c.6 0 1.16.36 1.4.92l2.37 5.4 3.23-.2a1.88 1.88 0 0 1 2 1.76V10c0 1.04-.84 1.88-1.88 1.88H16l-3.23-.2-2.37 5.4c-.24.56-.8.92-1.4.92a.88.88 0 0 1-.88-.88v-.06l.7-5.63-2.46-.16-1.14 2.28a.8.8 0 0 1-.72.45.5.5 0 0 1-.5-.5v-2.38l-1.06-.06a1 1 0 0 1-.94-1v-.12a1 1 0 0 1 .94-1L4 8.88V6.5c0-.28.22-.5.5-.5.3 0 .59.17.72.45l1.14 2.28 2.46-.16L8.12 3A.88.88 0 0 1 9 2Z"
]);
const $77e1bce0ac0f7fe7$export$39cf74e878a42ab6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane20Regular', "20", [
    "M8.78 8.29 8.1 2.81a1.16 1.16 0 0 1 1-1.3h.08l.17-.01c.6 0 1.13.35 1.37.9l2.51 5.74 2.75-.09c1.03-.03 1.9.73 2 1.74l.02.15V10c0 1.08-.87 1.95-1.96 1.95l-2.8-.1-2.52 5.75c-.24.55-.78.9-1.37.9h-.1a1.16 1.16 0 0 1-1.15-1.3l.68-5.5-2.14-.06-.96 1.67c-.24.43-.7.69-1.18.69a1 1 0 0 1-1-1v-1.47h-.16a1.53 1.53 0 0 1 0-3.05l.16-.01V7a1 1 0 0 1 1-1c.49 0 .94.26 1.18.69l.96 1.67 2.14-.07Zm.57-5.79h-.12a.16.16 0 0 0-.14.18l.82 6.57-3.84.13-1.26-2.2A.36.36 0 0 0 4.5 7v2.43l-.98.04a.53.53 0 0 0 0 1.06l.98.04V13h.08c.1-.03.18-.1.23-.18l1.26-2.2 3.84.13-.82 6.59c0 .09.07.16.16.16h.1a.5.5 0 0 0 .45-.3l2.79-6.36 3.46.11c.52 0 .95-.42.95-.95v-.03a.95.95 0 0 0-.98-.92l-3.43.11L9.8 2.8a.5.5 0 0 0-.45-.3Z"
]);
const $77e1bce0ac0f7fe7$export$644520e55f3584f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane24Filled', "24", [
    "M21.99 11.95a2 2 0 0 1-2.05 1.99l-4.74-.14-3.45 7.14c-.28.57-.86.94-1.5.94a.93.93 0 0 1-.92-1.04l.86-7.19-3.76-.1-.5 1.33c-.18.51-.66.85-1.2.85a.9.9 0 0 1-.9-.9v-1.48L3 13.18a1.26 1.26 0 0 1 0-2.47l.82-.17V9.07a.9.9 0 0 1 .78-.9h.12c.54 0 1.02.33 1.2.84l.5 1.34 3.75-.1-.85-7.1v-.1c0-.51.4-.93.92-.93.58 0 1.12.3 1.42.8l.08.14 3.4 7.04 4.79-.14a2 2 0 0 1 2.05 1.93v.06Z"
]);
const $77e1bce0ac0f7fe7$export$7faf10301b8cb745 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane24Regular', "24", [
    "m9.47 9.64-.7-5.87v-.08c0-.88.72-1.6 1.6-1.6.8 0 1.55.42 1.98 1.13l.1.16 2.94 6.09 3.95-.12a2.6 2.6 0 0 1 2.68 2.53v.07a2.6 2.6 0 0 1-2.62 2.6l-3.97-.12-2.99 6.19a2.3 2.3 0 0 1-2.06 1.3c-.9 0-1.61-.73-1.61-1.64v-.12l.71-5.9-2.13-.07-.27.74a1.95 1.95 0 0 1-1.83 1.28c-.87 0-1.58-.71-1.58-1.59v-.76l-.16-.03a1.92 1.92 0 0 1 0-3.76l.16-.03v-.76c0-.8.6-1.48 1.43-1.58h.15c.75 0 1.43.42 1.77 1.12l.06.15.27.74 2.12-.07Zm.9-6.05c-.05 0-.1.04-.1.08l.88 7.42-4.84.15-.62-1.72-.04-.08c-.07-.15-.23-.25-.35-.25h-.06a.09.09 0 0 0-.07.09v1.98l-1.35.28a.42.42 0 0 0 0 .82l1.35.28v1.98c0 .05.03.09.08.09.19 0 .36-.12.42-.3l.64-1.75 4.86.15-.9 7.47v.03c0 .06.05.1.1.1a.8.8 0 0 0 .72-.44l3.42-7.07 4.9.15c.61 0 1.1-.5 1.1-1.09v-.04a1.1 1.1 0 0 0-1.12-1.07l-4.93.15-3.35-6.93-.06-.1a.8.8 0 0 0-.67-.38Z"
]);
const $77e1bce0ac0f7fe7$export$4646e1d56d3c7e1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane28Filled', "28", [
    "M12.3 2c-.78 0-1.37.68-1.28 1.44l1 8.14-2.7.14-1.65-2.88C7.37 8.32 6.8 8 6.2 8 5.54 8 5 8.54 5 9.21v2.74L3.98 12a2 2 0 0 0 0 4l1.02.05v2.74c0 .67.54 1.21 1.21 1.21.6 0 1.16-.32 1.46-.84l1.64-2.88 2.7.14-1 8.14c-.08.77.51 1.44 1.28 1.44.72 0 1.37-.42 1.66-1.07l3.69-8.21c1.78.1 3.58.28 5.36.28a3 3 0 1 0 0-6c-1.78 0-3.58.19-5.36.28l-3.69-8.2A1.82 1.82 0 0 0 12.3 2Z"
]);
const $77e1bce0ac0f7fe7$export$73eaec2e30c712c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane28Regular', "28", [
    "M11.04 3.9A1.7 1.7 0 0 1 12.72 2c1.04 0 1.99.61 2.41 1.56l3.4 7.56C20.02 11.08 21.5 11 23 11a3 3 0 1 1 0 6c-1.49 0-2.98-.08-4.47-.12l-3.4 7.56A2.64 2.64 0 0 1 12.72 26a1.7 1.7 0 0 1-1.68-1.9l.9-7.4-2.83-.07-1.18 2.06A2.6 2.6 0 0 1 5.68 20C4.75 20 4 19.25 4 18.32v-1.87a2.5 2.5 0 0 1 0-4.9V9.68C4 8.75 4.75 8 5.68 8c.93 0 1.8.5 2.25 1.31l1.18 2.06 2.83-.07-.9-7.4Zm1.68-.4a.2.2 0 0 0-.2.22l1.11 9.03-5.37.15-1.63-2.85a1.1 1.1 0 0 0-.95-.55c-.1 0-.18.08-.18.18v3.3l-.99.02H4.5a1 1 0 1 0 0 2h.01l.99.03v3.3c0 .1.08.17.18.17.4 0 .76-.21.95-.55l1.63-2.85 5.37.15-1.1 9.03a.2.2 0 0 0 .19.22c.45 0 .86-.26 1.04-.68l3.8-8.47 5.36.15H23a1.5 1.5 0 1 0-.08-3l-5.35.15-3.8-8.47c-.2-.42-.6-.68-1.05-.68Z"
]);
const $77e1bce0ac0f7fe7$export$87c7c90c5e15f88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane32Filled', "32", [
    "M14.76 2a1.8 1.8 0 0 0-1.8 2L14 13.56l-3.8.17-1.46-3.4A2.2 2.2 0 0 0 6.7 9C5.77 9 5 9.77 5 10.71v3.25L3.97 14a2 2 0 0 0 0 4l1.03.04v3.25c0 .94.77 1.71 1.71 1.71a2.2 2.2 0 0 0 2.02-1.33l1.46-3.4 3.8.17L12.96 28a1.8 1.8 0 0 0 1.8 2c.94 0 1.78-.56 2.15-1.42l4.22-9.83c1.95.08 3.92.25 5.87.25a3 3 0 1 0 0-6c-1.95 0-3.92.17-5.87.25L16.9 3.42A2.35 2.35 0 0 0 14.76 2Z"
]);
const $77e1bce0ac0f7fe7$export$9f0db725384b7492 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane32Regular', "32", [
    "M12.02 4.5c-.15-1.34.9-2.5 2.24-2.5a3.1 3.1 0 0 1 2.85 1.88l3.59 8.37c1.76-.08 3.54-.25 5.3-.25a4 4 0 0 1 0 8c-1.76 0-3.54-.17-5.3-.25l-3.59 8.37A3.1 3.1 0 0 1 14.26 30a2.26 2.26 0 0 1-2.24-2.5l.87-8.12-2.13-.1-.83 1.91A2.99 2.99 0 0 1 7.2 23 2.2 2.2 0 0 1 5 20.8V19h-.03a3 3 0 0 1 0-6H5v-1.8C5 9.97 5.98 9 7.2 9c1.19 0 2.26.71 2.73 1.8l.83 1.92 2.13-.1L12 4.5Zm2.24-.5a.26.26 0 0 0-.26.29l1.1 10.23-5.64.27-1.36-3.2a.99.99 0 0 0-.9-.59.2.2 0 0 0-.2.2v3.7l-1.98.1H5a1 1 0 1 0 0 2h.02l1.98.1v3.7c0 .11.09.2.2.2.39 0 .74-.23.9-.6l1.36-3.19 5.64.27L14 27.71c-.01.16.1.29.26.29.44 0 .84-.26 1.01-.67l4.14-9.65 6.4.31.19.01a2 2 0 1 0-.2-4l-6.4.32-4.13-9.65a1.1 1.1 0 0 0-1-.67Z"
]);
const $77e1bce0ac0f7fe7$export$d672d4616aa6502 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane48Filled', "48", [
    "M21.01 3a2.02 2.02 0 0 0-2 2.22l1.5 14.93-4.36.28-2.5-4.37A4.09 4.09 0 0 0 10.1 14 2.1 2.1 0 0 0 8 16.1v4.84L6.96 21a3 3 0 0 0 0 6l1.04.06v4.84c0 1.16.94 2.1 2.1 2.1 1.47 0 2.82-.79 3.55-2.06l2.5-4.37 4.36.28-1.5 14.93A2.02 2.02 0 0 0 21 45c1.5 0 2.85-.87 3.47-2.23l6.5-14.27c2.66.17 5.36.5 8.02.5a5 5 0 0 0 0-10c-2.66 0-5.36.33-8.02.5l-6.5-14.27A3.81 3.81 0 0 0 21.01 3Z"
]);
const $77e1bce0ac0f7fe7$export$e8f5024cd4c3d2d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Airplane48Regular', "48", [
    "M19.02 5.56A2.33 2.33 0 0 1 21.33 3c1.9 0 3.62 1.1 4.4 2.83l5.93 13c2.27-.1 4.57-.33 6.84-.33a5.5 5.5 0 1 1 0 11c-2.27 0-4.57-.22-6.84-.33l-5.93 13a4.84 4.84 0 0 1-4.4 2.83 2.33 2.33 0 0 1-2.31-2.56l1.4-13.83-3.76-.18-1.68 2.94A5.23 5.23 0 0 1 10.44 34 2.44 2.44 0 0 1 8 31.56V28h-.03a4 4 0 0 1 0-8H8v-3.56C8 15.1 9.1 14 10.44 14c1.88 0 3.61 1 4.54 2.63l1.68 2.94 3.76-.18-1.4-13.83Zm2.5-.05 1.65 16.25-7.92.38-2.44-4.27a2.73 2.73 0 0 0-2.31-1.37v5.88l-2.47.12H8a1.5 1.5 0 0 0 0 3h.03l2.47.12v5.88a2.73 2.73 0 0 0 2.3-1.37l2.45-4.27 7.92.38-1.65 16.25a2.34 2.34 0 0 0 1.94-1.36l6.63-14.55 8.11.4a3 3 0 1 0 0-5.97l-8.11.4-6.63-14.54a2.34 2.34 0 0 0-1.94-1.36Z"
]);
const $77e1bce0ac0f7fe7$export$115089d364be5718 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding16Filled', "16", [
    "m8.85 2.85 1.07 2.19H8.89L6 4v-.5c0-1.6 2.15-2.08 2.85-.65Zm3.12 3.17a3 3 0 0 1 3.03 3v.48a1.5 1.5 0 0 1-1.98 1.42l-2.25-.77-5.23 1.77c-1.54.51-2.69-1.43-1.5-2.53l1.22-1.12-3.24-1.1a1.5 1.5 0 0 1-.73-2.3L3 2.47c.63-.88 2-.44 2 .63v1.6l3.54 1.29a1 1 0 0 0 .36.06l3.07-.03ZM1 14.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$b1bebd1bfedaf28b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding16Regular', "16", [
    "M6 5.06V3.5c0-1.59 2.15-2.09 2.85-.65l1.55 3.18 1.57-.01a3 3 0 0 1 3.03 3v.48a1.5 1.5 0 0 1-1.98 1.42l-2.25-.77-5.23 1.77c-1.54.51-2.69-1.43-1.5-2.53l1.22-1.12-3.24-1.1a1.5 1.5 0 0 1-.73-2.3L3 2.47c.63-.88 2-.44 2 .63v1.6l1 .36Zm3.3.98L7.95 3.28c-.23-.47-.95-.3-.95.22v1.93l1.54.56a1 1 0 0 0 .36.06h.4ZM1 14.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Zm1.34-8.28 3.25 1.1a1 1 0 0 1 .35 1.69l-1.22 1.12c-.4.36-.01 1.01.5.84l5.23-1.76a1 1 0 0 1 .65 0l2.24.76A.5.5 0 0 0 14 9.5v-.48a2 2 0 0 0-2.02-2l-3.08.03a2 2 0 0 1-.7-.12L4.33 5.52A.5.5 0 0 1 4 5.05V3.1a.1.1 0 0 0-.18-.06L2.1 5.45a.5.5 0 0 0 .24.77Z"
]);
const $77e1bce0ac0f7fe7$export$242f1e18a0ce8f13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding20Filled', "20", [
    "m11.88 6-1.03-2.15C10.16 2.41 8 2.91 8 4.5v.74l2.77.76h1.11Zm-1.11 1a1 1 0 0 1-.27-.04L6 5.74V4.2c0-1.22-1.61-1.66-2.23-.6L2.24 6.19c-.57.96-.1 2.2.96 2.55l3.42 1.12-1.68 1.52c-1.17 1.08-.08 3 1.45 2.55l6.6-1.99 3.04 1A1.5 1.5 0 0 0 18 11.5V11a4 4 0 0 0-4-4h-3.23ZM2 17.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$9881a4a5f19da6ec = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding20Regular', "20", [
    "m12.36 7-1.5-3.15C10.15 2.41 8 2.91 8 4.5v1.78l-2-.54V4.2c0-1.22-1.61-1.66-2.23-.6L2.24 6.19c-.57.96-.1 2.2.96 2.55l3.42 1.12-1.68 1.52c-1.17 1.08-.08 3 1.45 2.55l6.6-1.99 3.04 1A1.5 1.5 0 0 0 18 11.5V11a4 4 0 0 0-4-4h-1.64Zm-1.1 0h-.5a1 1 0 0 1-.26-.04L9 6.56V4.5c0-.53.72-.7.95-.21L11.25 7ZM2 17.5c0-.28.22-.5.5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Zm11.59-6.41a2 2 0 0 0-1.18-.01L6.1 12.97c-.51.15-.87-.49-.48-.85l1.67-1.53a1 1 0 0 0-.36-1.68L3.52 7.79a.75.75 0 0 1-.42-1.1L4.63 4.1c.1-.17.37-.1.37.1v1.92c0 .22.15.42.37.48l4.87 1.33a2 2 0 0 0 .53.07H14a3 3 0 0 1 3 3v.51a.5.5 0 0 1-.66.48l-2.39-.79-.36-.11Z"
]);
const $77e1bce0ac0f7fe7$export$8d21cfce2d47e3cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding24Filled', "24", [
    "M10 5.04v.78l3.03 1.2h2.12l-1.25-2.8C13 2.2 10 2.83 10 5.03Zm2.72 2.93L8.5 6.3V4.76a1.75 1.75 0 0 0-3.21-.96L3.38 6.7a2.3 2.3 0 0 0 1.04 3.4l3.5 1.46-2.05 1.9c-1.62 1.5 0 4.16 2.09 3.4l6.76-2.46 3.46 1.44A2.04 2.04 0 0 0 21 13.96v-1.23c0-2.6-2.11-4.71-4.72-4.71h-3.32a.64.64 0 0 1-.24-.05ZM3 20.25c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$adc7ff18f14d0d70 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneLanding24Regular', "24", [
    "M11.5 7.49V5.04c0-.58.79-.75 1.03-.22l1.42 3.2h-1a.64.64 0 0 1-.23-.05L11.5 7.5Zm4.1.53-1.7-3.8C13 2.2 10 2.83 10 5.03v1.85l-1.5-.6V4.77a1.75 1.75 0 0 0-3.21-.96L3.38 6.7a2.3 2.3 0 0 0 1.04 3.4l3.5 1.46-2.05 1.9c-1.62 1.5 0 4.16 2.09 3.4l6.76-2.46 3.46 1.44A2.04 2.04 0 0 0 21 13.96v-1.23c0-2.6-2.11-4.71-4.72-4.71h-.69ZM7 6.95c0 .22.13.42.34.5l4.83 1.92c.25.1.52.15.79.15h3.32a3.22 3.22 0 0 1 3.22 3.21v1.23c0 .39-.39.65-.74.5l-3.64-1.52a1 1 0 0 0-.73-.02l-6.95 2.53c-.55.2-.97-.5-.55-.9l2.62-2.42a1 1 0 0 0-.3-1.66L5 8.71a.8.8 0 0 1-.36-1.18l1.91-2.91c.14-.2.46-.11.46.14v2.2Zm-4 13.3c0-.41.34-.75.75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$6f74e1eee6d2cd4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff16Filled', "16", [
    "M8.6 3.74c-.12.14-.21.28-.3.41-.28.43-.66.74-1.1.86l-3.43.9-.6-1.25C2.64 3.57 1 3.95 1 5.16V8c0 1.16 1.1 2 2.22 1.68l3.11-.87-.31 1.4c-.36 1.61 1.76 2.54 2.7 1.19l3.1-4.48 2.23-.82.15-.07c.62-.3.98-1.03.71-1.7V4.3c-.04-.1-.1-.2-.16-.29L14.72 4a7.22 7.22 0 0 0-.22-.29c-.63-.77-1.65-1.7-3-1.7-.2 0-.38.02-.57.06-.54.11-1.02.39-1.41.7-.36.3-.66.64-.91.96l-.02.02Zm-4.16.96-.1-.13a1.6 1.6 0 0 1 2.17-2.29l1.27.87-.31.45c-.19.28-.39.4-.52.44l-2.5.66ZM1.5 14a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z"
]);
const $77e1bce0ac0f7fe7$export$2a51ff9be2a62983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff16Regular', "16", [
    "m5.1 5.56-.76-.99a1.6 1.6 0 0 1 2.17-2.29l2.1 1.44c.25-.32.55-.66.9-.95.53-.43 1.2-.77 2-.77 1.54.01 2.65 1.21 3.24 2.02.57.8.11 1.78-.7 2.08l-2.23.82-3.1 4.48c-.94 1.35-3.06.42-2.7-1.18l.31-1.41-3.1.87A1.75 1.75 0 0 1 1 8V5.16c0-1.21 1.64-1.59 2.17-.5l.6 1.25 1.34-.35Zm.03-1.6 1.03 1.32 1.04-.27c.3-.08.57-.25.8-.5l-2.06-1.4a.6.6 0 0 0-.8.85Zm4 .74a2.96 2.96 0 0 1-1.67 1.28l-3.83 1a.5.5 0 0 1-.58-.26L2.27 5.1c-.03-.05-.05-.06-.07-.07a.15.15 0 0 0-.1 0 .15.15 0 0 0-.07.04c-.01.01-.03.04-.03.09V8c0 .5.47.86.95.72l3.1-.87a1 1 0 0 1 1.26 1.18l-.32 1.4c-.12.54.59.85.9.4l3.2-4.61a.5.5 0 0 1 .24-.19l2.38-.87a.44.44 0 0 0 .27-.26.3.3 0 0 0-.05-.3C13.37 3.84 12.52 3 11.5 3c-.49 0-.94.2-1.35.54A5.2 5.2 0 0 0 9.14 4.7ZM1.5 14a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z"
]);
const $77e1bce0ac0f7fe7$export$6401bcd14635661a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff20Filled', "20", [
    "m11.68 5.16-.38.33c-.23.21-.48.38-.74.46L4.76 7.9l-.6-1.23a1.19 1.19 0 0 0-.24-.34c-.62-.6-1.74-.27-1.9.62L2 7.16v2.99c0 1.2 1.18 2.04 2.32 1.65l3.02-1.04-.3 1.46c-.3 1.56 1.7 2.47 2.66 1.21l3.1-4 4.18-1.35c.84-.27 1.33-1.28.74-2.1-.52-.7-1.43-1.68-2.67-1.92a2.98 2.98 0 0 0-.88-.04 4.9 4.9 0 0 0-2.5 1.14Zm-2.57.22L5.38 6.62l-.04-.05a1.6 1.6 0 0 1 2.17-2.29l1.6 1.1ZM2.5 17a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"
]);
const $77e1bce0ac0f7fe7$export$82d027adfc45eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff20Regular', "20", [
    "M14.5 4c-1.41-.01-2.63.96-3.2 1.49-.23.21-.48.38-.74.46l-.41.14L7.5 4.28a1.6 1.6 0 0 0-2.17 2.3l.7.88-1.28.43-.6-1.23C3.65 5.57 2 5.95 2 7.16v2.99c0 1.2 1.18 2.04 2.32 1.65l3.02-1.04-.3 1.46c-.3 1.56 1.7 2.47 2.66 1.21l3.1-4 4.18-1.35c.84-.27 1.33-1.28.74-2.1-.6-.8-1.7-1.97-3.22-1.98ZM7.04 7.13l-.9-1.17a.6.6 0 0 1 .8-.86L8.96 6.5l-1.92.64Zm4.94-.91c.55-.51 1.51-1.23 2.52-1.22 1 0 1.85.8 2.41 1.58.07.1.08.2.04.3-.04.1-.13.2-.28.25l-4.32 1.4a.5.5 0 0 0-.25.16l-3.19 4.13c-.32.42-.99.12-.88-.4l.29-1.47a1 1 0 0 0-1.3-1.14l-3.03 1.04c-.48.17-.99-.19-.99-.7V7.16c0-.05.02-.08.03-.1a.15.15 0 0 1 .08-.04l.1.01.06.07.78 1.62c.1.22.37.33.6.25l6.23-2.07c.43-.14.8-.4 1.1-.68ZM2.5 17a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z"
]);
const $77e1bce0ac0f7fe7$export$77d29957c6457afc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff24Filled', "24", [
    "m10.52 4.41 1.87 1.52-.5.56c-.12.15-.23.2-.29.21l-3.46.72-.38-.68a1.84 1.84 0 0 1 2.76-2.33Zm6.17.1c2.24-.18 3.91 1.24 4.86 2.32.49.56.58 1.27.37 1.88-.2.6-.69 1.1-1.34 1.32l-5.37 1.85-3.23 4.32a2 2 0 0 1-3.46-1.97l.5-1.23-3.3.63A2.3 2.3 0 0 1 3 11.38V7.7a1.7 1.7 0 0 1 3.18-.8l.96 1.76 4.67-.97c.3-.06.61-.26.85-.55.38-.45.93-1.05 1.6-1.57A4.7 4.7 0 0 1 16.7 4.5ZM3.75 19.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"
]);
const $77e1bce0ac0f7fe7$export$7dac991cf5af2ce8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('AirplaneTakeOff24Regular', "24", [
    "m8.32 8.4-.78-1.12a2.1 2.1 0 0 1 3.05-2.81l2.58 2.09c.31-.33.68-.68 1.1-1a4.7 4.7 0 0 1 2.42-1.06c2.24-.17 3.91 1.25 4.86 2.33.49.56.58 1.27.37 1.88-.2.6-.69 1.1-1.34 1.32l-5.37 1.85-3.16 4.22a2.25 2.25 0 0 1-4-1.78l.25-1.28-2.53.54A2.28 2.28 0 0 1 3 11.35V7.7a1.7 1.7 0 0 1 3.18-.8l.96 1.76 1.18-.24Zm.46-1.97 1.13 1.65 1.9-.4c.09-.02.17-.05.26-.09L9.65 5.63a.6.6 0 0 0-.87.8ZM16.81 6c-.5.04-1.07.32-1.63.75-.55.42-1.03.94-1.36 1.34-.42.5-1 .91-1.7 1.06L6.9 10.23a.75.75 0 0 1-.8-.37L4.85 7.6a.2.2 0 0 0-.36.1v3.65c0 .5.46.87.95.77l3.64-.79a.75.75 0 0 1 .9.88l-.47 2.4a.75.75 0 0 0 1.33.6l3.3-4.41a.75.75 0 0 1 .36-.26l5.58-1.93a.64.64 0 0 0 .41-.38.4.4 0 0 0-.08-.41c-.86-.98-2.1-1.94-3.61-1.82ZM3.75 19.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"
]);
const $77e1bce0ac0f7fe7$export$d42ee41964b71e72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel16Filled', "16", [
    "M2.5 4.55a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm0-1c-.11 0-.22.01-.32.03A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5V7.49a2 2 0 1 0 .5-3.94Zm3 2.95c0 .28.22.5.5.5h4a.5.5 0 1 0 0-1H6a.5.5 0 0 0-.5.5Zm0 3c0 .28.22.5.5.5h2.61a.5.5 0 0 0 0-1H6a.5.5 0 0 0-.5.5Z"
]);
const $77e1bce0ac0f7fe7$export$6e5569d28240ed9b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel16Regular', "16", [
    "M2.5 6.55a1 1 0 0 1-1-1 1 1 0 1 1 1 1Zm-.32-2.97a2.01 2.01 0 0 1 1.06.11C3.5 3.28 3.97 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5V7.49a2 2 0 0 1-1 0v4.01A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7a2.5 2.5 0 0 0-2.32 1.58ZM6 6a.5.5 0 0 0 0 1h4a.5.5 0 1 0 0-1H6Zm0 3a.5.5 0 0 0 0 1h2.61a.5.5 0 0 0 0-1H6Z"
]);
const $77e1bce0ac0f7fe7$export$c0983e5f2d26dcb0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-9ZM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Zm-4-5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1Z"
]);
const $77e1bce0ac0f7fe7$export$71460282f7886f05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel20Regular', "20", [
    "M3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm0-1c-.1 0-.2 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15Zm3.5 4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
]);
const $77e1bce0ac0f7fe7$export$74340571970d3728 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel24Filled', "24", [
    "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.45 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.25 3h11.5Zm-4.5 10h-4.5l-.1.01a.75.75 0 0 0 0 1.49H13.35a.75.75 0 0 0-.1-1.5Zm2-3.5h-6.6a.75.75 0 0 0 0 1.49H15.35a.75.75 0 0 0-.1-1.5ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$44956a5baf399d06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel24Regular', "24", [
    "M17.75 3A3.25 3.25 0 0 1 21 6.07v11.68a3.25 3.25 0 0 1-3.07 3.24l-.18.01H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 0 0 1.5 0v8.38c0 .92.7 1.67 1.6 1.74l.15.01h11.5c.92 0 1.67-.7 1.74-1.6l.01-.15V6.25c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.23 2.23 0 0 0-1.59-.2 3.25 3.25 0 0 1 2.85-2.05L6.25 3h11.5Zm-4.5 10a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.49h4.6Zm2-3.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$403873410304dd9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17Zm.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h13.5C23.1 25 25 23.1 25 20.75V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06ZM9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM9 15.75c0-.41.34-.75.75-.75h5.75a.75.75 0 0 1 0 1.5H9.75a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$211b0e8f85249a50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel28Regular', "28", [
    "M2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Zm1 2.65v9.35C3 23.1 4.9 25 7.25 25h13.5C23.1 25 25 23.1 25 20.75V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06 2.76 2.76 0 0 1 1.55.12A2.75 2.75 0 0 1 7.25 4.5h13.5a2.75 2.75 0 0 1 2.75 2.75v13.5a2.75 2.75 0 0 1-2.75 2.75H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a2.75 2.75 0 0 1-1.5 0Zm6.75-.4a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM9 15.75c0-.41.34-.75.75-.75h5.75a.75.75 0 0 1 0 1.5H9.75a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$f9ae3ca816f112e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel48Filled', "48", [
    "M6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4Zm.19-1.78A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6h-23.5c-2.92 0-5.38 2-6.06 4.72ZM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25ZM17.25 26h9.5a1.25 1.25 0 1 1 0 2.5h-9.5a1.25 1.25 0 1 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$552e62bde3258cf5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Channel48Regular', "48", [
    "M6.19 10.72A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 0 1 6 35.75V18.21a3.99 3.99 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75h23.5a3.75 3.75 0 0 0 3.75-3.75v-23.5a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-2.63 0ZM6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4ZM17.25 19a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5h-13.5ZM16 27.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25Z"
]);
const $77e1bce0ac0f7fe7$export$733c3c5f96e6a029 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd16Filled', "16", [
    "M1.63 2.29A1.76 1.76 0 0 1 3.75 4 1.75 1.75 0 0 1 1.5 5.68V8c0 1.1.9 2 2 2h1.52c.26-2.8 2.61-5 5.48-5V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29ZM4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 7a.5.5 0 0 1 0-1H6a.5.5 0 0 1 0 1H4.5ZM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V10H8.5a.5.5 0 0 0 0 1H10v1.5a.5.5 0 0 0 1 0V11h1.5a.5.5 0 0 0 0-1H11V8.5Z"
]);
const $77e1bce0ac0f7fe7$export$f6c5d78152012133 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd16Regular', "16", [
    "M2 2.25c-.13 0-.25.01-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2c-.34 0-.68.03-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4c-.21-.1-.45-.15-.7-.15ZM5.2 9H3.5a1 1 0 0 1-1-1V5.68a1.75 1.75 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52c.03-.34.1-.68.19-1ZM4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H4.5ZM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V10H8.5a.5.5 0 0 0 0 1H10v1.5a.5.5 0 0 0 1 0V11h1.5a.5.5 0 0 0 0-1H11V8.5Z"
]);
const $77e1bce0ac0f7fe7$export$55fd27dfeabec24a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.48 5.48 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.49 5.49 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3h-9ZM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$189d17f296beccc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd20Regular', "20", [
    "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15ZM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h3.7Zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 0 0 0 1h2.1ZM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$1de557b68f0e5974 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd24Filled', "24", [
    "M17.75 3C19.55 3 21 4.46 21 6.25v5.77a6.47 6.47 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.47 6.47 0 0 0 .3 6.5H6.24A3.25 3.25 0 0 1 3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.25 3h11.5Zm-2.5 6.5h-6.6a.75.75 0 0 0 0 1.49H15.35a.75.75 0 0 0-.1-1.5ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
]);
const $77e1bce0ac0f7fe7$export$24a9f54ea72a1266 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd24Regular', "24", [
    "M17.75 3A3.25 3.25 0 0 1 21 6.07V12.02c-.46-.3-.97-.53-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.23 2.23 0 0 0-1.59-.2 3.25 3.25 0 0 1 2.85-2.05L6.25 3h11.5Zm-6.44 16.5c.18.53.42 1.04.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 0 0 1.5 0v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06Zm.42-5c.29-.55.65-1.05 1.08-1.5H8.75l-.1.01a.75.75 0 0 0 .1 1.5h2.98Zm3.52-5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM23 17.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-5 .5v2.5a.5.5 0 1 1-1 0V18h-2.5a.5.5 0 0 1 0-1H17v-2.5a.5.5 0 1 1 1 0V17h2.5a.5.5 0 0 1 0 1H18Z"
]);
const $77e1bce0ac0f7fe7$export$e299b7eb5c7cb1b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd28Filled', "28", [
    "M3.17 6.06A2.76 2.76 0 0 1 6.5 8.75 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.47 7.47 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.47 7.47 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06ZM9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$379be5864c6bdc5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.49 7.49 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a2.75 2.75 0 0 1-1.5 0Zm22-4.15v7.25a7.49 7.49 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.74 2.74 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25ZM9.75 15h5.65c-.48.44-.9.95-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5ZM2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$57c1d4cd082afdfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.94 12.94 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6h-23.5ZM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
]);
const $77e1bce0ac0f7fe7$export$893c0dc6ec4f8477 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAdd48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8c-.78-.5-1.62-.92-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22Zm15.3 29c.33.88.74 1.72 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a3.99 3.99 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75H22.8Zm.94-11c.52-.9 1.16-1.75 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5h6.49ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12Zm9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5h-13.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-10-7a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
]);
const $77e1bce0ac0f7fe7$export$c024757c5230182c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert16Filled', "16", [
    "M1.63 2.29A1.76 1.76 0 0 1 3.75 4 1.75 1.75 0 0 1 1.5 5.68V8c0 1.1.9 2 2 2h1.52c.26-2.8 2.61-5 5.48-5V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29ZM4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 7a.5.5 0 0 1 0-1H6a.5.5 0 0 1 0 1H4.5ZM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM12.5 9a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36V9Zm-3.41 4a1.5 1.5 0 0 0 2.82 0H9.1Z"
]);
const $77e1bce0ac0f7fe7$export$939b1435b5a46d05 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert16Regular', "16", [
    "M2 2.25c-.13 0-.25.01-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2c-.34 0-.68.03-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4c-.21-.1-.45-.15-.7-.15ZM5.2 9H3.5a1 1 0 0 1-1-1V5.68a1.75 1.75 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52c.03-.34.1-.68.19-1ZM4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H4.5ZM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM12.5 9a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36V9Zm-3.41 4a1.5 1.5 0 0 0 2.82 0H9.1Z"
]);
const $77e1bce0ac0f7fe7$export$4f6dfa4cafa2d708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.48 5.48 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.49 5.49 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3h-9ZM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM16.5 13a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36V13Zm-3.41 4a1.5 1.5 0 0 0 2.82 0H13.1Z"
]);
const $77e1bce0ac0f7fe7$export$702842529f3e13b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert20Regular', "20", [
    "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15ZM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h3.7Zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 0 0 0 1h2.1ZM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM16.5 13a2 2 0 1 0-4 0v1.8l-.35.35a.5.5 0 0 0 .35.85h4a.5.5 0 0 0 .35-.85l-.35-.36V13Zm-3.41 4a1.5 1.5 0 0 0 2.82 0H13.1Z"
]);
const $77e1bce0ac0f7fe7$export$d9aea319a24d5973 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm.25-9A3.25 3.25 0 0 1 21 6.07V12.02a6.47 6.47 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.47 6.47 0 0 0 .3 6.5H6.24a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.05 3l.2-.01h11.5Zm.75 17h-2v.12a1 1 0 0 0 2-.12Zm-1-6h-.16c-.94.1-1.67.77-1.81 1.64l-.02.16v1.5l-.86.85a.5.5 0 0 0 .26.84L15 19h5a.5.5 0 0 0 .41-.79l-.06-.06-.85-.85v-1.5a1.98 1.98 0 0 0-2-1.8Zm-2.25-4.5h-6.6a.75.75 0 0 0 0 1.49H15.35a.75.75 0 0 0-.1-1.5ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$e6e42f6c7dc663e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-13-2.63v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06c.18.53.42 1.04.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 0 0 1.5 0ZM18.5 20h-2v.12a1 1 0 0 0 2-.12Zm-1-6h-.16c-.94.1-1.67.77-1.81 1.64l-.02.16v1.5l-.86.85a.5.5 0 0 0 .26.84L15 19h5a.5.5 0 0 0 .41-.79l-.06-.06-.85-.85v-1.5a1.98 1.98 0 0 0-2-1.8Zm-4.7-1c-.42.45-.78.95-1.07 1.5H8.75a.75.75 0 0 1-.1-1.49H12.8Zm4.95-10A3.25 3.25 0 0 1 21 6.07V12.02c-.46-.3-.97-.53-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.23 2.23 0 0 0-1.59-.2 3.25 3.25 0 0 1 2.85-2.05L6.25 3h11.5Zm-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$c31d7cbc8376a800 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17Zm.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.47 7.47 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.47 7.47 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06ZM9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM20.5 16a2.5 2.5 0 0 0-2.5 2.5v2.8l-.85.85a.5.5 0 0 0 .35.85h6a.5.5 0 0 0 .35-.85l-.85-.86V18.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.41 8a1.5 1.5 0 0 0 2.82 0H19.1Z"
]);
const $77e1bce0ac0f7fe7$export$5c30bbe81d47e221 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.49 7.49 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a2.75 2.75 0 0 1-1.5 0Zm22-4.15v7.25a7.49 7.49 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.74 2.74 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25ZM9.75 15h5.65c-.48.44-.9.95-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5ZM2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM20.5 16a2.5 2.5 0 0 0-2.5 2.5v2.8l-.85.85a.5.5 0 0 0 .35.85h6a.5.5 0 0 0 .35-.85l-.85-.86V18.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.41 8a1.5 1.5 0 0 0 2.82 0H19.1Z"
]);
const $77e1bce0ac0f7fe7$export$f135093870bd201e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.94 12.94 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6h-23.5ZM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-11-7a5 5 0 0 0-5 5v3.38l-.95 1.9a.5.5 0 0 0 .45.72h11a.5.5 0 0 0 .45-.72l-.95-1.9V33a5 5 0 0 0-5-5Zm-2 12a2 2 0 1 0 4 0h-4Z"
]);
const $77e1bce0ac0f7fe7$export$94703628afc41381 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelAlert48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8c-.78-.5-1.62-.92-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22Zm15.3 29c.33.88.74 1.72 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a3.99 3.99 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75H22.8Zm.94-11c.52-.9 1.16-1.75 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5h6.49ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12Zm9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5h-13.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-11-7a5 5 0 0 0-5 5v3.38l-.95 1.9a.5.5 0 0 0 .45.72h11a.5.5 0 0 0 .45-.72l-.95-1.9V33a5 5 0 0 0-5-5Zm-2 12a2 2 0 1 0 4 0h-4Z"
]);
const $77e1bce0ac0f7fe7$export$e56dfc0f1a998a4b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft16Filled', "16", [
    "M2 2.25c-.13 0-.25.01-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2a5.5 5.5 0 0 0-5.48 5H3.5a2 2 0 0 1-2-2V5.68A1.75 1.75 0 1 0 2 2.25ZM4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM4 6.5c0 .28.22.5.5.5H6a.5.5 0 0 0 0-1H4.5a.5.5 0 0 0-.5.5ZM2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm13 5.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L9.71 11h2.79a.5.5 0 0 0 0-1H9.7l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$63ce371805d4be56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft16Regular', "16", [
    "M2 2.25c-.13 0-.25.01-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2c-.34 0-.68.03-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4c-.21-.1-.45-.15-.7-.15ZM5.2 9H3.5a1 1 0 0 1-1-1V5.68a1.75 1.75 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52c.03-.34.1-.68.19-1Zm-.7-5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 2a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H4.5ZM2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm13 5.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L9.71 11h2.79a.5.5 0 0 0 0-1H9.7l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$b50af028b4af267e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.48 5.48 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.49 5.49 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3h-9ZM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$1a6e5b427f3ac52e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft20Regular', "20", [
    "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15ZM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h3.7Zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 0 0 0 1h2.1ZM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$502fca0a9458544e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm.25-9A3.25 3.25 0 0 1 21 6.07V12.02a6.47 6.47 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.47 6.47 0 0 0 .3 6.5H6.24a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.05 3l.2-.01h11.5Zm-1.03 11.59-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .77-.63l-.06-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06Zm-1.47-5.1h-6.5l-.1.01a.75.75 0 0 0 0 1.49H15.35a.75.75 0 0 0-.1-1.5ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$f0ee41e3b354b653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-13-2.63v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06c.18.53.42 1.04.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 0 0 1.5 0Zm12.22 5.22-.07.06-2.52 2.51-.04.05-.04.08-.02.06-.02.08v.11l.01.09.03.08.03.06.05.07 2.52 2.51a.5.5 0 0 0 .77-.63l-.06-.07L15.7 18h4.79a.5.5 0 0 0 .5-.41v-.09a.5.5 0 0 0-.41-.5h-4.88l1.65-1.65a.5.5 0 0 0 .05-.63l-.05-.07a.5.5 0 0 0-.64-.06ZM12.8 13c-.43.45-.8.95-1.08 1.5H8.75a.75.75 0 0 1-.1-1.49H12.8Zm4.94-10A3.25 3.25 0 0 1 21 6.07V12.02c-.46-.3-.97-.53-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.23 2.23 0 0 0-1.59-.2 3.25 3.25 0 0 1 2.85-2.05L6.25 3h11.5Zm-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$a6f3b51676874ba8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17Zm.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.47 7.47 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.47 7.47 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06ZM9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-2.5.5a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35c0 .13.05.26.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 21h6.79Z"
]);
const $77e1bce0ac0f7fe7$export$25f2eab997fa03a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.49 7.49 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a2.75 2.75 0 0 1-1.5 0Zm22-4.15v7.25a7.49 7.49 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.74 2.74 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25ZM9.75 15h5.65c-.48.44-.9.95-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5ZM2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-2.5.5a.5.5 0 0 0 0-1h-6.8l2.15-2.15a.5.5 0 0 0-.7-.7l-3 3a.5.5 0 0 0-.15.35c0 .13.05.26.15.35l3 3a.5.5 0 0 0 .7-.7L17.71 21h6.79Z"
]);
const $77e1bce0ac0f7fe7$export$c2f47d6e02002fca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.94 12.94 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6h-23.5ZM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-12.3-5.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.4-1.4L30.42 36H42a1 1 0 1 0 0-2H30.41l3.3-3.3a1 1 0 0 0 0-1.4Z"
]);
const $77e1bce0ac0f7fe7$export$f8e54cdfcb4d27e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelArrowLeft48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8c-.78-.5-1.62-.92-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22Zm15.3 29c.33.88.74 1.72 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a3.99 3.99 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75H22.8Zm.94-11c.52-.9 1.16-1.75 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5h6.49ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12Zm9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5h-13.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-12.3-5.7a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.4-1.4L30.42 36H42a1 1 0 1 0 0-2H30.41l3.3-3.3a1 1 0 0 0 0-1.4Z"
]);
const $77e1bce0ac0f7fe7$export$ad92a4bb1b35d726 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss16Filled', "16", [
    "M1.63 2.29A1.76 1.76 0 0 1 3.75 4 1.75 1.75 0 0 1 1.5 5.68V8c0 1.1.9 2 2 2h1.52c.26-2.8 2.61-5 5.48-5V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29ZM4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 7a.5.5 0 0 1 0-1H6a.5.5 0 0 1 0 1H4.5ZM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7L10.5 9.79 9.35 8.65a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $77e1bce0ac0f7fe7$export$5f93b17c8e6790a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss16Regular', "16", [
    "M2 2.25c-.13 0-.25.01-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2c-.34 0-.68.03-1 .1V3a1 1 0 0 0-1-1h-5a1 1 0 0 0-.8.4c-.21-.1-.45-.15-.7-.15ZM5.2 9H3.5a1 1 0 0 1-1-1V5.68a1.75 1.75 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52c.03-.34.1-.68.19-1ZM4 4.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 6a.5.5 0 0 0 0 1H6a.5.5 0 0 0 0-1H4.5ZM2.75 4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7L10.5 9.79 9.35 8.65a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15Z"
]);
const $77e1bce0ac0f7fe7$export$67c874acb6d7c193 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss20Filled', "20", [
    "M5.5 3a2.5 2.5 0 0 0-2.3 1.52l.3-.02A2 2 0 1 1 3 8.44v6.06A2.5 2.5 0 0 0 5.5 17h4.1a5.48 5.48 0 0 1 0-5H7.5a.5.5 0 0 1 0-1h2.76A5.49 5.49 0 0 1 17 9.6V5.5A2.5 2.5 0 0 0 14.5 3h-9ZM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3.5-3a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm15.5 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $77e1bce0ac0f7fe7$export$fb93dc783725c5a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss20Regular', "20", [
    "M3.5 4.5c-.1 0-.2 0-.3.02A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1c-.32-.16-.65-.3-1-.4V5.5c0-.83-.67-1.5-1.5-1.5h-9c-.51 0-.97.26-1.24.65a2 2 0 0 0-.76-.15ZM9.2 16c.1.35.24.68.4 1H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 0 0 1 0v6.06c0 .83.67 1.5 1.5 1.5h3.7Zm.4-4c.18-.36.4-.7.66-1H7.5a.5.5 0 0 0 0 1h2.1ZM3.5 5.5a1 1 0 0 0-1 1 1 1 0 1 0 1-1Zm4 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
]);
const $77e1bce0ac0f7fe7$export$5e5114a0730a64a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss24Filled', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm.25-9A3.25 3.25 0 0 1 21 6.07V12.02a6.47 6.47 0 0 0-8.2.98H8.76l-.1.01a.75.75 0 0 0 0 1.49h3.08a6.47 6.47 0 0 0 .3 6.5H6.24a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 1 0 .22-4.3A3.25 3.25 0 0 1 6.05 3l.2-.01h11.5Zm-2.66 11.97-.07.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05l-.07.05Zm.16-5.47h-6.6a.75.75 0 0 0 0 1.49H15.35a.75.75 0 0 0-.1-1.5ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$35e5af0ff761c73d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss24Regular', "24", [
    "M17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-13-2.63v8.38c0 .92.7 1.67 1.6 1.74l.15.01h5.06c.18.53.42 1.04.71 1.5H6.25a3.25 3.25 0 0 1-3.24-3.07L3 17.75V9.37a2.25 2.25 0 0 0 1.5 0Zm10.6 5.6-.08.05-.05.07a.5.5 0 0 0 0 .57l.05.07 1.77 1.77-1.76 1.77-.06.07a.5.5 0 0 0 0 .57l.06.06.07.06c.17.12.4.12.56 0l.07-.06 1.77-1.76 1.77 1.77.07.05c.17.12.4.12.57 0l.07-.05.05-.07a.5.5 0 0 0 0-.57l-.05-.07-1.77-1.77 1.77-1.77.06-.07a.5.5 0 0 0 0-.57l-.06-.07-.07-.05a.5.5 0 0 0-.57 0l-.07.05-1.77 1.77-1.77-1.77-.07-.05a.5.5 0 0 0-.5-.05l-.07.05ZM12.8 13c-.42.45-.78.95-1.07 1.5H8.75a.75.75 0 0 1-.1-1.49H12.8Zm4.95-10A3.25 3.25 0 0 1 21 6.07V12.02c-.46-.3-.97-.53-1.5-.7V6.24c0-.92-.7-1.67-1.6-1.74l-.15-.01H6.25c-.6 0-1.13.3-1.44.76a2.23 2.23 0 0 0-1.59-.2 3.25 3.25 0 0 1 2.85-2.05L6.25 3h11.5Zm-2.5 6.5a.75.75 0 0 1 .1 1.49h-6.6a.75.75 0 0 1-.1-1.49h6.6ZM3.75 6a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$11c36fa44f28863f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss28Filled', "28", [
    "M3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17Zm.17-1.1A2.76 2.76 0 0 1 6.5 8.74 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.47 7.47 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.47 7.47 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06ZM9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64-2.65-2.64Z"
]);
const $77e1bce0ac0f7fe7$export$d531b2bc4fc8e006 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.49 7.49 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a2.75 2.75 0 0 1-1.5 0Zm22-4.15v7.25a7.49 7.49 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.74 2.74 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25ZM9.75 15h5.65c-.48.44-.9.95-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5ZM2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-9.15-3.35a.5.5 0 0 0-.7.7l2.64 2.65-2.64 2.65a.5.5 0 0 0 .7.7l2.65-2.64 2.65 2.64a.5.5 0 0 0 .7-.7l-2.64-2.65 2.64-2.65a.5.5 0 0 0-.7-.7l-2.65 2.64-2.65-2.64Z"
]);
const $77e1bce0ac0f7fe7$export$b9eccea65312cb21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss48Filled', "48", [
    "M12.25 6c-2.92 0-5.38 2-6.06 4.72A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.94 12.94 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6h-23.5ZM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35l4.3-4.3Z"
]);
const $77e1bce0ac0f7fe7$export$53f0a00506aeaf2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelDismiss48Regular', "48", [
    "M7.5 10.5a4 4 0 0 0-1.31.22A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8c-.78-.5-1.62-.92-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-1.32-.22Zm15.3 29c.33.88.74 1.72 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a3.99 3.99 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75H22.8Zm.94-11c.52-.9 1.16-1.75 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5h6.49ZM7.5 12A2.49 2.49 0 0 0 5 14.5 2.5 2.5 0 1 0 7.5 12Zm9.75 7a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5h-13.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-5.3-4.3a1 1 0 0 0-1.4-1.4L35 33.58l-4.3-4.3a1 1 0 0 0-1.4 1.42L33.58 35l-4.3 4.3a1 1 0 0 0 1.42 1.4L35 36.42l4.3 4.3a1 1 0 0 0 1.4-1.42L36.42 35l4.3-4.3Z"
]);
const $77e1bce0ac0f7fe7$export$84148c1c62fd5fa9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare12Filled', "12", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h3.09a1.5 1.5 0 1 0 0-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2H3Zm6 10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5.91a1.5 1.5 0 1 0 0 1H9a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1H4c0 1.1.9 2 2 2h3Z"
]);
const $77e1bce0ac0f7fe7$export$256296b50a7ab9ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare12Regular', "12", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h3.09a1.5 1.5 0 1 0 0-1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2H3Zm5 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM9 11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5.91a1.5 1.5 0 1 0 0 1H9a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1H4c0 1.1.9 2 2 2h3ZM4.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$3d7420d90aa58542 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare16Filled', "16", [
    "M1 3.5A2.5 2.5 0 0 1 3.5 1h4A2.5 2.5 0 0 1 10 3.5V4H9v-.5C9 2.67 8.33 2 7.5 2h-4C2.67 2 2 2.67 2 3.5v4C2 8.33 2.67 9 3.5 9h5.59a1.5 1.5 0 1 1 0 1H3.5A2.5 2.5 0 0 1 1 7.5v-4ZM6 11v.5A2.5 2.5 0 0 0 8.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 5H6.91a1.5 1.5 0 1 0 0 1h5.59c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 11.5V11H6Z"
]);
const $77e1bce0ac0f7fe7$export$7514e12fb4bbb007 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare16Regular', "16", [
    "M1 3.5A2.5 2.5 0 0 1 3.5 1h4A2.5 2.5 0 0 1 10 3.5V4H9v-.5C9 2.67 8.33 2 7.5 2h-4C2.67 2 2 2.67 2 3.5v4C2 8.33 2.67 9 3.5 9h5.59a1.5 1.5 0 1 1 0 1H3.5A2.5 2.5 0 0 1 1 7.5v-4Zm9 6a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0ZM6 11v.5A2.5 2.5 0 0 0 8.5 14h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 5H6.91a1.5 1.5 0 1 0 0 1h5.59c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 11.5V11H6Zm-.5-6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z"
]);
const $77e1bce0ac0f7fe7$export$a823618a44e808c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare20Filled', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5v-5ZM7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$193a77fc602f4731 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare20Regular', "20", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5v-5Zm8 6.75a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5Zm.25-7.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$f52e544f19eb0dc8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h6c1.8 0 3.25 1.46 3.25 3.25a.75.75 0 0 1-1.5 0c0-.97-.78-1.75-1.75-1.75h-6c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h5.85a2.75 2.75 0 1 1 0 1.5H6.25A3.25 3.25 0 0 1 3 12.25v-6ZM17.75 10c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-6c-.97 0-1.75-.78-1.75-1.75a.75.75 0 0 0-1.5 0c0 1.8 1.46 3.25 3.25 3.25h6c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25H11.9a2.75 2.75 0 1 0 0 1.5h5.85Z"
]);
const $77e1bce0ac0f7fe7$export$751cff4fccabcd0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h6c1.8 0 3.25 1.46 3.25 3.25a.75.75 0 0 1-1.5 0c0-.97-.78-1.75-1.75-1.75h-6c-.97 0-1.75.78-1.75 1.75v6c0 .97.78 1.75 1.75 1.75h5.85a2.75 2.75 0 1 1 0 1.5H6.25A3.25 3.25 0 0 1 3 12.25v-6Zm10.5 8.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM17.75 10c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75h-6c-.97 0-1.75-.78-1.75-1.75a.75.75 0 0 0-1.5 0c0 1.8 1.46 3.25 3.25 3.25h6c1.8 0 3.25-1.46 3.25-3.25v-6c0-1.8-1.46-3.25-3.25-3.25H11.9a2.75 2.75 0 1 0 0 1.5h5.85Zm-8.5-2a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$89254b03360c2ecf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare28Filled', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v7.5A3.75 3.75 0 0 0 6.75 18h7.42a3 3 0 1 0-.13-1.5H6.75c-1.24 0-2.25-1-2.25-2.25v-7.5c0-1.24 1-2.25 2.25-2.25h7.5c1.24 0 2.25 1 2.25 2.25v.5a.75.75 0 0 0 1.5 0v-.5A3.75 3.75 0 0 0 14.25 3h-7.5Zm7.08 7a3 3 0 1 0 .13 1.5h7.29c1.24 0 2.25 1 2.25 2.25v7.5c0 1.24-1 2.25-2.25 2.25h-7.5c-1.24 0-2.25-1-2.25-2.25v-.5a.75.75 0 0 0-1.5 0v.5A3.75 3.75 0 0 0 13.75 25h7.5A3.75 3.75 0 0 0 25 21.25v-7.5A3.75 3.75 0 0 0 21.25 10h-7.42Z"
]);
const $77e1bce0ac0f7fe7$export$a6c9ce4a6275b44d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare28Regular', "28", [
    "M6.75 3A3.75 3.75 0 0 0 3 6.75v7.5A3.75 3.75 0 0 0 6.75 18h7.42a3 3 0 1 0-.13-1.5H6.75c-1.24 0-2.25-1-2.25-2.25v-7.5c0-1.24 1-2.25 2.25-2.25h7.5c1.24 0 2.25 1 2.25 2.25v.5a.75.75 0 0 0 1.5 0v-.5A3.75 3.75 0 0 0 14.25 3h-7.5ZM17 15.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-3.04-4h7.29c1.24 0 2.25 1 2.25 2.25v7.5c0 1.24-1 2.25-2.25 2.25h-7.5c-1.24 0-2.25-1-2.25-2.25v-.5a.75.75 0 0 0-1.5 0v.5A3.75 3.75 0 0 0 13.75 25h7.5A3.75 3.75 0 0 0 25 21.25v-7.5A3.75 3.75 0 0 0 21.25 10h-7.42a3 3 0 1 0 .13 1.5ZM9.5 11a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
]);
const $77e1bce0ac0f7fe7$export$437e1d23384d0772 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare48Filled', "48", [
    "M12.47 6A6.48 6.48 0 0 0 6 12.47v12.05C6 28.1 8.9 31 12.47 31h11.74a5.5 5.5 0 1 0-.12-2.5H12.47a3.98 3.98 0 0 1-3.97-3.98V12.48c0-2.2 1.78-3.98 3.97-3.98h12.05c2.2 0 3.98 1.78 3.98 3.97v.28a1.25 1.25 0 1 0 2.5 0v-.28C31 8.9 28.1 6 24.52 6H12.48ZM17 35.75v-.5a1.25 1.25 0 1 1 2.5 0v.5a3.75 3.75 0 0 0 3.75 3.75h12.5a3.75 3.75 0 0 0 3.75-3.75v-12.5a3.75 3.75 0 0 0-3.75-3.75H23.91a5.5 5.5 0 1 1-.12-2.5h11.96C39.2 17 42 19.8 42 23.25v12.5C42 39.2 39.2 42 35.75 42h-12.5A6.25 6.25 0 0 1 17 35.75Z"
]);
const $77e1bce0ac0f7fe7$export$c55281a869842e39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelShare48Regular', "48", [
    "M12.47 6h12.05C28.1 6 31 8.9 31 12.47v.28a1.25 1.25 0 1 1-2.5 0v-.28c0-2.19-1.78-3.97-3.98-3.97H12.48a3.98 3.98 0 0 0-3.98 3.97v12.05c0 2.2 1.78 3.98 3.97 3.98H24.1a5.5 5.5 0 1 1 .12 2.5H12.47A6.48 6.48 0 0 1 6 24.52V12.48C6 8.9 8.9 6 12.47 6ZM26.5 29.5a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM17 35.75v-.5a1.25 1.25 0 1 1 2.5 0v.5a3.75 3.75 0 0 0 3.75 3.75h12.5a3.75 3.75 0 0 0 3.75-3.75v-12.5a3.75 3.75 0 0 0-3.75-3.75H23.91a5.5 5.5 0 1 1-.12-2.5h11.96C39.2 17 42 19.8 42 23.25v12.5C42 39.2 39.2 42 35.75 42h-12.5A6.25 6.25 0 0 1 17 35.75Zm1.5-20.25a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
]);
const $77e1bce0ac0f7fe7$export$d1270654f242439f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract16Filled', "16", [
    "M2 2.25c-.13 0-.25.01-.37.04A2 2 0 0 1 3.5 1h5a2 2 0 0 1 2 2v2a5.5 5.5 0 0 0-5.48 5H3.5a2 2 0 0 1-2-2V5.68A1.75 1.75 0 1 0 2 2.25ZM4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM4 6.5c0 .28.22.5.5.5H6a.5.5 0 0 0 0-1H4.5a.5.5 0 0 0-.5.5ZM2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$b703c742c6b48b88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract16Regular', "16", [
    "M1.63 2.29a1.76 1.76 0 0 1 1.07.1A1 1 0 0 1 3.5 2h5a1 1 0 0 1 1 1v2.1c.32-.07.66-.1 1-.1V3a2 2 0 0 0-2-2h-5a2 2 0 0 0-1.87 1.29ZM5.03 10c.02-.34.09-.68.18-1H3.5a1 1 0 0 1-1-1V5.68a1.75 1.75 0 0 1-1 0V8c0 1.1.9 2 2 2h1.52ZM4.5 4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM4 6.5c0-.28.22-.5.5-.5H6a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5ZM2 4.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$abf099ffac0be0e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract20Filled', "20", [
    "M3.2 4.52A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v4.1a5.48 5.48 0 0 0-6.74 1.4H7.5a.5.5 0 0 0 0 1h2.1a5.48 5.48 0 0 0 0 5H5.5A2.5 2.5 0 0 1 3 14.5V8.44a2 2 0 1 0 .2-3.92ZM7.5 8a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM3 5.63a1 1 0 1 1 1 1.73 1 1 0 0 1-1-1.73ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$bd7e700490fb9046 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract20Regular', "20", [
    "M3.2 4.52a2.02 2.02 0 0 1 1.06.13C4.53 4.25 5 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v3.7c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0 0 14.5 3h-9a2.5 2.5 0 0 0-2.3 1.52ZM9.6 17c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 0 1 4 14.5V8.44a2 2 0 0 1-1 0v6.06A2.5 2.5 0 0 0 5.5 17h4.1Zm0-5c.18-.36.4-.7.66-1H7.5a.5.5 0 0 0 0 1h2.1ZM3 5.63a1 1 0 0 1 1 0 1 1 0 1 1-1 0ZM7 8.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2-4h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$258fc83e0d952b93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract24Filled', "24", [
    "M21 6.25C21 4.45 19.55 3 17.75 3H6.25c-1.38 0-2.55.85-3.03 2.06A2.26 2.26 0 1 1 3 9.37v8.38C3 19.55 4.46 21 6.25 21h5.77a6.47 6.47 0 0 1-.29-6.5H8.65a.75.75 0 0 1 0-1.49H12.8a6.48 6.48 0 0 1 8.19-.99V6.25ZM8.75 9.5h6.5a.75.75 0 0 1 .1 1.49H8.65a.75.75 0 0 1 0-1.49h.1ZM5 7.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1h6Z"
]);
const $77e1bce0ac0f7fe7$export$6028bf9755b3ef92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract24Regular', "24", [
    "M21 6.07A3.25 3.25 0 0 0 17.75 3H6.07c-1.3.08-2.4.9-2.85 2.06a2.26 2.26 0 0 1 1.59.2c.31-.46.84-.76 1.44-.76h11.64c.9.08 1.61.83 1.61 1.75v5.06c.53.18 1.04.42 1.5.71V6.07ZM12.02 21c-.3-.46-.53-.97-.7-1.5H6.1c-.9-.08-1.61-.83-1.61-1.75V9.37a2.25 2.25 0 0 1-1.5 0v8.56A3.25 3.25 0 0 0 6.26 21h5.77Zm-.29-6.5c.29-.55.65-1.05 1.08-1.5H8.75l-.1.01a.75.75 0 0 0 .1 1.5h2.98ZM16 10.25a.75.75 0 0 0-.75-.75h-6.6a.75.75 0 0 0 .1 1.5h6.5l.1-.01a.75.75 0 0 0 .65-.74Zm-11-3a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm3 6a.5.5 0 0 0 0-1h-6a.5.5 0 0 0 0 1h6Z"
]);
const $77e1bce0ac0f7fe7$export$ce5081758e0547f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract28Filled', "28", [
    "M3.17 6.06A2.76 2.76 0 0 1 6.5 8.75 2.75 2.75 0 0 1 3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.47 7.47 0 0 1-.35-8.5h-4.4a.75.75 0 0 1 0-1.5h5.65a7.47 7.47 0 0 1 9.6-.5V7.25C25 4.9 23.1 3 20.75 3H7.25a4.25 4.25 0 0 0-4.08 3.06ZM9.75 11h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5ZM3 7.17a1.75 1.75 0 1 0 1.5 3.16A1.75 1.75 0 0 0 3 7.17ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-2 0a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$f4a5de840b9ba748 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract28Regular', "28", [
    "M3 11.4v9.35C3 23.1 4.9 25 7.25 25h7.25a7.49 7.49 0 0 1-.88-1.5H7.25a2.75 2.75 0 0 1-2.75-2.75V11.4a2.75 2.75 0 0 1-1.5 0Zm22-4.15v7.25a7.49 7.49 0 0 0-1.5-.88V7.25a2.75 2.75 0 0 0-2.75-2.75H7.25c-1.14 0-2.11.7-2.53 1.68a2.74 2.74 0 0 0-1.55-.12A4.25 4.25 0 0 1 7.25 3h13.5C23.1 3 25 4.9 25 7.25ZM9.75 15h5.65c-.48.44-.9.95-1.25 1.5h-4.4a.75.75 0 0 1 0-1.5ZM2 8.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0ZM9.75 11a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-2 0a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 .5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$2e545ec56c2ab699 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract48Filled', "48", [
    "M6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4Zm.19-1.78A4 4 0 1 1 6 18.21v17.54C6 39.2 8.8 42 12.25 42h11.8a12.94 12.94 0 0 1-.31-13.5h-6.49a1.25 1.25 0 1 1 0-2.5h8.37A12.96 12.96 0 0 1 42 24.04V12.25C42 8.8 39.2 6 35.75 6h-23.5c-2.92 0-5.38 2-6.06 4.72ZM16 20.25c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-3 0a1 1 0 0 0-1-1H28a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1Z"
]);
const $77e1bce0ac0f7fe7$export$839094f48451d017 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChannelSubtract48Regular', "48", [
    "M6.19 10.72A6.25 6.25 0 0 1 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8c-.78-.5-1.62-.92-2.5-1.25V12.25a3.75 3.75 0 0 0-3.75-3.75h-23.5c-1.53 0-2.84.91-3.43 2.22a4 4 0 0 0-2.63 0ZM22.8 39.5c.33.88.74 1.72 1.24 2.5H12.25A6.25 6.25 0 0 1 6 35.75V18.21a3.99 3.99 0 0 0 2.5.16v17.38a3.75 3.75 0 0 0 3.75 3.75H22.8Zm.94-11c.52-.9 1.16-1.75 1.88-2.5h-8.37a1.25 1.25 0 1 0 0 2.5h6.49ZM6 12.5a2.5 2.5 0 1 0 3 4 2.5 2.5 0 0 0-3-4ZM17.25 19a1.25 1.25 0 1 0 0 2.5h13.5a1.25 1.25 0 1 0 0-2.5h-13.5ZM46 35a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-3 0a1 1 0 0 0-1-1H28a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1Z"
]);
const $77e1bce0ac0f7fe7$export$7f2d9d7735b9fdfd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple16Color', "16", `<path d="M5.46 2.1c.29-.06.54.18.54.47V7a1 1 0 0 0 1 1h4.43c.3 0 .53.25.47.54A5.5 5.5 0 1 1 5.46 2.1Z" fill="url(#ic_fluent_chart_multiple_16_color__a)"/><path d="M5.46 2.1c.29-.06.54.18.54.47V7a1 1 0 0 0 1 1h4.43c.3 0 .53.25.47.54A5.5 5.5 0 1 1 5.46 2.1Z" fill="url(#ic_fluent_chart_multiple_16_color__b)" fill-opacity=".4"/><path d="M5.46 2.1c.29-.06.54.18.54.47V7a1 1 0 0 0 1 1h4.43c.3 0 .53.25.47.54A5.5 5.5 0 1 1 5.46 2.1Z" fill="url(#ic_fluent_chart_multiple_16_color__c)" fill-opacity=".4"/><path d="M13 6.57C13 3.49 10.5 1 7.43 1c-.24 0-.43.2-.43.45V6.5c0 .28.22.5.5.5h5.06c.24 0 .44-.19.44-.43Z" fill="url(#ic_fluent_chart_multiple_16_color__d)"/><path d="M13 7a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0V7Z" fill="url(#ic_fluent_chart_multiple_16_color__e)"/><path d="M10 9a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V9Z" fill="url(#ic_fluent_chart_multiple_16_color__f)"/><path d="M7 11a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z" fill="url(#ic_fluent_chart_multiple_16_color__g)"/><defs><linearGradient id="ic_fluent_chart_multiple_16_color__a" x1="11.99" y1="14.76" x2="-1.28" y2="1.62" gradientUnits="userSpaceOnUse"><stop stop-color="#6D37CD"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_16_color__d" x1="13.25" y1="5.15" x2="12.98" y2=".03" gradientUnits="userSpaceOnUse"><stop stop-color="#E23CB4"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_16_color__e" x1="14.74" y1="3.24" x2="20.32" y2="5.55" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_16_color__f" x1="10.5" y1="8.5" x2="14.47" y2="10.55" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_16_color__g" x1="7.5" y1="10" x2="10.01" y2="11.85" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><radialGradient id="ic_fluent_chart_multiple_16_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 2.74881 -2.71092 0 8.34 13)"><stop stop-color="#30116E"/><stop offset=".75" stop-color="#30116E" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_chart_multiple_16_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 2.74881 -2.4384 0 11.1 11.63)"><stop stop-color="#30116E"/><stop offset="1" stop-color="#30116E" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$ef9cb9dbf7650778 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple16Filled', "16", [
    "M12 7a2 2 0 0 1 .87-1.65A5.57 5.57 0 0 0 7.43 1c-.24 0-.43.2-.43.45V6.5c0 .28.22.5.5.5H12ZM1 7.5a5.5 5.5 0 0 0 5 5.48V11a2 2 0 0 1 3-1.73V9c0-.36.1-.7.27-1H7a1 1 0 0 1-1-1V2.57c0-.3-.25-.53-.54-.47A5.5 5.5 0 0 0 1 7.5ZM14 6a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1Zm-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Zm-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z"
]);
const $77e1bce0ac0f7fe7$export$73986e32ab5a0a62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple16Regular', "16", [
    "M12 7a2 2 0 0 1 .87-1.65A5.57 5.57 0 0 0 7.43 1c-.24 0-.43.2-.43.45V6.5c0 .28.22.5.5.5H12ZM8 2.04c2.07.25 3.7 1.9 3.96 3.96H8V2.04ZM1 7.5a5.5 5.5 0 0 0 5 5.48v-1a4.5 4.5 0 0 1-1-8.72V7c0 1.1.9 2 2 2h2c0-.36.1-.7.27-1H7a1 1 0 0 1-1-1V2.57c0-.3-.25-.53-.54-.47A5.5 5.5 0 0 0 1 7.5ZM14 6a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1Zm-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1Zm-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z"
]);
const $77e1bce0ac0f7fe7$export$77e144a2314164a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple20Color', "20", `<path d="M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02Z" fill="url(#ic_fluent_chart_multiple_20_color__a)"/><path d="M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02Z" fill="url(#ic_fluent_chart_multiple_20_color__b)" fill-opacity=".4"/><path d="M8.5 4.02c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5A6 6 0 1 1 8.5 4.02Z" fill="url(#ic_fluent_chart_multiple_20_color__c)" fill-opacity=".4"/><path d="M16.52 9c.26 0 .48-.2.48-.46V8.5A6.5 6.5 0 0 0 10.46 2a.47.47 0 0 0-.46.48V8.5c0 .28.22.5.5.5h6.02Z" fill="url(#ic_fluent_chart_multiple_20_color__d)"/><path d="M16 11a1 1 0 1 1 2 0v7a1 1 0 1 1-2 0v-7Z" fill="url(#ic_fluent_chart_multiple_20_color__e)"/><path d="M13 13a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0v-5Z" fill="url(#ic_fluent_chart_multiple_20_color__f)"/><path d="M10 15a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z" fill="url(#ic_fluent_chart_multiple_20_color__g)"/><defs><linearGradient id="ic_fluent_chart_multiple_20_color__a" x1="15.07" y1="17.93" x2=".5" y2="3.5" gradientUnits="userSpaceOnUse"><stop stop-color="#6D37CD"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_20_color__d" x1="17.29" y1="6.84" x2="16.98" y2=".87" gradientUnits="userSpaceOnUse"><stop stop-color="#E23CB4"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_20_color__e" x1="17.74" y1="7.24" x2="23.32" y2="9.55" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_20_color__f" x1="13.5" y1="12.5" x2="17.47" y2="14.55" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_20_color__g" x1="10.5" y1="14" x2="13.01" y2="15.85" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><radialGradient id="ic_fluent_chart_multiple_20_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 3 -2.95312 0 11 16)"><stop stop-color="#30116E"/><stop offset=".75" stop-color="#30116E" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_chart_multiple_20_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 3 -2.65625 0 14 14.5)"><stop stop-color="#30116E"/><stop offset="1" stop-color="#30116E" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$6d0a49d79f39b7ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple20Filled', "20", [
    "M17 8.54c0 .26-.22.46-.48.46H10.5a.5.5 0 0 1-.5-.5V2.48c0-.26.2-.48.46-.48h.04A6.5 6.5 0 0 1 17 8.5v.04ZM9 4.5c0-.28-.22-.5-.5-.48A6 6 0 0 0 9 16v-1a2 2 0 0 1 3-1.73V13c0-1.1.9-2 2-2h.92a6 6 0 0 0 .06-.5.47.47 0 0 0-.48-.5H10a1 1 0 0 1-1-1V4.5Zm8 5.5a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1Zm-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Zm-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z"
]);
const $77e1bce0ac0f7fe7$export$3d4256e85f34db36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple20Regular', "20", [
    "M16.52 9c.26 0 .48-.2.48-.46V8.5A6.5 6.5 0 0 0 10.5 2h-.04a.47.47 0 0 0-.46.48V8.5c0 .28.22.5.5.5h6.02ZM11 3.02A5.5 5.5 0 0 1 15.98 8H11V3.02ZM8 9V5.1A5 5 0 0 0 9 15v1a6 6 0 0 1-.5-11.98c.28-.02.5.2.5.48V9a1 1 0 0 0 1 1h4.5c.28 0 .5.22.48.5a6 6 0 0 1-.06.5H10a2 2 0 0 1-2-2Zm9 1a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-7a1 1 0 0 0-1-1Zm-3 2a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Zm-4 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0v-3Z"
]);
const $77e1bce0ac0f7fe7$export$a1c25be48e3b655e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple24Color', "24", `<path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5A7.5 7.5 0 1 1 10 4.02Z" fill="url(#ic_fluent_chart_multiple_24_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5A7.5 7.5 0 1 1 10 4.02Z" fill="url(#ic_fluent_chart_multiple_24_color__b)" fill-opacity=".4"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5A7.5 7.5 0 1 1 10 4.02Z" fill="url(#ic_fluent_chart_multiple_24_color__c)" fill-opacity=".4"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20 9.4v.14c0 .26-.22.46-.48.46H12.5a.5.5 0 0 1-.5-.5V2.49c0-.27.2-.49.46-.49h.11C16.67 2 20 5.31 20 9.4Z" fill="url(#ic_fluent_chart_multiple_24_color__d)"/><path d="M21.5 12c-.83 0-1.5.67-1.5 1.5v8a1.5 1.5 0 0 0 3 0v-8c0-.83-.67-1.5-1.5-1.5Z" fill="url(#ic_fluent_chart_multiple_24_color__e)"/><path d="M16 16.5a1.5 1.5 0 0 1 3 0v5a1.5 1.5 0 0 1-3 0v-5Z" fill="url(#ic_fluent_chart_multiple_24_color__f)"/><path d="M13.5 18c-.83 0-1.5.67-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2c0-.83-.67-1.5-1.5-1.5Z" fill="url(#ic_fluent_chart_multiple_24_color__g)"/><defs><linearGradient id="ic_fluent_chart_multiple_24_color__a" x1="18.09" y1="21.42" x2="-.13" y2="3.37" gradientUnits="userSpaceOnUse"><stop stop-color="#6D37CD"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_24_color__d" x1="20.33" y1="7.53" x2="19.97" y2=".71" gradientUnits="userSpaceOnUse"><stop stop-color="#E23CB4"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_24_color__e" x1="22.61" y1="8.62" x2="30.4" y2="12.59" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_24_color__f" x1="16.75" y1="15.57" x2="21.91" y2="19.08" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_24_color__g" x1="12.75" y1="18" x2="15.36" y2="20.89" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><radialGradient id="ic_fluent_chart_multiple_24_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 3.86087 -3.80424 0 13.3 19)"><stop stop-color="#30116E"/><stop offset=".75" stop-color="#30116E" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_chart_multiple_24_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 3.86087 -3.4218 0 17.17 17.07)"><stop stop-color="#30116E"/><stop offset="1" stop-color="#30116E" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$9b5d995699c7f958 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple24Filled', "24", [
    "M20 9.46V9.4A7.43 7.43 0 0 0 12.46 2a.48.48 0 0 0-.46.49V9.5c0 .28.22.5.5.5h7.02c.26 0 .48-.2.48-.46v-.08ZM10.5 4.5c0-.28-.22-.5-.5-.48a7.5 7.5 0 1 0 1.05 14.96A2.5 2.5 0 0 1 15 17.5v-1a2.5 2.5 0 0 1 2.57-2.5c.23-.63.37-1.3.41-2a.48.48 0 0 0-.48-.5h-6a1 1 0 0 1-1-1v-6Zm9.5 9a1.5 1.5 0 0 1 3 0v8a1.5 1.5 0 0 1-3 0v-8ZM17.5 15c-.83 0-1.5.67-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5c0-.83-.67-1.5-1.5-1.5Zm-4 3c-.83 0-1.5.67-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2c0-.83-.67-1.5-1.5-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$332a846cb30e3ddb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple24Regular', "24", [
    "M20 9.54V9.4A7.43 7.43 0 0 0 12.46 2a.48.48 0 0 0-.46.49V9.5c0 .28.22.5.5.5h7.02c.26 0 .48-.2.48-.46Zm-6.5-5.97c2.53.4 4.53 2.4 4.93 4.93H13.5V3.57ZM9 10.5V5.69a6 6 0 1 0 3.01 11.62c-.57.38-.97.98-1.11 1.68l-.4.01A7.5 7.5 0 0 1 10 4.02c.28-.02.5.2.5.48v6a1 1 0 0 0 1 1h6c.28 0 .5.22.48.5a7.47 7.47 0 0 1-.36 1.85h-.12c-.74 0-1.4.3-1.88.79.3-.5.54-1.06.7-1.64H11.5A2.5 2.5 0 0 1 9 10.5Zm11 3a1.5 1.5 0 0 1 3 0v8a1.5 1.5 0 0 1-3 0v-8ZM17.5 15c-.83 0-1.5.67-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5c0-.83-.67-1.5-1.5-1.5Zm-4 3c-.83 0-1.5.67-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2c0-.83-.67-1.5-1.5-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$ea95844b7863822e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple32Color', "32", `<path d="M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 11.57 11.57c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3V7.54Z" fill="url(#ic_fluent_chart_multiple_32_color__a)"/><path d="M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 11.57 11.57c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3V7.54Z" fill="url(#ic_fluent_chart_multiple_32_color__b)" fill-opacity=".4"/><path d="M14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 11.57 11.57c.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3V7.54Z" fill="url(#ic_fluent_chart_multiple_32_color__c)" fill-opacity=".4"/><path d="m17.5 2-.55.01a1 1 0 0 0-.95 1V12c0 1.1.9 2 2 2h8.99a1 1 0 0 0 1-.95l.01-.55C28 6.7 23.3 2 17.5 2Z" fill="url(#ic_fluent_chart_multiple_32_color__d)"/><path d="M29 16a2 2 0 0 0-2 2v11a2 2 0 1 0 4 0V18a2 2 0 0 0-2-2Z" fill="url(#ic_fluent_chart_multiple_32_color__e)"/><path d="M24 20a2 2 0 0 0-2 2v7a2 2 0 1 0 4 0v-7a2 2 0 0 0-2-2Z" fill="url(#ic_fluent_chart_multiple_32_color__f)"/><path d="M17 25a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0v-4Z" fill="url(#ic_fluent_chart_multiple_32_color__g)"/><defs><linearGradient id="ic_fluent_chart_multiple_32_color__a" x1="24.1" y1="30.38" x2="-1.37" y2="5.14" gradientUnits="userSpaceOnUse"><stop stop-color="#6D37CD"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_32_color__d" x1="28.5" y1="10.3" x2="27.96" y2=".07" gradientUnits="userSpaceOnUse"><stop stop-color="#E23CB4"/><stop offset="1" stop-color="#EA71EF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_32_color__e" x1="30.47" y1="11.39" x2="40.96" y2="16.61" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_32_color__f" x1="23" y1="20.79" x2="30.02" y2="25.41" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_chart_multiple_32_color__g" x1="18" y1="22" x2="22.63" y2="25.8" gradientUnits="userSpaceOnUse"><stop stop-color="#16BBDA"/><stop offset="1" stop-color="#0067BF"/></linearGradient><radialGradient id="ic_fluent_chart_multiple_32_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 6.5 -5.34375 0 19 26)"><stop stop-color="#30116E"/><stop offset=".75" stop-color="#30116E" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_chart_multiple_32_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 5.5 -3.79687 0 24 24.5)"><stop stop-color="#30116E"/><stop offset="1" stop-color="#30116E" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$89feac9530134bde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple32Filled', "32", [
    "M16.95 2.01 17.5 2a10.5 10.5 0 0 1 10.49 11.05 1 1 0 0 1-1 .95H18a2 2 0 0 1-2-2V3.01a1 1 0 0 1 .95-1ZM14 7.54c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 3.13 20.75V25a3.5 3.5 0 0 1 5-3.16 3.5 3.5 0 0 1 3.3-3.34c.06-.28.1-.57.14-.87.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3V7.54ZM27 18a2 2 0 1 1 4 0v11a2 2 0 1 1-4 0V18Zm-5 4a2 2 0 1 1 4 0v7a2 2 0 1 1-4 0v-7Zm-3 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2Z"
]);
const $77e1bce0ac0f7fe7$export$eb10fded4df69da7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartMultiple32Regular', "32", [
    "M16.95 2.01 17.5 2a10.5 10.5 0 0 1 10.49 11.05 1 1 0 0 1-1 .95H18a2 2 0 0 1-2-2V3.01a1 1 0 0 1 .95-1Zm1.05 2V12h7.99A8.5 8.5 0 0 0 18 4.01Zm-4 3.53c0-.84-.72-1.58-1.63-1.48a10.5 10.5 0 1 0 3.13 20.75v-2.04A8.52 8.52 0 0 1 5 16.5a8.5 8.5 0 0 1 7-8.37V13a5 5 0 0 0 5 5h4.87c-.1.58-.27 1.14-.48 1.67a3.5 3.5 0 0 1 2.42-1.17c.05-.28.1-.57.13-.87.1-.91-.64-1.63-1.48-1.63H17a3 3 0 0 1-3-3V7.54ZM27 18a2 2 0 1 1 4 0v11a2 2 0 1 1-4 0V18Zm-5 4a2 2 0 1 1 4 0v7a2 2 0 1 1-4 0v-7Zm-3 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2Z"
]);
const $77e1bce0ac0f7fe7$export$d8e9710c38a97c7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson20Filled', "20", [
    "M10.5 2.5a.5.5 0 1 0-1 0V3H4.75A2.75 2.75 0 0 0 2 5.75v6.5A2.75 2.75 0 0 0 4.75 15h1.82l-1.49 2.23a.5.5 0 0 0 .84.55L7.77 15H11.5a2.5 2.5 0 0 1 1.77-.99A2.99 2.99 0 0 1 15.5 9a3 3 0 0 1 2.5 1.34V5.75A2.75 2.75 0 0 0 15.25 3H10.5v-.5ZM5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 4.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1Zm0-2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Zm12 3.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$4a35da29834851b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson20Regular', "20", [
    "M10 2c.28 0 .5.22.5.5V3h4.75A2.75 2.75 0 0 1 18 5.75v4.6c-.26-.4-.6-.72-1-.95V5.75c0-.65-.35-1.22-.88-1.52l-.02-.01a1.74 1.74 0 0 0-.85-.22H4.75C3.78 4 3 4.78 3 5.75v6.55c.03.94.8 1.7 1.75 1.7h8.51l.01.01a2.5 2.5 0 0 0-1.77.99H7.77l-1.85 2.78a.5.5 0 1 1-.84-.55L6.57 15H4.75A2.75 2.75 0 0 1 2 12.25v-6.5A2.75 2.75 0 0 1 4.75 3H9.5v-.5c0-.28.22-.5.5-.5ZM5 6.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 4.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM5 9c0-.27.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 5 9Zm12.5 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$b4c0c53f2763fd46 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson24Filled', "24", [
    "M12.5 2.75a.75.75 0 0 0-1.5 0V3H5.25A3.25 3.25 0 0 0 2 6.25v9.5C2 17.55 3.46 19 5.25 19h2.4l-1.48 1.77a.75.75 0 0 0 1.16.96L9.6 19h3.5c.34-1.16 1.41-2 2.67-2h.28a3.49 3.49 0 0 1 2.45-6 3.5 3.5 0 0 1 3.5 3.5V6.25C22 4.45 20.54 3 18.75 3H12.5v-.25Zm-6.5 5c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 6 7.75ZM6.75 10h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5Zm0 3h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5ZM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $77e1bce0ac0f7fe7$export$1275eec312ba6ec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson24Regular', "24", [
    "M12.5 2.75a.75.75 0 0 0-1.5 0V3H5.25A3.25 3.25 0 0 0 2 6.25v9.5C2 17.55 3.46 19 5.25 19h2.4l-1.48 1.77a.75.75 0 0 0 1.16.96L9.6 19h3.5c.19-.61.57-1.14 1.08-1.5H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75v5.38A3.5 3.5 0 0 1 22 14.5V6.25C22 4.45 20.54 3 18.75 3H12.5v-.25Zm-6.5 5c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 6 7.75ZM6.75 10a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM6 13.75c0-.41.34-.75.75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm15 .75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $77e1bce0ac0f7fe7$export$58b725d8727d7a2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson28Filled', "28", [
    "M14.25 2c.41 0 .75.34.75.75V3h7.75a3.29 3.29 0 0 1 1.2.23A3.25 3.25 0 0 1 26 6.25v10.5c0 .14-.11.25-.25.25a.26.26 0 0 1-.26-.25A4 4 0 1 0 18.85 20h-.8c-1.32 0-2.44.83-2.87 2h-4.6l-3.27 3.74a.75.75 0 0 1-1.13-.98L8.6 22H5.25l-.45-.03A3.25 3.25 0 0 1 2 18.75V6.25C2 4.45 3.46 3 5.25 3h8.25v-.25c0-.41.33-.75.75-.75Zm-7.5 5.5a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5h-5.5ZM6 12.25c0 .41.33.75.75.75h10.5a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0-.75.75Zm0 4c0 .41.33.75.75.75h8.5a.75.75 0 1 0 0-1.5h-8.5a.75.75 0 0 0-.75.75Zm18.5.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.5 6.25c0 1.87-1.57 3.75-5.5 3.75-3.93 0-5.5-1.88-5.5-3.75v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04v.21Z"
]);
const $77e1bce0ac0f7fe7$export$4864674f526f42a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson28Regular', "28", [
    "M14.25 2c.41 0 .75.34.75.75V3h7.75C24.55 3 26 4.46 26 6.25v10.5c0 .14-.11.25-.25.25a.26.26 0 0 1-.26-.25 3.98 3.98 0 0 0-.99-2.4v-8.1c0-.97-.78-1.75-1.75-1.75H5.25c-.97 0-1.75.78-1.75 1.75v12.5c0 .97.78 1.75 1.75 1.75h11.12c-.54.36-.96.88-1.19 1.5h-4.6l-3.27 3.74a.75.75 0 0 1-1.13-.99L8.59 22H5.25A3.25 3.25 0 0 1 2 18.75V6.25C2 4.45 3.46 3 5.25 3h8.25v-.25c0-.41.34-.75.75-.75Zm-7.5 5.5a.75.75 0 1 0 0 1.5h5.5a.75.75 0 1 0 0-1.5h-5.5Zm0 4a.75.75 0 1 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H6.75Zm0 4a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5h-8.5ZM24.5 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm2.5 6.25c0 1.87-1.57 3.75-5.5 3.75-3.93 0-5.5-1.88-5.5-3.75v-.2c0-1.13.92-2.05 2.05-2.05h6.9c1.13 0 2.05.92 2.05 2.04v.21Z"
]);
const $77e1bce0ac0f7fe7$export$3d8abf1091517c09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson48Filled', "48", [
    "M23.75 4c.69 0 1.25.56 1.25 1.25V6h13.75C41.65 6 44 8.35 44 11.25V29a7 7 0 1 0-11.9 5H31a5 5 0 0 0-4.58 3h-7.17l-.08.1-6 6.5a1.25 1.25 0 1 1-1.84-1.7l4.53-4.9H9.25A5.25 5.25 0 0 1 4 31.75v-20.5C4 8.35 6.35 6 9.25 6H22.5v-.75c0-.69.56-1.25 1.25-1.25Zm-11.5 9.5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5ZM11 21.75c0 .69.56 1.25 1.25 1.25h14.5a1.25 1.25 0 1 0 0-2.5h-14.5c-.69 0-1.25.56-1.25 1.25Zm0 7c0 .69.56 1.25 1.25 1.25h11.5a1.25 1.25 0 1 0 0-2.5h-11.5c-.69 0-1.25.56-1.25 1.25ZM42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v.5Z"
]);
const $77e1bce0ac0f7fe7$export$854b57f913b02b18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChartPerson48Regular', "48", [
    "M25 5.25a1.25 1.25 0 1 0-2.5 0V6H9.25A5.25 5.25 0 0 0 4 11.25v20.5C4 34.65 6.35 37 9.25 37h6.6l-4.52 4.9a1.25 1.25 0 1 0 1.84 1.7l6-6.5.08-.1h7.17a5.02 5.02 0 0 1 2.4-2.5H9.25a2.75 2.75 0 0 1-2.75-2.75v-20.5A2.75 2.75 0 0 1 9.25 8.5h29.5a2.75 2.75 0 0 1 2.75 2.75v12.39A6.98 6.98 0 0 1 44 29V11.25C44 8.35 41.65 6 38.75 6H25v-.75ZM12.25 13.5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5ZM11 21.75c0-.69.56-1.25 1.25-1.25h14.5a1.25 1.25 0 1 1 0 2.5h-14.5c-.69 0-1.25-.56-1.25-1.25Zm0 7c0-.69.56-1.25 1.25-1.25h11.5a1.25 1.25 0 1 1 0 2.5h-11.5c-.69 0-1.25-.56-1.25-1.25ZM42 29a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm4 10.5c0 3.5-3.15 6.5-9 6.5s-9-3-9-6.5V39a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v.5Z"
]);
const $77e1bce0ac0f7fe7$export$311f7c11f0706ece = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat12Filled', "12", [
    "M1 6a5 5 0 1 1 2.6 4.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A4.98 4.98 0 0 1 1 6Zm3-.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.5.5ZM4.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
]);
const $77e1bce0ac0f7fe7$export$664889444ee4a155 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat12Regular', "12", [
    "M4 5.5c0-.28.22-.5.5-.5h3a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM1 6a5 5 0 1 1 2.6 4.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A4.98 4.98 0 0 1 1 6Zm5-4a4 4 0 0 0-3.42 6.08c.08.12.1.27.05.4l-.38 1.26 1.26-.38a.5.5 0 0 1 .4.05A4 4 0 1 0 6 2Z"
]);
const $77e1bce0ac0f7fe7$export$944da024ff4983c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat16Color', "16", `<path d="M8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2A6 6 0 1 0 8 2Z" fill="url(#ic_fluent_chat_16_color__a)"/><path d="M6 7c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7Zm.5 1.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z" fill="url(#ic_fluent_chat_16_color__b)"/><defs><linearGradient id="ic_fluent_chat_16_color__a" x1="2.43" y1="4.25" x2="12.9" y2="22.11" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_16_color__b" x1="6.35" y1="6.55" x2="6.73" y2="9.8" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$51991fc8938e2d6c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat16Filled', "16", [
    "M8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2A6 6 0 1 0 8 2ZM6 7c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7Zm.5 1.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z"
]);
const $77e1bce0ac0f7fe7$export$f749dbbee791d214 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat16Regular', "16", [
    "M6 7c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7Zm.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM2 8a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 2 8Zm6-5a5 5 0 0 0-4.3 7.55.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06A5 5 0 1 0 8 3Z"
]);
const $77e1bce0ac0f7fe7$export$d802222eb5625e03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat20Color', "20", `<path d="M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Z" fill="url(#ic_fluent_chat_20_color__a)"/><path d="M10.5 11H7.41a.5.5 0 0 0 0 1H10.59a.5.5 0 0 0 0-1h-.09Zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1h-.09Z" fill="url(#ic_fluent_chat_20_color__b)"/><defs><linearGradient id="ic_fluent_chat_20_color__a" x1="2.57" y1="5" x2="16.54" y2="28.82" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_20_color__b" x1="7.52" y1="8.07" x2="7.97" y2="12.41" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$3a54bb59f5034e64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm.5 9H7.41a.5.5 0 0 0 0 1H10.59a.5.5 0 0 0 0-1h-.09Zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1h-.09Z"
]);
const $77e1bce0ac0f7fe7$export$7067d921f146093d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 10 3Zm.5 8a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h3.09Zm2-3a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09Z"
]);
const $77e1bce0ac0f7fe7$export$e4561528ec1dd0a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat24Color', "24", `<path d="M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Z" fill="url(#ic_fluent_chat_24_color__a)"/><path d="M13.25 13h-4.6a.75.75 0 0 0 0 1.5H13.35a.75.75 0 0 0 0-1.5h-.1Zm2-3.5h-6.6a.75.75 0 0 0 0 1.5H15.35a.75.75 0 0 0 0-1.5h-.1Z" fill="url(#ic_fluent_chat_24_color__b)"/><defs><linearGradient id="ic_fluent_chat_24_color__a" x1="2.71" y1="5.75" x2="20.18" y2="35.52" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_24_color__b" x1="8.7" y1="9.59" x2="9.23" y2="15.02" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$4b1011faa575c5fd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm1.25 11h-4.6a.75.75 0 0 0 0 1.5H13.35a.75.75 0 0 0 0-1.5h-.1Zm2-3.5h-6.6a.75.75 0 0 0 0 1.5H15.35a.75.75 0 0 0 0-1.5h-.1Z"
]);
const $77e1bce0ac0f7fe7$export$62fe31be16192f54 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2Zm0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5ZM8.75 13h4.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6-4.5Zm0-3.5h6.5a.75.75 0 0 1 .1 1.5h-6.6a.75.75 0 0 1-.1-1.5h6.6-6.5Z"
]);
const $77e1bce0ac0f7fe7$export$748ce0df1ff19dcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat28Color', "28", `<path d="M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14Zm7.5-2.25c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75Zm.75 3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" fill="url(#ic_fluent_chat_28_color__a)"/><path d="M9.5 11.75c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75Zm.75 3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" fill="url(#ic_fluent_chat_28_color__b)"/><defs><linearGradient id="ic_fluent_chat_28_color__a" x1="2.86" y1="6.5" x2="23.81" y2="42.22" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_28_color__b" x1="10.29" y1="11.11" x2="10.96" y2="17.62" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$3176de60cfda2552 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat28Filled', "28", [
    "M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14Zm7.5-2.25c0 .41.34.75.75.75h7.5a.75.75 0 0 0 0-1.5h-7.5a.75.75 0 0 0-.75.75Zm.75 3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
]);
const $77e1bce0ac0f7fe7$export$626f2dc30490ed84 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat28Regular', "28", [
    "M9.07 23.27a10.5 10.5 0 1 0-4.34-4.34c.18.35.22.75.12 1.12L3.6 24.39l4.34-1.24c.38-.1.78-.06 1.12.12ZM14 26c-2.04 0-3.96-.5-5.64-1.4L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 1 1 14 26ZM9.5 11.75c0-.41.34-.75.75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Zm0 4.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$78b13d6157b1606c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Color', "32", `<path d="M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A13.94 13.94 0 0 1 2 16Zm8-3a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H11a1 1 0 0 0-1 1Zm1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" fill="url(#ic_fluent_chat_32_color__a)"/><path d="M10 13a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H11a1 1 0 0 0-1 1Zm1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z" fill="url(#ic_fluent_chat_32_color__b)"/><defs><linearGradient id="ic_fluent_chat_32_color__a" x1="3" y1="7.25" x2="27.45" y2="48.93" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_32_color__b" x1="11.05" y1="12.14" x2="11.95" y2="20.83" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$5d2c7176d5c2a125 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Filled', "32", [
    "M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A13.94 13.94 0 0 1 2 16Zm8-3a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H11a1 1 0 0 0-1 1Zm1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
]);
const $77e1bce0ac0f7fe7$export$1be355d7fbaa7ab8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Light', "32", [
    "M16 2A14 14 0 0 0 3.63 22.56L2.06 28.1a1.5 1.5 0 0 0 1.85 1.85l5.53-1.57A14 14 0 1 0 16 2Zm0 27c-2.12 0-4.23-.52-6.09-1.51l-.36-.2L3.64 29a.52.52 0 0 1-.15.01.5.5 0 0 1-.47-.64l1.68-5.91-.19-.36A13.02 13.02 0 0 1 16 3a13.01 13.01 0 0 1 0 26Zm5.5-16h-11a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1Zm-4 6h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$9e7ea54b82e5925c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat32Regular', "32", [
    "M16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1A12 12 0 1 0 16 4ZM2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A13.94 13.94 0 0 1 2 16Zm8-3a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H11a1 1 0 0 1-1-1Zm1 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
]);
const $77e1bce0ac0f7fe7$export$874d2f883d3757b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat48Color', "48", `<path d="M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A19.92 19.92 0 0 1 4 24Z" fill="url(#ic_fluent_chat_48_color__a)"/><path d="M16 20.25c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25Zm1.25 6.25a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5Z" fill="url(#ic_fluent_chat_48_color__b)"/><defs><linearGradient id="ic_fluent_chat_48_color__a" x1="5.43" y1="11.5" x2="40.35" y2="71.04" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_48_color__b" x1="17.4" y1="19.18" x2="18.45" y2="30.05" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$43c6e5e89d5f91f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat48Filled', "48", [
    "M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A19.92 19.92 0 0 1 4 24Zm12-3.75c0 .69.56 1.25 1.25 1.25h13.5a1.25 1.25 0 1 0 0-2.5h-13.5c-.69 0-1.25.56-1.25 1.25Zm1.25 6.25a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5Z"
]);
const $77e1bce0ac0f7fe7$export$a5f7f9498d037a8d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chat48Regular', "48", [
    "M24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11c.33-.1.68-.05.97.12A17.5 17.5 0 1 0 24 6.5ZM4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A19.92 19.92 0 0 1 4 24Zm12-3.75c0-.69.56-1.25 1.25-1.25h13.5a1.25 1.25 0 1 1 0 2.5h-13.5c-.69 0-1.25-.56-1.25-1.25Zm1.25 6.25a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5Z"
]);
const $77e1bce0ac0f7fe7$export$a586357cc8a39912 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd16Color', "16", `<path d="M8 2a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A6 6 0 0 1 8 2Zm.5 3.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2Z" fill="url(#ic_fluent_chat_add_16_color__a)"/><path d="M8.5 5.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2Z" fill="url(#ic_fluent_chat_add_16_color__b)"/><defs><linearGradient id="ic_fluent_chat_add_16_color__a" x1="2.43" y1="4.25" x2="12.9" y2="22.11" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_add_16_color__b" x1="5.52" y1="5.11" x2="6.52" y2="11.54" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$c77764279cdb20d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd16Filled', "16", [
    "M8 2a6 6 0 1 1-3 11.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A6 6 0 0 1 8 2Zm.5 3.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2Z"
]);
const $77e1bce0ac0f7fe7$export$99ea78f967946a18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd16Regular', "16", [
    "M8.5 5.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2ZM8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2A6 6 0 1 0 8 2ZM3 8a5 5 0 1 1 2.33 4.23.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A4.97 4.97 0 0 1 3 8Z"
]);
const $77e1bce0ac0f7fe7$export$f70b8e3326a37a60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd20Color', "20", `<path d="M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8ZM6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3h-3Z" fill="url(#ic_fluent_chat_add_20_color__a)"/><path d="M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3h-3Z" fill="url(#ic_fluent_chat_add_20_color__b)"/><defs><linearGradient id="ic_fluent_chat_add_20_color__a" x1="2.57" y1="5" x2="16.54" y2="28.82" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_add_20_color__b" x1="6.7" y1="6.14" x2="8.03" y2="14.71" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$89ba831c3aacda1e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8ZM6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3h-3Z"
]);
const $77e1bce0ac0f7fe7$export$34b0375c618e5386 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd20Regular', "20", [
    "M6.5 9.5a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3a.5.5 0 0 0-1 0v3h-3ZM18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10ZM3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02a.5.5 0 0 0-.18 0l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A6.97 6.97 0 0 1 3 10Z"
]);
const $77e1bce0ac0f7fe7$export$1998c993195eff42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd24Color', "24", `<path d="M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm.75 5.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" fill="url(#ic_fluent_chat_add_24_color__a)"/><path d="M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" fill="url(#ic_fluent_chat_add_24_color__b)"/><defs><linearGradient id="ic_fluent_chat_add_24_color__a" x1="2.71" y1="5.75" x2="20.18" y2="35.52" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_add_24_color__b" x1="7.87" y1="7.18" x2="9.54" y2="17.89" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$b372735183fc8f10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm.75 5.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$d4506f69b85dcfae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd24Regular', "24", [
    "M12.75 7.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5ZM22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12ZM3.5 12a8.5 8.5 0 1 1 4.37 7.43l-.27-.15-3.99 1.11 1.11-3.98-.15-.27A8.46 8.46 0 0 1 3.5 12Z"
]);
const $77e1bce0ac0f7fe7$export$9dba58375d4c54c3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd28Color', "28", `<path d="M14 2a12 12 0 1 1-5.64 22.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2Zm.75 6.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" fill="url(#ic_fluent_chat_add_28_color__a)"/><path d="M14.75 8.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" fill="url(#ic_fluent_chat_add_28_color__b)"/><defs><linearGradient id="ic_fluent_chat_add_28_color__a" x1="2.86" y1="6.5" x2="23.81" y2="42.22" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_add_28_color__b" x1="9.05" y1="8.21" x2="11.04" y2="21.07" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$44fdd01a450af5e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd28Filled', "28", [
    "M14 2a12 12 0 1 1-5.64 22.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2Zm.75 6.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"
]);
const $77e1bce0ac0f7fe7$export$7751eb6c5f140989 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd28Regular', "28", [
    "M14.75 8.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5ZM14 2A12 12 0 0 0 3.4 19.64l-1.35 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35A12 12 0 1 0 14 2ZM3.5 14a10.5 10.5 0 1 1 5.32 9.14.75.75 0 0 0-.57-.07L3.6 24.39l1.32-4.64c.06-.19.03-.4-.07-.57A10.45 10.45 0 0 1 3.5 14Z"
]);
const $77e1bce0ac0f7fe7$export$92fed5ef1f40a3a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd32Color', "32", `<path d="M16 2a14 14 0 1 1-6.56 26.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2Zm0 7a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1Z" fill="url(#ic_fluent_chat_add_32_color__a)"/><path d="M16 9a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1Z" fill="url(#ic_fluent_chat_add_32_color__b)"/><defs><linearGradient id="ic_fluent_chat_add_32_color__a" x1="3" y1="7.25" x2="27.45" y2="48.93" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_add_32_color__b" x1="10.22" y1="9.25" x2="12.55" y2="24.25" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$6fb2e639082bb910 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd32Filled', "32", [
    "M16 2a14 14 0 1 1-6.56 26.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2Zm0 7a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1Z"
]);
const $77e1bce0ac0f7fe7$export$f7fc144b49a9ca2c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd32Regular', "32", [
    "M16 9a1 1 0 0 0-1 1v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5a1 1 0 0 0-1-1Zm0-7A14 14 0 0 0 3.63 22.56L2.06 28.1a1.5 1.5 0 0 0 1.85 1.85l5.53-1.57A14 14 0 1 0 16 2ZM4 16a12 12 0 1 1 6.06 10.43 1 1 0 0 0-.77-.1l-5.06 1.44 1.44-5.06a1 1 0 0 0-.1-.77C4.57 20.2 4 18.16 4 16Z"
]);
const $77e1bce0ac0f7fe7$export$f770bec62a9e004 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd48Color', "48", `<path d="M24 4a20 20 0 1 1-9.53 37.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4Zm1.25 11.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5v-7.5Z" fill="url(#ic_fluent_chat_add_48_color__a)"/><path d="M25.25 15.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5v-7.5Z" fill="url(#ic_fluent_chat_add_48_color__b)"/><defs><linearGradient id="ic_fluent_chat_add_48_color__a" x1="5.43" y1="11.5" x2="40.35" y2="71.04" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_add_48_color__b" x1="15.75" y1="14.35" x2="19.07" y2="35.79" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$7f989546cd53e0bf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd48Filled', "48", [
    "M24 4a20 20 0 1 1-9.53 37.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4Zm1.25 11.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5v-7.5Z"
]);
const $77e1bce0ac0f7fe7$export$37f9e935441d309a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatAdd48Regular', "48", [
    "M25.25 15.25a1.25 1.25 0 1 0-2.5 0v7.5h-7.5a1.25 1.25 0 1 0 0 2.5h7.5v7.5a1.25 1.25 0 1 0 2.5 0v-7.5h7.5a1.25 1.25 0 1 0 0-2.5h-7.5v-7.5ZM24 4A20 20 0 0 0 6.41 33.53l-2.34 8.24a1.75 1.75 0 0 0 2.16 2.16l8.24-2.34A20 20 0 1 0 24 4ZM6.5 24a17.5 17.5 0 1 1 8.75 15.16c-.3-.17-.64-.21-.97-.12l-7.44 2.11 2.12-7.44c.1-.32.05-.67-.12-.97A17.41 17.41 0 0 1 6.5 24Z"
]);
const $77e1bce0ac0f7fe7$export$18086e6f57618f14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack16Filled', "16", [
    "M7 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L4 12.2c.46.28.97.49 1.5.62a5.5 5.5 0 0 1 7.3-7.3A6 6 0 0 0 7.01 1Zm3.5 14a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 13 12.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75H8.71l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7L8.9 7.9a.5.5 0 1 1 .7.7Z"
]);
const $77e1bce0ac0f7fe7$export$a85836758140a5e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack16Regular', "16", [
    "M7 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L4 12.2c.46.28.97.49 1.5.62-.16-.37-.3-.76-.38-1.18a4.97 4.97 0 0 1-.8-.4.5.5 0 0 0-.42-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39 5 5 0 1 1 8.93-4.43c.42.08.81.22 1.18.39A6 6 0 0 0 7 1Zm8 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM9.6 7.9a.5.5 0 0 0-.7 0L7.15 9.65a.5.5 0 0 0 0 .7L8.9 12.1a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75H8.71l.9-.9a.5.5 0 0 0 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$47d6f3d324b9cd7d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a7.93 7.93 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm4.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z"
]);
const $77e1bce0ac0f7fe7$export$7434ace4cb20a168 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBack20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.25 5.5 5.5 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04c.92.51 1.94.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm4.5 17a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z"
]);
const $77e1bce0ac0f7fe7$export$7da9d4b08946b7ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown16Filled', "16", [
    "M1 7a6 6 0 0 1 11.81-1.5 5.5 5.5 0 0 0-7.3 7.3 5.97 5.97 0 0 1-1.51-.6l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 1 7Zm9.5-1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 13 8.75V8.5a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75H8.71l.9-.9a.5.5 0 1 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7L8.9 13.1a.5.5 0 0 0 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$3a81ff3c3a2393f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown16Regular', "16", [
    "M1 7a6 6 0 0 1 11.81-1.5c-.37-.16-.76-.3-1.18-.38A5 5 0 1 0 2.7 9.55a.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06c.25.15.51.3.79.4.08.42.22.81.39 1.18A5.97 5.97 0 0 1 4 12.2l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 1 7Zm9.5-1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 13 8.75V8.5a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75H8.71l.9-.9a.5.5 0 1 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7L8.9 13.1a.5.5 0 0 0 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$9965fa2977867ca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a7.97 7.97 0 0 0 3.86.86A5.5 5.5 0 0 1 18 10.26L18 10Zm-3.5 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 17 12.75v-.25a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75h-1.54l.9-.9a.5.5 0 0 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7l1.76 1.75a.5.5 0 0 0 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$30cfaf1c4f4a09d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.25 5.5 5.5 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04c.92.51 1.94.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm4.5 8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm-.9 6.4-.9-.9h1.55A2.75 2.75 0 0 0 17 12.75v-.25a.5.5 0 0 0-1 0v.25c0 .97-.78 1.75-1.75 1.75h-1.54l.9-.9a.5.5 0 0 0-.71-.7l-1.76 1.75a.5.5 0 0 0 0 .7l1.76 1.75a.5.5 0 0 0 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$447cb8cdc05bb6a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12a9.96 9.96 0 0 0 5.42 1.11 6.5 6.5 0 0 1 9.19-9.19L22 12Zm1 5.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-6.65 2.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h2.04c1.24 0 2.25-1 2.25-2.25v-.25a.5.5 0 0 1 1 0v.25c0 1.8-1.46 3.25-3.25 3.25h-2.04l.64.65Z"
]);
const $77e1bce0ac0f7fe7$export$fe94b56a5de57917 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown24Regular', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 6.52 6.52 0 0 0-1.47-1.05 8.5 8.5 0 1 0-15.93 4.4l.15.28-1.1 3.98 3.98-1.11.27.15a8.45 8.45 0 0 0 3.86 1.07c.28.54.64 1.03 1.05 1.47a10.14 10.14 0 0 1-5.37-1.08L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2Zm11 15.5a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Zm-6.65 2.15a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 0 1 .7.7l-.64.65h2.04c1.24 0 2.25-1 2.25-2.25v-.25a.5.5 0 0 1 1 0v.25c0 1.8-1.46 3.25-3.25 3.25h-2.04l.64.65Z"
]);
const $77e1bce0ac0f7fe7$export$da4f1b15b72f24d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown28Filled', "28", [
    "M2 14a12 12 0 1 1 23.93 1.32 7.5 7.5 0 1 0-10.6 10.6 12.14 12.14 0 0 1-6.97-1.32L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14Zm25 6.5a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Zm-8.15 2.65a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L17.71 21h2.54A2.75 2.75 0 0 0 23 18.25V18a.5.5 0 0 1 1 0v.25A3.75 3.75 0 0 1 20.25 22h-2.54l1.14 1.15Z"
]);
const $77e1bce0ac0f7fe7$export$e831200b572d4697 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown28Regular', "28", [
    "M14 3.5a10.5 10.5 0 0 0-9.14 15.68c.1.17.13.38.07.57L3.61 24.4l4.64-1.32c.2-.06.4-.03.57.07a10.45 10.45 0 0 0 5.33 1.36c.33.52.73 1 1.17 1.43a12.14 12.14 0 0 1-6.96-1.33L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77a12 12 0 1 1 22.52-4.32c-.43-.44-.9-.84-1.43-1.17V14c0-5.8-4.7-10.5-10.5-10.5Zm13 17a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Zm-8.15 2.65a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L17.71 21h2.54A2.75 2.75 0 0 0 23 18.25V18a.5.5 0 0 1 1 0v.25A3.75 3.75 0 0 1 20.25 22h-2.54l1.14 1.15Z"
]);
const $77e1bce0ac0f7fe7$export$8fe356533532b52a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown32Filled', "32", [
    "M2 16a14 14 0 1 1 27.95 1.22 9 9 0 1 0-12.73 12.73 14.16 14.16 0 0 1-7.78-1.58l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A13.94 13.94 0 0 1 2 16Zm21.5 0a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm-1.22 10.22L21.06 25h2.69C26.1 25 28 23.1 28 20.75v-.5a.75.75 0 0 0-1.5 0v.5a2.75 2.75 0 0 1-2.75 2.75h-2.69l1.22-1.22a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$489dda8d117f86ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown32Regular', "32", [
    "M16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1c1.67.95 3.59 1.52 5.64 1.57.42.72.93 1.37 1.52 1.95a14.16 14.16 0 0 1-7.78-1.58l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53a14 14 0 1 1 26.32-5.34A9.04 9.04 0 0 0 28 15.7 12 12 0 0 0 16 4Zm7.5 12a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm-1.22 10.22L21.06 25h2.69C26.1 25 28 23.1 28 20.75v-.5a.75.75 0 0 0-1.5 0v.5a2.75 2.75 0 0 1-2.75 2.75h-2.69l1.22-1.22a.75.75 0 1 0-1.06-1.06l-2.5 2.5c-.3.3-.3.77 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$9bfb64ce251d3fc5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown48Filled', "48", [
    "M4 24a20 20 0 1 1 39.94 1.62 13 13 0 1 0-18.32 18.32 19.92 19.92 0 0 1-11.15-2.35l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A19.92 19.92 0 0 1 4 24Zm41 10a11 11 0 1 0-22 0 11 11 0 0 0 22 0Zm-14.3 3.3a1 1 0 0 1-1.4 1.4l-3-3a1 1 0 0 1 0-1.4l3-3a1 1 0 0 1 1.4 1.4L29.42 34H35a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6h-5.59l1.3 1.3Z"
]);
const $77e1bce0ac0f7fe7$export$3ce8485c1398a28a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowBackDown48Regular', "48", [
    "M24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11c.33-.1.68-.05.97.12a17.4 17.4 0 0 0 8.12 2.33c.64.9 1.4 1.73 2.25 2.45a19.92 19.92 0 0 1-11.15-2.35l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24a20 20 0 1 1 37.52-7.91c-.71-.85-1.53-1.6-2.44-2.25A17.5 17.5 0 0 0 24 6.5ZM45 34a11 11 0 1 0-22 0 11 11 0 0 0 22 0Zm-14.3 3.3a1 1 0 0 1-1.4 1.4l-3-3a1 1 0 0 1 0-1.4l3-3a1 1 0 0 1 1.4 1.4L29.42 34H35a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6h-5.59l1.3 1.3Z"
]);
const $77e1bce0ac0f7fe7$export$1b172b3af504979f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack16Filled', "16", [
    "M7 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L4 12.2c.46.28.97.49 1.5.62a5.5 5.5 0 0 1 7.3-7.3A6 6 0 0 0 7.01 1Zm8 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM9.35 9.35a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7L8.21 10.5l1.14-1.15Zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H13v.5a.5.5 0 0 0 1 0V11a1 1 0 0 0-1-1h-1.8Z"
]);
const $77e1bce0ac0f7fe7$export$ffcb64dfa61b3252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack16Regular', "16", [
    "M1 7a6 6 0 0 1 11.81-1.5c-.37-.16-.76-.3-1.18-.38A5 5 0 1 0 2.7 9.55a.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06c.25.15.51.3.79.4.08.42.22.81.39 1.18A5.97 5.97 0 0 1 4 12.2l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 1 7Zm14 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM9.35 9.35a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7L8.21 10.5l1.14-1.15Zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H13v.5a.5.5 0 0 0 1 0V11a1 1 0 0 0-1-1h-1.8Z"
]);
const $77e1bce0ac0f7fe7$export$ac7d6d8df3364eaa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a7.93 7.93 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm9 12.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H17v.5a.5.5 0 0 0 1 0V15a1 1 0 0 0-1-1h-1.8Z"
]);
const $77e1bce0ac0f7fe7$export$84f5766e28c8a34a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatArrowDoubleBack20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.25 5.5 5.5 0 0 0-1.01-.66 7 7 0 1 0-13.1 3.83.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04c.92.51 1.94.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 0 1-3.86-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm9 12.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Zm1.86.65.64-.65a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7l-.64-.65H17v.5a.5.5 0 0 0 1 0V15a1 1 0 0 0-1-1h-1.8Z"
]);
const $77e1bce0ac0f7fe7$export$5be7ef9a597f9571 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion16Color', "16", `<path d="M9 4a5 5 0 0 1 4.53 7.11l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46A4.98 4.98 0 0 1 4 9a5 5 0 0 1 5-5Z" fill="url(#ic_fluent_chat_bubbles_question_16_color__a)"/><path d="M7 2a5 5 0 0 0-4.53 7.11L2 11.41a.5.5 0 0 0 .59.58l2.29-.46A4.98 4.98 0 0 0 12 7a5 5 0 0 0-5-5Z" fill="url(#ic_fluent_chat_bubbles_question_16_color__b)"/><path d="M6.38 9.5a.62.62 0 1 1 1.25 0 .62.62 0 0 1-1.25 0Z" fill="url(#ic_fluent_chat_bubbles_question_16_color__c)"/><path d="M5.15 5.95C5.14 4.82 5.95 4 7 4c1.03 0 1.86.85 1.86 1.95 0 .59-.22.9-.73 1.32l-.28.21c-.24.2-.33.3-.34.45l-.01.16a.5.5 0 0 1-1-.1c0-.56.21-.88.72-1.28l.28-.22c.29-.23.36-.34.36-.54C7.86 5.39 7.48 5 7 5c-.49 0-.86.37-.85.94a.5.5 0 1 1-1 .01Z" fill="url(#ic_fluent_chat_bubbles_question_16_color__d)"/><defs><linearGradient id="ic_fluent_chat_bubbles_question_16_color__b" x1="2" y1="2" x2="12" y2="12" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_chat_bubbles_question_16_color__c" x1="5.47" y1="4.11" x2="7.09" y2="10.42" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient><linearGradient id="ic_fluent_chat_bubbles_question_16_color__d" x1="5.47" y1="4.11" x2="7.09" y2="10.42" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient><radialGradient id="ic_fluent_chat_bubbles_question_16_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(4.60184 5.3384 -5.34296 4.60577 6.68 6.67)"><stop offset=".63" stop-color="#3D35B1"/><stop offset=".85" stop-color="#6553C9"/><stop offset="1" stop-color="#7660D3"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$fe285589ce465c51 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion16Filled', "16", [
    "M5.86 12.9a4.98 4.98 0 0 0 5.25.63l2.3.46a.5.5 0 0 0 .58-.59l-.46-2.29a4.98 4.98 0 0 0-.64-5.25 6.04 6.04 0 0 1 0 2.24 4.01 4.01 0 0 1-.33 2.72.5.5 0 0 0-.04.32l.34 1.72-1.72-.34a.5.5 0 0 0-.32.04 3.98 3.98 0 0 1-2.72.34 6.03 6.03 0 0 1-2.24 0ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25ZM7 4c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32C8.85 4.85 8.03 4 7 4Z"
]);
const $77e1bce0ac0f7fe7$export$b9946b07f87320c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion16Regular', "16", [
    "M7 8.88a.62.62 0 1 1 0 1.25.62.62 0 0 1 0-1.25ZM7 4c1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 0 1-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55C7.85 5.4 7.47 5 7 5c-.5 0-.86.37-.85.95a.5.5 0 0 1-1 0C5.14 4.83 5.95 4 7 4ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm5-4a4 4 0 0 0-3.56 5.82c.05.1.06.21.04.32l-.34 1.72 1.72-.34a.5.5 0 0 1 .32.04A4 4 0 1 0 7 3Zm-1.14 9.9a4.98 4.98 0 0 0 5.25.63l2.3.46a.5.5 0 0 0 .58-.59l-.46-2.29a4.98 4.98 0 0 0-.64-5.25 6.03 6.03 0 0 1 0 2.24 4.01 4.01 0 0 1-.33 2.72.5.5 0 0 0-.04.32l.34 1.72-1.72-.34a.5.5 0 0 0-.32.04 3.98 3.98 0 0 1-2.72.34 6.03 6.03 0 0 1-2.24 0Z"
]);
const $77e1bce0ac0f7fe7$export$384edc7de702e3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion20Color', "20", `<path d="M11.5 5a6.5 6.5 0 0 1 5.67 9.67l.8 2.08a1 1 0 0 1-1.2 1.32l-2.5-.7A6.5 6.5 0 1 1 11.5 5Z" fill="url(#ic_fluent_chat_bubbles_question_20_color__a)"/><path d="M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7A6.5 6.5 0 1 0 8.54 2Z" fill="url(#ic_fluent_chat_bubbles_question_20_color__b)"/><path d="M8.5 6.02c-.37.07-.76.3-1.07.85a.5.5 0 0 1-.86-.5A2.57 2.57 0 0 1 8.3 5.05c.65-.12 1.3.04 1.8.36.48.33.87.85.88 1.48.01.65-.39 1.24-1.12 1.67-.5.3-.7.5-.77.63-.07.11-.09.22-.09.44a.5.5 0 0 1-1 0c0-.27.01-.6.24-.97.2-.33.57-.63 1.11-.96.54-.31.63-.61.63-.8 0-.2-.14-.45-.44-.65-.29-.2-.67-.29-1.05-.22Zm.25 6.6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" fill="url(#ic_fluent_chat_bubbles_question_20_color__c)"/><defs><linearGradient id="ic_fluent_chat_bubbles_question_20_color__b" x1="2" y1="2" x2="15.11" y2="15.04" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_chat_bubbles_question_20_color__c" x1="6.89" y1="5.13" x2="8.96" y2="12.96" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient><radialGradient id="ic_fluent_chat_bubbles_question_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6 7 -7 6 8.5 8.5)"><stop offset=".63" stop-color="#3D35B1"/><stop offset=".85" stop-color="#6553C9"/><stop offset="1" stop-color="#7660D3"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$fd27a0cf70438154 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion20Filled', "20", [
    "M8.5 2a6.5 6.5 0 0 0-5.67 9.67l-.8 2.08a1 1 0 0 0 1.2 1.32l2.5-.7A6.5 6.5 0 1 0 8.5 2Zm0 3.9c-.37.07-.76.3-1.07.85a.5.5 0 1 1-.86-.5A2.57 2.57 0 0 1 8.3 4.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 0 1-1 0c0-.27.01-.61.24-.97.2-.34.57-.64 1.11-.96.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22Zm.25 6.6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm-2.21 3.24a6.49 6.49 0 0 0 7.7 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.47 6.47 0 0 0-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09A5.47 5.47 0 0 1 8.3 16a7.5 7.5 0 0 1-1.76-.26Z"
]);
const $77e1bce0ac0f7fe7$export$85f5ce5c5afbf102 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion20Regular', "20", [
    "M8.5 5.9c-.37.07-.76.3-1.07.85a.5.5 0 1 1-.86-.5A2.57 2.57 0 0 1 8.3 4.92c.65-.13 1.3.04 1.8.36.48.32.87.84.88 1.47.01.66-.39 1.25-1.12 1.68-.5.3-.7.5-.77.63-.07.11-.09.21-.09.44a.5.5 0 0 1-1 0c0-.27.01-.61.24-.97.2-.34.57-.64 1.11-.96.54-.32.63-.62.63-.8 0-.2-.14-.46-.44-.65-.29-.2-.67-.3-1.05-.22Zm.25 6.6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.5 2a6.5 6.5 0 0 0-5.67 9.67l-.8 2.08a1 1 0 0 0 1.2 1.32l2.5-.7A6.5 6.5 0 1 0 8.5 2ZM3 8.5a5.5 5.5 0 1 1 3 4.9l-.18-.09-2.86.8.97-2.53-.13-.21A5.47 5.47 0 0 1 3 8.5Zm8.46 9.5a6.49 6.49 0 0 1-4.92-2.26A7.5 7.5 0 0 0 8.3 16a5.47 5.47 0 0 0 5.66.4l.18-.09 2.86.8-.97-2.53.13-.21A5.47 5.47 0 0 0 16 8.39c0-.6-.1-1.2-.24-1.76a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7c-.84.4-1.78.63-2.78.63Z"
]);
const $77e1bce0ac0f7fe7$export$6b158c77aee5a32e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion24Color', "24", `<path fill-rule="evenodd" clip-rule="evenodd" d="M22 13.5a7.5 7.5 0 1 0-4.41 6.84c1.26.29 2.61.54 3.24.65a1 1 0 0 0 1.15-1.17 68 68 0 0 0-.68-3.15c.45-.96.7-2.04.7-3.17ZM14.52 18h-.04.04Z" fill="url(#ic_fluent_chat_bubbles_question_24_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.47 7.47 0 0 1 2 10.5ZM9.48 15h.04-.04Z" fill="url(#ic_fluent_chat_bubbles_question_24_color__b)"/><path d="M7.1 7.4c.25-.5.6-.86 1.04-1.1a2.83 2.83 0 0 1 3 .28c.5.42.86 1.07.86 1.92 0 .97-.69 1.5-1.08 1.8l-.08.07c-.43.33-.59.5-.59.88a.75.75 0 1 1-1.5 0c0-1.13.71-1.7 1.16-2.06.52-.4.59-.5.59-.7 0-.39-.15-.61-.32-.75-.2-.16-.46-.24-.68-.24-.3 0-.5.05-.65.13-.14.08-.3.21-.44.48a.75.75 0 0 1-1.32-.71ZM9.5 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" fill="url(#ic_fluent_chat_bubbles_question_24_color__c)"/><defs><linearGradient id="ic_fluent_chat_bubbles_question_24_color__b" x1="2" y1="3" x2="17" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_chat_bubbles_question_24_color__c" x1="7.44" y1="6.16" x2="10" y2="15.32" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient><radialGradient id="ic_fluent_chat_bubbles_question_24_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6.90278 8.0094 -8.01592 6.9084 11.03 10)"><stop offset=".63" stop-color="#3D35B1"/><stop offset=".85" stop-color="#6553C9"/><stop offset="1" stop-color="#7660D3"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$caa871aaa02bb661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion24Filled', "24", [
    "M9.5 3a7.5 7.5 0 0 0-6.8 10.67 68.1 68.1 0 0 0-.68 3.15 1 1 0 0 0 1.15 1.17c.63-.11 1.98-.36 3.24-.65A7.5 7.5 0 1 0 9.5 3ZM7.1 7.4c.25-.49.6-.86 1.04-1.1a2.83 2.83 0 0 1 3 .28c.5.42.86 1.07.86 1.92 0 .97-.69 1.5-1.08 1.8a8.4 8.4 0 0 0-.08.07c-.43.33-.59.51-.59.88a.75.75 0 0 1-1.5 0c0-1.13.71-1.7 1.16-2.06.51-.4.59-.5.59-.69 0-.4-.15-.62-.32-.76-.2-.16-.46-.24-.68-.24-.3 0-.5.05-.65.13-.14.08-.3.21-.44.48a.75.75 0 1 1-1.32-.71ZM9.5 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-.1 6a7.47 7.47 0 0 0 8.19 1.34c1.04.24 2.18.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8a7.5 7.5 0 0 0-4.34-10.26c.34.63.61 1.31.8 2.04a6 6 0 0 1 2.08 7.79l-.13.25.07.28.64 2.65-2.74-.61-.27-.07-.24.12a5.97 5.97 0 0 1-5.59-.13A8.52 8.52 0 0 1 9.4 19Z"
]);
const $77e1bce0ac0f7fe7$export$6253e8b8f6840d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion24Regular', "24", [
    "M8.14 6.3a2.83 2.83 0 0 1 2.99.28c.52.42.87 1.07.87 1.92 0 .97-.69 1.5-1.08 1.8l-.08.07c-.43.33-.6.51-.6.88a.75.75 0 1 1-1.5 0c0-1.13.72-1.7 1.17-2.06.51-.4.59-.5.59-.69 0-.4-.15-.62-.32-.76-.2-.16-.46-.24-.68-.24-.3 0-.5.05-.65.13-.14.08-.3.21-.44.48a.75.75 0 0 1-1.32-.71c.26-.49.61-.86 1.05-1.1ZM9.5 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-12a7.5 7.5 0 0 0-6.8 10.67l-.72 2.84c-.24.92.59 1.75 1.5 1.53l2.93-.7A7.5 7.5 0 1 0 9.5 3Zm-6 7.5a6 6 0 1 1 3.33 5.37l-.24-.12-.27.07-2.79.66.7-2.7.06-.28-.13-.25a5.97 5.97 0 0 1-.66-2.75Zm11 10.5a7.47 7.47 0 0 1-5.1-2 8.28 8.28 0 0 0 2.18-.26 5.97 5.97 0 0 0 5.59.13l.24-.12.27.07c.92.22 1.96.44 2.74.6-.18-.74-.42-1.75-.65-2.64l-.07-.28.14-.25a5.97 5.97 0 0 0-2.09-7.8 8.44 8.44 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.58 1.7-1.47 1.5-.73-.15-1.87-.39-2.91-.63-.95.42-2 .66-3.1.66Z"
]);
const $77e1bce0ac0f7fe7$export$bfcf31af20589fcb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion28Filled', "28", [
    "M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3Zm0 14.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM9.5 9.26A.75.75 0 0 1 8 9.25v-.02a1.61 1.61 0 0 1 0-.13 2.94 2.94 0 0 1 .38-1.22C8.78 7.15 9.6 6.5 11 6.5c1.4 0 2.21.65 2.62 1.38A3.02 3.02 0 0 1 14 9.2v.05c0 1.12-.7 1.88-1.2 2.43l-.12.13c-.54.61-.93 1.11-.93 1.94a.75.75 0 0 1-1.5 0c0-1.42.74-2.3 1.32-2.94l.02-.02c.6-.68.9-1.01.91-1.53a1.53 1.53 0 0 0-.18-.64C12.16 8.35 11.85 8 11 8c-.85 0-1.16.35-1.32.62a1.52 1.52 0 0 0-.18.64ZM17 25a8.98 8.98 0 0 1-6.73-3.03 10.08 10.08 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.93 9.93 0 0 0-.75-1.98 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A8.97 8.97 0 0 1 17 25ZM12.5 9.26"
]);
const $77e1bce0ac0f7fe7$export$492bd53f02edccb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion28Regular', "28", [
    "M3.5 12a7.5 7.5 0 1 1 3.9 6.59.75.75 0 0 0-.54-.07l-3.26.87.88-3.25a.75.75 0 0 0-.07-.55A7.46 7.46 0 0 1 3.5 12ZM11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3Zm6 22a8.98 8.98 0 0 1-6.73-3.03 10.08 10.08 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.93 9.93 0 0 0-.75-1.98 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A8.97 8.97 0 0 1 17 25Zm-5-8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9.5 9.26v-.04l.02-.14c.03-.14.08-.3.16-.46.16-.27.47-.62 1.32-.62.85 0 1.16.35 1.32.62a1.52 1.52 0 0 1 .18.63c0 .53-.3.86-.91 1.54l-.02.02a4.19 4.19 0 0 0-1.32 2.94.75.75 0 0 0 1.5 0c0-.83.39-1.33.93-1.94l.13-.13c.5-.55 1.19-1.3 1.19-2.43V9.2a2.22 2.22 0 0 0-.05-.4 3.02 3.02 0 0 0-.33-.92C13.22 7.15 12.4 6.5 11 6.5c-1.4 0-2.21.65-2.62 1.38A3.02 3.02 0 0 0 8 9.23v.02a.75.75 0 0 0 1.5 0Z"
]);
const $77e1bce0ac0f7fe7$export$40299383627f9f7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion32Filled', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3Zm1.95 22.34a12.08 12.08 0 0 1-2.8.13 10.47 10.47 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.44 10.44 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7.36.86.63 1.77.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.46 8.46 0 0 1-9.14-.62ZM11.5 15c0-1.66.88-2.66 1.6-3.48l.02-.02c.56-.64.88-1.02.88-1.5-.01-.29-.18-1-1.5-1-1.43 0-1.5.83-1.5 1a1 1 0 0 1-1 1 1 1 0 0 1-1-1c0-1.21.93-3 3.5-3S16 8.79 16 10s-.73 2.09-1.38 2.83l-.02.02c-.59.67-1.1 1.25-1.1 2.15a1 1 0 0 1-1 1 1 1 0 0 1-1-1Zm2.25 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
]);
const $77e1bce0ac0f7fe7$export$dae9e9e67d6bd272 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatBubblesQuestion32Regular', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3ZM5.05 17.59a8.5 8.5 0 1 1 3.36 3.36 1 1 0 0 0-.75-.09l-3.45.93.93-3.46a1 1 0 0 0-.1-.74Zm9.4 7.75a12.08 12.08 0 0 1-2.8.13 10.47 10.47 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.44 10.44 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7.36.86.63 1.77.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.46 8.46 0 0 1-9.14-.62ZM11.5 15a1 1 0 0 0 1 1 1 1 0 0 0 1-1c0-.9.51-1.48 1.1-2.15l.02-.02C15.27 12.09 16 11.21 16 10s-.93-3-3.5-3S9 8.79 9 10a1 1 0 0 0 1 1 1 1 0 0 0 1-1c0-.17.07-1 1.5-1 1.32 0 1.49.71 1.5 1 0 .48-.32.86-.88 1.5l-.02.02c-.72.82-1.6 1.82-1.6 3.48Zm2.25 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
]);
const $77e1bce0ac0f7fe7$export$cb87b173cb230de1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor16Filled', "16", [
    "M2 6a5 5 0 1 1 9.89 1.06L9.86 5.4A1.75 1.75 0 0 0 7 6.75V11c-.87 0-1.7-.22-2.4-.62l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A4.98 4.98 0 0 1 2 6Zm7.23.17 5.5 4.5a.75.75 0 0 1-.48 1.33h-2.99a.5.5 0 0 0-.4.2l-1.51 2A.75.75 0 0 1 8 13.75v-7l.01-.11a.75.75 0 0 1 1.22-.47Z"
]);
const $77e1bce0ac0f7fe7$export$582db7b65d91598a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor16Regular', "16", [
    "M2 6a5 5 0 1 1 9.89 1.06l-.9-.74L11 6a4 4 0 1 0-7.42 2.08c.08.12.1.27.05.4l-.38 1.26 1.26-.38a.5.5 0 0 1 .4.05C5.52 9.8 6.23 10 7 10v1c-.87 0-1.7-.22-2.4-.62l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A4.98 4.98 0 0 1 2 6Zm12.72 4.67a.75.75 0 0 1-.47 1.33h-3a.5.5 0 0 0-.39.2l-1.51 2A.75.75 0 0 1 8 13.75v-7c0-.63.73-.98 1.22-.58l5.5 4.5Z"
]);
const $77e1bce0ac0f7fe7$export$4fda91566e0bcb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor20Filled', "20", [
    "M8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2a5.97 5.97 0 0 0 4 .73V8.75c0-1.5 1.74-2.3 2.88-1.34l1.8 1.53A6 6 0 0 0 8 1Zm2 7.75v9a.75.75 0 0 0 1.37.42l1.98-2.95a.5.5 0 0 1 .42-.22h3.48c.7 0 1.02-.87.49-1.32l-6.5-5.5a.75.75 0 0 0-1.24.57Z"
]);
const $77e1bce0ac0f7fe7$export$bb6cf7c4aace8170 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor20Regular', "20", [
    "M8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2a5.97 5.97 0 0 0 4 .73V11.9a5.02 5.02 0 0 1-3.67-.67.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39 5 5 0 1 1 9.15-1.32l.83.7A6 6 0 0 0 8 1Zm2 7.75v9a.75.75 0 0 0 1.37.42l1.98-2.95a.5.5 0 0 1 .42-.22h3.48c.7 0 1.02-.87.49-1.32l-6.5-5.5a.75.75 0 0 0-1.24.57Z"
]);
const $77e1bce0ac0f7fe7$export$d59f18b6bc05dac9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor24Filled', "24", [
    "M12 11a1 1 0 0 1 1.6-.8l8 6A1 1 0 0 1 21 18h-4.4a1 1 0 0 0-.88.53l-1.84 3.44c-.49.92-1.88.57-1.88-.47V11ZM10 1a8 8 0 0 1 7.47 10.85L14.2 9.4A2 2 0 0 0 11 11v5.94a8.07 8.07 0 0 1-4.64-.82l-3.43.86a.75.75 0 0 1-.9-.91l.85-3.43A8 8 0 0 1 10 1Z"
]);
const $77e1bce0ac0f7fe7$export$7ef7233c8185aa30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatCursor24Regular', "24", [
    "M12 11a1 1 0 0 1 1.6-.8l8 6A1 1 0 0 1 21 18h-4.4a1 1 0 0 0-.88.53l-1.84 3.44c-.49.92-1.88.57-1.88-.47V11ZM10 1a8 8 0 0 1 7.47 10.85l-1.26-.94a6.5 6.5 0 1 0-11.88 1.27c.1.16.12.36.07.55l-.62 2.49 2.5-.62.13-.03c.14 0 .29.03.41.1a6.47 6.47 0 0 0 4.18.75v1.52a8.07 8.07 0 0 1-4.64-.82l-3.43.86a.75.75 0 0 1-.9-.91l.85-3.43A8 8 0 0 1 10 1Z"
]);
const $77e1bce0ac0f7fe7$export$3cf96f821c375556 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss16Filled', "16", [
    "M2 8a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 2 8Zm3.9-2.1-.06.07a.5.5 0 0 0 .06.63L7.3 8 5.9 9.4l-.06.07a.5.5 0 0 0 .06.63l.07.06c.2.14.46.12.63-.06L8 8.7l1.4 1.4.07.06c.2.14.46.12.63-.06l.06-.07a.5.5 0 0 0-.06-.63L8.7 8l1.4-1.4.06-.07a.5.5 0 0 0-.06-.63l-.07-.06a.5.5 0 0 0-.63.06L8 7.3 6.6 5.9l-.07-.06a.5.5 0 0 0-.63.06Z"
]);
const $77e1bce0ac0f7fe7$export$4c952bf9e55d0014 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss16Regular', "16", [
    "m5.9 5.9-.06.07a.5.5 0 0 0 .06.63L7.3 8 5.9 9.4l-.06.07a.5.5 0 0 0 .06.63l.07.06c.2.14.46.12.63-.06L8 8.7l1.4 1.4.07.06c.2.14.46.12.63-.06l.06-.07a.5.5 0 0 0-.06-.63L8.7 8l1.4-1.4.06-.07a.5.5 0 0 0-.06-.63l-.07-.06a.5.5 0 0 0-.63.06L8 7.3 6.6 5.9l-.07-.06a.5.5 0 0 0-.63.06ZM8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2A6 6 0 1 0 8 2ZM3 8a5 5 0 1 1 2.33 4.23.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A4.97 4.97 0 0 1 3 8Z"
]);
const $77e1bce0ac0f7fe7$export$8f3a4c52c95cfb77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10ZM7.85 7.15 10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 1 1 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$9dfc798f37d2e71e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss20Regular', "20", [
    "M7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15ZM18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10ZM3 10a7 7 0 1 1 3.58 6.1l-.09-.03-.1-.02a.5.5 0 0 0-.18 0l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A6.97 6.97 0 0 1 3 10Z"
]);
const $77e1bce0ac0f7fe7$export$d9457806d8e3f0e3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss24Filled', "24", [
    "M22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12ZM9.28 8.22 12 10.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L13.06 12l2.72 2.72a.75.75 0 1 1-1.06 1.06L12 13.06l-2.72 2.72a.75.75 0 0 1-1.06-1.06L10.94 12 8.22 9.28a.75.75 0 0 1 1.06-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$691b5468c2e72004 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatDismiss24Regular', "24", [
    "M9.28 8.22a.75.75 0 0 0-1.06 1.06L10.94 12l-2.72 2.72a.75.75 0 1 0 1.06 1.06L12 13.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L13.06 12l2.72-2.72a.75.75 0 0 0-1.06-1.06L12 10.94 9.28 8.22ZM22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12ZM3.5 12a8.5 8.5 0 1 1 4.37 7.43l-.27-.15-3.99 1.11 1.11-3.98-.15-.27A8.46 8.46 0 0 1 3.5 12Z"
]);
const $77e1bce0ac0f7fe7$export$fb554a607c09a800 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty12Filled', "12", [
    "M6 1a5 5 0 0 0-4.39 7.4l-.59 1.95a.5.5 0 0 0 .63.62l1.94-.59A5 5 0 1 0 6 1Z"
]);
const $77e1bce0ac0f7fe7$export$4b7df8920b77ede4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty12Regular', "12", [
    "M1 6a5 5 0 1 1 2.6 4.38l-1.95.6a.5.5 0 0 1-.63-.63l.6-1.95A4.98 4.98 0 0 1 1 6Zm5-4a4 4 0 0 0-3.42 6.08c.08.12.1.27.05.4l-.38 1.26 1.26-.38a.5.5 0 0 1 .4.05A4 4 0 1 0 6 2Z"
]);
const $77e1bce0ac0f7fe7$export$1232cd5562674a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty16Filled', "16", [
    "M2 8a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 2 8Z"
]);
const $77e1bce0ac0f7fe7$export$1394d9e48daac3f2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty16Regular', "16", [
    "M2 8a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 2 8Zm6-5a5 5 0 0 0-4.3 7.55.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06A5 5 0 1 0 8 3Z"
]);
const $77e1bce0ac0f7fe7$export$1411e8bf0b4d84d2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10Z"
]);
const $77e1bce0ac0f7fe7$export$6b4675ae05032a1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 10 3Z"
]);
const $77e1bce0ac0f7fe7$export$662f7176cfc333bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12A10 10 0 0 0 22 12Z"
]);
const $77e1bce0ac0f7fe7$export$e2e509debfe15a9a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2Zm0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5Z"
]);
const $77e1bce0ac0f7fe7$export$906cc77d5b44ea14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty28Filled', "28", [
    "M2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14Z"
]);
const $77e1bce0ac0f7fe7$export$392ac74865d2856e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty28Regular', "28", [
    "M14 3.5a10.5 10.5 0 0 0-9.14 15.68c.1.17.13.38.07.57L3.61 24.4l4.64-1.32c.2-.06.4-.03.57.07A10.5 10.5 0 1 0 14 3.5ZM2 14a12 12 0 1 1 6.36 10.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77C2.5 17.96 2 16.04 2 14Z"
]);
const $77e1bce0ac0f7fe7$export$f5c6b0f93292510f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty32Filled', "32", [
    "M2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A13.94 13.94 0 0 1 2 16Z"
]);
const $77e1bce0ac0f7fe7$export$2e627e8de476eaa8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty32Regular', "32", [
    "M16 4A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1A12 12 0 1 0 16 4ZM2 16a14 14 0 1 1 7.44 12.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A13.94 13.94 0 0 1 2 16Z"
]);
const $77e1bce0ac0f7fe7$export$203c1b9f6c042855 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty48Filled', "48", [
    "M4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A19.92 19.92 0 0 1 4 24Z"
]);
const $77e1bce0ac0f7fe7$export$9319f2b204a39ebb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatEmpty48Regular', "48", [
    "M24 6.5A17.5 17.5 0 0 0 8.84 32.74c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11c.33-.1.68-.05.97.12A17.5 17.5 0 1 0 24 6.5ZM4 24a20 20 0 1 1 10.47 17.59l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A19.92 19.92 0 0 1 4 24Z"
]);
const $77e1bce0ac0f7fe7$export$40c96fd8d85a590 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp20Filled', "20", [
    "M2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A7.97 7.97 0 0 1 2 10Zm7.25-2.7c.15-.17.39-.3.75-.3s.6.13.75.3c.16.2.25.44.25.7 0 .32-.07.52-.17.69-.1.17-.23.3-.42.5l-.02.03c-.19.2-.42.44-.6.78-.18.35-.29.76-.29 1.3a.5.5 0 1 0 1 0c0-.4.08-.64.18-.84.1-.2.24-.35.43-.55l.04-.04c.17-.18.38-.4.55-.68.18-.32.3-.7.3-1.19a1.95 1.95 0 0 0-2-2 1.95 1.95 0 0 0-2 2 .5.5 0 0 0 1 0c0-.26.09-.5.25-.7Zm1.45 6.21a.7.7 0 1 0-1.4 0 .7.7 0 0 0 1.4 0Z"
]);
const $77e1bce0ac0f7fe7$export$a36eabf02991c5ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp20Regular', "20", [
    "M9.25 7.3c-.16.2-.25.44-.25.7a.5.5 0 0 1-1 0 1.95 1.95 0 0 1 2-2 1.95 1.95 0 0 1 2 2c0 .49-.12.87-.3 1.19-.17.28-.38.5-.55.68l-.04.04c-.19.2-.33.35-.43.55-.1.2-.18.45-.18.83a.5.5 0 1 1-1 0 2.71 2.71 0 0 1 .89-2.07l.02-.02c.19-.2.32-.34.42-.51.1-.17.17-.37.17-.69 0-.26-.09-.5-.25-.7A.95.95 0 0 0 10 7c-.36 0-.6.13-.75.3Zm.75 6.91a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4ZM2 10a8 8 0 1 1 4.26 7.07L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A7.97 7.97 0 0 1 2 10Zm8-7a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05A7 7 0 1 0 10 3Z"
]);
const $77e1bce0ac0f7fe7$export$632383b1e2107c2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp24Filled', "24", [
    "M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm0 13.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-8.75A2.75 2.75 0 0 0 9.25 9.5a.75.75 0 0 0 1.5.1v-.23a1.25 1.25 0 0 1 2.5.13c0 .54-.13.8-.64 1.33l-.3.31c-.76.79-1.06 1.35-1.06 2.36a.75.75 0 0 0 1.5 0c0-.54.13-.8.64-1.33l.3-.31c.76-.79 1.06-1.35 1.06-2.36A2.75 2.75 0 0 0 12 6.75Z"
]);
const $77e1bce0ac0f7fe7$export$4449a2d9673d706a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHelp24Regular', "24", [
    "M12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2Zm0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5Zm0 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-8.75a2.75 2.75 0 0 1 2.75 2.75c0 1.01-.3 1.57-1.05 2.36l-.17.17c-.62.62-.78.89-.78 1.47a.75.75 0 0 1-1.5 0c0-1.01.3-1.57 1.05-2.36l.17-.17c.62-.62.78-.89.78-1.47a1.25 1.25 0 0 0-2.5-.13v.13a.75.75 0 0 1-1.5 0A2.75 2.75 0 0 1 12 6.75Z"
]);
const $77e1bce0ac0f7fe7$export$95d192396ff74135 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf16Filled', "16", [
    "M2.6 5.4a.5.5 0 0 1 .9.43 5.04 5.04 0 0 0-.36.98 5.02 5.02 0 0 0 .56 3.74.5.5 0 0 1 .05.4l-.5 1.77 1.65-.55a.5.5 0 0 1 .43.05 4.97 4.97 0 0 0 5.93-.43.5.5 0 1 1 .65.76l-.35.28a5.97 5.97 0 0 1-6.56.36l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5a5.98 5.98 0 0 1-.14-5.48Zm8.23 5.43A3.99 3.99 0 0 1 4 8c0-1.1.45-2.1 1.17-2.83l5.66 5.66Zm2.69-2.92a.5.5 0 0 1 .46.53 6.04 6.04 0 0 1-.58 2.17.5.5 0 0 1-.9-.44 5.04 5.04 0 0 0 .48-1.8.5.5 0 0 1 .54-.46Zm-1.68-3.88a.5.5 0 0 1 .7.05c.5.57.87 1.23 1.12 1.94a.5.5 0 0 1-.94.33c-.21-.59-.53-1.14-.94-1.61a.5.5 0 0 1 .06-.71Zm-5.82-1.7a.5.5 0 0 1 .33.95c-.6.2-1.14.52-1.62.93a.5.5 0 0 1-.65-.76c.57-.49 1.23-.87 1.94-1.11Zm2.42-.31a6.03 6.03 0 0 1 2.16.58.5.5 0 0 1-.43.9A5.03 5.03 0 0 0 8.37 3a.5.5 0 0 1 .07-1Z"
]);
const $77e1bce0ac0f7fe7$export$5fc1e6afaefc2aca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf16Regular', "16", [
    "M2.6 5.4a.5.5 0 0 1 .9.43 5.04 5.04 0 0 0 .2 4.72.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06 4.97 4.97 0 0 0 5.36-.02c.2-.13.4-.27.57-.42a.5.5 0 1 1 .65.76l-.35.28a5.97 5.97 0 0 1-6.56.36l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5a5.98 5.98 0 0 1-.14-5.48Zm10.92 2.5a.5.5 0 0 1 .46.54 6.04 6.04 0 0 1-.58 2.17.5.5 0 0 1-.9-.43 5.04 5.04 0 0 0 .48-1.81.5.5 0 0 1 .54-.46Zm-1.68-3.87a.5.5 0 0 1 .7.05c.5.57.87 1.23 1.12 1.94a.5.5 0 1 1-.94.33c-.21-.59-.53-1.14-.94-1.61a.5.5 0 0 1 .06-.7Zm-5.82-1.7a.5.5 0 0 1 .33.95c-.6.2-1.14.52-1.62.93a.5.5 0 0 1-.65-.75c.57-.5 1.23-.88 1.94-1.12Zm2.42-.31a6.04 6.04 0 0 1 2.16.58.5.5 0 0 1-.43.9A5.03 5.03 0 0 0 8.37 3a.5.5 0 0 1 .07-1Z"
]);
const $77e1bce0ac0f7fe7$export$456e5ab8de979a02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf20Filled', "20", [
    "M3.35 5.56a.48.48 0 0 1 .73-.06c.18.18.2.46.06.66a6.97 6.97 0 0 0-.25 7.26.5.5 0 0 1 .05.37L3.2 16.8l3.02-.75.1-.02c.09 0 .18.02.27.07a6.96 6.96 0 0 0 7.25-.25.53.53 0 0 1 .67.05c.22.22.2.57-.06.74a8.07 8.07 0 0 1-8.18.42L2.62 18a.5.5 0 0 1-.6-.61l.9-3.65a7.96 7.96 0 0 1 .13-7.69l.3-.48Zm10.9 8.68a5.98 5.98 0 0 1-6.94 1.12l-.1-.05-.34-.18-.34-.18-1.97.49.4-1.6.1-.36-.37-.68-.06-.11a6.04 6.04 0 0 1 1.13-6.93l8.48 8.48ZM17.35 11c.3 0 .54.27.48.56a7.95 7.95 0 0 1-1.19 2.88.48.48 0 0 1-.74.06.53.53 0 0 1-.05-.67c.47-.72.81-1.53 1-2.4a.53.53 0 0 1 .5-.43Zm-1.45-5.5c.22-.22.57-.2.74.06.58.86.99 1.83 1.2 2.88.05.3-.18.56-.49.56a.53.53 0 0 1-.5-.43 6.96 6.96 0 0 0-1-2.4.53.53 0 0 1 .05-.67ZM8.44 2.16c.3-.06.56.17.56.48 0 .25-.18.46-.43.5-.87.19-1.68.53-2.4 1a.53.53 0 0 1-.67-.06.48.48 0 0 1 .06-.73 7.95 7.95 0 0 1 2.88-1.2Zm3.12 0c1.05.2 2.02.61 2.88 1.19.25.17.27.52.06.73a.53.53 0 0 1-.67.06 6.96 6.96 0 0 0-2.4-1 .53.53 0 0 1-.43-.5c0-.3.27-.54.56-.48Z"
]);
const $77e1bce0ac0f7fe7$export$8da65b16c1b79736 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf20Regular', "20", [
    "M3.35 5.56a.48.48 0 0 1 .73-.06c.18.18.2.46.06.66a6.97 6.97 0 0 0-.25 7.26.5.5 0 0 1 .05.37L3.2 16.8l3.02-.75.1-.02c.09 0 .18.02.27.07a6.97 6.97 0 0 0 7.25-.25c.21-.14.5-.12.67.05.21.22.2.57-.06.74a8.05 8.05 0 0 1-8.18.42L2.62 18a.5.5 0 0 1-.6-.61l.9-3.65a7.97 7.97 0 0 1 .43-8.17ZM17.36 11c.3 0 .54.27.48.56a7.95 7.95 0 0 1-1.19 2.88.48.48 0 0 1-.74.06.53.53 0 0 1-.05-.67c.47-.72.81-1.53 1-2.4a.53.53 0 0 1 .5-.43Zm-1.45-5.5c.22-.21.57-.2.74.06.58.86.99 1.83 1.2 2.88.05.3-.18.56-.49.56a.53.53 0 0 1-.5-.43 6.96 6.96 0 0 0-1-2.4.53.53 0 0 1 .05-.67ZM8.44 2.16c.3-.06.56.17.56.47 0 .26-.18.47-.43.52-.87.18-1.68.52-2.4 1a.53.53 0 0 1-.67-.07.48.48 0 0 1 .06-.73 7.95 7.95 0 0 1 2.88-1.2Zm3.12 0c1.05.2 2.02.62 2.88 1.19.25.17.27.52.06.74a.53.53 0 0 1-.67.05 6.96 6.96 0 0 0-2.4-1 .53.53 0 0 1-.43-.5c0-.3.27-.54.56-.48Z"
]);
const $77e1bce0ac0f7fe7$export$715449ad7d9cba10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf24Filled', "24", [
    "M3.58 6.62a.75.75 0 0 1 1.26.8 8.53 8.53 0 0 0-.27 8.72l.15.27-1.1 3.98 3.98-1.11.27.15a8.46 8.46 0 0 0 8.61-.2.75.75 0 0 1 .79 1.27 9.98 9.98 0 0 1-9.86.39L3.6 21.95a1.25 1.25 0 0 1-1.54-1.54L3.1 16.6a9.96 9.96 0 0 1 .47-9.97ZM16.9 17.68a7.47 7.47 0 0 1-8.38.96l-.86-.44-.56.14-1.94.5.65-2.5-.45-.85-.2-.4A7.47 7.47 0 0 1 6.4 7l10.5 10.67Zm3.38-3.73a.75.75 0 0 1 1.46.34 10.08 10.08 0 0 1-1.3 3.09.75.75 0 0 1-1.27-.8 8.57 8.57 0 0 0 1.11-2.63Zm-.8-7.46a.75.75 0 0 1 1.03.25c.6.95 1.02 2 1.26 3.1a.75.75 0 0 1-1.46.33 8.56 8.56 0 0 0-1.07-2.64.75.75 0 0 1 .24-1.04ZM13.4 2.82c.1-.4.5-.65.9-.56a10.06 10.06 0 0 1 3.09 1.3.75.75 0 0 1-.8 1.27 8.57 8.57 0 0 0-2.64-1.1.75.75 0 0 1-.55-.91Zm-3.55-.59a.75.75 0 0 1 .32 1.47c-.93.2-1.82.57-2.64 1.07a.75.75 0 0 1-.78-1.28c.95-.59 2-1.01 3.1-1.26Z"
]);
const $77e1bce0ac0f7fe7$export$f5291f4b936301e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHintHalf24Regular', "24", [
    "M3.58 6.62a.75.75 0 0 1 1.26.8 8.53 8.53 0 0 0-.27 8.72l.15.27-1.1 3.98 3.98-1.11.27.15a8.46 8.46 0 0 0 8.61-.2.75.75 0 0 1 .79 1.27 9.98 9.98 0 0 1-9.86.39L3.6 21.95a1.25 1.25 0 0 1-1.54-1.54L3.1 16.6a9.96 9.96 0 0 1 .47-9.97Zm16.7 7.33a.75.75 0 0 1 1.46.34 10.08 10.08 0 0 1-1.3 3.09.75.75 0 0 1-1.27-.8 8.57 8.57 0 0 0 1.11-2.63Zm-.8-7.46a.75.75 0 0 1 1.03.25c.6.95 1.02 2 1.26 3.1a.75.75 0 0 1-1.46.33 8.56 8.56 0 0 0-1.07-2.64.75.75 0 0 1 .24-1.04ZM13.4 2.82c.1-.4.5-.65.9-.56a10.06 10.06 0 0 1 3.09 1.3.75.75 0 0 1-.8 1.27 8.57 8.57 0 0 0-2.64-1.1.75.75 0 0 1-.55-.91Zm-3.55-.59a.75.75 0 0 1 .32 1.47c-.93.2-1.82.57-2.64 1.07a.75.75 0 0 1-.78-1.28c.95-.59 2-1.01 3.1-1.26Z"
]);
const $77e1bce0ac0f7fe7$export$37bd94366a91a79d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10c0-.55.06-1.08.16-1.6a.5.5 0 0 1 .61-.4c.31.09.42.4.36.68l-.01.04a7.04 7.04 0 0 0 .77 4.7.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 4.26 6H6.5a.5.5 0 0 1 0 .99h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.2A7.98 7.98 0 0 1 10 2ZM4.34 8A5.99 5.99 0 0 0 4 9.98v.28l.03.31c.07.75.27 1.47.6 2.13l.42.78-.49 1.96 1.97-.5.78.42a6 6 0 1 0-.64-10.35A1.5 1.5 0 0 1 6.5 8H4.34ZM10 7.5V11h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0Z"
]);
const $77e1bce0ac0f7fe7$export$2beb2520a00c22b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10c0-.55.06-1.08.16-1.6a.5.5 0 0 1 .61-.4c.31.09.42.4.36.68l-.01.04a7.04 7.04 0 0 0 .77 4.7.5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 4.26 6H6.5a.5.5 0 0 1 0 .99h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.2A7.98 7.98 0 0 1 10 2Zm0 5.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V7.5Z"
]);
const $77e1bce0ac0f7fe7$export$81a07057e33f92f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory24Filled', "24", [
    "M22 12A10 10 0 0 0 5 4.86V3.75a.75.75 0 0 0-1.5 0v3.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H5.52a8.5 8.5 0 1 1 2.35 12.93l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.46 8.46 0 0 1-.84-6.1c.08-.3.06-.89-.54-1.02-.61-.14-.87.35-.93.72a10.03 10.03 0 0 0 .85 6.85l-1.06 3.83a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12ZM8.17 5.55a7.5 7.5 0 1 1 .18 13l-.62-.34-2.68.74.75-2.67-.35-.63a7.46 7.46 0 0 1-.75-5.37A2.04 2.04 0 0 0 4.6 9h3.15a1.75 1.75 0 0 0 .42-3.45ZM11.25 8a.75.75 0 0 0-.75.75v4.5c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5H12V8.75a.75.75 0 0 0-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$8c0a6a0f0a2b2351 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory24Regular', "24", [
    "M22 12A10 10 0 0 0 5 4.86V3.75a.75.75 0 0 0-1.5 0v3.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H5.52a8.5 8.5 0 1 1 2.35 12.93l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.46 8.46 0 0 1-.84-6.1c.08-.3.06-.89-.54-1.02-.61-.14-.87.35-.93.72a10.03 10.03 0 0 0 .85 6.85l-1.06 3.83a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12ZM12 8.75a.75.75 0 0 0-1.5 0v4.5c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5H12V8.75Z"
]);
const $77e1bce0ac0f7fe7$export$aa5a05e47898beb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory28Filled', "28", [
    "M5.5 4.25v1.28A12 12 0 1 1 8.36 24.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A11.95 11.95 0 0 1 2.17 12c.25-1.31.6-2.18 1.33-1.97.7.2.51.84.32 1.5l-.14.52a10.56 10.56 0 0 0 1.18 7.13c.1.17.13.38.07.57L3.61 24.4l4.64-1.32c.2-.06.4-.03.57.07A10.5 10.5 0 1 0 5.75 7.5h3a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 4 8.25v-4a.75.75 0 0 1 1.5 0ZM8.75 6.5h-.58a9.5 9.5 0 1 1 1.15 15.77c-.4-.23-.9-.3-1.34-.16l-2.91.82.82-2.9c.13-.45.07-.94-.16-1.35a9.45 9.45 0 0 1-.95-6.88l.02-.05c.08-.28.22-.76.2-1.2a1.71 1.71 0 0 0-.13-.55h3.88a1.75 1.75 0 1 0 0-3.5ZM14 9.75a.75.75 0 0 0-1.5 0v6c0 .41.34.75.75.75h4a.75.75 0 0 0 0-1.5H14V9.75Z"
]);
const $77e1bce0ac0f7fe7$export$2f9769b66ea7cd52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatHistory28Regular', "28", [
    "M5.5 5.53V4.25a.75.75 0 0 0-1.5 0v4c0 .41.34.75.75.75h4a.75.75 0 0 0 0-1.5h-3a10.5 10.5 0 1 1 3.07 15.64.75.75 0 0 0-.57-.07L3.6 24.39l1.32-4.64c.06-.19.03-.4-.07-.57a10.45 10.45 0 0 1-1.18-7.13l.14-.52c.2-.66.38-1.3-.32-1.5-.72-.21-1.08.66-1.33 1.97a12.08 12.08 0 0 0 1.24 7.64l-1.36 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35A12 12 0 1 0 5.5 5.53ZM13.25 9c.41 0 .75.34.75.75V15h3.25a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75v-6c0-.41.34-.75.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$43aa8aafd43e9252 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock16Filled', "16", [
    "M7 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L4 12.2c.88.52 1.9.81 3 .81v-3a2 2 0 0 1 1.5-1.94V8a3 3 0 0 1 4.25-2.73A6 6 0 0 0 7 1Zm2.5 8V8a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5Zm1-1v1h2V8a1 1 0 1 0-2 0Zm1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
]);
const $77e1bce0ac0f7fe7$export$8e7824cc01c397f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock16Regular', "16", [
    "M7 12c-.98 0-1.9-.28-2.67-.77a.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A5 5 0 1 1 11.59 5c.4.01.8.1 1.16.27a6 6 0 1 0-11.02 4.6l-.71 2.5a.5.5 0 0 0 .64.6L4 12.2c.88.52 1.9.81 3 .81v-1Zm2.5-4v1H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V8a2 2 0 1 0-4 0Zm1 1V8a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$a920119f100f975c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a7.97 7.97 0 0 0 4.61.8V14a2 2 0 0 1 1.5-1.94V12a3 3 0 0 1 5.5-1.67V10Zm-4.5 2v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$bee39e0d1682b3d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock20Regular', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a7.97 7.97 0 0 0 4.61.8v-1.01a7.06 7.06 0 0 1-4.42-.82l-.09-.04-.1-.02a.5.5 0 0 0-.18 0l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27 7 7 0 1 1 13.08-4.04c.41.24.76.56 1.02.95L18 10Zm-4.5 2v1H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$d8b57a3602f8d695 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12a9.96 9.96 0 0 0 5.68 1.09 2.5 2.5 0 0 1-.04-.45v-5a2.5 2.5 0 0 1 2-2.45V14a3.5 3.5 0 0 1 6.92-.74c.05-.41.08-.83.08-1.26Zm-6 3h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-5 0v1Zm1.5-1a1 1 0 1 1 2 0v1h-2v-1Zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
]);
const $77e1bce0ac0f7fe7$export$69df91f684d6a8bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock24Regular', "24", [
    "M22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07a9.96 9.96 0 0 0 5.63 1.06 2.5 2.5 0 0 1-.04-.45v-1.06a8.6 8.6 0 0 1-5.13-1.01l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 1 1 15.88-5.04 3.5 3.5 0 0 1 1.47 2.16c.05-.41.08-.83.08-1.26Zm-6 3h-.5c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H21v-1a2.5 2.5 0 0 0-5 0v1Zm1.5-1a1 1 0 1 1 2 0v1h-2v-1Zm2 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
]);
const $77e1bce0ac0f7fe7$export$f216205bfff363e7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock28Filled', "28", [
    "M14 2A12 12 0 0 0 3.4 19.64l-1.35 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35a11.95 11.95 0 0 0 6.8 1.35A3 3 0 0 1 15 25v-5a3 3 0 0 1 2.5-2.96V17a4 4 0 0 1 8 0v.04l.1.02A12.02 12.02 0 0 0 14 2Zm4.5 16H18a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-.5v-1a3 3 0 1 0-6 0v1Zm1.5-1a1.5 1.5 0 0 1 3 0v1h-3v-1Zm3 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
]);
const $77e1bce0ac0f7fe7$export$68fdb4933134e0e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatLock28Regular', "28", [
    "M14 24.5c-1.78 0-3.46-.44-4.93-1.23a1.5 1.5 0 0 0-1.12-.12L3.61 24.4l1.24-4.34c.1-.37.06-.77-.12-1.12a10.5 10.5 0 1 1 19.77-4.59c.62.71 1 1.64 1 2.66v.04l.1.02A12.02 12.02 0 0 0 14 2 12 12 0 0 0 3.4 19.64l-1.35 4.77c-.27.94.6 1.81 1.54 1.54l4.77-1.35a11.95 11.95 0 0 0 6.8 1.35A3 3 0 0 1 15 25v-.55c-.33.03-.66.05-1 .05Zm4.5-6.5H18a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-.5v-1a3 3 0 1 0-6 0v1Zm1.5-1a1.5 1.5 0 0 1 3 0v1h-3v-1Zm3 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
]);
const $77e1bce0ac0f7fe7$export$56fb7398967aea23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMail20Filled', "20", [
    "M2 7a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 2 7Zm4.5-1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm2 2h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1Z",
    "m12.28 14.95-2.4-1.2c.43-.13.86-.29 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 0 0-1-1h-1.67c.15-.32.28-.65.38-1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.07c.33.05.66.07 1 .07v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.2l-4.28 2.15a.5.5 0 0 1-.44 0Z"
]);
const $77e1bce0ac0f7fe7$export$8bac20b3f2f5722e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMail20Regular', "20", [
    "M6 6c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 6Zm.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM8 1a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 12.2A6 6 0 1 0 8 1ZM3 7a5 5 0 1 1 2.33 4.23.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A4.97 4.97 0 0 1 3 7Zm9.28 7.95-2.4-1.2c.43-.13.86-.29 1.26-.5l1.36.7 4.5-2.26V11a1 1 0 0 0-1-1h-1.67c.15-.32.28-.65.38-1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2.07c.33.05.66.07 1 .07v2a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-3.2l-4.28 2.15a.5.5 0 0 1-.44 0Z"
]);
const $77e1bce0ac0f7fe7$export$fbadb733dfb3381a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMore16Color', "16", `<path d="M8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2A6 6 0 1 0 8 2Z" fill="url(#ic_fluent_chat_more_16_color__a)"/><path d="M6 7c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7Zm.5 1.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z" fill="url(#ic_fluent_chat_more_16_color__b)"/><defs><linearGradient id="ic_fluent_chat_more_16_color__a" x1="2.43" y1="4.25" x2="12.9" y2="22.11" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_more_16_color__b" x1="6.35" y1="6.55" x2="6.73" y2="9.8" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$8d76900af933cc72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMore20Color', "20", `<path d="M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Z" fill="url(#ic_fluent_chat_more_20_color__a)"/><path d="M10.5 11H7.41a.5.5 0 0 0 0 1H10.59a.5.5 0 0 0 0-1h-.09Zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1h-.09Z" fill="url(#ic_fluent_chat_more_20_color__b)"/><defs><linearGradient id="ic_fluent_chat_more_20_color__a" x1="2.57" y1="5" x2="16.54" y2="28.82" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_more_20_color__b" x1="7.52" y1="8.07" x2="7.97" y2="12.41" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$a55ad55710bb96d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMore24Color', "24", `<path d="M12 2a10 10 0 1 1-4.64 18.86l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Z" fill="url(#ic_fluent_chat_more_24_color__a)"/><path d="M13.25 13h-4.6a.75.75 0 0 0 0 1.5H13.35a.75.75 0 0 0 0-1.5h-.1Zm2-3.5h-6.6a.75.75 0 0 0 0 1.5H15.35a.75.75 0 0 0 0-1.5h-.1Z" fill="url(#ic_fluent_chat_more_24_color__b)"/><defs><linearGradient id="ic_fluent_chat_more_24_color__a" x1="2.71" y1="5.75" x2="20.18" y2="35.52" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#CC23D1"/></linearGradient><linearGradient id="ic_fluent_chat_more_24_color__b" x1="8.7" y1="9.59" x2="9.23" y2="15.02" gradientUnits="userSpaceOnUse"><stop stop-color="#FDFDFD"/><stop offset="1" stop-color="#CCEAFF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$875ace76933778e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple16Color', "16", `<path d="M9 4a5 5 0 0 1 4.53 7.11l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46A4.98 4.98 0 0 1 4 9a5 5 0 0 1 5-5Z" fill="url(#ic_fluent_chat_multiple_16_color__a)"/><path d="M7 2a5 5 0 0 0-4.53 7.11L2 11.41a.5.5 0 0 0 .59.58l2.29-.46A4.98 4.98 0 0 0 12 7a5 5 0 0 0-5-5Z" fill="url(#ic_fluent_chat_multiple_16_color__b)"/><defs><radialGradient id="ic_fluent_chat_multiple_16_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(4.60184 5.3384 -5.34296 4.60577 6.68 6.67)"><stop offset=".63" stop-color="#3D35B1"/><stop offset=".85" stop-color="#6553C9"/><stop offset="1" stop-color="#7660D3"/></radialGradient><linearGradient id="ic_fluent_chat_multiple_16_color__b" x1="2" y1="2" x2="12" y2="12" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$32d43a6ffb7e389f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple16Filled', "16", [
    "M5.86 12.9a4.98 4.98 0 0 0 5.25.63l2.3.46a.5.5 0 0 0 .58-.59l-.46-2.29a4.98 4.98 0 0 0-.64-5.25 6.04 6.04 0 0 1 0 2.24 4.01 4.01 0 0 1-.33 2.72.5.5 0 0 0-.04.32l.34 1.72-1.72-.34a.5.5 0 0 0-.32.04 3.98 3.98 0 0 1-2.72.34 6.03 6.03 0 0 1-2.24 0ZM7 2a5 5 0 0 0-4.53 7.11L2 11.41a.5.5 0 0 0 .59.58l2.29-.46A4.98 4.98 0 0 0 12 7a5 5 0 0 0-5-5Z"
]);
const $77e1bce0ac0f7fe7$export$288ae28c1ccbbafa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple16Regular', "16", [
    "M7 2a5 5 0 0 0-4.53 7.11L2 11.41a.5.5 0 0 0 .59.58l2.29-.46A4.98 4.98 0 0 0 12 7a5 5 0 0 0-5-5ZM3 7a4 4 0 1 1 2.18 3.56.5.5 0 0 0-.32-.04l-1.72.34.34-1.72a.5.5 0 0 0-.04-.32A3.98 3.98 0 0 1 3 7Zm6 7a4.98 4.98 0 0 1-3.14-1.1 6.02 6.02 0 0 0 2.24 0 4 4 0 0 0 2.72-.34.5.5 0 0 1 .32-.04l1.72.34-.34-1.72a.5.5 0 0 1 .04-.32 3.98 3.98 0 0 0 .34-2.72 6.03 6.03 0 0 0 0-2.24 4.98 4.98 0 0 1 .63 5.25l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46c-.64.3-1.36.47-2.11.47Z"
]);
const $77e1bce0ac0f7fe7$export$b70f24c4e5ee8775 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple20Color', "20", `<path d="M11.5 5a6.5 6.5 0 0 1 5.67 9.67l.8 2.08a1 1 0 0 1-1.2 1.32l-2.5-.7A6.5 6.5 0 1 1 11.5 5Z" fill="url(#ic_fluent_chat_multiple_20_color__a)"/><path d="M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7A6.5 6.5 0 1 0 8.54 2Z" fill="url(#ic_fluent_chat_multiple_20_color__b)"/><defs><radialGradient id="ic_fluent_chat_multiple_20_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6 7 -7 6 8.5 8.5)"><stop offset=".63" stop-color="#3D35B1"/><stop offset=".85" stop-color="#6553C9"/><stop offset="1" stop-color="#7660D3"/></radialGradient><linearGradient id="ic_fluent_chat_multiple_20_color__b" x1="2" y1="2" x2="15.11" y2="15.04" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$413df688f1311942 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple20Filled', "20", [
    "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7A6.5 6.5 0 1 0 8.54 2ZM6.57 15.74a6.49 6.49 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.47 6.47 0 0 0-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.47 5.47 0 0 1-5.67-.4 7.5 7.5 0 0 1-1.76-.26Z"
]);
const $77e1bce0ac0f7fe7$export$7a72d50817a7f886 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple20Regular', "20", [
    "M8.54 2a6.5 6.5 0 0 0-5.68 9.67l-.8 2.08a1 1 0 0 0 1.21 1.32l2.49-.7A6.5 6.5 0 1 0 8.54 2Zm-5.5 6.5a5.5 5.5 0 1 1 3 4.9l-.18-.09-2.86.8.97-2.53-.13-.21a5.47 5.47 0 0 1-.8-2.87ZM11.5 18a6.49 6.49 0 0 1-4.93-2.26 7.5 7.5 0 0 0 1.76.26 5.47 5.47 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 0 0-.16-5.98c-.01-.6-.1-1.2-.24-1.76a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7c-.84.4-1.79.63-2.78.63Z"
]);
const $77e1bce0ac0f7fe7$export$27a756491409442f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple24Color', "24", `<path fill-rule="evenodd" clip-rule="evenodd" d="M22 13.5a7.5 7.5 0 1 0-4.41 6.84c1.26.29 2.61.54 3.24.65a1 1 0 0 0 1.15-1.17 68 68 0 0 0-.68-3.15c.45-.96.7-2.04.7-3.17ZM14.52 18h-.04.04Z" fill="url(#ic_fluent_chat_multiple_24_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.47 7.47 0 0 1 2 10.5ZM9.48 15h.04-.04Z" fill="url(#ic_fluent_chat_multiple_24_color__b)"/><defs><radialGradient id="ic_fluent_chat_multiple_24_color__a" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6.90278 8.0094 -8.01592 6.9084 11.03 10)"><stop offset=".63" stop-color="#3D35B1"/><stop offset=".85" stop-color="#6553C9"/><stop offset="1" stop-color="#7660D3"/></radialGradient><linearGradient id="ic_fluent_chat_multiple_24_color__b" x1="2" y1="3" x2="17" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0FAFFF"/><stop offset="1" stop-color="#2764E7"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$24e313a898e43541 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple24Filled', "24", [
    "M9.5 3a7.5 7.5 0 0 0-6.8 10.67 68.1 68.1 0 0 0-.68 3.15 1 1 0 0 0 1.15 1.17c.63-.11 1.98-.36 3.24-.65A7.5 7.5 0 1 0 9.5 3Zm-.04 16a7.47 7.47 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8a7.5 7.5 0 0 0-4.34-10.26c.35.63.62 1.31.8 2.04a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.13a5.97 5.97 0 0 1-5.59-.14 8.52 8.52 0 0 1-2.18.26Z"
]);
const $77e1bce0ac0f7fe7$export$b61ab4d7d48c2b50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple24Regular', "24", [
    "M9.56 3a7.5 7.5 0 0 0-6.8 10.67l-.72 2.84c-.23.92.59 1.75 1.5 1.53l2.93-.7A7.5 7.5 0 1 0 9.56 3Zm-6 7.5a6 6 0 1 1 3.33 5.37l-.24-.12-.27.07-2.78.66.69-2.7.07-.28-.13-.25a5.97 5.97 0 0 1-.67-2.75Zm11 10.5a7.47 7.47 0 0 1-5.1-2 8.28 8.28 0 0 0 2.18-.26 5.97 5.97 0 0 0 5.6.13l.24-.12.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8.44 8.44 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63-.94.42-1.99.66-3.09.66Z"
]);
const $77e1bce0ac0f7fe7$export$b7055ecad625f999 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple28Filled', "28", [
    "M11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3Zm6 22a8.98 8.98 0 0 1-6.73-3.03 10.08 10.08 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.93 9.93 0 0 0-.75-1.98 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A8.97 8.97 0 0 1 17 25Z"
]);
const $77e1bce0ac0f7fe7$export$65b8fc3eaceb4e93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple28Regular', "28", [
    "M3.5 12a7.5 7.5 0 1 1 3.9 6.59.75.75 0 0 0-.54-.07l-3.26.87.88-3.25a.75.75 0 0 0-.07-.55A7.46 7.46 0 0 1 3.5 12ZM11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3Zm6 22a8.98 8.98 0 0 1-6.73-3.03 10.08 10.08 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.93 9.93 0 0 0-.75-1.98 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A8.97 8.97 0 0 1 17 25Z"
]);
const $77e1bce0ac0f7fe7$export$592909d3c5cbc12c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple32Filled', "32", [
    "M2 13.5a10.5 10.5 0 1 1 5.8 9.4L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.43 10.43 0 0 1 2 13.5Zm10.5 12c.67 0 1.32-.05 1.95-.16a8.46 8.46 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08c-.16-.94-.43-1.85-.8-2.7a10.5 10.5 0 0 1 5.36 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42c.28.02.56.03.85.03Z"
]);
const $77e1bce0ac0f7fe7$export$40bf1fae74336a56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple32Regular', "32", [
    "M2 13.5a10.5 10.5 0 1 1 5.8 9.4L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.43 10.43 0 0 1 2 13.5Zm2 0c0 1.48.38 2.88 1.05 4.09a1 1 0 0 1 .09.74l-.93 3.46 3.45-.93a1 1 0 0 1 .75.1A8.5 8.5 0 1 0 4 13.5Zm8.5 12c.67 0 1.32-.05 1.95-.16a8.46 8.46 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08c-.16-.94-.43-1.85-.8-2.7a10.5 10.5 0 0 1 5.36 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42c.28.02.56.03.85.03Z"
]);
const $77e1bce0ac0f7fe7$export$9adb3a45a642ea20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple48Filled', "48", [
    "M34.52 13.05A15 15 0 0 1 44 27l-.01.51c-.08 2.34-.7 4.56-1.73 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A14.93 14.93 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17.25 17.25 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67.3-.18.65-.22.98-.12l4.92 1.43-1.44-4.92c-.1-.33-.05-.68.12-.97 1-1.73 1.6-3.7 1.66-5.82V27c0-4.47-2.34-8.4-5.88-10.6a16.88 16.88 0 0 0-1.1-3.35ZM19.39 5a15 15 0 0 1 14.6 15v.39a15 15 0 0 1-14.6 14.6l-.4.01c-2.53 0-4.92-.63-7.02-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74a14.93 14.93 0 0 1-1.73-6.51V20A15 15 0 0 1 19 5h.39Z"
]);
const $77e1bce0ac0f7fe7$export$4cbc3196641c7738 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiple48Regular', "48", [
    "M34.51 13.05A15 15 0 0 1 44 27l-.01.51c-.08 2.34-.7 4.56-1.73 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A14.94 14.94 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17.25 17.25 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67.3-.18.65-.22.98-.12l4.92 1.43-1.44-4.92c-.1-.33-.05-.68.12-.97 1-1.73 1.6-3.7 1.66-5.82V27c0-4.47-2.34-8.4-5.88-10.6a16.87 16.87 0 0 0-1.1-3.35ZM19.38 5A15 15 0 0 1 34 20v.39a15 15 0 0 1-14.62 14.6L19 35c-2.54 0-4.93-.63-7.03-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74A14.93 14.93 0 0 1 4 20.51L4 20A15 15 0 0 1 19 5h.38ZM19 7.5C12.1 7.5 6.5 13.1 6.5 20v.43c.07 2.11.67 4.1 1.67 5.82.17.3.21.64.11.97l-1.43 4.92 4.92-1.43c.32-.1.68-.06.97.12A12.44 12.44 0 0 0 19 32.5h.32a12.5 12.5 0 0 0 0-25H19Z"
]);
const $77e1bce0ac0f7fe7$export$f7c3a58119321541 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark16Filled', "16", [
    "M9 14a4.98 4.98 0 0 1-3.14-1.1 6.02 6.02 0 0 0 2.24 0 4 4 0 0 0 2.72-.34.5.5 0 0 1 .32-.04l1.72.34-.34-1.72a.5.5 0 0 1 .04-.32 3.98 3.98 0 0 0 .34-2.72 6.04 6.04 0 0 0 0-2.24 4.98 4.98 0 0 1 .63 5.25l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46c-.64.3-1.36.47-2.11.47ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm7.35-.64a.5.5 0 1 0-.7-.72l-2.2 2.17-1.1-1.03a.5.5 0 0 0-.7.73l1.46 1.36c.2.18.5.17.7-.01l2.54-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$258df6ce26548582 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark16Regular', "16", [
    "M9.35 6.36a.5.5 0 1 0-.7-.72l-2.2 2.17-1.1-1.03a.5.5 0 0 0-.7.73l1.46 1.36c.2.18.5.17.7-.01l2.54-2.5ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm5-4a4 4 0 0 0-3.56 5.82c.05.1.06.21.04.32l-.34 1.72 1.72-.34a.5.5 0 0 1 .32.04A4 4 0 1 0 7 3Zm-1.14 9.9a4.98 4.98 0 0 0 5.25.63l2.3.46a.5.5 0 0 0 .58-.59l-.46-2.29a4.98 4.98 0 0 0-.64-5.25 6.03 6.03 0 0 1 0 2.24 4.01 4.01 0 0 1-.33 2.72.5.5 0 0 0-.04.32l.34 1.72-1.72-.34a.5.5 0 0 0-.32.04 3.98 3.98 0 0 1-2.72.34 6.03 6.03 0 0 1-2.24 0Z"
]);
const $77e1bce0ac0f7fe7$export$c73fcf6271a29a11 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark20Filled', "20", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.47 6.47 0 0 1-.83-3.17Zm9.31-1.85a.5.5 0 0 0-.7 0l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L7.4 10.6c.2.2.5.2.7 0l3.25-3.25a.5.5 0 0 0 0-.7ZM11.5 18a6.49 6.49 0 0 1-4.93-2.26 7.5 7.5 0 0 0 1.76.26 5.47 5.47 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 0 0-.16-5.98c-.01-.6-.1-1.2-.24-1.76a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7c-.84.4-1.79.63-2.78.63Z"
]);
const $77e1bce0ac0f7fe7$export$619154dd8d0b277a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark20Regular', "20", [
    "M11.35 6.65c.2.2.2.5 0 .7L8.1 10.6a.5.5 0 0 1-.7 0L5.65 8.85a.5.5 0 1 1 .7-.7l1.4 1.4 2.9-2.9c.2-.2.5-.2.7 0ZM2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.47 6.47 0 0 1-.83-3.17ZM8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09A5.5 5.5 0 1 0 8.54 3ZM6.57 15.74a6.49 6.49 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.47 6.47 0 0 0-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.47 5.47 0 0 1-5.67-.4 7.5 7.5 0 0 1-1.76-.26Z"
]);
const $77e1bce0ac0f7fe7$export$a7b1960dad3e5835 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark24Filled', "24", [
    "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.47 7.47 0 0 1 2 10.5ZM13.06 9a.75.75 0 0 0-1.12-1l-3.5 3.94L7 10.64a.75.75 0 0 0-1 1.1l2 1.82a.75.75 0 0 0 1.06-.06l4-4.5Zm1.5 12a7.47 7.47 0 0 1-5.1-2 8.28 8.28 0 0 0 2.18-.26 5.97 5.97 0 0 0 5.6.14l.24-.13.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8.44 8.44 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63-.94.42-1.99.66-3.09.66Z"
]);
const $77e1bce0ac0f7fe7$export$479511d6aa1e13bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark24Regular', "24", [
    "M13.06 9a.75.75 0 0 0-1.12-1l-3.5 3.94L7 10.64a.75.75 0 0 0-1 1.1l2 1.82a.75.75 0 0 0 1.06-.06l4-4.5Zm-11 1.5a7.5 7.5 0 1 1 4.41 6.84l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84a7.47 7.47 0 0 1-.7-3.17Zm7.5-6a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.12A6 6 0 1 0 9.56 4.5ZM9.46 19a7.47 7.47 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8a7.5 7.5 0 0 0-4.34-10.26c.35.63.62 1.31.8 2.04a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.12a5.97 5.97 0 0 1-5.59-.13 8.52 8.52 0 0 1-2.18.26Z"
]);
const $77e1bce0ac0f7fe7$export$cd3594f9422232c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark28Filled', "28", [
    "M2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A8.97 8.97 0 0 1 2 12Zm12.22-3.03-4.47 4.47-1.97-1.97-.08-.07a.75.75 0 0 0-.98 1.13l2.5 2.5.08.07c.3.22.71.2.98-.07l5-5 .07-.08a.75.75 0 0 0-1.13-.98Zm-3.95 13a8.98 8.98 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55c.31.63.56 1.3.74 1.98a7.5 7.5 0 0 1 2.92 10.13.75.75 0 0 0-.07.55l.88 3.25-3.26-.87a.75.75 0 0 0-.55.07 7.46 7.46 0 0 1-8.21-.68 10.09 10.09 0 0 1-2.11.06Z"
]);
const $77e1bce0ac0f7fe7$export$9ae26dcebed1ab88 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleCheckmark28Regular', "28", [
    "m14.22 8.97-4.47 4.47-1.97-1.97-.08-.07a.75.75 0 0 0-.98 1.13l2.5 2.5.08.07c.3.22.71.2.98-.07l5-5 .07-.08a.75.75 0 0 0-1.13-.98ZM11 3a9 9 0 0 0-8.05 13.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 11 3Zm0 1.5a7.5 7.5 0 1 1-3.6 14.09.75.75 0 0 0-.54-.07l-3.26.87.88-3.25a.75.75 0 0 0-.07-.55A7.5 7.5 0 0 1 11 4.5ZM17 25a8.98 8.98 0 0 1-6.73-3.03 10.08 10.08 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.93 9.93 0 0 0-.75-1.98 9 9 0 0 1 5.12 12.54l.9 3.4c.25.92-.6 1.77-1.52 1.52l-3.4-.9A8.97 8.97 0 0 1 17 25Z"
]);
const $77e1bce0ac0f7fe7$export$b5af111abd998201 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart16Filled', "16", [
    "M9 14a4.98 4.98 0 0 1-3.14-1.1 6.02 6.02 0 0 0 2.24 0 4 4 0 0 0 2.72-.34.5.5 0 0 1 .32-.04l1.72.34-.34-1.72a.5.5 0 0 1 .04-.32 3.98 3.98 0 0 0 .34-2.72 6.04 6.04 0 0 0 0-2.24 4.98 4.98 0 0 1 .63 5.25l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46c-.64.3-1.36.47-2.11.47ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm2.9-1.6a1.35 1.35 0 0 0 0 1.9l1.96 1.97a.2.2 0 0 0 .3 0L9.1 7.32A1.35 1.35 0 0 0 7.19 5.4l-.2.19-.18-.2a1.35 1.35 0 0 0-1.92 0Z"
]);
const $77e1bce0ac0f7fe7$export$92635e9589cfe9dc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart16Regular', "16", [
    "M4.9 5.4a1.35 1.35 0 0 1 1.9 0l.2.19.18-.19a1.36 1.36 0 0 1 1.93 1.92L7.15 9.27a.2.2 0 0 1-.29 0L4.9 7.31a1.35 1.35 0 0 1 0-1.92ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm5-4a4 4 0 0 0-3.56 5.82c.05.1.06.21.04.32l-.34 1.72 1.72-.34a.5.5 0 0 1 .32.04A4 4 0 1 0 7 3Zm-1.14 9.9a4.98 4.98 0 0 0 5.25.63l2.3.46a.5.5 0 0 0 .58-.59l-.46-2.29a4.98 4.98 0 0 0-.64-5.25 6.03 6.03 0 0 1 0 2.24 4.01 4.01 0 0 1-.33 2.72.5.5 0 0 0-.04.32l.34 1.72-1.72-.34a.5.5 0 0 0-.32.04 3.98 3.98 0 0 1-2.72.34 6.03 6.03 0 0 1-2.24 0Z"
]);
const $77e1bce0ac0f7fe7$export$ef8ebeea9962f142 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart20Filled', "20", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.47 6.47 0 0 1-.83-3.17Zm3.51-2.01a1.9 1.9 0 0 0 0 2.68L8.3 11.9c.12.12.3.12.42 0l2.73-2.73a1.9 1.9 0 0 0-2.7-2.69l-.25.27-.27-.27a1.9 1.9 0 0 0-2.68 0ZM11.5 18a6.49 6.49 0 0 1-4.93-2.26 7.5 7.5 0 0 0 1.76.26 5.47 5.47 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 0 0-.16-5.98c-.01-.6-.1-1.2-.24-1.76a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7c-.84.4-1.79.63-2.78.63Z"
]);
const $77e1bce0ac0f7fe7$export$73f4eb9bc0b93f20 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart20Regular', "20", [
    "M5.55 6.49a1.9 1.9 0 0 1 2.68 0l.27.27.26-.26a1.9 1.9 0 0 1 2.69 2.68l-2.73 2.73a.3.3 0 0 1-.42 0L5.56 9.17a1.9 1.9 0 0 1 0-2.68ZM2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.47 6.47 0 0 1-.83-3.17ZM8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09A5.5 5.5 0 1 0 8.54 3ZM6.57 15.74a6.49 6.49 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.47 6.47 0 0 0-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.47 5.47 0 0 1-5.67-.4 7.5 7.5 0 0 1-1.76-.26Z"
]);
const $77e1bce0ac0f7fe7$export$6ef10af4f3ab9a75 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart24Filled', "24", [
    "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.47 7.47 0 0 1 2 10.5Zm4.34-2.16c-.79.8-.79 2.08 0 2.87l2.95 2.95c.12.12.32.12.44 0l2.93-2.93a2.03 2.03 0 0 0-2.88-2.88l-.28.28-.29-.28c-.8-.8-2.08-.8-2.87 0ZM14.56 21a7.47 7.47 0 0 1-5.1-2 8.28 8.28 0 0 0 2.18-.26 5.97 5.97 0 0 0 5.6.14l.24-.13.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8.44 8.44 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63-.94.42-1.99.66-3.09.66Z"
]);
const $77e1bce0ac0f7fe7$export$86e9ca0467b7ef72 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart24Regular', "24", [
    "M6.34 8.34c.8-.79 2.08-.79 2.87 0l.29.3.28-.29a2.03 2.03 0 0 1 2.88 2.88l-2.93 2.93a.31.31 0 0 1-.44 0L6.35 11.2c-.8-.8-.8-2.08 0-2.87ZM2.06 10.5a7.5 7.5 0 1 1 4.41 6.84l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84a7.47 7.47 0 0 1-.7-3.17Zm7.5-6a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.12A6 6 0 1 0 9.56 4.5ZM9.46 19a7.47 7.47 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8a7.5 7.5 0 0 0-4.34-10.26c.35.63.62 1.31.8 2.04a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.12a5.97 5.97 0 0 1-5.59-.13 8.52 8.52 0 0 1-2.18.26Z"
]);
const $77e1bce0ac0f7fe7$export$fed4fc383d15ae56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart28Filled', "28", [
    "M2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A8.97 8.97 0 0 1 2 12Zm4.79-3.2a2.75 2.75 0 0 0 0 3.86l3.93 3.97c.16.16.43.16.59 0l3.9-3.94a2.76 2.76 0 0 0 0-3.87 2.7 2.7 0 0 0-3.84-.01l-.37.38-.38-.38a2.69 2.69 0 0 0-3.83-.01Zm3.48 13.17a8.98 8.98 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55c.31.63.56 1.3.74 1.98a7.5 7.5 0 0 1 2.92 10.13.75.75 0 0 0-.07.55l.88 3.25-3.26-.87a.75.75 0 0 0-.55.07 7.46 7.46 0 0 1-8.21-.68 10.09 10.09 0 0 1-2.11.06Z"
]);
const $77e1bce0ac0f7fe7$export$a7ed9dd1296cf7d3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart28Regular', "28", [
    "M6.79 8.8a2.69 2.69 0 0 1 3.83 0l.38.39.37-.38a2.7 2.7 0 0 1 3.83.01 2.76 2.76 0 0 1 .01 3.87l-3.9 3.94a.41.41 0 0 1-.59 0L6.8 12.66a2.75 2.75 0 0 1-.01-3.86ZM2 12c0 1.45.34 2.82.95 4.03l-.9 3.4c-.26.92.6 1.77 1.52 1.52l3.4-.9A9 9 0 1 0 2 12Zm9-7.5a7.5 7.5 0 1 1-3.6 14.09.75.75 0 0 0-.54-.07l-3.26.87.88-3.25a.75.75 0 0 0-.07-.55A7.5 7.5 0 0 1 11 4.5Zm-.73 17.47a8.98 8.98 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55c.31.63.56 1.3.74 1.98a7.5 7.5 0 0 1 2.92 10.13.75.75 0 0 0-.07.55l.88 3.25-3.26-.87a.75.75 0 0 0-.55.07 7.46 7.46 0 0 1-8.21-.68 10.09 10.09 0 0 1-2.11.06Z"
]);
const $77e1bce0ac0f7fe7$export$5c2e2f6a78e55d34 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart32Filled', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3Zm1.95 22.34a12.08 12.08 0 0 1-2.8.13 10.47 10.47 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.44 10.44 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7.36.86.63 1.77.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.46 8.46 0 0 1-9.14-.62Zm-2.37-14.96.42.4.4-.4a2.99 2.99 0 0 1 4.23 4.2l-4.29 4.29a.46.46 0 0 1-.65 0l-4.31-4.3a2.96 2.96 0 1 1 4.2-4.2Z"
]);
const $77e1bce0ac0f7fe7$export$d2c14672915c090d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleHeart32Regular', "32", [
    "M12.5 3a10.5 10.5 0 0 0-9.4 15.19L2.05 22.1a1.5 1.5 0 0 0 1.84 1.83L7.8 22.9A10.5 10.5 0 1 0 12.5 3ZM5.05 17.59a8.5 8.5 0 1 1 3.36 3.36 1 1 0 0 0-.75-.09l-3.45.93.93-3.46a1 1 0 0 0-.1-.74Zm9.4 7.75a12.08 12.08 0 0 1-2.8.13 10.47 10.47 0 0 0 12.55 2.42l3.91 1.05a1.5 1.5 0 0 0 1.84-1.83l-1.05-3.92A10.44 10.44 0 0 0 30 18.5c0-4.36-2.66-8.1-6.45-9.7.36.86.63 1.77.79 2.7a8.5 8.5 0 0 1 2.61 11.09 1 1 0 0 0-.09.74l.93 3.46-3.45-.93a1 1 0 0 0-.75.1 8.46 8.46 0 0 1-9.14-.62Zm-2.37-14.96a2.96 2.96 0 1 0-4.2 4.19l4.31 4.3c.18.17.47.17.65 0l4.3-4.28a2.99 2.99 0 0 0-4.23-4.2l-.41.4-.42-.41Z"
]);
const $77e1bce0ac0f7fe7$export$416725787ce84da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus16Filled', "16", [
    "M9 14a4.98 4.98 0 0 1-3.14-1.1 6.02 6.02 0 0 0 2.24 0 4 4 0 0 0 2.72-.34.5.5 0 0 1 .32-.04l1.72.34-.34-1.72a.5.5 0 0 1 .04-.32 3.98 3.98 0 0 0 .34-2.72 6.04 6.04 0 0 0 0-2.24 4.98 4.98 0 0 1 .63 5.25l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46c-.64.3-1.36.47-2.11.47ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm3-.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H5Z"
]);
const $77e1bce0ac0f7fe7$export$1660de87647aa6ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus16Regular', "16", [
    "M5 6.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H5ZM2 7a5 5 0 1 1 2.89 4.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 2 7Zm5-4a4 4 0 0 0-3.56 5.82c.05.1.06.21.04.32l-.34 1.72 1.72-.34a.5.5 0 0 1 .32.04A4 4 0 1 0 7 3Zm-1.14 9.9a4.98 4.98 0 0 0 5.25.63l2.3.46a.5.5 0 0 0 .58-.59l-.46-2.29a4.98 4.98 0 0 0-.64-5.25 6.03 6.03 0 0 1 0 2.24 4.01 4.01 0 0 1-.33 2.72.5.5 0 0 0-.04.32l.34 1.72-1.72-.34a.5.5 0 0 0-.32.04 3.98 3.98 0 0 1-2.72.34 6.03 6.03 0 0 1-2.24 0Z"
]);
const $77e1bce0ac0f7fe7$export$6758dba688b4195f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus20Filled', "20", [
    "M2.04 8.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.47 6.47 0 0 1-.83-3.17ZM5.5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm6 10a6.49 6.49 0 0 1-4.93-2.26 7.5 7.5 0 0 0 1.76.26 5.47 5.47 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 0 0-.16-5.98c-.01-.6-.1-1.2-.24-1.76a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7c-.84.4-1.79.63-2.78.63Z"
]);
const $77e1bce0ac0f7fe7$export$23e81ecda24c5ea0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus20Regular', "20", [
    "M5.5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm-3.46.5a6.5 6.5 0 1 1 3.72 5.88l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08a6.47 6.47 0 0 1-.83-3.17ZM8.54 3a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09A5.5 5.5 0 1 0 8.54 3ZM6.57 15.74a6.49 6.49 0 0 0 7.71 1.64l2.49.7a1 1 0 0 0 1.2-1.33l-.8-2.08a6.47 6.47 0 0 0-1.37-8.04c.15.56.23 1.15.24 1.76a5.47 5.47 0 0 1 .16 5.98l-.13.2.97 2.54-2.86-.8-.18.09a5.47 5.47 0 0 1-5.67-.4 7.5 7.5 0 0 1-1.76-.26Z"
]);
const $77e1bce0ac0f7fe7$export$4c2afc2f53527d7b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus24Filled', "24", [
    "M2 10.5a7.5 7.5 0 1 1 4.41 6.84c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.47 7.47 0 0 1 2 10.5Zm4.5-.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6ZM14.56 21a7.47 7.47 0 0 1-5.1-2 8.28 8.28 0 0 0 2.18-.26 5.97 5.97 0 0 0 5.6.14l.24-.13.26.07c.92.22 1.96.44 2.74.6-.18-.74-.41-1.75-.64-2.64l-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8.44 8.44 0 0 0-.8-2.04 7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.57 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63-.94.42-1.99.66-3.09.66Z"
]);
const $77e1bce0ac0f7fe7$export$6613b05dc66edad1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus24Regular', "24", [
    "M6.25 9.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm-4.19 1a7.5 7.5 0 1 1 4.41 6.84l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84a7.47 7.47 0 0 1-.7-3.17Zm7.5-6a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.12A6 6 0 1 0 9.56 4.5ZM9.46 19a7.47 7.47 0 0 0 8.19 1.34c1.04.24 2.19.48 2.91.64.9.18 1.67-.62 1.47-1.5-.16-.7-.42-1.8-.67-2.8a7.5 7.5 0 0 0-4.34-10.26c.35.63.62 1.31.8 2.04a6 6 0 0 1 2.08 7.79l-.13.25.07.28c.23.9.46 1.9.64 2.65l-2.74-.61-.26-.07-.25.12a5.97 5.97 0 0 1-5.59-.13 8.52 8.52 0 0 1-2.18.26Z"
]);
const $77e1bce0ac0f7fe7$export$4a03a9f825da7c04 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus28Filled', "28", [
    "M2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A8.97 8.97 0 0 1 2 12Zm5.5-.75a.75.75 0 0 0 0 1.5H15a.75.75 0 0 0 0-1.5H7.5Zm2.77 10.72a8.98 8.98 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55c.31.63.56 1.3.74 1.98a7.5 7.5 0 0 1 2.92 10.13.75.75 0 0 0-.07.55l.88 3.25-3.26-.87a.75.75 0 0 0-.55.07 7.46 7.46 0 0 1-8.21-.68 10.09 10.09 0 0 1-2.11.06Z"
]);
const $77e1bce0ac0f7fe7$export$644abb499a1294c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultipleMinus28Regular', "28", [
    "M7.25 11a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-7.5ZM2 12a9 9 0 1 1 4.96 8.04l-3.39.91c-.92.25-1.78-.6-1.53-1.53l.91-3.39A8.97 8.97 0 0 1 2 12Zm9-7.5a7.5 7.5 0 0 0-6.59 11.09c.1.16.12.36.07.55l-.88 3.25 3.26-.87a.75.75 0 0 1 .55.07A7.5 7.5 0 1 0 11 4.5Zm-.73 17.47a8.98 8.98 0 0 0 10.77 2.07l3.39.91c.92.25 1.77-.6 1.53-1.53l-.91-3.39a9 9 0 0 0-5.12-12.55c.31.63.56 1.3.74 1.98a7.5 7.5 0 0 1 2.92 10.13.75.75 0 0 0-.07.55l.88 3.25-3.26-.87a.75.75 0 0 0-.55.07 7.46 7.46 0 0 1-8.21-.68 10.09 10.09 0 0 1-2.11.06Z"
]);
const $77e1bce0ac0f7fe7$export$c0ec5d90cdac3b73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson16Filled', "16", [
    "M12.9 5.86a4.98 4.98 0 0 1 .63 5.25l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46a4.98 4.98 0 0 1-5.25-.64 6.03 6.03 0 0 0 2.24 0 4.01 4.01 0 0 0 2.72-.33.5.5 0 0 1 .32-.04l1.72.34-.34-1.72a.5.5 0 0 1 .04-.32 3.98 3.98 0 0 0 .34-2.72 6.03 6.03 0 0 0 0-2.24ZM7 2a5 5 0 1 1-2.11 9.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 7 2ZM6 7a1 1 0 0 0-1 1c0 1 1 1.5 2 1.5S9 9 9 8a1 1 0 0 0-1-1H6Zm1-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
]);
const $77e1bce0ac0f7fe7$export$8b7104f687d3f1be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson16Regular', "16", [
    "M12.9 5.86a4.98 4.98 0 0 1 .63 5.25l.46 2.3a.5.5 0 0 1-.59.58l-2.29-.46a4.98 4.98 0 0 1-5.25-.64 6.03 6.03 0 0 0 2.24 0 4.01 4.01 0 0 0 2.72-.33.5.5 0 0 1 .32-.04l1.72.34-.34-1.72a.5.5 0 0 1 .04-.32 3.98 3.98 0 0 0 .34-2.72 6.03 6.03 0 0 0 0-2.24ZM7 2a5 5 0 1 1-2.11 9.53l-2.3.46a.5.5 0 0 1-.58-.59l.46-2.29A4.98 4.98 0 0 1 7 2Zm0 1a4 4 0 0 0-3.56 5.82c.05.1.06.21.04.32l-.34 1.72 1.72-.34a.5.5 0 0 1 .32.04A4 4 0 1 0 7 3Zm1 4a1 1 0 0 1 1 1c0 1-1 1.5-2 1.5S5 9 5 8a1 1 0 0 1 1-1h2ZM7 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
]);
const $77e1bce0ac0f7fe7$export$68f5f283438c36b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson20Filled', "20", [
    "M15.8 6.63a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7a6.48 6.48 0 0 1-7.7-1.63 7.5 7.5 0 0 0 1.75.26 5.48 5.48 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 0 0-.16-5.98c-.01-.6-.1-1.2-.24-1.76ZM8.54 2a6.5 6.5 0 1 1-2.78 12.38l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08A6.5 6.5 0 0 1 8.53 2ZM6.75 9c-.69 0-1.25.56-1.25 1.25 0 1.25 1 2.25 3 2.25s3-1 3-2.25c0-.69-.56-1.25-1.25-1.25h-3.5ZM8.5 4.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$bde8de27401c483 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson20Regular', "20", [
    "M15.8 6.63a6.48 6.48 0 0 1 1.38 8.04l.8 2.08a1 1 0 0 1-1.21 1.32l-2.49-.7a6.48 6.48 0 0 1-7.7-1.63 7.5 7.5 0 0 0 1.75.26 5.48 5.48 0 0 0 5.67.4l.18-.09 2.86.8-.97-2.53.13-.21a5.47 5.47 0 0 0-.16-5.98c-.01-.6-.1-1.2-.24-1.76ZM8.54 2a6.5 6.5 0 1 1-2.78 12.38l-2.49.7a1 1 0 0 1-1.2-1.33l.8-2.08A6.5 6.5 0 0 1 8.53 2Zm0 1a5.5 5.5 0 0 0-4.7 8.37l.13.2L3 14.12l2.86-.8.18.09A5.5 5.5 0 1 0 8.54 3Zm1.71 6c.69 0 1.25.56 1.25 1.25 0 1.25-1 2.25-3 2.25s-3-1-3-2.25C5.5 9.56 6.06 9 6.75 9h3.5ZM8.5 4.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$7716a33c6fde075b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson24Filled', "24", [
    "M17.01 6.41a7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.58 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63A7.48 7.48 0 0 1 9.46 19h.1c.72 0 1.42-.09 2.08-.26a5.97 5.97 0 0 0 5.6.14l.23-.13.27.07c.92.22 1.96.44 2.74.6l-.64-2.64-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8.44 8.44 0 0 0-.8-2.04ZM9.5 3a7.5 7.5 0 1 1-3.09 14.34c-1.26.29-2.61.54-3.24.65a1 1 0 0 1-1.15-1.17c.12-.61.38-1.92.68-3.15A7.5 7.5 0 0 1 9.5 3Zm-2 8c-.83 0-1.5.67-1.5 1.5C6 14 7.5 15 9.5 15s3.5-1 3.5-2.5c0-.83-.67-1.5-1.5-1.5h-4Zm2-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
]);
const $77e1bce0ac0f7fe7$export$f841cf43f68ce876 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson24Regular', "24", [
    "M17.01 6.41a7.5 7.5 0 0 1 4.35 10.26l.67 2.8c.2.9-.58 1.7-1.47 1.5-.72-.15-1.87-.39-2.91-.63A7.48 7.48 0 0 1 9.46 19h.1c.72 0 1.42-.09 2.08-.26a5.97 5.97 0 0 0 5.6.14l.23-.13.27.07c.92.22 1.96.44 2.74.6l-.64-2.64-.07-.28.13-.25a5.97 5.97 0 0 0-2.09-7.8 8.45 8.45 0 0 0-.8-2.04ZM9.56 3a7.5 7.5 0 1 1-3.09 14.34l-2.93.7a1.25 1.25 0 0 1-1.5-1.53l.72-2.84A7.5 7.5 0 0 1 9.56 3Zm0 1.5a6 6 0 0 0-5.33 8.75l.13.25-.07.28-.7 2.7 2.8-.66.26-.07.24.13A6 6 0 1 0 9.56 4.5ZM11.5 11c.83 0 1.5.67 1.5 1.5C13 14 11.5 15 9.5 15S6 14 6 12.5c0-.83.67-1.5 1.5-1.5h4Zm-2-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
]);
const $77e1bce0ac0f7fe7$export$6a12aa55cb137b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson28Filled', "28", [
    "M19.93 7.49a9 9 0 0 1 5.12 12.54l.9 3.4c.26.92-.6 1.77-1.53 1.52l-3.38-.9a8.97 8.97 0 0 1-10.77-2.08 10.12 10.12 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.94 9.94 0 0 0-.75-1.98ZM11 3a9 9 0 1 1-4.04 17.04l-3.38.91c-.93.25-1.79-.6-1.54-1.53l.91-3.39A9 9 0 0 1 11 3ZM8.25 13c-.97 0-1.75.78-1.75 1.75C6.5 16.5 8.5 18 11 18s4.5-1.5 4.5-3.25c0-.97-.78-1.75-1.75-1.75h-5.5ZM11 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
]);
const $77e1bce0ac0f7fe7$export$f4260854a548f274 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson28Regular', "28", [
    "M19.93 7.49a9 9 0 0 1 5.12 12.54l.9 3.4c.26.92-.6 1.77-1.53 1.52l-3.38-.9a8.97 8.97 0 0 1-10.77-2.08 10.12 10.12 0 0 0 2.1-.06 7.47 7.47 0 0 0 8.22.68c.17-.1.37-.12.55-.07l3.25.87-.87-3.25a.75.75 0 0 1 .07-.55 7.5 7.5 0 0 0-2.91-10.12 9.94 9.94 0 0 0-.75-1.98ZM11 3a9 9 0 1 1-4.04 17.04l-3.38.91c-.93.25-1.79-.6-1.54-1.53l.91-3.39A9 9 0 0 1 11 3Zm0 1.5a7.5 7.5 0 0 0-6.59 11.09c.1.16.12.36.07.55l-.88 3.25 3.26-.87a.75.75 0 0 1 .55.07A7.5 7.5 0 1 0 11 4.5Zm2.75 8.5c.97 0 1.75.78 1.75 1.75 0 1.75-2 3.25-4.5 3.25s-4.5-1.5-4.5-3.25c0-.97.78-1.75 1.75-1.75h5.5ZM11 6.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"
]);
const $77e1bce0ac0f7fe7$export$fd398b2690689c9e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson32Filled', "32", [
    "M23.55 8.81a10.5 10.5 0 0 1 5.35 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42 12.15 12.15 0 0 0 2.8-.13 8.46 8.46 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08c-.16-.94-.43-1.85-.8-2.7ZM12.5 3a10.5 10.5 0 1 1-4.7 19.9L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.47 10.47 0 0 1 2 13.5C2 7.7 6.7 3 12.5 3Zm-3 11a2 2 0 0 0-2 2c0 2 1.5 4 5 4s5-2 5-4a2 2 0 0 0-2-2h-6Zm3-7a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z"
]);
const $77e1bce0ac0f7fe7$export$96161dc4fdaf1b62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson32Regular', "32", [
    "M23.55 8.81a10.5 10.5 0 0 1 5.35 14.38l1.05 3.92a1.5 1.5 0 0 1-1.84 1.83L24.2 27.9a10.46 10.46 0 0 1-12.55-2.42 12.15 12.15 0 0 0 2.8-.13 8.46 8.46 0 0 0 9.14.61 1 1 0 0 1 .75-.09l3.45.93-.93-3.46a1 1 0 0 1 .1-.74 8.5 8.5 0 0 0-2.62-11.08c-.16-.94-.43-1.85-.8-2.7ZM12.5 3a10.5 10.5 0 1 1-4.7 19.9L3.9 23.93a1.5 1.5 0 0 1-1.84-1.83l1.05-3.92A10.47 10.47 0 0 1 2 13.5C2 7.7 6.7 3 12.5 3Zm0 2a8.5 8.5 0 0 0-7.45 12.59 1 1 0 0 1 .09.74l-.93 3.46 3.45-.93a1 1 0 0 1 .75.1A8.5 8.5 0 1 0 12.5 5Zm3 9a2 2 0 0 1 2 2c0 2-1.5 4-5 4s-5-2-5-4c0-1.1.9-2 2-2h6Zm-3-7a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5Z"
]);
const $77e1bce0ac0f7fe7$export$37b11390fffb679f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson48Filled', "48", [
    "M34.52 13.05A15 15 0 0 1 44 27l-.01.51c-.08 2.34-.7 4.56-1.73 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A14.94 14.94 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17.23 17.23 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67.3-.18.65-.22.98-.12l4.92 1.43-1.44-4.92c-.1-.33-.05-.68.12-.97 1-1.73 1.6-3.7 1.66-5.82V27c0-4.47-2.34-8.4-5.88-10.6a16.87 16.87 0 0 0-1.1-3.35ZM19.39 5a15 15 0 0 1 14.6 15v.39a15 15 0 0 1-14.6 14.6l-.4.01c-2.53 0-4.92-.63-7.02-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74a14.93 14.93 0 0 1-1.73-6.51V20A15 15 0 0 1 19 5h.39ZM14.5 21a3 3 0 0 0-3 3c0 3 3 5.5 7.5 5.5s7.5-2.5 7.5-5.5a3 3 0 0 0-3-3h-9ZM19 11a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
]);
const $77e1bce0ac0f7fe7$export$4de900e7a1fcecb3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatMultiplePerson48Regular', "48", [
    "M34.52 13.05A15 15 0 0 1 44 27v.51c-.09 2.34-.7 4.56-1.74 6.51l1.67 5.74a1.75 1.75 0 0 1-2.17 2.17l-5.73-1.68A14.94 14.94 0 0 1 29 42h-.39c-4.3-.11-8.16-2.04-10.83-5.04a17.26 17.26 0 0 0 3.52-.12c2.04 1.6 4.6 2.59 7.38 2.66H29c2.28 0 4.41-.61 6.25-1.67.3-.18.65-.22.98-.12l4.92 1.43-1.44-4.92c-.1-.33-.05-.68.12-.97 1-1.73 1.6-3.7 1.66-5.82l.01-.43c0-4.47-2.35-8.4-5.89-10.6a16.87 16.87 0 0 0-1.1-3.35ZM19.38 5A15 15 0 0 1 34 20v.39a15 15 0 0 1-14.62 14.6L19 35c-2.54 0-4.93-.63-7.03-1.75l-5.73 1.68a1.75 1.75 0 0 1-2.17-2.17l1.67-5.74a14.93 14.93 0 0 1-1.73-6.51L4 20A15 15 0 0 1 19 5h.38ZM19 7.5C12.1 7.5 6.5 13.1 6.5 20v.43c.08 2.11.67 4.1 1.67 5.82.17.3.21.64.12.97l-1.44 4.92 4.92-1.43c.33-.1.68-.06.97.12A12.44 12.44 0 0 0 19 32.5h.32a12.5 12.5 0 0 0 0-25H19ZM23.5 21a3 3 0 0 1 3 3c0 3-3 5.5-7.5 5.5S11.5 27 11.5 24a3 3 0 0 1 3-3h9ZM19 11a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
]);
const $77e1bce0ac0f7fe7$export$95a72e34df1141b4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff16Filled', "16", [
    "m11.87 12.58 2.28 2.27a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7l2.27 2.28a5.98 5.98 0 0 0-.69 6.74l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2a5.97 5.97 0 0 0 6.87-.6ZM8.73 9.44a.5.5 0 0 1-.23.06h-2a.5.5 0 0 1 0-1h1.3l.93.94ZM10 7a.5.5 0 0 1-.4.49l3.57 3.56a6 6 0 0 0-8.22-8.22L8.62 6.5h.88c.28 0 .5.22.5.5Z"
]);
const $77e1bce0ac0f7fe7$export$a8deb1b9f9689980 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff16Regular', "16", [
    "m11.87 12.58 2.28 2.27a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7l2.27 2.28a5.98 5.98 0 0 0-.69 6.74l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2a5.97 5.97 0 0 0 6.87-.6Zm-.7-.7a4.98 4.98 0 0 1-5.84.35.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39 4.97 4.97 0 0 1 .43-5.71l1.93 1.93a.5.5 0 0 0 .44.73h.3l1 1H6.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .23-.06l2.43 2.43ZM8.61 6.5l.99.99a.5.5 0 0 0-.11-.99h-.88ZM13 8c0 .83-.2 1.62-.57 2.31l.74.74a6 6 0 0 0-8.22-8.22l.74.74A5 5 0 0 1 13 8Z"
]);
const $77e1bce0ac0f7fe7$export$e5f42fb89fa06971 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff20Filled', "20", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7L4.71 4 16 15.3l1.85 1.85a.5.5 0 0 1-.7.7L15.29 16a7.97 7.97 0 0 1-8.9 1.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3Zm6.97 6.98-.68-.68H7.41a.5.5 0 0 0 0 1H10.59a.5.5 0 0 0 .38-.32ZM8.29 9l-.97-.97a.5.5 0 0 0 .09.96L7.5 9h.8Z",
    "M12.5 9h-1.38l5.5 5.5A8 8 0 0 0 5.5 3.39L10.11 8H12.6a.5.5 0 0 1 0 1h-.09Z"
]);
const $77e1bce0ac0f7fe7$export$988de9a26c4ea5a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff20Regular', "20", [
    "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7L4.71 4l.7.7 9.88 9.88.7.71 1.86 1.86a.5.5 0 0 1-.7.7L15.29 16a7.97 7.97 0 0 1-8.9 1.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10c0-2.03.76-3.88 2-5.3Zm10.58 10.6-3.61-3.62a.5.5 0 0 1-.38.31l-.09.01h-3a.5.5 0 0 1-.09-1H10.3l-2-2h-.8a.5.5 0 0 1-.18-.97L4.71 5.42a6.97 6.97 0 0 0-.82 8 .5.5 0 0 1 .07.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04a6.97 6.97 0 0 0 8-.82Z",
    "m16.62 14.5-.72-.73A7 7 0 0 0 6.23 4.1l-.73-.72A8 8 0 0 1 16.61 14.5Z",
    "M12.5 9h-1.38l-1-1h2.38a.5.5 0 0 1 .09 1h-.09Z"
]);
const $77e1bce0ac0f7fe7$export$3426ddaaa38aefb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l2.2 2.2a9.96 9.96 0 0 0-1.28 11.17l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12a9.96 9.96 0 0 0 11.16-1.28l2.2 2.2a.75.75 0 0 0 1.06-1.06L3.28 2.22Zm10.14 12.26-.07.01-.1.01h-4.6a.75.75 0 0 1 0-1.5h3.29l1.48 1.48ZM9.94 11H8.65a.75.75 0 0 1-.16-1.45L9.94 11Z",
    "M15.25 11h-1.07l6.3 6.3A10 10 0 0 0 6.7 3.52l5.98 5.98h2.67a.75.75 0 0 1 0 1.5h-.1Z"
]);
const $77e1bce0ac0f7fe7$export$f2041738c355bbae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l2.2 2.2a9.96 9.96 0 0 0-1.3 11.11l-1.07 3.83a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07a9.96 9.96 0 0 0 11.11-1.3l2.2 2.19a.75.75 0 0 0 1.06-1.06L3.28 2.22Zm14.18 16.3a8.47 8.47 0 0 1-9.6.91l-.26-.15-3.99 1.11 1.11-3.98-.15-.27a8.46 8.46 0 0 1 .91-9.6l3 3A.75.75 0 0 0 8.76 11h1.19l2 2H8.65a.75.75 0 0 0 .1 1.5h4.6l.07-.02 4.04 4.04Z",
    "M15.25 9.5h-2.57l1.5 1.5H15.35a.75.75 0 0 0-.1-1.5Z",
    "M20.5 12c0 1.53-.4 2.97-1.11 4.2l1.1 1.1A10 10 0 0 0 6.7 3.52l1.08 1.1A8.5 8.5 0 0 1 20.5 12Z"
]);
const $77e1bce0ac0f7fe7$export$37c914c6636dde02 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings16Filled', "16", [
    "M1 7a6 6 0 0 1 11.81-1.5 5.5 5.5 0 0 0-7.3 7.3 5.97 5.97 0 0 1-1.51-.6l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 1 7Zm7.07.44a2 2 0 0 1-1.43 2.48l-.46.12a4.7 4.7 0 0 0 0 1.02l.35.08A2 2 0 0 1 8 13.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 13 7.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$2992e05589610995 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings16Regular', "16", [
    "M1 7a6 6 0 0 1 11.81-1.5c-.37-.16-.76-.3-1.18-.38A5 5 0 1 0 2.7 9.55a.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06c.25.15.51.3.79.4.08.42.22.81.39 1.18A5.97 5.97 0 0 1 4 12.2l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 1 7Zm7.07.44a2 2 0 0 1-1.43 2.48l-.46.12a4.7 4.7 0 0 0 0 1.02l.35.08A2 2 0 0 1 8 13.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 13 7.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$533a7a9cd4133861 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.25A5.5 5.5 0 0 0 10.26 18a7.93 7.93 0 0 1-3.87-.85l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm2.07 9.44a2 2 0 0 1-1.44 2.48l-.46.12a4.73 4.73 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$5a88b2e274a2eebd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings20Regular', "20", [
    "M10 3a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .04.37l-.75 3.02 3.02-.75a.5.5 0 0 1 .37.05c.9.5 1.92.82 3.01.88.19.36.4.7.66 1a7.93 7.93 0 0 1-3.99-.92L2.62 18a.5.5 0 0 1-.6-.61l.9-3.64A8 8 0 1 1 18 10.26c-.3-.26-.64-.48-1-.67A7 7 0 0 0 10 3Zm2.07 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$1e1586590432d485 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings24Filled', "24", [
    "M12 2a10 10 0 0 1 9.97 10.78 6.5 6.5 0 0 0-9.19 9.19 10.14 10.14 0 0 1-5.42-1.11l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Zm2.28 11.98a2 2 0 0 1-1.44 2.5l-.59.14a5.73 5.73 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64c.44.38.94.7 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5.28 5.28 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a5.72 5.72 0 0 0 0-1.8l-.55-.13a2 2 0 0 1-1.45-2.51l.19-.63c-.44-.4-.94-.7-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52c-.54.22-1.04.53-1.48.9l.2.7ZM17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16Z"
]);
const $77e1bce0ac0f7fe7$export$43ed5ff73bfa9b21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSettings24Regular', "24", [
    "M22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07a9.96 9.96 0 0 0 5.37 1.08 6.52 6.52 0 0 1-1.05-1.47 8.45 8.45 0 0 1-3.86-1.07l-.27-.15-3.99 1.11 1.11-3.98-.15-.27a8.5 8.5 0 1 1 15.92-4.4c.55.27 1.04.63 1.48 1.04L22 12Zm-9.16 4.47a2 2 0 0 0 1.44-2.5l-.2-.68c.44-.38.94-.7 1.48-.91l.5.52a2 2 0 0 0 2.9 0l.5-.52c.54.23 1.04.54 1.48.93l-.19.63a2 2 0 0 0 1.45 2.5l.54.14a5.73 5.73 0 0 1 0 1.8l-.58.15a2 2 0 0 0-1.44 2.5l.2.68c-.44.38-.94.7-1.48.91l-.5-.52a2 2 0 0 0-2.9 0l-.5.52a5.28 5.28 0 0 1-1.48-.92l.19-.64a2 2 0 0 0-1.45-2.5l-.54-.14a5.72 5.72 0 0 1 0-1.8l.58-.15Zm6.11 1.03c0-.83-.65-1.5-1.45-1.5-.8 0-1.45.67-1.45 1.5S16.7 19 17.5 19c.8 0 1.45-.67 1.45-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$3c743fb3fbbfbfc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle16Filled', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02Zm-3.5 2.94c.09.23.23.42.42.58A5.99 5.99 0 0 1 5 13.19l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5a6 6 0 0 1 4.58-8.83l-.36.11A1.43 1.43 0 0 0 6 3.5a1.41 1.41 0 0 0 .97 1.35l1.06.35c.15.05.3.13.47.29.11.1.2.24.3.47l.35 1.1c.1.24.25.47.52.68.14.1.3.17.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25c.08.03.16.08.22.14.07.06.1.14.14.22l.26.8Z"
]);
const $77e1bce0ac0f7fe7$export$3f74b99e22c5d6fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle16Regular', "16", [
    "m10.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.2 2.2 0 0 0-1.4-1.4L7.28 3.9a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02Zm-3.5 2.94c.09.23.23.42.42.58A5.99 5.99 0 0 1 5 13.19l-2.34.78a.5.5 0 0 1-.64-.6l.71-2.5a6 6 0 0 1 4.58-8.83l-.36.11A1.43 1.43 0 0 0 6 3.41a5 5 0 0 0-2.3 7.14.5.5 0 0 1 .05.4l-.5 1.78 1.65-.56a.5.5 0 0 1 .43.06 4.97 4.97 0 0 0 6.83-1.45l.12.37Z"
]);
const $77e1bce0ac0f7fe7$export$daf609e59deb4b08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle20Filled', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.27 0-.52-.08-.74-.23a1.4 1.4 0 0 1-.48-.62l-.26-.8a.52.52 0 0 0-.14-.22.64.64 0 0 0-.22-.14l-.77-.25c-.27-.1-.49-.26-.65-.48a1.3 1.3 0 0 1-.12-1.3 1.32 1.32 0 0 1-.45-.22 1.51 1.51 0 0 1-.52-.69l-.36-1.09a1.27 1.27 0 0 0-.29-.47 1.3 1.3 0 0 0-.47-.3l-1.06-.34A1.41 1.41 0 0 1 10 3.5a1.4 1.4 0 0 1 .95-1.35l.22-.07A8 8 0 0 0 2 10v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 11.37-5.16l-.26.02Z"
]);
const $77e1bce0ac0f7fe7$export$7bb457ed46c95eeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle20Regular', "20", [
    "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM17.5 12c-.26 0-.51-.08-.73-.22a7 7 0 0 1-10.2 4.33l-.08-.04-.1-.02a.5.5 0 0 0-.18 0l-3.02.76.75-3.02.02-.1a.5.5 0 0 0-.07-.27A7 7 0 0 1 10.1 3a1.42 1.42 0 0 1 .86-.85l.22-.07A8 8 0 0 0 2 10v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06a8 8 0 0 0 11.37-5.16l-.26.02Z"
]);
const $77e1bce0ac0f7fe7$export$9bb9615868abba58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle24Filled', "24", [
    "M16.09 6.41a2.84 2.84 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.84 2.84 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.84 2.84 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.84 2.84 0 0 0-1.8 1.8l-.45 1.38a.54.54 0 0 1-1.03 0l-.44-1.38c-.1-.3-.25-.6-.45-.85Zm7.7 3.8-.77-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM12 2a10 10 0 0 1 2.76.39c-.12.07-.24.13-.37.17L13.05 3c-.3.1-.58.3-.77.57a1.57 1.57 0 0 0 0 1.79c.17.28.42.5.72.64l1.4.46c.27.09.52.24.72.44l.18.1c.13.17.22.35.29.55L16 9c.1.3.3.58.57.77a1.57 1.57 0 0 0 1.57.12 1.28 1.28 0 0 0 .06 1.4c.16.23.38.4.63.49l.79.25a.59.59 0 0 1 .36.37l.24.76c.1.26.26.49.49.65a1.29 1.29 0 0 0 1.09.2 10 10 0 0 1-14.44 6.85l-4.3 1.12a.85.85 0 0 1-1.03-1.04l1.11-4.29A10 10 0 0 1 12 2Z"
]);
const $77e1bce0ac0f7fe7$export$2aaa4724198422c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle24Regular', "24", [
    "M16.09 6.41a2.84 2.84 0 0 0-1.35-.95L13.36 5a.54.54 0 0 1 0-1.03l1.38-.44a2.84 2.84 0 0 0 1.76-1.77l.01-.03.45-1.38a.54.54 0 0 1 1.03 0l.44 1.38a2.84 2.84 0 0 0 1.8 1.8l1.38.44.03.01a.54.54 0 0 1 0 1.03l-1.38.44a2.84 2.84 0 0 0-1.8 1.8l-.45 1.38a.54.54 0 0 1-1.03 0l-.44-1.38c-.1-.3-.25-.6-.45-.85Zm7.7 3.8-.77-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM12 2a10 10 0 0 1 2.76.39c-.12.07-.24.13-.37.17L13.05 3c-.28.1-.53.28-.72.5H12a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15a8.5 8.5 0 0 0 12.5-5.96c.1.13.2.24.34.34a1.29 1.29 0 0 0 1.09.2A10 10 0 0 1 7.4 20.88L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2Z"
]);
const $77e1bce0ac0f7fe7$export$5de211489087f9d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle28Filled', "28", [
    "M18.17 6.83a3.16 3.16 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.15 3.15 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.54-.5a3.15 3.15 0 0 1-2-2L20.55.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.15 3.15 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5c.47.15.9.41 1.24.76Zm8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM14 2a12 12 0 0 1 3.45.5c-.24.23-.53.4-.84.5l-1.52.5c-.32.1-.6.31-.8.59a1.58 1.58 0 0 0 0 1.85c.2.27.47.48.78.59l1.56.5a2.25 2.25 0 0 1 1 .73c.16.19.28.4.35.64l.5 1.53c.11.32.32.6.59.8a1.64 1.64 0 0 0 1.86 0l.13-.11a1.34 1.34 0 0 0 .85 1.66l.94.3c.13.05.24.12.34.22.1.1.17.22.22.35l.3.92A1.34 1.34 0 0 0 25 15a1.37 1.37 0 0 0 .99-.42A12 12 0 0 1 8.36 24.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2Z"
]);
const $77e1bce0ac0f7fe7$export$84bc6687161a69bc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle28Regular', "28", [
    "M18.17 6.83a3.16 3.16 0 0 1 .76 1.24l.5 1.53a.6.6 0 0 0 1.14 0l.5-1.53a3.15 3.15 0 0 1 2-2l1.53-.5a.6.6 0 0 0 0-1.14h-.03l-1.54-.5a3.15 3.15 0 0 1-2-2L20.55.4a.6.6 0 0 0-1.14 0l-.5 1.53-.01.04a3.15 3.15 0 0 1-1.96 1.96l-1.53.5a.6.6 0 0 0 0 1.14l1.53.5c.47.15.9.41 1.24.76Zm8.65 3.53.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM14 2a12 12 0 0 1 3.45.5c-.24.23-.53.4-.84.5l-1.52.5-.12.04a10.5 10.5 0 0 0-10.1 15.63c.1.18.12.39.06.58L3.61 24.4l4.64-1.32c.2-.06.4-.03.57.07a10.5 10.5 0 0 0 15.64-8.25 1.37 1.37 0 0 0 1.53-.31A12 12 0 0 1 8.36 24.6L3.6 25.95c-.94.27-1.8-.6-1.54-1.54l1.36-4.77A12 12 0 0 1 14 2Z"
]);
const $77e1bce0ac0f7fe7$export$51cb9aaa44442069 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle32Filled', "32", [
    "M21.49 8.51a3.49 3.49 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.47 3.47 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.47 3.47 0 0 1-2.2-2.2l-.55-1.68a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.47 3.47 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55c.51.17.98.46 1.36.84Zm9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM16 2c1.68 0 3.3.3 4.79.84-.1.2-.23.4-.39.56-.21.22-.47.38-.76.48L18 4.44a2.17 2.17 0 0 0-1.5 2.06 2.17 2.17 0 0 0 1.45 2l1.71.56c.36.12.71.35.93.66.14.17.24.37.31.58l.55 1.7a2.16 2.16 0 0 0 3.3 1.08 1.9 1.9 0 0 0-.25.9 1.84 1.84 0 0 0 1.24 1.75l1 .3.14.11c.04.04.08.1.09.15l.3.91a2 2 0 0 0 .69.94 1.89 1.89 0 0 0 1.85.17A14 14 0 0 1 9.44 28.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2Z"
]);
const $77e1bce0ac0f7fe7$export$c3f8fc6fcdb1f9eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle32Regular', "32", [
    "M21.49 8.51a3.49 3.49 0 0 1 .84 1.36l.54 1.69a.66.66 0 0 0 1.26 0l.54-1.69a3.47 3.47 0 0 1 2.2-2.2l1.69-.54a.67.67 0 0 0 0-1.25l-.04-.01-1.68-.55a3.47 3.47 0 0 1-2.2-2.2l-.55-1.68a.66.66 0 0 0-1.25 0l-.55 1.69-.01.04a3.47 3.47 0 0 1-2.15 2.15l-1.69.55a.67.67 0 0 0 0 1.25l1.69.55c.51.17.98.46 1.36.84Zm9.33 4.85.92.3h.02a.36.36 0 0 1 0 .68l-.92.3a1.9 1.9 0 0 0-1.2 1.2l-.3.92a.36.36 0 0 1-.68 0l-.3-.92a1.9 1.9 0 0 0-1.2-1.2l-.92-.3a.36.36 0 0 1 0-.68l.92-.3a1.9 1.9 0 0 0 1.18-1.2l.3-.92a.36.36 0 0 1 .68 0l.3.92a1.89 1.89 0 0 0 1.2 1.2ZM16 2c1.68 0 3.3.3 4.79.84-.1.2-.23.4-.39.56-.21.22-.47.38-.76.48l-1.13.38A12 12 0 0 0 5.57 21.94a1 1 0 0 1 .1.77l-1.44 5.06 5.06-1.44a1 1 0 0 1 .77.1 12 12 0 0 0 17.77-8.4l.13.11a1.89 1.89 0 0 0 1.85.17A14 14 0 0 1 9.44 28.37l-5.53 1.57a1.5 1.5 0 0 1-1.85-1.85l1.57-5.53A14 14 0 0 1 16 2Z"
]);
const $77e1bce0ac0f7fe7$export$d6969e4836b59323 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle48Filled', "48", [
    "M31.83 13.11a5.36 5.36 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.36 5.36 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.36 5.36 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.36 5.36 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5.35 5.35 0 0 0-.85-1.6Zm14.78 6.87-1.38-.44a2.84 2.84 0 0 1-1.8-1.8L43 16.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.84 2.84 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45c.15.05.3.11.44.18v.02a2.84 2.84 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01a.5.5 0 0 0 .02-.04l.45-1.38a2.84 2.84 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03ZM29.93 5l.08-.08a20 20 0 0 0-23.6 28.6l-2.34 8.25a1.75 1.75 0 0 0 2.16 2.16l8.24-2.34a20 20 0 0 0 29.36-14.97 2.55 2.55 0 0 1-2.83-.08 2.54 2.54 0 0 1-.89-1.35l-.44-1.37a.86.86 0 0 0-.4-.48l-.12-.06-1.42-.46a2.55 2.55 0 0 1-1.7-2.4c0-.34.08-.69.22-1a3 3 0 0 1-4.59-1.51l-.84-2.59a3.24 3.24 0 0 0-2.17-2.11L26 12.35a3 3 0 0 1-1.44-4.58c.37-.52.9-.91 1.51-1.12l2.57-.83c.49-.17.93-.45 1.29-.82Z"
]);
const $77e1bce0ac0f7fe7$export$cef917c35bb6a3c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatSparkle48Regular', "48", [
    "M31.83 13.11a5.36 5.36 0 0 0-2.54-1.8l-2.6-.85a1.03 1.03 0 0 1 0-1.94l2.6-.84a5.36 5.36 0 0 0 3.32-3.33l.02-.06.85-2.6a1.03 1.03 0 0 1 1.94 0l.84 2.6a5.36 5.36 0 0 0 3.4 3.39l2.6.84.05.02a1.03 1.03 0 0 1 0 1.94l-2.6.84a5.36 5.36 0 0 0-3.4 3.4l-.84 2.6-.03.06a1.03 1.03 0 0 1-1.9-.07l-.86-2.6a5.35 5.35 0 0 0-.85-1.6Zm14.78 6.87-1.38-.44a2.84 2.84 0 0 1-1.8-1.8L43 16.36a.54.54 0 0 0-1.03 0l-.45 1.38a2.84 2.84 0 0 1-1.77 1.8l-1.38.44a.54.54 0 0 0 0 1.03l1.38.45c.15.05.3.11.44.18v.02a2.84 2.84 0 0 1 1.36 1.61l.45 1.38a.54.54 0 0 0 1 .04v-.01a.5.5 0 0 0 .02-.04l.45-1.38a2.84 2.84 0 0 1 1.8-1.8l1.38-.44a.54.54 0 0 0 0-1.03h-.03ZM24 4a20 20 0 0 1 6.01.92l-.08.08c-.36.37-.8.65-1.29.82l-2.5.8a17.5 17.5 0 0 0-17.3 26.12c.17.3.21.65.12.97l-2.12 7.44 7.44-2.11c.33-.1.68-.05.97.12a17.5 17.5 0 0 0 26.04-12.44 2.55 2.55 0 0 0 2.54-.1 20 20 0 0 1-29.36 14.97l-8.24 2.34a1.75 1.75 0 0 1-2.16-2.16l2.34-8.24A20 20 0 0 1 24 4Z"
]);
const $77e1bce0ac0f7fe7$export$c7fed079b97079ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo20Filled', "20", [
    "M18 10a8 8 0 1 0-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0 0 18 10ZM6 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8Zm7.15-.15a.5.5 0 0 1 .85.36v3.58a.5.5 0 0 1-.85.36L12 11V9l1.15-1.15Z"
]);
const $77e1bce0ac0f7fe7$export$3a1874985925af56 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo20Regular', "20", [
    "M6 8a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8Zm6 1 1.15-1.15a.5.5 0 0 1 .85.36v3.58a.5.5 0 0 1-.85.36L12 11V9Zm-2-7a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 10 3Z"
]);
const $77e1bce0ac0f7fe7$export$c674bec42c5f8ddf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.04l4.29-1.12A10 10 0 0 0 22 12ZM12 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h3Zm3 5.16v-2.32l1.73-1.64a.75.75 0 0 1 1.27.54v4.52c0 .66-.79 1-1.27.54L15 13.16Z"
]);
const $77e1bce0ac0f7fe7$export$328e14ceeeb7ea5b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatVideo24Regular', "24", [
    "M12 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h3Zm3 5.16v-2.32l1.73-1.64a.75.75 0 0 1 1.27.54v4.52c0 .66-.79 1-1.27.54L15 13.16ZM22 12a10 10 0 1 0-18.89 4.6l-1.06 3.82a1.25 1.25 0 0 0 1.54 1.54l3.82-1.07A10 10 0 0 0 22 12ZM3.5 12a8.5 8.5 0 1 1 4.37 7.43l-.27-.15-3.99 1.11 1.11-3.98-.15-.27A8.46 8.46 0 0 1 3.5 12Z"
]);
const $77e1bce0ac0f7fe7$export$c8b18a4b4d00e101 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning16Filled', "16", [
    "M2 8a6 6 0 1 1 3 5.2l-2.34.77a.5.5 0 0 1-.64-.6l.71-2.5A5.98 5.98 0 0 1 2 8Zm6.75 2.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-.26-5.84A.5.5 0 0 0 7.5 5v3.59a.5.5 0 0 0 1-.09V4.91Z"
]);
const $77e1bce0ac0f7fe7$export$14d0abdecf5d1a3e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning16Regular', "16", [
    "M8.75 10.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-.26-5.84A.5.5 0 0 0 7.5 5v3.59a.5.5 0 0 0 1-.09V4.91ZM8 2a6 6 0 0 0-5.27 8.87l-.71 2.5a.5.5 0 0 0 .64.6L5 13.2A6 6 0 1 0 8 2ZM3 8a5 5 0 1 1 2.33 4.23.5.5 0 0 0-.43-.06l-1.66.56.51-1.79a.5.5 0 0 0-.05-.39A4.97 4.97 0 0 1 3 8Z"
]);
const $77e1bce0ac0f7fe7$export$2c899825e892d555 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning20Filled', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 3.5a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 1 0V6a.5.5 0 0 0-.5-.5Zm0 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$ccfb2e952f3242ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning20Regular', "20", [
    "M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 10 3Zm0 2.5c.28 0 .5.22.5.5v5.5a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5Zm0 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$a278fdafcc136730 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning24Filled', "24", [
    "M22 12a10 10 0 1 0-18.86 4.65l-1.11 4.29a.85.85 0 0 0 1.04 1.03l4.29-1.11A10 10 0 0 0 22 12ZM12 6.5c.41 0 .75.34.75.75v6.25a.75.75 0 0 1-1.5 0V7.25c0-.41.34-.75.75-.75Zm1 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
]);
const $77e1bce0ac0f7fe7$export$83805d6781758e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChatWarning24Regular', "24", [
    "M12 6.5c.41 0 .75.34.75.75v6.25a.75.75 0 0 1-1.5 0V7.25c0-.41.34-.75.75-.75Zm0 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 2a10 10 0 1 1-4.59 18.89L3.6 21.96a1.25 1.25 0 0 1-1.54-1.54l1.06-3.83A10 10 0 0 1 12 2Zm0 1.5a8.5 8.5 0 0 0-7.43 12.64l.15.27-1.1 3.98 3.98-1.11.27.15A8.5 8.5 0 1 0 12 3.5Z"
]);
const $77e1bce0ac0f7fe7$export$46d3f2b895feb843 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check20Filled', "20", [
    "M15.88 5H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7.12l-4.44 4.44a1.5 1.5 0 0 1-2.12-2.12L15.88 5ZM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm13.85-5.65a.5.5 0 0 0-.7-.7l-5 5a.5.5 0 0 0 .7.7l5-5Z"
]);
const $77e1bce0ac0f7fe7$export$40e1fbd66d279874 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check20Regular', "20", [
    "M18 7.12V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h11.88l-1 1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.12l1-1ZM4 8.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm13.85-6.35c.2.2.2.5 0 .7l-6 6a.5.5 0 0 1-.7-.7l6-6c.2-.2.5-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$9a03e4b20f5fe33f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check24Filled', "24", [
    "M21.77 5.79a.75.75 0 1 0-1.04-1.08l-6.75 6.5a.75.75 0 1 0 1.04 1.08l6.75-6.5ZM18.99 5H4.55A2.55 2.55 0 0 0 2 7.55v6.9C2 15.85 3.14 17 4.55 17h14.9c1.4 0 2.55-1.14 2.55-2.55v-6.9c0-.18-.02-.36-.06-.54l-6.23 6a1.75 1.75 0 0 1-2.42-2.52L18.99 5ZM4.5 9.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm0 3.5c0-.41.34-.75.75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$eed406905ced219c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Check24Regular', "24", [
    "M21.78 5.78a.75.75 0 0 0-1.06-1.06l-7.5 7.5a.75.75 0 1 0 1.06 1.06l7.5-7.5Zm.17 1.25c.03.17.05.34.05.52v6.9c0 1.4-1.14 2.55-2.55 2.55H4.55A2.55 2.55 0 0 1 2 14.45v-6.9C2 6.15 3.14 5 4.55 5h14.48l-1.5 1.5H4.55c-.58 0-1.05.47-1.05 1.05v6.9c0 .58.47 1.05 1.05 1.05h14.9c.58 0 1.05-.47 1.05-1.05V8.47l1.45-1.44ZM4.5 9.25c0-.41.34-.75.75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Zm0 3.5c0-.41.34-.75.75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$34004d92a1b1bc13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox16Color', "16", `<path d="M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Z" fill="url(#ic_fluent_checkbox_16_color__a)"/><path d="m10.85 6.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7 9.29l3.15-3.14a.5.5 0 0 1 .7.7Z" fill="url(#ic_fluent_checkbox_16_color__b)"/><defs><linearGradient id="ic_fluent_checkbox_16_color__a" x1="2.43" y1="4.25" x2="10.71" y2="12.85" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_checkbox_16_color__b" x1="6.15" y1="6.35" x2="8.8" y2="14.9" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$ddc296961e40d14b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox120Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8c.77 0 1.47-.29 2-.76v-.83a1.5 1.5 0 0 1-1.4-2.61l2-1.5c.12-.1.26-.16.4-.21V6a3 3 0 0 0-3-3H6Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7Zm3.87 4.2a.5.5 0 0 1 .28.45v5a.5.5 0 0 1-1 0v-4l-1.2.9a.5.5 0 0 1-.6-.8l2-1.5a.5.5 0 0 1 .52-.05Z"
]);
const $77e1bce0ac0f7fe7$export$f57d2d52cc47345 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox120Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8c.77 0 1.47-.29 2-.76v-.83c-.22.08-.44.1-.67.08A2 2 0 0 1 14 16H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.75l.6-.45c.12-.1.26-.16.4-.21V6a3 3 0 0 0-3-3H6Zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5Zm3.87 4.2a.5.5 0 0 1 .28.45v5a.5.5 0 0 1-1 0v-4l-1.2.9a.5.5 0 0 1-.6-.8l2-1.5a.5.5 0 0 1 .52-.05Z"
]);
const $77e1bce0ac0f7fe7$export$26c4fb6ce6d395f8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox124Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c.64 0 1.24-.19 1.75-.51v-1.66a1.75 1.75 0 0 1-1.84-2.95l2.5-2a1.75 1.75 0 0 1 .84-.36V6.25C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06ZM21 14.54a.75.75 0 0 0-.22.12l-2.5 2a.75.75 0 1 0 .94 1.18l1.28-1.03v4.44a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1-.7Z"
]);
const $77e1bce0ac0f7fe7$export$b015a6ac6a418c2a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox124Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c.64 0 1.24-.19 1.75-.51v-1.66c-.16.08-.33.13-.5.15-.33.32-.76.52-1.25.52H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v8.16l.66-.53a1.75 1.75 0 0 1 .84-.36V6.25C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0l6.75-6.75ZM21 14.54a.75.75 0 0 0-.22.12l-2.5 2a.75.75 0 1 0 .94 1.18l1.28-1.03v4.44a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1-.7Z"
]);
const $77e1bce0ac0f7fe7$export$c1c5f6675b65d0c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox20Color', "20", `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5Z" fill="url(#ic_fluent_checkbox_20_color__a)"/><path d="M13.85 7.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5Z" fill="url(#ic_fluent_checkbox_20_color__b)"/><defs><linearGradient id="ic_fluent_checkbox_20_color__a" x1="3.5" y1="5.63" x2="13.16" y2="15.66" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_checkbox_20_color__b" x1="7.54" y1="7.46" x2="11.07" y2="18.87" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$48e14e54dca18d2e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox24Color', "24", `<path d="M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Z" fill="url(#ic_fluent_checkbox_24_color__a)"/><path d="m17.28 9.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06Z" fill="url(#ic_fluent_checkbox_24_color__b)"/><defs><linearGradient id="ic_fluent_checkbox_24_color__a" x1="3.64" y1="6.38" x2="16.07" y2="19.28" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_checkbox_24_color__b" x1="8.62" y1="8.63" x2="13.47" y2="24.31" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$3766828a2cdf841a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox220Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h7.05c.06-.3.18-.63.4-1 .23-.4.57-.8 1.04-1.23a1.5 1.5 0 0 1-1.12-2.48A3.51 3.51 0 0 1 15.82 11c.42-.02.82.05 1.18.17V6a3 3 0 0 0-3-3H6Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7ZM15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65c.54-.61 1.15-.91 1.76-.95.6-.03 1.14.2 1.52.57.38.36.63.88.59 1.43-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45 1.43 1.43 0 0 1 .03-.34c.04-.19.12-.42.28-.7a5.8 5.8 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.84.84 0 0 0-.28-.64c-.2-.19-.48-.3-.78-.29Z"
]);
const $77e1bce0ac0f7fe7$export$8a6536ece20fe103 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox220Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h7.05c.06-.3.18-.63.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5c.35 0 .69.06 1 .17V6a3 3 0 0 0-3-3H6Zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5ZM15.93 13c-.3.02-.67.16-1.05.6a.5.5 0 1 1-.76-.65c.54-.61 1.15-.91 1.76-.95.6-.03 1.14.2 1.52.57.38.36.63.88.59 1.43-.04.57-.38 1.1-.99 1.45-1.1.64-1.6 1.2-1.82 1.55h2.32a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.45 1.43 1.43 0 0 1 .03-.34c.04-.19.12-.42.28-.7a5.8 5.8 0 0 1 2.2-1.93c.36-.21.47-.46.48-.65a.84.84 0 0 0-.28-.64c-.2-.19-.48-.3-.78-.29Z"
]);
const $77e1bce0ac0f7fe7$export$e52a5bd321bba7f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox224Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h10c.11-1.86 1.38-2.85 2.1-3.38a1.75 1.75 0 0 1-1.65-2.88 3.8 3.8 0 0 1 3.47-1.18c.28.06.56.15.83.29v-7.6C21 4.45 19.54 3 17.75 3H6.25Zm12.81 15.35c-.7.5-1.7 1.23-1.8 2.65l-.01.25c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5h-2.06a3.45 3.45 0 0 1 1.09-1l.04-.03c.22-.16.47-.34.72-.56.5-.46.96-1.08.96-2 0-.63-.17-1.18-.5-1.6a2.05 2.05 0 0 0-1.27-.76 2.8 2.8 0 0 0-2.54.86.75.75 0 1 0 1.12 1c.27-.3.76-.47 1.13-.4.17.04.3.12.38.22.09.11.18.31.18.68 0 .55-.35.83-1.19 1.44Zm-1.78-9.07-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$18632c6763606f0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkbox224Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h10c.04-.58.19-1.08.4-1.5H6.24c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v7.25a3.5 3.5 0 0 1 1.5.35v-7.6C21 4.45 19.54 3 17.75 3H6.25Zm11.56 16.5a2.86 2.86 0 0 0-.56 1.75c0 .41.34.75.75.75h3a.75.75 0 0 0 0-1.5h-2.06a3.45 3.45 0 0 1 1.09-1l.04-.03c.22-.16.47-.34.72-.56.5-.46.96-1.08.96-2 0-.63-.17-1.18-.5-1.6a2.05 2.05 0 0 0-1.27-.76 2.82 2.82 0 0 0-2.54.86.75.75 0 1 0 1.12 1 1.32 1.32 0 0 1 1.13-.4c.17.04.3.12.38.22.09.11.18.31.18.68 0 .45-.23.72-.77 1.13-.13.1-.26.2-.42.3-.4.3-.88.65-1.25 1.16Zm-.53-10.22a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0l6.75-6.75Z"
]);
const $77e1bce0ac0f7fe7$export$5f3303fb4e4a2d5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2A5.5 5.5 0 0 1 16 9.2V5a3 3 0 0 0-3-3H5Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7ZM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
]);
const $77e1bce0ac0f7fe7$export$119b1753c492bb1c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2c-.08-.32-.15-.66-.18-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4.02c.34.03.68.1 1 .19V5a3 3 0 0 0-3-3H5Zm7.85 4.85a.5.5 0 0 0-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l5-5ZM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z"
]);
const $77e1bce0ac0f7fe7$export$11aea36eb024ed94 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight24Filled', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v11.5C2 18.55 3.46 20 5.25 20h6.25a6.5 6.5 0 0 1 8.5-8.5V5.25C20 3.45 18.54 2 16.75 2H5.25Zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L9 13.44l6.22-6.22a.75.75 0 1 1 1.06 1.06ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17H14.5Z"
]);
const $77e1bce0ac0f7fe7$export$f20901f0b21c5616 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxArrowRight24Regular', "24", [
    "M5.25 2A3.25 3.25 0 0 0 2 5.25v11.5C2 18.55 3.46 20 5.25 20h6.25c-.2-.47-.34-.98-.42-1.5H5.25c-.97 0-1.75-.78-1.75-1.75V5.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v5.83c.52.08 1.03.22 1.5.42V5.25C20 3.45 18.54 2 16.75 2H5.25Zm11.03 6.28a.75.75 0 1 0-1.06-1.06L9 13.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0l6.75-6.75ZM17.5 12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm-3 5a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L19.29 17H14.5Z"
]);
const $77e1bce0ac0f7fe7$export$3221cacdfc23a74b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Zm6.35 4.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7 9.29l3.15-3.14a.5.5 0 0 1 .7.7Z"
]);
const $77e1bce0ac0f7fe7$export$ac176cfd9164d78f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7Zm7.85 2.35a.5.5 0 0 0-.7-.7L7 9.29 5.85 8.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$7afbd228ce7724b0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7Z"
]);
const $77e1bce0ac0f7fe7$export$4163fc3f4a6afc6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm9.85 1.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5Z"
]);
const $77e1bce0ac0f7fe7$export$c8735a94ad571647 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$c9f70fc1b1a87bbb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxChecked24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25ZM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25Zm12.78 3.03a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0l6.75-6.75Z"
]);
const $77e1bce0ac0f7fe7$export$4b55059290401a13 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync16Filled', "16", [
    "M2.5 0A2.5 2.5 0 0 0 0 2.5v7A2.5 2.5 0 0 0 2.5 12h3.52A5.5 5.5 0 0 1 12 6.02V2.5A2.5 2.5 0 0 0 9.5 0h-7Zm6.35 4.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L5 7.29l3.15-3.14a.5.5 0 1 1 .7.7ZM7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a1.98 1.98 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $77e1bce0ac0f7fe7$export$46033ebfd01b1261 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync16Regular', "16", [
    "M2.5 0A2.5 2.5 0 0 0 0 2.5v7A2.5 2.5 0 0 0 2.5 12h3.52a5.57 5.57 0 0 1 0-1H2.5A1.5 1.5 0 0 1 1 9.5v-7C1 1.67 1.67 1 2.5 1h7c.83 0 1.5.67 1.5 1.5v3.52a5.57 5.57 0 0 1 1 0V2.5A2.5 2.5 0 0 0 9.5 0h-7Zm6.35 4.85a.5.5 0 1 0-.7-.7L5 7.29 3.85 6.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5ZM7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H12a.5.5 0 0 1 0-1h.47a1.98 1.98 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 0 1-.71-.71A3 3 0 0 1 13 9.15V9c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V14a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H11a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $77e1bce0ac0f7fe7$export$901736fdd14acd50 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync20Filled', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2A5.5 5.5 0 0 1 16 9.2V5a3 3 0 0 0-3-3H5Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7ZM10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $77e1bce0ac0f7fe7$export$3e6c3906e9a83976 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxCheckedSync20Regular', "20", [
    "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.2c-.08-.32-.15-.66-.18-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4.02c.34.03.68.1 1 .19V5a3 3 0 0 0-3-3H5Zm7.85 4.85a.5.5 0 0 0-.7-.7L7.5 10.79 5.85 9.15a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l5-5ZM10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z"
]);
const $77e1bce0ac0f7fe7$export$981bf28810402867 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate16Filled', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Zm-1 2.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7Zm2 .5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Z"
]);
const $77e1bce0ac0f7fe7$export$8cefe2ba281c6a58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate16Regular', "16", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7ZM5 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z"
]);
const $77e1bce0ac0f7fe7$export$bde9ff718393ca4a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4.5 6c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H6A1.5 1.5 0 0 1 4.5 14V6ZM7 6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7Z"
]);
const $77e1bce0ac0f7fe7$export$2c0315ead1e5e105 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm2.5-1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7Z"
]);
const $77e1bce0ac0f7fe7$export$8465c0eb67c8226e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25ZM5 6.25C5 5.56 5.56 5 6.25 5h11.5c.69 0 1.25.56 1.25 1.25v11.5c0 .69-.56 1.25-1.25 1.25H6.25C5.56 19 5 18.44 5 17.75V6.25Zm2.5.25a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-9Z"
]);
const $77e1bce0ac0f7fe7$export$e02915b90ee5e8f5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxIndeterminate24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25ZM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25ZM7.25 6C6.56 6 6 6.56 6 7.25v9.5c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25v-9.5C18 6.56 17.44 6 16.75 6h-9.5Z"
]);
const $77e1bce0ac0f7fe7$export$6c79b8e125a62bfb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson16Color', "16", `<path d="M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Z" fill="url(#ic_fluent_checkbox_person_16_color__a)"/><path d="M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Z" fill="url(#ic_fluent_checkbox_person_16_color__b)"/><path d="M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2h-7Z" fill="url(#ic_fluent_checkbox_person_16_color__c)"/><path d="m10.85 6.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L7 9.29l3.15-3.14a.5.5 0 0 1 .7.7Z" fill="url(#ic_fluent_checkbox_person_16_color__d)"/><path d="M16 13.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z" fill="url(#ic_fluent_checkbox_person_16_color__e)"/><path d="M16 13.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z" fill="url(#ic_fluent_checkbox_person_16_color__f)"/><path d="M14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" fill="url(#ic_fluent_checkbox_person_16_color__g)"/><defs><linearGradient id="ic_fluent_checkbox_person_16_color__a" x1="2.43" y1="4.25" x2="10.71" y2="12.85" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_16_color__d" x1="6.15" y1="6.35" x2="8.8" y2="14.9" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_16_color__e" x1="10.66" y1="12.53" x2="12.1" y2="16.55" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#BD96FF"/><stop offset="1" stop-color="#9C6CFE"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_16_color__f" x1="12.5" y1="11.52" x2="14.53" y2="18.15" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_16_color__g" x1="11.45" y1="7.53" x2="13.49" y2="10.79" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#BD96FF"/><stop offset="1" stop-color="#9C6CFE"/></linearGradient><radialGradient id="ic_fluent_checkbox_person_16_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(5 0 0 3.46354 12.5 13.5)"><stop stop-color="#4A43CB"/><stop offset=".91" stop-color="#4A43CB" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_checkbox_person_16_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 2.5 -2.5 0 12.5 10)"><stop stop-color="#4A43CB"/><stop offset="1" stop-color="#4A43CB" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$d784ccb2228cbccc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson16Filled', "16", [
    "M3.5 1A2.5 2.5 0 0 0 1 3.5v7A2.5 2.5 0 0 0 3.5 13h4.55a2.5 2.5 0 0 1 2.22-1.99A3 3 0 0 1 13 6.04V3.5A2.5 2.5 0 0 0 10.5 1h-7Zm6.35 4.85-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6 8.29l3.15-3.14a.5.5 0 1 1 .7.7ZM14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$989156c24de2de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson16Regular', "16", [
    "M3.5 1A2.5 2.5 0 0 0 1 3.5v7A2.5 2.5 0 0 0 3.5 13h4.55c.07-.37.23-.7.45-1h-5A1.5 1.5 0 0 1 2 10.5v-7C2 2.67 2.67 2 3.5 2h7c.83 0 1.5.67 1.5 1.5v2.54a3.02 3.02 0 0 1 1 0V3.5A2.5 2.5 0 0 0 10.5 1h-7Zm6.35 4.85a.5.5 0 0 0-.7-.7L6 8.29 4.85 7.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5ZM14.5 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S9 14.75 9 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$2c4ee4a40f37925d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson20Color', "20", `<path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5Z" fill="url(#ic_fluent_checkbox_person_20_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5Z" fill="url(#ic_fluent_checkbox_person_20_color__b)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6.25C3 4.45 4.46 3 6.25 3h7.5C15.55 3 17 4.46 17 6.25v7.5c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 0 1 3 13.75v-7.5Z" fill="url(#ic_fluent_checkbox_person_20_color__c)"/><path d="M13.85 7.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5Z" fill="url(#ic_fluent_checkbox_person_20_color__d)"/><path d="M19 16.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z" fill="url(#ic_fluent_checkbox_person_20_color__e)"/><path d="M19 16.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z" fill="url(#ic_fluent_checkbox_person_20_color__f)"/><path d="M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" fill="url(#ic_fluent_checkbox_person_20_color__g)"/><defs><linearGradient id="ic_fluent_checkbox_person_20_color__a" x1="3.5" y1="5.63" x2="13.16" y2="15.66" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_20_color__d" x1="7.54" y1="7.46" x2="11.07" y2="18.87" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_20_color__e" x1="13.66" y1="15.53" x2="15.1" y2="19.55" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#BD96FF"/><stop offset="1" stop-color="#9C6CFE"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_20_color__f" x1="15.5" y1="14.52" x2="17.53" y2="21.15" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_20_color__g" x1="14.45" y1="10.53" x2="16.49" y2="13.79" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#BD96FF"/><stop offset="1" stop-color="#9C6CFE"/></linearGradient><radialGradient id="ic_fluent_checkbox_person_20_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(6.6292 0 0 4.5921 15.53 16.25)"><stop stop-color="#4A43CB"/><stop offset=".91" stop-color="#4A43CB" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_checkbox_person_20_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 1.32 14.13) scale(3.24526)"><stop stop-color="#4A43CB"/><stop offset="1" stop-color="#4A43CB" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$a4cc5d996c686a49 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.04a2.5 2.5 0 0 1 2.23-2.99A2.99 2.99 0 0 1 15.5 9c.55 0 1.06.15 1.5.4V6a3 3 0 0 0-3-3H6Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7ZM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$bbc2e89b68e3cf6b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5.04a3.3 3.3 0 0 1 .01-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.04c.36.06.7.19 1 .36V6a3 3 0 0 0-3-3H6Zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5ZM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$31d42aa45c581c03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson24Color', "24", `<path d="M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Z" fill="url(#ic_fluent_checkbox_person_24_color__a)"/><path d="M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Z" fill="url(#ic_fluent_checkbox_person_24_color__b)"/><path d="M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Z" fill="url(#ic_fluent_checkbox_person_24_color__c)"/><path d="m17.28 9.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06Z" fill="url(#ic_fluent_checkbox_person_24_color__d)"/><path d="M23 19.88c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z" fill="url(#ic_fluent_checkbox_person_24_color__e)"/><path d="M23 19.88c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z" fill="url(#ic_fluent_checkbox_person_24_color__f)"/><path d="M21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" fill="url(#ic_fluent_checkbox_person_24_color__g)"/><defs><linearGradient id="ic_fluent_checkbox_person_24_color__a" x1="3.64" y1="6.38" x2="16.07" y2="19.28" gradientUnits="userSpaceOnUse"><stop stop-color="#36DFF1"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_24_color__d" x1="8.62" y1="8.63" x2="13.47" y2="24.31" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#B3E0FF"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_24_color__e" x1="16.14" y1="18.66" x2="17.9" y2="23.72" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#BD96FF"/><stop offset="1" stop-color="#9C6CFE"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_24_color__f" x1="18.5" y1="17.4" x2="20.97" y2="25.73" gradientUnits="userSpaceOnUse"><stop stop-color="#885EDB" stop-opacity="0"/><stop offset="1" stop-color="#E362F8"/></linearGradient><linearGradient id="ic_fluent_checkbox_person_24_color__g" x1="17.19" y1="12.66" x2="19.74" y2="16.73" gradientUnits="userSpaceOnUse"><stop offset=".13" stop-color="#BD96FF"/><stop offset="1" stop-color="#9C6CFE"/></linearGradient><radialGradient id="ic_fluent_checkbox_person_24_color__b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(8 0 0 5.54167 18.5 20.5)"><stop stop-color="#4A43CB"/><stop offset=".91" stop-color="#4A43CB" stop-opacity="0"/></radialGradient><radialGradient id="ic_fluent_checkbox_person_24_color__c" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 1.5 17) scale(3.5)"><stop stop-color="#4A43CB"/><stop offset="1" stop-color="#4A43CB" stop-opacity="0"/></radialGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$b061524226690e0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h6.92a3.74 3.74 0 0 1-.17-1.13v-.1A2.77 2.77 0 0 1 15.77 17h.28a3.49 3.49 0 0 1 2.45-6c.98 0 1.86.4 2.5 1.05v-5.8C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06ZM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $77e1bce0ac0f7fe7$export$397d83e9ed1cf29a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxPerson24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h6.92a3.74 3.74 0 0 1-.17-1.13v-.1l.01-.27H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v4.9a3.5 3.5 0 0 1 1.5.9v-5.8C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0l6.75-6.75ZM21 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1Z"
]);
const $77e1bce0ac0f7fe7$export$defa37380057cc99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked12Filled', "12", [
    "M2 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm2-.5a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H4Z"
]);
const $77e1bce0ac0f7fe7$export$e2df8e3c56fb7d4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked12Regular', "12", [
    "M2 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Z"
]);
const $77e1bce0ac0f7fe7$export$c0e6692b191fd2d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked16Filled', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7Zm2.5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-7Z"
]);
const $77e1bce0ac0f7fe7$export$b9df7686607478b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked16Regular', "16", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7ZM4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7Z"
]);
const $77e1bce0ac0f7fe7$export$fb86162d9555deb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked20Filled', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1.5c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6c0-.83-.67-1.5-1.5-1.5H6Z"
]);
const $77e1bce0ac0f7fe7$export$f27666c2b1a774f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked20Regular', "20", [
    "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z"
]);
const $77e1bce0ac0f7fe7$export$bfd493d27bc7bab5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked24Filled', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25ZM6.25 5C5.56 5 5 5.56 5 6.25v11.5c0 .69.56 1.25 1.25 1.25h11.5c.69 0 1.25-.56 1.25-1.25V6.25C19 5.56 18.44 5 17.75 5H6.25Z"
]);
const $77e1bce0ac0f7fe7$export$799dc389d102935a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxUnchecked24Regular', "24", [
    "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 0 1 3 17.75V6.25ZM6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75H6.25Z"
]);
const $77e1bce0ac0f7fe7$export$964c03e09ffcb159 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.27l3.44-6.9a2 2 0 0 1 3.58 0l.71 1.42V6a3 3 0 0 0-3-3H6Zm7.85 4.85-5 5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7l1.65 1.64 4.65-4.64a.5.5 0 0 1 .7.7Zm-.25 2.7-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$59b708156d5960eb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.27l.5-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.67c.11.13.21.27.3.44l.7 1.41V6a3 3 0 0 0-3-3H6Zm7.85 4.85a.5.5 0 0 0-.7-.7L8.5 11.79l-1.65-1.64a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l5-5Zm-.25 2.7-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$7b9cf511bae51a37 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h4.8c.05-.2.12-.42.22-.62l4-8a2.5 2.5 0 0 1 4.47 0L21 14.9V6.25C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28-6.75 6.75c-.3.29-.77.29-1.06 0l-2.75-2.75a.75.75 0 0 1 1.06-1.06L10 14.44l6.22-6.22a.75.75 0 1 1 1.06 1.06Zm-1.12 3.55-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0ZM18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$e9e1a1a7029f16da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckboxWarning24Regular', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h4.8c.05-.2.12-.42.22-.62l.44-.88H6.25c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v5.74c.09.12.17.25.24.4L21 14.9V6.25C21 4.45 19.54 3 17.75 3H6.25Zm11.03 6.28a.75.75 0 1 0-1.06-1.06L10 14.44l-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75c.29.29.76.29 1.06 0l6.75-6.75Zm-1.12 3.55-4 8A1.5 1.5 0 0 0 13.51 23h8a1.5 1.5 0 0 0 1.33-2.17l-4-8a1.5 1.5 0 0 0-2.68 0ZM18 15.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$ea97004bee98e8e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark12Filled', "12", [
    "M9.76 3.2c.3.29.32.76.04 1.06l-4.25 4.5a.75.75 0 0 1-1.08.02L2.22 6.53a.75.75 0 0 1 1.06-1.06l1.7 1.7L8.7 3.24a.75.75 0 0 1 1.06-.04Z"
]);
const $77e1bce0ac0f7fe7$export$515f34a868f2f664 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark12Regular', "12", [
    "M9.85 3.15c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L5 7.29l4.15-4.14c.2-.2.5-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$d958ed78946d42ef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark16Filled', "16", [
    "M14.05 3.49c.28.3.27.77-.04 1.06l-7.93 7.47A.85.85 0 0 1 4.9 12L2.22 9.28a.75.75 0 1 1 1.06-1.06l2.24 2.27 7.47-7.04a.75.75 0 0 1 1.06.04Z"
]);
const $77e1bce0ac0f7fe7$export$7fa2da86ef4db94b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark16Regular', "16", [
    "M13.86 3.66a.5.5 0 0 1-.02.7l-7.93 7.48a.6.6 0 0 1-.84-.02L2.4 9.1a.5.5 0 0 1 .72-.7l2.4 2.44 7.65-7.2a.5.5 0 0 1 .7.02Z"
]);
const $77e1bce0ac0f7fe7$export$c6c730cc7dfbec73 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark20Filled', "20", [
    "M7.03 13.9 3.56 10a.75.75 0 0 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06l-9.94 9.94Z"
]);
const $77e1bce0ac0f7fe7$export$2c80ee2f74739ccd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark20Regular', "20", [
    "M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27l-3.65-4.1Z"
]);
const $77e1bce0ac0f7fe7$export$40e0285be0ea111d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark24Filled', "24", [
    "m8.5 16.59-3.8-3.8a1 1 0 0 0-1.4 1.42l4.5 4.5a1 1 0 0 0 1.4 0l11-11a1 1 0 0 0-1.4-1.42L8.5 16.6Z"
]);
const $77e1bce0ac0f7fe7$export$c1c7efebde6aa976 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark24Regular', "24", [
    "M4.53 12.97a.75.75 0 0 0-1.06 1.06l4.5 4.5c.3.3.77.3 1.06 0l11-11a.75.75 0 0 0-1.06-1.06L8.5 16.94l-3.97-3.97Z"
]);
const $77e1bce0ac0f7fe7$export$fbc3dfef2e71f82e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark28Filled', "28", [
    "m10.5 19.59-6.3-6.3a1 1 0 0 0-1.4 1.42l7 7a1 1 0 0 0 1.4 0l14-14a1 1 0 0 0-1.4-1.42L10.5 19.6Z"
]);
const $77e1bce0ac0f7fe7$export$cff6e9518fed6ecd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark28Regular', "28", [
    "M4.03 13.47a.75.75 0 0 0-1.06 1.06l7 7c.3.3.77.3 1.06 0l14-14a.75.75 0 0 0-1.06-1.06L10.5 19.94l-6.47-6.47Z"
]);
const $77e1bce0ac0f7fe7$export$f2111711b82fc63e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark32Filled', "32", [
    "M29.9 5.14c.48.5.46 1.3-.04 1.77l-19 18a1.25 1.25 0 0 1-1.77-.06L2.34 17.6a1.25 1.25 0 0 1 1.82-1.7l5.9 6.33L28.14 5.09c.5-.47 1.3-.45 1.77.05Z"
]);
const $77e1bce0ac0f7fe7$export$2576c8304bdffdde = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark32Light', "32", [
    "M29.85 5.15c.2.2.2.5 0 .7l-19 19a.5.5 0 0 1-.7 0l-8-8a.5.5 0 0 1 .7-.7l7.65 7.64L29.15 5.15c.2-.2.5-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$b0d22be9f84942fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark32Regular', "32", [
    "M29.73 5.31a1 1 0 0 1-.04 1.42l-19 18a1 1 0 0 1-1.42-.05l-7-7.5a1 1 0 1 1 1.46-1.36l6.31 6.76 18.27-17.3a1 1 0 0 1 1.42.03Z"
]);
const $77e1bce0ac0f7fe7$export$a5effc10870e495c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark48Filled', "48", [
    "M40.32 12.7a1.5 1.5 0 0 1-.02 2.12l-22.25 22a1.5 1.5 0 0 1-2.1 0l-9.25-9a1.5 1.5 0 1 1 2.1-2.15l8.2 7.98 21.2-20.97a1.5 1.5 0 0 1 2.12.02Z"
]);
const $77e1bce0ac0f7fe7$export$d7be6162f76b15da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Checkmark48Regular', "48", [
    "M40.14 12.87c.48.5.48 1.28-.01 1.77l-22.25 22c-.49.48-1.26.48-1.75 0l-9.25-9a1.25 1.25 0 1 1 1.74-1.79L17 34l21.38-21.14c.5-.48 1.28-.48 1.77.01Z"
]);
const $77e1bce0ac0f7fe7$export$7c4f9b2e13b339fa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle12Filled', "12", [
    "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm7.35-.9a.5.5 0 1 0-.7-.7L5.5 6.54 4.35 5.4a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l2.5-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$9ab2ebacb21926b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle12Regular', "12", [
    "M8.35 5.1a.5.5 0 1 0-.7-.7L5.5 6.54 4.35 5.4a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l2.5-2.5ZM6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
]);
const $77e1bce0ac0f7fe7$export$f56a2825a10f121d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle16Color', "16", `<path d="M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z" fill="url(#ic_fluent_checkmark_circle_16_color__a)"/><path d="M10.12 6.16 7.25 9.04l-1.4-1.4a.5.5 0 1 0-.7.71L6.9 10.1c.2.2.5.2.7 0l3.23-3.23a.5.5 0 0 0-.71-.7Z" fill="url(#ic_fluent_checkmark_circle_16_color__b)"/><defs><linearGradient id="ic_fluent_checkmark_circle_16_color__a" x1="2.43" y1="4.25" x2="10.71" y2="12.85" gradientUnits="userSpaceOnUse"><stop stop-color="#52D17C"/><stop offset="1" stop-color="#22918B"/></linearGradient><linearGradient id="ic_fluent_checkmark_circle_16_color__b" x1="6.12" y1="6.45" x2="7.08" y2="11.21" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#E3FFD9"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$2ba3a0b4e685c4b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle16Filled', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm9.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L6.9 10.1c.2.2.5.2.7 0l3.25-3.25Z"
]);
const $77e1bce0ac0f7fe7$export$2bd6ba17bb026eaf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle16Regular', "16", [
    "M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm2.85 5.85a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L6.9 10.1c.2.2.5.2.7 0l3.25-3.25Z"
]);
const $77e1bce0ac0f7fe7$export$bbd915ec87019f0f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle20Color', "20", `<path d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" fill="url(#ic_fluent_checkmark_circle_20_color__a)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.35 7.65c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 11.29l3.65-3.64c.2-.2.5-.2.7 0Z" fill="url(#ic_fluent_checkmark_circle_20_color__b)"/><defs><linearGradient id="ic_fluent_checkmark_circle_20_color__a" x1="2.57" y1="5" x2="13.61" y2="16.47" gradientUnits="userSpaceOnUse"><stop stop-color="#52D17C"/><stop offset="1" stop-color="#22918B"/></linearGradient><linearGradient id="ic_fluent_checkmark_circle_20_color__b" x1="7.81" y1="8.01" x2="8.95" y2="13.63" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#E3FFD9"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$2e08cd71852e8bd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63Z"
]);
const $77e1bce0ac0f7fe7$export$e0a0bd9924d25c26 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle20Regular', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm3.36 4.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$64b1a9de151a5fc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle24Color', "24", `<path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z" fill="url(#ic_fluent_checkmark_circle_24_color__a)"/><path d="m15.22 8.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06Z" fill="url(#ic_fluent_checkmark_circle_24_color__b)"/><defs><linearGradient id="ic_fluent_checkmark_circle_24_color__a" x1="2.71" y1="5.75" x2="16.52" y2="20.09" gradientUnits="userSpaceOnUse"><stop stop-color="#52D17C"/><stop offset="1" stop-color="#22918B"/></linearGradient><linearGradient id="ic_fluent_checkmark_circle_24_color__b" x1="9.19" y1="9.41" x2="10.68" y2="16.71" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#E3FFD9"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$17cd49aa44fc764c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$efb54d2bdf5b8f19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm-1.25 9.94 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07 1.97 1.97 4.47-4.47-4.47 4.47Z"
]);
const $77e1bce0ac0f7fe7$export$67ba6fc685411cb5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Color', "32", `<path d="M30 16a14 14 0 1 1-28 0 14 14 0 0 1 28 0Z" fill="url(#ic_fluent_checkmark_circle_32_color__a)"/><path d="M22.7 12.7a1 1 0 0 0-1.4-1.4l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l7.5-7.5Z" fill="url(#ic_fluent_checkmark_circle_32_color__b)"/><defs><linearGradient id="ic_fluent_checkmark_circle_32_color__a" x1="3" y1="7.25" x2="22.32" y2="27.33" gradientUnits="userSpaceOnUse"><stop stop-color="#52D17C"/><stop offset="1" stop-color="#22918B"/></linearGradient><linearGradient id="ic_fluent_checkmark_circle_32_color__b" x1="12.03" y1="11.97" x2="14.16" y2="22.66" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#E3FFD9"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$2b2bab55016df3b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0Zm20.7-3.3a1 1 0 0 0-1.4-1.4l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l7.5-7.5Z"
]);
const $77e1bce0ac0f7fe7$export$a860305cb5a0b68 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Light', "32", [
    "M3 16a13 13 0 1 1 26 0 13 13 0 0 1-26 0ZM16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28Zm6.85 10.35a.5.5 0 0 0-.7-.7l-7.65 7.64-3.65-3.64a.5.5 0 0 0-.7.7l4 4c.2.2.5.2.7 0l8-8Z"
]);
const $77e1bce0ac0f7fe7$export$4be6bee60ab25878 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle32Regular', "32", [
    "M22.7 12.7a1 1 0 0 0-1.4-1.4l-6.8 6.79-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l7.5-7.5ZM16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28ZM4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0Z"
]);
const $77e1bce0ac0f7fe7$export$73912fa45a949164 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle48Color', "48", `<path d="M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Z" fill="url(#ic_fluent_checkmark_circle_48_color__a)"/><path d="M32.63 17.62c.5.48.5 1.28 0 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61 10.12-10.11a1.25 1.25 0 0 1 1.76 0Z" fill="url(#ic_fluent_checkmark_circle_48_color__b)"/><defs><linearGradient id="ic_fluent_checkmark_circle_48_color__a" x1="5.43" y1="11.5" x2="33.03" y2="40.18" gradientUnits="userSpaceOnUse"><stop stop-color="#52D17C"/><stop offset="1" stop-color="#22918B"/></linearGradient><linearGradient id="ic_fluent_checkmark_circle_48_color__b" x1="18.38" y1="18.63" x2="21.59" y2="33.74" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset="1" stop-color="#E3FFD9"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$847c1f2c967bd529 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Zm8.63 13.62a1.25 1.25 0 0 0-1.66-.1l-.1.1-10.12 10.11-3.62-3.61a1.25 1.25 0 0 0-1.85 1.66l.09.1 4.5 4.5c.45.46 1.17.49 1.66.1l.1-.1 11-11c.5-.48.5-1.28 0-1.76Z"
]);
const $77e1bce0ac0f7fe7$export$dead63c6d32d0315 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircle48Regular', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Zm0 2.5a17.5 17.5 0 1 0 0 35 17.5 17.5 0 0 0 0-35Zm8.63 11.12c.5.48.5 1.28 0 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61 10.12-10.11a1.25 1.25 0 0 1 1.76 0Z"
]);
const $77e1bce0ac0f7fe7$export$fb53b96eccab63bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint16Filled', "16", [
    "M8.74 13.45c.38-.05.76.13.9.48.18.42-.05.9-.5.98a7.04 7.04 0 0 1-2.28 0c-.45-.08-.68-.56-.5-.98a.84.84 0 0 1 .9-.48 5.56 5.56 0 0 0 1.48 0Zm-6.1-2.42c.35-.14.75 0 .98.3.3.4.66.75 1.05 1.05.3.23.44.63.3.98-.18.42-.68.6-1.04.33-.63-.44-1.18-1-1.62-1.61-.27-.37-.09-.87.33-1.05Zm9.74.3c.23-.3.63-.44.98-.3.42.18.6.68.33 1.05-.45.62-1 1.17-1.62 1.61-.36.27-.86.09-1.04-.33a.84.84 0 0 1 .3-.98c.4-.3.75-.66 1.05-1.05ZM9.97 5.97a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.97 8.53a.75.75 0 0 1 1-1.11l.06.05 1.22 1.22 2.72-2.72Zm-8.88.89c.08-.45.56-.68.97-.5.36.14.54.52.49.9a5.55 5.55 0 0 0 0 1.48.84.84 0 0 1-.48.9c-.42.18-.9-.05-.98-.5a7.05 7.05 0 0 1 0-2.28Zm12.85-.5c.41-.18.9.05.97.5a7.05 7.05 0 0 1 0 2.29c-.08.44-.56.67-.98.5a.84.84 0 0 1-.48-.9 5.55 5.55 0 0 0 0-1.5.84.84 0 0 1 .49-.9ZM3.93 2.3c.36-.27.86-.09 1.04.33.14.35 0 .75-.3.98-.4.3-.75.66-1.05 1.05a.84.84 0 0 1-.98.3c-.42-.17-.6-.68-.33-1.04.44-.63 1-1.17 1.62-1.62Zm7.1.33c.18-.42.68-.6 1.04-.33.63.44 1.18 1 1.62 1.62.27.36.09.87-.33 1.04a.84.84 0 0 1-.98-.3c-.3-.4-.66-.75-1.05-1.05a.84.84 0 0 1-.3-.98ZM8 1c.39 0 .77.03 1.14.1.45.07.68.55.5.97a.84.84 0 0 1-.9.48 5.55 5.55 0 0 0-1.48 0 .84.84 0 0 1-.9-.48c-.18-.42.05-.9.5-.98C7.23 1.03 7.6 1 8 1Z"
]);
const $77e1bce0ac0f7fe7$export$56c8b8a0478583c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint16Regular', "16", [
    "M6.84 13.89a6.03 6.03 0 0 0 2.3 0c.26-.05.52.08.61.31.12.28-.03.6-.33.66a7.04 7.04 0 0 1-2.85 0 .47.47 0 0 1-.33-.66c.1-.24.36-.36.6-.31Zm6.14-2.54c.14-.2.4-.3.64-.2.28.1.4.44.23.7a7.04 7.04 0 0 1-2.01 2 .48.48 0 0 1-.7-.22c-.1-.24 0-.5.2-.65.65-.43 1.2-.99 1.64-1.63Zm-10.6-.2c.23-.1.5-.01.64.2.43.64.99 1.2 1.63 1.63.2.14.3.4.2.64a.48.48 0 0 1-.7.23 7.04 7.04 0 0 1-2-2.01.48.48 0 0 1 .23-.7Zm7.77-5a.5.5 0 1 1 .7.7L7.6 10.1a.5.5 0 0 1-.7 0L5.15 8.35a.5.5 0 0 1 .63-.77l.07.07 1.4 1.4 2.9-2.9Zm4.05.1c.28-.12.6.03.65.32a7.03 7.03 0 0 1 0 2.86.48.48 0 0 1-.65.33.54.54 0 0 1-.31-.6 6.03 6.03 0 0 0 0-2.31.54.54 0 0 1 .3-.6Zm-13.06.33c.07-.3.38-.45.66-.33.23.1.36.35.31.6a6.03 6.03 0 0 0 0 2.3c.05.25-.07.5-.3.6a.47.47 0 0 1-.66-.33 7.03 7.03 0 0 1 0-2.84Zm3.02-4.43a.48.48 0 0 1 .7.23c.1.23 0 .5-.21.64-.64.44-1.2 1-1.63 1.63a.54.54 0 0 1-.65.21.47.47 0 0 1-.23-.7 7.04 7.04 0 0 1 2.02-2.01Zm6.98.22c.11-.27.45-.4.7-.23.8.53 1.49 1.22 2.01 2.02.17.25.05.58-.23.7-.23.1-.5 0-.64-.21a6.03 6.03 0 0 0-1.63-1.63.54.54 0 0 1-.21-.65ZM8 1c.49 0 .96.05 1.42.14.3.07.45.38.33.66a.54.54 0 0 1-.6.31 6.03 6.03 0 0 0-2.3 0 .54.54 0 0 1-.6-.3.48.48 0 0 1 .32-.66C7.03 1.05 7.51 1 8 1Z"
]);
const $77e1bce0ac0f7fe7$export$85762b1966445e35 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint20Filled', "20", [
    "M11.06 16.41a.75.75 0 0 1 .24 1.48c-.85.14-1.76.14-2.6 0a.75.75 0 0 1 .24-1.48c.69.12 1.43.12 2.12 0Zm-7.4-2.8a.75.75 0 0 1 1.05.18c.42.57.93 1.08 1.5 1.5a.75.75 0 1 1-.87 1.21 8.04 8.04 0 0 1-1.84-1.84.75.75 0 0 1 .17-1.05Zm11.62.18a.75.75 0 1 1 1.22.87 8.04 8.04 0 0 1-1.84 1.84.75.75 0 0 1-.88-1.22 6.55 6.55 0 0 0 1.5-1.5Zm-2.81-6.32a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1-1.11l.06.05L9 10.94l3.47-3.47ZM2.1 8.7a.75.75 0 0 1 1.48.24 6.68 6.68 0 0 0 0 2.12.75.75 0 1 1-1.48.24 8.19 8.19 0 0 1 0-2.6Zm14.93-.62c.41-.07.8.2.86.62a8.2 8.2 0 0 1 0 2.6.75.75 0 0 1-1.48-.24c.11-.69.11-1.43 0-2.12-.06-.4.21-.8.62-.86ZM5.33 3.5a.75.75 0 0 1 .88 1.21c-.57.42-1.08.93-1.5 1.5a.75.75 0 1 1-1.21-.87A8.04 8.04 0 0 1 5.34 3.5Zm8.28.17a.75.75 0 0 1 1.05-.17c.7.5 1.33 1.13 1.84 1.84a.75.75 0 0 1-1.22.87 6.55 6.55 0 0 0-1.5-1.5.75.75 0 0 1-.17-1.04ZM8.7 2.1a8.19 8.19 0 0 1 2.6 0 .75.75 0 0 1-.24 1.48 6.68 6.68 0 0 0-2.12 0A.75.75 0 1 1 8.7 2.1Z"
]);
const $77e1bce0ac0f7fe7$export$78a8ef3973757031 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint20Regular', "20", [
    "M11.37 16.87a.5.5 0 0 1 .2.98 8.2 8.2 0 0 1-3.13 0 .5.5 0 1 1 .2-.98 7.2 7.2 0 0 0 2.73 0Zm-7.88-3.12a.5.5 0 0 1 .69.14 7.04 7.04 0 0 0 1.93 1.93.5.5 0 0 1-.55.83 8.04 8.04 0 0 1-2.21-2.2.5.5 0 0 1 .14-.7Zm12.33.14a.5.5 0 0 1 .83.55 8.04 8.04 0 0 1-2.2 2.21.5.5 0 0 1-.56-.83 7.04 7.04 0 0 0 1.93-1.93Zm-3.17-6.24a.5.5 0 1 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .63-.77l.07.07L9 11.29l3.65-3.64Zm-9.9.4a.5.5 0 0 1 .39.58 7.2 7.2 0 0 0 0 2.74.5.5 0 0 1-.99.19 8.2 8.2 0 0 1 0-3.12.5.5 0 0 1 .6-.4Zm14.51 0a.5.5 0 0 1 .59.39 8.2 8.2 0 0 1 0 3.12.5.5 0 0 1-.98-.2 7.2 7.2 0 0 0 0-2.73.5.5 0 0 1 .4-.58Zm-11.7-4.7a.5.5 0 0 1 .55.83A7.04 7.04 0 0 0 4.18 6.1a.5.5 0 0 1-.83-.56 8.04 8.04 0 0 1 2.2-2.2Zm8.2.13a.5.5 0 0 1 .69-.13 8.04 8.04 0 0 1 2.2 2.2.5.5 0 0 1-.83.56 7.04 7.04 0 0 0-1.93-1.93.5.5 0 0 1-.14-.7ZM8.43 2.15a8.2 8.2 0 0 1 3.12 0 .5.5 0 0 1-.2.98 7.2 7.2 0 0 0-2.72 0 .5.5 0 0 1-.2-.98Z"
]);
const $77e1bce0ac0f7fe7$export$5a1c644876c67163 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint24Filled', "24", [
    "M13.24 19.9c.5-.07 1.02.17 1.21.64.23.56-.07 1.2-.66 1.3a10.07 10.07 0 0 1-3.59 0c-.59-.1-.89-.74-.66-1.3.2-.47.71-.71 1.22-.64a8.06 8.06 0 0 0 2.48 0Zm-9.02-3.6c.47-.2 1 0 1.3.41.5.67 1.1 1.27 1.77 1.76.4.3.6.84.4 1.3-.23.56-.89.8-1.38.46-1-.69-1.85-1.55-2.54-2.54-.34-.5-.1-1.16.45-1.39Zm14.24.4c.3-.4.84-.6 1.31-.4.56.23.8.9.45 1.39-.68.99-1.54 1.85-2.53 2.53-.5.35-1.16.1-1.39-.45-.2-.47 0-1 .4-1.3a8.05 8.05 0 0 0 1.76-1.76Zm-3.42-7.9a1 1 0 1 1 1.42 1.4l-5 5a1 1 0 0 1-1.42 0l-2.5-2.5-.07-.07a1 1 0 0 1 1.41-1.4l.08.06 1.79 1.8 4.3-4.3ZM2.16 10.2c.1-.59.74-.89 1.3-.66.47.2.71.71.63 1.22a8.06 8.06 0 0 0 0 2.48c.08.5-.17 1.02-.64 1.22-.55.22-1.19-.08-1.3-.67a10.06 10.06 0 0 1 0-3.59Zm18.38-.66c.55-.23 1.19.07 1.3.66a10.07 10.07 0 0 1 0 3.6c-.11.58-.75.88-1.3.65-.47-.2-.72-.7-.64-1.21a8.06 8.06 0 0 0 0-2.48c-.08-.5.17-1.02.64-1.22ZM16.3 4.22c.23-.55.9-.79 1.38-.45 1 .7 1.86 1.55 2.54 2.54.34.5.1 1.16-.45 1.39-.47.19-1 0-1.3-.41a8.05 8.05 0 0 0-1.76-1.76c-.41-.3-.6-.83-.4-1.3Zm-9.99-.45c.5-.34 1.15-.1 1.38.45.2.47 0 1.01-.4 1.31A8.05 8.05 0 0 0 5.53 7.3c-.3.41-.84.6-1.3.4-.56-.23-.8-.89-.46-1.38.69-.99 1.55-1.85 2.54-2.54ZM12 2c.61 0 1.21.06 1.8.16.58.1.88.74.65 1.3-.2.47-.7.71-1.21.64a8.06 8.06 0 0 0-2.48 0c-.5.07-1.02-.17-1.22-.64-.23-.56.07-1.2.66-1.3.58-.1 1.18-.16 1.8-.16Z"
]);
const $77e1bce0ac0f7fe7$export$1c2b999ae1ed0fa5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint24Regular', "24", [
    "M13.65 20.34a.8.8 0 0 1 .91.46.71.71 0 0 1-.49.99 10.05 10.05 0 0 1-4.15 0 .71.71 0 0 1-.49-.99.8.8 0 0 1 .91-.46 8.55 8.55 0 0 0 3.31 0Zm5.42-3.61a.8.8 0 0 1 .97-.32c.41.17.59.67.34 1.04a10.06 10.06 0 0 1-2.93 2.93.71.71 0 0 1-1.04-.34.8.8 0 0 1 .32-.97 8.55 8.55 0 0 0 2.34-2.34Zm-15.1-.32a.8.8 0 0 1 .96.31 8.55 8.55 0 0 0 2.34 2.34.8.8 0 0 1 .32.98.71.71 0 0 1-1.04.34 10.05 10.05 0 0 1-2.94-2.93.71.71 0 0 1 .35-1.04Zm11.25-7.44a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2.5-2.5-.05-.06a.75.75 0 0 1 1.05-1.05l.06.05 1.97 1.97 4.47-4.47Zm5.58.46c.42-.17.9.06.98.5a10.04 10.04 0 0 1 0 4.14.71.71 0 0 1-.98.5.8.8 0 0 1-.46-.92 8.54 8.54 0 0 0 0-3.3.8.8 0 0 1 .46-.92Zm-18.58.5c.09-.44.56-.67.98-.5a.8.8 0 0 1 .46.92 8.54 8.54 0 0 0 0 3.3.8.8 0 0 1-.46.91.71.71 0 0 1-.99-.49 10.04 10.04 0 0 1 0-4.15Zm4.33-6.31a.71.71 0 0 1 1.04.34.8.8 0 0 1-.32.97 8.55 8.55 0 0 0-2.34 2.34.8.8 0 0 1-.97.32.71.71 0 0 1-.34-1.04 10.05 10.05 0 0 1 2.93-2.93Zm9.86.34a.71.71 0 0 1 1.04-.35c1.17.77 2.17 1.77 2.93 2.94.25.37.07.86-.34 1.04a.8.8 0 0 1-.98-.32 8.55 8.55 0 0 0-2.33-2.34.8.8 0 0 1-.32-.97ZM12 2c.71 0 1.4.07 2.07.21.44.1.66.57.5.99a.8.8 0 0 1-.92.46 8.54 8.54 0 0 0-3.3 0 .8.8 0 0 1-.92-.46.71.71 0 0 1 .5-.98C10.58 2.07 11.28 2 12 2Z"
]);
const $77e1bce0ac0f7fe7$export$5e2d3b8d5c374f4f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint28Filled', "28", [
    "M15.77 23.84c.5-.09 1.02.16 1.21.63.23.55-.07 1.19-.66 1.3a12.06 12.06 0 0 1-4.64 0c-.6-.1-.9-.74-.66-1.3.2-.47.7-.72 1.2-.63a10.07 10.07 0 0 0 3.55 0ZM4.48 19.3c.47-.2 1.01 0 1.3.42.68.97 1.54 1.83 2.51 2.5.42.3.61.84.42 1.3-.23.56-.9.8-1.4.46-1.3-.87-2.41-1.99-3.28-3.29-.34-.5-.1-1.16.45-1.39Zm17.73.41c.3-.42.83-.6 1.3-.41.56.23.8.89.46 1.39a12.07 12.07 0 0 1-3.29 3.29c-.5.33-1.16.1-1.39-.46-.2-.47 0-1 .41-1.3.98-.68 1.83-1.53 2.51-2.5Zm-3.92-9.65a1 1 0 0 1 1.41 1.41l-6.5 6.5a1 1 0 0 1-1.4 0l-3.5-3.5a1 1 0 0 1 1.4-1.42l2.8 2.8 5.79-5.8ZM2.22 11.67c.12-.59.75-.89 1.3-.66.48.2.72.71.63 1.21a10.06 10.06 0 0 0 0 3.55c.1.5-.15 1.02-.62 1.21-.56.23-1.2-.07-1.3-.66a12.06 12.06 0 0 1 0-4.65Zm22.25-.65c.55-.23 1.19.07 1.3.66a12.06 12.06 0 0 1 0 4.64c-.11.59-.75.89-1.3.66-.47-.2-.72-.7-.63-1.21a10.06 10.06 0 0 0 0-3.54c-.1-.5.16-1.02.63-1.21Zm-5.18-6.53c.23-.55.9-.79 1.4-.45 1.29.87 2.4 1.98 3.27 3.28.34.5.1 1.16-.45 1.39-.47.2-1 0-1.3-.42a10.06 10.06 0 0 0-2.5-2.5c-.42-.3-.61-.83-.42-1.3ZM7.32 4.03c.5-.33 1.16-.1 1.39.46.19.47 0 1-.42 1.3-.97.67-1.83 1.52-2.5 2.5-.3.42-.83.6-1.3.41-.56-.23-.8-.89-.46-1.39.87-1.3 1.99-2.4 3.29-3.28ZM14 2c.8 0 1.57.08 2.33.23.58.11.88.75.66 1.3-.2.47-.71.72-1.21.63a10.07 10.07 0 0 0-3.56 0c-.5.09-1.01-.16-1.2-.63-.23-.56.07-1.19.65-1.3C12.43 2.07 13.2 2 14 2Z"
]);
const $77e1bce0ac0f7fe7$export$33c9ca8384c840ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint28Regular', "28", [
    "M16.18 24.27a.8.8 0 0 1 .91.46.72.72 0 0 1-.49.99 12.04 12.04 0 0 1-5.2 0 .72.72 0 0 1-.49-.99.8.8 0 0 1 .9-.46 10.55 10.55 0 0 0 4.37 0ZM4.22 19.4a.8.8 0 0 1 .97.32C6 20.95 7.05 22 8.3 22.8c.31.2.46.61.31.97a.72.72 0 0 1-1.04.34 12.06 12.06 0 0 1-3.68-3.68.72.72 0 0 1 .34-1.04Zm18.59.32a.8.8 0 0 1 .97-.32c.41.17.59.67.34 1.04a12.07 12.07 0 0 1-3.67 3.68.72.72 0 0 1-1.05-.35.8.8 0 0 1 .32-.96c1.23-.8 2.29-1.86 3.09-3.1Zm-4.34-9.5a.75.75 0 0 1 1.06 1.07l-6.5 6.49c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 0 1 1.06-1.06l2.97 2.97 5.97-5.97ZM2.28 11.4c.1-.44.57-.67.99-.5a.8.8 0 0 1 .46.91 10.54 10.54 0 0 0 0 4.37.8.8 0 0 1-.46.91.72.72 0 0 1-.99-.5 12.04 12.04 0 0 1 0-5.2Zm22.45-.5c.42-.17.89.06.99.5a12.04 12.04 0 0 1 0 5.2.72.72 0 0 1-.99.49.8.8 0 0 1-.46-.9 10.54 10.54 0 0 0 0-4.38.8.8 0 0 1 .46-.9ZM19.4 4.24a.72.72 0 0 1 1.05-.35c1.47.94 2.73 2.2 3.67 3.67.24.38.07.87-.35 1.05a.8.8 0 0 1-.96-.32 10.55 10.55 0 0 0-3.09-3.09.8.8 0 0 1-.32-.96ZM7.55 3.88a.72.72 0 0 1 1.05.35.8.8 0 0 1-.32.96C7.05 6 6 7.05 5.2 8.28a.8.8 0 0 1-.96.32.72.72 0 0 1-.35-1.05c.94-1.48 2.2-2.73 3.67-3.67ZM14 2c.9 0 1.77.1 2.6.28.44.1.67.57.5.99a.8.8 0 0 1-.91.46 10.54 10.54 0 0 0-4.38 0 .8.8 0 0 1-.9-.46.72.72 0 0 1 .49-.99C12.24 2.1 13.1 2 14 2Z"
]);
const $77e1bce0ac0f7fe7$export$78c45e4c6a9f4338 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint32Filled', "32", [
    "M17.9 27.34c.62-.1 1.26.2 1.5.8.3.69-.09 1.49-.83 1.62a14.08 14.08 0 0 1-5.13 0c-.74-.13-1.12-.93-.83-1.62.24-.59.88-.9 1.5-.8a11.58 11.58 0 0 0 3.79 0ZM5.02 22.18c.58-.24 1.25-.01 1.62.5a11.57 11.57 0 0 0 2.69 2.69c.51.37.75 1.03.5 1.62-.29.7-1.12 1-1.74.57a14.08 14.08 0 0 1-3.64-3.64c-.42-.62-.13-1.45.57-1.74Zm20.34.5a1.37 1.37 0 0 1 1.63-.5c.7.28.99 1.11.56 1.73a14.08 14.08 0 0 1-3.63 3.64c-.62.43-1.46.13-1.74-.57-.25-.58-.01-1.25.5-1.62a11.57 11.57 0 0 0 2.68-2.68Zm-4.24-11.56a1.25 1.25 0 0 1 1.76 1.76l-7.5 7.5c-.48.5-1.28.5-1.76 0l-4-4a1.25 1.25 0 1 1 1.76-1.76l3.12 3.11 6.62-6.61Zm-18.88 2.3c.13-.73.93-1.11 1.63-.82.58.24.89.88.79 1.5a11.58 11.58 0 0 0 0 3.8c.1.63-.2 1.27-.8 1.5-.69.3-1.48-.08-1.62-.82a14.08 14.08 0 0 1 0-5.15Zm25.9-.82c.7-.28 1.49.1 1.63.83a14.08 14.08 0 0 1 0 5.14c-.14.74-.94 1.12-1.64.83-.58-.24-.89-.88-.79-1.5a11.58 11.58 0 0 0 0-3.79c-.1-.63.21-1.26.8-1.5Zm-5.96-7.58c.29-.7 1.12-1 1.74-.56 1.42.97 2.66 2.2 3.63 3.63.43.62.13 1.45-.56 1.74-.59.24-1.26.01-1.63-.5a11.57 11.57 0 0 0-2.67-2.69 1.37 1.37 0 0 1-.5-1.62Zm-14.1-.57c.63-.43 1.46-.13 1.75.56.24.59 0 1.26-.51 1.63a11.57 11.57 0 0 0-2.68 2.68c-.37.52-1.04.75-1.63.5-.7-.28-.99-1.11-.56-1.73a14.08 14.08 0 0 1 3.64-3.64ZM16 2c.88 0 1.74.08 2.58.24.74.14 1.12.93.83 1.63-.24.58-.88.9-1.5.79a11.58 11.58 0 0 0-3.8 0c-.63.1-1.27-.21-1.51-.8-.29-.7.1-1.49.83-1.62.83-.16 1.7-.24 2.57-.24Z"
]);
const $77e1bce0ac0f7fe7$export$46d694f6c699c36a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint32Regular', "32", [
    "M18.3 27.78c.5-.1 1.02.15 1.21.62a.95.95 0 0 1-.66 1.31 14.07 14.07 0 0 1-5.7 0 .95.95 0 0 1-.66-1.31c.2-.47.71-.72 1.21-.62a12.06 12.06 0 0 0 4.6 0Zm7.66-5.08c.29-.42.82-.6 1.3-.41.55.23.78.89.45 1.39a14.08 14.08 0 0 1-4.03 4.03.95.95 0 0 1-1.4-.46c-.2-.47 0-1 .42-1.29 1.28-.87 2.4-1.97 3.26-3.26Zm-21.2-.41c.47-.2 1-.01 1.29.41.86 1.29 1.97 2.4 3.26 3.26.42.28.6.82.41 1.29a.95.95 0 0 1-1.4.46 14.08 14.08 0 0 1-4.02-4.03.95.95 0 0 1 .46-1.4Zm16.53-11a1 1 0 1 1 1.42 1.42l-7.5 7.5a1 1 0 0 1-1.42 0l-4-4a1 1 0 1 1 1.42-1.42l3.29 3.3 6.8-6.8Zm-19 1.86a.95.95 0 0 1 1.31-.66c.47.2.72.7.62 1.2a12.06 12.06 0 0 0 0 4.62c.1.5-.14 1.01-.61 1.2a.95.95 0 0 1-1.32-.65 14.06 14.06 0 0 1 0-5.7Zm26.11-.66a.95.95 0 0 1 1.31.66 14.06 14.06 0 0 1 0 5.7.95.95 0 0 1-1.3.66c-.48-.19-.73-.7-.63-1.2a12.06 12.06 0 0 0 0-4.61c-.1-.5.15-1.01.62-1.2ZM8.32 4.3a.95.95 0 0 1 1.4.46c.2.47 0 1.01-.42 1.3-1.28.86-2.39 1.97-3.26 3.25-.28.43-.82.61-1.29.42a.95.95 0 0 1-.46-1.4A14.08 14.08 0 0 1 8.32 4.3Zm13.97.46a.95.95 0 0 1 1.4-.46 14.08 14.08 0 0 1 4.02 4.04c.33.5.1 1.16-.46 1.39-.46.2-1 0-1.29-.42a12.07 12.07 0 0 0-3.26-3.26 1.07 1.07 0 0 1-.41-1.29ZM16 2c.98 0 1.94.1 2.86.3.59.11.89.75.66 1.3-.2.47-.7.72-1.2.62a12.06 12.06 0 0 0-4.63 0c-.5.1-1-.15-1.2-.62a.95.95 0 0 1 .66-1.3c.92-.2 1.88-.3 2.85-.3Z"
]);
const $77e1bce0ac0f7fe7$export$da92883582a96ff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint48Filled', "48", [
    "M18.62 41.56a1.62 1.62 0 0 1 1.84-.93 17.07 17.07 0 0 0 7.07 0c.76-.16 1.55.21 1.85.93.34.82-.1 1.76-.97 1.95a20.07 20.07 0 0 1-8.83 0 1.42 1.42 0 0 1-.96-1.95Zm19.64-8.3a1.62 1.62 0 0 1 1.95-.65c.82.34 1.18 1.31.7 2.06a20.1 20.1 0 0 1-6.24 6.25c-.75.47-1.72.12-2.06-.7-.3-.72 0-1.54.65-1.96 2-1.3 3.7-3 5-5Zm-30.48-.65c.72-.3 1.54 0 1.96.65 1.3 2 3 3.7 5 5 .65.42.94 1.24.65 1.95a1.42 1.42 0 0 1-2.07.7 20.1 20.1 0 0 1-6.24-6.24 1.42 1.42 0 0 1 .7-2.06Zm22.9-15.17a1.5 1.5 0 1 1 2.13 2.12l-11 11a1.5 1.5 0 0 1-2.12 0l-4.5-4.5a1.5 1.5 0 1 1 2.12-2.12l3.44 3.44 9.94-9.94Zm10.88 1.18c.82-.34 1.76.1 1.95.96a20.06 20.06 0 0 1 0 8.84c-.2.86-1.13 1.3-1.95.96a1.62 1.62 0 0 1-.93-1.84 17.07 17.07 0 0 0 0-7.08c-.16-.75.21-1.54.93-1.84Zm-37.07.96c.2-.86 1.13-1.3 1.95-.96.72.3 1.09 1.09.93 1.85a17.07 17.07 0 0 0 0 7.06c.16.76-.21 1.55-.93 1.85-.82.34-1.76-.1-1.95-.97a20.07 20.07 0 0 1 0-8.82Zm8.83-12.5a1.42 1.42 0 0 1 2.07.7c.3.72 0 1.54-.65 1.96-2 1.3-3.7 3-5 5-.42.65-1.24.95-1.95.65a1.42 1.42 0 0 1-.7-2.06 20.1 20.1 0 0 1 6.23-6.25Zm19.29.7a1.42 1.42 0 0 1 2.06-.7 20.1 20.1 0 0 1 6.25 6.25c.47.75.11 1.72-.7 2.06-.72.3-1.54 0-1.96-.65-1.3-2-3-3.7-5-5a1.62 1.62 0 0 1-.65-1.96ZM24 4c1.52 0 3 .17 4.41.49.87.2 1.3 1.13.96 1.95a1.62 1.62 0 0 1-1.84.93 17.07 17.07 0 0 0-7.07 0c-.76.16-1.54-.21-1.84-.93-.34-.82.1-1.76.96-1.95C21 4.17 22.48 4 24 4Z"
]);
const $77e1bce0ac0f7fe7$export$4ebfd8d0ce53db23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleHint48Regular', "48", [
    "M27.95 41.05c.63-.14 1.28.16 1.53.76a1.2 1.2 0 0 1-.8 1.64 20.06 20.06 0 0 1-9.37 0 1.2 1.2 0 0 1-.8-1.64c.25-.6.9-.9 1.54-.76a17.55 17.55 0 0 0 7.9 0ZM7.53 32.72c.6-.25 1.27 0 1.62.54a17.6 17.6 0 0 0 5.58 5.59c.55.34.8 1.03.55 1.62a1.2 1.2 0 0 1-1.72.6 20.1 20.1 0 0 1-6.63-6.63 1.2 1.2 0 0 1 .6-1.72Zm31.32.54c.34-.54 1.02-.8 1.62-.54.68.28.98 1.09.59 1.72a20.1 20.1 0 0 1-6.62 6.62 1.2 1.2 0 0 1-1.73-.59c-.24-.6 0-1.28.55-1.62a17.6 17.6 0 0 0 5.59-5.59Zm-7.98-15.64a1.25 1.25 0 0 1 1.76 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61 10.12-10.11Zm-26.32 1.7a1.2 1.2 0 0 1 1.63-.8c.6.24.9.9.76 1.53a17.55 17.55 0 0 0 0 7.9c.15.63-.16 1.29-.76 1.53a1.2 1.2 0 0 1-1.63-.8 20.05 20.05 0 0 1 0-9.37Zm37.26-.8a1.2 1.2 0 0 1 1.63.8 20.05 20.05 0 0 1 0 9.37 1.2 1.2 0 0 1-1.63.8c-.6-.25-.9-.91-.76-1.54a17.55 17.55 0 0 0 0-7.9c-.15-.63.16-1.29.76-1.53ZM13.56 6.94a1.2 1.2 0 0 1 1.72.59c.25.6 0 1.28-.55 1.62a17.59 17.59 0 0 0-5.58 5.59c-.34.54-1.03.79-1.62.54a1.2 1.2 0 0 1-.6-1.72 20.1 20.1 0 0 1 6.63-6.62Zm19.15.59a1.2 1.2 0 0 1 1.73-.6 20.1 20.1 0 0 1 6.62 6.63 1.2 1.2 0 0 1-.6 1.72c-.59.25-1.27 0-1.61-.54a17.6 17.6 0 0 0-5.59-5.59 1.33 1.33 0 0 1-.55-1.62ZM24 4c1.61 0 3.18.2 4.68.55.72.17 1.08.96.8 1.64-.25.6-.9.9-1.53.76a17.56 17.56 0 0 0-7.9 0 1.33 1.33 0 0 1-1.54-.76 1.2 1.2 0 0 1 .8-1.64C20.81 4.2 22.38 4 24 4Z"
]);
const $77e1bce0ac0f7fe7$export$9af961a05ecd76b7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle20Filled', "20", [
    "M10 2c.4 0 .79.03 1.17.08l-.22.07A1.43 1.43 0 0 0 10 3.5a1.42 1.42 0 0 0 .97 1.35l1.06.35c.15.05.3.13.47.29.11.1.2.24.3.47l.35 1.1c.1.24.25.47.52.68.14.1.3.17.45.21a1.3 1.3 0 0 0 .77 1.79l.77.25c.08.03.15.08.21.14.08.06.12.14.15.22l.26.8c.1.25.26.46.48.62a1.33 1.33 0 0 0 1 .2A8 8 0 1 1 10 2Zm3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63ZM17.5 12Zm-.02-6a.3.3 0 0 1 .29.2l.25.77a1.58 1.58 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2Zm-3-6a.42.42 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.43.43 0 0 1-.14-.2l-.35-1.06a2.22 2.22 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .4-.28Z"
]);
const $77e1bce0ac0f7fe7$export$902f05329bcfa3f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle20Regular', "20", [
    "M10 2c.4 0 .79.03 1.17.08l-.22.07a1.43 1.43 0 0 0-.86.85H10a7 7 0 1 0 6.77 8.78 1.32 1.32 0 0 0 .98.2A8 8 0 1 1 10 2Zm2.65 5.65a.5.5 0 0 1 .77.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65ZM17.5 12Zm-.02-6a.3.3 0 0 1 .29.2l.25.77a1.58 1.58 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2Zm-3-6a.42.42 0 0 1 .4.28l.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.64.2l-.02-.01a.43.43 0 0 1-.14-.2l-.35-1.06a2.22 2.22 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .4-.28Z"
]);
const $77e1bce0ac0f7fe7$export$c34bd028441cbad3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle24Filled', "24", [
    "M12 2a10 10 0 0 1 2.75.39 1.8 1.8 0 0 1-.36.17L13.05 3c-.63.22-1.05.8-1.05 1.47 0 .63.42 1.28 1 1.53l1.4.46c.52.17 1.01.57 1.19 1.09l.35 1.23a.75.75 0 0 0-.72.19l-4.47 4.47-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5c.1-.1.16-.22.2-.34a1.54 1.54 0 0 0 1.66.2c-.12.2-.18.43-.18.66 0 .54.36 1.05.87 1.23.38.12 1 .18 1.15.62.24.76.5 1.65 1.48 1.65.12 0 .24-.02.34-.04A10 10 0 1 1 12 2Zm9.48 6a.3.3 0 0 1 .29.2l.25.77a1.58 1.58 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2Zm-4-8a.55.55 0 0 1 .5.36l.45 1.38a2.84 2.84 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.55.55 0 0 1-.26.2l-1.38.44a2.84 2.84 0 0 0-1.8 1.8l-.45 1.38a.58.58 0 0 1-.2.26.55.55 0 0 1-.82-.26l-.45-1.38a2.84 2.84 0 0 0-1.8-1.8L13.36 5a.55.55 0 0 1-.26-.83c.06-.09.16-.16.26-.2l1.38-.44a2.84 2.84 0 0 0 1.76-1.77l.01-.03.45-1.38a.55.55 0 0 1 .51-.36Z"
]);
const $77e1bce0ac0f7fe7$export$56ed7dde2018bca3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSparkle24Regular', "24", [
    "M12 2a10 10 0 0 1 2.75.39 1.8 1.8 0 0 1-.36.17L13.05 3c-.29.1-.53.28-.71.5H12a8.5 8.5 0 1 0 8.38 9.91c.22.37.54.64 1.08.64.12 0 .24-.02.34-.04A10 10 0 1 1 12 2Zm3.22 6.97a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07 1.97 1.97 4.47-4.47ZM21.48 8a.3.3 0 0 1 .29.2l.25.77a1.58 1.58 0 0 0 1 1l.76.24h.02a.3.3 0 0 1 .14.47.3.3 0 0 1-.14.1l-.77.26a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.57 1.57 0 0 0-1-1l-.77-.25a.3.3 0 0 1-.14-.46.3.3 0 0 1 .14-.1l.77-.26a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .28-.2Zm-4-8a.55.55 0 0 1 .5.36l.45 1.38a2.84 2.84 0 0 0 1.8 1.8l1.38.44.03.01a.55.55 0 0 1 .26.83.55.55 0 0 1-.26.2l-1.38.44a2.84 2.84 0 0 0-1.8 1.8l-.45 1.38a.58.58 0 0 1-.2.26.55.55 0 0 1-.82-.26l-.45-1.38a2.84 2.84 0 0 0-1.8-1.8L13.36 5a.55.55 0 0 1-.26-.83c.06-.09.16-.16.26-.2l1.38-.44a2.84 2.84 0 0 0 1.76-1.77l.01-.03.45-1.38a.55.55 0 0 1 .51-.36Z"
]);
const $77e1bce0ac0f7fe7$export$209f6d48b1b545ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare16Filled', "16", [
    "M5.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.85-5.15-2 2a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 1.65-1.64a.5.5 0 1 1 .7.7ZM6 10.98v1.52A2.5 2.5 0 0 0 8.5 15h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 12.5 6h-1.52c-.03.34-.1.68-.19 1h1.71c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 7 12.5v-1.7c-.32.08-.66.15-1 .18Zm6.35-1.13a.5.5 0 0 0-.7-.7L10 10.79l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l2-2Z"
]);
const $77e1bce0ac0f7fe7$export$cbdaf28d44a06bbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare16Regular', "16", [
    "M9 5.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Zm1 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4 7v-1.52c.34-.03.68-.1 1-.19v1.71c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-1.7c.09-.32.15-.66.18-1h1.52A2.5 2.5 0 0 1 15 8.5v4a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 6 12.5Zm1.35-8.35c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0Zm5 5.7a.5.5 0 0 0-.7-.7L10 10.79l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l2-2Z"
]);
const $77e1bce0ac0f7fe7$export$989e3ee947a4a90e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare20Filled', "20", [
    "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12Zm2.85-7.15-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64a.5.5 0 1 1 .7.7ZM8 13.93V16a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3h-2.07c-.05.34-.12.68-.22 1H16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2.29c-.32.1-.66.17-1 .22Zm8.35-1.58a.5.5 0 0 0-.7-.7L13 14.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3Z"
]);
const $77e1bce0ac0f7fe7$export$e8dd1107d599267c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare20Regular', "20", [
    "M12 7A5 5 0 1 0 2 7a5 5 0 0 0 10 0Zm1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Zm-5 9v-2.07c.34-.05.68-.12 1-.22V16c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-2.29c.1-.32.17-.66.22-1H16a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3ZM9.85 5.15c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6.5 7.79l2.65-2.64c.2-.2.5-.2.7 0Zm3.5 10.2 3-3a.5.5 0 0 0-.7-.7L13 14.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$587b135e09dc0e31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare24Filled', "24", [
    "M8.5 16a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm3.78-9.22-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l1.47 1.47 3.47-3.47a.75.75 0 1 1 1.06 1.06Zm8 6.94c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 3.47-3.47c.3-.3.77-.3 1.06 0ZM9.75 20v-3.1c.52-.07 1.02-.19 1.5-.35V20c0 .97.78 1.75 1.75 1.75h7c.97 0 1.75-.78 1.75-1.75v-7c0-.97-.78-1.75-1.75-1.75h-3.45c.16-.48.28-.98.36-1.5H20c1.8 0 3.25 1.46 3.25 3.25v7c0 1.8-1.46 3.25-3.25 3.25h-7A3.25 3.25 0 0 1 9.75 20Z"
]);
const $77e1bce0ac0f7fe7$export$d4455856aed78793 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleSquare24Regular', "24", [
    "M14.5 8.5a6 6 0 1 0-12 0 6 6 0 0 0 12 0Zm1.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Zm4.28 6.28a.75.75 0 1 0-1.06-1.06l-3.47 3.47-1.47-1.47a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l4-4Zm-8-9.06c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 0 1 1.06-1.06l1.47 1.47 3.47-3.47c.3-.3.77-.3 1.06 0ZM9.75 20v-3.1c.52-.07 1.02-.19 1.5-.35V20c0 .97.78 1.75 1.75 1.75h7c.97 0 1.75-.78 1.75-1.75v-7c0-.97-.78-1.75-1.75-1.75h-3.45c.16-.48.28-.98.36-1.5H20c1.8 0 3.25 1.46 3.25 3.25v7c0 1.8-1.46 3.25-3.25 3.25h-7A3.25 3.25 0 0 1 9.75 20Z"
]);
const $77e1bce0ac0f7fe7$export$b4a699e8ab53a874 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning16Filled', "16", [
    "M0 7a7 7 0 1 1 13.88 1.29L13.3 7.1a2 2 0 0 0-3.58 0L6.3 13.96A7 7 0 0 1 0 7Zm9.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0l3.25-3.25Zm.75 1.7-3.5 7A1 1 0 0 0 8 16h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM12 9.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$11e47445c3eaec15 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning16Regular', "16", [
    "M1 7a6 6 0 0 1 12-.34c.1.13.2.28.3.45l.58 1.18a7 7 0 1 0-7.6 5.68l.5-.97A6 6 0 0 1 1 7Zm8.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0l3.25-3.25Zm.75 1.7-3.5 7A1 1 0 0 0 8 16h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM12 9.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$d0a4ff0be34beeb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning20Filled', "20", [
    "M10 2a8 8 0 0 1 7.74 10.01l-.45-.9a2 2 0 0 0-3.58 0L10.27 18H10a8 8 0 1 1 0-16Zm3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63Zm1.24 3.9a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 19 20h-7a1 1 0 0 1-.9-1.45l3.5-7ZM16 13.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0v-3Zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$e473b61af3cc9d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning20Regular', "20", [
    "M10 2a8 8 0 0 1 7.74 10.01l-.45-.9c-.09-.18-.2-.34-.32-.47a7 7 0 1 0-6.18 6.32L10.27 18H10a8 8 0 1 1 0-16Zm3.36 5.65c.17.17.2.44.06.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0Zm1.24 3.9a1 1 0 0 1 1.8 0l3.5 7A1 1 0 0 1 19 20h-7a1 1 0 0 1-.9-1.45l3.5-7ZM16 13.5a.5.5 0 1 0-1 0v3a.5.5 0 1 0 1 0v-3Zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$4ce58862deadad9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning24Filled', "24", [
    "M12 2a10 10 0 0 1 9.54 13l-.8-1.62a2.5 2.5 0 0 0-4.47 0l-4 8c-.1.2-.17.41-.21.62H12a10 10 0 0 1 0-20Zm3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06Zm1.94 4.86a1.5 1.5 0 0 1 2.69 0l4 8c.5 1-.23 2.17-1.35 2.17h-8a1.5 1.5 0 0 1-1.34-2.17l4-8ZM19 16.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$a906cfa961a69148 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkCircleWarning24Regular', "24", [
    "M12 2a10 10 0 0 1 9.54 13l-.8-1.62a2.58 2.58 0 0 0-.29-.45 8.5 8.5 0 1 0-7.72 7.54l-.46.91c-.1.2-.17.41-.21.62H12a10 10 0 0 1 0-20Zm-1.25 11.44 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07 1.97 1.97Zm6.41.39a1.5 1.5 0 0 1 2.69 0l4 8c.5 1-.23 2.17-1.35 2.17h-8a1.5 1.5 0 0 1-1.34-2.17l4-8ZM19 16.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Zm-.5 5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
]);
const $77e1bce0ac0f7fe7$export$3e9366a3d8611cf8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock16Filled', "16", [
    "M0 7a7 7 0 0 1 13.97-.61A3 3 0 0 0 9.5 9v.06A2 2 0 0 0 8 11v2.93A7 7 0 0 1 0 7Zm9.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0l3.25-3.25ZM10.5 9v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V9a2 2 0 1 0-4 0Zm1 1V9a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$cfbdee6253d6b671 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock16Regular', "16", [
    "M1 7a6 6 0 0 1 11.92-.97c.38.05.73.18 1.05.36A7 7 0 1 0 8 13.93v-1.01A6 6 0 0 1 1 7Zm8.85-1.15a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L5.9 9.1c.2.2.5.2.7 0l3.25-3.25ZM10.5 9v1H10a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5V9a2 2 0 1 0-4 0Zm1 1V9a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$70808698fe09d09b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock20Filled', "20", [
    "M10 2a8 8 0 0 1 8 8.33A3 3 0 0 0 12.5 12v.06A2 2 0 0 0 11 14v3.94A8 8 0 1 1 10 2Zm3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63ZM15.5 10a2 2 0 0 1 2 2v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5v-1c0-1.1.9-2 2-2Zm-.65 6.37a.75.75 0 1 0 1.3-.74.75.75 0 0 0-1.3.74ZM15.5 11a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1Z"
]);
const $77e1bce0ac0f7fe7$export$8aa052f6085bce80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock20Regular', "20", [
    "M10 2a8 8 0 0 1 8 8.33 3.02 3.02 0 0 0-1.03-.94A7 7 0 1 0 11 16.93v1A8 8 0 1 1 10 2Zm6.97 8.64A2 2 0 0 1 17.5 12v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5v-1a2 2 0 0 1 3.47-1.36ZM14.5 13h2v-1a1 1 0 1 0-2 0v1Zm.35 3.37a.75.75 0 1 0 1.3-.74.75.75 0 0 0-1.3.74Zm-1.5-8.72c.18.17.2.44.07.63l-.06.07-4 4a.5.5 0 0 1-.64.07l-.07-.06-2-2a.5.5 0 0 1 .63-.77l.07.06L9 11.3l3.65-3.65c.2-.2.51-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$b28c494f9a55e892 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock24Filled', "24", [
    "M12 2a10 10 0 0 1 9.92 11.26A3.5 3.5 0 0 0 15 14v.05a2.5 2.5 0 0 0-2 2.45v5c0 .15.01.3.04.45A10 10 0 1 1 12 2Zm3.22 6.97-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5a.75.75 0 1 0-1.06-1.06Zm3.28 2.53A2.5 2.5 0 0 1 21 14v1h.54c.81.02 1.46.69 1.46 1.5v5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h.5v-1a2.5 2.5 0 0 1 2.5-2.5Zm-.4 8.42a1 1 0 0 0 1.35-1.24 1 1 0 1 0-1.34 1.24ZM17.5 14v1h2v-1a1 1 0 1 0-2 0Z"
]);
const $77e1bce0ac0f7fe7$export$b11015c889692983 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkLock24Regular', "24", [
    "M12 2a10 10 0 0 1 9.92 11.26 3.5 3.5 0 0 0-1.47-2.17A8.5 8.5 0 1 0 13 20.44v1.06c0 .15.01.3.04.45A10 10 0 1 1 12 2Zm8.49 10.48A2.5 2.5 0 0 0 16 14v1h-.5c-.83 0-1.5.67-1.5 1.5v5l.03.3c.14.68.74 1.2 1.47 1.2h6c.83 0 1.5-.67 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5H21v-1c0-.57-.2-1.1-.51-1.52Zm-2.38 7.44a1 1 0 1 1 .78-1.84 1 1 0 0 1-.78 1.84ZM17.5 14a1 1 0 1 1 2 0v1h-2v-1Zm-6.75-.56 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5a.75.75 0 0 1 .98-1.13l.08.07 1.97 1.97Z"
]);
const $77e1bce0ac0f7fe7$export$b7ce22fb2aa9e84e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkNote20Filled', "20", [
    "M6.03 12.9 2.56 9a.75.75 0 1 0-1.12 1l4 4.5c.29.32.79.34 1.09.03l10.5-10.5a.75.75 0 0 0-1.06-1.06l-9.94 9.94ZM11 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4Zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1Zm-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1h-4Z"
]);
const $77e1bce0ac0f7fe7$export$6485224de4d6a6b8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkNote20Regular', "20", [
    "M1.67 9.13a.5.5 0 0 1 .7.04l3.65 4.1L16.15 3.15a.5.5 0 1 1 .7.7l-10.5 10.5a.5.5 0 0 1-.72-.02l-4-4.5a.5.5 0 0 1 .04-.7ZM11 13c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-4Zm6.5 3h-4a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1Zm-4-3a.5.5 0 1 0 0 1h4a.5.5 0 1 0 0-1h-4Z"
]);
const $77e1bce0ac0f7fe7$export$fd06d5c9f650d53a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare20Filled', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm7.35 5.35-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L9 11.29l3.65-3.64a.5.5 0 0 1 .7.7Z"
]);
const $77e1bce0ac0f7fe7$export$682e76233421f0f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare20Regular', "20", [
    "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm9.35 2.35a.5.5 0 0 0-.7-.7L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4Z"
]);
const $77e1bce0ac0f7fe7$export$16e22662a2685f82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare24Filled', "24", [
    "M6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25Zm10.03 6.78-5 5c-.3.3-.77.3-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 4.47-4.47a.75.75 0 1 1 1.06 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$b951b34e50107802 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkSquare24Regular', "24", [
    "M16.28 9.78a.75.75 0 0 0-1.06-1.06l-4.47 4.47-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l5-5ZM6.25 3A3.25 3.25 0 0 0 3 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25ZM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25Z"
]);
const $77e1bce0ac0f7fe7$export$7e20265d53fdff4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst16Filled', "16", [
    "M4.1 2.25a2 2 0 0 1 2.65-1.08l.88.38c.25.11.54.11.79 0l.89-.37a2 2 0 0 1 2.64 1.1l.35.9c.1.26.3.46.56.56l.9.36a2 2 0 0 1 1.07 2.65l-.38.89a1 1 0 0 0 0 .78l.37.9a2 2 0 0 1-1.1 2.63l-.9.35a1 1 0 0 0-.56.56l-.36.9a2 2 0 0 1-2.65 1.08l-.88-.39a1 1 0 0 0-.8 0l-.88.37a2 2 0 0 1-2.64-1.1l-.35-.9a1 1 0 0 0-.56-.56l-.9-.36a2 2 0 0 1-1.07-2.65l.38-.88a1 1 0 0 0 0-.79l-.37-.89a2 2 0 0 1 1.1-2.64l.9-.35a1 1 0 0 0 .56-.55l.36-.9Zm6.75 3.9a.5.5 0 0 0-.7 0l-2.9 2.9-1.4-1.4a.5.5 0 0 0-.7.7L6.9 10.1c.2.2.5.2.7 0l3.25-3.25a.5.5 0 0 0 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$aea04397f79a8872 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst16Regular', "16", [
    "M4.1 2.25a2 2 0 0 1 2.65-1.08l.88.38c.26.1.54.1.8 0l.88-.37a2 2 0 0 1 2.64 1.1l.35.9c.1.25.3.46.56.56l.9.36a2 2 0 0 1 1.08 2.65l-.39.88a1 1 0 0 0 0 .8l.37.88a2 2 0 0 1-1.1 2.64l-.9.35a1 1 0 0 0-.56.56l-.36.9a2 2 0 0 1-2.65 1.08l-.88-.39a1 1 0 0 0-.8 0l-.88.37a2 2 0 0 1-2.64-1.1l-.35-.9a1 1 0 0 0-.56-.56l-.9-.36a2 2 0 0 1-1.08-2.65l.39-.88a1 1 0 0 0 0-.8l-.37-.88a2 2 0 0 1 1.1-2.64l.9-.35a1 1 0 0 0 .56-.56l.36-.9Zm2.25-.17a1 1 0 0 0-1.32.54l-.37.9a2 2 0 0 1-1.11 1.1l-.9.36A1 1 0 0 0 2.1 6.3l.37.89a2 2 0 0 1 0 1.57l-.39.89a1 1 0 0 0 .54 1.32l.9.37c.5.2.9.6 1.1 1.11l.36.9a1 1 0 0 0 1.32.55l.89-.37a2 2 0 0 1 1.57 0l.89.39a1 1 0 0 0 1.32-.54l.37-.9a2 2 0 0 1 1.11-1.1l.9-.36a1 1 0 0 0 .55-1.32l-.37-.89a2 2 0 0 1 0-1.57l.39-.89a1 1 0 0 0-.54-1.32l-.9-.36a2 2 0 0 1-1.1-1.12l-.36-.9A1 1 0 0 0 9.7 2.1l-.89.37a2 2 0 0 1-1.57 0l-.89-.39Zm3.8 4.07a.5.5 0 0 1 .7.7L7.6 10.1a.5.5 0 0 1-.7 0L5.15 8.35a.5.5 0 0 1 .7-.7l1.4 1.4 2.9-2.9Z"
]);
const $77e1bce0ac0f7fe7$export$deed0f49b38688a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst20Filled', "20", [
    "M11.54 1.9c1.21-.48 2.58.09 3.1 1.28l.43.98c.15.35.43.62.77.78l.98.42a2.42 2.42 0 0 1 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.4.99a2.42 2.42 0 0 1-1.3 3.1l-.97.43a1.5 1.5 0 0 0-.77.77l-.43.98a2.42 2.42 0 0 1-3.1 1.28l-.99-.39a1.5 1.5 0 0 0-1.1 0l-.99.4a2.42 2.42 0 0 1-3.1-1.3l-.42-.97a1.5 1.5 0 0 0-.78-.77l-.98-.43a2.42 2.42 0 0 1-1.28-3.1l.39-.99a1.5 1.5 0 0 0 0-1.1l-.4-.99a2.42 2.42 0 0 1 1.3-3.1l.97-.42c.35-.16.62-.43.78-.78l.42-.98a2.42 2.42 0 0 1 3.1-1.28l1 .39c.35.14.74.14 1.1 0l.98-.4Zm1.81 5.75a.5.5 0 0 0-.7 0L9 11.29 7.35 9.65a.5.5 0 1 0-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 0 0 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$88a6657e828b7510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst20Regular', "20", [
    "M11.54 1.9c1.21-.48 2.58.09 3.1 1.28l.43.98c.15.35.43.62.77.77l.98.43a2.42 2.42 0 0 1 1.28 3.1l-.39 1a1.5 1.5 0 0 0 0 1.09l.4.99a2.42 2.42 0 0 1-1.3 3.1l-.97.43a1.5 1.5 0 0 0-.77.77l-.43.98a2.42 2.42 0 0 1-3.1 1.28l-.99-.39a1.5 1.5 0 0 0-1.1 0l-.99.4a2.42 2.42 0 0 1-3.1-1.3l-.42-.97a1.5 1.5 0 0 0-.78-.77l-.98-.43a2.42 2.42 0 0 1-1.28-3.1l.39-.99a1.5 1.5 0 0 0 0-1.1l-.4-.99a2.42 2.42 0 0 1 1.3-3.1l.97-.43c.35-.15.62-.42.78-.77l.42-.98a2.42 2.42 0 0 1 3.1-1.28l1 .39c.35.14.74.14 1.1 0l.98-.4Zm2.19 1.68c-.3-.7-1.11-1.03-1.82-.75l-1 .39a2.5 2.5 0 0 1-1.82 0l-1-.4a1.42 1.42 0 0 0-1.81.76l-.43.98a2.5 2.5 0 0 1-1.3 1.3l-.97.42c-.7.3-1.03 1.1-.75 1.82l.39.99a2.5 2.5 0 0 1 0 1.83l-.4.99c-.27.7.06 1.51.76 1.81l.98.43a2.5 2.5 0 0 1 1.3 1.3l.42.97c.3.7 1.1 1.03 1.82.75l.99-.39a2.5 2.5 0 0 1 1.83 0l.99.4c.7.27 1.51-.06 1.82-.76l.42-.98a2.5 2.5 0 0 1 1.3-1.3l.97-.42c.7-.3 1.03-1.1.75-1.81l-.39-1a2.5 2.5 0 0 1 0-1.82l.4-1a1.42 1.42 0 0 0-.76-1.81l-.98-.43a2.5 2.5 0 0 1-1.29-1.3l-.42-.97Zm-1.08 4.07a.5.5 0 0 1 .7.7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9 11.29l3.65-3.64Z"
]);
const $77e1bce0ac0f7fe7$export$c2df18216d425fb4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst24Filled', "24", [
    "M6.35 3.75a2.75 2.75 0 0 1 3.81-1.58l1.29.63c.35.17.75.17 1.1 0l1.28-.63a2.75 2.75 0 0 1 3.69 1.25l.07.16.06.17.46 1.36c.13.36.42.65.78.78l1.36.46a2.75 2.75 0 0 1 1.58 3.81l-.63 1.29c-.17.35-.17.75 0 1.1l.63 1.29a2.75 2.75 0 0 1-1.58 3.81l-1.36.46c-.36.13-.65.42-.78.78l-.46 1.36a2.75 2.75 0 0 1-3.82 1.58l-1.28-.63a1.25 1.25 0 0 0-1.1 0l-1.29.63a2.75 2.75 0 0 1-3.81-1.58l-.46-1.36a1.25 1.25 0 0 0-.78-.78l-1.36-.46a2.75 2.75 0 0 1-1.58-3.81l.63-1.29c.17-.35.17-.75 0-1.1l-.63-1.29a2.75 2.75 0 0 1 1.58-3.81l1.36-.46c.36-.13.65-.42.78-.78l.46-1.36Zm9.93 5.22a.75.75 0 0 0-1.06 0l-4.47 4.47-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5c.3-.3.3-.77 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$96985897b6dca161 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst24Regular', "24", [
    "M6.35 3.75a2.75 2.75 0 0 1 3.81-1.58l1.29.63c.35.17.75.17 1.1 0l1.28-.63a2.75 2.75 0 0 1 3.69 1.25l.07.16.06.17.46 1.36c.13.36.42.65.78.78l1.36.46a2.75 2.75 0 0 1 1.58 3.82l-.63 1.28c-.17.35-.17.75 0 1.1l.63 1.29a2.75 2.75 0 0 1-1.58 3.81l-1.36.46c-.36.13-.65.42-.78.78l-.46 1.36a2.75 2.75 0 0 1-3.82 1.58l-1.28-.63a1.25 1.25 0 0 0-1.1 0l-1.29.63a2.75 2.75 0 0 1-3.81-1.58l-.46-1.36a1.25 1.25 0 0 0-.78-.78l-1.36-.46a2.75 2.75 0 0 1-1.58-3.81l.63-1.29c.17-.35.17-.75 0-1.1l-.63-1.28a2.75 2.75 0 0 1 1.58-3.82l1.36-.46c.36-.13.65-.42.78-.78l.46-1.36Zm9.76.22a1.25 1.25 0 0 0-1.61-.45l-1.29.63c-.76.37-1.66.37-2.42 0L9.5 3.52a1.26 1.26 0 0 0-1.73.72L7.3 5.59c-.28.8-.91 1.44-1.72 1.72l-1.35.46c-.06.01-.1.04-.16.06-.61.3-.87 1.05-.56 1.67l.63 1.29c.37.76.37 1.66 0 2.42l-.63 1.29a1.25 1.25 0 0 0 .72 1.73l1.35.46c.8.28 1.44.91 1.72 1.72l.46 1.35c.01.06.04.1.06.15.3.62 1.05.88 1.67.57l1.29-.63a2.75 2.75 0 0 1 2.42 0l1.29.63.15.07c.65.22 1.36-.13 1.58-.79l.46-1.35c.28-.8.91-1.44 1.72-1.72l1.35-.46c.06-.01.1-.04.15-.06.62-.3.88-1.05.57-1.67l-.63-1.29a2.75 2.75 0 0 1 0-2.42l.63-1.29.07-.15a1.25 1.25 0 0 0-.79-1.58l-1.35-.46a2.75 2.75 0 0 1-1.72-1.72l-.46-1.35-.03-.08-.03-.08-.06-.1Zm-.89 5a.75.75 0 1 1 1.06 1.06l-5 5c-.3.3-.77.3-1.06 0l-2.5-2.5a.75.75 0 0 1 1.06-1.06l1.97 1.97 4.47-4.47Z"
]);
const $77e1bce0ac0f7fe7$export$9c6eff0fda7fe679 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst28Filled', "28", [
    "M15.72 2.4a3.75 3.75 0 0 1 5.26 2.18l.25.75c.22.68.75 1.22 1.43 1.44l.76.25a3.75 3.75 0 0 1 2.17 5.26l-.35.7c-.33.64-.33 1.4 0 2.03l.35.7a3.75 3.75 0 0 1-2.17 5.27l-.76.24c-.68.23-1.21.76-1.43 1.44l-.25.75a3.75 3.75 0 0 1-5.26 2.18l-.7-.36a2.25 2.25 0 0 0-2.04 0l-.7.36a3.75 3.75 0 0 1-5.26-2.18l-.25-.75a2.25 2.25 0 0 0-1.43-1.44l-.76-.24a3.75 3.75 0 0 1-2.17-5.26l.35-.7c.33-.65.33-1.4 0-2.04l-.35-.7a3.75 3.75 0 0 1 2.17-5.26l.76-.25a2.25 2.25 0 0 0 1.43-1.44l.25-.75a3.75 3.75 0 0 1 5.26-2.18l.7.36c.64.32 1.4.32 2.04 0l.7-.36Zm3.81 7.82a.75.75 0 0 0-1.06 0l-5.97 5.97-2.97-2.97a.75.75 0 0 0-1.06 1.06l3.5 3.5c.3.3.77.3 1.06 0l6.5-6.5c.3-.3.3-.77 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$b1b2f75d10b4778c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst28Regular', "28", [
    "M15.72 2.4a3.75 3.75 0 0 1 5.26 2.18l.25.75c.22.68.75 1.22 1.43 1.44l.76.25a3.75 3.75 0 0 1 2.17 5.26l-.35.7c-.33.64-.33 1.4 0 2.03l.35.7a3.75 3.75 0 0 1-2.17 5.27l-.76.24c-.68.23-1.21.76-1.43 1.44l-.25.75a3.75 3.75 0 0 1-5.26 2.18l-.7-.36a2.25 2.25 0 0 0-2.04 0l-.7.36a3.75 3.75 0 0 1-5.26-2.18l-.25-.75a2.25 2.25 0 0 0-1.43-1.44l-.76-.24a3.75 3.75 0 0 1-2.17-5.26l.35-.7c.33-.65.33-1.4 0-2.04l-.35-.7a3.75 3.75 0 0 1 2.17-5.26l.76-.25a2.25 2.25 0 0 0 1.43-1.44l.25-.75a3.75 3.75 0 0 1 5.26-2.18l.7.36c.64.32 1.4.32 2.04 0l.7-.36Zm3.83 2.65a2.25 2.25 0 0 0-3.15-1.3l-.7.35a3.75 3.75 0 0 1-3.4 0l-.7-.36a2.25 2.25 0 0 0-3.15 1.3l-.25.76a3.75 3.75 0 0 1-2.4 2.4l-.75.24a2.25 2.25 0 0 0-1.3 3.16l.35.7a3.75 3.75 0 0 1 0 3.4l-.36.7a2.25 2.25 0 0 0 1.31 3.15l.75.25a3.75 3.75 0 0 1 2.4 2.4l.25.75a2.25 2.25 0 0 0 3.15 1.3l.7-.35a3.75 3.75 0 0 1 3.4 0l.7.35c1.23.63 2.73 0 3.15-1.3l.25-.75a3.75 3.75 0 0 1 2.4-2.4l.75-.25a2.25 2.25 0 0 0 1.3-3.15l-.35-.7a3.75 3.75 0 0 1 0-3.4l.36-.7c.62-1.23 0-2.73-1.31-3.16l-.75-.24a3.75 3.75 0 0 1-2.4-2.4l-.25-.75Zm-1.08 5.17a.75.75 0 0 1 1.06 1.06l-6.5 6.5c-.3.3-.77.3-1.06 0l-3.5-3.5a.75.75 0 0 1 1.06-1.06l2.97 2.97 5.97-5.97Z"
]);
const $77e1bce0ac0f7fe7$export$df4460f7988deef6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst32Filled', "32", [
    "M8.11 4.73a4 4 0 0 1 5.61-2.3l1.43.74a2 2 0 0 0 1.8 0l1.44-.71a4 4 0 0 1 5.59 2.34l.5 1.53a2 2 0 0 0 1.26 1.28l1.52.5a4 4 0 0 1 2.3 5.61l-.73 1.43a2 2 0 0 0-.01 1.8l.72 1.44a4 4 0 0 1-2.35 5.59l-1.52.5a2 2 0 0 0-1.28 1.26l-.5 1.52a4 4 0 0 1-5.62 2.3l-1.42-.73a2 2 0 0 0-1.81 0l-1.43.7A4 4 0 0 1 8 27.2l-.49-1.53a2 2 0 0 0-1.27-1.28l-1.52-.5a4 4 0 0 1-2.3-5.62l.74-1.42a2 2 0 0 0 0-1.8l-.71-1.44A4 4 0 0 1 4.8 8l1.53-.48A2 2 0 0 0 7.6 6.25l.5-1.52Zm14.6 6.56a1 1 0 0 0-1.42 0l-6.8 6.8-3.28-3.3a1 1 0 0 0-1.42 1.42l4 4a1 1 0 0 0 1.42 0l7.5-7.5a1 1 0 0 0 0-1.42Z"
]);
const $77e1bce0ac0f7fe7$export$4bbfba83827e9708 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst32Regular', "32", [
    "M8.11 4.73a4 4 0 0 1 5.61-2.3l1.43.74a2 2 0 0 0 1.8 0l1.44-.71a4 4 0 0 1 5.59 2.34l.5 1.53a2 2 0 0 0 1.26 1.28l1.52.5a4 4 0 0 1 2.3 5.61l-.73 1.43a2 2 0 0 0-.01 1.8l.72 1.44a4 4 0 0 1-2.35 5.59l-1.52.5a2 2 0 0 0-1.28 1.26l-.5 1.52a4 4 0 0 1-5.62 2.3l-1.42-.73a2 2 0 0 0-1.81 0l-1.43.7A4 4 0 0 1 8 27.2l-.49-1.53a2 2 0 0 0-1.27-1.28l-1.52-.5a4 4 0 0 1-2.3-5.62l.74-1.42a2 2 0 0 0 0-1.8l-.71-1.44A4 4 0 0 1 4.8 8l1.53-.48A2 2 0 0 0 7.6 6.25l.5-1.52Zm4.7-.51a2 2 0 0 0-2.8 1.14l-.5 1.52a4 4 0 0 1-2.57 2.55l-1.53.49a2 2 0 0 0-1.17 2.8l.72 1.43a4 4 0 0 1-.02 3.6l-.73 1.43a2 2 0 0 0 1.15 2.8l1.52.51a4 4 0 0 1 2.54 2.57l.5 1.52a2 2 0 0 0 2.8 1.17l1.43-.71a4 4 0 0 1 3.6.01l1.43.73a2 2 0 0 0 2.8-1.15l.51-1.52a4 4 0 0 1 2.57-2.54l1.52-.5a2 2 0 0 0 1.17-2.79l-.71-1.43a4 4 0 0 1 .01-3.61l.73-1.43a2 2 0 0 0-1.15-2.8l-1.52-.5a4 4 0 0 1-2.54-2.57l-.5-1.53a2 2 0 0 0-2.79-1.17l-1.43.72a4 4 0 0 1-3.61-.01l-1.43-.73Zm8.48 7.07a1 1 0 1 1 1.42 1.42l-7.5 7.5a1 1 0 0 1-1.42 0l-4-4a1 1 0 1 1 1.42-1.42l3.29 3.3 6.8-6.8Z"
]);
const $77e1bce0ac0f7fe7$export$2bdcb0c64d72650a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst48Filled', "48", [
    "M13.1 7.28a5.25 5.25 0 0 1 6.95-2.85L23 5.71c.69.3 1.47.3 2.16.01l2.96-1.25a5.25 5.25 0 0 1 6.92 2.9l1.18 2.99c.28.7.83 1.25 1.53 1.53l2.97 1.21a5.25 5.25 0 0 1 2.85 6.95L42.29 23c-.3.69-.3 1.47-.01 2.16l1.25 2.96a5.25 5.25 0 0 1-2.9 6.92l-2.99 1.18c-.7.28-1.25.83-1.53 1.53l-1.21 2.97a5.25 5.25 0 0 1-6.95 2.85L25 42.29c-.69-.3-1.47-.3-2.16-.01l-2.96 1.25a5.25 5.25 0 0 1-6.92-2.9l-1.18-2.99a2.75 2.75 0 0 0-1.53-1.53L7.28 34.9a5.25 5.25 0 0 1-2.85-6.95L5.71 25c.3-.69.3-1.47.01-2.16l-1.25-2.96a5.25 5.25 0 0 1 2.9-6.92l2.99-1.18c.7-.28 1.25-.83 1.53-1.53l1.21-2.97Zm19.53 10.34a1.25 1.25 0 0 0-1.76 0L20.75 27.73l-3.62-3.61a1.25 1.25 0 0 0-1.76 1.76l4.5 4.5c.48.5 1.28.5 1.76 0l11-11c.5-.48.5-1.28 0-1.76Z"
]);
const $77e1bce0ac0f7fe7$export$daf7a802e736eec5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkStarburst48Regular', "48", [
    "M13.1 7.28a5.25 5.25 0 0 1 6.95-2.85L23 5.71c.69.3 1.47.3 2.16 0l2.96-1.24a5.25 5.25 0 0 1 6.92 2.9l1.18 2.99c.28.7.83 1.25 1.53 1.53l2.97 1.21a5.25 5.25 0 0 1 2.85 6.95L42.29 23c-.3.69-.3 1.47 0 2.16l1.24 2.96a5.25 5.25 0 0 1-2.9 6.92l-2.99 1.18c-.7.28-1.25.83-1.53 1.53l-1.21 2.97a5.25 5.25 0 0 1-6.95 2.85L25 42.29c-.69-.3-1.47-.3-2.16-.01l-2.96 1.25a5.25 5.25 0 0 1-6.92-2.9l-1.18-2.99a2.75 2.75 0 0 0-1.53-1.53L7.28 34.9a5.25 5.25 0 0 1-2.85-6.95L5.71 25c.3-.69.3-1.47.01-2.16l-1.25-2.96a5.25 5.25 0 0 1 2.9-6.92l2.99-1.18c.7-.28 1.25-.83 1.53-1.53l1.21-2.97Zm5.96-.55a2.75 2.75 0 0 0-3.64 1.49l-1.2 2.97a5.25 5.25 0 0 1-2.94 2.91l-2.99 1.18a2.75 2.75 0 0 0-1.52 3.63l1.25 2.96A5.25 5.25 0 0 1 8 26l-1.27 2.94a2.75 2.75 0 0 0 1.49 3.64l2.97 1.21a5.25 5.25 0 0 1 2.91 2.93l1.18 2.99a2.75 2.75 0 0 0 3.63 1.52l2.96-1.25A5.25 5.25 0 0 1 26 40l2.95 1.27a2.75 2.75 0 0 0 3.63-1.49l1.21-2.97a5.25 5.25 0 0 1 2.93-2.91l3-1.18a2.75 2.75 0 0 0 1.51-3.63l-1.25-2.96A5.25 5.25 0 0 1 40 22l1.27-2.94a2.75 2.75 0 0 0-1.49-3.64l-2.97-1.21a5.25 5.25 0 0 1-2.91-2.93l-1.18-3a2.75 2.75 0 0 0-3.63-1.51l-2.96 1.25A5.25 5.25 0 0 1 22 8l-2.94-1.27Zm11.8 10.89a1.25 1.25 0 0 1 1.77 1.76l-11 11c-.48.5-1.28.5-1.76 0l-4.5-4.5a1.25 1.25 0 0 1 1.76-1.76l3.62 3.61 10.12-10.11Z"
]);
const $77e1bce0ac0f7fe7$export$b1e8ffbf60a8d109 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle16Filled', "16", [
    "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm2.86-8.85c.19.2.19.52 0 .72L7.97 8.85a.48.48 0 0 1-.7 0L6.15 7.68a.52.52 0 0 1 0-.72c.2-.2.5-.2.7 0l.78.81 2.54-2.62c.2-.2.5-.2.7 0ZM6.5 10h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Z"
]);
const $77e1bce0ac0f7fe7$export$be00f3230aa510f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle16Regular', "16", [
    "M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10Zm0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm2.86-8.85c.19.2.19.52 0 .72L7.97 8.85a.48.48 0 0 1-.7 0L6.15 7.68a.52.52 0 0 1 0-.72c.2-.2.5-.2.7 0l.78.81 2.54-2.62c.2-.2.5-.2.7 0ZM6 10.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$1cd847e219b683d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle20Filled', "20", [
    "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0ZM7.5 13h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1Z"
]);
const $77e1bce0ac0f7fe7$export$ba8d87f30eceaa4e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle20Regular', "20", [
    "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.85-11.85c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7L9.5 9.79l3.65-3.64c.2-.2.5-.2.7 0ZM7 13.5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5Z"
]);
const $77e1bce0ac0f7fe7$export$4e051ad2b50bcc06 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle24Filled', "24", [
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1.25 9.44 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5A.75.75 0 0 1 8.7 9.4l.08.07 1.97 1.97ZM8.5 15h6.75a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1 0-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$3cdb3f8b4100b5f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('CheckmarkUnderlineCircle24Regular', "24", [
    "m10.75 11.44 4.47-4.47a.75.75 0 0 1 1.13.98l-.07.08-5 5a.75.75 0 0 1-.98.07l-.08-.07-2.5-2.5A.75.75 0 0 1 8.7 9.4l.08.07 1.97 1.97ZM8.5 15a.75.75 0 0 0 0 1.5h6.75a.75.75 0 0 0 0-1.5H8.5ZM2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm10-8.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Z"
]);
const $77e1bce0ac0f7fe7$export$569e85cb21c2e84a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess16Filled', "16", [
    "M5 4a2.5 2.5 0 0 1 2 4 1 1 0 0 1 0 2h-.46a3.44 3.44 0 0 0 1.69 2.3c.42.26.77.73.77 1.3 0 .78-.62 1.4-1.4 1.4H2.4A1.4 1.4 0 0 1 1 13.6c0-.57.35-1.04.77-1.3.6-.38 1.49-1.11 1.69-2.3H3a1 1 0 0 1 0-2 2.5 2.5 0 0 1 2-4Zm4-3c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.28.22-.5.5-.5h.25c.41 0 .75.34.75.75V4a2 2 0 0 1-2 2c.07 4.14 1 5.75 1.46 6.3.25.3.54.74.54 1.27 0 .8-.64 1.43-1.43 1.43H9.53c.3-.4.47-.9.47-1.43 0-.9-.48-1.6-1-2.02.45-.9.94-2.57 1-5.55a2 2 0 0 1-2-2V1.75c0-.41.34-.75.75-.75H9Z"
]);
const $77e1bce0ac0f7fe7$export$39f873b955a864ac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess16Regular', "16", [
    "M5 4a2.5 2.5 0 0 1 2.43 3.06 1.5 1.5 0 0 1-.4 2.94c.16 1.2.84 1.93 1.3 2.29.36.28.67.74.67 1.28v.15c-.08.67-.6 1.2-1.28 1.27l-.15.01H2.43c-.74 0-1.35-.56-1.42-1.28L1 13.57c0-.54.3-1 .67-1.28a3.45 3.45 0 0 0 1.3-2.3 1.5 1.5 0 0 1-.4-2.93A2.5 2.5 0 0 1 5 4Zm4.5-3c.38 0 .73.15 1 .39a1.49 1.49 0 0 1 2 0 1.5 1.5 0 0 1 1-.39h.5a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2c.07 4.14 1 5.75 1.46 6.3.25.3.54.74.54 1.27 0 .8-.64 1.43-1.43 1.43H9.53c.22-.3.36-.63.43-1h3.61c.24 0 .43-.2.43-.43 0-.17-.1-.39-.3-.63-.7-.82-1.7-2.8-1.7-7.44 0-.28.22-.5.5-.5h.5a1 1 0 0 0 1-1V2h-.5a.5.5 0 0 0-.5.5V3a.5.5 0 0 1-1 0V2.5a.5.5 0 0 0-.98-.1l-.01.1L11 3a.5.5 0 0 1-1 0v-.52A.5.5 0 0 0 9.5 2H9v2a1 1 0 0 0 1 1h.5c.28 0 .5.22.5.5 0 3.81-.68 5.83-1.3 6.89a2.87 2.87 0 0 0-.7-.84c.45-.9.94-2.57 1-5.55a2 2 0 0 1-2-2V2a1 1 0 0 1 1-1h.5ZM5 5a1.5 1.5 0 0 0-1.3 2.25.5.5 0 0 1-.43.75H3a.5.5 0 0 0 0 1h.5c.28 0 .5.22.5.5a4.47 4.47 0 0 1-1.71 3.58c-.2.15-.29.34-.29.5v.08c.05.2.22.34.43.34H7.66c.17-.04.3-.17.33-.34l.01-.09c0-.15-.1-.34-.29-.5A4.47 4.47 0 0 1 6 9.5c0-.28.22-.5.5-.5H7l.1-.01a.5.5 0 0 0 0-.98L7 8h-.27a.5.5 0 0 1-.43-.75A1.5 1.5 0 0 0 5 5Z"
]);
const $77e1bce0ac0f7fe7$export$f82ba2c948694adf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess20Filled', "20", [
    "M10.5 2a.5.5 0 0 0-.5.5v2.6a3 3 0 0 0 2.2 2.89 16.03 16.03 0 0 1-1.67 6.05c.18.21.36.37.5.49.51.43.97 1.14.97 2.02 0 .54-.18 1.04-.48 1.45H17c.83 0 1.5-.67 1.5-1.5v-.3c0-.35-.12-.68-.3-.94A15.03 15.03 0 0 1 15.8 8 3 3 0 0 0 18 5.1V2.5a.5.5 0 0 0-.5-.5h-.75a.75.75 0 0 0-.75.75v.75a.5.5 0 0 1-1 0v-.75a.75.75 0 0 0-.75-.75h-.5a.75.75 0 0 0-.75.75v.75a.5.5 0 0 1-1 0v-.75a.75.75 0 0 0-.75-.75h-.75Zm-4 3a3 3 0 0 0-2.24 5H4a1 1 0 1 0 0 2h.52a5.76 5.76 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.76 5.76 0 0 1 8.48 12H9a1 1 0 1 0 0-2h-.26A3 3 0 0 0 6.5 5Z"
]);
const $77e1bce0ac0f7fe7$export$d72b9ebdc19953a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess20Regular', "20", [
    "M10 3a1 1 0 0 1 1-1h.5c.39 0 .74.15 1 .38a1.5 1.5 0 0 1 1-.38h1c.38 0 .73.15 1 .38a1.5 1.5 0 0 1 1-.38h.5a1 1 0 0 1 1 1v2.5a2.5 2.5 0 0 1-1.95 2.44c.28 4.04 1.7 6.58 2.19 7.35.16.25.26.55.26.88v.33c0 .83-.67 1.5-1.5 1.5h-5.48c.22-.3.37-.63.44-1H17a.5.5 0 0 0 .5-.5v-.33c0-.11-.03-.23-.1-.34-.58-.9-2.16-3.78-2.38-8.3a.5.5 0 0 1 .5-.53A1.5 1.5 0 0 0 17 5.5V3h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 0-.5-.5H11v2.5c0 .82.66 1.49 1.48 1.5a.5.5 0 0 1 .5.52 18.32 18.32 0 0 1-1.76 7.2 2.82 2.82 0 0 0-.2-.2 4.2 4.2 0 0 1-.55-.55 17.38 17.38 0 0 0 1.48-6.03A2.5 2.5 0 0 1 10 5.5V3ZM4.5 8a2 2 0 1 1 3.6 1.2.5.5 0 0 0 .4.8H9a.5.5 0 0 1 0 1H7.9a.5.5 0 0 0-.5.56 6.86 6.86 0 0 0 2.34 4.5c.17.15.26.33.26.49 0 .25-.2.45-.45.45h-6.1a.45.45 0 0 1-.45-.45c0-.16.09-.34.26-.49a6.86 6.86 0 0 0 2.34-4.5.5.5 0 0 0-.5-.56H4a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .4-.8c-.25-.33-.4-.75-.4-1.2Zm2-3a3 3 0 0 0-2.82 4.03A1.5 1.5 0 0 0 4 12h.52a5.76 5.76 0 0 1-1.9 3.3c-.35.28-.62.73-.62 1.25 0 .8.65 1.45 1.45 1.45h6.1c.8 0 1.45-.65 1.45-1.45 0-.52-.27-.97-.62-1.26A5.76 5.76 0 0 1 8.48 12H9a1.5 1.5 0 0 0 .32-2.97A3 3 0 0 0 6.5 5Z"
]);
const $77e1bce0ac0f7fe7$export$919574d8d51e4fdd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess24Filled', "24", [
    "M7.5 6a3.5 3.5 0 0 1 2.45 6h.55a1.5 1.5 0 0 1 0 3h-.37c.38 1.8 1.5 3 2.14 3.56.42.36.73.92.73 1.55 0 1.04-.85 1.89-1.89 1.89H3.89A1.89 1.89 0 0 1 2 20.11c0-.63.31-1.19.73-1.55A6.69 6.69 0 0 0 4.87 15H4.5a1.5 1.5 0 0 1 0-3h.55A3.49 3.49 0 0 1 7.5 6ZM13 2a1 1 0 0 1 1 1v1.25a.75.75 0 0 0 1.5 0V3a1 1 0 1 1 2 0v1.25a.75.75 0 0 0 1.5 0V3a1 1 0 0 1 1-1h.25c.41 0 .75.34.75.75V7a2 2 0 0 1-2 2h-.22c.26 5.45 2.16 8.73 2.83 9.71.23.35.39.78.39 1.25 0 1.13-.91 2.04-2.04 2.04h-6.67c.44-.5.71-1.17.71-1.89 0-.97-.48-1.78-1.07-2.3a6.1 6.1 0 0 1-.65-.67c.8-1.65 1.76-4.37 1.94-8.14H14a2 2 0 0 1-2-2V2.75c0-.41.34-.75.75-.75H13Z"
]);
const $77e1bce0ac0f7fe7$export$981e2df2d442ef45 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Chess24Regular', "24", [
    "M7.5 6a3.5 3.5 0 0 1 3.33 4.58 2.25 2.25 0 0 1-.58 4.42h-.12a6.7 6.7 0 0 0 2.14 3.56c.42.36.73.92.73 1.55l-.01.2c-.09.88-.8 1.59-1.69 1.68l-.19.01H3.89c-.98 0-1.78-.74-1.88-1.7L2 20.11c0-.63.31-1.19.73-1.55A6.7 6.7 0 0 0 4.87 15h-.12a2.25 2.25 0 0 1-.58-4.42A3.49 3.49 0 0 1 7.5 6Zm6.23-4c.54 0 1.04.2 1.43.52a1.99 1.99 0 0 1 2.68 0c.39-.33.89-.52 1.43-.52h.38A1.5 1.5 0 0 1 21 3.5v3.25c0 1.33-.94 2.44-2.2 2.7.34 5.18 2.16 8.3 2.8 9.26.24.35.4.78.4 1.25l-.01.2c-.1.97-.86 1.73-1.82 1.83l-.21.01h-6.67c.36-.41.6-.93.68-1.5h5.99l.1-.01a.54.54 0 0 0 .43-.42l.01-.11a.74.74 0 0 0-.14-.41c-.8-1.18-2.87-4.81-3.09-10.77a.75.75 0 0 1 .75-.78h.23c.69 0 1.25-.56 1.25-1.25V3.5h-.23c-.4 0-.74.33-.75.73l-.02 1.03a.75.75 0 0 1-1.5-.01V4a.5.5 0 0 0-1 0v1.33a.75.75 0 0 1-1.5-.07l-.02-1.03c0-.4-.34-.73-.75-.73h-.23v3.25c0 .69.56 1.25 1.25 1.25h.23a.75.75 0 0 1 .75.78 22.2 22.2 0 0 1-2.35 9.51 3.27 3.27 0 0 0-.45-.48 6.1 6.1 0 0 1-.65-.67 20.8 20.8 0 0 0 1.91-7.7A2.75 2.75 0 0 1 12 6.75V3.5c0-.83.67-1.5 1.5-1.5h.23ZM7.5 7.5a2 2 0 0 0-1.54 3.27.75.75 0 0 1-.58 1.23h-.63a.75.75 0 0 0 0 1.5h.98a.75.75 0 0 1 .75.8 8.04 8.04 0 0 1-2.76 5.38.6.6 0 0 0-.22.43v.08c.04.18.2.31.39.31h7.3a.4.4 0 0 0 .3-.31l.01-.08a.6.6 0 0 0-.22-.43 8.04 8.04 0 0 1-2.76-5.38.75.75 0 0 1 .75-.8h1.06a.75.75 0 0 0-.08-1.5h-.63a.75.75 0 0 1-.58-1.23A2 2 0 0 0 7.5 7.5Z"
]);
const $77e1bce0ac0f7fe7$export$2a5fc15f81ec94fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown12Filled', "12", [
    "M6 1a5 5 0 1 1 0 10A5 5 0 0 1 6 1Zm1.85 4.85a.5.5 0 1 0-.7-.7L6 6.29 4.85 5.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$92bb7fb515b03540 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown12Regular', "12", [
    "M7.85 5.85a.5.5 0 1 0-.7-.7L6 6.29 4.85 5.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5ZM11 6A5 5 0 1 0 1 6a5 5 0 0 0 10 0ZM6 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"
]);
const $77e1bce0ac0f7fe7$export$7a0b860e2a65abc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm3.35 5.65a.5.5 0 0 0-.7 0L8 9.29 5.35 6.65a.5.5 0 1 0-.7.7l3 3c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$3778e7909b62ebd3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm2.65 4.65a.5.5 0 1 1 .7.7l-3 3a.5.5 0 0 1-.7 0l-3-3a.5.5 0 1 1 .7-.7L8 9.29l2.65-2.64Z"
]);
const $77e1bce0ac0f7fe7$export$7d37a2cba0b2aabd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm4.85-1.85a.5.5 0 1 0-.7.7l3.5 3.5a.5.5 0 0 0 .7 0l3.5-3.5a.5.5 0 0 0-.7-.7L10 11.29 6.85 8.15Z"
]);
const $77e1bce0ac0f7fe7$export$4c42ab072de1faae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown20Regular', "20", [
    "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM6.85 8.15a.5.5 0 1 0-.7.7l3.5 3.5a.5.5 0 0 0 .7 0l3.5-3.5a.5.5 0 0 0-.7-.7L10 11.29 6.85 8.15Z"
]);
const $77e1bce0ac0f7fe7$export$46969c85cd00773f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown24Filled', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20ZM7.47 9.97c-.3.3-.3.77 0 1.06l4 4c.3.3.77.3 1.06 0l4-4a.75.75 0 1 0-1.06-1.06L12 13.44 8.53 9.97a.75.75 0 0 0-1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$3c40ad3419582687 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown24Regular', "24", [
    "M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM7.47 9.97c.3-.3.77-.3 1.06 0L12 13.44l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4c-.3.3-.77.3-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$99812d3e1b65a8c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown28Filled', "28", [
    "M2 14a12 12 0 1 1 24 0 12 12 0 0 1-24 0Zm7.03-2.78a.75.75 0 0 0-1.06 1.06l5.5 5.5c.3.3.77.3 1.06 0l5.5-5.5a.75.75 0 1 0-1.06-1.06L14 16.19l-4.97-4.97Z"
]);
const $77e1bce0ac0f7fe7$export$c9e9ba1edf9c74 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown28Regular', "28", [
    "M3.5 14a10.5 10.5 0 1 1 21 0 10.5 10.5 0 0 1-21 0ZM14 2a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm-4.97 9.22a.75.75 0 0 0-1.06 1.06l5.5 5.5c.3.3.77.3 1.06 0l5.5-5.5a.75.75 0 1 0-1.06-1.06L14 16.19l-4.97-4.97Z"
]);
const $77e1bce0ac0f7fe7$export$f2b826ba95e374b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown32Filled', "32", [
    "M16 2a14 14 0 1 1 0 28 14 14 0 0 1 0-28Zm6.7 12.7a1 1 0 0 0-1.4-1.4L16 18.58l-5.3-5.3a1 1 0 0 0-1.4 1.42l5.87 5.88.03.02.08.08c.2.2.46.3.72.29.26 0 .48-.1.72-.3.05-.03.06-.04.1-.1l5.89-5.87Z"
]);
const $77e1bce0ac0f7fe7$export$23dbeaa81ff24b27 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown32Regular', "32", [
    "M22.7 14.7a1 1 0 0 0-1.4-1.4L16 18.58l-5.3-5.3a1 1 0 0 0-1.4 1.42l5.87 5.88.03.02.08.08c.2.2.46.3.72.29.26 0 .48-.1.72-.3.05-.03.06-.04.1-.1l5.89-5.87ZM30 16a14 14 0 1 0-28 0 14 14 0 0 0 28 0ZM16 4a12 12 0 1 1 0 24 12 12 0 0 1 0-24Z"
]);
const $77e1bce0ac0f7fe7$export$771e26bd3c76cabb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown48Filled', "48", [
    "M24 44a20 20 0 1 0 0-40 20 20 0 0 0 0 40Zm-8.62-23.63L24 28.98l8.62-8.61a1.25 1.25 0 0 1 1.76 1.76l-9.5 9.5c-.48.5-1.28.5-1.76 0l-9.5-9.5a1.25 1.25 0 0 1 1.76-1.76Z"
]);
const $77e1bce0ac0f7fe7$export$30abd1c0041c4fa6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleDown48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 1 35 0 17.5 17.5 0 0 1-35 0ZM24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40Zm-8.62 16.37a1.25 1.25 0 0 0-1.76 1.76l9.5 9.5c.48.5 1.28.5 1.76 0l9.5-9.5a1.25 1.25 0 0 0-1.76-1.76L24 28.98l-8.62-8.61Z"
]);
const $77e1bce0ac0f7fe7$export$904a433301365dbf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft12Filled', "12", [
    "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0ZM6.15 7.85a.5.5 0 1 0 .7-.7L5.71 6l1.14-1.15a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$8128867870ce7039 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft12Regular', "12", [
    "M6.15 7.85a.5.5 0 1 0 .7-.7L5.71 6l1.14-1.15a.5.5 0 1 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5ZM6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Zm4-5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
]);
const $77e1bce0ac0f7fe7$export$6018bfb20d7df034 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm1.35 3.65a.5.5 0 0 0-.7 0l-3 3a.5.5 0 0 0 0 .7l3 3a.5.5 0 1 0 .7-.7L6.71 8l2.64-2.65a.5.5 0 0 0 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$b108056a2c74185d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm.65 2.65a.5.5 0 1 1 .7.7L6.71 8l2.64 2.65a.5.5 0 1 1-.7.7l-3-3a.5.5 0 0 1 0-.7l3-3Z"
]);
const $77e1bce0ac0f7fe7$export$2d03c751266431d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft20Filled', "20", [
    "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm1.85 4.85a.5.5 0 0 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L8.71 10l3.14-3.15Z"
]);
const $77e1bce0ac0f7fe7$export$104109799aa0071e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft20Regular', "20", [
    "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm8 7a8 8 0 1 0-16 0 8 8 0 0 0 16 0Zm-6.15-3.15a.5.5 0 0 0-.7-.7l-3.5 3.5a.5.5 0 0 0 0 .7l3.5 3.5a.5.5 0 0 0 .7-.7L8.71 10l3.14-3.15Z"
]);
const $77e1bce0ac0f7fe7$export$95e4f5c9b7ba3a36 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft24Filled', "24", [
    "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-7.97-4.53a.75.75 0 0 0-1.06 0l-4 4c-.3.3-.3.77 0 1.06l4 4a.75.75 0 1 0 1.06-1.06L10.56 12l3.47-3.47c.3-.3.3-.77 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$d5e829d578f1ab60 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft24Regular', "24", [
    "M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0Zm-1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Zm-6.47 4.53c.3-.3.3-.77 0-1.06L10.56 12l3.47-3.47a.75.75 0 0 0-1.06-1.06l-4 4c-.3.3-.3.77 0 1.06l4 4c.3.3.77.3 1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$fff2773883ed9d8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft28Filled', "28", [
    "M14 2a12 12 0 1 1 0 24 12 12 0 0 1 0-24Zm2.78 7.03a.75.75 0 0 0-1.06-1.06l-5.5 5.5c-.3.3-.3.77 0 1.06l5.5 5.5a.75.75 0 1 0 1.06-1.06L11.81 14l4.97-4.97Z"
]);
const $77e1bce0ac0f7fe7$export$f0ab9b343a015b8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft28Regular', "28", [
    "M14 3.5a10.5 10.5 0 1 1 0 21 10.5 10.5 0 0 1 0-21ZM26 14a12 12 0 1 0-24 0 12 12 0 0 0 24 0Zm-9.22-4.97a.75.75 0 0 0-1.06-1.06l-5.5 5.5c-.3.3-.3.77 0 1.06l5.5 5.5a.75.75 0 1 0 1.06-1.06L11.81 14l4.97-4.97Z"
]);
const $77e1bce0ac0f7fe7$export$71a12b46f0f4d6af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft32Filled', "32", [
    "M30 16a14 14 0 1 1-28 0 14 14 0 0 1 28 0Zm-12.7 6.7a1 1 0 0 0 1.4-1.4L13.42 16l5.3-5.3a1 1 0 0 0-1.42-1.4l-5.88 5.87-.02.03-.08.08a1 1 0 0 0-.29.72c0 .26.1.48.3.72.03.05.04.06.1.1l5.87 5.89Z"
]);
const $77e1bce0ac0f7fe7$export$78670066bf5e0498 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft32Regular', "32", [
    "M17.3 22.7a1 1 0 0 0 1.4-1.4L13.42 16l5.3-5.3a1 1 0 0 0-1.42-1.4l-5.88 5.87-.02.03-.08.08a1 1 0 0 0-.29.72c0 .26.1.48.3.72.03.05.04.06.1.1l5.87 5.89ZM16 30a14 14 0 1 0 0-28 14 14 0 0 0 0 28Zm12-14a12 12 0 1 1-24 0 12 12 0 0 1 24 0Z"
]);
const $77e1bce0ac0f7fe7$export$af27e8bdc93dab8b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft48Filled', "48", [
    "M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40Zm3.63 28.62a1.25 1.25 0 0 1-1.76 1.76l-9.5-9.5a1.25 1.25 0 0 1 0-1.76l9.5-9.5a1.25 1.25 0 0 1 1.76 1.76L19.02 24l8.61 8.62Z"
]);
const $77e1bce0ac0f7fe7$export$ddce28bd1fef545a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleLeft48Regular', "48", [
    "M24 41.5a17.5 17.5 0 1 0 0-35 17.5 17.5 0 0 0 0 35ZM44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0Zm-16.37 8.62a1.25 1.25 0 0 1-1.76 1.76l-9.5-9.5a1.25 1.25 0 0 1 0-1.76l9.5-9.5a1.25 1.25 0 0 1 1.76 1.76L19.02 24l8.61 8.62Z"
]);
const $77e1bce0ac0f7fe7$export$92f4311a039112bd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight12Filled', "12", [
    "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm4.85-1.85a.5.5 0 1 0-.7.7L6.29 6 5.15 7.15a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$df56548f94a0a3da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight12Regular', "12", [
    "M5.85 4.15a.5.5 0 1 0-.7.7L6.29 6 5.15 7.15a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5ZM6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM2 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z"
]);
const $77e1bce0ac0f7fe7$export$81c418a43ec310a9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm-.65 3.65a.5.5 0 1 0-.7.7L9.29 8l-2.64 2.65a.5.5 0 1 0 .7.7l3-3a.5.5 0 0 0 0-.7l-3-3Z"
]);
const $77e1bce0ac0f7fe7$export$dd5e35c7227a08c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM6.65 4.65c.2-.2.5-.2.7 0l3 3c.2.2.2.5 0 .7l-3 3a.5.5 0 1 1-.7-.7L9.29 8 6.65 5.35a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$a0d02266f49d3bae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight20Filled', "20", [
    "M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-1.85-4.85a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 1 0-.7.7L11.29 10l-3.14 3.15Z"
]);
const $77e1bce0ac0f7fe7$export$5bb269e0ecdc948c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight20Regular', "20", [
    "M10 17a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm-8-7a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm6.15 3.15a.5.5 0 0 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 1 0-.7.7L11.29 10l-3.14 3.15Z"
]);
const $77e1bce0ac0f7fe7$export$3c2a0a7d43b5992f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight24Filled', "24", [
    "M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm7.97 4.53c.3.3.77.3 1.06 0l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06L13.44 12l-3.47 3.47c-.3.3-.3.77 0 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$7b8aa18793a831a3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight24Regular', "24", [
    "M2 12a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm1.5 0a8.5 8.5 0 1 0 17 0 8.5 8.5 0 0 0-17 0Zm6.47 4.53a.75.75 0 0 1 0-1.06L13.44 12 9.97 8.53a.75.75 0 0 1 1.06-1.06l4 4c.3.3.3.77 0 1.06l-4 4c-.3.3-.77.3-1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$485566085279e83b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight28Filled', "28", [
    "M14 26a12 12 0 1 1 0-24 12 12 0 0 1 0 24Zm-2.78-7.03a.75.75 0 1 0 1.06 1.06l5.5-5.5c.3-.3.3-.77 0-1.06l-5.5-5.5a.75.75 0 1 0-1.06 1.06L16.19 14l-4.97 4.97Z"
]);
const $77e1bce0ac0f7fe7$export$6a9f703c258a9d96 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight28Regular', "28", [
    "M14 24.5a10.5 10.5 0 1 1 0-21 10.5 10.5 0 0 1 0 21ZM2 14a12 12 0 1 0 24 0 12 12 0 0 0-24 0Zm9.22 4.97a.75.75 0 1 0 1.06 1.06l5.5-5.5c.3-.3.3-.77 0-1.06l-5.5-5.5a.75.75 0 1 0-1.06 1.06L16.19 14l-4.97 4.97Z"
]);
const $77e1bce0ac0f7fe7$export$7f3d12da9a51b120 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight32Filled', "32", [
    "M2 16a14 14 0 1 1 28 0 14 14 0 0 1-28 0Zm12.7-6.7a1 1 0 1 0-1.4 1.4l5.29 5.3-5.3 5.3a1 1 0 0 0 1.42 1.4l5.88-5.87.02-.03.08-.08a1 1 0 0 0 .29-.72c0-.26-.1-.48-.3-.72a1.23 1.23 0 0 0-.1-.1l-5.87-5.89Z"
]);
const $77e1bce0ac0f7fe7$export$493a4b59a172549f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight32Regular', "32", [
    "M14.7 9.3a1 1 0 1 0-1.4 1.4l5.29 5.3-5.3 5.3a1 1 0 0 0 1.42 1.4l5.88-5.87.02-.03.08-.08a1 1 0 0 0 .29-.72c0-.26-.1-.48-.3-.72a1.23 1.23 0 0 0-.1-.1l-5.87-5.89ZM16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28ZM4 16a12 12 0 1 1 24 0 12 12 0 0 1-24 0Z"
]);
const $77e1bce0ac0f7fe7$export$d3a4ca90ed7d8a38 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Zm-3.63 28.62a1.25 1.25 0 0 0 1.76 1.76l9.5-9.5c.5-.48.5-1.28 0-1.76l-9.5-9.5a1.25 1.25 0 0 0-1.76 1.76L28.98 24l-8.61 8.62Z"
]);
const $77e1bce0ac0f7fe7$export$974274cfbf4bd495 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleRight48Regular', "48", [
    "M24 41.5a17.5 17.5 0 1 1 0-35 17.5 17.5 0 0 1 0 35ZM4 24a20 20 0 1 0 40 0 20 20 0 0 0-40 0Zm16.37 8.62a1.25 1.25 0 0 0 1.76 1.76l9.5-9.5c.5-.48.5-1.28 0-1.76l-9.5-9.5a1.25 1.25 0 0 0-1.76 1.76L28.98 24l-8.61 8.62Z"
]);
const $77e1bce0ac0f7fe7$export$29f23d08c7df2b19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp12Filled', "12", [
    "M6 11A5 5 0 1 1 6 1a5 5 0 0 1 0 10ZM4.15 6.15a.5.5 0 1 0 .7.7L6 5.71l1.15 1.14a.5.5 0 1 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$1fcda9f032aec311 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp12Regular', "12", [
    "M4.15 6.15a.5.5 0 1 0 .7.7L6 5.71l1.15 1.14a.5.5 0 1 0 .7-.7l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5ZM1 6a5 5 0 1 0 10 0A5 5 0 0 0 1 6Zm5 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
]);
const $77e1bce0ac0f7fe7$export$67f469f9207c5e21 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp16Filled', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm.35 4.65a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L8 6.71l2.65 2.64a.5.5 0 1 0 .7-.7l-3-3Z"
]);
const $77e1bce0ac0f7fe7$export$895adcdab6200bd1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp16Regular', "16", [
    "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm-.35 3.65c.2-.2.5-.2.7 0l3 3a.5.5 0 1 1-.7.7L8 6.71 5.35 9.35a.5.5 0 1 1-.7-.7l3-3Z"
]);
const $77e1bce0ac0f7fe7$export$daf871f7bcf829d8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp20Filled', "20", [
    "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0Zm4.85 1.85a.5.5 0 0 1-.7-.7l3.5-3.5a.5.5 0 0 1 .7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 8.71l-3.15 3.14Z"
]);
const $77e1bce0ac0f7fe7$export$dbd5cdfadcdacc66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp20Regular', "20", [
    "M3 10a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm7 8a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-3.15-6.15a.5.5 0 0 1-.7-.7l3.5-3.5a.5.5 0 0 1 .7 0l3.5 3.5a.5.5 0 0 1-.7.7L10 8.71l-3.15 3.14Z"
]);
const $77e1bce0ac0f7fe7$export$bf727b9f8d87cd09 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp24Filled', "24", [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm-4.53-7.97a.75.75 0 0 1 0-1.06l4-4c.3-.3.77-.3 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12 10.56l-3.47 3.47c-.3.3-.77.3-1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$dc3e2f23f8903f31 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp24Regular', "24", [
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Zm0-1.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17Zm-4.53-6.47c.3.3.77.3 1.06 0L12 10.56l3.47 3.47a.75.75 0 1 0 1.06-1.06l-4-4a.75.75 0 0 0-1.06 0l-4 4c-.3.3-.3.77 0 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$a1445298ccf0a32d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp28Filled', "28", [
    "M2 14a12 12 0 1 0 24 0 12 12 0 0 0-24 0Zm7.03 2.78a.75.75 0 0 1-1.06-1.06l5.5-5.5c.3-.3.77-.3 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06L14 11.81l-4.97 4.97Z"
]);
const $77e1bce0ac0f7fe7$export$45cbbd3e4641b50a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp28Regular', "28", [
    "M3.5 14a10.5 10.5 0 1 0 21 0 10.5 10.5 0 0 0-21 0ZM14 26a12 12 0 1 1 0-24 12 12 0 0 1 0 24Zm-4.97-9.22a.75.75 0 0 1-1.06-1.06l5.5-5.5c.3-.3.77-.3 1.06 0l5.5 5.5a.75.75 0 1 1-1.06 1.06L14 11.81l-4.97 4.97Z"
]);
const $77e1bce0ac0f7fe7$export$efffbe4450e13e07 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp32Filled', "32", [
    "M16 30a14 14 0 1 1 0-28 14 14 0 0 1 0 28ZM9.3 17.3a1 1 0 1 0 1.4 1.4l5.3-5.29 5.3 5.3a1 1 0 0 0 1.4-1.42l-5.87-5.88-.03-.02a1.66 1.66 0 0 1-.08-.08 1 1 0 0 0-.72-.29c-.26 0-.48.1-.72.3-.05.03-.06.04-.1.1l-5.89 5.87Z"
]);
const $77e1bce0ac0f7fe7$export$62fec6f273e2bbdf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp32Regular', "32", [
    "M4 16a12 12 0 1 0 24 0 12 12 0 0 0-24 0Zm12 14a14 14 0 1 1 0-28 14 14 0 0 1 0 28ZM9.3 18.7a1 1 0 0 1 0-1.4l5.87-5.89.11-.1c.24-.2.46-.3.72-.29a1 1 0 0 1 .72.3l.1.1 5.89 5.87a1 1 0 0 1-1.42 1.42L16 13.4l-5.3 5.3a1 1 0 0 1-1.4 0Z"
]);
const $77e1bce0ac0f7fe7$export$a68e120449d233b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp48Filled', "48", [
    "M24 4a20 20 0 1 1 0 40 20 20 0 0 1 0-40Zm-8.62 23.63L24 19.02l8.62 8.61a1.25 1.25 0 0 0 1.76-1.76l-9.5-9.5a1.25 1.25 0 0 0-1.76 0l-9.5 9.5a1.25 1.25 0 0 0 1.76 1.76Z"
]);
const $77e1bce0ac0f7fe7$export$e4601fd42072bf8e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronCircleUp48Regular', "48", [
    "M6.5 24a17.5 17.5 0 1 0 35 0 17.5 17.5 0 0 0-35 0ZM24 44a20 20 0 1 1 0-40 20 20 0 0 1 0 40Zm-8.62-16.37a1.25 1.25 0 0 1-1.76-1.76l9.5-9.5a1.25 1.25 0 0 1 1.76 0l9.5 9.5a1.25 1.25 0 0 1-1.76 1.76L24 19.02l-8.62 8.61Z"
]);
const $77e1bce0ac0f7fe7$export$fd7b76e13d57b45f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown16Filled', "16", [
    "M11.72 7.97a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L3.22 9.03a.75.75 0 1 1 1.06-1.06L8 11.69l3.72-3.72Zm0-4.5a.75.75 0 1 1 1.06 1.06L8.53 8.78a.75.75 0 0 1-1.06 0L3.22 4.53a.75.75 0 1 1 1.06-1.06L8 7.19l3.72-3.72Z"
]);
const $77e1bce0ac0f7fe7$export$ff764729d76295c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown16Regular', "16", [
    "M3.15 7.65c.2-.2.5-.2.7 0L8 11.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 0-.7Zm0-4c.2-.2.5-.2.7 0L8 7.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$a7fd08e94ec759f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown20Filled', "20", [
    "M14.72 9.97a.75.75 0 1 1 1.06 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0l-5.25-5.25a.75.75 0 1 1 1.06-1.06L10 14.69l4.72-4.72Zm0-5.5a.75.75 0 1 1 1.06 1.06l-5.25 5.25c-.3.3-.77.3-1.06 0L4.22 5.53a.75.75 0 1 1 1.06-1.06L10 9.19l4.72-4.72Z"
]);
const $77e1bce0ac0f7fe7$export$7d4392ac1163682d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleDown20Regular', "20", [
    "M15.15 9.65a.5.5 0 1 1 .7.7l-5.5 5.5a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L10 14.79l5.15-5.14Zm0-5a.5.5 0 1 1 .7.7l-5.5 5.5a.5.5 0 0 1-.7 0l-5.5-5.5a.5.5 0 1 1 .7-.7L10 9.79l5.15-5.14Z"
]);
const $77e1bce0ac0f7fe7$export$9c9ed1eca4959a6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft16Filled', "16", [
    "M6.97 3.22a.75.75 0 1 1 1.06 1.06L4.31 8l3.72 3.72a.75.75 0 1 1-1.06 1.06L2.72 8.53a.75.75 0 0 1 0-1.06l4.25-4.25Zm4.5 0a.75.75 0 1 1 1.06 1.06L8.81 8l3.72 3.72a.75.75 0 1 1-1.06 1.06L7.22 8.53a.75.75 0 0 1 0-1.06l4.25-4.25Z"
]);
const $77e1bce0ac0f7fe7$export$e8fd97f848a43b69 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft16Regular', "16", [
    "M7.65 3.15a.5.5 0 0 1 .7.7L4.21 8l4.14 4.15a.5.5 0 1 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5Zm4 0a.5.5 0 0 1 .7.7L8.21 8l4.14 4.15a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5Z"
]);
const $77e1bce0ac0f7fe7$export$fcd375a494703178 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft20Filled', "20", [
    "M8.97 4.22a.75.75 0 1 1 1.06 1.06L5.31 10l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06l5.25-5.25Zm5.5 0a.75.75 0 1 1 1.06 1.06L10.81 10l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06l5.25-5.25Z"
]);
const $77e1bce0ac0f7fe7$export$9a922493494456e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleLeft20Regular', "20", [
    "M9.65 4.15a.5.5 0 1 1 .7.7L5.21 10l5.14 5.15a.5.5 0 1 1-.7.7l-5.5-5.5a.5.5 0 0 1 0-.7l5.5-5.5Zm5 0a.5.5 0 1 1 .7.7L10.21 10l5.14 5.15a.5.5 0 1 1-.7.7l-5.5-5.5a.5.5 0 0 1 0-.7l5.5-5.5Z"
]);
const $77e1bce0ac0f7fe7$export$abf125fb9a9bf8de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight16Filled', "16", [
    "M3.47 3.22c.3-.3.77-.3 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L7.19 8 3.47 4.28a.75.75 0 0 1 0-1.06Zm4.5 0c.3-.3.77-.3 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.69 8 7.97 4.28a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$8dbabd4110ba48b2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight16Regular', "16", [
    "M3.65 3.15c.2-.2.5-.2.7 0l4.5 4.5a.5.5 0 0 1 0 .7l-4.5 4.5a.5.5 0 0 1-.7-.7L7.79 8 3.65 3.85a.5.5 0 0 1 0-.7Zm4 0c.2-.2.5-.2.7 0l4.5 4.5a.5.5 0 0 1 .14.45.5.5 0 0 1-.14.25l-4.5 4.5a.5.5 0 0 1-.7-.7L11.79 8 7.65 3.85a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$6b251f47ce55b0f7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight20Filled', "20", [
    "M4.47 4.22c.3-.3.77-.3 1.06 0l5.25 5.25c.3.3.3.77 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L9.19 10 4.47 5.28a.75.75 0 0 1 0-1.06Zm5.5 0c.3-.3.77-.3 1.06 0l5.25 5.25c.3.3.3.77 0 1.06l-5.25 5.25a.75.75 0 0 1-1.06-1.06L14.69 10 9.97 5.28a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$af346d6b32bc19f1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleRight20Regular', "20", [
    "M4.65 4.15c.2-.2.5-.2.7 0l5.5 5.5a.5.5 0 0 1 0 .7l-5.5 5.5a.5.5 0 1 1-.7-.7L9.79 10 4.65 4.85a.5.5 0 0 1 0-.7Zm5 0c.2-.2.5-.2.7 0l5.5 5.5a.5.5 0 0 1 0 .7l-5.5 5.5a.5.5 0 1 1-.7-.7L14.79 10 9.65 4.85a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$500d38468ba4ecf4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp16Filled', "16", [
    "M8 7c.2 0 .39.08.53.22l4.25 4.25a.75.75 0 0 1-1.06 1.06L8 8.81l-3.72 3.72a.75.75 0 1 1-1.06-1.06l4.25-4.25A.75.75 0 0 1 8 7Zm0-4.5c.2 0 .39.08.53.22l4.25 4.25a.75.75 0 0 1-1.06 1.06L8 4.31 4.28 8.03a.75.75 0 1 1-1.06-1.06l4.25-4.25A.75.75 0 0 1 8 2.5Z"
]);
const $77e1bce0ac0f7fe7$export$d59d2a13e91c7dc9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp16Regular', "16", [
    "M7.72 7.08a.5.5 0 0 1 .63.07l4.5 4.5a.5.5 0 0 1-.08.77.5.5 0 0 1-.62-.07L8 8.21l-4.15 4.14a.5.5 0 0 1-.7-.7l4.5-4.5a.5.5 0 0 1 .07-.07Zm0-4a.5.5 0 0 1 .63.07l4.5 4.5a.5.5 0 0 1-.08.77.5.5 0 0 1-.62-.07L8 4.21 3.85 8.35a.5.5 0 0 1-.7-.7l4.5-4.5a.5.5 0 0 1 .07-.07Z"
]);
const $77e1bce0ac0f7fe7$export$9f2809b57388f3ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp20Filled', "20", [
    "M9.47 9.22c.3-.3.77-.3 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06L10 10.81l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25Zm0-5.5c.3-.3.77-.3 1.06 0l5.25 5.25a.75.75 0 0 1-1.06 1.06L10 5.31l-4.72 4.72a.75.75 0 0 1-1.06-1.06l5.25-5.25Z"
]);
const $77e1bce0ac0f7fe7$export$a621f83a0f4938c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDoubleUp20Regular', "20", [
    "M10 9a.5.5 0 0 1 .35.15l5.5 5.5a.5.5 0 0 1-.7.7L10 10.21l-5.15 5.14a.5.5 0 1 1-.7-.7l5.5-5.5A.5.5 0 0 1 10 9Zm0-5a.5.5 0 0 1 .35.15l5.5 5.5a.5.5 0 0 1-.7.7L10 5.21l-5.15 5.14a.5.5 0 1 1-.7-.7l5.5-5.5A.5.5 0 0 1 10 4Z"
]);
const $77e1bce0ac0f7fe7$export$8ede359537058d1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown12Filled', "12", [
    "M2.22 4.47c.3-.3.77-.3 1.06 0L6 7.19l2.72-2.72a.75.75 0 0 1 1.06 1.06L6.53 8.78c-.3.3-.77.3-1.06 0L2.22 5.53a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$31cf9241c3bcfc42 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown12Regular', "12", [
    "M2.15 4.65c.2-.2.5-.2.7 0L6 7.79l3.15-3.14a.5.5 0 1 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$92a412ced084861c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown16Filled', "16", [
    "M3.2 5.74a.75.75 0 0 1 1.06-.04L8 9.23l3.74-3.53a.75.75 0 1 1 1.02 1.1l-4.25 4a.75.75 0 0 1-1.02 0l-4.25-4a.75.75 0 0 1-.04-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$4c6c51570726ab4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown16Regular', "16", [
    "M3.15 5.65c.2-.2.5-.2.7 0L8 9.79l4.15-4.14a.5.5 0 0 1 .7.7l-4.5 4.5a.5.5 0 0 1-.7 0l-4.5-4.5a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$c09e9bddba195db4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown20Filled', "20", [
    "M15.8 7.73c.28.3.27.78-.03 1.06l-5.25 5a.75.75 0 0 1-1.04 0l-5.25-5a.75.75 0 0 1 1.04-1.08L10 12.2l4.73-4.5a.75.75 0 0 1 1.06.02Z"
]);
const $77e1bce0ac0f7fe7$export$c582cc3ceb1d3030 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown20Regular', "20", [
    "M15.85 7.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 0 1-.78 0L4.15 8.35a.5.5 0 1 1 .7-.7L10 12.8l5.15-5.16c.2-.2.5-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$6b6bd648af0cd5d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown24Filled', "24", [
    "M4.3 8.3a1 1 0 0 1 1.4 0l6.3 6.29 6.3-6.3a1 1 0 1 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-7-7a1 1 0 0 1 0-1.42Z"
]);
const $77e1bce0ac0f7fe7$export$ecee63a4f5c6a76d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown24Regular', "24", [
    "M4.22 8.47c.3-.3.77-.3 1.06 0L12 15.19l6.72-6.72a.75.75 0 1 1 1.06 1.06l-7.25 7.25c-.3.3-.77.3-1.06 0L4.22 9.53a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$1b543d00c743dec3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown28Filled', "28", [
    "M4.3 9.3a1 1 0 0 1 1.4 0l8.3 8.29 8.3-8.3a1 1 0 1 1 1.4 1.42l-9 9a1 1 0 0 1-1.4 0l-9-9a1 1 0 0 1 0-1.42Z"
]);
const $77e1bce0ac0f7fe7$export$45f8839e91670ccd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown28Regular', "28", [
    "M4.22 9.47c.3-.3.77-.3 1.06 0L14 18.19l8.72-8.72a.75.75 0 1 1 1.06 1.06l-9.25 9.25c-.3.3-.77.3-1.06 0l-9.25-9.25a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$527b558e877769af = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown32Filled', "32", [
    "M5.37 11.12a1.25 1.25 0 0 1 1.76 0L16 19.98l8.87-8.86a1.25 1.25 0 0 1 1.76 1.76l-9.75 9.75c-.48.5-1.28.5-1.76 0l-9.75-9.75a1.25 1.25 0 0 1 0-1.76Z"
]);
const $77e1bce0ac0f7fe7$export$52bdca8f98cd0815 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown32Regular', "32", [
    "M5.3 11.3a1 1 0 0 1 1.4 0l9.3 9.29 9.3-9.3a1 1 0 0 1 1.4 1.42l-10 10a1 1 0 0 1-1.4 0l-10-10a1 1 0 0 1 0-1.42Z"
]);
const $77e1bce0ac0f7fe7$export$f57a8964e6697c6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown48Filled', "48", [
    "M8.44 15.94a1.5 1.5 0 0 1 2.12 0L24 29.38l13.44-13.44a1.5 1.5 0 0 1 2.12 2.12l-14.5 14.5a1.5 1.5 0 0 1-2.12 0l-14.5-14.5a1.5 1.5 0 0 1 0-2.12Z"
]);
const $77e1bce0ac0f7fe7$export$784ee78bee2794d9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDown48Regular', "48", [
    "M8.37 16.12a1.25 1.25 0 0 0 0 1.76l14.75 14.75c.48.5 1.28.5 1.76 0l14.75-14.75a1.25 1.25 0 0 0-1.76-1.76L24 29.98 10.13 16.12a1.25 1.25 0 0 0-1.76 0Z"
]);
const $77e1bce0ac0f7fe7$export$c5fec23d3a03b482 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp16Filled', "16", [
    "M11.78 3.53 8.53 6.78c-.3.3-.77.3-1.06 0L4.22 3.53a.75.75 0 0 1 1.06-1.06L8 5.19l2.72-2.72a.75.75 0 1 1 1.06 1.06ZM8.53 9.22a.75.75 0 0 0-1.06 0l-3.25 3.25a.75.75 0 1 0 1.06 1.06L8 10.81l2.72 2.72a.75.75 0 1 0 1.06-1.06L8.53 9.22Z"
]);
const $77e1bce0ac0f7fe7$export$749942d6a9da2234 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp16Regular', "16", [
    "m11.85 3.35-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 1 1 .7-.7L8 5.79l3.15-3.14a.5.5 0 0 1 .7.7Zm0 9.3-3.5-3.5a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 .7.7L8 10.21l3.15 3.14a.5.5 0 0 0 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$2586da9e98756b7a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp20Filled', "20", [
    "M6.28 2.97a.75.75 0 0 0-1.06 1.06l4.25 4.25c.3.3.77.3 1.06 0l4.25-4.25a.75.75 0 0 0-1.06-1.06L10 6.69 6.28 2.97Zm8.5 13-4.25-4.25a.75.75 0 0 0-1.06 0l-4.25 4.25a.75.75 0 1 0 1.06 1.06L10 13.31l3.72 3.72a.75.75 0 1 0 1.06-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$60aea861cac8a53e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp20Regular', "20", [
    "M5.85 3.15a.5.5 0 1 0-.7.7l4.5 4.5c.2.2.5.2.7 0l4.5-4.5a.5.5 0 0 0-.7-.7L10 7.29 5.85 3.15Zm9 13-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 .7.7L10 12.71l4.15 4.14a.5.5 0 0 0 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$2dd3ef3d33ea37f6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp24Filled', "24", [
    "M6.7 2.8a1 1 0 0 0-1.4 1.4l6 6a1 1 0 0 0 1.4 0l6-6a1 1 0 0 0-1.4-1.4L12 8.08l-5.3-5.3Zm0 18.4a1 1 0 0 1-1.4-1.4l6-6a1 1 0 0 1 1.4 0l6 6a1 1 0 0 1-1.4 1.4L12 15.92l-5.3 5.3Z"
]);
const $77e1bce0ac0f7fe7$export$bb1d80d6c6dbd119 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronDownUp24Regular', "24", [
    "M6.28 2.97a.75.75 0 0 0-1.06 1.06l6.25 6.25c.3.3.77.3 1.06 0l6.25-6.25a.75.75 0 0 0-1.06-1.06L12 8.69 6.28 2.97Zm0 18.06a.75.75 0 0 1-1.06-1.06l6.25-6.25c.3-.3.77-.3 1.06 0l6.25 6.25a.75.75 0 1 1-1.06 1.06L12 15.31l-5.72 5.72Z"
]);
const $77e1bce0ac0f7fe7$export$e5e9255d4584e527 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft12Filled', "12", [
    "M7.53 2.22c.3.3.3.77 0 1.06L4.81 6l2.72 2.72a.75.75 0 0 1-1.06 1.06L3.22 6.53a.75.75 0 0 1 0-1.06l3.25-3.25c.3-.3.77-.3 1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$d227ddf35cadc99c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft12Regular', "12", [
    "M7.35 2.15c.2.2.2.5 0 .7L4.21 6l3.14 3.15a.5.5 0 1 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5c.2-.2.5-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$63ad940419973b85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft16Filled', "16", [
    "M10.26 3.2c.3.28.32.76.04 1.06L6.77 8l3.53 3.74a.75.75 0 1 1-1.1 1.02l-4-4.25a.75.75 0 0 1 0-1.02l4-4.25a.75.75 0 0 1 1.06-.04Z"
]);
const $77e1bce0ac0f7fe7$export$be85cf8cb46d6189 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft16Regular', "16", [
    "M10.35 3.15c.2.2.2.5 0 .7L6.21 8l4.14 4.15a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$7ebf1e34ba329263 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft20Filled', "20", [
    "M12.27 15.8a.75.75 0 0 1-1.06-.03l-5-5.25a.75.75 0 0 1 0-1.04l5-5.25a.75.75 0 1 1 1.08 1.04L7.8 10l4.5 4.73c.29.3.28.78-.02 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$9446244bdce3b644 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft20Regular', "20", [
    "M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7Z"
]);
const $77e1bce0ac0f7fe7$export$ecbc9bcc844d8cd7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft24Filled', "24", [
    "M15.7 4.3a1 1 0 0 1 0 1.4L9.42 12l6.3 6.3a1 1 0 0 1-1.42 1.4l-7-7a1 1 0 0 1 0-1.4l7-7a1 1 0 0 1 1.42 0Z"
]);
const $77e1bce0ac0f7fe7$export$1e7ef057c950ea64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft24Regular', "24", [
    "M15.53 4.22c.3.3.3.77 0 1.06L8.81 12l6.72 6.72a.75.75 0 1 1-1.06 1.06l-7.25-7.25a.75.75 0 0 1 0-1.06l7.25-7.25c.3-.3.77-.3 1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$4327048b5a99e322 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft28Filled', "28", [
    "M18.46 23.2a1 1 0 0 1-1.42 0L8.3 14.47a1 1 0 0 1 0-1.42l8.75-8.75a1 1 0 1 1 1.42 1.42l-8.05 8.04 8.05 8.04a1 1 0 0 1 0 1.42Z"
]);
const $77e1bce0ac0f7fe7$export$bbf8eba905ce46c7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft28Regular', "28", [
    "M18.03 22.78c-.3.3-.77.3-1.06 0l-8.75-8.75a.75.75 0 0 1 0-1.06l8.75-8.75a.75.75 0 1 1 1.06 1.06L9.81 13.5l8.22 8.22c.3.3.3.77 0 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$db024ea3edd86f12 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft32Filled', "32", [
    "M20.88 5.37c.5.48.5 1.28 0 1.76L12.02 16l8.86 8.87a1.25 1.25 0 0 1-1.76 1.76l-9.75-9.75a1.25 1.25 0 0 1 0-1.76l9.75-9.75a1.25 1.25 0 0 1 1.76 0Z"
]);
const $77e1bce0ac0f7fe7$export$a574d9218f744319 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft32Regular', "32", [
    "M20.7 5.3a1 1 0 0 1 0 1.4L11.42 16l9.3 9.3a1 1 0 0 1-1.42 1.4l-10-10a1 1 0 0 1 0-1.4l10-10a1 1 0 0 1 1.42 0Z"
]);
const $77e1bce0ac0f7fe7$export$5e6f503203d79ca = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft48Filled', "48", [
    "M32.06 8.19a1.5 1.5 0 0 1 0 2.12L18.62 23.75l13.44 13.44a1.5 1.5 0 0 1-2.12 2.12l-14.5-14.5a1.5 1.5 0 0 1 0-2.12l14.5-14.5a1.5 1.5 0 0 1 2.12 0Z"
]);
const $77e1bce0ac0f7fe7$export$8d123056d8c9e13d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronLeft48Regular', "48", [
    "M31.88 8.37c.5.48.5 1.28 0 1.76L18.02 24l13.86 13.87a1.25 1.25 0 0 1-1.76 1.76L15.37 24.88a1.25 1.25 0 0 1 0-1.76L30.12 8.37a1.25 1.25 0 0 1 1.76 0Z"
]);
const $77e1bce0ac0f7fe7$export$5a89398dca6fb05f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight12Filled', "12", [
    "M4.47 2.22c-.3.3-.3.77 0 1.06L7.19 6 4.47 8.72a.75.75 0 0 0 1.06 1.06l3.25-3.25c.3-.3.3-.77 0-1.06L5.53 2.22a.75.75 0 0 0-1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$33afbe898eda2576 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight12Regular', "12", [
    "M4.65 2.15a.5.5 0 0 0 0 .7L7.79 6 4.65 9.15a.5.5 0 1 0 .7.7l3.5-3.5a.5.5 0 0 0 0-.7l-3.5-3.5a.5.5 0 0 0-.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$8d7a50ae66cb8fce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight16Filled', "16", [
    "M5.74 3.2a.75.75 0 0 0-.04 1.06L9.23 8 5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04Z"
]);
const $77e1bce0ac0f7fe7$export$b85c2ddf81cdbdc6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight16Regular', "16", [
    "M5.65 3.15a.5.5 0 0 0 0 .7L9.79 8l-4.14 4.15a.5.5 0 0 0 .7.7l4.5-4.5a.5.5 0 0 0 0-.7l-4.5-4.5a.5.5 0 0 0-.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$8676d73c4ff1ee29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight20Filled', "20", [
    "M7.73 4.2a.75.75 0 0 1 1.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 1 1-1.08-1.04L12.2 10l-4.5-4.73a.75.75 0 0 1 .02-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$e3f0d4752148cea7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight20Regular', "20", [
    "M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 0 1-.7-.7L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$2e16027e8fd2aad9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight24Filled', "24", [
    "M8.3 4.3a1 1 0 0 0 0 1.4l6.29 6.3-6.3 6.3a1 1 0 1 0 1.42 1.4l7-7a1 1 0 0 0 0-1.4l-7-7a1 1 0 0 0-1.42 0Z"
]);
const $77e1bce0ac0f7fe7$export$1478f2ef8eb23ce3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight24Regular', "24", [
    "M8.47 4.22c-.3.3-.3.77 0 1.06L15.19 12l-6.72 6.72a.75.75 0 1 0 1.06 1.06l7.25-7.25c.3-.3.3-.77 0-1.06L9.53 4.22a.75.75 0 0 0-1.06 0Z"
]);
const $77e1bce0ac0f7fe7$export$26d7fba6e4399c77 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight28Filled', "28", [
    "M9.54 4.3a1 1 0 0 1 1.42 0l8.75 8.74a1 1 0 0 1 0 1.42l-8.75 8.75a1 1 0 0 1-1.42-1.42l8.05-8.04-8.05-8.04a1 1 0 0 1 0-1.42Z"
]);
const $77e1bce0ac0f7fe7$export$9a984518e841eda5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight28Regular', "28", [
    "M9.97 4.22c.3-.3.77-.3 1.06 0l8.75 8.75a.75.75 0 0 1 0 1.06l-8.75 8.75a.75.75 0 1 1-1.06-1.06l8.22-8.22-8.22-8.22a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$7e82dc392daa4f71 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight32Filled', "32", [
    "M11.12 26.63a1.25 1.25 0 0 1 0-1.76L19.98 16l-8.86-8.87a1.25 1.25 0 0 1 1.76-1.76l9.75 9.75c.5.48.5 1.28 0 1.76l-9.75 9.75c-.48.5-1.28.5-1.76 0Z"
]);
const $77e1bce0ac0f7fe7$export$713536791546a81f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight32Regular', "32", [
    "M11.3 26.7a1 1 0 0 1 0-1.4l9.29-9.3-9.3-9.3a1 1 0 0 1 1.42-1.4l10 10a1 1 0 0 1 0 1.4l-10 10a1 1 0 0 1-1.42 0Z"
]);
const $77e1bce0ac0f7fe7$export$d83ad5de52b5cdcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight48Filled', "48", [
    "M15.94 39.31a1.5 1.5 0 0 1 0-2.12l13.44-13.44-13.44-13.44a1.5 1.5 0 0 1 2.12-2.12l14.5 14.5a1.5 1.5 0 0 1 0 2.12l-14.5 14.5a1.5 1.5 0 0 1-2.12 0Z"
]);
const $77e1bce0ac0f7fe7$export$1d703fde24f47fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronRight48Regular', "48", [
    "M16.12 39.63a1.25 1.25 0 0 1 0-1.76L29.98 24 16.12 10.13a1.25 1.25 0 0 1 1.76-1.76l14.75 14.75c.5.48.5 1.28 0 1.76L17.88 39.63c-.48.5-1.28.5-1.76 0Z"
]);
const $77e1bce0ac0f7fe7$export$fe506f26b56b6a5f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp12Filled', "12", [
    "M2.22 7.53c.3.3.77.3 1.06 0L6 4.81l2.72 2.72a.75.75 0 0 0 1.06-1.06L6.53 3.22a.75.75 0 0 0-1.06 0L2.22 6.47c-.3.3-.3.77 0 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$64d34f52799e5dfe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp12Regular', "12", [
    "M2.15 7.35c.2.2.5.2.7 0L6 4.21l3.15 3.14a.5.5 0 1 0 .7-.7l-3.5-3.5a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 0 .7Z"
]);
const $77e1bce0ac0f7fe7$export$1c0fdd1f968e84c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp16Filled', "16", [
    "M3.2 10.26c.28.3.76.32 1.06.04L8 6.77l3.74 3.53a.75.75 0 1 0 1.02-1.1l-4.25-4a.75.75 0 0 0-1.02 0l-4.25 4a.75.75 0 0 0-.04 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$5fc3128e974fde90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp16Regular', "16", [
    "M3.15 10.35c.2.2.5.2.7 0L8 6.21l4.15 4.14a.5.5 0 0 0 .7-.7l-4.5-4.5a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 0 0 0 .7Z"
]);
const $77e1bce0ac0f7fe7$export$c26ed8d9fef79842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp20Filled', "20", [
    "M4.2 12.27a.75.75 0 0 1 .03-1.06l5.25-5a.75.75 0 0 1 1.04 0l5.25 5a.75.75 0 0 1-1.04 1.08L10 7.8l-4.73 4.5a.75.75 0 0 1-1.06-.02Z"
]);
const $77e1bce0ac0f7fe7$export$2fb99f3cc19a5e86 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp20Regular', "20", [
    "M4.15 12.35a.5.5 0 0 1 0-.7L9.6 6.16a.55.55 0 0 1 .78 0l5.46 5.49a.5.5 0 0 1-.7.7L10 7.2l-5.15 5.16a.5.5 0 0 1-.7 0Z"
]);
const $77e1bce0ac0f7fe7$export$ce67089fac78efb8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp24Filled', "24", [
    "M4.3 15.7a1 1 0 0 0 1.4 0L12 9.42l6.3 6.3a1 1 0 0 0 1.4-1.42l-7-7a1 1 0 0 0-1.4 0l-7 7a1 1 0 0 0 0 1.42Z"
]);
const $77e1bce0ac0f7fe7$export$58e2d56f9f7c11b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp24Regular', "24", [
    "M4.22 15.53c.3.3.77.3 1.06 0L12 8.81l6.72 6.72a.75.75 0 1 0 1.06-1.06l-7.25-7.25a.75.75 0 0 0-1.06 0l-7.25 7.25c-.3.3-.3.77 0 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$5eaef7a39ba111db = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp28Filled', "28", [
    "M23.7 18.7a1 1 0 0 1-1.4 0L14 10.42l-8.3 8.3a1 1 0 0 1-1.4-1.42l9-9a1 1 0 0 1 1.4 0l9 9a1 1 0 0 1 0 1.42Z"
]);
const $77e1bce0ac0f7fe7$export$53a8c7c429681c0e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp28Regular', "28", [
    "M23.78 18.53c-.3.3-.77.3-1.06 0L14 9.81l-8.72 8.72a.75.75 0 0 1-1.06-1.06l9.25-9.25c.3-.3.77-.3 1.06 0l9.25 9.25c.3.3.3.77 0 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$2352532f0f4a79c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp32Filled', "32", [
    "M5.37 20.88c.48.5 1.28.5 1.76 0L16 12.02l8.87 8.86a1.25 1.25 0 0 0 1.76-1.76l-9.75-9.75a1.25 1.25 0 0 0-1.76 0l-9.75 9.75a1.25 1.25 0 0 0 0 1.76Z"
]);
const $77e1bce0ac0f7fe7$export$226acf21722b5c33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp32Regular', "32", [
    "M5.3 20.7a1 1 0 0 0 1.4 0l9.3-9.29 9.3 9.3a1 1 0 0 0 1.4-1.42l-10-10a1 1 0 0 0-1.4 0l-10 10a1 1 0 0 0 0 1.42Z"
]);
const $77e1bce0ac0f7fe7$export$2c6f68d6ad29f7e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp48Filled', "48", [
    "M39.56 32.06a1.5 1.5 0 0 1-2.12 0L24 18.62 10.56 32.06a1.5 1.5 0 0 1-2.12-2.12l14.5-14.5a1.5 1.5 0 0 1 2.12 0l14.5 14.5a1.5 1.5 0 0 1 0 2.12Z"
]);
const $77e1bce0ac0f7fe7$export$64ea2740598048e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUp48Regular', "48", [
    "M39.63 31.88c-.48.5-1.28.5-1.76 0L24 18.02 10.13 31.88a1.25 1.25 0 0 1-1.76-1.76l14.75-14.75a1.25 1.25 0 0 1 1.76 0l14.75 14.75c.5.48.5 1.28 0 1.76Z"
]);
const $77e1bce0ac0f7fe7$export$8b9d6c193f7c2d3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown16Filled', "16", [
    "M4.22 6.53c.3.3.77.3 1.06 0L8 3.81l2.72 2.72a.75.75 0 1 0 1.06-1.06L8.53 2.22a.75.75 0 0 0-1.06 0L4.22 5.47c-.3.3-.3.77 0 1.06Zm0 2.94c.3-.3.77-.3 1.06 0L8 12.19l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25c-.3.3-.77.3-1.06 0l-3.25-3.25a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$ead95d908001de23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown16Regular', "16", [
    "M4.15 6.35c.2.2.5.2.7 0L8 3.21l3.15 3.14a.5.5 0 0 0 .7-.7l-3.5-3.5a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 0 .7Zm0 3.3c.2-.2.5-.2.7 0L8 12.79l3.15-3.14a.5.5 0 0 1 .7.7l-3.5 3.5a.5.5 0 0 1-.7 0l-3.5-3.5a.5.5 0 0 1 0-.7Z"
]);
const $77e1bce0ac0f7fe7$export$ec22b2ea339ab996 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown20Filled', "20", [
    "M10.53 2.72a.75.75 0 0 0-1.06 0L5.22 6.97a.75.75 0 0 0 1.06 1.06L10 4.31l3.72 3.72a.75.75 0 1 0 1.06-1.06l-4.25-4.25Zm4.25 10.31-4.25 4.25c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 1 1 1.06-1.06L10 15.69l3.72-3.72a.75.75 0 1 1 1.06 1.06Z"
]);
const $77e1bce0ac0f7fe7$export$d281dccdcfc5c0c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown20Regular', "20", [
    "M14.91 7.22a.5.5 0 0 1-.76.63L10 3.71 5.85 7.85l-.07.06a.5.5 0 0 1-.63-.76l4.5-4.5.07-.06a.5.5 0 0 1 .63.06l4.5 4.5.06.07ZM5.1 12.78a.5.5 0 0 1 .76-.63L10 16.29l4.15-4.14.07-.06a.5.5 0 0 1 .63.76l-4.5 4.5-.07.06a.5.5 0 0 1-.63-.06l-4.5-4.5-.06-.07Z"
]);
const $77e1bce0ac0f7fe7$export$860f58bb500e8f03 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown24Filled', "24", [
    "M18.79 8.39a1 1 0 0 1-1.5 1.32L12 4.4l-5.3 5.3-.09.08a1 1 0 0 1-1.32-1.5l6-6 .1-.08a1 1 0 0 1 1.32.08l6 6 .08.1ZM5.21 15.6a1 1 0 0 1 1.5-1.32L12 19.6l5.3-5.3.09-.08a1 1 0 0 1 1.32 1.5l-6 6-.1.08a1 1 0 0 1-1.32-.08l-6-6-.08-.1Z"
]);
const $77e1bce0ac0f7fe7$export$437b95df136d559d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ChevronUpDown24Regular', "24", [
    "M12.54 2.23a.75.75 0 0 0-1.08 0L5.2 8.73a.75.75 0 1 0 1.08 1.04L12 3.83l5.7 5.94a.75.75 0 1 0 1.1-1.04l-6.26-6.5Zm0 19.54a.75.75 0 0 1-1.08 0l-6.25-6.5a.75.75 0 1 1 1.08-1.04L12 20.17l5.7-5.94a.75.75 0 1 1 1.1 1.04l-6.26 6.5Z"
]);
const $77e1bce0ac0f7fe7$export$211458b4cdc92b6f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door16Filled', "16", [
    "M3 3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3Zm3 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$d48067cbe854849a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door16Regular', "16", [
    "M6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 1a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H5ZM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3Z"
]);
const $77e1bce0ac0f7fe7$export$d0e717b4c71b9018 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door20Filled', "20", [
    "M4.5 4c0-.83.67-1.5 1.5-1.5h8.15A1.5 1.5 0 0 1 15.5 4v12c0 .83-.67 1.5-1.5 1.5H6A1.5 1.5 0 0 1 4.5 16V4ZM7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$c48ee1d778453a48 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door20Regular', "20", [
    "M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 13h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z"
]);
const $77e1bce0ac0f7fe7$export$32a7d15130657b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door24Filled', "24", [
    "M17.75 2C18.99 2 20 3 20 4.25v15.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h11.5ZM8.5 10.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
]);
const $77e1bce0ac0f7fe7$export$18776d5fa6c0ffa3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door24Regular', "24", [
    "M17.75 2C18.99 2 20 3 20 4.25v15.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h11.5ZM6.25 3.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h11.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75H6.25Zm2.25 6.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
]);
const $77e1bce0ac0f7fe7$export$6cea0a8f04ceea41 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door28Filled', "28", [
    "M8 2a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H8Zm1.5 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
]);
const $77e1bce0ac0f7fe7$export$b507381b7c36661 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door28Regular', "28", [
    "M9.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5Zm3-1.5c-.83 0-1.5.67-1.5 1.5v18c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5V5c0-.83-.67-1.5-1.5-1.5H8Z"
]);
const $77e1bce0ac0f7fe7$export$454a0f737b08a903 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door32Filled', "32", [
    "M23.75 2C25.55 2 27 3.46 27 5.25v21.5c0 1.8-1.46 3.25-3.25 3.25H8.25A3.25 3.25 0 0 1 5 26.92V5.25C5 3.45 6.46 2 8.25 2h15.5ZM10.5 13.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$18903c90a172b23 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Door32Regular', "32", [
    "M23.75 2C25.55 2 27 3.46 27 5.25v21.5c0 1.8-1.46 3.25-3.25 3.25H8.25A3.25 3.25 0 0 1 5 26.92V5.25C5 3.45 6.46 2 8.25 2h15.5ZM8.25 4C7.56 4 7 4.56 7 5.25v21.63c.07.63.6 1.12 1.25 1.12h15.5c.69 0 1.25-.56 1.25-1.25V5.25C25 4.56 24.44 4 23.75 4H8.25Zm2.25 9.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$d1427adcd76ee3bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft16Filled', "16", [
    "M3 2.75C3 1.78 3.78 1 4.75 1h6.5c.97 0 1.75.78 1.75 1.75v3.46A5.5 5.5 0 0 0 7.26 15H4.75C3.78 15 3 14.22 3 13.25V2.75ZM6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 2.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$1896c47f41559656 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft16Regular', "16", [
    "M4.75 1C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h2.5a5.5 5.5 0 0 1-.65-1H4.75a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.27c.34.03.68.1 1 .19V2.75C13 1.78 12.22 1 11.25 1h-6.5ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$8609b3b6b9845bef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft20Filled', "20", [
    "M6 2.5c-.83 0-1.5.67-1.5 1.5v12c0 .83.67 1.5 1.5 1.5h3.89a5.5 5.5 0 0 1 5.61-8.4V4c0-.83-.67-1.5-1.5-1.5H6ZM8 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm11 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$589a136ff5d86b82 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft20Regular', "20", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02c.34.03.68.1 1 .19V4a2 2 0 0 0-2-2H6Zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm11 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$9c46e7c3496e218e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft24Filled', "24", [
    "M6.25 2.75c-.83 0-1.5.67-1.5 1.5v15.5c0 .83.67 1.5 1.5 1.5h5.94a6.5 6.5 0 0 1 7.06-10.01V4.25c0-.83-.67-1.5-1.5-1.5H6.25Zm2.25 10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9 9.75a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm3.5-5.5a.5.5 0 0 1-.5.5h-4.8l1.65 1.65a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5a.5.5 0 0 1 .7.7L15.71 17h4.79c.28 0 .5.22.5.5Z"
]);
const $77e1bce0ac0f7fe7$export$2d0a71c7ad8a30ed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowLeft24Regular', "24", [
    "M6.25 2C5.01 2 4 3 4 4.25v15.5C4 20.99 5 22 6.25 22h6.56a6.52 6.52 0 0 1-1.08-1.5H6.25a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75h11.5c.41 0 .75.34.75.75v6.83c.52.08 1.03.22 1.5.42V4.25C20 3.01 19 2 17.75 2H6.25ZM17.5 23a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm3.5-5.5a.5.5 0 0 1-.5.5h-4.8l1.65 1.65a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5a.5.5 0 0 1 .7.7L15.71 17h4.79c.28 0 .5.22.5.5ZM8.5 13.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
]);
const $77e1bce0ac0f7fe7$export$4482837f936a1d5d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight16Filled', "16", [
    "M3 2.75C3 1.78 3.78 1 4.75 1h6.5c.97 0 1.75.78 1.75 1.75v3.46A5.5 5.5 0 0 0 7.26 15H4.75C3.78 15 3 14.22 3 13.25V2.75ZM6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5.5 7a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L12.29 12H9.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$bfc69ec658fdba85 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight16Regular', "16", [
    "M4.75 1C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h2.5a5.5 5.5 0 0 1-.65-1H4.75a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.27c.34.03.68.1 1 .19V2.75C13 1.78 12.22 1 11.25 1h-6.5ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L12.29 12H9.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$3e72b722863e8f01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight20Filled', "20", [
    "M6 2.5c-.83 0-1.5.67-1.5 1.5v12c0 .83.67 1.5 1.5 1.5h3.89a5.5 5.5 0 0 1 5.61-8.4V4c0-.83-.67-1.5-1.5-1.5H6ZM8 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$38c9709c1dbb662a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight20Regular', "20", [
    "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02c.34.03.68.1 1 .19V4a2 2 0 0 0-2-2H6Zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"
]);
const $77e1bce0ac0f7fe7$export$e25398e573c08b33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight28Filled', "28", [
    "M8 2a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h7.4A7.5 7.5 0 0 1 23 13.43V5a3 3 0 0 0-3-3H8Zm1.5 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM16.5 20a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 20H16.5Z"
]);
const $77e1bce0ac0f7fe7$export$edb3730dbd54f653 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight28Regular', "28", [
    "M5 5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8.43c-.48-.17-.98-.3-1.5-.36V5c0-.83-.67-1.5-1.5-1.5H8c-.83 0-1.5.67-1.5 1.5v18c0 .83.67 1.5 1.5 1.5h6.15c.35.55.77 1.06 1.25 1.5H8a3 3 0 0 1-3-3V5Zm4.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM27 20.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM16.5 20a.5.5 0 0 0 0 1h6.8l-2.15 2.15a.5.5 0 0 0 .7.7l3-3a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-3-3a.5.5 0 0 0-.7.7L23.29 20H16.5Z"
]);
const $77e1bce0ac0f7fe7$export$3809c7eb0dfda03b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight32Filled', "32", [
    "M23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm.25-14C25.55 2 27 3.46 27 5.25v9.96A9 9 0 0 0 17.28 30H8.25A3.25 3.25 0 0 1 5 26.9V5.26C5 3.45 6.46 2 8.25 2h15.5Zm1.03 16.72a.75.75 0 1 0-1.06 1.06l2.72 2.72h-7.69a.75.75 0 0 0 0 1.5h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4ZM10.5 13.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$ca0bd8e968333c1d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight32Light', "32", [
    "M8.25 2A3.25 3.25 0 0 0 5 5.25v21.5C5 28.55 6.46 30 8.25 30h9.02a9.06 9.06 0 0 1-.9-1H8.26C7.01 29 6 28 6 26.75V5.25C6 4.01 7 3 8.25 3h15.5C24.99 3 26 4 26 5.25v9.6c.34.1.68.22 1 .36V5.25C27 3.45 25.54 2 23.75 2H8.25ZM23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15ZM18 23.25c0 .41.34.75.75.75h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4a.75.75 0 1 0-1.06 1.06l2.72 2.72h-7.69a.75.75 0 0 0-.75.75Zm-8.5-6a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
]);
const $77e1bce0ac0f7fe7$export$f7e187f1e9cce4ad = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorArrowRight32Regular', "32", [
    "M23.5 16a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Zm.25-14C25.55 2 27 3.46 27 5.25v9.96a8.93 8.93 0 0 0-2-.58V5.25C25 4.56 24.44 4 23.75 4H8.25C7.56 4 7 4.56 7 5.25v21.63c.07.63.6 1.12 1.25 1.12h7.46c.43.74.95 1.41 1.57 2H8.25A3.25 3.25 0 0 1 5 26.92V5.25C5 3.45 6.46 2 8.25 2h15.5Zm1.03 16.72a.75.75 0 1 0-1.06 1.06l2.72 2.72h-7.69a.75.75 0 0 0 0 1.5h7.69l-2.72 2.72a.75.75 0 1 0 1.06 1.06l4-4c.3-.3.3-.77 0-1.06l-4-4ZM10.5 13.75a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$2afbe3560921b0ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag20Filled', "20", [
    "M9.3 6.3A1 1 0 1 1 10 8H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7.05a4.98 4.98 0 0 0-8.54-3.59A2 2 0 1 0 9.3 6.3ZM8 14h4a.5.5 0 0 1 0 1H8a.5.5 0 0 1 0-1Z"
]);
const $77e1bce0ac0f7fe7$export$572043c0b0d13925 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag20Regular', "20", [
    "M9.3 6.3A1 1 0 1 1 10 8H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V7.05a4.98 4.98 0 0 0-8.54-3.59A2 2 0 1 0 9.3 6.3ZM11.4 8.4A2 2 0 1 0 8.6 5.6a1 1 0 0 1-1.42-1.42A4 4 0 0 1 14 7V16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h3a2 2 0 0 0 1.41-.59ZM8 14a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H8Z"
]);
const $77e1bce0ac0f7fe7$export$fa17368313b7d79b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag24Filled', "24", [
    "M12 6.5c-.49 0-.92.23-1.2.6a2.25 2.25 0 0 1-3.6-2.7A6 6 0 0 1 18 8v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8.5c0-1.1.9-2 2-2h4a1.5 1.5 0 0 0 0-3Zm-2.25 11a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
]);
const $77e1bce0ac0f7fe7$export$5cff03aea53f6873 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('DoorTag24Regular', "24", [
    "M9.75 17.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM10.8 7.1A1.5 1.5 0 1 1 12 9.5H8a2 2 0 0 0-2 2V20c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8A6 6 0 0 0 7.2 4.4a2.25 2.25 0 1 0 3.6 2.7ZM12 5a3 3 0 0 0-2.4 1.2.75.75 0 0 1-1.2-.9A4.5 4.5 0 0 1 16.5 8v12a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-8.5c0-.28.22-.5.5-.5h4a3 3 0 1 0 0-6Z"
]);
const $77e1bce0ac0f7fe7$export$ea2182f382a21663 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth16Filled', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-6h-.05c.09.18.19.4.28.63.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38-.13.2-.1.43.04.9l.03.1c.06.19.13.4.16.6.04.26.06.58-.1.89-.16.3-.38.51-.63.65-.23.13-.47.17-.66.2l-.07.02c-.36.06-.54.1-.71.28-.14.15-.22.4-.27.77l-.05.46v.08l-.07.53-.03.11a5.98 5.98 0 0 0 7.4 1.03 3.16 3.16 0 0 1-.26-.28c-.23-.3-.54-.81-.43-1.41.05-.29.2-.53.35-.72a4.98 4.98 0 0 1 .62-.61l.32-.31.12-.15.04-.05c.05-.17-.01-.3-.09-.35-.05-.04-.2-.1-.44.05l-.26.16a.99.99 0 0 1-.27.12.53.53 0 0 1-.63-.36.64.64 0 0 1-.03-.2 1.15 1.15 0 0 1 .01-.19c.03-.21.07-.52-.06-.98-.1-.37-.23-.66-.38-.94a9.15 9.15 0 0 1-.2-.42c-.08-.2-.18-.46-.16-.73.02-.32.18-.58.44-.78.32-.24.72-.78 1.06-1.33.17-.27.31-.51.41-.7l.02-.03A5.97 5.97 0 0 0 8 2Z"
]);
const $77e1bce0ac0f7fe7$export$5fa9ebe3f44de04b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth16Regular', "16", [
    "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-6h-.05c.09.18.19.4.28.63.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38-.13.2-.1.43.04.9l.03.1c.06.19.13.4.16.6.04.26.06.58-.1.89-.16.3-.38.51-.63.65-.23.13-.47.17-.66.2l-.07.02c-.36.06-.54.1-.71.28-.14.15-.22.4-.27.77l-.05.46v.08l-.07.53-.03.11a5.98 5.98 0 0 0 7.4 1.03 3.16 3.16 0 0 1-.26-.28c-.23-.3-.54-.81-.43-1.41.05-.29.2-.53.35-.72a4.98 4.98 0 0 1 .62-.61l.32-.31.12-.15.04-.05c.05-.17-.01-.3-.09-.35-.05-.04-.2-.1-.44.05l-.26.16a.99.99 0 0 1-.27.12.53.53 0 0 1-.63-.36.64.64 0 0 1-.03-.2 1.15 1.15 0 0 1 .01-.19c.03-.21.07-.52-.06-.98-.1-.37-.23-.66-.38-.94a9.15 9.15 0 0 1-.2-.42c-.08-.2-.18-.46-.16-.73.02-.32.18-.58.44-.78.32-.24.72-.78 1.06-1.33.17-.27.31-.51.41-.7l.02-.03A5.97 5.97 0 0 0 8 2Zm4.03 1.56-.38.65a6.37 6.37 0 0 1-1.35 1.64c0 .03 0 .1.08.27l.13.27c.16.32.38.76.5 1.24.07.25.1.48.11.68.44-.15.88-.08 1.21.18.42.32.6.88.43 1.43-.07.25-.25.45-.39.6l-.38.37a22.63 22.63 0 0 0-.5.5.66.66 0 0 0-.15.25c-.03.17.05.38.24.61a2.22 2.22 0 0 0 .3.32 5.99 5.99 0 0 0 .15-9ZM2 8c0 1.08.29 2.1.79 2.97l.01-.15c.06-.4.17-.93.54-1.32.41-.45.92-.53 1.24-.58l.1-.02c.17-.03.27-.06.36-.1.06-.04.14-.1.21-.24.01-.02.03-.09 0-.24a28.64 28.64 0 0 1-.16-.58c-.13-.43-.33-1.12.08-1.75.36-.55.94-.69 1.32-.78.04 0 .08-.02.11-.03.4-.1.63-.2.8-.54.2-.46.12-1.07-.1-1.65a5.38 5.38 0 0 0-.44-.88A6 6 0 0 0 2 8Z"
]);
const $77e1bce0ac0f7fe7$export$f210fbb2142194e9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth20Filled', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-7h-.25c.11.23.25.5.37.83.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12c.07.21.14.46.18.69.05.28.06.63-.11.97-.18.34-.41.57-.69.72-.26.14-.53.2-.75.24l-.08.01c-.41.07-.65.12-.87.35-.18.2-.28.51-.34.94l-.05.54v.1c-.02.2-.04.41-.09.6v.02a6.98 6.98 0 0 0 8.86 1.25 3.56 3.56 0 0 1-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a5.68 5.68 0 0 1 .7-.7c.15-.14.28-.25.39-.37a.9.9 0 0 0 .2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19c-.09.04-.2.1-.34.12a.6.6 0 0 1-.54-.18.73.73 0 0 1-.18-.37 2.58 2.58 0 0 1-.03-.28v-.07l-.02-.23c-.02-.22-.06-.5-.15-.83-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .03-.55c.07-.19.2-.33.35-.44a18.6 18.6 0 0 0 1.74-1.66c.3-.31.58-.6.77-.82h.01A6.97 6.97 0 0 0 10 3Z"
]);
const $77e1bce0ac0f7fe7$export$c2c57f3395cae90a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth20Regular', "20", [
    "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-7h-.25c.11.23.25.5.37.83.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12c.07.21.14.46.18.69.05.28.06.63-.11.97-.18.34-.41.57-.69.72-.26.14-.53.2-.75.24l-.08.01c-.41.07-.65.12-.87.35-.18.2-.28.51-.34.94l-.05.54v.1c-.02.2-.04.41-.09.6v.02a6.98 6.98 0 0 0 8.86 1.25 3.56 3.56 0 0 1-.27-.31c-.27-.34-.61-.91-.5-1.57.06-.31.23-.58.4-.8a5.68 5.68 0 0 1 .7-.7c.15-.14.28-.25.39-.37a.9.9 0 0 0 .2-.26c.07-.23-.02-.4-.13-.5-.1-.06-.3-.13-.6.07l-.33.19c-.09.04-.2.1-.34.12a.6.6 0 0 1-.54-.18.74.74 0 0 1-.18-.37 2.57 2.57 0 0 1-.03-.28v-.07l-.02-.23c-.02-.22-.06-.5-.15-.83-.12-.49-.44-.89-.76-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 18.6 18.6 0 0 0 1.74-1.65c.3-.31.58-.6.77-.82h.01A6.97 6.97 0 0 0 10 3Zm4.64 1.76a42.1 42.1 0 0 1-2.71 2.66c.03.07.1.18.24.36l.12.16c.32.4.78.97.96 1.68.1.4.15.73.17.98v.01c.6-.33 1.21-.3 1.66.06.46.35.66.97.47 1.57-.08.27-.27.5-.43.66l-.44.43-.11.1c-.2.17-.36.33-.48.48a.83.83 0 0 0-.19.34c-.04.23.07.5.29.78.1.12.2.23.3.3 0 .01 0 .02.02.03a6.99 6.99 0 0 0 .13-10.6ZM8.8 3.36l-.13-.23a7 7 0 0 0-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02c.21-.03.34-.07.45-.13.1-.05.2-.13.28-.3.03-.06.05-.15.02-.34a4.4 4.4 0 0 0-.15-.54l-.05-.15c-.15-.5-.37-1.26.09-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6.33 6.33 0 0 0-.38-.83Z"
]);
const $77e1bce0ac0f7fe7$export$511b3700ca9299b9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth24Filled', "24", [
    "M10.95 2.05A10 10 0 1 1 4.1 18.13a10 10 0 0 1 6.83-16.08h.02ZM12 3.5h-.16c.12.25.26.53.37.85.35.92.67 2.28.1 3.49-.52 1.11-1.42 1.4-2.09 1.57l-.08.02c-.66.17-.9.24-1.1.52-.16.25-.14.58.07 1.25l.04.14c.09.26.18.57.23.87.07.36.09.82-.15 1.27-.23.45-.54.75-.9.95-.34.18-.7.25-.96.3l-.09.02c-.51.09-.76.13-1 .39-.19.2-.3.55-.38 1.07l-.06.65v.12c-.03.24-.05.52-.1.76a8.48 8.48 0 0 0 10.58 1.58l-.31-.35c-.34-.43-.79-1.16-.63-2.03.07-.42.3-.77.51-1.04.22-.27.49-.52.72-.74l.16-.14c.18-.17.33-.3.46-.44.17-.18.21-.26.21-.27.07-.22-.01-.38-.1-.45a.3.3 0 0 0-.2-.06.75.75 0 0 0-.4.14.91.91 0 0 1-.83.08c-.27-.1-.41-.31-.49-.43a2.75 2.75 0 0 1-.27-.77l-.12-.55-.04-.21-.13-.54-.02-.04a6.23 6.23 0 0 0-.3-.42l-.1-.14c-.16-.21-.36-.47-.52-.71-.2-.3-.42-.7-.49-1.1a1.39 1.39 0 0 1 .54-1.38 13 13 0 0 0 1.83-1.97c.29-.36.54-.7.73-.95A8.46 8.46 0 0 0 12 3.5Z"
]);
const $77e1bce0ac0f7fe7$export$462f7342665633d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth24Regular', "24", [
    "M10.95 2.05A10 10 0 1 1 4.1 18.13a10 10 0 0 1 6.83-16.08h.02ZM12 3.5h-.16c.12.25.26.53.37.85.35.92.67 2.28.1 3.49-.52 1.11-1.42 1.4-2.09 1.57l-.08.02c-.66.17-.9.24-1.1.52-.16.25-.14.58.07 1.25l.04.14c.09.26.18.57.23.87.07.36.09.82-.15 1.27-.23.45-.54.75-.9.95-.34.18-.7.25-.96.3l-.09.02c-.51.09-.76.13-1 .39-.19.2-.3.55-.38 1.07l-.06.65v.12c-.03.24-.05.52-.1.76a8.48 8.48 0 0 0 10.58 1.58l-.31-.35c-.34-.43-.79-1.16-.63-2.03.07-.42.3-.77.51-1.04.22-.27.49-.52.72-.74l.16-.14c.18-.17.33-.3.46-.44.17-.18.21-.26.21-.27.07-.22-.01-.38-.1-.45a.3.3 0 0 0-.2-.06.75.75 0 0 0-.4.14.91.91 0 0 1-.83.08c-.27-.1-.41-.31-.49-.43a2.75 2.75 0 0 1-.27-.77l-.12-.55-.04-.21a4.1 4.1 0 0 0-.13-.54l-.02-.04a6.23 6.23 0 0 0-.3-.42l-.1-.14c-.16-.21-.36-.47-.52-.71-.2-.3-.42-.7-.49-1.1a1.39 1.39 0 0 1 .54-1.38 13 13 0 0 0 1.83-1.97c.29-.36.54-.7.73-.95A8.46 8.46 0 0 0 12 3.5Zm5.73 2.22-.76.98c-.6.75-1.4 1.68-2.05 2.19.03.1.1.26.26.5a10.73 10.73 0 0 0 .56.77c.18.23.42.54.52.84.1.23.15.52.2.76l.05.25.08.37c.6-.17 1.2-.07 1.67.3.6.46.86 1.28.62 2.07-.11.36-.36.66-.56.87l-.56.53-.13.12c-.23.2-.42.4-.57.57a.9.9 0 0 0-.2.36c-.04.22.06.51.32.84a3.14 3.14 0 0 0 .38.4 8.48 8.48 0 0 0 .17-12.72ZM3.5 12c0 1.4.34 2.72.94 3.88.08-.56.26-1.25.74-1.77a2.91 2.91 0 0 1 1.93-.86c.25-.04.4-.08.5-.14a.7.7 0 0 0 .3-.32c0-.03.03-.1 0-.33-.04-.18-.1-.38-.18-.63l-.06-.2c-.18-.6-.48-1.6.12-2.5.53-.8 1.36-1 1.9-1.13l.16-.04c.56-.15.88-.28 1.1-.76.3-.63.18-1.48-.14-2.32a7.61 7.61 0 0 0-.58-1.2A8.5 8.5 0 0 0 3.5 12Z"
]);
const $77e1bce0ac0f7fe7$export$ef38267e4a99b18 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth32Filled', "32", [
    "M8.22 4.36a14 14 0 1 1 15.56 23.28A14 14 0 0 1 8.22 4.36ZM8.3 20.6c-.8 1.07-.55 3.11-.39 4.24a11.92 11.92 0 0 0 14.49 1.28 3.75 3.75 0 0 1-1.9-2.42c-.36-1.79.83-2.91 1.73-3.74.9-.83 1.11-1.14 1-1.52a5 5 0 0 0-.73.15 2.13 2.13 0 0 1-2.08-.17 1.68 1.68 0 0 1-.42-1.59 4 4 0 0 0-1.07-2.93c-.67-.95-1.68-2.39-.3-3.64 1.44-1.3 2.7-2.77 3.76-4.4A11.92 11.92 0 0 0 16 4h-.37l.05.18.06.1c.83 1.53 1.74 3.17 1.19 5.45-.44 1.82-2.14 2.4-3.4 2.83l-.04.01c-.43.11-.85.3-1.23.53-.5.67-.36 1.34-.1 2.34a3.64 3.64 0 0 1-.16 3.11 2.62 2.62 0 0 1-2 1.13 2 2 0 0 0-1.7.92Z"
]);
const $77e1bce0ac0f7fe7$export$13663aa77a43dd78 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth32Regular', "32", [
    "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28Zm-2.51 2.27.49.9c.76 1.36 1.43 2.53 1 4.1-.17.68-1 1-2.14 1.4-.82.2-1.56.62-2.14 1.23a4.31 4.31 0 0 0-.43 4c.19.74.3 1.2.1 1.5-.2.3-.15.18-.68.25a3.94 3.94 0 0 0-3 1.7c-.58.84-.9 1.82-.93 2.84a11.85 11.85 0 0 1 .91-13.73 12 12 0 0 1 6.82-4.19ZM7.91 24.84c-.16-1.13-.41-3.17.39-4.24a2 2 0 0 1 1.7-.92 2.62 2.62 0 0 0 2-1.13 3.64 3.64 0 0 0 .16-3.11c-.26-1-.4-1.67.1-2.34.38-.24.8-.42 1.23-.53 1.27-.43 3-1 3.44-2.84.56-2.33-.4-4-1.25-5.55L15.63 4H16c2.26 0 4.48.65 6.39 1.86a21.74 21.74 0 0 1-3.76 4.4c-1.38 1.25-.37 2.69.3 3.64A4 4 0 0 1 20 16.83a1.68 1.68 0 0 0 .42 1.59 2.13 2.13 0 0 0 2.08.17 5 5 0 0 1 .73-.15c.11.38-.1.69-1 1.52-.9.83-2.09 1.95-1.73 3.74a3.75 3.75 0 0 0 1.9 2.42 11.92 11.92 0 0 1-14.49-1.28Zm16.2 0-.39-.25c-.7-.42-1.13-.72-1.24-1.27-.11-.55.25-1.05 1.14-1.88.89-.83 2.13-2 1.47-3.77-.61-1.61-2.29-1.2-3.05-1a6.18 6.18 0 0 0-1.47-3.9c-.25-.3-.45-.64-.6-1a23.31 23.31 0 0 0 4-4.67 11.95 11.95 0 0 1 .12 17.75l.02-.01Z"
]);
const $77e1bce0ac0f7fe7$export$ddbb268968792fd0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth48Filled', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.61 10.61 0 0 1 2.73 7.35c-.02.85.62 1.31.95 1.47.35.16 1.04.33 1.66-.12.93-.67 1.9-.36 2.14-.06.07.09.17.26.02.65-.17.46-.66 1.18-1.85 2.07a5.43 5.43 0 0 0-2.13 2.84c-.3 1.07-.1 2.07.3 2.91a7.16 7.16 0 0 0 2.08 2.45 17.44 17.44 0 0 1-21.75-2.2v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a4.71 4.71 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22-.07-.49-.18-.97-.29-1.41l-.04-.18c-.09-.38-.17-.73-.23-1.07-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9 2.33-.66 3.98-1.65 5-2.95a5.66 5.66 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4-.28-.5-.57-1-.87-1.46ZM24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40Z"
]);
const $77e1bce0ac0f7fe7$export$b7577c48a3d424fe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Earth48Regular', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.61 10.61 0 0 1 2.73 7.35c-.02.85.62 1.31.95 1.47.35.16 1.04.33 1.66-.12.93-.67 1.9-.36 2.14-.06.07.09.17.26.02.65-.17.46-.66 1.18-1.85 2.07a5.43 5.43 0 0 0-2.13 2.84c-.3 1.07-.1 2.07.3 2.91a7.16 7.16 0 0 0 2.08 2.45 17.44 17.44 0 0 1-21.75-2.2v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a4.71 4.71 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22-.07-.49-.18-.97-.29-1.41l-.04-.18c-.09-.38-.17-.73-.23-1.07-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9 2.33-.66 3.98-1.65 5-2.95a5.66 5.66 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4-.28-.5-.57-1-.87-1.46Zm-2.77.34c.5.71 1 1.5 1.44 2.31.58 1.08 1 2.14 1.11 3.1.11.94-.06 1.74-.6 2.45-.58.73-1.68 1.5-3.72 2.08-1.47.42-2.5 1.15-3 2.27a5.14 5.14 0 0 0-.2 3.07c.07.4.17.8.26 1.19l.04.16c.1.44.2.84.25 1.23.12.78.08 1.31-.13 1.72-.1.21-.26.35-.88.46l-.64.09-.5.06c-.44.06-.96.15-1.47.34a4.35 4.35 0 0 0-2.68 2.76c-.3.83-.5 1.85-.55 3.13A17.5 17.5 0 0 1 20.44 6.87ZM35.6 37.12a5.28 5.28 0 0 1-1.9-1.95c-.21-.43-.26-.8-.16-1.17.1-.37.4-.9 1.22-1.5 1.39-1.04 2.3-2.12 2.7-3.2a3.07 3.07 0 0 0-.44-3.1c-.97-1.2-2.68-1.52-4.22-1.04a13.12 13.12 0 0 0-3.24-7.59 39.12 39.12 0 0 0 5.85-6.85A17.46 17.46 0 0 1 41.5 24c0 5.22-2.29 9.9-5.91 13.12ZM24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40Z"
]);
const $77e1bce0ac0f7fe7$export$24db641b7d13735d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf16Filled', "16", [
    "M1 8a7 7 0 0 1 13.97-.67l-.61-.15a9.52 9.52 0 0 0-4.53.09 10.38 10.38 0 0 0-.36-.75c-.1-.2-.19-.46-.17-.73.02-.32.18-.58.44-.78.32-.24.72-.78 1.06-1.33.17-.27.31-.51.41-.7l.02-.03A5.97 5.97 0 0 0 8 2h-.05c.09.18.19.4.28.63.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38-.13.2-.1.43.04.9l.03.1c.06.19.13.4.16.6.05.26.06.58-.1.89-.16.3-.37.51-.62.65-.24.13-.48.17-.67.2l-.07.02c-.36.06-.54.1-.71.28-.14.15-.22.4-.27.77l-.05.46v.08l-.07.53-.03.11a6 6 0 0 0 2.22 1.48c-.2.28-.37.57-.53.87A7 7 0 0 1 1 8Zm14.93.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02a6.14 6.14 0 0 1-.3-.08l-.09-.03c-.23-.06-.51-.14-.84-.21A8.52 8.52 0 0 0 11.19 8c-1.2.15-2.12.56-2.75 1.15a2.85 2.85 0 0 0-.9 2.62 13.17 13.17 0 0 1 3.77-2.23.5.5 0 1 1 .38.92c-.8.32-1.54.7-2.2 1.1a8.47 8.47 0 0 0-3.44 3.72.5.5 0 1 0 .9.44c.38-.76.84-1.45 1.44-2.06a3.92 3.92 0 0 0 .59.8 3.07 3.07 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a7.5 7.5 0 0 1 1-2.03V9.6c.1-.14.18-.27.23-.38a.5.5 0 0 0-.02-.48Z"
]);
const $77e1bce0ac0f7fe7$export$8cb56bb03f8c54e1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf16Regular', "16", [
    "M1 8a7 7 0 0 1 13.97-.67 13.56 13.56 0 0 0-1.04-.24 5.99 5.99 0 0 0-1.9-3.53l-.38.65a6.37 6.37 0 0 1-1.35 1.64c0 .03 0 .1.08.27l.13.27c.1.18.2.4.3.66-.34.05-.67.12-.98.22a10.38 10.38 0 0 0-.36-.75c-.1-.2-.19-.46-.17-.73.02-.32.18-.58.44-.78.32-.24.72-.78 1.06-1.33.17-.27.31-.51.41-.7l.02-.03A5.97 5.97 0 0 0 8 2h-.05c.09.18.19.4.28.63.24.65.46 1.6.07 2.43-.36.77-.98.97-1.45 1.1h-.07c-.45.13-.64.17-.77.38-.13.2-.1.43.04.9l.03.1c.06.19.13.4.16.6.05.26.06.58-.1.89-.16.3-.37.51-.62.65-.24.13-.48.17-.67.2l-.07.02c-.36.06-.54.1-.71.28-.14.15-.22.4-.27.77l-.05.46v.08l-.07.53-.03.11a6 6 0 0 0 2.22 1.48c-.2.28-.37.57-.53.87A7 7 0 0 1 1 8Zm1 0c0 1.08.29 2.1.79 2.97 0-.05 0-.1.02-.15.05-.4.16-.93.53-1.32a2.02 2.02 0 0 1 1.34-.6c.17-.03.28-.06.36-.1.06-.04.14-.1.21-.24.01-.02.03-.09 0-.24a28.64 28.64 0 0 1-.16-.58c-.13-.43-.33-1.12.08-1.75.36-.55.94-.69 1.32-.78.04 0 .08-.02.11-.03.4-.1.63-.2.8-.54.2-.46.12-1.07-.1-1.65a5.38 5.38 0 0 0-.44-.88A6 6 0 0 0 2 8Zm13.93.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02a6.14 6.14 0 0 1-.3-.08l-.09-.03c-.23-.06-.51-.14-.84-.21A8.52 8.52 0 0 0 11.19 8c-1.2.15-2.12.56-2.75 1.15a2.85 2.85 0 0 0-.9 2.62 13.17 13.17 0 0 1 3.77-2.23.5.5 0 1 1 .38.92c-.8.32-1.54.7-2.2 1.1a8.47 8.47 0 0 0-3.44 3.72.5.5 0 1 0 .9.44c.38-.76.84-1.45 1.44-2.06a3.92 3.92 0 0 0 .59.8 3.07 3.07 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a7.5 7.5 0 0 1 1-2.03V9.6c.1-.14.18-.27.23-.38a.5.5 0 0 0-.02-.48Z"
]);
const $77e1bce0ac0f7fe7$export$de52142d361175b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf20Filled', "20", [
    "M2 10a8 8 0 1 1 16 .34l-.64-.16a9.52 9.52 0 0 0-3.3-.17c-.6.08-1.16.21-1.67.4a5 5 0 0 0-.1-.54c-.13-.49-.45-.89-.77-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 18.6 18.6 0 0 0 1.74-1.65l.78-.82A6.97 6.97 0 0 0 9.74 3c.12.23.26.5.38.83.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12c.07.21.14.46.18.69.05.28.06.63-.11.97-.18.34-.41.57-.69.72-.26.14-.53.2-.75.24l-.08.01c-.41.07-.65.12-.87.35-.18.2-.28.51-.34.94l-.05.54v.1c-.02.2-.04.41-.09.6v.02a7 7 0 0 0 3.87 2.17c-.18.3-.35.6-.51.91A8 8 0 0 1 2 10Zm16.93 1.74a.5.5 0 0 0-.43-.24h-.03l-.1-.02a6.16 6.16 0 0 1-.3-.08l-.09-.03c-.23-.06-.51-.14-.84-.21a8.52 8.52 0 0 0-2.95-.16c-1.2.15-2.12.56-2.75 1.15a2.85 2.85 0 0 0-.9 2.62 13.17 13.17 0 0 1 3.77-2.23.5.5 0 1 1 .38.92c-.8.32-1.54.7-2.2 1.1a8.47 8.47 0 0 0-3.44 3.72.5.5 0 0 0 .9.44c.38-.76.84-1.45 1.44-2.06a3.71 3.71 0 0 0 .59.8 3.07 3.07 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a7.5 7.5 0 0 1 1-2.03v-.02c.1-.14.18-.27.23-.38a.5.5 0 0 0-.02-.48Z"
]);
const $77e1bce0ac0f7fe7$export$7238fc4e44fd89df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf20Regular', "20", [
    "M2 10a8 8 0 1 1 16 .34 13.76 13.76 0 0 0-1-.23V10c0-2.1-.91-3.97-2.36-5.25l-.07.07-.79.84c-.6.62-1.35 1.37-1.85 1.75.03.07.1.18.24.36l.12.16a4.67 4.67 0 0 1 1.07 2.2c-.34.06-.66.16-.97.28a5 5 0 0 0-.1-.55c-.13-.49-.45-.89-.77-1.3l-.14-.18c-.16-.2-.37-.48-.44-.77a.9.9 0 0 1 .38-1 18.6 18.6 0 0 0 1.74-1.65l.78-.82A6.97 6.97 0 0 0 9.74 3c.12.23.26.5.38.83.28.74.52 1.82.08 2.76-.4.86-1.1 1.08-1.63 1.22l-.1.02c-.5.13-.75.2-.93.46-.17.26-.12.58.04 1.12l.04.12c.07.21.14.46.18.69.05.28.06.63-.11.97-.18.34-.41.57-.69.72-.26.14-.53.2-.75.24l-.08.01c-.41.07-.65.12-.87.35-.18.2-.28.51-.34.94l-.05.54v.1c-.02.2-.04.41-.09.6v.02a7 7 0 0 0 3.87 2.17c-.18.3-.35.6-.51.91A8 8 0 0 1 2 10Zm6.8-6.65a5.8 5.8 0 0 0-.13-.22 7 7 0 0 0-4.72 10.39l.02-.2c.06-.46.2-1.06.6-1.49.46-.5 1.02-.59 1.4-.65l.1-.02c.21-.03.34-.07.45-.13.1-.05.2-.13.28-.3.03-.06.05-.15.02-.34a4.4 4.4 0 0 0-.15-.54l-.04-.15c-.16-.5-.38-1.26.08-1.96.4-.6 1.04-.76 1.48-.87l.13-.03c.47-.12.77-.24.98-.68.26-.56.14-1.3-.12-1.98a6.33 6.33 0 0 0-.38-.83Zm10.13 8.39a.5.5 0 0 0-.43-.24h-.03l-.1-.02a6.16 6.16 0 0 1-.3-.08l-.09-.03c-.23-.06-.51-.14-.84-.21a8.52 8.52 0 0 0-2.95-.16c-1.2.15-2.12.56-2.75 1.15a2.85 2.85 0 0 0-.9 2.62 13.17 13.17 0 0 1 3.77-2.23.5.5 0 1 1 .38.92c-.8.32-1.54.7-2.2 1.1a8.47 8.47 0 0 0-3.44 3.72.5.5 0 0 0 .9.44c.38-.76.84-1.45 1.44-2.06a3.71 3.71 0 0 0 .59.8 3.07 3.07 0 0 0 3.9.58c.45-.28.77-.67 1-1.08.37-.63.58-1.38.74-1.94l.1-.37a7.5 7.5 0 0 1 1-2.03v-.02c.1-.14.18-.27.23-.38a.5.5 0 0 0-.02-.48Z"
]);
const $77e1bce0ac0f7fe7$export$f8d6c4867da6a16d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf24Filled', "24", [
    "M10.95 2.05A10 10 0 0 1 22 11.75c-1.17-.24-2.85-.4-5.23-.08-.64.09-1.22.26-1.76.5a25.3 25.3 0 0 0-.15-.65l-.02-.04a6.23 6.23 0 0 0-.3-.42l-.1-.14c-.16-.21-.36-.47-.52-.71-.2-.3-.42-.7-.49-1.1a1.39 1.39 0 0 1 .54-1.38 13 13 0 0 0 1.83-1.97c.29-.36.54-.7.73-.95a8.46 8.46 0 0 0-4.69-1.3c.12.24.25.52.37.84.35.92.67 2.28.1 3.49-.52 1.11-1.42 1.4-2.09 1.57l-.08.02c-.66.17-.9.24-1.1.52-.16.25-.14.58.07 1.25l.04.14a7 7 0 0 1 .23.87c.07.36.09.82-.15 1.27-.23.45-.54.75-.9.95-.34.18-.7.25-.96.3l-.09.02c-.51.09-.76.13-1 .39-.19.2-.3.55-.38 1.07l-.06.65-.01.12c-.02.24-.04.52-.1.76a8.48 8.48 0 0 0 5.63 2.74c-.17.5-.29 1-.34 1.47A9.96 9.96 0 0 1 2 12a10 10 0 0 1 8.93-9.94l.02-.01ZM12 22.2c.05-.97.49-2.15 1.23-3.26a8.9 8.9 0 0 1 5.38-3.97.5.5 0 0 0-.24-.96 9.9 9.9 0 0 0-5.73 4c-.1-.3-.15-.64-.15-1.02 0-.92.46-1.91 1.2-2.7a5.33 5.33 0 0 1 3.2-1.64 13.5 13.5 0 0 1 5.56.23.75.75 0 0 1 .21 1.35.92.92 0 0 0-.26.34c-.1.2-.2.48-.32.82l-.26.93-.05.21c-.12.41-.24.85-.39 1.29-.29.86-.7 1.78-1.4 2.48a4.02 4.02 0 0 1-3 1.2 3.82 3.82 0 0 1-2.84-1.16c-.4.74-.62 1.43-.65 1.95a.75.75 0 1 1-1.5-.1Z"
]);
const $77e1bce0ac0f7fe7$export$5592a7ee6f6318a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf24Regular', "24", [
    "M10.95 2.05h-.02A10 10 0 0 0 4.1 18.15a9.99 9.99 0 0 0 6.92 3.81c.05-.47.17-.97.34-1.47a8.48 8.48 0 0 1-5.63-2.74c.06-.24.08-.52.1-.76l.01-.12.06-.65c.07-.52.2-.87.38-1.07.24-.26.49-.3 1-.4l.1-.01c.26-.05.61-.12.95-.3.36-.2.67-.5.9-.95.24-.45.22-.9.15-1.27a7 7 0 0 0-.27-1.01c-.2-.67-.23-1-.06-1.25.18-.28.43-.35 1.09-.52l.08-.02c.67-.17 1.57-.46 2.1-1.57.56-1.2.24-2.57-.1-3.49-.13-.32-.26-.6-.38-.85H12c1.67 0 3.22.48 4.53 1.3-.19.26-.44.6-.73.96a13 13 0 0 1-1.82 1.96 1.39 1.39 0 0 0-.55 1.38c.07.42.3.8.5 1.1.15.25.35.5.5.72l.12.14a6.23 6.23 0 0 1 .29.42l.02.04a4.1 4.1 0 0 1 .15.65c.45-.2.93-.35 1.44-.45-.04-.23-.1-.5-.19-.72a3.69 3.69 0 0 0-.65-1.01c-.15-.21-.3-.4-.43-.6-.16-.24-.23-.4-.26-.5a14.6 14.6 0 0 0 2.05-2.2c.3-.36.56-.7.76-.97a8.48 8.48 0 0 1 2.76 5.82c.58.04 1.08.12 1.5.2a10 10 0 0 0-11.04-9.69ZM4.44 15.88a8.5 8.5 0 0 1 5.8-12.2 7.41 7.41 0 0 1 .57 1.2c.31.84.44 1.7.15 2.32-.23.48-.55.61-1.11.76L9.69 8c-.54.13-1.37.33-1.9 1.12-.6.91-.3 1.91-.12 2.52l.06.19c.08.25.14.45.18.63.03.22 0 .3 0 .33a.7.7 0 0 1-.3.32c-.1.06-.25.1-.5.14l-.13.02c-.46.08-1.2.2-1.8.84a3.27 3.27 0 0 0-.74 1.77ZM12 22.2c.06-.96.5-2.14 1.23-3.25a8.9 8.9 0 0 1 5.38-3.97.5.5 0 0 0-.24-.97 9.9 9.9 0 0 0-5.73 4c-.1-.3-.15-.63-.15-1.01 0-.92.47-1.91 1.2-2.7a5.33 5.33 0 0 1 3.2-1.64 13.5 13.5 0 0 1 5.56.23.75.75 0 0 1 .22 1.35.91.91 0 0 0-.26.34c-.11.2-.22.48-.32.82-.1.29-.17.6-.26.93l-.06.21c-.11.41-.24.85-.38 1.29-.3.86-.7 1.78-1.4 2.48a4.02 4.02 0 0 1-3 1.2 3.82 3.82 0 0 1-2.85-1.16c-.4.74-.61 1.43-.65 1.95a.75.75 0 0 1-1.5-.1Z"
]);
const $77e1bce0ac0f7fe7$export$44ca0b03e6c06526 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf32Filled', "32", [
    "M8.22 4.36A14 14 0 0 1 30 16v.07c-1.77-.4-3.88-.7-6-.53-1.33.1-2.7.39-4 .95a4 4 0 0 0-1.07-2.59c-.67-.95-1.68-2.39-.3-3.64 1.44-1.3 2.7-2.77 3.76-4.4A11.92 11.92 0 0 0 16 4h-.37l.05.18.06.1c.83 1.53 1.74 3.17 1.19 5.45-.44 1.82-2.14 2.4-3.4 2.83l-.04.01c-.43.11-.85.3-1.23.53-.5.67-.36 1.34-.1 2.34a3.64 3.64 0 0 1-.16 3.11 2.62 2.62 0 0 1-2 1.13 2 2 0 0 0-1.7.92c-.8 1.07-.55 3.11-.39 4.24a11.92 11.92 0 0 0 7.03 3.1l.04.01c-.23.7-.38 1.36-.45 1.97A14.02 14.02 0 0 1 3.07 10.64a14 14 0 0 1 5.15-6.28ZM18.38 27.3c.77.8 2.18 1.69 4.62 1.69 4.3 0 5.64-5.53 6.25-8.04.1-.42.18-.75.25-.96.15-.45.54-.8.98-1.04.7-.4.7-1.05-.06-1.25-3.63-.95-9.03-1.48-12.42 1.9-1.4 1.41-1.38 3.25-1.1 4.6l.18-.25A14.6 14.6 0 0 1 24 18.79a.75.75 0 0 1 .5 1.42 13.1 13.1 0 0 0-6.2 4.64 11.4 11.4 0 0 0-2.3 5.42.75.75 0 0 0 1.5.04c.07-.91.36-1.95.88-3Z"
]);
const $77e1bce0ac0f7fe7$export$7a141de9aa08b040 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf32Regular', "32", [
    "M16 2a14 14 0 0 0-1.47 27.92c.07-.61.22-1.28.45-1.97h-.04a11.92 11.92 0 0 1-7.03-3.11c-.16-1.13-.41-3.17.39-4.24a2 2 0 0 1 1.7-.92 2.62 2.62 0 0 0 2-1.13 3.64 3.64 0 0 0 .16-3.11c-.26-1-.4-1.67.1-2.34.38-.24.8-.42 1.23-.53l.03-.01c1.27-.43 2.97-1 3.41-2.83.55-2.28-.36-3.92-1.2-5.44l-.05-.11-.05-.18H16c2.26 0 4.48.65 6.39 1.86a21.74 21.74 0 0 1-3.76 4.4c-1.38 1.25-.37 2.69.3 3.64A4 4 0 0 1 20 16.49c.65-.28 1.3-.49 1.97-.64a6.18 6.18 0 0 0-1.4-3.08c-.25-.3-.45-.64-.6-1a23.31 23.31 0 0 0 4-4.67 11.95 11.95 0 0 1 4 8.6c.71.1 1.4.22 2.03.37V16A14 14 0 0 0 16 2Zm-2.51 2.27.49.9.03.05c.75 1.34 1.4 2.5.97 4.05-.17.68-1 1-2.14 1.4-.82.2-1.56.62-2.14 1.23a4.31 4.31 0 0 0-.43 4c.19.74.3 1.2.1 1.5-.14.21-.16.21-.35.22l-.33.03a3.94 3.94 0 0 0-3 1.7c-.58.84-.9 1.82-.93 2.84a11.85 11.85 0 0 1 .91-13.73 12 12 0 0 1 6.82-4.19Zm4.89 23.04c.77.8 2.18 1.69 4.62 1.69 4.3 0 5.64-5.53 6.25-8.04.1-.42.18-.75.25-.96.15-.45.54-.8.98-1.04.7-.4.7-1.05-.06-1.25-3.63-.95-9.03-1.48-12.42 1.9-1.4 1.41-1.38 3.25-1.1 4.6l.18-.25A14.6 14.6 0 0 1 24 18.79a.75.75 0 0 1 .5 1.42 13.1 13.1 0 0 0-6.2 4.64 11.4 11.4 0 0 0-2.3 5.42.75.75 0 0 0 1.5.04c.07-.91.36-1.95.88-3Z"
]);
const $77e1bce0ac0f7fe7$export$a3c1e21dce19ceed = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf48Filled', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.65 10.65 0 0 1 2.61 5.47c.35-.2.71-.38 1.07-.55a24.9 24.9 0 0 1 12.63-1.93A20 20 0 1 0 24.17 44c.04-.12.1-.23.15-.35.39-.77.8-1.51 1.2-2.22a17.44 17.44 0 0 1-13.77-4.93v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a4.71 4.71 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22-.07-.49-.18-.97-.29-1.41l-.04-.18c-.09-.38-.17-.73-.23-1.07-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9 2.33-.66 3.98-1.65 5-2.95a5.66 5.66 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4-.28-.5-.57-1-.87-1.46Zm21.75 17.76c-4.14-.66-9.05-.17-12.82 1.6-1.9.88-3.58 2.11-4.7 3.75a8.18 8.18 0 0 0-1.33 5.98 9.9 9.9 0 0 0 1.05 3.26 33.4 33.4 0 0 1 6.7-7.27 27.85 27.85 0 0 1 3.68-2.48h.01v-.01h.01a1 1 0 0 1 .9 1.78 5.67 5.67 0 0 0-.22.12l-.7.41c-.59.37-1.43.95-2.43 1.74a31.45 31.45 0 0 0-6.85 7.66 37.9 37.9 0 0 0-2.14 3.73 1 1 0 1 0 1.78.9c.64-1.27 1.3-2.42 1.99-3.46a10.54 10.54 0 0 0 7.37 1.94 6.54 6.54 0 0 0 3.78-1.63 9.04 9.04 0 0 0 2.44-3.62 11.9 11.9 0 0 0 .51-3.89c.07-2.18.15-4.77 1.91-8.77a1.25 1.25 0 0 0-.94-1.74Z"
]);
const $77e1bce0ac0f7fe7$export$bfd3e8038bf0a3b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('EarthLeaf48Regular', "48", [
    "m23.2 6.52.8-.02c3.45 0 6.67 1 9.38 2.73-2 3.06-4.4 5.46-5.63 6.6-.97.9-.97 2.39-.15 3.31a10.65 10.65 0 0 1 2.61 5.47 17.17 17.17 0 0 1 2.34-1.08 13.13 13.13 0 0 0-3-5.96 39.12 39.12 0 0 0 5.85-6.85A17.47 17.47 0 0 1 41.39 22c.85 0 1.7.05 2.52.13A20 20 0 1 0 24.17 44c.04-.12.1-.23.15-.35.39-.77.8-1.51 1.2-2.22a17.44 17.44 0 0 1-13.77-4.93v-.1c-.25-2.82-.04-4.44.3-5.38.32-.84.74-1.12 1.19-1.28a4.71 4.71 0 0 1 1.31-.26c.28-.03.6-.07.88-.12.89-.15 2.05-.51 2.69-1.8.55-1.1.5-2.25.36-3.22-.07-.49-.18-.97-.29-1.41l-.04-.18c-.09-.38-.17-.73-.23-1.07-.15-.8-.13-1.27.01-1.58.1-.23.38-.6 1.42-.9 2.33-.66 3.98-1.65 5-2.95a5.66 5.66 0 0 0 1.11-4.27c-.16-1.41-.74-2.79-1.38-4-.28-.5-.57-1-.87-1.46Zm-2.77.34c.5.71 1 1.5 1.44 2.31.58 1.08 1 2.14 1.11 3.1.11.94-.06 1.74-.6 2.45-.58.73-1.68 1.5-3.72 2.08-1.47.42-2.5 1.15-3 2.27a5.14 5.14 0 0 0-.2 3.07c.07.4.17.8.26 1.19l.04.16c.1.44.2.84.25 1.23.12.78.08 1.31-.13 1.72-.1.21-.26.35-.88.46l-.64.09-.5.06c-.44.06-.96.15-1.47.34a4.35 4.35 0 0 0-2.68 2.76c-.3.83-.5 1.85-.55 3.13A17.5 17.5 0 0 1 20.44 6.87ZM44.95 24.3c-4.14-.67-9.05-.17-12.82 1.59-1.9.88-3.58 2.11-4.7 3.75a8.18 8.18 0 0 0-1.33 5.98 9.9 9.9 0 0 0 1.05 3.26 33.4 33.4 0 0 1 6.7-7.27 27.83 27.83 0 0 1 3.65-2.47l.03-.01h.01v-.01h.01a1 1 0 0 1 .9 1.78 5.67 5.67 0 0 0-.22.12l-.7.41c-.59.37-1.43.95-2.43 1.74a31.45 31.45 0 0 0-6.85 7.66 37.9 37.9 0 0 0-2.14 3.73 1 1 0 1 0 1.78.9c.64-1.27 1.3-2.42 1.99-3.46a10.54 10.54 0 0 0 7.37 1.94 6.54 6.54 0 0 0 3.78-1.63 9.04 9.04 0 0 0 2.44-3.62 11.9 11.9 0 0 0 .51-3.89c.07-2.18.15-4.77 1.91-8.77a1.25 1.25 0 0 0-.94-1.73Z"
]);
const $77e1bce0ac0f7fe7$export$af6a1d11b5198e00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent20Filled', "20", [
    "M10.72 2.05a.5.5 0 0 0-.44 0l-5 2.5A.5.5 0 0 0 5 5v9.5c0 .18.1.34.24.43l5 3a.5.5 0 0 0 .76-.43v-4.7l4.72-2.35a.5.5 0 0 0 0-.9l-4.1-2.05 4.1-2.05a.5.5 0 0 0 0-.9l-5-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$1243d3250eaa1a92 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent20Regular', "20", [
    "M10.28 2.05a.5.5 0 0 1 .44 0l5 2.5a.5.5 0 0 1 0 .9l-4.1 2.05 4.1 2.05a.5.5 0 0 1 0 .9L11 12.8v4.69a.5.5 0 0 1-.76.43l-5-3A.5.5 0 0 1 5 14.5V5c0-.19.1-.36.28-.45l5-2.5ZM6 5.31v8.9l4 2.4v-3.8a1 1 0 0 1 .55-.9L14.38 10l-4.1-2.05a.5.5 0 0 1 0-.9L14.38 5 10.5 3.06 6 5.3Z"
]);
const $77e1bce0ac0f7fe7$export$c455dc1c19009b1f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent24Filled', "24", [
    "M12.59 2.08a.75.75 0 0 0-.68 0l-6 3a.75.75 0 0 0-.41.67v11.73c0 .26.13.5.35.64l6 3.77a.75.75 0 0 0 1.15-.64v-6.03l5.59-2.8a.75.75 0 0 0 0-1.34l-4.66-2.33 4.66-2.33a.75.75 0 0 0 0-1.34l-6-3Z"
]);
const $77e1bce0ac0f7fe7$export$4162df2c5c5125ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent24Regular', "24", [
    "M11.91 2.08c.22-.1.46-.1.68 0l6 3a.75.75 0 0 1 0 1.34l-4.66 2.33 4.66 2.33a.75.75 0 0 1 0 1.34L13 15.22v6.03a.75.75 0 0 1-1.15.64l-6-3.77a.75.75 0 0 1-.35-.64V5.75c0-.28.16-.54.41-.67l6-3ZM7 6.22v10.85l4.5 2.82v-5.14c0-.28.16-.54.41-.67l4.66-2.33-4.66-2.33a.75.75 0 0 1 0-1.34l4.66-2.33-4.32-2.16L7 6.22Z"
]);
const $77e1bce0ac0f7fe7$export$5a966efd4dd48271 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent32Filled', "32", [
    "M17.45 2.1a1 1 0 0 0-.9 0l-8 4A1 1 0 0 0 8 7v17.5c0 .36.2.7.51.87l8 4.5A1 1 0 0 0 18 29v-9.38l7.45-3.73a1 1 0 0 0 0-1.78L19.24 11l6.2-3.1a1 1 0 0 0 0-1.8l-8-4Z"
]);
const $77e1bce0ac0f7fe7$export$2e26587f6b78e01e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent32Regular', "32", [
    "M16.55 2.1a1 1 0 0 1 .9 0l8 4a1 1 0 0 1 0 1.8L19.24 11l6.2 3.1a1 1 0 0 1 0 1.8L18 19.61V29a1 1 0 0 1-1.49.87l-8-4.5A1 1 0 0 1 8 24.5V7a1 1 0 0 1 .55-.9l8-4ZM10 7.63v16.3l6 3.37V19a1 1 0 0 1 .55-.9l6.21-3.1-6.2-3.1a1 1 0 0 1 0-1.8l6.2-3.1L17 4.12l-7 3.5Z"
]);
const $77e1bce0ac0f7fe7$export$508f1ce63642933 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent48Filled', "48", [
    "M25.17 4.16a1.5 1.5 0 0 0-1.34 0l-12 6c-.5.26-.83.78-.83 1.35v23.45c0 .52.27 1 .7 1.27l12 7.54A1.5 1.5 0 0 0 26 42.5V30.43l11.17-5.58a1.5 1.5 0 0 0 0-2.69l-9.32-4.65 9.32-4.66a1.5 1.5 0 0 0 0-2.69l-12-6Z"
]);
const $77e1bce0ac0f7fe7$export$e6822e43619d1fda = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluent48Regular', "48", [
    "M23.83 4.16a1.5 1.5 0 0 1 1.34 0l12 6a1.5 1.5 0 0 1 0 2.68l-9.32 4.66 9.32 4.66a1.5 1.5 0 0 1 0 2.68L26 30.43V42.5a1.5 1.5 0 0 1-2.3 1.27l-12-7.54a1.5 1.5 0 0 1-.7-1.27V11.5c0-.57.32-1.09.83-1.34l12-6ZM14 12.43v21.7l9 5.66V29.5c0-.57.32-1.08.83-1.34l9.32-4.66-9.32-4.66a1.5 1.5 0 0 1 0-2.68l9.32-4.66-8.65-4.32L14 12.43Z"
]);
const $77e1bce0ac0f7fe7$export$6eb6a67f3771aaef = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid16Filled', "16", [
    "M1 2.5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5v2C6 5.33 5.33 6 4.5 6h-2A1.5 1.5 0 0 1 1 4.5v-2Zm7 7C8 8.67 8.67 8 9.5 8h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 8 13.5v-4Zm-5 1V7h1v3.5c0 .28.22.5.5.5H7v1H4.5A1.5 1.5 0 0 1 3 10.5ZM7 3v1h3.5c.28 0 .5.22.5.5V7h1V4.5c0-.83-.67-1.5-1.5-1.5H7Z"
]);
const $77e1bce0ac0f7fe7$export$b74ad81d6d60e8a7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid16Regular', "16", [
    "M1 2.5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5v2C6 5.33 5.33 6 4.5 6h-2A1.5 1.5 0 0 1 1 4.5v-2ZM2.5 2a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2ZM8 9.5C8 8.67 8.67 8 9.5 8h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 8 13.5v-4ZM9.5 9a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4ZM3 10.5V7h1v3.5c0 .28.22.5.5.5H7v1H4.5A1.5 1.5 0 0 1 3 10.5ZM7 3v1h3.5c.28 0 .5.22.5.5V7h1V4.5c0-.83-.67-1.5-1.5-1.5H7Z"
]);
const $77e1bce0ac0f7fe7$export$fba7ef6bf32c00 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid20Filled', "20", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 5.54V3.5ZM8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 0 0-.5-.5H8V4ZM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 0 1 4 13.5V8h1Zm6.5 2c-.82 0-1.5.67-1.5 1.5v5c0 .83.68 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-5Z"
]);
const $77e1bce0ac0f7fe7$export$1185b1d95d131234 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid20Regular', "20", [
    "M8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 0 0-.5-.5H8V4ZM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 0 1 4 13.5V8h1ZM2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 5.54V3.5ZM3.5 3a.5.5 0 0 0-.5.5v2.04c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-2Zm6.5 8.5c0-.83.68-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5v-5Zm1.5-.5a.5.5 0 0 0-.5.5v5c0 .28.23.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Z"
]);
const $77e1bce0ac0f7fe7$export$1d94df8ec55555ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid24Filled', "24", [
    "M11 5h5.75C17.98 5 19 6 19 7.25V11h-1.5V7.25a.75.75 0 0 0-.75-.75H11V5Zm-4.5 6v5.75c0 .4.34.75.75.75H11V19H7.25C6.01 19 5 17.98 5 16.75V11h1.5ZM2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5C10 8.99 9 10 7.75 10h-3.5C3.01 10 2 9 2 7.75v-3.5Zm10 10c0-1.24 1-2.25 2.25-2.25h5.5c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C13.01 22 12 21 12 19.75v-5.5Z"
]);
const $77e1bce0ac0f7fe7$export$e404823320523011 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Fluid24Regular', "24", [
    "M11 5h5.75C17.98 5 19 6 19 7.25V11h-1.5V7.25a.75.75 0 0 0-.75-.75H11V5Zm-4.5 6v5.75c0 .4.34.75.75.75H11V19H7.25C6.01 19 5 17.98 5 16.75V11h1.5ZM2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5C10 8.99 9 10 7.75 10h-3.5C3.01 10 2 9 2 7.75v-3.5Zm2.25-.75a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 0 0-.75-.75h-3.5ZM12 14.25c0-1.24 1-2.25 2.25-2.25h5.5c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C13.01 22 12 21 12 19.75v-5.5Zm2.25-.75a.75.75 0 0 0-.75.75v5.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 0 0-.75-.75h-5.5Z"
]);
const $77e1bce0ac0f7fe7$export$87ca6e2b3954ba16 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart16Filled', "16", [
    "M10 3H6v1h.5a1.5 1.5 0 0 1 1.41 2H10V3Zm1 10v-2h1.5a1.5 1.5 0 0 0 .4-2.95A1.5 1.5 0 0 0 11.5 6H11V3h1.5A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5H11ZM9 9.5c0-.18.03-.34.09-.5H7.5A1.5 1.5 0 0 1 6 7.5V13h4v-2.09c-.58-.2-1-.76-1-1.41ZM5 7H3.5a1.5 1.5 0 1 1 0-3H5V3H3.5A2.5 2.5 0 0 0 1 5.5v5A2.5 2.5 0 0 0 3.5 13H5V7ZM3.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm4 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm3 2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
]);
const $77e1bce0ac0f7fe7$export$a16ac00f51144127 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart16Regular', "16", [
    "M1 5.5A2.5 2.5 0 0 1 3.5 3h9A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 10.5v-5ZM3.5 4C2.67 4 2 4.67 2 5.5v5c0 .83.67 1.5 1.5 1.5H5V7h1v5h4v-1.09c.16.06.32.09.5.09h.5v1h1.5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5H11v2h-1V4H3.5Zm0 1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM7 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM10.5 9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
]);
const $77e1bce0ac0f7fe7$export$b4488b8abae85842 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart20Filled', "20", [
    "M2 6.5A2.5 2.5 0 0 1 4.5 4H7v2H4.5a1.5 1.5 0 1 0 0 3H7v7H4.5A2.5 2.5 0 0 1 2 13.5v-7ZM8 16V9.5c0 .83.67 1.5 1.5 1.5H11v.5c0 .65.42 1.2 1 1.41V16H8Zm2-8h2V4H8v2h.5c.83 0 1.5.67 1.5 1.5V8Zm5.5 5H13v3h2.5a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4H13v4h.5c.83 0 1.5.67 1.5 1.5v.5h.5a1.5 1.5 0 0 1 0 3Zm-11-6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm3.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
]);
const $77e1bce0ac0f7fe7$export$7fcd62f9f5e73ead = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart20Regular', "20", [
    "M4.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM9 9.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm3.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm-8-7A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11ZM3 6.5C3 5.67 3.67 5 4.5 5H7v1h1V5h4v3h1V5h2.5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H13v-2h-1v2H8V9H7v6H4.5A1.5 1.5 0 0 1 3 13.5v-7Z"
]);
const $77e1bce0ac0f7fe7$export$8ccf786c11d897fb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart24Filled', "24", [
    "M2 7.25C2 5.45 3.46 4 5.25 4h3v3H6a2 2 0 1 0 0 4h2.25v9h-3A3.25 3.25 0 0 1 2 16.75v-9.5ZM9.25 20v-9H10v1c0 1.1.9 2 2 2h1v1a2 2 0 0 0 1.75 1.98V20h-5.5ZM12 10h2.75V4h-5.5v3H10a2 2 0 0 1 2 2v1Zm6 7h-2.25v3h3c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4h-3v6H16a2 2 0 0 1 2 2v1a2 2 0 1 1 0 4ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6Zm5 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm4 2a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3Z"
]);
const $77e1bce0ac0f7fe7$export$3e93fbb4134394d6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('GanttChart24Regular', "24", [
    "M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6Zm5 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm4 2a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3ZM5.25 4A3.25 3.25 0 0 0 2 7.25v9.5C2 18.55 3.46 20 5.25 20h13.5c1.8 0 3.25-1.46 3.25-3.25v-9.5C22 5.45 20.54 4 18.75 4H5.25ZM8 5.5V7h1.5V5.5h5V10H16V5.5h2.75c.97 0 1.75.78 1.75 1.75v9.5c0 .97-.78 1.75-1.75 1.75H16V17h-1a2 2 0 0 1-.5-.06v1.56h-5V11H8v7.5H5.25c-.97 0-1.75-.78-1.75-1.75v-9.5c0-.97.78-1.75 1.75-1.75H8Z"
]);
const $77e1bce0ac0f7fe7$export$bb878c3f8f38c271 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke20Filled', "20", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98.2.1.4.23.57.41.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17-1.44.18-2.5.36-3.22.52a42.44 42.44 0 0 0 4.24.57c1.02.09 2.1.23 3.02.4.46.09.9.19 1.26.3.36.1.71.23.97.4.13.1.3.23.42.45.14.25.17.56.03.85-.11.24-.3.4-.45.5-.16.1-.35.18-.54.25-.77.29-2.15.55-4.29.8-2.12.23-3.4.54-4.11.85-.3.13-.45.24-.51.3.03.04.07.1.16.17.15.14.36.3.64.45.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96-.34-.2-.67-.41-.93-.65a2.03 2.03 0 0 1-.62-.94c-.12-.44-.01-.88.28-1.24.26-.33.65-.58 1.1-.77.93-.4 2.4-.73 4.55-.98 1.37-.15 2.36-.31 3.04-.46l-.55-.12c-.86-.16-1.89-.29-2.86-.37a43.94 43.94 0 0 1-3.7-.46c-.53-.09-1-.2-1.4-.3-.37-.11-.75-.24-1.02-.43a1.19 1.19 0 0 1-.43-.49.93.93 0 0 1 .06-.87c.13-.22.32-.36.47-.44.17-.1.36-.18.56-.26.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96-.64-.2-1.63-.42-2.9-.63a88.96 88.96 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82Z"
]);
const $77e1bce0ac0f7fe7$export$60be0391352f71ee = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke20Regular', "20", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96.19.1.37.21.51.36.14.16.27.4.22.69a.95.95 0 0 1-.4.57c-.16.13-.38.24-.63.34-.99.4-2.89.77-5.92 1.15a22.58 22.58 0 0 0-4.13.78l.3.1c.34.09.77.18 1.28.27 1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4.45.08.87.18 1.23.29.35.1.67.22.9.38.12.07.26.18.34.35.1.18.13.4.03.62a.97.97 0 0 1-.37.4c-.13.08-.3.16-.49.23-.74.27-2.08.53-4.22.77a16 16 0 0 0-4.2.88c-.37.16-.55.3-.63.4-.06.08-.05.11-.04.14.02.07.08.19.26.35.17.15.4.31.7.48.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94-.33-.19-.64-.4-.88-.62a1.78 1.78 0 0 1-.55-.81c-.1-.36-.01-.72.23-1.03.23-.28.58-.5 1.02-.7.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7a11.8 11.8 0 0 0-1.44-.37 30 30 0 0 0-2.89-.38 43.66 43.66 0 0 1-3.68-.45c-.52-.1-.98-.2-1.37-.3-.37-.1-.71-.24-.95-.4a.94.94 0 0 1-.34-.38.68.68 0 0 1 .04-.64c.1-.17.25-.28.39-.36.14-.08.32-.16.52-.23a23.3 23.3 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09.1-.04.2-.08.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96Z"
]);
const $77e1bce0ac0f7fe7$export$a2f1b72be78160e2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke24Filled', "24", [
    "M3 2.9A1 1 0 0 1 4.1 2l3.74.35c2.66.27 5.2.59 7.3.95 2.04.35 3.8.76 4.76 1.27.25.13.52.3.73.55.22.26.44.66.35 1.16-.08.46-.38.77-.61.96-.25.2-.55.35-.88.48-1.27.53-3.66 1.03-7.4 1.51-1.67.22-2.91.44-3.8.64l.69.14c1.21.22 2.75.41 4.38.56a37 37 0 0 1 3.72.51c.57.11 1.1.24 1.57.38.43.14.88.31 1.22.55.16.11.38.3.53.58.17.32.2.72.04 1.1-.15.31-.4.52-.58.65-.2.13-.44.25-.69.34-.95.37-2.66.7-5.3 1.02-2.6.31-4.17.7-5.03 1.1-.34.15-.51.28-.59.36l.18.2c.18.18.44.37.79.57.68.4 1.56.78 2.41 1.07l3.25 1.05a1 1 0 1 1-.61 1.9L11 20.9c-.94-.32-1.96-.75-2.8-1.25a6.33 6.33 0 0 1-1.15-.84c-.32-.3-.64-.71-.77-1.22a1.83 1.83 0 0 1 .34-1.6c.33-.43.82-.75 1.4-1.01 1.14-.52 2.96-.95 5.62-1.26 1.59-.2 2.76-.38 3.59-.56l-.54-.12c-1.05-.2-2.31-.37-3.5-.48a51.94 51.94 0 0 1-4.57-.59c-.65-.12-1.24-.25-1.73-.4a4.5 4.5 0 0 1-1.29-.55 1.55 1.55 0 0 1-.54-.65c-.16-.39-.12-.8.07-1.13.17-.28.4-.46.6-.58.2-.13.45-.24.7-.34 1.01-.37 2.77-.72 5.41-1.07 3.23-.42 5.27-.83 6.4-1.2-.77-.26-1.94-.52-3.44-.78-2.03-.35-4.53-.66-7.16-.93L3.91 4A1 1 0 0 1 3 2.9Z"
]);
const $77e1bce0ac0f7fe7$export$dd5919b0fd22d902 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStroke24Regular', "24", [
    "M3.25 2.93c.04-.41.4-.72.82-.68l3.74.35c2.66.27 5.2.58 7.28.94 2.05.35 3.77.76 4.7 1.25.23.13.47.29.65.5.2.21.36.55.3.95-.07.37-.31.63-.53.8-.22.18-.5.32-.81.45-1.24.51-3.6 1-7.33 1.5-2.38.3-3.9.61-4.76.89l.08.02c.4.12.93.24 1.54.35 1.23.23 2.77.42 4.4.57 1.25.1 2.57.28 3.7.5.57.12 1.1.24 1.54.38.43.14.85.3 1.16.51.15.1.33.26.45.5a1 1 0 0 1 .03.87c-.12.26-.32.43-.5.55-.17.12-.39.23-.63.32-.92.35-2.6.69-5.23 1-2.62.32-4.22.71-5.11 1.12-.45.2-.65.38-.73.48-.05.07-.05.09-.04.1.02.06.08.2.29.4.2.19.48.39.83.6.7.41 1.6.8 2.47 1.09l3.24 1.05a.75.75 0 0 1-.46 1.42l-3.26-1.05a15.4 15.4 0 0 1-2.75-1.22c-.41-.24-.8-.51-1.1-.81a2.4 2.4 0 0 1-.71-1.1c-.13-.48-.02-.97.3-1.39.29-.38.74-.68 1.3-.94 1.1-.5 2.9-.92 5.55-1.24 2.29-.27 3.72-.55 4.54-.8l-.08-.03c-.38-.11-.85-.23-1.39-.33a35.23 35.23 0 0 0-3.54-.49 51.7 51.7 0 0 1-4.54-.58c-.64-.12-1.22-.25-1.7-.4-.46-.13-.9-.3-1.21-.52a1.3 1.3 0 0 1-.46-.54 1 1 0 0 1 .06-.9c.13-.23.34-.4.51-.5.2-.12.42-.22.66-.31.98-.36 2.7-.72 5.35-1.06 3.75-.5 5.92-.97 6.95-1.4l.13-.05c-.73-.34-2.16-.7-4.11-1.03-2.04-.35-4.54-.66-7.17-.92l-3.74-.35a.75.75 0 0 1-.68-.82Z"
]);
const $77e1bce0ac0f7fe7$export$86014ece0efe0c7e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown20Filled', "20", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98.2.1.4.23.57.41.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17-1.44.18-2.5.36-3.22.52a42.44 42.44 0 0 0 4.24.57c1.02.09 2.1.23 3.02.4.46.09.9.19 1.26.3.36.1.71.23.97.4a1.26 1.26 0 0 1 .49.59 1.75 1.75 0 0 0-2.33 1.65v.16c-.76.15-1.74.3-2.99.44-2.12.24-3.4.55-4.11.86-.3.13-.45.24-.51.3.03.04.07.1.16.17.15.14.36.3.64.45.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96-.34-.2-.67-.41-.93-.65a2.03 2.03 0 0 1-.62-.94c-.12-.44-.01-.88.28-1.24.26-.33.65-.58 1.1-.77.93-.4 2.4-.73 4.55-.98 1.37-.15 2.36-.31 3.04-.46l-.55-.12c-.86-.16-1.89-.29-2.86-.37a43.94 43.94 0 0 1-3.7-.46c-.53-.09-1-.2-1.4-.3-.37-.11-.75-.24-1.02-.43a1.19 1.19 0 0 1-.43-.49.93.93 0 0 1 .06-.87c.13-.22.32-.36.47-.44.17-.1.36-.18.56-.26.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96-.64-.2-1.63-.42-2.9-.63a88.96 88.96 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82ZM17 12.25a.75.75 0 0 0-1.5 0v4.19l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72v-4.19Z"
]);
const $77e1bce0ac0f7fe7$export$e00790a76164066e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown20Regular', "20", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96.19.1.37.21.51.36.14.16.27.4.22.69a.95.95 0 0 1-.4.57c-.16.13-.38.24-.63.34-.99.4-2.89.77-5.92 1.15-2.15.27-3.44.53-4.1.77H5.9l.3.1c.34.1.77.2 1.28.28 1 .18 2.25.33 3.59.44 1 .09 2.07.22 2.99.4.45.08.87.18 1.23.29.35.1.67.22.9.38.12.07.26.18.34.35.08.13.1.27.09.43L16.5 11a1.5 1.5 0 0 0-1.42 1.02c-.8.2-1.96.4-3.6.58a16 16 0 0 0-4.18.88c-.38.16-.56.3-.64.4-.06.08-.05.11-.04.14.02.07.08.19.26.35.17.15.4.31.7.48.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94-.33-.19-.64-.4-.88-.62a1.78 1.78 0 0 1-.55-.81c-.1-.36-.01-.72.23-1.03.23-.28.58-.5 1.02-.7.88-.38 2.32-.7 4.47-.95 2.1-.24 3.33-.48 3.95-.7a11.8 11.8 0 0 0-1.44-.37 30 30 0 0 0-2.89-.38 43.66 43.66 0 0 1-3.68-.45c-.52-.1-.98-.2-1.37-.3-.37-.1-.71-.24-.95-.4a.94.94 0 0 1-.34-.38.68.68 0 0 1 .04-.64c.1-.17.25-.28.39-.36.14-.08.32-.16.52-.23a23.3 23.3 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09.1-.04.2-.08.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96Zm14 9.54a.5.5 0 0 0-1 0v4.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L17 17.29V12.5Z"
]);
const $77e1bce0ac0f7fe7$export$c98df533bc0cc740 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown24Filled', "24", [
    "M3 2.9A1 1 0 0 1 4.1 2l3.74.35c2.66.27 5.2.59 7.3.95 2.04.35 3.8.76 4.76 1.27.25.13.52.3.73.55.22.26.44.66.35 1.16-.08.46-.38.77-.61.96-.25.2-.55.35-.88.48-1.27.53-3.66 1.03-7.4 1.51-1.67.22-2.91.44-3.8.64l.69.14c1.21.22 2.75.41 4.38.56a37 37 0 0 1 3.72.51 15.54 15.54 0 0 1 1.89.5 2 2 0 0 0-1.47 1.92v1.64c-.93.2-2.13.38-3.62.56-2.61.31-4.18.7-5.04 1.1-.34.15-.51.28-.59.36l.18.2c.18.18.44.37.79.57.68.4 1.56.78 2.41 1.07l3.25 1.05a1 1 0 1 1-.61 1.9L11 20.9c-.94-.32-1.96-.75-2.8-1.25a6.33 6.33 0 0 1-1.15-.84c-.32-.3-.64-.71-.77-1.22a1.83 1.83 0 0 1 .34-1.6c.33-.43.82-.75 1.4-1.01 1.14-.52 2.96-.95 5.62-1.26 1.59-.2 2.76-.38 3.59-.56l-.54-.12c-1.05-.2-2.31-.37-3.5-.48a51.94 51.94 0 0 1-4.57-.59c-.65-.12-1.24-.25-1.73-.4a4.5 4.5 0 0 1-1.29-.55 1.55 1.55 0 0 1-.54-.65c-.16-.39-.12-.8.07-1.13.17-.28.4-.46.6-.58.2-.13.45-.24.7-.34 1.01-.37 2.77-.72 5.41-1.07 3.23-.42 5.27-.83 6.4-1.2-.77-.26-1.94-.52-3.44-.78-2.03-.35-4.53-.66-7.16-.93L3.91 4A1 1 0 0 1 3 2.9Zm17.5 10.6a1 1 0 1 0-2 0v6.09l-.8-.8a1 1 0 0 0-1.4 1.42l2.5 2.5a1 1 0 0 0 1.4 0l2.5-2.5a1 1 0 0 0-1.4-1.42l-.8.8V13.5Z"
]);
const $77e1bce0ac0f7fe7$export$7de2fda0bebd41ce = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowDown24Regular', "24", [
    "M3.25 2.93c.04-.41.4-.72.82-.68l3.74.35c2.66.27 5.2.58 7.28.94 2.05.35 3.77.76 4.7 1.25.23.13.47.29.65.5.2.21.36.55.3.95-.07.37-.31.63-.53.8-.22.18-.5.32-.81.45-1.24.51-3.6 1-7.33 1.5-2.38.3-3.9.61-4.76.89l.08.02c.4.12.93.24 1.54.35 1.23.23 2.77.42 4.4.57 1.25.1 2.57.28 3.7.5.57.12 1.1.24 1.54.38.3.1.6.2.85.33-.6.12-1.1.54-1.3 1.1-.38-.12-.85-.23-1.38-.33a35.23 35.23 0 0 0-3.54-.49 51.7 51.7 0 0 1-4.54-.58c-.64-.12-1.22-.25-1.7-.4-.46-.13-.9-.3-1.21-.52a1.3 1.3 0 0 1-.46-.54 1 1 0 0 1 .06-.9c.13-.23.34-.4.51-.5.2-.12.42-.22.66-.31.98-.36 2.7-.72 5.35-1.06 3.75-.5 5.92-.97 6.95-1.4l.13-.05c-.73-.34-2.16-.7-4.11-1.03-2.04-.35-4.54-.66-7.17-.92l-3.74-.35a.75.75 0 0 1-.68-.82ZM18 13.75v1.02c-.97.24-2.34.47-4.15.68-2.62.32-4.22.71-5.11 1.12-.45.2-.65.38-.73.48-.05.07-.05.09-.04.1.02.06.08.2.29.4.2.19.48.39.83.6.7.41 1.6.8 2.47 1.09l3.24 1.05a.75.75 0 0 1-.46 1.42l-3.26-1.05a15.4 15.4 0 0 1-2.75-1.22c-.41-.24-.8-.51-1.1-.81a2.4 2.4 0 0 1-.71-1.1c-.13-.48-.02-.97.3-1.39.29-.38.74-.68 1.3-.94 1.1-.5 2.9-.92 5.55-1.24 2.17-.26 3.58-.52 4.42-.76-.06.17-.09.36-.09.55Zm2.5 0a.75.75 0 0 0-1.5 0v6.69l-1.22-1.22a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22v-6.69Z"
]);
const $77e1bce0ac0f7fe7$export$1c60b86d4c317b5c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown20Filled', "20", [
    "M2.75 2.93c.04-.4.4-.71.82-.68l3.04.28c2.16.2 4.22.45 5.92.73 1.66.27 3.08.6 3.85.98.2.1.4.23.57.41.18.2.36.51.28.9-.06.36-.3.6-.48.73a3 3 0 0 1-.7.37c-1.02.4-2.95.8-5.98 1.17-1.44.18-2.5.36-3.22.52a42.44 42.44 0 0 0 4.24.57 31.21 31.21 0 0 1 3.52.5l-1.28 1.29a31.6 31.6 0 0 0-2.36-.3 43.94 43.94 0 0 1-3.7-.45c-.53-.09-1-.2-1.4-.3-.37-.11-.75-.24-1.02-.43a1.19 1.19 0 0 1-.43-.49.93.93 0 0 1 .06-.87c.13-.22.32-.36.47-.44.17-.1.36-.18.56-.26.8-.28 2.22-.56 4.37-.83 2.7-.33 4.38-.66 5.3-.96-.64-.2-1.63-.42-2.9-.63a88.96 88.96 0 0 0-5.8-.72l-3.05-.27a.75.75 0 0 1-.68-.82Zm10.13 8.23a1.75 1.75 0 0 0-.32 1.56c-.32.05-.67.09-1.05.13-2.12.24-3.4.55-4.11.86-.3.13-.45.24-.51.3.03.04.07.1.16.17.15.14.36.3.64.45.56.32 1.29.61 1.98.84l2.64.81a.75.75 0 1 1-.44 1.44L9.2 16.9c-.75-.25-1.58-.58-2.25-.96-.34-.2-.67-.41-.93-.65a2.03 2.03 0 0 1-.62-.94c-.12-.44-.01-.88.28-1.24.26-.33.65-.58 1.1-.77.93-.4 2.4-.73 4.55-.98.58-.06 1.09-.13 1.54-.2Zm3.9-1.44a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v4.38l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2c.3.3.77.3 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72v-4.38l.72.72a.75.75 0 1 0 1.06-1.06l-2-2Z"
]);
const $77e1bce0ac0f7fe7$export$acb5bd75150fbb3c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown20Regular', "20", [
    "M3 2.96a.5.5 0 0 1 .54-.46l3.05.27c2.15.2 4.21.45 5.9.73 1.67.28 3.04.6 3.77.96.19.1.37.21.51.36.14.16.27.4.22.69a.95.95 0 0 1-.4.57c-.16.13-.38.24-.63.34-.99.4-2.89.77-5.92 1.15-2.15.27-3.44.53-4.1.77H5.9l.3.1c.34.1.77.2 1.28.28 1 .18 2.25.33 3.59.44a30.96 30.96 0 0 1 4.01.63l-.83.83a30 30 0 0 0-3.27-.46 43.66 43.66 0 0 1-3.68-.45c-.52-.1-.98-.2-1.37-.3-.37-.1-.71-.24-.95-.4a.94.94 0 0 1-.34-.38.68.68 0 0 1 .04-.64c.1-.17.25-.28.39-.36.14-.08.32-.16.52-.23a23.3 23.3 0 0 1 4.31-.82c3.05-.38 4.83-.75 5.68-1.09.1-.04.2-.08.26-.12l-.04-.01c-.57-.3-1.8-.6-3.48-.87-1.66-.27-3.7-.52-5.84-.72L3.46 3.5A.5.5 0 0 1 3 2.96Zm10.44 8.48a1.5 1.5 0 0 0-.44.97l-1.51.2a16 16 0 0 0-4.2.87c-.37.16-.55.3-.63.4-.06.08-.05.11-.04.14.02.07.08.19.26.35.17.15.4.31.7.48.57.33 1.31.63 2.02.86l2.64.81a.5.5 0 0 1-.3.96l-2.65-.82c-.74-.24-1.55-.57-2.21-.94-.33-.19-.64-.4-.88-.62a1.78 1.78 0 0 1-.55-.81c-.1-.36-.01-.72.23-1.03.23-.28.58-.5 1.02-.7.88-.38 2.32-.7 4.47-.95.88-.1 1.6-.2 2.2-.3l-.13.13Zm3.41-1.3a.5.5 0 0 0-.7 0l-2 2a.5.5 0 0 0 .7.71L16 11.71v5.58l-1.15-1.14a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 0 0-.7-.7L17 17.29v-5.58l1.15 1.14a.5.5 0 0 0 .7-.7l-2-2Z"
]);
const $77e1bce0ac0f7fe7$export$29b05b2de9f2c33 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown24Filled', "24", [
    "M3 2.9A1 1 0 0 1 4.1 2l3.74.35c2.66.27 5.2.59 7.3.95 2.04.35 3.8.76 4.76 1.27.25.13.52.3.73.55.22.26.44.66.35 1.16-.08.46-.38.77-.61.96-.25.2-.55.35-.88.48-1.27.53-3.66 1.03-7.4 1.51-1.67.22-2.91.44-3.8.64l.69.14c1.21.22 2.75.41 4.38.56a37 37 0 0 1 3.72.51l-1.5 1.5-.2.24c-.71-.1-1.47-.2-2.2-.26a51.94 51.94 0 0 1-4.56-.59c-.65-.12-1.24-.25-1.73-.4a4.5 4.5 0 0 1-1.29-.55 1.55 1.55 0 0 1-.54-.65c-.16-.39-.12-.8.07-1.13.17-.28.4-.46.6-.58.2-.13.45-.24.7-.34 1.01-.37 2.77-.72 5.41-1.07 3.23-.42 5.27-.83 6.4-1.2-.77-.26-1.94-.52-3.44-.78-2.03-.35-4.53-.66-7.16-.93L3.91 4A1 1 0 0 1 3 2.9ZM15.6 15.42l.05.06c-.53.08-1.12.15-1.76.23-2.61.31-4.18.7-5.04 1.1-.34.15-.51.28-.59.36l.18.2c.18.18.44.37.79.57.68.4 1.56.78 2.41 1.07l3.25 1.05a1 1 0 1 1-.61 1.9L11 20.9c-.94-.32-1.96-.75-2.8-1.25a6.33 6.33 0 0 1-1.15-.84c-.32-.3-.64-.71-.77-1.22a1.83 1.83 0 0 1 .34-1.6c.33-.43.82-.75 1.4-1.01 1.14-.52 2.96-.95 5.62-1.26l1.42-.19a2 2 0 0 0 .53 1.88Zm4.62-4.62a1 1 0 0 0-1.42 0l-2.5 2.5a1 1 0 0 0 1.42 1.42l.79-.8v5.68l-.8-.8a1 1 0 0 0-1.4 1.42l2.5 2.5a1 1 0 0 0 1.4 0l2.5-2.5a1 1 0 0 0-1.4-1.42l-.8.8V13.9l.8.8a1 1 0 0 0 1.4-1.42l-2.5-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$378917b89e9e26d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkStrokeArrowUpDown24Regular', "24", [
    "M3.25 2.93c.04-.41.4-.72.82-.68l3.74.35c2.66.27 5.2.58 7.28.94 2.05.35 3.77.76 4.7 1.25.23.13.47.29.65.5.2.21.36.55.3.95-.07.37-.31.63-.53.8-.22.18-.5.32-.81.45-1.24.51-3.6 1-7.33 1.5-2.38.3-3.9.61-4.76.89l.08.02c.4.12.93.24 1.54.35 1.23.23 2.77.42 4.4.57a36.74 36.74 0 0 1 4.25.62l-1.27 1.28c-.97-.18-2.06-.32-3.1-.41a51.7 51.7 0 0 1-4.55-.58c-.64-.12-1.22-.25-1.7-.4-.46-.13-.9-.3-1.21-.52a1.3 1.3 0 0 1-.46-.54 1 1 0 0 1 .06-.9c.13-.23.34-.4.51-.5.2-.12.42-.22.66-.31.98-.36 2.7-.72 5.35-1.06 3.75-.5 5.92-.97 6.95-1.4l.13-.05c-.73-.34-2.16-.7-4.11-1.03-2.04-.35-4.54-.66-7.17-.92l-3.74-.35a.75.75 0 0 1-.68-.82ZM15.6 13.71c-.16.49-.1 1.04.19 1.48-.58.1-1.22.18-1.93.26-2.62.32-4.22.71-5.11 1.12-.45.2-.65.38-.73.48-.05.07-.05.09-.04.1.02.06.08.2.29.4.2.19.48.39.83.6.7.41 1.6.8 2.47 1.09l3.24 1.05a.75.75 0 0 1-.46 1.42l-3.26-1.05a15.4 15.4 0 0 1-2.75-1.22c-.41-.24-.8-.51-1.1-.81a2.4 2.4 0 0 1-.71-1.1c-.13-.48-.02-.97.3-1.39.29-.38.74-.68 1.3-.94 1.1-.5 2.9-.92 5.55-1.24a57.8 57.8 0 0 0 1.92-.25Zm4.69-2.49a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 1 0 1.06 1.06L19 13.56v6.88l-1.22-1.22a.75.75 0 1 0-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22v-6.88l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$9021b747ff7bc51d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool16Filled', "16", [
    "M2 1a1 1 0 0 0-1 1v.4a.5.5 0 0 0 0 .1v1C1 4.33 1.67 5 2.5 5h11c.83 0 1.5-.67 1.5-1.5V2a1 1 0 0 0-1-1H2Zm4.5 12c.02.41.12.86.32 1.23.21.39.6.76 1.17.77H8c.58 0 .97-.38 1.18-.77.2-.37.3-.82.31-1.23H6.51Zm3.48-1.55L12.74 6H3.26l2.76 5.45a1 1 0 0 0 .89.55h2.18a1 1 0 0 0 .89-.55Z"
]);
const $77e1bce0ac0f7fe7$export$5070b677b3f58149 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool16Regular', "16", [
    "M2 1.5a.5.5 0 0 0-1 0v2C1 4.33 1.67 5 2.5 5h.25l3.26 6.45a1 1 0 0 0 .58.5c-.12.62-.11 1.23.02 1.74.17.64.6 1.31 1.4 1.31.78 0 1.22-.67 1.39-1.31.13-.5.14-1.12.02-1.74a1 1 0 0 0 .56-.5L13.25 5h.25c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2ZM3.87 5h8.26l-3.04 6H6.91L3.87 5Zm3.73 7h.8c.14.55.13 1.06.03 1.44-.13.48-.33.56-.43.56-.09 0-.3-.08-.42-.56-.1-.38-.1-.9.02-1.44Z"
]);
const $77e1bce0ac0f7fe7$export$37882fad2a818ec6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool20Filled', "20", [
    "M8.52 15a6.2 6.2 0 0 0-.02.5c0 .58.07 1.16.27 1.62.21.47.6.88 1.23.88s1.02-.41 1.23-.88c.2-.46.27-1.04.27-1.62 0-.17 0-.34-.02-.5H8.52ZM2.5 5.5v-3c0-.28.22-.5.5-.5h14c.28 0 .5.22.5.5v3c0 .83-.67 1.5-1.5 1.5H4a1.5 1.5 0 0 1-1.5-1.5ZM4.75 8l2.72 5.45a1 1 0 0 0 .9.55h3.26a1 1 0 0 0 .9-.55L15.25 8H4.75Z"
]);
const $77e1bce0ac0f7fe7$export$f92fae909a5b0ebe = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool20Regular', "20", [
    "M3.5 2.5a.5.5 0 0 0-1 0v3C2.5 6.33 3.17 7 4 7h.2l3.58 7.17c.16.33.43.57.75.71-.05.66-.03 1.31.1 1.83.1.33.23.64.45.88.23.25.54.41.92.41s.7-.16.93-.41c.22-.24.35-.55.43-.88.14-.52.17-1.17.11-1.83.32-.14.6-.39.75-.7L15.81 7H16c.83 0 1.5-.67 1.5-1.5v-3a.5.5 0 0 0-1 0v3a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-3ZM5.3 7h9.4l-3.37 6.72a.5.5 0 0 1-.45.28H9.12a.5.5 0 0 1-.45-.28L5.31 7Zm4.22 8h.96c.04.58.01 1.09-.08 1.46-.06.23-.14.38-.21.45A.23.23 0 0 1 10 17a.23.23 0 0 1-.18-.09 1.09 1.09 0 0 1-.21-.45c-.1-.37-.13-.88-.09-1.46Z"
]);
const $77e1bce0ac0f7fe7$export$81989a399a84a1b3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool24Filled', "24", [
    "M13.82 20.04c-.12.46-.31.88-.56 1.27a1.5 1.5 0 0 1-2.47.08l-.08-.12-.13-.22a5.63 5.63 0 0 1-.55-3.05h3.94c.07.72.02 1.4-.15 2.04ZM18.48 9 15 16.09c-.22.45-.62.78-1.1.91h-3.73l-.1-.03c-.38-.13-.7-.38-.92-.72l-.08-.15L5.54 9h12.94Zm1.77-7c.38 0 .7.28.74.65l.01.1v3.5c0 .92-.7 1.67-1.6 1.74H4.74c-.92 0-1.67-.7-1.74-1.6V2.75c0-.38.27-.7.64-.75h16.6Z"
]);
const $77e1bce0ac0f7fe7$export$116758badd387170 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool24Regular', "24", [
    "M4.5 2.75a.75.75 0 0 0-1.5 0v3.5C3 7.22 3.78 8 4.75 8h.27l4.03 8.97c.2.45.59.79 1.04.94a5.79 5.79 0 0 0 .27 3.01c.3.6.83 1.08 1.64 1.08.8 0 1.35-.48 1.64-1.08a5.79 5.79 0 0 0 .27-3.01c.45-.15.83-.49 1.04-.94L18.98 8h.27C20.22 8 21 7.22 21 6.25v-3.5a.75.75 0 0 0-1.5 0v3.5c0 .14-.11.25-.25.25H4.75a.25.25 0 0 1-.25-.25v-3.5ZM6.66 8h10.68l-3.76 8.35a.25.25 0 0 1-.23.15h-2.7a.25.25 0 0 1-.23-.15L6.66 8Zm4.95 10h.78c.07.26.11.6.11 1 0 .57-.08 1-.21 1.26-.1.22-.2.24-.29.24-.1 0-.18-.02-.29-.24A3.03 3.03 0 0 1 11.5 19c0-.4.04-.74.11-1Z"
]);
const $77e1bce0ac0f7fe7$export$14417d4ea4594e08 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool32Filled', "32", [
    "M4.02 2a2 2 0 0 0-2 2v.81A1 1 0 0 0 2 5v2a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V4a2 2 0 0 0-2-2H4.02Zm9 24c.02.82.21 1.72.62 2.45.43.78 1.2 1.54 2.34 1.55h.04c1.14-.01 1.91-.77 2.34-1.55.4-.73.6-1.63.62-2.45h-5.96Zm6.94-3.1L25.48 12H6.52l5.51 10.9a2 2 0 0 0 1.79 1.1h4.36a2 2 0 0 0 1.78-1.1Z"
]);
const $77e1bce0ac0f7fe7$export$a648b3da81f079da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingTool32Regular', "32", [
    "M4.02 2.95a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h.46l6.55 12.95a2 2 0 0 0 1.11.98c-.07.62-.12 1.33-.12 1.97 0 .86.19 1.82.62 2.6S14.84 30 15.98 30h.04c1.14-.01 1.91-.77 2.34-1.55.43-.78.62-1.74.62-2.6a17.47 17.47 0 0 0-.12-1.97 2 2 0 0 0 1.1-.98l6.56-12.95h.5a3 3 0 0 0 3-3v-4a1 1 0 1 0-2 0v4a1 1 0 0 1-1 1h-22a1 1 0 0 1-1-1v-4ZM16.86 24a14.26 14.26 0 0 1 .12 1.85c0 .6-.14 1.21-.37 1.64-.23.41-.44.5-.61.51-.17 0-.38-.1-.6-.5a3.58 3.58 0 0 1-.38-1.65c0-.54.04-1.17.11-1.73l.01-.12h1.72Zm7.42-14.05L18.18 22h-4.36L7.72 9.95h16.56Z"
]);
const $77e1bce0ac0f7fe7$export$31d6c02426837894 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent16Filled', "16", [
    "M14.5 2v2a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2h13Zm-4 2.5.52.48-2.4 4.75a.5.5 0 1 1-.9-.46l2.18-4.3.6-.47ZM9 13c0 .83-.45 1.5-1 1.5s-1-.67-1-1.5.45-1.5 1-1.5 1 .67 1 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$9631b11e278f0648 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent20Filled', "20", [
    "M17 6V3H3v3c0 .28.22.5.5.5h13A.5.5 0 0 0 17 6Zm-4.55 1-2.4 4.78a.5.5 0 1 0 .9.44L13.56 7 13 6.5l-.55.5ZM10 17.5c.55 0 1-.67 1-1.5s-.45-1.5-1-1.5-1 .67-1 1.5.45 1.5 1 1.5Z"
]);
const $77e1bce0ac0f7fe7$export$17c239c39472ca80 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent24Filled', "24", [
    "M4 7h16.25c.12 0 .22-.08.24-.2l.01-.05V3H3.75v3.75c0 .12.08.22.2.24L4 7Zm7.98 6.95L14.62 8l.88-.5.76.5-2.91 6.55a.75.75 0 1 1-1.37-.6ZM13 19c0 1.1-.45 2-1 2s-1-.9-1-2 .45-2 1-2 1 .9 1 2Z"
]);
const $77e1bce0ac0f7fe7$export$c864ecab0625870b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('InkingToolAccent32Filled', "32", [
    "M3 4h26v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-.1.45l-5 10a1 1 0 1 1-1.8-.9L20.89 9H4a1 1 0 0 1-1-1V4Zm14.86 21.88c0 1.86-.87 3.37-1.93 3.37-1.07 0-1.93-1.51-1.93-3.38 0-1.86.86-3.37 1.93-3.37 1.06 0 1.93 1.51 1.93 3.38Z"
]);
const $77e1bce0ac0f7fe7$export$99bc36e4aa597c58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot16Filled', "16", [
    "M12 3.5a1.5 1.5 0 0 1-1.75 1.48L9.63 6.1c.48.41.8 1 .86 1.67l.66.08a1.5 1.5 0 1 1-.11 1l-.66-.08c-.2.6-.6 1.09-1.13 1.4l.28.83a1.5 1.5 0 1 1-.95.32l-.28-.84a2.52 2.52 0 0 1-2.2-.85l-1.12.62.02.25a1.5 1.5 0 1 1-.5-1.12l1.12-.63a2.5 2.5 0 0 1 .3-2.13l-.77-.77a1.5 1.5 0 1 1 .7-.7l.77.76a2.49 2.49 0 0 1 2.13-.3l.63-1.12a1.5 1.5 0 1 1 2.62-1Z"
]);
const $77e1bce0ac0f7fe7$export$253946f40477962b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot16Regular', "16", [
    "M10 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 0 0-1.12 2.5l-.63 1.12a2.5 2.5 0 0 0-2.13.3l-.77-.77a1.5 1.5 0 1 0-.7.7l.76.77a2.49 2.49 0 0 0-.3 2.13l-1.12.63a1.5 1.5 0 1 0 .49.87l1.12-.62a2.5 2.5 0 0 0 2.2.85l.28.84a1.5 1.5 0 1 0 .95-.32l-.28-.83c.53-.31.94-.8 1.13-1.4l.66.07a1.5 1.5 0 1 0 .1-1l-.65-.07a2.5 2.5 0 0 0-.86-1.67l.62-1.12.25.02a1.5 1.5 0 0 0 0-3Zm-6 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM9 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM12.5 8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM8 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
]);
const $77e1bce0ac0f7fe7$export$750f138dd499bbd5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot20Filled', "20", [
    "M16 4a2 2 0 0 1-2.65 1.89l-1.28 1.94A3 3 0 0 1 13 9.99l1.17.2a2 2 0 1 1-.16.99l-1.17-.2a3.01 3.01 0 0 1-1.43 1.67l.45 1.36H12a2 2 0 1 1-1.1.31l-.44-1.35a3.02 3.02 0 0 1-2.87-1.18l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a2.99 2.99 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4Z"
]);
const $77e1bce0ac0f7fe7$export$a909f8c4614de31c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot20Regular', "20", [
    "M16 4a2 2 0 0 1-2.65 1.89l-1.28 1.94A3 3 0 0 1 13 9.99l1.17.2a2 2 0 1 1-.16.99l-1.17-.2a3.01 3.01 0 0 1-1.43 1.67l.45 1.36H12a2 2 0 1 1-1.1.31l-.44-1.35a3.02 3.02 0 0 1-2.87-1.18l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a2.99 2.99 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4Zm-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm8 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$c5551bf103f7ec62 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot24Filled', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06C15.5 9.79 16 10.84 16 12v.05l1.3.27a2.5 2.5 0 1 1-.28 1.47l-1.32-.26a4.01 4.01 0 0 1-1.75 1.96l.5 1.51h.05a2.5 2.5 0 1 1-1.47.48l-.5-1.51a4.04 4.04 0 0 1-3.75-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a3.98 3.98 0 0 1 3.36-.23l1.25-2.06a2.5 2.5 0 0 1 1.82-4.22A2.5 2.5 0 0 1 19 4.5Z"
]);
const $77e1bce0ac0f7fe7$export$54137c4bbdbd23ae = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Iot24Regular', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06a3.99 3.99 0 0 1 1.29 3l1.3.26a2.5 2.5 0 1 1-.28 1.47l-1.32-.26a4.02 4.02 0 0 1-1.75 1.96l.5 1.51h.05a2.5 2.5 0 1 1-1.47.48l-.5-1.51a4.05 4.05 0 0 1-3.75-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a3.98 3.98 0 0 1 3.36-.23l1.25-2.06a2.5 2.5 0 0 1 1.82-4.22A2.5 2.5 0 0 1 19 4.5Zm-1.5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-6.5 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm10 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm4-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
]);
const $77e1bce0ac0f7fe7$export$536f726ca911407 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert16Filled', "16", [
    "M12 3.5a1.5 1.5 0 0 1-1.75 1.48L9.63 6.1l.24.24A4 4 0 0 0 7.5 10v.45a2.5 2.5 0 0 1-1.4-.82l-1.12.62.02.25a1.5 1.5 0 1 1-.5-1.12l1.12-.63a2.5 2.5 0 0 1 .3-2.13l-.77-.77a1.5 1.5 0 1 1 .7-.7l.77.76a2.49 2.49 0 0 1 2.13-.3l.63-1.12a1.5 1.5 0 1 1 2.62-1ZM8.5 10a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L8.5 12v-2Zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1Z"
]);
const $77e1bce0ac0f7fe7$export$e849023048eecae6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert16Regular', "16", [
    "M10 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-1.5a1.5 1.5 0 0 0-1.12 2.5l-.63 1.12a2.5 2.5 0 0 0-2.13.3l-.77-.77a1.5 1.5 0 1 0-.7.7l.76.77a2.49 2.49 0 0 0-.3 2.13l-1.12.63a1.5 1.5 0 1 0 .49.87l1.12-.62c.36.41.84.7 1.4.82V10c0-.2.01-.39.04-.57A1.5 1.5 0 1 1 9 6.88a4 4 0 0 1 .87-.54 2.52 2.52 0 0 0-.24-.24l.62-1.12.25.02a1.5 1.5 0 0 0 0-3Zm-6 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm-1 6a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Zm5 0a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L8.5 12v-2Zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1Z"
]);
const $77e1bce0ac0f7fe7$export$4756fe773519dbc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert20Filled', "20", [
    "M16 4a2 2 0 0 1-2.65 1.88l-1.28 1.95.3.33A4 4 0 0 0 9.5 12v.96a3 3 0 0 1-1.91-1.17l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a2.99 2.99 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4Zm-5.5 8a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 14v-2Zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1Z"
]);
const $77e1bce0ac0f7fe7$export$d34f3271637ba402 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert20Regular', "20", [
    "M16 4a2 2 0 0 1-2.65 1.88l-1.28 1.95.3.33c-.34.1-.66.24-.96.43A2 2 0 0 0 8 10a2 2 0 0 0 1.5 1.94v1.02a3 3 0 0 1-1.91-1.17l-1.64.78A2 2 0 0 1 4 15a2 2 0 1 1 1.5-3.32l1.64-.79A3 3 0 0 1 7.77 8l-.93-1.17a2 2 0 1 1 .77-.63l.95 1.18a2.99 2.99 0 0 1 2.68-.1l1.28-1.94A2 2 0 1 1 16 4Zm-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM6 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm5.5-1a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.32.88h-8a.5.5 0 0 1-.32-.88L10.5 14v-2Zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1Z"
]);
const $77e1bce0ac0f7fe7$export$3f27b8d15458bedc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert24Filled', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06c.32.3.6.65.8 1.04a5 5 0 0 0-4 4.9v.97a4 4 0 0 1-2.73-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a3.98 3.98 0 0 1 3.36-.24l1.25-2.06A2.5 2.5 0 0 1 16.5 2 2.5 2.5 0 0 1 19 4.5ZM16.5 11a4 4 0 0 0-4 4v3l-.95.8c-.3.26-.46.39-.5.5a.5.5 0 0 0 .24.65c.1.05.3.05.7.05h9.02c.4 0 .6 0 .7-.05a.5.5 0 0 0 .25-.66c-.05-.1-.2-.23-.5-.49l-.96-.8v-3a4 4 0 0 0-4-4ZM18 21c-.22.58-.8 1-1.5 1-.69 0-1.28-.42-1.5-1h3Z"
]);
const $77e1bce0ac0f7fe7$export$1c17e488fc78c010 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('IotAlert24Regular', "24", [
    "M19 4.5a2.5 2.5 0 0 1-3.01 2.44L14.7 9.06c.32.3.6.65.8 1.04-.5.1-.98.28-1.42.52a2.5 2.5 0 1 0-2.56 3.84c-.02.17-.03.36-.03.54v.97a4 4 0 0 1-2.72-1.6l-1.8.85.02.28a2.5 2.5 0 1 1-.62-1.65l1.75-.83a4 4 0 0 1 .79-3.57l-1-1.13A2.5 2.5 0 0 1 4.5 6a2.5 2.5 0 1 1 4.59 1.38l.98 1.12a3.98 3.98 0 0 1 3.36-.24l1.25-2.06A2.5 2.5 0 0 1 16.5 2 2.5 2.5 0 0 1 19 4.5Zm-1.5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM7 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1.5 8.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm11-4.5a4 4 0 0 0-4 4v3l-.95.8c-.3.26-.46.39-.5.5a.5.5 0 0 0 .24.65c.1.05.3.05.7.05h9.02c.4 0 .6 0 .7-.05a.5.5 0 0 0 .25-.66c-.05-.1-.2-.23-.5-.49l-.96-.8v-3a4 4 0 0 0-4-4ZM18 21c-.22.58-.8 1-1.5 1-.69 0-1.28-.42-1.5-1h3Z"
]);
const $77e1bce0ac0f7fe7$export$b644bfe289cc36e4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library16Color', "16", `<path d="M1 3.25C1 2.55 1.56 2 2.25 2h.5C3.44 2 4 2.56 4 3.25v9.5c0 .68-.56 1.24-1.25 1.24h-.5C1.55 14 1 13.43 1 12.74v-9.5Z" fill="url(#ic_fluent_library_16_color__a)"/><path d="M5 3.25C5 2.55 5.56 2 6.25 2h.5c.68 0 1.24.56 1.24 1.25v9.5c0 .68-.56 1.24-1.24 1.24h-.5C5.55 14 5 13.43 5 12.74v-9.5Z" fill="url(#ic_fluent_library_16_color__b)"/><path d="M11.97 4.78a1.25 1.25 0 0 0-1.57-.72l-.58.2c-.67.24-1.01 1-.75 1.65l2.94 7.3c.25.63.94.94 1.57.72l.58-.2c.68-.24 1.02-.99.75-1.65l-2.94-7.3Z" fill="url(#ic_fluent_library_16_color__c)"/><path d="M1 4h3v2H1V4Z" fill="url(#ic_fluent_library_16_color__d)"/><path d="M12.31 5.62 9.42 6.79l.75 1.84 2.88-1.16-.74-1.85Z" fill="url(#ic_fluent_library_16_color__e)"/><path d="M8 4H5v2h3V4Z" fill="url(#ic_fluent_library_16_color__f)"/><defs><linearGradient id="ic_fluent_library_16_color__a" x1="4.47" y1="3.99" x2="5.64" y2="17.42" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_16_color__b" x1="4.47" y1="3.99" x2="5.64" y2="17.42" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_16_color__c" x1="4.47" y1="3.99" x2="5.64" y2="17.42" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_16_color__d" x1="5" y1=".18" x2="8.89" y2="1.06" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_16_color__e" x1="5" y1=".18" x2="8.89" y2="1.06" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_16_color__f" x1="5" y1=".18" x2="8.89" y2="1.06" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$5894e417a4f344da = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library16Filled', "16", [
    "M2.25 2C1.55 2 1 2.56 1 3.25v9.5c0 .68.56 1.24 1.25 1.24h.5C3.44 14 4 13.43 4 12.74v-9.5C4 2.57 3.44 2 2.75 2h-.5Zm4 0C5.55 2 5 2.56 5 3.25v9.5c0 .68.56 1.24 1.25 1.24h.5c.69 0 1.24-.56 1.24-1.25v-9.5C8 2.57 7.44 2 6.75 2h-.5Zm5.72 2.78a1.25 1.25 0 0 0-1.57-.72l-.58.2c-.67.24-1.01 1-.75 1.65l2.94 7.3c.25.63.94.94 1.57.72l.58-.2c.68-.24 1.02-.99.75-1.65l-2.94-7.3Z"
]);
const $77e1bce0ac0f7fe7$export$ca3a7deb4a8c44a8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library16Regular', "16", [
    "M1 3.25C1 2.55 1.56 2 2.25 2h.5C3.44 2 4 2.56 4 3.25v9.5c0 .69-.56 1.24-1.25 1.24h-.5C1.55 14 1 13.44 1 12.74v-9.5ZM2.25 3a.25.25 0 0 0-.25.25v9.5c0 .13.11.24.25.24h.5c.14 0 .25-.1.25-.25v-9.5A.25.25 0 0 0 2.75 3h-.5ZM5 3.25C5 2.55 5.56 2 6.25 2h.5c.68 0 1.24.56 1.24 1.25v9.5c0 .69-.56 1.24-1.24 1.24h-.5C5.55 14 5 13.44 5 12.74v-9.5ZM6.25 3a.25.25 0 0 0-.25.25v9.5c0 .13.1.24.25.24h.5c.13 0 .24-.1.24-.25v-9.5A.25.25 0 0 0 6.75 3h-.5Zm5.72 1.78a1.25 1.25 0 0 0-1.57-.72l-.58.2c-.67.24-1.01 1-.75 1.65l2.94 7.3c.25.63.94.94 1.57.72l.58-.2c.68-.24 1.02-.99.75-1.65l-2.94-7.3ZM10.73 5c.13-.05.27.02.32.14l2.93 7.3a.25.25 0 0 1-.15.33l-.58.2a.25.25 0 0 1-.31-.14L10 5.54a.25.25 0 0 1 .15-.33l.58-.2Z"
]);
const $77e1bce0ac0f7fe7$export$bb643549357f69fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library20Color', "20", `<path d="M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V3.5Z" fill="url(#ic_fluent_library_20_color__a)"/><path d="M7 3.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V3.5Z" fill="url(#ic_fluent_library_20_color__b)"/><path d="M15.72 6.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.85 1.15l.98-.25c.79-.2 1.27-1 1.1-1.78l-2.25-9.76Z" fill="url(#ic_fluent_library_20_color__c)"/><path d="M6 7H2V5h4v2Z" fill="url(#ic_fluent_library_20_color__d)"/><path d="m12.32 8.36 3.73-.76.45 1.95-3.78.76-.4-1.95Z" fill="url(#ic_fluent_library_20_color__e)"/><path d="M7 7h4V5H7v2Z" fill="url(#ic_fluent_library_20_color__f)"/><defs><linearGradient id="ic_fluent_library_20_color__a" x1="7.52" y1="4.99" x2="9.5" y2="22.35" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_20_color__b" x1="7.52" y1="4.99" x2="9.5" y2="22.35" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_20_color__c" x1="7.52" y1="4.99" x2="9.5" y2="22.35" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_20_color__d" x1="7" y1="4.09" x2="11" y2="6.5" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_20_color__e" x1="7" y1="4.09" x2="11" y2="6.5" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_20_color__f" x1="7" y1="4.09" x2="11" y2="6.5" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$ca4036e17e9e2d76 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library20Filled', "20", [
    "M3.5 2C2.67 2 2 2.67 2 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5C6 2.67 5.33 2 4.5 2h-1Zm5 0C7.67 2 7 2.67 7 3.5v12.98c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V3.5c0-.83-.67-1.5-1.5-1.5h-1Zm7.22 4.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78l-2.25-9.76Z"
]);
const $77e1bce0ac0f7fe7$export$c68c3f24d351ec39 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library20Regular', "20", [
    "M2 3.5C2 2.67 2.67 2 3.5 2h1C5.33 2 6 2.67 6 3.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V3.5ZM3.5 3a.5.5 0 0 0-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-1Zm3.5.5C7 2.67 7.67 2 8.5 2h1c.83 0 1.5.67 1.5 1.5v12.98c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5V3.5ZM8.5 3a.5.5 0 0 0-.5.5v12.98c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-1Zm7.22 3.16a1.5 1.5 0 0 0-1.87-1.1l-.75.2A1.5 1.5 0 0 0 12.04 7l2 9.8c.18.84 1.02 1.36 1.84 1.15l.99-.25c.79-.2 1.27-1 1.1-1.78l-2.25-9.76ZM14.12 6a.5.5 0 0 1 .62.37L17 16.14a.5.5 0 0 1-.37.6l-.98.25a.5.5 0 0 1-.61-.39l-2-9.8a.5.5 0 0 1 .35-.58l.74-.2Z"
]);
const $77e1bce0ac0f7fe7$export$775cea28b801f1c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library24Color', "24", `<path d="M5.5 3C6.33 3 7 3.67 7 4.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 19.5v-15C2 3.67 2.67 3 3.5 3h2Z" fill="url(#ic_fluent_library_24_color__a)"/><path d="M11.5 3c.83 0 1.5.67 1.5 1.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 8 19.5v-15C8 3.67 8.67 3 9.5 3h2Z" fill="url(#ic_fluent_library_24_color__b)"/><path d="M22 18.64 18.78 6.12a1.5 1.5 0 0 0-1.82-1.08l-1.88.49A1.5 1.5 0 0 0 14 7.35l3.21 12.52a1.5 1.5 0 0 0 1.83 1.08l1.88-.48A1.5 1.5 0 0 0 22 18.64Z" fill="url(#ic_fluent_library_24_color__c)"/><path d="M2 6h5v2H2V6Z" fill="url(#ic_fluent_library_24_color__d)"/><path d="m14.98 11.18 4.79-1.22-.5-1.93-4.79 1.21.5 1.94Z" fill="url(#ic_fluent_library_24_color__e)"/><path d="M13 6H8v2h5V6Z" fill="url(#ic_fluent_library_24_color__f)"/><defs><linearGradient id="ic_fluent_library_24_color__a" x1="-1.75" y1="3" x2="2.7" y2="26.49" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_24_color__b" x1="-1.75" y1="3" x2="2.7" y2="26.49" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_24_color__c" x1="-1.75" y1="3" x2="2.7" y2="26.49" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_24_color__d" x1="8" y1="2.18" x2="13.97" y2="4.43" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_24_color__e" x1="8" y1="2.18" x2="13.97" y2="4.43" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_24_color__f" x1="8" y1="2.18" x2="13.97" y2="4.43" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$eacb829816973375 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library24Filled', "24", [
    "M5.5 3C6.33 3 7 3.67 7 4.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 2 19.5v-15C2 3.67 2.67 3 3.5 3h2Zm6 0c.83 0 1.5.67 1.5 1.5v15c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 8 19.5v-15C8 3.67 8.67 3 9.5 3h2Zm7.28 3.12L22 18.64c.21.8-.27 1.62-1.07 1.83l-1.88.48a1.5 1.5 0 0 1-1.83-1.08L14 7.35a1.5 1.5 0 0 1 1.08-1.82l1.87-.49c.8-.2 1.63.28 1.83 1.08Z"
]);
const $77e1bce0ac0f7fe7$export$c5f634ab1adc95c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library24Regular', "24", [
    "M4 3h1a2 2 0 0 1 2 1.85V19a2 2 0 0 1-1.85 2H4a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2H5 4Zm6 0h1a2 2 0 0 1 2 1.85V19a2 2 0 0 1-1.85 2H10a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2H11h-1Zm6.97 2a2 2 0 0 1 1.9 1.35l.04.15 3.02 11.75a2 2 0 0 1-1.3 2.39l-.14.04-.97.25a2 2 0 0 1-2.39-1.28l-.05-.16-3.01-11.74a2 2 0 0 1 1.3-2.4l.14-.04.97-.25c.16-.04.33-.06.5-.06ZM5 4.5H4a.5.5 0 0 0-.5.41V19c0 .24.18.45.41.5H5a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5H5Zm6 0h-1a.5.5 0 0 0-.5.41V19c0 .24.18.45.41.5H11a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5H11Zm5.98 2h-.07l-.06.02-.97.24a.5.5 0 0 0-.38.51l.02.1 3.02 11.75c.06.26.3.37.48.37h.06l.06-.01.97-.25a.5.5 0 0 0 .38-.52l-.02-.09-3.01-11.74a.5.5 0 0 0-.48-.38Z"
]);
const $77e1bce0ac0f7fe7$export$5799b08562e2fded = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library28Color', "28", `<path d="M7.99 5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v18c0 1.1.9 2 2 2H6a2 2 0 0 0 2-2V5Z" fill="url(#ic_fluent_library_28_color__a)"/><path d="m22.07 6.54 3.86 15.49a2 2 0 0 1-1.46 2.42l-1.96.49a2 2 0 0 1-2.42-1.46L16.23 8a2 2 0 0 1 1.45-2.42l1.97-.5a2 2 0 0 1 2.42 1.46Z" fill="url(#ic_fluent_library_28_color__b)"/><path d="M12.99 3a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2H13Z" fill="url(#ic_fluent_library_28_color__c)"/><path d="M2 7h6v2H2V7Z" fill="url(#ic_fluent_library_28_color__d)"/><path d="M9 7h6v2H9V7Z" fill="url(#ic_fluent_library_28_color__e)"/><path d="m16.87 10.57 5.81-1.58.49 1.95-5.82 1.57-.48-1.94Z" fill="url(#ic_fluent_library_28_color__f)"/><defs><linearGradient id="ic_fluent_library_28_color__a" x1="4.51" y1="3" x2="10.05" y2="31.67" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_28_color__b" x1="4.51" y1="3" x2="10.05" y2="31.67" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_28_color__c" x1="4.51" y1="3" x2="10.05" y2="31.67" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_28_color__d" x1="16.87" y1="2.27" x2="24.87" y2="4.43" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_28_color__e" x1="16.87" y1="2.27" x2="24.87" y2="4.43" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_28_color__f" x1="16.87" y1="2.27" x2="24.87" y2="4.43" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$ce54b8f2bc4a345e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library28Filled', "28", [
    "M5.99 3a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2H6Zm7 0a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h2Zm9.08 3.54 3.86 15.49a2 2 0 0 1-1.46 2.42l-1.96.49a2 2 0 0 1-2.42-1.46L16.23 8a2 2 0 0 1 1.45-2.42l1.97-.5a2 2 0 0 1 2.42 1.46Z"
]);
const $77e1bce0ac0f7fe7$export$324c0f16d960966a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library28Regular', "28", [
    "M4 3h1.99a2 2 0 0 1 2 1.85V23a2 2 0 0 1-1.85 2H4a2 2 0 0 1-2-1.85V5a2 2 0 0 1 1.85-2H6 4Zm7 0h1.99a2 2 0 0 1 2 1.85V23a2 2 0 0 1-1.85 2h-2.15A2 2 0 0 1 9 23.15V5a2 2 0 0 1 1.85-2h2.14-2Zm9.13 2.03a2 2 0 0 1 1.9 1.36l.04.15 3.86 15.49a2 2 0 0 1-1.31 2.38l-.15.04-1.96.49a2 2 0 0 1-2.38-1.3l-.04-.16L16.23 8a2 2 0 0 1 1.3-2.38l.15-.04 1.97-.5c.16-.03.32-.05.48-.05ZM5.99 4.5H4a.5.5 0 0 0-.5.41V23c0 .24.18.45.41.5h2.08a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5h-.09Zm7 0h-2a.5.5 0 0 0-.49.41V23c0 .24.17.45.4.5H13a.5.5 0 0 0 .5-.41V5a.5.5 0 0 0-.41-.5h-.09Zm7.14 2.03h-.06l-.06.01-1.96.49a.5.5 0 0 0-.38.52l.01.09 3.86 15.48c.07.26.3.38.49.38h.06l.06-.02L24.1 23a.5.5 0 0 0 .38-.52l-.02-.1-3.86-15.47a.5.5 0 0 0-.48-.38Z"
]);
const $77e1bce0ac0f7fe7$export$fad11b49e8c5b7d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library32Color', "32", `<path d="M3 5.5A2.5 2.5 0 0 1 5.5 3h2A2.5 2.5 0 0 1 10 5.5v21A2.5 2.5 0 0 1 7.5 29h-2A2.5 2.5 0 0 1 3 26.5v-21Zm9 0A2.5 2.5 0 0 1 14.5 3h2A2.5 2.5 0 0 1 19 5.5v21a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5v-21Zm9.8 2.1a2.52 2.52 0 0 0-1.72 3.08l4.27 16.46a2.42 2.42 0 0 0 2.98 1.77l1.87-.52a2.52 2.52 0 0 0 1.72-3.07L26.65 8.86a2.42 2.42 0 0 0-2.98-1.77l-1.87.52Z" fill="url(#ic_fluent_library_32_color__a)"/><path d="M3 8h7v3H3V8Z" fill="url(#ic_fluent_library_32_color__b)"/><path d="m27.3 11.37-6.58 1.76.75 2.9 6.58-1.76-.75-2.9Z" fill="url(#ic_fluent_library_32_color__c)"/><path d="M19 8h-7v3h7V8Z" fill="url(#ic_fluent_library_32_color__d)"/><defs><linearGradient id="ic_fluent_library_32_color__a" x1="-18" y1="3" x2="-16.29" y2="38.07" gradientUnits="userSpaceOnUse"><stop stop-color="#43E5CA"/><stop offset="1" stop-color="#2764E7"/></linearGradient><linearGradient id="ic_fluent_library_32_color__b" x1="12" y1="2.27" x2="20.49" y2="5.25" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_32_color__c" x1="12" y1="2.27" x2="20.49" y2="5.25" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient><linearGradient id="ic_fluent_library_32_color__d" x1="12" y1="2.27" x2="20.49" y2="5.25" gradientUnits="userSpaceOnUse"><stop stop-color="#9FF0F9"/><stop offset="1" stop-color="#6CE0FF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$fbecd61f36260cb7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library32Filled', "32", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h2A2.5 2.5 0 0 1 10 5.5v21A2.5 2.5 0 0 1 7.5 29h-2A2.5 2.5 0 0 1 3 26.5v-21Zm9 0A2.5 2.5 0 0 1 14.5 3h2A2.5 2.5 0 0 1 19 5.5v21a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5v-21Zm9.8 2.1a2.52 2.52 0 0 0-1.72 3.08l4.27 16.46a2.42 2.42 0 0 0 2.98 1.77l1.87-.52a2.52 2.52 0 0 0 1.72-3.07L26.65 8.86a2.42 2.42 0 0 0-2.98-1.77l-1.87.52Z"
]);
const $77e1bce0ac0f7fe7$export$67c0775baabbf4de = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Library32Regular', "32", [
    "M3 5.5A2.5 2.5 0 0 1 5.5 3h2A2.5 2.5 0 0 1 10 5.5v21A2.5 2.5 0 0 1 7.5 29h-2A2.5 2.5 0 0 1 3 26.5v-21ZM5.5 5a.5.5 0 0 0-.5.5v21c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-21a.5.5 0 0 0-.5-.5h-2Zm6.5.5A2.5 2.5 0 0 1 14.5 3h2A2.5 2.5 0 0 1 19 5.5v21a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5v-21Zm2.5-.5a.5.5 0 0 0-.5.5v21c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-21a.5.5 0 0 0-.5-.5h-2Zm7.3 2.6a2.52 2.52 0 0 0-1.72 3.08l4.27 16.46a2.42 2.42 0 0 0 2.98 1.77l1.87-.52a2.52 2.52 0 0 0 1.72-3.07L26.65 8.86a2.42 2.42 0 0 0-2.98-1.77l-1.87.52Zm.16 2.56a.5.5 0 0 1 .34-.62l1.88-.52c.26-.07.52.09.6.36l4.26 16.46a.5.5 0 0 1-.34.62l-1.88.52a.48.48 0 0 1-.6-.36l-4.26-16.46Z"
]);
const $77e1bce0ac0f7fe7$export$176c1cbaedb2c917 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv16Filled', "16", [
    "M13.22 4.25 7.09 6.24a.5.5 0 0 1-.24.08L4.75 7h8.75c.28 0 .5.22.5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 12.5v-5c0-.1.03-.2.09-.29l-.2-.6A2.5 2.5 0 0 1 3.5 3.46l6.66-2.16a2.5 2.5 0 0 1 3.15 1.6l.23.72a.5.5 0 0 1-.32.63Zm-3.75.16 1.29-2.23-.3.07-1.24.4-1.3 2.27 1.55-.5Zm2.3-1.98-.02.04-.85 1.48 1.53-.5-.07-.24a1.5 1.5 0 0 0-.6-.78Zm-3.97.69-1.56.5-1.3 2.27 1.55-.51 1.3-2.26ZM2.92 6.54l.59-.2 1.3-2.26-1 .33a1.5 1.5 0 0 0-.96 1.9l.07.23Z"
]);
const $77e1bce0ac0f7fe7$export$12e58acf88f473aa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv16Regular', "16", [
    "M13.22 4.25 7.09 6.24a.5.5 0 0 1-.24.08L4.75 7h8.75c.28 0 .5.22.5.5v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 12.5v-5c0-.1.03-.2.09-.29l-.2-.6A2.5 2.5 0 0 1 3.5 3.46l6.66-2.16a2.5 2.5 0 0 1 3.15 1.6l.23.72a.5.5 0 0 1-.32.63Zm-3.75.16 1.29-2.23-.3.07-1.24.4-1.3 2.27 1.55-.5Zm2.3-1.98-.02.04-.85 1.48 1.53-.5-.07-.24a1.5 1.5 0 0 0-.6-.78Zm-3.97.69-1.56.5-1.3 2.27 1.55-.51 1.3-2.26ZM2.92 6.54l.59-.2 1.3-2.26-1 .33a1.5 1.5 0 0 0-.96 1.9l.07.23ZM3 8v4.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V8H3Z"
]);
const $77e1bce0ac0f7fe7$export$5c2262435a43e569 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv20Filled', "20", [
    "M16.13 5.38 7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V8.57l-.26-.9a2.5 2.5 0 0 1 1.71-3.09L13.1 2.1a2.5 2.5 0 0 1 3.1 1.7l.27.97a.5.5 0 0 1-.34.62ZM3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 0 0 3.7 7.4l.14.48Zm2-.57 2.11-.61L9.4 4.2l-2.13.61-.02.04-1.42 2.46Zm5.62-1.63 1.44-2.5-2.12.62-.03.05L9.34 6.3l2.12-.62Zm2.68-2.65c0 .02 0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 0 0-1.09-1.05Z"
]);
const $77e1bce0ac0f7fe7$export$98483777b9368bea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv20Regular', "20", [
    "M16.13 5.38 7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V8.57l-.26-.9a2.5 2.5 0 0 1 1.71-3.09L13.1 2.1a2.5 2.5 0 0 1 3.1 1.7l.27.97a.5.5 0 0 1-.34.62ZM3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 0 0 3.7 7.4l.14.48Zm2-.57 2.11-.61L9.4 4.2l-2.13.61-.02.04-1.42 2.46Zm5.62-1.63 1.44-2.5-2.12.62-.03.05L9.34 6.3l2.12-.62Zm2.68-2.65c0 .02 0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 0 0-1.09-1.05ZM4 9v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V9H4Z"
]);
const $77e1bce0ac0f7fe7$export$e200f3158e6d4b99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv24Filled', "24", [
    "m19.73 3.88.05.15.55 1.93c.1.36-.08.74-.42.89l-.1.03L9.1 9.96h11.16c.38 0 .7.28.74.65v8.6a2.75 2.75 0 0 1-2.57 2.74H5.75a2.75 2.75 0 0 1-2.74-2.57L3 19.2v-8.4L2.48 9c-.4-1.41.36-2.87 1.72-3.35l.16-.06 12.02-3.44c1.4-.4 2.87.36 3.35 1.73ZM6.27 6.6l-1.5.43c-.61.17-1 .8-.88 1.42l.03.12.34 1.2.3-.08 1.71-3.1Zm4.76-1.37-2.72.78-1.71 3.1 2.72-.79 1.7-3.09Zm4.76-1.36-2.72.78-1.71 3.09 2.71-.78 1.72-3.1Zm1.84-.23-1.52 2.74 2.57-.74-.34-1.2c-.1-.38-.38-.66-.7-.8Z"
]);
const $77e1bce0ac0f7fe7$export$922b24891072999d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('MoviesAndTv24Regular', "24", [
    "m19.73 3.92.05.16.55 1.92c.1.36-.08.74-.42.9l-.1.03L9.1 10h11.16c.38 0 .7.29.74.65v8.6A2.75 2.75 0 0 1 18.43 22H5.75a2.75 2.75 0 0 1-2.74-2.58L3 19.25v-8.4l-.52-1.81c-.4-1.4.36-2.87 1.72-3.35l.16-.05 12.02-3.45c1.4-.4 2.87.37 3.35 1.73Zm-.23 7.58h-15v7.75c0 .6.43 1.1 1 1.23l.12.01.13.01h12.5c.65 0 1.18-.5 1.24-1.12V11.5ZM6.27 6.65l-1.5.43c-.61.18-1 .8-.88 1.42l.03.12.34 1.2.3-.08 1.71-3.1Zm4.76-1.36-2.72.77-1.71 3.1 2.72-.78 1.7-3.1Zm4.76-1.37-2.72.78-1.71 3.1L14.07 7l1.72-3.09Zm1.84-.23-1.52 2.74 2.57-.74-.34-1.2c-.1-.37-.38-.66-.7-.8Z"
]);
const $77e1bce0ac0f7fe7$export$affea0695da8171f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward20Filled', "20", [
    "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V6H9.5A3.5 3.5 0 0 0 6 9.5V13H4.5A2.5 2.5 0 0 1 2 10.5v-6ZM9.5 7A2.5 2.5 0 0 0 7 9.5v6A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7h-6ZM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5v-6Z"
]);
const $77e1bce0ac0f7fe7$export$d867b308509cfb87 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward20Regular', "20", [
    "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H6v-1.7l-.7.7h-.8a1.5 1.5 0 0 1-.65-.15L6 9.71V9.5c0-.57.14-1.11.38-1.59l-3.23 3.24A1.5 1.5 0 0 1 3 10.5v-.94L9.56 3h.94c.23 0 .45.05.65.15L7.9 6.38A3.49 3.49 0 0 1 9.5 6h.2l2.15-2.15c.1.2.15.42.15.65v.8l-.7.7H13V4.5A2.5 2.5 0 0 0 10.5 2h-6ZM3 4.5C3 3.67 3.67 3 4.5 3h.65L3 5.15V4.5Zm0 2.06L6.56 3h1.59L3 8.15V6.56ZM7 9.5A2.5 2.5 0 0 1 9.5 7h6A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5v-6ZM9.5 8C8.67 8 8 8.67 8 9.5v6c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-6Z"
]);
const $77e1bce0ac0f7fe7$export$bb5219c1a5fdf6c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward24Filled', "24", [
    "M16.5 6.5h-5.75a4.25 4.25 0 0 0-4.25 4.25v5.75H5.25A3.25 3.25 0 0 1 2 13.25v-8C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V6.5ZM22 18.75c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25v-8c0-1.8 1.46-3.25 3.25-3.25h8c1.8 0 3.25 1.46 3.25 3.25v8Zm-3.25 1.75c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75h-8C9.78 9 9 9.78 9 10.75v8c0 .97.78 1.75 1.75 1.75h8Z"
]);
const $77e1bce0ac0f7fe7$export$c09a87185cf927c0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionBackward24Regular', "24", [
    "M6.5 16.5H5.25A3.25 3.25 0 0 1 2 13.25v-8C2 3.45 3.46 2 5.25 2h8c1.8 0 3.25 1.46 3.25 3.25V6.5h-1.65l.15-.15v-1.1c0-.23-.04-.45-.13-.65l-1.9 1.9h-2.12l2.92-2.92a1.75 1.75 0 0 0-.52-.08h-1.28L3.5 11.97v1.28c0 .18.03.36.08.52l2.92-2.92v2.12l-1.9 1.9c.2.09.42.13.65.13h1.1l.15-.15v1.65Zm3.35-13H7.97L3.5 7.97v1.88L9.85 3.5Zm-4 0h-.6c-.97 0-1.75.78-1.75 1.75v.6L5.85 3.5ZM22 18.75c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25v-8c0-1.8 1.46-3.25 3.25-3.25h8c1.8 0 3.25 1.46 3.25 3.25v8Zm-3.25 1.75c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75h-8C9.78 9 9 9.78 9 10.75v8c0 .97.78 1.75 1.75 1.75h8Z"
]);
const $77e1bce0ac0f7fe7$export$1b7d10a208473450 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward20Filled', "20", [
    "M7 14v1.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5V14H7ZM2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5v-6Z"
]);
const $77e1bce0ac0f7fe7$export$f25d83c9ee7298a2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward20Regular', "20", [
    "M7 14v1.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H14v1h1.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5V14H7ZM2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5v-6ZM4.5 3C3.67 3 3 3.67 3 4.5v.65L5.15 3H4.5Zm2.06 0L3 6.56v1.59L8.15 3H6.56ZM3 10.5c0 .23.05.45.15.65l8-8A1.5 1.5 0 0 0 10.5 3h-.94L3 9.56v.94ZM4.5 12h.8L12 5.3v-.8c0-.23-.05-.45-.15-.65l-8 8c.2.1.42.15.65.15Zm5.2 0h.8c.83 0 1.5-.67 1.5-1.5v-.8L9.7 12Zm-1.4 0L12 8.3V6.7L6.7 12h1.6Z"
]);
const $77e1bce0ac0f7fe7$export$47ffb89d813c639e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward24Filled', "24", [
    "M13.25 16.5c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25h-8A3.25 3.25 0 0 0 2 5.25v8c0 1.8 1.46 3.25 3.25 3.25h8Zm-5.75 1H9v1.25c0 .97.78 1.75 1.75 1.75h8c.97 0 1.75-.78 1.75-1.75v-8c0-.97-.78-1.75-1.75-1.75H17.5V7.5h1.25c1.8 0 3.25 1.46 3.25 3.25v8c0 1.8-1.46 3.25-3.25 3.25h-8a3.25 3.25 0 0 1-3.25-3.25V17.5Z"
]);
const $77e1bce0ac0f7fe7$export$dbab8d55caeb3f3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionForward24Regular', "24", [
    "M18.75 22c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25H17.5V9h1.25c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75h-8c-.97 0-1.75-.78-1.75-1.75V17.5H7.5v1.25c0 1.8 1.46 3.25 3.25 3.25h8Zm-5.5-5.5c1.8 0 3.25-1.46 3.25-3.25v-8c0-1.8-1.46-3.25-3.25-3.25h-8A3.25 3.25 0 0 0 2 5.25v8c0 1.8 1.46 3.25 3.25 3.25h8ZM15 13.25c0 .97-.78 1.75-1.75 1.75h-.78L15 12.47v.78Zm0-2.78L10.47 15h-2L15 8.47v2ZM6.35 15h-1.1c-.23 0-.45-.04-.65-.13L14.87 4.6c.09.2.13.42.13.65v1.1L6.35 15Zm-2.77-1.23a1.75 1.75 0 0 1-.08-.52v-1.28l8.47-8.47h1.28c.18 0 .36.03.52.08L3.57 13.77ZM3.5 9.85V7.97L7.97 3.5h1.88L3.5 9.85Zm0-4v-.6c0-.97.78-1.75 1.75-1.75h.6L3.5 5.85Z"
]);
const $77e1bce0ac0f7fe7$export$836512b89f199503 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack20Filled', "20", [
    "M12 14c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3ZM5 9h1.3C7.8 9 9 7.8 9 6.3V5h3.5A2.5 2.5 0 0 1 15 7.5V11h-1.3a2.7 2.7 0 0 0-2.7 2.7V15H7.5A2.5 2.5 0 0 1 5 12.5V9ZM1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3Z"
]);
const $77e1bce0ac0f7fe7$export$123e8721148b75b1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack20Regular', "20", [
    "M12 14c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-3ZM5 9v3.5A2.5 2.5 0 0 0 7.5 15H11v-1H9.7l1.67-1.66c.23-.4.57-.74.97-.97L14 9.7V11h1V7.5A2.5 2.5 0 0 0 12.5 5H9v1h1.3L8.62 7.66c-.23.4-.57.74-.97.97L6 10.3V9H5Zm6.7-3h.8c.23 0 .45.05.65.15l-7 7A1.5 1.5 0 0 1 6 12.5v-.8L11.7 6Zm-4.2 8a1.5 1.5 0 0 1-.65-.15l7-7c.1.2.15.42.15.65v.8L8.3 14h-.8ZM1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3Z"
]);
const $77e1bce0ac0f7fe7$export$8a387c36b1bd3cfa = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack24Filled', "24", [
    "M6 11h1.25A3.75 3.75 0 0 0 11 7.25V6h3.75C16.55 6 18 7.46 18 9.25V13h-1.25A3.75 3.75 0 0 0 13 16.75V18H9.25A3.25 3.25 0 0 1 6 14.75V11ZM1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75v3.5A2.75 2.75 0 0 1 7.25 10h-3.5A2.75 2.75 0 0 1 1 7.25v-3.5ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5ZM14 16.75A2.75 2.75 0 0 1 16.75 14h3.5A2.75 2.75 0 0 1 23 16.75v3.5A2.75 2.75 0 0 1 20.25 23h-3.5A2.75 2.75 0 0 1 14 20.25v-3.5Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$55a5a5e6dc13ff3 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToBack24Regular', "24", [
    "M14 16.75A2.75 2.75 0 0 1 16.75 14h3.5A2.75 2.75 0 0 1 23 16.75v3.5A2.75 2.75 0 0 1 20.25 23h-3.5A2.75 2.75 0 0 1 14 20.25v-3.5Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5ZM6 11v3.75C6 16.55 7.46 18 9.25 18H13v-1.5h-.32l.37-.37a3.75 3.75 0 0 1 3.08-3.08l.37-.37v.33l.25-.01H18V9.25C18 7.45 16.54 6 14.75 6H11v1.5h.56l-.68.68a3.76 3.76 0 0 1-2.7 2.7l-.68.68V11l-.25.01H6Zm7.68-3.5h1.07c.24 0 .47.05.68.14l-7.8 7.79c-.08-.21-.13-.44-.13-.68v-1.07l6.18-6.18Zm-4.43 9c-.17 0-.34-.02-.5-.07l7.68-7.68c.05.16.07.33.07.5v1.31l-5.94 5.94H9.25ZM1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75v3.5A2.75 2.75 0 0 1 7.25 10h-3.5A2.75 2.75 0 0 1 1 7.25v-3.5ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-3.5Z"
]);
const $77e1bce0ac0f7fe7$export$c7d3c6d8d7a468c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront20Filled', "20", [
    "M1 3c0-1.1.9-2 2-2h3a2 2 0 0 1 2 2v1h-.5c-.17 0-.34.01-.5.04V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1.04C4 7.16 4 7.33 4 7.5V8H3a2 2 0 0 1-2-2V3Zm11 13v1c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2h-1v.5c0 .17-.01.34-.04.5H17a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.04c-.16.03-.33.04-.5.04H12ZM5 7.5A2.5 2.5 0 0 1 7.5 5h5A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 12.5v-5Z"
]);
const $77e1bce0ac0f7fe7$export$9fce5288847c1353 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront20Regular', "20", [
    "M3 1a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h1v-.5c0-.17.01-.34.04-.5H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1.04C7.16 4 7.33 4 7.5 4H8V3a2 2 0 0 0-2-2H3Zm9 16v-1h.5c.17 0 .34-.01.5-.04V17a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-1.04c.03-.16.04-.33.04-.5V12h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2ZM5 7.5A2.5 2.5 0 0 1 7.5 5h5A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 12.5v-5Zm2.28-1.48a1.5 1.5 0 0 0-1.26 1.26l1.26-1.26ZM6 10.29 10.3 6H8.7L6 8.7v1.6ZM11.7 6 6 11.7v.8c0 .23.05.45.15.65l7-7A1.5 1.5 0 0 0 12.5 6h-.8Zm-4.2 8h.8L14 8.3v-.8c0-.23-.05-.45-.15-.65l-7 7c.2.1.42.15.65.15Zm2.2 0h1.6l2.7-2.7V9.7L9.7 14Zm3.02-.02a1.5 1.5 0 0 0 1.26-1.26l-1.26 1.26Z"
]);
const $77e1bce0ac0f7fe7$export$9007870bb3b5f510 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront24Filled', "24", [
    "M1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75V5h-.75c-.26 0-.5.02-.75.07V3.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h1.32c-.05.24-.07.5-.07.75V10H3.75A2.75 2.75 0 0 1 1 7.25v-3.5ZM14 19v1.25A2.75 2.75 0 0 0 16.75 23h3.5A2.75 2.75 0 0 0 23 20.25v-3.5A2.75 2.75 0 0 0 20.25 14H19v.75c0 .26-.02.5-.07.75h1.32c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-1.32c-.24.05-.5.07-.75.07H14ZM6 9.25C6 7.45 7.46 6 9.25 6h5.5C16.55 6 18 7.46 18 9.25v5.5c0 1.8-1.46 3.25-3.25 3.25h-5.5A3.25 3.25 0 0 1 6 14.75v-5.5Z"
]);
const $77e1bce0ac0f7fe7$export$617fc168886cb7a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('PositionToFront24Regular', "24", [
    "M1 3.75A2.75 2.75 0 0 1 3.75 1h3.5A2.75 2.75 0 0 1 10 3.75V5h-.75c-.26 0-.5.02-.75.07V3.75c0-.69-.56-1.25-1.25-1.25h-3.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h1.32c-.05.24-.07.5-.07.75V10H3.75A2.75 2.75 0 0 1 1 7.25v-3.5ZM14 19v1.25A2.75 2.75 0 0 0 16.75 23h3.5A2.75 2.75 0 0 0 23 20.25v-3.5A2.75 2.75 0 0 0 20.25 14H19v.75c0 .26-.02.5-.07.75h1.32c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-1.32c-.24.05-.5.07-.75.07H14ZM9.25 6A3.25 3.25 0 0 0 6 9.25v5.5C6 16.55 7.46 18 9.25 18h5.5c1.8 0 3.25-1.46 3.25-3.25v-5.5C18 7.45 16.54 6 14.75 6h-5.5Zm2.31 1.5L7.5 11.56V9.68L9.68 7.5h1.88ZM7.5 13.68l6.18-6.18h1.07c.24 0 .47.05.68.14l-7.8 7.79c-.08-.21-.13-.44-.13-.68v-1.07Zm1.25 2.75 7.68-7.68c.05.16.07.33.07.5v1.31l-5.94 5.94H9.25c-.17 0-.34-.02-.5-.07Zm5.94.07h-2l3.81-3.82v2.07l-.03-.03-1.78 1.78Z"
]);
const $77e1bce0ac0f7fe7$export$648b29bb39136c5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler16Filled', "16", [
    "M9.5 2c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 5 12.5v-9C5 2.67 5.67 2 6.5 2h3Zm-2 9a.5.5 0 0 0 0-1H6v1h1.5ZM8 8.5a.5.5 0 0 0 0-1H6v1h2ZM7.5 6a.5.5 0 0 0 0-1H6v1h1.5Z"
]);
const $77e1bce0ac0f7fe7$export$b12808b208d8fe30 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler16Regular', "16", [
    "M11 3.5c0-.83-.67-1.5-1.5-1.5h-3C5.67 2 5 2.67 5 3.5v9c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-9ZM9.5 3c.28 0 .5.22.5.5v9a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V11h1.5a.5.5 0 0 0 0-1H6V8.5h2a.5.5 0 1 0 0-1H6V6h1.5a.5.5 0 1 0 0-1H6V3.5c0-.28.22-.5.5-.5h3Z"
]);
const $77e1bce0ac0f7fe7$export$913c4f785173202a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler20Filled', "20", [
    "m13.97 3.2.03.3v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 6 16.5v-13A1.5 1.5 0 0 1 7.5 2h5c.72 0 1.33.51 1.47 1.2ZM7 14.5v1h1.5a.5.5 0 0 0 0-1H7Zm0-10v1h1.5a.5.5 0 0 0 0-1H7ZM7 7v1h2.5a.5.5 0 0 0 0-1H7Zm0 2.5v1h1.5a.5.5 0 0 0 0-1H7ZM7 12v1h2.5a.5.5 0 1 0 0-1H7Z"
]);
const $77e1bce0ac0f7fe7$export$8ff0c77d1508ece8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler20Regular', "20", [
    "M14 3.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 2 6 2.67 6 3.5v13c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-13ZM7 13h2.5a.5.5 0 0 0 0-1H7v-1.5h1.5a.5.5 0 0 0 0-1H7V8h2.5a.5.5 0 0 0 0-1H7V5.5h1.5a.5.5 0 0 0 0-1H7v-1c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1h1.5a.5.5 0 0 0 0-1H7V13Z"
]);
const $77e1bce0ac0f7fe7$export$4b1ee5590a3e286f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler24Filled', "24", [
    "M7 4.25C7 3.01 8 2 9.25 2h5.5C15.99 2 17 3 17 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.5A2.26 2.26 0 0 1 7 19.75V4.25ZM8.5 5v1.5h1.75a.75.75 0 0 0 0-1.5H8.5Zm0 3v1.5h3.75a.75.75 0 0 0 0-1.5H8.5Zm0 3.25v1.5h1.75a.75.75 0 0 0 0-1.5H8.5Zm0 3.25V16h3.75a.75.75 0 0 0 0-1.5H8.5Zm0 3V19h1.75a.75.75 0 0 0 0-1.5H8.5Z"
]);
const $77e1bce0ac0f7fe7$export$48e29013c50dbb9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler24Regular', "24", [
    "M9.25 2C8.01 2 7 3 7 4.25v15.5C7 20.99 8 22 9.25 22h5.5c1.24 0 2.25-1 2.25-2.25V4.25C17 3.01 16 2 14.75 2h-5.5ZM8.5 19h1.75a.75.75 0 0 0 0-1.5H8.5V16h3.75a.75.75 0 0 0 0-1.5H8.5v-1.75h1.75a.75.75 0 0 0 0-1.5H8.5V9.5h3.75a.75.75 0 0 0 0-1.5H8.5V6.5h1.75a.75.75 0 0 0 0-1.5H8.5v-.75c0-.41.34-.75.75-.75h5.5c.41 0 .75.34.75.75v15.5c0 .41-.34.75-.75.75h-5.5a.75.75 0 0 1-.75-.75V19Z"
]);
const $77e1bce0ac0f7fe7$export$422b4710715dadb1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler28Filled', "28", [
    "M9 2.63c.48-.4 1.09-.63 1.75-.63h6.5A2.75 2.75 0 0 1 20 4.75v18.5A2.75 2.75 0 0 1 17.25 26h-6.5A2.75 2.75 0 0 1 8 23.25V4.75a2.74 2.74 0 0 1 1-2.12Zm.5 3.12v1.5h2.75a.75.75 0 0 0 0-1.5H9.5Zm0 3.75V11h4.75a.75.75 0 0 0 0-1.5H9.5Zm0 3.75v1.5h2.75a.75.75 0 0 0 0-1.5H9.5Zm0 3.75v1.5h4.75a.75.75 0 0 0 0-1.5H9.5Zm0 3.75v1.5h2.75a.75.75 0 0 0 0-1.5H9.5Z"
]);
const $77e1bce0ac0f7fe7$export$d25a944258119fcc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler28Regular', "28", [
    "M10.75 2A2.75 2.75 0 0 0 8 4.75v18.5A2.75 2.75 0 0 0 10.75 26h6.5A2.75 2.75 0 0 0 20 23.25V4.75A2.75 2.75 0 0 0 17.25 2h-6.5ZM9.5 14.75h2.75a.75.75 0 0 0 0-1.5H9.5V11h4.75a.75.75 0 0 0 0-1.5H9.5V7.25h2.75a.75.75 0 0 0 0-1.5H9.5v-1c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25v18.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-1h2.75a.75.75 0 0 0 0-1.5H9.5V18.5h4.75a.75.75 0 0 0 0-1.5H9.5v-2.25Z"
]);
const $77e1bce0ac0f7fe7$export$30580676c98dd434 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler32Filled', "32", [
    "M9 5.5A3.5 3.5 0 0 1 12.5 2h7A3.5 3.5 0 0 1 23 5.5v21a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 9 26.5v-21Zm2 .5v2h3a1 1 0 1 0 0-2h-3Zm0 4.5v2h5a1 1 0 1 0 0-2h-5Zm0 4.5v2h3a1 1 0 1 0 0-2h-3Zm0 4.5v2h5a1 1 0 1 0 0-2h-5Zm0 4.5v2h3a1 1 0 1 0 0-2h-3Z"
]);
const $77e1bce0ac0f7fe7$export$298bfec57ff60727 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler32Regular', "32", [
    "M12.5 2A3.5 3.5 0 0 0 9 5.5v21a3.5 3.5 0 0 0 3.5 3.5h7a3.5 3.5 0 0 0 3.5-3.5v-21A3.5 3.5 0 0 0 19.5 2h-7ZM11 8h3a1 1 0 1 0 0-2h-3v-.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5v21c0 .83-.67 1.5-1.5 1.5h-7a1.5 1.5 0 0 1-1.5-1.5V26h3a1 1 0 1 0 0-2h-3v-2.5h5a1 1 0 1 0 0-2h-5V17h3a1 1 0 1 0 0-2h-3v-2.5h5a1 1 0 1 0 0-2h-5V8Z"
]);
const $77e1bce0ac0f7fe7$export$69ea3ab0810bdd6e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler48Filled', "48", [
    "M14.02 7.82A4.25 4.25 0 0 1 18.25 4h11.5C32.1 4 34 5.9 34 8.25v31.5C34 42.1 32.1 44 29.75 44h-11.5A4.25 4.25 0 0 1 14 39.75V8.25c0-.15 0-.3.02-.43Zm2.48 2.43v2.5h4.25a1.25 1.25 0 1 0 0-2.5H16.5Zm0 6.25V19h8.25a1.25 1.25 0 1 0 0-2.5H16.5Zm0 6.25v2.5h4.25a1.25 1.25 0 1 0 0-2.5H16.5Zm0 6.25v2.5h8.25a1.25 1.25 0 1 0 0-2.5H16.5Zm0 6.25v2.5h4.25a1.25 1.25 0 1 0 0-2.5H16.5Z"
]);
const $77e1bce0ac0f7fe7$export$c64cf47e612846df = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Ruler48Regular', "48", [
    "M18.25 4A4.25 4.25 0 0 0 14 8.25v31.5C14 42.1 15.9 44 18.25 44h11.5C32.1 44 34 42.1 34 39.75V8.25C34 5.9 32.1 4 29.75 4h-11.5Zm-1.75 8.75h4.25a1.25 1.25 0 1 0 0-2.5H16.5v-2c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v31.5c0 .97-.78 1.75-1.75 1.75h-11.5c-.97 0-1.75-.78-1.75-1.75v-2h4.25a1.25 1.25 0 1 0 0-2.5H16.5V31.5h8.25a1.25 1.25 0 1 0 0-2.5H16.5v-3.75h4.25a1.25 1.25 0 1 0 0-2.5H16.5V19h8.25a1.25 1.25 0 1 0 0-2.5H16.5v-3.75Z"
]);
const $77e1bce0ac0f7fe7$export$f13a13858791bb90 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent12Filled', "12", [
    "M6.43 1.46a.5.5 0 0 0-.77 0c-.72.87-2.18 1.92-3.01 2.39a.5.5 0 0 0-.25.37L1.74 9H1.5a.5.5 0 1 0 0 1h9a.5.5 0 1 0 0-1h-.14L9.7 4.22a.5.5 0 0 0-.25-.37 12.87 12.87 0 0 1-3.02-2.4ZM4.83 9c.41-.63.82-1.42 1.2-2.5.36 1 .75 1.77 1.21 2.5h-2.4Z"
]);
const $77e1bce0ac0f7fe7$export$8647d4364890732f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent12Regular', "12", [
    "M6.43 1.46a.5.5 0 0 0-.77 0c-.72.87-2.18 1.92-3.01 2.39a.5.5 0 0 0-.25.37L1.74 9H1.5a.5.5 0 1 0 0 1h9a.5.5 0 1 0 0-1h-.14L9.7 4.22a.5.5 0 0 0-.25-.37 12.87 12.87 0 0 1-3.02-2.4ZM8.44 9c-.8-1.15-1.38-2.3-1.92-4.36a.5.5 0 0 0-.97 0C4.95 6.94 4.26 8.12 3.62 9h-.87l.6-4.4c.78-.47 1.9-1.28 2.7-2.08.8.8 1.92 1.61 2.7 2.08l.6 4.4h-.9Zm-1.2 0h-2.4c.4-.63.81-1.42 1.2-2.5.35 1 .74 1.77 1.2 2.5Z"
]);
const $77e1bce0ac0f7fe7$export$63068f4c226c959f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent16Filled', "16", [
    "M8.4 1.35a.5.5 0 0 0-.76 0 18.24 18.24 0 0 1-4.3 3.4.5.5 0 0 0-.24.37L2.15 12h-.66a.5.5 0 0 0 0 1H14.5a.5.5 0 0 0 0-1h-.6l-.96-6.88a.5.5 0 0 0-.25-.37 18.24 18.24 0 0 1-4.28-3.4ZM5.95 12A16.5 16.5 0 0 0 8 7.66c.6 1.81 1.25 3.1 2.06 4.34H5.94Z"
]);
const $77e1bce0ac0f7fe7$export$9ac15ed21e00dc5a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent16Regular', "16", [
    "M8.4 1.35a.5.5 0 0 0-.76 0 18.24 18.24 0 0 1-4.3 3.4.5.5 0 0 0-.24.37L2.15 12h-.66a.5.5 0 0 0 0 1H14.5a.5.5 0 0 0 0-1h-.6l-.96-6.88a.5.5 0 0 0-.25-.37 18.23 18.23 0 0 1-4.28-3.4ZM11.28 12A17.4 17.4 0 0 1 8.5 5.73a.5.5 0 0 0-.97 0c-.86 3.34-1.87 5-2.8 6.27H3.16l.9-6.5c1.12-.66 2.84-1.9 3.96-3.08A20.47 20.47 0 0 0 12 5.5l.9 6.5h-1.62Zm-1.2 0H5.93A16.5 16.5 0 0 0 8 7.66c.6 1.81 1.25 3.1 2.06 4.34Z"
]);
const $77e1bce0ac0f7fe7$export$33a82671f56cf400 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent20Filled', "20", [
    "M10.4 2.82a.5.5 0 0 0-.77 0 20.89 20.89 0 0 1-4.91 3.9.5.5 0 0 0-.25.36L3.37 15H2.5a.5.5 0 0 0 0 1h3.94a.5.5 0 0 0 .1.01h6.9a.5.5 0 0 0 .1-.01h3.96a.5.5 0 0 0 0-1h-.84l-1.1-7.92a.5.5 0 0 0-.24-.36 20.89 20.89 0 0 1-4.92-3.9ZM7.51 15c.84-1.22 1.7-2.79 2.49-5.26.7 2.23 1.5 3.78 2.49 5.26H7.5Z"
]);
const $77e1bce0ac0f7fe7$export$32e39c925e98ca29 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent20Regular', "20", [
    "M10.4 2.82a.5.5 0 0 0-.77 0 20.89 20.89 0 0 1-4.91 3.9.5.5 0 0 0-.25.36L3.37 15H2.5a.5.5 0 0 0 0 1h3.94a.5.5 0 0 0 .1.01h6.9a.5.5 0 0 0 .1-.01h3.96a.5.5 0 0 0 0-1h-.84l-1.1-7.92a.5.5 0 0 0-.24-.36 20.89 20.89 0 0 1-4.92-3.9ZM13.7 15a19.92 19.92 0 0 1-3.22-7.2.5.5 0 0 0-.97 0c-.98 3.84-2.14 5.75-3.22 7.2H4.4l1.03-7.54c1.3-.76 3.3-2.2 4.6-3.57a23.15 23.15 0 0 0 4.6 3.57L15.64 15h-1.96Zm-1.22 0H7.52c.84-1.22 1.7-2.78 2.48-5.25.7 2.23 1.49 3.77 2.48 5.25Z"
]);
const $77e1bce0ac0f7fe7$export$bad77674c7b19710 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent24Filled', "24", [
    "M12.26 2.2a.75.75 0 0 0-1.04.02l-1.7 1.7a19.93 19.93 0 0 1-3.84 3c-.4.23-.66.63-.72 1.09L3.6 17.5h-.85a.75.75 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5h-.85l-1.35-9.45a1.56 1.56 0 0 0-.8-1.15 20.82 20.82 0 0 1-4.23-3.06L12.26 2.2Zm1.84 12.92a18.4 18.4 0 0 0 1.65 2.38H8.28c.54-.66 1.18-1.52 1.64-2.4a43.26 43.26 0 0 0 2.06-5.02l.19.53a32.4 32.4 0 0 0 1.93 4.5Z"
]);
const $77e1bce0ac0f7fe7$export$8d9a389c2e1223b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent24Regular', "24", [
    "M11.22 2.22a.75.75 0 0 1 1.04-.02l1.76 1.64c1.28 1.2 2.7 2.22 4.23 3.06.43.23.73.66.8 1.15l1.35 9.45h.85a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h.85L4.96 8c.06-.45.33-.85.72-1.08 1.4-.84 2.69-1.85 3.84-3l1.7-1.7ZM5.12 17.5h2.13a23.31 23.31 0 0 0 3.5-7.16l.53-1.8a.75.75 0 0 1 1.44 0l.52 1.8c.75 2.57 1.94 5 3.51 7.16h2.14l-1.33-9.24A22.31 22.31 0 0 1 13 4.94l-1.22-1.15-1.19 1.19a21.43 21.43 0 0 1-4.14 3.24L5.11 17.5Zm9.8 0A24.81 24.81 0 0 1 12 11.4a24.81 24.81 0 0 1-2.93 6.1h5.86Z"
]);
const $77e1bce0ac0f7fe7$export$608c071fc8ba275 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent28Filled', "28", [
    "M14.6 3.21a.75.75 0 0 0-1.15 0c-1.8 2.15-5.34 4.71-7.37 5.85a.75.75 0 0 0-.38.55L4.06 21.5H2.75a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5h-1.26L22.35 9.61a.75.75 0 0 0-.38-.55c-2.03-1.14-5.57-3.7-7.37-5.85ZM10.27 21.5A28.31 28.31 0 0 0 14 13.6a29.27 29.27 0 0 0 3.73 7.9h-7.46Z"
]);
const $77e1bce0ac0f7fe7$export$62433f5c0765a6bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent28Regular', "28", [
    "M14.6 3.21a.75.75 0 0 0-1.15 0c-1.8 2.15-5.34 4.71-7.37 5.85a.75.75 0 0 0-.38.55L4.06 21.5H2.75a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5h-1.26L22.35 9.61a.75.75 0 0 0-.38-.55c-2.03-1.14-5.57-3.7-7.37-5.85Zm4.94 18.27c-2.04-2.87-3.48-5.67-4.82-10.8a.75.75 0 0 0-1.45.01c-1.47 5.75-3.22 8.62-4.83 10.8H5.58l1.55-11.3a34.72 34.72 0 0 0 6.9-5.37 34.73 34.73 0 0 0 6.89 5.36l1.55 11.3h-2.93Zm-1.82 0h-7.44A28.32 28.32 0 0 0 14 13.61a29.28 29.28 0 0 0 3.72 7.87Z"
]);
const $77e1bce0ac0f7fe7$export$a6e5c617789c98d0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent48Filled', "48", [
    "M25 6.02a1.25 1.25 0 0 0-1.92 0c-2.99 3.59-8.9 7.85-12.29 9.75-.34.19-.57.53-.63.92L7.43 36.5H5.25a1.25 1.25 0 0 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5h-2.1l-2.73-19.81a1.25 1.25 0 0 0-.63-.92C33.9 13.87 28 9.6 25 6.02ZM17.8 36.5c2.1-3.05 4.26-6.97 6.21-13.15a48.79 48.79 0 0 0 6.21 13.15H17.8Z"
]);
const $77e1bce0ac0f7fe7$export$9c0e58d5b39fde64 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Tent48Regular', "48", [
    "M25 6.02a1.25 1.25 0 0 0-1.92 0c-2.99 3.59-8.9 7.85-12.29 9.75-.34.19-.57.53-.63.92l-2.73 19.8H5.25a1.25 1.25 0 0 0 0 2.5h37.5a1.25 1.25 0 1 0 0-2.5h-2.1l-2.73-19.8a1.25 1.25 0 0 0-.63-.92C33.9 13.87 28 9.6 25 6.02Zm8.23 30.45c-3.4-4.79-5.8-9.46-8.02-17.99a1.25 1.25 0 0 0-2.43 0c-2.45 9.6-5.37 14.37-8.05 18H9.96l2.6-18.84c3.25-1.9 8.26-5.52 11.48-8.94 3.22 3.42 8.23 7.03 11.49 8.94l2.6 18.83h-4.9Zm-3.03 0H17.8c2.1-3.04 4.25-6.95 6.2-13.12a48.79 48.79 0 0 0 6.2 13.12Z"
]);
const $77e1bce0ac0f7fe7$export$3d2e8c11a3b24c40 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather20Filled', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1Zm-5 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM10 8.5a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1V8.5Zm0 7.5c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5ZM2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7l-1 1Zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7Zm-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7l-1-1Zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$c2ade1840e96a5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather20Regular', "20", [
    "M10.5 2.5a.5.5 0 0 0-1 0v1a.5.5 0 0 0 1 0v-1Zm-.5 6a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1h-1V8.5Zm0-3a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM6.5 10a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm3.5 6c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0v-1c0-.28.22-.5.5-.5ZM2.5 9.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM16 10c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM4.15 15.15a.5.5 0 0 0 .7.7l1-1a.5.5 0 0 0-.7-.7l-1 1Zm10-10 1-1a.5.5 0 0 1 .7.7l-1 1a.5.5 0 0 1-.7-.7Zm-9.3-1a.5.5 0 1 0-.7.7l1 1a.5.5 0 1 0 .7-.7l-1-1Zm10 10 1 1a.5.5 0 0 1-.7.7l-1-1a.5.5 0 0 1 .7-.7Z"
]);
const $77e1bce0ac0f7fe7$export$95baa5b74ec920a4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather24Filled', "24", [
    "M12 18.53a1 1 0 0 1 .99.89v1.57a1 1 0 0 1-1.99.11v-1.57a1 1 0 0 1 1-1Zm6.03-1.93 1.03 1.03a1 1 0 0 1-1.41 1.41l-1.03-1.03a1 1 0 0 1 1.41-1.41Zm-10.66 0a1 1 0 0 1 0 1.41l-1.03 1.03a1 1 0 0 1-1.41-1.41l1.03-1.03a1 1 0 0 1 1.41 0Zm4.64-10.13a5.52 5.52 0 1 1 0 11.05 5.52 5.52 0 0 1 0-11.05ZM11.25 9c-.38 0-.7.28-.74.65l-.01.1v3.1c.05.34.32.6.65.65h2.2c.33-.05.6-.31.64-.64l.01-.1v-.1a.75.75 0 0 0-.65-.65H12V9.64a.75.75 0 0 0-.75-.65Zm9.73 2.02a1 1 0 0 1 .11 2h-1.57a1 1 0 0 1-.11-2h1.57Zm-16.5-.03a1 1 0 0 1 .12 2H3.02a1 1 0 0 1-.11-2h1.57Zm1.77-6.12.1.09 1.02 1.03a1 1 0 0 1-1.32 1.5l-.09-.09-1.03-1.03a1 1 0 0 1 1.32-1.5Zm12.81.09a1 1 0 0 1 .09 1.32l-.09.1-1.03 1.02a1 1 0 0 1-1.5-1.32l.09-.1 1.03-1.02a1 1 0 0 1 1.41 0ZM12 2a1 1 0 0 1 1 .89v1.57a1 1 0 0 1-2 .12V3a1 1 0 0 1 1-1Z"
]);
const $77e1bce0ac0f7fe7$export$e8c27ba200d3b489 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimeAndWeather24Regular', "24", [
    "M12 19.01c.38 0 .69.28.74.65v1.6a.75.75 0 0 1-1.49.1v-1.6c0-.41.33-.75.75-.75Zm6.02-2.07L19.08 18a.75.75 0 0 1-1.06 1.06L16.96 18a.75.75 0 1 1 1.06-1.06Zm-10.99 0c.3.29.3.77 0 1.06l-1.06 1.06A.75.75 0 1 1 4.91 18l1.06-1.06c.3-.3.77-.3 1.06 0ZM12 6.47a5.53 5.53 0 1 1 0 11.05 5.53 5.53 0 0 1 0-11.05Zm0 1.5a4.03 4.03 0 1 0 0 8.05 4.03 4.03 0 0 0 0-8.05ZM11.25 9c.38 0 .7.28.74.65l.01.1V12h1.25c.38 0 .7.29.74.65v.1c0 .38-.27.7-.64.75h-2.1a.75.75 0 0 1-.74-.64l-.01-.1V9.74c0-.41.34-.75.75-.75Zm10 2.27a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6Zm-17-.03a.75.75 0 0 1 .1 1.5h-1.6a.75.75 0 0 1-.1-1.5h1.6Zm1.64-6.37.08.07L7.03 6a.75.75 0 0 1-.97 1.13l-.09-.07L4.91 6a.75.75 0 0 1 .98-1.13Zm13.19.07c.26.27.29.68.07.98l-.07.08-1.06 1.06a.75.75 0 0 1-1.14-.97l.08-.09 1.06-1.06c.3-.3.77-.3 1.06 0ZM12 2c.38 0 .7.28.74.65l.01.1v1.5a.75.75 0 0 1-1.5.1v-1.6c0-.41.34-.75.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$b177467d4d89bd3f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker20Filled', "20", [
    "M10.47 2.17a.75.75 0 0 0-.94 0L6.78 4.42a.75.75 0 0 0 .94 1.16L10 3.72l2.28 1.86a.75.75 0 1 0 .94-1.16l-2.75-2.25Zm2.75 13.41-2.75 2.25a.75.75 0 0 1-.94 0l-2.75-2.25a.75.75 0 0 1 .94-1.16L10 16.28l2.28-1.86a.75.75 0 1 1 .94 1.16Zm-2.47-6.83a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8ZM6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8ZM2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Z"
]);
const $77e1bce0ac0f7fe7$export$afdc984d93b85f2b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker20Regular', "20", [
    "M10.32 2.12a.5.5 0 0 0-.64 0l-3 2.5a.5.5 0 1 0 .64.76L10 3.15l2.68 2.23a.5.5 0 0 0 .64-.76l-3-2.5Zm3 13.26-3 2.5a.5.5 0 0 1-.64 0l-3-2.5a.5.5 0 1 1 .64-.76L10 16.85l2.68-2.23a.5.5 0 0 1 .64.76Zm-2.57-6.63a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM10 12a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm6-2.5a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C5.67 8 5 8.67 5 9.5v1a1.5 1.5 0 0 0 3 0v-1C8 8.67 7.33 8 6.5 8ZM6 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm6 0a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0v-1Zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5Zm-11-1C1.67 8 1 8.67 1 9.5v1a1.5 1.5 0 0 0 3 0v-1C4 8.67 3.33 8 2.5 8ZM2 9.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Z"
]);
const $77e1bce0ac0f7fe7$export$3aca18c91f2a4e19 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker24Filled', "24", [
    "M12.62 2.22a1 1 0 0 0-1.24 0l-3.75 3a1 1 0 1 0 1.24 1.56L12 4.28l3.13 2.5a1 1 0 0 0 1.24-1.56l-3.75-3ZM2.75 9C1.51 9 .5 10 .5 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C5 10.01 4 9 2.75 9ZM2 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5ZM8.25 9C7.01 9 6 10 6 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5c0-1.24-1-2.25-2.25-2.25Zm-.75 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm6.5 0a2.25 2.25 0 0 1 4.5 0v1.5a2.25 2.25 0 0 1-4.5 0v-1.5Zm2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75Zm5.5-1.5c-1.24 0-2.25 1-2.25 2.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C24 10.01 23 9 21.75 9ZM21 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm-8-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.38 7.53 4-3.25a1 1 0 0 0-1.26-1.56L12 19.96l-3.37-2.74a1 1 0 1 0-1.26 1.56l4 3.25c.37.3.9.3 1.26 0Z"
]);
const $77e1bce0ac0f7fe7$export$3d790f07a2fb5096 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimePicker24Regular', "24", [
    "M12.47 2.17a.75.75 0 0 0-.94 0l-4 3.25a.75.75 0 1 0 .94 1.16L12 3.72l3.53 2.86a.75.75 0 1 0 .94-1.16l-4-3.25ZM2.75 9C1.51 9 .5 10 .5 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C5 10.01 4 9 2.75 9ZM2 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5ZM8.25 9C7.01 9 6 10 6 11.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5c0-1.24-1-2.25-2.25-2.25Zm-.75 2.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm6.5 0a2.25 2.25 0 0 1 4.5 0v1.5a2.25 2.25 0 0 1-4.5 0v-1.5Zm2.25-.75a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75Zm5.5-1.5c-1.24 0-2.25 1-2.25 2.25v1.5a2.25 2.25 0 0 0 4.5 0v-1.5C24 10.01 23 9 21.75 9ZM21 11.25a.75.75 0 0 1 1.5 0v1.5a.75.75 0 0 1-1.5 0v-1.5Zm-8-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.22 7.33 4-3.25a.75.75 0 1 0-.94-1.16L12 20.28l-3.53-2.86a.75.75 0 0 0-.94 1.16l4 3.25c.27.23.67.23.94 0Z"
]);
const $77e1bce0ac0f7fe7$export$23bc9cd26718b4d7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline20Filled', "20", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9Zm0 8c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9ZM17 12.44a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88ZM16.5 3c.28 0 .5.22.5.5v4.04a3.02 3.02 0 0 0-1 0V3.5c0-.28.22-.5.5-.5Zm0 10.5c-.17 0-.34-.01-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04c-.16.03-.33.04-.5.04Z"
]);
const $77e1bce0ac0f7fe7$export$513f26ac8161419f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline20Regular', "20", [
    "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9ZM3 4.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-4Zm.5 6.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-9ZM3 12.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-4Zm14-.06a2 2 0 0 1-1-3.88 2 2 0 0 1 1 3.88ZM16.5 3c.28 0 .5.22.5.5v4.04a3.02 3.02 0 0 0-1 0V3.5c0-.28.22-.5.5-.5Zm0 10.5c-.17 0-.34-.01-.5-.04v4.04a.5.5 0 0 0 1 0v-4.04c-.16.03-.33.04-.5.04Z"
]);
const $77e1bce0ac0f7fe7$export$6d52c7bf18408bbd = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline24Filled', "24", [
    "M15.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 21 2 20.22 2 19.25v-4.5c0-.97.78-1.75 1.75-1.75h11.5ZM21 14.9v5.35a.75.75 0 0 1-1.5.1V14.91a3 3 0 0 0 1.5-.01Zm-.75-4.8a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8Zm-5-7.1C16.2 3 17 3.78 17 4.75v4.5c0 .97-.79 1.75-1.75 1.75H3.75C2.78 11 2 10.22 2 9.25v-4.5c0-.92.7-1.67 1.6-1.75h11.65Zm5 0c.38 0 .7.28.74.65l.01.1V9.1a3 3 0 0 0-1.5-.01V3.75c0-.41.34-.75.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$4d7af1a78f86e86c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timeline24Regular', "24", [
    "M15.25 13c.97 0 1.75.78 1.75 1.75v4.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 21 2 20.22 2 19.25v-4.5c0-.97.78-1.75 1.75-1.75h11.5ZM21 14.9v5.35a.75.75 0 0 1-1.5.1V14.91a3 3 0 0 0 1.5-.01Zm-5.75-.4H3.75a.25.25 0 0 0-.25.25v4.5c0 .14.11.25.25.25h11.5c.14 0 .25-.11.25-.25v-4.5a.25.25 0 0 0-.25-.25Zm5-4.4a1.9 1.9 0 1 1 0 3.8 1.9 1.9 0 0 1 0-3.8Zm-5-7.1C16.2 3 17 3.78 17 4.75v4.5c0 .97-.79 1.75-1.75 1.75H3.75C2.78 11 2 10.22 2 9.25v-4.5c0-.92.7-1.67 1.6-1.74L3.75 3h11.5Zm0 1.5H3.69a.25.25 0 0 0-.2.25v4.5c0 .14.12.25.26.25h11.5c.13 0 .25-.11.25-.25v-4.5a.25.25 0 0 0-.25-.25Zm5-1.5c.38 0 .7.28.74.65l.01.1V9.1a3 3 0 0 0-1.5-.01V3.75c0-.41.34-.75.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$a61a1f1db8536fcf = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1020Filled', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM16.43 10c-.98.02-1.86.44-2.48 1.1a1.5 1.5 0 0 0-1.92-1.02l-1.5.5A1.5 1.5 0 0 0 11 13.5v4.34A7.03 7.03 0 0 1 2.5 11a7 7 0 0 1 13.93-1ZM9 10.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0v4Zm5 3a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0v-3Zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5Zm-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0v-7Z"
]);
const $77e1bce0ac0f7fe7$export$2f75e605af3d2d8f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1020Regular', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM9 6.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0v-4ZM9.5 18c.51 0 1.02-.06 1.5-.16V16.8a6.01 6.01 0 1 1 4.44-6.65c.31-.1.65-.15.99-.16a7 7 0 1 0-6.93 8Zm4.5-4.5a2.5 2.5 0 0 1 5 0v3a2.5 2.5 0 0 1-5 0v-3Zm2.5-1.5c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5Zm-3.5-.5a.5.5 0 0 0-.66-.47l-1.5.5a.5.5 0 1 0 .32.94l.84-.28v6.31a.5.5 0 0 0 1 0v-7Z"
]);
const $77e1bce0ac0f7fe7$export$653f0d7a2154b17e = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1024Filled', "24", [
    "M12 5a8.5 8.5 0 0 1 8.38 7.05 4.28 4.28 0 0 0-4.38 2.2v-.5a1.75 1.75 0 0 0-2.3-1.66l-.95.32V8.65a.75.75 0 0 0-1.5 0V13.34a1.75 1.75 0 0 0 1.25 2.64v6c-.17.02-.33.02-.5.02a8.5 8.5 0 0 1 0-17Zm7.17.12.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2ZM14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Zm.44 10.64c.2.14.31.37.31.61v8.5a.75.75 0 0 1-1.5 0v-7.46l-.51.17a.75.75 0 0 1-.48-1.42l1.5-.5a.75.75 0 0 1 .68.1Zm1.81 3.11a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-3.5Zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5a1.75 1.75 0 1 0 3.5 0v-3.5c0-.97-.78-1.75-1.75-1.75Z"
]);
const $77e1bce0ac0f7fe7$export$825e0544bfd2e04d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer1024Regular', "24", [
    "M12 5a8.5 8.5 0 0 1 8.38 7.05 4.28 4.28 0 0 0-1.52.04 7 7 0 1 0-6.36 8.4v1.5L12 22a8.5 8.5 0 0 1 0-17Zm.75 7.4V8.66a.75.75 0 0 0-1.5.1v4.59c.21-.34.54-.61.95-.75l.55-.18Zm6.4-7.29.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22Zm-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Zm.44 10.64c.2.14.31.37.31.61v8.5a.75.75 0 0 1-1.5 0v-7.46l-.51.17a.75.75 0 0 1-.48-1.42l1.5-.5a.75.75 0 0 1 .68.1Zm1.81 3.11a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-3.5Zm3.25-1.75c-.97 0-1.75.78-1.75 1.75v3.5a1.75 1.75 0 1 0 3.5 0v-3.5c0-.97-.78-1.75-1.75-1.75Z"
]);
const $77e1bce0ac0f7fe7$export$39132daebfdbc93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer12Filled', "12", [
    "M3.5 0a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM1 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4 1a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Zm5.85-3.65a.5.5 0 0 1-.7 0l-1-1a.5.5 0 1 1 .7-.7l1 1c.2.2.2.5 0 .7Z"
]);
const $77e1bce0ac0f7fe7$export$2e1a65ae9d9f598 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer12Regular', "12", [
    "M3 .5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 3 .5Zm2 7a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3ZM5.5 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM2 6.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm8.15-2.65a.5.5 0 1 0 .7-.7l-1-1a.5.5 0 1 0-.7.7l1 1Z"
]);
const $77e1bce0ac0f7fe7$export$c0506077fe9c4312 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer16Filled', "16", [
    "M5 1.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM7.5 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-10c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5Zm4.95-2.36a.5.5 0 1 0-.7.7l1.4 1.41a.5.5 0 1 0 .7-.7l-1.4-1.4Z"
]);
const $77e1bce0ac0f7fe7$export$cf4ce333c9360b01 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer16Regular', "16", [
    "M5 1.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM7.5 5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm6 4a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1 0a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-.05-6.36a.5.5 0 1 0-.7.7l1.4 1.41a.5.5 0 1 0 .7-.7l-1.4-1.4Z"
]);
const $77e1bce0ac0f7fe7$export$98be67c3607882ea = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer20Filled', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM16.5 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0ZM9 6.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0Z"
]);
const $77e1bce0ac0f7fe7$export$bce2495c7f101218 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer20Regular', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm0 12a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z"
]);
const $77e1bce0ac0f7fe7$export$3c0aedf3fdb1569c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer24Filled', "24", [
    "M12 5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 3c-.38 0-.7.28-.74.65l-.01.1v4.6a.75.75 0 0 0 1.5 0V8.65A.75.75 0 0 0 12 8Zm7.17-2.88.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2ZM14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z"
]);
const $77e1bce0ac0f7fe7$export$9fde69334c1dc173 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer24Regular', "24", [
    "M12 5a8.5 8.5 0 1 1 0 17 8.5 8.5 0 0 1 0-17Zm0 1.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM12 8c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 0 1-1.5.1v-4.6c0-.41.34-.75.75-.75Zm7.15-2.89.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22Zm-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z"
]);
const $77e1bce0ac0f7fe7$export$581098b84d1dd97c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer28Filled', "28", [
    "M10.75 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM4 16a10 10 0 1 1 20 0 10 10 0 0 1-20 0Zm10.75-5.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm6.47-4.03c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06Z"
]);
const $77e1bce0ac0f7fe7$export$f959312d8e2f1a93 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer28Regular', "28", [
    "M10.75 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM14 9.5c.41 0 .75.34.75.75v6a.75.75 0 0 1-1.5 0v-6c0-.41.34-.75.75-.75ZM14 6a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM5.5 16a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0Zm16.78-9.78a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06l-1.5-1.5Z"
]);
const $77e1bce0ac0f7fe7$export$c68f34af0dd8e210 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer220Filled', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42Zm1.29 6.2A3.5 3.5 0 0 0 12 13.5c0 .7.47 1.27 1.1 1.45A3.49 3.49 0 0 0 12 17.5v.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87ZM9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v5Zm6.5-.5a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5Z"
]);
const $77e1bce0ac0f7fe7$export$5664ae125270da4d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer220Regular', "20", [
    "M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM9 6.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm3 11.04A6.98 6.98 0 0 1 2.5 11a7 7 0 0 1 13.95-.87 3.5 3.5 0 0 0-1.03-.13 6 6 0 1 0-3.23 6.37A3.5 3.5 0 0 0 12 17.5v.04ZM15.5 11a2.5 2.5 0 0 0-2.5 2.5.5.5 0 0 0 1 0 1.5 1.5 0 1 1 1.5 1.5 2.5 2.5 0 0 0-2.5 2.5v1c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H14v-.5c0-.83.67-1.5 1.5-1.5a2.5 2.5 0 0 0 0-5Z"
]);
const $77e1bce0ac0f7fe7$export$faf8e07577a1a9d4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer224Filled', "24", [
    "M20.4 12.16a8.5 8.5 0 1 0-5.4 9.3v-.21c0-1.31.6-2.48 1.53-3.26A1.75 1.75 0 0 1 15 16.25a4.25 4.25 0 0 1 5.4-4.1Zm-9.14-3.51a.75.75 0 0 1 1.48 0l.01.1v4.6a.75.75 0 0 1-1.5 0V8.65Zm8-3.47-.09-.06a.75.75 0 0 0-.9 1.2l1.15 1 .08.06a.75.75 0 0 0 .9-1.2l-1.15-1ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM19.25 13A3.25 3.25 0 0 0 16 16.25a.75.75 0 0 0 1.5 0A1.75 1.75 0 1 1 19.25 18 3.25 3.25 0 0 0 16 21.25v1c0 .41.34.75.75.75h5a.75.75 0 0 0 0-1.5H17.5v-.25c0-.97.78-1.75 1.75-1.75a3.25 3.25 0 0 0 0-6.5Z"
]);
const $77e1bce0ac0f7fe7$export$fc44c5f5c7c862b5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer224Regular', "24", [
    "M20.4 12.16a8.5 8.5 0 1 0-5.4 9.3v-.21c0-.56.1-1.09.3-1.58a7 7 0 1 1 3.54-7.65 4.3 4.3 0 0 1 1.55.14Zm-7.66-3.51a.75.75 0 0 0-1.49.1v4.6a.75.75 0 0 0 1.5-.1v-4.6Zm6.49-3.48-.08-.06a.75.75 0 0 0-.88 1.22l1.16.96.08.06a.75.75 0 0 0 .88-1.21l-1.16-.97ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM19.25 13A3.25 3.25 0 0 0 16 16.25a.75.75 0 0 0 1.5 0A1.75 1.75 0 1 1 19.25 18 3.25 3.25 0 0 0 16 21.25v1c0 .41.34.75.75.75h5a.75.75 0 0 0 0-1.5H17.5v-.25c0-.97.78-1.75 1.75-1.75a3.25 3.25 0 0 0 0-6.5Z"
]);
const $77e1bce0ac0f7fe7$export$bdc11fa5da12b7cc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer32Filled', "32", [
    "M13 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm15 16a12 12 0 1 1-24 0 12 12 0 0 1 24 0Zm-11-6a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Zm8.3-5.7a1 1 0 0 1 1.4 0l2 2a1 1 0 1 1-1.4 1.4l-2-2a1 1 0 0 1 0-1.4Z"
]);
const $77e1bce0ac0f7fe7$export$de66b77ebd5a18c4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer32Regular', "32", [
    "M13 2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm3 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm12 7a12 12 0 1 1-24 0 12 12 0 0 1 24 0Zm-2 0a10 10 0 1 0-20 0 10 10 0 0 0 20 0Zm.7-11.7a1 1 0 1 0-1.4 1.4l2 2a1 1 0 1 0 1.4-1.4l-2-2Z"
]);
const $77e1bce0ac0f7fe7$export$b70352dde68b8832 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer320Filled', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42Zm1.29 6.2a3.7 3.7 0 0 0-.95-.13 4.47 4.47 0 0 0-2.74.97l-.25.2v.01a1.5 1.5 0 0 0 1.63 2.48 2.49 2.49 0 0 0-.04 2.62l-.04.03a1.5 1.5 0 0 0-2.05 1.23 7 7 0 1 1 4.44-7.41ZM9 11.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v5Zm4.84 1.21.03-.02a2.57 2.57 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25 0 .28-.17.58-.51.84-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41.34.26.51.56.51.84 0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3.37 3.37 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a3.68 3.68 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4.35 4.35 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73Z"
]);
const $77e1bce0ac0f7fe7$export$9bf787113fc2a8c9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer320Regular', "20", [
    "M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm0 12c.88 0 1.73-.16 2.5-.46l.01-.07a1.5 1.5 0 0 1 .45-1.25A6 6 0 1 1 15.42 10a3.8 3.8 0 0 1 1.03.12A7 7 0 1 0 9.5 18Zm4.34-5.29.03-.02a2.57 2.57 0 0 1 .47-.33c.32-.2.73-.36 1.16-.36.9 0 1.5.62 1.5 1.25 0 .28-.17.58-.51.84-.34.25-.8.41-1.24.41a.5.5 0 0 0 0 1c.44 0 .9.16 1.24.41.34.26.51.56.51.84 0 .63-.6 1.25-1.5 1.25-.43 0-.84-.17-1.16-.36a3.37 3.37 0 0 1-.47-.33l-.02-.02a.5.5 0 0 0-.7.72h.01l.01.02.04.03a3.68 3.68 0 0 0 .62.45c.4.23 1 .49 1.67.49 1.32 0 2.5-.95 2.5-2.25 0-.7-.4-1.26-.91-1.64l-.16-.11.16-.11c.5-.38.91-.95.91-1.64 0-1.3-1.18-2.25-2.5-2.25-.68 0-1.27.26-1.67.5a4.35 4.35 0 0 0-.62.44l-.04.03v.01h-.01a.5.5 0 0 0 .68.73Z"
]);
const $77e1bce0ac0f7fe7$export$8d153714f54d5e8a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer324Filled', "24", [
    "M15.45 15.92c.53.6 1.37.74 2.06.4a2.99 2.99 0 0 0 0 3.35 1.75 1.75 0 0 0-2.5 1.78 8.5 8.5 0 1 1 5.38-9.3c-.37-.1-.76-.15-1.14-.15a5.47 5.47 0 0 0-3.35 1.19 5.53 5.53 0 0 0-.28.22l-.02.02-.01.01a1.75 1.75 0 0 0-.14 2.48Zm-4.2-7.27V13.35a.75.75 0 0 0 1.5 0V8.65a.75.75 0 0 0-1.5 0Zm8-3.47-.08-.06a.75.75 0 0 0-.9 1.2l1.15 1 .08.06a.75.75 0 0 0 .9-1.2l-1.15-1ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM18.25 18c0-.41.34-.75.75-.75.53 0 1.06-.18 1.44-.47.4-.3.56-.63.56-.9 0-.65-.66-1.38-1.75-1.38-.52 0-1.01.19-1.4.4a4.1 4.1 0 0 0-.6.4v.01a.75.75 0 0 1-1-1.12l.02-.02a3.08 3.08 0 0 1 .23-.18c.15-.1.36-.25.62-.4.51-.28 1.27-.59 2.13-.59 1.68 0 3.25 1.18 3.25 2.88 0 .89-.52 1.62-1.16 2.1l-.03.02.03.02c.64.48 1.16 1.21 1.16 2.1 0 1.7-1.57 2.88-3.25 2.88-.86 0-1.62-.31-2.13-.6a5.58 5.58 0 0 1-.85-.57l-.01-.01-.01-.01a.75.75 0 0 1 1-1.12l.02.02a2.96 2.96 0 0 0 .57.38c.4.22.9.41 1.41.41 1.09 0 1.75-.73 1.75-1.38 0-.27-.17-.6-.56-.9a2.48 2.48 0 0 0-1.44-.47.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$d0340aafda30ec99 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer324Regular', "24", [
    "M20.4 12.15a8.5 8.5 0 1 0-5.39 9.3 1.75 1.75 0 0 1 .65-1.98 7 7 0 1 1 3.18-7.45 4.68 4.68 0 0 1 1.55.13Zm-7.66-3.5a.75.75 0 0 0-1.49.1v4.6a.75.75 0 0 0 1.5-.1v-4.6Zm6.49-3.48-.08-.06a.75.75 0 0 0-.88 1.22l1.16.96.08.06a.75.75 0 0 0 .88-1.21l-1.16-.97ZM15 3.25a.75.75 0 0 0-.75-.75h-4.6a.75.75 0 0 0 .1 1.5h4.6a.75.75 0 0 0 .65-.75ZM18.25 18c0-.41.34-.75.75-.75.53 0 1.06-.18 1.44-.47.4-.3.56-.63.56-.9 0-.65-.66-1.38-1.75-1.38-.52 0-1.01.19-1.4.4a4.1 4.1 0 0 0-.6.4v.01a.75.75 0 0 1-1-1.12l.02-.02a3.08 3.08 0 0 1 .23-.18c.15-.1.36-.25.62-.4.51-.28 1.27-.59 2.13-.59 1.68 0 3.25 1.18 3.25 2.88 0 .89-.52 1.62-1.16 2.1l-.03.02.03.02c.64.48 1.16 1.21 1.16 2.1 0 1.7-1.57 2.88-3.25 2.88-.86 0-1.62-.31-2.13-.6a5.58 5.58 0 0 1-.85-.57l-.01-.01-.01-.01a.75.75 0 0 1 1-1.12l.02.02a2.96 2.96 0 0 0 .57.38c.4.22.9.41 1.41.41 1.09 0 1.75-.73 1.75-1.38 0-.27-.17-.6-.56-.9a2.48 2.48 0 0 0-1.44-.47.75.75 0 0 1-.75-.75Z"
]);
const $77e1bce0ac0f7fe7$export$1038751ad15e77ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer48Filled', "48", [
    "M19.25 5a1.25 1.25 0 1 0 0 2.5h9.5a1.25 1.25 0 1 0 0-2.5h-9.5ZM7 27a17 17 0 1 1 34 0 17 17 0 0 1-34 0Zm15.75-.25a1.25 1.25 0 1 0 2.5 0v-9.5a1.25 1.25 0 1 0-2.5 0v9.5Zm13.62-16.38a1.25 1.25 0 0 1 1.76 0l2.5 2.5a1.25 1.25 0 0 1-1.76 1.76l-2.5-2.5a1.25 1.25 0 0 1 0-1.76Z"
]);
const $77e1bce0ac0f7fe7$export$132e9e142e4355ab = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Timer48Regular', "48", [
    "M18 6.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 1 1 0 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25Zm4.75 20.5a1.25 1.25 0 1 0 2.5 0v-9.5a1.25 1.25 0 1 0-2.5 0v9.5ZM24 10a17 17 0 1 0 0 34 17 17 0 0 0 0-34ZM9.5 27a14.5 14.5 0 1 1 29 0 14.5 14.5 0 0 1-29 0Zm28.63-16.63a1.25 1.25 0 1 0-1.76 1.76l2.5 2.5a1.25 1.25 0 0 0 1.76-1.76l-2.5-2.5Z"
]);
const $77e1bce0ac0f7fe7$export$b62950436973cf66 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff20Filled', "20", [
    "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33ZM10 10.71l-1-1v1.79a.5.5 0 0 0 1 0v-.8Zm0-4.21v1.38l5.92 5.92A7 7 0 0 0 6.7 4.58L9 6.88V6.5a.5.5 0 0 1 1 0Zm-3-4c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71Z"
]);
const $77e1bce0ac0f7fe7$export$c248778180e0368c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff20Regular', "20", [
    "M4.96 5.67 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2.32-2.31A6.98 6.98 0 0 1 2.5 11c0-2.13.96-4.05 2.46-5.33Zm9.16 9.16L10 10.7v.79a.5.5 0 0 1-1 0V9.7L5.67 6.39A5.99 5.99 0 0 0 9.5 17c1.86 0 3.52-.85 4.62-2.17ZM9 6.5v.38l1 1V6.5a.5.5 0 0 0-1 0Zm6.5 4.5a6 6 0 0 1-.35 2.03l.77.77A7 7 0 0 0 6.7 4.58l.77.77A5.99 5.99 0 0 1 15.5 11Zm-8-9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42Z"
]);
const $77e1bce0ac0f7fe7$export$1bf7709d7688689a = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff24Filled', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4 4a8.5 8.5 0 1 0 12.01 12.01l2.49 2.5a.75.75 0 0 0 1.06-1.07L3.28 2.22Zm9.34 11.46a.75.75 0 0 1-1.36-.33l-.01-.1v-.94l1.37 1.37Zm.13-4.93v.82l7.13 7.13A8.5 8.5 0 0 0 8.8 5.62l2.63 2.63a.75.75 0 0 1 1.3.4l.01.1Zm6.42-3.63.08.06 1.15 1a.75.75 0 0 1-.9 1.2l-.08-.06-1.15-1a.75.75 0 0 1 .9-1.2ZM14.25 2.5a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z"
]);
const $77e1bce0ac0f7fe7$export$fc7faf1fa1398a52 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('TimerOff24Regular', "24", [
    "M3.28 2.22a.75.75 0 1 0-1.06 1.06l4 4a8.5 8.5 0 1 0 12.01 12.01l2.49 2.5a.75.75 0 0 0 1.06-1.07L3.28 2.22Zm13.88 16a7 7 0 1 1-9.89-9.89l3.98 3.98v1.04a.75.75 0 0 0 1.37.33l4.54 4.55Zm-5.72-9.97 1.31 1.32V8.65a.75.75 0 0 0-1.31-.4ZM19 13.5a7 7 0 0 1-.3 2.02l1.18 1.18A8.5 8.5 0 0 0 8.8 5.62L9.97 6.8A7 7 0 0 1 19 13.5Zm.15-8.39.08.06 1.16.97a.75.75 0 0 1-.88 1.21l-.08-.06-1.16-.96a.75.75 0 0 1 .88-1.22Zm-4.9-2.61a.75.75 0 0 1 .1 1.5h-4.6a.75.75 0 0 1-.1-1.5h4.6Z"
]);
const $77e1bce0ac0f7fe7$export$f16928cc3eb9ec10 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop20Filled', "20", [
    "M1.96 4.5c0-.83.67-1.5 1.5-1.5H16.4c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H12v2.01h1.5a.5.5 0 0 1 0 1h-7a.5.5 0 1 1 0-1H8V14H3.46a1.5 1.5 0 0 1-1.5-1.5v-8ZM9 14v2.01h2V14H9ZM4 5.5v6c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm3 0v6c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5Z"
]);
const $77e1bce0ac0f7fe7$export$8407d04ba57c12d1 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop20Regular', "20", [
    "M4 5.5c0-.28.22-.5.5-.5h1c.27 0 .5.22.5.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6ZM7.5 5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-8Zm-5.54-.5c0-.83.67-1.5 1.5-1.5H16.4c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5H12v2.01h1.5a.5.5 0 0 1 0 1h-7a.5.5 0 1 1 0-1H8V14H3.46a1.5 1.5 0 0 1-1.5-1.5v-8ZM9 14v2.01h2V14H9ZM3.46 4a.5.5 0 0 0-.5.5v8c0 .28.23.5.5.5H16.4a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5H3.46Z"
]);
const $77e1bce0ac0f7fe7$export$e9a2ca9cbb3f66c2 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop24Filled', "24", [
    "M19.75 3c1.19 0 2.16.93 2.24 2.1v10.65c0 1.2-.92 2.17-2.09 2.25h-4.4v2.5h1.75a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5H8.5V18H4.25c-1.2 0-2.17-.92-2.24-2.1L2 15.76V5.25c0-1.2.93-2.17 2.1-2.24L4.25 3h15.5ZM14 18h-4v2.5h4V18Zm4.5-12h-9a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5Zm-11 0h-2a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$fe232d1bff74cc14 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktop24Regular', "24", [
    "M19.75 3c1.2 0 2.17.93 2.24 2.1l.01.15v10.5c0 1.2-.93 2.17-2.1 2.25h-4.4v2.5h1.75a.75.75 0 0 1 .1 1.5H6.75a.75.75 0 0 1-.1-1.5H8.5V18H4.25c-1.19 0-2.16-.92-2.24-2.1V5.26c0-1.2.92-2.17 2.09-2.24L4.25 3h15.5ZM14 18h-4v2.5h4V18Zm5.75-13.5H4.25c-.38 0-.7.28-.74.65v10.6c0 .38.27.7.64.75h15.6c.38 0 .7-.28.74-.65l.01-.1V5.25c0-.38-.28-.7-.65-.74l-.1-.01ZM18.5 6a.5.5 0 0 1 .5.41v8.09a.5.5 0 0 1-.4.5H9.5a.5.5 0 0 1-.5-.4V6.5a.5.5 0 0 1 .41-.5h9.09Zm-11 0a.5.5 0 0 1 .5.41v8.09a.5.5 0 0 1-.41.5h-2.1a.5.5 0 0 1-.48-.4L5 14.5v-8a.5.5 0 0 1 .4-.5h2.1Z"
]);
const $77e1bce0ac0f7fe7$export$968e9c912748cdac = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile20Filled', "20", [
    "M5 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm2.5 0a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-5Zm0 4a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5ZM9 15.5c0 .28.22.5.5.5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0-.5.5Z"
]);
const $77e1bce0ac0f7fe7$export$384ed314a86f9b58 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile20Regular', "20", [
    "M7.5 4a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-5ZM7 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5ZM9.5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM7 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7ZM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4Z"
]);
const $77e1bce0ac0f7fe7$export$1e8e0f1709fc7415 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile24Filled', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5Zm-2.5 16h-2.5a.75.75 0 0 0-.1 1.5h2.6a.75.75 0 0 0 0-1.5Zm1.25-9h-5a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5Zm0-4h-5a.5.5 0 0 0-.5.5v2c0 .27.22.5.5.5h5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5Z"
]);
const $77e1bce0ac0f7fe7$export$f5a4f8e6bea64cb6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('ViewDesktopMobile24Regular', "24", [
    "M15.75 2C16.99 2 18 3 18 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-7.5C7.01 22 6 21 6 19.75V4.25C6 3.01 7 2 8.25 2h7.5Zm0 1.5h-7.5a.75.75 0 0 0-.75.75v15.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 0 0-.75-.75Zm-2.5 14a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h2.5ZM14.5 9a.5.5 0 0 1 .5.4v6.1a.5.5 0 0 1-.41.5H9.5a.5.5 0 0 1-.5-.4V9.5a.5.5 0 0 1 .41-.5h5.09Zm0-4a.5.5 0 0 1 .5.41V7.5a.5.5 0 0 1-.41.5H9.5a.5.5 0 0 1-.5-.4V5.5a.5.5 0 0 1 .41-.5h5.09Z"
]);
const $77e1bce0ac0f7fe7$export$7ce86077b4bac9f4 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench16Color', "16", `<path d="M11 1a4 4 0 0 0-3.9 4.91l-5.05 5.24a1.99 1.99 0 0 0 2.85 2.77l5-5.07a4 4 0 0 0 5.06-4.39.5.5 0 0 0-.84-.28L12 6.29 9.7 4l2.12-2.12a.5.5 0 0 0-.28-.84A4.03 4.03 0 0 0 11 1Z" fill="url(#ic_fluent_wrench_16_color__a)"/><defs><linearGradient id="ic_fluent_wrench_16_color__a" x1="6.98" y1="1.84" x2="9.39" y2="14.99" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$12bfa6f119e095fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench16Filled', "16", [
    "M11 1a4 4 0 0 0-3.9 4.91l-5.05 5.24a1.99 1.99 0 0 0 2.85 2.77l5-5.07a4 4 0 0 0 5.06-4.39.5.5 0 0 0-.85-.28L12 6.29 9.7 4l2.12-2.12a.5.5 0 0 0-.29-.84A4.03 4.03 0 0 0 11 1Z"
]);
const $77e1bce0ac0f7fe7$export$ffddc1d08f9d68b6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench16Regular', "16", [
    "M7 5a4 4 0 0 1 5.45-3.73.5.5 0 0 1 .17.82L10.7 4 12 5.3l1.91-1.92a.5.5 0 0 1 .82.17 4 4 0 0 1-4.83 5.3l-5 5.07a1.99 1.99 0 0 1-2.85-2.77L7.1 5.9c-.06-.3-.1-.6-.1-.91Zm4-3a3 3 0 0 0-2.86 3.9.5.5 0 0 1-.12.5l-5.25 5.44a.99.99 0 0 0 1.41 1.38l5.23-5.3a.5.5 0 0 1 .53-.11 3 3 0 0 0 4.05-3.09l-1.64 1.63a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7L11.28 2 11 2Z"
]);
const $77e1bce0ac0f7fe7$export$477a492df683be4c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench20Color', "20", `<path d="M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3l6.37-6.46a4.51 4.51 0 0 0 5.49-5.37.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84A4.51 4.51 0 0 0 13.5 2Z" fill="url(#ic_fluent_wrench_20_color__a)"/><defs><linearGradient id="ic_fluent_wrench_20_color__a" x1="8.5" y1="3" x2="11.36" y2="18.58" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$7a4dd08841447bd9 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench20Filled', "20", [
    "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3l6.37-6.46a4.51 4.51 0 0 0 5.49-5.37.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84 4.51 4.51 0 0 0-1-.11Z"
]);
const $77e1bce0ac0f7fe7$export$cb0724f115e985ff = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench20Regular', "20", [
    "M9 6.5a4.5 4.5 0 0 1 6.35-4.1.5.5 0 0 1 .15.8l-2.3 2.3 1.3 1.3 2.3-2.3a.5.5 0 0 1 .8.15A4.49 4.49 0 0 1 13.5 11a4.5 4.5 0 0 1-1.1-.14l-6.37 6.45a2.36 2.36 0 0 1-3.37-3.3l6.42-6.65A4.52 4.52 0 0 1 9 6.5ZM13.5 3a3.5 3.5 0 0 0-3.39 4.39.5.5 0 0 1-.12.47L3.38 14.7a1.36 1.36 0 0 0 1.94 1.9l6.57-6.66a.5.5 0 0 1 .51-.12 3.5 3.5 0 0 0 4.53-4.05l-2.08 2.07a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2.07-2.08A3.52 3.52 0 0 0 13.5 3Z"
]);
const $77e1bce0ac0f7fe7$export$d94b164a7b059560 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench24Color', "24", `<path d="M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l8.31-8.31a5.51 5.51 0 0 0 6.5-7.1.75.75 0 0 0-1.23-.29l-2.45 2.45c-.3.29-.77.29-1.06 0l-.88-.88a.75.75 0 0 1 0-1.06l2.45-2.45a.75.75 0 0 0-.3-1.24A5.5 5.5 0 0 0 16.5 2Z" fill="url(#ic_fluent_wrench_24_color__a)"/><defs><linearGradient id="ic_fluent_wrench_24_color__a" x1="10.13" y1="3.25" x2="13.69" y2="22.71" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$f77683ef180290c6 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench24Filled', "24", [
    "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l8.31-8.31a5.51 5.51 0 0 0 6.5-7.1.75.75 0 0 0-1.23-.29l-2.45 2.45c-.3.29-.77.29-1.06 0l-.88-.88a.75.75 0 0 1 0-1.06l2.45-2.45a.75.75 0 0 0-.3-1.24A5.5 5.5 0 0 0 16.5 2Z"
]);
const $77e1bce0ac0f7fe7$export$60c3f7ede56c3174 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('Wrench24Regular', "24", [
    "M11 7.5a5.5 5.5 0 0 1 7.66-5.06.75.75 0 0 1 .24 1.22L16.3 6.25l1.44 1.44 2.59-2.59a.75.75 0 0 1 1.22.24 5.49 5.49 0 0 1-6.35 7.5l-8.3 8.32a2.87 2.87 0 1 1-4.07-4.06l8.31-8.31c-.1-.42-.15-.85-.15-1.29Zm5.5-4a4 4 0 0 0-3.8 5.27c.1.27.03.57-.18.77L3.9 18.16a1.37 1.37 0 0 0 1.94 1.94l8.63-8.62c.2-.2.5-.27.76-.18a4 4 0 0 0 5.25-4.22l-1.85 1.85c-.48.48-1.28.48-1.76 0l-1.8-1.8a1.25 1.25 0 0 1 0-1.76l1.85-1.85a4.06 4.06 0 0 0-.42-.02Z"
]);
const $77e1bce0ac0f7fe7$export$6940411ed03519fc = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver20Color', "20", `<path d="M16 5.12v5.38h-3V5.12a19.87 19.87 0 0 1-.44-.87.63.63 0 0 1-.06-.25 43.7 43.7 0 0 1 .52-1.66c.03-.1.1-.18.18-.24.1-.06.2-.1.3-.1h2c.1 0 .2.03.29.1.08.06.14.14.19.24l.11.35a45.77 45.77 0 0 1 .34.99l.07.32c0 .06-.02.14-.06.24a12.57 12.57 0 0 1-.3.64l-.14.24Z" fill="url(#ic_fluent_wrench_screwdriver_20_color__a)"/><path d="M17 11.5h-5v4.05c0 .34.07.66.2.96a2.58 2.58 0 0 0 1.35 1.3 2.47 2.47 0 0 0 1.9 0c.3-.14.57-.31.8-.53.23-.22.41-.48.55-.77.13-.3.2-.62.2-.96V11.5Z" fill="url(#ic_fluent_wrench_screwdriver_20_color__b)"/><path d="M17 12v-1.5c0-.11-.03-.2-.07-.27a.37.37 0 0 0-.17-.15.86.86 0 0 0-.24-.06 2.08 2.08 0 0 0-.25-.02h-3.54c-.09 0-.18 0-.26.02a.72.72 0 0 0-.24.07.44.44 0 0 0-.17.14.48.48 0 0 0-.06.27V12h5Z" fill="url(#ic_fluent_wrench_screwdriver_20_color__c)"/><path d="M5.78 2.13c.14.09.22.24.22.41V6a1 1 0 0 0 2 0V2.54a.5.5 0 0 1 .69-.46 4.5 4.5 0 0 1 .31 8.2V16a2 2 0 1 1-4 0v-5.72a4.5 4.5 0 0 1 .31-8.2.5.5 0 0 1 .47.05Z" fill="url(#ic_fluent_wrench_screwdriver_20_color__d)"/><defs><linearGradient id="ic_fluent_wrench_screwdriver_20_color__a" x1="15.83" y1=".38" x2="12.81" y2="16.97" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset=".85" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_20_color__b" x1="17" y1="18.14" x2="10.45" y2="13.59" gradientUnits="userSpaceOnUse"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_20_color__c" x1="13.38" y1="10.48" x2="14.04" y2="12.15" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA43D"/><stop offset="1" stop-color="#FB5937"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_20_color__d" x1="10" y1="-1" x2="4.8" y2="18.48" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$8b56b44f75ce906b = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver20Filled', "20", [
    "M17 12v-1.5c0-.11-.03-.2-.07-.27a.37.37 0 0 0-.17-.15.87.87 0 0 0-.24-.06 2.08 2.08 0 0 0-.25-.02H16V5.12l.13-.24.17-.32.14-.32c.04-.1.06-.18.06-.24s-.03-.17-.07-.32a7.43 7.43 0 0 0-.34-1c-.05-.15-.1-.26-.11-.34a.57.57 0 0 0-.2-.25.47.47 0 0 0-.28-.09h-2c-.1 0-.2.04-.3.1a.46.46 0 0 0-.18.24 13.58 13.58 0 0 1-.3.86 43.7 43.7 0 0 0-.22.8c0 .07.02.16.06.25a7.72 7.72 0 0 0 .44.87V10h-.27c-.09 0-.18 0-.26.02a.72.72 0 0 0-.24.07.44.44 0 0 0-.17.14.48.48 0 0 0-.06.27V12h5Zm0 1h-5v2.55c0 .34.07.66.2.96a2.58 2.58 0 0 0 1.35 1.3 2.47 2.47 0 0 0 1.9 0c.3-.14.57-.31.8-.53.23-.22.41-.48.55-.77.13-.3.2-.62.2-.96V13ZM5.78 2.13c.14.09.22.24.22.41V6a1 1 0 0 0 2 0V2.54a.5.5 0 0 1 .69-.46 4.5 4.5 0 0 1 .31 8.2V16a2 2 0 1 1-4 0v-5.72a4.5 4.5 0 0 1 .31-8.2.5.5 0 0 1 .47.05Z"
]);
const $77e1bce0ac0f7fe7$export$2427341ac31ef2be = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver20Regular', "20", [
    "M17 15.55V10.5c0-.11-.03-.2-.07-.27a.37.37 0 0 0-.17-.15.87.87 0 0 0-.24-.06 2.08 2.08 0 0 0-.25-.02H16V5.12l.13-.24.17-.32.14-.32c.04-.1.06-.18.06-.24s-.03-.17-.07-.32a7.43 7.43 0 0 0-.34-1c-.05-.15-.1-.26-.11-.34a.57.57 0 0 0-.2-.25.47.47 0 0 0-.28-.09h-2c-.1 0-.2.04-.3.1a.46.46 0 0 0-.18.24 13.58 13.58 0 0 1-.3.86 43.7 43.7 0 0 0-.22.8c0 .07.02.16.06.25a7.72 7.72 0 0 0 .44.87V10h-.27c-.09 0-.18 0-.26.02a.72.72 0 0 0-.24.07.44.44 0 0 0-.17.14.48.48 0 0 0-.06.27v5.05c0 .34.07.66.2.96a2.58 2.58 0 0 0 1.35 1.3 2.47 2.47 0 0 0 1.9 0c.3-.14.57-.31.8-.53.23-.22.41-.48.55-.77.13-.3.2-.62.2-.96ZM15 10h-1V5a.5.5 0 0 0-.05-.23l-.41-.8.32-.97h1.28l.32.96-.4.81A.5.5 0 0 0 15 5v5Zm-2 2v-1h3v1h-3Zm3 1v2.5c0 .2-.03.4-.12.58a1.5 1.5 0 0 1-1.96.8A1.5 1.5 0 0 1 13 15.5V13h3ZM6 2.54a.5.5 0 0 0-.69-.46 4.5 4.5 0 0 0-.31 8.2V16a2 2 0 0 0 4 0v-5.72a4.5 4.5 0 0 0-.31-8.2.5.5 0 0 0-.69.46V6a1 1 0 1 1-2 0V2.54ZM3.5 6.25c0-1.19.6-2.24 1.5-2.87V6a2 2 0 1 0 4 0V3.38a3.5 3.5 0 0 1-.69 6.12.5.5 0 0 0-.31.46V16a1 1 0 1 1-2 0V9.96a.5.5 0 0 0-.31-.46A3.5 3.5 0 0 1 3.5 6.25Z"
]);
const $77e1bce0ac0f7fe7$export$361fcff3bec2227f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver24Color', "24", `<path d="M16.75 2a.75.75 0 0 0-.67.41l-1 2c-.11.23-.1.5.02.71L16 6.7v5.8h3V6.7l.9-1.58a.75.75 0 0 0 .02-.7l-1-2a.75.75 0 0 0-.67-.42h-1.5Z" fill="url(#ic_fluent_wrench_screwdriver_24_color__a)"/><path d="M14 14.5v4a3.5 3.5 0 1 0 7 0v-4h-7Z" fill="url(#ic_fluent_wrench_screwdriver_24_color__b)"/><path d="M20.25 12c.41 0 .75.34.75.75V15h-7v-2.25c0-.41.34-.75.75-.75h5.5Z" fill="url(#ic_fluent_wrench_screwdriver_24_color__c)"/><path d="M8.83 2.21c.2-.14.47-.17.7-.07a5.5 5.5 0 0 1 .5 10v7.32a2.54 2.54 0 0 1-5.07 0v-7.33a5.5 5.5 0 0 1 .51-10 .75.75 0 0 1 1.03.7V6.5a1 1 0 1 0 2 0V2.83c0-.25.12-.48.33-.62Z" fill="url(#ic_fluent_wrench_screwdriver_24_color__d)"/><defs><linearGradient id="ic_fluent_wrench_screwdriver_24_color__a" x1="19.17" y1="0" x2="15.47" y2="20.5" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset=".85" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_24_color__b" x1="21" y1="22.17" x2="13.05" y2="15.46" gradientUnits="userSpaceOnUse"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_24_color__c" x1="15.93" y1="12.73" x2="16.98" y2="15.18" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA43D"/><stop offset="1" stop-color="#FB5937"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_24_color__d" x1="11.17" y1="-1.71" x2="4.56" y2="22.53" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$2b02e278d3375f25 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver24Filled', "24", [
    "M16.08 2.41a.75.75 0 0 1 .67-.41h1.5c.28 0 .54.16.67.41l1 2c.11.23.1.5-.02.71L19 6.7V12h1.25c.41 0 .75.34.75.75v1.75h-7v-1.75c0-.41.34-.75.75-.75H16V6.7l-.9-1.58a.75.75 0 0 1-.02-.7l1-2ZM14 16v2.5a3.5 3.5 0 1 0 7 0V16h-7ZM8.83 2.21c.2-.14.47-.17.7-.07a5.5 5.5 0 0 1 .5 10v7.32a2.54 2.54 0 0 1-5.07 0v-7.33a5.5 5.5 0 0 1 .51-10 .75.75 0 0 1 1.03.7V6.5a1 1 0 1 0 2 0V2.83c0-.25.12-.48.33-.62Z"
]);
const $77e1bce0ac0f7fe7$export$380a43a96e0283bb = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver24Regular', "24", [
    "M16.25 2a.75.75 0 0 0-.67.41l-1 2c-.11.23-.1.5.02.71l.9 1.58V12h-.75a.75.75 0 0 0-.75.75v5.75a3.5 3.5 0 1 0 7 0v-5.75a.75.75 0 0 0-.75-.75h-.75V6.7l.9-1.58a.75.75 0 0 0 .02-.7l-1-2a.75.75 0 0 0-.67-.42h-2.5ZM18 12h-1V6.5a.75.75 0 0 0-.1-.37l-.8-1.4.61-1.23h1.58l.61 1.23-.8 1.4a.75.75 0 0 0-.1.37V12Zm-2.5 6.5V16h4v2.5a2 2 0 1 1-4 0Zm4-4h-4v-1h4v1ZM9.53 2.14a.75.75 0 0 0-1.03.7V6.5a1 1 0 0 1-2 0V2.83a.75.75 0 0 0-1.03-.7 5.5 5.5 0 0 0-.5 10v7.33a2.54 2.54 0 0 0 5.07 0v-7.33a5.5 5.5 0 0 0-.51-10ZM10 6.5V4.13a4 4 0 0 1-1 6.83.75.75 0 0 0-.46.7v7.8a1.04 1.04 0 0 1-2.08 0v-7.8c0-.31-.18-.59-.46-.7a4 4 0 0 1-1-6.83V6.5a2.5 2.5 0 1 0 5 0Z"
]);
const $77e1bce0ac0f7fe7$export$11a0897811c6bd2f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver28Filled', "28", [
    "M11.37 2.8a.75.75 0 0 1 .74 0A6.5 6.5 0 0 1 11 14.67V24l-.01.2A2 2 0 0 1 7 24v-9.32A6.5 6.5 0 0 1 5.9 2.8a.75.75 0 0 1 1.1.66V6.5l.01.2A2 2 0 0 0 9 8.5l.2-.01A2 2 0 0 0 11 6.5V3.45c0-.27.14-.51.37-.65ZM25 22a4 4 0 0 1-8 0v-3.5h8V22ZM22.18 2c.23.04.44.18.56.39l1.25 2.25c.11.2.12.45.03.66l-.94 2.1V14h1.17c.41 0 .75.34.75.75V17h-8v-2.25c0-.41.34-.75.75-.75h1.33V7.4l-.93-2.1a.75.75 0 0 1 .03-.66l1.25-2.25.05-.09c.14-.19.36-.3.6-.3h2.1Z"
]);
const $77e1bce0ac0f7fe7$export$4cd0e83edc470ca7 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver28Regular', "28", [
    "M10.3 2.42c.2-.15.45-.19.68-.11a6.5 6.5 0 0 1 .52 12.19v9a2.5 2.5 0 0 1-5 0v-9a6.5 6.5 0 0 1 .52-12.2.75.75 0 0 1 .98.72V7.6a1 1 0 0 0 2-.1V3.02c0-.24.11-.46.3-.6ZM22.1 2c.23.03.44.17.56.38l1.25 2.25c.11.2.12.45.03.66L23 7.4V14h1.25c.41 0 .75.34.75.75v6.75a4.5 4.5 0 1 1-9 0v-6.75c0-.41.34-.75.75-.75H18V7.4l-.94-2.1a.75.75 0 0 1 .03-.66l1.25-2.25.06-.09c.14-.19.36-.3.6-.3h3.1ZM11.5 7.5l-.01.26A2.5 2.5 0 0 1 6.5 7.5V4.17A5 5 0 0 0 4 8.5v.2a5 5 0 0 0 3.48 4.56c.3.1.52.4.52.72v9.52a1 1 0 1 0 2 0v-9.52c0-.33.21-.62.52-.72A5 5 0 0 0 14 8.71V8.5a5 5 0 0 0-2.5-4.33V7.5Zm6 14a3 3 0 1 0 6 0v-3h-6v3Zm0-4.5h6v-1.5h-6V17Zm1.09-11.96.85 1.9c.04.1.06.2.06.31V14h2V7.25c0-.1.02-.2.06-.3l.85-1.91-.85-1.54h-2.12l-.85 1.54Z"
]);
const $77e1bce0ac0f7fe7$export$584d04c0a8f115a0 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Color', "32", `<path d="M22 3a1 1 0 0 0-.93.63l-1 2.5a1 1 0 0 0 0 .74L21 9.2V16h5V9.2l.93-2.33a1 1 0 0 0 0-.74l-1-2.5A1 1 0 0 0 25 3h-3Z" fill="url(#ic_fluent_wrench_screwdriver_32_color__a)"/><path d="M18 19.5v4a5.5 5.5 0 1 0 11 0v-4H18Z" fill="url(#ic_fluent_wrench_screwdriver_32_color__b)"/><path d="M28 16a1 1 0 0 1 1 1v3H18v-3a1 1 0 0 1 1-1h9Z" fill="url(#ic_fluent_wrench_screwdriver_32_color__c)"/><path d="M8.58 3.52a1 1 0 0 1 .42.82V9a1 1 0 0 0 2 0V4.34a1 1 0 0 1 1.33-.94A7 7 0 0 1 13 16.33V26a3 3 0 1 1-6 0v-9.67A7 7 0 0 1 7.67 3.4a1 1 0 0 1 .9.12Z" fill="url(#ic_fluent_wrench_screwdriver_32_color__d)"/><defs><linearGradient id="ic_fluent_wrench_screwdriver_32_color__a" x1="25.83" y1=".52" x2="21.76" y2="26.08" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset=".85" stop-color="#0067BF"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_32_color__b" x1="29" y1="29.21" x2="18.79" y2="18.53" gradientUnits="userSpaceOnUse"><stop stop-color="#FF6F47"/><stop offset="1" stop-color="#FFCD0F"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_32_color__c" x1="21.03" y1="16.97" x2="22.27" y2="20.38" gradientUnits="userSpaceOnUse"><stop stop-color="#FFA43D"/><stop offset="1" stop-color="#FB5937"/></linearGradient><linearGradient id="ic_fluent_wrench_screwdriver_32_color__d" x1="14.67" y1="-1.55" x2="6.06" y2="29.63" gradientUnits="userSpaceOnUse"><stop stop-color="#2BDABE"/><stop offset="1" stop-color="#0067BF"/></linearGradient></defs>`, {
    color: true
});
const $77e1bce0ac0f7fe7$export$939d25515cf94e9f = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Filled', "32", [
    "M21.07 3.63A1 1 0 0 1 22 3h3a1 1 0 0 1 .93.63l1 2.5c.1.24.1.5 0 .74L26 9.2V16h2a1 1 0 0 1 1 1v3H18v-3a1 1 0 0 1 1-1h2V9.2l-.93-2.33a1 1 0 0 1 0-.74l1-2.5Zm-12.5-.1a1 1 0 0 1 .43.81V9a1 1 0 0 0 2 0V4.34a1 1 0 0 1 1.33-.94A7 7 0 0 1 13 16.33V26a3 3 0 1 1-6 0v-9.67A7 7 0 0 1 7.67 3.4a1 1 0 0 1 .9.12ZM18 22v1.5a5.5 5.5 0 1 0 11 0V22H18Z"
]);
const $77e1bce0ac0f7fe7$export$717167534271843d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Light', "32", [
    "M21.5 3h4c.19 0 .36.1.45.28l1.5 3a.5.5 0 0 1 0 .44L26 9.62V16h2.5c.28 0 .5.22.5.5v7a5.5 5.5 0 1 1-11 0v-7c0-.28.22-.5.5-.5H21V9.62l-1.45-2.9a.5.5 0 0 1 0-.44l1.5-3A.5.5 0 0 1 21.5 3ZM25 16V9.5a.5.5 0 0 1 .05-.22l1.4-2.78L25.18 4h-3.38l-1.25 2.5 1.39 2.78a.5.5 0 0 1 .05.22V16h3Zm-6 1v3h9v-3h-9Zm0 4v2.5a4.5 4.5 0 1 0 9 0V21h-9ZM7.78 3.58c.14.1.22.25.22.42v5a2 2 0 1 0 4 0V4a.5.5 0 0 1 .7-.46 7 7 0 0 1 .3 12.79V26a3 3 0 1 1-6 0v-9.67a7 7 0 0 1 .3-12.8.5.5 0 0 1 .48.05ZM7 4.8a6 6 0 0 0 .7 10.74c.18.08.3.26.3.46v10a2 2 0 1 0 4 0V16c0-.2.12-.38.3-.46A6 6 0 0 0 13 4.8V9a3 3 0 1 1-6 0V4.8Z"
]);
const $77e1bce0ac0f7fe7$export$75fa6cae5f6f100c = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchScrewdriver32Regular', "32", [
    "M21 3a1 1 0 0 0-.93.63l-1 2.5a1 1 0 0 0 0 .74L20 9.2V16h-1a1 1 0 0 0-1 1v6.5a5.5 5.5 0 1 0 11 0V17a1 1 0 0 0-1-1h-1V9.2l.93-2.33a1 1 0 0 0 0-.74l-1-2.5A1 1 0 0 0 26 3h-5Zm4 13h-3V9a1 1 0 0 0-.07-.37l-.85-2.13.6-1.5h3.64l.6 1.5-.85 2.13A1 1 0 0 0 25 9v7Zm-5 2h7v2h-7v-2ZM8.58 3.52a1 1 0 0 1 .42.82V9a1 1 0 0 0 2 0V4.34a1 1 0 0 1 1.33-.94A7 7 0 0 1 13 16.33V26a3 3 0 1 1-6 0v-9.67A7 7 0 0 1 7.67 3.4a1 1 0 0 1 .9.12ZM7 6a5 5 0 0 0 1.33 8.72 1 1 0 0 1 .67.94V26a1 1 0 1 0 2 0V15.66a1 1 0 0 1 .67-.94A5 5 0 0 0 13 6v3a3 3 0 1 1-6 0V6Zm13 16h7v1.5a3.5 3.5 0 1 1-7 0V22Z"
]);
const $77e1bce0ac0f7fe7$export$e2095562c14d46e5 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings20Filled', "20", [
    "M13.5 2a4.5 4.5 0 0 0-4.42 5.36l-6.42 6.66a2.36 2.36 0 0 0 3.37 3.3L9 14.3a5.5 5.5 0 0 1 7.84-4.78 4.48 4.48 0 0 0 1.05-4.03.5.5 0 0 0-.84-.24L14.5 7.79 12.2 5.5l2.55-2.55a.5.5 0 0 0-.24-.84 4.51 4.51 0 0 0-1-.11Zm-2.86 11.92a2 2 0 0 0 1.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.71 4.71 0 0 1 0-1.01l.46-.12Zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
]);
const $77e1bce0ac0f7fe7$export$ae9c779e9b0cc570 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings20Regular', "20", [
    "M9 6.5a4.5 4.5 0 0 1 6.35-4.1.5.5 0 0 1 .15.8l-2.3 2.3 1.3 1.3 2.3-2.3a.5.5 0 0 1 .8.15 4.49 4.49 0 0 1-.76 4.87 5.46 5.46 0 0 0-1.05-.37 3.5 3.5 0 0 0 1.14-3.37l-2.08 2.07a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2.07-2.08a3.52 3.52 0 0 0-4.1 4.32.5.5 0 0 1-.13.47L3.38 14.7a1.36 1.36 0 0 0 1.94 1.9l4.06-4.11A5.48 5.48 0 0 0 9 14.3L6.03 17.3a2.36 2.36 0 0 1-3.37-3.3l6.42-6.65A4.52 4.52 0 0 1 9 6.5Zm1.64 7.42a2 2 0 0 0 1.43-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.71 4.71 0 0 1 0-1.01l.46-.12Zm2.86.58a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
]);
const $77e1bce0ac0f7fe7$export$735e049a81ee038d = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings24Filled', "24", [
    "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l4.12-4.11a6.5 6.5 0 0 1 9.17-5.47 5.49 5.49 0 0 0 1.53-5.82.75.75 0 0 0-1.24-.3l-2.45 2.45c-.3.29-.77.29-1.06 0l-.88-.88a.75.75 0 0 1 0-1.06l2.45-2.45a.75.75 0 0 0-.3-1.24A5.5 5.5 0 0 0 16.5 2Zm-2.22 11.98a2 2 0 0 1-1.44 2.5l-.59.14a5.73 5.73 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64c.44.38.94.7 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5.28 5.28 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a5.73 5.73 0 0 0-.01-1.8l-.54-.13a2 2 0 0 1-1.45-2.51l.19-.63c-.44-.39-.94-.7-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52c-.54.22-1.04.53-1.48.9l.2.7ZM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19Z"
]);
const $77e1bce0ac0f7fe7$export$a696513800429c8 = /*#__PURE__*/ (0, $5ca69d2d5c3b46dc$export$8977aaf2b9d73b87)('WrenchSettings24Regular', "24", [
    "M16.5 2a5.5 5.5 0 0 0-5.35 6.79l-8.3 8.31a2.87 2.87 0 1 0 4.05 4.06l4.12-4.11c.08-1.22.5-2.35 1.17-3.3L5.84 20.1a1.37 1.37 0 0 1-1.94-1.94l8.62-8.62c.2-.2.28-.5.19-.77a4 4 0 0 1 4.2-5.25l-1.84 1.85a1.25 1.25 0 0 0 0 1.76l1.8 1.8c.48.48 1.28.48 1.76 0l1.85-1.85.02.42a4 4 0 0 1-2.16 3.55c.65.09 1.27.27 1.85.53a5.49 5.49 0 0 0 1.37-6.24.75.75 0 0 0-1.22-.24L17.75 7.7l-1.44-1.44 2.59-2.59a.75.75 0 0 0-.24-1.22A5.48 5.48 0 0 0 16.5 2Zm-2.22 11.98a2 2 0 0 1-1.44 2.5l-.59.14a5.73 5.73 0 0 0 0 1.8l.55.13a2 2 0 0 1 1.45 2.51l-.19.64c.44.38.94.7 1.49.92l.49-.52a2 2 0 0 1 2.9 0l.5.52a5.28 5.28 0 0 0 1.48-.91l-.2-.69a2 2 0 0 1 1.44-2.5l.59-.14a5.73 5.73 0 0 0-.01-1.8l-.54-.13a2 2 0 0 1-1.45-2.51l.19-.63c-.44-.39-.94-.7-1.49-.93l-.49.52a2 2 0 0 1-2.9 0l-.5-.52c-.54.22-1.04.53-1.48.9l.2.7ZM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19Z"
]);



'use client';
const $25567175ba75005f$var$DEFAULT_SPIN_DELAY_MS = 150;
const $25567175ba75005f$var$MIN_SPIN_DELAY_MS = 80;
const $25567175ba75005f$var$MAX_SPIN_TIME_MS = 1000;
// This is here to give an ease for the mouse held down case.
// Exact easing it to be defined. Once it is we'll likely
// pull this out into a util function in the SpinButton package.
const $25567175ba75005f$var$lerp = (start, end, percent)=>start + (end - start) * percent;
const $25567175ba75005f$export$f8886578e4f19ca3 = (props, ref)=>{
    const nativeProps = (0, $f5c0cec12bf016e1$export$199c93d3d8d08c56)({
        props: props,
        primarySlotTagName: 'input',
        excludedPropNames: [
            'defaultValue',
            'max',
            'min',
            'onChange',
            'value'
        ]
    });
    const { value: value, displayValue: displayValue, defaultValue: defaultValue, min: min, max: max, step: step = 1, stepPage: stepPage = 1, precision: precisionFromProps, onChange: onChange, root: root, input: input, incrementButton: incrementButton, decrementButton: decrementButton } = props;
    const precision = $acw62.useMemo(()=>{
        return precisionFromProps !== null && precisionFromProps !== void 0 ? precisionFromProps : Math.max((0, $ad78e04db390d0d8$export$fb97a23451ff4bd8)(step), 0);
    }, [
        precisionFromProps,
        step
    ]);
    const [currentValue, setCurrentValue] = (0, $18a7d7467c2b10b3$export$6f32135080cb4c3)({
        state: value,
        defaultState: defaultValue,
        initialState: 0
    });
    const inputRef = $acw62.useRef(null);
    const isControlled = value !== undefined;
    const [textValue, setTextValue] = $acw62.useState(undefined);
    const [keyboardSpinState, setKeyboardSpinState] = $acw62.useState('rest');
    const internalState = $acw62.useRef({
        value: currentValue,
        spinState: 'rest',
        spinTime: 0,
        spinDelay: $25567175ba75005f$var$DEFAULT_SPIN_DELAY_MS,
        atBound: currentValue !== null ? (0, $24bfcc54f48da074$export$e0323f9c333f1b2a)((0, $ad78e04db390d0d8$export$21940c83e368df92)(currentValue, precision), min, max) : 'none'
    });
    const [setStepTimeout, clearStepTimeout] = (0, $bf7615d1d68d35d9$export$d8e6abf214c9ec0f)();
    const stepValue = (e, direction, startFrom)=>{
        let startValue = internalState.current.value;
        if (startFrom) {
            const num = parseFloat(startFrom);
            if (!isNaN(num)) startValue = num;
        }
        const val = startValue;
        const dir = direction === 'up' || direction === 'upPage' ? 1 : -1;
        const stepSize = direction === 'upPage' || direction === 'downPage' ? stepPage : step;
        if (val === null) {
            const stepStart = min === undefined ? 0 : min;
            const nullStep = (0, $902b29ca1597bd57$export$7d15b64cf5a3a4c4)(stepStart + stepSize * dir, min, max);
            commit(e, nullStep);
            return;
        }
        let newValue = val + stepSize * dir;
        if (!Number.isNaN(newValue)) newValue = (0, $902b29ca1597bd57$export$7d15b64cf5a3a4c4)(newValue, min, max);
        commit(e, newValue);
        if (internalState.current.spinState !== 'rest') setStepTimeout(()=>{
            // Ease the step speed a bit
            internalState.current.spinTime += internalState.current.spinDelay;
            internalState.current.spinDelay = $25567175ba75005f$var$lerp($25567175ba75005f$var$DEFAULT_SPIN_DELAY_MS, $25567175ba75005f$var$MIN_SPIN_DELAY_MS, internalState.current.spinTime / $25567175ba75005f$var$MAX_SPIN_TIME_MS);
            stepValue(e, direction);
        }, internalState.current.spinDelay);
    };
    const handleInputChange = (e)=>{
        if (!internalState.current.previousTextValue) internalState.current.previousTextValue = textValue !== null && textValue !== void 0 ? textValue : String(currentValue);
        const newValue = e.target.value;
        setTextValue(newValue);
        if (inputRef.current) // we need to set this here using the IDL attribute directly, because otherwise the timing of the ARIA value update
        // is not in sync with the user-entered native input value, and some screen readers end up reading the wrong value.
        // eslint-disable-next-line react-compiler/react-compiler
        inputRef.current.ariaValueNow = newValue;
    };
    const handleIncrementMouseDown = (e)=>{
        commit(e, currentValue, textValue);
        internalState.current.spinState = 'up';
        stepValue(e, 'up');
    };
    const handleDecrementMouseDown = (e)=>{
        commit(e, currentValue, textValue);
        internalState.current.spinState = 'down';
        stepValue(e, 'down');
    };
    const handleStepMouseUpOrLeave = (e)=>{
        clearStepTimeout();
        internalState.current.spinState = 'rest';
        internalState.current.spinDelay = $25567175ba75005f$var$DEFAULT_SPIN_DELAY_MS;
        internalState.current.spinTime = 0;
    };
    const handleBlur = (e)=>{
        commit(e, currentValue, textValue);
        internalState.current.previousTextValue = undefined;
    };
    const handleKeyDown = (e)=>{
        let nextKeyboardSpinState = 'rest';
        if (e.currentTarget.readOnly) return;
        if (e.key === (0, $c823d65ebf8ac0ff$export$2624c5890f1bbcf7)) {
            stepValue(e, 'up', textValue);
            nextKeyboardSpinState = 'up';
        } else if (e.key === (0, $c823d65ebf8ac0ff$export$1fa5a43af950a186)) {
            stepValue(e, 'down', textValue);
            nextKeyboardSpinState = 'down';
        } else if (e.key === (0, $c823d65ebf8ac0ff$export$f1f11e2fed2d2ae0)) {
            e.preventDefault();
            stepValue(e, 'upPage', textValue);
            nextKeyboardSpinState = 'up';
        } else if (e.key === (0, $c823d65ebf8ac0ff$export$f3f5fc7dcaa52927)) {
            e.preventDefault();
            stepValue(e, 'downPage', textValue);
            nextKeyboardSpinState = 'down';
        } else if (!e.shiftKey && e.key === (0, $c823d65ebf8ac0ff$export$b94310965bed44e6) && min !== undefined) {
            commit(e, min);
            nextKeyboardSpinState = 'down';
        } else if (!e.shiftKey && e.key === (0, $c823d65ebf8ac0ff$export$290d774e6bd35c9a) && max !== undefined) {
            commit(e, max);
            nextKeyboardSpinState = 'up';
        } else if (e.key === (0, $c823d65ebf8ac0ff$export$64a2c9e77ce3aa7a)) {
            commit(e, currentValue, textValue);
            internalState.current.previousTextValue = undefined;
        } else if (e.key === (0, $c823d65ebf8ac0ff$export$d244daf709653685)) {
            if (internalState.current.previousTextValue) {
                setTextValue(undefined);
                internalState.current.previousTextValue = undefined;
            }
        }
        if (keyboardSpinState !== nextKeyboardSpinState) setKeyboardSpinState(nextKeyboardSpinState);
    };
    const handleKeyUp = (e)=>{
        if (keyboardSpinState !== 'rest') {
            setKeyboardSpinState('rest');
            internalState.current.spinState = 'rest';
        }
    };
    const commit = (e, newValue, newDisplayValue)=>{
        const valueChanged = newValue !== undefined && currentValue !== newValue;
        const displayValueChanged = newDisplayValue !== undefined && internalState.current.previousTextValue !== undefined && internalState.current.previousTextValue !== newDisplayValue;
        let roundedValue;
        if (valueChanged) {
            roundedValue = (0, $ad78e04db390d0d8$export$21940c83e368df92)(newValue, precision);
            setCurrentValue(roundedValue);
            internalState.current.value = roundedValue;
        } else if (displayValueChanged && !isControlled) {
            const nextValue = parseFloat(newDisplayValue);
            if (!isNaN(nextValue)) {
                setCurrentValue((0, $ad78e04db390d0d8$export$21940c83e368df92)(nextValue, precision));
                internalState.current.value = (0, $ad78e04db390d0d8$export$21940c83e368df92)(nextValue, precision);
            }
        }
        if (valueChanged || displayValueChanged) onChange === null || onChange === void 0 || onChange(e, {
            value: roundedValue,
            displayValue: newDisplayValue
        });
        setTextValue(undefined);
    };
    let valueToDisplay;
    if (textValue !== undefined) valueToDisplay = textValue;
    else if (value === null || currentValue === null) {
        valueToDisplay = displayValue !== null && displayValue !== void 0 ? displayValue : '';
        internalState.current.value = null;
        internalState.current.atBound = 'none';
    } else {
        const roundedValue = (0, $ad78e04db390d0d8$export$21940c83e368df92)(currentValue, precision);
        internalState.current.value = roundedValue;
        internalState.current.atBound = (0, $24bfcc54f48da074$export$e0323f9c333f1b2a)(roundedValue, min, max);
        if (isControlled) valueToDisplay = displayValue !== null && displayValue !== void 0 ? displayValue : String(roundedValue);
        else valueToDisplay = String(roundedValue);
    }
    const state = {
        spinState: keyboardSpinState,
        atBound: internalState.current.atBound,
        components: {
            root: 'span',
            input: 'input',
            incrementButton: 'button',
            decrementButton: 'button'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always(root, {
            defaultProps: nativeProps.root,
            elementType: 'span'
        }),
        input: (0, $fcf7ddccaab7fd8f$exports).always(input, {
            defaultProps: {
                autoComplete: 'off',
                role: 'spinbutton',
                type: 'text',
                ...nativeProps.primary
            },
            elementType: 'input'
        }),
        incrementButton: (0, $fcf7ddccaab7fd8f$exports).always(incrementButton, {
            defaultProps: {
                tabIndex: -1,
                disabled: nativeProps.primary.readOnly || nativeProps.primary.disabled || internalState.current.atBound === 'max' || internalState.current.atBound === 'both',
                'aria-label': 'Increment value',
                type: 'button'
            },
            elementType: 'button'
        }),
        decrementButton: (0, $fcf7ddccaab7fd8f$exports).always(decrementButton, {
            defaultProps: {
                tabIndex: -1,
                disabled: nativeProps.primary.readOnly || nativeProps.primary.disabled || internalState.current.atBound === 'min' || internalState.current.atBound === 'both',
                'aria-label': 'Decrement value',
                type: 'button'
            },
            elementType: 'button'
        })
    };
    state.input.value = valueToDisplay;
    state.input.ref = (0, $de7d48ea62179626$export$9cf7d991616612b3)(inputRef, ref);
    state.input['aria-valuemin'] = min;
    state.input['aria-valuemax'] = max;
    var _internalState_current_value;
    state.input['aria-valuenow'] = (_internalState_current_value = internalState.current.value) !== null && _internalState_current_value !== void 0 ? _internalState_current_value : undefined;
    var _state_input_ariavaluetext;
    state.input['aria-valuetext'] = (_state_input_ariavaluetext = state.input['aria-valuetext']) !== null && _state_input_ariavaluetext !== void 0 ? _state_input_ariavaluetext : value !== undefined && displayValue || undefined;
    state.input.onChange = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.input.onChange, handleInputChange);
    state.input.onInput = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.input.onInput, handleInputChange);
    state.input.onBlur = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.input.onBlur, handleBlur);
    state.input.onKeyDown = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.input.onKeyDown, handleKeyDown);
    state.input.onKeyUp = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.input.onKeyUp, handleKeyUp);
    state.incrementButton.onMouseDown = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(handleIncrementMouseDown, state.incrementButton.onMouseDown);
    state.incrementButton.onMouseUp = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.incrementButton.onMouseUp, handleStepMouseUpOrLeave);
    state.incrementButton.onMouseLeave = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.incrementButton.onMouseLeave, handleStepMouseUpOrLeave);
    state.decrementButton.onMouseDown = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(handleDecrementMouseDown, state.decrementButton.onMouseDown);
    state.decrementButton.onMouseUp = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.decrementButton.onMouseUp, handleStepMouseUpOrLeave);
    state.decrementButton.onMouseLeave = (0, $5a086c5c32116b33$export$f05a241035b5c5eb)(state.decrementButton.onMouseLeave, handleStepMouseUpOrLeave);
    return state;
};
const $25567175ba75005f$export$6685a3eb800fe2c0 = (props, ref)=>{
    var _state_incrementButton, _state_decrementButton;
    // Merge props from surrounding <Field>, if any
    props = (0, $af5cf4826b6cd175$export$fc5228adfb2d94ce)(props, {
        supportsLabelFor: true,
        supportsRequired: true
    });
    const overrides = (0, $dcb30b81376c0f2d$export$ab0d8295b09da679)();
    var _overrides_inputDefaultAppearance;
    const { appearance: appearance = (_overrides_inputDefaultAppearance = overrides.inputDefaultAppearance) !== null && _overrides_inputDefaultAppearance !== void 0 ? _overrides_inputDefaultAppearance : 'outline', size: size = 'medium', ...baseProps } = props;
    const state = $25567175ba75005f$export$f8886578e4f19ca3(baseProps, ref);
    var _children;
    (_children = (_state_incrementButton = state.incrementButton).children) !== null && _children !== void 0 ? _children : _state_incrementButton.children = /*#__PURE__*/ $acw62.createElement((0, $77e1bce0ac0f7fe7$export$5fc3128e974fde90), null);
    var _children1;
    (_children1 = (_state_decrementButton = state.decrementButton).children) !== null && _children1 !== void 0 ? _children1 : _state_decrementButton.children = /*#__PURE__*/ $acw62.createElement((0, $77e1bce0ac0f7fe7$export$4c6c51570726ab4d), null);
    return {
        ...state,
        appearance: appearance,
        size: size
    };
};




const $9ed305c504b85bf5$export$b583e644dcbc1a26 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$25062201e9e25d76)(state.root, {
        children: [
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.input, {}),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.incrementButton, {}),
            /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.decrementButton, {})
        ]
    });
};




'use client';
const $931e3c5aa8fcfc9e$export$823a2a4502bf6ba9 = {
    root: 'fui-SpinButton',
    input: 'fui-SpinButton__input',
    incrementButton: 'fui-SpinButton__incrementButton',
    decrementButton: 'fui-SpinButton__decrementButton'
};
const $931e3c5aa8fcfc9e$var$spinButtonExtraClassNames = {
    buttonActive: 'fui-SpinButton__button_active'
};
const $931e3c5aa8fcfc9e$var$fieldHeights = {
    small: '24px',
    medium: '32px'
};
const $931e3c5aa8fcfc9e$var$useRootClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r109xulx", "r1h2jnch", {
    r: [
        ".r109xulx{display:inline-grid;grid-template-columns:1fr 24px;grid-template-rows:1fr 1fr;column-gap:var(--spacingHorizontalXS);row-gap:0;position:relative;isolation:isolate;vertical-align:middle;background-color:var(--colorNeutralBackground1);min-height:32px;padding:0 0 0 var(--spacingHorizontalMNudge);border-radius:var(--borderRadiusMedium);}",
        ".r109xulx::before{content:\"\";box-sizing:border-box;position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;z-index:10;border:1px solid var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStrokeAccessible);border-radius:var(--borderRadiusMedium);}",
        ".r109xulx::after{box-sizing:border-box;content:\"\";position:absolute;right:0;bottom:0;left:0;z-index:20;height:max(2px, var(--borderRadiusMedium));border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-bottom:2px solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - 2px) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}",
        ".r109xulx:focus-within::after{transform:scaleX(1);transition-property:transform;transition-duration:var(--durationNormal);transition-delay:var(--curveDecelerateMid);}",
        ".r109xulx:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",
        ".r109xulx:focus-within{outline:2px solid transparent;}",
        ".r1h2jnch{display:inline-grid;grid-template-columns:1fr 24px;grid-template-rows:1fr 1fr;column-gap:var(--spacingHorizontalXS);row-gap:0;position:relative;isolation:isolate;vertical-align:middle;background-color:var(--colorNeutralBackground1);min-height:32px;padding:0 var(--spacingHorizontalMNudge) 0 0;border-radius:var(--borderRadiusMedium);}",
        ".r1h2jnch::before{content:\"\";box-sizing:border-box;position:absolute;top:0;left:0;bottom:0;right:0;pointer-events:none;z-index:10;border:1px solid var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStrokeAccessible);border-radius:var(--borderRadiusMedium);}",
        ".r1h2jnch::after{box-sizing:border-box;content:\"\";position:absolute;left:0;bottom:0;right:0;z-index:20;height:max(2px, var(--borderRadiusMedium));border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-bottom:2px solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - 2px) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}",
        ".r1h2jnch:focus-within::after{transform:scaleX(1);transition-property:transform;transition-duration:var(--durationNormal);transition-delay:var(--curveDecelerateMid);}",
        ".r1h2jnch:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",
        ".r1h2jnch:focus-within{outline:2px solid transparent;}"
    ],
    s: [
        "@media screen and (prefers-reduced-motion: reduce){.r109xulx::after{transition-duration:0.01ms;transition-delay:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r109xulx:focus-within::after{transition-duration:0.01ms;transition-delay:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1h2jnch::after{transition-duration:0.01ms;transition-delay:0.01ms;}}",
        "@media screen and (prefers-reduced-motion: reduce){.r1h2jnch:focus-within::after{transition-duration:0.01ms;transition-delay:0.01ms;}}"
    ]
});
const $931e3c5aa8fcfc9e$var$useRootStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    small: {
        sshi5w: "f1pha7fy",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ]
    },
    medium: {},
    outline: {},
    outlineInteractive: {
        Bo3r8zu: "f1w2y1rc",
        Hpvxnh: [
            "f1gofhvl",
            "f18htlvq"
        ],
        Bx11ytk: "ffcnd28",
        B1rg0w0: [
            "f18htlvq",
            "f1gofhvl"
        ],
        Bsg1tlv: "f6lmxco",
        Brjw370: [
            "fcoc0mf",
            "f15r4wkl"
        ],
        xcfy85: "f1ipdth8",
        Bcc6kan: [
            "f15r4wkl",
            "fcoc0mf"
        ]
    },
    underline: {
        B0qfbqy: "f1o236ok",
        B4f6apu: [
            "faeg28l",
            "f64aojp"
        ],
        y0oebl: "fdw6hkg",
        uvfttm: [
            "f64aojp",
            "faeg28l"
        ],
        r59vdv: 0,
        Budzafs: 0,
        ck0cow: 0,
        n07z76: 0,
        Gng75u: "f1xyh2jw"
    },
    underlineInteractive: {
        Bx11ytk: "ffcnd28",
        xcfy85: "f1ipdth8",
        d9w3h3: 0,
        B3778ie: 0,
        B4j8arr: 0,
        Bl18szs: 0,
        Blrzh8d: "fkp7w9h"
    },
    filled: {
        Bcgcnre: 0,
        Bqjgrrk: 0,
        qa3bma: 0,
        y0oebl: 0,
        Biqmznv: 0,
        Bm6vgfq: 0,
        Bbv0w2i: 0,
        uvfttm: 0,
        eqrjj: 0,
        Bk5zm6e: 0,
        m598lv: 0,
        B4f6apu: 0,
        ydt019: 0,
        Bq4z7u6: 0,
        Bdkvgpv: 0,
        B0qfbqy: 0,
        kj8mxx: "f1kc0wz4"
    },
    "filled-darker": {
        De3pzq: "f16xq7d1"
    },
    "filled-lighter": {
        De3pzq: "fxugw4r"
    },
    filledInteractive: {
        B05mzqr: "f1xqt08",
        tb9y6h: [
            "fzt5lgo",
            "f8tv3r9"
        ],
        jcehpj: "fyhrops",
        B23o0hn: [
            "f8tv3r9",
            "fzt5lgo"
        ]
    },
    invalid: {
        emecyz: "fl48pg9",
        lz0pba: [
            "f1a168p3",
            "f1pvdymy"
        ],
        Bo1k74p: "f11knvgl",
        Ba322q7: [
            "f1pvdymy",
            "f1a168p3"
        ]
    },
    disabled: {
        Bceei9c: "fdrzuqr",
        De3pzq: "f1c21dwh",
        Bq4z7u6: "f1a0lfh7",
        Bk5zm6e: [
            "f1p2ejm6",
            "fmzytvz"
        ],
        Bqjgrrk: "fas2e61",
        Bm6vgfq: [
            "fmzytvz",
            "f1p2ejm6"
        ],
        Bvljrlq: "f1p5b8em",
        Cqojjj: [
            "fs6f9xf",
            "f11b7h5x"
        ],
        G3zxag: "f1vrn6tw",
        H8270r: [
            "f11b7h5x",
            "fs6f9xf"
        ]
    }
}, {
    d: [
        ".f1pha7fy{min-height:24px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1o236ok::before{border-top-width:0;}",
        ".faeg28l::before{border-right-width:0;}",
        ".f64aojp::before{border-left-width:0;}",
        ".fdw6hkg::before{border-bottom-width:1px;}",
        [
            ".f1xyh2jw::before{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        [
            ".fkp7w9h::after{border-radius:var(--borderRadiusNone);}",
            {
                p: -1
            }
        ],
        [
            ".f1kc0wz4::before{border:1px solid var(--colorTransparentStroke);}",
            {
                p: -2
            }
        ],
        ".f16xq7d1{background-color:var(--colorNeutralBackground3);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".fl48pg9:not(:focus-within)::before,.fl48pg9:hover:not(:focus-within)::before{border-top-color:var(--colorPaletteRedBorder2);}",
        ".f1a168p3:not(:focus-within)::before,.f1a168p3:hover:not(:focus-within)::before{border-right-color:var(--colorPaletteRedBorder2);}",
        ".f1pvdymy:not(:focus-within)::before,.f1pvdymy:hover:not(:focus-within)::before{border-left-color:var(--colorPaletteRedBorder2);}",
        ".f11knvgl:not(:focus-within)::before,.f11knvgl:hover:not(:focus-within)::before{border-bottom-color:var(--colorPaletteRedBorder2);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1a0lfh7::before{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1p2ejm6::before{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fmzytvz::before{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".fas2e61::before{border-bottom-color:var(--colorNeutralStrokeDisabled);}"
    ],
    h: [
        ".f1w2y1rc:hover::before{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1gofhvl:hover::before{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f18htlvq:hover::before{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".ffcnd28:hover::before{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}",
        ".f1xqt08:hover::before,.f1xqt08:focus-within::before{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".fzt5lgo:hover::before,.fzt5lgo:focus-within::before{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".f8tv3r9:hover::before,.f8tv3r9:focus-within::before{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".fyhrops:hover::before,.fyhrops:focus-within::before{border-bottom-color:var(--colorTransparentStrokeInteractive);}"
    ],
    a: [
        ".f6lmxco:active::before,.f6lmxco:focus-within::before{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".fcoc0mf:active::before,.fcoc0mf:focus-within::before{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f15r4wkl:active::before,.f15r4wkl:focus-within::before{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".f1ipdth8:active::before,.f1ipdth8:focus-within::before{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1p5b8em::before{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f11b7h5x::before{border-left-color:GrayText;}.fs6f9xf::before{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1vrn6tw::before{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const $931e3c5aa8fcfc9e$var$useInputClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r1ljrqje", null, [
    ".r1ljrqje{grid-column-start:1;grid-column-end:2;grid-row-start:1;grid-row-end:3;outline-style:none;border:0;padding:0;color:var(--colorNeutralForeground1);background-color:transparent;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;width:100%;}",
    ".r1ljrqje::-webkit-input-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r1ljrqje::-moz-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r1ljrqje::placeholder{color:var(--colorNeutralForeground4);opacity:1;}"
]);
const $931e3c5aa8fcfc9e$var$useInputStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    disabled: {
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr",
        De3pzq: "f1c21dwh",
        yvdlaj: "fahhnxm"
    }
}, {
    d: [
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}",
        ".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}"
    ]
});
const $931e3c5aa8fcfc9e$var$useBaseButtonClassName = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("r1g4chgs", null, [
    ".r1g4chgs{display:inline-flex;width:24px;align-items:center;justify-content:center;border:0;position:absolute;outline-style:none;height:16px;background-color:transparent;color:var(--colorNeutralForeground3);grid-column-start:2;border-radius:0;padding:0 5px 0 5px;}",
    ".r1g4chgs:active{outline-style:none;}",
    ".r1g4chgs:enabled:hover{cursor:pointer;color:var(--colorNeutralForeground3Hover);background-color:var(--colorSubtleBackgroundHover);}",
    ".r1g4chgs:enabled:active{color:var(--colorNeutralForeground3Pressed);background-color:var(--colorSubtleBackgroundPressed);}",
    ".r1g4chgs:enabled.fui-SpinButton__button_active{color:var(--colorNeutralForeground3Pressed);background-color:var(--colorSubtleBackgroundPressed);}",
    ".r1g4chgs:disabled{cursor:not-allowed;color:var(--colorNeutralForegroundDisabled);}"
]);
const $931e3c5aa8fcfc9e$var$useButtonStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    increment: {
        Ijaq50: "f16hsg94",
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        z8tnut: "f10ra9hq",
        Byoj8tv: "f1brlhvm"
    },
    decrement: {
        Ijaq50: "faunodf",
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        z8tnut: "f1sl3k7w",
        Byoj8tv: "f1y2xyjm"
    },
    incrementButtonSmall: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f4lv8q1",
            "fm3uwd2"
        ],
        Bqenvij: "fvblgha"
    },
    decrementButtonSmall: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: [
            "f1q86st8",
            "frkrfqj"
        ],
        Bqenvij: "fvblgha"
    },
    outline: {},
    underline: {
        De3pzq: "f3rmtva",
        sj55zd: "f11d4kpn",
        r4wkhp: "f1no7wuu",
        B95qlz1: "f1bifk9c",
        p743kt: "fp1zg4s",
        B7xitij: "fo6hitd",
        B6siaa6: "f1wiab75",
        Ba9qmo4: "fj9zm5z",
        Dyrjrp: "f1cqwcg4"
    },
    "filled-darker": {
        De3pzq: "f3rmtva",
        sj55zd: "f11d4kpn",
        r4wkhp: "f1no7wuu",
        B95qlz1: "fwwxidx",
        p743kt: "fp1zg4s",
        B7xitij: "f14i52sd",
        B6siaa6: "f1wiab75",
        Ba9qmo4: "fwry2ka",
        Dyrjrp: "f1cqwcg4"
    },
    "filled-lighter": {
        De3pzq: "f3rmtva",
        sj55zd: "f11d4kpn",
        r4wkhp: "f1no7wuu",
        B95qlz1: "f1yywxnv",
        drw0cw: "fzaa11h",
        idzz8t: "f4fpmm9",
        Dyrjrp: "f1cqwcg4"
    }
}, {
    d: [
        ".f16hsg94{grid-row-start:1;}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f10ra9hq{padding-top:4px;}",
        ".f1brlhvm{padding-bottom:1px;}",
        ".faunodf{grid-row-start:2;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1sl3k7w{padding-top:1px;}",
        ".f1y2xyjm{padding-bottom:4px;}",
        [
            ".f4lv8q1{padding:3px 6px 0px 4px;}",
            {
                p: -1
            }
        ],
        [
            ".fm3uwd2{padding:3px 4px 0px 6px;}",
            {
                p: -1
            }
        ],
        ".fvblgha{height:12px;}",
        [
            ".f1q86st8{padding:0px 6px 3px 4px;}",
            {
                p: -1
            }
        ],
        [
            ".frkrfqj{padding:0px 4px 3px 6px;}",
            {
                p: -1
            }
        ],
        ".f3rmtva{background-color:transparent;}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f1no7wuu:enabled:hover{color:var(--colorNeutralForeground3Hover);}",
        ".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fp1zg4s:enabled:active{color:var(--colorNeutralForeground3Pressed);}",
        ".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1wiab75:enabled.fui-SpinButton__button_active{color:var(--colorNeutralForeground3Pressed);}",
        ".fj9zm5z:enabled.fui-SpinButton__button_active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1cqwcg4:disabled{color:var(--colorNeutralForegroundDisabled);}",
        ".fwwxidx:enabled:hover{background-color:var(--colorNeutralBackground3Hover);}",
        ".f14i52sd:enabled:active{background-color:var(--colorNeutralBackground3Pressed);}",
        ".fwry2ka:enabled.fui-SpinButton__button_active{background-color:var(--colorNeutralBackground3Pressed);}",
        ".f1yywxnv:enabled:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".fzaa11h:enabled:active,.fzaa11h:enabled.fui-SpinButton__button_active{color:var(--colorNeutralForeground3Pressed);}",
        ".f4fpmm9:enabled:active,.f4fpmm9:enabled.fui-SpinButton__button_active{background-color:var(--colorNeutralBackground1Pressed);}"
    ]
});
const $931e3c5aa8fcfc9e$export$fe494266af289316 = (state)=>{
    'use no memo';
    const { appearance: appearance, spinState: spinState, size: size } = state;
    const disabled = state.input.disabled;
    const invalid = `${state.input['aria-invalid']}` === 'true';
    const filled = appearance.startsWith('filled');
    const rootStyles = $931e3c5aa8fcfc9e$var$useRootStyles();
    const buttonStyles = $931e3c5aa8fcfc9e$var$useButtonStyles();
    const inputStyles = $931e3c5aa8fcfc9e$var$useInputStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($931e3c5aa8fcfc9e$export$823a2a4502bf6ba9.root, $931e3c5aa8fcfc9e$var$useRootClassName(), rootStyles[size], rootStyles[appearance], filled && rootStyles.filled, !disabled && appearance === 'outline' && rootStyles.outlineInteractive, !disabled && appearance === 'underline' && rootStyles.underlineInteractive, !disabled && filled && rootStyles.filledInteractive, !disabled && invalid && rootStyles.invalid, disabled && rootStyles.disabled, state.root.className);
    state.incrementButton.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($931e3c5aa8fcfc9e$export$823a2a4502bf6ba9.incrementButton, spinState === 'up' && `${$931e3c5aa8fcfc9e$var$spinButtonExtraClassNames.buttonActive}`, $931e3c5aa8fcfc9e$var$useBaseButtonClassName(), buttonStyles.increment, buttonStyles[appearance], size === 'small' && buttonStyles.incrementButtonSmall, state.incrementButton.className);
    state.decrementButton.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($931e3c5aa8fcfc9e$export$823a2a4502bf6ba9.decrementButton, spinState === 'down' && `${$931e3c5aa8fcfc9e$var$spinButtonExtraClassNames.buttonActive}`, $931e3c5aa8fcfc9e$var$useBaseButtonClassName(), buttonStyles.decrement, buttonStyles[appearance], size === 'small' && buttonStyles.decrementButtonSmall, state.decrementButton.className);
    state.input.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($931e3c5aa8fcfc9e$export$823a2a4502bf6ba9.input, $931e3c5aa8fcfc9e$var$useInputClassName(), disabled && inputStyles.disabled, state.input.className);
    return state;
};



'use client';
const $d37d0cad6a600601$export$40bd1878c35e891c = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $25567175ba75005f$export$6685a3eb800fe2c0)(props, ref);
    (0, $931e3c5aa8fcfc9e$export$fe494266af289316)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useSpinButtonStyles_unstable')(state);
    return (0, $9ed305c504b85bf5$export$b583e644dcbc1a26)(state);
});
$d37d0cad6a600601$export$40bd1878c35e891c.displayName = 'SpinButton';


var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

const $b47b647faf3f8791$export$13bf030b9400d05d = (props, ref)=>{
    const { position: position = 'end', fluid: fluid = false } = props;
    return {
        components: {
            root: 'div'
        },
        root: (0, $fcf7ddccaab7fd8f$exports).always((0, $3cf8e596657ab4e0$export$c8517108b1b59810)('div', {
            // FIXME:
            // `ref` is wrongly assigned to be `HTMLElement` instead of `HTMLDivElement`
            // but since it would be a breaking change to fix it, we are casting ref to it's proper type
            ref: ref,
            ...props
        }), {
            elementType: 'div'
        }),
        position: position,
        fluid: fluid
    };
};




const $9aaf3b8fcc1f4be9$export$ee061f47be9b8c80 = (state)=>{
    (0, $637c7ee6d96c4982$export$9b4ff06cafef0276)(state);
    // TODO Add additional slots in the appropriate place
    return /*#__PURE__*/ (0, $505f9e7ea0e895ad$export$34b9dba7ce09269b)(state.root, {});
};




'use client';
const $dd17e3174906cc80$export$69259980d62f092a = {
    root: 'fui-DialogActions'
};
/**
 * Styles for the root slot
 */ const $dd17e3174906cc80$var$useResetStyles = /*#__PURE__*/ (0, $69f85aebb0ae267b$export$7e3b04e77a0827f2)("rhfpeu0", null, {
    r: [
        ".rhfpeu0{gap:8px;height:fit-content;box-sizing:border-box;display:flex;grid-row-start:3;grid-row-end:3;}"
    ],
    s: [
        "@media screen and (max-width: 480px){.rhfpeu0{flex-direction:column;justify-self:stretch;}}"
    ]
});
const $dd17e3174906cc80$var$useStyles = /*#__PURE__*/ (0, $8ef74b7807535a4a$export$c5d3a2c2e0d67663)({
    gridPositionEnd: {
        Bdqf98w: "f1a7i8kp",
        Br312pm: "fd46tj4",
        Bw0ie65: "fsyjsko",
        Btsd7tp: "f1n00o3b",
        ufxxby: "f1mvsp37",
        Bq5p579: "flbz1vp"
    },
    gridPositionStart: {
        Bdqf98w: "fsxvdwy",
        Br312pm: "fwpfdsa",
        Bw0ie65: "f1e2fz10",
        Ew0qkd: "f119phc2",
        ufxxby: "f1j719yo",
        Bq5p579: "flbz1vp"
    },
    fluidStart: {
        Bw0ie65: "fsyjsko"
    },
    fluidEnd: {
        Br312pm: "fwpfdsa"
    }
}, {
    d: [
        ".f1a7i8kp{justify-self:end;}",
        ".fd46tj4{grid-column-start:2;}",
        ".fsyjsko{grid-column-end:4;}",
        ".fsxvdwy{justify-self:start;}",
        ".fwpfdsa{grid-column-start:1;}",
        ".f1e2fz10{grid-column-end:2;}"
    ],
    m: [
        [
            "@media screen and (max-width: 480px){.f1n00o3b{grid-column-start:1;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f1mvsp37{grid-row-start:4;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.flbz1vp{grid-row-end:auto;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f119phc2{grid-column-end:4;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ],
        [
            "@media screen and (max-width: 480px){.f1j719yo{grid-row-start:3;}}",
            {
                m: "screen and (max-width: 480px)"
            }
        ]
    ]
});
const $dd17e3174906cc80$export$ab3fd2ac246c300d = (state)=>{
    'use no memo';
    const resetStyles = $dd17e3174906cc80$var$useResetStyles();
    const styles = $dd17e3174906cc80$var$useStyles();
    state.root.className = (0, $5d215fd24b7ad0fd$export$3d46f4579dba46e5)($dd17e3174906cc80$export$69259980d62f092a.root, resetStyles, state.position === 'start' && styles.gridPositionStart, state.position === 'end' && styles.gridPositionEnd, state.fluid && state.position === 'start' && styles.fluidStart, state.fluid && state.position === 'end' && styles.fluidEnd, state.root.className);
    return state;
};



'use client';
const $97e7a40f84d593e3$export$702322f34446412d = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const state = (0, $b47b647faf3f8791$export$13bf030b9400d05d)(props, ref);
    (0, $dd17e3174906cc80$export$ab3fd2ac246c300d)(state);
    (0, $df848b23091d7919$export$cf90cf4172902307)('useDialogActionsStyles_unstable')(state);
    return (0, $9aaf3b8fcc1f4be9$export$ee061f47be9b8c80)(state);
});
$97e7a40f84d593e3$export$702322f34446412d.displayName = 'DialogActions';



var $acw62 = parcelRequire("acw62");
function $1ce07b9af26db0de$export$2e2bcd8739ae039({ valueName: valueName, valueMax: valueMax, open: open, setOpen: setOpen, callback: callback }) {
    const [disableOK, setDisableOK] = (0, $acw62.useState)(true);
    const [currentValue, setCurrentValue] = (0, $acw62.useState)(0);
    const handleInputChange = (event)=>{
        const value = parseInt(event.target.value);
        if (value < 0 || value > valueMax) setDisableOK(true);
        else {
            setDisableOK(false);
            setCurrentValue(value);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $432da315193df471$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (_, data)=>setOpen(data.open),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73cdd34c0b870187$export$8d5c5a60a915d482), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4346adda79f54b9d$export$5d20f2c38fcde41f), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dce7a536101527d5$export$16f7638e4a34b909), {
                        children: [
                            "Change ",
                            valueName
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $330458ead2ba66c5$export$b6d9565de1e068cf), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d37d0cad6a600601$export$40bd1878c35e891c), {
                            defaultValue: 0,
                            max: valueMax,
                            onChange: handleInputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $97e7a40f84d593e3$export$702322f34446412d), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                appearance: "primary",
                                disabled: disableOK,
                                onClick: ()=>{
                                    callback(currentValue);
                                    setOpen(false);
                                },
                                children: "OK"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $16af17f31b90353f$export$2e1e1122cf0cba88), {
                                disableButtonEnhancement: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                    appearance: "secondary",
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}


const $7cb855ce9761e1a4$var$EditIcon = (0, $544dcb7495d058dc$export$5c43b1785e5213ca)((0, $61c84b424f99a7b1$export$a18b2635075e93d1), (0, $61c84b424f99a7b1$export$e57a7ca8375c5ccb));
function $7cb855ce9761e1a4$export$2e2bcd8739ae039() {
    const [changeValueDialogOpen, setChangeValueDialogOpen] = (0, $acw62.useState)(false);
    const [changeValueName, setChangeValueName] = (0, $acw62.useState)("");
    const [changeValueMax, setChangeValueMax] = (0, $acw62.useState)(20);
    const [unusedPoints, setUnusedPoints] = (0, $acw62.useState)(20);
    const changeValueOpen = (valueName, valueMax)=>{
        setChangeValueName(valueName);
        setChangeValueMax(valueMax);
        setChangeValueDialogOpen(true);
    };
    const handleChangeValue = (newValue)=>{};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                children: "Character Sheet"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bf8e3f93ce344917$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a43c21910348d1c5$export$f850895b287ef28e), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                    children: "Stat"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9460e3ff7c1178b7$export$9e1517a3035b3e5c), {
                                    children: "Value"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3f2f433630850f26$export$76ccd210b9029917), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                    colSpan: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                            children: "Unused points:"
                                        }),
                                        " ",
                                        unusedPoints
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Strength",
                                            info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                        children: "Strength"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Raw physical power."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: "Used for:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Melee attacks (heavy weapons)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Lifting, pushing, breaking things"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Athletics checks (climbing, jumping, grappling)"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                size: "small",
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7cb855ce9761e1a4$var$EditIcon, {}),
                                                onClick: ()=>changeValueOpen("Strength", 20)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Dexterity",
                                            info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                        children: "Dexterity"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Agility, reflexes, coordination."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: "Used for:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Ranged attacks and finesse weapons"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Armour class (how hard you are to hit)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Stealth, acrobatics, sleight of hand"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                size: "small",
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7cb855ce9761e1a4$var$EditIcon, {}),
                                                onClick: ()=>changeValueOpen("Dexterity", 20)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Constitution",
                                            info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                        children: "Constitution"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Endurance and toughness."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: "Used for:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Hit points (your health pool)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Resisting poison, disease, fatigue"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Concentration checks (for spells)"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                size: "small",
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7cb855ce9761e1a4$var$EditIcon, {}),
                                                onClick: ()=>changeValueOpen("Constitution", 20)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Intelligence",
                                            info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                        children: "Intelligence"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Reasoning, memory, knowledge."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: "Used for:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Arcana, history, investigation, nature, religion"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Science experiments"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Matrix research, computer and technology hacking"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                size: "small",
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7cb855ce9761e1a4$var$EditIcon, {}),
                                                onClick: ()=>changeValueOpen("Intelligence", 20)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Wisdom",
                                            info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                        children: "Wisdom"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Awareness, perception, intuition."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: "Used for:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Perception (spotting danger)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Insight (reading people)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                        children: "Survival, medicine"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                size: "small",
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7cb855ce9761e1a4$var$EditIcon, {}),
                                                onClick: ()=>changeValueOpen("Wisdom", 20)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f29ac2e18a97c20$export$b05581f4e764e162), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $123fb63dcb21233c$export$6fdf58e0e61e341c), {
                                            label: "Charisma",
                                            info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                        children: "Charisma"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "Force of personality, charm, presence."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: "Used for:"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                    children: "Persuasion, deception, intimidation, performance"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f2f4f4f80b3c9f0c$export$1e4baea7053fc0e3), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b2f31b5d520190a$export$353f5b6fc5456de1), {
                                                appearance: "transparent",
                                                size: "small",
                                                style: {
                                                    marginLeft: "0.5rem"
                                                },
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7cb855ce9761e1a4$var$EditIcon, {}),
                                                onClick: ()=>changeValueOpen("Charisma", 20)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ce07b9af26db0de$export$2e2bcd8739ae039), {
                valueName: changeValueName,
                valueMax: changeValueMax,
                open: changeValueDialogOpen,
                setOpen: setChangeValueDialogOpen,
                callback: handleChangeValue
            })
        ]
    });
}


const $046798b5de0850fe$var$useStyles = (0, $6ca57e1ddff6d070$export$b35517af9e0a5689)({
    root: {
        marginTop: "2rem",
        display: "flex",
        gap: "2rem",
        flex: "1 1 auto"
    }
});
function $046798b5de0850fe$export$2e2bcd8739ae039() {
    const styles = $046798b5de0850fe$var$useStyles();
    const [selectedNav, setSelectedNav] = (0, $acw62.useState)("stats");
    (0, $acw62.useEffect)(()=>{
        if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            const validHashes = [
                "stats",
                "character-sheet"
            ];
            if (validHashes.includes(hash)) setSelectedNav(hash);
        }
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: styles.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $900345cf912ae8c0$export$e51a686c67fdaa2d), {
                vertical: true,
                appearance: "subtle",
                selectedValue: selectedNav,
                onTabSelect: (_, data)=>setSelectedNav(data.value),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e914794eade933$export$3e41faf802a29e71), {
                        value: "stats",
                        children: "My Stats"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71e914794eade933$export$3e41faf802a29e71), {
                        value: "character-sheet",
                        children: "Character Sheet"
                    })
                ]
            }),
            selectedNav === "stats" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c4a1369613a4589$export$2e2bcd8739ae039), {}) : selectedNav === "character-sheet" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7cb855ce9761e1a4$export$2e2bcd8739ae039), {}) : null
        ]
    });
}


function $f3e3c56ef615c784$export$2e2bcd8739ae039() {
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [loadingError, setLoadingError] = (0, $acw62.useState)(null);
    const [userDisplayName, setUserDisplayName] = (0, $acw62.useState)("Unknown User");
    (0, $acw62.useEffect)(()=>{
        let hak = new URLSearchParams(window.location.search).get("hak");
        if (hak) {
            sessionStorage.setItem("hak", hak);
            window.location.href = window.location.pathname + window.location.hash;
            return;
        }
        hak = sessionStorage.getItem("hak") ?? null;
        if (hak) fetch("/api", {
            method: "GET",
            headers: {
                "X-Hak": hak
            }
        }).then(async (r)=>{
            if (r.status !== 200) {
                console.error("Failed to fetch HUD data.");
                setLoading(false);
                setLoadingError("Failed to fetch HUD data. Try clicking the \"Configure\" button on your HUD in-world again.");
                return;
            }
            const result = await r.json();
            setUserDisplayName(result.userInfo.displayName);
            setLoading(false);
        });
        else {
            console.warn("No hak provided, cannot fetch HUD data.");
            setLoading(false);
            setLoadingError("Please select \"Configure\" on your HUD in-world.");
        }
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                padding: "2rem 10rem 2rem 10rem"
            },
            children: [
                loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $16c0c2858b6dc7eb$export$7f7cbe89f1eacd2), {
                        size: "extra-large",
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $715c9647a8930a69$export$661f1b2c265066f), {
                            children: "Loading your HUD information..."
                        }),
                        labelPosition: "below"
                    })
                }) : null,
                loadingError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $715c9647a8930a69$export$661f1b2c265066f), {
                    style: {
                        color: (0, $4e9eda319b2a962b$export$6ad93df59e712c43).colorStatusDangerForeground1
                    },
                    children: [
                        "Error: ",
                        loadingError
                    ]
                }) : null,
                !loading && !loadingError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                            children: [
                                userDisplayName,
                                "'s Roleplay HUD"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $046798b5de0850fe$export$2e2bcd8739ae039), {})
                    ]
                }) : null
            ]
        })
    });
}


let $70fc9a727fa662ae$var$container = document.getElementById("app");
let $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
const $70fc9a727fa662ae$var$vorlaxion = {
    10: "#040300",
    20: "#1C1704",
    30: "#2E260B",
    40: "#3D3110",
    50: "#4C3C16",
    60: "#5D481E",
    70: "#6D5328",
    80: "#7E6034",
    90: "#8E6C43",
    100: "#9E7952",
    110: "#AE8763",
    120: "#BD9575",
    130: "#CBA488",
    140: "#D8B39C",
    150: "#E4C3B1",
    160: "#EED4C7"
};
const $70fc9a727fa662ae$var$lightTheme = {
    ...(0, $e46fa2d032c035de$export$433454ecdac7def9)($70fc9a727fa662ae$var$vorlaxion)
};
const $70fc9a727fa662ae$var$darkTheme = {
    ...(0, $3b5403a30a78663f$export$ac47085da93aabfb)($70fc9a727fa662ae$var$vorlaxion)
};
$70fc9a727fa662ae$var$darkTheme.colorBrandForeground1 = $70fc9a727fa662ae$var$vorlaxion[110];
$70fc9a727fa662ae$var$darkTheme.colorBrandForeground2 = $70fc9a727fa662ae$var$vorlaxion[120];
$70fc9a727fa662ae$var$lightTheme.fontFamilyBase = "Inter";
$70fc9a727fa662ae$var$darkTheme.fontFamilyBase = "Inter";
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edc7f381b74604ab$export$a2fd5c9263a86adf), {
    theme: $70fc9a727fa662ae$var$darkTheme,
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa12b390a398aec2$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa12b390a398aec2$export$3565eb3d00ca5a74), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $fa12b390a398aec2$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f88f73ddeac33bb$export$2e2bcd8739ae039), {}),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa12b390a398aec2$export$e7b0ac011bb776c6), {
                        path: "/hud",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3e3c56ef615c784$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa12b390a398aec2$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9aecac4636d85589$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    })
}));


//# sourceMappingURL=vgrp.js.map
